(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["holidayguru-components"] = factory(require("vue"));
	else
		root["holidayguru-components"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0174":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0237":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_icon_vue_vue_type_style_index_0_id_6e5a53c9_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7f24");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_icon_vue_vue_type_style_index_0_id_6e5a53c9_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_icon_vue_vue_type_style_index_0_id_6e5a53c9_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0249":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0264":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "05f4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "06c5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "06eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_title_trigger_vue_vue_type_style_index_0_id_1da8472c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b4cc");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_title_trigger_vue_vue_type_style_index_0_id_1da8472c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_title_trigger_vue_vue_type_style_index_0_id_1da8472c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "076b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_1_id_687b2f39_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5fa4");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_1_id_687b2f39_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_1_id_687b2f39_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "07d6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0812":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_short_trip_search_vue_vue_type_style_index_0_id_77f91d9c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9b8e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_short_trip_search_vue_vue_type_style_index_0_id_77f91d9c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_short_trip_search_vue_vue_type_style_index_0_id_77f91d9c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0897":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_loading_screen_vue_vue_type_style_index_0_id_5713da89_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0e7c");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_loading_screen_vue_vue_type_style_index_0_id_5713da89_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_loading_screen_vue_vue_type_style_index_0_id_5713da89_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "09e6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_promotionbanner_vue_vue_type_style_index_0_id_5ebd11d8_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2967");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_promotionbanner_vue_vue_type_style_index_0_id_5ebd11d8_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_promotionbanner_vue_vue_type_style_index_0_id_5ebd11d8_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0b5d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0c50":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0d47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_single_datepicker_vue_vue_type_style_index_0_id_7c8b225d_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e6da");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_single_datepicker_vue_vue_type_style_index_0_id_7c8b225d_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_single_datepicker_vue_vue_type_style_index_0_id_7c8b225d_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0d80":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0df7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0e46":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0e7c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0fa7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_header_background_vue_vue_type_style_index_0_id_51a4a022_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7f13");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_header_background_vue_vue_type_style_index_0_id_51a4a022_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_header_background_vue_vue_type_style_index_0_id_51a4a022_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1016":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1059":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "10b0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tooltip_vue_vue_type_style_index_0_id_24a4ab90_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4187");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tooltip_vue_vue_type_style_index_0_id_24a4ab90_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tooltip_vue_vue_type_style_index_0_id_24a4ab90_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "125b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_vue_vue_type_style_index_1_id_7821805c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99f4");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_vue_vue_type_style_index_1_id_7821805c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_vue_vue_type_style_index_1_id_7821805c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "12b8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_star_rating_vue_vue_type_style_index_0_id_6e7b4bf2_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8f2e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_star_rating_vue_vue_type_style_index_0_id_6e7b4bf2_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_star_rating_vue_vue_type_style_index_0_id_6e7b4bf2_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1300":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1390":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "145d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_periodpicker_vue_vue_type_style_index_1_id_4496c327_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0c50");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_periodpicker_vue_vue_type_style_index_1_id_4496c327_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_periodpicker_vue_vue_type_style_index_1_id_4496c327_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1497":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "14b8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "171f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1760":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1764":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "186f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1893":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "193d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_snap_slider_vue_vue_type_style_index_0_id_9c81ac70_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d7af");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_snap_slider_vue_vue_type_style_index_0_id_9c81ac70_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_snap_slider_vue_vue_type_style_index_0_id_9c81ac70_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1cd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_dropdown_vue_vue_type_style_index_0_id_9296a406_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a19d");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_dropdown_vue_vue_type_style_index_0_id_9296a406_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_dropdown_vue_vue_type_style_index_0_id_9296a406_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1d41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_title_vue_vue_type_style_index_0_id_e6e9d84c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8ea9");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_title_vue_vue_type_style_index_0_id_e6e9d84c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_title_vue_vue_type_style_index_0_id_e6e9d84c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1d6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_periodpicker_vue_vue_type_style_index_0_id_4496c327_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1497");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_periodpicker_vue_vue_type_style_index_0_id_4496c327_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_periodpicker_vue_vue_type_style_index_0_id_4496c327_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1d80":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1daa":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1e34":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1eb7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_destination_vue_vue_type_style_index_0_id_2a026ccb_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f61e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_destination_vue_vue_type_style_index_0_id_2a026ccb_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_destination_vue_vue_type_style_index_0_id_2a026ccb_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1ee6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_new_vue_vue_type_style_index_0_id_435288de_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c76e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_new_vue_vue_type_style_index_0_id_435288de_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_new_vue_vue_type_style_index_0_id_435288de_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1f40":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1f7e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2217":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_link_button_vue_vue_type_style_index_0_id_5a4e8ecc_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fadb");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_link_button_vue_vue_type_style_index_0_id_5a4e8ecc_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_link_button_vue_vue_type_style_index_0_id_5a4e8ecc_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2221":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "22ee":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2319":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_loading_bubble_vue_vue_type_style_index_0_id_a0d4b67c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98b4");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_loading_bubble_vue_vue_type_style_index_0_id_a0d4b67c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_loading_bubble_vue_vue_type_style_index_0_id_a0d4b67c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2438":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2494":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2597":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_footer_vue_vue_type_style_index_0_id_01a74078_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9127");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_footer_vue_vue_type_style_index_0_id_01a74078_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_footer_vue_vue_type_style_index_0_id_01a74078_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "25f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_newsletter_box_vue_vue_type_style_index_0_id_e6de27ba_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fef1");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_newsletter_box_vue_vue_type_style_index_0_id_e6de27ba_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_newsletter_box_vue_vue_type_style_index_0_id_e6de27ba_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2732":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "27d1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "27de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_link_list_text_vue_vue_type_style_index_0_id_c943ba90_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5e17");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_link_list_text_vue_vue_type_style_index_0_id_c943ba90_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_link_list_text_vue_vue_type_style_index_0_id_c943ba90_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "28c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_modal_vue_vue_type_style_index_0_id_3c3c5ed6_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("27d1");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_modal_vue_vue_type_style_index_0_id_3c3c5ed6_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_modal_vue_vue_type_style_index_0_id_3c3c5ed6_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2967":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "29d2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "29d5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_moods_vue_vue_type_style_index_0_id_4c2e0b3d_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("70cd");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_moods_vue_vue_type_style_index_0_id_4c2e0b3d_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_moods_vue_vue_type_style_index_0_id_4c2e0b3d_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2a52":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2a77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_partner_slider_vue_vue_type_style_index_0_id_21f543e0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9a63");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_partner_slider_vue_vue_type_style_index_0_id_21f543e0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_partner_slider_vue_vue_type_style_index_0_id_21f543e0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2a8f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2b88":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

 /*! 
  * portal-vue © Thorsten Lünborg, 2019 
  * 
  * Version: 2.1.7
  * 
  * LICENCE: MIT 
  * 
  * https://github.com/linusborg/portal-vue
  * 
 */



Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(__webpack_require__("8bbf"));

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var inBrowser = typeof window !== 'undefined';
function freeze(item) {
  if (Array.isArray(item) || _typeof(item) === 'object') {
    return Object.freeze(item);
  }

  return item;
}
function combinePassengers(transports) {
  var slotProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return transports.reduce(function (passengers, transport) {
    var temp = transport.passengers[0];
    var newPassengers = typeof temp === 'function' ? temp(slotProps) : transport.passengers;
    return passengers.concat(newPassengers);
  }, []);
}
function stableSort(array, compareFn) {
  return array.map(function (v, idx) {
    return [idx, v];
  }).sort(function (a, b) {
    return compareFn(a[1], b[1]) || a[0] - b[0];
  }).map(function (c) {
    return c[1];
  });
}
function pick(obj, keys) {
  return keys.reduce(function (acc, key) {
    if (obj.hasOwnProperty(key)) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

var transports = {};
var targets = {};
var sources = {};
var Wormhole = Vue.extend({
  data: function data() {
    return {
      transports: transports,
      targets: targets,
      sources: sources,
      trackInstances: inBrowser
    };
  },
  methods: {
    open: function open(transport) {
      if (!inBrowser) return;
      var to = transport.to,
          from = transport.from,
          passengers = transport.passengers,
          _transport$order = transport.order,
          order = _transport$order === void 0 ? Infinity : _transport$order;
      if (!to || !from || !passengers) return;
      var newTransport = {
        to: to,
        from: from,
        passengers: freeze(passengers),
        order: order
      };
      var keys = Object.keys(this.transports);

      if (keys.indexOf(to) === -1) {
        Vue.set(this.transports, to, []);
      }

      var currentIndex = this.$_getTransportIndex(newTransport); // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays

      var newTransports = this.transports[to].slice(0);

      if (currentIndex === -1) {
        newTransports.push(newTransport);
      } else {
        newTransports[currentIndex] = newTransport;
      }

      this.transports[to] = stableSort(newTransports, function (a, b) {
        return a.order - b.order;
      });
    },
    close: function close(transport) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var to = transport.to,
          from = transport.from;
      if (!to || !from && force === false) return;

      if (!this.transports[to]) {
        return;
      }

      if (force) {
        this.transports[to] = [];
      } else {
        var index = this.$_getTransportIndex(transport);

        if (index >= 0) {
          // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays
          var newTransports = this.transports[to].slice(0);
          newTransports.splice(index, 1);
          this.transports[to] = newTransports;
        }
      }
    },
    registerTarget: function registerTarget(target, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.targets[target]) {
        console.warn("[portal-vue]: Target ".concat(target, " already exists"));
      }

      this.$set(this.targets, target, Object.freeze([vm]));
    },
    unregisterTarget: function unregisterTarget(target) {
      this.$delete(this.targets, target);
    },
    registerSource: function registerSource(source, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.sources[source]) {
        console.warn("[portal-vue]: source ".concat(source, " already exists"));
      }

      this.$set(this.sources, source, Object.freeze([vm]));
    },
    unregisterSource: function unregisterSource(source) {
      this.$delete(this.sources, source);
    },
    hasTarget: function hasTarget(to) {
      return !!(this.targets[to] && this.targets[to][0]);
    },
    hasSource: function hasSource(to) {
      return !!(this.sources[to] && this.sources[to][0]);
    },
    hasContentFor: function hasContentFor(to) {
      return !!this.transports[to] && !!this.transports[to].length;
    },
    // Internal
    $_getTransportIndex: function $_getTransportIndex(_ref) {
      var to = _ref.to,
          from = _ref.from;

      for (var i in this.transports[to]) {
        if (this.transports[to][i].from === from) {
          return +i;
        }
      }

      return -1;
    }
  }
});
var wormhole = new Wormhole(transports);

var _id = 1;
var Portal = Vue.extend({
  name: 'portal',
  props: {
    disabled: {
      type: Boolean
    },
    name: {
      type: String,
      default: function _default() {
        return String(_id++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerSource(_this.name, _this);
    });
  },
  mounted: function mounted() {
    if (!this.disabled) {
      this.sendUpdate();
    }
  },
  updated: function updated() {
    if (this.disabled) {
      this.clear();
    } else {
      this.sendUpdate();
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterSource(this.name);
    this.clear();
  },
  watch: {
    to: function to(newValue, oldValue) {
      oldValue && oldValue !== newValue && this.clear(oldValue);
      this.sendUpdate();
    }
  },
  methods: {
    clear: function clear(target) {
      var closer = {
        from: this.name,
        to: target || this.to
      };
      wormhole.close(closer);
    },
    normalizeSlots: function normalizeSlots() {
      return this.$scopedSlots.default ? [this.$scopedSlots.default] : this.$slots.default;
    },
    normalizeOwnChildren: function normalizeOwnChildren(children) {
      return typeof children === 'function' ? children(this.slotProps) : children;
    },
    sendUpdate: function sendUpdate() {
      var slotContent = this.normalizeSlots();

      if (slotContent) {
        var transport = {
          from: this.name,
          to: this.to,
          passengers: _toConsumableArray(slotContent),
          order: this.order
        };
        wormhole.open(transport);
      } else {
        this.clear();
      }
    }
  },
  render: function render(h) {
    var children = this.$slots.default || this.$scopedSlots.default || [];
    var Tag = this.tag;

    if (children && this.disabled) {
      return children.length <= 1 && this.slim ? this.normalizeOwnChildren(children)[0] : h(Tag, [this.normalizeOwnChildren(children)]);
    } else {
      return this.slim ? h() : h(Tag, {
        class: {
          'v-portal': true
        },
        style: {
          display: 'none'
        },
        key: 'v-portal-placeholder'
      });
    }
  }
});

var PortalTarget = Vue.extend({
  name: 'portalTarget',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    slim: {
      type: Boolean,
      default: false
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  data: function data() {
    return {
      transports: wormhole.transports,
      firstRender: true
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerTarget(_this.name, _this);
    });
  },
  watch: {
    ownTransports: function ownTransports() {
      this.$emit('change', this.children().length > 0);
    },
    name: function name(newVal, oldVal) {
      /**
       * TODO
       * This should warn as well ...
       */
      wormhole.unregisterTarget(oldVal);
      wormhole.registerTarget(newVal, this);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.transition) {
      this.$nextTick(function () {
        // only when we have a transition, because it causes a re-render
        _this2.firstRender = false;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterTarget(this.name);
  },
  computed: {
    ownTransports: function ownTransports() {
      var transports = this.transports[this.name] || [];

      if (this.multiple) {
        return transports;
      }

      return transports.length === 0 ? [] : [transports[transports.length - 1]];
    },
    passengers: function passengers() {
      return combinePassengers(this.ownTransports, this.slotProps);
    }
  },
  methods: {
    // can't be a computed prop because it has to "react" to $slot changes.
    children: function children() {
      return this.passengers.length !== 0 ? this.passengers : this.$scopedSlots.default ? this.$scopedSlots.default(this.slotProps) : this.$slots.default || [];
    },
    // can't be a computed prop because it has to "react" to this.children().
    noWrapper: function noWrapper() {
      var noWrapper = this.slim && !this.transition;

      if (noWrapper && this.children().length > 1) {
        console.warn('[portal-vue]: PortalTarget with `slim` option received more than one child element.');
      }

      return noWrapper;
    }
  },
  render: function render(h) {
    var noWrapper = this.noWrapper();
    var children = this.children();
    var Tag = this.transition || this.tag;
    return noWrapper ? children[0] : this.slim && !Tag ? h() : h(Tag, {
      props: {
        // if we have a transition component, pass the tag if it exists
        tag: this.transition && this.tag ? this.tag : undefined
      },
      class: {
        'vue-portal-target': true
      }
    }, children);
  }
});

var _id$1 = 0;
var portalProps = ['disabled', 'name', 'order', 'slim', 'slotProps', 'tag', 'to'];
var targetProps = ['multiple', 'transition'];
var MountingPortal = Vue.extend({
  name: 'MountingPortal',
  inheritAttrs: false,
  props: {
    append: {
      type: [Boolean, String]
    },
    bail: {
      type: Boolean
    },
    mountTo: {
      type: String,
      required: true
    },
    // Portal
    disabled: {
      type: Boolean
    },
    // name for the portal
    name: {
      type: String,
      default: function _default() {
        return 'mounted_' + String(_id$1++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    // name for the target
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    },
    // Target
    multiple: {
      type: Boolean,
      default: false
    },
    targetSlim: {
      type: Boolean
    },
    targetSlotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    targetTag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  created: function created() {
    if (typeof document === 'undefined') return;
    var el = document.querySelector(this.mountTo);

    if (!el) {
      console.error("[portal-vue]: Mount Point '".concat(this.mountTo, "' not found in document"));
      return;
    }

    var props = this.$props; // Target already exists

    if (wormhole.targets[props.name]) {
      if (props.bail) {
        console.warn("[portal-vue]: Target ".concat(props.name, " is already mounted.\n        Aborting because 'bail: true' is set"));
      } else {
        this.portalTarget = wormhole.targets[props.name];
      }

      return;
    }

    var append = props.append;

    if (append) {
      var type = typeof append === 'string' ? append : 'DIV';
      var mountEl = document.createElement(type);
      el.appendChild(mountEl);
      el = mountEl;
    } // get props for target from $props
    // we have to rename a few of them


    var _props = pick(this.$props, targetProps);

    _props.slim = this.targetSlim;
    _props.tag = this.targetTag;
    _props.slotProps = this.targetSlotProps;
    _props.name = this.to;
    this.portalTarget = new PortalTarget({
      el: el,
      parent: this.$parent || this,
      propsData: _props
    });
  },
  beforeDestroy: function beforeDestroy() {
    var target = this.portalTarget;

    if (this.append) {
      var el = target.$el;
      el.parentNode.removeChild(el);
    }

    target.$destroy();
  },
  render: function render(h) {
    if (!this.portalTarget) {
      console.warn("[portal-vue] Target wasn't mounted");
      return h();
    } // if there's no "manual" scoped slot, so we create a <Portal> ourselves


    if (!this.$scopedSlots.manual) {
      var props = pick(this.$props, portalProps);
      return h(Portal, {
        props: props,
        attrs: this.$attrs,
        on: this.$listeners,
        scopedSlots: this.$scopedSlots
      }, this.$slots.default);
    } // else, we render the scoped slot


    var content = this.$scopedSlots.manual({
      to: this.to
    }); // if user used <template> for the scoped slot
    // content will be an array

    if (Array.isArray(content)) {
      content = content[0];
    }

    if (!content) return h();
    return content;
  }
});

function install(Vue$$1) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue$$1.component(options.portalName || 'Portal', Portal);
  Vue$$1.component(options.portalTargetName || 'PortalTarget', PortalTarget);
  Vue$$1.component(options.MountingPortalName || 'MountingPortal', MountingPortal);
}

var index = {
  install: install
};

exports.default = index;
exports.Portal = Portal;
exports.PortalTarget = PortalTarget;
exports.MountingPortal = MountingPortal;
exports.Wormhole = wormhole;
//# sourceMappingURL=portal-vue.common.js.map


/***/ }),

/***/ "2c26":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2c2f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2c30":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_vakantiediscounter_package_tour_search_vue_vue_type_style_index_0_id_57ea2242_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1f7e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_vakantiediscounter_package_tour_search_vue_vue_type_style_index_0_id_57ea2242_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_vakantiediscounter_package_tour_search_vue_vue_type_style_index_0_id_57ea2242_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2c4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_redesign_vue_vue_type_style_index_0_id_a03dbb62_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6741");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_redesign_vue_vue_type_style_index_0_id_a03dbb62_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_redesign_vue_vue_type_style_index_0_id_a03dbb62_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "323c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_layout_vue_vue_type_style_index_1_id_2118e6b4_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("186f");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_layout_vue_vue_type_style_index_1_id_2118e6b4_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_layout_vue_vue_type_style_index_1_id_2118e6b4_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "326f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "339a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_cruise_select_vue_vue_type_style_index_0_id_028423d2_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b03e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_cruise_select_vue_vue_type_style_index_0_id_028423d2_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_cruise_select_vue_vue_type_style_index_0_id_028423d2_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "339c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_promotion_vue_vue_type_style_index_0_id_f2062e30_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9ff2");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_promotion_vue_vue_type_style_index_0_id_f2062e30_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_promotion_vue_vue_type_style_index_0_id_f2062e30_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "33b1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "34b7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "34e2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_top_deal_card_vue_vue_type_style_index_0_id_f7c69882_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("886f");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_top_deal_card_vue_vue_type_style_index_0_id_f7c69882_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_top_deal_card_vue_vue_type_style_index_0_id_f7c69882_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3520":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_responsive_content_vue_vue_type_style_index_0_id_4d593466_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6789");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_responsive_content_vue_vue_type_style_index_0_id_4d593466_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_responsive_content_vue_vue_type_style_index_0_id_4d593466_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "355b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "35b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_period_label_vue_vue_type_style_index_0_id_48565fd1_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("52c2");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_period_label_vue_vue_type_style_index_0_id_48565fd1_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_period_label_vue_vue_type_style_index_0_id_48565fd1_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "35ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_home_hero_de_svg_vue_vue_type_style_index_0_id_1710cbd4_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9cc5");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_home_hero_de_svg_vue_vue_type_style_index_0_id_1710cbd4_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_home_hero_de_svg_vue_vue_type_style_index_0_id_1710cbd4_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "35e9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_hotel_attributes_vue_vue_type_style_index_0_id_a9a08254_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9de0");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_hotel_attributes_vue_vue_type_style_index_0_id_a9a08254_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_hotel_attributes_vue_vue_type_style_index_0_id_a9a08254_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "369d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "36e4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_footer_vue_vue_type_style_index_1_id_01a74078_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5a3e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_footer_vue_vue_type_style_index_1_id_01a74078_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_footer_vue_vue_type_style_index_1_id_01a74078_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "36f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_trust_vue_vue_type_style_index_0_id_7d3f5686_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1f40");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_trust_vue_vue_type_style_index_0_id_7d3f5686_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_trust_vue_vue_type_style_index_0_id_7d3f5686_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3709":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3898":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3a30":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3a94":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_category_vue_vue_type_style_index_0_id_0ad51ea0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("df09");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_category_vue_vue_type_style_index_0_id_0ad51ea0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_category_vue_vue_type_style_index_0_id_0ad51ea0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3c74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_play_at_vue_vue_type_style_index_0_id_119aaaf8_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bd4b");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_play_at_vue_vue_type_style_index_0_id_119aaaf8_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_play_at_vue_vue_type_style_index_0_id_119aaaf8_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3de7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_watado_search_vue_vue_type_style_index_0_id_3c36e99a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0264");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_watado_search_vue_vue_type_style_index_0_id_3c36e99a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_watado_search_vue_vue_type_style_index_0_id_3c36e99a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3ea4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_radio_group_vue_vue_type_style_index_0_id_37df19a8_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5d22");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_radio_group_vue_vue_type_style_index_0_id_37df19a8_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_radio_group_vue_vue_type_style_index_0_id_37df19a8_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3f99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_periods_vue_vue_type_style_index_0_id_3107b8f0_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0b5d");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_periods_vue_vue_type_style_index_0_id_3107b8f0_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_periods_vue_vue_type_style_index_0_id_3107b8f0_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4087":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_lastminute_package_tour_search_vue_vue_type_style_index_0_id_101e1317_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7761");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_lastminute_package_tour_search_vue_vue_type_style_index_0_id_101e1317_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_lastminute_package_tour_search_vue_vue_type_style_index_0_id_101e1317_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "408d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_cruise_search_vue_vue_type_style_index_0_id_7e6d4ce6_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dfe8");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_cruise_search_vue_vue_type_style_index_0_id_7e6d4ce6_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_cruise_search_vue_vue_type_style_index_0_id_7e6d4ce6_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4187":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "41d4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_coupon_button_vue_vue_type_style_index_0_id_3215deb7_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e013");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_coupon_button_vue_vue_type_style_index_0_id_3215deb7_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_coupon_button_vue_vue_type_style_index_0_id_3215deb7_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "42e3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_support_vue_vue_type_style_index_0_id_932a0416_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("92ac");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_support_vue_vue_type_style_index_0_id_932a0416_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_support_vue_vue_type_style_index_0_id_932a0416_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4343":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "43d8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_footnote_vue_vue_type_style_index_0_id_bfc12f52_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("29d2");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_footnote_vue_vue_type_style_index_0_id_bfc12f52_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_footnote_vue_vue_type_style_index_0_id_bfc12f52_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "47d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_trustpilot_buttons_vue_vue_type_style_index_0_id_f1c6d80a_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("557f");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_trustpilot_buttons_vue_vue_type_style_index_0_id_f1c6d80a_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_trustpilot_buttons_vue_vue_type_style_index_0_id_f1c6d80a_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4893":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4a6c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_collapsible_content_vue_vue_type_style_index_0_id_57fc7ca2_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dbc3");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_collapsible_content_vue_vue_type_style_index_0_id_57fc7ca2_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_collapsible_content_vue_vue_type_style_index_0_id_57fc7ca2_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4d70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_new_vue_vue_type_style_index_1_id_435288de_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5c0b");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_new_vue_vue_type_style_index_1_id_435288de_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_new_vue_vue_type_style_index_1_id_435288de_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4e38":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "50bb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "51d1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_auth_modal_vue_vue_type_style_index_0_id_27fc1204_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("eb36");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_auth_modal_vue_vue_type_style_index_0_id_27fc1204_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_auth_modal_vue_vue_type_style_index_0_id_27fc1204_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "52c2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "536d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "53a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_listing_vue_vue_type_style_index_0_id_1f5367ac_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("64fb");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_listing_vue_vue_type_style_index_0_id_1f5367ac_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_listing_vue_vue_type_style_index_0_id_1f5367ac_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "53ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ "53d6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "54c2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "557f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5589":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_dropdown_new_vue_vue_type_style_index_0_id_14d2e622_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1d80");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_dropdown_new_vue_vue_type_style_index_0_id_14d2e622_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_dropdown_new_vue_vue_type_style_index_0_id_14d2e622_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5615":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_basic_vue_vue_type_style_index_0_id_e2e335c6_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("778b");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_basic_vue_vue_type_style_index_0_id_e2e335c6_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_basic_vue_vue_type_style_index_0_id_e2e335c6_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "570f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_social_vue_vue_type_style_index_0_id_3049c524_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("969b");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_social_vue_vue_type_style_index_0_id_3049c524_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_social_vue_vue_type_style_index_0_id_3049c524_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5861":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_vue_vue_type_style_index_0_id_7821805c_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("59b0");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_vue_vue_type_style_index_0_id_7821805c_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_flicking_vue_vue_type_style_index_0_id_7821805c_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "58c1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_netmatch_package_tour_search_vue_vue_type_style_index_0_id_291d5b6e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("faad");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_netmatch_package_tour_search_vue_vue_type_style_index_0_id_291d5b6e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_netmatch_package_tour_search_vue_vue_type_style_index_0_id_291d5b6e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "595b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hotel_of_the_day_circle_svg_vue_vue_type_style_index_0_id_1ba1fb94_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1760");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hotel_of_the_day_circle_svg_vue_vue_type_style_index_0_id_1ba1fb94_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hotel_of_the_day_circle_svg_vue_vue_type_style_index_0_id_1ba1fb94_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "59b0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5a3e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5b6d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5c0b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5c17":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5c8b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5cbb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_ch_vue_vue_type_style_index_0_id_ec2a1f88_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("53d6");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_ch_vue_vue_type_style_index_0_id_ec2a1f88_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_ch_vue_vue_type_style_index_0_id_ec2a1f88_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5d22":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5d4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_home_hero_nl_svg_vue_vue_type_style_index_0_id_5d65cdc6_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("85de");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_home_hero_nl_svg_vue_vue_type_style_index_0_id_5d65cdc6_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_home_hero_nl_svg_vue_vue_type_style_index_0_id_5d65cdc6_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5da8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_email_register_vue_vue_type_style_index_0_id_dac8e610_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d3dc");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_email_register_vue_vue_type_style_index_0_id_dac8e610_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_email_register_vue_vue_type_style_index_0_id_dac8e610_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5e17":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5e7e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5f6e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5fa4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5fe6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_accommodation_vue_vue_type_style_index_0_id_688d563a_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("edc6");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_accommodation_vue_vue_type_style_index_0_id_688d563a_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_accommodation_vue_vue_type_style_index_0_id_688d563a_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "61e7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6205":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6211":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6348":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_type_vue_vue_type_style_index_0_id_453e7a06_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2732");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_type_vue_vue_type_style_index_0_id_453e7a06_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_type_vue_vue_type_style_index_0_id_453e7a06_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "63c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_vue_vue_type_style_index_0_id_78e26094_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("70b6");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_vue_vue_type_style_index_0_id_78e26094_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_vue_vue_type_style_index_0_id_78e26094_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "644f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "64b5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_amadeus_package_tour_search_vue_vue_type_style_index_0_id_128f9186_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4343");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_amadeus_package_tour_search_vue_vue_type_style_index_0_id_128f9186_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_amadeus_package_tour_search_vue_vue_type_style_index_0_id_128f9186_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "64e7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "64fb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6541":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_collapse_vue_vue_type_style_index_1_id_b16ccb34_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cb77");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_collapse_vue_vue_type_style_index_1_id_b16ccb34_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_collapse_vue_vue_type_style_index_1_id_b16ccb34_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "65da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_sort_filter_vue_vue_type_style_index_0_id_3e023578_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2438");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_sort_filter_vue_vue_type_style_index_0_id_3e023578_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_sort_filter_vue_vue_type_style_index_0_id_3e023578_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "664a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_vue_vue_type_style_index_0_id_3f6d751c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fcc4");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_vue_vue_type_style_index_0_id_3f6d751c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_vue_vue_type_style_index_0_id_3f6d751c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6657":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_numeric_input_vue_vue_type_style_index_0_id_3447bf08_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7a95");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_numeric_input_vue_vue_type_style_index_0_id_3447bf08_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_numeric_input_vue_vue_type_style_index_0_id_3447bf08_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6741":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6789":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6962":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_cancellation_badge_vue_vue_type_style_index_0_id_44afaa0f_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8697");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_cancellation_badge_vue_vue_type_style_index_0_id_44afaa0f_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_cancellation_badge_vue_vue_type_style_index_0_id_44afaa0f_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6a55":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_newsletter_vue_vue_type_style_index_0_id_20ae4065_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fa20");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_newsletter_vue_vue_type_style_index_0_id_20ae4065_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_newsletter_vue_vue_type_style_index_0_id_20ae4065_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6af3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6d91":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6d912":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_text_input_vue_vue_type_style_index_0_id_5607e814_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ec13");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_text_input_vue_vue_type_style_index_0_id_5607e814_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_text_input_vue_vue_type_style_index_0_id_5607e814_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6da7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_687b2f39_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("644f");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_687b2f39_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_687b2f39_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6df6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6e9f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6ee2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_ibe_search_vue_vue_type_style_index_0_id_42ba11c8_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("355b");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_ibe_search_vue_vue_type_style_index_0_id_42ba11c8_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_ibe_search_vue_vue_type_style_index_0_id_42ba11c8_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6f6b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6f99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_radio_group_vue_vue_type_style_index_1_id_37df19a8_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3a30");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_radio_group_vue_vue_type_style_index_1_id_37df19a8_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_radio_group_vue_vue_type_style_index_1_id_37df19a8_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7039":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_portal_dropdown_desktop_vue_vue_type_style_index_0_id_5d3136c4_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("34b7");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_portal_dropdown_desktop_vue_vue_type_style_index_0_id_5d3136c4_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_portal_dropdown_desktop_vue_vue_type_style_index_0_id_5d3136c4_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "70b6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "70c3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "70cd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "710f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "743c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_hotel_of_the_day_vue_vue_type_style_index_0_id_f6a5bc7e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("81d4");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_hotel_of_the_day_vue_vue_type_style_index_0_id_f6a5bc7e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_hotel_of_the_day_vue_vue_type_style_index_0_id_f6a5bc7e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "747b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "74dc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "767d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_new_vue_vue_type_style_index_0_id_c5dde3c8_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8fe5");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_new_vue_vue_type_style_index_0_id_c5dde3c8_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_new_vue_vue_type_style_index_0_id_c5dde3c8_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7691":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_icon_with_headline_vue_vue_type_style_index_0_id_7e39150c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fdea");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_icon_with_headline_vue_vue_type_style_index_0_id_7e39150c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_icon_with_headline_vue_vue_type_style_index_0_id_7e39150c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7761":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "778b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7850":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "786f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_travel_duration_select_vue_vue_type_style_index_0_id_36791838_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("369d");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_travel_duration_select_vue_vue_type_style_index_0_id_36791838_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_travel_duration_select_vue_vue_type_style_index_0_id_36791838_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7894":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_play_ch_vue_vue_type_style_index_0_id_47d061b6_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0d80");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_play_ch_vue_vue_type_style_index_0_id_47d061b6_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_play_ch_vue_vue_type_style_index_0_id_47d061b6_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7a95":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7c0e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7dac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_vue_vue_type_style_index_1_id_e64e1fb6_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2494");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_vue_vue_type_style_index_1_id_e64e1fb6_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_vue_vue_type_style_index_1_id_e64e1fb6_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7f13":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7f24":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8037":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_loading_bar_vue_vue_type_style_index_0_id_2e3318a0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0174");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_loading_bar_vue_vue_type_style_index_0_id_2e3318a0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_loading_bar_vue_vue_type_style_index_0_id_2e3318a0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8171":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_price_vue_vue_type_style_index_0_id_48a9b655_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("06c5");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_price_vue_vue_type_style_index_0_id_48a9b655_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_price_vue_vue_type_style_index_0_id_48a9b655_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "81d4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8211":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_highlights_vue_vue_type_style_index_0_id_1fbbcb23_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("14b8");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_highlights_vue_vue_type_style_index_0_id_1fbbcb23_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_highlights_vue_vue_type_style_index_0_id_1fbbcb23_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "85de":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8697":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8763":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_at_vue_vue_type_style_index_0_id_afbd35ec_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6df6");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_at_vue_vue_type_style_index_0_id_afbd35ec_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_at_vue_vue_type_style_index_0_id_afbd35ec_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "886f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "88c3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "89c4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8cb5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hero_vue_vue_type_style_index_0_id_2cb7cd6e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5c8b");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hero_vue_vue_type_style_index_0_id_2cb7cd6e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hero_vue_vue_type_style_index_0_id_2cb7cd6e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8cf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_newsletter_banner_vue_vue_type_style_index_0_id_3cf66e80_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d7c0");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_newsletter_banner_vue_vue_type_style_index_0_id_3cf66e80_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_newsletter_banner_vue_vue_type_style_index_0_id_3cf66e80_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8ea9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8f2e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8f6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_activate_account_vue_vue_type_style_index_0_id_6488a7ac_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c997");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_activate_account_vue_vue_type_style_index_0_id_6488a7ac_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_activate_account_vue_vue_type_style_index_0_id_6488a7ac_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8faf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_lists_vue_vue_type_style_index_0_id_4bf8b4be_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("05f4");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_lists_vue_vue_type_style_index_0_id_4bf8b4be_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_lists_vue_vue_type_style_index_0_id_4bf8b4be_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8fe5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9050":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_netmatch_hotel_tour_search_vue_vue_type_style_index_0_id_23cf52fb_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3709");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_netmatch_hotel_tour_search_vue_vue_type_style_index_0_id_23cf52fb_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_netmatch_hotel_tour_search_vue_vue_type_style_index_0_id_23cf52fb_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9127":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "929d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "92ac":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "934e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_collapse_vue_vue_type_style_index_0_id_b16ccb34_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fa6d");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_collapse_vue_vue_type_style_index_0_id_b16ccb34_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_collapse_vue_vue_type_style_index_0_id_b16ccb34_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9525":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_de_vue_vue_type_style_index_0_id_1a855f90_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1390");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_de_vue_vue_type_style_index_0_id_1a855f90_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_de_vue_vue_type_style_index_0_id_1a855f90_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9592":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_register_form_vue_vue_type_style_index_0_id_c410030e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0df7");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_register_form_vue_vue_type_style_index_0_id_c410030e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_register_form_vue_vue_type_style_index_0_id_c410030e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9640":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "969b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "97af":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "98b4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "99f4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9a63":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9a81":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_checkbox_vue_vue_type_style_index_0_id_1992bf91_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d3b3");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_checkbox_vue_vue_type_style_index_0_id_1992bf91_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_checkbox_vue_vue_type_style_index_0_id_1992bf91_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9b8e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9bee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_search_tabs_vue_vue_type_style_index_0_id_ccce72e6_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("eb0e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_search_tabs_vue_vue_type_style_index_0_id_ccce72e6_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_search_tabs_vue_vue_type_style_index_0_id_ccce72e6_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9c3d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9cb7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9cc5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9d09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_travelers_vue_vue_type_style_index_0_id_879517a4_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2221");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_travelers_vue_vue_type_style_index_0_id_879517a4_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_travelers_vue_vue_type_style_index_0_id_879517a4_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9d13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_guru_logo_plain_vue_vue_type_style_index_0_id_8b90c156_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("88c3");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_guru_logo_plain_vue_vue_type_style_index_0_id_8b90c156_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_guru_logo_plain_vue_vue_type_style_index_0_id_8b90c156_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9de0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9e52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_flight_vue_vue_type_style_index_0_id_3bffadc2_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0249");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_flight_vue_vue_type_style_index_0_id_3bffadc2_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_flight_vue_vue_type_style_index_0_id_3bffadc2_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9eb6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9ee2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_amadeus_package_tour_vue_vue_type_style_index_0_id_b90654a0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("64e7");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_amadeus_package_tour_vue_vue_type_style_index_0_id_b90654a0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_amadeus_package_tour_vue_vue_type_style_index_0_id_b90654a0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9ff2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a099":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_play_de_vue_vue_type_style_index_0_id_b1ba5614_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a0a0");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_play_de_vue_vue_type_style_index_0_id_b1ba5614_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_play_de_vue_vue_type_style_index_0_id_b1ba5614_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a0a0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a19d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a28a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_layout_vue_vue_type_style_index_0_id_2118e6b4_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5b6d");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_layout_vue_vue_type_style_index_0_id_2118e6b4_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_layout_vue_vue_type_style_index_0_id_2118e6b4_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a2bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_social_media_vue_vue_type_style_index_0_id_ef3ca2a4_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1e34");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_social_media_vue_vue_type_style_index_0_id_ef3ca2a4_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_social_media_vue_vue_type_style_index_0_id_ef3ca2a4_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a451":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a560":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tag_carousel_vue_vue_type_style_index_0_id_e3823b40_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("eafc");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tag_carousel_vue_vue_type_style_index_0_id_e3823b40_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tag_carousel_vue_vue_type_style_index_0_id_e3823b40_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a8c8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_home_hero_at_svg_vue_vue_type_style_index_0_id_e66d1830_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("22ee");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_home_hero_at_svg_vue_vue_type_style_index_0_id_e66d1830_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_home_hero_at_svg_vue_vue_type_style_index_0_id_e66d1830_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a8de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_content_card_vue_vue_type_style_index_0_id_15bbf0cc_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1300");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_content_card_vue_vue_type_style_index_0_id_15bbf0cc_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_content_card_vue_vue_type_style_index_0_id_15bbf0cc_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "aa02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_auth_modal_vue_vue_type_style_index_1_id_27fc1204_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("33b1");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_auth_modal_vue_vue_type_style_index_1_id_27fc1204_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_auth_modal_vue_vue_type_style_index_1_id_27fc1204_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ada6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_reminder_vue_vue_type_style_index_0_id_5d5fec63_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c3e9");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_reminder_vue_vue_type_style_index_0_id_5d5fec63_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_reminder_vue_vue_type_style_index_0_id_5d5fec63_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ae0f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_guru_logo_vue_vue_type_style_index_0_id_03134204_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("97af");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_guru_logo_vue_vue_type_style_index_0_id_03134204_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_guru_logo_vue_vue_type_style_index_0_id_03134204_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ae95":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "af84":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "afad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_like_bookmark_vue_vue_type_style_index_0_id_3f031b76_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0e46");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_like_bookmark_vue_vue_type_style_index_0_id_3f031b76_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_like_bookmark_vue_vue_type_style_index_0_id_3f031b76_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b03e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b091":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_skeleton_vue_vue_type_style_index_0_id_f828fa8a_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1daa");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_skeleton_vue_vue_type_style_index_0_id_f828fa8a_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_skeleton_vue_vue_type_style_index_0_id_f828fa8a_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b09b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_login_button_vue_vue_type_style_index_0_id_22a07e14_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4893");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_login_button_vue_vue_type_style_index_0_id_22a07e14_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_login_button_vue_vue_type_style_index_0_id_22a07e14_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b2a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_highlights_vue_vue_type_style_index_1_id_1fbbcb23_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("70c3");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_highlights_vue_vue_type_style_index_1_id_1fbbcb23_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_highlights_vue_vue_type_style_index_1_id_1fbbcb23_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b4aa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_select_vue_vue_type_style_index_0_id_0de119f6_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9cb7");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_select_vue_vue_type_style_index_0_id_0de119f6_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_select_vue_vue_type_style_index_0_id_0de119f6_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b4cc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b5e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_magazine_card_vue_vue_type_style_index_0_id_9583825a_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b8d2");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_magazine_card_vue_vue_type_style_index_0_id_9583825a_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_magazine_card_vue_vue_type_style_index_0_id_9583825a_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b759":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_dropdown_vue_vue_type_style_index_0_id_6a09efa2_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2a52");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_dropdown_vue_vue_type_style_index_0_id_6a09efa2_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_dropdown_vue_vue_type_style_index_0_id_6a09efa2_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b8d2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b95d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_listing_skeleton_vue_vue_type_style_index_0_id_4baa0054_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9c3d");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_listing_skeleton_vue_vue_type_style_index_0_id_4baa0054_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_listing_skeleton_vue_vue_type_style_index_0_id_4baa0054_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b9ed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_topbar_vue_vue_type_style_index_0_id_0b8e8acc_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ae95");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_topbar_vue_vue_type_style_index_0_id_0b8e8acc_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_topbar_vue_vue_type_style_index_0_id_0b8e8acc_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ba42":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_login_form_vue_vue_type_style_index_0_id_6fb4033a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c686");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_login_form_vue_vue_type_style_index_0_id_6fb4033a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_login_form_vue_vue_type_style_index_0_id_6fb4033a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bac1":
/***/ (function(module) {

module.exports = JSON.parse("{\"holidayguru\":\"Urlaubsguru\",\"holiday\":\"Urlaub\",\"home\":\"Start\",\"deals\":\"Deals\",\"partners\":\"Suchen & Buchen\",\"wpLinkTitle\":\"Urlaubsziele\",\"wpLinkTarget\":\"https://www.urlaubsguru.de/urlaubsziele/\",\"welcome\":\"Herzlich Willkommen!\",\"loginSuccess\":\"Du bist jetzt angemeldet\",\"registerSuccess\":\"Bitte bestätige noch dein Kundenkonto mit einem Klick auf den Aktivierungslink in der E-Mail.\",\"logoutSuccess\":\"Du bist jetzt abgemeldet\",\"logout\":\"Abmelden\",\"settings\":\"Einstellungen\",\"expired\":\"abgelaufen\",\"noDealsFound\":\"Keine Ergebnisse gefunden. Starte eine neue Suche\",\"saveSuccess\":\"Gespeichert!\",\"removeBookmark\":\"Von der Merkliste entfernt\",\"addBookmark\":\"Zur Merkliste hinzugefügt\",\"communityAgree\":\"Die Community ist deiner Meinung\\n\",\"followTagSuccess\":\"Reisewunsch bestätigt!\",\"unfollowTagSuccess\":\"Reisewunsch entfernt!\",\"showMoreDeals\":\"Weitere Deals anzeigen\",\"moreDeals\":\"weitere Deals\",\"currency\":\"EUR\",\"from\":\"ab\",\"price\":{\"zero\":\"AKTION\"},\"LinkList\":{\"introduction\":{\"head\":\"Herzlich willkommen bei <span>Urlaubsguru!</span>\",\"sub\":\"Seit 10 Jahren ist das Team von Urlaubsguru dein Ansprechpartner für preiswerten Urlaub. Bei der Auswahl unserer Angebote legt unser Team aus Reiseexpert:innen besonderen Wert auf ein optimales Preis-Leistungs-Verhältnis.\"},\"listHead\":{\"travel\":\"Reisearten\",\"destination\":\"Destinationen\"},\"shortIntro\":\"Diese Angebote kannst du direkt bei Urlaubsguru buchen:\",\"destinations\":{\"list\":{\"packageTour\":\"<a href='https://www.urlaubsguru.de/pauschalreisen/'>Pauschalreisen</a>\",\"shortTrip\":\"<a href='https://www.urlaubsguru.de/kurzreisen/'>Kurzreisen</a>\",\"skiTrip\":\"<a href='https://www.urlaubsguru.de/skiurlaub/'>Skireisen</a>\",\"holidayHomes\":\"<a href='https://ferienwohnung.urlaubsguru.de/'>Ferienhäuser</a>\",\"roundTrips\":\"<a href='https://www.urlaubsguru.de/rundreisen/'>Rundreisen</a>\"},\"allIn\":{\"head\":\"All inclusive Urlaub\",\"link\":\"https://www.urlaubsguru.de/all-inclusive/\"},\"earlyBird\":{\"head\":\"Frühbucher\",\"link\":\"https://www.urlaubsguru.de/fruehbucher/\"},\"lastMinute\":{\"head\":\"Last Minute\",\"link\":\"https://www.urlaubsguru.de/last-minute/\"},\"packageTour\":{\"head\":\"Pauschalreisen\",\"sub\":\"Das Rundum-Sorglos-Paket, mit Flug, Hotel, Transfers und Verpflegung. Buche online oder lasse dich von 8-22 Uhr telefonisch beraten. Unsere Service-Telefonnummer: +49 2301 8939742\",\"link\":\"https://www.urlaubsguru.de/pauschalreisen/\"},\"shortTrip\":{\"head\":\"Kurzreisen\",\"sub\":\"Angebote für Wellness, Musical-Reisen und Städtetrips.\",\"link\":\"https://www.urlaubsguru.de/kurzreisen/\"},\"weekendTrips\":{\"head\":\"Wochenentrips\",\"link\":\"https://www.urlaubsguru.de/wochenendtrip/\"},\"familyTrip\":{\"head\":\"Familienurlaub\",\"link\":\"https://www.urlaubsguru.de/familienurlaub/\"},\"cityTrip\":{\"head\":\"Städtereisen\",\"link\":\"https://www.urlaubsguru.de/staedtereisen/\"},\"singleTrip\":{\"head\":\"Singlereisen\",\"link\":\"https://www.urlaubsguru.de/singlereisen/\"},\"longDistanceTravel\":{\"head\":\"Fernreisen\",\"link\":\"https://www.urlaubsguru.de/tag/fernreisen/\"},\"groupTravel\":{\"head\":\"Gruppenreisen\",\"link\":\"https://www.urlaubsguru.de/gruppenreisen/\"},\"luxuryVacation\":{\"head\":\"Luxusurlaub\",\"link\":\"https://www.urlaubsguru.de/luxusurlaub/\"},\"ownArrival\":{\"head\":\"Eigene Anreise\",\"link\":\"https://www.urlaubsguru.de/urlaub-eigene-anreise/\"},\"holidayFlat\":{\"head\":\"Ferienwohnungen\",\"link\":\"https://www.urlaubsguru.de/ferienwohnungen/\"},\"roundTrips\":{\"head\":\"Rundreisen\",\"sub\":\"Organisierte Rundreisen weltweit.\",\"link\":\"https://www.urlaubsguru.de/rundreisen/\"},\"wellness\":{\"head\":\"Wellness\",\"link\":\"https://www.urlaubsguru.de/wellness/\"},\"skiTrip\":{\"head\":\"Skireisen\",\"sub\":\"Top Hotels inkl. Skipass für den nächsten Winterurlaub.\"},\"holidayHomes\":{\"head\":\"Ferienhäuser\",\"sub\":\"Unsere Redaktion versorgt dich mit gut recherchierten Tipps und hilft dir bei der Reiseplanung.\"}},\"specificDestinations\":{\"mallorca\":{\"link\":\"https://www.urlaubsguru.de/urlaubsziele/mallorca-urlaub/\",\"head\":\"Mallorca Urlaub\"},\"greece\":{\"link\":\"https://www.urlaubsguru.de/urlaubsziele/griechenland-urlaub/\",\"head\":\"Griechenland Urlaub\"},\"germany\":{\"link\":\"https://www.urlaubsguru.de/deutschlandliebe/\",\"head\":\"Urlaub in Deutschland\"},\"turkey\":{\"link\":\"https://www.urlaubsguru.de/urlaubsziele/tuerkei-urlaub/\",\"head\":\"Türkei Urlaub\"},\"fuerteventura\":{\"link\":\"https://www.urlaubsguru.de/urlaubsziele/fuerteventura/\",\"head\":\"Fuerteventura Urlaub\"},\"egypt\":{\"link\":\"https://www.urlaubsguru.de/urlaubsziele/aegypten-urlaub/\",\"head\":\"Ägypten Urlaub\"},\"austria\":{\"link\":\"https://www.urlaubsguru.de/urlaubsziele/oesterreich/\",\"head\":\"Österreich Urlaub\"},\"netherlands\":{\"link\":\"https://www.urlaubsguru.de/urlaubsziele/niederlande-urlaub/\",\"head\":\"Niederlande Urlaub\"}},\"inspiration\":{\"head\":\"Inspiration und Reisetipp\",\"sub\":\"Im <a href='https://www.urlaubsguru.de/reisemagazin/'>Reisemagazin</a> und auf Urlaubsziele-Seiten bekommst du hilfreiche Inspiration und Tipps für <a href='https://www.urlaubsguru.de/urlaubsziele/sehenswuerdigkeiten/'>Sehenswürdigkeiten</a>.\"},\"explanationText\":{\"firstText\":\"Außerdem findest du eine <a href='https://www.urlaubsguru.de/flugsuche/#/flights'>Flugsuche</a>, kannst <a href='https://www.urlaubsguru.de/mietwagen/'>Mietwagen</a> buchen und dir <a href='https://www.urlaubsguru.de/gutscheine/'>Reisegutscheine</a> sichern. Gelegentlich leiten wir dich für die Buchung zu verschiedenen Reiseveranstaltern weiter.\",\"secondText\":\"Zum Beispiel, wenn diese besondere Sparaktionen haben, die du dir nicht entgehen lassen solltest. Wundere dich also nicht, wenn du einige Angebote nicht bei uns, sondern bei Partnern wie TUI, trivago, Travelcircus oder auf Hotelwebsites buchen kannst.\"},\"lastInfo\":\"Der <a href='https://www.urlaubsguru.de/reisekalender/'>Reisekalender</a> hilft bei der Wahl der besten Reisezeit und in den <a href='https://www.urlaubsguru.de/freizeitaktivitaeten/'>Freizeitaktivitäten</a> findest du Tipps für Ausflüge und Events.\"},\"travelAgent\":{\"mandatory\":\"*Pflichtfelder\",\"couponButtonText\":{\"homepage\":\"Sichere dir jetzt deinen Reisegutschein!\",\"accountPage\":\"<strong>Dein Reisegutschein wartet hier auf dich!</strong>\"},\"checkBox\":{\"data\":\"Die <a class='privacy-link' href='https://www.urlaubsguru.de/datenschutzerklaerung/' target='blank'>Datenschutzhinweise</a> habe ich zur Kenntnis genommen.*\",\"newsletter\":\"Ja, ich möchte per E-Mail Newsletter über neue Angebote informiert werden. Eine Abmeldung ist jederzeit möglich. (optional)\"},\"emailRegister\":{\"title\":\"Willkommen bei Urlaubsguru. </br> Schön, dass du da bist!\",\"sub\":\"Registriere dich kostenlos und sichere dir nur für kurze Zeit satte <strong>100 € Rabatt auf deine nächste Pauschalreise</strong> (im Wert von über 1.500 €).\",\"secondScreen\":{\"title\":\"Schließe deine kostenlose Registrierung ab.\",\"sub\":\"Fast geschafft! Lege dein persönliches Passwort fest. Dein 100 € Gutschein wartet auf dich! \"},\"name\":\"Vorname*\",\"surname\":\"Nachname*\",\"mail\":\"E-Mail-Adresse*\",\"namePasswort\":\"Passwort festlegen\",\"passwort\":\"Passwort*\",\"repeatPasswort\":\"Passwort wiederholen*\",\"cta\":\"Registrieren & Gutschein sichern\",\"personalData\":{\"sub\":\"Fast geschafft! Lege dein persönliches Passwort fest und reserviere deinen Reisegutschein.\"},\"success\":{\"title\":\"Dein 100€ Gutschein ist nur noch wenige Klicks entfernt\",\"sub\":\"Bestätige die Registrierung deines Accounts, um deinen Gutscheincode zu reservieren.\"}},\"dataRegister\":{\"title\":\"Wonach suchst du? \",\"sub\":\"Teile uns deine Reisepräferenzen und Lieblingsziele mit. Wir stellen dir maßgeschneiderte Angebote vor. Einfach ausfüllen und aus verschiedenen Angeboten deine Favoriten wählen.\",\"destination\":\"Reiseziel*\",\"destinationPlaceholder\":\"Wo soll die Reise hingehen?\",\"cta\":\"Gutschein aktivieren\",\"successCta\":\"Zum Reisemagazin\",\"datePicker\":\"Früheste Hinreise* - Späteste Rückreise*\",\"duration\":\"Reisedauer*\",\"budget\":\"Gesamtes Reisebudget\",\"moneyText\":\"z.B. 1200€\",\"travelersLabel\":\"Reisende*\",\"success\":{\"title\":\"Danke für deine Zeit!\",\"sub\":\"Du erhältst deinen 100 € Gutscheincode in Kürze per Mail.*\",\"subTitle\":\"Deine nächste Reise kann kommen!\",\"subInfo\":\"Wir prüfen deine Reisepräferenzen und schlagen dir zukünftig tolle Angebote vor, die perfekt zu deinen Wünschen passen. \",\"couponDuration\":\"*Gutschein gültig bis 30.11.2022\"}},\"activateAccount\":{\"title\":\"Dein Account ist aktiv\",\"sub\":\"Jetzt kannst du dich einloggen, durch die besten Angebote stöbern und deine Favoriten speichern.\",\"couponTitle\":\"Gutscheinaktivierung\",\"couponSub\":\"Erzähle uns mehr über deine Reisepräferenzen und Lieblingsziele. So können wir dir maßgeschneiderte Angebote vorschlagen, die du dann mit deinem Gutschein deutlich günstiger buchen kannst. \"}},\"ibeUrl\":\"https://buchen.urlaubsguru.de\",\"cookienotice\":\"Mit der Nutzung unserer Dienste erklärst Du dich damit einverstanden, dass wir Cookies verwenden.\",\"minute\":\"Minute\",\"minutes\":\"Minuten\",\"hour\":\"Stunde\",\"hours\":\"Stunden\",\"days\":\"Tage\",\"day\":\"Tag\",\"star\":\"Stern\",\"stars\":\"Sterne\",\"adult\":\"Erwachsener\",\"adults\":\"Erwachsene\",\"child\":\"Kind\",\"children\":\"Kinder\",\"backToHome\":\"zurück zum Start\",\"back\":\"zurück\",\"continue\":\"fortfahren\",\"cancel\":\"Abbrechen\",\"confirm\":\"Bestätigen\",\"save\":\"Speichern\",\"decline\":\"Ablehnen\",\"seo\":{\"home\":{\"title\":\"Urlaub günstig buchen mit Urlaubsguru: Findet euren Traumurlaub\",\"description\":\"Entdeckt mit mir die Welt! ☀️ Hier gibt es die besten Urlaubsangebote ✅ Pauschalreisen, Städtereisen, Flüge, Hotels ✅ Bucht jetzt!\"},\"deals\":{\"title\":\"Aktuelle Deals | Urlaubsguru.de\",\"description\":\"Entdeckt mit mir die Welt! ☀️ Hier gibt es die besten Urlaubsangebote ✅ Pauschalreisen, Städtereisen, Flüge, Hotels ✅ Bucht jetzt!\"},\"partners\":{\"title\":\"Suchen & Buchen | Urlaubsguru.de\",\"description\":\"Suchen & Buchen - die besten Angebote direkt buchen | Urlaubsguru.de\"},\"newsletter\":{\"title\":\"Newsletter | Urlaubsguru.de\",\"description\":\"Beschreibung\"},\"login\":{\"title\":\"Einloggen | Urlaubsguru.de\",\"description\":\"Melde dich bei Urlaubsguru an!\"},\"register\":{\"title\":\"Registrieren | Urlaubsguru.de\",\"description\":\"Registriere dich bei Urlaubsguru!\"},\"forgotPassword\":{\"title\":\"Passwort vergessen | Urlaubsguru.de\",\"description\":\"Setze dein Passwort zurück um deinen Account wieder herzustellen.\"}},\"newest\":\"Neueste\",\"newestDescription\":\"Sortiert nach Einstellungsdatum\",\"mostPopular\":\"Beliebteste\",\"mostPopularDescription\":\"Deals mit den meisten Upvotes\",\"activate\":{\"title\":\"Account aktivieren\",\"subline\":\"Wenn dein Account aktiviert ist, kannst du dich einloggen, Favoriten speichern, und vieles mehr!\",\"success\":\"Erfolgreich aktiviert\",\"fail\":\"Account ist bereits aktiv!\",\"resendMail\":\"Aktivierungsmail erneut senden\"},\"authModal\":{\"title\":\"Schön, dass du da bist!\",\"subline\":\"Willkommen in der Urlaubsguru-Community\",\"login\":\"Einloggen\",\"register\":\"Registrieren\",\"loginTitle\":\"Bitte melde dich mit deinem Konto an.\",\"registerTitle\":\"Registriere dich jetzt und werde Teil unserer Community!\",\"emailLabel\":\"E-Mail\",\"firstNameLabel\":\"Vorname\",\"lastNameLabel\":\"Nachname\",\"passwordLabel\":\"Passwort\",\"passwordConfirmLabel\":\"Passwort wiederholen\",\"forgotPassword\":\"Passwort vergessen?\",\"usernameLabel\":\"Benutzername\",\"newsLetterConsent\":\"Ja, ich möchte per E-Mail Newsletter über neue Deals informiert werden. Abmeldung jederzeit möglich. (optional)\",\"privacyConsent\":\"Die Datenschutzhinweise habe ich zur Kenntnis genommen.\",\"accountExistsQuestion\":\"Du hast bereits einen Account?\",\"registerNow\":\"Jetzt registrieren!\",\"loginNow\":\"Jetzt anmelden!\",\"loginOldAccountWarning\":\"Du hast deinen Account vor März 2020 angelegt? Dann registriere dich bitte neu!\"},\"forgotPassword\":{\"title\":\"Passwort vergessen\",\"checkMail\":\"Wir haben dir eine E-Mail an {email} geschickt. Es kann einige Minuten dauern, bis sie bei dir ankommt. Wenn du keine E-Mail erhalten hast, überprüfe ob die E-Mail richtig geschrieben ist und auch registriert ist.\",\"description\":\"Gib hier deine E-Mail Adresse ein. Wir schicken dir einen Link, um dein Passwort zurückzusetzen.\"},\"resetPassword\":{\"title\":\"Passwort zurücksetzen\",\"success\":\"Erfolgreich zurückgesetzt!\",\"fail\":\"Passwort wurde bereits zurückgesetzt!\",\"description\":\"Wähle ein neues Passwort\",\"reset\":\"zurücksetzen\",\"passwordRequirements\":\"*Das Passwort sollte 8 oder mehr Zeichen mit einer Mischung aus Groß- und Kleinbuchstaben und Zahlen enthalten.\",\"newPassword\":\"Neues Passwort\",\"passwordConfirm\":\"Passwort bestätigen\"},\"share\":{\"facebook\":\"Auf Facebook teilen\",\"twitter\":\"Auf Twitter teilen\",\"whatsapp\":\"Auf WhatsApp teilen\",\"pinterest\":\"Auf Pinterest teilen\",\"messenger\":\"Auf Messenger teilen\"},\"dealSearch\":{\"placeholder\":\"Aktuelle Deals durchsuchen\",\"categoryLabel\":\"Deal-Kategorien wählen\",\"labelHighlightTags\":\"Beliebte Suchbegriffe\",\"labelDeals\":\"Deals\"},\"bookmarkPage\":{\"title\":\"Meine Merkliste\",\"subline\":\"Hier findest du deine gespeicherten Favoriten\",\"empty\":\"Du hast noch keine Favoriten gespeichert\"},\"inputs\":{\"buttonTextApply\":\"Übernehmen\"},\"datepicker\":{\"rangeLabel\":\"Zeitraum\",\"rangeStartLabel\":\"Früheste Hinreise\",\"rangeEndLabel\":\"Späteste Rückreise\",\"rangeStartPlaceholder\":\"bitte auswählen\",\"rangeEndPlaceholder\":\"bitte auswählen\",\"rangePlaceholder\":\"TT.MM.JJJJ - TT.MM.JJJJ\",\"durationRangeErrorText\":\"Der gewählte Reisezeitraum passt nicht zur Reisedauer\"},\"travelDuration\":{\"durationLabel\":\"Reisedauer\",\"durationPlaceholder\":\"Bitte wählen\"},\"ibeSearch\":{\"title\":\"Pauschalreisen\",\"subtitle\":\"Schnüre dein Rundum-Sorglos-Paket\",\"buttonText\":\"Suchen\",\"destinationLabel\":\"Reiseziel oder Hotel\",\"shortDestinationLabel\":\"Reiseziel\",\"destinationPlaceholder\":\"Wo soll die Reise hingehen?\",\"destinationResult\":\"Trage dein Reiseziel ein\",\"noResults\":\"Keine Ergebnisse\",\"dateRangeLabel\":\"Zeitraum\",\"dateRangePlaceholder\":\"TT.MM.JJJJ - TT.MM.JJJJ\",\"dayNames\":[\"So\",\"Mo\",\"Di\",\"Mi\",\"Do\",\"Fr\",\"Sa\"],\"monthNames\":[\"Januar\",\"Februar\",\"März\",\"April\",\"Mai\",\"Juni\",\"Juli\",\"August\",\"September\",\"Oktober\",\"November\",\"Dezember\"],\"durationLabel\":\"Reisedauer\",\"durationPlaceholder\":\"Bitte wählen\",\"airportLabel\":{\"without\":\"Abflughafen\",\"with\":\"Abflughafen*\"},\"airportPlaceholder\":\"Bitte wählen\",\"travelersLabel\":\"Reisende\",\"travelersPlaceholder\":\"2 Erwachsene\",\"travelerChildAgeLabel\":\"Kindesalter bei Rückreise:\",\"dateRangeStartLabel\":\"Von\",\"dateRangeEndLabel\":\"Bis\",\"dateRangeStartPlaceholder\":\"TT.MM.JJJJ\",\"dateRangeEndPlaceholder\":\"TT.MM.JJJJ\",\"favoriteAirport\":\"Beliebte Flughäfen\",\"airportOverview\":\"Flughafenübersicht\",\"noMatch\":\"Kein Treffer\",\"noMatchSubtitle\":\"Leider konnten wir zu deiner Suchanfrage keinen Treffer finden.\",\"noMatchSubtitle2\":\"Bitte prüfe deine Rechtschreibung oder gebe einen anderen Flughafen ein.\",\"chooseDate\":\"Datum wählen\",\"travelerSupportTel\":\"+49 2301 89 39 742\"},\"ameropaSearch\":{\"departureLabel\":\"Abfahrtsbahnhof\",\"departurePlaceholder\":\"Der nächste Bahnhof in deiner Nähe\",\"departureResult\":\"Trage deinen Abfahrtsbahnhof ein\",\"destinationLabel\":\"Reiseziel\",\"destinationPlaceholder\":\"Wo soll die Reise hingehen?\",\"destinationResult\":\"Trage dein Reiseziel ein\"},\"countries\":{\"de\":\"Deutschland\",\"at\":\"Österreich\",\"ch\":\"Schweiz\",\"es\":\"Spanien\",\"nl\":\"Nierderlande\",\"be\":\"Belgien\",\"fr\":\"Frankreich\",\"lux\":\"Luxemburg\",\"east\":\"Deutschland Ost\",\"west\":\"Deutschland West\",\"north\":\"Deutschland Nord\",\"south\":\"Deutschland Süd\",\"it\":\"Italien\",\"svk\":\"Slowakei\",\"hun\":\"Ungarn\"},\"yourProfile\":\"Mein Urlaubsguru-Profil\",\"profileForm\":{\"title\":\"Profil bearbeiten\"},\"firstName\":\"Vorname\",\"firstNamePlaceholder\":\"Justine\",\"lastName\":\"Nachname\",\"lastNamePlaceholder\":\"Musterfrau\",\"locationSelect\":\"PLZ\",\"locationPlaceholder\":\"Holzwickede\",\"profile\":{\"hello\":\"Hallo\",\"subtitle\":\"Willkommen auf deinem Urlaubsguru Profil. Du kannst deine Informationen pflegen und Reiseinteressen auswählen. Das hilft uns dabei, dir Angebote zu zeigen, die perfekt zu dir passen.\",\"yourPersonalData\":\"Meine Persönlichen Daten\",\"completeYourProfile\":\"Mache Urlaubsguru zum perfekten Reiseportal für dich. Stelle dir dein persönliches Profil zusammen.\",\"yourLoginData\":\"Meine Zugangsdaten\",\"yourAccountIsRegisteredWith\":\"Dein Account ist registriert mit der E-Mail:\",\"sex\":{\"male\":\"Männlich\",\"female\":\"Weiblich\",\"label\":\"Geschlecht\",\"placeholder\":\"Bitte wähle dein Geschlecht aus\",\"other\":\"Divers\"},\"preferenceCenterTitle\":\"Meine Reiseinteressen\",\"preferenceCenterButtonLabel\":\"Jetzt auswählen\",\"preferenceCenterButtonUrl\":\"https://www.urlaubsguru.de/reiseninteressen/\",\"xmasCalendarTitle\":\" \",\"xmasCalendarButtonLabel\":\" \",\"xmasCalendarButtonUrl\":\" \"},\"profileTags\":{\"title\":\"Welche Art von Reisen magst du am liebsten?\",\"subtitle\":\"Damit wir dir in Zukunft bessere Angebote schicken können, teile uns bitte mit, welche Art von Reisen du magst.\",\"pleaseSelect\":\"Bitte wähle Reisetypen aus!\"},\"afterRegistration\":{\"almostThere\":\"Fast geschafft!\"},\"deleteAccount\":\"Account löschen\",\"deleteAccountConfirmation\":\"Bist du wirklich sicher, dass du uns verlassen möchtest?\",\"deleteAccountNotice\":\"Dein Account wird sofort deaktiviert und ist nicht mehr zugänglich. Nach spätestens 7 Tagen sind all deine persönlichen Daten aus unseren Systemen gelöscht.\",\"logoutInProgress\":\"Du wirst nun ausgeloggt\",\"delete\":\"löschen\",\"newsletterBox\":{\"title\":\"Nie wieder die Top Deals verpassen\",\"subtitle\":\"Melde dich für den <b>kostenlosen Newsletter</b> an. Hier wirst du über exklusive Specials und die Top Deals der Woche informiert.\",\"subscribeButtonText\":\"Jetzt anmelden\",\"privacyText\":\"Die Datenschutzhinweise habe ich zur Kenntnis genommen.\",\"successTitle\":\"Du hast dich erfolgreich angemeldet\",\"successSubtitleFirst\":\"Vielen Dank für deine Anmeldung.\",\"successSubtitleSecond\":\"Du erhälst eine Bestätigungsemail, in der du die Anmeldung bestätigen musst.\",\"alreadyRegisteredMessage\":\"Du hast bereits ein Urlaubsguru Konto, und möchtest den kostenlosen Newsletter abonnieren?\",\"privacyButtonLabel\":\"Datenschutzerklärung\",\"privacyButtonUrl\":\"https://www.urlaubsguru.de/datenschutzerklaerung/\",\"placeholder\":\"Deine E-Mail-Adresse\",\"send\":\"Anmelden\"},\"locationSelectPlaceholder\":\"44809\",\"validation\":{\"passwordConfirm\":\"Die Passwörter stimmen nicht überein.\",\"password\":\"Das Passwort entspricht nicht den Mindestanforderungen (mind. 6 Zeichen)\",\"email\":\"Bitte gib eine gültige E-Mail-Adresse ein (zum Beispiel: name@muster.de).\",\"required\":\"Dieses Feld ist erforderlich.\",\"firstNameRequired\":\"Bitte gib deinen Vornamen ein.\",\"lastNameRequired\":\"Bitte gib deinen Nachnamen ein.\",\"emailRequired\":\"Bitte gib deine E-Mail-Adresse ein.\"},\"errorHandling\":{\"404\":{\"title\":\"Entschuldigung, da ist irgendetwas schiefgegangen.\",\"description\":\"Diese Seite ist gerade nicht verfügbar. Versuche es mit einer neuen Suchanfrage oder nutze einen der Links, die du hier finden kannst.\",\"linkHeader\":\"Diese Angebote und Tipps können dir auch gefallen:\"},\"410\":{\"title\":\"Hoppla, dieser Inhalt ist nicht mehr verfügbar\",\"description\":\"Da war wohl jemand schneller und hat den Deal schon weggeschnappt. Vielleicht findest du ja auf unserer Seite eine spannende Alternative? \",\"linkHeader\":\"Hier sind einige hilfreiche Links:\"},\"bookmarkNotAdded\":\"Konnte nicht zur Merkliste hinzugefügt werden. Bitte probiere es später erneut.\",\"errorBoxTitle\":\"Hoppla, da ist etwas schief gelaufen.\",\"page_not_exists\":\"Diese Seite existiert nicht\"},\"newsletter\":{\"title\":\"Urlaubsguru Newsletter\",\"subline\":\"Melde dich hier unkompliziert für den kostenlosen Newsetter an. Damit verpasst du keinen Top-Deal mehr.\"},\"topDeal\":\"Top Deal\",\"screenshot\":{\"notice\":\"Bitte beachtet, dass der Screenshot zum Zeitpunkt der Dealerstellung gemacht wurde und der Preis sich möglicherweise bereits geändert hat\"},\"loading\":\"Lade Daten...\",\"loadingscreen\":{\"title\":\"Deine Daten werden verarbeitet.\",\"subtitle\":\"Bitte lade die Seite nicht neu.\"},\"raffle\":{\"successTitle\":\"Danke für deine Teilnahme!\",\"successSubtitle\":\"Der Gewinner/die Gewinnerin wird spätestens 7 Werktage nach Beendigung des Gewinnspiels schriftlich per Mail kontaktiert.\",\"notRegisteredPrompt\":\"Du bist nicht angemeldet, bitte erst\",\"loginButton\":\"anmelden\",\"or\":\"oder\",\"registerButton\":\"kostenlos registrieren\",\"participateButton\":\"Jetzt teilnehmen!\",\"inactive\":\"Dieses Gewinnspiel ist noch nicht aktiv.\",\"clickNotice\":\"Mit dem Klick auf den Button bestätigst du die unten stehenden Teilnahmebedingungen des Adventskalender Gewinnspiels.\",\"completeYourProfileTitle\":\"Bitte vervollständige dein Urlaubsguru-Profil\",\"completeYourProfileSubtitle\":\"Du suchst noch den perfekten Reise-Deal? Um dir in Zukunft noch bessere Angebote zu machen, bitten wir dich dein Profil zu vervollständigen.\",\"completeYourProfileButton\":\"Profil jetzt vervollständigen\",\"alreadyParticipantTitle\":\"Du hast bereits an diesem Gewinnspiel teilgenommen!\",\"alreadyParticipantSubtitle\":\"Falls du gewonnen hast, wirst du per Mail kontaktiert.\"},\"youMightLikeThis\":\"Das könnte dir auch gefallen\",\"night\":\"Nacht\",\"nights\":\"Nächte\",\"goToDeal\":\"Zum Deal\",\"deal\":{\"showScreenshot\":\"Deal-Screenshot anzeigen\",\"showScreenshots\":\"Deal-Screenshots anzeigen\",\"voucherCode\":\"Gutschein Code:\",\"description\":\"Dealbeschreibung\",\"accommodationHeading\":\"Hotel Informationen\",\"accommodationsHeading\":\"Unterkünfte\",\"createdBy\":\"Erstellt von\",\"createdBy_On\":\"am\",\"createdOn\":\"Erstellt am\",\"tooltipVoucherCode\":\"Um den Gutschein zu kopieren, klicke auf den Link und trage diesen beim Bezahlvorgang in das entsprechende Feld ein.\"},\"supportPerson\":{\"name\":\"Lena\",\"title\":\"Hast Du Fragen zu diesem Deal?\",\"telephone\":\"+49 2301 - 8939742\",\"mail\":\"anfrage@urlaubsguru.de\",\"tooltip\":{\"content\":\"Bitte gebe die hier hinterlegte Deal-ID bei der Hotline oder in deiner E-Mail mit an. So können wir dir schneller behilflich sein.\"},\"mailSubject\":\"Meine Frage zum Deal mit der ID:\"},\"dealBox\":{\"flight\":\"Flug\",\"airline\":\"Airline\",\"dealOverview\":\"Deal Übersicht\",\"showMore\":\"Mehr anzeigen\",\"periodsHeading\":\"Termine\",\"periodsTagline\":\"Die günstigsten Termine im Reisezeitraum zwischen:\",\"stayDuration\":\"Aufenthaltsdauer:\",\"periodsTaglineCheapest\":\"Für weitere Termine klicke \\\"Zum Deal\\\".\",\"periodsTaglineDefault\":\"Dein Wunschdatum ist auch verfügbar. Dies ist nur eine Auswahl, für weitere Termine klicke „Zum Deal“.\",\"reminderHeadline\":\"Leider ist der Deal nicht mehr verfügbar.\",\"reminderSubtitle\":\"Das war knapp. Dieser Deal ist nicht mehr verfügbar, aber der nächste gute Deal wartet bereits auf dich.\",\"reminderTextFlight\":\" \",\"reminderTextDefault\":\" \",\"reminderTextNotice\":\" \",\"topPricePerformance\":\"Top Preis-Leistung\",\"handpickedDeal\":\"Handverlesenes Angebot\",\"dealIsValidFor\":\"Angebot gilt bei\",\"travelers\":\"Reisenden\",\"notifyMe\":\"Benachrichtigt mich\",\"cheapestPeriod\":\"Top Preis\",\"availablePeriods\":\"Verfügbar\",\"selectedPeriod\":\"Ausgewählt\",\"priceNotice\":\"* Bitte beachte, dass sich der Preis mittlerweile geändert haben kann\",\"includedInPrice\":\"Im Gesamtpreis inklusive\",\"goToHotelBooking\":\"Zur Hotelbuchung\",\"goToFlightBooking\":\"Zur Flugbuchung\",\"bookYourFlightHere\":\"Buche hier Deinen Flug\",\"bookYourAccommodationHere\":\"Buche hier Deine Unterkunft\",\"departureFrom\":\"Abflug ab\",\"departureSelectLabel\":\"Abflug ab\"},\"dealSort\":{\"newestTitle\":\"Neueste\",\"newestDescription\":\"Sortiert nach Einstellungsdatum\",\"cheapestTitle\":\"Niedrigster Preis\",\"cheapestDescription\":\"Sortiert nach Preis (aufsteigend)\",\"mostExpensiveTitle\":\"Höchster Preis\",\"mostExpensiveDescription\":\"Sortiert nach Preis (absteigend)\"},\"authSuccessTitle\":\"Super!\",\"AccommodationDeal\":\"Unterkunft\",\"BasicDeal\":\"Sonstige\",\"TravelBasicDeal\":\"Reise\",\"FlightDeal\":\"Flug\",\"PackageTourDeal\":\"Pauschalreise\",\"TravelCombinationDeal\":\"Kombideal\",\"departureAirport\":\"Abflughafen\",\"arrivalAirport\":\"Ankunftsflughafen\",\"shareModal\":{\"title\":\"Deal teilen\",\"subtitle\":\"Erzähle deinen Freunden von diesem Deal!\"},\"hotel\":\"Hotel\",\"fieldNames\":{\"firstname\":\"Vorname\",\"lastname\":\"Nachname\",\"email-login\":\"E-Mail\",\"register-email\":\"E-Mail\",\"password-login\":\"Passwort\",\"password\":\"Passwort\",\"confirm\":\"Bestätigen\",\"register\":\"Registrieren\",\"email\":\"E-Mail-Adresse\",\"zip-code-input\":\"PLZ\"},\"AmadeusPackageTourDeal\":\"Pauschalreise\",\"helpBox\":{\"title\":\"Benötigst du Hilfe?\",\"subline\":\"täglich von 8 bis 22 Uhr\",\"phone\":\"+4923018939742\",\"phoneLabel\":\"+49 2301 89 39 742\",\"contactPage\":\" \"},\"travelRestrictions\":{\"title\":\"Infos zu Einreisebestimmungen im Zusammenhang mit Covid-19\",\"showMore\":\"Mehr anzeigen\",\"modalTitle\":\"Fragen und Antworten zur Einreise\",\"yes\":\"Ja.\",\"no\":\"Nein.\",\"quarantineOnEntry\":\"Quarantäne-Pflicht bei Einreise?\",\"show_covid_19_test\":\"Corona-Testpflicht (für Ungeimpfte) bei Einreise?\",\"obligation_to_download_corona_app\":\"Corona App erforderlich?\",\"quick_test_obligatory_on_site\":\"Obligatorischer Schnelltest vor Ort?\",\"registration\":\"Anmeldepflicht bei Einreise?\",\"health_check\":\"Health Check\",\"measures_if_symptoms\":\"Measures if sympoms\",\"insurance\":\"Versicherung\",\"entry_masks\":\"Maskenpflicht vor Ort?\",\"luggage\":\"Gepäck\",\"data\":\"Data\",\"positive_test\":\"Positiver Test\",\"additional_content\":\"Weiteres\",\"importantWhenEnteringTheCountry\":\"Wichtig bei der Einreise\",\"entryIsPossible\":\"Einreise ist möglich\",\"entryIsPartiallyPossible\":\"Einreise ist teilweise möglich\",\"entryIsImpossible\":\"Einreise ist nicht möglich\",\"vaccinated\":\"Geimpft\",\"healed\":\"Genesen\",\"covid19VaccinatedAndHealed\":\"Hinweise für Geimpfte oder Genesene\",\"source\":\"Weiterführende Infos\",\"entryIsForbiddenForCountries\":\"Reisende aus den folgenden Ländern dürfen jedoch nicht einreisen:\"},\"providerConditions\":{\"FLEXIBLE_CANCELLATION_POLICY\":{\"badge\":\"Flexible Stornoregelung\",\"tooltip\":\"Für diesen Deal kann gegen einen kleinen Aufpreis ein Flex-Tarif hinzu gebucht werden. Der Flex-Tarif garantiert bis zu einem gewissen Datum vor der Abreise eine kostenfreie Stornierung. Alle Infos dazu findest du in der Infobox unten.\"},\"FREE_CANCELLATION\":{\"badge\":\"Kostenlose Stornierung\",\"tooltip\":\"Dieser Deal ist bis zu einem gewissen Datum vor der Abreise kostenfrei stornierbar. Alle Infos dazu findest du in der Infobox unten.\"},\"hotel\":\"Hotel\",\"fieldNames\":{\"firstname\":\"Vorname\",\"lastname\":\"Nachname\",\"email-login\":\"E-Mail\",\"register-email\":\"E-Mail\",\"password-login\":\"Passwort\",\"password\":\"Passwort\",\"confirm\":\"Bestätigen\",\"register\":\"Registrieren\",\"email\":\"E-Mail-Adresse\",\"zip-code-input\":\"PLZ\"},\"AmadeusPackageTourDeal\":\"Pauschalreise\",\"helpBox\":{\"title\":\"Benötigst du Hilfe?\",\"subline\":\"täglich von 8 bis 22 Uhr\",\"phone\":\"+4923018939742\",\"phoneLabel\":\"+49 2301 89 39 742\",\"contactPage\":\" \"},\"travelRestrictions\":{\"title\":\"Infos zu Einreisebestimmungen im Zusammenhang mit Covid-19\",\"showMore\":\"Mehr anzeigen\",\"modalTitle\":\"Fragen und Antworten zur Einreise\",\"yes\":\"Ja.\",\"no\":\"Nein.\",\"quarantineOnEntry\":\"Quarantäne-Pflicht bei Einreise?\",\"show_covid_19_test\":\"Corona-Testpflicht (für Ungeimpfte) bei Einreise?\",\"obligation_to_download_corona_app\":\"Corona App erforderlich?\",\"quick_test_obligatory_on_site\":\"Obligatorischer Schnelltest vor Ort?\",\"registration\":\"Anmeldepflicht bei Einreise?\",\"health_check\":\"Health Check\",\"measures_if_symptoms\":\"Measures if sympoms\",\"insurance\":\"Versicherung\",\"entry_masks\":\"Maskenpflicht vor Ort?\",\"luggage\":\"Gepäck\",\"data\":\"Data\",\"positive_test\":\"Positiver Test\",\"additional_content\":\"Weiteres\",\"importantWhenEnteringTheCountry\":\"Wichtig bei der Einreise\",\"entryIsPossible\":\"Einreise ist möglich\",\"entryIsPartiallyPossible\":\"Einreise ist teilweise möglich\",\"entryIsImpossible\":\"Einreise ist nicht möglich\",\"vaccinated\":\"Geimpft\",\"healed\":\"Genesen\",\"covid19VaccinatedAndHealed\":\"Hinweise für Geimpfte oder Genesene\",\"source\":\"Weiterführende Infos\",\"entryIsForbiddenForCountries\":\"Reisende aus den folgenden Ländern dürfen jedoch nicht einreisen:\"},\"providerConditions\":{\"FLEXIBLE_CANCELLATION_POLICY\":{\"badge\":\"Flexible Stornoregelung\",\"tooltip\":\"Für diesen Deal kann gegen einen kleinen Aufpreis ein Flex-Tarif hinzu gebucht werden. Der Flex-Tarif garantiert bis zu einem gewissen Datum vor der Abreise eine kostenfreie Stornierung. Alle Infos dazu findest du in der Infobox unten.\"},\"FREE_CANCELLATION\":{\"badge\":\"Kostenlose Stornierung\",\"tooltip\":\"Dieser Deal ist bis zu einem gewissen Datum vor der Abreise kostenfrei stornierbar. Alle Infos dazu findest du in der Infobox unten.\"},\"FREE_REBOOKING\":{\"badge\":\"Kostenlose Umbuchung\",\"tooltip\":\"Dieser Deal ist bis zu einem gewissen Datum vor der Abreise kostenfrei umbuchbar. Alle Infos dazu findest du in der Infobox unten.\"}},\"noResults\":{\"title\":\"Hoppla!\",\"text\":\"Leider konnten wir zu deiner Suchanfrage keinen Treffer finden. Bitte prüfe deine Rechtschreibung oder suche einfach direkt auf der Urlaubsziele Seite nach deinem Lieblingsziel!\",\"linkText\":\"Zu den Urlaubszielen\"},\"display\":\"anzeigen\",\"theBestTravelStories\":\"Die schönsten Reiseberichte\",\"toRaffle\":\"zum Gewinnspiel\",\"skiSearch\":{\"title\":\"Skireisen\",\"destinationLabel\":\"Reiseziel oder Hotel\",\"destinationPlaceholder\":\"Wo soll die Reise hingehen?\"},\"shortTripSearch\":{\"title\":\"Kurzreisen\",\"destinationLabel\":\"Reiseziel\",\"destinationPlaceholder\":\"Wo soll die Reise hingehen?\",\"noResult\":\"Trage deinen Abreiseort ein\"},\"destinations\":\"Orte\",\"regions\":\"Regionen\",\"accommodation\":{\"tabname\":\"Unterkünfte\",\"hotelbutton\":\"Hotel\",\"accomodationbutton\":\"Ferienwohnung\"},\"citys\":\"Städte\",\"pois\":\"Sehenswürdigkeiten\",\"watadoSearch\":{\"destinationLabel\":\"Reiseziel oder Hotel\",\"destinationPlaceholder\":\"Wo soll die Reise hingehen?\"},\"home2goSearch\":{\"destinationLabel\":\"Reiseziel\",\"destinationPlaceholder\":\"Wo soll die Reise hingehen?\"},\"DirectDeal\":\"Direkter Deal\"},\"getYourGuide\":{\"transferPossible\":\"Abholung möglich\"},\"hotel-of-the-day\":{\"organizer\":\"Veranstalter\"},\"cruiseCompass\":{\"placeholder\":\"Beliebig. Inspiriere mich!\",\"cruiseLineOverview\":\"Reederei\",\"regionsOverview\":\"Regionen\"}}");

/***/ }),

/***/ "bbcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_ameropa_search_vue_vue_type_style_index_0_id_598de7dd_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6e9f");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_ameropa_search_vue_vue_type_style_index_0_id_598de7dd_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_ameropa_search_vue_vue_type_style_index_0_id_598de7dd_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bbd6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "bc6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_dropdown_search_vue_vue_type_style_index_0_id_0a1aeabe_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("af84");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_dropdown_search_vue_vue_type_style_index_0_id_0a1aeabe_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_dropdown_search_vue_vue_type_style_index_0_id_0a1aeabe_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bd4b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "bd98":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_scroll_top_vue_vue_type_style_index_0_id_430d67c2_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bbd6");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_scroll_top_vue_vue_type_style_index_0_id_430d67c2_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_scroll_top_vue_vue_type_style_index_0_id_430d67c2_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bfac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_search_dropdown_vue_vue_type_style_index_0_id_6176ed38_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1016");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_search_dropdown_vue_vue_type_style_index_0_id_6176ed38_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_search_dropdown_vue_vue_type_style_index_0_id_6176ed38_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bfad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_h2go_search_vue_vue_type_style_index_0_id_ea81c080_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("89c4");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_h2go_search_vue_vue_type_style_index_0_id_ea81c080_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_h2go_search_vue_vue_type_style_index_0_id_ea81c080_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bfea":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_vue_vue_type_style_index_0_id_e64e1fb6_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("74dc");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_vue_vue_type_style_index_0_id_e64e1fb6_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_vue_vue_type_style_index_0_id_e64e1fb6_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c1cf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_data_register_vue_vue_type_style_index_0_id_4c8bd33a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("929d");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_data_register_vue_vue_type_style_index_0_id_4c8bd33a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_data_register_vue_vue_type_style_index_0_id_4c8bd33a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c3e9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c620":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_skeleton_redesign_vue_vue_type_style_index_0_id_95de6c6c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fbb9");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_skeleton_redesign_vue_vue_type_style_index_0_id_95de6c6c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_card_skeleton_redesign_vue_vue_type_style_index_0_id_95de6c6c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c686":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c735":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_skeleton_vue_vue_type_style_index_0_id_9b5b01fe_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6f6b");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_skeleton_vue_vue_type_style_index_0_id_9b5b01fe_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_skeleton_vue_vue_type_style_index_0_id_9b5b01fe_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c76e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c810":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_airport_select_vue_vue_type_style_index_0_id_6a9e0f9e_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6af3");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_airport_select_vue_vue_type_style_index_0_id_6a9e0f9e_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_airport_select_vue_vue_type_style_index_0_id_6a9e0f9e_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c89a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hotel_of_the_day_landing_vue_vue_type_style_index_0_id_df756024_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7850");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hotel_of_the_day_landing_vue_vue_type_style_index_0_id_df756024_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hotel_of_the_day_landing_vue_vue_type_style_index_0_id_df756024_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c997":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "cb0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hotel_detail_view_vue_vue_type_style_index_0_id_70d4000c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("171f");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hotel_detail_view_vue_vue_type_style_index_0_id_70d4000c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hotel_detail_view_vue_vue_type_style_index_0_id_70d4000c_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "cb77":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "cbc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_package_tour_vue_vue_type_style_index_0_id_9869dcba_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cfad");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_package_tour_vue_vue_type_style_index_0_id_9869dcba_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_package_tour_vue_vue_type_style_index_0_id_9869dcba_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "cfad":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d03b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_search_wrapper_vue_vue_type_style_index_0_id_de763d8e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2a8f");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_search_wrapper_vue_vue_type_style_index_0_id_de763d8e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_search_wrapper_vue_vue_type_style_index_0_id_de763d8e_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d1e3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_badge_vue_vue_type_style_index_0_id_5eb3e4ad_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("61e7");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_badge_vue_vue_type_style_index_0_id_5eb3e4ad_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_badge_vue_vue_type_style_index_0_id_5eb3e4ad_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d247":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_alert_box_vue_vue_type_style_index_0_id_c9d4a024_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1764");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_alert_box_vue_vue_type_style_index_0_id_c9d4a024_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_alert_box_vue_vue_type_style_index_0_id_c9d4a024_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d3b3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d3dc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d69f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tabs_vue_vue_type_style_index_0_id_1732a6e5_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5e7e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tabs_vue_vue_type_style_index_0_id_1732a6e5_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tabs_vue_vue_type_style_index_0_id_1732a6e5_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d7af":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d7c0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dbc3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dc51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_detail_skeleton_vue_vue_type_style_index_0_id_0f2bf358_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1893");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_detail_skeleton_vue_vue_type_style_index_0_id_0f2bf358_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_detail_skeleton_vue_vue_type_style_index_0_id_0f2bf358_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "df08":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "df09":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "df2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_flicking_slide_vue_vue_type_style_index_0_id_11ac3934_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e388");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_flicking_slide_vue_vue_type_style_index_0_id_11ac3934_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_flicking_slide_vue_vue_type_style_index_0_id_11ac3934_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "dfe8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e011":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_datepicker_vue_vue_type_style_index_0_id_49882b7d_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5c17");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_datepicker_vue_vue_type_style_index_0_id_49882b7d_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_datepicker_vue_vue_type_style_index_0_id_49882b7d_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e013":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e12b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_form_errors_vue_vue_type_style_index_0_id_2dc2a2ba_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9640");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_form_errors_vue_vue_type_style_index_0_id_2dc2a2ba_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_form_errors_vue_vue_type_style_index_0_id_2dc2a2ba_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e138":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_logitravel_package_tour_search_vue_vue_type_style_index_0_id_52840c71_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("07d6");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_logitravel_package_tour_search_vue_vue_type_style_index_0_id_52840c71_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_logitravel_package_tour_search_vue_vue_type_style_index_0_id_52840c71_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e24f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_amadeus_hotel_tour_search_vue_vue_type_style_index_0_id_50e571d7_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6211");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_amadeus_hotel_tour_search_vue_vue_type_style_index_0_id_50e571d7_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_amadeus_hotel_tour_search_vue_vue_type_style_index_0_id_50e571d7_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e292":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_travel_basic_vue_vue_type_style_index_0_id_3bece8be_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6d91");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_travel_basic_vue_vue_type_style_index_0_id_3bece8be_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_travel_basic_vue_vue_type_style_index_0_id_3bece8be_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e388":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e4c8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_getyourguide_card_vue_vue_type_style_index_0_id_48195939_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3898");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_getyourguide_card_vue_vue_type_style_index_0_id_48195939_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_getyourguide_card_vue_vue_type_style_index_0_id_48195939_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e625":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_modal_navbar_vue_vue_type_style_index_0_id_5fb9d48a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ea3c");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_modal_navbar_vue_vue_type_style_index_0_id_5fb9d48a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_modal_navbar_vue_vue_type_style_index_0_id_5fb9d48a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e63a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_destination_select_vue_vue_type_style_index_0_id_2d72399a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f5b6");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_destination_select_vue_vue_type_style_index_0_id_2d72399a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_destination_select_vue_vue_type_style_index_0_id_2d72399a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e6da":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e70d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hotd_filter_vue_vue_type_style_index_0_id_f1c73da8_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4e38");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hotd_filter_vue_vue_type_style_index_0_id_f1c73da8_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_hotd_filter_vue_vue_type_style_index_0_id_f1c73da8_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e7e8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_ski_search_vue_vue_type_style_index_0_id_3fcc6cce_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("536d");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_ski_search_vue_vue_type_style_index_0_id_3fcc6cce_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_ski_search_vue_vue_type_style_index_0_id_3fcc6cce_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e8ab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_portal_dropdown_mobile_vue_vue_type_style_index_0_id_b62e6636_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2c2f");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_portal_dropdown_mobile_vue_vue_type_style_index_0_id_b62e6636_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_portal_dropdown_mobile_vue_vue_type_style_index_0_id_b62e6636_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ea2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_text_link_vue_vue_type_style_index_0_id_696d3d56_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a451");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_text_link_vue_vue_type_style_index_0_id_696d3d56_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_text_link_vue_vue_type_style_index_0_id_696d3d56_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ea3c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "eafc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "eb0e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "eb36":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ebd7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ec13":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ec62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hamburger_vue_vue_type_style_index_0_id_fe929f90_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("326f");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hamburger_vue_vue_type_style_index_0_id_fe929f90_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hamburger_vue_vue_type_style_index_0_id_fe929f90_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "edc6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ef3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_stars_vue_vue_type_style_index_0_id_37ef1096_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ebd7");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_stars_vue_vue_type_style_index_0_id_37ef1096_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_stars_vue_vue_type_style_index_0_id_37ef1096_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f056":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_contact_vue_vue_type_style_index_0_id_008721bf_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6205");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_contact_vue_vue_type_style_index_0_id_008721bf_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_footer_contact_vue_vue_type_style_index_0_id_008721bf_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f136":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_guru_svg_vue_vue_type_style_index_0_id_2e47b090_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9eb6");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_guru_svg_vue_vue_type_style_index_0_id_2e47b090_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_guru_svg_vue_vue_type_style_index_0_id_2e47b090_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f225":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_image_gallery_vue_vue_type_style_index_0_id_46912c22_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("df08");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_image_gallery_vue_vue_type_style_index_0_id_46912c22_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_image_gallery_vue_vue_type_style_index_0_id_46912c22_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f325":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_support_box_vue_vue_type_style_index_0_id_4f398480_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("54c2");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_support_box_vue_vue_type_style_index_0_id_4f398480_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_support_box_vue_vue_type_style_index_0_id_4f398480_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f353":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_carousel_vue_vue_type_style_index_0_id_a171d01a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("50bb");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_carousel_vue_vue_type_style_index_0_id_a171d01a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_card_carousel_vue_vue_type_style_index_0_id_a171d01a_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f487":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_button_vue_vue_type_style_index_0_id_69c28d58_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("710f");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_button_vue_vue_type_style_index_0_id_69c28d58_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_button_vue_vue_type_style_index_0_id_69c28d58_prod_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f4c8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tag_vue_vue_type_style_index_0_id_7b5c52b0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7c0e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tag_vue_vue_type_style_index_0_id_7b5c52b0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_tag_vue_vue_type_style_index_0_id_7b5c52b0_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f5b6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f61e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f6f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_travel_combination_vue_vue_type_style_index_0_id_3149169c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2c26");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_travel_combination_vue_vue_type_style_index_0_id_3149169c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_box_travel_combination_vue_vue_type_style_index_0_id_3149169c_prod_scoped_true_lang_postcss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f7d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_flights_vue_vue_type_style_index_0_id_5eefb2d4_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5f6e");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_flights_vue_vue_type_style_index_0_id_5eefb2d4_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_box_section_flights_vue_vue_type_style_index_0_id_5eefb2d4_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f7fe":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "f8fd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_journaway_search_vue_vue_type_style_index_0_id_61e17084_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1059");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_journaway_search_vue_vue_type_style_index_0_id_61e17084_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_journaway_search_vue_vue_type_style_index_0_id_61e17084_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "fa20":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fa6d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "faad":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fadb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "HgButton", function() { return /* reexport */ hg_button; });
__webpack_require__.d(__webpack_exports__, "HgLinkButton", function() { return /* reexport */ hg_link_button; });
__webpack_require__.d(__webpack_exports__, "HgDropdown", function() { return /* reexport */ hg_dropdown; });
__webpack_require__.d(__webpack_exports__, "HgSelect", function() { return /* reexport */ hg_select; });
__webpack_require__.d(__webpack_exports__, "HgCheckbox", function() { return /* reexport */ hg_checkbox; });
__webpack_require__.d(__webpack_exports__, "HgDatepicker", function() { return /* reexport */ hg_datepicker; });
__webpack_require__.d(__webpack_exports__, "HgSingleDatepicker", function() { return /* reexport */ hg_single_datepicker; });
__webpack_require__.d(__webpack_exports__, "HgPeriodpicker", function() { return /* reexport */ hg_periodpicker; });
__webpack_require__.d(__webpack_exports__, "HgRadioGroup", function() { return /* reexport */ hg_radio_group; });
__webpack_require__.d(__webpack_exports__, "HgTextInput", function() { return /* reexport */ hg_text_input; });
__webpack_require__.d(__webpack_exports__, "HgDealSearchDropdown", function() { return /* reexport */ hg_deal_search_dropdown; });
__webpack_require__.d(__webpack_exports__, "HgDestinationSelect", function() { return /* reexport */ hg_destination_select; });
__webpack_require__.d(__webpack_exports__, "HgAirportSelect", function() { return /* reexport */ hg_airport_select; });
__webpack_require__.d(__webpack_exports__, "HgTravelDurationSelect", function() { return /* reexport */ hg_travel_duration_select; });
__webpack_require__.d(__webpack_exports__, "HgZipCodeInput", function() { return /* reexport */ hg_zip_code_input; });
__webpack_require__.d(__webpack_exports__, "HgNumericInput", function() { return /* reexport */ hg_numeric_input; });
__webpack_require__.d(__webpack_exports__, "HgTravelers", function() { return /* reexport */ hg_travelers; });
__webpack_require__.d(__webpack_exports__, "HgTravelersLocales", function() { return /* reexport */ locales; });
__webpack_require__.d(__webpack_exports__, "HgFormErrors", function() { return /* reexport */ hg_form_errors; });
__webpack_require__.d(__webpack_exports__, "HgCouponButton", function() { return /* reexport */ hg_coupon_button; });
__webpack_require__.d(__webpack_exports__, "HgBadge", function() { return /* reexport */ hg_badge; });
__webpack_require__.d(__webpack_exports__, "HgCruiseSelect", function() { return /* reexport */ hg_cruise_select; });
__webpack_require__.d(__webpack_exports__, "HgAlertBox", function() { return /* reexport */ hg_alert_box; });
__webpack_require__.d(__webpack_exports__, "HgTitleTrigger", function() { return /* reexport */ hg_title_trigger; });
__webpack_require__.d(__webpack_exports__, "HgResponsiveContent", function() { return /* reexport */ hg_responsive_content; });
__webpack_require__.d(__webpack_exports__, "HgCollapsibleContent", function() { return /* reexport */ hg_collapsible_content; });
__webpack_require__.d(__webpack_exports__, "HgCollapse", function() { return /* reexport */ hg_collapse; });
__webpack_require__.d(__webpack_exports__, "HgTabs", function() { return /* reexport */ hg_tabs; });
__webpack_require__.d(__webpack_exports__, "HgTag", function() { return /* reexport */ hg_tag; });
__webpack_require__.d(__webpack_exports__, "HgModal", function() { return /* reexport */ hg_modal; });
__webpack_require__.d(__webpack_exports__, "HgSnapSlider", function() { return /* reexport */ hg_snap_slider; });
__webpack_require__.d(__webpack_exports__, "HgLoadingBar", function() { return /* reexport */ hg_loading_bar; });
__webpack_require__.d(__webpack_exports__, "HgLoadingBubble", function() { return /* reexport */ hg_loading_bubble; });
__webpack_require__.d(__webpack_exports__, "HgTrustpilot", function() { return /* reexport */ hg_trustpilot; });
__webpack_require__.d(__webpack_exports__, "HgTrustpilotButtons", function() { return /* reexport */ hg_trustpilot_buttons; });
__webpack_require__.d(__webpack_exports__, "HgTooltip", function() { return /* reexport */ hg_tooltip; });
__webpack_require__.d(__webpack_exports__, "HgTopbar", function() { return /* reexport */ hg_topbar; });
__webpack_require__.d(__webpack_exports__, "HgTextLink", function() { return /* reexport */ hg_text_link; });
__webpack_require__.d(__webpack_exports__, "HgIcon", function() { return /* reexport */ hg_icon; });
__webpack_require__.d(__webpack_exports__, "HgCardCarousel", function() { return /* reexport */ hg_card_carousel; });
__webpack_require__.d(__webpack_exports__, "HgCarouselSlide", function() { return /* reexport */ hg_carousel_slide; });
__webpack_require__.d(__webpack_exports__, "HgApiErrors", function() { return /* reexport */ hg_api_errors; });
__webpack_require__.d(__webpack_exports__, "HgCancellationBadge", function() { return /* reexport */ hg_cancellation_badge; });
__webpack_require__.d(__webpack_exports__, "HgCardFlicking", function() { return /* reexport */ hg_card_flicking; });
__webpack_require__.d(__webpack_exports__, "HgCardFlickingNew", function() { return /* reexport */ hg_card_flicking_new; });
__webpack_require__.d(__webpack_exports__, "HgFlickingSlide", function() { return /* reexport */ hg_flicking_slide; });
__webpack_require__.d(__webpack_exports__, "HgTagCarousel", function() { return /* reexport */ hg_tag_carousel; });
__webpack_require__.d(__webpack_exports__, "HgHeaderBackground", function() { return /* reexport */ hg_header_background; });
__webpack_require__.d(__webpack_exports__, "HgImage", function() { return /* reexport */ hg_image; });
__webpack_require__.d(__webpack_exports__, "HgLoadingScreen", function() { return /* reexport */ hg_loading_screen; });
__webpack_require__.d(__webpack_exports__, "HgLinkHandler", function() { return /* reexport */ hg_link_handler; });
__webpack_require__.d(__webpack_exports__, "HgLikeBookmark", function() { return /* reexport */ hg_like_bookmark; });
__webpack_require__.d(__webpack_exports__, "HgDealType", function() { return /* reexport */ hg_deal_type; });
__webpack_require__.d(__webpack_exports__, "HgStarRating", function() { return /* reexport */ hg_star_rating; });
__webpack_require__.d(__webpack_exports__, "HgLoginButton", function() { return /* reexport */ hg_login_button; });
__webpack_require__.d(__webpack_exports__, "HgNewsletterBanner", function() { return /* reexport */ hg_newsletter_banner; });
__webpack_require__.d(__webpack_exports__, "HgIconWithHeadline", function() { return /* reexport */ hg_icon_with_headline; });
__webpack_require__.d(__webpack_exports__, "HgDropdownNew", function() { return /* reexport */ hg_dropdown_new; });
__webpack_require__.d(__webpack_exports__, "HgLayout", function() { return /* reexport */ hg_layout; });
__webpack_require__.d(__webpack_exports__, "HgNavbar", function() { return /* reexport */ hg_navbar; });
__webpack_require__.d(__webpack_exports__, "HgNavbarLocales", function() { return /* reexport */ hg_navbarvue_type_script_lang_js_locales; });
__webpack_require__.d(__webpack_exports__, "HgFooter", function() { return /* reexport */ hg_footer; });
__webpack_require__.d(__webpack_exports__, "HgFooterLocales", function() { return /* reexport */ hg_footervue_type_script_lang_js_locales; });
__webpack_require__.d(__webpack_exports__, "HgModalNavbar", function() { return /* reexport */ hg_modal_navbar; });
__webpack_require__.d(__webpack_exports__, "HgHero", function() { return /* reexport */ hg_hero; });
__webpack_require__.d(__webpack_exports__, "HgPortalDropdownDesktop", function() { return /* reexport */ hg_portal_dropdown_desktop; });
__webpack_require__.d(__webpack_exports__, "HgPortalDropdownMobile", function() { return /* reexport */ hg_portal_dropdown_mobile; });
__webpack_require__.d(__webpack_exports__, "HgDealSearchWrapper", function() { return /* reexport */ hg_deal_search_wrapper; });
__webpack_require__.d(__webpack_exports__, "HgEmailRegister", function() { return /* reexport */ email_register; });
__webpack_require__.d(__webpack_exports__, "HgDataRegister", function() { return /* reexport */ data_register; });
__webpack_require__.d(__webpack_exports__, "HgActivateAccount", function() { return /* reexport */ activate_account; });
__webpack_require__.d(__webpack_exports__, "HgLinkListText", function() { return /* reexport */ hg_link_list_text; });
__webpack_require__.d(__webpack_exports__, "HgDestination", function() { return /* reexport */ hg_destination; });
__webpack_require__.d(__webpack_exports__, "HgFooterNew", function() { return /* reexport */ hg_footer_new; });
__webpack_require__.d(__webpack_exports__, "HgFooterContact", function() { return /* reexport */ hg_footer_contact; });
__webpack_require__.d(__webpack_exports__, "HgFooterContactLocales", function() { return /* reexport */ hg_footer_contactvue_type_script_lang_js_locales; });
__webpack_require__.d(__webpack_exports__, "HgFooterDropdown", function() { return /* reexport */ hg_footer_dropdown; });
__webpack_require__.d(__webpack_exports__, "HgFooterDropdownLocales", function() { return /* reexport */ /* Cannot get final name for export "locales" in "./src/components/partials/hg-footer/hg-footer-dropdown.vue" (known exports: default, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "HgFooterFootnote", function() { return /* reexport */ hg_footer_footnote; });
__webpack_require__.d(__webpack_exports__, "HgFooterFootnoteLocales", function() { return /* reexport */ hg_footer_footnotevue_type_script_lang_js_locales; });
__webpack_require__.d(__webpack_exports__, "HgFooterLists", function() { return /* reexport */ hg_footer_lists; });
__webpack_require__.d(__webpack_exports__, "HgFooterListsLocales", function() { return /* reexport */ hg_footer_listsvue_type_script_lang_js_locales; });
__webpack_require__.d(__webpack_exports__, "HgFooterNewsletter", function() { return /* reexport */ hg_footer_newsletter; });
__webpack_require__.d(__webpack_exports__, "HgFooterNewsletterLocales", function() { return /* reexport */ hg_footer_newslettervue_type_script_lang_js_locales; });
__webpack_require__.d(__webpack_exports__, "HgFooterPromotion", function() { return /* reexport */ hg_footer_promotion; });
__webpack_require__.d(__webpack_exports__, "HgFooterPromotionLocales", function() { return /* reexport */ hg_footer_promotionvue_type_script_lang_js_locales; });
__webpack_require__.d(__webpack_exports__, "HgFooterScrollTop", function() { return /* reexport */ hg_footer_scroll_top; });
__webpack_require__.d(__webpack_exports__, "HgFooterSocialMedia", function() { return /* reexport */ hg_footer_social_media; });
__webpack_require__.d(__webpack_exports__, "HgFooterSocialMediaLocales", function() { return /* reexport */ hg_footer_social_mediavue_type_script_lang_js_locales; });
__webpack_require__.d(__webpack_exports__, "HgSearchTabs", function() { return /* reexport */ hg_search_tabs; });
__webpack_require__.d(__webpack_exports__, "HgDealSortFilter", function() { return /* reexport */ hg_deal_sort_filter; });
__webpack_require__.d(__webpack_exports__, "HgIbeSearch", function() { return /* reexport */ hg_ibe_search; });
__webpack_require__.d(__webpack_exports__, "HgSkiSearch", function() { return /* reexport */ hg_ski_search; });
__webpack_require__.d(__webpack_exports__, "HgShortTripSearch", function() { return /* reexport */ hg_short_trip_search; });
__webpack_require__.d(__webpack_exports__, "HgWatadoSearch", function() { return /* reexport */ hg_watado_search; });
__webpack_require__.d(__webpack_exports__, "HgDealDropdownSearch", function() { return /* reexport */ hg_deal_dropdown_search; });
__webpack_require__.d(__webpack_exports__, "HgMobileSearch", function() { return /* reexport */ hg_mobile_search; });
__webpack_require__.d(__webpack_exports__, "HgVakantiediscounterPackageTourSearch", function() { return /* reexport */ hg_vakantiediscounter_package_tour_search; });
__webpack_require__.d(__webpack_exports__, "HgLogitravelPackageTourSearch", function() { return /* reexport */ hg_logitravel_package_tour_search; });
__webpack_require__.d(__webpack_exports__, "HgH2goSearch", function() { return /* reexport */ hg_h2go_search; });
__webpack_require__.d(__webpack_exports__, "HgAmadeusHotelTourSearch", function() { return /* reexport */ hg_amadeus_hotel_tour_search; });
__webpack_require__.d(__webpack_exports__, "HgAmadeusPackageTourSearch", function() { return /* reexport */ hg_amadeus_package_tour_search; });
__webpack_require__.d(__webpack_exports__, "HgNetmatchPackageTourSearch", function() { return /* reexport */ hg_netmatch_package_tour_search; });
__webpack_require__.d(__webpack_exports__, "HgNetmatchHotelTourSearch", function() { return /* reexport */ hg_netmatch_hotel_tour_search; });
__webpack_require__.d(__webpack_exports__, "HgPartnerSlider", function() { return /* reexport */ hg_partner_slider; });
__webpack_require__.d(__webpack_exports__, "HgHotdFilter", function() { return /* reexport */ hg_hotd_filter; });
__webpack_require__.d(__webpack_exports__, "HgCruiseSearch", function() { return /* reexport */ hg_cruise_search; });
__webpack_require__.d(__webpack_exports__, "HgJournawaySearch", function() { return /* reexport */ hg_journaway_search; });
__webpack_require__.d(__webpack_exports__, "HgAmeropaSearch", function() { return /* reexport */ hg_ameropa_search; });
__webpack_require__.d(__webpack_exports__, "HgLastminutePackageTourSearch", function() { return /* reexport */ hg_lastminute_package_tour_search; });
__webpack_require__.d(__webpack_exports__, "HgContentCard", function() { return /* reexport */ hg_content_card; });
__webpack_require__.d(__webpack_exports__, "HgMagazineCard", function() { return /* reexport */ hg_magazine_card; });
__webpack_require__.d(__webpack_exports__, "HgTopDealCard", function() { return /* reexport */ hg_top_deal_card; });
__webpack_require__.d(__webpack_exports__, "HgDealCard", function() { return /* reexport */ hg_deal_card; });
__webpack_require__.d(__webpack_exports__, "HgDealListing", function() { return /* reexport */ hg_deal_listing; });
__webpack_require__.d(__webpack_exports__, "HgDealCardSkeleton", function() { return /* reexport */ hg_deal_card_skeleton; });
__webpack_require__.d(__webpack_exports__, "HgDealCardSkeletonRedesign", function() { return /* reexport */ hg_deal_card_skeleton_redesign; });
__webpack_require__.d(__webpack_exports__, "HgDealListingSkeleton", function() { return /* reexport */ hg_deal_listing_skeleton; });
__webpack_require__.d(__webpack_exports__, "HgGetYourGuideCard", function() { return /* reexport */ hg_getyourguide_card; });
__webpack_require__.d(__webpack_exports__, "HgDealCardRedesign", function() { return /* reexport */ hg_deal_card_redesign; });
__webpack_require__.d(__webpack_exports__, "HgCard", function() { return /* reexport */ hg_card; });
__webpack_require__.d(__webpack_exports__, "HgCardHotelOfTheDay", function() { return /* reexport */ hg_card_hotel_of_the_day; });
__webpack_require__.d(__webpack_exports__, "HgCardCategory", function() { return /* reexport */ hg_card_category; });
__webpack_require__.d(__webpack_exports__, "HgHotelOfTheDayLanding", function() { return /* reexport */ hg_hotel_of_the_day_landing; });
__webpack_require__.d(__webpack_exports__, "HgCardMoods", function() { return /* reexport */ hg_card_moods; });
__webpack_require__.d(__webpack_exports__, "HgPromotionbanner", function() { return /* reexport */ hg_promotionbanner; });
__webpack_require__.d(__webpack_exports__, "HgDealDetailSkeleton", function() { return /* reexport */ hg_deal_detail_skeleton; });
__webpack_require__.d(__webpack_exports__, "HgDealImageGallery", function() { return /* reexport */ hg_deal_image_gallery; });
__webpack_require__.d(__webpack_exports__, "HgDealHotelAttributes", function() { return /* reexport */ hg_deal_hotel_attributes; });
__webpack_require__.d(__webpack_exports__, "HgDealVoucher", function() { return /* reexport */ hg_deal_voucher; });
__webpack_require__.d(__webpack_exports__, "HgDealSupportBox", function() { return /* reexport */ hg_deal_support_box; });
__webpack_require__.d(__webpack_exports__, "HgDealPrice", function() { return /* reexport */ hg_deal_price; });
__webpack_require__.d(__webpack_exports__, "HgDealTitle", function() { return /* reexport */ hg_deal_title; });
__webpack_require__.d(__webpack_exports__, "HgDealFooter", function() { return /* reexport */ hg_deal_footer; });
__webpack_require__.d(__webpack_exports__, "HgDealBoxSkeleton", function() { return /* reexport */ hg_deal_box_skeleton; });
__webpack_require__.d(__webpack_exports__, "HgDealBoxBasic", function() { return /* reexport */ hg_deal_box_basic; });
__webpack_require__.d(__webpack_exports__, "HgDealBoxTravelBasic", function() { return /* reexport */ hg_deal_box_travel_basic; });
__webpack_require__.d(__webpack_exports__, "HgDealBoxAccommodation", function() { return /* reexport */ hg_deal_box_accommodation; });
__webpack_require__.d(__webpack_exports__, "HgDealBoxFlight", function() { return /* reexport */ hg_deal_box_flight; });
__webpack_require__.d(__webpack_exports__, "HgDealBoxPackageTour", function() { return /* reexport */ hg_deal_box_package_tour; });
__webpack_require__.d(__webpack_exports__, "HgDealBoxAmadeusPackageTour", function() { return /* reexport */ hg_deal_box_amadeus_package_tour; });
__webpack_require__.d(__webpack_exports__, "HgDealBoxTravelCombination", function() { return /* reexport */ hg_deal_box_travel_combination; });
__webpack_require__.d(__webpack_exports__, "HgPeriodLabel", function() { return /* reexport */ hg_period_label; });
__webpack_require__.d(__webpack_exports__, "HgHotelDetailView", function() { return /* reexport */ hg_hotel_detail_view; });
__webpack_require__.d(__webpack_exports__, "HgStars", function() { return /* reexport */ hg_stars; });
__webpack_require__.d(__webpack_exports__, "HgLoginForm", function() { return /* reexport */ hg_login_form; });
__webpack_require__.d(__webpack_exports__, "HgRegisterForm", function() { return /* reexport */ hg_register_form; });
__webpack_require__.d(__webpack_exports__, "HgNewPasswordForm", function() { return /* reexport */ hg_new_password_form; });
__webpack_require__.d(__webpack_exports__, "HgForgotPasswordForm", function() { return /* reexport */ hg_forgot_password_form; });
__webpack_require__.d(__webpack_exports__, "HgAccountActivationForm", function() { return /* reexport */ hg_account_activation_form; });
__webpack_require__.d(__webpack_exports__, "HgActivateForm", function() { return /* reexport */ hg_activate_form; });
__webpack_require__.d(__webpack_exports__, "HgNewsletterBox", function() { return /* reexport */ hg_newsletter_box; });
__webpack_require__.d(__webpack_exports__, "HgUserProfileForm", function() { return /* reexport */ hg_user_profile_form; });
__webpack_require__.d(__webpack_exports__, "HgAuthModal", function() { return /* reexport */ hg_auth_modal; });
__webpack_require__.d(__webpack_exports__, "GuruSvg", function() { return /* reexport */ guru_svg; });
__webpack_require__.d(__webpack_exports__, "GuruLogo", function() { return /* reexport */ guru_logo; });
__webpack_require__.d(__webpack_exports__, "GuruLogoPlain", function() { return /* reexport */ guru_logo_plain; });
__webpack_require__.d(__webpack_exports__, "GuruLogoMobile", function() { return /* reexport */ guru_logo_mobile; });
__webpack_require__.d(__webpack_exports__, "GuruScrollTop", function() { return /* reexport */ guru_scroll_top; });
__webpack_require__.d(__webpack_exports__, "GuruLogoU", function() { return /* reexport */ guru_logo_u; });
__webpack_require__.d(__webpack_exports__, "GuruLogoPart", function() { return /* reexport */ guru_logo_part; });
__webpack_require__.d(__webpack_exports__, "GygLogo", function() { return /* reexport */ gyg_logo; });
__webpack_require__.d(__webpack_exports__, "AppleLogo", function() { return /* reexport */ apple_logo; });
__webpack_require__.d(__webpack_exports__, "FacebookLogo", function() { return /* reexport */ facebook_logo; });
__webpack_require__.d(__webpack_exports__, "GoogleLogo", function() { return /* reexport */ google_logo; });
__webpack_require__.d(__webpack_exports__, "ArrowSvg", function() { return /* reexport */ arrow_svg; });
__webpack_require__.d(__webpack_exports__, "ArrowCircleSvg", function() { return /* reexport */ arrow_circle_svg; });
__webpack_require__.d(__webpack_exports__, "ArrowRightLongSvg", function() { return /* reexport */ arrow_right_long_svg; });
__webpack_require__.d(__webpack_exports__, "SupportBoxSvg", function() { return /* reexport */ support_box_svg; });
__webpack_require__.d(__webpack_exports__, "BadgeSvg", function() { return /* reexport */ badge_svg; });
__webpack_require__.d(__webpack_exports__, "HomeHeroDeSvg", function() { return /* reexport */ home_hero_de_svg; });
__webpack_require__.d(__webpack_exports__, "HomeHeroAtSvg", function() { return /* reexport */ home_hero_at_svg; });
__webpack_require__.d(__webpack_exports__, "HomeHeroNlSvg", function() { return /* reexport */ home_hero_nl_svg; });
__webpack_require__.d(__webpack_exports__, "HomeHeroEsSvg", function() { return /* reexport */ home_hero_es_svg; });
__webpack_require__.d(__webpack_exports__, "HomeHeroChSvg", function() { return /* reexport */ home_hero_ch_svg; });
__webpack_require__.d(__webpack_exports__, "HomeHeroEngSvg", function() { return /* reexport */ home_hero_eng_svg; });
__webpack_require__.d(__webpack_exports__, "NoResultSvg", function() { return /* reexport */ no_result_svg; });
__webpack_require__.d(__webpack_exports__, "BlueStarSvg", function() { return /* reexport */ blue_star_svg; });
__webpack_require__.d(__webpack_exports__, "TrustpilotStarSvg", function() { return /* reexport */ trustpilot_star_svg; });
__webpack_require__.d(__webpack_exports__, "InstagramFooterSvg", function() { return /* reexport */ instagram_footer_svg; });
__webpack_require__.d(__webpack_exports__, "FacebookFooterSvg", function() { return /* reexport */ facebook_footer_svg; });
__webpack_require__.d(__webpack_exports__, "YoutubeFooterSvg", function() { return /* reexport */ youtube_footer_svg; });
__webpack_require__.d(__webpack_exports__, "TiktokFooterSvg", function() { return /* reexport */ tiktok_footer_svg; });
__webpack_require__.d(__webpack_exports__, "LinkedinFooterSvg", function() { return /* reexport */ linkedin_footer_svg; });
__webpack_require__.d(__webpack_exports__, "PinterestFooterSvg", function() { return /* reexport */ pinterest_footer_svg; });
__webpack_require__.d(__webpack_exports__, "TelegramFooterSvg", function() { return /* reexport */ telegram_footer_svg; });
__webpack_require__.d(__webpack_exports__, "WhatsappFooterSvg", function() { return /* reexport */ whatsapp_footer_svg; });
__webpack_require__.d(__webpack_exports__, "FilterSvg", function() { return /* reexport */ filter_svg; });
__webpack_require__.d(__webpack_exports__, "EarthSvg", function() { return /* reexport */ earth_svg; });
__webpack_require__.d(__webpack_exports__, "EnvelopeSvg", function() { return /* reexport */ envelope_svg; });
__webpack_require__.d(__webpack_exports__, "PlaneSvg", function() { return /* reexport */ plane_svg; });
__webpack_require__.d(__webpack_exports__, "OneHundredEuroSvg", function() { return /* reexport */ one_hundred_euro_svg; });
__webpack_require__.d(__webpack_exports__, "CouponTextSvg", function() { return /* reexport */ coupon_text_svg; });
__webpack_require__.d(__webpack_exports__, "GuruLogoSvg", function() { return /* reexport */ guru_logo_svg; });
__webpack_require__.d(__webpack_exports__, "ButtonCircleSvg", function() { return /* reexport */ button_circle_svg; });
__webpack_require__.d(__webpack_exports__, "TrustPilotPlaceholderSvg", function() { return /* reexport */ trust_pilot_placeholder_svg; });
__webpack_require__.d(__webpack_exports__, "HotelOfTheDaySvg", function() { return /* reexport */ hotel_of_the_day_circle_svg; });
__webpack_require__.d(__webpack_exports__, "LinkOutSvg", function() { return /* reexport */ link_out_svg; });
__webpack_require__.d(__webpack_exports__, "LinkOutWhiteSvg", function() { return /* reexport */ link_out_white_svg; });
__webpack_require__.d(__webpack_exports__, "LinkInsideArrowSvg", function() { return /* reexport */ link_inside_arrow_svg; });
__webpack_require__.d(__webpack_exports__, "NewsletterBannerMailSvg", function() { return /* reexport */ newsletter_banner_mail_svg; });
__webpack_require__.d(__webpack_exports__, "NewsletterBannerFlightSvg", function() { return /* reexport */ newsletter_banner_flight_svg; });
__webpack_require__.d(__webpack_exports__, "PremiosFinalistaSvg", function() { return /* reexport */ premios_finalista_svg; });
__webpack_require__.d(__webpack_exports__, "AdultsSvg", function() { return /* reexport */ adults_svg; });
__webpack_require__.d(__webpack_exports__, "BabyBottleSvg", function() { return /* reexport */ baby_bottle_svg; });
__webpack_require__.d(__webpack_exports__, "BabySvg", function() { return /* reexport */ baby_svg; });
__webpack_require__.d(__webpack_exports__, "BeachSvg", function() { return /* reexport */ beach_svg; });
__webpack_require__.d(__webpack_exports__, "BikingSvg", function() { return /* reexport */ biking_svg; });
__webpack_require__.d(__webpack_exports__, "CalendarImageSvg", function() { return /* reexport */ calendar_image_svg; });
__webpack_require__.d(__webpack_exports__, "CheckSvg", function() { return /* reexport */ check_svg; });
__webpack_require__.d(__webpack_exports__, "ChildSvg", function() { return /* reexport */ child_svg; });
__webpack_require__.d(__webpack_exports__, "ClockSvg", function() { return /* reexport */ clock_svg; });
__webpack_require__.d(__webpack_exports__, "CoinsSvg", function() { return /* reexport */ coins_svg; });
__webpack_require__.d(__webpack_exports__, "CoupleSvg", function() { return /* reexport */ couple_svg; });
__webpack_require__.d(__webpack_exports__, "DeckChairSunSvg", function() { return /* reexport */ deck_chair_sun_svg; });
__webpack_require__.d(__webpack_exports__, "DivingSvg", function() { return /* reexport */ diving_svg; });
__webpack_require__.d(__webpack_exports__, "DoctorSvg", function() { return /* reexport */ doctor_svg; });
__webpack_require__.d(__webpack_exports__, "EntertainmentSvg", function() { return /* reexport */ entertainment_svg; });
__webpack_require__.d(__webpack_exports__, "FamilySvg", function() { return /* reexport */ family_svg; });
__webpack_require__.d(__webpack_exports__, "FitnessSvg", function() { return /* reexport */ fitness_svg; });
__webpack_require__.d(__webpack_exports__, "GarageCarSvg", function() { return /* reexport */ garage_car_svg; });
__webpack_require__.d(__webpack_exports__, "GolfClubSvg", function() { return /* reexport */ golf_club_svg; });
__webpack_require__.d(__webpack_exports__, "HandWashSvg", function() { return /* reexport */ hand_wash_svg; });
__webpack_require__.d(__webpack_exports__, "HikingSvg", function() { return /* reexport */ hiking_svg; });
__webpack_require__.d(__webpack_exports__, "HotelSvg", function() { return /* reexport */ hotel_svg; });
__webpack_require__.d(__webpack_exports__, "MassageSvg", function() { return /* reexport */ massage_svg; });
__webpack_require__.d(__webpack_exports__, "MaxiClubSvg", function() { return /* reexport */ maxi_club_svg; });
__webpack_require__.d(__webpack_exports__, "MiniClubSvg", function() { return /* reexport */ mini_club_svg; });
__webpack_require__.d(__webpack_exports__, "NoSmokingSvg", function() { return /* reexport */ no_smoking_svg; });
__webpack_require__.d(__webpack_exports__, "ParkingSvg", function() { return /* reexport */ parking_svg; });
__webpack_require__.d(__webpack_exports__, "PetSvg", function() { return /* reexport */ pet_svg; });
__webpack_require__.d(__webpack_exports__, "PlaceSvg", function() { return /* reexport */ place_svg; });
__webpack_require__.d(__webpack_exports__, "PoolSvg", function() { return /* reexport */ pool_svg; });
__webpack_require__.d(__webpack_exports__, "PoolKidsSvg", function() { return /* reexport */ pool_kids_svg; });
__webpack_require__.d(__webpack_exports__, "RestaurantSvg", function() { return /* reexport */ restaurant_svg; });
__webpack_require__.d(__webpack_exports__, "SaunaSvg", function() { return /* reexport */ sauna_svg; });
__webpack_require__.d(__webpack_exports__, "StarSvg", function() { return /* reexport */ star_svg; });
__webpack_require__.d(__webpack_exports__, "TheaterMasksSvg", function() { return /* reexport */ theater_masks_svg; });
__webpack_require__.d(__webpack_exports__, "TrainSubwaySvg", function() { return /* reexport */ train_subway; });
__webpack_require__.d(__webpack_exports__, "TwentyFourReceptionSvg", function() { return /* reexport */ twenty_four_reception_svg; });
__webpack_require__.d(__webpack_exports__, "WasherSvg", function() { return /* reexport */ washer_svg; });
__webpack_require__.d(__webpack_exports__, "WatersportsSvg", function() { return /* reexport */ watersports_svg; });
__webpack_require__.d(__webpack_exports__, "WellnessSvg", function() { return /* reexport */ wellness_svg; });
__webpack_require__.d(__webpack_exports__, "WheelchairSvg", function() { return /* reexport */ wheelchair_svg; });
__webpack_require__.d(__webpack_exports__, "WintersportSvg", function() { return /* reexport */ wintersport_svg; });
__webpack_require__.d(__webpack_exports__, "WlanSvg", function() { return /* reexport */ wlan_svg; });
__webpack_require__.d(__webpack_exports__, "AppStoreDE", function() { return /* reexport */ app_de; });
__webpack_require__.d(__webpack_exports__, "AppStoreAT", function() { return /* reexport */ app_at; });
__webpack_require__.d(__webpack_exports__, "AppStoreCH", function() { return /* reexport */ app_ch; });
__webpack_require__.d(__webpack_exports__, "AppStoreNL", function() { return /* reexport */ app_nl; });
__webpack_require__.d(__webpack_exports__, "AppStoreES", function() { return /* reexport */ app_es; });
__webpack_require__.d(__webpack_exports__, "PlayStoreDE", function() { return /* reexport */ play_de; });
__webpack_require__.d(__webpack_exports__, "PlayStoreAT", function() { return /* reexport */ play_at; });
__webpack_require__.d(__webpack_exports__, "PlayStoreCH", function() { return /* reexport */ play_ch; });
__webpack_require__.d(__webpack_exports__, "PlayStoreNL", function() { return /* reexport */ play_nl; });
__webpack_require__.d(__webpack_exports__, "PlayStoreES", function() { return /* reexport */ play_es; });
__webpack_require__.d(__webpack_exports__, "messages", function() { return /* reexport */ lang; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-button.vue?vue&type=template&id=69c28d58
var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.computedTag,_vm._b({tag:"component",staticClass:"hg-button",class:[
    `hg-button--${_vm.color} hg-button--${_vm.size}`,
    _vm.rounded && 'hg-button--rounded',
    _vm.mobileIcon && 'hg-button--mobile-icon',
  ],attrs:{"type":_vm.nativeType,"data-partner":_vm.dataPartner,"role":"button"},on:{"click":_vm.handleClick}},'component',_vm.$attrs,false),[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-button.vue?vue&type=template&id=69c28d58

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-button.vue?vue&type=script&lang=js

/* harmony default export */ var hg_buttonvue_type_script_lang_js = ({
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: 'default',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'regular',
    },
    mobileIcon: {
      type: Boolean,
      default: false,
    },
    nativeType: {
      type: String,
      default: 'button',
      validator: (value) => {
        return ['button', 'submit', 'reset'].indexOf(value) >= 0
      },
    },
    tag: {
      type: String,
      default: 'button',
      validator: (value) => {
        return ['button', 'a', 'nuxt-link', 'div', 'span'].indexOf(value) >= 0
      },
    },
    dataPartner: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedTag() {
      if (
        this.$attrs.disabled !== undefined &&
        this.$attrs.disabled !== false
      ) {
        return 'button'
      }
      return this.tag
    },
  },
  methods: {
    handleClick() {
      this.$emit('onClick')
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-button.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_buttonvue_type_script_lang_js = (hg_buttonvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-button.vue?vue&type=style&index=0&id=69c28d58&prod&lang=postcss
var hg_buttonvue_type_style_index_0_id_69c28d58_prod_lang_postcss = __webpack_require__("f487");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/inputs/hg-button.vue






/* normalize component */

var component = normalizeComponent(
  inputs_hg_buttonvue_type_script_lang_js,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_button = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-link-button.vue?vue&type=template&id=5a4e8ecc
var hg_link_buttonvue_type_template_id_5a4e8ecc_render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.computedTag,_vm._b({tag:"component",staticClass:"hg-button-component",class:`hg-link-button hg-link-button--${_vm.alignSelf}`,attrs:{"type":_vm.nativeType,"data-partner":_vm.dataPartner,"target":_vm.target,"rel":_vm.computedRel,"href":_vm.href,"role":"button"},on:{"click":_vm.handleClick}},'component',_vm.$attrs,false),[(_vm.size !== 'small')?_c('span',{staticClass:"hg-component-text"},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e(),_c('hg-icon',{staticClass:"hg-component-icon",attrs:{"name":"chevron-right","size":_vm.size}})],1)
}
var hg_link_buttonvue_type_template_id_5a4e8ecc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-link-button.vue?vue&type=template&id=5a4e8ecc

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-link-button.vue?vue&type=script&lang=js

/* harmony default export */ var hg_link_buttonvue_type_script_lang_js = ({
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: 'default',
    },
    buttonText: {
      type: String,
      default: 'click here',
    },
    size: {
      type: String,
      default: 'regular',
    },
    target: {
      type: String,
      default: '_blank',
    },
    alignSelf: {
      type: String,
      default: 'start',
    },
    nativeType: {
      type: String,
      default: 'button',
      validator: (value) => {
        return ['button', 'submit', 'reset'].includes(value)
      },
    },
    tag: {
      type: String,
      default: 'button',
      validator: (value) => {
        return ['button', 'a', 'nuxt-link', 'div', 'span'].includes(value)
      },
    },
    dataPartner: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    computedTag() {
      if (
        this.$attrs.disabled !== undefined &&
        this.$attrs.disabled !== false
      ) {
        return 'button'
      }
      return this.tag
    },
    computedRel() {
      return this.tag === 'a' && this.target === '_blank' ? 'noopener' : null
    },
  },
  methods: {
    handleClick() {
      this.$emit('onClick')
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-link-button.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_link_buttonvue_type_script_lang_js = (hg_link_buttonvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-link-button.vue?vue&type=style&index=0&id=5a4e8ecc&prod&lang=postcss
var hg_link_buttonvue_type_style_index_0_id_5a4e8ecc_prod_lang_postcss = __webpack_require__("2217");

// CONCATENATED MODULE: ./src/components/inputs/hg-link-button.vue






/* normalize component */

var hg_link_button_component = normalizeComponent(
  inputs_hg_link_buttonvue_type_script_lang_js,
  hg_link_buttonvue_type_template_id_5a4e8ecc_render,
  hg_link_buttonvue_type_template_id_5a4e8ecc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_link_button = (hg_link_button_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-dropdown.vue?vue&type=template&id=9296a406&scoped=true
var hg_dropdownvue_type_template_id_9296a406_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-dropdown-wrapper"},[_c('button',{ref:"buttonRef",class:[
      `hg-${_vm.dropdownStyle} hg-${_vm.dropdownStyle}--${_vm.triggerColor} hg-${_vm.dropdownStyle}--${_vm.triggerColor}-border hg-${_vm.dropdownStyle}--regular`,
      _vm.triggerClasses,
      _vm.isDisabled && 'hg-dropdown--disabled',
      _vm.theme ? _vm.theme : '',
    ],attrs:{"aria-active":_vm.isActive,"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){return _vm.clickTrigger()}}},[_vm._t("trigger"),(_vm.hasDropdownChevron)?[_c('span',{staticClass:"hg-dropdown__chevron",class:{ 'hg-dropdown__chevron--rotate-180': _vm.isActive }},[_c('hg-icon',{attrs:{"name":"chevron-down","size":"small"}})],1)]:_vm._e()],2),_c('transition',{attrs:{"name":`${
      _vm.isFullscreenOnMobile || _vm.isInsidePortal
        ? 'hg-dropdown-slide'
        : 'hg-dropdown-fade'
    }`}},[(_vm.isActive)?_c('div',{ref:"contentRef",staticClass:"dd-content-wrapper",class:_vm.wrapperClasses,attrs:{"aria-expanded":_vm.isActive}},[(_vm.isFullscreenOnMobile)?_c('div',{staticClass:"close-container"},[_c('button',{staticClass:"close close-button hg-button hg-button--white",on:{"click":_vm.close}},[_c('hg-icon',{attrs:{"name":"times","pack":"fal"}})],1)]):_vm._e(),_vm._t("default")],2):_vm._e()])],1)
}
var hg_dropdownvue_type_template_id_9296a406_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-dropdown.vue?vue&type=template&id=9296a406&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-dropdown.vue?vue&type=script&lang=js

/* harmony default export */ var hg_dropdownvue_type_script_lang_js = ({
  props: {
    position: {
      type: String,
      default: 'bottom left',
    },
    size: {
      type: String,
      default: 'regular',
    },
    dropdownStyle: {
      type: String,
      default: 'button',
    },
    hasDropdownChevron: {
      type: Boolean,
      default: true,
    },
    triggerColor: {
      type: String,
      default: 'teal',
    },
    isFullscreenOnMobile: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isInsidePortal: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  computed: {
    wrapperClasses() {
      const [vertical, horizontal] = this.position.split(' ')
      let classes = `dd-content-wrapper--${vertical} dd-content-wrapper--${horizontal}`
      if (this.isFullscreenOnMobile) classes += ' fullscreen-mobile'
      return classes
    },
    triggerClasses() {
      const [vertical, horizontal] = this.position.split(' ')
      return `hg-dropdown-trigger hg-dropdown-trigger--${vertical} hg-dropdown-trigger--${horizontal} hg-dropdown-trigger--${this.size}`
    },
  },
  data: () => ({
    isActive: false,
  }),
  methods: {
    clickTrigger() {
      this.isActive = !this.isActive
    },
    onClickout(event) {
      if (!event.composedPath().includes(this.$el)) {
        this.close()
      }
    },
    addClickaway() {
      document.addEventListener('click', this.onClickout)
      this.$once('hook:beforeDestroy', () => {
        document.removeEventListener('click', this.onClickout)
      })
    },
    removeClickaway() {
      document.removeEventListener('click', this.onClickout)
    },
    close() {
      this.isActive = false
    },
  },
  watch: {
    isActive: function (newActiveState) {
      this.$emit('dropdownChange', newActiveState)
    },
    // dropdown needs to stay open until closed for mobile
    isInsidePortal(nv) {
      if (nv) {
        this.removeClickaway()
      } else {
        this.addClickaway()
      }
    },
  },
  mounted() {
    if (this.isInsidePortal) return
    this.addClickaway()
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-dropdown.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_dropdownvue_type_script_lang_js = (hg_dropdownvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-dropdown.vue?vue&type=style&index=0&id=9296a406&prod&scoped=true&lang=postcss
var hg_dropdownvue_type_style_index_0_id_9296a406_prod_scoped_true_lang_postcss = __webpack_require__("1cd3");

// CONCATENATED MODULE: ./src/components/inputs/hg-dropdown.vue






/* normalize component */

var hg_dropdown_component = normalizeComponent(
  inputs_hg_dropdownvue_type_script_lang_js,
  hg_dropdownvue_type_template_id_9296a406_scoped_true_render,
  hg_dropdownvue_type_template_id_9296a406_scoped_true_staticRenderFns,
  false,
  null,
  "9296a406",
  null
  
)

/* harmony default export */ var hg_dropdown = (hg_dropdown_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-select.vue?vue&type=template&id=0de119f6&scoped=true
var hg_selectvue_type_template_id_0de119f6_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab"))return null;_vm.tabKeyPressed = true},"!blur":function($event){return _vm.handleBlur.apply(null, arguments)}}},[_c('div',{staticClass:"hg-select__control hg-control label-position--inside",class:_vm.disabled && 'hg-control--disabled'},[_c('label',{attrs:{"for":_vm.name,"id":`${_vm._uid}-label`}},[_vm._v(_vm._s(_vm.label))]),_c('button',{ref:"button",staticClass:"hg-select__button hg-button--regular",class:[
        _vm.optionsVisible && 'optionsVisible',
        _vm.disabled && 'hg-select--disabled',
      ],attrs:{"disabled":_vm.disabled,"role":"button","type":"button","name":_vm.name,"id":`${_vm._uid}-button`,"aria-haspopup":"listbox","aria-labelledby":`${_vm._uid}-label ${_vm._uid}-button`,"aria-expanded":_vm.optionsVisible},on:{"click":_vm.toggleOptions,"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"]))return null;$event.preventDefault();return _vm.showOptions.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"]))return null;$event.preventDefault();return _vm.selectPrevOption.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"]))return null;$event.preventDefault();return _vm.selectNextOption.apply(null, arguments)}]}},[_c('span',{staticClass:"hg-select__value"},[_vm._v(_vm._s(_vm.getDisplayValue(_vm.value)))]),(!_vm.value)?_c('span',{staticClass:"hg-select__placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_c('span',{staticClass:"hg-select__icon",class:{ 'hg-select__icon--rotate-180': _vm.optionsVisible }},[_c('span',{staticClass:"SvgAngle"},[_c('hg-icon',{attrs:{"name":"chevron-down","size":"small"}})],1)])]),(!_vm.tabKeyPressed)?_c('input',{staticClass:"u-visually-hidden",attrs:{"aria-hidden":"true"},on:{"focus":_vm.handleFocusTrap}}):_vm._e(),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.optionsVisible),expression:"optionsVisible"}],ref:"options",staticClass:"hg-select__options",attrs:{"tabindex":"-1","role":"listbox","aria-labelledby":`${_vm._uid}-label`,"aria-activedescendant":_vm.activeDescendant},on:{"focus":_vm.setupFocus,"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"]))return null;$event.preventDefault();return _vm.selectPrevOption.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"]))return null;$event.preventDefault();return _vm.selectNextOption.apply(null, arguments)}],"keydown":[_vm.search,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"]))return null;$event.preventDefault();},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"]))return null;$event.preventDefault();return _vm.reset.apply(null, arguments)}]}},_vm._l((_vm.options),function(option,index){return _c('li',{key:option.id,staticClass:"hg-select__option",class:`${_vm.activeOptionIndex === index && 'has-focus'} ${
          index + 1 < _vm.options.length ? 'not-last' : ''
        }`,attrs:{"id":`${_vm._uid}-option-${index}`,"aria-selected":_vm.activeOptionIndex === index,"role":"option"},on:{"click":function($event){return _vm.handleOptionClick(option)}}},[_vm._v(" "+_vm._s(_vm.getDisplayValue(option))+" "),(_vm.activeOptionIndex === index)?_c('span',{staticClass:"hg-select__selected"},[_c('hg-icon',{attrs:{"name":"check"}})],1):_vm._e(),(_vm.activeOptionIndex !== index)?_c('span',{staticClass:"hg-select__notselected"}):_vm._e()])}),0)])])
}
var hg_selectvue_type_template_id_0de119f6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-select.vue?vue&type=template&id=0de119f6&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-select.vue?vue&type=script&lang=js

let resetKeysSoFarTimer

/**
 * HG Select Dropdown Component
 * @displayName HG Select
 * @param {string|number|object} value - initial value to display. should be same type and part of `options`. If {type: Object} please provide `displayProperty`
 * @param {string[]|number[]|object[]} options - initial value to display. If {type: Object} please provide `displayProperty`
 * @param {string} displayProperty - Name of the Property to use as Displaystring, if value: {type: Object} and options: {type: Object[]}, nested Properties can be passed as . delimited string `propLevel1.propLevel2.propLevel3`
 */

/* harmony default export */ var hg_selectvue_type_script_lang_js = ({
  name: 'hg-select',
  model: {
    event: 'change',
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Select',
    },
    name: {
      type: String,
      deafult: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number, Object],
      default: '',
    },
    displayProperty: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keysSoFar: '',
      tabKeyPressed: false,
      optionsVisible: false,
    }
  },
  computed: {
    activeOptionIndex() {
      return this.options.findIndex(
        (x) => x.value === this.value || x === this.value
      )
    },
    valueIsObject() {
      return (
        typeof this.value === 'object' &&
        this.value !== null &&
        this.value !== undefined
      )
    },
    prevOptionIndex() {
      const next = this.activeOptionIndex - 1
      return next >= 0 ? next : this.options.length - 1
    },
    nextOptionIndex() {
      const next = this.activeOptionIndex + 1
      return next <= this.options.length - 1 ? next : 0
    },
    activeDescendant() {
      return `${this._uid}-option-${this.activeOptionIndex}`
    },
  },
  methods: {
    handleFocusTrap(e) {
      this.optionsVisible = true
      this.$refs.button.focus()
    },
    handleOptionClick(option) {
      this.$emit('change', option)
      this.reset()
    },
    handleBlur(e) {
      if (this.$el.contains(e.relatedTarget)) return
      this.hideOptions()
    },
    toggleOptions() {
      this.optionsVisible ? this.hideOptions() : this.showOptions()
    },
    async showOptions() {
      this.optionsVisible = true
      await this.$nextTick()
      this.$refs.options.focus()
    },
    hideOptions() {
      this.optionsVisible = false
    },
    async reset() {
      this.hideOptions()
      await this.$nextTick()
      this.$refs.button.focus()
    },
    setupFocus() {
      if (this.value) return
      this.$emit('change', this.options[0])
    },
    selectPrevOption() {
      this.$emit('change', this.options[this.prevOptionIndex])
    },
    selectNextOption() {
      this.$emit('change', this.options[this.nextOptionIndex])
    },
    search(e) {
      clearTimeout(resetKeysSoFarTimer)
      // No alphanumeric key was pressed.
      if (e.key.length > 1) return

      resetKeysSoFarTimer = setTimeout(() => {
        this.keysSoFar = ''
      }, 500)

      this.keysSoFar += e.key
      const matchingOption = this.options.find((x) =>
        (x.value || x).toLowerCase().startsWith(this.keysSoFar)
      )

      if (!matchingOption) return

      this.$emit('change', matchingOption)
    },
    getDisplayValue(containingObject) {
      if (!this.valueIsObject || !this.displayProperty) return containingObject
      let displayValue = this.displayProperty
        .split('.')
        .reduce((p, c) => (p && p[c]) || null, containingObject)
      return displayValue
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-select.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_selectvue_type_script_lang_js = (hg_selectvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-select.vue?vue&type=style&index=0&id=0de119f6&prod&lang=postcss&scoped=true
var hg_selectvue_type_style_index_0_id_0de119f6_prod_lang_postcss_scoped_true = __webpack_require__("b4aa");

// CONCATENATED MODULE: ./src/components/inputs/hg-select.vue






/* normalize component */

var hg_select_component = normalizeComponent(
  inputs_hg_selectvue_type_script_lang_js,
  hg_selectvue_type_template_id_0de119f6_scoped_true_render,
  hg_selectvue_type_template_id_0de119f6_scoped_true_staticRenderFns,
  false,
  null,
  "0de119f6",
  null
  
)

/* harmony default export */ var hg_select = (hg_select_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-checkbox.vue?vue&type=template&id=1992bf91&scoped=true
var hg_checkboxvue_type_template_id_1992bf91_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{class:[
    'hg-control',
    _vm.expanded && 'expanded',
    _vm.disabled && 'hg-control--disabled',
  ],attrs:{"vid":_vm.name,"name":_vm.name,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function({ errors, valid }){return [_c('label',{ref:"label",staticClass:"hg-checkbox",on:{"click":_vm.focus,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();return _vm.$refs.label.click()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedValue),expression:"computedValue"}],ref:"input",staticClass:"checkbox",class:[
        valid === true ? 'hg-input--valid' : '',
        _vm.disabled === true ? 'hg-input--disabled' : '',
      ],attrs:{"true-value":_vm.trueValue,"false-value":_vm.falseValue,"type":"checkbox","name":_vm.name,"id":_vm.name},domProps:{"indeterminate":_vm.indeterminate,"value":_vm.nativeValue,"checked":Array.isArray(_vm.computedValue)?_vm._i(_vm.computedValue,_vm.nativeValue)>-1:_vm._q(_vm.computedValue,_vm.trueValue)},on:{"change":[function($event){var $$a=_vm.computedValue,$$el=$event.target,$$c=$$el.checked?(_vm.trueValue):(_vm.falseValue);if(Array.isArray($$a)){var $$v=_vm.nativeValue,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.computedValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.computedValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.computedValue=$$c}},_vm.change],"click":function($event){$event.stopPropagation();}}}),_c('span',{class:[
        'checkmark',
        _vm.teal ? 'checkmark--teal-border' : '',
        { 'checkmark--transparent': _vm.transparent },
      ]}),_vm._t("default")],2),(errors && errors.length)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(errors[0]))]):_vm._e()]}}],null,true)})
}
var hg_checkboxvue_type_template_id_1992bf91_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-checkbox.vue?vue&type=template&id=1992bf91&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-checkbox.vue?vue&type=script&lang=js

/**
 * Heavily inspired by:
 * https://github.com/buefy/buefy/blob/dev/src/utils/CheckRadioMixin.js
 */
/* harmony default export */ var hg_checkboxvue_type_script_lang_js = ({
  props: {
    indeterminate: Boolean,
    nativeValue: [String, Number, Boolean, Function, Object, Array],
    value: {
      type: Boolean,
      default: false,
    },
    teal: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    trueValue: {
      type: [String, Number, Boolean, Function, Object, Array],
      default: true,
    },
    falseValue: {
      type: [String, Number, Boolean, Function, Object, Array],
      default: false,
    },
  },
  data() {
    return {
      newValue: this.value,
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.newValue
      },
      set(value) {
        this.newValue = value
        this.$emit('input', value)
      },
    },
  },
  watch: {
    /**
     * When v-model change, set internal value.
     */
    value(value) {
      this.newValue = value
    },
  },
  methods: {
    change(e) {
      this.$emit('onChange', !this.checked, e)
    },
    focus() {
      // MacOS FireFox and Safari do not focus when clicked
      this.$refs.input.focus()
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-checkbox.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_checkboxvue_type_script_lang_js = (hg_checkboxvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-checkbox.vue?vue&type=style&index=0&id=1992bf91&prod&lang=postcss&scoped=true
var hg_checkboxvue_type_style_index_0_id_1992bf91_prod_lang_postcss_scoped_true = __webpack_require__("9a81");

// CONCATENATED MODULE: ./src/components/inputs/hg-checkbox.vue






/* normalize component */

var hg_checkbox_component = normalizeComponent(
  inputs_hg_checkboxvue_type_script_lang_js,
  hg_checkboxvue_type_template_id_1992bf91_scoped_true_render,
  hg_checkboxvue_type_template_id_1992bf91_scoped_true_staticRenderFns,
  false,
  null,
  "1992bf91",
  null
  
)

/* harmony default export */ var hg_checkbox = (hg_checkbox_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-datepicker.vue?vue&type=template&id=49882b7d&scoped=true
var hg_datepickervue_type_template_id_49882b7d_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"datepicker",staticClass:"input-wrapper input-wrapper--date-picker date-picker",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"]))return null;return _vm.close.apply(null, arguments)}}},[_c('div',{staticClass:"input-wrapper-inner"},[_c('HgDropdown',{ref:"dropdownRef",attrs:{"dropdownStyle":"input","position":_vm.position,"isInsidePortal":_vm.isMobile && _vm.dropDownActive,"hasDropdownChevron":false,"theme":_vm.theme},on:{"dropdownChange":function($event){_vm.dropDownActive = $event}},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{staticClass:"hg-control label-position--inside"},[(_vm.label !== '')?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.inputRangeString)?[_c('span',{class:[
                'content hg-datepicker-content',
                _vm.placeholderColor && 'hg-text--color',
              ]},[_vm._v(" "+_vm._s(_vm.inputRangeString)+" ")])]:[_c('span',{staticClass:"hg-datepicker__placeholder content"},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")])]],2)]},proxy:true}])},[_c(_vm.isMobile && _vm.dropDownActive
            ? 'HgPortalDropdownMobile'
            : 'HgPortalDropdownDesktop',{tag:"component",attrs:{"theme":_vm.theme},on:{"close":_vm.close,"reset":_vm.reset},scopedSlots:_vm._u([{key:"message",fn:function(){return undefined},proxy:true},{key:_vm.dynamicSlotName,fn:function(){return [_c('div',{staticClass:"dates-wrapper"},[_c('div',{staticClass:"dates-from-to-container",class:{ 'full-width': _vm.isMobile }},[_c('div',{staticClass:"dates-from-to"},[_c('label',[_vm._v(_vm._s(_vm.$t('datepicker.rangeStartLabel')))]),_c('span',{staticClass:"tw-whitespace-no-wrap"},[_vm._v(" "+_vm._s(_vm.rangeStart !== null ? _vm.getFormat(_vm.rangeStart, _vm.dateFormatString) : _vm.$t('datepicker.rangeStartPlaceholder'))+" ")])]),_c('div',{staticClass:"dates-arrow"},[_c('hg-icon',{attrs:{"name":"long-arrow-right"}})],1),_c('div',{staticClass:"dates-from-to"},[_c('label',[_vm._v(_vm._s(_vm.$t('datepicker.rangeEndLabel')))]),_c('span',{staticClass:"tw-whitespace-no-wrap"},[_vm._v(" "+_vm._s(_vm.rangeEnd !== null ? _vm.getFormat(_vm.rangeEnd, _vm.dateFormatString) : _vm.$t('datepicker.rangeEndPlaceholder'))+" ")])])]),(_vm.showError)?_c('hg-form-errors',{attrs:{"size":"small"}},[_c('div',[_vm._v(_vm._s(_vm.$t('datepicker.durationRangeErrorText')))])]):_vm._e()],1)]},proxy:true},{key:"content-2",fn:function(){return [_c('div',{staticClass:"datepicker"},[_c('div',{ref:"calendar",staticClass:"twin-calendar",class:{ 'is-mobile': _vm.isMobile }},_vm._l((_vm.scrl),function(scrollMonth,index){return _c('div',{key:index},[_c('div',{staticClass:"datepicker-container datepicker-container-currentmonth",attrs:{"data-month":_vm.getMonth(scrollMonth[15].date)}},[_c('header',{staticClass:"header"},[(index % 2 === 0 && !_vm.isMobile)?_c('button',{staticClass:"hg-button hg-button--rounded hg-button--small hg-button--nopad hg-button--transparent prev-month-button",attrs:{"type":"button","disabled":_vm.format(_vm.today, 'MM.yyyy') ===
                        _vm.format(scrollMonth[15].date, 'MM.yyyy')},on:{"click":_vm.prevMonth}},[_c('hg-icon',{attrs:{"name":"chevron-left"}})],1):_vm._e(),_c('span',{staticClass:"current-month"},[_vm._v(" "+_vm._s(_vm.getFormat(_vm.monthStarts[index], 'MMMM \ yyyy'))+" ")]),(index % 2 !== 0 && !_vm.isMobile)?_c('button',{staticClass:"hg-button hg-button--rounded hg-button--small hg-button--nopad hg-button--transparent next-month-button",attrs:{"type":"button"},on:{"click":_vm.nextMonth}},[_c('hg-icon',{attrs:{"name":"chevron-right"}})],1):_vm._e()]),_c('div',{staticClass:"calendar-container"},[_vm._l((_vm.getWeekdays(index)),function(weekdayName){return _c('span',{key:weekdayName,staticClass:"weekday-name"},[_vm._v(_vm._s(weekdayName)+" ")])}),_vm._l((scrollMonth),function(monthDay){return _c('div',{key:_vm.getFormat(monthDay.date, 'dd-MMMM-yyyy'),staticClass:"calendar__day",class:_vm.containerRangeClass(monthDay.date)},[_c('span',{class:`range-indicator range-indicator--before ${
                          _vm.theme ? _vm.theme : ''
                        }`}),_c('button',{class:[
                          [6, 0].indexOf(new Date(monthDay.date).getDay()) !=
                          -1
                            ? 'date--weekend'
                            : '',
                          _vm.dateMonthClass(monthDay.date, _vm.monthStarts[index]),
                          _vm.dateActiveClass(monthDay.date),
                          _vm.dateRangeClass(monthDay.date),
                          _vm.dateHoverClass(monthDay.date),
                          'date',
                          _vm.dateClass(monthDay.date),
                          _vm.theme ? _vm.theme : '',
                        ],attrs:{"type":"button"},on:{"click":function($event){return _vm.selectDate(monthDay.date)},"mouseenter":function($event){return _vm.hoverDate(monthDay.date)}}},[_vm._v(" "+_vm._s(monthDay.day)+" ")]),_c('span',{class:`range-indicator range-indicator--after ${
                          _vm.theme ? _vm.theme : ''
                        }`})])})],2)])])}),0)])]},proxy:true}],null,true)},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)],1)])
}
var hg_datepickervue_type_template_id_49882b7d_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-datepicker.vue?vue&type=template&id=49882b7d&scoped=true

// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("53ca");

// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/toDate/index.js


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || Object(esm_typeof["a" /* default */])(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDay/index.js


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/isDate/index.js


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || Object(esm_typeof["a" /* default */])(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js


function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js



function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions_defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions_defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions_defaultOptions = newOptions;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize_localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize_localize);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var en_US_locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (en_US_locale);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarDays/index.js



var differenceInCalendarDays_MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / differenceInCalendarDays_MILLISECONDS_IN_DAY);
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js


 // Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/subMonths/index.js



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/isBefore/index.js


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/isAfter/index.js


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/getMonth/index.js


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  return month;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameDay/index.js


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/addDays/index.js



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/subDays/index.js



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfMonth/index.js


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfMonth/index.js


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatDistance/index.js
var formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    standalone: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    },
    withPreposition: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    }
  },
  xSeconds: {
    standalone: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    },
    withPreposition: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    }
  },
  halfAMinute: {
    standalone: 'halbe Minute',
    withPreposition: 'halben Minute'
  },
  lessThanXMinutes: {
    standalone: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    },
    withPreposition: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    }
  },
  xMinutes: {
    standalone: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    },
    withPreposition: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    }
  },
  aboutXHours: {
    standalone: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    },
    withPreposition: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    }
  },
  xHours: {
    standalone: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    },
    withPreposition: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    }
  },
  xDays: {
    standalone: {
      one: '1 Tag',
      other: '{{count}} Tage'
    },
    withPreposition: {
      one: '1 Tag',
      other: '{{count}} Tagen'
    }
  },
  aboutXWeeks: {
    standalone: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    },
    withPreposition: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    }
  },
  xWeeks: {
    standalone: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    },
    withPreposition: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    }
  },
  aboutXMonths: {
    standalone: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monate'
    },
    withPreposition: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monaten'
    }
  },
  xMonths: {
    standalone: {
      one: '1 Monat',
      other: '{{count}} Monate'
    },
    withPreposition: {
      one: '1 Monat',
      other: '{{count}} Monaten'
    }
  },
  aboutXYears: {
    standalone: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahre'
    },
    withPreposition: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahren'
    }
  },
  xYears: {
    standalone: {
      one: '1 Jahr',
      other: '{{count}} Jahre'
    },
    withPreposition: {
      one: '1 Jahr',
      other: '{{count}} Jahren'
    }
  },
  overXYears: {
    standalone: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahre'
    },
    withPreposition: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahren'
    }
  },
  almostXYears: {
    standalone: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahre'
    },
    withPreposition: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahren'
    }
  }
};
var formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistance_formatDistanceLocale[token].withPreposition : formatDistance_formatDistanceLocale[token].standalone;
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return 'vor ' + result;
    }
  }
  return result;
};
/* harmony default export */ var de_lib_formatDistance = (formatDistance_formatDistance);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatLong/index.js

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var formatLong_dateFormats = {
  full: 'EEEE, do MMMM y',
  // Montag, 7. Januar 2018
  long: 'do MMMM y',
  // 7. Januar 2018
  medium: 'do MMM y',
  // 7. Jan. 2018
  short: 'dd.MM.y' // 07.01.2018
};

var formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var formatLong_dateTimeFormats = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong_formatLong = {
  date: buildFormatLongFn({
    formats: formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var de_lib_formatLong = (formatLong_formatLong);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatRelative/index.js
var formatRelative_formatRelativeLocale = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: 'P'
};
var formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelative_formatRelativeLocale[token];
};
/* harmony default export */ var de_lib_formatRelative = (formatRelative_formatRelative);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/localize/index.js

var localize_eraValues = {
  narrow: ['v.Chr.', 'n.Chr.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['vor Christus', 'nach Christus']
};
var localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
};

// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var localize_monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  wide: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
};

// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var formattingMonthValues = {
  narrow: localize_monthValues.narrow,
  abbreviated: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
  wide: localize_monthValues.wide
};
var localize_dayValues = {
  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
};

// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var localize_dayPeriodValues = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachm.',
    evening: 'Abend',
    night: 'Nacht'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  }
};
var localize_formattingDayPeriodValues = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachm.',
    evening: 'abends',
    night: 'nachts'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  }
};
var localize_ordinalNumber = function ordinalNumber(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
};
var _lib_localize_localize = {
  ordinalNumber: localize_ordinalNumber,
  era: buildLocalizeFn({
    values: localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: localize_monthValues,
    formattingValues: formattingMonthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var de_lib_localize = (_lib_localize_localize);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/match/index.js


var match_matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var match_parseOrdinalNumberPattern = /\d+/i;
var match_matchEraPatterns = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var match_parseEraPatterns = {
  any: [/^v/i, /^n/i]
};
var match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var match_matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var match_parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var match_matchDayPatterns = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var match_parseDayPatterns = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
var match_matchDayPeriodPatterns = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var match_parseDayPeriodPatterns = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i // will never be matched. Night is matched by `pm`
  }
};

var match_match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: match_matchOrdinalNumberPattern,
    parsePattern: match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value);
    }
  }),
  era: buildMatchFn({
    matchPatterns: match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: match_matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var de_lib_match = (match_match);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */
var de_locale = {
  code: 'de',
  formatDistance: de_lib_formatDistance,
  formatLong: de_lib_formatLong,
  formatRelative: de_lib_formatRelative,
  localize: de_lib_localize,
  match: de_lib_match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var de = (de_locale);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/_lib/formatDistance/index.js
var _lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'minder dan een seconde',
    other: 'minder dan {{count}} seconden'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} seconden'
  },
  halfAMinute: 'een halve minuut',
  lessThanXMinutes: {
    one: 'minder dan een minuut',
    other: 'minder dan {{count}} minuten'
  },
  xMinutes: {
    one: 'een minuut',
    other: '{{count}} minuten'
  },
  aboutXHours: {
    one: 'ongeveer 1 uur',
    other: 'ongeveer {{count}} uur'
  },
  xHours: {
    one: '1 uur',
    other: '{{count}} uur'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dagen'
  },
  aboutXWeeks: {
    one: 'ongeveer 1 week',
    other: 'ongeveer {{count}} weken'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weken'
  },
  aboutXMonths: {
    one: 'ongeveer 1 maand',
    other: 'ongeveer {{count}} maanden'
  },
  xMonths: {
    one: '1 maand',
    other: '{{count}} maanden'
  },
  aboutXYears: {
    one: 'ongeveer 1 jaar',
    other: 'ongeveer {{count}} jaar'
  },
  xYears: {
    one: '1 jaar',
    other: '{{count}} jaar'
  },
  overXYears: {
    one: 'meer dan 1 jaar',
    other: 'meer dan {{count}} jaar'
  },
  almostXYears: {
    one: 'bijna 1 jaar',
    other: 'bijna {{count}} jaar'
  }
};
var _lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = _lib_formatDistance_formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'over ' + result;
    } else {
      return result + ' geleden';
    }
  }
  return result;
};
/* harmony default export */ var nl_lib_formatDistance = (_lib_formatDistance_formatDistance);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/_lib/formatLong/index.js

var _lib_formatLong_dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd-MM-y'
};
var _lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var _lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var _lib_formatLong_formatLong = {
  date: buildFormatLongFn({
    formats: _lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: _lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: _lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var nl_lib_formatLong = (_lib_formatLong_formatLong);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/_lib/formatRelative/index.js
var _lib_formatRelative_formatRelativeLocale = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: 'P'
};
var _lib_formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return _lib_formatRelative_formatRelativeLocale[token];
};
/* harmony default export */ var nl_lib_formatRelative = (_lib_formatRelative_formatRelative);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/_lib/localize/index.js

var _lib_localize_eraValues = {
  narrow: ['v.C.', 'n.C.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['voor Christus', 'na Christus']
};
var _lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
};
var _lib_localize_monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
};
var _lib_localize_dayValues = {
  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
};
var _lib_localize_dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
};
var _lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + 'e';
};
var nl_lib_localize_localize = {
  ordinalNumber: _lib_localize_ordinalNumber,
  era: buildLocalizeFn({
    values: _lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: _lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: _lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: _lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: _lib_localize_dayPeriodValues,
    defaultWidth: 'wide'
  })
};
/* harmony default export */ var nl_lib_localize = (nl_lib_localize_localize);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/_lib/match/index.js


var _lib_match_matchOrdinalNumberPattern = /^(\d+)e?/i;
var _lib_match_parseOrdinalNumberPattern = /\d+/i;
var _lib_match_matchEraPatterns = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
};
var _lib_match_parseEraPatterns = {
  any: [/^v/, /^n/]
};
var _lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
};
var _lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var _lib_match_matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var _lib_match_parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
};
var _lib_match_matchDayPatterns = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var _lib_match_parseDayPatterns = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
};
var _lib_match_matchDayPeriodPatterns = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var _lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
};
var _lib_match_match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: _lib_match_matchOrdinalNumberPattern,
    parsePattern: _lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: _lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: _lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: _lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: _lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: _lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: _lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: _lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: _lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: _lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: _lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var nl_lib_match = (_lib_match_match);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */
var nl_locale = {
  code: 'nl',
  formatDistance: nl_lib_formatDistance,
  formatLong: nl_lib_formatLong,
  formatRelative: nl_lib_formatRelative,
  localize: nl_lib_localize,
  match: nl_lib_match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var nl = (nl_locale);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/_lib/formatDistance/index.js
var es_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'menos de un segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'medio minuto',
  lessThanXMinutes: {
    one: 'menos de un minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'alrededor de 1 hora',
    other: 'alrededor de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 día',
    other: '{{count}} días'
  },
  aboutXWeeks: {
    one: 'alrededor de 1 semana',
    other: 'alrededor de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'alrededor de 1 mes',
    other: 'alrededor de {{count}} meses'
  },
  xMonths: {
    one: '1 mes',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'alrededor de 1 año',
    other: 'alrededor de {{count}} años'
  },
  xYears: {
    one: '1 año',
    other: '{{count}} años'
  },
  overXYears: {
    one: 'más de 1 año',
    other: 'más de {{count}} años'
  },
  almostXYears: {
    one: 'casi 1 año',
    other: 'casi {{count}} años'
  }
};
var es_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = es_lib_formatDistance_formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'en ' + result;
    } else {
      return 'hace ' + result;
    }
  }
  return result;
};
/* harmony default export */ var es_lib_formatDistance = (es_lib_formatDistance_formatDistance);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/_lib/formatLong/index.js

var es_lib_formatLong_dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var es_lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var es_lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var es_lib_formatLong_formatLong = {
  date: buildFormatLongFn({
    formats: es_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: es_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: es_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var es_lib_formatLong = (es_lib_formatLong_formatLong);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/_lib/formatRelative/index.js
var es_lib_formatRelative_formatRelativeLocale = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: 'P'
};
var formatRelativeLocalePlural = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: 'P'
};
var es_lib_formatRelative_formatRelative = function formatRelative(token, date, _baseDate, _options) {
  if (date.getUTCHours() !== 1) {
    return formatRelativeLocalePlural[token];
  } else {
    return es_lib_formatRelative_formatRelativeLocale[token];
  }
};
/* harmony default export */ var es_lib_formatRelative = (es_lib_formatRelative_formatRelative);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/_lib/localize/index.js

var es_lib_localize_eraValues = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'después de cristo']
};
var es_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var es_lib_localize_monthValues = {
  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  wide: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
};
var es_lib_localize_dayValues = {
  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
  short: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
  abbreviated: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  wide: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
};
var es_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  }
};
var _lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  }
};
var es_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + 'º';
};
var es_lib_localize_localize = {
  ordinalNumber: es_lib_localize_ordinalNumber,
  era: buildLocalizeFn({
    values: es_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: es_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: es_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: es_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: es_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: _lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var es_lib_localize = (es_lib_localize_localize);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/_lib/match/index.js


var es_lib_match_matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var es_lib_match_parseOrdinalNumberPattern = /\d+/i;
var es_lib_match_matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var es_lib_match_parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
};
var es_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var es_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var es_lib_match_matchMonthPatterns = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var es_lib_match_parseMonthPatterns = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
};
var es_lib_match_matchDayPatterns = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var es_lib_match_parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
};
var es_lib_match_matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var es_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
};
var es_lib_match_match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: es_lib_match_matchOrdinalNumberPattern,
    parsePattern: es_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: es_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: es_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: es_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: es_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: es_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: es_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: es_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: es_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: es_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: es_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var es_lib_match = (es_lib_match_match);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */
var es_locale = {
  code: 'es',
  formatDistance: es_lib_formatDistance,
  formatLong: es_lib_formatLong,
  formatRelative: es_lib_formatRelative,
  localize: es_lib_localize,
  match: es_lib_match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var es = (es_locale);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-datepicker.vue?vue&type=script&lang=js






let hg_datepickervue_type_script_lang_js_locale = de

/* harmony default export */ var hg_datepickervue_type_script_lang_js = ({
  components: { hgDropdown: hg_dropdown },
  props: {
    initialStartDate: {
      type: Object | Date,
      default: () => {},
    },
    initialEndDate: {
      type: Object | Date,
      default: () => {},
    },
    label: {
      type: String,
      default: '',
    },
    disabledPortal: {
      type: Boolean,
      default: true,
    },
    dateFormatString: {
      type: String,
      default: 'eeeeee, dd.MM.yyyy',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    scrollableMonths: {
      type: Number,
      default: 2,
    },
    placeholder: {
      default: 'TT.MM.JJJJ - TT.MM.JJJJ',
      type: String,
    },
    paddedDays: {
      default: true,
      type: Boolean,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    position: {
      type: String,
      default: 'bottom center',
    },
    placeholderColor: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    today: null,
    currentMonth: null,
    rangeStart: null,
    rangeEnd: null,
    hoveredRangeEnd: null,
    weekdayNames: null,
    numSelectedDays: null,
    closeRef: null,
    portalDisabled: true,
    dropDownActive: false,
    createdPortal: false,
    monthStarts: [],
    scrl: [],
  }),

  mounted() {
    if (this.initialStartDate && this.initialEndDate) {
      this.setInitialRange()
    }
    this.closeRef = this.$refs.dropdownRef
    this.generateScrollMonths(this.currentMonth, this.numberOfMonths)
  },

  computed: {
    dynamicSlotName() {
      return this.isMobile && this.dropDownActive ? 'header-field' : 'content-1'
    },

    numberOfMonths() {
      return this.isMobile ? 17 : this.scrollableMonths
    },

    inputRangeString() {
      if (!this.rangeStart || !this.rangeEnd) return ''

      return (
        this.getFormat(this.rangeStart, this.dateFormatString) +
        ' - ' +
        this.getFormat(this.rangeEnd, this.dateFormatString)
      )
    },
    selectedRangeString() {
      if (!this.numSelectedDays) return

      if (this.numSelectedDays === 1) {
        return `${this.numSelectedDays} day`
      } else if (this.numSelectedDays > 1) {
        return `${this.numSelectedDays} days`
      }

      return ''
    },
  },

  methods: {
    generateScrollMonths(currentMonth, numberMonths) {
      let startTM = this.isMobile
        ? this.startOfMonth(new Date())
        : this.startOfMonth(currentMonth) // Scrollable months always start in today's month!

      let scrl = []
      let monthStarts = []

      for (let i = 0; i < numberMonths; i++) {
        let start = this.startOfMonth(addMonths(startTM, i))
        const end = this.subDays(this.endOfMonth(start), 1)
        monthStarts.push(start)

        scrl.push({ start: start, end: end })
      }
      scrl = scrl.map((item) => this.generateDays(item.start, item.end))
      this.scrl = scrl
      this.monthStarts = monthStarts
    },
    generateDays(start, end) {
      const days = []

      while (this.differenceInDays(end, start) >= 0) {
        days.push({
          day: this.getFormat(start, 'd'),
          dayIndex: this.getDay(start),
          date: new Date(start),
        })
        start = this.addDays(start, 1)
      }

      if (!this.paddedDays) return days

      const firstDay = days[0]
      const lastDay = days[days.length - 1]
      const startPad = this.padMonthStart(firstDay)
      const endPad = this.padMonthEnd(lastDay)

      return [...startPad, ...days, ...endPad]
    },
    setInitialRange() {
      this.rangeStart = new Date(this.initialStartDate)
      this.rangeEnd = new Date(this.initialEndDate)
      this.numSelectedDays =
        Math.abs(this.differenceInDays(this.rangeEnd, this.rangeStart)) + 1

      this.$emit('onDateRangeSelect', {
        start: this.rangeStart,
        end: this.rangeEnd,
      })
    },
    prevMonth() {
      this.currentMonth = this.subMonths(this.currentMonth, 1)
      this.generateScrollMonths(this.currentMonth, this.numberOfMonths)
    },
    nextMonth() {
      this.currentMonth = this.addMonths(this.currentMonth, 1)
      this.generateScrollMonths(this.currentMonth, this.numberOfMonths)
    },
    getWeekdays(i) {
      let firstWeekdayinMonth = this.paddedDays
        ? 1
        : new Date(this.monthStarts[i]).getDay()
      return [...Array(7)].map((_item, i) =>
        hg_datepickervue_type_script_lang_js_locale.localize.day((firstWeekdayinMonth + i) % 7, { width: 'short' })
      )
    },
    selectDate(date) {
      if (!this.rangeStart && !this.rangeEnd) {
        // Set range-start
        this.rangeStart = date
      } else if (this.rangeStart && !this.rangeEnd) {
        // Set range-end
        this.rangeEnd = date

        if (this.isBefore(this.rangeEnd, this.rangeStart)) {
          // Switch Dates if end-date is before the initial start-date
          const s = this.rangeEnd
          this.rangeEnd = this.rangeStart
          this.rangeStart = s
          this.hoveredRangeEnd = this.rangeEnd
        }

        this.updateNumSelectedDays()

        // Emit final Date
        if (this.$refs.dropdownRef.close && this.isMobile) {
          this.$refs.dropdownRef.close()
        }

        this.$emit('onDateRangeSelect', {
          start: this.rangeStart,
          end: this.rangeEnd,
        })
      } else if (this.rangeStart && this.rangeEnd) {
        // Begin new Range selection
        this.rangeStart = date
        this.rangeEnd = null
        this.hoveredRangeEnd = null
      }
    },
    hoverDate(date) {
      if (!this.rangeStart) return
      if (this.rangeStart && this.rangeEnd) return

      this.updateNumSelectedDays()
      this.hoveredRangeEnd = date
    },
    dateMonthClass(date, month) {
      if (this.getMonth(date) === this.getMonth(month)) {
        return 'date--current-month'
      } else {
        return !this.paddedDays
          ? 'date--adjacent-month'
          : 'date--adjacent-month--padded'
      }
    },
    dateRangeClass(date) {
      if (!this.rangeStart && !this.rangeEnd) return

      if (
        (this.isBefore(date, this.hoveredRangeEnd) &&
          this.isAfter(date, this.rangeStart)) ||
        (this.isBefore(date, this.rangeEnd) &&
          this.isAfter(date, this.rangeStart))
      )
        return 'date--is-in-range'
    },
    containerRangeClass(date) {
      if (this.rangeStart && this.rangeEnd) {
        return this.getRangeClass(date, this.rangeStart, this.rangeEnd)
      }

      if (this.rangeStart && this.hoveredRangeEnd) {
        return this.getRangeClass(date, this.rangeStart, this.hoveredRangeEnd)
      }
    },
    updateNumSelectedDays() {
      if (this.rangeEnd) {
        this.numSelectedDays =
          Math.abs(this.differenceInDays(this.rangeEnd, this.rangeStart)) + 1
      } else if (this.hoveredRangeEnd) {
        this.numSelectedDays =
          Math.abs(
            this.differenceInDays(this.hoveredRangeEnd, this.rangeStart)
          ) + 1
      }
    },
    getRangeClass(current, start, end) {
      // Start before End Date
      if (this.isBefore(start, end)) {
        if (this.isSameDay(current, start)) return 'day--is-start-of-range'
        if (this.isSameDay(current, end)) return 'day--is-end-of-range'

        if (this.isBefore(current, end) && this.isAfter(current, start))
          return 'day--is-in-range'
      } else {
        // End Before Start
        if (this.isSameDay(current, start)) return 'day--is-end-of-range'
        if (this.isSameDay(current, end)) return 'day--is-start-of-range'
        if (this.isAfter(current, end) && this.isBefore(current, start))
          return 'day--is-in-range'
      }
    },
    dateHoverClass(date) {
      // Check Hover State of a date
      if (!this.rangeStart || !this.hoveredRangeEnd) return

      if (
        (this.isAfter(date, this.rangeStart) &&
          this.isBefore(date, this.hoveredRangeEnd)) ||
        (this.isBefore(date, this.rangeStart) &&
          this.isAfter(date, this.hoveredRangeEnd))
      ) {
        return 'date--is-in-hovered-range'
      } else if (this.isSameDay(date, this.hoveredRangeEnd)) {
        return 'date--is-hovered-end'
      }
    },
    dateActiveClass(date) {
      if (
        this.rangeStart &&
        this.getFormat(this.rangeStart, 'dd MM yyyy') ===
          this.getFormat(date, 'dd MM yyyy')
      ) {
        return 'date--selected'
      }
      if (
        this.rangeEnd &&
        this.getFormat(this.rangeEnd, 'dd MM yyyy') ===
          this.getFormat(date, 'dd MM yyyy')
      ) {
        return 'date--selected'
      }
    },
    dateClass(date) {
      return `date--${this.getFormat(date, 'dd')}`
    },
    padMonthStart(firstDay) {
      const daysToPad = ((this.getDay(firstDay.date) + 6) % 7) + 1
      const padTarget = new Date(firstDay.date)
      let days = []

      for (let i = 1; i < daysToPad; i++) {
        const newDate = this.subDays(new Date(padTarget), i)
        days.unshift({
          day: this.getFormat(newDate, 'd'),
          dayIndex: getDay(newDate),
          date: newDate,
        })
      }

      return days
    },
    padMonthEnd(lastDay) {
      const daysToPad = 7 - this.getDay(lastDay.date)
      const padTarget = new Date(lastDay.date)
      let days = []

      if (this.getDay(lastDay.date) === 0) return days

      for (let i = 1; i <= daysToPad; i++) {
        const newDate = this.addDays(new Date(padTarget), i)
        days.push({
          day: this.getFormat(newDate, 'd'),
          dayIndex: this.getDay(newDate),
          date: newDate,
        })
      }

      return days
    },
    showOverlay() {
      this.$emit('onPortalContent', this)
    },
    format: format,
    differenceInDays: differenceInDays,
    subMonths: subMonths,
    addMonths: addMonths,
    isBefore: isBefore,
    isAfter: isAfter,
    getMonth: getMonth,
    isSameDay: isSameDay,
    getDay: getDay,
    addDays: addDays,
    subDays: subDays,
    startOfMonth: startOfMonth,
    endOfMonth: endOfMonth,
    getFormat(date, formatString) {
      return this.format(date, formatString, { locale: hg_datepickervue_type_script_lang_js_locale })
    },

    close() {
      this.dropDownActive = false
      this.$refs.dropdownRef.isActive = false
    },
    reset() {
      this.dropDownActive = false
      this.$refs.dropdownRef.isActive = false
    },
  },
  created() {
    let currentLocale = this.$i18n.locale
    switch (currentLocale) {
      case 'nl':
        hg_datepickervue_type_script_lang_js_locale = nl
        break
      case 'es':
        hg_datepickervue_type_script_lang_js_locale = es
        break
      default:
        hg_datepickervue_type_script_lang_js_locale = de
        break
    }
    this.today = new Date()
    this.currentMonth = this.initialStartDate || new Date()
    this.weekdayNames = [...Array(7).keys()].map((i) =>
      hg_datepickervue_type_script_lang_js_locale.localize.day(i + 1 < 7 ? i + 1 : 0, { width: 'short' })
    )
  },
  watch: {
    isMobile() {
      this.generateScrollMonths(this.currentMonth, this.numberOfMonths)
    },
    dropDownActive() {
      if (!this.isMobile) return

      setTimeout(() => {
        const calendarRef = this.$refs.calendar
        const currentMonthIndex = this.getMonth(this.rangeStart)
        const scrollContainer =
          calendarRef.parentElement.parentElement.parentElement

        const currentScrollMonth = document.querySelector(
          `[data-month="${currentMonthIndex}"`
        )

        currentScrollMonth.scrollIntoView(true)
        scrollContainer.scrollTop -= 140
      }, 50)
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-datepicker.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_datepickervue_type_script_lang_js = (hg_datepickervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-datepicker.vue?vue&type=style&index=0&id=49882b7d&prod&scoped=true&lang=postcss
var hg_datepickervue_type_style_index_0_id_49882b7d_prod_scoped_true_lang_postcss = __webpack_require__("e011");

// CONCATENATED MODULE: ./src/components/inputs/hg-datepicker.vue






/* normalize component */

var hg_datepicker_component = normalizeComponent(
  inputs_hg_datepickervue_type_script_lang_js,
  hg_datepickervue_type_template_id_49882b7d_scoped_true_render,
  hg_datepickervue_type_template_id_49882b7d_scoped_true_staticRenderFns,
  false,
  null,
  "49882b7d",
  null
  
)

/* harmony default export */ var hg_datepicker = (hg_datepicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-single-datepicker.vue?vue&type=template&id=7c8b225d&scoped=true
var hg_single_datepickervue_type_template_id_7c8b225d_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"datepicker",staticClass:"input-wrapper input-wrapper--date-picker date-picker"},[_c('div',{staticClass:"input-wrapper-inner"},[_c('HgDropdown',{ref:"dropdownRef",attrs:{"dropdownStyle":"input","position":_vm.position,"isInsidePortal":_vm.isMobile && _vm.dropDownActive,"hasDropdownChevron":false},on:{"dropdownChange":function($event){_vm.dropDownActive = $event}},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{staticClass:"hg-control label-position--inside"},[(_vm.label !== '')?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.inputDateString)?[_c('span',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.inputDateString)+" ")])]:[_c('span',{staticClass:"hg-datepicker__placeholder content"},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")])]],2)]},proxy:true}])},[_c(_vm.isMobile && _vm.dropDownActive
            ? 'HgPortalDropdownMobile'
            : 'HgPortalDropdownDesktop',{tag:"component",on:{"close":_vm.close,"reset":_vm.reset},scopedSlots:_vm._u([{key:"message",fn:function(){return undefined},proxy:true},{key:"content-2",fn:function(){return [_c('div',{staticClass:"datepicker"},[_c('div',{ref:"calendar",staticClass:"twin-calendar",class:{ 'is-mobile': _vm.isMobile }},_vm._l((_vm.scrl),function(scrollMonth,index){return _c('div',{key:index},[_c('div',{staticClass:"datepicker-container datepicker-container-currentmonth",attrs:{"data-month":_vm.getMonth(scrollMonth[15].date)}},[_c('header',{staticClass:"header"},[(index % 2 === 0 && !_vm.isMobile)?_c('button',{staticClass:"hg-button hg-button--rounded hg-button--small hg-button--nopad hg-button--transparent prev-month-button",attrs:{"type":"button","disabled":_vm.getMonth(_vm.today) === _vm.getMonth(scrollMonth[15].date)},on:{"click":_vm.prevMonth}},[_c('hg-icon',{attrs:{"name":"chevron-left"}})],1):_vm._e(),_c('span',{staticClass:"current-month"},[_vm._v(" "+_vm._s(_vm.getMonthString(_vm.monthStarts[index]))+" ")]),(index % 2 !== 0 && !_vm.isMobile)?_c('button',{staticClass:"hg-button hg-button--rounded hg-button--small hg-button--nopad hg-button--transparent next-month-button",attrs:{"type":"button"},on:{"click":_vm.nextMonth}},[_c('hg-icon',{attrs:{"name":"chevron-right"}})],1):_vm._e()]),_c('div',{staticClass:"calendar-container"},[_vm._l((_vm.getWeekdays(index)),function(weekdayName){return _c('span',{key:weekdayName,staticClass:"weekday-name"},[_vm._v(" "+_vm._s(weekdayName)+" ")])}),_vm._l((scrollMonth),function(monthDay){return _c('div',{key:_vm.getFormat(monthDay.date, 'dd-MMMM-yyyy'),staticClass:"calendar__day"},[_c('span',{staticClass:"range-indicator range-indicator--before"}),_c('button',{class:[
                          [6, 0].indexOf(new Date(monthDay.date).getDay()) !=
                          -1
                            ? 'date--weekend'
                            : '',
                          _vm.dateMonthClass(monthDay.date, _vm.monthStarts[index]),
                          _vm.dateActiveClass(monthDay.date),
                          'date',
                          _vm.dateClass(monthDay.date),
                        ],attrs:{"type":"button"},on:{"click":function($event){return _vm.selectDate(monthDay.date)}}},[_vm._v(" "+_vm._s(monthDay.day)+" ")]),_c('span',{staticClass:"range-indicator range-indicator--after"})])})],2)])])}),0)])]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)],1)])
}
var hg_single_datepickervue_type_template_id_7c8b225d_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-single-datepicker.vue?vue&type=template&id=7c8b225d&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-single-datepicker.vue?vue&type=script&lang=js





/* harmony default export */ var hg_single_datepickervue_type_script_lang_js = ({
  components: { HgDropdown: hg_dropdown },
  props: {
    initialStartDate: {
      type: Object | Date,
      default: () => {},
    },
    minDate: {
      type: Object | Date,
      default: () => {},
    },
    label: {
      type: String,
      default: '',
    },
    disabledPortal: {
      type: Boolean,
      default: true,
    },
    dateFormatString: {
      type: String,
      default: 'eeeeee, dd.MM.yyyy',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    scrollableMonths: {
      type: Number,
      default: 2,
    },
    placeholder: {
      default: 'TT.MM.JJJJ - TT.MM.JJJJ',
      type: String,
    },
    paddedDays: {
      default: true,
      type: Boolean,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    position: {
      type: String,
      default: 'bottom center',
    },
  },
  data: () => ({
    today: null,
    currentMonth: null,
    selectedDate: null,
    weekdayNames: null,
    numSelectedDays: null,
    closeRef: null,
    portalDisabled: true,
    dropDownActive: false,
    createdPortal: false,
    monthStarts: [],
    scrl: [],
    locale: de,
  }),

  mounted() {
    this.setLocale()
    this.closeRef = this.$refs.dropdownRef
    this.generateScrollMonths(this.currentMonth, this.numberOfMonths)

    if (this.initialStartDate != null) {
      this.selectDate(this.initialStartDate)
    }

    if (this.minDate == null) {
      this.minDate = new Date()
    }
  },

  computed: {
    dynamicSlotName() {
      return this.isMobile && this.dropDownActive ? 'header-field' : 'content-1'
    },

    numberOfMonths() {
      return this.isMobile ? 12 : this.scrollableMonths
    },

    inputDateString() {
      if (!this.selectedDate) return ''

      return this.getDayPrefix(this.selectedDate)
    },
    selectedRangeString() {
      if (!this.numSelectedDays) return

      if (this.numSelectedDays === 1) {
        return `${this.numSelectedDays} day`
      } else if (this.numSelectedDays > 1) {
        return `${this.numSelectedDays} days`
      }

      return ''
    },
  },

  methods: {
    setLocale() {
      // Set locale
      switch (this.$i18n.locale) {
        case 'de':
          this.locale = de
          break
        case 'nl':
          this.locale = nl
          break
        case 'at':
          this.locale = de
          break
        case 'ch':
          this.locale = de
          break
        case 'es':
          this.locale = es
          break
        default:
          this.locale = de
          break
      }
    },

    generateScrollMonths(currentMonth, numberMonths) {
      let startTM = this.isMobile
        ? this.startOfMonth(new Date())
        : this.startOfMonth(currentMonth) // Scrollable months always start in today's month!

      let scrl = []
      let monthStarts = []

      for (let i = 0; i < numberMonths; i++) {
        let start = this.startOfMonth(addMonths(startTM, i))
        const end = this.subDays(this.endOfMonth(start), 1)
        monthStarts.push(start)

        scrl.push({ start: start, end: end })
      }
      scrl = scrl.map(item => this.generateDays(item.start, item.end))
      this.scrl = scrl
      this.monthStarts = monthStarts
    },

    generateDays(start, end) {
      const days = []

      while (this.differenceInDays(end, start) >= 0) {
        days.push({
          day: this.getFormat(start, 'd'),
          dayIndex: this.getDay(start),
          date: new Date(start),
        })
        start = this.addDays(start, 1)
      }

      if (!this.paddedDays) return days

      const firstDay = days[0]
      const lastDay = days[days.length - 1]
      const startPad = this.padMonthStart(firstDay)
      const endPad = this.padMonthEnd(lastDay)

      return [...startPad, ...days, ...endPad]
    },

    prevMonth() {
      this.currentMonth = this.subMonths(this.currentMonth, 1)
      this.generateScrollMonths(this.currentMonth, this.numberOfMonths)
    },

    nextMonth() {
      this.currentMonth = this.addMonths(this.currentMonth, 1)
      this.generateScrollMonths(this.currentMonth, this.numberOfMonths)
    },

    getWeekdays(i) {
      let firstWeekdayinMonth = this.paddedDays
        ? 1
        : new Date(this.monthStarts[i]).getDay()
      return [...Array(7)].map((_item, i) =>
        this.locale.localize.day((firstWeekdayinMonth + i) % 7, {
          width: 'short',
        })
      )
    },

    selectDate(date) {
      this.selectedDate = date
      this.$emit('onDateSelect', format(this.selectedDate, 'yyyy-MM-dd'))
      if (!this.isMobile) {
        this.close()
      }
    },

    dateMonthClass(date, month) {
      if (
        this.getMonth(date) === this.getMonth(month) &&
        !this.dayDisabled(date)
      ) {
        return 'date--current-month'
      } else {
        return !this.paddedDays
          ? 'date--adjacent-month'
          : 'date--adjacent-month--padded'
      }
    },

    dateActiveClass(date) {
      if (
        this.selectedDate &&
        this.getFormat(this.selectedDate, 'dd MM') ===
          this.getFormat(date, 'dd MM')
      ) {
        return 'date--selected'
      }
    },

    dateClass(date) {
      return `date--${this.getFormat(date, 'dd')}`
    },

    dayDisabled(date) {
      return this.startOfDay(date) < this.startOfDay(this.minDate)
    },

    padMonthStart(firstDay) {
      const daysToPad = ((this.getDay(firstDay.date) + 6) % 7) + 1
      const padTarget = new Date(firstDay.date)
      let days = []

      for (let i = 1; i < daysToPad; i++) {
        const newDate = this.subDays(new Date(padTarget), i)
        days.unshift({
          day: this.getFormat(newDate, 'd'),
          dayIndex: getDay(newDate),
          date: newDate,
        })
      }

      return days
    },

    padMonthEnd(lastDay) {
      const daysToPad = 7 - this.getDay(lastDay.date)
      const padTarget = new Date(lastDay.date)
      let days = []

      if (this.getDay(lastDay.date) === 0) return days

      for (let i = 1; i <= daysToPad; i++) {
        const newDate = this.addDays(new Date(padTarget), i)
        days.push({
          day: this.getFormat(newDate, 'd'),
          dayIndex: this.getDay(newDate),
          date: newDate,
        })
      }

      return days
    },

    showOverlay() {
      this.$emit('onPortalContent', this)
    },

    format: format,
    differenceInDays: differenceInDays,
    subMonths: subMonths,
    addMonths: addMonths,
    isBefore: isBefore,
    isAfter: isAfter,
    getMonth: getMonth,
    isSameDay: isSameDay,
    getDay: getDay,
    addDays: addDays,
    subDays: subDays,
    startOfMonth: startOfMonth,
    startOfDay: startOfDay,
    endOfMonth: endOfMonth,
    getFormat(date, formatString) {
      const temp = this.locale
      return this.format(date, formatString, { temp })
    },

    getDayPrefix(day) {
      switch (getDay(day)) {
        case 0:
          return (
            this.$i18n.t('ibeSearch.dayNames')[0] +
            this.getFormat(this.selectedDate, ', dd.MM.yyyy')
          )
        case 1:
          return (
            this.$i18n.t('ibeSearch.dayNames')[1] +
            this.getFormat(this.selectedDate, ', dd.MM.yyyy')
          )
        case 2:
          return (
            this.$i18n.t('ibeSearch.dayNames')[2] +
            this.getFormat(this.selectedDate, ', dd.MM.yyyy')
          )
        case 3:
          return (
            this.$i18n.t('ibeSearch.dayNames')[3] +
            this.getFormat(this.selectedDate, ', dd.MM.yyyy')
          )
        case 4:
          return (
            this.$i18n.t('ibeSearch.dayNames')[4] +
            this.getFormat(this.selectedDate, ', dd.MM.yyyy')
          )
        case 5:
          return (
            this.$i18n.t('ibeSearch.dayNames')[5] +
            this.getFormat(this.selectedDate, ', dd.MM.yyyy')
          )
        case 6:
          return (
            this.$i18n.t('ibeSearch.dayNames')[6] +
            this.getFormat(this.selectedDate, ', dd.MM.yyyy')
          )
        default:
          return ''
      }
    },

    getMonthString(date) {
      return `${
        this.$i18n.t('ibeSearch.monthNames')[this.getMonth(date)]
      } ${this.getFormat(date, 'yyyy')}`
    },

    close() {
      this.dropDownActive = false
      this.$refs.dropdownRef.isActive = false
    },
    reset() {
      this.dropDownActive = false
      this.$refs.dropdownRef.isActive = false
    },
  },
  created() {
    this.today = new Date()
    this.currentMonth = this.initialStartDate || new Date()
    this.weekdayNames = [...Array(7).keys()].map(i =>
      this.locale.localize.day(i + 1 < 7 ? i + 1 : 0, { width: 'short' })
    )
  },
  watch: {
    isMobile() {
      this.generateScrollMonths(this.currentMonth, this.numberOfMonths)
    },
    dropDownActive() {
      if (!this.isMobile) return

      setTimeout(() => {
        const calendarRef = this.$refs.calendar
        const currentMonthIndex = this.getMonth(this.rangeStart)
        const scrollContainer =
          calendarRef.parentElement.parentElement.parentElement

        const currentScrollMonth = document.querySelector(
          `[data-month="${currentMonthIndex}"`
        )

        currentScrollMonth.scrollIntoView(true)
        scrollContainer.scrollTop -= 140
      }, 50)
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-single-datepicker.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_single_datepickervue_type_script_lang_js = (hg_single_datepickervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-single-datepicker.vue?vue&type=style&index=0&id=7c8b225d&prod&scoped=true&lang=postcss
var hg_single_datepickervue_type_style_index_0_id_7c8b225d_prod_scoped_true_lang_postcss = __webpack_require__("0d47");

// CONCATENATED MODULE: ./src/components/inputs/hg-single-datepicker.vue






/* normalize component */

var hg_single_datepicker_component = normalizeComponent(
  inputs_hg_single_datepickervue_type_script_lang_js,
  hg_single_datepickervue_type_template_id_7c8b225d_scoped_true_render,
  hg_single_datepickervue_type_template_id_7c8b225d_scoped_true_staticRenderFns,
  false,
  null,
  "7c8b225d",
  null
  
)

/* harmony default export */ var hg_single_datepicker = (hg_single_datepicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-periodpicker.vue?vue&type=template&id=4496c327&scoped=true
var hg_periodpickervue_type_template_id_4496c327_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-wrapper input-wrapper--date-picker"},[_c('div',{staticClass:"input-wrapper-inner"},[_c('HgDropdown',{ref:"dropdownRef",staticClass:"period-picker-dropdown",attrs:{"isFullscreenOnMobile":_vm.isMobile,"dropdownStyle":"input","isDisabled":_vm.disabled},on:{"dropdownChange":_vm.changeDropdownState},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{staticClass:"trigger-content-wrapper",class:_vm.disabled && 'disabled'},[_c('div',{staticClass:"trigger-content"},[_vm._t("inputOverlay")],2)])]},proxy:true}],null,true)},[_c('div',{staticClass:"periodpicker"},[_c('div',{staticClass:"periodpicker-container"},[_c('header',{staticClass:"header"},[_c('hg-button',{staticClass:"month-button prev-month-button",attrs:{"type":"button","aria-label":"previous Month"},on:{"onClick":_vm.prevMonth}},[_c('hg-icon',{attrs:{"name":"chevron-left"}})],1),_c('span',{staticClass:"current-month"},[_vm._v(_vm._s(_vm.getFormat(_vm.currentMonth, 'MMMM \ yyyy')))]),_c('hg-button',{staticClass:"month-button next-month-button",attrs:{"type":"button","aria-label":"next Month"},on:{"onClick":_vm.nextMonth}},[_c('hg-icon',{attrs:{"name":"chevron-right"}})],1)],1),_c('div',{staticClass:"calendar-container"},[_vm._l((_vm.weekdayNames),function(weekdayName){return _c('span',{key:weekdayName,staticClass:"weekday-name"},[_vm._v(_vm._s(weekdayName))])}),_vm._l((_vm.currentMonthdays),function(monthDay){return _c('div',{key:_vm.getFormat(monthDay.date, 'dd-MMMM-yyyy'),staticClass:"calendar__day",class:[
                _vm.containerRangeClass(monthDay.date),
                ..._vm.containerUnselectedRangeClass(monthDay.date),
              ]},[_c('span',{class:`${_vm.getRangeIndicatorClass(
                  monthDay.date
                )} ${_vm.getRangeIndicatorClass(monthDay.date)}--before`}),_c('button',{class:[
                  _vm.dateMonthClass(monthDay.date),
                  _vm.dateActiveClass(monthDay.date),
                  _vm.dateRangeClass(monthDay.date),
                  _vm.dateHoverClass(monthDay.date),
                  `date-price--${_vm.dateBestDealClass(monthDay.date)}`,
                  'date',
                  _vm.dateClass(monthDay.date),
                  !_vm.startDateInAnyRange(monthDay.date) && 'disabled',
                ],attrs:{"type":"button","disabled":!_vm.startDateInAnyRange(monthDay.date)},on:{"click":function($event){return _vm.selectDate(monthDay.date)},"mouseenter":function($event){return _vm.hoverDate(monthDay.date)}}},[_c('div',[_vm._v(_vm._s(monthDay.day))]),_c('div',{staticClass:"date-price",class:`date-price-tag--${_vm.dateBestDealClass(
                    monthDay.date
                  )}`},[(
                      _vm.showPricePerDate && _vm.dateBestDealPrice(monthDay.date)
                    )?_c('hg-deal-price',{attrs:{"teal":_vm.priceInSelectedRange(monthDay.date),"price":_vm.dateBestDealPrice(monthDay.date),"add-prefix":false,"per-person":false,"rounded":_vm.roundCalendarPrices,"price-size":"xs-light"}}):_c('div',{class:`date-price--${_vm.dateBestDealClass(monthDay.date)}`})],1)]),_c('span',{class:`${_vm.getRangeIndicatorClass(
                  monthDay.date
                )} ${_vm.getRangeIndicatorClass(monthDay.date)}--after`})])})],2)]),_c('div',{staticClass:"periodpicker-footer"},[(_vm.airports.length > 0)?_c('div',{staticClass:"departure-info"},[_c('div',{staticClass:"departure-info__label"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.departureFrom'))+" ")]),(_vm.airports.length < 5)?_c('div',{staticClass:"departure-info__airport oneline"},[_vm._v(" "+_vm._s(_vm.airports.join(', '))+" ")]):_c('hg-collapsible-content',{scopedSlots:_vm._u([{key:"teaserContent",fn:function(){return [_c('div',{staticClass:"departure-info__airport teaser"},[_vm._v(" "+_vm._s(_vm.airports .filter((airport, index) => index < 4) .join(', ') + '...')+" ")])]},proxy:true},{key:"fullContent",fn:function(){return [_c('div',{staticClass:"departure-info__airport"},[_vm._v(" "+_vm._s(_vm.airports.join(', '))+" ")])]},proxy:true}],null,false,836762773)})],1):_vm._e(),_c('div',{staticClass:"divider"}),_c('div',{class:`periodpicker-legend ${
              _vm.airports.length > 0 ? 'tw-pt-2' : ''
            }`},[_c('div',{staticClass:"legend-item"},[_c('div',{staticClass:"marker bestprice"}),_vm._v(" "+_vm._s(_vm.$t('dealBox.cheapestPeriod'))+" ")]),_c('div',{staticClass:"legend-item"},[_c('div',{staticClass:"marker unselected"}),_vm._v(" "+_vm._s(_vm.$t('dealBox.availablePeriods'))+" ")]),_c('div',{staticClass:"legend-item"},[_c('div',{staticClass:"marker selected"}),_vm._v(" "+_vm._s(_vm.$t('dealBox.selectedPeriod'))+" ")])]),_c('div',{staticClass:"periodpicker-currentchoice"},[_c('div',{staticClass:"price-container"},[_c('div',{staticClass:"current-price"},[_c('div',{staticClass:"price-tag"},[_c('hg-deal-price',{attrs:{"teal":"","price":_vm.currentDealPrice,"perPerson":true,"rounded":_vm.roundDealPrice,"priceSize":"3xl"}})],1),_c('div',{staticClass:"price-legal"},[_vm._v("*")])]),_c('div',{staticClass:"current-nights-persons"},[_c('span',{staticClass:"period-label nights"},[_vm._v(" "+_vm._s(_vm.currentPeriodNights)+" "+_vm._s(_vm.currentPeriodNights === 1 ? _vm.$t('night') : _vm.$t('nights'))+" ")]),(_vm.dealNumberOfAdults)?_c('span',{staticClass:"offer-persons"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.dealIsValidFor'))+" "+_vm._s(_vm.dealNumberOfAdults)+" "+_vm._s(_vm.$t('dealBox.travelers'))+" ")]):_vm._e()])]),_c('div',{staticClass:"periodpicker-select"},[_c('hg-button',{attrs:{"type":"submit","size":"full","color":"teal"},on:{"onClick":_vm.clickSelectRange}},[_vm._v(" "+_vm._s(_vm.$t('confirm'))+" ")])],1),_c('div',{staticClass:"periodpicker-legal"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.priceNotice'))+" ")])])])])])],1)])
}
var hg_periodpickervue_type_template_id_4496c327_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-periodpicker.vue?vue&type=template&id=4496c327&scoped=true

// CONCATENATED MODULE: ./node_modules/date-fns/esm/isEqual/index.js


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-price.vue?vue&type=template&id=48a9b655&scoped=true
var hg_deal_pricevue_type_template_id_48a9b655_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-price",class:[
    _vm.breakLine && 'breakline',
    `pricesize--${_vm.priceSize}`,
    _vm.teal && 'price--teal',
  ]},[(_vm.price == null)?[(_vm.addPrefix)?_c('span',{staticClass:"prefix"},[_vm._v(" "+_vm._s(_vm.$t('from'))+" ")]):_vm._e(),_c('div',{staticClass:"combo"},[_c('span',{staticClass:"price-span"},[_vm._v("--")]),_c('span',{staticClass:"currency-span"},[_vm._v(" "+_vm._s(_vm.currencyValue))])]),(_vm.perPerson)?_c('span',{staticClass:"suffix"},[_vm._v(" "+_vm._s(_vm.perPersonText)+" ")]):_vm._e()]:(_vm.price.value === 0)?[_c('div',{staticClass:"combo"},[_c('span',{staticClass:"price-span"},[_vm._v(" "+_vm._s(_vm.$t('price.zero')))]),(_vm.legal)?_c('span',{staticClass:"asterisk"},[_vm._v("*")]):_vm._e()])]:(_vm.locale === 'nl')?[(_vm.price.value > 0 && _vm.addPrefix)?_c('span',{staticClass:"prefix"},[_vm._v(" "+_vm._s(_vm.$t('from'))+" ")]):_vm._e(),_c('div',{staticClass:"combo"},[_c('span',{staticClass:"currency-span"},[_vm._v(_vm._s(_vm.currencyValue)+" ")]),_c('span',{staticClass:"price-span"},[_vm._v(_vm._s(_vm.priceValue))]),(_vm.legal)?_c('span',{staticClass:"asterisk"},[_vm._v("*")]):_vm._e()]),(_vm.perPerson)?_c('span',{staticClass:"suffix"},[_vm._v(" "+_vm._s(_vm.perPersonText)+" ")]):_vm._e()]:[(_vm.price.value > 0 && _vm.addPrefix)?_c('span',{staticClass:"prefix"},[_vm._v(" "+_vm._s(_vm.$t('from'))+" ")]):_vm._e(),_c('div',{staticClass:"combo"},[_c('span',{staticClass:"price-span"},[_vm._v(_vm._s(_vm.priceValue))]),_c('span',{staticClass:"currency-span"},[_vm._v(" "+_vm._s(_vm.currencyValue))]),(_vm.legal)?_c('span',{staticClass:"asterisk"},[_vm._v("*")]):_vm._e()]),(_vm.perPerson)?_c('span',{staticClass:"suffix"},[_vm._v(_vm._s(_vm.perPersonText))]):_vm._e()]],2)
}
var hg_deal_pricevue_type_template_id_48a9b655_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-price.vue?vue&type=template&id=48a9b655&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-price.vue?vue&type=script&lang=js

/* harmony default export */ var hg_deal_pricevue_type_script_lang_js = ({
  props: {
    price: {
      type: Object,
      default() {
        return {
          value: 0,
          currency: '',
        }
      },
    },
    breakLine: {
      type: Boolean,
      default: false,
    },
    perPerson: {
      type: Boolean,
      default: true,
    },
    priceSize: {
      type: String,
      default: '2xl',
    },
    addPrefix: {
      type: Boolean,
      default: true,
    },
    teal: {
      type: Boolean,
      default: false,
    },
    legal: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (!this.$i18n) return
    this.locale = this.$i18n.locale

    if (this.locale === 'es' || this.locale === 'nl') {
      this.perPersonText = 'p.p.'
    }
  },
  data: () => ({
    locale: null,
    perPersonText: 'p.P.',
  }),
  computed: {
    priceValue() {
      const { value } = this.price
      if (this.isInt(value / 100)) return value / 100
      const commaValue = (value / 100).toFixed(2)
      const roundedValue = Math.round(commaValue)
      const priceValueString = this.rounded
        ? roundedValue
        : commaValue.toString().replace('.', ',')
      return priceValueString
    },
    currencyValue() {
      if (this.price == null) {
        return '€'
      }

      const { currency } = this.price
      if (currency === null) return ''
      if (currency === 'EUR') return '€'
      if (currency === 'USD') return '$'
      else return currency
    },
  },
  methods: {
    isInt(n) {
      return n % 1 === 0
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-price.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_detail_hg_deal_pricevue_type_script_lang_js = (hg_deal_pricevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-detail/hg-deal-price.vue?vue&type=style&index=0&id=48a9b655&prod&scoped=true&lang=postcss
var hg_deal_pricevue_type_style_index_0_id_48a9b655_prod_scoped_true_lang_postcss = __webpack_require__("8171");

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-price.vue






/* normalize component */

var hg_deal_price_component = normalizeComponent(
  deal_detail_hg_deal_pricevue_type_script_lang_js,
  hg_deal_pricevue_type_template_id_48a9b655_scoped_true_render,
  hg_deal_pricevue_type_template_id_48a9b655_scoped_true_staticRenderFns,
  false,
  null,
  "48a9b655",
  null
  
)

/* harmony default export */ var hg_deal_price = (hg_deal_price_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-collapsible-content.vue?vue&type=template&id=57fc7ca2&scoped=true
var hg_collapsible_contentvue_type_template_id_57fc7ca2_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-collapsible-content-wrapper"},[(_vm.isCollapsibleOpen)?[_vm._t("default")]:_vm._e(),_c('button',{staticClass:"hg-collapsible-content-trigger",on:{"click":function($event){$event.preventDefault();return _vm.toggleCollapse.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"hg-collapsible__chevron",class:{ 'hg-collapsible__chevron--rotate-180': _vm.isCollapsibleOpen }},[_c('hg-icon',{attrs:{"name":"chevron-down","size":"small"}})],1)])],2)
}
var hg_collapsible_contentvue_type_template_id_57fc7ca2_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-collapsible-content.vue?vue&type=template&id=57fc7ca2&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-collapsible-content.vue?vue&type=script&lang=js

/* harmony default export */ var hg_collapsible_contentvue_type_script_lang_js = ({
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    isCollapsibleOpen: false,
  }),
  methods: {
    toggleCollapse() {
      this.isCollapsibleOpen = !this.isCollapsibleOpen
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-collapsible-content.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_collapsible_contentvue_type_script_lang_js = (hg_collapsible_contentvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-collapsible-content.vue?vue&type=style&index=0&id=57fc7ca2&prod&scoped=true&lang=postcss
var hg_collapsible_contentvue_type_style_index_0_id_57fc7ca2_prod_scoped_true_lang_postcss = __webpack_require__("4a6c");

// CONCATENATED MODULE: ./src/components/ui/hg-collapsible-content.vue






/* normalize component */

var hg_collapsible_content_component = normalizeComponent(
  ui_hg_collapsible_contentvue_type_script_lang_js,
  hg_collapsible_contentvue_type_template_id_57fc7ca2_scoped_true_render,
  hg_collapsible_contentvue_type_template_id_57fc7ca2_scoped_true_staticRenderFns,
  false,
  null,
  "57fc7ca2",
  null
  
)

/* harmony default export */ var hg_collapsible_content = (hg_collapsible_content_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-periodpicker.vue?vue&type=script&lang=js









let hg_periodpickervue_type_script_lang_js_locale = de

/**
 * HG Periodpicker Dropdown Component
 * @displayName HG Periodpicker
 * @param {object[]} validPeriods - array of valid/choosable timePeriods
 * @param {object} currentDealPeriod - currently chosen period
 * @param {string} startDateProperty - Name of the Property to use as startDate in every Period Object (validPeriods / currentPeriod). Nested Properties can be passed as . delimited string `propLevel1.propLevel2.propLevel3`
 * @param {string} endDateProperty - Name of the Property to use as endDate in every Period Object (validPeriods / currentPeriod). Nested Properties can be passed as . delimited string `propLevel1.propLevel2.propLevel3`
 *
 */
/* harmony default export */ var hg_periodpickervue_type_script_lang_js = ({
  components: {
    HgDealPrice: hg_deal_price,
    HgCollapsibleContent: hg_collapsible_content,
  },
  props: {
    initialStartDate: {
      type: Object | Date,
      default: () => {},
    },
    initialEndDate: {
      type: Object | Date,
      default: () => {},
    },
    disabledPortal: {
      type: Boolean,
      default: true,
    },
    dateFormatString: {
      type: String,
      default: 'eeeeee, dd.MM.yyyy',
    },
    validPeriods: {
      type: Array,
      default: () => [],
    },
    currentDealPeriod: {
      type: Object,
      default: () => {},
    },
    bestDealPeriod: {
      type: Object,
      default: () => {},
    },
    startDateProperty: {
      type: String,
      default: 'startDate',
    },
    endDateProperty: {
      type: String,
      default: 'endDate',
    },
    dealNumberOfAdults: {
      type: Number,
      default: 0,
    },
    currentPeriodNights: 0,
    currentPeriodPossibleAirports: {
      type: Array,
      default: () => [],
    },
    currentDealPrice: {
      type: Object,
      default: () => {},
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showPricePerDate: {
      type: Boolean,
      default: false,
    },
    roundCalendarPrices: {
      type: Boolean,
      default: false,
    },
    roundDealPrice: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    today: null,
    currentMonth: null,
    rangeStart: null,
    rangeEnd: null,
    hoveredRangeEnd: null,
    weekdayNames: null,
    numSelectedDays: null,
    closeRef: null,
    portalDisabled: true,
    selectedPeriod: null,
    dropdownOpen: false,
  }),
  computed: {
    currentMonthdays() {
      const days = []
      let start = this.startOfMonth(this.currentMonth)
      const end = this.subDays(this.endOfMonth(this.currentMonth), 1)

      while (this.differenceInDays(end, start) >= 0) {
        days.push({
          day: this.getFormat(start, 'd'),
          dayIndex: this.getDay(start),
          date: new Date(start),
        })
        start = this.addDays(start, 1)
      }

      const firstDay = days[0]
      const lastDay = days[days.length - 1]
      const startPad = this.padMonthStart(firstDay)
      const endPad = this.padMonthEnd(lastDay)

      return [...startPad, ...days, ...endPad]
    },
    unselectedPeriods() {
      if (!this.validPeriods.length) return []
      return this.validPeriods.filter(
        (period) => period !== this.currentDealPeriod
      )
    },
    airports() {
      const res = this.currentPeriodPossibleAirports.reduce(
        (unique, item) =>
          unique.includes(item.name) ? unique : [...unique, item.name],
        []
      )
      return res
    },
  },
  mounted() {
    if (this.initialStartDate && this.initialEndDate) {
      this.setInitialRange()
    }
    this.closeRef = this.$refs.dropdownRef
  },
  methods: {
    setInitialRange() {
      this.rangeStart = new Date(this.initialStartDate)
      this.rangeEnd = new Date(this.initialEndDate)
      this.numSelectedDays =
        Math.abs(this.differenceInDays(this.rangeEnd, this.rangeStart)) + 1
    },
    prevMonth() {
      this.currentMonth = this.subMonths(this.currentMonth, 1)
      this.updateMonth()
    },
    nextMonth() {
      this.currentMonth = this.addMonths(this.currentMonth, 1)
      this.updateMonth()
    },
    updateMonth() {
      const start = this.currentMonthdays[0]
      const end = this.currentMonthdays[this.currentMonthdays.length - 1]

      this.$emit('onUpdateMonth', {
        startDate: start.date,
        endDate: end.date,
      })
    },
    selectDate(date) {
      const clickedPeriods = this.getClickedPeriodFromStartDate(date)
      const bestClicked = {
        period: clickedPeriods[0],
      }
      if (clickedPeriods.length > 1) {
        for (let i = 1; i < clickedPeriods.length; i++) {
          if (
            clickedPeriods[i].periodPrice.value <
            bestClicked.period.periodPrice.value
          ) {
            bestClicked.period = clickedPeriods[i]
          }
        }
      }

      this.rangeStart = this.getStartDate(bestClicked.period)
      this.rangeEnd = this.getEndDate(bestClicked.period)
      this.selectedPeriod = bestClicked.period
      this.updateNumSelectedDays()
      // Emit final Date
      // if (this.$refs.dropdownRef.close) {
      //   this.$refs.dropdownRef.close()
      // }

      this.$emit('onDateRangeSelect', {
        start: this.rangeStart,
        end: this.rangeEnd,
        period: bestClicked.period,
      })
    },
    clickSelectRange() {
      if (this.$refs.dropdownRef.close) {
        this.$refs.dropdownRef.close()
      }
      this.$emit('onDateRangeSelect', {
        start: this.rangeStart,
        end: this.rangeEnd,
        period: this.selectedPeriod,
      })
    },
    selectDateRange(period) {},
    hoverDate(date) {
      if (!this.rangeStart) return
      if (this.rangeStart && this.rangeEnd) return

      this.updateNumSelectedDays()
      this.hoveredRangeEnd = date
    },
    dateMonthClass(date) {
      if (this.getMonth(date) === this.getMonth(this.currentMonth)) {
        return 'date--current-month'
      } else {
        return 'date--adjacent-month'
      }
    },
    dateRangeClass(date) {
      if (!this.rangeStart && !this.rangeEnd) return

      if (
        (this.isBefore(date, this.hoveredRangeEnd) &&
          this.isAfter(date, this.rangeStart)) ||
        (this.isBefore(date, this.rangeEnd) &&
          this.isAfter(date, this.rangeStart))
      )
        return 'date--is-in-range'
    },
    dateRangeUnselectedClass(date) {
      for (let i = 0; i < this.unselectedPeriods.length; i++) {
        if (
          (this.isBefore(date, this.hoveredRangeEnd) &&
            this.isAfter(date, this.getStartDate(this.unselectedPeriods[i]))) ||
          (this.isBefore(date, this.getEndDate(this.unselectedPeriods[i])) &&
            this.isAfter(date, this.getStartDate(this.unselectedPeriods[i])))
        )
          return 'date--is-in-unselected-range'
      }
    },
    containerRangeClass(date) {
      if (this.rangeStart && this.rangeEnd) {
        return this.getRangeClass(date, this.rangeStart, this.rangeEnd)
      }

      if (this.rangeStart && this.hoveredRangeEnd) {
        return this.getRangeClass(date, this.rangeStart, this.hoveredRangeEnd)
      }
    },
    containerUnselectedRangeClass(date) {
      const classes = []
      for (let i = 0; i < this.unselectedPeriods.length; i++) {
        classes.push(
          this.getUnselectedRangeClass(
            date,
            this.getStartDate(this.unselectedPeriods[i]),
            this.getEndDate(this.unselectedPeriods[i])
          )
        )
      }
      return classes
    },
    updateNumSelectedDays() {
      if (this.rangeEnd) {
        this.numSelectedDays =
          Math.abs(this.differenceInDays(this.rangeEnd, this.rangeStart)) + 1
      } else if (this.hoveredRangeEnd) {
        this.numSelectedDays =
          Math.abs(
            this.differenceInDays(this.hoveredRangeEnd, this.rangeStart)
          ) + 1
      }
    },
    getRangeClass(current, start, end) {
      if (this.getMonth(current) !== this.getMonth(this.currentMonth)) return ''
      // Start before End Date
      if (this.isBefore(start, end)) {
        if (this.isSameDay(current, start)) return 'day--is-start-of-range'
        if (this.isSameDay(current, end)) return 'day--is-end-of-range'

        if (this.isBefore(current, end) && this.isAfter(current, start))
          return 'day--is-in-range'
      } else {
        // End Before Start
        if (this.isSameDay(current, start)) return 'day--is-end-of-range'
        if (this.isSameDay(current, end)) return 'day--is-start-of-range'
        if (this.isAfter(current, end) && this.isBefore(current, start))
          return 'day--is-in-range'
      }
    },
    getUnselectedRangeClass(current, start, end) {
      // Start before End Date
      if (this.isBefore(start, end)) {
        if (this.isSameDay(current, start))
          return 'day--is-start-of-unselected-range'
        if (this.isSameDay(current, end))
          return 'day--is-end-of-unselected-range'

        if (this.isBefore(current, end) && this.isAfter(current, start))
          return 'day--is-in-unselected-range'
      } else {
        // End Before Start
        if (this.isSameDay(current, start))
          return 'day--is-end-of-unselected-range'
        if (this.isSameDay(current, end))
          return 'day--is-start-of-unselected-range'
        if (this.isAfter(current, end) && this.isBefore(current, start))
          return 'day--is-in-unselected-range'
      }
    },
    getRangeIndicatorClass(date) {
      if (
        this.dateRangeClass(date) ||
        (this.startDateInSelectedRange(date) &&
          !this.endDateInSelectedRange(date))
      ) {
        return 'range-indicator'
      } else {
        return 'range-indicator-unselected'
      }
    },
    priceInSelectedRange(date) {
      if (
        !this.startDateInSelectedRange(date) &&
        !this.dateRangeClass(date) &&
        this.dateBestDealClass(date) === 'has-not-best-deal'
      ) {
        return true
      }
      return false
    },
    dateHoverClass(date) {
      // Check Hover State of a date
      if (!this.rangeStart || !this.hoveredRangeEnd) return

      if (
        (this.isAfter(date, this.rangeStart) &&
          this.isBefore(date, this.hoveredRangeEnd)) ||
        (this.isBefore(date, this.rangeStart) &&
          this.isAfter(date, this.hoveredRangeEnd))
      ) {
        return 'date--is-in-hovered-range'
      } else if (this.isSameDay(date, this.hoveredRangeEnd)) {
        return 'date--is-hovered-end'
      }
    },
    dateActiveClass(date) {
      if (
        this.rangeStart &&
        this.getFormat(this.rangeStart, 'dd MM') ===
          this.getFormat(date, 'dd MM')
      ) {
        return 'date--selected'
      }
      if (
        this.rangeEnd &&
        this.getFormat(this.rangeEnd, 'dd MM') === this.getFormat(date, 'dd MM')
      ) {
        return 'date--selected'
      }
    },
    dateBestDealClass(date) {
      for (let i = 0; i < this.validPeriods.length; i++) {
        if (
          this.isSameDay(
            new Date(date),
            new Date(this.getStartDate(this.validPeriods[i]))
          )
        ) {
          if (
            this.validPeriods[i].period.startDate ===
              this.bestDealPeriod.period.startDate &&
            this.validPeriods[i].period.endDate ===
              this.bestDealPeriod.period.endDate
          ) {
            return `has-best-deal`
          }
        }
      }
      return 'has-not-best-deal'
    },
    dateBestDealPrice(date) {
      let price = null
      for (let i = 0; i < this.validPeriods.length; i++) {
        if (
          this.isSameDay(
            new Date(date),
            new Date(this.getStartDate(this.validPeriods[i]))
          )
        ) {
          if (!price || price.value > this.validPeriods[i].periodPrice.value) {
            price = this.validPeriods[i].periodPrice
          }
        }
      }
      return price
    },
    dateClass(date) {
      return `date--${this.getFormat(date, 'dd')}`
    },
    padMonthStart(firstDay) {
      const daysToPad = ((this.getDay(firstDay.date) + 6) % 7) + 1
      const padTarget = new Date(firstDay.date)
      let days = []

      for (let i = 1; i < daysToPad; i++) {
        const newDate = this.subDays(new Date(padTarget), i)
        days.unshift({
          day: this.getFormat(newDate, 'd'),
          dayIndex: getDay(newDate),
          date: newDate,
        })
      }

      return days
    },
    padMonthEnd(lastDay) {
      const daysToPad = 7 - this.getDay(lastDay.date)
      const padTarget = new Date(lastDay.date)
      let days = []

      if (this.getDay(lastDay.date) === 0) return days

      for (let i = 1; i <= daysToPad; i++) {
        const newDate = this.addDays(new Date(padTarget), i)
        days.push({
          day: this.getFormat(newDate, 'd'),
          dayIndex: this.getDay(newDate),
          date: newDate,
        })
      }

      return days
    },
    showOverlay() {
      this.$emit('onPortalContent', this)
    },
    getEndDate(containingObject) {
      let endDate = this.endDateProperty
        .split('.')
        .reduce((p, c) => (p && p[c]) || null, containingObject.period)
      return new Date(endDate)
    },
    getStartDate(containingObject) {
      let startDate = this.startDateProperty
        .split('.')
        .reduce((p, c) => (p && p[c]) || null, containingObject.period)
      return new Date(startDate)
    },
    dateInAnyRange(date) {
      for (let i = 0; i < this.validPeriods.length; i++) {
        if (
          this.isSameDay(date, this.getStartDate(this.validPeriods[i])) ||
          this.isSameDay(date, this.getEndDate(this.validPeriods[i])) ||
          (this.isBefore(date, this.getEndDate(this.validPeriods[i])) &&
            this.isAfter(date, this.getStartDate(this.validPeriods[i])))
        ) {
          return true
        }
      }
      return false
    },
    dateInUnselectedRange(date) {
      for (let i = 0; i < this.unselectedPeriods.length; i++) {
        if (
          this.getUnselectedRangeClass(
            date,
            this.getStartDate(this.unselectedPeriods[i]),
            this.getEndDate(this.unselectedPeriods[i])
          )
        )
          return true
      }
      return false
    },
    startDateInUnselectedRange(date) {
      for (let i = 0; i < this.unselectedPeriods.length; i++) {
        if (
          this.isSameDay(
            new Date(date),
            new Date(this.getStartDate(this.unselectedPeriods[i]))
          )
        ) {
          return true
        }
      }
      return false
    },
    endDateInUnselectedRange(date) {
      for (let i = 0; i < this.unselectedPeriods.length; i++) {
        if (
          this.isSameDay(
            new Date(date),
            new Date(this.getEndDate(this.unselectedPeriods[i]))
          )
        ) {
          return true
        }
      }
      return false
    },
    startDateInSelectedRange(date) {
      if (
        this.isSameDay(
          new Date(date),
          new Date(this.getStartDate({ period: this.currentDealPeriod.period }))
        )
      )
        return true
      return false
    },
    endDateInSelectedRange(date) {
      if (
        this.isSameDay(
          new Date(date),
          new Date(this.getEndDate({ period: this.currentDealPeriod.period }))
        )
      )
        return true
      return false
    },
    startDateInAnyRange(date) {
      for (let i = 0; i < this.validPeriods.length; i++) {
        if (
          this.isSameDay(
            new Date(date),
            new Date(this.getStartDate(this.validPeriods[i]))
          )
        ) {
          return true
        }
      }
      return false
    },
    getClickedPeriod(date) {
      const clickedPeriods = []
      for (let i = 0; i < this.unselectedPeriods.length; i++) {
        if (
          this.isSameDay(date, this.getStartDate(this.unselectedPeriods[i])) ||
          this.isSameDay(date, this.getEndDate(this.unselectedPeriods[i])) ||
          (this.isBefore(date, this.getEndDate(this.unselectedPeriods[i])) &&
            this.isAfter(date, this.getStartDate(this.unselectedPeriods[i])))
        ) {
          clickedPeriods.push(this.unselectedPeriods[i])
        }
      }
      if (clickedPeriods.length) return clickedPeriods
      for (let i = 0; i < this.validPeriods.length; i++) {
        if (
          this.isSameDay(date, this.getStartDate(this.validPeriods[i])) ||
          this.isSameDay(date, this.getEndDate(this.validPeriods[i])) ||
          (this.isBefore(date, this.getEndDate(this.validPeriods[i])) &&
            this.isAfter(date, this.getStartDate(this.validPeriods[i])))
        ) {
          clickedPeriods.push(this.validPeriods[i])
        }
      }
      return clickedPeriods
    },
    getClickedPeriodFromStartDate(date) {
      const clickedPeriods = []
      for (let i = 0; i < this.validPeriods.length; i++) {
        if (this.isSameDay(date, this.getStartDate(this.validPeriods[i]))) {
          clickedPeriods.push(this.validPeriods[i])
        }
      }
      return clickedPeriods
    },
    changeDropdownState(newState) {
      this.dropdownOpen = newState
    },
    format: format,
    isEqual: isEqual,
    isSameDay: isSameDay,
    isBefore: isBefore,
    isAfter: isAfter,
    getMonth: getMonth,
    startOfMonth: startOfMonth,
    endOfMonth: endOfMonth,
    differenceInDays: differenceInDays,
    getDay: getDay,
    addDays: addDays,
    subDays: subDays,
    addMonths: addMonths,
    subMonths: subMonths,
    getFormat(date, formatString) {
      return this.format(date, formatString, { locale: hg_periodpickervue_type_script_lang_js_locale })
    },
  },
  created() {
    let currentLocale = this.$i18n.locale
    switch (currentLocale) {
      case 'nl':
        hg_periodpickervue_type_script_lang_js_locale = nl
        break
      case 'es':
        hg_periodpickervue_type_script_lang_js_locale = es
        break
      default:
        hg_periodpickervue_type_script_lang_js_locale = de
        break
    }

    this.today = new Date()
    this.currentMonth = this.initialStartDate
      ? new Date(this.initialStartDate)
      : new Date()
    this.weekdayNames = [...Array(7).keys()].map((i) =>
      hg_periodpickervue_type_script_lang_js_locale.localize.day(i + 1 < 7 ? i + 1 : 0, { width: 'short' })
    )
    this.selectedPeriod = this.currentDealPeriod
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-periodpicker.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_periodpickervue_type_script_lang_js = (hg_periodpickervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-periodpicker.vue?vue&type=style&index=0&id=4496c327&prod&scoped=true&lang=postcss
var hg_periodpickervue_type_style_index_0_id_4496c327_prod_scoped_true_lang_postcss = __webpack_require__("1d6d");

// EXTERNAL MODULE: ./src/components/inputs/hg-periodpicker.vue?vue&type=style&index=1&id=4496c327&prod&lang=postcss
var hg_periodpickervue_type_style_index_1_id_4496c327_prod_lang_postcss = __webpack_require__("145d");

// CONCATENATED MODULE: ./src/components/inputs/hg-periodpicker.vue







/* normalize component */

var hg_periodpicker_component = normalizeComponent(
  inputs_hg_periodpickervue_type_script_lang_js,
  hg_periodpickervue_type_template_id_4496c327_scoped_true_render,
  hg_periodpickervue_type_template_id_4496c327_scoped_true_staticRenderFns,
  false,
  null,
  "4496c327",
  null
  
)

/* harmony default export */ var hg_periodpicker = (hg_periodpicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-deal-search-dropdown.vue?vue&type=template&id=6176ed38&scoped=true
var hg_deal_search_dropdownvue_type_template_id_6176ed38_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('hg-deal-search-wrapper',{attrs:{"is-mobile":_vm.isMobile,"is-open":_vm.isOpen},on:{"close":function($event){return _vm.close()}}},[_c('div',{staticClass:"hg-deal-search-input-wrapper"},[_c('vue-autosuggest',{ref:"dealSuggest",staticClass:"hg-deal-search",attrs:{"suggestions":_vm.options,"sectionConfigs":_vm.sectionConfigs,"input-props":{
        id: 'autosuggest__input',
        placeholder: _vm.placeholder,
        class: 'hg-input data-hj-allow',
      },"should-render-suggestions":_vm.shouldRenderSuggestions},on:{"input":_vm.updateSearchTerm,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.triggerSearch.apply(null, arguments)},"opened":_vm.open,"closed":_vm.close},scopedSlots:_vm._u([{key:"default",fn:function({ suggestion }){return [_c('div',{staticClass:"tw-flex tw-items-center"},[_c('hg-icon',{staticClass:"tw-mr-3",attrs:{"name":_vm.inputValue.length > 1 ? 'star' : 'search',"size":"small"}}),_c('span',[_vm._v(_vm._s(suggestion.item.name))])],1)]}}]),model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},[_c('template',{slot:"after-input"},[(_vm.isLoading)?_c('div',{staticClass:"hg-input-loading"},[_c('hg-loading-bubble',{attrs:{"loading":_vm.isLoading}})],1):_vm._e(),(_vm.selected !== null)?_c('button',{staticClass:"hg-input-clear hg-button",on:{"click":_vm.resetValue}},[_c('hg-icon',{attrs:{"name":"times-circle","size":"small"}})],1):_vm._e()])],2),_c('hg-button',{staticClass:"hg-search-button",attrs:{"color":"teal","aria-label":"search button"},on:{"onClick":_vm.triggerSearch}},[_c('hg-icon',{attrs:{"name":"search","pack":"fas"}})],1)],1)])
}
var hg_deal_search_dropdownvue_type_template_id_6176ed38_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-deal-search-dropdown.vue?vue&type=template&id=6176ed38&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-deal-search-dropdown.vue?vue&type=script&lang=js

/* harmony default export */ var hg_deal_search_dropdownvue_type_script_lang_js = ({
  props: {
    isMobile: Boolean,
    placeholder: String,
    options: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    term: {
      type: String,
      default: '',
    },
    labelHighlightTags: {
      type: String,
      default: '',
    },
    labelDeals: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selected: null,
      inputValue: '',
      isOpen: false,

      sectionConfigs: {
        default: {
          limit: 6,
          onSelected: function () {},
        },
        highlightTags: {
          limit: 10,
          label: this.labelHighlightTags,
          onSelected: (selected) => {
            if (selected) {
              this.selected = true
              this.inputValue = selected.item.name
              this.$emit('onTriggerSearch', selected.item.name)
            }
          },
        },
        searchTags: {
          limit: 10,
          label: this.labelDeals,
          onSelected: (selected) => {
            if (selected) {
              this.selected = true
              this.inputValue = selected.item.name
              this.$emit('onTriggerSearch', selected.item.name)
            }
          },
        },
      },
    }
  },
  mounted() {
    if (this.term) {
      this.inputValue = this.term
      this.selected = true
    }
    document.documentElement.style.setProperty('overflow', 'auto', 'important')
  },
  methods: {
    shouldRenderSuggestions(size, loading) {
      return size >= 0 && !loading
    },

    open() {
      if (this.isMobile) {
        this.isOpen = true
        window.scrollTo(0, 0)
        document.documentElement.style.setProperty(
          'overflow',
          'hidden',
          'important'
        )
      }
    },
    close() {
      if (this.isMobile) {
        this.isOpen = false
        document.documentElement.style.setProperty(
          'overflow',
          'auto',
          'important'
        )
      }
    },
    resetValue() {
      this.inputValue = ''
      this.selected = null
      this.$emit('onTriggerSearch', this.inputValue)
      if (this.isMobile) this.isOpen = true
      this.$refs.dealSuggest.$el.querySelector('input').click()
      this.$refs.dealSuggest.$el.querySelector('input').focus()
    },

    updateSearchTerm(term) {
      this.inputValue = term
      this.$emit('onUpdateSearchTerm', term)
    },
    triggerSearch() {
      this.$emit('onTriggerSearch', this.inputValue)
      this.close()
    },
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        this.$refs.dealSuggest.$el.querySelector('input').focus()
      }
    },
    term() {
      this.inputValue = this.term
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-deal-search-dropdown.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_deal_search_dropdownvue_type_script_lang_js = (hg_deal_search_dropdownvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-deal-search-dropdown.vue?vue&type=style&index=0&id=6176ed38&prod&lang=postcss&scoped=true
var hg_deal_search_dropdownvue_type_style_index_0_id_6176ed38_prod_lang_postcss_scoped_true = __webpack_require__("bfac");

// CONCATENATED MODULE: ./src/components/inputs/hg-deal-search-dropdown.vue






/* normalize component */

var hg_deal_search_dropdown_component = normalizeComponent(
  inputs_hg_deal_search_dropdownvue_type_script_lang_js,
  hg_deal_search_dropdownvue_type_template_id_6176ed38_scoped_true_render,
  hg_deal_search_dropdownvue_type_template_id_6176ed38_scoped_true_staticRenderFns,
  false,
  null,
  "6176ed38",
  null
  
)

/* harmony default export */ var hg_deal_search_dropdown = (hg_deal_search_dropdown_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-destination-select.vue?vue&type=template&id=2d72399a&scoped=true
var hg_destination_selectvue_type_template_id_2d72399a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-combo-blocks',{ref:"comboBlock",staticClass:"hg-destination-select",attrs:{"itemToString":_vm.itemToString,"items":_vm.options,"stateReducer":_vm.stateReducer},on:{"input-value-change":function($event){_vm.open(); _vm.$emit('onUpdateDestinationTerm', arguments[0])},"select":_vm.selectDestination},scopedSlots:_vm._u([{key:"default",fn:function({
    reset,
    isOpen,
    hoveredIndex,
    getComboboxProps,
    getInputProps,
    getInputEventListeners,
    getMenuProps,
    getMenuEventListeners,
    getItemProps,
    getItemEventListeners,
  }){return [_c('div',_vm._b({},'div',getComboboxProps(),false),[_c('div',{staticClass:"hg-control label-position--inside"},[_c('label',{attrs:{"id":"hg-destination-label","for":"hg-destination-input"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('input',_vm._g(_vm._b({class:`hg-input ${_vm.allowHotjarRecord ? 'data-hj-allow' : ''} ${
          _vm.theme ? _vm.theme : ''
        }`,attrs:{"id":"hg-destination-input","name":"hg-destination-input","placeholder":_vm.placeholder,"aria-labelledby":"hg-destination-label"},on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.clickInput.apply(null, arguments)}}},'input',getInputProps(),false),getInputEventListeners())),(_vm.isLoading)?_c('div',{staticClass:"hg-input-loading"},[_c('hg-loading-bubble',{attrs:{"loading":_vm.isLoading,"theme":_vm.theme}})],1):_vm._e(),(_vm.selected !== null)?_c('button',{staticClass:"hg-input-clear hg-button",on:{"click":reset}},[_c('hg-icon',{attrs:{"name":"times","size":"small"}})],1):_vm._e()]),(isOpen && _vm.isVisible)?_c('div',_vm._g(_vm._b({ref:"selectMenu",staticClass:"hg-select-menu-wrapper",class:_vm.isMobile
          ? 'hg-select-menu-wrapper--mobile'
          : 'hg-select-menu-wrapper--desktop'},'div',getMenuProps(),false),getMenuEventListeners()),[_c(_vm.isMobile && isOpen
            ? 'HgPortalDropdownMobile'
            : 'HgPortalDropdownDesktop',{tag:"component",attrs:{"theme":_vm.theme,"padding":false},on:{"close":_vm.close,"reset":_vm.resetValue},scopedSlots:_vm._u([{key:"header-field",fn:function(){return [_c('div',{staticClass:"hg-control"},[_c('input',_vm._g(_vm._b({ref:"mobileDestinationInput",class:[
                'hg-input',
                _vm.teal ? 'hg-input--teal-border' : '',
                { 'hg-input--transparent': _vm.transparent },
                _vm.theme ? _vm.theme : '',
              ],attrs:{"id":"hg-destination-input","placeholder":_vm.placeholder}},'input',getInputProps(),false),getInputEventListeners())),_c('button',{staticClass:"hg-input-clear hg-button",on:{"click":reset}},[_c('hg-icon',{attrs:{"name":"times","size":"small"}})],1)])]},proxy:true},{key:"content-2",fn:function(){return [_c('div',_vm._g(_vm._b({directives:[{name:"show",rawName:"v-show",value:(isOpen),expression:"isOpen"}],staticClass:"hg-select-menu"},'div',getMenuProps(),false),getMenuEventListeners()),[(_vm.options.length)?_vm._l((_vm.options),function(item,index){return _c('div',_vm._g(_vm._b({key:item.id + item.name + index || item.suggestion},'div',getItemProps({ item, index }),false),getItemEventListeners({ item, index })),[_c('div',{staticClass:"tw-px-2 tw-py-2"},[(
                      index === 0 || _vm.options[index - 1].type !== item.type
                    )?[(item.type)?_c('div',{class:`hg-select-option-dropdown-category ${
                        _vm.theme ? _vm.theme : ''
                      }`},[(
                          _vm.$te(
                            `destination_category_${item.type.toLowerCase()}`
                          )
                        )?_c('span',[_vm._v(" "+_vm._s(_vm.$t( `destination_category_${item.type.toLowerCase()}` ))+" ")]):_c('span',[_vm._v(_vm._s(item.type))])]):_vm._e()]:_vm._e(),_c('button',{class:[
                      'hg-select-option',
                      hoveredIndex === index && 'hg-select-option--hovered',
                      _vm.selected &&
                        _vm.selected.id &&
                        _vm.selected.id === item.id &&
                        'hg-select-option--selected',
                      _vm.selected &&
                        _vm.selected.suggestion &&
                        _vm.selected.suggestion === item.suggestion &&
                        'hg-select-option--selected',
                      _vm.theme ? _vm.theme : '',
                    ],attrs:{"data-icon":item.type}},[(item.type)?_c('hg-icon',{attrs:{"name":_vm.getIcon(item.type),"size":"small"}}):_vm._e(),_c('div',{staticClass:"tw-flex-col"},[_c('div',{staticClass:"tw-font-medium",domProps:{"innerHTML":_vm._s(item.suggestion || item.name || item.value)}}),_c('div',{staticClass:"tw-text-gray-600"},[_vm._v(" "+_vm._s(item.shortnameCropped)+" "+_vm._s(item.villageName || item.provinceName || item.city)+_vm._s(item.countryName && `, ${item.countryName}`)+" "+_vm._s(item.subname)+" ")])])],1)],2)])}):_c('div',{staticClass:"hg-select-option hg-select-option--default"},[_vm._v(" "+_vm._s(_vm.noResult)+" ")])],2)]},proxy:true}],null,true)},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.showMadeByGoogle)?_c('div',{staticClass:"hg-google-wrap"},[_vm._v(" powered by Google ")]):_vm._e()],1):_vm._e()])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var hg_destination_selectvue_type_template_id_2d72399a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-destination-select.vue?vue&type=template&id=2d72399a&scoped=true

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vue-combo-blocks/build/vue-combo-blocks.esm.js


var controls = {
  arrowUpKey: 38,
  arrowDownKey: 40,
  escKey: 27,
  enterKey: 13,
  showList: 40,
};

function isControlledProp(props, key) {
  return props[key] !== undefined;
}

function hasKeyCode(keyCode, event) {
  return keyCode === event.keyCode;
}

function getItemIndex(index, item, items) {
  if (index !== undefined) {
    return index;
  }
  if (!items.length) {
    return -1;
  }
  return items.indexOf(item);
}

function vue_combo_blocks_esm_hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function requiredProp(fnName, propName) {
  // eslint-disable-next-line no-console
  console.error(("The property \"" + propName + "\" is required in \"" + fnName + "\""));
}

/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards,
 *                            positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled.
 *                   Returns next non-disabled item otherwise. If no non-disabled found
 *                   it will return -1.
 */
function getNextNonDisabledIndex(
  moveAmount,
  baseIndex,
  itemCount,
  getItemNodeFromIndex,
  circular
) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);
  if (!currentElementNode || !currentElementNode.hasAttribute('disabled')) {
    return baseIndex;
  }

  if (moveAmount > 0) {
    for (var index = baseIndex + 1; index < itemCount; index += 1) {
      if (!getItemNodeFromIndex(index).hasAttribute('disabled')) {
        return index;
      }
    }
  } else {
    for (var index$1 = baseIndex - 1; index$1 >= 0; index$1 -= 1) {
      if (!getItemNodeFromIndex(index$1).hasAttribute('disabled')) {
        return index$1;
      }
    }
  }

  if (circular) {
    return moveAmount > 0
      ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false)
      : getNextNonDisabledIndex(
        -1,
        itemCount - 1,
        itemCount,
        getItemNodeFromIndex,
        false
      );
  }
  return -1;
}

function scrollToElement(element, parentElement, hoveredIndex) {
  /* eslint-disable no-param-reassign */
  var clientHeight = parentElement.clientHeight;
  var scrollTop = parentElement.scrollTop;
  var offsetHeight = element.offsetHeight;
  var offsetTop = element.offsetTop;

  if (offsetTop < scrollTop) {
    // If scrolled down past the last item, scroll all the way to the top
    if (hoveredIndex === 0) { parentElement.scrollTop = 0; }
    else { parentElement.scrollTop = offsetTop; } // scroll up
  } else {
    var offsetBottom = offsetTop + offsetHeight;
    var scrollBottom = scrollTop + clientHeight;
    if (offsetBottom > scrollBottom) {
      parentElement.scrollTop = offsetBottom - clientHeight; // scroll down
    }
  }
/* eslint-enable no-param-reassign */
}

var InputKeyDownArrowDown = 'InputKeyDownArrowDown';

var InputKeyDownArrowUp = 'InputKeyDownArrowUp';
var InputKeyDownTab = 'InputKeyDownTab';
var InputKeyUpEscape = 'InputKeyUpEscape';
// export const InputKeyDownHome = 'InputKeyDownHome';
// export const InputKeyDownEnd = 'InputKeyDownEnd';
var InputKeyUpEnter = 'InputKeyUpEnter';
var InputChange = 'InputChange';
var InputBlur = 'InputBlur';

var ItemMouseLeave = 'ItemMouseLeave';

var ItemMouseMove = 'ItemMouseMove';
var ItemClick = 'ItemClick';

// export const ToggleButtonClick = 'ToggleButtonClick';

// export const FunctionToggleMenu = 'FunctionToggleMenu';
var FunctionOpenMenu = 'FunctionOpenMenu';
var FunctionCloseMenu = 'FunctionCloseMenu';
// export const FunctionSetHighlightedIndex = 'FunctionSetHighlightedIndex';

var FunctionSelectItem = 'FunctionSelectItem';
var FunctionSetInputValue = 'FunctionSetInputValue';

var FunctionReset = 'FunctionReset';
var ControlledPropUpdatedSelectedItem = 'ControlledPropUpdatedSelectedItem';

var sct = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: InputKeyDownArrowDown,
  InputKeyDownArrowUp: InputKeyDownArrowUp,
  InputKeyDownTab: InputKeyDownTab,
  InputKeyUpEscape: InputKeyUpEscape,
  InputKeyUpEnter: InputKeyUpEnter,
  InputChange: InputChange,
  InputBlur: InputBlur,
  ItemMouseLeave: ItemMouseLeave,
  ItemMouseMove: ItemMouseMove,
  ItemClick: ItemClick,
  FunctionOpenMenu: FunctionOpenMenu,
  FunctionCloseMenu: FunctionCloseMenu,
  FunctionSelectItem: FunctionSelectItem,
  FunctionSetInputValue: FunctionSetInputValue,
  FunctionReset: FunctionReset,
  ControlledPropUpdatedSelectedItem: ControlledPropUpdatedSelectedItem
});

var idCounter = 0;
var VueComboBlocks = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.component('vue-combo-blocks', {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      default: null,
    },
    itemToString: {
      type: Function,
      default: function (item) { return (item ? String(item) : ''); },
    },
    stateReducer: {
      type: Function,
      default: function (s, a) { return a.changes; },
    },
    getItemId: {
      type: Function,
      default: function default$1(i) {
        return ("v-" + (this.idCounter) + "-vue-combo-blocks-item-" + i);
      },
    },
    menuId: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      default: '',
    },
    labelId: {
      type: String,
      default: '',
    },
    scrollIntoView: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value: function value(newValue) {
      if (isControlledProp(this.$props, 'value')) {
        // Quietly set the internal state
        this.inputValue = this.itemToString(newValue);
        this.selectedItem = newValue;
      }
    },
  },
  beforeCreate: function beforeCreate() {
    this.idCounter = idCounter.toString();
    idCounter += 1;
  },
  data: function data() {
    return {
      selectedItem: this.value,
      hovered: null,
      isOpen: false,
      inputValue: this.itemToString(this.value),
      hoveredIndex: -1,
    };
  },
  computed: {
    computedMenuId: function computedMenuId() { return this.menuId || ("v-" + (this.idCounter) + "-vue-combo-blocks-menu"); },
    computedInputId: function computedInputId() { return this.inputId || ("v-" + (this.idCounter) + "-vue-combo-blocks-input"); },
    computedLabelId: function computedLabelId() { return this.labelId || ("v-" + (this.idCounter) + "-vue-combo-blocks-label"); },
    selectedIndex: function selectedIndex() { return this.items.indexOf(this.selectedItem); },
    menuElement: function menuElement() { return this.$el.querySelector(("#" + (this.computedMenuId))); },
  },
  methods: {
    setState: function setState(changes, type) {
      var oldState = this.$data;
      var newState = this.stateReducer(oldState, { changes: changes, type: type });

      var isItemSelected = vue_combo_blocks_esm_hasOwnProperty(newState, 'selectedItem');
      var hasSelectedItemChanged = newState.selectedItem !== oldState.selectedItem;

      // Emit select and change events
      if (isItemSelected) {
        this.$emit('select', newState.selectedItem, type);
        // Only emit 'change' if selectedItem has changed
        if (hasSelectedItemChanged) {
          this.$emit('change', newState.selectedItem, type);
        }
      }

      var nextFullState = {};

      // eslint-disable-next-line no-restricted-syntax
      for (var prop in newState) {
        if (vue_combo_blocks_esm_hasOwnProperty(newState, prop)) {
          if (oldState[prop] !== newState[prop]) {
            nextFullState[prop] = newState[prop];
            this[prop] = nextFullState[prop];
            // Emit other events
            if (prop === 'inputValue') { this.$emit('input-value-change', newState[prop], type); }
            else if (prop === 'isOpen') { this.$emit('is-open-change', newState[prop], type); }
            else if (prop === 'hoveredIndex') { this.$emit('hovered-index-change', newState[prop], type); }
          }
        }
      }
      this.$emit('state-change', nextFullState, type);
    },
    getComboboxProps: function getComboboxProps() {
      return {
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': this.computedMenuId,
        'aria-expanded': this.isOpen ? 'true' : 'false',
      };
    },
    getInputProps: function getInputProps() {
      return {
        value: this.inputValue || '',
        'aria-activedescendant': this.hovered ? this.getItemId(this.hoveredIndex) : '',
        'aria-autocomplete': 'list',
        'aria-controls': this.computedMenuId,
        'aria-labelledby': this.computedLabelId,
        id: this.computedInputId,
        autocomplete: 'off',
      };
    },
    getMenuProps: function getMenuProps() {
      return {
        id: this.computedMenuId,
        role: 'listbox',
        'aria-labelledby': this.computedLabelId,
      };
    },
    getLabelProps: function getLabelProps() {
      return {
        id: this.computedLabelId,
        for: this.computedInputId,
      };
    },
    getInputEventListeners: function getInputEventListeners() {
      var vm = this;
      return {
        blur: vm.onInputBlur,
        input: vm.onInput,
        keydown: vm.onInputKeyDown,
        keyup: vm.onInputKeyUp,
      };
    },
    getMenuEventListeners: function getMenuEventListeners() {
      // const vm = this;
      return {
        mousedown: function mousedown(e) {
          // TODO: Prevent menu to close when clicking something
          // on a menu but not necessarily menu item.
          // This does the trick, but now you can't select and copy any text
          // in the menu.
          e.preventDefault();
        },
      };
    },
    getItemEventListeners: function getItemEventListeners(ref) {
      if ( ref === void 0 ) ref = {};
      var index = ref.index;
      var disabled = ref.disabled;
      var item = ref.item; if ( item === void 0 ) item =  true ? undefined
        : undefined;

      var itemIndex = getItemIndex(index, item, this.items);
      var vm = this;
      if (disabled) { return {}; }
      return {
        mousemove: function mousemove() {
          if (vm.hoveredIndex === itemIndex) { return; }
          vm.setState({
            hoveredIndex: itemIndex,
            hovered: item,
          }, ItemMouseMove);
        },
        mousedown: function mousedown(e) {
          e.preventDefault();
        },
        mouseleave: function mouseleave() {
          vm.setState({
            hoveredIndex: -1,
            hovered: null,
          }, ItemMouseLeave);
        },
        click: function click() {
          // e.preventDefault();
          vm.setState({
            inputValue: vm.itemToString(item),
            selectedItem: item,
            isOpen: false,
            hoveredIndex: -1,
            hovered: null,
          }, ItemClick);
        },
      };
    },
    getItemProps: function getItemProps(ref) {
      if ( ref === void 0 ) ref = {};
      var index = ref.index;
      var disabled = ref.disabled; if ( disabled === void 0 ) disabled = false;
      var item = ref.item; if ( item === void 0 ) item =  true ? undefined
        : undefined;

      var itemIndex = getItemIndex(index, item, this.items);
      var id = this.getItemId(itemIndex);
      return {
        id: id,
        disabled: disabled,
        role: 'option',
        'aria-selected': this.isHovered(itemIndex) || this.isSelected(itemIndex) ? 'true' : 'false',
      };
    },
    isSelected: function isSelected(index) {
      return index === this.selectedIndex;
    },
    isHovered: function isHovered(index) {
      return index === this.hoveredIndex;
    },
    autocompleteText: function autocompleteText(item) {
      this.setInputValue(this.itemToString(item));
    },
    reset: function reset() {
      this.setState({
        selectedItem: null,
        inputValue: '',
      }, FunctionReset);
    },
    select: function select(item) {
      this.setState({
        inputValue: this.itemToString(item),
        selectedItem: item,
        isOpen: false,
        hoveredIndex: -1,
        hovered: null,
      }, FunctionSelectItem);
    },
    setHoveredItem: function setHoveredItem(item, index, elem) {
      if (item && item !== this.hovered) {
        this.$emit('hover', item, elem);
      }
      this.hovered = item;
      this.hoveredIndex = typeof index === 'number' ? index : -1;
    },
    closeMenu: function closeMenu() {
      this.setState({
        isOpen: false,
        hoveredIndex: -1,
        hovered: null,
      }, FunctionCloseMenu);
    },
    openMenu: function openMenu() {
      this.setState({
        isOpen: true,
      }, FunctionOpenMenu);
    },
    getItemNodeFromIndex: function getItemNodeFromIndex(index) {
      return document.getElementById(this.getItemId(index));
    },
    scrollItemIntoView: function scrollItemIntoView(index) {
      var itemElement = this.$el.querySelector(("#" + (this.getItemId(index))));
      scrollToElement(itemElement, this.menuElement, index);
    },

    moveSelection: function moveSelection(e) {
      var this$1 = this;

      var itemCount = this.items.length;
      if (!this.isOpen || !itemCount) { return; }
      var isMovingDown = hasKeyCode(controls.arrowDownKey, e);
      var isMovingUp = hasKeyCode(controls.arrowUpKey, e);

      if (isMovingDown || isMovingUp) {
        e.preventDefault();
        var direction = isMovingDown * 2 - 1;
        var menuEdge = isMovingDown ? 0 : itemCount - 1;
        var hoversBetweenEdges = isMovingDown
          ? this.hoveredIndex < itemCount - 1
          : this.hoveredIndex > 0;

        var index = hoversBetweenEdges ? this.hoveredIndex + direction : menuEdge;
        var nextIndex = getNextNonDisabledIndex(
          direction,
          index,
          itemCount,
          this.getItemNodeFromIndex,
          true
        );
        var item = this.items[nextIndex];
        if (this.scrollIntoView) {
          this.$nextTick(function () {
            this$1.scrollItemIntoView(index);
          });
        }
        this.setState({
          hoveredIndex: nextIndex,
          hovered: item,
        }, isMovingDown ? InputKeyDownArrowDown : InputKeyDownArrowUp);
      }
    },
    onInputKeyDown: function onInputKeyDown(e) {
      // prevent form submit on keydown if Enter key registered in the keyup
      if (e.key === 'Enter' && this.isOpen) {
        e.preventDefault();
      // } else if (e.key === 'Tab' && this.hovered) {
      //   this.setState({
      //     inputValue: this.itemToString(this.hovered),
      //     selectedItem: this.hovered,
      //     isOpen: false,
      //   }, sct.InputKeyDownTab);
      } else if (hasKeyCode(controls.arrowDownKey, e) && !this.isOpen) {
        this.setState({ isOpen: true }, InputKeyDownArrowDown);
        this.moveSelection(e);
      } else { this.moveSelection(e); }
    },
    onInputKeyUp: function onInputKeyUp(e) {
      var enterKey = controls.enterKey;
      var escKey = controls.escKey;
      if (this.isOpen) {
        if (hasKeyCode(enterKey, e)) {
          if (this.hoveredIndex >= 0) {
            e.preventDefault();
            var itemNode = this.getItemNodeFromIndex(this.hoveredIndex);
            if (itemNode && itemNode.hasAttribute('disabled')) {
              return;
            }
            this.setState({
              inputValue: this.itemToString(this.hovered),
              selectedItem: this.hovered,
              hoveredIndex: -1,
              hovered: null,
              isOpen: false,
            }, InputKeyUpEnter);
          }
        } else if (hasKeyCode(escKey, e)) {
          this.setState({
            hoveredIndex: -1,
            hovered: null,
            isOpen: false,
          }, InputKeyUpEscape);
        }
      }
    },
    onInputBlur: function onInputBlur() {
      this.setState({
        isOpen: false,
        inputValue: this.itemToString(this.selectedItem),
        hovered: null,
        hoveredIndex: -1,
      }, InputBlur);
    },
    onInput: function onInput(e) {
      // Custom input component might return just the value
      var inputValue = e.target ? e.target.value : e;
      this.setState({
        inputValue: inputValue,
        hovered: null,
        isOpen: true,
      },
      InputChange);
    },
    setInputValue: function setInputValue(value) {
      if (this.inputValue === value) {
        return;
      }
      this.setState({
        inputValue: value,
      }, FunctionSetInputValue);
    },

  },
  render: function render() {
    return this.$scopedSlots.default({
      // prop getters
      getInputProps: this.getInputProps,
      getItemProps: this.getItemProps,
      getMenuProps: this.getMenuProps,
      getComboboxProps: this.getComboboxProps,
      getLabelProps: this.getLabelProps,

      // event listeners
      getInputEventListeners: this.getInputEventListeners,
      getMenuEventListeners: this.getMenuEventListeners,
      getItemEventListeners: this.getItemEventListeners,

      // state
      isOpen: this.isOpen,
      selectedItem: this.selectedItem,
      hoveredIndex: this.hoveredIndex,
      inputValue: this.inputValue,

      // actions
      reset: this.reset,
      select: this.select,
      setInputValue: this.setInputValue,
      openMenu: this.openMenu,
      closeMenu: this.closeMenu,
    });
  },
});

VueComboBlocks.stateChangeTypes = sct;

/* harmony default export */ var vue_combo_blocks_esm = (VueComboBlocks);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-destination-select.vue?vue&type=script&lang=js



/* harmony default export */ var hg_destination_selectvue_type_script_lang_js = ({
  components: {
    VueComboBlocks: vue_combo_blocks_esm,
  },
  props: {
    showMadeByGoogle: {
      type: Boolean,
      default: false,
    },
    isMobile: Boolean,
    label: String,
    noResult: String,
    placeholder: String,
    defaultValue: String,
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    teal: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    selected: null,
    isVisible: false,
  }),

  mounted() {
    if (this.defaultValue) {
      this.selected = {
        name: this.defaultValue,
      }
    }
  },

  methods: {
    async clickInput(e) {
      this.open()
      await this.$nextTick()
      if (this.isMobile) {
        this.$refs.mobileDestinationInput.focus()
      }
    },
    itemToString(item) {
      if (item && item.name) return item.name
      if (item && item.suggestion) return item.suggestion
      if (item && item.value) return item.value
      return item ? item.name : ''
    },
    open() {
      this.$refs.comboBlock.openMenu()
      this.isVisible = true
    },
    close() {
      // TODO: closeMenu does not work... WHY?
      this.$refs.comboBlock.closeMenu()
      this.isVisible = false
    },
    selectDestination(destination) {
      this.$emit('onSelectDestination', destination)
      this.close()
    },

    getIcon(category) {
      switch (category) {
        case 'Accommodation':
        case 'accommodation':
          return 'suitcase'
        case 'City':
        case 'city':
        case 'neighborhood':
          return 'building'
        case 'Poi':
        case 'point_of_interest':
          return 'star'
        default:
          return 'map-marker-alt'
      }
    },
    resetValue() {
      this.$refs.comboBlock.reset()
      this.close()
    },
    stateReducer(oldState, { changes, type }) {
      switch (type) {
        case this.isMobile && vue_combo_blocks_esm.stateChangeTypes.InputBlur:
        // return {
        //   ...changes,
        //   // isOpen: oldState.selectedItem ? false : true,
        //   isOpen: oldState.isOpen, // ? false : true,
        // }
        case this.isMobile && vue_combo_blocks_esm.stateChangeTypes.ItemClick:
          // case VueComboBlocks.stateChangeTypes.InputBlur:
          // case VueComboBlocks.stateChangeTypes.ItemClick:
          return {
            ...changes,
            isOpen: true, // changes.selectedItem ? false : true,
          }
        default:
          return changes
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-destination-select.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_destination_selectvue_type_script_lang_js = (hg_destination_selectvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-destination-select.vue?vue&type=style&index=0&id=2d72399a&prod&lang=postcss&scoped=true
var hg_destination_selectvue_type_style_index_0_id_2d72399a_prod_lang_postcss_scoped_true = __webpack_require__("e63a");

// CONCATENATED MODULE: ./src/components/inputs/hg-destination-select.vue






/* normalize component */

var hg_destination_select_component = normalizeComponent(
  inputs_hg_destination_selectvue_type_script_lang_js,
  hg_destination_selectvue_type_template_id_2d72399a_scoped_true_render,
  hg_destination_selectvue_type_template_id_2d72399a_scoped_true_staticRenderFns,
  false,
  null,
  "2d72399a",
  null
  
)

/* harmony default export */ var hg_destination_select = (hg_destination_select_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-airport-select.vue?vue&type=template&id=6a9e0f9e&scoped=true
var hg_airport_selectvue_type_template_id_6a9e0f9e_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`hg-airport${_vm.isMobile ? '--mobile' : ''} ${
    _vm.show && _vm.isMobile
      ? 'tw-fixed tw-top-0 tw-left-0 tw-bottom-0 tw-z-50'
      : 'tw-relative'
  }`},[_c('div',{class:`hg-airport__select${_vm.isMobile ? '--mobile' : ''}`},[_c('div',[(!_vm.isMobile || !_vm.show)?_c('label',{staticClass:"select__label",attrs:{"for":"select__input"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('input',{class:`select__input${_vm.isMobile && _vm.show ? '--show' : ''} ${
          _vm.allowHotjarRecord ? 'data-hj-allow' : ''
        } ${_vm.theme ? _vm.theme : ''}`,attrs:{"id":"select__input","name":"select__input","type":"text","placeholder":_vm.$t('ibeSearch.airportPlaceholder')},domProps:{"value":_vm.show ? _vm.queryString : _vm.inputPlaceholder},on:{"click":function($event){return _vm.isShown()},"keyup":function($event){_vm.queryString = $event.target.value},"focus":_vm.isShown}}),(!_vm.isMobile && _vm.show)?_c('svg',{class:`select__delete ${_vm.queryString === '' ? 'tw-hidden' : ''}`,attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){_vm.queryString = ''}}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 15.333A7.332 7.332 0 0 0 15.334 8 7.332 7.332 0 0 0 8 .667 7.332 7.332 0 0 0 .667 8 7.332 7.332 0 0 0 8 15.333zm0-1.419A5.912 5.912 0 0 1 2.086 8 5.912 5.912 0 0 1 8 2.086 5.912 5.912 0 0 1 13.914 8 5.912 5.912 0 0 1 8 13.914zm3.01-3.572-.668.668a.355.355 0 0 1-.502 0L8 9.171l-1.839 1.84a.355.355 0 0 1-.503 0l-.668-.669a.355.355 0 0 1 0-.503L6.83 8 4.99 6.16a.355.355 0 0 1 0-.502l.668-.668a.355.355 0 0 1 .503 0l1.84 1.84L9.84 4.99a.355.355 0 0 1 .502 0l.668.668a.355.355 0 0 1 0 .503L9.171 8l1.84 1.838a.355.355 0 0 1 0 .503z","fill":"#9D9D9D"}})]):_vm._e()]),(_vm.isMobile && _vm.show)?_c('div',{staticClass:"hg-airport__mobile-headline"},[_c('h2',{staticClass:"mobile-headline__headline"},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.airportLabel.without'))+" ")]),_c('svg',{staticClass:"mobile-headline__icon",attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.isNotShown()}}},[_c('path',{attrs:{"d":"m14.33 15.39 1.06-1.06a.375.375 0 0 0 0-.53L9.591 8 14.4 3.193l.991-.992a.375.375 0 0 0 0-.53L14.33.611a.375.375 0 0 0-.53 0L8 6.408 2.201.61a.375.375 0 0 0-.53 0L.61 1.672a.375.375 0 0 0 0 .53L6.41 8l-5.8 5.798a.375.375 0 0 0 0 .53l1.06 1.061a.375.375 0 0 0 .53 0L8 9.591l4.808 4.808.991.991a.375.375 0 0 0 .53 0z","fill":"#323231"}})])]):_vm._e(),(_vm.isMobile && _vm.show)?_c('div',{staticClass:"select--mobile",on:{"click":_vm.isShown}},[_c('input',{class:`select__input-mobile ${_vm.theme ? _vm.theme : ''}`,attrs:{"id":"select__input","name":"select__input","type":"text","placeholder":_vm.$t('ibeSearch.airportPlaceholder')},domProps:{"value":_vm.queryString},on:{"keyup":function($event){_vm.queryString = $event.target.value}}}),_c('svg',{class:`select__delete--mobile ${
          _vm.queryString === '' ? 'tw-hidden' : ''
        }`,attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){_vm.queryString = ''}}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 15.333A7.332 7.332 0 0 0 15.334 8 7.332 7.332 0 0 0 8 .667 7.332 7.332 0 0 0 .667 8 7.332 7.332 0 0 0 8 15.333zm0-1.419A5.912 5.912 0 0 1 2.086 8 5.912 5.912 0 0 1 8 2.086 5.912 5.912 0 0 1 13.914 8 5.912 5.912 0 0 1 8 13.914zm3.01-3.572-.668.668a.355.355 0 0 1-.502 0L8 9.171l-1.839 1.84a.355.355 0 0 1-.503 0l-.668-.669a.355.355 0 0 1 0-.503L6.83 8 4.99 6.16a.355.355 0 0 1 0-.502l.668-.668a.355.355 0 0 1 .503 0l1.84 1.84L9.84 4.99a.355.355 0 0 1 .502 0l.668.668a.355.355 0 0 1 0 .503L9.171 8l1.84 1.838a.355.355 0 0 1 0 .503z","fill":"#9D9D9D"}})])]):_vm._e()]),(_vm.show)?_c('div',{class:`hg-airport__results${_vm.isMobile ? '--mobile' : ''}`},[(_vm.show)?_c('div',{class:`hg-airport__select-results${_vm.isMobile ? '--mobile' : ''} ${
        _vm.searchAirports.length <= 0 && _vm.queryString !== ''
          ? 'tw-pb-0'
          : 'tw-pb-20'
      }`},[(_vm.selectedAirports.length > 0)?_c('div',{staticClass:"select-results__selection-tags"},_vm._l((_vm.selectedAirports),function(airport){return _c('button',{key:airport.iataCode,class:`selection-tags__tag ${_vm.theme ? _vm.theme : ''}`,on:{"click":function($event){return _vm.selectSearchedAirport(airport)}}},[_c('svg',{staticClass:"tw-block tw-my-auto",attrs:{"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m8.36 9.02.645-.645a.412.412 0 0 0 0-.582L6.227 5.016 9.004 2.24a.412.412 0 0 0 0-.582l-.645-.645a.412.412 0 0 0-.582 0L5 3.789 2.223 1.012a.412.412 0 0 0-.582 0l-.646.645a.412.412 0 0 0 0 .582l2.778 2.777L.995 7.793a.412.412 0 0 0 0 .582l.646.646c.16.16.421.16.582 0L5 6.243 7.777 9.02c.16.161.421.161.582 0z","fill":_vm.iconColor}})]),_c('p',{staticClass:"tw-m-0"},[_vm._v(_vm._s(airport.iataCode))])])}),0):_vm._e(),(
          _vm.sortedAirports.find((airport) =>
            _vm.filterAirports(airport.iataCode)
          ) && _vm.queryString === ''
        )?_c('div',[_c('h3',{class:`hg-airport__subheadline ${_vm.theme ? _vm.theme : ''}`},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.favoriteAirport'))+" ")]),_vm._l((_vm.sortedAirports),function(airport){return (_vm.filterAirports(airport.iataCode))?_c('button',{key:airport.iataCode,staticClass:"airport-item",on:{"click":function($event){return _vm.selectSearchedAirport(airport)}}},[_c('span',{staticClass:"hg-airport__list-element"},[_c('div',[_c('div',{class:`hg-airport__checkbox ${
                  _vm.selectedAirports.filter((el) => el.name === airport.name)
                    .length > 0
                    ? 'tw-hidden'
                    : ''
                }`}),_c('svg',{class:`hg-airport__checkbox__svg ${
                  _vm.selectedAirports.filter((el) => el.name === airport.name)
                    .length > 0
                    ? ''
                    : 'tw-hidden'
                }`,attrs:{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":".5","width":"16","height":"16","rx":"4","fill":_vm.checkboxBackgroundColor}}),_c('path',{attrs:{"d":"m6.834 11.552 6.495-6.495a.26.26 0 0 0 0-.368l-.613-.613a.26.26 0 0 0-.367 0L6.65 9.775 4.557 7.68a.26.26 0 0 0-.368 0l-.613.612a.26.26 0 0 0 0 .368l2.89 2.89a.26.26 0 0 0 .368 0z","fill":_vm.iconColor}})])]),_c('div',{staticClass:"hg-airport__list-element--desciption"},[_c('p',{staticClass:"hg-airport__list-element--desciption--name"},[_vm._v(" "+_vm._s(airport.name + ', ' + airport.location.address.country)+" ")]),_c('p',{staticClass:"hg-airport__list-element--desciption--code"},[_vm._v(" "+_vm._s(airport.iataCode)+" ")])])])]):_vm._e()})],2):_vm._e(),(_vm.queryString === '')?_c('div',[_c('h3',{class:`hg-airport__subheadline ${_vm.theme ? _vm.theme : ''}`},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.airportOverview'))+" ")]),_vm._l((_vm.sortedAirports),function(airport){return _c('button',{key:airport.iataCode,staticClass:"airport-item",on:{"click":function($event){return _vm.selectSearchedAirport(airport)}}},[_c('span',{staticClass:"hg-airport__list-element"},[_c('div',[_c('div',{class:`hg-airport__checkbox ${
                  _vm.selectedAirports.filter((el) => el.name === airport.name)
                    .length > 0
                    ? 'tw-hidden'
                    : ''
                }`}),_c('svg',{class:`hg-airport__checkbox__svg ${
                  _vm.selectedAirports.filter((el) => el.name === airport.name)
                    .length > 0
                    ? ''
                    : 'tw-hidden'
                }`,attrs:{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":".5","width":"16","height":"16","rx":"4","fill":_vm.checkboxBackgroundColor}}),_c('path',{attrs:{"d":"m6.834 11.552 6.495-6.495a.26.26 0 0 0 0-.368l-.613-.613a.26.26 0 0 0-.367 0L6.65 9.775 4.557 7.68a.26.26 0 0 0-.368 0l-.613.612a.26.26 0 0 0 0 .368l2.89 2.89a.26.26 0 0 0 .368 0z","fill":_vm.iconColor}})])]),_c('div',{staticClass:"hg-airport__list-element--desciption"},[_c('p',{staticClass:"hg-airport__list-element--desciption--name"},[_vm._v(" "+_vm._s(airport.name + ', ' + airport.location.address.country)+" ")]),_c('p',{staticClass:"hg-airport__list-element--desciption--code"},[_vm._v(" "+_vm._s(airport.iataCode)+" ")])])])])})],2):_vm._e(),(_vm.queryString !== '')?_c('div',{staticClass:"hg-airport__search"},[_vm._l((_vm.searchAirports),function(airport){return _c('button',{key:airport.iataCode,staticClass:"airport-item",on:{"click":function($event){return _vm.selectSearchedAirport(airport)}}},[_c('span',{staticClass:"hg-airport__list-element"},[_c('div',[_c('div',{class:`hg-airport__checkbox ${
                  _vm.selectedAirports.filter((el) => el.name === airport.name)
                    .length > 0
                    ? 'tw-hidden'
                    : ''
                }`}),_c('svg',{class:`hg-airport__checkbox__svg ${
                  _vm.selectedAirports.filter((el) => el.name === airport.name)
                    .length > 0
                    ? ''
                    : 'tw-hidden'
                }`,attrs:{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":".5","width":"16","height":"16","rx":"4","fill":_vm.checkboxBackgroundColor}}),_c('path',{attrs:{"d":"m6.834 11.552 6.495-6.495a.26.26 0 0 0 0-.368l-.613-.613a.26.26 0 0 0-.367 0L6.65 9.775 4.557 7.68a.26.26 0 0 0-.368 0l-.613.612a.26.26 0 0 0 0 .368l2.89 2.89a.26.26 0 0 0 .368 0z","fill":_vm.iconColor}})])]),_c('div',{staticClass:"hg-airport__list-element--desciption"},[_c('p',{staticClass:"hg-airport__list-element--desciption--name"},[_vm._v(" "+_vm._s(airport.name + ', ' + airport.location.address.country)+" ")]),_c('p',{staticClass:"hg-airport__list-element--desciption--code"},[_vm._v(" "+_vm._s(airport.iataCode)+" ")])])])])}),(_vm.airportEmpty())?_c('div',[_c('div',{staticClass:"search__no-result"},[_c('NoResultSvg',{staticClass:"no-results__img"}),_c('h2',{staticClass:"no-results__heading"},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.noMatch'))+" ")]),_c('p',{staticClass:"no-results__description-one"},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.noMatchSubtitle'))+" ")]),_c('p',{staticClass:"no-results__description-two"},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.noMatchSubtitle2'))+" ")])],1)]):_vm._e()],2):_vm._e()]):_vm._e(),(_vm.show && (!_vm.airportEmpty() || _vm.selectedAirports.length > 0))?_c('div',{class:`hg-airport__checkout${_vm.isMobile ? '--mobile' : ''}`},[_c('button',{class:`checkout__button${_vm.isMobile ? '--mobile' : ''} ${
          _vm.theme ? _vm.theme : ''
        }`,on:{"click":function($event){_vm.checkout()
          _vm.isNotShown()}}},[_vm._v(" "+_vm._s(_vm.$t('inputs.buttonTextApply'))+" ")])]):_vm._e()]):_vm._e()])
}
var hg_airport_selectvue_type_template_id_6a9e0f9e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-airport-select.vue?vue&type=template&id=6a9e0f9e&scoped=true

// CONCATENATED MODULE: ./src/mixins/clickAwayMixin.js
/* harmony default export */ var clickAwayMixin = ({
  mounted() {
    this.addClickaway()
  },
  onBeforeUnmount() {
    document.removeEventListener('click', this.onClickout)
  },

  methods: {
    onClickout(event) {
      if (!event.composedPath().includes(this.$el)) {
        this.isNotShown()
      }
    },
    addClickaway() {
      document.addEventListener('click', this.onClickout)
    },
  },
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-airport-select.vue?vue&type=script&lang=js



const favoritsDe = ['DUS', 'FRA', 'MUC', 'CGN', 'BER']
const favoritsNl = ['AMS', 'EIN', 'RTM', 'DUS', 'BRU', 'CGN', 'FMO']
const favoritsEs = ['BCN', 'MAD', 'SVQ', 'AGP', 'VLC']
const favoritsAT = ['VIE', 'MUC', 'SZG']
const favoritsCH = ['ZRH', 'BSL', 'MUC']

/* harmony default export */ var hg_airport_selectvue_type_script_lang_js = ({
  mixins: [clickAwayMixin],

  props: {
    label: String,
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    searchedAirports: {
      type: Array,
      required: true,
    },
    airports: {
      type: Array,
      required: true,
    },
    singleAirport: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    selectedAirports: [],
    show: false,
    inputPlaceholder: '',
    queryString: '',
    sortedAirports: [],
    timeoutRunning: false,
    searchAirports: [],
    lang: 'de',
  }),

  computed: {
    iconColor() {
      if (this.theme == "5vf") {
        return "white"
      }

      return "#323231"
    },
    checkboxBackgroundColor() {
      switch (this.theme) {
        case "5vf":
          return "#0a91ed"
        case "bild":
          return "#09de85"
        default:
          return "#00D5E0"
      }
    }
  },

  mounted() {
    this.addCloseOnKey()
    this.lang = this.$i18n.locale
  },

  onBeforeUnmount() {
    document.removeEventListener('click', this.closeOnKey)
  },

  watch: {
    selectedAirports: {
      handler(val, oldVal) {
        if (this.selectedAirports.length > 0) {
          this.inputPlaceholder = `${this.$i18n.t('from')} ${
            this.selectedAirports[0].iataCode
          } ${this.selectedAirports.length > 1 ? '+' : ''}${
            this.selectedAirports.length > 1
              ? this.selectedAirports.length - 1
              : ''
          }`
          this.queryString = ''
        } else {
          this.inputPlaceholder = ''
          this.queryString = ''
        }
      },
      deep: true,
    },

    airports() {
      this.searchAirports = this.airports
      this.sortedAirports = [...this.airports]
      this.sortedAirports.sort((a, b) => {
        if (a.name < b.name) {
          return -1
        }
        if (a.name > b.name) {
          return 1
        }
        return 0
      })
    },

    queryString() {
      this.search()
    },

    searchedAirports() {
      this.searchAirports = this.searchedAirports
    },
  },

  methods: {
    addCloseOnKey() {
      document.addEventListener('keyup', this.closeOnKey)
    },

    closeOnKey(e) {
      if (e.key === 'Escape') {
        this.isNotShown()
      }
    },

    airportEmpty() {
      if (this.searchAirports.length <= 0 && this.queryString !== '')
        return true
      return false
    },

    selectSearchedAirport(airport) {
      if (!this.singleAirport) {
        this.selectedAirports.filter((el) => el.name === airport.name).length >
        0
          ? this.selectedAirports.splice(
              this.selectedAirports.indexOf(airport),
              1
            )
          : this.selectedAirports.push(airport)

        this.checkout()
      } else {
        this.selectedAirports = [airport]
        this.checkout()
      }
    },

    search() {
      const timeout = setTimeout(() => {
        this.$emit('onChangeAirportTerm', this.queryString)
        this.timeoutRunning = false
      }, 250)

      if (this.timeoutRunning) {
        clearTimeout(timeout)
      } else {
        this.timeoutRunning = true
        timeout
      }
    },

    isShown() {
      this.show = true
    },
    isNotShown() {
      this.show = false
    },

    checkout() {
      this.$emit('onSelectAirports', this.selectedAirports)
    },

    filterAirports(iataCode) {
      switch (this.lang) {
        case 'de':
          return favoritsDe.includes(iataCode)

        case 'nl':
          return favoritsNl.includes(iataCode)

        case 'es':
          return favoritsEs.includes(iataCode)

        case 'at':
          return favoritsAT.includes(iataCode)

        case 'ch':
          return favoritsCH.includes(iataCode)

        default:
          return favoritsDe.includes(iataCode)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-airport-select.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_airport_selectvue_type_script_lang_js = (hg_airport_selectvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-airport-select.vue?vue&type=style&index=0&id=6a9e0f9e&prod&scoped=true&lang=postcss
var hg_airport_selectvue_type_style_index_0_id_6a9e0f9e_prod_scoped_true_lang_postcss = __webpack_require__("c810");

// CONCATENATED MODULE: ./src/components/inputs/hg-airport-select.vue






/* normalize component */

var hg_airport_select_component = normalizeComponent(
  inputs_hg_airport_selectvue_type_script_lang_js,
  hg_airport_selectvue_type_template_id_6a9e0f9e_scoped_true_render,
  hg_airport_selectvue_type_template_id_6a9e0f9e_scoped_true_staticRenderFns,
  false,
  null,
  "6a9e0f9e",
  null
  
)

/* harmony default export */ var hg_airport_select = (hg_airport_select_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-travel-duration-select.vue?vue&type=template&id=36791838&scoped=true
var hg_travel_duration_selectvue_type_template_id_36791838_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options)?_c('vue-combo-blocks',{ref:"comboBlock",staticClass:"hg-duration-select field duration",attrs:{"itemToString":_vm.itemToString,"items":_vm.options,"stateReducer":_vm.stateReducer},on:{"input-value-change":_vm.updateValue,"select":function($event){return _vm.$emit('onSelectTravelDuration', arguments[0])}},scopedSlots:_vm._u([{key:"default",fn:function({
    getInputProps,
    getInputEventListeners,
    hoveredIndex,
    isOpen,
    getMenuProps,
    getMenuEventListeners,
    getItemProps,
    getItemEventListeners,
    getComboboxProps,
  }){return [_c('div',_vm._b({},'div',getComboboxProps(),false),[_c('div',{staticClass:"hg-control label-position--inside"},[_c('label',{staticClass:"label",attrs:{"id":"hg-travel-duration-label","for":"hg-travel-duration-input"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('input',_vm._g(_vm._b({class:`hg-input hg-input--teal ${_vm.theme ? _vm.theme : ''}`,attrs:{"id":"hg-travel-duration-input","name":"hg-travel-duration-input","readonly":"","placeholder":_vm.placeholder,"aria-labelledby":"hg-travel-duration-label"},on:{"click":_vm.open,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"]))return null;return _vm.open.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.open.apply(null, arguments)}]}},'input',getInputProps(),false),getInputEventListeners()))]),(isOpen && _vm.isShown)?_c('div',_vm._g(_vm._b({ref:"selectMenu",staticClass:"hg-select-menu-wrapper",class:_vm.isMobile
          ? 'hg-select-menu-wrapper--mobile'
          : 'hg-select-menu-wrapper--desktop'},'div',getMenuProps(),false),getMenuEventListeners()),[_c(_vm.isMobile && isOpen
            ? 'HgPortalDropdownMobile'
            : 'HgPortalDropdownDesktop',{tag:"component",attrs:{"theme":_vm.theme,"padding":false},on:{"close":_vm.close,"reset":_vm.resetValue},scopedSlots:_vm._u([{key:"header-field",fn:function(){return [_c('div',{staticClass:"hg-control"},[_c('input',_vm._g(_vm._b({class:`hg-input ${_vm.theme ? _vm.theme : ''}`,attrs:{"id":"hg-travel-duration-input","readonly":"","placeholder":_vm.placeholder}},'input',getInputProps(),false),getInputEventListeners()))])]},proxy:true},{key:"message",fn:function(){return [(_vm.showError)?_c('hg-form-errors',[_c('div',[_vm._v("Der gewählte Reisezeitraum passt nicht zur Reisedauer")])]):_vm._e()]},proxy:true},{key:"content-2",fn:function(){return [_c('div',_vm._g(_vm._b({staticClass:"hg-select-menu"},'div',getMenuProps(),false),getMenuEventListeners()),[(_vm.options)?[_c('div',{staticClass:"tw-px-2 tw-py-4 tw-mb-2"},_vm._l((_vm.options),function(item,index){return _c('div',_vm._g(_vm._b({key:index,class:[
                    'hg-select-option',
                    hoveredIndex === index && 'hg-select-option--hovered',
                    _vm.selected &&
                      _vm.selected.value === item.value &&
                      'hg-select-option--selected',
                    _vm.theme ? _vm.theme : '',
                  ]},'div',getItemProps({ item, index }),false),getItemEventListeners({ item, index })),[_c('div',[_vm._v(" "+_vm._s(item.name)+" ")])])}),0)]:_vm._e()],2)]},proxy:true}],null,true)},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1):_vm._e()])]}}],null,false,4228944412),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()
}
var hg_travel_duration_selectvue_type_template_id_36791838_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-travel-duration-select.vue?vue&type=template&id=36791838&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-travel-duration-select.vue?vue&type=script&lang=js



/* harmony default export */ var hg_travel_duration_selectvue_type_script_lang_js = ({
  components: {
    VueComboBlocks: vue_combo_blocks_esm,
  },
  props: {
    prev: String,
    options: Array,
    defaultValue: String,
    isMobile: Boolean,
    placeholder: String,
    label: String,
    showError: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selected: null,
      isShown: false,
    }
  },
  mounted() {
    if (this.defaultValue != null) {
      this.selected = this.options.find(
        (item) => item.value == this.defaultValue
      )
    }
  },

  methods: {
    open() {
      this.$refs.comboBlock.openMenu()
      this.isShown = true
    },
    close() {
      this.$refs.comboBlock.closeMenu()
      this.isShown = false
    },

    reset() {
      this.selected = this.options.find((item) => item.value === 'exact')
    },
    resetValue() {
      this.selected = this.options.find((item) => item.value === 'exact')
      this.close()
    },
    updateValue() {
      this.$emit('onUpdateTravelDuration', arguments[0])
      if (this.isMobile) this.close()
    },

    itemToString(item) {
      return item ? item.name : ''
    },
    stateReducer(oldState, { changes, type }) {
      switch (type) {
        case this.isMobile && vue_combo_blocks_esm.stateChangeTypes.InputBlur:
        case this.isMobile && vue_combo_blocks_esm.stateChangeTypes.ItemClick:
          // case VueComboBlocks.stateChangeTypes.InputBlur:
          // case VueComboBlocks.stateChangeTypes.ItemClick:
          return {
            ...changes,
            isOpen: true,
          }
        default:
          return changes
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-travel-duration-select.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_travel_duration_selectvue_type_script_lang_js = (hg_travel_duration_selectvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-travel-duration-select.vue?vue&type=style&index=0&id=36791838&prod&lang=postcss&scoped=true
var hg_travel_duration_selectvue_type_style_index_0_id_36791838_prod_lang_postcss_scoped_true = __webpack_require__("786f");

// CONCATENATED MODULE: ./src/components/inputs/hg-travel-duration-select.vue






/* normalize component */

var hg_travel_duration_select_component = normalizeComponent(
  inputs_hg_travel_duration_selectvue_type_script_lang_js,
  hg_travel_duration_selectvue_type_template_id_36791838_scoped_true_render,
  hg_travel_duration_selectvue_type_template_id_36791838_scoped_true_staticRenderFns,
  false,
  null,
  "36791838",
  null
  
)

/* harmony default export */ var hg_travel_duration_select = (hg_travel_duration_select_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-zip-code-input.vue?vue&type=template&id=bedcabe8
var hg_zip_code_inputvue_type_template_id_bedcabe8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-combo-blocks',{ref:"comboBlock",staticClass:"hg-zip-code-input",attrs:{"itemToString":_vm.itemToString,"items":_vm.options},on:{"input-value-change":function($event){return _vm.$emit('onChangeLocation', arguments[0])},"select":function($event){return _vm.$emit('onSelectLocation', arguments[0])}},scopedSlots:_vm._u([{key:"default",fn:function({
    reset,
    isOpen,
    hoveredIndex,
    getComboboxProps,
    getInputProps,
    getInputEventListeners,
    getMenuProps,
    getMenuEventListeners,
    getItemProps,
    getItemEventListeners,
  }){return [_c('div',_vm._b({},'div',getComboboxProps(),false),[_c('ValidationProvider',{class:[
        'hg-control',
        'label-position--inside',
        _vm.disabled && 'hg-control--disabled',
      ],attrs:{"vid":"zip-code-input","name":"zip-code-input","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function({ errors, valid }){return [_c('label',{attrs:{"for":"hg-destination-input"}},[_vm._v(" "+_vm._s(_vm.$t('locationSelect'))+" ")]),_c('input',_vm._g(_vm._b({class:[
          'hg-input',
        _vm.teal ? 'hg-input--teal-border' : '',
        { 'hg-input--transparent': _vm.transparent }
    ],attrs:{"id":"hg-zip-code-input","placeholder":_vm.placeholder},on:{"click":_vm.clickInput}},'input',getInputProps(),false),getInputEventListeners())),_c('button',{staticClass:"hg-input-clear hg-button",attrs:{"type":"button","role":"button"},on:{"click":reset}},[_c('hg-icon',{attrs:{"name":"times","size":"small"}})],1),(errors && errors.length)?_c('span',{staticClass:"error-message"},[_vm._v(" "+_vm._s(errors[0])+" ")]):_vm._e()]}}],null,true)}),_c('transition',{attrs:{"name":"hg-menu-fade","mode":"in-out"}},[_c('div',{staticClass:"hg-select-menu-wrapper"},[_c('ul',_vm._g(_vm._b({directives:[{name:"show",rawName:"v-show",value:(isOpen),expression:"isOpen"}],staticClass:"hg-select-menu"},'ul',getMenuProps(),false),getMenuEventListeners()),[(_vm.options.length)?_vm._l((_vm.options),function(item,index){return _c('li',_vm._g(_vm._b({key:index,class:[
                'hg-select-option',
                hoveredIndex === index && 'hg-select-option--hovered',
                _vm.selected &&
                  _vm.selected.id === item.id &&
                  'hg-select-option--selected',
              ]},'li',getItemProps({ item, index }),false),getItemEventListeners({ item, index })),[_c('span',[_vm._v(" "+_vm._s(item.formatted)+" ")])])}):_c('li',{staticClass:"hg-select-option hg-select-option--default"},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.noResults'))+" ")])],2)])])],1)]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var hg_zip_code_inputvue_type_template_id_bedcabe8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-zip-code-input.vue?vue&type=template&id=bedcabe8

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-zip-code-input.vue?vue&type=script&lang=js



/* harmony default export */ var hg_zip_code_inputvue_type_script_lang_js = ({
  components: {
    VueComboBlocks: vue_combo_blocks_esm,
  },
  props: {
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    initialLocation: {
      type: Object,
      default: () => {},
    },
    teal: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.initialLocation) {
      this.selected = this.initialLocation
    }
  },
  data: () => ({
    selected: null,
  }),
  methods: {
    clickInput() {
      this.$refs.comboBlock.openMenu()
    },
    itemToString(item) {
      return item && item.address ? item.address.postcode : ''
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-zip-code-input.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_zip_code_inputvue_type_script_lang_js = (hg_zip_code_inputvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/inputs/hg-zip-code-input.vue





/* normalize component */

var hg_zip_code_input_component = normalizeComponent(
  inputs_hg_zip_code_inputvue_type_script_lang_js,
  hg_zip_code_inputvue_type_template_id_bedcabe8_render,
  hg_zip_code_inputvue_type_template_id_bedcabe8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_zip_code_input = (hg_zip_code_input_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-numeric-input.vue?vue&type=template&id=3447bf08&scoped=true
var hg_numeric_inputvue_type_template_id_3447bf08_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"numeric-input"},[_c('div',{staticClass:"numeric-input-field",class:{ small: _vm.size }},[_c('HgButton',{staticClass:"btn btn-decrement",attrs:{"color":_vm.submitButtonColor,"rounded":false,"size":"small","disabled":_vm.val <= _vm.min || _vm.disabled || _vm.val == _vm.validOptions[0],"title":"decrement"},on:{"onClick":() => _vm.countDown()}},[_c('hg-icon',{attrs:{"name":"minus","pack":"fal","aria-hidden":"true"}})],1),_c('div',{staticClass:"hg-control",class:`label-position--${_vm.labelPosition}`},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],class:[
          'hg-input hg-numeric-input',
          _vm.disabled === true ? 'hg-input--disabled' : '',
          _vm.teal ? 'hg-input--teal-border' : '',
          _vm.readonly ? 'hg-input--readonly' : '',
          _vm.theme ? _vm.theme : '',
        ],attrs:{"type":"number","name":_vm.name,"max":_vm.max,"min":_vm.min,"id":_vm.id,"disabled":_vm.disabled,"readonly":_vm.readonly || _vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":(_vm.val)},on:{"input":function($event){if($event.target.composing)return;_vm.val=$event.target.value}}})]),_c('HgButton',{staticClass:"btn btn-increment",attrs:{"color":_vm.submitButtonColor,"rounded":false,"size":"small","disabled":_vm.val >= _vm.max || _vm.disabled || _vm.val == _vm.validOptions[_vm.validOptions.length - 1],"title":"increment"},on:{"onClick":() => _vm.countUp()}},[_c('hg-icon',{attrs:{"name":"plus","pack":"fal","aria-hidden":"true"}})],1)],1)])
}
var hg_numeric_inputvue_type_template_id_3447bf08_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-numeric-input.vue?vue&type=template&id=3447bf08&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-numeric-input.vue?vue&type=script&lang=js

let count = 1
/* harmony default export */ var hg_numeric_inputvue_type_script_lang_js = ({
  props: {
    min: {
      default: 0,
      type: Number,
    },
    name: {
      type: String,
      default: 'numeric-input',
    },
    max: {
      default: 4,
      type: Number,
    },

    id: {
      type: String,
      default: '',
    },
    placeholder: {
      default: '',
      type: String,
    },
    teal: {
      type: Boolean,
      default: true,
    },
    labelPosition: {
      type: String,
      default: 'inside',
    },
    value: {
      type: [String, Number],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'small',
    },
    label: String,
    validOptions: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      val: this.value,
    }
  },
  mounted() {
    count++
  },

  computed: {
    componentId() {
      return `numeric-${count++}`
    },
    submitButtonColor() {
      switch (this.theme) {
        case 'bild':
          return 'bild-green'
        case '5vf':
          return '5vf'
        default:
          return 'teal'
      }
    },
  },

  watch: {
    value(nv) {
      this.val = nv
    },
    val(nv, ov) {
      if (nv !== ov) {
        this.$emit('input', nv)
      }
    },
  },

  methods: {
    countUp() {
      if (this.validOptions.length > 0) {
        var index = this.validOptions.findIndex(el => el == this.val)

        if (index == this.validOptions.length - 1) return

        this.val = this.validOptions[index + 1]

        return
      }

      if (this.val < this.max) {
        this.val++
      }
    },
    countDown() {
      if (this.validOptions.length > 0) {
        var index = this.validOptions.findIndex(el => el == this.val)

        if (index == 0) return

        this.val = this.validOptions[index - 1]
      } else if (this.val > this.min) {
        this.val--
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-numeric-input.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_numeric_inputvue_type_script_lang_js = (hg_numeric_inputvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-numeric-input.vue?vue&type=style&index=0&id=3447bf08&prod&scoped=true&lang=css
var hg_numeric_inputvue_type_style_index_0_id_3447bf08_prod_scoped_true_lang_css = __webpack_require__("6657");

// CONCATENATED MODULE: ./src/components/inputs/hg-numeric-input.vue






/* normalize component */

var hg_numeric_input_component = normalizeComponent(
  inputs_hg_numeric_inputvue_type_script_lang_js,
  hg_numeric_inputvue_type_template_id_3447bf08_scoped_true_render,
  hg_numeric_inputvue_type_template_id_3447bf08_scoped_true_staticRenderFns,
  false,
  null,
  "3447bf08",
  null
  
)

/* harmony default export */ var hg_numeric_input = (hg_numeric_input_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-travelers.vue?vue&type=template&id=879517a4&scoped=true
var hg_travelersvue_type_template_id_879517a4_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-control input-wrapper input-wrapper--travelers hg-travelers",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"]))return null;return _vm.close.apply(null, arguments)}}},[_c('div',[_c('HgDropdown',{ref:"dropdownRef",attrs:{"isInsidePortal":_vm.isMobile && _vm.dropDownActive,"dropdownStyle":"input","hasDropdownChevron":false,"theme":_vm.theme},on:{"dropdownChange":function($event){_vm.dropDownActive = $event}},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{staticClass:"hg-control hg-control--travelers label-position--inside"},[(_vm.label !== '')?_c('label',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),(_vm.travelerString)?[_c('span',{class:['content', _vm.placeholderColor && 'hg-text--color']},[_vm._v(" "+_vm._s(_vm.travelerString)+" ")])]:[_c('span',{staticClass:"hg-datepicker__placeholder content"},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")])]],2)]},proxy:true}])},[_c(_vm.isMobile && _vm.dropDownActive
            ? 'HgPortalDropdownMobile'
            : 'HgPortalDropdownDesktop',{tag:"component",attrs:{"theme":_vm.theme},on:{"close":_vm.close,"reset":_vm.reset},scopedSlots:_vm._u([{key:"header-field",fn:function(){return [(_vm.isMobile && _vm.dropDownActive)?_c('button',{class:`hg-input ${_vm.theme ? _vm.theme : ''}`},[(_vm.travelerString)?[_c('span',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.travelerString)+" ")])]:[_c('span',{staticClass:"hg-datepicker__placeholder content"},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")])]],2):_vm._e()]},proxy:true},{key:"message",fn:function(){return undefined},proxy:true},{key:"content-1",fn:function(){return [_c('HgNumericInput',{attrs:{"max":parseFloat(_vm.maxAdults),"min":1,"label":_vm.locale.adults,"labelPosition":'outside',"size":'small',"teal":true,"theme":_vm.theme},on:{"input":function($event){_vm.adults = +$event}},model:{value:(_vm.adults),callback:function ($$v) {_vm.adults=$$v},expression:"adults"}}),_c('HgNumericInput',{attrs:{"max":parseFloat(_vm.maxChildren),"label":_vm.locale.children,"labelPosition":'outside',"size":'small',"teal":true,"theme":_vm.theme},on:{"input":function($event){_vm.children = +$event}},model:{value:(_vm.children),callback:function ($$v) {_vm.children=$$v},expression:"children"}}),(_vm.showRooms)?_c('HgNumericInput',{attrs:{"max":99,"label":_vm.locale.roomLabel,"labelPosition":'outside',"size":'small',"teal":true,"validOptions":_vm.validRooms,"readonly":true,"theme":_vm.theme},on:{"input":function($event){_vm.rooms = +$event}},model:{value:(_vm.rooms),callback:function ($$v) {_vm.rooms=$$v},expression:"rooms"}}):_vm._e(),(_vm.showErrors)?[(_vm.errorMessage !== '')?_c('hg-form-errors',{attrs:{"message":true,"size":"small","theme":_vm.theme}},[_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}}),_c('br'),_c('a',{class:`support-phone-link ${_vm.theme ? _vm.theme : ''}`,attrs:{"href":`tel:${_vm.locale.travelerSupportTel}`}},[_vm._v(" "+_vm._s(_vm.locale.travelerSupportTel)+" ")]),_c('span',{staticClass:"tw-ml-1"},[_vm._v(_vm._s(_vm.locale.travelerSupportTelHours))])])]):_vm._e()]:_vm._e()]},proxy:true},{key:"content-2",fn:function(){return [(_vm.children)?_c('span',{staticClass:"section-label"},[_vm._v(" "+_vm._s(_vm.locale.travelerChildAgeLabel)+" ")]):_vm._e(),_c('div',{staticClass:"age-select-wrapper"},_vm._l((_vm.children),function(child,index){return _c('div',{key:'child-' + index,staticClass:"hg-control label-position--inside age-select-input"},[_c('label',{attrs:{"for":`child-${index}`}},[_vm._v(" "+_vm._s(index + 1 + '. ' + _vm.locale.child)+" ")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ages[index]),expression:"ages[index]"}],class:`hg-select age-select ${_vm.theme ? _vm.theme : ''}`,attrs:{"required":"","name":`child-${index + 1}`,"id":`child-${index + 1}`},on:{"input":_vm.selectAge,"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.ages, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeAge($event, index)}]}},_vm._l((_vm.ageOptions),function(option){return _c('option',{key:option.value,domProps:{"value":option.value,"selected":option.value === _vm.ages[index]}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)])}),0)]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)],1)])
}
var hg_travelersvue_type_template_id_879517a4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-travelers.vue?vue&type=template&id=879517a4&scoped=true

// CONCATENATED MODULE: ./src/utils/helpers.js
function isVueComponent(c) {
  return c && c._isVue
}

/**
 * Merge function to replace Object.assign with deep merging possibility
 */
const isObject = (item) => typeof item === 'object' && !Array.isArray(item)
const mergeFn = (target, source, deep = false) => {
  if (deep || !Object.assign) {
    const isDeep = (prop) =>
      isObject(source[prop]) &&
      target !== null &&
      target.hasOwnProperty(prop) &&
      isObject(target[prop])
    const replaced = Object.getOwnPropertyNames(source)
      .map((prop) => ({
        [prop]: isDeep(prop)
          ? mergeFn(target[prop], source[prop], deep)
          : source[prop],
      }))
      .reduce((a, b) => ({ ...a, ...b }), {})

    return {
      ...target,
      ...replaced,
    }
  } else {
    return Object.assign(target, source)
  }
}
const merge = mergeFn

/**
 * Return month names according to a specified locale
 * @param  {String} locale A bcp47 localerouter. undefined will use the user browser locale
 * @param  {String} format long (ex. March), short (ex. Mar) or narrow (M)
 * @return {Array<String>} An array of month names
 */
function getMonthNames(locale = undefined, format = 'long') {
  const dates = []
  for (let i = 0; i < 12; i++) {
    dates.push(new Date(2000, i, 15))
  }
  const dtf = new Intl.DateTimeFormat(locale, {
    month: format,
    timeZone: 'UTC',
  })
  return dates.map((d) => dtf.format(d))
}

/**
 * Return weekday names according to a specified locale
 * @param  {String} locale A bcp47 localerouter. undefined will use the user browser locale
 * @param  {Number} first day of week index
 * @param  {String} format long (ex. Thursday), short (ex. Thu) or narrow (T)
 * @return {Array<String>} An array of weekday names
 */
function getWeekdayNames(locale = undefined, format = 'narrow') {
  const dates = []
  const dt = new Date(2000, 0, 1)
  const dayOfWeek = dt.getDay()
  dt.setDate(dt.getDate() - dayOfWeek)
  for (let i = 0; i < 7; i++) {
    dates.push(new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + i))
  }
  const dtf = new Intl.DateTimeFormat(locale, {
    weekday: format,
    timeZone: 'UTC',
  })
  return dates.map((d) => dtf.format(d))
}

/**
 * Mobile detection
 * https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
 */
const isMobile = {
  Android: function () {
    return (
      typeof window !== 'undefined' &&
      window.navigator.userAgent.match(/Android/i)
    )
  },
  BlackBerry: function () {
    return (
      typeof window !== 'undefined' &&
      window.navigator.userAgent.match(/BlackBerry/i)
    )
  },
  iOS: function () {
    return (
      typeof window !== 'undefined' &&
      window.navigator.userAgent.match(/iPhone|iPad|iPod/i)
    )
  },
  Opera: function () {
    return (
      typeof window !== 'undefined' &&
      window.navigator.userAgent.match(/Opera Mini/i)
    )
  },
  Windows: function () {
    return (
      typeof window !== 'undefined' &&
      window.navigator.userAgent.match(/IEMobile/i)
    )
  },
  any: function () {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    )
  },
}

function getLocale(locales, lang) {
  if (Object.keys(locales).includes(lang)) {
    return locales[lang]
  }

  return locales.de
}

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-travelers.vue?vue&type=script&lang=js




const locales = {
  de: {
    adults: 'Erwachsene',
    child: 'Kind',
    children: 'Kinder',
    roomLabel: 'Zimmer',
    travelerChildAgeLabel: 'Kindesalter bei Rückreise:',
    infoTextSingleRoom:
      'Alle Personen werden in einem Zimmer untergebracht.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextSingleRoomMultiple:
      'Jeder Erwachsene wird automatisch einem eigenen Zimmer zugewiesen.<br><br><strong>Wünschst du eine andere Zimmeraufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextMultipleRooms:
      '#ROOMS identische Zimmer mit je #ADULTS Erwachsenen.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextMultipleSingular:
      '#ROOMS identische Zimmer mit je #ADULTS Erwachsenen und #CHILDREN Kind.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextMultiplePlural:
      '#ROOMS identische Zimmer mit je #ADULTS Erwachsenen und #CHILDREN Kindern.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    roomConfigNotAvailable:
      'Mit deiner aktuellen Auswahl ist keine passende Zimmerkonfiguration möglich.<br><br><strong>Wünschst du diese Aufteilung?</strong><br>Dann rufe uns gerne an:',
    travelerSupportTel: '+49 2301 89 39 742',
    travelerSupportTelHours: '(täglich von 8 bis 22 Uhr)',
  },
  at: {
    adults: 'Erwachsene',
    child: 'Kind',
    children: 'Kinder',
    roomLabel: 'Zimmer',
    travelerChildAgeLabel: 'Kindesalter bei Rückreise:',
    infoTextSingleRoom:
      'Alle Personen werden in einem Zimmer untergebracht.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextSingleRoomMultiple:
      'Jeder Erwachsene wird automatisch einem eigenen Zimmer zugewiesen.<br><br><strong>Wünschst du eine andere Zimmeraufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextMultipleRooms:
      '#ROOMS identische Zimmer mit je #ADULTS Erwachsenen.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextMultipleSingular:
      '#ROOMS identische Zimmer mit je #ADULTS Erwachsenen und #CHILDREN Kind.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextMultiplePlural:
      '#ROOMS identische Zimmer mit je #ADULTS Erwachsenen und #CHILDREN Kindern.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    roomConfigNotAvailable:
      'Mit deiner aktuellen Auswahl ist keine passende Zimmerkonfiguration möglich.<br><br><strong>Wünschst du diese Aufteilung?</strong><br>Dann rufe uns gerne an:',
    travelerSupportTel: '+43 1 3852397',
    travelerSupportTelHours: '(täglich von 8 bis 22 Uhr)',
  },
  ch: {
    adults: 'Erwachsene',
    child: 'Kind',
    children: 'Kinder',
    roomLabel: 'Zimmer',
    travelerChildAgeLabel: 'Kindesalter bei Rückreise:',
    infoTextSingleRoom:
      'Alle Personen werden in einem Zimmer untergebracht.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextSingleRoomMultiple:
      'Jeder Erwachsene wird automatisch einem eigenen Zimmer zugewiesen.<br><br><strong>Wünschst du eine andere Zimmeraufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextMultipleRooms:
      '#ROOMS identische Zimmer mit je #ADULTS Erwachsenen.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextMultipleSingular:
      '#ROOMS identische Zimmer mit je #ADULTS Erwachsenen und #CHILDREN Kind.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    infoTextMultiplePlural:
      '#ROOMS identische Zimmer mit je #ADULTS Erwachsenen und #CHILDREN Kindern.<br><br><strong>Wünschst du eine andere Aufteilung?</strong><br>Dann rufe uns gerne an:',
    roomConfigNotAvailable:
      'Mit deiner aktuellen Auswahl ist keine passende Zimmerkonfiguration möglich.<br><br><strong>Wünschst du diese Aufteilung?</strong><br>Dann rufe uns gerne an:',
    travelerSupportTel: '+41 4 45222063',
    travelerSupportTelHours: '(täglich von 8 bis 22 Uhr)',
  },
  nl: {
    adults: 'Volwassenen',
    child: 'Kind',
    children: 'Kinderen',
    roomLabel: 'Kamers',
    travelerChildAgeLabel: 'Leeftijd van de kinderen bij de terugreis:',
    infoTextSingleRoom:
      'Alle personen worden in één kamer ondergebracht. Als je een andere kamerindeling wenst, bel ons op:',
    infoTextSingleRoomMultiple: '',
    infoTextMultipleRooms:
      '#ROOMS Identieke kamers met elk #ADULTS volwassenen. Als je een andere kamerindeling wilt, bel ons dan:',
    infoTextMultipleSingular:
      '#ROOMS Kamer met #ADULTS volwassenen en #CHILDREN kinderen. Als je een andere kamerindeling wilt, bel ons dan:',
    infoTextMultiplePlural:
      '#ROOMS Kamers met #ADULTS volwassenen en #CHILDREN kinderen. Als je een andere kamerindeling wilt, bel ons dan:',
    roomConfigNotAvailable: '',
    travelerSupportTel: '+31 30 8082995',
    travelerSupportTelHours: '(Dagelijks van 8u tot 22u)',
  },
  es: {
    adults: 'Adultos',
    child: 'Niño',
    children: 'Niños',
    roomLabel: 'Habitaciónes',
    travelerChildAgeLabel: 'Edad del niño en el viaje de vuelta:',
    infoTextSingleRoom:
      'Todas las personas se alojarán en una habitación. Si desea una distribución de la habitación diferente, contáctanos:',
    infoTextSingleRoomMultiple: '',
    infoTextMultipleRooms: '',
    infoTextMultipleSingular: '',
    infoTextMultiplePlural: '',
    roomConfigNotAvailable: '',
    travelerSupportTel: '',
    travelerSupportTelHours: '',
  },
}

/* harmony default export */ var hg_travelersvue_type_script_lang_js = ({
  components: { HgDropdown: hg_dropdown },
  props: {
    lang: {
      type: String,
      default: 'de',
    },
    isMobile: Boolean,
    showErrors: Boolean,
    prev: String,
    label: String,
    placeholder: String,
    maxAdults: {
      type: Number,
      default: 4,
    },
    maxChildren: {
      type: Number,
      default: 3,
    },
    placeholderColor: {
      type: Boolean,
      default: false,
    },
    defaultChildAges: {
      type: Number,
      default: 6,
    },
    showRooms: {
      type: Boolean,
      default: false,
    },
    limitRooms: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      locale: locales.de,
      adults: 2,
      children: 0,
      rooms: 1,
      ages: [],
      dropDownActive: false,
      createdPortal: false,
      ageOptions: this.$i18n.t('ibeSearchControls.childAgeOptions'),
      errorMessage: '',
      validRooms: [],
    }
  },

  mounted() {
    this.update()
    if (this.limitRooms) this.checkRooms()
    this.validateRooms()

    this.setLocale()
  },

  computed: {
    travelerString() {
      let travelerString = ''
      if (this.adults > 1) {
        travelerString += `${this.adults} ${this.$i18n.t('adults')}`
      } else {
        travelerString += `${this.adults} ${this.$i18n.t('adult')}`
      }

      if (this.children === 0) {
        travelerString += ` & 0 ${this.$i18n.t('children')}`
      } else if (this.children === 1) {
        travelerString += ` & ${this.children} ${this.$i18n.t('child')}`
      } else if (this.children > 1) {
        travelerString += ` & ${this.children} ${this.$i18n.t('children')}`
      }

      return travelerString
    },
  },

  watch: {
    lang() {
      this.setLocale()
    },
    adults() {
      if (this.limitRooms) this.checkRooms()
      this.validateRooms()
      this.update()
    },
    children() {
      if (this.limitRooms) this.checkRooms()
      this.validateRooms()
      this.update()
    },
    rooms() {
      this.validateRooms()
      this.update()
    },
  },

  methods: {
    setLocale() {
      this.locale = getLocale(locales, this.lang)
    },
    checkRooms() {
      if (
        (this.adults == 2 && (this.children == 2 || this.children == 0)) ||
        (this.adults == 4 && this.children == 2)
      ) {
        this.validRooms = [1, 2]
      } else if (this.adults == 3 && this.children == 0) {
        this.validRooms = [1, 2, 3]
      } else if (this.adults == 3 && this.children == 3) {
        this.validRooms = [1, 2, 3]
      } else if (
        this.adults == 4 &&
        (this.children == 4 || this.children == 0)
      ) {
        this.validRooms = [1, 2, 3, 4]
      } else if (
        (this.adults == 1 && this.children == 0) ||
        (this.adults == 1 && this.children > 0 && this.children <= 4) ||
        (this.adults == 2 &&
          (this.children == 3 || this.children == 4 || this.children == 1)) ||
        (this.adults == 3 &&
          (this.children == 1 || this.children == 2 || this.children == 4)) ||
        (this.adults == 4 && (this.children == 1 || this.children == 3))
      ) {
        this.validRooms = [1]
      } else {
        this.validRooms = [0]
      }

      this.rooms = this.validRooms[0]
    },

    validateRooms() {
      if (this.showRooms) {
        if (
          (this.adults == 2 && this.children == 0 && this.rooms == 2)
        ) {
          this.errorMessage = this.locale.infoTextSingleRoomMultiple
        } else if (
          (this.adults == 4 && this.children == 0 && this.rooms == 2) ||
          (this.adults == 3 && this.children == 0 && this.rooms == 3) ||
          (this.adults == 4 && this.children == 0 && this.rooms == 4)
        ) {
          this.errorMessage = this.locale.infoTextMultipleRooms
            .replace('#ROOMS', this.rooms)
            .replace('#ADULTS', this.adults / this.rooms)
        } else if (
          (this.adults == 2 && this.children == 0 && this.rooms == 1) ||
          (this.adults == 2 && this.children == 1 && this.rooms == 1) ||
          (this.adults == 2 && this.children == 2 && this.rooms == 1) ||
          (this.adults == 2 && this.children == 3 && this.rooms == 1) ||
          (this.adults == 2 && this.children == 4 && this.rooms == 1) ||
          (this.adults == 3 && this.children == 0 && this.rooms == 1) ||
          (this.adults == 3 && this.children == 1 && this.rooms == 1) ||
          (this.adults == 3 && this.children == 2 && this.rooms == 1) ||
          (this.adults == 3 && this.children == 3 && this.rooms == 1) ||
          (this.adults == 3 && this.children == 4 && this.rooms == 1) ||
          (this.adults == 4 && this.children == 0 && this.rooms == 1) ||
          (this.adults == 4 && this.children == 1 && this.rooms == 1) ||
          (this.adults == 4 && this.children == 2 && this.rooms == 1) ||
          (this.adults == 4 && this.children == 3 && this.rooms == 1) ||
          (this.adults == 4 && this.children == 4 && this.rooms == 1)
        ) {
          this.errorMessage = this.locale.infoTextSingleRoom
        } else if (
          (this.adults == 2 && this.children == 2 && this.rooms == 2) ||
          (this.adults == 3 && this.children == 3 && this.rooms == 3) ||
          (this.adults == 4 && this.children == 2 && this.rooms == 2) ||
          (this.adults == 4 && this.children == 4 && this.rooms == 4)
        ) {
          this.errorMessage = this.locale.infoTextMultipleSingular
            .replace('#ROOMS', this.rooms)
            .replace('#ADULTS', this.adults / this.rooms)
            .replace('#CHILDREN', this.children / this.rooms)
        } else if (this.adults == 4 && this.children == 4 && this.rooms == 2) {
          this.errorMessage = this.locale.infoTextMultiplePlural
            .replace('#ROOMS', this.rooms)
            .replace('#ADULTS', this.adults / this.rooms)
            .replace('#CHILDREN', this.children / this.rooms)
        } else if (
          (this.adults == 3 && this.children == 0 && this.rooms == 2) ||
          (this.adults == 3 && this.children == 3 && this.rooms == 2) ||
          (this.adults == 4 && this.children == 0 && this.rooms == 3) ||
          (this.adults == 4 && this.children == 4 && this.rooms == 3)
        ) {
          this.errorMessage = this.locale.roomConfigNotAvailable
        } else {
          this.errorMessage = ''
        }
      } else {
        this.errorMessage = ''
      }
    },

    close() {
      this.dropDownActive = false
      this.$refs.dropdownRef.isActive = false
    },
    reset() {
      this.adults = 2
      this.children = 0
      this.close()
    },

    selectAge(childIndex, age) {
      this.update()
    },

    changeAge(ev, index) {
      this.update()
    },

    update() {
      // Check if the value for defaultChildAges exists in ageOptions
      let i = this.ageOptions.findIndex(
        age => age.value == this.defaultChildAges
      )
      let defaultChildAge = this.defaultChildAges

      if (i == -1) {
        // Set the default value
        defaultChildAge = 6
      }

      for (let i = 0; i < this.children; i++) {
        if (!this.ages[i]) this.ages[i] = defaultChildAge
      }
      if (this.ages.length > this.children) {
        this.ages.pop() // Remove age of deleted child
      }

      const travelers = {
        adults: this.adults,
        children: this.children,
        ages: this.ages,
        rooms: this.rooms,
      }

      this.$emit('onUpdateTravelers', travelers)
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-travelers.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_travelersvue_type_script_lang_js = (hg_travelersvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-travelers.vue?vue&type=style&index=0&id=879517a4&prod&scoped=true&lang=postcss
var hg_travelersvue_type_style_index_0_id_879517a4_prod_scoped_true_lang_postcss = __webpack_require__("9d09");

// CONCATENATED MODULE: ./src/components/inputs/hg-travelers.vue






/* normalize component */

var hg_travelers_component = normalizeComponent(
  inputs_hg_travelersvue_type_script_lang_js,
  hg_travelersvue_type_template_id_879517a4_scoped_true_render,
  hg_travelersvue_type_template_id_879517a4_scoped_true_staticRenderFns,
  false,
  null,
  "879517a4",
  null
  
)

/* harmony default export */ var hg_travelers = (hg_travelers_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-form-errors.vue?vue&type=template&id=2dc2a2ba&scoped=true
var hg_form_errorsvue_type_template_id_2dc2a2ba_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.message)?[_c('div',{class:`form-box message ${_vm.theme ? _vm.theme : ''}`},[_c('div',{staticClass:"hg-icon hg-icon--small info-icon"},[_c('hg-icon',{attrs:{"name":"info-circle","size":"small","color":"black"}})],1),_c('div',{staticClass:"text",class:{ 'size-small': _vm.size === 'small' }},[_vm._t("default")],2)])]:[_c('div',{staticClass:"form-box error"},[_c('div',{staticClass:"hg-icon hg-icon--small info-icon"},[_c('hg-icon',{attrs:{"name":"exclamation-circle","size":"small","color":"red"}})],1),_c('div',{staticClass:"text",class:{ 'size-small': _vm.size === 'small' }},[_vm._t("default")],2)])]],2)
}
var hg_form_errorsvue_type_template_id_2dc2a2ba_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-form-errors.vue?vue&type=template&id=2dc2a2ba&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-form-errors.vue?vue&type=script&lang=js

/* harmony default export */ var hg_form_errorsvue_type_script_lang_js = ({
  props: {
    message: {
      type: Boolean,
      default: false,
    },
    size: {
      default: 'default', // default | small
      type: String,
    },
    theme: {
      type: String,
      default: null
    }
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-form-errors.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_form_errorsvue_type_script_lang_js = (hg_form_errorsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-form-errors.vue?vue&type=style&index=0&id=2dc2a2ba&prod&scoped=true&lang=postcss
var hg_form_errorsvue_type_style_index_0_id_2dc2a2ba_prod_scoped_true_lang_postcss = __webpack_require__("e12b");

// CONCATENATED MODULE: ./src/components/inputs/hg-form-errors.vue






/* normalize component */

var hg_form_errors_component = normalizeComponent(
  inputs_hg_form_errorsvue_type_script_lang_js,
  hg_form_errorsvue_type_template_id_2dc2a2ba_scoped_true_render,
  hg_form_errorsvue_type_template_id_2dc2a2ba_scoped_true_staticRenderFns,
  false,
  null,
  "2dc2a2ba",
  null
  
)

/* harmony default export */ var hg_form_errors = (hg_form_errors_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-coupon-button.vue?vue&type=template&id=3215deb7&scoped=true
var hg_coupon_buttonvue_type_template_id_3215deb7_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"role":"button"},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"hg-coupon-container"},[_c('div',{staticClass:"hg-coupon-content"},[_c('div',{staticClass:"hg-coupon-content__left"},[_c('PaperPlaneSvg',{staticClass:"hg-plane"})],1),_c('div',{staticClass:"hg-coupon-content__right"},[_c('p',{staticClass:"hg-text",domProps:{"innerHTML":_vm._s(_vm.couponButtonText)}})])])])])
}
var hg_coupon_buttonvue_type_template_id_3215deb7_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-coupon-button.vue?vue&type=template&id=3215deb7&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/paper-plane-svg.vue?vue&type=template&id=5d3c06b0
var paper_plane_svgvue_type_template_id_5d3c06b0_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"133","height":"66","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"opacity":".5","stroke":"#2D2D2D","stroke-width":".372","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M100.951 13.113s-.19-.022-.55-.054"}}),_c('path',{attrs:{"d":"M98.911 12.928c-.53-.043-1.15-.086-1.86-.14M96.311 12.733C75.041 11.28-11.669 8.688.091 64.023","stroke-dasharray":"1.12 1.12"}}),_c('path',{attrs:{"d":"M.261 64.816c.04.195.09.39.14.585"}})]),_c('path',{attrs:{"d":"m132.091 11.735-30.83-3.503L96.561 0l35.53 11.735ZM132.091 11.735l-29.98-.574 3.79 16.973 26.19-16.399Z","fill":"#CEEDEB"}}),_c('path',{attrs:{"d":"m101.261 8.232-3.97 8.883 4.82-5.954 29.98.574-30.83-3.503Z","fill":"#81C1BC"}}),_c('path',{attrs:{"d":"m97.291 17.115 5.95-.922-1.13-5.033-4.82 5.955Z","fill":"#91D8D5"}})])
}
var paper_plane_svgvue_type_template_id_5d3c06b0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/paper-plane-svg.vue?vue&type=template&id=5d3c06b0

// CONCATENATED MODULE: ./src/components/svg/decorations/paper-plane-svg.vue

var script = {}


/* normalize component */

var paper_plane_svg_component = normalizeComponent(
  script,
  paper_plane_svgvue_type_template_id_5d3c06b0_render,
  paper_plane_svgvue_type_template_id_5d3c06b0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var paper_plane_svg = (paper_plane_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-coupon-button.vue?vue&type=script&lang=js



/* harmony default export */ var hg_coupon_buttonvue_type_script_lang_js = ({
  components: {
    PaperPlaneSvg: paper_plane_svg,
  },
  props: {
    couponButtonText: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick() {
      this.$emit('onClick')
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-coupon-button.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_coupon_buttonvue_type_script_lang_js = (hg_coupon_buttonvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-coupon-button.vue?vue&type=style&index=0&id=3215deb7&prod&lang=postcss&scoped=true
var hg_coupon_buttonvue_type_style_index_0_id_3215deb7_prod_lang_postcss_scoped_true = __webpack_require__("41d4");

// CONCATENATED MODULE: ./src/components/inputs/hg-coupon-button.vue






/* normalize component */

var hg_coupon_button_component = normalizeComponent(
  inputs_hg_coupon_buttonvue_type_script_lang_js,
  hg_coupon_buttonvue_type_template_id_3215deb7_scoped_true_render,
  hg_coupon_buttonvue_type_template_id_3215deb7_scoped_true_staticRenderFns,
  false,
  null,
  "3215deb7",
  null
  
)

/* harmony default export */ var hg_coupon_button = (hg_coupon_button_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-text-input.vue?vue&type=template&id=5607e814&scoped=true
var hg_text_inputvue_type_template_id_5607e814_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{class:[
    'hg-control',
    'label-position--' + _vm.labelPosition,
    _vm.expanded && 'expanded',
    _vm.disabled && 'hg-control--disabled',
  ],attrs:{"vid":_vm.name,"name":_vm.name,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function({ errors, valid }){return [(_vm.label)?_c('label',{attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',_vm._b({ref:"input",class:[
      'hg-input',
      valid === false && errors.length ? 'hg-input--error' : '',
      valid === true && _vm.rules ? 'hg-input--valid' : '',
      _vm.disabled === true ? 'hg-input--disabled' : '',
      _vm.teal ? 'hg-input--teal-border' : '',
      _vm.theme ? `hg-input--${_vm.theme}` : '',
      { 'hg-input--transparent': _vm.transparent },
    ],attrs:{"type":_vm.type,"id":_vm.name,"name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.computedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus,"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.onSubmit.apply(null, arguments)},function($event){return _vm.$emit('onError', errors)}]}},'input',_vm.$attrs,false)),(errors && errors.length)?_c('span',{staticClass:"error-message"},[(_vm.showIcon)?_c('svg',{staticClass:"tw-mr-1",attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.846 10.774a.985.985 0 0 1-.853 1.476H2.152a.985.985 0 0 1-.853-1.476L6.22 2.242a.985.985 0 0 1 1.705 0l4.921 8.532zm-10.589.307a.123.123 0 0 0 .107.185h9.418a.123.123 0 0 0 .106-.185L7.18 2.92a.123.123 0 0 0-.213 0l-4.709 8.162zm5.24-2.604a.25.25 0 0 0 .246-.232l.135-2.297a.246.246 0 0 0-.246-.26H6.513a.246.246 0 0 0-.245.26l.135 2.297c.008.13.115.232.246.232h.848zm.437 1.148a.861.861 0 1 1-1.723 0 .861.861 0 0 1 1.723 0z","fill":"#D1435B"}})]):_vm._e(),_vm._v(" "+_vm._s(errors[0]))]):_vm._e()]}}])})
}
var hg_text_inputvue_type_template_id_5607e814_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-text-input.vue?vue&type=template&id=5607e814&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-text-input.vue?vue&type=script&lang=js

/* harmony default export */ var hg_text_inputvue_type_script_lang_js = ({
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
    },
    rules: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    vid: {
      type: String,
      default: Math.random().toString(),
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: '',
    },
    labelPosition: {
      type: String,
      default: 'inside',
    },
    teal: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: Array,
      default: () => {},
    },
    allowSubmitEvent: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    disableNumbers: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      newValue: this.value,
      currentValue: '',
      _elementRef: this.type === 'textarea' ? 'textarea' : 'input',
    }
  },

  computed: {
    computedValue: {
      get() {
        return this.newValue
      },
      set(value) {
        this.newValue = value
      },
    },
  },

  watch: {
    currentValue(val) {
      // allows us to use v-model on our input.
      this.$emit('input', val)
    },
    value(val) {
      this.newValue = val
    },
  },

  methods: {
    updateValue(value) {
      this.computedValue = value
    },
    onInput(event) {
      let value = event.target.value

      if (this.disableNumbers) {
        // Remove numbers from the value
        value = value.replace(/[0-9]/g, '')
      }

      this.updateValue(value)
      this.$emit('input', value)
    },
    onSubmit(event) {
      const value = event.target.value
      this.updateValue(value)
      if (this.allowSubmitEvent) {
        this.$emit('submit', value)
      }
    },

    onBlur($event) {
      this.isFocused = false
      this.$emit('blur', $event)
    },

    onFocus($event) {
      this.isFocused = true
      this.$emit('focus', $event)
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-text-input.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_text_inputvue_type_script_lang_js = (hg_text_inputvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-text-input.vue?vue&type=style&index=0&id=5607e814&prod&scoped=true&lang=css
var hg_text_inputvue_type_style_index_0_id_5607e814_prod_scoped_true_lang_css = __webpack_require__("6d912");

// CONCATENATED MODULE: ./src/components/inputs/hg-text-input.vue






/* normalize component */

var hg_text_input_component = normalizeComponent(
  inputs_hg_text_inputvue_type_script_lang_js,
  hg_text_inputvue_type_template_id_5607e814_scoped_true_render,
  hg_text_inputvue_type_template_id_5607e814_scoped_true_staticRenderFns,
  false,
  null,
  "5607e814",
  null
  
)

/* harmony default export */ var hg_text_input = (hg_text_input_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-badge.vue?vue&type=template&id=5eb3e4ad&scoped=true
var hg_badgevue_type_template_id_5eb3e4ad_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"role":"button","type":"button"},on:{"click":_vm.handleClick}},[_c('div',{class:['hg-badge-wrapper', {'hg-badge-arrow' : _vm.hasArrow}]},[_c('GuruLogoSvg',{staticClass:"hg-logo"}),_c('div',{staticClass:"tw-flex hg-text-content"},[_c('OneHundredEuroSvg'),_c('CouponTextSvg',{staticClass:"hg-image-text"})],1),_c('div',{staticClass:"hg-button-wrap"},[_vm._v(_vm._s(_vm.buttonText))])],1)])
}
var hg_badgevue_type_template_id_5eb3e4ad_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-badge.vue?vue&type=template&id=5eb3e4ad&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/one-hundred-euro-svg.vue?vue&type=template&id=68da12d3
var one_hundred_euro_svgvue_type_template_id_68da12d3_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"91","height":"43","viewBox":"0 0 91 43","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.3492 18.0747C6.0372 18.4387 5.7252 18.7767 5.4132 19.0887C5.1012 19.4007 4.7892 19.7387 4.4772 20.1027C4.1132 20.5187 3.6712 20.9087 3.1512 21.2727C2.6832 21.5327 2.2152 21.6887 1.7472 21.7407C1.3312 21.7407 0.9152 21.5587 0.4992 21.1947C0.0832 20.8307 -0.0728 20.4667 0.0312 20.1027C0.1352 19.7387 0.3172 19.3747 0.5772 19.0107C1.8772 17.3467 3.1512 15.6827 4.3992 14.0187C5.6472 12.3547 6.8952 10.6907 8.1432 9.02673C8.7672 8.14273 9.3912 7.28473 10.0152 6.45273C10.6392 5.56873 11.2632 4.68473 11.8872 3.80073C12.0952 3.54073 12.3032 3.28073 12.5112 3.02073C12.7192 2.76073 12.9532 2.55273 13.2132 2.39673C14.2012 1.72073 15.2152 1.72073 16.2552 2.39673C17.1392 2.86473 17.5032 3.61873 17.3472 4.65873C17.2432 4.81473 17.1652 4.99673 17.1132 5.20473C17.1132 5.36073 17.0612 5.49073 16.9572 5.59473C15.7612 8.81873 14.7472 12.0167 13.9152 15.1887C13.0832 18.3607 12.4592 21.5847 12.0432 24.8607C11.7312 27.1487 11.4712 29.4367 11.2632 31.7247C11.0552 33.9607 11.1072 36.2227 11.4192 38.5107C11.5752 39.6027 11.1592 40.4087 10.1712 40.9287C9.5992 41.1887 9.0012 41.2927 8.3772 41.2407C7.8052 41.1367 7.3372 40.8507 6.9732 40.3827C6.1932 39.4987 5.6732 38.4587 5.4132 37.2627C4.9972 35.5987 4.8672 33.9087 5.0232 32.1927C5.2312 30.4247 5.4392 28.7087 5.6472 27.0447C5.7512 25.5887 5.9072 24.1327 6.1152 22.6767C6.3232 21.2207 6.5572 19.7387 6.8172 18.2307C6.6092 18.1267 6.4532 18.0747 6.3492 18.0747Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M35.9045 10.3527C35.7485 13.6287 35.4365 16.7747 34.9685 19.7907C34.5005 22.7547 33.7985 25.6667 32.8625 28.5267C32.4465 30.0347 31.9005 31.4647 31.2245 32.8167C30.6005 34.1687 29.7945 35.4427 28.8065 36.6387C28.2865 37.2107 27.7145 37.7827 27.0905 38.3547C26.4665 38.9267 25.8165 39.4207 25.1405 39.8367C23.8405 40.5647 22.5665 40.7467 21.3185 40.3827C20.1225 40.0187 19.1605 39.2127 18.4325 37.9647C18.0165 37.1847 17.6265 36.3527 17.2625 35.4687C16.9505 34.5327 16.7425 33.6227 16.6385 32.7387C15.9105 26.2387 16.8725 20.0507 19.5245 14.1747C19.8885 13.2387 20.3045 12.3807 20.7725 11.6007C21.2925 10.8207 21.9165 10.0667 22.6445 9.33873C23.0085 9.02673 23.2945 8.66273 23.5025 8.24673C23.7105 7.77873 23.8925 7.31073 24.0485 6.84273C24.4645 5.90673 24.9845 5.02273 25.6085 4.19073C26.2325 3.35873 26.9865 2.65673 27.8705 2.08473C29.6385 1.04473 31.2245 0.810727 32.6285 1.38273C34.0325 1.95473 34.9945 3.22873 35.5145 5.20473C35.6705 5.62073 35.7485 6.08873 35.7485 6.60873C35.8005 7.33673 35.8265 8.03873 35.8265 8.71473C35.8785 9.39073 35.9045 9.93673 35.9045 10.3527ZM31.0685 5.04873C29.8725 5.46473 29.0145 6.08873 28.4945 6.92073C28.0265 7.75273 27.6885 8.68873 27.4805 9.72873C27.4285 9.98873 27.4025 10.2487 27.4025 10.5087C27.4545 10.7167 27.4285 10.8987 27.3245 11.0547C26.5965 12.3027 26.2065 13.5507 26.1545 14.7987C26.1025 15.9947 26.3625 17.2167 26.9345 18.4647C27.2985 19.3487 27.1425 20.0507 26.4665 20.5707C26.1545 20.9347 25.7905 21.1167 25.3745 21.1167C25.0105 21.0647 24.6205 20.8827 24.2045 20.5707C23.7365 20.3107 23.3205 20.0507 22.9565 19.7907C22.2285 22.9107 21.8905 25.8747 21.9425 28.6827C22.0465 31.4907 22.5405 33.6227 23.4245 35.0787C23.7365 34.7147 24.0745 34.4287 24.4385 34.2207C24.8025 33.9607 25.0885 33.6227 25.2965 33.2067C25.8685 32.3747 26.3885 31.5687 26.8565 30.7887C27.3765 30.0087 27.7665 29.1767 28.0265 28.2927C30.6265 21.7407 31.8485 14.9547 31.6925 7.93473C31.6405 7.46673 31.5365 7.02473 31.3805 6.60873C31.2765 6.14073 31.1725 5.62073 31.0685 5.04873Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M56.5471 10.3527C56.3911 13.6287 56.0791 16.7747 55.6111 19.7907C55.1431 22.7547 54.4411 25.6667 53.5051 28.5267C53.0891 30.0347 52.5431 31.4647 51.8671 32.8167C51.2431 34.1687 50.4371 35.4427 49.4491 36.6387C48.9291 37.2107 48.3571 37.7827 47.7331 38.3547C47.1091 38.9267 46.4591 39.4207 45.7831 39.8367C44.4831 40.5647 43.2091 40.7467 41.9611 40.3827C40.7651 40.0187 39.8031 39.2127 39.0751 37.9647C38.6591 37.1847 38.2691 36.3527 37.9051 35.4687C37.5931 34.5327 37.3851 33.6227 37.2811 32.7387C36.5531 26.2387 37.5151 20.0507 40.1671 14.1747C40.5311 13.2387 40.9471 12.3807 41.4151 11.6007C41.9351 10.8207 42.5591 10.0667 43.2871 9.33873C43.6511 9.02673 43.9371 8.66273 44.1451 8.24673C44.3531 7.77873 44.5351 7.31073 44.6911 6.84273C45.1071 5.90673 45.6271 5.02273 46.2511 4.19073C46.8751 3.35873 47.6291 2.65673 48.5131 2.08473C50.2811 1.04473 51.8671 0.810727 53.2711 1.38273C54.6751 1.95473 55.6371 3.22873 56.1571 5.20473C56.3131 5.62073 56.3911 6.08873 56.3911 6.60873C56.4431 7.33673 56.4691 8.03873 56.4691 8.71473C56.5211 9.39073 56.5471 9.93673 56.5471 10.3527ZM51.7111 5.04873C50.5151 5.46473 49.6571 6.08873 49.1371 6.92073C48.6691 7.75273 48.3311 8.68873 48.1231 9.72873C48.0711 9.98873 48.0451 10.2487 48.0451 10.5087C48.0971 10.7167 48.0711 10.8987 47.9671 11.0547C47.2391 12.3027 46.8491 13.5507 46.7971 14.7987C46.7451 15.9947 47.0051 17.2167 47.5771 18.4647C47.9411 19.3487 47.7851 20.0507 47.1091 20.5707C46.7971 20.9347 46.4331 21.1167 46.0171 21.1167C45.6531 21.0647 45.2631 20.8827 44.8471 20.5707C44.3791 20.3107 43.9631 20.0507 43.5991 19.7907C42.8711 22.9107 42.5331 25.8747 42.5851 28.6827C42.6891 31.4907 43.1831 33.6227 44.0671 35.0787C44.3791 34.7147 44.7171 34.4287 45.0811 34.2207C45.4451 33.9607 45.7311 33.6227 45.9391 33.2067C46.5111 32.3747 47.0311 31.5687 47.4991 30.7887C48.0191 30.0087 48.4091 29.1767 48.6691 28.2927C51.2691 21.7407 52.4911 14.9547 52.3351 7.93473C52.2831 7.46673 52.1791 7.02473 52.0231 6.60873C51.9191 6.14073 51.8151 5.62073 51.7111 5.04873Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M75.3957 14.4867C76.1237 14.3827 76.7217 14.3047 77.1897 14.2527C77.6577 14.1487 78.1257 14.0967 78.5937 14.0967C79.3217 14.0447 80.1017 14.0967 80.9337 14.2527C81.8697 14.2527 82.2597 14.6427 82.1037 15.4227C82.0517 15.8387 81.8957 16.0987 81.6357 16.2027C81.3757 16.3067 81.0377 16.3847 80.6217 16.4367C80.0497 16.4367 79.4517 16.4627 78.8277 16.5147C78.2557 16.5147 77.6837 16.5667 77.1117 16.6707C76.5397 16.7747 76.0717 16.8787 75.7077 16.9827C75.3957 17.0867 75.1357 17.2167 74.9277 17.3727C74.7717 17.5287 74.6417 17.7627 74.5377 18.0747C74.4857 18.3867 74.4337 18.8027 74.3817 19.3227V20.4927C75.1617 20.3367 75.8897 20.1807 76.5657 20.0247C77.2937 19.8687 77.9697 19.7387 78.5937 19.6347C78.8537 19.5307 79.1137 19.4527 79.3737 19.4007C79.6337 19.2967 79.8937 19.2707 80.1537 19.3227C80.4137 19.3227 80.6737 19.4007 80.9337 19.5567C81.2457 19.6607 81.4537 19.8167 81.5577 20.0247C81.6617 20.1807 81.6357 20.4147 81.4797 20.7267C81.3757 20.9867 81.1937 21.1687 80.9337 21.2727C80.5697 21.5327 80.1537 21.7407 79.6857 21.8967C79.2177 22.0007 78.7497 22.1047 78.2817 22.2087C77.6057 22.4167 76.8777 22.5987 76.0977 22.7547C75.3697 22.9107 74.6417 23.0927 73.9137 23.3007C73.5497 25.6407 73.4197 27.9807 73.5237 30.3207C73.6797 32.6087 74.1477 34.9227 74.9277 37.2627C75.0317 37.1067 75.1617 36.9507 75.3177 36.7947C75.4737 36.5867 75.6037 36.3527 75.7077 36.0927C76.2797 34.8447 76.8517 33.5967 77.4237 32.3487C77.9957 31.1007 78.5677 29.8527 79.1397 28.6047C79.3477 28.1367 79.5297 27.7467 79.6857 27.4347C79.8937 27.0707 80.1277 26.6807 80.3877 26.2647C81.0117 25.2247 81.7917 24.8867 82.7277 25.2507C83.7157 25.6667 84.0277 26.3947 83.6637 27.4347C83.4037 28.0587 83.1437 28.6827 82.8837 29.3067C82.6757 29.8787 82.4157 30.4767 82.1037 31.1007C81.6357 32.2447 81.1677 33.3887 80.6997 34.5327C80.2837 35.6767 79.7897 36.8207 79.2177 37.9647C78.8017 38.9527 78.1517 39.9667 77.2677 41.0067C76.3837 41.8387 75.3697 42.2287 74.2257 42.1767C73.0817 42.1247 72.1197 41.6567 71.3397 40.7727C70.9237 40.3047 70.5597 39.7587 70.2477 39.1347C69.9357 38.5107 69.6497 37.8867 69.3897 37.2627C68.8177 35.8067 68.4797 34.3247 68.3757 32.8167C68.3237 31.2567 68.3237 29.6967 68.3757 28.1367V24.6267H67.0497C66.5817 24.6267 66.1657 24.5747 65.8017 24.4707C65.4377 24.3147 65.2297 24.0027 65.1777 23.5347C65.0737 23.1187 65.2037 22.8067 65.5677 22.5987C65.8797 22.3907 66.2437 22.2347 66.6597 22.1307C67.0237 22.0267 67.3617 21.9487 67.6737 21.8967C68.0377 21.7927 68.4277 21.6887 68.8437 21.5847C68.9477 21.0647 69.0517 20.5707 69.1557 20.1027C69.2597 19.6347 69.3377 19.1147 69.3897 18.5427C69.0257 18.5427 68.7137 18.5427 68.4537 18.5427C68.1937 18.5427 67.9597 18.4907 67.7517 18.3867C67.5437 18.2827 67.3357 18.1787 67.1277 18.0747C66.9197 17.9187 66.7897 17.7627 66.7377 17.6067C66.6337 17.0867 66.8157 16.6967 67.2837 16.4367C67.5437 16.3327 67.8037 16.2287 68.0637 16.1247C68.3237 15.9687 68.5837 15.8647 68.8437 15.8127C69.3637 15.7087 69.7277 15.5267 69.9357 15.2667C70.1957 15.0067 70.4297 14.6687 70.6377 14.2527C70.9497 13.1087 71.3137 11.9647 71.7297 10.8207C72.1457 9.67673 72.5877 8.55873 73.0557 7.46673C73.4197 6.68673 73.8357 5.93273 74.3037 5.20473C74.7717 4.47673 75.2657 3.74873 75.7857 3.02073C76.0457 2.65673 76.3837 2.31873 76.7997 2.00673C77.2157 1.69473 77.6317 1.40873 78.0477 1.14873C79.5037 0.212727 80.9857 -0.151273 82.4937 0.0567275C84.0017 0.264728 85.3017 0.966728 86.3937 2.16273C87.1217 2.94273 87.6677 3.80073 88.0317 4.73673C88.3957 5.62073 88.7077 6.55673 88.9677 7.54473C89.1757 8.32473 89.3577 9.13073 89.5137 9.96273C89.7217 10.7427 89.9297 11.5487 90.1377 12.3807C90.1377 12.7967 90.0857 13.1607 89.9817 13.4727C89.9297 13.7847 89.6437 13.9927 89.1237 14.0967C88.6037 14.2007 88.1877 14.1747 87.8757 14.0187C87.5637 13.8107 87.3557 13.4987 87.2517 13.0827C86.9917 12.5107 86.7837 11.9387 86.6277 11.3667C86.5237 10.7427 86.3417 10.1187 86.0817 9.49473C85.8217 8.76673 85.5617 8.03873 85.3017 7.31073C85.0417 6.53073 84.7037 5.77673 84.2877 5.04873C83.5597 3.85273 82.7537 3.25473 81.8697 3.25473C81.0377 3.25473 80.2577 3.80073 79.5297 4.89273C78.8537 5.88073 78.2817 6.89473 77.8137 7.93473C77.3977 8.97473 76.9297 10.0147 76.4097 11.0547C76.2017 11.5747 76.0457 12.0947 75.9417 12.6147C75.8377 13.1347 75.6557 13.7587 75.3957 14.4867Z","fill":"#F3FDFC"}})])
}
var one_hundred_euro_svgvue_type_template_id_68da12d3_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/one-hundred-euro-svg.vue?vue&type=template&id=68da12d3

// CONCATENATED MODULE: ./src/components/svg/decorations/one-hundred-euro-svg.vue

var one_hundred_euro_svg_script = {}


/* normalize component */

var one_hundred_euro_svg_component = normalizeComponent(
  one_hundred_euro_svg_script,
  one_hundred_euro_svgvue_type_template_id_68da12d3_render,
  one_hundred_euro_svgvue_type_template_id_68da12d3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var one_hundred_euro_svg = (one_hundred_euro_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/coupon-text-svg.vue?vue&type=template&id=968d6ef6
var coupon_text_svgvue_type_template_id_968d6ef6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"120","height":"39","viewBox":"0 0 120 39","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M25.536 2.5344C25.152 2.6624 24.752 2.7744 24.336 2.8704C23.92 2.9664 23.536 3.1264 23.184 3.3504C22.48 3.7984 21.776 4.2624 21.072 4.7424C20.368 5.1904 19.696 5.6864 19.056 6.2304C15.952 8.8544 13.248 11.7984 10.944 15.0624C8.67203 18.2944 6.68803 21.7824 4.99203 25.5264C4.73603 26.1344 4.51203 26.7744 4.32003 27.4464C4.16003 28.0864 4.00003 28.7264 3.84003 29.3664C3.77603 29.5904 3.74403 29.8144 3.74403 30.0384C3.74403 30.2624 3.74403 30.4864 3.74403 30.7104C3.77603 31.0304 3.87203 31.2704 4.03203 31.4304C4.22403 31.5584 4.46403 31.5584 4.75203 31.4304C5.04003 31.3344 5.32803 31.2384 5.61603 31.1424C5.90403 31.0464 6.17603 30.9184 6.43203 30.7584C8.70403 29.5424 10.784 28.1184 12.672 26.4864C14.56 24.8224 16.304 22.9824 17.904 20.9664C18.096 20.7744 18.208 20.5344 18.24 20.2464C17.952 20.3744 17.664 20.4704 17.376 20.5344C17.088 20.5984 16.8 20.6944 16.512 20.8224C16.224 20.9184 15.968 21.0784 15.744 21.3024C15.52 21.4944 15.344 21.7824 15.216 22.1664C15.12 22.4864 14.928 22.6464 14.64 22.6464C14.384 22.6144 14.112 22.5664 13.824 22.5024C13.536 22.4384 13.248 22.3744 12.96 22.3104C12.704 22.2144 12.512 21.9904 12.384 21.6384C12.288 21.3184 12.304 21.0464 12.432 20.8224C12.56 20.5664 12.752 20.3584 13.008 20.1984C13.168 20.0704 13.328 19.9584 13.488 19.8624C13.648 19.7664 13.824 19.6864 14.016 19.6224C15.424 19.0144 16.8 18.4224 18.144 17.8464C19.52 17.2704 20.928 16.6944 22.368 16.1184C22.496 16.0864 22.624 16.0704 22.752 16.0704C22.912 16.0384 23.056 16.0384 23.184 16.0704C23.536 16.1024 23.776 16.2624 23.904 16.5504C24.064 16.8384 24.032 17.1264 23.808 17.4144C23.744 17.5744 23.632 17.7184 23.472 17.8464C23.344 17.9424 23.264 18.0064 23.232 18.0384C23.168 18.9664 23.104 19.8304 23.04 20.6304C23.008 21.4304 22.96 22.2144 22.896 22.9824C22.768 24.2944 22.64 25.6064 22.512 26.9184C22.416 28.1984 22.32 29.4784 22.224 30.7584C22.16 31.3344 22.16 31.8944 22.224 32.4384C22.288 32.9504 22.544 33.4624 22.992 33.9744C23.28 34.3264 23.344 34.6944 23.184 35.0784C23.024 35.4624 22.72 35.7344 22.272 35.8944C21.728 36.1504 21.184 36.1664 20.64 35.9424C20.096 35.6864 19.696 35.2384 19.44 34.5984C19.28 34.2144 19.152 33.8304 19.056 33.4464C18.992 33.0304 18.96 32.6304 18.96 32.2464C18.896 31.3184 18.88 30.3904 18.912 29.4624C18.944 28.5344 18.976 27.6064 19.008 26.6784V24.9024C18.72 25.1904 18.48 25.4304 18.288 25.6224C18.096 25.8144 17.92 25.9904 17.76 26.1504C16.544 27.3984 15.28 28.5984 13.968 29.7504C12.656 30.8704 11.248 31.8944 9.74403 32.8224C9.20003 33.1744 8.64003 33.4784 8.06403 33.7344C7.52003 33.9904 6.96003 34.2464 6.38403 34.5024C6.12803 34.6304 5.87203 34.7264 5.61603 34.7904C5.36003 34.8224 5.10403 34.8704 4.84803 34.9344C3.50403 35.1264 2.38403 34.8544 1.48803 34.1184C0.592026 33.3504 0.128026 32.2464 0.0960258 30.8064C0.0640258 30.0704 0.112026 29.3184 0.240026 28.5504C0.368026 27.7824 0.544026 27.0464 0.768026 26.3424C1.05603 25.4144 1.37603 24.5024 1.72803 23.6064C2.11203 22.7104 2.52803 21.8464 2.97603 21.0144C4.80003 17.5584 6.92803 14.3904 9.36003 11.5104C11.792 8.5984 14.512 5.9424 17.52 3.5424C18.352 2.8704 19.232 2.2464 20.16 1.6704C21.088 1.0944 22.08 0.646398 23.136 0.326399C23.68 0.166399 24.208 0.0703991 24.72 0.0383995C25.264 -0.0255997 25.808 -0.00959988 26.352 0.0863989C27.152 0.246399 27.712 0.630399 28.032 1.2384C28.352 1.8144 28.368 2.5184 28.08 3.3504C27.92 3.7344 27.744 4.1184 27.552 4.5024C27.36 4.8864 27.168 5.2704 26.976 5.6544C26.592 6.2304 26.128 6.4064 25.584 6.1824C25.264 6.0224 25.088 5.8144 25.056 5.5584C25.056 5.2704 25.12 4.9824 25.248 4.6944C25.376 4.3744 25.472 4.0704 25.536 3.7824C25.632 3.4624 25.744 3.1424 25.872 2.8224C25.808 2.7904 25.744 2.7584 25.68 2.7264C25.648 2.6624 25.6 2.5984 25.536 2.5344Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M33.3105 23.1744C32.9905 23.5904 32.7185 23.9424 32.4945 24.2304C32.3025 24.5184 32.0945 24.7744 31.8705 24.9984C31.4225 25.5424 30.9265 26.0544 30.3825 26.5344C29.8705 26.9824 29.2785 27.3344 28.6065 27.5904C27.7745 27.9744 27.0385 27.9744 26.3985 27.5904C25.8545 27.2704 25.5185 26.7424 25.3905 26.0064C25.2625 25.2704 25.2625 24.5184 25.3905 23.7504C25.5185 22.9504 25.7265 22.1984 26.0145 21.4944C26.3025 20.7584 26.5745 20.2464 26.8305 19.9584C27.1185 19.6064 27.4545 19.4304 27.8385 19.4304C28.2545 19.3984 28.6225 19.4784 28.9425 19.6704C29.2625 19.8304 29.4705 20.0704 29.5665 20.3904C29.6945 20.7104 29.6145 21.0464 29.3265 21.3984C29.1665 21.5904 29.0225 21.8624 28.8945 22.2144C28.7665 22.5344 28.6385 22.9024 28.5105 23.3184C28.3825 23.7024 28.2705 24.0864 28.1745 24.4704C28.1105 24.8544 28.0785 25.1744 28.0785 25.4304C28.2065 25.6224 28.4785 25.5424 28.8945 25.1904C29.3425 24.8384 29.8225 24.3744 30.3345 23.7984C30.8785 23.2224 31.4065 22.6144 31.9185 21.9744C32.4305 21.3024 32.8465 20.7744 33.1665 20.3904C33.2945 20.2304 33.4065 20.0704 33.5025 19.9104C33.6305 19.7184 33.7745 19.5424 33.9345 19.3824C34.1265 19.1904 34.3825 19.0784 34.7025 19.0464C35.0225 18.9824 35.3265 18.9824 35.6145 19.0464C35.9345 19.0784 36.2065 19.1744 36.4305 19.3344C36.6545 19.4944 36.7825 19.7024 36.8145 19.9584C36.8145 20.1184 36.7825 20.4224 36.7185 20.8704C36.6545 21.3184 36.5745 21.8144 36.4785 22.3584C36.4145 22.9024 36.3505 23.4464 36.2865 23.9904C36.2545 24.5024 36.2545 24.9344 36.2865 25.2864C36.3505 25.6384 36.4785 25.8464 36.6705 25.9104C36.8625 25.9744 37.1505 25.8144 37.5345 25.4304C38.0785 24.8864 38.5905 24.3264 39.0705 23.7504C39.5825 23.1744 40.0945 22.5824 40.6065 21.9744C40.9585 21.5584 41.2945 21.3024 41.6145 21.2064C41.9665 21.1104 42.2225 21.1424 42.3825 21.3024C42.5745 21.4304 42.6545 21.6544 42.6225 21.9744C42.5905 22.2944 42.3985 22.6464 42.0465 23.0304C41.5345 23.6704 41.0065 24.3264 40.4625 24.9984C39.9505 25.6704 39.4225 26.2784 38.8785 26.8224C38.3665 27.3344 37.8385 27.7504 37.2945 28.0704C36.7825 28.3904 36.2705 28.5344 35.7585 28.5024C34.0305 28.3424 33.2145 26.5664 33.3105 23.1744Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M46.2912 10.9344C47.1232 10.7744 47.9712 10.5984 48.8352 10.4064C49.7312 10.1824 50.5792 9.9904 51.3792 9.8304C51.6031 9.7664 51.8272 9.7184 52.0512 9.6864C52.3072 9.6224 52.5472 9.5744 52.7712 9.5424C53.3792 9.4784 53.7312 9.7184 53.8272 10.2624C53.9552 10.7424 53.7472 11.1264 53.2032 11.4144C52.8512 11.5104 52.5152 11.6064 52.1952 11.7024C51.8752 11.7984 51.5551 11.8784 51.2351 11.9424C50.5951 12.1024 49.8591 12.2784 49.0271 12.4704C48.2271 12.6304 47.4912 12.7744 46.8192 12.9024C46.1472 13.0304 45.7632 13.4304 45.6672 14.1024C45.2192 16.6304 44.8992 19.1744 44.7071 21.7344C44.5471 24.2624 44.5631 26.7904 44.7551 29.3184C44.8191 29.7024 44.8832 30.0864 44.9472 30.4704C45.0432 30.8224 45.2192 31.1744 45.4752 31.5264C45.8912 32.0384 46.0191 32.5504 45.8591 33.0624C45.7312 33.5424 45.3152 33.7984 44.6112 33.8304C43.3312 33.9264 42.4352 33.3664 41.9231 32.1504C41.4751 31.0624 41.2032 29.9424 41.1072 28.7904C40.8832 26.8704 40.8512 24.9824 41.0112 23.1264C41.1712 21.2384 41.3471 19.3344 41.5392 17.4144C41.6031 16.9664 41.6672 16.5024 41.7312 16.0224C41.7952 15.5104 41.8591 14.9824 41.9231 14.4384C41.6671 14.5024 41.4432 14.5504 41.2512 14.5824C41.0912 14.5824 40.9152 14.6144 40.7232 14.6784C40.3712 14.8064 40.0032 14.9344 39.6192 15.0624C39.2352 15.1904 38.8512 15.3344 38.4672 15.4944C37.2831 15.9744 36.5952 15.9264 36.4032 15.3504C36.1152 14.8384 36.6112 14.3264 37.8912 13.8144C38.4032 13.5584 38.9151 13.3344 39.4272 13.1424C39.9392 12.9504 40.4672 12.7744 41.0112 12.6144C41.5551 12.4544 41.9712 12.2304 42.2592 11.9424C42.5471 11.6544 42.7552 11.2064 42.8832 10.5984C42.9792 10.2784 43.1072 9.8784 43.2672 9.3984C43.4272 8.9184 43.6192 8.4864 43.8432 8.1024C44.0992 7.6864 44.4031 7.3664 44.7551 7.1424C45.1072 6.9184 45.5071 6.8864 45.9552 7.0464C46.3391 7.2064 46.5471 7.4784 46.5792 7.8624C46.6112 8.2464 46.5951 8.7104 46.5312 9.2544C46.4991 9.5104 46.4672 9.7664 46.4352 10.0224C46.4031 10.2784 46.3552 10.5824 46.2912 10.9344Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M51.2652 21.4944C53.9852 23.5104 55.5852 25.9424 56.0652 28.7904C56.1931 29.5584 56.2412 30.3584 56.2092 31.1904C56.2092 31.9904 56.1132 32.7744 55.9212 33.5424C55.7291 34.2784 55.4252 34.9824 55.0092 35.6544C54.6252 36.2944 54.1132 36.8544 53.4732 37.3344C52.1612 38.2624 50.7371 38.5344 49.2011 38.1504C48.2731 37.9264 47.5532 37.4304 47.0411 36.6624C46.5291 35.8944 46.3372 34.9984 46.4651 33.9744C46.9132 31.1264 48.2892 28.7584 50.5932 26.8704C50.9132 26.5824 51.2971 26.2944 51.7452 26.0064C51.6172 25.5584 51.4252 25.2224 51.1692 24.9984C50.9132 24.7424 50.6572 24.4864 50.4011 24.2304C50.0812 23.9424 49.7452 23.6704 49.3932 23.4144C49.0411 23.1264 48.7211 22.8064 48.4332 22.4544C47.8251 21.7504 47.5532 21.0304 47.6171 20.2944C47.6811 19.5584 47.9532 18.8864 48.4332 18.2784C48.9132 17.6704 49.5052 17.1744 50.2092 16.7904C50.9452 16.3744 51.6652 16.1504 52.3692 16.1184C52.9772 16.0864 53.4732 16.2144 53.8572 16.5024C54.2411 16.7904 54.4972 17.1904 54.6252 17.7024C54.6892 17.9584 54.6892 18.2144 54.6252 18.4704C54.5932 18.6944 54.4492 18.8864 54.1931 19.0464C53.9371 19.2384 53.7132 19.3024 53.5212 19.2384C53.3292 19.1424 53.1372 18.9984 52.9452 18.8064C52.5292 18.3904 52.0812 18.1824 51.6012 18.1824C51.1531 18.1824 50.8012 18.3424 50.5452 18.6624C50.2892 18.9504 50.1932 19.3504 50.2572 19.8624C50.3212 20.3744 50.6572 20.9184 51.2652 21.4944ZM52.0812 27.6384C51.8251 27.8624 51.5692 28.1824 51.3132 28.5984C51.0572 28.9824 50.8012 29.4304 50.5452 29.9424C50.3212 30.4224 50.1132 30.9344 49.9212 31.4784C49.7612 31.9904 49.6652 32.4864 49.6332 32.9664C49.6012 33.5424 49.6332 33.9904 49.7292 34.3104C49.8572 34.5984 50.0172 34.7904 50.2092 34.8864C50.4332 34.9504 50.6731 34.9184 50.9291 34.7904C51.1852 34.6624 51.4252 34.4544 51.6492 34.1664C52.0331 33.7504 52.2892 33.2704 52.4172 32.7264C52.5772 32.1504 52.6572 31.5584 52.6572 30.9504C52.6572 30.3424 52.5932 29.7504 52.4652 29.1744C52.3692 28.5984 52.2411 28.0864 52.0812 27.6384Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M60.7328 21.1584C59.8688 22.7584 59.3888 23.9264 59.2928 24.6624C59.2288 25.3984 59.4048 25.8464 59.8208 26.0064C60.2688 26.1664 60.8768 26.0864 61.6448 25.7664C62.4128 25.4464 63.2128 25.0304 64.0448 24.5184C64.9088 23.9744 65.7248 23.3824 66.4928 22.7424C67.2608 22.1024 67.8528 21.5424 68.2688 21.0624C68.4928 20.8064 68.7168 20.6944 68.9408 20.7264C69.1648 20.7264 69.3568 20.8064 69.5168 20.9664C69.6768 21.1264 69.7728 21.3504 69.8048 21.6384C69.8368 21.8944 69.7568 22.1664 69.5648 22.4544C68.9888 23.0304 68.2688 23.6864 67.4048 24.4224C66.5728 25.1264 65.6768 25.7984 64.7168 26.4384C63.7568 27.0464 62.7808 27.5424 61.7888 27.9264C60.7968 28.3104 59.8688 28.4704 59.0048 28.4064C58.1408 28.3424 57.4688 27.9744 56.9888 27.3024C56.4768 26.5984 56.3008 25.6864 56.4608 24.5664C56.5568 23.8624 56.7328 23.1424 56.9888 22.4064C57.2448 21.6704 57.5648 20.9984 57.9488 20.3904C58.3648 19.7504 58.8448 19.2064 59.3888 18.7584C59.9328 18.2784 60.5568 17.9264 61.2608 17.7024C62.1568 17.4464 62.9248 17.5584 63.5648 18.0384C64.2048 18.5184 64.5248 19.2224 64.5248 20.1504C64.5568 20.5024 64.5088 20.8064 64.3808 21.0624C64.2848 21.3184 64.0448 21.5264 63.6608 21.6864C63.3088 21.7824 63.0208 21.7344 62.7968 21.5424C62.5728 21.3504 62.4128 21.1104 62.3168 20.8224C62.2208 20.5024 62.1088 20.3104 61.9808 20.2464C61.8528 20.1824 61.7088 20.1984 61.5488 20.2944C61.4208 20.3904 61.2768 20.5344 61.1168 20.7264C60.9888 20.8864 60.8608 21.0304 60.7328 21.1584Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M80.586 25.4784C81.098 24.8704 81.578 24.2784 82.026 23.7024C82.474 23.0944 82.922 22.4704 83.37 21.8304C83.498 21.6704 83.61 21.5424 83.706 21.4464C83.802 21.3184 83.898 21.1904 83.994 21.0624C84.186 20.8704 84.378 20.7424 84.57 20.6784C84.762 20.5824 84.986 20.6144 85.242 20.7744C85.498 20.9664 85.626 21.1744 85.626 21.3984C85.658 21.5904 85.594 21.7984 85.434 22.0224C85.146 22.4704 84.858 22.9184 84.57 23.3664C84.314 23.7824 84.01 24.2144 83.658 24.6624C83.21 25.2064 82.778 25.7664 82.362 26.3424C81.978 26.8864 81.53 27.3984 81.018 27.8784C80.282 28.6464 79.562 28.9664 78.858 28.8384C78.154 28.6784 77.594 28.1184 77.178 27.1584C76.826 26.1344 76.602 25.1584 76.506 24.2304C76.41 23.2704 76.314 22.3104 76.218 21.3504C75.77 21.6064 75.338 21.9424 74.922 22.3584C74.538 22.7744 74.17 23.2384 73.818 23.7504C73.466 24.2624 73.13 24.7744 72.81 25.2864C72.522 25.7984 72.234 26.2464 71.946 26.6304C71.85 26.7904 71.786 26.9824 71.754 27.2064C71.754 27.4304 71.738 27.6384 71.706 27.8304C71.578 28.5024 71.274 28.9664 70.794 29.2224C70.346 29.4464 69.834 29.3824 69.258 29.0304C68.586 28.6464 68.218 28.0544 68.154 27.2544C67.994 25.7824 67.946 24.0064 68.01 21.9264C68.074 19.8464 68.202 17.7824 68.394 15.7344C68.618 13.6544 68.89 11.7184 69.21 9.9264C69.562 8.1344 69.946 6.7744 70.362 5.8464C70.554 5.3664 70.842 5.0464 71.226 4.8864C71.642 4.6944 72.026 4.6304 72.378 4.6944C72.73 4.7584 73.002 4.9504 73.194 5.2704C73.386 5.5904 73.402 6.0224 73.242 6.5664C72.922 7.5904 72.634 8.8704 72.378 10.4064C72.154 11.9424 71.946 13.5264 71.754 15.1584C71.594 16.7584 71.482 18.3264 71.418 19.8624C71.354 21.3664 71.322 22.6144 71.322 23.6064C71.962 22.8064 72.586 22.0384 73.194 21.3024C73.802 20.5664 74.474 19.8784 75.21 19.2384C75.946 18.5984 76.634 18.3904 77.274 18.6144C77.946 18.8384 78.394 19.4304 78.618 20.3904C78.746 20.9344 78.826 21.4944 78.858 22.0704C78.89 22.6144 78.938 23.1744 79.002 23.7504C79.034 24.1984 79.066 24.6464 79.098 25.0944C79.162 25.5104 79.242 25.8464 79.338 26.1024C79.434 26.3264 79.578 26.4224 79.77 26.3904C79.962 26.3264 80.234 26.0224 80.586 25.4784Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M85.9223 23.9904C85.8263 24.6304 85.8583 25.0944 86.0183 25.3824C86.2103 25.6704 86.4663 25.8464 86.7863 25.9104C87.1383 25.9744 87.5223 25.9744 87.9383 25.9104C88.3863 25.8144 88.8183 25.6864 89.2343 25.5264C90.5143 25.1104 91.5863 24.5824 92.4503 23.9424C93.3143 23.3024 94.2263 22.5664 95.1863 21.7344C95.6023 21.3504 95.9543 21.1424 96.2423 21.1104C96.5303 21.0784 96.7383 21.1424 96.8663 21.3024C97.0263 21.4624 97.0903 21.7184 97.0583 22.0704C97.0263 22.3904 96.8823 22.7104 96.6263 23.0304C96.1783 23.6064 95.5543 24.2144 94.7543 24.8544C93.9863 25.4944 93.1383 26.0864 92.2103 26.6304C91.3143 27.1744 90.3863 27.6224 89.4263 27.9744C88.4983 28.2944 87.6503 28.4384 86.8823 28.4064C85.3783 28.2464 84.2903 27.6704 83.6183 26.6784C82.9143 25.6864 82.7703 24.4704 83.1863 23.0304C83.5063 21.9424 84.0343 20.9824 84.7703 20.1504C85.0903 19.7664 85.5383 19.3504 86.1143 18.9024C86.6903 18.4224 87.2823 18.0384 87.8903 17.7504C88.5303 17.4304 89.1543 17.2704 89.7623 17.2704C90.4023 17.2384 90.9463 17.4624 91.3943 17.9424C91.9383 18.4864 92.0823 19.1584 91.8263 19.9584C91.5703 20.7584 91.1063 21.5104 90.4343 22.2144C89.7943 22.8864 89.0423 23.4144 88.1783 23.7984C87.3463 24.1824 86.5943 24.2464 85.9223 23.9904ZM89.7143 19.5264C88.3063 20.1344 87.3943 20.9824 86.9783 22.0704C87.5543 21.9104 88.0663 21.6544 88.5143 21.3024C88.9943 20.9504 89.3943 20.3584 89.7143 19.5264Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M97.5518 26.6784C97.7118 26.8064 97.9838 26.6944 98.3678 26.3424C98.7838 25.9584 99.2318 25.4784 99.7118 24.9024C100.192 24.3264 100.688 23.7344 101.2 23.1264C101.744 22.4864 102.208 21.9904 102.592 21.6384C102.784 21.4784 102.976 21.3984 103.168 21.3984C103.392 21.3984 103.584 21.4624 103.744 21.5904C103.904 21.6864 104 21.8304 104.032 22.0224C104.096 22.2144 104.064 22.4384 103.936 22.6944C103.776 22.9824 103.584 23.2704 103.36 23.5584C102.72 24.2304 102.096 24.9184 101.488 25.6224C100.912 26.3264 100.304 27.0144 99.6638 27.6864C99.3118 28.0384 98.8798 28.3424 98.3678 28.5984C97.4398 29.0784 96.5918 29.1424 95.8238 28.7904C95.0878 28.4384 94.6398 27.7504 94.4798 26.7264C94.3198 25.7024 94.3518 24.5984 94.5758 23.4144C94.7998 22.2304 95.1198 21.1744 95.5358 20.2464C95.6958 19.8304 95.9358 19.5424 96.2558 19.3824C96.5758 19.2224 96.9118 19.2064 97.2638 19.3344C97.9998 19.5904 98.3198 20.1344 98.2238 20.9664C98.1918 21.4784 98.1118 22.0864 97.9838 22.7904C97.8878 23.4944 97.8078 24.1024 97.7438 24.6144C97.6798 24.8704 97.6478 25.1744 97.6478 25.5264C97.6478 25.8464 97.6158 26.2304 97.5518 26.6784ZM97.6958 15.6864C97.8558 15.6864 98.0158 15.7664 98.1758 15.9264C98.3678 16.0544 98.5278 16.2144 98.6558 16.4064C98.8158 16.5664 98.9278 16.7424 98.9918 16.9344C99.0878 17.1264 99.1198 17.2864 99.0878 17.4144C99.0238 17.5744 98.8958 17.7344 98.7038 17.8944C98.5118 18.0544 98.3358 18.1504 98.1758 18.1824C97.9838 18.1824 97.7918 18.1344 97.5998 18.0384C97.4078 17.9424 97.2318 17.8144 97.0718 17.6544C96.9438 17.4624 96.8318 17.2704 96.7358 17.0784C96.6398 16.8864 96.5918 16.7104 96.5918 16.5504C96.6558 16.2944 96.7838 16.0864 96.9758 15.9264C97.1678 15.7344 97.4078 15.6544 97.6958 15.6864Z","fill":"#F3FDFC"}}),_c('path',{attrs:{"d":"M109.717 19.5744C110.357 19.0944 111.013 18.9504 111.685 19.1424C112.357 19.3344 112.773 19.8464 112.933 20.6784C112.997 21.1264 113.029 21.6864 113.029 22.3584C113.029 23.0304 113.029 23.7024 113.029 24.3744C113.061 25.0144 113.109 25.5744 113.173 26.0544C113.269 26.5344 113.429 26.7904 113.653 26.8224C113.813 26.8224 114.037 26.6784 114.325 26.3904C114.709 26.0064 115.109 25.5424 115.525 24.9984C115.973 24.4544 116.389 23.9264 116.773 23.4144C117.157 22.8704 117.493 22.4064 117.781 22.0224C118.069 21.6064 118.261 21.3504 118.357 21.2544C118.485 21.1264 118.629 21.0784 118.789 21.1104C118.949 21.1424 119.077 21.2224 119.173 21.3504C119.301 21.4784 119.397 21.6384 119.461 21.8304C119.525 22.0224 119.541 22.1824 119.509 22.3104C119.445 22.6944 119.205 23.2064 118.789 23.8464C118.373 24.4864 117.893 25.1424 117.349 25.8144C116.805 26.4544 116.229 27.0464 115.621 27.5904C115.045 28.1024 114.549 28.4384 114.133 28.5984C113.525 28.8224 112.933 28.8224 112.357 28.5984C111.813 28.3744 111.413 27.8624 111.157 27.0624C110.997 26.5504 110.885 26.0064 110.821 25.4304C110.789 24.8224 110.741 24.2464 110.677 23.7024C110.645 23.4144 110.629 23.1264 110.629 22.8384C110.629 22.5184 110.613 22.1504 110.581 21.7344C110.037 22.2144 109.589 22.7264 109.237 23.2704C108.885 23.7824 108.549 24.3104 108.229 24.8544C107.909 25.3984 107.589 25.9424 107.269 26.4864C106.949 27.0304 106.565 27.5424 106.117 28.0224C105.573 28.4704 104.965 28.6944 104.293 28.6944C103.621 28.6624 103.093 28.3424 102.709 27.7344C102.453 27.3504 102.309 26.9024 102.277 26.3904C102.245 25.8784 102.213 25.3824 102.181 24.9024C102.181 23.7184 102.261 22.5344 102.421 21.3504C102.549 20.1344 102.805 18.9504 103.189 17.7984C103.285 17.5104 103.381 17.2704 103.477 17.0784C103.893 16.0864 104.469 15.7504 105.205 16.0704C105.525 16.1344 105.781 16.3424 105.973 16.6944C106.197 17.0144 106.229 17.4304 106.069 17.9424C105.845 18.6784 105.637 19.4304 105.445 20.1984C105.285 20.9664 105.173 21.6864 105.109 22.3584C105.045 23.0304 105.013 23.6224 105.013 24.1344C105.045 24.6144 105.141 24.9664 105.301 25.1904C105.493 25.3504 105.749 25.1904 106.069 24.7104C106.421 24.2304 106.789 23.6544 107.173 22.9824C107.589 22.3104 108.005 21.6384 108.421 20.9664C108.869 20.2944 109.301 19.8304 109.717 19.5744Z","fill":"#F3FDFC"}})])
}
var coupon_text_svgvue_type_template_id_968d6ef6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/coupon-text-svg.vue?vue&type=template&id=968d6ef6

// CONCATENATED MODULE: ./src/components/svg/decorations/coupon-text-svg.vue

var coupon_text_svg_script = {}


/* normalize component */

var coupon_text_svg_component = normalizeComponent(
  coupon_text_svg_script,
  coupon_text_svgvue_type_template_id_968d6ef6_render,
  coupon_text_svgvue_type_template_id_968d6ef6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var coupon_text_svg = (coupon_text_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/guru-logo-svg.vue?vue&type=template&id=29df2df3
var guru_logo_svgvue_type_template_id_29df2df3_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"94","height":"75","viewBox":"0 0 94 75","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56.2791 12.6572C56.2791 9.99343 56.2791 7.73945 55.7037 5.28057C55.3405 3.49532 54.7295 1.71007 53.8904 0H62.0903C61.3632 4.3568 59.6762 8.58466 57.0463 12.2474C56.9277 12.374 56.8092 12.4224 56.6454 12.4893C56.5441 12.5306 56.4256 12.5789 56.2791 12.6572ZM66.4439 0V0.567856C66.4439 1.18258 66.8275 1.38745 67.4029 1.18255C67.7864 0.977642 68.3618 0.567829 68.7454 0.158016C68.8116 0.105004 68.878 0.0523302 68.9448 0H66.4439ZM72.1593 0C70.8803 0.874423 69.6602 1.84445 68.5536 3.02669C68.8172 3.37872 69.0865 3.73074 69.3565 4.08381L69.357 4.08439C70.6587 5.78625 71.9789 7.51227 72.773 9.3788C73.3484 10.6082 74.1156 10.8132 75.2664 10.6082C77.5679 10.1984 80.0612 10.4034 82.3627 10.8132C82.7462 10.8132 83.3216 11.0181 83.5134 11.6328C82.8901 11.6328 82.2668 11.62 81.6435 11.6072C79.7735 11.5688 77.9035 11.5303 76.0335 11.8377C74.3074 12.0426 74.3074 12.2475 74.8827 13.8868C75.6499 16.1407 76.2253 18.1898 76.8007 20.4437C76.9925 20.8535 76.9925 21.4683 76.9925 21.8781C76.9925 21.9585 76.9998 22.0389 77.0074 22.1208C77.0382 22.4566 77.0714 22.8183 76.6089 23.3125C75.4581 19.6241 74.1156 16.1407 72.1977 12.8622C70.2797 9.58373 68.3618 6.5101 65.4849 4.05122C64.1424 8.14935 62.6081 11.8377 60.3066 14.9113C59.8271 15.526 59.3477 16.1919 58.8682 16.8577L58.8681 16.8579C58.3886 17.5238 57.9092 18.1898 57.4297 18.8045C56.6625 19.6241 56.8543 20.2388 57.6214 20.8536C58.005 21.0585 58.1968 21.2634 58.5804 21.6732C64.526 27.0007 69.5126 33.1479 73.3484 40.3197C74.3713 42.232 75.2237 44.1444 76.076 46.0568L76.0761 46.0569C76.5023 47.0132 76.9285 47.9695 77.3761 48.9258L77.9514 45.8522C79.1022 39.2952 83.3216 35.197 89.2672 34.5823C92.5276 34.3774 92.5276 34.3773 93.103 30.689V29.6645C93.8702 20.2388 91.7605 11.4279 87.7328 3.23161C87.1834 2.12045 86.6038 1.04361 85.9952 0H72.1593ZM73.9911 75C74.5361 71.336 74.5218 67.6525 74.5071 63.8832L74.5071 63.8782C74.5047 63.2676 74.5024 62.6548 74.5024 62.0395C74.5024 55.4825 72.7763 49.3353 69.8994 43.5979C66.0635 36.0164 60.8851 29.6643 54.556 24.3367C54.1724 23.722 53.597 23.1073 52.8298 23.1073C51.4873 25.3612 49.953 27.4103 47.8433 28.8446C46.6925 29.6642 46.3089 30.6888 46.3089 32.328V61.0149V61.0151C46.3089 63.4739 46.3089 65.7278 45.9253 67.9817C45.5163 70.822 44.3442 73.2545 42.5832 75H73.9911ZM27.2211 75C25.6837 73.4232 24.6048 71.1748 24.061 68.1866C23.8692 66.5474 23.6774 64.7032 23.6774 62.8591V46.2616V31.7133V31.7133C23.6774 30.8936 23.6774 30.0741 22.9103 29.4594C20.6088 27.8201 18.6908 25.5661 16.9647 22.9023C10.1451 28.4626 4.33308 34.9199 0 42.9458V67C0 71.4183 3.58173 75 8.00001 75H27.2211ZM0 34.615C3.77992 28.8451 8.37885 23.8481 13.7012 19.624C14.6602 18.8044 15.2356 17.9848 14.6602 16.5504C13.893 14.5014 13.893 12.4523 13.893 10.1984V10.1983C13.893 6.58166 14.7536 3.09636 16.2672 0H8C3.58172 0 0 3.58172 0 8V34.615ZM20.9626 0C18.9305 3.01786 17.7319 6.68802 17.7319 10.6081C17.7319 20.8534 25.7871 29.4594 35.185 29.2545C44.7746 29.0496 52.4463 20.6485 52.4463 10.6081C52.4463 6.68802 51.2476 3.01786 49.227 0H20.9626Z","fill":"#285E72"}})])
}
var guru_logo_svgvue_type_template_id_29df2df3_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/guru-logo-svg.vue?vue&type=template&id=29df2df3

// CONCATENATED MODULE: ./src/components/svg/decorations/guru-logo-svg.vue

var guru_logo_svg_script = {}


/* normalize component */

var guru_logo_svg_component = normalizeComponent(
  guru_logo_svg_script,
  guru_logo_svgvue_type_template_id_29df2df3_render,
  guru_logo_svgvue_type_template_id_29df2df3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var guru_logo_svg = (guru_logo_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-badge.vue?vue&type=script&lang=js





/* harmony default export */ var hg_badgevue_type_script_lang_js = ({
  components: {
    GuruLogoSvg: guru_logo_svg,
    CouponTextSvg: coupon_text_svg,
    OneHundredEuroSvg: one_hundred_euro_svg
  },
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    hasArrow: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleClick() {
      this.$emit('onClick')
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-badge.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_badgevue_type_script_lang_js = (hg_badgevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-badge.vue?vue&type=style&index=0&id=5eb3e4ad&prod&lang=postcss&scoped=true
var hg_badgevue_type_style_index_0_id_5eb3e4ad_prod_lang_postcss_scoped_true = __webpack_require__("d1e3");

// CONCATENATED MODULE: ./src/components/inputs/hg-badge.vue






/* normalize component */

var hg_badge_component = normalizeComponent(
  inputs_hg_badgevue_type_script_lang_js,
  hg_badgevue_type_template_id_5eb3e4ad_scoped_true_render,
  hg_badgevue_type_template_id_5eb3e4ad_scoped_true_staticRenderFns,
  false,
  null,
  "5eb3e4ad",
  null
  
)

/* harmony default export */ var hg_badge = (hg_badge_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-cruise-select.vue?vue&type=template&id=028423d2&scoped=true
var hg_cruise_selectvue_type_template_id_028423d2_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`hg-airport${_vm.isMobile ? '--mobile' : ''} ${
    _vm.show && _vm.isMobile
      ? 'tw-fixed tw-top-0 tw-left-0 tw-bottom-0 tw-z-50'
      : 'tw-relative'
  }`},[_c('div',{class:`hg-airport__select${_vm.isMobile ? '--mobile' : ''}`},[_c('div',[(!_vm.isMobile || !_vm.show)?_c('label',{staticClass:"select__label",attrs:{"id":`select__label-${_vm.uuid}`,"for":`select__input-${_vm.uuid}`}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('input',{class:`select__input${_vm.isMobile && _vm.show ? '--show' : ''} ${
          _vm.allowHotjarRecord ? 'data-hj-allow' : ''
        } ${_vm.theme ? _vm.theme : ''}`,attrs:{"type":"text","id":`select__input-${_vm.uuid}`,"name":`select__input-${_vm.uuid}`,"placeholder":_vm.$t('cruiseCompass.placeholder'),"aria-labelledby":`select__label-${_vm.uuid}`},domProps:{"value":_vm.show ? _vm.queryString : _vm.inputPlaceholder},on:{"click":function($event){return _vm.isShown()},"keyup":function($event){_vm.isShown(); _vm.queryString = $event.target.value}}}),(!_vm.isMobile && _vm.show)?_c('svg',{class:`select__delete ${_vm.queryString === '' ? 'tw-hidden' : ''}`,attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){_vm.queryString = ''}}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 15.333A7.332 7.332 0 0 0 15.334 8 7.332 7.332 0 0 0 8 .667 7.332 7.332 0 0 0 .667 8 7.332 7.332 0 0 0 8 15.333zm0-1.419A5.912 5.912 0 0 1 2.086 8 5.912 5.912 0 0 1 8 2.086 5.912 5.912 0 0 1 13.914 8 5.912 5.912 0 0 1 8 13.914zm3.01-3.572-.668.668a.355.355 0 0 1-.502 0L8 9.171l-1.839 1.84a.355.355 0 0 1-.503 0l-.668-.669a.355.355 0 0 1 0-.503L6.83 8 4.99 6.16a.355.355 0 0 1 0-.502l.668-.668a.355.355 0 0 1 .503 0l1.84 1.84L9.84 4.99a.355.355 0 0 1 .502 0l.668.668a.355.355 0 0 1 0 .503L9.171 8l1.84 1.838a.355.355 0 0 1 0 .503z","fill":"#9D9D9D"}})]):_vm._e()]),(_vm.isMobile && _vm.show)?_c('div',{staticClass:"hg-airport__mobile-headline"},[_c('h2',{staticClass:"mobile-headline__headline"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('svg',{staticClass:"mobile-headline__icon",attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.isNotShown()}}},[_c('path',{attrs:{"d":"m14.33 15.39 1.06-1.06a.375.375 0 0 0 0-.53L9.591 8 14.4 3.193l.991-.992a.375.375 0 0 0 0-.53L14.33.611a.375.375 0 0 0-.53 0L8 6.408 2.201.61a.375.375 0 0 0-.53 0L.61 1.672a.375.375 0 0 0 0 .53L6.41 8l-5.8 5.798a.375.375 0 0 0 0 .53l1.06 1.061a.375.375 0 0 0 .53 0L8 9.591l4.808 4.808.991.991a.375.375 0 0 0 .53 0z","fill":"#323231"}})])]):_vm._e(),(_vm.isMobile && _vm.show)?_c('div',{staticClass:"select--mobile",on:{"click":_vm.isShown}},[_c('input',{class:`select__input-mobile ${_vm.theme ? _vm.theme : ''}`,attrs:{"type":"text","id":`select__input-mobile-${_vm.uuid}`,"name":`select__input-mobile-${_vm.uuid}`,"placeholder":_vm.$t('cruiseCompass.placeholder')},domProps:{"value":_vm.queryString},on:{"keyup":function($event){_vm.queryString = $event.target.value}}}),_c('svg',{class:`select__delete--mobile ${
          _vm.queryString === '' ? 'tw-hidden' : ''
        }`,attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){_vm.queryString = ''}}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 15.333A7.332 7.332 0 0 0 15.334 8 7.332 7.332 0 0 0 8 .667 7.332 7.332 0 0 0 .667 8 7.332 7.332 0 0 0 8 15.333zm0-1.419A5.912 5.912 0 0 1 2.086 8 5.912 5.912 0 0 1 8 2.086 5.912 5.912 0 0 1 13.914 8 5.912 5.912 0 0 1 8 13.914zm3.01-3.572-.668.668a.355.355 0 0 1-.502 0L8 9.171l-1.839 1.84a.355.355 0 0 1-.503 0l-.668-.669a.355.355 0 0 1 0-.503L6.83 8 4.99 6.16a.355.355 0 0 1 0-.502l.668-.668a.355.355 0 0 1 .503 0l1.84 1.84L9.84 4.99a.355.355 0 0 1 .502 0l.668.668a.355.355 0 0 1 0 .503L9.171 8l1.84 1.838a.355.355 0 0 1 0 .503z","fill":"#9D9D9D"}})])]):_vm._e()]),(_vm.show)?_c('div',{class:`hg-airport__results${_vm.isMobile ? '--mobile' : ''}`},[(_vm.show)?_c('div',{class:`hg-airport__select-results${_vm.isMobile ? '--mobile' : ''} ${
        _vm.searchCruises.length <= 0 && _vm.queryString !== ''
          ? 'tw-pb-0'
          : 'tw-pb-20'
      }`},[(_vm.selectedCruises.length > 0)?_c('div',{staticClass:"select-results__selection-tags"},_vm._l((_vm.selectedCruises),function(airport){return _c('button',{key:airport.id,class:`selection-tags__tag ${_vm.theme ? _vm.theme : ''}`,on:{"click":function($event){return _vm.selectSearchedCruise(airport)}}},[_c('svg',{staticClass:"tw-block tw-my-auto",attrs:{"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m8.36 9.02.645-.645a.412.412 0 0 0 0-.582L6.227 5.016 9.004 2.24a.412.412 0 0 0 0-.582l-.645-.645a.412.412 0 0 0-.582 0L5 3.789 2.223 1.012a.412.412 0 0 0-.582 0l-.646.645a.412.412 0 0 0 0 .582l2.778 2.777L.995 7.793a.412.412 0 0 0 0 .582l.646.646c.16.16.421.16.582 0L5 6.243 7.777 9.02c.16.161.421.161.582 0z","fill":"#323231"}})]),_c('p',{staticClass:"tw-m-0"},[_vm._v(_vm._s(airport.name.split(' ')[0]))])])}),0):_vm._e(),(_vm.queryString === '')?_c('div',[_c('h3',{class:`hg-airport__subheadline ${_vm.theme ? _vm.theme : ''}`},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._l((_vm.sortedCruises),function(airport){return _c('button',{key:airport.id,staticClass:"cruise-item",on:{"click":function($event){return _vm.selectSearchedCruise(airport)}}},[_c('span',{staticClass:"hg-airport__list-element"},[_c('div',[_c('div',{class:`hg-airport__checkbox ${
                  _vm.selectedCruises.filter((el) => el.name === airport.name)
                    .length > 0
                    ? 'tw-hidden'
                    : ''
                }`}),_c('svg',{class:`hg-airport__checkbox__svg ${
                  _vm.selectedCruises.filter((el) => el.name === airport.name)
                    .length > 0
                    ? ''
                    : 'tw-hidden'
                }`,attrs:{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":".5","width":"16","height":"16","rx":"4","fill":_vm.checkboxBackgroundColor}}),_c('path',{attrs:{"d":"m6.834 11.552 6.495-6.495a.26.26 0 0 0 0-.368l-.613-.613a.26.26 0 0 0-.367 0L6.65 9.775 4.557 7.68a.26.26 0 0 0-.368 0l-.613.612a.26.26 0 0 0 0 .368l2.89 2.89a.26.26 0 0 0 .368 0z","fill":"#323231"}})])]),_c('div',{staticClass:"hg-airport__list-element--desciption"},[_c('p',{staticClass:"hg-airport__list-element--desciption--name"},[_vm._v(" "+_vm._s(airport.name)+" ")])])])])})],2):_vm._e(),(_vm.queryString !== '')?_c('div',{staticClass:"hg-airport__search"},[_vm._l((_vm.searchCruises),function(airport){return _c('div',{key:airport.id,on:{"click":function($event){return _vm.selectSearchedCruise(airport)}}},[_c('span',{staticClass:"hg-airport__list-element"},[_c('div',[_c('div',{class:`hg-airport__checkbox ${
                  _vm.selectedCruises.filter((el) => el.name === airport.name)
                    .length > 0
                    ? 'tw-hidden'
                    : ''
                }`}),_c('svg',{class:`hg-airport__checkbox__svg ${
                  _vm.selectedCruises.filter((el) => el.name === airport.name)
                    .length > 0
                    ? ''
                    : 'tw-hidden'
                }`,attrs:{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":".5","width":"16","height":"16","rx":"4","fill":_vm.checkboxBackgroundColor}}),_c('path',{attrs:{"d":"m6.834 11.552 6.495-6.495a.26.26 0 0 0 0-.368l-.613-.613a.26.26 0 0 0-.367 0L6.65 9.775 4.557 7.68a.26.26 0 0 0-.368 0l-.613.612a.26.26 0 0 0 0 .368l2.89 2.89a.26.26 0 0 0 .368 0z","fill":"#323231"}})])]),_c('div',{staticClass:"hg-airport__list-element--desciption"},[_c('p',{staticClass:"hg-airport__list-element--desciption--name"},[_vm._v(" "+_vm._s(airport.name)+" ")])])])])}),(_vm.airportEmpty())?_c('div',[_c('div',{staticClass:"search__no-result"},[_c('NoResultSvg',{staticClass:"no-results__img"}),_c('h2',{staticClass:"no-results__heading"},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.noMatch'))+" ")]),_c('p',{staticClass:"no-results__description-one"},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.cruiseLineNoMatch'))+" ")]),_c('p',{staticClass:"no-results__description-two"},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.cruiseLineNoMatch2'))+" ")])],1)]):_vm._e()],2):_vm._e()]):_vm._e(),(_vm.show && (!_vm.airportEmpty() || _vm.selectedCruises.length > 0))?_c('div',{class:`hg-airport__checkout${_vm.isMobile ? '--mobile' : ''}`},[_c('button',{class:`checkout__button${_vm.isMobile ? '--mobile' : ''} ${_vm.theme ? _vm.theme : ''}`,on:{"click":function($event){_vm.checkout()
          _vm.isNotShown()}}},[_vm._v(" "+_vm._s(_vm.$t('inputs.buttonTextApply'))+" ")])]):_vm._e()]):_vm._e()])
}
var hg_cruise_selectvue_type_template_id_028423d2_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inputs/hg-cruise-select.vue?vue&type=template&id=028423d2&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inputs/hg-cruise-select.vue?vue&type=script&lang=js



/* harmony default export */ var hg_cruise_selectvue_type_script_lang_js = ({
  mixins: [clickAwayMixin],

  props: {
    label: String,
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    singleCruiseLine: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    selectedCruises: [],
    show: false,
    inputPlaceholder: '',
    queryString: '',
    sortedCruises: [],
    timeoutRunning: false,
    searchCruises: [],
    uuid: crypto.randomUUID()
  }),

  computed: {
    checkboxBackgroundColor() {
      switch (this.theme) {
        case "bild":
          return "#09de85"
        default:
          return "#00D5E0"
      }
    }
  },

  mounted() {
    this.addCloseOnKey()
  },

  onBeforeUnmount() {
    document.removeEventListener('click', this.closeOnKey)
  },

  watch: {
    selectedCruises: {
      handler(val, oldVal) {
        if (this.selectedCruises.length > 0) {
          this.inputPlaceholder = `${
            this.selectedCruises[0].name.split(' ')[0]
          } ${this.selectedCruises.length > 1 ? '+' : ''}${
            this.selectedCruises.length > 1
              ? this.selectedCruises.length - 1
              : ''
          }`
          this.queryString = ''
        } else {
          this.inputPlaceholder = ''
          this.queryString = ''
        }
      },
      deep: true,
    },

    options() {
      this.searchCruises = this.options
      this.sortedCruises = [...this.options]
      this.sortedCruises.sort((a, b) => {
        if (a.name < b.name) {
          return -1
        }
        if (a.name > b.name) {
          return 1
        }
        return 0
      })
    },

    queryString() {
      this.search()
    },

    searchedCruises() {
      this.searchCruises = this.searchedCruises
    },
  },

  methods: {
    addCloseOnKey() {
      document.addEventListener('keyup', this.closeOnKey)
    },

    closeOnKey(e) {
      if (e.key === 'Escape') {
        this.isNotShown()
      }
    },

    airportEmpty() {
      return this.searchCruises.length <= 0 && this.queryString !== ''
    },

    selectSearchedCruise(cruise) {
      if (!this.singleCruiseLine) {
        this.selectedCruises.filter((el) => el.name === cruise.name).length > 0
          ? this.selectedCruises.splice(this.selectedCruises.indexOf(cruise), 1)
          : this.selectedCruises.push(cruise)

        this.checkout()
      } else {
        this.selectedCruises = [cruise]
        this.checkout()
      }
    },

    search() {
      const timeout = setTimeout(() => {
        this.$emit('onChangeSearchTerm', this.queryString)
        this.timeoutRunning = false
      }, 250)

      if (this.timeoutRunning) {
        clearTimeout(timeout)
      } else {
        this.timeoutRunning = true
        timeout
      }
    },

    isShown() {
      this.show = true
    },
    isNotShown() {
      this.show = false
    },

    checkout() {
      this.$emit('onSelect', this.selectedCruises)
    },
  },
});

// CONCATENATED MODULE: ./src/components/inputs/hg-cruise-select.vue?vue&type=script&lang=js
 /* harmony default export */ var inputs_hg_cruise_selectvue_type_script_lang_js = (hg_cruise_selectvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/inputs/hg-cruise-select.vue?vue&type=style&index=0&id=028423d2&prod&scoped=true&lang=postcss
var hg_cruise_selectvue_type_style_index_0_id_028423d2_prod_scoped_true_lang_postcss = __webpack_require__("339a");

// CONCATENATED MODULE: ./src/components/inputs/hg-cruise-select.vue






/* normalize component */

var hg_cruise_select_component = normalizeComponent(
  inputs_hg_cruise_selectvue_type_script_lang_js,
  hg_cruise_selectvue_type_template_id_028423d2_scoped_true_render,
  hg_cruise_selectvue_type_template_id_028423d2_scoped_true_staticRenderFns,
  false,
  null,
  "028423d2",
  null
  
)

/* harmony default export */ var hg_cruise_select = (hg_cruise_select_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-alert-box.vue?vue&type=template&id=c9d4a024&scoped=true
var hg_alert_boxvue_type_template_id_c9d4a024_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['hg-alert-box', _vm.type, !_vm.isVisible && 'hg-alert-box--hidden']},[(_vm.closable)?_c('button',{staticClass:"hg-close-button hg-button hg-button-- hg-button--rounded",attrs:{"type":"button"},on:{"click":function($event){_vm.isVisible = false}}},[_c('hg-icon',{attrs:{"name":"times","pack":"fal"}})],1):_vm._e(),(_vm.type !== 'flat-info')?_c('div',{staticClass:"svg-container"},[(_vm.type === 'success')?[_c('hg-icon',{staticClass:"tw-mt-px",attrs:{"name":"check-circle"}})]:(_vm.type === 'error')?[_c('hg-icon',{attrs:{"name":"exclamation-triangle"}})]:[_c('hg-icon',{staticClass:"tw-mt-px",attrs:{"name":"info-circle"}})]],2):_vm._e(),_c('div',{staticClass:"hg-alert-box__message hg-content"},[(_vm.title)?_c('div',{staticClass:"hg-alert-box__title hg-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("default")],2)])
}
var hg_alert_boxvue_type_template_id_c9d4a024_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-alert-box.vue?vue&type=template&id=c9d4a024&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-alert-box.vue?vue&type=script&lang=js

/* harmony default export */ var hg_alert_boxvue_type_script_lang_js = ({
  props: {
    type: {
      type: String,
      default: 'info',
    },
    title: {
      type: String,
      default: '',
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isVisible: true,
  }),
});

// CONCATENATED MODULE: ./src/components/ui/hg-alert-box.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_alert_boxvue_type_script_lang_js = (hg_alert_boxvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-alert-box.vue?vue&type=style&index=0&id=c9d4a024&prod&scoped=true&lang=postcss
var hg_alert_boxvue_type_style_index_0_id_c9d4a024_prod_scoped_true_lang_postcss = __webpack_require__("d247");

// CONCATENATED MODULE: ./src/components/ui/hg-alert-box.vue






/* normalize component */

var hg_alert_box_component = normalizeComponent(
  ui_hg_alert_boxvue_type_script_lang_js,
  hg_alert_boxvue_type_template_id_c9d4a024_scoped_true_render,
  hg_alert_boxvue_type_template_id_c9d4a024_scoped_true_staticRenderFns,
  false,
  null,
  "c9d4a024",
  null
  
)

/* harmony default export */ var hg_alert_box = (hg_alert_box_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-card-carousel.vue?vue&type=template&id=a171d01a&scoped=true
var hg_card_carouselvue_type_template_id_a171d01a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-carousel-wrapper"},[_c('div',{ref:"slider",staticClass:"hg-carousel"},[_vm._t("default"),_c('div',{staticClass:"hg-carousel-slide hg-carousel-slide--spacer"})],2),(_vm.showControls)?_c('div',[_c('HgButton',{staticClass:"hg-carousel-navigation hg-carousel-navigation--left",attrs:{"aria-label":"Slide left","color":"teal","rounded":true,"disabled":_vm.activeSlideIndex === 0},on:{"onClick":_vm.prevSlide}},[_c('HgIcon',{attrs:{"name":"chevron-left"}})],1),_c('HgButton',{staticClass:"hg-carousel-navigation hg-carousel-navigation--right",attrs:{"aria-label":"Slide right","color":"teal","rounded":true,"disabled":_vm.disableRightScroll},on:{"onClick":_vm.nextSlide}},[_c('HgIcon',{attrs:{"name":"chevron-right"}})],1)],1):_vm._e(),(_vm.showIndicators)?_c('div',{ref:"indicators",staticClass:"hg-carousel-indicators"},_vm._l((_vm.numSlides),function(slideNumber,index){return _c('button',{key:`slide-${index}`,staticClass:"hg-carousel-indicator-button",class:index === _vm.activeSlideIndex
          ? 'hg-carousel-indicator-button--active'
          : '',on:{"click":function($event){return _vm.scrollTo(index)}}},[_vm._v(" "+_vm._s(slideNumber)+" ")])}),0):_vm._e()])
}
var hg_card_carouselvue_type_template_id_a171d01a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-card-carousel.vue?vue&type=template&id=a171d01a&scoped=true

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__("f7fe");
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/coins-svg.vue?vue&type=template&id=03dbe43c
var coins_svgvue_type_template_id_03dbe43c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 16c3.312 0 6-1.119 6-2.5v-1.647c2.328-.344 4-1.266 4-2.353v-7C16 1.119 13.312 0 10 0 6.687 0 4 1.119 4 2.5v1.644C1.672 4.487 0 5.412 0 6.5v7C0 14.881 2.687 16 6 16zm4-11.5c-.156 0-.306-.01-.46-.016-.812-.247-1.774-.412-2.824-.465C5.969 3.75 5.5 3.394 5.5 3c0-.828 2.016-1.5 4.5-1.5s4.5.672 4.5 1.5-2.016 1.5-4.5 1.5zm2 2.834V6.5a1.21 1.21 0 00-.213-.653c1.057-.166 2-.463 2.713-.869v1.406c-.222.26-1.09.707-2.5.95zM6 8.5c-2.484 0-4.5-.672-4.5-1.5S3.516 5.5 6 5.5s4.5.672 4.5 1.5S8.484 8.5 6 8.5zm6 1.834v-1.49c.969-.144 1.834-.378 2.5-.694v1.234c-.222.26-1.09.707-2.5.95zM6 11.5c-2.612 0-4.188-.75-4.5-1.116V8.981C2.6 9.606 4.206 10 6 10s3.4-.397 4.5-1.019v1.403C10.187 10.75 8.612 11.5 6 11.5zm0 3c-2.612 0-4.188-.75-4.5-1.116V12.15c1.1.519 2.706.85 4.5.85s3.4-.331 4.5-.85v1.234C10.187 13.75 8.612 14.5 6 14.5z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var coins_svgvue_type_template_id_03dbe43c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/coins-svg.vue?vue&type=template&id=03dbe43c

// CONCATENATED MODULE: ./src/components/svg/attributes/coins-svg.vue

var coins_svg_script = {}


/* normalize component */

var coins_svg_component = normalizeComponent(
  coins_svg_script,
  coins_svgvue_type_template_id_03dbe43c_render,
  coins_svgvue_type_template_id_03dbe43c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var coins_svg = (coins_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-card-carousel.vue?vue&type=script&lang=js



const SCROLL_DEBOUNCE = 100
const RESIZE_DEBOUNCE = 410

/* harmony default export */ var hg_card_carouselvue_type_script_lang_js = ({
  props: {
    showControls: {
      type: Boolean,
      default: true,
    },
    showIndicators: {
      type: Boolean,
      default: true,
    },
    isResponsive: {
      type: Boolean,
      default: false,
    },
    breakpoints: {
      type: Array,
      default: () => [
        {
          minWidth: 550,
          slideWidth: '80%',
        },
        {
          minWidth: 768,
          slideWidth: '60%',
        },
        {
          minWidth: 920,
          slideWidth: '55%',
        },
      ],
    },
  },
  data: () => ({
    numSlides: 0,
    activeSlideIndex: 0,
    slideWidth: 0,
    disableRightScroll: false,
    scrollLeft: 0,
    scrollWidth: 0,
    clickScroll: false,
    margin: 24,
  }),
  mounted() {
    this.handleDebouncedScroll = lodash_debounce_default()(this.handleScroll, 100)
    this.handleDebouncedResize = lodash_debounce_default()(this.handleResize, 300)

    this.$refs.slider.addEventListener('scroll', this.handleDebouncedScroll)
    window.addEventListener('resize', this.handleDebouncedResize)

    this.scrollWidth = this.$refs.slider.scrollWidth
    this.numSlides = this.$refs.slider.childElementCount - 1
    this.slideWidth =
      this.$refs.slider.firstElementChild.clientWidth + this.margin

    this.indicators = this.showIndicators
      ? Array.from(this.$refs.indicators.children)
      : []
    this.slides = Array.from(this.$refs.slider.children)

    setTimeout(() => {
      this.handleResize()
    }, 100)
  },
  beforeDestroy() {
    this.$refs.slider.removeEventListener('scroll', this.handleDebouncedScroll)
    this.$refs.slider.removeEventListener('resize', this.handleDebouncedScroll)
  },
  methods: {
    handleScroll() {
      if (this.clickScroll === false) {
        if (!this.$refs.slider) return
        this.$emit('onHandleScroll')

        this.scrollLeft = this.$refs.slider.scrollLeft

        // if (scrollLeft > (this.numSlides - 1) * slideWidth + 16) {
        //   // Last Slide (offset problem)
        //   this.activeSlideIndex = this.numSlides - 1
        // } else {
        //   this.activeSlideIndex = Math.floor(scrollLeft / slideWidth)
        // }
        // TODO: Have ideas about bounding right scroll + indicator display?
        //const diff = this.slideWidth - scrollLeft;

        //this.activeSlideIndex = Math.floor(scrollLeft / this.slideWidth)

        //if (scrollLeft % this.slideWidth === 0) scrollLeft = this.slideWidth
        this.activeSlideIndex = Math.floor(this.scrollLeft / this.slideWidth)

        if (
          window.innerWidth >= 380 &&
          this.scrollLeft + window.innerWidth + this.slideWidth / 2 >
            this.scrollWidth
        )
          this.activeSlideIndex++

        this.scrollLeft = this.activeSlideIndex * this.slideWidth
      }
      this.checkDisableButton()
      this.clickScroll = false
    },
    handleResize() {
      if (!this.$refs.indicators || !this.$refs.indicators.children) return
      if (!this.isResponsive) return

      let slideWidth = '100%'

      this.breakpoints.forEach((breakpoint) => {
        if (window.innerWidth > breakpoint.minWidth) {
          slideWidth = breakpoint.slideWidth
        }
      })

      this.scrollTo(0)

      this.slides.forEach((slide) => {
        slide.style.flexBasis = slideWidth
      })
    },
    nextSlide() {
      this.scrollTo(this.activeSlideIndex + 1)
    },
    prevSlide() {
      this.scrollTo(this.activeSlideIndex - 1)
    },
    scrollTo(index) {
      this.clickScroll = true
      this.activeSlideIndex = index
      this.scrollLeft = index * this.slideWidth

      this.$refs.slider.scrollTo({
        left: this.scrollLeft,
        behaviour: 'smooth',
      })
    },
    checkDisableButton() {
      this.disableRightScroll =
        this.scrollLeft + window.innerWidth > this.scrollWidth ? true : false
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-card-carousel.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_card_carouselvue_type_script_lang_js = (hg_card_carouselvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-card-carousel.vue?vue&type=style&index=0&id=a171d01a&prod&lang=postcss&scoped=true
var hg_card_carouselvue_type_style_index_0_id_a171d01a_prod_lang_postcss_scoped_true = __webpack_require__("f353");

// CONCATENATED MODULE: ./src/components/ui/hg-card-carousel.vue






/* normalize component */

var hg_card_carousel_component = normalizeComponent(
  ui_hg_card_carouselvue_type_script_lang_js,
  hg_card_carouselvue_type_template_id_a171d01a_scoped_true_render,
  hg_card_carouselvue_type_template_id_a171d01a_scoped_true_staticRenderFns,
  false,
  null,
  "a171d01a",
  null
  
)

/* harmony default export */ var hg_card_carousel = (hg_card_carousel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-carousel-slide.vue?vue&type=template&id=54d81964
var hg_carousel_slidevue_type_template_id_54d81964_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"vsSlide"},[_vm._t("default")],2)
}
var hg_carousel_slidevue_type_template_id_54d81964_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-carousel-slide.vue?vue&type=template&id=54d81964

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-carousel-slide.vue?vue&type=script&lang=js

/* harmony default export */ var hg_carousel_slidevue_type_script_lang_js = ({});

// CONCATENATED MODULE: ./src/components/ui/hg-carousel-slide.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_carousel_slidevue_type_script_lang_js = (hg_carousel_slidevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/ui/hg-carousel-slide.vue





/* normalize component */

var hg_carousel_slide_component = normalizeComponent(
  ui_hg_carousel_slidevue_type_script_lang_js,
  hg_carousel_slidevue_type_template_id_54d81964_render,
  hg_carousel_slidevue_type_template_id_54d81964_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_carousel_slide = (hg_carousel_slide_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-collapse.vue?vue&type=template&id=b16ccb34&scoped=true
var hg_collapsevue_type_template_id_b16ccb34_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-collapse"},[_c('button',{staticClass:"hg-collapse-trigger hg-button",on:{"click":function($event){$event.preventDefault();return _vm.toggleCollapse.apply(null, arguments)}}},[_c('span',{staticClass:"hg-collapse-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('hg-icon',{staticClass:"hg-collapse-chevron",class:{ 'hg-collapse-chevron--active': _vm.isCollapsibleOpen },attrs:{"name":"chevron-down","size":"small"}})],1),(_vm.isCollapsibleOpen)?_c('div',{staticClass:"hg-collapse-content"},[_vm._t("default")],2):_vm._e()])
}
var hg_collapsevue_type_template_id_b16ccb34_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-collapse.vue?vue&type=template&id=b16ccb34&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-collapse.vue?vue&type=script&lang=js

/* harmony default export */ var hg_collapsevue_type_script_lang_js = ({
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    isCollapsibleOpen: false,
  }),
  methods: {
    toggleCollapse() {
      this.isCollapsibleOpen = !this.isCollapsibleOpen
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-collapse.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_collapsevue_type_script_lang_js = (hg_collapsevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-collapse.vue?vue&type=style&index=0&id=b16ccb34&prod&scoped=true&lang=postcss
var hg_collapsevue_type_style_index_0_id_b16ccb34_prod_scoped_true_lang_postcss = __webpack_require__("934e");

// EXTERNAL MODULE: ./src/components/ui/hg-collapse.vue?vue&type=style&index=1&id=b16ccb34&prod&lang=postcss
var hg_collapsevue_type_style_index_1_id_b16ccb34_prod_lang_postcss = __webpack_require__("6541");

// CONCATENATED MODULE: ./src/components/ui/hg-collapse.vue







/* normalize component */

var hg_collapse_component = normalizeComponent(
  ui_hg_collapsevue_type_script_lang_js,
  hg_collapsevue_type_template_id_b16ccb34_scoped_true_render,
  hg_collapsevue_type_template_id_b16ccb34_scoped_true_staticRenderFns,
  false,
  null,
  "b16ccb34",
  null
  
)

/* harmony default export */ var hg_collapse = (hg_collapse_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-icon.vue?vue&type=template&id=6e5a53c9
var hg_iconvue_type_template_id_6e5a53c9_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['hg-icon', `hg-icon--${_vm.color}`, `hg-icon--${_vm.size}`]},[(_vm.computedTag === 'font-awesome-icon')?[_c('font-awesome-icon',{attrs:{"icon":[_vm.pack, _vm.name.toLowerCase()]}})]:[_c(_vm.computedTag,{tag:"component"})]],2)
}
var hg_iconvue_type_template_id_6e5a53c9_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-icon.vue?vue&type=template&id=6e5a53c9

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-icon.vue?vue&type=script&lang=js

const fontAwesomeSvgNames = [
  'bars',
  'building',
  'bus',
  'camera',
  'sparkles',
  'chevron-left',
  'chevron-right',
  'chevron-down',
  'plane',
  'chevron-up',
  'check-circle',
  'clock',
  'copy',
  'do-not-enter',
  'envelope',
  'exclamation-triangle',
  'exclamation-circle',
  'equals',
  'flame',
  'heart',
  'home-alt',
  'info-circle',
  'long-arrow-right',
  'minus',
  'map-marker-alt',
  'plus',
  'phone',
  'phone-alt',
  'ship',
  'star',
  'suitcase',
  'star-half',
  'share',
  'search',
  'times',
  'times-circle',
  'th',
  'user',
  'facebook',
  'whatsapp',
  'twitter',
  'pinterest',
  'facebook-messenger',
  'globe-americas'
]
const customSvgNames = [
  'adults',
  'baby-bottle',
  'baby',
  'beach',
  'biking',
  'calendar-image',
  'check',
  'child',
  'clock',
  'coins',
  'couple',
  'deck-chair-sun',
  'diving',
  'doctor',
  'entertainment',
  'family',
  'fitness',
  'garage-car',
  'golf-club',
  'hand-wash',
  'hiking',
  'hotel',
  'massage',
  'maxi-club',
  'mini-club',
  'no-smoking',
  'parking',
  'pet',
  'place',
  'pool',
  'pool-kids',
  'restaurant',
  'sauna',
  'star',
  'theater-masks',
  'train-subway',
  'twenty-four-reception',
  'washer',
  'watersports',
  'wellness',
  'wheelchair',
  'wintersport',
  'wlan',
]
const packs = ['far', 'fas', 'fab', 'fal']


/* harmony default export */ var hg_iconvue_type_script_lang_js = ({
  props: {
    name: {
      type: String,
      default: 'check',
    },
    size: {
      type: String,
      default: 'regular',
    },
    color: {
      type: String,
      default: 'teal',
    },
    pack: {
      type: String,
      default: 'far',
    },
  },
  methods: {
    mapNameToComponent(name) {
      const iconName = name.toLowerCase().replace('_', '-')
      if (fontAwesomeSvgNames.includes(iconName)) {
        return 'font-awesome-icon'
      } else if (customSvgNames.includes(iconName)) {
        return `${iconName}-svg`
      }
    },
  },
  computed: {
    computedTag() {
      const tag = this.mapNameToComponent(this.name)
      return tag
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-icon.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_iconvue_type_script_lang_js = (hg_iconvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-icon.vue?vue&type=style&index=0&id=6e5a53c9&prod&lang=postcss
var hg_iconvue_type_style_index_0_id_6e5a53c9_prod_lang_postcss = __webpack_require__("0237");

// CONCATENATED MODULE: ./src/components/ui/hg-icon.vue






/* normalize component */

var hg_icon_component = normalizeComponent(
  ui_hg_iconvue_type_script_lang_js,
  hg_iconvue_type_template_id_6e5a53c9_render,
  hg_iconvue_type_template_id_6e5a53c9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_icon = (hg_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-modal.vue?vue&type=template&id=3c3c5ed6
var hg_modalvue_type_template_id_3c3c5ed6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":`${_vm.isFullscreen ? 'hg-modal-slide' : 'hg-modal-fade'}`}},[(_vm.show)?_c('div',{ref:"wrapper",staticClass:"hg-modal-wrapper",class:_vm.isFullscreen && 'hg-modal-wrapper--fullscreen',on:{"click":_vm.wrapperClick}},[_c('div',{staticClass:"hg-modal-content",class:_vm.isFullscreen && 'hg-modal-content--fullscreen'},[_c('div',{class:['hg-modal-scroll-content', _vm.isSmallContent && 'hg-modal-scroll-content--small']},[_c('button',{staticClass:"hg-modal-close-button hg-button hg-button--white",on:{"click":_vm.closeModal}},[_c('hg-icon',{attrs:{"name":"times","pack":"fal"}})],1),_vm._t("default")],2)])]):_vm._e()])
}
var hg_modalvue_type_template_id_3c3c5ed6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-modal.vue?vue&type=template&id=3c3c5ed6

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-modal.vue?vue&type=script&lang=js

/* harmony default export */ var hg_modalvue_type_script_lang_js = ({
  props: {
    isFullscreen: {
      type: Boolean,
      default: false,
    },
    isSmallContent: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    show: false,
  }),
  methods: {
    closeModal() {
      this.show = false
      this.$emit('onClose')
    },
    wrapperClick(event) {
      if (event.target === this.$refs.wrapper) {
        this.closeModal()
      }
    },
    onKeyup(e) {
      if (e.keyCode === 27) {
        this.closeModal()
      }
    },
  },
  mounted() {
    document.documentElement.style.setProperty(
      'overflow',
      'hidden',
      'important'
    )
    document.addEventListener('keyup', this.onKeyup)
    this.show = true
  },
  destroyed() {
    document.documentElement.style.setProperty('overflow', 'auto', 'important')
    document.removeEventListener('keyup', this.onKeyup)
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-modal.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_modalvue_type_script_lang_js = (hg_modalvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-modal.vue?vue&type=style&index=0&id=3c3c5ed6&prod&lang=postcss
var hg_modalvue_type_style_index_0_id_3c3c5ed6_prod_lang_postcss = __webpack_require__("28c9");

// CONCATENATED MODULE: ./src/components/ui/hg-modal.vue






/* normalize component */

var hg_modal_component = normalizeComponent(
  ui_hg_modalvue_type_script_lang_js,
  hg_modalvue_type_template_id_3c3c5ed6_render,
  hg_modalvue_type_template_id_3c3c5ed6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_modal = (hg_modal_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-loading-bar.vue?vue&type=template&id=2e3318a0&scoped=true
var hg_loading_barvue_type_template_id_2e3318a0_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar"},[(_vm.loading)?_c('div',{staticClass:"progress"}):_vm._e()])
}
var hg_loading_barvue_type_template_id_2e3318a0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-loading-bar.vue?vue&type=template&id=2e3318a0&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-loading-bar.vue?vue&type=script&lang=js

/* harmony default export */ var hg_loading_barvue_type_script_lang_js = ({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-loading-bar.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_loading_barvue_type_script_lang_js = (hg_loading_barvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-loading-bar.vue?vue&type=style&index=0&id=2e3318a0&prod&scoped=true&lang=postcss
var hg_loading_barvue_type_style_index_0_id_2e3318a0_prod_scoped_true_lang_postcss = __webpack_require__("8037");

// CONCATENATED MODULE: ./src/components/ui/hg-loading-bar.vue






/* normalize component */

var hg_loading_bar_component = normalizeComponent(
  ui_hg_loading_barvue_type_script_lang_js,
  hg_loading_barvue_type_template_id_2e3318a0_scoped_true_render,
  hg_loading_barvue_type_template_id_2e3318a0_scoped_true_staticRenderFns,
  false,
  null,
  "2e3318a0",
  null
  
)

/* harmony default export */ var hg_loading_bar = (hg_loading_bar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-loading-bubble.vue?vue&type=template&id=a0d4b67c&scoped=true
var hg_loading_bubblevue_type_template_id_a0d4b67c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-loading-bubble"},[_c('div',{class:`double-bounce1 ${_vm.theme}`}),_c('div',{class:`double-bounce2 ${_vm.theme}`})])
}
var hg_loading_bubblevue_type_template_id_a0d4b67c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-loading-bubble.vue?vue&type=template&id=a0d4b67c&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-loading-bubble.vue?vue&type=script&lang=js

/* harmony default export */ var hg_loading_bubblevue_type_script_lang_js = ({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null
    }
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-loading-bubble.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_loading_bubblevue_type_script_lang_js = (hg_loading_bubblevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-loading-bubble.vue?vue&type=style&index=0&id=a0d4b67c&prod&scoped=true&lang=postcss
var hg_loading_bubblevue_type_style_index_0_id_a0d4b67c_prod_scoped_true_lang_postcss = __webpack_require__("2319");

// CONCATENATED MODULE: ./src/components/ui/hg-loading-bubble.vue






/* normalize component */

var hg_loading_bubble_component = normalizeComponent(
  ui_hg_loading_bubblevue_type_script_lang_js,
  hg_loading_bubblevue_type_template_id_a0d4b67c_scoped_true_render,
  hg_loading_bubblevue_type_template_id_a0d4b67c_scoped_true_staticRenderFns,
  false,
  null,
  "a0d4b67c",
  null
  
)

/* harmony default export */ var hg_loading_bubble = (hg_loading_bubble_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-responsive-content.vue?vue&type=template&id=4d593466&scoped=true
var hg_responsive_contentvue_type_template_id_4d593466_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-responsive-content-wrapper"},[_c('hg-title-trigger',{staticClass:"hg-responsive-content-trigger",on:{"onClick":function($event){_vm.isModalOpen = true}}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.content)?_c('div',{staticClass:"hg-responsive-content-inline"},[_vm._t("default")],2):_vm._e(),(_vm.content)?_c('div',{staticClass:"hg-content hg-responsive-content-inline",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticClass:"hg-content hg-responsive-content-inline"},[_vm._t("default")],2),(_vm.isModalOpen)?_c('hg-modal',{staticClass:"hg-responsive-content-modal",attrs:{"isFullscreen":""},on:{"onClose":function($event){_vm.isModalOpen = false}}},[_c('div',{staticClass:"tw-py-4"},[_c('div',{staticClass:"hg-modal-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.content)?_vm._t("default"):_vm._e(),(_vm.content)?_c('div',{staticClass:"hg-content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticClass:"hg-content"},[_vm._t("default")],2)],2)]):_vm._e()],1)
}
var hg_responsive_contentvue_type_template_id_4d593466_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-responsive-content.vue?vue&type=template&id=4d593466&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-responsive-content.vue?vue&type=script&lang=js

/* harmony default export */ var hg_responsive_contentvue_type_script_lang_js = ({
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    isModalOpen: false,
  }),
});

// CONCATENATED MODULE: ./src/components/ui/hg-responsive-content.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_responsive_contentvue_type_script_lang_js = (hg_responsive_contentvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-responsive-content.vue?vue&type=style&index=0&id=4d593466&prod&scoped=true&lang=postcss
var hg_responsive_contentvue_type_style_index_0_id_4d593466_prod_scoped_true_lang_postcss = __webpack_require__("3520");

// CONCATENATED MODULE: ./src/components/ui/hg-responsive-content.vue






/* normalize component */

var hg_responsive_content_component = normalizeComponent(
  ui_hg_responsive_contentvue_type_script_lang_js,
  hg_responsive_contentvue_type_template_id_4d593466_scoped_true_render,
  hg_responsive_contentvue_type_template_id_4d593466_scoped_true_staticRenderFns,
  false,
  null,
  "4d593466",
  null
  
)

/* harmony default export */ var hg_responsive_content = (hg_responsive_content_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-radio-group.vue?vue&type=template&id=37df19a8&scoped=true
var hg_radio_groupvue_type_template_id_37df19a8_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radiogroup",attrs:{"role":"radiogroup","aria-labelledby":`${_vm.groupId}-label`,"id":_vm.groupId}},[_c('div',{staticClass:"radiogroup__label",attrs:{"id":`${_vm.groupId}-label`}},[_vm._t("default")],2),_c('div',{staticClass:"radiogroup__buttons",class:_vm.orientation === 'horizontal'
        ? 'radiogroup__buttons--horizontal'
        : 'radiogroup__buttons--vertical'},_vm._l((_vm.options),function(option,index){return _c('div',{key:`radio-item-${index}`,staticClass:"radiogroup__radio",attrs:{"role":"radio","tabindex":option.value === _vm.checkedValue ? 0 : -1,"aria-checked":option.value === _vm.checkedValue ? true : false,"data-value":option.value,"data-value-index":index},on:{"keyup":_vm.keyup,"click":_vm.click}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)])
}
var hg_radio_groupvue_type_template_id_37df19a8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-radio-group.vue?vue&type=template&id=37df19a8&scoped=true

// CONCATENATED MODULE: ./src/utils/keycodes.js
const keycodes = {
  ENTER: 13,
  SPACE: 32,
  TAB: 9,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
}

/* harmony default export */ var utils_keycodes = (keycodes);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-radio-group.vue?vue&type=script&lang=js



/* harmony default export */ var hg_radio_groupvue_type_script_lang_js = ({
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    orientation: {
      type: String,
      default: 'horizontal',
    },
  },
  data: () => ({
    groupId: Math.random().toString(),
    checkedValue: null,
    checkedValueIndex: null,
    activeRadioElement: null,
  }),
  mounted() {
    this.checkedValue = this.options[0].value
    this.checkedValueIndex = 0
  },
  methods: {
    keyup(e) {
      const keyCode = e.keyCode
      if (keyCode === utils_keycodes.UP || keyCode === utils_keycodes.LEFT) {
        // Check previous option on Up|Left
        if (this.checkedValueIndex <= 0) {
          // Wrap to start
          this.checkedValue = this.options[this.options.length - 1].value
          this.checkedValueIndex = this.options.length - 1
        } else {
          this.checkedValue = this.options[this.checkedValueIndex - 1].value
          this.checkedValueIndex = this.checkedValueIndex - 1
        }
      } else if (keyCode === utils_keycodes.DOWN || keyCode === utils_keycodes.RIGHT) {
        // Check next option on Down|Right
        if (this.checkedValueIndex >= this.options.length - 1) {
          // Wrap to start
          this.checkedValue = this.options[0].value
          this.checkedValueIndex = 0
        } else {
          this.checkedValue = this.options[this.checkedValueIndex + 1].value
          this.checkedValueIndex = this.checkedValueIndex + 1
        }
      }

      // Focus new Element
      const newElement = document.querySelector(
        '[role="radio"][data-value-index="' + this.checkedValueIndex + '"]'
      )
      newElement.focus()
      this.$emit('onSelected', this.checkedValue)
      // e.preventDefault()
    },
    click({ target }) {
      if (target.className === 'radiogroup__label') return

      this.checkedValue = target.getAttribute('data-value')
      this.checkedValueIndex = parseInt(target.getAttribute('data-value-index'))
      this.$emit('onSelected', this.checkedValue)
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-radio-group.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_radio_groupvue_type_script_lang_js = (hg_radio_groupvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-radio-group.vue?vue&type=style&index=0&id=37df19a8&prod&scoped=true&lang=postcss
var hg_radio_groupvue_type_style_index_0_id_37df19a8_prod_scoped_true_lang_postcss = __webpack_require__("3ea4");

// EXTERNAL MODULE: ./src/components/ui/hg-radio-group.vue?vue&type=style&index=1&id=37df19a8&prod&lang=postcss
var hg_radio_groupvue_type_style_index_1_id_37df19a8_prod_lang_postcss = __webpack_require__("6f99");

// CONCATENATED MODULE: ./src/components/ui/hg-radio-group.vue







/* normalize component */

var hg_radio_group_component = normalizeComponent(
  ui_hg_radio_groupvue_type_script_lang_js,
  hg_radio_groupvue_type_template_id_37df19a8_scoped_true_render,
  hg_radio_groupvue_type_template_id_37df19a8_scoped_true_staticRenderFns,
  false,
  null,
  "37df19a8",
  null
  
)

/* harmony default export */ var hg_radio_group = (hg_radio_group_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-snap-slider.vue?vue&type=template&id=9c81ac70&scoped=true
var hg_snap_slidervue_type_template_id_9c81ac70_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-wrapper"},[_c('div',{ref:"slider",staticClass:"slider"},[_vm._t("default")],2),(_vm.showControls && _vm.numSlides !== 1)?_c('div',[_c('button',{class:`controls controls__prev ${
        _vm.activeSlideIndex == 0 && !_vm.isCircular ? 'tw-hidden' : ''
      }`,on:{"click":function($event){$event.preventDefault();return _vm.prevSlide.apply(null, arguments)}}},[_c('ArrowCircleSvg',{staticClass:"arrow-left"})],1),_c('button',{class:`controls controls__next ${
        _vm.activeSlideIndex == _vm.numSlides - 1 && !_vm.isCircular ? 'tw-hidden' : ''
      }`,on:{"click":function($event){$event.preventDefault();return _vm.nextSlide.apply(null, arguments)}}},[_c('ArrowCircleSvg')],1)]):_vm._e(),(_vm.showIndicators && _vm.numSlides !== 1)?[_c('div',{ref:"indicators",staticClass:"slider-indicator"},_vm._l((_vm.numSlides),function(slideNumber,index){return _c('button',{key:`slide-${index}`,staticClass:"indicator__button",class:index === _vm.activeSlideIndex ? 'indicator__button--active' : '',attrs:{"tabindex":"-1"},on:{"click":function($event){return _vm.scrollTo(index)}}},[_vm._v(" "+_vm._s(slideNumber)+" ")])}),0)]:_vm._e()],2)
}
var hg_snap_slidervue_type_template_id_9c81ac70_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-snap-slider.vue?vue&type=template&id=9c81ac70&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/arrow-circle-svg.vue?vue&type=template&id=4654786c
var arrow_circle_svgvue_type_template_id_4654786c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"opacity":"0.7","fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40ZM21.6665 25.8405L26.8598 20.3344C27.0475 20.1466 27.0475 19.8651 26.8598 19.6774L21.6665 14.1712C21.4788 13.9522 21.1659 13.9522 20.9469 14.1399C20.728 14.3277 20.728 14.6405 20.9157 14.8282L25.2956 19.4897H13.5011C13.2196 19.4897 13.0006 19.7712 13.0006 20.0215C13.0006 20.2718 13.2196 20.4908 13.5011 20.4908H25.2956L20.9157 25.1835C20.728 25.3712 20.728 25.6841 20.9469 25.8718C21.0408 25.9656 21.1659 25.9969 21.2911 25.9969C21.4162 25.9969 21.5726 25.9656 21.6665 25.8405Z","fill":"white"}})])
}
var arrow_circle_svgvue_type_template_id_4654786c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/arrow-circle-svg.vue?vue&type=template&id=4654786c

// CONCATENATED MODULE: ./src/components/svg/ui/arrow-circle-svg.vue

var arrow_circle_svg_script = {}


/* normalize component */

var arrow_circle_svg_component = normalizeComponent(
  arrow_circle_svg_script,
  arrow_circle_svgvue_type_template_id_4654786c_render,
  arrow_circle_svgvue_type_template_id_4654786c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var arrow_circle_svg = (arrow_circle_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-snap-slider.vue?vue&type=script&lang=js



/* harmony default export */ var hg_snap_slidervue_type_script_lang_js = ({
  props: {
    showControls: {
      type: Boolean,
      default: true,
    },
    showIndicators: {
      type: Boolean,
      default: true,
    },
    isCircular: {
      type: Boolean,
      default: false,
    },
    isResponsive: {
      type: Boolean,
      default: false,
    },
    breakpoints: {
      type: Array,
      default: () => [
        {
          minWidth: 550,
          slideWidth: '80%',
        },
        {
          minWidth: 768,
          slideWidth: '60%',
        },
        {
          minWidth: 920,
          slideWidth: '55%',
        },
      ],
    },
    height: {
      type: Number,
      default: 250,
    },
  },
  data: () => ({
    numSlides: 0,
    activeSlideIndex: 0,
  }),
  watch: {
    height() {
      this.$refs.slider.style.height = `${this.height}px`
    },
  },
  mounted() {
    this.handleDebouncedScroll = this.debounce(this.handleScroll, 100)
    this.handleDebouncedResize = this.debounce(this.handleResize, 300)

    this.$refs.slider.addEventListener('scroll', this.handleDebouncedScroll)
    this.$refs.slider.style.height = `${this.height}px`
    window.addEventListener('resize', this.handleDebouncedResize)

    this.numSlides = this.$refs.slider.children.length

    this.indicators = Array.from(this.$refs.indicators.children)
    this.slides = Array.from(this.$refs.slider.children)

    setTimeout(() => {
      this.handleResize()
    }, 100)
  },
  beforeDestroy() {
    this.$refs.slider.removeEventListener('scroll', this.handleDebouncedScroll)
    this.$refs.slider.removeEventListener('resize', this.handleDebouncedScroll)
  },
  methods: {
    handleScroll() {
      if (!this.$refs.slider) return
      const scrollLeft = this.$refs.slider.scrollLeft + 10
      const scrollWidth = this.$refs.slider.scrollWidth
      const slideWidth = Math.floor(scrollWidth / this.numSlides)
      this.$emit('onHandleScroll')

      if (scrollLeft > (this.numSlides - 2) * slideWidth + 16) {
        // Last Slide (offset problem)
        this.activeSlideIndex = this.numSlides - 1
      } else {
        this.activeSlideIndex = Math.floor(scrollLeft / slideWidth)
      }
    },
    handleResize() {
      if (
        !this.$refs.indicators ||
        !this.$refs.indicators.children ||
        !this.isResponsive
      ) {
        return
      }

      let slideWidth = '100%'

      this.breakpoints.forEach((breakpoint) => {
        if (window.innerWidth > breakpoint.minWidth) {
          slideWidth = breakpoint.slideWidth
        }
      })

      this.slides.forEach((slide) => {
        slide.style.flexBasis = slideWidth
      })
    },
    nextSlide() {
      let newIndex = this.activeSlideIndex + 1

      if (this.isCircular && newIndex >= this.numSlides) {
        newIndex = 0
      }

      this.scrollTo(newIndex)
    },
    prevSlide() {
      let newIndex = this.activeSlideIndex - 1

      if (this.isCircular && newIndex < 0) {
        newIndex = this.numSlides - 1
      }

      this.scrollTo(newIndex)
    },
    scrollTo(index) {
      const scrollLeft = Math.floor(
        this.$refs.slider.scrollWidth * (index / this.numSlides)
      )
      this.$refs.slider.scrollTo({
        left: scrollLeft,
        behaviour: 'smooth',
      })
    },
    debounce(fn, delay) {
      let timeout
      return () => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          timeout = null
          fn()
        }, delay)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-snap-slider.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_snap_slidervue_type_script_lang_js = (hg_snap_slidervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-snap-slider.vue?vue&type=style&index=0&id=9c81ac70&prod&scoped=true&lang=postcss
var hg_snap_slidervue_type_style_index_0_id_9c81ac70_prod_scoped_true_lang_postcss = __webpack_require__("193d");

// CONCATENATED MODULE: ./src/components/ui/hg-snap-slider.vue






/* normalize component */

var hg_snap_slider_component = normalizeComponent(
  ui_hg_snap_slidervue_type_script_lang_js,
  hg_snap_slidervue_type_template_id_9c81ac70_scoped_true_render,
  hg_snap_slidervue_type_template_id_9c81ac70_scoped_true_staticRenderFns,
  false,
  null,
  "9c81ac70",
  null
  
)

/* harmony default export */ var hg_snap_slider = (hg_snap_slider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-tabs.vue?vue&type=template&id=1732a6e5&scoped=true
var hg_tabsvue_type_template_id_1732a6e5_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tablist.length)?_c('div',{class:['hg-tabs', { [`hg-tabs--theme-${_vm.theme}`]: _vm.theme }]},[_c('div',{staticClass:"hg-tablist",attrs:{"role":"tablist","aria-orientation":_vm.orientation,"aria-label":_vm.label}},_vm._l((_vm.tablist),function(tab,index){return _c('button',{key:tab,ref:"tab",refInFor:true,staticClass:"hg-tab-button hg-button",attrs:{"aria-selected":index === _vm.activeIndex},on:{"keydown":_vm.onKeydown,"click":function($event){return _vm.click(index)}}},[_vm._v(" "+_vm._s(tab)+" ")])}),0),_vm._l((_vm.tablist),function(tab,index){return _c('div',{key:tab,class:[`hg-tab-panel--${index}`, 'hg-tab-panel'],attrs:{"id":`${_vm.id}-panel-${index}`,"aria-labelledby":`${_vm.id}-tab-${index}`,"hidden":index !== _vm.activeIndex,"role":"tabpanel"}},[_vm._t(tab)],2)})],2):_vm._e()
}
var hg_tabsvue_type_template_id_1732a6e5_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-tabs.vue?vue&type=template&id=1732a6e5&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-tabs.vue?vue&type=script&lang=js



/* harmony default export */ var hg_tabsvue_type_script_lang_js = ({
  props: {
    label: {
      type: String,
      default: '',
    },
    orientation: {
      type: String,
      default: 'horizontal',
    },
    theme: {
      type: String,
      default: '',
    },
    activeTab: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    activeIndex: 0,
  }),

  created() {
    this.activeIndex = this.activeTab
  },

  watch: {
    activeTab(newVal) {
      this.activeIndex = newVal
    },
  },

  computed: {
    tablist() {
      return Object.keys(this.$slots)
    },

    id() {
      return Array(6)
        .fill()
        .map(() => Math.floor(36 * Math.random()).toString(36))
        .join('')
    },
  },

  methods: {
    click(index) {
      this.$emit('onTabClicked', index)
      this.activeIndex = index
    },
    onKeydown(event) {
      const { keyCode } = event
      switch (keyCode) {
        case utils_keycodes.LEFT:
        case utils_keycodes.RIGHT:
        case utils_keycodes.UP:
        case utils_keycodes.DOWN:
          this.determineOrientation(event)
          break
      }
    },

    // Depending on the orientation only let UP/DOWN or LEFT/RIGHT keys proceed
    determineOrientation(event) {
      const { keyCode } = event
      let proceed = false
      if (this.orientation === 'vertical') {
        if (keyCode === utils_keycodes.UP || keyCode === utils_keycodes.DOWN) {
          event.preventDefault()
          proceed = true
        }
      } else {
        if (keyCode === utils_keycodes.LEFT || keyCode === utils_keycodes.RIGHT) {
          proceed = true
        }
      }
      if (proceed) {
        this.switchTabOnArrowPress(event)
        this.setFocus()
      }
    },

    switchTabOnArrowPress(event) {
      const keyCode = event.keyCode
      const directions = {
        [utils_keycodes.LEFT]: -1,
        [utils_keycodes.UP]: -1,
        [utils_keycodes.RIGHT]: 1,
        [utils_keycodes.DOWN]: 1,
      }

      if (!directions[keyCode]) return
      const nextIndex = this.activeIndex + directions[keyCode]
      if (nextIndex < 0) {
        this.activeIndex = this.$refs.tab.length - 1
      } else if (nextIndex >= this.$refs.tab.length) {
        this.activeIndex = 0
      } else {
        this.activeIndex = nextIndex
      }
    },

    setFocus() {
      this.$refs.tab[this.activeIndex].focus()
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-tabs.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_tabsvue_type_script_lang_js = (hg_tabsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-tabs.vue?vue&type=style&index=0&id=1732a6e5&prod&scoped=true&lang=postcss
var hg_tabsvue_type_style_index_0_id_1732a6e5_prod_scoped_true_lang_postcss = __webpack_require__("d69f");

// CONCATENATED MODULE: ./src/components/ui/hg-tabs.vue






/* normalize component */

var hg_tabs_component = normalizeComponent(
  ui_hg_tabsvue_type_script_lang_js,
  hg_tabsvue_type_template_id_1732a6e5_scoped_true_render,
  hg_tabsvue_type_template_id_1732a6e5_scoped_true_staticRenderFns,
  false,
  null,
  "1732a6e5",
  null
  
)

/* harmony default export */ var hg_tabs = (hg_tabs_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-tag.vue?vue&type=template&id=7b5c52b0&scoped=true
var hg_tagvue_type_template_id_7b5c52b0_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tag)?_c('button',{staticClass:"hg-button tag-button",class:[
    _vm.active && 'active',
    `tag-button--${_vm.color}`,
    `tag-button--border-${_vm.borderColor}`,
  ],on:{"click":_vm.clickTag}},[(_vm.showToggle)?_c('hg-icon',{attrs:{"name":_vm.active ? 'times' : 'plus',"size":"small","pack":"fal"}}):_vm._e(),_c('span',{class:!_vm.showToggle && 'tw-ml-2'},[_vm._v(" "+_vm._s(_vm.tag.name)+" ")])],1):_vm._e()
}
var hg_tagvue_type_template_id_7b5c52b0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-tag.vue?vue&type=template&id=7b5c52b0&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-tag.vue?vue&type=script&lang=js

/* harmony default export */ var hg_tagvue_type_script_lang_js = ({
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: Object,
      default: () => {},
    },
    showToggle: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'default',
    },
    borderColor: {
      type: String,
      default: 'default',
    },
  },
  methods: {
    clickTag() {
      this.$emit('onClick', this.tag)
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-tag.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_tagvue_type_script_lang_js = (hg_tagvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-tag.vue?vue&type=style&index=0&id=7b5c52b0&prod&scoped=true&lang=postcss
var hg_tagvue_type_style_index_0_id_7b5c52b0_prod_scoped_true_lang_postcss = __webpack_require__("f4c8");

// CONCATENATED MODULE: ./src/components/ui/hg-tag.vue






/* normalize component */

var hg_tag_component = normalizeComponent(
  ui_hg_tagvue_type_script_lang_js,
  hg_tagvue_type_template_id_7b5c52b0_scoped_true_render,
  hg_tagvue_type_template_id_7b5c52b0_scoped_true_staticRenderFns,
  false,
  null,
  "7b5c52b0",
  null
  
)

/* harmony default export */ var hg_tag = (hg_tag_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-text-link.vue?vue&type=template&id=696d3d56&scoped=true
var hg_text_linkvue_type_template_id_696d3d56_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.computedTag,{tag:"component",staticClass:"link hg-text-link",attrs:{"href":_vm.href,"rel":_vm.computedRel},on:{"click":_vm.clickLink}},[_vm._t("default")],2)
}
var hg_text_linkvue_type_template_id_696d3d56_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-text-link.vue?vue&type=template&id=696d3d56&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-text-link.vue?vue&type=script&lang=js

/* harmony default export */ var hg_text_linkvue_type_script_lang_js = ({
  props: {
    href: {
      type: String,
      default: null,
    },
    rel: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: '_self',
    },
  },
  computed: {
    computedTag() {
      return this.href ? 'a' : 'span'
    },
    computedRel() {
      return this.href && this.target === '_blank' ? 'noopener' : null
    },
  },
  methods: {
    clickLink() {
      this.$emit('linkClicked')
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-text-link.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_text_linkvue_type_script_lang_js = (hg_text_linkvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-text-link.vue?vue&type=style&index=0&id=696d3d56&prod&lang=postcss&scoped=true
var hg_text_linkvue_type_style_index_0_id_696d3d56_prod_lang_postcss_scoped_true = __webpack_require__("ea2c");

// CONCATENATED MODULE: ./src/components/ui/hg-text-link.vue






/* normalize component */

var hg_text_link_component = normalizeComponent(
  ui_hg_text_linkvue_type_script_lang_js,
  hg_text_linkvue_type_template_id_696d3d56_scoped_true_render,
  hg_text_linkvue_type_template_id_696d3d56_scoped_true_staticRenderFns,
  false,
  null,
  "696d3d56",
  null
  
)

/* harmony default export */ var hg_text_link = (hg_text_link_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-title-trigger.vue?vue&type=template&id=1da8472c&scoped=true
var hg_title_triggervue_type_template_id_1da8472c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"hg-title-trigger",attrs:{"role":"button"},on:{"click":_vm.onClick}},[_c('span',[_vm._t("default")],2),_c('div',{staticClass:"hg-title-chevron"},[_c('hg-icon',{attrs:{"name":"chevron-right"}})],1)])
}
var hg_title_triggervue_type_template_id_1da8472c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-title-trigger.vue?vue&type=template&id=1da8472c&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-title-trigger.vue?vue&type=script&lang=js

/* harmony default export */ var hg_title_triggervue_type_script_lang_js = ({
  methods: {
    onClick() {
      this.$emit('onClick')
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-title-trigger.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_title_triggervue_type_script_lang_js = (hg_title_triggervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-title-trigger.vue?vue&type=style&index=0&id=1da8472c&prod&scoped=true&lang=postcss
var hg_title_triggervue_type_style_index_0_id_1da8472c_prod_scoped_true_lang_postcss = __webpack_require__("06eb");

// CONCATENATED MODULE: ./src/components/ui/hg-title-trigger.vue






/* normalize component */

var hg_title_trigger_component = normalizeComponent(
  ui_hg_title_triggervue_type_script_lang_js,
  hg_title_triggervue_type_template_id_1da8472c_scoped_true_render,
  hg_title_triggervue_type_template_id_1da8472c_scoped_true_staticRenderFns,
  false,
  null,
  "1da8472c",
  null
  
)

/* harmony default export */ var hg_title_trigger = (hg_title_trigger_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-tooltip.vue?vue&type=template&id=24a4ab90&scoped=true
var hg_tooltipvue_type_template_id_24a4ab90_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{ref:"tooltip",staticClass:"tooltip",class:_vm.tooltipClasses,style:(_vm.tooltipStyle),attrs:{"role":"alert"}},[_c('div',{staticClass:"tooltip-content"},[(_vm.closable)?_c('div',{staticClass:"tooltip-close",on:{"click":_vm.closeTooltip}},[_c('hg-icon',{attrs:{"name":"times","size":_vm.isMobile ? 'regular' : 'small'}})],1):_vm._e(),_vm._v(" "+_vm._s(_vm.tooltipContent)+" "),(_vm.tooltipHighlightContent)?_c('p',{staticClass:"tooltip-highlight-content"},[_vm._v(" "+_vm._s(_vm.tooltipHighlightContent)+" ")]):_vm._e()]),_c('div',{staticClass:"tooltip-arrow"}),(!_vm.isMobile && _vm.hasTip)?_c('div',{staticClass:"tooltip-tip--outer"},[_c('div',{staticClass:"tooltip-tip--inner",class:!_vm.isMobile && 'desktop',style:(`clip-path: polygon(${_vm.position[_vm.tipPosition]}% 90%, ${
        _vm.position[_vm.tipPosition] - 5
      }% 0%, ${_vm.position[_vm.tipPosition] + 5}% 0%);`)})]):_vm._e()]):_vm._e()
}
var hg_tooltipvue_type_template_id_24a4ab90_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-tooltip.vue?vue&type=template&id=24a4ab90&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-tooltip.vue?vue&type=script&lang=js



/* harmony default export */ var hg_tooltipvue_type_script_lang_js = ({
  components: { HgIcon: hg_icon },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    hasTip: {
      type: Boolean,
      default: false,
    },
    tooltipContent: {
      type: String,
    },
    tooltipHighlightContent: {
      type: String,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    pxCenter: {
      type: Number,
      default: undefined,
    },
    pxBottom: {
      type: Number,
      default: undefined,
    },
    tipPosition: {
      type: String,
      default: 'left',
      validator: function (value) {
        return ['left', 'right', 'middle'].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {
      position: {
        left: 10,
        right: 90,
        middle: 50,
      },
      tooltipHeight: 0,
    }
  },
  computed: {
    tooltipStyle() {
      let style = ''
      if (this.isMobile && this.pxBottom) {
        style += `top: ${this.pxBottom}px`
      } else {
        style += `top: ${-this.tooltipHeight}px`
      }
      return style
    },
    tooltipClasses() {
      let classes = this.isMobile ? 'mobile ' : ''
      return classes
    },
  },
  created() {
    let self = this
    window.addEventListener('click', function (e) {
      // close dropdown when clicked outside
      if (
        self.isVisible &&
        !e.target.classList.contains('tooltip-content') &&
        !e.target.classList.contains('tooltip-activator')
      ) {
        self.closeTooltip()
      }
    })
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.tooltip)
        this.tooltipHeight = this.$refs.tooltip.clientHeight
    }, 0)
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        setTimeout(() => {
          if (this.$refs.tooltip)
            this.tooltipHeight = this.$refs.tooltip.clientHeight
        }, 0)
      }
    },
  },
  methods: {
    getTooltipTip(voucher) {
      const factor = 2.55
      const setoff = 37 + factor * 3
      if (!voucher.code) return 10
      if (setoff + voucher.code.length * factor >= 90) return 90
      return setoff + voucher.code.length * factor
    },
    closeTooltip() {
      this.$emit('onCloseTooltip')
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-tooltip.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_tooltipvue_type_script_lang_js = (hg_tooltipvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-tooltip.vue?vue&type=style&index=0&id=24a4ab90&prod&scoped=true&lang=postcss
var hg_tooltipvue_type_style_index_0_id_24a4ab90_prod_scoped_true_lang_postcss = __webpack_require__("10b0");

// CONCATENATED MODULE: ./src/components/ui/hg-tooltip.vue






/* normalize component */

var hg_tooltip_component = normalizeComponent(
  ui_hg_tooltipvue_type_script_lang_js,
  hg_tooltipvue_type_template_id_24a4ab90_scoped_true_render,
  hg_tooltipvue_type_template_id_24a4ab90_scoped_true_staticRenderFns,
  false,
  null,
  "24a4ab90",
  null
  
)

/* harmony default export */ var hg_tooltip = (hg_tooltip_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-topbar.vue?vue&type=template&id=0b8e8acc&scoped=true
var hg_topbarvue_type_template_id_0b8e8acc_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar-container"},[_c('div',{class:['topbar-inner-container', { center: !_vm.hasSlot }]},[_c('div',{staticClass:"topbar-slot-container"},[_vm._t("default")],2),_c('div',{staticClass:"topbar-trustpilot-container"},[_c('hg-trustpilot',{attrs:{"size":"micro","theme":"dark"}})],1)])])
}
var hg_topbarvue_type_template_id_0b8e8acc_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-topbar.vue?vue&type=template&id=0b8e8acc&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-topbar.vue?vue&type=script&lang=js

/* harmony default export */ var hg_topbarvue_type_script_lang_js = ({
  data: () => ({
    hasSlot: false
  }),
  mounted() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    handleResize() {
      this.hasSlot = this.$slots["default"] != null
    }
  }
});

// CONCATENATED MODULE: ./src/components/ui/hg-topbar.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_topbarvue_type_script_lang_js = (hg_topbarvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-topbar.vue?vue&type=style&index=0&id=0b8e8acc&prod&scoped=true&lang=postcss
var hg_topbarvue_type_style_index_0_id_0b8e8acc_prod_scoped_true_lang_postcss = __webpack_require__("b9ed");

// CONCATENATED MODULE: ./src/components/ui/hg-topbar.vue






/* normalize component */

var hg_topbar_component = normalizeComponent(
  ui_hg_topbarvue_type_script_lang_js,
  hg_topbarvue_type_template_id_0b8e8acc_scoped_true_render,
  hg_topbarvue_type_template_id_0b8e8acc_scoped_true_staticRenderFns,
  false,
  null,
  "0b8e8acc",
  null
  
)

/* harmony default export */ var hg_topbar = (hg_topbar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-trustpilot.vue?vue&type=template&id=6bf9a880&%40click=onClick()
var hg_trustpilotvue_type_template_id_6bf9a880_40click_onClick_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.size === 'large')?[_c('div',{staticClass:"trustpilot-widget",attrs:{"data-locale":_vm.getDataLocale(),"data-template-id":"53aa8912dec7e10d38f59f36","data-businessunit-id":_vm.getBusinessUnitId(),"data-style-height":_vm.height,"data-style-width":"100%","data-theme":_vm.theme,"data-stars":"4,5","data-review-languages":"de","data-font-family":"Open Sans","data-text-color":"#323231"}},[_c('a',{attrs:{"href":"https://de.trustpilot.com/review/www.urlaubsguru.de","target":"_blank","rel":"noopener"}},[_c('TrustPilotPlaceholderSvg',{attrs:{"alt":"Trust Pilot Logo und Bewertung"}})],1)])]:(_vm.size === 'micro')?[_c('div',{staticClass:"trustpilot-widget",attrs:{"data-locale":_vm.getDataLocale(),"data-template-id":"5419b637fa0340045cd0c936","data-businessunit-id":_vm.getBusinessUnitId(),"data-style-height":"20px","data-style-width":"100%","data-theme":_vm.theme,"data-font-family":"Open Sans"}},[_c('a',{attrs:{"href":"https://de.trustpilot.com/review/www.urlaubsguru.de","target":"_blank","rel":"noopener"}})])]:[_c('div',{staticClass:"trustpilot-widget",attrs:{"data-locale":_vm.getDataLocale(),"data-template-id":"53aa8807dec7e10d38f59f32","data-businessunit-id":_vm.getBusinessUnitId(),"data-style-height":"150px","data-style-width":"100%","data-theme":_vm.theme}},[_c('a',{attrs:{"href":"https://de.trustpilot.com/review/www.urlaubsguru.de","target":"_blank","rel":"noopener"}},[_c('TrustPilotPlaceholderSvg',{attrs:{"alt":"Trust Pilot Logo und Bewertung"}})],1)])]],2)
}
var hg_trustpilotvue_type_template_id_6bf9a880_40click_onClick_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-trustpilot.vue?vue&type=template&id=6bf9a880&%40click=onClick()

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-trustpilot.vue?vue&type=script&lang=js

/* harmony default export */ var hg_trustpilotvue_type_script_lang_js = ({
  props: {
    size: {
      type: String,
      default: 'large',
    },
    theme: {
      type: String,
      default: 'light',
    },
  },

  data: () => ({
    businessUnitIds: {
      de: '512d0e32000064000522fdf7',
      at: '53941986000064000578e457',
      ch: '5512c8f40000ff00057e4922',
      nl: '537611cd000064000578c3f8',
      es: '536a31b6000064000578b553',
    },
    height: '320px',
  }),

  mounted() {
    const script = document.createElement('script')
    script.src =
      'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    script.async = true
    document.body.appendChild(script)

    this.height = window.matchMedia('(max-width: 768px)').matches
      ? '320px'
      : '160px'
  },

  methods: {
    getBusinessUnitId() {
      return this.businessUnitIds[this.$i18n.locale]
    },

    getDataLocale() {
      switch (this.$i18n.locale) {
        case 'de':
          return 'de-DE'
        case 'at':
          return 'de-AT'
        case 'ch':
          return 'de-CH'
        case 'nl':
          return 'nl-NL'
        case 'es':
          return 'es-ES'
      }
    },
    onClick() {
      this.$emit('onClick')
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-trustpilot.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_trustpilotvue_type_script_lang_js = (hg_trustpilotvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/ui/hg-trustpilot.vue





/* normalize component */

var hg_trustpilot_component = normalizeComponent(
  ui_hg_trustpilotvue_type_script_lang_js,
  hg_trustpilotvue_type_template_id_6bf9a880_40click_onClick_render,
  hg_trustpilotvue_type_template_id_6bf9a880_40click_onClick_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_trustpilot = (hg_trustpilot_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-trustpilot-buttons.vue?vue&type=template&id=f1c6d80a&scoped=true
var hg_trustpilot_buttonsvue_type_template_id_f1c6d80a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"headline"},[_vm._v(" "+_vm._s(_vm.locale.headline)+" ")]),_c('p',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.locale.description)+" ")]),_c('div',{staticClass:"button-container"},[_c('a',{attrs:{"href":_vm.link,"target":"blank"}},[_vm._v(" "+_vm._s(_vm.locale.stars['5'])+" "),_c('div',{staticClass:"stars-container"},[_c('TrustpilotStarSvg',{staticClass:"star-svg"}),_c('TrustpilotStarSvg',{staticClass:"star-svg"}),_c('TrustpilotStarSvg',{staticClass:"star-svg"}),_c('TrustpilotStarSvg',{staticClass:"star-svg"}),_c('TrustpilotStarSvg',{staticClass:"star-svg"})],1)]),_c('a',{attrs:{"href":_vm.link,"target":"blank"}},[_vm._v(" "+_vm._s(_vm.locale.stars['4'])+" "),_c('div',{staticClass:"stars-container"},[_c('TrustpilotStarSvg',{staticClass:"star-svg"}),_c('TrustpilotStarSvg',{staticClass:"star-svg"}),_c('TrustpilotStarSvg',{staticClass:"star-svg"}),_c('TrustpilotStarSvg',{staticClass:"star-svg"})],1)]),_c('a',{attrs:{"href":_vm.link,"target":"blank"}},[_vm._v(" "+_vm._s(_vm.locale.stars['3'])+" "),_c('div',{staticClass:"stars-container"},[_c('TrustpilotStarSvg',{staticClass:"star-svg"}),_c('TrustpilotStarSvg',{staticClass:"star-svg"}),_c('TrustpilotStarSvg',{staticClass:"star-svg"})],1)]),_c('a',{attrs:{"href":_vm.link,"target":"blank"}},[_vm._v(" "+_vm._s(_vm.locale.stars['2'])+" "),_c('div',{staticClass:"stars-container"},[_c('TrustpilotStarSvg',{staticClass:"star-svg"}),_c('TrustpilotStarSvg',{staticClass:"star-svg"})],1)]),_c('a',{attrs:{"href":_vm.link,"target":"blank"}},[_vm._v(" "+_vm._s(_vm.locale.stars['1'])+" "),_c('div',{staticClass:"stars-container"},[_c('TrustpilotStarSvg',{staticClass:"star-svg"})],1)])])])
}
var hg_trustpilot_buttonsvue_type_template_id_f1c6d80a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-trustpilot-buttons.vue?vue&type=template&id=f1c6d80a&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-trustpilot-buttons.vue?vue&type=script&lang=js



const hg_trustpilot_buttonsvue_type_script_lang_js_locales = {
  de: {
    headline: 'Deine Meinung ist uns wichtig',
    description:
      'Deine Bewertung hilft anderen Kunden, eine informierte Entscheidung zu treffen. Wir leiten dich zu Trustpilot weiter.',
    stars: {
      5: 'Bisher nichts zu meckern',
      4: 'Okay',
      3: 'Nicht so gut',
      2: 'Schlecht',
      1: 'Sehr schlecht',
    },
  },
  nl: {
    headline: 'Jouw mening is belangrijk voor ons',
    description:
      'Jouw beoordeling helpt andere klanten om een weloverwogen beslissing te nemen. We zullen je doorverwijzen naar Trustpilot.',
    stars: {
      5: 'Heel goed',
      4: 'Goed',
      3: 'Oké',
      2: 'Niet zo goed',
      1: 'Slecht',
    },
  },
}

/* harmony default export */ var hg_trustpilot_buttonsvue_type_script_lang_js = ({
  data: () => ({
    locale: hg_trustpilot_buttonsvue_type_script_lang_js_locales.de,
  }),
  props: {
    lang: {
      type: String,
      default: 'de',
    },
  },
  computed: {
    link() {
      switch (this.lang) {
        case 'at':
          return 'https://at.trustpilot.com/evaluate/urlaubsguru.at'
        case 'ch':
          return 'https://ch.trustpilot.com/evaluate/holidayguru.ch'
        case 'es':
          return 'https://es.trustpilot.com/evaluate/holidayguru.es'
        case 'nl':
          return 'https://nl.trustpilot.com/evaluate/holidayguru.nl'
        default:
          return 'https://de.trustpilot.com/evaluate/www.urlaubsguru.de'
      }
    },
  },
  watch: {
    lang() {
      this.setLocale()
    },
  },
  created() {
    this.setLocale()
  },
  methods: {
    setLocale() {
      this.locale = getLocale(hg_trustpilot_buttonsvue_type_script_lang_js_locales, this.lang)
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-trustpilot-buttons.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_trustpilot_buttonsvue_type_script_lang_js = (hg_trustpilot_buttonsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-trustpilot-buttons.vue?vue&type=style&index=0&id=f1c6d80a&prod&scoped=true&lang=css
var hg_trustpilot_buttonsvue_type_style_index_0_id_f1c6d80a_prod_scoped_true_lang_css = __webpack_require__("47d3");

// CONCATENATED MODULE: ./src/components/ui/hg-trustpilot-buttons.vue






/* normalize component */

var hg_trustpilot_buttons_component = normalizeComponent(
  ui_hg_trustpilot_buttonsvue_type_script_lang_js,
  hg_trustpilot_buttonsvue_type_template_id_f1c6d80a_scoped_true_render,
  hg_trustpilot_buttonsvue_type_template_id_f1c6d80a_scoped_true_staticRenderFns,
  false,
  null,
  "f1c6d80a",
  null
  
)

/* harmony default export */ var hg_trustpilot_buttons = (hg_trustpilot_buttons_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-api-errors.vue?vue&type=template&id=856945d8
var hg_api_errorsvue_type_template_id_856945d8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tw-mb-1 tw-mt-0 tw-text-red-600"},_vm._l((_vm.errors),function(error,index){return _c('div',{key:index,staticClass:"error-wrapper"},[(
        error.message && error.message.error && error.message.error.errorCode
      )?_c('li',[_c('span',[_vm._v(_vm._s(error.message.error.message))]),(error.message.error.errorCode === 'not_activated')?_c('span',{staticClass:"reactivate tw-font-bold tw-cursor-pointer tw-underline",on:{"click":function($event){return _vm.resendActivateMail(error.extensions.variables.email, index)}}},[_vm._v(" "+_vm._s(_vm.$t('activate.resendMail'))+" ")]):_vm._e()]):_vm._e()])}),0)
}
var hg_api_errorsvue_type_template_id_856945d8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-api-errors.vue?vue&type=template&id=856945d8

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-api-errors.vue?vue&type=script&lang=js

/* harmony default export */ var hg_api_errorsvue_type_script_lang_js = ({
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    resendActivateMail(email, index) {},
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-api-errors.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_api_errorsvue_type_script_lang_js = (hg_api_errorsvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/ui/hg-api-errors.vue





/* normalize component */

var hg_api_errors_component = normalizeComponent(
  ui_hg_api_errorsvue_type_script_lang_js,
  hg_api_errorsvue_type_template_id_856945d8_render,
  hg_api_errorsvue_type_template_id_856945d8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_api_errors = (hg_api_errors_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/partials/hg-cancellation-badge.vue?vue&type=template&id=44afaa0f&scoped=true
var hg_cancellation_badgevue_type_template_id_44afaa0f_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tooltipActivator",staticClass:"tooltip-activator badge-wrapper",class:!_vm.isMobile && 'tw--ml-5'},[_c('hg-tooltip',{attrs:{"is-visible":_vm.badgeTooltipVisible,"is-mobile":_vm.isMobile,"px-center":_vm.tooltipActivatorPos.center,"px-bottom":_vm.tooltipActivatorPos.top,"tooltip-content":_vm.tooltipContent,"has-tip":"","tip-position":"middle","closable":""},on:{"onCloseTooltip":function($event){_vm.badgeTooltipVisible = false}}}),(!_vm.isMobile)?_c('div',{staticClass:"flag--outer"},[_c('div',{staticClass:"flag--inner"})]):_vm._e(),_vm._l((_vm.badges),function(badge,index){return _c('div',{key:index,staticClass:"badge",class:_vm.getBadgeRadiusClass(index),on:{"click":_vm.toggleTooltip}},[_c('hg-icon',{staticClass:"tw-p-px",attrs:{"size":"small","name":"check"}}),_c('span',{staticClass:"badge-clicker"},[_vm._v(" "+_vm._s(badge.badgeText)+" ")]),_c('hg-icon',{staticClass:"tw-ml-2",attrs:{"size":"small","name":"info-circle"}})],1)})],2)
}
var hg_cancellation_badgevue_type_template_id_44afaa0f_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/partials/hg-cancellation-badge.vue?vue&type=template&id=44afaa0f&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/partials/hg-cancellation-badge.vue?vue&type=script&lang=js

/* harmony default export */ var hg_cancellation_badgevue_type_script_lang_js = ({
  props: {
    first: {
      type: Boolean,
      default: false,
    },
    last: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    badges: {
      type: Array,
      default: () => [
        {
          tooltipContent: 'Tooltip default text',
          badgeText: 'Badge default text',
        },
      ],
    },
  },
  data() {
    return {
      badgeTooltipVisible: false,
      tooltipContent: '',
      tooltipActivatorPos: {
        top: undefined,
        center: undefined,
      },
    }
  },
  mounted() {
    this.tooltipContent = this.getTooltipContent()
  },
  methods: {
    getTooltipContent() {
      if (!this.badges.length) return ''
      if (this.badges.length === 1) return this.badges[0].tooltipContent
      return this.badges.reduce((prev, cur, i) => {
        if (i === 1) return prev.tooltipContent + ' ' + cur.tooltipContent
        return prev + ' ' + cur.tooltipContent
      })
    },
    getBadgeRadiusClass(index) {
      let res = ''
      if (index === 0) res = 'tw-rounded-t-2'
      if (index === 0 && !this.isMobile)
        res = 'tw-rounded-tl-none tw-rounded-tr-2'
      if (index === this.badges.length - 1) res += ' tw-rounded-b-2'
      if (index > 0 && index < this.badges.length - 1) res = 'tw-rounded-none'
      return res
    },
    toggleTooltip(e) {
      e.stopPropagation()
      this.getPos()
      this.badgeTooltipVisible = !this.badgeTooltipVisible
    },
    getPos() {
      const {
        left,
        top,
        right,
        bottom,
      } = this.$refs.tooltipActivator.getBoundingClientRect()
      const center = left + (right - left) / 2
      this.tooltipActivatorPos.top = top
      this.tooltipActivatorPos.center = center
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/partials/hg-cancellation-badge.vue?vue&type=script&lang=js
 /* harmony default export */ var partials_hg_cancellation_badgevue_type_script_lang_js = (hg_cancellation_badgevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/partials/hg-cancellation-badge.vue?vue&type=style&index=0&id=44afaa0f&prod&lang=postcss&scoped=true
var hg_cancellation_badgevue_type_style_index_0_id_44afaa0f_prod_lang_postcss_scoped_true = __webpack_require__("6962");

// CONCATENATED MODULE: ./src/components/deal-box/partials/hg-cancellation-badge.vue






/* normalize component */

var hg_cancellation_badge_component = normalizeComponent(
  partials_hg_cancellation_badgevue_type_script_lang_js,
  hg_cancellation_badgevue_type_template_id_44afaa0f_scoped_true_render,
  hg_cancellation_badgevue_type_template_id_44afaa0f_scoped_true_staticRenderFns,
  false,
  null,
  "44afaa0f",
  null
  
)

/* harmony default export */ var hg_cancellation_badge = (hg_cancellation_badge_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-card-flicking.vue?vue&type=template&id=7821805c&scoped=true
var hg_card_flickingvue_type_template_id_7821805c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`hg-flicking ${
    _vm.sideButtons && !_vm.fullWidthLeft ? 'hg-flicking-padding-left' : ''
  } ${_vm.sideButtons && !_vm.fullWidthRight ? 'hg-flicking-padding-right' : ''}`},[_c('Flicking',{ref:"flicking",class:`hg-flicking-container ${
      _vm.alignLeft ? 'container-align-left' : ''
    }`,attrs:{"options":_vm.flickingOption,"plugins":_vm.plugins},on:{"changed":_vm.flickingChanged}},[_vm._t("default"),_c('div',{ref:"pagination",staticClass:"flicking-pagination",attrs:{"slot":"viewport"},slot:"viewport"})],2),_c('span',{class:`flicking-arrow-prev flicking-arrow-prev-${_vm.flickingId} hg-button hg-flicking-button-left ${
      _vm.sideButtons ? 'hg-side-button-left' : ''
    } ${_vm.prevButtonVisible ? '' : 'tw-invisible'}`},[_c('HgIcon',{attrs:{"name":"chevron-left","size":_vm.sideButtons ? 'small' : 'regular'}})],1),_c('span',{class:`flicking-arrow-next flicking-arrow-next-${_vm.flickingId} hg-button hg-flicking-button-right ${
      _vm.sideButtons ? 'hg-side-button-right' : ''
    } ${_vm.nextButtonVisible ? '' : 'tw-invisible'}`},[_c('HgIcon',{attrs:{"name":"chevron-right","size":_vm.sideButtons ? 'small' : 'regular'}})],1)],1)
}
var hg_card_flickingvue_type_template_id_7821805c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-card-flicking.vue?vue&type=template&id=7821805c&scoped=true

// CONCATENATED MODULE: ./node_modules/@egjs/component/dist/component.esm.js
/*
Copyright (c) NAVER Corp.
name: @egjs/component
license: MIT
author: NAVER Corp.
repository: https://github.com/naver/egjs-component
version: 3.0.4
*/
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
  return ar;
}

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
var isUndefined = function (value) {
  return typeof value === "undefined";
};

// This class name is not matched to file name intentionally
/**
 * Event class to provide additional properties
 * @ko Component에서 추가적인 프로퍼티를 제공하는 이벤트 클래스
 */
var ComponentEvent = /*#__PURE__*/function () {
  /**
   * Create a new instance of ComponentEvent.
   * @ko ComponentEvent의 새로운 인스턴스를 생성한다.
   * @param eventType The name of the event.<ko>이벤트 이름.</ko>
   * @param props An object that contains additional event properties.<ko>추가적인 이벤트 프로퍼티 오브젝트.</ko>
   */
  function ComponentEvent(eventType, props) {
    var e_1, _a;
    this._canceled = false;
    if (props) {
      try {
        for (var _b = __values(Object.keys(props)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          this[key] = props[key];
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
    this.eventType = eventType;
  }
  /**
   * Stop the event. {@link ComponentEvent#isCanceled} will return `true` after.
   * @ko 이벤트를 중단한다. 이후 {@link ComponentEvent#isCanceled}가 `true`를 반환한다.
   */
  var __proto = ComponentEvent.prototype;
  __proto.stop = function () {
    this._canceled = true;
  };
  /**
   * Returns a boolean value that indicates whether {@link ComponentEvent#stop} is called before.
   * @ko {@link ComponentEvent#stop}이 호출되었는지 여부를 반환한다.
   * @return {boolean} A boolean value that indicates whether {@link ComponentEvent#stop} is called before.<ko>이전에 {@link ComponentEvent#stop}이 불려졌는지 여부를 반환한다.</ko>
   */
  __proto.isCanceled = function () {
    return this._canceled;
  };
  return ComponentEvent;
}();

/**
 * A class used to manage events in a component
 * @ko 컴포넌트의 이벤트을 관리할 수 있게 하는 클래스
 */
var Component = /*#__PURE__*/function () {
  /**
   * @support {"ie": "7+", "ch" : "latest", "ff" : "latest",  "sf" : "latest", "edge" : "latest", "ios" : "7+", "an" : "2.1+ (except 3.x)"}
   */
  function Component() {
    this._eventHandler = {};
  }
  /**
   * Trigger a custom event.
   * @ko 커스텀 이벤트를 발생시킨다
   * @param {string | ComponentEvent} event The name of the custom event to be triggered or an instance of the ComponentEvent<ko>발생할 커스텀 이벤트의 이름 또는 ComponentEvent의 인스턴스</ko>
   * @param {any[]} params Event data to be sent when triggering a custom event <ko>커스텀 이벤트가 발생할 때 전달할 데이터</ko>
   * @return An instance of the component itself<ko>컴포넌트 자신의 인스턴스</ko>
   * @example
   * ```ts
   * import Component, { ComponentEvent } from "@egjs/component";
   *
   * class Some extends Component<{
   *   beforeHi: ComponentEvent<{ foo: number; bar: string }>;
   *   hi: { foo: { a: number; b: boolean } };
   *   someEvent: (foo: number, bar: string) => void;
   *   someOtherEvent: void; // When there's no event argument
   * }> {
   *   some(){
   *     if(this.trigger("beforeHi")){ // When event call to stop return false.
   *       this.trigger("hi");// fire hi event.
   *     }
   *   }
   * }
   *
   * const some = new Some();
   * some.on("beforeHi", e => {
   *   if(condition){
   *     e.stop(); // When event call to stop, `hi` event not call.
   *   }
   *   // `currentTarget` is component instance.
   *   console.log(some === e.currentTarget); // true
   *
   *   typeof e.foo; // number
   *   typeof e.bar; // string
   * });
   * some.on("hi", e => {
   *   typeof e.foo.b; // boolean
   * });
   * // If you want to more know event design. You can see article.
   * // https://github.com/naver/egjs-component/wiki/How-to-make-Component-event-design%3F
   * ```
   */
  var __proto = Component.prototype;
  __proto.trigger = function (event) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      params[_i - 1] = arguments[_i];
    }
    var eventName = event instanceof ComponentEvent ? event.eventType : event;
    var handlers = __spread(this._eventHandler[eventName] || []);
    if (handlers.length <= 0) {
      return this;
    }
    if (event instanceof ComponentEvent) {
      event.currentTarget = this;
      handlers.forEach(function (handler) {
        handler(event);
      });
    } else {
      handlers.forEach(function (handler) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        handler.apply(void 0, __spread(params));
      });
    }
    return this;
  };
  /**
   * Executed event just one time.
   * @ko 이벤트가 한번만 실행된다.
   * @param {string} eventName The name of the event to be attached or an event name - event handler mapped object.<ko>등록할 이벤트의 이름 또는 이벤트 이름-핸들러 오브젝트</ko>
   * @param {function} handlerToAttach The handler function of the event to be attached <ko>등록할 이벤트의 핸들러 함수</ko>
   * @return An instance of the component itself<ko>컴포넌트 자신의 인스턴스</ko>
   * @example
   * ```ts
   * import Component, { ComponentEvent } from "@egjs/component";
   *
   * class Some extends Component<{
   *   hi: ComponentEvent;
   * }> {
   *   hi() {
   *     alert("hi");
   *   }
   *   thing() {
   *     this.once("hi", this.hi);
   *   }
   * }
   *
   * var some = new Some();
   * some.thing();
   * some.trigger(new ComponentEvent("hi"));
   * // fire alert("hi");
   * some.trigger(new ComponentEvent("hi"));
   * // Nothing happens
   * ```
   */
  __proto.once = function (eventName, handlerToAttach) {
    var _this = this;
    if (typeof eventName === "object" && isUndefined(handlerToAttach)) {
      var eventHash = eventName;
      for (var key in eventHash) {
        this.once(key, eventHash[key]);
      }
      return this;
    } else if (typeof eventName === "string" && typeof handlerToAttach === "function") {
      var listener_1 = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        handlerToAttach.apply(void 0, __spread(args));
        _this.off(eventName, listener_1);
      };
      this.on(eventName, listener_1);
    }
    return this;
  };
  /**
   * Checks whether an event has been attached to a component.
   * @ko 컴포넌트에 이벤트가 등록됐는지 확인한다.
   * @param {string} eventName The name of the event to be attached <ko>등록 여부를 확인할 이벤트의 이름</ko>
   * @return {boolean} Indicates whether the event is attached. <ko>이벤트 등록 여부</ko>
   * @example
   * ```ts
   * import Component from "@egjs/component";
   *
   * class Some extends Component<{
   *   hi: void;
   * }> {
   *   some() {
   *     this.hasOn("hi");// check hi event.
   *   }
   * }
   * ```
   */
  __proto.hasOn = function (eventName) {
    return !!this._eventHandler[eventName];
  };
  /**
   * Attaches an event to a component.
   * @ko 컴포넌트에 이벤트를 등록한다.
   * @param {string} eventName The name of the event to be attached or an event name - event handler mapped object.<ko>등록할 이벤트의 이름 또는 이벤트 이름-핸들러 오브젝트</ko>
   * @param {function} handlerToAttach The handler function of the event to be attached <ko>등록할 이벤트의 핸들러 함수</ko>
   * @return An instance of a component itself<ko>컴포넌트 자신의 인스턴스</ko>
   * @example
   * ```ts
   * import Component, { ComponentEvent } from "@egjs/component";
   *
   * class Some extends Component<{
   *   hi: void;
   * }> {
   *   hi() {
   *     console.log("hi");
   *   }
   *   some() {
   *     this.on("hi",this.hi); //attach event
   *   }
   * }
   * ```
   */
  __proto.on = function (eventName, handlerToAttach) {
    if (typeof eventName === "object" && isUndefined(handlerToAttach)) {
      var eventHash = eventName;
      for (var name in eventHash) {
        this.on(name, eventHash[name]);
      }
      return this;
    } else if (typeof eventName === "string" && typeof handlerToAttach === "function") {
      var handlerList = this._eventHandler[eventName];
      if (isUndefined(handlerList)) {
        this._eventHandler[eventName] = [];
        handlerList = this._eventHandler[eventName];
      }
      handlerList.push(handlerToAttach);
    }
    return this;
  };
  /**
   * Detaches an event from the component.<br/>If the `eventName` is not given this will detach all event handlers attached.<br/>If the `handlerToDetach` is not given, this will detach all event handlers for `eventName`.
   * @ko 컴포넌트에 등록된 이벤트를 해제한다.<br/>`eventName`이 주어지지 않았을 경우 모든 이벤트 핸들러를 제거한다.<br/>`handlerToAttach`가 주어지지 않았을 경우 `eventName`에 해당하는 모든 이벤트 핸들러를 제거한다.
   * @param {string?} eventName The name of the event to be detached <ko>해제할 이벤트의 이름</ko>
   * @param {function?} handlerToDetach The handler function of the event to be detached <ko>해제할 이벤트의 핸들러 함수</ko>
   * @return An instance of a component itself <ko>컴포넌트 자신의 인스턴스</ko>
   * @example
   * ```ts
   * import Component, { ComponentEvent } from "@egjs/component";
   *
   * class Some extends Component<{
   *   hi: void;
   * }> {
   *   hi() {
   *     console.log("hi");
   *   }
   *   some() {
   *     this.off("hi",this.hi); //detach event
   *   }
   * }
   * ```
   */
  __proto.off = function (eventName, handlerToDetach) {
    var e_1, _a;
    // Detach all event handlers.
    if (isUndefined(eventName)) {
      this._eventHandler = {};
      return this;
    }
    // Detach all handlers for eventname or detach event handlers by object.
    if (isUndefined(handlerToDetach)) {
      if (typeof eventName === "string") {
        delete this._eventHandler[eventName];
        return this;
      } else {
        var eventHash = eventName;
        for (var name in eventHash) {
          this.off(name, eventHash[name]);
        }
        return this;
      }
    }
    // Detach single event handler
    var handlerList = this._eventHandler[eventName];
    if (handlerList) {
      var idx = 0;
      try {
        for (var handlerList_1 = __values(handlerList), handlerList_1_1 = handlerList_1.next(); !handlerList_1_1.done; handlerList_1_1 = handlerList_1.next()) {
          var handlerFunction = handlerList_1_1.value;
          if (handlerFunction === handlerToDetach) {
            handlerList.splice(idx, 1);
            if (handlerList.length <= 0) {
              delete this._eventHandler[eventName];
            }
            break;
          }
          idx++;
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (handlerList_1_1 && !handlerList_1_1.done && (_a = handlerList_1.return)) _a.call(handlerList_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
    return this;
  };
  /**
   * Version info string
   * @ko 버전정보 문자열
   * @name VERSION
   * @static
   * @example
   * Component.VERSION;  // ex) 3.0.0
   * @memberof Component
   */
  Component.VERSION = "3.0.4";
  return Component;
}();

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unsafe-assignment
var ComponentEvent$1 = ComponentEvent;

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */

/* harmony default export */ var component_esm = (Component);

//# sourceMappingURL=component.esm.js.map

// CONCATENATED MODULE: ./node_modules/@egjs/agent/dist/agent.esm.js
/*
Copyright (c) 2015 NAVER Corp.
name: @egjs/agent
license: MIT
author: NAVER Corp.
repository: git+https://github.com/naver/agent.git
version: 2.4.3
*/
function some(arr, callback) {
  var length = arr.length;

  for (var i = 0; i < length; ++i) {
    if (callback(arr[i], i)) {
      return true;
    }
  }

  return false;
}
function find(arr, callback) {
  var length = arr.length;

  for (var i = 0; i < length; ++i) {
    if (callback(arr[i], i)) {
      return arr[i];
    }
  }

  return null;
}
function getUserAgentString(agent) {
  var userAgent = agent;

  if (typeof userAgent === "undefined") {
    if (typeof navigator === "undefined" || !navigator) {
      return "";
    }

    userAgent = navigator.userAgent || "";
  }

  return userAgent.toLowerCase();
}
function execRegExp(pattern, text) {
  try {
    return new RegExp(pattern, "g").exec(text);
  } catch (e) {
    return null;
  }
}
function hasUserAgentData() {
  if (typeof navigator === "undefined" || !navigator || !navigator.userAgentData) {
    return false;
  }

  var userAgentData = navigator.userAgentData;
  var brands = userAgentData.brands || userAgentData.uaList;
  return !!(brands && brands.length);
}
function findVersion(versionTest, userAgent) {
  var result = execRegExp("(" + versionTest + ")((?:\\/|\\s|:)([0-9|\\.|_]+))", userAgent);
  return result ? result[3] : "";
}
function convertVersion(text) {
  return text.replace(/_/g, ".");
}
function findPreset(presets, userAgent) {
  var userPreset = null;
  var version = "-1";
  some(presets, function (preset) {
    var result = execRegExp("(" + preset.test + ")((?:\\/|\\s|:)([0-9|\\.|_]+))?", userAgent);

    if (!result || preset.brand) {
      return false;
    }

    userPreset = preset;
    version = result[3] || "-1";

    if (preset.versionAlias) {
      version = preset.versionAlias;
    } else if (preset.versionTest) {
      version = findVersion(preset.versionTest.toLowerCase(), userAgent) || version;
    }

    version = convertVersion(version);
    return true;
  });
  return {
    preset: userPreset,
    version: version
  };
}
function findPresetBrand(presets, brands) {
  var brandInfo = {
    brand: "",
    version: "-1"
  };
  some(presets, function (preset) {
    var result = findBrand(brands, preset);

    if (!result) {
      return false;
    }

    brandInfo.brand = preset.id;
    brandInfo.version = preset.versionAlias || result.version;
    return brandInfo.version !== "-1";
  });
  return brandInfo;
}
function findBrand(brands, preset) {
  return find(brands, function (_a) {
    var brand = _a.brand;
    return execRegExp("" + preset.test, brand.toLowerCase());
  });
}

var BROWSER_PRESETS = [{
  test: "phantomjs",
  id: "phantomjs"
}, {
  test: "whale",
  id: "whale"
}, {
  test: "edgios|edge|edg",
  id: "edge"
}, {
  test: "msie|trident|windows phone",
  id: "ie",
  versionTest: "iemobile|msie|rv"
}, {
  test: "miuibrowser",
  id: "miui browser"
}, {
  test: "samsungbrowser",
  id: "samsung internet"
}, {
  test: "samsung",
  id: "samsung internet",
  versionTest: "version"
}, {
  test: "chrome|crios",
  id: "chrome"
}, {
  test: "firefox|fxios",
  id: "firefox"
}, {
  test: "android",
  id: "android browser",
  versionTest: "version"
}, {
  test: "safari|iphone|ipad|ipod",
  id: "safari",
  versionTest: "version"
}]; // chromium's engine(blink) is based on applewebkit 537.36.

var CHROMIUM_PRESETS = [{
  test: "(?=.*applewebkit/(53[0-7]|5[0-2]|[0-4]))(?=.*\\schrome)",
  id: "chrome",
  versionTest: "chrome"
}, {
  test: "chromium",
  id: "chrome"
}, {
  test: "whale",
  id: "chrome",
  versionAlias: "-1",
  brand: true
}];
var WEBKIT_PRESETS = [{
  test: "applewebkit",
  id: "webkit",
  versionTest: "applewebkit|safari"
}];
var WEBVIEW_PRESETS = [{
  test: "(?=(iphone|ipad))(?!(.*version))",
  id: "webview"
}, {
  test: "(?=(android|iphone|ipad))(?=.*(naver|daum|; wv))",
  id: "webview"
}, {
  // test webview
  test: "webview",
  id: "webview"
}];
var OS_PRESETS = [{
  test: "windows phone",
  id: "windows phone"
}, {
  test: "windows 2000",
  id: "window",
  versionAlias: "5.0"
}, {
  test: "windows nt",
  id: "window"
}, {
  test: "win32|windows",
  id: "window"
}, {
  test: "iphone|ipad|ipod",
  id: "ios",
  versionTest: "iphone os|cpu os"
}, {
  test: "macos|macintel|mac os x",
  id: "mac"
}, {
  test: "android|linux armv81",
  id: "android"
}, {
  test: "tizen",
  id: "tizen"
}, {
  test: "webos|web0s",
  id: "webos"
}];

function isWebView(userAgent) {
  return !!findPreset(WEBVIEW_PRESETS, userAgent).preset;
}
function getLegacyAgent(userAgent) {
  var nextAgent = getUserAgentString(userAgent);
  var isMobile = !!/mobi/g.exec(nextAgent);
  var browser = {
    name: "unknown",
    version: "-1",
    majorVersion: -1,
    webview: isWebView(nextAgent),
    chromium: false,
    chromiumVersion: "-1",
    webkit: false,
    webkitVersion: "-1"
  };
  var os = {
    name: "unknown",
    version: "-1",
    majorVersion: -1
  };

  var _a = findPreset(BROWSER_PRESETS, nextAgent),
      browserPreset = _a.preset,
      browserVersion = _a.version;

  var _b = findPreset(OS_PRESETS, nextAgent),
      osPreset = _b.preset,
      osVersion = _b.version;

  var chromiumPreset = findPreset(CHROMIUM_PRESETS, nextAgent);
  browser.chromium = !!chromiumPreset.preset;
  browser.chromiumVersion = chromiumPreset.version;

  if (!browser.chromium) {
    var webkitPreset = findPreset(WEBKIT_PRESETS, nextAgent);
    browser.webkit = !!webkitPreset.preset;
    browser.webkitVersion = webkitPreset.version;
  }

  if (osPreset) {
    os.name = osPreset.id;
    os.version = osVersion;
    os.majorVersion = parseInt(osVersion, 10);
  }

  if (browserPreset) {
    browser.name = browserPreset.id;
    browser.version = browserVersion; // Early whale bugs

    if (browser.webview && os.name === "ios" && browser.name !== "safari") {
      browser.webview = false;
    }
  }

  browser.majorVersion = parseInt(browser.version, 10);
  return {
    browser: browser,
    os: os,
    isMobile: isMobile,
    isHints: false
  };
}

function getClientHintsAgent(osData) {
  var userAgentData = navigator.userAgentData;
  var brands = (userAgentData.uaList || userAgentData.brands).slice();
  var fullVersionList = osData && osData.fullVersionList;
  var isMobile = userAgentData.mobile || false;
  var firstBrand = brands[0];
  var platform = (osData && osData.platform || userAgentData.platform || navigator.platform).toLowerCase();
  var browser = {
    name: firstBrand.brand,
    version: firstBrand.version,
    majorVersion: -1,
    webkit: false,
    webkitVersion: "-1",
    chromium: false,
    chromiumVersion: "-1",
    webview: !!findPresetBrand(WEBVIEW_PRESETS, brands).brand || isWebView(getUserAgentString())
  };
  var os = {
    name: "unknown",
    version: "-1",
    majorVersion: -1
  };
  browser.webkit = !browser.chromium && some(WEBKIT_PRESETS, function (preset) {
    return findBrand(brands, preset);
  });
  var chromiumBrand = findPresetBrand(CHROMIUM_PRESETS, brands);
  browser.chromium = !!chromiumBrand.brand;
  browser.chromiumVersion = chromiumBrand.version;

  if (!browser.chromium) {
    var webkitBrand = findPresetBrand(WEBKIT_PRESETS, brands);
    browser.webkit = !!webkitBrand.brand;
    browser.webkitVersion = webkitBrand.version;
  }

  var platfomResult = find(OS_PRESETS, function (preset) {
    return new RegExp("" + preset.test, "g").exec(platform);
  });
  os.name = platfomResult ? platfomResult.id : "";

  if (osData) {
    os.version = osData.platformVersion;
  }

  if (fullVersionList && fullVersionList.length) {
    var browserBrandByFullVersionList = findPresetBrand(BROWSER_PRESETS, fullVersionList);
    browser.name = browserBrandByFullVersionList.brand || browser.name;
    browser.version = browserBrandByFullVersionList.version || browser.version;
  } else {
    var browserBrand = findPresetBrand(BROWSER_PRESETS, brands);
    browser.name = browserBrand.brand || browser.name;
    browser.version = browserBrand.brand && osData ? osData.uaFullVersion : browserBrand.version;
  }

  if (browser.webkit) {
    os.name = isMobile ? "ios" : "mac";
  }

  if (os.name === "ios" && browser.webview) {
    browser.version = "-1";
  }

  os.version = convertVersion(os.version);
  browser.version = convertVersion(browser.version);
  os.majorVersion = parseInt(os.version, 10);
  browser.majorVersion = parseInt(browser.version, 10);
  return {
    browser: browser,
    os: os,
    isMobile: isMobile,
    isHints: true
  };
}

/**
 * @namespace eg.agent
 */

/**
* Extracts accuate browser and operating system information from the user agent string or client hints.
* @ko 유저 에이전트 문자열 또는 client hints에서 정확한 브라우저와 운영체제 정보를 추출한다.
* @function eg.agent#getAccurateAgent
* @param - Callback function to get the accuate agent <ko>정확한 에이전트를 가져오기 위한 callback 함수</ko>
* @return - get the accuate agent promise. If Promise are not supported, null is returned. <ko> 정확한 에이전트 promise를 가져온다. Promise를 지원 하지 않는 경우, null을 반환한다. </ko>
* @example
import { getAccurateAgent } from "@egjs/agent";
// eg.agent.getAccurateAgent()
getAccurateAgent().then(agent => {
   const { os, browser, isMobile } = agent;
});
getAccurateAgent(agent => {
    const { os, browser, isMobile } = agent;
});
*/

function getAccurateAgent(callback) {
  if (hasUserAgentData()) {
    return navigator.userAgentData.getHighEntropyValues(["architecture", "model", "platform", "platformVersion", "uaFullVersion", "fullVersionList"]).then(function (info) {
      var agentInfo = getClientHintsAgent(info);
      callback && callback(agentInfo);
      return agentInfo;
    });
  }

  callback && callback(agent());

  if (typeof Promise === "undefined" || !Promise) {
    return null;
  }

  return Promise.resolve(agent());
}
/**
 * Extracts browser and operating system information from the user agent string.
 * @ko 유저 에이전트 문자열에서 브라우저와 운영체제 정보를 추출한다.
 * @function eg.agent#agent
 * @param - user agent string to parse <ko>파싱할 유저에이전트 문자열</ko>
 * @return - agent Info <ko> 에이전트 정보 </ko>
 * @example
import agent from "@egjs/agent";
// eg.agent();
const { os, browser, isMobile } = agent();
 */

function agent(userAgent) {
  if (typeof userAgent === "undefined" && hasUserAgentData()) {
    return getClientHintsAgent();
  } else {
    return getLegacyAgent(userAgent);
  }
}

/* harmony default export */ var agent_esm = (agent);

//# sourceMappingURL=agent.esm.js.map

// CONCATENATED MODULE: ./node_modules/@cfcs/core/dist/cfcs.esm.js
/*
Copyright (c) 2022-present NAVER Corp.
name: @cfcs/core
license: MIT
author: NAVER Crop.
repository: https://github.com/naver/cfcs/tree/main/packages/core
version: 0.1.0
*/


/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */

/**
 * @hidden
 */
function keys(obj) {
  return Object.keys(obj);
}
/**
 * @hidden
 */

function camelize(str) {
  return str.replace(/[\s-_]([a-z])/g, function (all, letter) {
    return letter.toUpperCase();
  });
}
/**
 * @hidden
 */

function isString(val) {
  return typeof val === "string";
}
/**
 * @hidden
 */

function cfcs_esm_isObject(val) {
  return typeof val === "object";
}
/**
 * @hidden
 */

function isFunction(val) {
  return typeof val === "function";
}

/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */
/**
 * @hidden
 */

function findTarget(target) {
  var el;

  if (!target) {
    return null;
  }

  if (isString(target)) {
    el = document.querySelector(target);
  } else if (target instanceof Element) {
    el = target;
  } else if ("value" in target || "current" in target) {
    el = target.value || target.current;
  }

  return el;
}
/**
 * @description Sets the name of the class method to be exposed to the outside.
 * @category DOM
 * @return Property Decorator
 * @example
 * ```ts
 * import { withClassMethods } from "@cfcs/core";
 *
 * class YourFrameworkComponent {
 *   @withClassMethod(METHOD_NAMES)
 *   inst = new YourComponent();
 * }
 * ```
 */

function withClassMethods(methods) {
  return function (prototype, memberName) {
    methods.forEach(function (name) {
      if (name in prototype) {
        return;
      }

      prototype[name] = function () {
        var _a;

        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        var result = (_a = this[memberName])[name].apply(_a, args); // fix `this` type to return your own `class` instance to the instance using the decorator.


        if (result === this[memberName]) {
          return this;
        } else {
          return result;
        }
      };
    });
  };
}

/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */
var OBSERVERS_PATH = "__observers__";
var COMPUTED_PATH = "__computed__";
var CFCS_DETECTED_DEPENDENCIES_VERSION = 1;
var CFCS_DETECTED_DEPENDENCIES = "__CFCS_DETECTED_DEPENDENCIES__";

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };

  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */
function getDetectedStack() {
  // Version issues do not occur when you access the native object in the global.
  Object[CFCS_DETECTED_DEPENDENCIES] = Object[CFCS_DETECTED_DEPENDENCIES] || {};
  var versionList = Object[CFCS_DETECTED_DEPENDENCIES];
  versionList[CFCS_DETECTED_DEPENDENCIES_VERSION] = versionList[CFCS_DETECTED_DEPENDENCIES_VERSION] || [];
  return versionList[CFCS_DETECTED_DEPENDENCIES_VERSION];
}
function getCurrentDetected() {
  var stack = getDetectedStack();
  return stack[stack.length - 1];
}
function detectDependencies(host) {
  var stack = getDetectedStack();
  var observers = [];
  var detected = {
    host: host,
    observers: observers,
    push: function (observer) {
      if (host !== observer && observers.indexOf(observer) === -1) {
        observers.push(observer);
      }
    }
  };
  stack.push(detected);
  return detected;
}
function endDetectDependencies() {
  var stack = getDetectedStack();
  return stack.pop();
}

/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */
/**
 * Creates a mutable ref object. You can access the `.current` value and detect the value change through `.subscribe`.
 * @category Reactive
 * @see observe
 */

var cfcs_esm_Observer =
/*#__PURE__*/
function () {
  /**
   *
   */
  function Observer(value) {
    this._emitter = new component_esm();
    this._current = value;
  }

  var __proto = Observer.prototype;
  Object.defineProperty(__proto, "current", {
    /**
     * return the current value.
     */
    get: function () {
      var currentDetected = getCurrentDetected();
      currentDetected === null || currentDetected === void 0 ? void 0 : currentDetected.push(this);
      return this._current;
    },
    set: function (value) {
      this._setCurrent(value);
    },
    enumerable: false,
    configurable: true
  });
  /**
   * When the current value changes, the callback function is called.
   */

  __proto.subscribe = function (callback) {
    this.current;

    this._emitter.on("update", callback);

    return this;
  };
  /**
   * Cancel the registered subscription through callback.
   */


  __proto.unsubscribe = function (callback) {
    this._emitter.off("update", callback);

    return this;
  };

  __proto._setCurrent = function (value) {
    var prevValue = this._current;
    var isUpdate = value !== prevValue;
    this._current = value;

    if (isUpdate) {
      this._emitter.trigger("update", value, prevValue);
    }
  };
  /**
   * @hidden
   */


  __proto.toString = function () {
    return "".concat(this.current);
  };
  /**
   * @hidden
   */


  __proto.valueOf = function () {
    return this.current;
  };

  return Observer;
}();

/**
 * @category Reactive
 * @hidden
 */

var ComputedObserver =
/*#__PURE__*/
function (_super) {
  __extends(ComputedObserver, _super);
  /**
   * @description Creates a new computed observer from the values of other observers.
   * It is read-only and if you change the value of the observer used inside the callback, its value will be automatically updated.
   * @param _computedCallback A function for observers to be computed.
   */


  function ComputedObserver(_computedCallback) {
    var _this = _super.call(this) || this;

    _this._computedCallback = _computedCallback;
    _this._registered = [];

    _this._onCheckUpdate = function () {
      _this._setCurrent(_this.current);
    };

    _this._current = _this.current;
    return _this;
  }

  var __proto = ComputedObserver.prototype;
  Object.defineProperty(__proto, "current", {
    get: function () {
      var _this = this;

      detectDependencies(this);

      var value = this._computedCallback();

      var results = endDetectDependencies();

      this._registered.forEach(function (observer) {
        observer.unsubscribe(_this._onCheckUpdate);
      });

      results.observers.forEach(function (observer) {
        observer.subscribe(_this._onCheckUpdate);
      });
      this._registered = results.observers;
      return value;
    },
    enumerable: false,
    configurable: true
  });
  return ComputedObserver;
}(cfcs_esm_Observer);

/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */

function injectObserve(prototype, memberName, publicName) {
  if (publicName === void 0) {
    publicName = memberName;
  }

  var nextAttributes = {
    configurable: true,
    get: function () {
      return getObserver(this, publicName).current;
    },
    set: function (value) {
      getObserver(this, publicName, value).current = value;
    }
  };
  Object.defineProperty(prototype, memberName, nextAttributes);

  if (publicName !== memberName) {
    Object.defineProperty(prototype, publicName, {
      configurable: true,
      get: function () {
        return getObserver(this, publicName).current;
      }
    });
  }
}
/**
 * @description `Observe` is a property decorator and converts the property into a `reactive state`. You can detect its status through `.subscribe`.
 * @category Reactive-Decorator
 * @see ReactiveSubscribe
 * @example
* ```ts
import { ReactiveSubscribe, Observe } from "@cfcs/core";

@ReactiveSubscribe
class Component {
  // The public name and state name are the same.
  @Observe value1 = 1;
  // If you want to set public name and private properties separately
  @Observe("value2") _value2 = 1;

  constructor() {
    requestAnimationFrame(() => {
      this.value1 = 2;
    });
  }
}
interface C
```
 */


function Observe() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  if (args.length > 1) {
    return injectObserve(args[0], args[1]);
  }

  return function (prototype, memberName) {
    return injectObserve(prototype, memberName, args[0]);
  };
}
/**
 * @hidden
 */

function Reactive() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return Observe.apply(void 0, args);
}

/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */
/**
 * @hidden
 */

function injectReactiveSubscribe(object) {
  object["subscribe"] = function (name, callback) {
    this[name];
    getObserver(this, name).subscribe(callback);
  };

  object["unsubscribe"] = function (name, callback) {
    var _this = this;

    if (!name) {
      keys(getObservers(this)).forEach(function (observerName) {
        _this.unsubscribe(observerName);
      });
      return;
    }

    if (!(name in this)) {
      return;
    }

    getObserver(this, name).unsubscribe(callback);
  };
}
/**
 * @description `ReactiveSubscribe` is a class decorator and adds `.subscribe` and `.unsubscribe` methods.
 * @category Reactive-Decorator
 * @see Observe
 * @example
 * ```ts
import { ReactiveSubscribe, Observe } from "@cfcs/core";

@ReactiveSubscribe
class Component {
  @Observe value1 = 1;

  constructor() {
    requestAnimationFrame(() => {
      this.value1 = 2;
    });
  }
}

interface Component extends ReactiveSubscribe<{
  value1: number;
  value2: number;
}> {}

const component = new Component();

// 1
console.log(component.value1);

component.subscribe("value1", nextValue => {
  // When the change event occurs => (2, 2)
  console.log(nextValue, component.value2);
});
```
 */

function ReactiveSubscribe(Constructor) {
  var prototype = Constructor.prototype;
  injectReactiveSubscribe(prototype);
}

/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */

function makeReactiveObject(setup, all) {
  var result = isFunction(setup) ? setup() : setup;
  var reactiveObject = {};
  defineObservers(reactiveObject);
  keys(result).forEach(function (name) {
    var value = result[name];

    if (isObserver(value)) {
      setObserver(reactiveObject, name, value);
    } else {
      setObserver(reactiveObject, name, observe(value));
    }

    Observe(name)(reactiveObject, name);
  });
  injectReactiveSubscribe(reactiveObject);
  return reactiveObject;
}
/**
 * @description Make the return value of the corresponding object or function a reactive object.
 * @category Reactive
 * @param setup - The target object or function to which reactive is applied
 * @returns Makes all values into reactive objects.
 * @example
 * ```ts
 * import { reactive } from "@cfcs/core";
 *
 * const obj = reactive({
 *  value1: 1,
 *  value2: 2,
 * });
 *
 * obj.subscribe("value1", value1 => {
 *   console.log(value1);
 * });
 * obj.value1 = 2;
 * ```
 */


function reactive(setup) {
  return makeReactiveObject(setup);
}
/**
 * @description Make the return value of the corresponding object or function a reactive object.
 * @category Reactive
 * @param setup - The target object or function to which reactive is applied
 * @returns Only the values to which observer is applied are objects to which reactive is applied.
 * @example
 * ```ts
 * import { partialReactive, observe } from "@cfcs/core";
 *
 * const value1 = observe(1);
 * const value2 = observe(2);
 * const obj = partialReactive({
 *  value1,
 *  value2,
 * });
 *
 * obj.subscribe("value1", value1 => {
 *   console.log(value1);
 * });
 * value1.current = 2;
 * ```
 */

function partialReactive(setup) {
  return makeReactiveObject(setup);
}
/**
 * @description Creates a mutable ref object. You can access the `.current` value and detect the value change through `.subscribe`.
 * @category Reactive
 * @example
 * ```ts
 * import { observe } from "@cfcs/core";
 *
 * const ob1 = observe(1);
 *
 * ob1.subscribe(nextValue => {
 *   console.log(nextValue);
 * });
 *
 * ob1.current = 2;
 * ```
 */

function observe(defaultValue) {
  return new cfcs_esm_Observer(defaultValue);
}
/**
 * @hidden
 */

function computed(computedCallback) {
  return new ComputedObserver(computedCallback);
}

/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */
/**
 * @hidden
 */

function withReactiveMethods(ref, methods) {
  var obj = {};

  if (!methods) {
    return obj;
  }

  methods.forEach(function (name) {
    obj[name] = function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var current = ref.current || ref.value;
      return current[name].apply(current, args);
    };
  });
  return obj;
}
/**
 * @hidden
 */

function defineObservers(instance) {
  var observers = {};
  Object.defineProperty(instance, OBSERVERS_PATH, {
    get: function () {
      return observers;
    }
  });
  return observers;
}
/**
 * @hidden
 */

function getObservers(instance, isComputed) {
  var _a, _b;

  if (!instance[OBSERVERS_PATH]) {
    defineObservers(instance);
  }

  var observers = instance[OBSERVERS_PATH];

  if (!isComputed) {
    var computedList = (_b = (_a = instance === null || instance === void 0 ? void 0 : instance.constructor) === null || _a === void 0 ? void 0 : _a.prototype) === null || _b === void 0 ? void 0 : _b[COMPUTED_PATH];

    if (computedList) {
      computedList.forEach(function (name) {
        if (!(name in observers) && name in instance) {
          instance[name];
        }
      });
    }
  }

  return observers;
}
/**
 * @hidden
 */

function getObserver(instance, name, defaultValue) {
  var observers = getObservers(instance);

  if (!observers[name]) {
    observers[name] = observe(defaultValue);
  }

  return observers[name];
}
/**
 * @hidden
 */

function setObserver(instance, name, observer) {
  var observers = getObservers(instance);
  observers[name] = observer;
}
/**
 * @description Whether that object is an observer instance
 * @category Reactive
 */

function isObserver(val) {
  return val && cfcs_esm_isObject(val) && "current" in val && "subscribe" in val && "unsubscribe" in val;
}
/**
 * @description Whether the object is reactive
 * @category Reactive
 */

function isReactive(val) {
  return val && !isObserver(val) && "subscribe" in val && "unsubscribe" in val;
}

/**
 * @category Reactive
 * @hidden
 */

function adaptReactive(adapter, props) {
  var objectAdapter = isFunction(adapter) ? {
    setup: adapter
  } : adapter;

  function getProps() {
    var _a, _b, _c, _d, _e;

    return (_e = (_c = (_a = props === null || props === void 0 ? void 0 : props()) !== null && _a !== void 0 ? _a : (_b = objectAdapter.props) === null || _b === void 0 ? void 0 : _b.call(objectAdapter)) !== null && _c !== void 0 ? _c : (_d = objectAdapter.data) === null || _d === void 0 ? void 0 : _d.call(objectAdapter)) !== null && _e !== void 0 ? _e : {};
  }

  var eventEmitter = new component_esm();
  var mountedHooks = [];
  var initHooks = [];
  var destroyHooks = [];
  var onHooks = [];
  var instanceRef = {
    current: null
  };
  var offHooksList = [];
  var initialState = null;
  var eventNames = [];
  var methodNames = [];

  var onMounted = function (callback) {
    mountedHooks.push(callback);
  };

  var onInit = function (callback) {
    initHooks.push(callback);
  };

  var onDestroy = function (callback) {
    destroyHooks.push(callback);
  };

  var on = function (callback) {
    onHooks.push(callback);
  };

  var emit = function (eventName) {
    var params = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      params[_i - 1] = arguments[_i];
    }

    eventEmitter.trigger.apply(eventEmitter, __spreadArray([eventName], params, false));
  };

  var setInitialState = function (state) {
    initialState = state;
  };

  var setEvents = function (events) {
    eventNames = events;
  };

  var setMethods = function (methods) {
    methodNames = methods;
  };

  if (objectAdapter.setup) {
    instanceRef.current = objectAdapter.setup({
      getProps: getProps,
      setInitialState: setInitialState,
      setEvents: setEvents,
      setMethods: setMethods,
      onMounted: onMounted,
      onDestroy: onDestroy,
      onInit: onInit,
      emit: emit,
      on: on
    }) || null;
  }

  if (objectAdapter.created) {
    instanceRef.current = objectAdapter.created(getProps()) || null;
  }

  if (objectAdapter.events) {
    setEvents(objectAdapter.events);
  }

  if (objectAdapter.state) {
    setInitialState(objectAdapter.state);
  }

  if (objectAdapter.methods) {
    setMethods(objectAdapter.methods);
  }

  if (objectAdapter.mounted) {
    onMounted(objectAdapter.mounted);
  }

  if (objectAdapter.destroy) {
    destroyHooks.push(objectAdapter.destroy);
  }

  if (objectAdapter.init) {
    initHooks.push(objectAdapter.init);
  }

  if (objectAdapter.on) {
    onHooks.push(function (instance, eventName, listener) {
      var off = objectAdapter.on(instance, eventName, listener);
      return function () {
        var _a;

        off && off();
        (_a = objectAdapter.off) === null || _a === void 0 ? void 0 : _a.call(objectAdapter, instance, eventName, listener);
      };
    });
  }

  return {
    events: function () {
      return eventNames;
    },
    state: function () {
      var inst = instanceRef.current;

      if (initialState) {
        return initialState;
      }

      if (inst) {
        var observers_1 = getObservers(inst);
        setInitialState(keys(observers_1).reduce(function (prev, cur) {
          prev[cur] = observers_1[cur].current;
          return prev;
        }, {}));
      }

      return initialState || {};
    },
    instance: function () {
      return instanceRef.current;
    },
    mounted: function () {
      var props = getProps();
      mountedHooks.forEach(function (hook) {
        instanceRef.current = hook(props, instanceRef.current) || instanceRef.current;
      });
    },
    init: function () {
      // on events
      var instance = instanceRef.current;
      var props = getProps();
      offHooksList = eventNames.map(function (eventName) {
        var listener = function () {
          var _a;

          var params = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
          }

          (_a = eventEmitter).trigger.apply(_a, __spreadArray([eventName], params, false));
        };

        var instance = instanceRef.current;
        return onHooks.map(function (hook) {
          return hook(instance, eventName, listener);
        }).filter(Boolean);
      }); // init

      initHooks.forEach(function (hook) {
        hook(instance, props);
      });
    },
    destroy: function () {
      // off events
      offHooksList.forEach(function (offHooks) {
        offHooks.forEach(function (hook) {
          hook();
        });
      }); // destroy

      eventEmitter.off();
      var instance = instanceRef.current;
      var props = getProps();
      destroyHooks.forEach(function (hook) {
        hook(instance, props);
      });
    },
    methods: function () {
      return withReactiveMethods(instanceRef, methodNames);
    },
    on: function (eventName, listener) {
      eventEmitter.on(eventName, listener);
    },
    off: function (eventName, listener) {
      eventEmitter.off(eventName, listener);
    }
  };
}

/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */
/**
 * @description `Computed` is a property decorator.
 * Changes in computed state values are also recognized according to changes in observers used within the getter function.
 * You can detect its status through `.subscribe`.
 * @hidden
 * @category Reactive-Decorator
 * @see ReactiveSubscribe
 * @example
 * ```ts
const ob1 = observe(0);
const ob2 = observe(1);

// When
@ReactiveSubscribe
class TestComputed {
  @Computed
  get ob3() {
    return ob1.current + ob2.current;
  }
}
const inst = new TestComputed();

inst.subscribe("ob3", ob3 => {
  console.log(ob3);
});

ob1.current = 1;
```
 */

function Computed(prototype, memberName, attributes) {
  var get = attributes.get;

  function getComputed() {
    var observers = getObservers(this, true);

    if (!(memberName in observers)) {
      observers[memberName] = computed(get.bind(this));
    }

    return getObserver(this, memberName).current;
  }

  var nextAttributes = {
    configurable: true,
    get: getComputed
  };
  prototype[COMPUTED_PATH] || (prototype[COMPUTED_PATH] = []);
  var computedList = prototype[COMPUTED_PATH];

  if (computedList.indexOf(memberName) === -1) {
    computedList.push(memberName);
  }

  Object.defineProperty(prototype, memberName, nextAttributes);
  return nextAttributes;
}


//# sourceMappingURL=cfcs.esm.js.map

// CONCATENATED MODULE: ./node_modules/@egjs/axes/dist/axes.esm.js
/*
Copyright (c) NAVER Corp.
name: @egjs/axes
license: MIT
author: NAVER Corp.
repository: https://github.com/naver/egjs-axes
version: 3.9.0
*/




/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var axes_esm_extendStatics = function (d, b) {
  axes_esm_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return axes_esm_extendStatics(d, b);
};
function axes_esm_extends(d, b) {
  axes_esm_extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
/* eslint-disable no-new-func, no-nested-ternary */
var win;
if (typeof window === "undefined") {
  // window is undefined in node.js
  win = {
    navigator: {
      userAgent: ""
    }
  };
} else {
  win = window;
}

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_HORIZONTAL = 2 | 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;
var DIRECTION_VERTICAL = 8 | 16;
var DIRECTION_ALL = 2 | 4 | 8 | 16;
var MOUSE_LEFT = "left";
var MOUSE_RIGHT = "right";
var MOUSE_MIDDLE = "middle";
var MOUSE_BUTTON_CODE_MAP = {
  1: MOUSE_LEFT,
  2: MOUSE_MIDDLE,
  3: MOUSE_RIGHT
};
var ANY = "any";
var NONE = "none";
var SHIFT = "shift";
var CTRL = "ctrl";
var ALT = "alt";
var META = "meta";
var VELOCITY_INTERVAL = 16;
var AXES_METHODS = ["connect", "disconnect", "get", "setTo", "setBy", "setOptions", "setAxis", "stopAnimation", "updateAnimation", "isBounceArea"];
var AXES_EVENTS = ["hold", "release", "change", "animationStart", "animationEnd", "finish"];
var IOS_EDGE_THRESHOLD = 30;
var IS_IOS_SAFARI = "ontouchstart" in win && agent_esm().browser.name === "safari";
var TRANSFORM = function () {
  if (typeof document === "undefined") {
    return "";
  }
  var bodyStyle = (document.head || document.getElementsByTagName("head")[0]).style;
  var target = ["transform", "webkitTransform", "msTransform", "mozTransform"];
  for (var i = 0, len = target.length; i < len; i++) {
    if (target[i] in bodyStyle) {
      return target[i];
    }
  }
  return "";
}();
var PREVENT_DRAG_CSSPROPS = {
  "-webkit-user-select": "none",
  "-ms-user-select": "none",
  "-moz-user-select": "none",
  "user-select": "none",
  "-webkit-user-drag": "none"
};

var toArray = function (nodes) {
  // const el = Array.prototype.slice.call(nodes);
  // for IE8
  var el = [];
  for (var i = 0, len = nodes.length; i < len; i++) {
    el.push(nodes[i]);
  }
  return el;
};
var $ = function (param, multi) {
  if (multi === void 0) {
    multi = false;
  }
  var el;
  if (typeof param === "string") {
    // String (HTML, Selector)
    // check if string is HTML tag format
    var match = param.match(/^<([a-z]+)\s*([^>]*)>/);
    // creating element
    if (match) {
      // HTML
      var dummy = document.createElement("div");
      dummy.innerHTML = param;
      el = toArray(dummy.childNodes);
    } else {
      // Selector
      el = toArray(document.querySelectorAll(param));
    }
    if (!multi) {
      el = el.length >= 1 ? el[0] : undefined;
    }
  } else if (param === win) {
    // window
    el = param;
  } else if ("value" in param || "current" in param) {
    el = param.value || param.current;
  } else if (param.nodeName && (param.nodeType === 1 || param.nodeType === 9)) {
    // HTMLElement, Document
    el = param;
  } else if ("jQuery" in win && param instanceof jQuery || param.constructor.prototype.jquery) {
    // jQuery
    el = multi ? param.toArray() : param.get(0);
  } else if (Array.isArray(param)) {
    el = param.map(function (v) {
      return $(v);
    });
    if (!multi) {
      el = el.length >= 1 ? el[0] : undefined;
    }
  }
  return el;
};
var raf = win.requestAnimationFrame || win.webkitRequestAnimationFrame;
var caf = win.cancelAnimationFrame || win.webkitCancelAnimationFrame;
if (raf && !caf) {
  var keyInfo_1 = {};
  var oldraf_1 = raf;
  raf = function (callback) {
    var wrapCallback = function (timestamp) {
      if (keyInfo_1[key]) {
        callback(timestamp);
      }
    };
    var key = oldraf_1(wrapCallback);
    keyInfo_1[key] = true;
    return key;
  };
  caf = function (key) {
    delete keyInfo_1[key];
  };
} else if (!(raf && caf)) {
  raf = function (callback) {
    return win.setTimeout(function () {
      callback(win.performance && win.performance.now && win.performance.now() || new Date().getTime());
    }, 16);
  };
  caf = win.clearTimeout;
}
/**
 * A polyfill for the window.requestAnimationFrame() method.
 * @see  https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
 * @private
 */
var requestAnimationFrame = function (fp) {
  return raf(fp);
};
/**
 * A polyfill for the window.cancelAnimationFrame() method. It cancels an animation executed through a call to the requestAnimationFrame() method.
 * @param {Number} key −  The ID value returned through a call to the requestAnimationFrame() method. <ko>requestAnimationFrame() 메서드가 반환한 아이디 값</ko>
 * @see  https://developer.mozilla.org/en-US/docs/Web/API/Window/cancelAnimationFrame
 * @private
 */
var cancelAnimationFrame = function (key) {
  caf(key);
};
var map = function (obj, callback) {
  var tranformed = {};
  for (var k in obj) {
    if (k) {
      tranformed[k] = callback(obj[k], k);
    }
  }
  return tranformed;
};
var filter = function (obj, callback) {
  var filtered = {};
  for (var k in obj) {
    if (k && callback(obj[k], k)) {
      filtered[k] = obj[k];
    }
  }
  return filtered;
};
var every = function (obj, callback) {
  for (var k in obj) {
    if (k && !callback(obj[k], k)) {
      return false;
    }
  }
  return true;
};
var equal = function (target, base) {
  return every(target, function (v, k) {
    return v === base[k];
  });
};
var roundNumFunc = {};
var roundNumber = function (num, roundUnit) {
  // Cache for performance
  if (!roundNumFunc[roundUnit]) {
    roundNumFunc[roundUnit] = getRoundFunc(roundUnit);
  }
  return roundNumFunc[roundUnit](num);
};
var roundNumbers = function (num, roundUnit) {
  if (!num || !roundUnit) {
    return num;
  }
  return map(num, function (value, key) {
    return roundNumber(value, typeof roundUnit === "number" ? roundUnit : roundUnit[key]);
  });
};
var getDecimalPlace = function (val) {
  if (!isFinite(val)) {
    return 0;
  }
  var v = "".concat(val);
  if (v.indexOf("e") >= 0) {
    // Exponential Format
    // 1e-10, 1e-12
    var p = 0;
    var e = 1;
    while (Math.round(val * e) / e !== val) {
      e *= 10;
      p++;
    }
    return p;
  }
  // In general, following has performance benefit.
  // https://jsperf.com/precision-calculation
  return v.indexOf(".") >= 0 ? v.length - v.indexOf(".") - 1 : 0;
};
var inversePow = function (n) {
  // replace Math.pow(10, -n) to solve floating point issue.
  // eg. Math.pow(10, -4) => 0.00009999999999999999
  return 1 / Math.pow(10, n);
};
var getRoundFunc = function (v) {
  var p = v < 1 ? Math.pow(10, getDecimalPlace(v)) : 1;
  return function (n) {
    if (v === 0) {
      return 0;
    }
    return Math.round(Math.round(n / v) * v * p) / p;
  };
};
var getAngle = function (posX, posY) {
  return Math.atan2(posY, posX) * 180 / Math.PI;
};
var isCssPropsFromAxes = function (originalCssProps) {
  var same = true;
  Object.keys(PREVENT_DRAG_CSSPROPS).forEach(function (prop) {
    if (!originalCssProps || originalCssProps[prop] !== PREVENT_DRAG_CSSPROPS[prop]) {
      same = false;
    }
  });
  return same;
};
var getDirection = function (useHorizontal, useVertical) {
  if (useHorizontal && useVertical) {
    return DIRECTION_ALL;
  } else if (useHorizontal) {
    return DIRECTION_HORIZONTAL;
  } else if (useVertical) {
    return DIRECTION_VERTICAL;
  } else {
    return DIRECTION_NONE;
  }
};
var useDirection = function (checkType, direction, userDirection) {
  if (userDirection) {
    return !!(direction === DIRECTION_ALL || direction & checkType && userDirection & checkType);
  } else {
    return !!(direction & checkType);
  }
};
var setCssProps = function (element, option, direction) {
  var _a;
  var touchActionMap = (_a = {}, _a[DIRECTION_NONE] = "auto", _a[DIRECTION_ALL] = "none", _a[DIRECTION_VERTICAL] = "pan-x", _a[DIRECTION_HORIZONTAL] = "pan-y", _a);
  var oldCssProps = {};
  if (element && element.style) {
    var touchAction = option.touchAction ? option.touchAction : touchActionMap[direction];
    var newCssProps_1 = __assign(__assign({}, PREVENT_DRAG_CSSPROPS), {
      "touch-action": element.style["touch-action"] === "none" ? "none" : touchAction
    });
    Object.keys(newCssProps_1).forEach(function (prop) {
      oldCssProps[prop] = element.style[prop];
      element.style[prop] = newCssProps_1[prop];
    });
  }
  return oldCssProps;
};
var revertCssProps = function (element, originalCssProps) {
  if (element && element.style && originalCssProps) {
    Object.keys(originalCssProps).forEach(function (prop) {
      element.style[prop] = originalCssProps[prop];
    });
  }
  return;
};

var axes_esm_EventManager = /*#__PURE__*/function () {
  function EventManager(_axes) {
    this._axes = _axes;
    this.holdingCount = 0;
  }
  /**
   * This event is fired when a user holds an element on the screen of the device.
   * @ko 사용자가 기기의 화면에 손을 대고 있을 때 발생하는 이벤트
   * @event Axes#hold
   * @type {object}
   * @property {Object.<string, number>} pos coordinate <ko>좌표 정보</ko>
   * @property {Object} input The instance of inputType where the event occurred<ko>이벤트가 발생한 inputType 인스턴스</ko>
   * @property {Object} inputEvent The event object received from inputType <ko>inputType으로 부터 받은 이벤트 객체</ko>
   * @property {Boolean} isTrusted Returns true if an event was generated by the user action, or false if it was caused by a script or API call <ko>사용자의 액션에 의해 이벤트가 발생하였으면 true, 스크립트나 API호출에 의해 발생하였을 경우에는 false를 반환한다.</ko>
   *
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "zoom": {
   *      range: [50, 30]
   *   }
   * }).on("hold", function(event) {
   *   // event.pos
   *   // event.input
   *   // event.inputEvent
   *   // isTrusted
   * });
   * ```
   */
  var __proto = EventManager.prototype;
  __proto.hold = function (pos, option) {
    var roundPos = this._getRoundPos(pos).roundPos;
    this._axes.trigger(new ComponentEvent$1("hold", {
      pos: roundPos,
      input: option.input || null,
      inputEvent: option.event || null,
      isTrusted: true
    }));
  };
  /**
   * Specifies the coordinates to move after the 'change' event. It works when the holding value of the change event is true.
   * @ko 'change' 이벤트 이후 이동할 좌표를 지정한다. change이벤트의 holding 값이 true일 경우에 동작한다
   * @param {Object.<string, number>} pos The coordinate to move to <ko>이동할 좌표</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "zoom": {
   *      range: [50, 30]
   *   }
   * }).on("change", function(event) {
   *   event.holding && event.set({x: 10});
   * });
   * ```
   */
  /** Specifies the animation coordinates to move after the 'release' or 'animationStart' events.
   * @ko 'release' 또는 'animationStart' 이벤트 이후 이동할 좌표를 지정한다.
   * @param {Object.<string, number>} pos The coordinate to move to <ko>이동할 좌표</ko>
   * @param {Number} [duration=0] Duration of the animation (unit: ms) <ko>애니메이션 진행 시간(단위: ms)</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "zoom": {
   *      range: [50, 30]
   *   }
   * }).on("animationStart", function(event) {
   *   event.setTo({x: 10}, 2000);
   * });
   * ```
   */
  /**
   * This event is fired when a user release an element on the screen of the device.
   * @ko 사용자가 기기의 화면에서 손을 뗐을 때 발생하는 이벤트
   * @event Axes#release
   * @type {object}
   * @property {Object.<string, number>} depaPos The coordinates when releasing an element<ko>손을 뗐을 때의 좌표 </ko>
   * @property {Object.<string, number>} destPos The coordinates to move to after releasing an element<ko>손을 뗀 뒤에 이동할 좌표</ko>
   * @property {Object.<string, number>} delta  The movement variation of coordinate <ko>좌표의 변화량</ko>
   * @property {Object.<string, number>} bounceRatio If the coordinates at the time of release are in the bounce area, the current bounce value divided by the maximum bounce value <ko>손을 뗐을 때의 좌표가 bounce 영역에 있는 경우 현재 bounce된 값을 최대 bounce 값으로 나눈 수치.</ko>
   * @property {Object} inputEvent The event object received from inputType <ko>inputType으로 부터 받은 이벤트 객체</ko>
   * @property {Object} input The instance of inputType where the event occurred<ko>이벤트가 발생한 inputType 인스턴스</ko>
   * @property {setTo} setTo Specifies the animation coordinates to move after the event <ko>이벤트 이후 이동할 애니메이션 좌표를 지정한다</ko>
   * @property {Boolean} isTrusted Returns true if an event was generated by the user action, or false if it was caused by a script or API call <ko>사용자의 액션에 의해 이벤트가 발생하였으면 true, 스크립트나 API호출에 의해 발생하였을 경우에는 false를 반환한다.</ko>
   *
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "zoom": {
   *      range: [50, 30]
   *   }
   * }).on("release", function(event) {
   *   // event.depaPos
   *   // event.destPos
   *   // event.delta
   *   // event.input
   *   // event.inputEvent
   *   // event.setTo
   *   // event.isTrusted
   *
   *   // if you want to change the animation coordinates to move after the 'release' event.
   *   event.setTo({x: 10}, 2000);
   * });
   * ```
   */
  __proto.triggerRelease = function (param) {
    var _a = this._getRoundPos(param.destPos, param.depaPos),
      roundPos = _a.roundPos,
      roundDepa = _a.roundDepa;
    param.destPos = roundPos;
    param.depaPos = roundDepa;
    param.setTo = this._createUserControll(param.destPos, param.duration);
    this._axes.trigger(new ComponentEvent$1("release", __assign(__assign({}, param), {
      bounceRatio: this._getBounceRatio(roundPos)
    })));
  };
  /**
   * This event is fired when coordinate changes.
   * @ko 좌표가 변경됐을 때 발생하는 이벤트
   * @event Axes#change
   * @type {object}
   * @property {Object.<string, number>} pos  The coordinate <ko>좌표</ko>
   * @property {Object.<string, number>} delta  The movement variation of coordinate <ko>좌표의 변화량</ko>
   * @property {Object.<string, number>} bounceRatio If the current coordinates are in the bounce area, the current bounce value divided by the maximum bounce value <ko>현재 좌표가 bounce 영역에 있는 경우 현재 bounce된 값을 최대 bounce 값으로 나눈 수치.</ko>
   * @property {Boolean} holding Indicates whether a user holds an element on the screen of the device.<ko>사용자가 기기의 화면을 누르고 있는지 여부</ko>
   * @property {Object} input The instance of inputType where the event occurred. If the value is changed by animation, it returns 'null'.<ko>이벤트가 발생한 inputType 인스턴스. 애니메이션에 의해 값이 변경될 경우에는 'null'을 반환한다.</ko>
   * @property {Object} inputEvent The event object received from inputType. If the value is changed by animation, it returns 'null'.<ko>inputType으로 부터 받은 이벤트 객체. 애니메이션에 의해 값이 변경될 경우에는 'null'을 반환한다.</ko>
   * @property {set} set Specifies the coordinates to move after the event. It works when the holding value is true <ko>이벤트 이후 이동할 좌표를 지정한다. holding 값이 true일 경우에 동작한다.</ko>
   * @property {Boolean} isTrusted Returns true if an event was generated by the user action, or false if it was caused by a script or API call <ko>사용자의 액션에 의해 이벤트가 발생하였으면 true, 스크립트나 API호출에 의해 발생하였을 경우에는 false를 반환한다.</ko>
   *
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "zoom": {
   *      range: [50, 30]
   *   }
   * }).on("change", function(event) {
   *   // event.pos
   *   // event.delta
   *   // event.input
   *   // event.inputEvent
   *   // event.holding
   *   // event.set
   *   // event.isTrusted
   *
   *   // if you want to change the coordinates to move after the 'change' event.
   *   // it works when the holding value of the change event is true.
   *   event.holding && event.set({x: 10});
   * });
   * ```
   */
  __proto.triggerChange = function (pos, depaPos, option, holding) {
    var _this = this;
    if (holding === void 0) {
      holding = false;
    }
    var animationManager = this.animationManager;
    var axisManager = animationManager.axisManager;
    var eventInfo = animationManager.getEventInfo();
    var _a = this._getRoundPos(pos, depaPos),
      roundPos = _a.roundPos,
      roundDepa = _a.roundDepa;
    var moveTo = axisManager.moveTo(roundPos, roundDepa);
    var inputEvent = (option === null || option === void 0 ? void 0 : option.event) || (eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.event) || null;
    var param = {
      pos: moveTo.pos,
      delta: moveTo.delta,
      bounceRatio: this._getBounceRatio(moveTo.pos),
      holding: holding,
      inputEvent: inputEvent,
      isTrusted: !!inputEvent,
      input: (option === null || option === void 0 ? void 0 : option.input) || (eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.input) || null,
      set: inputEvent ? this._createUserControll(moveTo.pos) : function () {} // eslint-disable-line @typescript-eslint/no-empty-function
    };

    var event = new ComponentEvent$1("change", param);
    this._axes.trigger(event);
    Object.keys(moveTo.pos).forEach(function (axis) {
      var p = moveTo.pos[axis];
      getObserver(_this._axes, axis, p).current = p;
    });
    if (inputEvent) {
      axisManager.set(param.set().destPos);
    }
    return !event.isCanceled();
  };
  /**
   * This event is fired when animation starts.
   * @ko 에니메이션이 시작할 때 발생한다.
   * @event Axes#animationStart
   * @type {object}
   * @property {Object.<string, number>} depaPos The coordinates when animation starts<ko>애니메이션이 시작 되었을 때의 좌표 </ko>
   * @property {Object.<string, number>} destPos The coordinates to move to. If you change this value, you can run the animation<ko>이동할 좌표. 이값을 변경하여 애니메이션을 동작시킬수 있다</ko>
   * @property {Object.<string, number>} delta  The movement variation of coordinate <ko>좌표의 변화량</ko>
   * @property {Number} duration Duration of the animation (unit: ms). If you change this value, you can control the animation duration time.<ko>애니메이션 진행 시간(단위: ms). 이값을 변경하여 애니메이션의 이동시간을 조절할 수 있다.</ko>
   * @property {Object} input The instance of inputType where the event occurred. If the value is changed by animation, it returns 'null'.<ko>이벤트가 발생한 inputType 인스턴스. 애니메이션에 의해 값이 변경될 경우에는 'null'을 반환한다.</ko>
   * @property {Object} inputEvent The event object received from inputType <ko>inputType으로 부터 받은 이벤트 객체</ko>
   * @property {setTo} setTo Specifies the animation coordinates to move after the event <ko>이벤트 이후 이동할 애니메이션 좌표를 지정한다</ko>
   * @property {Boolean} isTrusted Returns true if an event was generated by the user action, or false if it was caused by a script or API call <ko>사용자의 액션에 의해 이벤트가 발생하였으면 true, 스크립트나 API호출에 의해 발생하였을 경우에는 false를 반환한다.</ko>
   *
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "zoom": {
   *      range: [50, 30]
   *   }
   * }).on("release", function(event) {
   *   // event.depaPos
   *   // event.destPos
   *   // event.delta
   *   // event.input
   *   // event.inputEvent
   *   // event.setTo
   *   // event.isTrusted
   *
   *   // if you want to change the animation coordinates to move after the 'animationStart' event.
   *   event.setTo({x: 10}, 2000);
   * });
   * ```
   */
  __proto.triggerAnimationStart = function (param) {
    var _a = this._getRoundPos(param.destPos, param.depaPos),
      roundPos = _a.roundPos,
      roundDepa = _a.roundDepa;
    param.destPos = roundPos;
    param.depaPos = roundDepa;
    param.setTo = this._createUserControll(param.destPos, param.duration);
    var event = new ComponentEvent$1("animationStart", param);
    this._axes.trigger(event);
    return !event.isCanceled();
  };
  /**
   * This event is fired when animation ends.
   * @ko 에니메이션이 끝났을 때 발생한다.
   * @event Axes#animationEnd
   * @type {object}
   * @property {Boolean} isTrusted Returns true if an event was generated by the user action, or false if it was caused by a script or API call <ko>사용자의 액션에 의해 이벤트가 발생하였으면 true, 스크립트나 API호출에 의해 발생하였을 경우에는 false를 반환한다.</ko>
   *
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "zoom": {
   *      range: [50, 30]
   *   }
   * }).on("animationEnd", function(event) {
   *   // event.isTrusted
   * });
   * ```
   */
  __proto.triggerAnimationEnd = function (isTrusted) {
    if (isTrusted === void 0) {
      isTrusted = false;
    }
    this._axes.trigger(new ComponentEvent$1("animationEnd", {
      isTrusted: isTrusted
    }));
  };
  /**
   * This event is fired when all actions have been completed.
   * @ko 에니메이션이 끝났을 때 발생한다.
   * @event Axes#finish
   * @type {object}
   * @property {Boolean} isTrusted Returns true if an event was generated by the user action, or false if it was caused by a script or API call <ko>사용자의 액션에 의해 이벤트가 발생하였으면 true, 스크립트나 API호출에 의해 발생하였을 경우에는 false를 반환한다.</ko>
   *
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "zoom": {
   *      range: [50, 30]
   *   }
   * }).on("finish", function(event) {
   *   // event.isTrusted
   * });
   * ```
   */
  __proto.triggerFinish = function (isTrusted) {
    if (isTrusted === void 0) {
      isTrusted = false;
    }
    this._axes.trigger(new ComponentEvent$1("finish", {
      isTrusted: isTrusted
    }));
  };
  __proto.setAnimationManager = function (animationManager) {
    this.animationManager = animationManager;
  };
  __proto.destroy = function () {
    this._axes.off();
  };
  __proto._createUserControll = function (pos, duration) {
    if (duration === void 0) {
      duration = 0;
    }
    // to controll
    var userControl = {
      destPos: __assign({}, pos),
      duration: duration
    };
    return function (toPos, userDuration) {
      if (toPos) {
        userControl.destPos = __assign({}, toPos);
      }
      if (userDuration !== undefined) {
        userControl.duration = userDuration;
      }
      return userControl;
    };
  };
  __proto._getRoundPos = function (pos, depaPos) {
    // round value if round exist
    var roundUnit = this._axes.options.round;
    // if (round == null) {
    //   return {pos, depaPos}; // undefined, undefined
    // }
    return {
      roundPos: roundNumbers(pos, roundUnit),
      roundDepa: roundNumbers(depaPos, roundUnit)
    };
  };
  __proto._getBounceRatio = function (pos) {
    return this._axes.axisManager.map(pos, function (v, opt) {
      if (v < opt.range[0] && opt.bounce[0] !== 0) {
        return (opt.range[0] - v) / opt.bounce[0];
      } else if (v > opt.range[1] && opt.bounce[1] !== 0) {
        return (v - opt.range[1]) / opt.bounce[1];
      } else {
        return 0;
      }
    });
  };
  __decorate([Observe], EventManager.prototype, "holdingCount", void 0);
  return EventManager;
}();

var InterruptManager = /*#__PURE__*/function () {
  function InterruptManager(_options) {
    this._options = _options;
    this._prevented = false; //  check whether the animation event was prevented
  }
  var __proto = InterruptManager.prototype;
  __proto.isInterrupting = function () {
    // when interruptable is 'true', return value is always 'true'.
    return this._options.interruptable || this._prevented;
  };
  __proto.isInterrupted = function () {
    return !this._options.interruptable && this._prevented;
  };
  __proto.setInterrupt = function (prevented) {
    if (!this._options.interruptable) {
      this._prevented = prevented;
    }
  };
  return InterruptManager;
}();

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
var getInsidePosition = function (destPos, range, circular, bounce) {
  var toDestPos = destPos;
  var targetRange = [circular[0] ? range[0] : bounce ? range[0] - bounce[0] : range[0], circular[1] ? range[1] : bounce ? range[1] + bounce[1] : range[1]];
  toDestPos = Math.max(targetRange[0], toDestPos);
  toDestPos = Math.min(targetRange[1], toDestPos);
  return toDestPos;
};
// determine outside
var isOutside = function (pos, range) {
  return pos < range[0] || pos > range[1];
};
// determine whether position has reached the maximum moveable area
var isEndofBounce = function (pos, range, bounce, circular) {
  return !circular[0] && pos === range[0] - bounce[0] || !circular[1] && pos === range[1] + bounce[1];
};
var getDuration = function (distance, deceleration) {
  var duration = Math.sqrt(distance / deceleration * 2);
  // when duration is under 100, then value is zero
  return duration < 100 ? 0 : duration;
};
var isCircularable = function (destPos, range, circular) {
  return circular[1] && destPos > range[1] || circular[0] && destPos < range[0];
};
var getCirculatedPos = function (pos, range, circular) {
  var toPos = pos;
  var min = range[0];
  var max = range[1];
  var length = max - min;
  if (circular[1] && pos > max) {
    // right
    toPos = (toPos - max) % length + min;
  }
  if (circular[0] && pos < min) {
    // left
    toPos = (toPos - min) % length + max;
  }
  return toPos;
};

var AxisManager = /*#__PURE__*/function () {
  function AxisManager(_axis) {
    var _this = this;
    this._axis = _axis;
    this._complementOptions();
    this._pos = Object.keys(this._axis).reduce(function (pos, v) {
      pos[v] = _this._axis[v].startPos;
      return pos;
    }, {});
  }
  var __proto = AxisManager.prototype;
  __proto.getDelta = function (depaPos, destPos) {
    var fullDepaPos = this.get(depaPos);
    return map(this.get(destPos), function (v, k) {
      return v - fullDepaPos[k];
    });
  };
  __proto.get = function (axes) {
    var _this = this;
    if (axes && Array.isArray(axes)) {
      return axes.reduce(function (acc, v) {
        if (v && v in _this._pos) {
          acc[v] = _this._pos[v];
        }
        return acc;
      }, {});
    } else {
      return __assign(__assign({}, this._pos), axes || {});
    }
  };
  __proto.moveTo = function (pos, depaPos) {
    if (depaPos === void 0) {
      depaPos = this._pos;
    }
    var delta = map(this._pos, function (v, key) {
      return key in pos && key in depaPos ? pos[key] - depaPos[key] : 0;
    });
    this.set(this.map(pos, function (v, opt) {
      return opt ? getCirculatedPos(v, opt.range, opt.circular) : 0;
    }));
    return {
      pos: __assign({}, this._pos),
      delta: delta
    };
  };
  __proto.set = function (pos) {
    for (var k in pos) {
      if (k && k in this._pos) {
        this._pos[k] = pos[k];
      }
    }
  };
  __proto.every = function (pos, callback) {
    var axisOptions = this._axis;
    return every(pos, function (value, key) {
      return callback(value, axisOptions[key], key);
    });
  };
  __proto.filter = function (pos, callback) {
    var axisOptions = this._axis;
    return filter(pos, function (value, key) {
      return callback(value, axisOptions[key], key);
    });
  };
  __proto.map = function (pos, callback) {
    var axisOptions = this._axis;
    return map(pos, function (value, key) {
      return callback(value, axisOptions[key], key);
    });
  };
  __proto.isOutside = function (axes) {
    return !this.every(axes ? this.get(axes) : this._pos, function (v, opt) {
      return !isOutside(v, opt.range);
    });
  };
  __proto.getAxisOptions = function (key) {
    return this._axis[key];
  };
  __proto.setAxis = function (axis) {
    var _this = this;
    Object.keys(axis).forEach(function (key) {
      if (!_this._axis[key]) {
        throw new Error("Axis ".concat(key, " does not exist in Axes instance"));
      }
      _this._axis[key] = __assign(__assign({}, _this._axis[key]), axis[key]);
    });
    this._complementOptions();
  };
  /**
   * set up 'css' expression
   * @private
   */
  __proto._complementOptions = function () {
    var _this = this;
    Object.keys(this._axis).forEach(function (axis) {
      _this._axis[axis] = __assign({
        range: [0, 100],
        startPos: _this._axis[axis].range[0],
        bounce: [0, 0],
        circular: [false, false]
      }, _this._axis[axis]);
      ["bounce", "circular"].forEach(function (v) {
        var axisOption = _this._axis;
        var key = axisOption[axis][v];
        if (/string|number|boolean/.test(typeof key)) {
          axisOption[axis][v] = [key, key];
        }
      });
    });
  };
  return AxisManager;
}();

var SUPPORT_TOUCH = ("ontouchstart" in win);
var SUPPORT_POINTER = ("PointerEvent" in win);
var SUPPORT_MSPOINTER = ("MSPointerEvent" in win);
var SUPPORT_POINTER_EVENTS = SUPPORT_POINTER || SUPPORT_MSPOINTER;
var isValidKey = function (event, inputKey) {
  if (!inputKey || inputKey.indexOf(ANY) > -1 || inputKey.indexOf(NONE) > -1 && !event.shiftKey && !event.ctrlKey && !event.altKey && !event.metaKey || inputKey.indexOf(SHIFT) > -1 && event.shiftKey || inputKey.indexOf(CTRL) > -1 && event.ctrlKey || inputKey.indexOf(ALT) > -1 && event.altKey || inputKey.indexOf(META) > -1 && event.metaKey) {
    return true;
  }
  return false;
};
var EventInput = /*#__PURE__*/function () {
  function EventInput() {
    var _this = this;
    this._stopContextMenu = function (event) {
      event.preventDefault();
      win.removeEventListener("contextmenu", _this._stopContextMenu);
    };
  }
  var __proto = EventInput.prototype;
  __proto.extendEvent = function (event) {
    var _a;
    var prevEvent = this.prevEvent;
    var center = this._getCenter(event);
    var movement = prevEvent ? this._getMovement(event) : {
      x: 0,
      y: 0
    };
    var scale = prevEvent ? this._getScale(event) : 1;
    var angle = prevEvent ? getAngle(center.x - prevEvent.center.x, center.y - prevEvent.center.y) : 0;
    var deltaX = prevEvent ? prevEvent.deltaX + movement.x : movement.x;
    var deltaY = prevEvent ? prevEvent.deltaY + movement.y : movement.y;
    var offsetX = movement.x;
    var offsetY = movement.y;
    var latestInterval = this._latestInterval;
    var timeStamp = Date.now();
    var deltaTime = latestInterval ? timeStamp - latestInterval.timestamp : 0;
    var velocityX = prevEvent ? prevEvent.velocityX : 0;
    var velocityY = prevEvent ? prevEvent.velocityY : 0;
    if (!latestInterval || deltaTime >= VELOCITY_INTERVAL) {
      if (latestInterval) {
        _a = [(deltaX - latestInterval.deltaX) / deltaTime, (deltaY - latestInterval.deltaY) / deltaTime], velocityX = _a[0], velocityY = _a[1];
      }
      this._latestInterval = {
        timestamp: timeStamp,
        deltaX: deltaX,
        deltaY: deltaY
      };
    }
    return {
      srcEvent: event,
      scale: scale,
      angle: angle,
      center: center,
      deltaX: deltaX,
      deltaY: deltaY,
      offsetX: offsetX,
      offsetY: offsetY,
      velocityX: velocityX,
      velocityY: velocityY,
      preventSystemEvent: true
    };
  };
  __proto._getDistance = function (start, end) {
    var x = end.clientX - start.clientX;
    var y = end.clientY - start.clientY;
    return Math.sqrt(x * x + y * y);
  };
  __proto._getButton = function (event) {
    var buttonCodeMap = {
      1: MOUSE_LEFT,
      2: MOUSE_RIGHT,
      4: MOUSE_MIDDLE
    };
    var button = this._isTouchEvent(event) ? MOUSE_LEFT : buttonCodeMap[event.buttons];
    return button ? button : null;
  };
  __proto._isTouchEvent = function (event) {
    return event.type && event.type.indexOf("touch") > -1;
  };
  __proto._isValidButton = function (button, inputButton) {
    return inputButton.indexOf(button) > -1;
  };
  __proto._isValidEvent = function (event, inputKey, inputButton) {
    return (!inputKey || isValidKey(event, inputKey)) && (!inputButton || this._isValidButton(this._getButton(event), inputButton));
  };
  __proto._preventMouseButton = function (event, button) {
    if (button === MOUSE_RIGHT) {
      win.addEventListener("contextmenu", this._stopContextMenu);
    } else if (button === MOUSE_MIDDLE) {
      event.preventDefault();
    }
  };
  return EventInput;
}();

var MouseEventInput = /*#__PURE__*/function (_super) {
  axes_esm_extends(MouseEventInput, _super);
  function MouseEventInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.start = ["mousedown"];
    _this.move = ["mousemove"];
    _this.end = ["mouseup"];
    return _this;
  }
  var __proto = MouseEventInput.prototype;
  __proto.onEventStart = function (event, inputKey, inputButton) {
    var button = this._getButton(event);
    if (!this._isValidEvent(event, inputKey, inputButton)) {
      return null;
    }
    this._preventMouseButton(event, button);
    return this.extendEvent(event);
  };
  __proto.onEventMove = function (event, inputKey, inputButton) {
    if (!this._isValidEvent(event, inputKey, inputButton)) {
      return null;
    }
    return this.extendEvent(event);
  };
  __proto.onEventEnd = function () {
    return;
  };
  __proto.onRelease = function () {
    this.prevEvent = null;
    return;
  };
  __proto.getTouches = function (event, inputButton) {
    if (inputButton) {
      return this._isValidButton(MOUSE_BUTTON_CODE_MAP[event.which], inputButton) && this.end.indexOf(event.type) === -1 ? 1 : 0;
    }
    return 0;
  };
  __proto._getScale = function () {
    return 1;
  };
  __proto._getCenter = function (event) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  };
  __proto._getMovement = function (event) {
    var prev = this.prevEvent.srcEvent;
    return {
      x: event.clientX - prev.clientX,
      y: event.clientY - prev.clientY
    };
  };
  return MouseEventInput;
}(EventInput);

var TouchEventInput = /*#__PURE__*/function (_super) {
  axes_esm_extends(TouchEventInput, _super);
  function TouchEventInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.start = ["touchstart"];
    _this.move = ["touchmove"];
    _this.end = ["touchend", "touchcancel"];
    return _this;
  }
  var __proto = TouchEventInput.prototype;
  __proto.onEventStart = function (event, inputKey) {
    this._baseTouches = event.touches;
    if (!this._isValidEvent(event, inputKey)) {
      return null;
    }
    return this.extendEvent(event);
  };
  __proto.onEventMove = function (event, inputKey) {
    if (!this._isValidEvent(event, inputKey)) {
      return null;
    }
    return this.extendEvent(event);
  };
  __proto.onEventEnd = function (event) {
    this._baseTouches = event.touches;
    return;
  };
  __proto.onRelease = function () {
    this.prevEvent = null;
    this._baseTouches = null;
    return;
  };
  __proto.getTouches = function (event) {
    return event.touches.length;
  };
  __proto._getScale = function (event) {
    if (event.touches.length !== 2 || this._baseTouches.length < 2) {
      return null; // TODO: consider calculating non-pinch gesture scale
    }

    return this._getDistance(event.touches[0], event.touches[1]) / this._getDistance(this._baseTouches[0], this._baseTouches[1]);
  };
  __proto._getCenter = function (event) {
    return {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY
    };
  };
  __proto._getMovement = function (event) {
    var prev = this.prevEvent.srcEvent;
    if (event.touches[0].identifier !== prev.touches[0].identifier) {
      return {
        x: 0,
        y: 0
      };
    }
    return {
      x: event.touches[0].clientX - prev.touches[0].clientX,
      y: event.touches[0].clientY - prev.touches[0].clientY
    };
  };
  return TouchEventInput;
}(EventInput);

var PointerEventInput = /*#__PURE__*/function (_super) {
  axes_esm_extends(PointerEventInput, _super);
  function PointerEventInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.start = SUPPORT_POINTER ? ["pointerdown"] : ["MSPointerDown"];
    _this.move = SUPPORT_POINTER ? ["pointermove"] : ["MSPointerMove"];
    _this.end = SUPPORT_POINTER ? ["pointerup", "pointercancel"] : ["MSPointerUp", "MSPointerCancel"];
    // store first, recent inputs for each event id
    _this._firstInputs = [];
    _this._recentInputs = [];
    return _this;
  }
  var __proto = PointerEventInput.prototype;
  __proto.onEventStart = function (event, inputKey, inputButton) {
    var button = this._getButton(event);
    if (!this._isValidEvent(event, inputKey, inputButton)) {
      return null;
    }
    this._preventMouseButton(event, button);
    this._updatePointerEvent(event);
    return this.extendEvent(event);
  };
  __proto.onEventMove = function (event, inputKey, inputButton) {
    if (!this._isValidEvent(event, inputKey, inputButton)) {
      return null;
    }
    this._updatePointerEvent(event);
    return this.extendEvent(event);
  };
  __proto.onEventEnd = function (event) {
    this._removePointerEvent(event);
  };
  __proto.onRelease = function () {
    this.prevEvent = null;
    this._firstInputs = [];
    this._recentInputs = [];
    return;
  };
  __proto.getTouches = function () {
    return this._recentInputs.length;
  };
  __proto._getScale = function () {
    if (this._recentInputs.length !== 2) {
      return null; // TODO: consider calculating non-pinch gesture scale
    }

    return this._getDistance(this._recentInputs[0], this._recentInputs[1]) / this._getDistance(this._firstInputs[0], this._firstInputs[1]);
  };
  __proto._getCenter = function (event) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  };
  __proto._getMovement = function (event) {
    var prev = this.prevEvent.srcEvent;
    if (event.pointerId !== prev.pointerId) {
      return {
        x: 0,
        y: 0
      };
    }
    return {
      x: event.clientX - prev.clientX,
      y: event.clientY - prev.clientY
    };
  };
  __proto._updatePointerEvent = function (event) {
    var _this = this;
    var addFlag = false;
    this._recentInputs.forEach(function (e, i) {
      if (e.pointerId === event.pointerId) {
        addFlag = true;
        _this._recentInputs[i] = event;
      }
    });
    if (!addFlag) {
      this._firstInputs.push(event);
      this._recentInputs.push(event);
    }
  };
  __proto._removePointerEvent = function (event) {
    this._firstInputs = this._firstInputs.filter(function (x) {
      return x.pointerId !== event.pointerId;
    });
    this._recentInputs = this._recentInputs.filter(function (x) {
      return x.pointerId !== event.pointerId;
    });
  };
  return PointerEventInput;
}(EventInput);

var TouchMouseEventInput = /*#__PURE__*/function (_super) {
  axes_esm_extends(TouchMouseEventInput, _super);
  function TouchMouseEventInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.start = ["mousedown", "touchstart"];
    _this.move = ["mousemove", "touchmove"];
    _this.end = ["mouseup", "touchend", "touchcancel"];
    return _this;
  }
  var __proto = TouchMouseEventInput.prototype;
  __proto.onEventStart = function (event, inputKey, inputButton) {
    var button = this._getButton(event);
    if (this._isTouchEvent(event)) {
      this._baseTouches = event.touches;
    }
    if (!this._isValidEvent(event, inputKey, inputButton)) {
      return null;
    }
    this._preventMouseButton(event, button);
    return this.extendEvent(event);
  };
  __proto.onEventMove = function (event, inputKey, inputButton) {
    if (!this._isValidEvent(event, inputKey, inputButton)) {
      return null;
    }
    return this.extendEvent(event);
  };
  __proto.onEventEnd = function (event) {
    if (this._isTouchEvent(event)) {
      this._baseTouches = event.touches;
    }
    return;
  };
  __proto.onRelease = function () {
    this.prevEvent = null;
    this._baseTouches = null;
    return;
  };
  __proto.getTouches = function (event, inputButton) {
    if (this._isTouchEvent(event)) {
      return event.touches.length;
    } else {
      return this._isValidButton(MOUSE_BUTTON_CODE_MAP[event.which], inputButton) && this.end.indexOf(event.type) === -1 ? 1 : 0;
    }
  };
  __proto._getScale = function (event) {
    if (this._isTouchEvent(event)) {
      if (event.touches.length !== 2 || this._baseTouches.length < 2) {
        return 1; // TODO: consider calculating non-pinch gesture scale
      }

      return this._getDistance(event.touches[0], event.touches[1]) / this._getDistance(this._baseTouches[0], this._baseTouches[1]);
    }
    return this.prevEvent.scale;
  };
  __proto._getCenter = function (event) {
    if (this._isTouchEvent(event)) {
      return {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
    }
    return {
      x: event.clientX,
      y: event.clientY
    };
  };
  __proto._getMovement = function (event) {
    var _this = this;
    var prev = this.prevEvent.srcEvent;
    var _a = [event, prev].map(function (e) {
        if (_this._isTouchEvent(e)) {
          return {
            id: e.touches[0].identifier,
            x: e.touches[0].clientX,
            y: e.touches[0].clientY
          };
        }
        return {
          id: null,
          x: e.clientX,
          y: e.clientY
        };
      }),
      nextSpot = _a[0],
      prevSpot = _a[1];
    return nextSpot.id === prevSpot.id ? {
      x: nextSpot.x - prevSpot.x,
      y: nextSpot.y - prevSpot.y
    } : {
      x: 0,
      y: 0
    };
  };
  return TouchMouseEventInput;
}(EventInput);

var toAxis = function (source, offset) {
  return offset.reduce(function (acc, v, i) {
    if (source[i]) {
      acc[source[i]] = v;
    }
    return acc;
  }, {});
};
var convertInputType = function (inputType) {
  if (inputType === void 0) {
    inputType = [];
  }
  var hasTouch = false;
  var hasMouse = false;
  var hasPointer = false;
  inputType.forEach(function (v) {
    switch (v) {
      case "mouse":
        hasMouse = true;
        break;
      case "touch":
        hasTouch = SUPPORT_TOUCH;
        break;
      case "pointer":
        hasPointer = SUPPORT_POINTER_EVENTS;
      // no default
    }
  });

  if (hasPointer) {
    return new PointerEventInput();
  } else if (hasTouch && hasMouse) {
    return new TouchMouseEventInput();
  } else if (hasTouch) {
    return new TouchEventInput();
  } else if (hasMouse) {
    return new MouseEventInput();
  }
  return null;
};
function getAddEventOptions(eventName) {
  // The passive default value of the touch event is true.
  // If not a touch event, return false to support ie11
  return eventName.indexOf("touch") > -1 ? {
    passive: false
  } : false;
}

var InputObserver = /*#__PURE__*/function () {
  function InputObserver(_a) {
    var options = _a.options,
      interruptManager = _a.interruptManager,
      eventManager = _a.eventManager,
      axisManager = _a.axisManager,
      animationManager = _a.animationManager;
    this._isOutside = false;
    this._moveDistance = null;
    this._isStopped = false;
    this.options = options;
    this._interruptManager = interruptManager;
    this._eventManager = eventManager;
    this._axisManager = axisManager;
    this._animationManager = animationManager;
  }
  var __proto = InputObserver.prototype;
  __proto.get = function (input) {
    return this._axisManager.get(input.axes);
  };
  __proto.hold = function (input, event) {
    if (this._interruptManager.isInterrupted() || !input.axes.length) {
      return;
    }
    var changeOption = {
      input: input,
      event: event
    };
    this._isStopped = false;
    this._interruptManager.setInterrupt(true);
    this._animationManager.stopAnimation(changeOption);
    ++this._eventManager.holdingCount;
    if (!this._moveDistance) {
      this._eventManager.hold(this._axisManager.get(), changeOption);
    }
    this._isOutside = this._axisManager.isOutside(input.axes);
    this._moveDistance = this._axisManager.get(input.axes);
  };
  __proto.change = function (input, event, offset, useAnimation) {
    if (this._isStopped || !this._interruptManager.isInterrupting() || this._axisManager.every(offset, function (v) {
      return v === 0;
    })) {
      return;
    }
    var nativeEvent = event.srcEvent ? event.srcEvent : event;
    if (nativeEvent.__childrenAxesAlreadyChanged) {
      return;
    }
    var depaPos = this._moveDistance || this._axisManager.get(input.axes);
    var destPos;
    // for outside logic
    destPos = map(depaPos, function (v, k) {
      return v + (offset[k] || 0);
    });
    if (this._moveDistance) {
      this._moveDistance = this._axisManager.map(destPos, function (v, _a) {
        var circular = _a.circular,
          range = _a.range;
        return circular && (circular[0] || circular[1]) ? getCirculatedPos(v, range, circular) : v;
      });
    }
    // from outside to inside
    if (this._isOutside && this._axisManager.every(depaPos, function (v, opt) {
      return !isOutside(v, opt.range);
    })) {
      this._isOutside = false;
    }
    depaPos = this._atOutside(depaPos);
    destPos = this._atOutside(destPos);
    if (!this.options.nested || !this._isEndofAxis(offset, depaPos, destPos)) {
      nativeEvent.__childrenAxesAlreadyChanged = true;
    }
    var changeOption = {
      input: input,
      event: event
    };
    if (useAnimation) {
      var duration = this._animationManager.getDuration(destPos, depaPos);
      this._animationManager.animateTo(destPos, duration, changeOption);
    } else {
      var isCanceled = !this._eventManager.triggerChange(destPos, depaPos, changeOption, true);
      if (isCanceled) {
        this._isStopped = true;
        this._moveDistance = null;
        this._animationManager.finish(false);
      }
    }
  };
  __proto.release = function (input, event, velocity, inputDuration) {
    if (this._isStopped || !this._interruptManager.isInterrupting() || !this._moveDistance) {
      return;
    }
    var nativeEvent = event.srcEvent ? event.srcEvent : event;
    if (nativeEvent.__childrenAxesAlreadyReleased) {
      velocity = velocity.map(function () {
        return 0;
      });
    }
    var pos = this._axisManager.get(input.axes);
    var depaPos = this._axisManager.get();
    var displacement = this._animationManager.getDisplacement(velocity);
    var offset = toAxis(input.axes, displacement);
    var destPos = this._axisManager.get(this._axisManager.map(offset, function (v, opt, k) {
      if (opt.circular && (opt.circular[0] || opt.circular[1])) {
        return pos[k] + v;
      } else {
        return getInsidePosition(pos[k] + v, opt.range, opt.circular, opt.bounce);
      }
    }));
    nativeEvent.__childrenAxesAlreadyReleased = true;
    var duration = this._animationManager.getDuration(destPos, pos, inputDuration);
    if (duration === 0) {
      destPos = __assign({}, depaPos);
    }
    // prepare params
    var param = {
      depaPos: depaPos,
      destPos: destPos,
      duration: duration,
      delta: this._axisManager.getDelta(depaPos, destPos),
      inputEvent: event,
      input: input,
      isTrusted: true
    };
    --this._eventManager.holdingCount;
    this._eventManager.triggerRelease(param);
    if (this._eventManager.holdingCount === 0) {
      this._moveDistance = null;
    }
    // to contol
    var userWish = this._animationManager.getUserControl(param);
    var isEqual = equal(userWish.destPos, depaPos);
    var changeOption = {
      input: input,
      event: event
    };
    if (isEqual || userWish.duration === 0) {
      if (!isEqual) {
        this._eventManager.triggerChange(userWish.destPos, depaPos, changeOption, true);
      }
      this._interruptManager.setInterrupt(false);
      if (this._axisManager.isOutside()) {
        this._animationManager.restore(changeOption);
      } else {
        this._eventManager.triggerFinish(true);
      }
    } else {
      this._animationManager.animateTo(userWish.destPos, userWish.duration, changeOption);
    }
  };
  // when move pointer is held in outside
  __proto._atOutside = function (pos) {
    var _this = this;
    if (this._isOutside) {
      return this._axisManager.map(pos, function (v, opt) {
        var tn = opt.range[0] - opt.bounce[0];
        var tx = opt.range[1] + opt.bounce[1];
        return v > tx ? tx : v < tn ? tn : v;
      });
    } else {
      return this._axisManager.map(pos, function (v, opt) {
        var min = opt.range[0];
        var max = opt.range[1];
        var out = opt.bounce;
        var circular = opt.circular;
        if (circular[0] && v < min || circular[1] && v > max) {
          return v;
        } else if (v < min) {
          // left
          return min - _this._animationManager.interpolate(min - v, out[0]);
        } else if (v > max) {
          // right
          return max + _this._animationManager.interpolate(v - max, out[1]);
        }
        return v;
      });
    }
  };
  __proto._isEndofAxis = function (offset, depaPos, destPos) {
    return this._axisManager.every(depaPos, function (value, option, key) {
      return offset[key] === 0 || depaPos[key] === destPos[key] && isEndofBounce(value, option.range, option.bounce, option.circular);
    });
  };
  return InputObserver;
}();

var clamp = function (value, min, max) {
  return Math.max(Math.min(value, max), min);
};
var AnimationManager = /*#__PURE__*/function () {
  function AnimationManager(_a) {
    var options = _a.options,
      interruptManager = _a.interruptManager,
      eventManager = _a.eventManager,
      axisManager = _a.axisManager;
    this._options = options;
    this.interruptManager = interruptManager;
    this.eventManager = eventManager;
    this.axisManager = axisManager;
    this.animationEnd = this.animationEnd.bind(this);
  }
  var __proto = AnimationManager.prototype;
  __proto.getDuration = function (depaPos, destPos, wishDuration) {
    var _this = this;
    var duration;
    if (typeof wishDuration !== "undefined") {
      duration = wishDuration;
    } else {
      var durations_1 = map(destPos, function (v, k) {
        return getDuration(Math.abs(v - depaPos[k]), _this._options.deceleration);
      });
      duration = Object.keys(durations_1).reduce(function (max, v) {
        return Math.max(max, durations_1[v]);
      }, -Infinity);
    }
    return clamp(duration, this._options.minimumDuration, this._options.maximumDuration);
  };
  __proto.getDisplacement = function (velocity) {
    var totalVelocity = Math.pow(velocity.reduce(function (total, v) {
      return total + v * v;
    }, 0), 1 / velocity.length);
    var duration = Math.abs(totalVelocity / -this._options.deceleration);
    return velocity.map(function (v) {
      return v / 2 * duration;
    });
  };
  __proto.stopAnimation = function (option) {
    if (this._animateParam) {
      var orgPos_1 = this.axisManager.get();
      var pos = this.axisManager.map(orgPos_1, function (v, opt) {
        return getCirculatedPos(v, opt.range, opt.circular);
      });
      if (!every(pos, function (v, k) {
        return orgPos_1[k] === v;
      })) {
        this.eventManager.triggerChange(pos, orgPos_1, option, !!option);
      }
      this._animateParam = null;
      if (this._raf) {
        cancelAnimationFrame(this._raf);
      }
      this._raf = null;
      this.eventManager.triggerAnimationEnd(!!(option === null || option === void 0 ? void 0 : option.event));
    }
  };
  __proto.getEventInfo = function () {
    if (this._animateParam && this._animateParam.input && this._animateParam.inputEvent) {
      return {
        input: this._animateParam.input,
        event: this._animateParam.inputEvent
      };
    } else {
      return null;
    }
  };
  __proto.restore = function (option) {
    var pos = this.axisManager.get();
    var destPos = this.axisManager.map(pos, function (v, opt) {
      return Math.min(opt.range[1], Math.max(opt.range[0], v));
    });
    this.stopAnimation();
    this.animateTo(destPos, this.getDuration(pos, destPos), option);
  };
  __proto.animationEnd = function () {
    var beforeParam = this.getEventInfo();
    this._animateParam = null;
    // for Circular
    var circularTargets = this.axisManager.filter(this.axisManager.get(), function (v, opt) {
      return isCircularable(v, opt.range, opt.circular);
    });
    if (Object.keys(circularTargets).length > 0) {
      this.setTo(this.axisManager.map(circularTargets, function (v, opt) {
        return getCirculatedPos(v, opt.range, opt.circular);
      }));
    }
    this.interruptManager.setInterrupt(false);
    this.eventManager.triggerAnimationEnd(!!beforeParam);
    if (this.axisManager.isOutside()) {
      this.restore(beforeParam);
    } else {
      this.finish(!!beforeParam);
    }
  };
  __proto.finish = function (isTrusted) {
    this._animateParam = null;
    this.interruptManager.setInterrupt(false);
    this.eventManager.triggerFinish(isTrusted);
  };
  __proto.getUserControl = function (param) {
    var userWish = param.setTo();
    userWish.destPos = this.axisManager.get(userWish.destPos);
    userWish.duration = clamp(userWish.duration, this._options.minimumDuration, this._options.maximumDuration);
    return userWish;
  };
  __proto.animateTo = function (destPos, duration, option) {
    var _this = this;
    this.stopAnimation();
    var param = this._createAnimationParam(destPos, duration, option);
    var depaPos = __assign({}, param.depaPos);
    var retTrigger = this.eventManager.triggerAnimationStart(param);
    // to control
    var userWish = this.getUserControl(param);
    // You can't stop the 'animationStart' event when 'circular' is true.
    if (!retTrigger && this.axisManager.every(userWish.destPos, function (v, opt) {
      return isCircularable(v, opt.range, opt.circular);
    })) {
      console.warn("You can't stop the 'animation' event when 'circular' is true.");
    }
    if (retTrigger && !equal(userWish.destPos, depaPos)) {
      var inputEvent = (option === null || option === void 0 ? void 0 : option.event) || null;
      this._animateLoop({
        depaPos: depaPos,
        destPos: userWish.destPos,
        duration: userWish.duration,
        delta: this.axisManager.getDelta(depaPos, userWish.destPos),
        isTrusted: !!inputEvent,
        inputEvent: inputEvent,
        input: (option === null || option === void 0 ? void 0 : option.input) || null
      }, function () {
        return _this.animationEnd();
      });
    }
  };
  __proto.setTo = function (pos, duration) {
    if (duration === void 0) {
      duration = 0;
    }
    var axes = Object.keys(pos);
    var orgPos = this.axisManager.get(axes);
    if (equal(pos, orgPos)) {
      return this;
    }
    this.interruptManager.setInterrupt(true);
    var movedPos = filter(pos, function (v, k) {
      return orgPos[k] !== v;
    });
    if (!Object.keys(movedPos).length) {
      return this;
    }
    movedPos = this.axisManager.map(movedPos, function (v, opt) {
      var range = opt.range,
        circular = opt.circular;
      if (circular && (circular[0] || circular[1])) {
        return v;
      } else {
        return getInsidePosition(v, range, circular);
      }
    });
    if (equal(movedPos, orgPos)) {
      return this;
    }
    if (duration > 0) {
      this.animateTo(movedPos, duration);
    } else {
      this.stopAnimation();
      this.eventManager.triggerChange(movedPos);
      this.finish(false);
    }
    return this;
  };
  __proto.setBy = function (pos, duration) {
    if (duration === void 0) {
      duration = 0;
    }
    return this.setTo(map(this.axisManager.get(Object.keys(pos)), function (v, k) {
      return v + pos[k];
    }), duration);
  };
  __proto.setOptions = function (options) {
    this._options = __assign(__assign({}, this._options), options);
  };
  __proto._createAnimationParam = function (pos, duration, option) {
    var depaPos = this.axisManager.get();
    var destPos = pos;
    var inputEvent = (option === null || option === void 0 ? void 0 : option.event) || null;
    return {
      depaPos: depaPos,
      destPos: destPos,
      duration: clamp(duration, this._options.minimumDuration, this._options.maximumDuration),
      delta: this.axisManager.getDelta(depaPos, destPos),
      inputEvent: inputEvent,
      input: (option === null || option === void 0 ? void 0 : option.input) || null,
      isTrusted: !!inputEvent,
      done: this.animationEnd
    };
  };
  __proto._animateLoop = function (param, complete) {
    var _this = this;
    if (param.duration) {
      this._animateParam = __assign(__assign({}, param), {
        startTime: new Date().getTime()
      });
      var originalIntendedPos_1 = map(param.destPos, function (v) {
        return v;
      });
      var state_1 = this._initState(this._animateParam);
      var loop_1 = function () {
        _this._raf = null;
        var animateParam = _this._animateParam;
        var nextState = _this._getNextState(state_1);
        var isCanceled = !_this.eventManager.triggerChange(nextState.pos, state_1.pos);
        state_1 = nextState;
        if (nextState.finished) {
          animateParam.destPos = _this._getFinalPos(animateParam.destPos, originalIntendedPos_1);
          if (!equal(animateParam.destPos, _this.axisManager.get(Object.keys(animateParam.destPos)))) {
            _this.eventManager.triggerChange(animateParam.destPos, nextState.pos);
          }
          complete();
          return;
        } else if (isCanceled) {
          _this.finish(false);
        } else {
          _this._raf = requestAnimationFrame(loop_1);
        }
      };
      loop_1();
    } else {
      this.eventManager.triggerChange(param.destPos);
      complete();
    }
  };
  /**
   * Get estimated final value.
   *
   * If destPos is within the 'error range' of the original intended position, the initial intended position is returned.
   *   - eg. original intended pos: 100, destPos: 100.0000000004 ==> return 100;
   * If dest Pos is outside the 'range of error' compared to the originally intended pos, it is returned rounded based on the originally intended pos.
   *   - eg. original intended pos: 100.123 destPos: 50.12345 => return 50.123
   * @param originalIntendedPos
   * @param destPos
   */
  __proto._getFinalPos = function (destPos, originalIntendedPos) {
    var _this = this;
    // compare destPos and originalIntendedPos
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var ERROR_LIMIT = 0.000001;
    var finalPos = map(destPos, function (value, key) {
      if (value >= originalIntendedPos[key] - ERROR_LIMIT && value <= originalIntendedPos[key] + ERROR_LIMIT) {
        // In error range, return original intended
        return originalIntendedPos[key];
      } else {
        // Out of error range, return rounded pos.
        var roundUnit = _this._getRoundUnit(value, key);
        var result = roundNumber(value, roundUnit);
        return result;
      }
    });
    return finalPos;
  };
  __proto._getRoundUnit = function (val, key) {
    var roundUnit = this._options.round; // manual mode
    var minRoundUnit = null; // auto mode
    // auto mode
    if (!roundUnit) {
      // Get minimum round unit
      var options = this.axisManager.getAxisOptions(key);
      minRoundUnit = inversePow(Math.max(getDecimalPlace(options.range[0]), getDecimalPlace(options.range[1]), getDecimalPlace(val)));
    }
    return minRoundUnit || roundUnit;
  };
  return AnimationManager;
}();

var EasingManager = /*#__PURE__*/function (_super) {
  axes_esm_extends(EasingManager, _super);
  function EasingManager() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._useDuration = true;
    return _this;
  }
  var __proto = EasingManager.prototype;
  __proto.interpolate = function (displacement, threshold) {
    var initSlope = this._easing(0.00001) / 0.00001;
    return this._easing(displacement / (threshold * initSlope)) * threshold;
  };
  __proto.updateAnimation = function (options) {
    var _a;
    var animateParam = this._animateParam;
    if (!animateParam) {
      return;
    }
    var diffTime = new Date().getTime() - animateParam.startTime;
    var pos = (options === null || options === void 0 ? void 0 : options.destPos) || animateParam.destPos;
    var duration = (_a = options === null || options === void 0 ? void 0 : options.duration) !== null && _a !== void 0 ? _a : animateParam.duration;
    if ((options === null || options === void 0 ? void 0 : options.restart) || duration <= diffTime) {
      this.setTo(pos, duration - diffTime);
      return;
    }
    if (options === null || options === void 0 ? void 0 : options.destPos) {
      var currentPos = this.axisManager.get();
      // When destination is changed, new delta should be calculated as remaining percent.
      // For example, moving x:0, y:0 to x:200, y:200 and it has current easing percent of 92%. coordinate is x:184 and y:184
      // If destination changes to x:300, y:300. xdelta:200, ydelta:200 changes to xdelta:116, ydelta:116 and use remaining easingPer as 100%, not 8% as previous.
      // Therefore, original easingPer by time is kept. And divided by (1 - self._initialEasingPer) which means new total easing percent. Like calculating 8% as 100%.
      this._initialEasingPer = this._prevEasingPer;
      animateParam.delta = this.axisManager.getDelta(currentPos, pos);
      animateParam.destPos = pos;
    }
    if (options === null || options === void 0 ? void 0 : options.duration) {
      var ratio = (diffTime + this._durationOffset) / animateParam.duration;
      // Use durationOffset for keeping animation ratio after duration is changed.
      // newRatio = (diffTime + newDurationOffset) / newDuration = oldRatio
      // newDurationOffset = oldRatio * newDuration - diffTime
      this._durationOffset = ratio * duration - diffTime;
      animateParam.duration = duration;
    }
  };
  __proto._initState = function (info) {
    this._initialEasingPer = 0;
    this._prevEasingPer = 0;
    this._durationOffset = 0;
    return {
      pos: info.depaPos,
      easingPer: 0,
      finished: false
    };
  };
  __proto._getNextState = function (prevState) {
    var _this = this;
    var animateParam = this._animateParam;
    var prevPos = prevState.pos;
    var destPos = animateParam.destPos;
    var directions = map(prevPos, function (value, key) {
      return value <= destPos[key] ? 1 : -1;
    });
    var diffTime = new Date().getTime() - animateParam.startTime;
    var ratio = (diffTime + this._durationOffset) / animateParam.duration;
    var easingPer = this._easing(ratio);
    var toPos = this.axisManager.map(prevPos, function (pos, options, key) {
      var nextPos = ratio >= 1 ? destPos[key] : pos + animateParam.delta[key] * (easingPer - _this._prevEasingPer) / (1 - _this._initialEasingPer);
      // Subtract distance from distance already moved.
      // Recalculate the remaining distance.
      // Fix the bouncing phenomenon by changing the range.
      var circulatedPos = getCirculatedPos(nextPos, options.range, options.circular);
      if (nextPos !== circulatedPos) {
        // circular
        var rangeOffset = directions[key] * (options.range[1] - options.range[0]);
        destPos[key] -= rangeOffset;
        prevPos[key] -= rangeOffset;
      }
      return circulatedPos;
    });
    this._prevEasingPer = easingPer;
    return {
      pos: toPos,
      easingPer: easingPer,
      finished: easingPer >= 1
    };
  };
  __proto._easing = function (p) {
    return p > 1 ? 1 : this._options.easing(p);
  };
  return EasingManager;
}(AnimationManager);

/**
 * @typedef {Object} AxisOption The Axis information. The key of the axis specifies the name to use as the logical virtual coordinate system.
 * @ko 축 정보. 축의 키는 논리적인 가상 좌표계로 사용할 이름을 지정한다.
 * @param {Number[]} [range] The range of coordinate <ko>좌표 범위</ko>
 * @param {Number} [range[0]=0] The coordinate of the minimum <ko>최소 좌표</ko>
 * @param {Number} [range[1]=0] The coordinate of the maximum <ko>최대 좌표</ko>
 * @param {Number} [startPos=range[0]] The coordinates to be moved when creating an instance <ko>인스턴스 생성시 이동할 좌표</ko>
 * @param {Number[]} [bounce] The size of bouncing area. The coordinates can exceed the coordinate area as much as the bouncing area based on user action. If the coordinates does not exceed the bouncing area when an element is dragged, the coordinates where bouncing effects are applied are retuned back into the coordinate area<ko>바운스 영역의 크기. 사용자의 동작에 따라 좌표가 좌표 영역을 넘어 바운스 영역의 크기만큼 더 이동할 수 있다. 사용자가 끌어다 놓는 동작을 했을 때 좌표가 바운스 영역에 있으면, 바운스 효과가 적용된 좌표가 다시 좌표 영역 안으로 들어온다</ko>
 * @param {Number} [bounce[0]=0] The size of coordinate of the minimum area <ko>최소 좌표 바운스 영역의 크기</ko>
 * @param {Number} [bounce[1]=0] The size of coordinate of the maximum area <ko>최대 좌표 바운스 영역의 크기</ko>
 * @param {Boolean[]} [circular] Indicates whether a circular element is available. If it is set to "true" and an element is dragged outside the coordinate area, the element will appear on the other side.<ko>순환 여부. 'true'로 설정한 방향의 좌표 영역 밖으로 엘리먼트가 이동하면 반대 방향에서 엘리먼트가 나타난다</ko>
 * @param {Boolean} [circular[0]=false] Indicates whether to circulate to the coordinate of the minimum <ko>최소 좌표 방향의 순환 여부</ko>
 * @param {Boolean} [circular[1]=false] Indicates whether to circulate to the coordinate of the maximum <ko>최대 좌표 방향의 순환 여부</ko>
 **/
/**
 * @typedef {Object} AxesOption The option object of the eg.Axes module
 * @ko eg.Axes 모듈의 옵션 객체
 * @param {Function} [easing=easing.easeOutCubic] The easing function to apply to an animation <ko>애니메이션에 적용할 easing 함수</ko>
 * @param {Number} [maximumDuration=Infinity] Maximum duration of the animation <ko>가속도에 의해 애니메이션이 동작할 때의 최대 좌표 이동 시간</ko>
 * @param {Number} [minimumDuration=0] Minimum duration of the animation <ko>가속도에 의해 애니메이션이 동작할 때의 최소 좌표 이동 시간</ko>
 * @param {Number} [deceleration=0.0006] Deceleration of the animation where acceleration is manually enabled by user. A higher value indicates shorter running time. <ko>사용자의 동작으로 가속도가 적용된 애니메이션의 감속도. 값이 높을수록 애니메이션 실행 시간이 짧아진다</ko>
 * @param {Boolean} [interruptable=true] Indicates whether an animation is interruptible.
 * - true: It can be paused or stopped by user action or the API.
 * - false: It cannot be paused or stopped by user action or the API while it is running.
 * <ko>진행 중인 애니메이션 중지 가능 여부.
 * - true: 사용자의 동작이나 API로 애니메이션을 중지할 수 있다.
 * - false: 애니메이션이 진행 중일 때는 사용자의 동작이나 API가 적용되지 않는다</ko>
 * @param {Number} [round=null] Rounding unit. For example, 0.1 rounds to 0.1 decimal point(6.1234 => 6.1), 5 rounds to 5 (93 => 95)
 * [Details](https://github.com/naver/egjs-axes/wiki/round-option)<ko>반올림 단위. 예를 들어 0.1 은 소숫점 0.1 까지 반올림(6.1234 => 6.1), 5 는 5 단위로 반올림(93 => 95).
 * [상세내용](https://github.com/naver/egjs-axes/wiki/round-option)</ko>
 * @param {Boolean} [nested=false] Whether the event propagates to other instances when the coordinates reach the end of the movable area <ko>좌표가 이동 가능한 영역의 끝까지 도달했을 때 다른 인스턴스들로의 이벤트 전파 여부</ko>
 **/
/**
 * A module used to change the information of user action entered by various input devices such as touch screen or mouse into the logical virtual coordinates. You can easily create a UI that responds to user actions.
 * @ko 터치 입력 장치나 마우스와 같은 다양한 입력 장치를 통해 전달 받은 사용자의 동작을 논리적인 가상 좌표로 변경하는 모듈이다. 사용자 동작에 반응하는 UI를 손쉽게 만들수 있다.
 * @extends eg.Component
 *
 * @param {Object.<string, AxisOption>} axis Axis information managed by eg.Axes. The key of the axis specifies the name to use as the logical virtual coordinate system.  <ko>eg.Axes가 관리하는 축 정보. 축의 키는 논리적인 가상 좌표계로 사용할 이름을 지정한다.</ko>
 * @param {AxesOption} [options={}] The option object of the eg.Axes module<ko>eg.Axes 모듈의 옵션 객체</ko>
 * @param {Object.<string, number>} [startPos={}] The coordinates to be moved when creating an instance. It is applied with higher priority than startPos of axisOption.<ko>인스턴스 생성시 이동할 좌표, axisOption의 startPos보다 높은 우선순위로 적용된다.</ko>
 *
 * @support {"ie": "10+", "ch" : "latest", "ff" : "latest",  "sf" : "latest", "edge" : "latest", "ios" : "7+", "an" : "2.3+ (except 3.x)"}
 * @example
 * ```js
 * // 1. Initialize eg.Axes
 * const axes = new eg.Axes({
 *  something1: {
 *    range: [0, 150],
 *    bounce: 50
 *  },
 *  something2: {
 *    range: [0, 200],
 *    bounce: 100
 *  },
 *  somethingN: {
 *    range: [1, 10],
 *  }
 * }, {
 *  deceleration : 0.0024
 * });
 *
 * // 2. attach event handler
 * axes.on({
 *  "hold" : function(evt) {
 *  },
 *  "release" : function(evt) {
 *  },
 *  "animationStart" : function(evt) {
 *  },
 *  "animationEnd" : function(evt) {
 *  },
 *  "change" : function(evt) {
 *  }
 * });
 *
 * // 3. Initialize inputTypes
 * const panInputArea = new eg.Axes.PanInput("#area", {
 *  scale: [0.5, 1]
 * });
 * const panInputHmove = new eg.Axes.PanInput("#hmove");
 * const panInputVmove = new eg.Axes.PanInput("#vmove");
 * const pinchInputArea = new eg.Axes.PinchInput("#area", {
 *  scale: 1.5
 * });
 *
 * // 4. Connect eg.Axes and InputTypes
 * // [PanInput] When the mouse or touchscreen is down and moved.
 * // Connect the 'something2' axis to the mouse or touchscreen x position and
 * // connect the 'somethingN' axis to the mouse or touchscreen y position.
 * axes.connect(["something2", "somethingN"], panInputArea); // or axes.connect("something2 somethingN", panInputArea);
 *
 * // Connect only one 'something1' axis to the mouse or touchscreen x position.
 * axes.connect(["something1"], panInputHmove); // or axes.connect("something1", panInputHmove);
 *
 * // Connect only one 'something2' axis to the mouse or touchscreen y position.
 * axes.connect(["", "something2"], panInputVmove); // or axes.connect(" something2", panInputVmove);
 *
 * // [PinchInput] Connect 'something2' axis when two pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * axes.connect("something2", pinchInputArea);
 * ```
 */
var axes_esm_Axes = /*#__PURE__*/function (_super) {
  axes_esm_extends(Axes, _super);
  /**
   *
   */
  function Axes(axis, options, startPos) {
    if (axis === void 0) {
      axis = {};
    }
    if (options === void 0) {
      options = {};
    }
    if (startPos === void 0) {
      startPos = {};
    }
    var _this = _super.call(this) || this;
    _this.axis = axis;
    _this._inputs = [];
    _this.options = __assign({
      easing: function (x) {
        return 1 - Math.pow(1 - x, 3);
      },
      interruptable: true,
      maximumDuration: Infinity,
      minimumDuration: 0,
      deceleration: 0.0006,
      round: null,
      nested: false
    }, options);
    Object.keys(startPos).forEach(function (key) {
      _this.axis[key].startPos = startPos[key];
    });
    _this.interruptManager = new InterruptManager(_this.options);
    _this.axisManager = new AxisManager(_this.axis);
    _this.eventManager = new axes_esm_EventManager(_this);
    _this.animationManager = new EasingManager(_this);
    _this.inputObserver = new InputObserver(_this);
    _this.eventManager.setAnimationManager(_this.animationManager);
    _this.eventManager.triggerChange(_this.axisManager.get());
    return _this;
  }
  var __proto = Axes.prototype;
  Object.defineProperty(__proto, "holding", {
    /**
     * @name Axes#holding
     * @desc Returns true if at least one input is in progress.
     * @ko 입력이 하나 이상 진행 중인지 여부를 반환한다.
     *
     * @readonly
     * @type {boolean}
     * @example
     * ```js
     * const axes = new eg.Axes({
     *  x: {
     *    range: [0, 100],
     *  },
     * });
     *
     * axes.holding
     * ```
     */
    get: function () {
      return this.eventManager.holdingCount > 0;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Connect the axis of eg.Axes to the inputType.
   * @ko eg.Axes의 축과 inputType을 연결한다
   * @param {(String[]|String)} axes The name of the axis to associate with inputType <ko>inputType과 연결할 축의 이름</ko>
   * @param {Object} inputType The inputType instance to associate with the axis of eg.Axes <ko>eg.Axes의 축과 연결할 inputType 인스턴스</ko>
   * @return {eg.Axes} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "xOther": {
   *      range: [-100, 100]
   *   }
   * });
   *
   * axes.connect("x", new eg.Axes.PanInput("#area1"))
   *    .connect("x xOther", new eg.Axes.PanInput("#area2"))
   *    .connect(" xOther", new eg.Axes.PanInput("#area3"))
   *    .connect(["x"], new eg.Axes.PanInput("#area4"))
   *    .connect(["xOther", "x"], new eg.Axes.PanInput("#area5"))
   *    .connect(["", "xOther"], new eg.Axes.PanInput("#area6"));
   * ```
   */
  __proto.connect = function (axes, inputType) {
    var mapped;
    if (typeof axes === "string") {
      mapped = axes.split(" ");
    } else {
      mapped = axes.concat();
    }
    // check same instance
    if (~this._inputs.indexOf(inputType)) {
      this.disconnect(inputType);
    }
    inputType.mapAxes(mapped);
    inputType.connect(this.inputObserver);
    this._inputs.push(inputType);
    return this;
  };
  /**
   * Disconnect the axis of eg.Axes from the inputType.
   * @ko eg.Axes의 축과 inputType의 연결을 끊는다.
   * @param {Object} [inputType] An inputType instance associated with the axis of eg.Axes <ko>eg.Axes의 축과 연결한 inputType 인스턴스</ko>
   * @return {eg.Axes} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "xOther": {
   *      range: [-100, 100]
   *   }
   * });
   *
   * const input1 = new eg.Axes.PanInput("#area1");
   * const input2 = new eg.Axes.PanInput("#area2");
   * const input3 = new eg.Axes.PanInput("#area3");
   *
   * axes.connect("x", input1);
   *    .connect("x xOther", input2)
   *    .connect(["xOther", "x"], input3);
   *
   * axes.disconnect(input1); // disconnects input1
   * axes.disconnect(); // disconnects all of them
   * ```
   */
  __proto.disconnect = function (inputType) {
    if (inputType) {
      var index = this._inputs.indexOf(inputType);
      if (index >= 0) {
        this._inputs[index].disconnect();
        this._inputs.splice(index, 1);
      }
    } else {
      this._inputs.forEach(function (v) {
        return v.disconnect();
      });
      this._inputs = [];
    }
    return this;
  };
  /**
   * Returns the current position of the coordinates.
   * @ko 좌표의 현재 위치를 반환한다
   * @param {Object} [axes] The names of the axis <ko>축 이름들</ko>
   * @return {Object.<string, number>} Axis coordinate information <ko>축 좌표 정보</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "xOther": {
   *      range: [-100, 100]
   *   },
   *    "zoom": {
   *      range: [50, 30]
   *   }
   * });
   *
   * axes.get(); // {"x": 0, "xOther": -100, "zoom": 50}
   * axes.get(["x", "zoom"]); // {"x": 0, "zoom": 50}
   * ```
   */
  __proto.get = function (axes) {
    return this.axisManager.get(axes);
  };
  /**
   * Moves an axis to specific coordinates.
   * @ko 좌표를 이동한다.
   * @param {Object.<string, number>} pos The coordinate to move to <ko>이동할 좌표</ko>
   * @param {Number} [duration=0] Duration of the animation (unit: ms) <ko>애니메이션 진행 시간(단위: ms)</ko>
   * @return {eg.Axes} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "xOther": {
   *      range: [-100, 100]
   *   },
   *    "zoom": {
   *      range: [50, 30]
   *   }
   * });
   *
   * axes.setTo({"x": 30, "zoom": 60});
   * axes.get(); // {"x": 30, "xOther": -100, "zoom": 60}
   *
   * axes.setTo({"x": 100, "xOther": 60}, 1000); // animatation
   *
   * // after 1000 ms
   * axes.get(); // {"x": 100, "xOther": 60, "zoom": 60}
   * ```
   */
  __proto.setTo = function (pos, duration) {
    if (duration === void 0) {
      duration = 0;
    }
    this.animationManager.setTo(pos, duration);
    return this;
  };
  /**
   * Moves an axis from the current coordinates to specific coordinates.
   * @ko 현재 좌표를 기준으로 좌표를 이동한다.
   * @param {Object.<string, number>} pos The coordinate to move to <ko>이동할 좌표</ko>
   * @param {Number} [duration=0] Duration of the animation (unit: ms) <ko>애니메이션 진행 시간(단위: ms)</ko>
   * @return {eg.Axes} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "xOther": {
   *      range: [-100, 100]
   *   },
   *    "zoom": {
   *      range: [50, 30]
   *   }
   * });
   *
   * axes.setBy({"x": 30, "zoom": 10});
   * axes.get(); // {"x": 30, "xOther": -100, "zoom": 60}
   *
   * axes.setBy({"x": 70, "xOther": 60}, 1000); // animatation
   *
   * // after 1000 ms
   * axes.get(); // {"x": 100, "xOther": -40, "zoom": 60}
   * ```
   */
  __proto.setBy = function (pos, duration) {
    if (duration === void 0) {
      duration = 0;
    }
    this.animationManager.setBy(pos, duration);
    return this;
  };
  /**
   * Change the options of Axes instance.
   * @ko 인스턴스의 옵션을 변경한다.
   * @param {AxesOption} options Axes options to change <ko>변경할 옵션 목록</ko>
   * @return {eg.Axes} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   * }, {
   *   round: 10,
   * });
   *
   * axes.setTo({"x": 48});
   * axes.get(); // {"x": 50}
   *
   * axes.setOptions({
   *   round: 1,
   * });
   *
   * axes.setTo({"x": 48});
   * axes.get(); // {"x": 48}
   * ```
   */
  __proto.setOptions = function (options) {
    this.options = __assign(__assign({}, this.options), options);
    this.animationManager.setOptions(options);
    return this;
  };
  /**
   * Change the information of an existing axis.
   * @ko 존재하는 축의 정보를 변경한다.
   * @param {Object.<string, AxisOption>} axis Axis options to change <ko>변경할 축의 정보</ko>
   * @return {eg.Axes} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   * });
   *
   * axes.setTo({"x": 150});
   * axes.get(); // {"x": 100}
   *
   * axes.setAxis({
   *   "x": {
   *      range: [0, 200]
   *   },
   * });
   *
   * axes.setTo({"x": 150});
   * axes.get(); // {"x": 150}
   * ```
   */
  __proto.setAxis = function (axis) {
    this.axisManager.setAxis(axis);
    return this;
  };
  /**
   * Stop an animation in progress.
   * @ko 재생 중인 애니메이션을 정지한다.
   * @return {eg.Axes} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   * });
   *
   * axes.setTo({"x": 10}, 1000); // start animatation
   *
   * // after 500 ms
   * axes.stopAnimation(); // stop animation during movement.
   * ```
   */
  __proto.stopAnimation = function () {
    this.animationManager.stopAnimation();
    this.animationManager.finish(false);
    return this;
  };
  /**
   * Change the destination of an animation in progress.
   * @ko 재생 중인 애니메이션의 목적지와 진행 시간을 변경한다.
   * @param {UpdateAnimationOption} pos The coordinate to move to <ko>이동할 좌표</ko>
   * @return {eg.Axes} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 200]
   *   },
   *   "y": {
   *      range: [0, 200]
   *   }
   * });
   *
   * axes.setTo({"x": 50, "y": 50}, 1000); // trigger animation by setTo
   *
   * // after 500 ms
   * axes.updateAnimation({destPos: {"x": 100, "y": 100}}); // animation will end after 500 ms, at {"x": 100, "y": 100}
   *
   * // after 500 ms
   * axes.setTo({"x": 50, "y": 50}, 1000); // trigger animation by setTo
   *
   * // after 700 ms
   * axes.updateAnimation({destPos: {"x": 100, "y": 100}, duration: 1500, restart: true}); // this works same as axes.setTo({"x": 100, "y": 100}, 800) since restart is true.
   * ```
   */
  __proto.updateAnimation = function (options) {
    this.animationManager.updateAnimation(options);
    return this;
  };
  /**
   * Returns whether there is a coordinate in the bounce area of ​​the target axis.
   * @ko 대상 축 중 bounce영역에 좌표가 존재하는지를 반환한다
   * @param {Object} [axes] The names of the axis <ko>축 이름들</ko>
   * @return {Boolen} Whether the bounce area exists. <ko>bounce 영역 존재 여부</ko>
   * @example
   * ```js
   * const axes = new eg.Axes({
   *   "x": {
   *      range: [0, 100]
   *   },
   *   "xOther": {
   *      range: [-100, 100]
   *   },
   *    "zoom": {
   *      range: [50, 30]
   *   }
   * });
   *
   * axes.isBounceArea(["x"]);
   * axes.isBounceArea(["x", "zoom"]);
   * axes.isBounceArea();
   * ```
   */
  __proto.isBounceArea = function (axes) {
    return this.axisManager.isOutside(axes);
  };
  /**
   * Destroys properties, and events used in a module and disconnect all connections to inputTypes.
   * @ko 모듈에 사용한 속성, 이벤트를 해제한다. 모든 inputType과의 연결을 끊는다.
   */
  __proto.destroy = function () {
    this.disconnect();
    this.eventManager.destroy();
  };
  /**
   * @name VERSION
   * @desc Version info string
   * @ko 버전정보 문자열
   *
   * @constant
   * @type {String}
   * @example
   * ```js
   * eg.Axes.VERSION;  // ex) 3.3.3
   * ```
   */
  Axes.VERSION = "3.9.0";
  /* eslint-enable */
  /**
   * @name TRANSFORM
   * @desc Returns the transform attribute with CSS vendor prefixes.
   * @ko CSS vendor prefixes를 붙인 transform 속성을 반환한다.
   *
   * @constant
   * @type {String}
   * @example
   * ```js
   * eg.Axes.TRANSFORM; // "transform" or "webkitTransform"
   * ```
   */
  Axes.TRANSFORM = TRANSFORM;
  /**
   * @name DIRECTION_NONE
   * @constant
   * @type {Number}
   */
  Axes.DIRECTION_NONE = DIRECTION_NONE;
  /**
   * @name DIRECTION_LEFT
   * @constant
   * @type {Number}
   */
  Axes.DIRECTION_LEFT = DIRECTION_LEFT;
  /**
   * @name DIRECTION_RIGHT
   * @constant
   * @type {Number}
   */
  Axes.DIRECTION_RIGHT = DIRECTION_RIGHT;
  /**
   * @name DIRECTION_UP
   * @constant
   * @type {Number}
   */
  Axes.DIRECTION_UP = DIRECTION_UP;
  /**
   * @name DIRECTION_DOWN
   * @constant
   * @type {Number}
   */
  Axes.DIRECTION_DOWN = DIRECTION_DOWN;
  /**
   * @name DIRECTION_HORIZONTAL
   * @constant
   * @type {Number}
   */
  Axes.DIRECTION_HORIZONTAL = DIRECTION_HORIZONTAL;
  /**
   * @name DIRECTION_VERTICAL
   * @constant
   * @type {Number}
   */
  Axes.DIRECTION_VERTICAL = DIRECTION_VERTICAL;
  /**
   * @name DIRECTION_ALL
   * @constant
   * @type {Number}
   */
  Axes.DIRECTION_ALL = DIRECTION_ALL;
  __decorate([Computed], Axes.prototype, "holding", null);
  Axes = __decorate([ReactiveSubscribe], Axes);
  return Axes;
}(component_esm);

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
// get user's direction
var getDirectionByAngle = function (angle, thresholdAngle) {
  if (thresholdAngle < 0 || thresholdAngle > 90) {
    return DIRECTION_NONE;
  }
  var toAngle = Math.abs(angle);
  return toAngle > thresholdAngle && toAngle < 180 - thresholdAngle ? DIRECTION_VERTICAL : DIRECTION_HORIZONTAL;
};
/**
 * @typedef {Object} PanInputOption The option object of the eg.Axes.PanInput module.
 * @ko eg.Axes.PanInput 모듈의 옵션 객체
 * @param {String[]} [inputType=["touch", "mouse", "pointer"]] Types of input devices
 * - touch: Touch screen
 * - mouse: Mouse
 * - pointer: Mouse and touch <ko>입력 장치 종류
 * - touch: 터치 입력 장치
 * - mouse: 마우스
 * - pointer: 마우스 및 터치</ko>
 * @param {String[]} [inputKey=["any"]] List of key combinations to allow input
 * - any: any key
 * - shift: shift key
 * - ctrl: ctrl key and pinch gesture on the trackpad
 * - alt: alt key
 * - meta: meta key
 * - none: none of these keys are pressed <ko>입력을 허용할 키 조합 목록
 * - any: 아무 키
 * - shift: shift 키
 * - ctrl: ctrl 키 및 트랙패드의 pinch 제스쳐
 * - alt: alt 키
 * - meta: meta 키
 * - none: 아무 키도 눌리지 않은 상태 </ko>
 * @param {String[]} [inputButton=["left"]] List of buttons to allow input
 * - left: Left mouse button and normal touch
 * - middle: Mouse wheel press
 * - right: Right mouse button <ko>입력을 허용할 버튼 목록
 * - left: 마우스 왼쪽 버튼
 * - middle: 마우스 휠 눌림
 * - right: 마우스 오른쪽 버튼 </ko>
 * @param {Number[]} [scale] Coordinate scale that a user can move<ko>사용자의 동작으로 이동하는 좌표의 배율</ko>
 * @param {Number} [scale[0]=1] horizontal axis scale <ko>수평축 배율</ko>
 * @param {Number} [scale[1]=1] vertical axis scale <ko>수직축 배율</ko>
 * @param {Number} [thresholdAngle=45] The threshold value that determines whether user action is horizontal or vertical (0~90) <ko>사용자의 동작이 가로 방향인지 세로 방향인지 판단하는 기준 각도(0~90)</ko>
 * @param {Number} [threshold=0] Minimal pan distance required before recognizing <ko>사용자의 Pan 동작을 인식하기 위해산 최소한의 거리</ko>
 * @param {Boolean} [preventClickOnDrag=false] Whether to cancel the {@link https://developer.mozilla.org/en/docs/Web/API/Element/click_event click} event when the user finishes dragging more than 1 pixel <ko>사용자가 1픽셀 이상 드래그를 마쳤을 때 {@link https://developer.mozilla.org/ko/docs/Web/API/Element/click_event click} 이벤트 취소 여부</ko>
 * @param {Boolean} [preventDefaultOnDrag=false] Whether to use the {@link https://developer.mozilla.org/ko/docs/Web/API/Event/preventDefault preventDefault} when the user starts dragging <ko>사용자가 드래그를 시작할 때 {@link https://developer.mozilla.org/ko/docs/Web/API/Event/preventDefault preventDefault} 실행 여부</ko>
 * @param {Number} [iOSEdgeSwipeThreshold=30] Area (px) that can go to the next page when swiping the right edge in iOS safari <ko>iOS Safari에서 오른쪽 엣지를 스와이프 하는 경우 다음 페이지로 넘어갈 수 있는 영역(px)</ko>
 * @param {String} [touchAction=null] Value that overrides the element's "touch-action" css property. If set to null, it is automatically set to prevent scrolling in the direction of the connected axis. <ko>엘리먼트의 "touch-action" CSS 속성을 덮어쓰는 값. 만약 null로 설정된 경우, 연결된 축 방향으로의 스크롤을 방지하게끔 자동으로 설정된다.</ko>
 **/
/**
 * A module that passes the amount of change to eg.Axes when the mouse or touchscreen is down and moved. use less than two axes.
 * @ko 마우스나 터치 스크린을 누르고 움직일때의 변화량을 eg.Axes에 전달하는 모듈. 두개 이하의 축을 사용한다.
 *
 * @example
 * ```js
 * const pan = new eg.Axes.PanInput("#area", {
 *     inputType: ["touch"],
 *     scale: [1, 1.3],
 * });
 *
 * // Connect the 'something2' axis to the mouse or touchscreen x position when the mouse or touchscreen is down and moved.
 * // Connect the 'somethingN' axis to the mouse or touchscreen y position when the mouse or touchscreen is down and moved.
 * axes.connect(["something2", "somethingN"], pan); // or axes.connect("something2 somethingN", pan);
 *
 * // Connect only one 'something1' axis to the mouse or touchscreen x position when the mouse or touchscreen is down and moved.
 * axes.connect(["something1"], pan); // or axes.connect("something1", pan);
 *
 * // Connect only one 'something2' axis to the mouse or touchscreen y position when the mouse or touchscreen is down and moved.
 * axes.connect(["", "something2"], pan); // or axes.connect(" something2", pan);
 * ```
 * @param {String|HTMLElement|Ref<HTMLElement>|jQuery} element An element to use the eg.Axes.PanInput module <ko>eg.Axes.PanInput 모듈을 사용할 엘리먼트</ko>
 * @param {PanInputOption} [options={}] The option object of the eg.Axes.PanInput module<ko>eg.Axes.PanInput 모듈의 옵션 객체</ko>
 */
var PanInput = /*#__PURE__*/function () {
  /**
   *
   */
  function PanInput(el, options) {
    var _this = this;
    this.axes = [];
    this.element = null;
    this._enabled = false;
    this._activeEvent = null;
    this._atRightEdge = false;
    this._rightEdgeTimer = 0;
    this._dragged = false;
    this._isOverThreshold = false;
    this._preventClickWhenDragged = function (e) {
      if (_this._dragged) {
        e.preventDefault();
        e.stopPropagation();
      }
      _this._dragged = false;
    };
    this._voidFunction = function () {};
    this.element = $(el);
    this.options = __assign({
      inputType: ["touch", "mouse", "pointer"],
      inputKey: [ANY],
      inputButton: [MOUSE_LEFT],
      scale: [1, 1],
      thresholdAngle: 45,
      threshold: 0,
      preventClickOnDrag: false,
      preventDefaultOnDrag: false,
      iOSEdgeSwipeThreshold: IOS_EDGE_THRESHOLD,
      releaseOnScroll: false,
      touchAction: null
    }, options);
    this._onPanstart = this._onPanstart.bind(this);
    this._onPanmove = this._onPanmove.bind(this);
    this._onPanend = this._onPanend.bind(this);
  }
  var __proto = PanInput.prototype;
  __proto.mapAxes = function (axes) {
    this._direction = getDirection(!!axes[0], !!axes[1]);
    this.axes = axes;
  };
  __proto.connect = function (observer) {
    if (this._activeEvent) {
      this._detachElementEvent();
      this._detachWindowEvent(this._activeEvent);
    }
    this._attachElementEvent(observer);
    this._originalCssProps = setCssProps(this.element, this.options, this._direction);
    return this;
  };
  __proto.disconnect = function () {
    this._detachElementEvent();
    this._detachWindowEvent(this._activeEvent);
    if (!isCssPropsFromAxes(this._originalCssProps)) {
      revertCssProps(this.element, this._originalCssProps);
    }
    this._direction = DIRECTION_NONE;
    return this;
  };
  /**
   * Destroys elements, properties, and events used in a module.
   * @ko 모듈에 사용한 엘리먼트와 속성, 이벤트를 해제한다.
   */
  __proto.destroy = function () {
    this.disconnect();
    this.element = null;
  };
  /**
   * Enables input devices
   * @ko 입력 장치를 사용할 수 있게 한다
   * @return {PanInput} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   */
  __proto.enable = function () {
    this._enabled = true;
    return this;
  };
  /**
   * Disables input devices
   * @ko 입력 장치를 사용할 수 없게 한다.
   * @return {PanInput} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   */
  __proto.disable = function () {
    this._enabled = false;
    return this;
  };
  /**
   * Returns whether to use an input device
   * @ko 입력 장치 사용 여부를 반환한다.
   * @return {Boolean} Whether to use an input device <ko>입력장치 사용여부</ko>
   */
  __proto.isEnabled = function () {
    return this._enabled;
  };
  /**
   * Releases current user input.
   * @ko 사용자의 입력을 강제로 중단시킨다.
   * @return {PanInput} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   */
  __proto.release = function () {
    var activeEvent = this._activeEvent;
    var prevEvent = activeEvent.prevEvent;
    activeEvent.onRelease();
    this._observer.release(this, prevEvent, [0, 0]);
    this._detachWindowEvent(activeEvent);
    return this;
  };
  __proto._onPanstart = function (event) {
    var _a = this.options,
      inputKey = _a.inputKey,
      inputButton = _a.inputButton,
      preventDefaultOnDrag = _a.preventDefaultOnDrag;
    var activeEvent = this._activeEvent;
    var panEvent = activeEvent.onEventStart(event, inputKey, inputButton);
    if (!panEvent || !this._enabled || activeEvent.getTouches(event, inputButton) > 1) {
      return;
    }
    if (panEvent.srcEvent.cancelable !== false) {
      var edgeThreshold = this.options.iOSEdgeSwipeThreshold;
      this._dragged = false;
      this._isOverThreshold = false;
      this._observer.hold(this, panEvent);
      this._atRightEdge = IS_IOS_SAFARI && panEvent.center.x > window.innerWidth - edgeThreshold;
      this._attachWindowEvent(activeEvent);
      preventDefaultOnDrag && panEvent.srcEvent.type !== "touchstart" && panEvent.srcEvent.preventDefault();
      activeEvent.prevEvent = panEvent;
    }
  };
  __proto._onPanmove = function (event) {
    var _this = this;
    var _a = this.options,
      iOSEdgeSwipeThreshold = _a.iOSEdgeSwipeThreshold,
      preventClickOnDrag = _a.preventClickOnDrag,
      releaseOnScroll = _a.releaseOnScroll,
      inputKey = _a.inputKey,
      inputButton = _a.inputButton,
      threshold = _a.threshold,
      thresholdAngle = _a.thresholdAngle;
    var activeEvent = this._activeEvent;
    var panEvent = activeEvent.onEventMove(event, inputKey, inputButton);
    var touches = activeEvent.getTouches(event, inputButton);
    if (touches === 0 || releaseOnScroll && panEvent && !panEvent.srcEvent.cancelable) {
      this._onPanend(event);
      return;
    }
    if (!panEvent || !this._enabled || touches > 1) {
      return;
    }
    var userDirection = getDirectionByAngle(panEvent.angle, thresholdAngle);
    var useHorizontal = useDirection(DIRECTION_HORIZONTAL, this._direction, userDirection);
    var useVertical = useDirection(DIRECTION_VERTICAL, this._direction, userDirection);
    if (activeEvent.prevEvent && IS_IOS_SAFARI) {
      var swipeLeftToRight = panEvent.center.x < 0;
      if (swipeLeftToRight) {
        // iOS swipe left => right
        this.release();
        return;
      } else if (this._atRightEdge) {
        clearTimeout(this._rightEdgeTimer);
        // - is right to left
        var swipeRightToLeft = panEvent.deltaX < -iOSEdgeSwipeThreshold;
        if (swipeRightToLeft) {
          this._atRightEdge = false;
        } else {
          // iOS swipe right => left
          this._rightEdgeTimer = window.setTimeout(function () {
            return _this.release();
          }, 100);
        }
      }
    }
    var distance = this._getDistance([panEvent.deltaX, panEvent.deltaY], [useHorizontal, useVertical]);
    var offset = this._getOffset([panEvent.offsetX, panEvent.offsetY], [useHorizontal, useVertical]);
    var prevent = offset.some(function (v) {
      return v !== 0;
    });
    if (prevent) {
      if (panEvent.srcEvent.cancelable !== false) {
        panEvent.srcEvent.preventDefault();
      }
      panEvent.srcEvent.stopPropagation();
    }
    panEvent.preventSystemEvent = prevent;
    if (prevent && (this._isOverThreshold || distance >= threshold)) {
      this._dragged = preventClickOnDrag;
      this._isOverThreshold = true;
      this._observer.change(this, panEvent, toAxis(this.axes, offset));
    }
    activeEvent.prevEvent = panEvent;
  };
  __proto._onPanend = function (event) {
    var inputButton = this.options.inputButton;
    var activeEvent = this._activeEvent;
    activeEvent.onEventEnd(event);
    if (!this._enabled || activeEvent.getTouches(event, inputButton) !== 0) {
      return;
    }
    this._detachWindowEvent(activeEvent);
    clearTimeout(this._rightEdgeTimer);
    var prevEvent = activeEvent.prevEvent;
    var velocity = this._isOverThreshold ? this._getOffset([Math.abs(prevEvent.velocityX) * (prevEvent.offsetX < 0 ? -1 : 1), Math.abs(prevEvent.velocityY) * (prevEvent.offsetY < 0 ? -1 : 1)], [useDirection(DIRECTION_HORIZONTAL, this._direction), useDirection(DIRECTION_VERTICAL, this._direction)]) : [0, 0];
    activeEvent.onRelease();
    this._observer.release(this, prevEvent, velocity);
  };
  __proto._attachWindowEvent = function (activeEvent) {
    var _this = this;
    activeEvent === null || activeEvent === void 0 ? void 0 : activeEvent.move.forEach(function (event) {
      window.addEventListener(event, _this._onPanmove, getAddEventOptions(event));
    });
    activeEvent === null || activeEvent === void 0 ? void 0 : activeEvent.end.forEach(function (event) {
      window.addEventListener(event, _this._onPanend, getAddEventOptions(event));
    });
  };
  __proto._detachWindowEvent = function (activeEvent) {
    var _this = this;
    activeEvent === null || activeEvent === void 0 ? void 0 : activeEvent.move.forEach(function (event) {
      window.removeEventListener(event, _this._onPanmove);
    });
    activeEvent === null || activeEvent === void 0 ? void 0 : activeEvent.end.forEach(function (event) {
      window.removeEventListener(event, _this._onPanend);
    });
  };
  __proto._getOffset = function (properties, direction) {
    var scale = this.options.scale;
    return [direction[0] ? properties[0] * scale[0] : 0, direction[1] ? properties[1] * scale[1] : 0];
  };
  __proto._getDistance = function (delta, direction) {
    return Math.sqrt(Number(direction[0]) * Math.pow(delta[0], 2) + Number(direction[1]) * Math.pow(delta[1], 2));
  };
  __proto._attachElementEvent = function (observer) {
    var _this = this;
    var activeEvent = convertInputType(this.options.inputType);
    var element = this.element;
    if (!activeEvent) {
      return;
    }
    if (!element) {
      throw new Error("Element to connect input does not exist.");
    }
    this._observer = observer;
    this._enabled = true;
    this._activeEvent = activeEvent;
    element.addEventListener("click", this._preventClickWhenDragged, true);
    activeEvent.start.forEach(function (event) {
      element.addEventListener(event, _this._onPanstart);
    });
    // adding event listener to element prevents invalid behavior in iOS Safari
    activeEvent.move.forEach(function (event) {
      element.addEventListener(event, _this._voidFunction);
    });
  };
  __proto._detachElementEvent = function () {
    var _this = this;
    var activeEvent = this._activeEvent;
    var element = this.element;
    if (element) {
      element.removeEventListener("click", this._preventClickWhenDragged, true);
      activeEvent === null || activeEvent === void 0 ? void 0 : activeEvent.start.forEach(function (event) {
        element.removeEventListener(event, _this._onPanstart);
      });
      activeEvent === null || activeEvent === void 0 ? void 0 : activeEvent.move.forEach(function (event) {
        element.removeEventListener(event, _this._voidFunction);
      });
    }
    this._enabled = false;
    this._observer = null;
  };
  return PanInput;
}();

/**
 * A module that passes the angle moved by touch to Axes and uses one axis of rotation.
 * [Details](https://github.com/naver/egjs-axes/wiki/RotatePanInput)
 * @ko 터치에 의해 움직인 각도를 Axes 에 전달하며 1개의 회전축만 사용한다.
 * [상세내용](https://github.com/naver/egjs-axes/wiki/RotatePanInput-%7C-%ED%95%9C%EA%B5%AD%EC%96%B4)
 *
 * @example
 * ```js
 * const input = new eg.Axes.RotatePanInput("#area");
 *
 * var axes = new eg.Axes({
 *	// property name('angle') could be anything you want (eg. x, y, z...)
 * 	angle: {
 * 		range: [-180, 180] // from -180deg to 180deg
 * 	}
 * });
 *
 * axes.connect("angle", input)
 * ```
 * @param {HTMLElement|String|jQuery} element An element to use the eg.Axes.RotatePanInput module <ko>eg.Axes.RotatePanInput 모듈을 사용할 엘리먼트</ko>
 * @param {PanInputOption} [options] The option object of the eg.Axes.PanInput module<ko>eg.Axes.PanInput 모듈의 옵션 객체</ko>
 * @extends PanInput
 */
var RotatePanInput = /*#__PURE__*/function (_super) {
  axes_esm_extends(RotatePanInput, _super);
  /**
   *
   */
  function RotatePanInput(el, options) {
    var _this = _super.call(this, el, options) || this;
    _this._prevQuadrant = null;
    _this._lastDiff = 0;
    return _this;
  }
  var __proto = RotatePanInput.prototype;
  __proto.mapAxes = function (axes) {
    this._direction = axes_esm_Axes.DIRECTION_ALL;
    this.axes = axes;
  };
  __proto._onPanstart = function (event) {
    var _a = this.options,
      inputKey = _a.inputKey,
      inputButton = _a.inputButton;
    var activeEvent = this._activeEvent;
    var panEvent = activeEvent.onEventStart(event, inputKey, inputButton);
    if (!panEvent || !this.isEnabled()) {
      return;
    }
    var rect = this.element.getBoundingClientRect();
    this._observer.hold(this, panEvent);
    this._attachWindowEvent(activeEvent);
    // TODO: how to do if element is ellipse not circle.
    this._coefficientForDistanceToAngle = 360 / (rect.width * Math.PI); // from 2*pi*r * x / 360
    // TODO: provide a way to set origin like https://developer.mozilla.org/en-US/docs/Web/CSS/transform-origin
    this._rotateOrigin = [rect.left + (rect.width - 1) / 2, rect.top + (rect.height - 1) / 2];
    // init angle.
    this._prevAngle = null;
    this._triggerChange(panEvent);
    activeEvent.prevEvent = panEvent;
  };
  __proto._onPanmove = function (event) {
    var _a = this.options,
      inputKey = _a.inputKey,
      inputButton = _a.inputButton;
    var activeEvent = this._activeEvent;
    var panEvent = activeEvent.onEventMove(event, inputKey, inputButton);
    if (!panEvent || !this.isEnabled()) {
      return;
    }
    if (panEvent.srcEvent.cancelable !== false) {
      panEvent.srcEvent.preventDefault();
    }
    panEvent.srcEvent.stopPropagation();
    this._triggerChange(panEvent);
    activeEvent.prevEvent = panEvent;
  };
  __proto._onPanend = function (event) {
    var activeEvent = this._activeEvent;
    activeEvent.onEventEnd(event);
    if (!this.isEnabled()) {
      return;
    }
    var prevEvent = activeEvent.prevEvent;
    this._triggerChange(prevEvent);
    var vx = prevEvent.velocityX;
    var vy = prevEvent.velocityY;
    var velocity = Math.sqrt(vx * vx + vy * vy) * (this._lastDiff > 0 ? -1 : 1); // clockwise
    activeEvent.onRelease();
    this._observer.release(this, prevEvent, [velocity * this._coefficientForDistanceToAngle]);
    this._detachWindowEvent(activeEvent);
  };
  __proto._triggerChange = function (event) {
    var _a = this._getPosFromOrigin(event.center.x, event.center.y),
      x = _a.x,
      y = _a.y;
    var angle = getAngle(x, y);
    var positiveAngle = angle < 0 ? 360 + angle : angle;
    var quadrant = this._getQuadrant(event.center.x, event.center.y);
    var diff = this._getDifference(this._prevAngle, positiveAngle, this._prevQuadrant, quadrant);
    this._prevAngle = positiveAngle;
    this._prevQuadrant = quadrant;
    if (diff === 0) {
      return;
    }
    this._lastDiff = diff;
    this._observer.change(this, event, toAxis(this.axes, [-diff])); // minus for clockwise
  };

  __proto._getDifference = function (prevAngle, angle, prevQuadrant, quadrant) {
    var diff;
    if (prevAngle === null) {
      diff = 0;
    } else if (prevQuadrant === 1 && quadrant === 4) {
      diff = -prevAngle - (360 - angle);
    } else if (prevQuadrant === 4 && quadrant === 1) {
      diff = 360 - prevAngle + angle;
    } else {
      diff = angle - prevAngle;
    }
    return diff;
  };
  __proto._getPosFromOrigin = function (posX, posY) {
    return {
      x: posX - this._rotateOrigin[0],
      y: this._rotateOrigin[1] - posY
    };
  };
  __proto._getQuadrant = function (posX, posY) {
    /**
     * Quadrant
     *       y(+)
     *       |
     *   2   |    1
     * --------------->x(+)
     *   3   |    4
     *       |
     */
    var _a = this._getPosFromOrigin(posX, posY),
      x = _a.x,
      y = _a.y;
    var q = 0;
    if (x >= 0 && y >= 0) {
      q = 1;
    } else if (x < 0 && y >= 0) {
      q = 2;
    } else if (x < 0 && y < 0) {
      q = 3;
    } else if (x >= 0 && y < 0) {
      q = 4;
    }
    return q;
  };
  return RotatePanInput;
}(PanInput);

/**
 * @typedef {Object} PinchInputOption The option object of the eg.Axes.PinchInput module
 * @ko eg.Axes.PinchInput 모듈의 옵션 객체
 * @param {Number} [scale=1] Coordinate scale that a user can move<ko>사용자의 동작으로 이동하는 좌표의 배율</ko>
 * @param {Number} [threshold=0] Minimal scale before recognizing <ko>사용자의 Pinch 동작을 인식하기 위해산 최소한의 배율</ko>
 * @param {String[]} [inputType=["touch", "pointer"]] Types of input devices
 * - touch: Touch screen
 * - pointer: Mouse and touch <ko>입력 장치 종류
 * - touch: 터치 입력 장치
 * - pointer: 마우스 및 터치</ko>
 * @param {String} [touchAction="none"] Value that overrides the element's "touch-action" css property. It is set to "none" to prevent scrolling during touch. <ko>엘리먼트의 "touch-action" CSS 속성을 덮어쓰는 값. 터치 도중 스크롤을 방지하기 위해 "none" 으로 설정되어 있다.</ko>
 **/
/**
 * A module that passes the amount of change to eg.Axes when two pointers are moving toward (zoom-in) or away from each other (zoom-out). use one axis.
 * @ko 2개의 pointer를 이용하여 zoom-in하거나 zoom-out 하는 동작의 변화량을 eg.Axes에 전달하는 모듈. 한 개 의 축을 사용한다.
 * @example
 * ```js
 * const pinch = new eg.Axes.PinchInput("#area", {
 *   scale: 1
 * });
 *
 * // Connect 'something' axis when two pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * axes.connect("something", pinch);
 * ```
 * @param {HTMLElement|String|jQuery} element An element to use the eg.Axes.PinchInput module <ko>eg.Axes.PinchInput 모듈을 사용할 엘리먼트</ko>
 * @param {PinchInputOption} [options] The option object of the eg.Axes.PinchInput module<ko>eg.Axes.PinchInput 모듈의 옵션 객체</ko>
 */
var PinchInput = /*#__PURE__*/function () {
  /**
   *
   */
  function PinchInput(el, options) {
    this.axes = [];
    this.element = null;
    this._pinchFlag = false;
    this._enabled = false;
    this._activeEvent = null;
    this._isOverThreshold = false;
    this.element = $(el);
    this.options = __assign({
      scale: 1,
      threshold: 0,
      inputType: ["touch", "pointer"],
      touchAction: "none"
    }, options);
    this._onPinchStart = this._onPinchStart.bind(this);
    this._onPinchMove = this._onPinchMove.bind(this);
    this._onPinchEnd = this._onPinchEnd.bind(this);
  }
  var __proto = PinchInput.prototype;
  __proto.mapAxes = function (axes) {
    this.axes = axes;
  };
  __proto.connect = function (observer) {
    if (this._activeEvent) {
      this._detachEvent();
    }
    this._attachEvent(observer);
    this._originalCssProps = setCssProps(this.element, this.options, DIRECTION_ALL);
    return this;
  };
  __proto.disconnect = function () {
    this._detachEvent();
    if (!isCssPropsFromAxes(this._originalCssProps)) {
      revertCssProps(this.element, this._originalCssProps);
    }
    return this;
  };
  /**
   * Destroys elements, properties, and events used in a module.
   * @ko 모듈에 사용한 엘리먼트와 속성, 이벤트를 해제한다.
   */
  __proto.destroy = function () {
    this.disconnect();
    this.element = null;
  };
  /**
   * Enables input devices
   * @ko 입력 장치를 사용할 수 있게 한다
   * @return {PinchInput} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   */
  __proto.enable = function () {
    this._enabled = true;
    return this;
  };
  /**
   * Disables input devices
   * @ko 입력 장치를 사용할 수 없게 한다.
   * @return {PinchInput} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   */
  __proto.disable = function () {
    this._enabled = false;
    return this;
  };
  /**
   * Returns whether to use an input device
   * @ko 입력 장치를 사용 여부를 반환한다.
   * @return {Boolean} Whether to use an input device <ko>입력장치 사용여부</ko>
   */
  __proto.isEnabled = function () {
    return this._enabled;
  };
  __proto._onPinchStart = function (event) {
    var activeEvent = this._activeEvent;
    var pinchEvent = activeEvent.onEventStart(event);
    if (!pinchEvent || !this._enabled || activeEvent.getTouches(event) !== 2) {
      return;
    }
    this._baseValue = this._observer.get(this)[this.axes[0]];
    this._observer.hold(this, event);
    this._pinchFlag = true;
    this._isOverThreshold = false;
    activeEvent.prevEvent = pinchEvent;
  };
  __proto._onPinchMove = function (event) {
    var threshold = this.options.threshold;
    var activeEvent = this._activeEvent;
    var pinchEvent = activeEvent.onEventMove(event);
    if (!pinchEvent || !this._pinchFlag || !this._enabled || activeEvent.getTouches(event) !== 2) {
      return;
    }
    var distance = this._getDistance(pinchEvent.scale);
    var offset = this._getOffset(pinchEvent.scale, activeEvent.prevEvent.scale);
    if (this._isOverThreshold || distance >= threshold) {
      this._isOverThreshold = true;
      this._observer.change(this, event, toAxis(this.axes, [offset]));
    }
    activeEvent.prevEvent = pinchEvent;
  };
  __proto._onPinchEnd = function (event) {
    var activeEvent = this._activeEvent;
    activeEvent.onEventEnd(event);
    if (!this._pinchFlag || !this._enabled || activeEvent.getTouches(event) >= 2) {
      return;
    }
    activeEvent.onRelease();
    this._observer.release(this, event, [0], 0);
    this._baseValue = null;
    this._pinchFlag = false;
  };
  __proto._attachEvent = function (observer) {
    var _this = this;
    var activeEvent = convertInputType(this.options.inputType);
    var element = this.element;
    if (!activeEvent) {
      return;
    }
    if (!element) {
      throw new Error("Element to connect input does not exist.");
    }
    this._observer = observer;
    this._enabled = true;
    this._activeEvent = activeEvent;
    activeEvent.start.forEach(function (event) {
      element.addEventListener(event, _this._onPinchStart, false);
    });
    activeEvent.move.forEach(function (event) {
      element.addEventListener(event, _this._onPinchMove, false);
    });
    activeEvent.end.forEach(function (event) {
      element.addEventListener(event, _this._onPinchEnd, false);
    });
  };
  __proto._detachEvent = function () {
    var _this = this;
    var activeEvent = this._activeEvent;
    var element = this.element;
    if (element) {
      activeEvent === null || activeEvent === void 0 ? void 0 : activeEvent.start.forEach(function (event) {
        element.removeEventListener(event, _this._onPinchStart, false);
      });
      activeEvent === null || activeEvent === void 0 ? void 0 : activeEvent.move.forEach(function (event) {
        element.removeEventListener(event, _this._onPinchMove, false);
      });
      activeEvent === null || activeEvent === void 0 ? void 0 : activeEvent.end.forEach(function (event) {
        element.removeEventListener(event, _this._onPinchEnd, false);
      });
    }
    this._enabled = false;
    this._observer = null;
  };
  __proto._getOffset = function (pinchScale, prev) {
    if (prev === void 0) {
      prev = 1;
    }
    return this._baseValue * (pinchScale - prev) * this.options.scale;
  };
  __proto._getDistance = function (pinchScale) {
    return Math.abs(pinchScale - 1);
  };
  return PinchInput;
}();

/**
 * @typedef {Object} WheelInputOption The option object of the eg.Axes.WheelInput module
 * @ko eg.Axes.WheelInput 모듈의 옵션 객체
 * @param {String[]} [inputKey=["any"]] List of key combinations to allow input
 * - any: any key
 * - shift: shift key
 * - ctrl: ctrl key and pinch gesture on the trackpad
 * - alt: alt key
 * - meta: meta key
 * - none: none of these keys are pressed <ko>입력을 허용할 키 조합 목록
 * - any: 아무 키
 * - shift: shift 키
 * - ctrl: ctrl 키 및 트랙패드의 pinch 제스쳐
 * - alt: alt 키
 * - meta: meta 키
 * - none: 아무 키도 눌리지 않은 상태 </ko>
 * @param {Number} [scale=1] Coordinate scale that a user can move<ko>사용자의 동작으로 이동하는 좌표의 배율</ko>
 * @param {Number} [releaseDelay=300] Millisecond that trigger release event after last input<ko>마지막 입력 이후 release 이벤트가 트리거되기까지의 밀리초</ko>
 * @param {Boolean} [useNormalized=true] Whether to calculate scroll speed the same in all browsers<ko>모든 브라우저에서 스크롤 속도를 동일하게 처리할지 여부</ko>
 * @param {Boolean} [useAnimation=false] Whether to process coordinate changes through the mouse wheel as a continuous animation<ko>마우스 휠을 통한 좌표 변화를 연속적인 애니메이션으로 처리할지 여부</ko>
 **/
/**
 * A module that passes the amount of change to eg.Axes when the mouse wheel is moved. use one axis.
 * @ko 마우스 휠이 움직일때의 변화량을 eg.Axes에 전달하는 모듈. 두개 이하의 축을 사용한다.
 *
 * @example
 * ```js
 * const wheel = new eg.Axes.WheelInput("#area", {
 *     scale: 1
 * });
 *
 * // Connect only one 'something1' axis to the vertical mouse wheel.
 * axes.connect(["something1"], wheel); // or axes.connect("something1", wheel);
 *
 * // Connect only one 'something2' axis to the horizontal mouse wheel.
 * axes.connect(["", "something2"], wheel); // or axes.connect(" something2", pan);
 *
 * // Connect the 'something1' axis to the vertical mouse wheel.
 * // Connect the 'something2' axis to the horizontal mouse wheel.
 * axes.connect(["something1", "something2"], wheel);
 * ```
 * @param {HTMLElement|String|jQuery} element An element to use the eg.Axes.WheelInput module <ko>eg.Axes.WheelInput 모듈을 사용할 엘리먼트</ko>
 * @param {WheelInputOption} [options] The option object of the eg.Axes.WheelInput module<ko>eg.Axes.WheelInput 모듈의 옵션 객체</ko>
 */
var WheelInput = /*#__PURE__*/function () {
  /**
   *
   */
  function WheelInput(el, options) {
    this.axes = [];
    this.element = null;
    this._enabled = false;
    this._holding = false;
    this._timer = null;
    this.element = $(el);
    this.options = __assign({
      inputKey: [ANY],
      scale: 1,
      releaseDelay: 300,
      useNormalized: true,
      useAnimation: false
    }, options);
    this._onWheel = this._onWheel.bind(this);
  }
  var __proto = WheelInput.prototype;
  __proto.mapAxes = function (axes) {
    // vertical mouse wheel is mapped into axes[0]
    this._direction = getDirection(!!axes[1], !!axes[0]);
    this.axes = axes;
  };
  __proto.connect = function (observer) {
    this._detachEvent();
    this._attachEvent(observer);
    return this;
  };
  __proto.disconnect = function () {
    this._detachEvent();
    return this;
  };
  /**
   * Destroys elements, properties, and events used in a module.
   * @ko 모듈에 사용한 엘리먼트와 속성, 이벤트를 해제한다.
   */
  __proto.destroy = function () {
    this.disconnect();
    this.element = null;
  };
  /**
   * Enables input devices
   * @ko 입력 장치를 사용할 수 있게 한다
   * @return {WheelInput} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   */
  __proto.enable = function () {
    this._enabled = true;
    return this;
  };
  /**
   * Disables input devices
   * @ko 입력 장치를 사용할 수 없게 한다.
   * @return {WheelInput} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   */
  __proto.disable = function () {
    this._enabled = false;
    return this;
  };
  /**
   * Returns whether to use an input device
   * @ko 입력 장치를 사용 여부를 반환한다.
   * @return {Boolean} Whether to use an input device <ko>입력장치 사용여부</ko>
   */
  __proto.isEnabled = function () {
    return this._enabled;
  };
  __proto._onWheel = function (event) {
    var _this = this;
    if (!this._enabled || !isValidKey(event, this.options.inputKey)) {
      return;
    }
    var offset = this._getOffset([event.deltaY, event.deltaX], [useDirection(DIRECTION_VERTICAL, this._direction), useDirection(DIRECTION_HORIZONTAL, this._direction)]);
    if (offset[0] === 0 && offset[1] === 0) {
      return;
    }
    event.preventDefault();
    if (!this._holding) {
      this._observer.hold(this, event);
      this._holding = true;
    }
    this._observer.change(this, event, toAxis(this.axes, offset), this.options.useAnimation);
    clearTimeout(this._timer);
    this._timer = setTimeout(function () {
      if (_this._holding) {
        _this._holding = false;
        _this._observer.release(_this, event, [0]);
      }
    }, this.options.releaseDelay);
  };
  __proto._getOffset = function (properties, direction) {
    var scale = this.options.scale;
    var useNormalized = this.options.useNormalized;
    return [direction[0] && properties[0] ? (properties[0] > 0 ? -1 : 1) * (useNormalized ? 1 : Math.abs(properties[0])) * scale : 0, direction[1] && properties[1] ? (properties[1] > 0 ? -1 : 1) * (useNormalized ? 1 : Math.abs(properties[1])) * scale : 0];
  };
  __proto._attachEvent = function (observer) {
    var element = this.element;
    if (!element) {
      throw new Error("Element to connect input does not exist.");
    }
    this._observer = observer;
    element.addEventListener("wheel", this._onWheel);
    this._enabled = true;
  };
  __proto._detachEvent = function () {
    var element = this.element;
    if (element) {
      this.element.removeEventListener("wheel", this._onWheel);
    }
    this._enabled = false;
    this._observer = null;
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  };
  return WheelInput;
}();

var KEY_LEFT_ARROW = 37;
var KEY_A = 65;
var KEY_UP_ARROW = 38;
var KEY_W = 87;
var KEY_RIGHT_ARROW = 39;
var KEY_D = 68;
var KEY_DOWN_ARROW = 40;
var KEY_S = 83;
/* eslint-disable */
var DIRECTION_REVERSE = -1;
var DIRECTION_FORWARD = 1;
var DIRECTION_HORIZONTAL$1 = -1;
var DIRECTION_VERTICAL$1 = 1;
var DELAY = 80;
/**
 * @typedef {Object} MoveKeyInputOption The option object of the eg.Axes.MoveKeyInput module
 * @ko eg.Axes.MoveKeyInput 모듈의 옵션 객체
 * @param {Array<Number>} [scale] Coordinate scale that a user can move<ko>사용자의 동작으로 이동하는 좌표의 배율</ko>
 * @param {Number} [scale[0]=1] Coordinate scale for the first axis<ko>첫번째 축의 배율</ko>
 * @param {Number} [scale[1]=1] Coordinate scale for the decond axis<ko>두번째 축의 배율</ko>
 **/
/**
 * A module that passes the amount of change to eg.Axes when the move key stroke is occured. use two axis.
 * @ko 이동키 입력이 발생했을 때의 변화량을 eg.Axes에 전달하는 모듈. 두 개 의 축을 사용한다.
 *
 * @example
 * ```js
 * const moveKey = new eg.Axes.MoveKeyInput("#area", {
 *     scale: [1, 1]
 * });
 *
 * // Connect 'x', 'y' axes when the moveKey is pressed.
 * axes.connect(["x", "y"], moveKey);
 * ```
 * @param {HTMLElement|String|jQuery} element An element to use the eg.Axes.MoveKeyInput module <ko>eg.Axes.MoveKeyInput 모듈을 사용할 엘리먼트</ko>
 * @param {MoveKeyInputOption} [options] The option object of the eg.Axes.MoveKeyInput module<ko>eg.Axes.MoveKeyInput 모듈의 옵션 객체</ko>
 */
var MoveKeyInput = /*#__PURE__*/function () {
  /**
   *
   */
  function MoveKeyInput(el, options) {
    this.axes = [];
    this.element = null;
    this._enabled = false;
    this._holding = false;
    this._timer = null;
    this.element = $(el);
    this.options = __assign({
      scale: [1, 1]
    }, options);
    this._onKeydown = this._onKeydown.bind(this);
    this._onKeyup = this._onKeyup.bind(this);
  }
  var __proto = MoveKeyInput.prototype;
  __proto.mapAxes = function (axes) {
    this.axes = axes;
  };
  __proto.connect = function (observer) {
    this._detachEvent();
    // add tabindex="0" to the container for making it focusable
    if (this.element.getAttribute("tabindex") !== "0") {
      this.element.setAttribute("tabindex", "0");
    }
    this._attachEvent(observer);
    return this;
  };
  __proto.disconnect = function () {
    this._detachEvent();
    return this;
  };
  /**
   * Destroys elements, properties, and events used in a module.
   * @ko 모듈에 사용한 엘리먼트와 속성, 이벤트를 해제한다.
   */
  __proto.destroy = function () {
    this.disconnect();
    this.element = null;
  };
  /**
   * Enables input devices
   * @ko 입력 장치를 사용할 수 있게 한다
   * @return {MoveKeyInput} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   */
  __proto.enable = function () {
    this._enabled = true;
    return this;
  };
  /**
   * Disables input devices
   * @ko 입력 장치를 사용할 수 없게 한다.
   * @return {MoveKeyInput} An instance of a module itself <ko>모듈 자신의 인스턴스</ko>
   */
  __proto.disable = function () {
    this._enabled = false;
    return this;
  };
  /**
   * Returns whether to use an input device
   * @ko 입력 장치를 사용 여부를 반환한다.
   * @return {Boolean} Whether to use an input device <ko>입력장치 사용여부</ko>
   */
  __proto.isEnabled = function () {
    return this._enabled;
  };
  __proto._onKeydown = function (event) {
    if (!this._enabled) {
      return;
    }
    var isMoveKey = true;
    var direction = DIRECTION_FORWARD;
    var move = DIRECTION_HORIZONTAL$1;
    switch (event.keyCode) {
      case KEY_LEFT_ARROW:
      case KEY_A:
        direction = DIRECTION_REVERSE;
        break;
      case KEY_RIGHT_ARROW:
      case KEY_D:
        break;
      case KEY_DOWN_ARROW:
      case KEY_S:
        direction = DIRECTION_REVERSE;
        move = DIRECTION_VERTICAL$1;
        break;
      case KEY_UP_ARROW:
      case KEY_W:
        move = DIRECTION_VERTICAL$1;
        break;
      default:
        isMoveKey = false;
    }
    if (move === DIRECTION_HORIZONTAL$1 && !this.axes[0] || move === DIRECTION_VERTICAL$1 && !this.axes[1]) {
      isMoveKey = false;
    }
    if (!isMoveKey) {
      return;
    }
    event.preventDefault();
    var offsets = move === DIRECTION_HORIZONTAL$1 ? [+this.options.scale[0] * direction, 0] : [0, +this.options.scale[1] * direction];
    if (!this._holding) {
      this._observer.hold(this, event);
      this._holding = true;
    }
    clearTimeout(this._timer);
    this._observer.change(this, event, toAxis(this.axes, offsets));
  };
  __proto._onKeyup = function (event) {
    var _this = this;
    if (!this._holding) {
      return;
    }
    clearTimeout(this._timer);
    this._timer = setTimeout(function () {
      _this._observer.release(_this, event, [0, 0]);
      _this._holding = false;
    }, DELAY);
  };
  __proto._attachEvent = function (observer) {
    var element = this.element;
    if (!element) {
      throw new Error("Element to connect input does not exist.");
    }
    this._observer = observer;
    element.addEventListener("keydown", this._onKeydown, false);
    element.addEventListener("keypress", this._onKeydown, false);
    element.addEventListener("keyup", this._onKeyup, false);
    this._enabled = true;
  };
  __proto._detachEvent = function () {
    var element = this.element;
    if (element) {
      element.removeEventListener("keydown", this._onKeydown, false);
      element.removeEventListener("keypress", this._onKeydown, false);
      element.removeEventListener("keyup", this._onKeyup, false);
    }
    this._enabled = false;
    this._observer = null;
  };
  return MoveKeyInput;
}();

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
var REACTIVE_AXES = {
  methods: AXES_METHODS,
  events: AXES_EVENTS,
  created: function (data) {
    return new axes_esm_Axes(data.axis, data.options);
  },
  on: function (instance, name, callback) {
    instance.on(name, callback);
  },
  off: function (instance, name, callback) {
    instance.off(name, callback);
  },
  destroy: function (instance) {
    instance.destroy();
  }
};

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */

/* harmony default export */ var axes_esm = (axes_esm_Axes);

//# sourceMappingURL=axes.esm.js.map

// CONCATENATED MODULE: ./node_modules/@egjs/imready/node_modules/@cfcs/core/dist/cfcs.esm.js
/*
Copyright (c) NAVER Crop.
name: @cfcs/core
license: MIT
author: NAVER Crop.
repository: https://github.com/naver/cfcs
version: 0.0.24
*/


/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */

/**
 * @hidden
 */
function cfcs_esm_keys(obj) {
  return Object.keys(obj);
}
/**
 * @hidden
 */

function cfcs_esm_camelize(str) {
  return str.replace(/[\s-_]([a-z])/g, function (all, letter) {
    return letter.toUpperCase();
  });
}
/**
 * @hidden
 */

function cfcs_esm_isString(val) {
  return typeof val === "string";
}
/**
 * @hidden
 */

function dist_cfcs_esm_isObject(val) {
  return typeof val === "object";
}
/**
 * @hidden
 */

function cfcs_esm_isFunction(val) {
  return typeof val === "function";
}

/**
 * @hidden
 */

function cfcs_esm_findTarget(target) {
  var el;

  if (!target) {
    return null;
  }

  if (cfcs_esm_isString(target)) {
    el = document.querySelector(target);
  } else if (target instanceof Element) {
    el = target;
  } else if ("value" in target || "current" in target) {
    el = target.value || target.current;
  }

  return el;
}
/**
 * @description Sets the name of the class method to be exposed to the outside.
 * @category DOM
 * @return Property Decorator
 * @example
 * ```ts
 * import { withClassMethods } from "@cfcs/core";
 *
 * class YourFrameworkComponent {
 *   @withClassMethod(METHOD_NAMES)
 *   inst = new YourComponent();
 * }
 * ```
 */

function cfcs_esm_withClassMethods(methods) {
  return function (prototype, memberName) {
    methods.forEach(function (name) {
      if (name in prototype) {
        return;
      }

      prototype[name] = function () {
        var _a;

        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        var result = (_a = this[memberName])[name].apply(_a, args); // fix `this` type to return your own `class` instance to the instance using the decorator.


        if (result === this[memberName]) {
          return this;
        } else {
          return result;
        }
      };
    });
  };
}

var cfcs_esm_OBSERVERS_PATH = "__observers__";
var cfcs_esm_COMPUTED_PATH = "__computed__";
var cfcs_esm_CFCS_DETECTED_DEPENDENCIES_VERSION = 1;
var cfcs_esm_CFCS_DETECTED_DEPENDENCIES = "__CFCS_DETECTED_DEPENDENCIES__";

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var cfcs_esm_extendStatics = function (d, b) {
  cfcs_esm_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };

  return cfcs_esm_extendStatics(d, b);
};

function cfcs_esm_extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  cfcs_esm_extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function cfcs_esm_spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function cfcs_esm_getDetectedStack() {
  // Version issues do not occur when you access the native object in the global.
  Object[cfcs_esm_CFCS_DETECTED_DEPENDENCIES] = Object[cfcs_esm_CFCS_DETECTED_DEPENDENCIES] || {};
  var versionList = Object[cfcs_esm_CFCS_DETECTED_DEPENDENCIES];
  versionList[cfcs_esm_CFCS_DETECTED_DEPENDENCIES_VERSION] = versionList[cfcs_esm_CFCS_DETECTED_DEPENDENCIES_VERSION] || [];
  return versionList[cfcs_esm_CFCS_DETECTED_DEPENDENCIES_VERSION];
}
function cfcs_esm_getCurrentDetected() {
  var stack = cfcs_esm_getDetectedStack();
  return stack[stack.length - 1];
}
function cfcs_esm_detectDependencies(host) {
  var stack = cfcs_esm_getDetectedStack();
  var observers = [];
  var detected = {
    host: host,
    observers: observers,
    push: function (observer) {
      if (host !== observer && observers.indexOf(observer) === -1) {
        observers.push(observer);
      }
    }
  };
  stack.push(detected);
  return detected;
}
function cfcs_esm_endDetectDependencies() {
  var stack = cfcs_esm_getDetectedStack();
  return stack.pop();
}

/**
 * Creates a mutable ref object. You can access the `.current` value and detect the value change through `.subscribe`.
 * @category Reactive
 * @see observe
 */

var dist_cfcs_esm_Observer =
/*#__PURE__*/
function () {
  /**
   *
   */
  function Observer(value) {
    this._emitter = new component_esm();
    this._current = value;
  }

  var __proto = Observer.prototype;
  Object.defineProperty(__proto, "current", {
    /**
     * return the current value.
     */
    get: function () {
      var currentDetected = cfcs_esm_getCurrentDetected();
      currentDetected === null || currentDetected === void 0 ? void 0 : currentDetected.push(this);
      return this._current;
    },
    set: function (value) {
      this._setCurrent(value);
    },
    enumerable: false,
    configurable: true
  });
  /**
   * When the current value changes, the callback function is called.
   */

  __proto.subscribe = function (callback) {
    this.current;

    this._emitter.on("update", callback);

    return this;
  };
  /**
   * Cancel the registered subscription through callback.
   */


  __proto.unsubscribe = function (callback) {
    this._emitter.off("update", callback);

    return this;
  };

  __proto._setCurrent = function (value) {
    var prevValue = this._current;
    var isUpdate = value !== prevValue;
    this._current = value;

    if (isUpdate) {
      this._emitter.trigger("update", value, prevValue);
    }
  };
  /**
   * @hidden
   */


  __proto.toString = function () {
    return "".concat(this.current);
  };
  /**
   * @hidden
   */


  __proto.valueOf = function () {
    return this.current;
  };

  return Observer;
}();

/**
 * @category Reactive
 * @hidden
 */

var cfcs_esm_ComputedObserver =
/*#__PURE__*/
function (_super) {
  cfcs_esm_extends(ComputedObserver, _super);
  /**
   * @description Creates a new computed observer from the values of other observers.
   * It is read-only and if you change the value of the observer used inside the callback, its value will be automatically updated.
   * @param _computedCallback A function for observers to be computed.
   */


  function ComputedObserver(_computedCallback) {
    var _this = _super.call(this) || this;

    _this._computedCallback = _computedCallback;
    _this._registered = [];

    _this._onCheckUpdate = function () {
      _this._setCurrent(_this.current);
    };

    _this._current = _this.current;
    return _this;
  }

  var __proto = ComputedObserver.prototype;
  Object.defineProperty(__proto, "current", {
    get: function () {
      var _this = this;

      cfcs_esm_detectDependencies(this);

      var value = this._computedCallback();

      var results = cfcs_esm_endDetectDependencies();

      this._registered.forEach(function (observer) {
        observer.unsubscribe(_this._onCheckUpdate);
      });

      results.observers.forEach(function (observer) {
        observer.subscribe(_this._onCheckUpdate);
      });
      this._registered = results.observers;
      return value;
    },
    enumerable: false,
    configurable: true
  });
  return ComputedObserver;
}(dist_cfcs_esm_Observer);

function cfcs_esm_injectObserve(prototype, memberName, publicName) {
  if (publicName === void 0) {
    publicName = memberName;
  }

  var nextAttributes = {
    configurable: true,
    get: function () {
      return cfcs_esm_getObserver(this, publicName).current;
    },
    set: function (value) {
      cfcs_esm_getObserver(this, publicName, value).current = value;
    }
  };
  Object.defineProperty(prototype, memberName, nextAttributes);

  if (publicName !== memberName) {
    Object.defineProperty(prototype, publicName, {
      configurable: true,
      get: function () {
        return cfcs_esm_getObserver(this, publicName).current;
      }
    });
  }
}
/**
 * @description `Observe` is a property decorator and converts the property into a `reactive state`. You can detect its status through `.subscribe`.
 * @category Reactive-Decorator
 * @see ReactiveSubscribe
 * @example
* ```ts
import { ReactiveSubscribe, Observe } from "@cfcs/core";

@ReactiveSubscribe
class Component {
  // The public name and state name are the same.
  @Observe value1 = 1;
  // If you want to set public name and private properties separately
  @Observe("value2") _value2 = 1;

  constructor() {
    requestAnimationFrame(() => {
      this.value1 = 2;
    });
  }
}
interface C
```
 */


function cfcs_esm_Observe() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  if (args.length > 1) {
    return cfcs_esm_injectObserve(args[0], args[1]);
  }

  return function (prototype, memberName) {
    return cfcs_esm_injectObserve(prototype, memberName, args[0]);
  };
}
/**
 * @hidden
 */

function cfcs_esm_Reactive() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return cfcs_esm_Observe.apply(void 0, args);
}

/**
 * @hidden
 */

function cfcs_esm_injectReactiveSubscribe(object) {
  object["subscribe"] = function (name, callback) {
    this[name];
    cfcs_esm_getObserver(this, name).subscribe(callback);
  };

  object["unsubscribe"] = function (name, callback) {
    var _this = this;

    if (!name) {
      cfcs_esm_keys(cfcs_esm_getObservers(this)).forEach(function (observerName) {
        _this.unsubscribe(observerName);
      });
      return;
    }

    if (!(name in this)) {
      return;
    }

    cfcs_esm_getObserver(this, name).unsubscribe(callback);
  };
}
/**
 * @description `ReactiveSubscribe` is a class decorator and adds `.subscribe` and `.unsubscribe` methods.
 * @category Reactive-Decorator
 * @see Observe
 * @example
 * ```ts
import { ReactiveSubscribe, Observe } from "@cfcs/core";

@ReactiveSubscribe
class Component {
  @Observe value1 = 1;

  constructor() {
    requestAnimationFrame(() => {
      this.value1 = 2;
    });
  }
}

interface Component extends ReactiveSubscribe<{
  value1: number;
  value2: number;
}> {}

const component = new Component();

// 1
console.log(component.value1);

component.subscribe("value1", nextValue => {
  // When the change event occurs => (2, 2)
  console.log(nextValue, component.value2);
});
```
 */

function cfcs_esm_ReactiveSubscribe(Constructor) {
  var prototype = Constructor.prototype;
  cfcs_esm_injectReactiveSubscribe(prototype);
}

function cfcs_esm_makeReactiveObject(setup, all) {
  var result = cfcs_esm_isFunction(setup) ? setup() : setup;
  var reactiveObject = {};
  cfcs_esm_defineObservers(reactiveObject);
  cfcs_esm_keys(result).forEach(function (name) {
    var value = result[name];

    if (cfcs_esm_isObserver(value)) {
      cfcs_esm_setObserver(reactiveObject, name, value);
    } else {
      cfcs_esm_setObserver(reactiveObject, name, cfcs_esm_observe(value));
    }

    cfcs_esm_Observe(name)(reactiveObject, name);
  });
  cfcs_esm_injectReactiveSubscribe(reactiveObject);
  return reactiveObject;
}
/**
 * @description Make the return value of the corresponding object or function a reactive object.
 * @category Reactive
 * @param setup - The target object or function to which reactive is applied
 * @returns Makes all values into reactive objects.
 * @example
 * ```ts
 * import { reactive } from "@cfcs/core";
 *
 * const obj = reactive({
 *  value1: 1,
 *  value2: 2,
 * });
 *
 * obj.subscribe("value1", value1 => {
 *   console.log(value1);
 * });
 * obj.value1 = 2;
 * ```
 */


function cfcs_esm_reactive(setup) {
  return cfcs_esm_makeReactiveObject(setup);
}
/**
 * @description Make the return value of the corresponding object or function a reactive object.
 * @category Reactive
 * @param setup - The target object or function to which reactive is applied
 * @returns Only the values to which observer is applied are objects to which reactive is applied.
 * @example
 * ```ts
 * import { partialReactive, observe } from "@cfcs/core";
 *
 * const value1 = observe(1);
 * const value2 = observe(2);
 * const obj = partialReactive({
 *  value1,
 *  value2,
 * });
 *
 * obj.subscribe("value1", value1 => {
 *   console.log(value1);
 * });
 * value1.current = 2;
 * ```
 */

function cfcs_esm_partialReactive(setup) {
  return cfcs_esm_makeReactiveObject(setup);
}
/**
 * @description Creates a mutable ref object. You can access the `.current` value and detect the value change through `.subscribe`.
 * @category Reactive
 * @example
 * ```ts
 * import { observe } from "@cfcs/core";
 *
 * const ob1 = observe(1);
 *
 * ob1.subscribe(nextValue => {
 *   console.log(nextValue);
 * });
 *
 * ob1.current = 2;
 * ```
 */

function cfcs_esm_observe(defaultValue) {
  return new dist_cfcs_esm_Observer(defaultValue);
}
/**
 * @hidden
 */

function cfcs_esm_computed(computedCallback) {
  return new cfcs_esm_ComputedObserver(computedCallback);
}

/**
 * @hidden
 */

function cfcs_esm_withReactiveMethods(ref, methods) {
  var obj = {};

  if (!methods) {
    return obj;
  }

  methods.forEach(function (name) {
    obj[name] = function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var current = ref.current || ref.value;
      return current[name].apply(current, args);
    };
  });
  return obj;
}
/**
 * @hidden
 */

function cfcs_esm_defineObservers(instance) {
  var observers = {};
  Object.defineProperty(instance, cfcs_esm_OBSERVERS_PATH, {
    get: function () {
      return observers;
    }
  });
  return observers;
}
/**
 * @hidden
 */

function cfcs_esm_getObservers(instance) {
  var _a, _b;

  if (!instance[cfcs_esm_OBSERVERS_PATH]) {
    cfcs_esm_defineObservers(instance);
  }

  var observers = instance[cfcs_esm_OBSERVERS_PATH];
  var computedList = (_b = (_a = instance === null || instance === void 0 ? void 0 : instance.constructor) === null || _a === void 0 ? void 0 : _a.prototype) === null || _b === void 0 ? void 0 : _b[cfcs_esm_COMPUTED_PATH];

  if (computedList) {
    computedList.forEach(function (name) {
      if (!(name in observers) && name in instance) {
        instance[name];
      }
    });
  }

  return observers;
}
/**
 * @hidden
 */

function cfcs_esm_getObserver(instance, name, defaultValue) {
  var observers = cfcs_esm_getObservers(instance);

  if (!observers[name]) {
    observers[name] = cfcs_esm_observe(defaultValue);
  }

  return observers[name];
}
/**
 * @hidden
 */

function cfcs_esm_setObserver(instance, name, observer) {
  var observers = cfcs_esm_getObservers(instance);
  observers[name] = observer;
}
/**
 * @description Whether that object is an observer instance
 * @category Reactive
 */

function cfcs_esm_isObserver(val) {
  return val && dist_cfcs_esm_isObject(val) && "current" in val && "subscribe" in val && "unsubscribe" in val;
}
/**
 * @description Whether the object is reactive
 * @category Reactive
 */

function cfcs_esm_isReactive(val) {
  return val && !cfcs_esm_isObserver(val) && "subscribe" in val && "unsubscribe" in val;
}

/**
 * @category Reactive
 * @hidden
 */

function cfcs_esm_adaptReactive(adapter, props) {
  var objectAdapter = cfcs_esm_isFunction(adapter) ? {
    setup: adapter
  } : adapter;

  function getProps() {
    var _a, _b, _c, _d, _e;

    return (_e = (_c = (_a = props === null || props === void 0 ? void 0 : props()) !== null && _a !== void 0 ? _a : (_b = objectAdapter.props) === null || _b === void 0 ? void 0 : _b.call(objectAdapter)) !== null && _c !== void 0 ? _c : (_d = objectAdapter.data) === null || _d === void 0 ? void 0 : _d.call(objectAdapter)) !== null && _e !== void 0 ? _e : {};
  }

  var eventEmitter = new component_esm();
  var mountedHooks = [];
  var initHooks = [];
  var destroyHooks = [];
  var onHooks = [];
  var instanceRef = {
    current: null
  };
  var offHooksList = [];
  var initialState = null;
  var eventNames = [];
  var methodNames = [];

  var onMounted = function (callback) {
    mountedHooks.push(callback);
  };

  var onInit = function (callback) {
    initHooks.push(callback);
  };

  var onDestroy = function (callback) {
    destroyHooks.push(callback);
  };

  var on = function (callback) {
    onHooks.push(callback);
  };

  var emit = function (eventName) {
    var params = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      params[_i - 1] = arguments[_i];
    }

    eventEmitter.trigger.apply(eventEmitter, cfcs_esm_spreadArray([eventName], params, false));
  };

  var setInitialState = function (state) {
    initialState = state;
  };

  var setEvents = function (events) {
    eventNames = events;
  };

  var setMethods = function (methods) {
    methodNames = methods;
  };

  if (objectAdapter.setup) {
    instanceRef.current = objectAdapter.setup({
      getProps: getProps,
      setInitialState: setInitialState,
      setEvents: setEvents,
      setMethods: setMethods,
      onMounted: onMounted,
      onDestroy: onDestroy,
      onInit: onInit,
      emit: emit,
      on: on
    }) || null;
  }

  if (objectAdapter.created) {
    instanceRef.current = objectAdapter.created(getProps()) || null;
  }

  if (objectAdapter.events) {
    setEvents(objectAdapter.events);
  }

  if (objectAdapter.state) {
    setInitialState(objectAdapter.state);
  }

  if (objectAdapter.methods) {
    setMethods(objectAdapter.methods);
  }

  if (objectAdapter.mounted) {
    onMounted(objectAdapter.mounted);
  }

  if (objectAdapter.destroy) {
    destroyHooks.push(objectAdapter.destroy);
  }

  if (objectAdapter.init) {
    initHooks.push(objectAdapter.init);
  }

  if (objectAdapter.on) {
    onHooks.push(function (instance, eventName, listener) {
      var off = objectAdapter.on(instance, eventName, listener);
      return function () {
        var _a;

        off && off();
        (_a = objectAdapter.off) === null || _a === void 0 ? void 0 : _a.call(objectAdapter, instance, eventName, listener);
      };
    });
  }

  return {
    events: function () {
      return eventNames;
    },
    state: function () {
      var inst = instanceRef.current;

      if (initialState) {
        return initialState;
      }

      if (inst) {
        var observers_1 = cfcs_esm_getObservers(inst);
        setInitialState(cfcs_esm_keys(observers_1).reduce(function (prev, cur) {
          prev[cur] = observers_1[cur].current;
          return prev;
        }, {}));
      }

      return initialState || {};
    },
    instance: function () {
      return instanceRef.current;
    },
    mounted: function () {
      var props = getProps();
      mountedHooks.forEach(function (hook) {
        instanceRef.current = hook(props, instanceRef.current) || instanceRef.current;
      });
    },
    init: function () {
      // on events
      var instance = instanceRef.current;
      var props = getProps();
      offHooksList = eventNames.map(function (eventName) {
        var listener = function () {
          var _a;

          var params = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
          }

          (_a = eventEmitter).trigger.apply(_a, cfcs_esm_spreadArray([eventName], params, false));
        };

        var instance = instanceRef.current;
        return onHooks.map(function (hook) {
          return hook(instance, eventName, listener);
        }).filter(Boolean);
      }); // init

      initHooks.forEach(function (hook) {
        hook(instance, props);
      });
    },
    destroy: function () {
      // off events
      offHooksList.forEach(function (offHooks) {
        offHooks.forEach(function (hook) {
          hook();
        });
      }); // destroy

      eventEmitter.off();
      var instance = instanceRef.current;
      var props = getProps();
      destroyHooks.forEach(function (hook) {
        hook(instance, props);
      });
    },
    methods: function () {
      return cfcs_esm_withReactiveMethods(instanceRef, methodNames);
    },
    on: function (eventName, listener) {
      eventEmitter.on(eventName, listener);
    },
    off: function (eventName, listener) {
      eventEmitter.off(eventName, listener);
    }
  };
}

/**
 * @description `Computed` is a property decorator.
 * Changes in computed state values are also recognized according to changes in observers used within the getter function.
 * You can detect its status through `.subscribe`.
 * @hidden
 * @category Reactive-Decorator
 * @see ReactiveSubscribe
 * @example
 * ```ts
const ob1 = observe(0);
const ob2 = observe(1);

// When
@ReactiveSubscribe
class TestComputed {
    @Computed
    get ob3() {
        return ob1.current + ob2.current;
    }
}
const inst = new TestComputed();

inst.subscribe("ob3", ob3 => {
  console.log(ob3);
});

ob1.current = 1;
```
 */

function cfcs_esm_Computed(prototype, memberName, attributes) {
  var get = attributes.get;

  function getComputed() {
    var observers = cfcs_esm_getObservers(this);

    if (!(memberName in observers)) {
      observers[memberName] = cfcs_esm_computed(get.bind(this));
    }

    return cfcs_esm_getObserver(this, memberName).current;
  }

  var nextAttributes = {
    configurable: true,
    get: getComputed
  };

  if (cfcs_esm_COMPUTED_PATH in prototype) {
    prototype[cfcs_esm_COMPUTED_PATH] || (prototype[cfcs_esm_COMPUTED_PATH] = []);
    var computedList = prototype[cfcs_esm_COMPUTED_PATH];

    if (computedList.indexOf(memberName) === -1) {
      computedList.push(memberName);
    }
  }

  Object.defineProperty(prototype, memberName, nextAttributes);
  return nextAttributes;
}


//# sourceMappingURL=cfcs.esm.js.map

// CONCATENATED MODULE: ./node_modules/@egjs/imready/dist/imready.esm.js
/*
Copyright (c) NAVER Corp.
name: @egjs/imready
license: MIT
author: NAVER Corp.
repository: https://github.com/naver/egjs-imready
version: 1.4.1
*/



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var imready_esm_extendStatics = function (d, b) {
  imready_esm_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return imready_esm_extendStatics(d, b);
};
function imready_esm_extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  imready_esm_extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var imready_esm_assign = function () {
  imready_esm_assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return imready_esm_assign.apply(this, arguments);
};

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
}

/*
egjs-imready
Copyright (c) 2020-present NAVER Corp.
MIT license
*/
var isWindow = typeof window !== "undefined";
var ua = isWindow ? window.navigator.userAgent : "";
var SUPPORT_COMPUTEDSTYLE = isWindow ? !!("getComputedStyle" in window) : false;
var IS_IE = /MSIE|Trident|Windows Phone|Edge/.test(ua);
var SUPPORT_ADDEVENTLISTENER = isWindow ? !!("addEventListener" in document) : false;
var WIDTH = "width";
var HEIGHT = "height";
var PROPS = ["prefix", "loaders"];
var EVENTS = ["preReadyElement", "readyElement", "error", "preReady", "ready"];

function getAttribute(el, name) {
  return el.getAttribute(name) || "";
}
function imready_esm_toArray(arr) {
  return [].slice.call(arr);
}
function hasSizeAttribute(target, prefix) {
  if (prefix === void 0) {
    prefix = "data-";
  }
  return !!target.getAttribute(prefix + "width");
}
function hasLoadingAttribute(target, prefix) {
  if (prefix === void 0) {
    prefix = "data-";
  }
  return "loading" in target && target.getAttribute("loading") === "lazy" || !!target.getAttribute(prefix + "lazy");
}
function hasSkipAttribute(target, prefix) {
  if (prefix === void 0) {
    prefix = "data-";
  }
  return !!target.getAttribute(prefix + "skip");
}
function addEvent(element, type, handler) {
  if (SUPPORT_ADDEVENTLISTENER) {
    element.addEventListener(type, handler, false);
  } else if (element.attachEvent) {
    element.attachEvent("on" + type, handler);
  } else {
    element["on" + type] = handler;
  }
}
function removeEvent(element, type, handler) {
  if (element.removeEventListener) {
    element.removeEventListener(type, handler, false);
  } else if (element.detachEvent) {
    element.detachEvent("on" + type, handler);
  } else {
    element["on" + type] = null;
  }
}
function imready_esm_innerWidth(el) {
  return getSize(el, "Width");
}
function imready_esm_innerHeight(el) {
  return getSize(el, "Height");
}
function getStyles(el) {
  return (SUPPORT_COMPUTEDSTYLE ? window.getComputedStyle(el) : el.currentStyle) || {};
}
function getSize(el, name) {
  var size = el["client" + name] || el["offset" + name];
  return parseFloat(size || getStyles(el)[name.toLowerCase()]) || 0;
}
function getContentElements(element, tags, prefix) {
  var skipElements = imready_esm_toArray(element.querySelectorAll(__spreadArrays(["[" + prefix + "skip] [" + prefix + "width]"], tags.map(function (tag) {
    return ["[" + prefix + "skip] " + tag, tag + "[" + prefix + "skip]", "[" + prefix + "width] " + tag].join(", ");
  })).join(", ")));
  return imready_esm_toArray(element.querySelectorAll("[" + prefix + "width], " + tags.join(", "))).filter(function (el) {
    return skipElements.indexOf(el) === -1;
  });
}

/*
egjs-imready
Copyright (c) 2020-present NAVER Corp.
MIT license
*/
var imready_esm_elements = [];
function addAutoSizer(element, prefix) {
  !imready_esm_elements.length && addEvent(window, "resize", resizeAllAutoSizers);
  element.__PREFIX__ = prefix;
  imready_esm_elements.push(element);
  resize(element);
}
function removeAutoSizer(element, prefix) {
  var index = imready_esm_elements.indexOf(element);
  if (index < 0) {
    return;
  }
  var fixed = getAttribute(element, prefix + "fixed");
  delete element.__PREFIX__;
  element.style[fixed === HEIGHT ? WIDTH : HEIGHT] = "";
  imready_esm_elements.splice(index, 1);
  !imready_esm_elements.length && removeEvent(window, "resize", resizeAllAutoSizers);
}
function resize(element, prefix) {
  if (prefix === void 0) {
    prefix = "data-";
  }
  var elementPrefix = element.__PREFIX__ || prefix;
  var dataWidth = parseInt(getAttribute(element, "" + elementPrefix + WIDTH), 10) || 0;
  var dataHeight = parseInt(getAttribute(element, "" + elementPrefix + HEIGHT), 10) || 0;
  var fixed = getAttribute(element, elementPrefix + "fixed");
  if (fixed === HEIGHT) {
    var size = imready_esm_innerHeight(element) || dataHeight;
    element.style[WIDTH] = dataWidth / dataHeight * size + "px";
  } else {
    var size = imready_esm_innerWidth(element) || dataWidth;
    element.style[HEIGHT] = dataHeight / dataWidth * size + "px";
  }
}
function resizeAllAutoSizers() {
  imready_esm_elements.forEach(function (element) {
    resize(element);
  });
}

var Loader = /*#__PURE__*/function (_super) {
  imready_esm_extends(Loader, _super);
  function Loader(element, options) {
    if (options === void 0) {
      options = {};
    }
    var _this = _super.call(this) || this;
    _this.isReady = false;
    _this.isPreReady = false;
    _this.hasDataSize = false;
    _this.hasLoading = false;
    _this.isSkip = false;
    _this.onCheck = function (e) {
      _this.clear();
      if (e && e.type === "error") {
        _this.onError(_this.element);
      }
      if (_this.hasLoading && _this.checkElement()) {
        // I'm not ready
        return;
      }
      // I'm pre-ready and ready!
      var withPreReady = !_this.hasDataSize && !_this.hasLoading;
      _this.onReady(withPreReady);
    };
    _this.options = imready_esm_assign({
      prefix: "data-"
    }, options);
    _this.element = element;
    var prefix = _this.options.prefix;
    _this.hasDataSize = hasSizeAttribute(element, prefix);
    _this.isSkip = hasSkipAttribute(element, prefix);
    _this.hasLoading = hasLoadingAttribute(element, prefix);
    return _this;
  }
  var __proto = Loader.prototype;
  __proto.check = function () {
    if (this.isSkip || !this.checkElement()) {
      // I'm Ready
      this.onAlreadyReady(true);
      return false;
    }
    if (this.hasDataSize) {
      addAutoSizer(this.element, this.options.prefix);
    }
    if (this.hasDataSize || this.hasLoading) {
      // I'm Pre Ready
      this.onAlreadyPreReady();
    }
    // Wati Pre Ready, Ready
    return true;
  };
  __proto.addEvents = function () {
    var _this = this;
    var element = this.element;
    this.constructor.EVENTS.forEach(function (name) {
      addEvent(element, name, _this.onCheck);
    });
  };
  __proto.clear = function () {
    var _this = this;
    var element = this.element;
    this.constructor.EVENTS.forEach(function (name) {
      removeEvent(element, name, _this.onCheck);
    });
    this.removeAutoSizer();
  };
  __proto.destroy = function () {
    this.clear();
    this.off();
  };
  __proto.removeAutoSizer = function () {
    if (this.hasDataSize) {
      // I'm already ready.
      var prefix = this.options.prefix;
      removeAutoSizer(this.element, prefix);
    }
  };
  __proto.onError = function (target) {
    this.trigger("error", {
      element: this.element,
      target: target
    });
  };
  __proto.onPreReady = function () {
    if (this.isPreReady) {
      return;
    }
    this.isPreReady = true;
    this.trigger("preReady", {
      element: this.element,
      hasLoading: this.hasLoading,
      isSkip: this.isSkip
    });
  };
  __proto.onReady = function (withPreReady) {
    if (this.isReady) {
      return;
    }
    withPreReady = !this.isPreReady && withPreReady;
    if (withPreReady) {
      this.isPreReady = true;
    }
    this.removeAutoSizer();
    this.isReady = true;
    this.trigger("ready", {
      element: this.element,
      withPreReady: withPreReady,
      hasLoading: this.hasLoading,
      isSkip: this.isSkip
    });
  };
  __proto.onAlreadyError = function (target) {
    var _this = this;
    setTimeout(function () {
      _this.onError(target);
    });
  };
  __proto.onAlreadyPreReady = function () {
    var _this = this;
    setTimeout(function () {
      _this.onPreReady();
    });
  };
  __proto.onAlreadyReady = function (withPreReady) {
    var _this = this;
    setTimeout(function () {
      _this.onReady(withPreReady);
    });
  };
  Loader.EVENTS = [];
  return Loader;
}(component_esm);

var ElementLoader = /*#__PURE__*/function (_super) {
  imready_esm_extends(ElementLoader, _super);
  function ElementLoader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  var __proto = ElementLoader.prototype;
  __proto.setHasLoading = function (hasLoading) {
    this.hasLoading = hasLoading;
  };
  __proto.check = function () {
    if (this.isSkip) {
      // I'm Ready
      this.onAlreadyReady(true);
      return false;
    }
    if (this.hasDataSize) {
      addAutoSizer(this.element, this.options.prefix);
      this.onAlreadyPreReady();
    } else {
      // has not data size
      this.trigger("requestChildren");
    }
    return true;
  };
  __proto.checkElement = function () {
    return true;
  };
  __proto.destroy = function () {
    this.clear();
    this.trigger("requestDestroy");
    this.off();
  };
  __proto.onAlreadyPreReady = function () {
    // has data size
    _super.prototype.onAlreadyPreReady.call(this);
    this.trigger("reqeustReadyChildren");
  };
  ElementLoader.EVENTS = [];
  return ElementLoader;
}(Loader);

/**
 * @alias eg.ImReady
 * @extends eg.Component
 */
var imready_esm_ImReadyManager = /*#__PURE__*/function (_super) {
  imready_esm_extends(ImReadyManager, _super);
  /**
   * @param - ImReady's options
   */
  function ImReadyManager(options) {
    if (options === void 0) {
      options = {};
    }
    var _this = _super.call(this) || this;
    _this.readyCount = 0;
    _this.preReadyCount = 0;
    _this.totalCount = 0;
    _this.totalErrorCount = 0;
    _this.isPreReadyOver = true;
    _this.elementInfos = [];
    _this.options = imready_esm_assign({
      loaders: {},
      prefix: "data-"
    }, options);
    return _this;
  }
  /**
   * Checks whether elements are in the ready state.
   * @ko 엘리먼트가 준비 상태인지 체크한다.
   * @elements - Elements to check ready status. <ko> 준비 상태를 체크할 엘리먼트들.</ko>
   * @example
     * ```html
     * <div>
     *    <img src="./1.jpg" data-width="1280" data-height="853" style="width:100%"/>
     *    <img src="./2.jpg" data-width="1280" data-height="853"/>
     *    <img src="ERR" data-width="1280" data-height="853"/>
     * </div>
     * ```
     * ## Javascript
     * ```js
     * import ImReady from "@egjs/imready";
     *
     * const im = new ImReady(); // umd: eg.ImReady
     * im.check(document.querySelectorAll("img")).on({
     *   preReadyElement: e => {
     *     // 1, 3
     *     // 2, 3
     *     // 3, 3
     *     console.log(e.preReadyCount, e.totalCount),
     *   },
     * });
     * ```
   */
  var __proto = ImReadyManager.prototype;
  __proto.check = function (elements) {
    var _this = this;
    var prefix = this.options.prefix;
    this.clear();
    this.elementInfos = imready_esm_toArray(elements).map(function (element, index) {
      var loader = _this.getLoader(element, {
        prefix: prefix
      });
      loader.check();
      loader.on("error", function (e) {
        _this.onError(index, e.target);
      }).on("preReady", function (e) {
        var info = _this.elementInfos[index];
        info.hasLoading = e.hasLoading;
        info.isSkip = e.isSkip;
        var isPreReady = _this.checkPreReady(index);
        _this.onPreReadyElement(index);
        isPreReady && _this.onPreReady();
      }).on("ready", function (_a) {
        var withPreReady = _a.withPreReady,
          hasLoading = _a.hasLoading,
          isSkip = _a.isSkip;
        var info = _this.elementInfos[index];
        info.hasLoading = hasLoading;
        info.isSkip = isSkip;
        var isPreReady = withPreReady && _this.checkPreReady(index);
        var isReady = _this.checkReady(index);
        // Pre-ready and ready occur simultaneously
        withPreReady && _this.onPreReadyElement(index);
        _this.onReadyElement(index);
        isPreReady && _this.onPreReady();
        isReady && _this.onReady();
      });
      return {
        loader: loader,
        element: element,
        hasLoading: false,
        hasError: false,
        isPreReady: false,
        isReady: false,
        isSkip: false
      };
    });
    var length = this.elementInfos.length;
    this.totalCount = length;
    if (!length) {
      setTimeout(function () {
        _this.onPreReady();
        _this.onReady();
      });
    }
    return this;
  };
  /**
   * Gets the total count of elements to be checked.
   * @ko 체크하는 element의 총 개수를 가져온다.
   */
  __proto.getTotalCount = function () {
    return this.totalCount;
  };
  /**
   * Whether the elements are all pre-ready. (all sizes are known)
   * @ko 엘리먼트들이 모두 사전 준비가 됐는지 (사이즈를 전부 알 수 있는지) 여부.
   */
  __proto.isPreReady = function () {
    return this.elementInfos.every(function (info) {
      return info.isPreReady;
    });
  };
  /**
   * Whether the elements are all ready.
   * @ko 엘리먼트들이 모두 준비가 됐는지 여부.
   */
  __proto.isReady = function () {
    return this.elementInfos.every(function (info) {
      return info.isReady;
    });
  };
  /**
   * Whether an error has occurred in the elements in the current state.
   * @ko 현재 상태에서 엘리먼트들이 에러가 발생했는지 여부.
   */
  __proto.hasError = function () {
    return this.totalErrorCount > 0;
  };
  /**
   * Clears events of elements being checked.
   * @ko 체크 중인 엘리먼트들의 이벤트를 해제 한다.
   */
  __proto.clear = function () {
    this.isPreReadyOver = false;
    this.totalCount = 0;
    this.preReadyCount = 0;
    this.readyCount = 0;
    this.totalErrorCount = 0;
    this.elementInfos.forEach(function (info) {
      if (info.loader) {
        info.loader.destroy();
      }
    });
    this.elementInfos = [];
  };
  /**
   * Destory all events.
   * @ko 모든 이벤트를 해제 한다.
   */
  __proto.destroy = function () {
    this.clear();
    this.off();
  };
  __proto.getLoader = function (element, options) {
    var _this = this;
    var tagName = element.tagName.toLowerCase();
    var loaders = this.options.loaders;
    var prefix = options.prefix;
    var tags = Object.keys(loaders);
    if (loaders[tagName]) {
      return new loaders[tagName](element, options);
    }
    var loader = new ElementLoader(element, options);
    var children = imready_esm_toArray(element.querySelectorAll(tags.join(", ")));
    loader.setHasLoading(children.some(function (el) {
      return hasLoadingAttribute(el, prefix);
    }));
    var withPreReady = false;
    var childrenImReady = this.clone().on("error", function (e) {
      loader.onError(e.target);
    }).on("ready", function () {
      loader.onReady(withPreReady);
    });
    loader.on("requestChildren", function () {
      // has not data size
      var contentElements = getContentElements(element, tags, _this.options.prefix);
      childrenImReady.check(contentElements).on("preReady", function (e) {
        withPreReady = e.isReady;
        if (!withPreReady) {
          loader.onPreReady();
        }
      });
    }).on("reqeustReadyChildren", function () {
      // has data size
      // loader call preReady
      // check only video, image elements
      childrenImReady.check(children);
    }).on("requestDestroy", function () {
      childrenImReady.destroy();
    });
    return loader;
  };
  __proto.clone = function () {
    return new ImReadyManager(imready_esm_assign({}, this.options));
  };
  __proto.checkPreReady = function (index) {
    this.elementInfos[index].isPreReady = true;
    ++this.preReadyCount;
    if (this.preReadyCount < this.totalCount) {
      return false;
    }
    return true;
  };
  __proto.checkReady = function (index) {
    this.elementInfos[index].isReady = true;
    ++this.readyCount;
    if (this.readyCount < this.totalCount) {
      return false;
    }
    return true;
  };
  __proto.onError = function (index, target) {
    var info = this.elementInfos[index];
    info.hasError = true;
    /**
     * An event occurs if the image, video fails to load.
     * @ko 이미지, 비디오가 로딩에 실패하면 이벤트가 발생한다.
     * @event eg.ImReady#error
     * @param {eg.ImReady.OnError} e - The object of data to be sent to an event <ko>이벤트에 전달되는 데이터 객체</ko>
     * @example
     * ```html
     * <div>
     *    <img src="./1.jpg" data-width="1280" data-height="853" style="width:100%"/>
     *    <img src="./2.jpg"/>
     *    <img src="ERR"/>
     * </div>
     * ```
     * ## Javascript
     * ```js
     * import ImReady from "@egjs/imready";
     *
     * const im = new ImReady(); // umd: eg.ImReady
     * im.check([document.querySelector("div")]).on({
     *   error: e => {
     *     // <div>...</div>, 0, <img src="ERR"/>
     *     console.log(e.element, e.index, e.target),
     *   },
     * });
     * ```
     */
    this.trigger(new ComponentEvent$1("error", {
      element: info.element,
      index: index,
      target: target,
      errorCount: this.getErrorCount(),
      totalErrorCount: ++this.totalErrorCount
    }));
  };
  __proto.onPreReadyElement = function (index) {
    var info = this.elementInfos[index];
    /**
     * An event occurs when the element is pre-ready (when the loading attribute is applied or the size is known)
     * @ko 해당 엘리먼트가 사전 준비되었을 때(loading 속성이 적용되었거나 사이즈를 알 수 있을 때) 이벤트가 발생한다.
     * @event eg.ImReady#preReadyElement
     * @param {eg.ImReady.OnPreReadyElement} e - The object of data to be sent to an event <ko>이벤트에 전달되는 데이터 객체</ko>
     * @example
     * ```html
     * <div>
     *    <img src="./1.jpg" data-width="1280" data-height="853" style="width:100%"/>
     *    <img src="./2.jpg" data-width="1280" data-height="853"/>
     *    <img src="ERR" data-width="1280" data-height="853"/>
     * </div>
     * ```
     * ## Javascript
     * ```js
     * import ImReady from "@egjs/imready";
     *
     * const im = new ImReady(); // umd: eg.ImReady
     * im.check(document.querySelectorAll("img")).on({
     *   preReadyElement: e => {
     *     // 1, 3
     *     // 2, 3
     *     // 3, 3
     *     console.log(e.preReadyCount, e.totalCount),
     *   },
     * });
     * ```
     */
    this.trigger(new ComponentEvent$1("preReadyElement", {
      element: info.element,
      index: index,
      preReadyCount: this.preReadyCount,
      readyCount: this.readyCount,
      totalCount: this.totalCount,
      isPreReady: this.isPreReady(),
      isReady: this.isReady(),
      hasLoading: info.hasLoading,
      isSkip: info.isSkip
    }));
  };
  __proto.onPreReady = function () {
    this.isPreReadyOver = true;
    /**
     * An event occurs when all element are pre-ready (When all elements have the loading attribute applied or the size is known)
     * @ko 모든 엘리먼트들이 사전 준비된 경우 (모든 엘리먼트들이 loading 속성이 적용되었거나 사이즈를 알 수 있는 경우) 이벤트가 발생한다.
     * @event eg.ImReady#preReady
     * @param {eg.ImReady.OnPreReady} e - The object of data to be sent to an event <ko>이벤트에 전달되는 데이터 객체</ko>
     * @example
     * ```html
     * <div>
     *    <img src="./1.jpg" data-width="1280" data-height="853" style="width:100%"/>
     *    <img src="./2.jpg" data-width="1280" data-height="853"/>
     *    <img src="ERR" data-width="1280" data-height="853"/>
     * </div>
     * ```
     * ## Javascript
     * ```js
     * import ImReady from "@egjs/imready";
     *
     * const im = new ImReady(); // umd: eg.ImReady
     * im.check(document.querySelectorAll("img")).on({
     *   preReady: e => {
     *     // 0, 3
     *     console.log(e.readyCount, e.totalCount),
     *   },
     * });
     * ```
     */
    this.trigger(new ComponentEvent$1("preReady", {
      readyCount: this.readyCount,
      totalCount: this.totalCount,
      isReady: this.isReady(),
      hasLoading: this.hasLoading()
    }));
  };
  __proto.onReadyElement = function (index) {
    var info = this.elementInfos[index];
    /**
     * An event occurs when the element is ready
     * @ko 해당 엘리먼트가 준비가 되었을 때 이벤트가 발생한다.
     * @event eg.ImReady#readyElement
     * @param {eg.ImReady.OnReadyElement} e - The object of data to be sent to an event <ko>이벤트에 전달되는 데이터 객체</ko>
     * @example
     * ```html
     * <div>
     *    <img src="./1.jpg" data-width="1280" data-height="853" style="width:100%"/>
     *    <img src="./2.jpg" data-width="1280" data-height="853"/>
     *    <img src="ERR" data-width="1280" data-height="853"/>
     * </div>
     * ```
     * ## Javascript
     * ```js
     * import ImReady from "@egjs/imready";
     *
     * const im = new ImReady(); // umd: eg.ImReady
     * im.check(document.querySelectorAll("img")).on({
     *   readyElement: e => {
     *     // 1, 0, false, 3
     *     // 2, 1, false, 3
     *     // 3, 2, true, 3
     *     console.log(e.readyCount, e.index, e.hasError, e.totalCount),
     *   },
     * });
     * ```
     */
    this.trigger(new ComponentEvent$1("readyElement", {
      index: index,
      element: info.element,
      hasError: info.hasError,
      errorCount: this.getErrorCount(),
      totalErrorCount: this.totalErrorCount,
      preReadyCount: this.preReadyCount,
      readyCount: this.readyCount,
      totalCount: this.totalCount,
      isPreReady: this.isPreReady(),
      isReady: this.isReady(),
      hasLoading: info.hasLoading,
      isPreReadyOver: this.isPreReadyOver,
      isSkip: info.isSkip
    }));
  };
  __proto.onReady = function () {
    /**
     * An event occurs when all element are ready
     * @ko 모든 엘리먼트들이 준비된 경우 이벤트가 발생한다.
     * @event eg.ImReady#ready
     * @param {eg.ImReady.OnReady} e - The object of data to be sent to an event <ko>이벤트에 전달되는 데이터 객체</ko>
     * @example
     * ```html
     * <div>
     *    <img src="./1.jpg" data-width="1280" data-height="853" style="width:100%"/>
     *    <img src="./2.jpg" data-width="1280" data-height="853"/>
     *    <img src="ERR" data-width="1280" data-height="853"/>
     * </div>
     * ```
     * ## Javascript
     * ```js
     * import ImReady from "@egjs/imready";
     *
     * const im = new ImReady(); // umd: eg.ImReady
     * im.check(document.querySelectorAll("img")).on({
     *   preReady: e => {
     *     // 0, 3
     *     console.log(e.readyCount, e.totalCount),
     *   },
     *   ready: e => {
     *     // 1, 3
     *     console.log(e.errorCount, e.totalCount),
     *   },
     * });
     * ```
     */
    this.trigger(new ComponentEvent$1("ready", {
      errorCount: this.getErrorCount(),
      totalErrorCount: this.totalErrorCount,
      totalCount: this.totalCount
    }));
  };
  __proto.getErrorCount = function () {
    return this.elementInfos.filter(function (info) {
      return info.hasError;
    }).length;
  };
  __proto.hasLoading = function () {
    return this.elementInfos.some(function (info) {
      return info.hasLoading;
    });
  };
  return ImReadyManager;
}(component_esm);

var ImageLoader = /*#__PURE__*/function (_super) {
  imready_esm_extends(ImageLoader, _super);
  function ImageLoader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  var __proto = ImageLoader.prototype;
  __proto.checkElement = function () {
    var element = this.element;
    var src = element.getAttribute("src");
    if (element.complete) {
      if (src) {
        // complete
        if (!element.naturalWidth) {
          this.onAlreadyError(element);
        }
        return false;
      } else {
        // Using an external lazy loading module
        this.onAlreadyPreReady();
      }
    }
    this.addEvents();
    IS_IE && element.setAttribute("src", src);
    return true;
  };
  ImageLoader.EVENTS = ["load", "error"];
  return ImageLoader;
}(Loader);

var VideoLoader = /*#__PURE__*/function (_super) {
  imready_esm_extends(VideoLoader, _super);
  function VideoLoader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  var __proto = VideoLoader.prototype;
  __proto.checkElement = function () {
    var element = this.element;
    // HAVE_NOTHING: 0, no information whether or not the audio/video is ready
    // HAVE_METADATA: 1, HAVE_METADATA - metadata for the audio/video is ready
    // HAVE_CURRENT_DATA: 2, data for the current playback position is available, but not enough data to play next frame/millisecond
    // HAVE_FUTURE_DATA: 3, data for the current and at least the next frame is available
    // HAVE_ENOUGH_DATA: 4, enough data available to start playing
    if (element.readyState >= 1) {
      return false;
    }
    if (element.error) {
      this.onAlreadyError(element);
      return false;
    }
    this.addEvents();
    return true;
  };
  VideoLoader.EVENTS = ["loadedmetadata", "error"];
  return VideoLoader;
}(Loader);

var ImReady = /*#__PURE__*/function (_super) {
  imready_esm_extends(ImReady, _super);
  function ImReady(options) {
    if (options === void 0) {
      options = {};
    }
    return _super.call(this, imready_esm_assign({
      loaders: {
        img: ImageLoader,
        video: VideoLoader
      }
    }, options)) || this;
  }
  return ImReady;
}(imready_esm_ImReadyManager);

var REACTIVE_IMREADY = function (_a) {
  var setEvents = _a.setEvents,
    setMethods = _a.setMethods,
    on = _a.on,
    onInit = _a.onInit,
    onDestroy = _a.onDestroy,
    getProps = _a.getProps;
  setEvents(EVENTS);
  setMethods(["add"]);
  var children = [];
  var reactiveImReady = cfcs_esm_reactive({
    preReadyCount: 0,
    readyCount: 0,
    errorCount: 0,
    totalErrorCount: 0,
    totalCount: 0,
    isPreReady: false,
    isReady: false,
    hasError: false,
    isPreReadyOver: false,
    add: function (element) {
      children.push(element);
    }
  });
  var props = getProps() || {};
  var imReady = new ImReady(props);
  imReady.on("error", function (e) {
    reactiveImReady.hasError = true;
    reactiveImReady.errorCount = e.errorCount;
    reactiveImReady.totalErrorCount = e.totalErrorCount;
  }).on("preReadyElement", function (e) {
    reactiveImReady.preReadyCount = e.preReadyCount;
  }).on("readyElement", function (e) {
    reactiveImReady.readyCount = e.readyCount;
    reactiveImReady.isPreReadyOver = e.isPreReadyOver;
  }).on("preReady", function () {
    reactiveImReady.isPreReady = true;
  }).on("ready", function () {
    reactiveImReady.isReady = true;
  });
  on(function (_, name, callback) {
    imReady.on(name, callback);
    return function () {
      imReady.off(name, callback);
    };
  });
  onInit(function () {
    var selector = props === null || props === void 0 ? void 0 : props.selector;
    var checkedElements = [];
    children.forEach(function (child) {
      if (!child) {
        return;
      }
      if (cfcs_esm_isString(child)) {
        checkedElements = __spreadArrays(checkedElements, imready_esm_toArray(document.querySelectorAll(child)));
      } else if (child instanceof Element) {
        checkedElements.push(child);
      } else if ("value" in child || "current" in child) {
        var element = child.value || child.current;
        if (element) {
          checkedElements.push(element);
        }
      }
    });
    if (selector) {
      checkedElements = checkedElements.reduce(function (prev, cur) {
        return __spreadArrays(prev, [].slice.call(cur.querySelectorAll(selector)));
      }, []);
    }
    reactiveImReady.totalCount = checkedElements.length;
    imReady.check(checkedElements);
  });
  onDestroy(function () {
    imReady.destroy();
  });
  return reactiveImReady;
};

/*
egjs-imready
Copyright (c) 2020-present NAVER Corp.
MIT license
*/

/* harmony default export */ var imready_esm = (ImReady);

//# sourceMappingURL=imready.esm.js.map

// CONCATENATED MODULE: ./node_modules/@egjs/flicking/dist/flicking.esm.js
/*
Copyright (c) 2015-present NAVER Corp.
name: @egjs/flicking
license: MIT
author: NAVER Corp.
repository: https://github.com/naver/egjs-flicking
version: 4.10.8
*/




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var flicking_esm_extendStatics = function (d, b) {
  flicking_esm_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return flicking_esm_extendStatics(d, b);
};
function flicking_esm_extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  flicking_esm_extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var flicking_esm_assign = function () {
  flicking_esm_assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return flicking_esm_assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function flicking_esm_values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function flicking_esm_read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}

/** @deprecated */
function flicking_esm_spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(flicking_esm_read(arguments[i]));
  return ar;
}

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/**
 * Error codes of {@link FlickingError}. Below are the conditions where each error code occurs.
 * @ko {@link FlickingError}의 에러 코드. 아래는 각각의 에러 코드가 발생하는 조건입니다.
 * @name ERROR_CODE
 * @constant
 * @type object
 * @property {number} WRONG_TYPE Parameter type is wrong<ko>패러미터의 타입이 잘못되었을 경우</ko>
 * @property {number} ELEMENT_NOT_FOUND Element is not found inside page with the given CSS selector<ko>주어진 CSS selector로 페이지 내에서 해당 엘리먼트를 찾지 못했을 경우</ko>
 * @property {number} VAL_MUST_NOT_NULL Expected non-null value, but given `null` or `undefined`<ko>값을 기대했으나, `null`이나 `undefined`를 받은 경우</ko>
 * @property {number} NOT_ATTACHED_TO_FLICKING When Flicking's component is not initialized (i.e. {@link Flicking#init} is not called)<ko>Flicking 내부 컴포넌트가 초기화되지 않은 경우 ({@link Flicking#init}이 호출되지 않은 경우)</ko>
 * @property {number} WRONG_OPTION One of the options is wrong<ko>옵션들 중 잘못된 값이 있을 때</ko>
 * @property {number} INDEX_OUT_OF_RANGE When the given index is out of possible range<ko>인덱스가 주어진 범위를 벗어난 경우</ko>
 * @property {number} POSITION_NOT_REACHABLE When {@link Control#moveToPosition}'s position parameter is out of possible range.<ko>{@link Control#moveToPosition}의 `position` 패러미터가 도달 가능한 범위를 벗어난 경우</ko>
 * @property {number} TRANSFORM_NOT_SUPPORTED CSS `transform` property is not available(<=IE8) <ko>CSS `transform` 속성을 사용할 수 없는 경우(<=IE8)</ko>
 * @property {number} STOP_CALLED_BY_USER When the event's `stop()` is called by user.<ko>사용자에 의해 이벤트의 `stop()`이 호출된 경우</ko>
 * @property {number} ANIMATION_INTERRUPTED When the animation is interrupted by user.<ko>사용자에 의해 애니메이션이 중단된 경우</ko>
 * @property {number} ANIMATION_ALREADY_PLAYING When the animation is already playing.<ko>현재 애니메이션이 이미 진행중인 경우</ko>
 * @property {number} NOT_ALLOWED_IN_FRAMEWORK When the non-allowed method is called from frameworks (React, Angular, Vue...)
 * <ko>프레임워크(React, Angular, Vue ...)에서 사용 불가능한 메소드를 호출했을 경우</ko>
 * @property {number} NOT_INITIALIZED When the {@link Flicking#init} is not called before but is needed<ko>{@link Flicking#init}의 호출이 필요하나, 아직 호출되지 않았을 경우</ko>
 * @property {number} NO_ACTIVE When there're no active panel that flicking has selected. This may be due to the absence of any panels<ko>현재 Flicking이 선택한 패널이 없을 경우. 일반적으로 패널이 하나도 없는 경우에 발생할 수 있습니다</ko>
 * @property {number} NOT_ALLOWED_IN_VIRTUAL When the non-allowed method is called while the virtual option is enabled<ko>virtual 옵션이 활성화된 상태에서 사용 불가능한 메소드가 호출되었을 경우</ko>
 */
var CODE = {
  WRONG_TYPE: 0,
  ELEMENT_NOT_FOUND: 1,
  VAL_MUST_NOT_NULL: 2,
  NOT_ATTACHED_TO_FLICKING: 3,
  WRONG_OPTION: 4,
  INDEX_OUT_OF_RANGE: 5,
  POSITION_NOT_REACHABLE: 6,
  TRANSFORM_NOT_SUPPORTED: 7,
  STOP_CALLED_BY_USER: 8,
  ANIMATION_INTERRUPTED: 9,
  ANIMATION_ALREADY_PLAYING: 10,
  NOT_ALLOWED_IN_FRAMEWORK: 11,
  NOT_INITIALIZED: 12,
  NO_ACTIVE: 13,
  NOT_ALLOWED_IN_VIRTUAL: 14
};
var MESSAGE = {
  WRONG_TYPE: function (wrongVal, correctTypes) {
    return wrongVal + "(" + typeof wrongVal + ") is not a " + correctTypes.map(function (type) {
      return "\"" + type + "\"";
    }).join(" or ") + ".";
  },
  ELEMENT_NOT_FOUND: function (selector) {
    return "Element with selector \"" + selector + "\" not found.";
  },
  VAL_MUST_NOT_NULL: function (val, name) {
    return name + " should be provided. Given: " + val;
  },
  NOT_ATTACHED_TO_FLICKING: "This module is not attached to the Flicking instance. \"init()\" should be called first.",
  WRONG_OPTION: function (optionName, val) {
    return "Option \"" + optionName + "\" is not in correct format, given: " + val;
  },
  INDEX_OUT_OF_RANGE: function (val, min, max) {
    return "Index \"" + val + "\" is out of range: should be between " + min + " and " + max + ".";
  },
  POSITION_NOT_REACHABLE: function (position) {
    return "Position \"" + position + "\" is not reachable.";
  },
  TRANSFORM_NOT_SUPPORTED: "Browser does not support CSS transform.",
  STOP_CALLED_BY_USER: "Event stop() is called by user.",
  ANIMATION_INTERRUPTED: "Animation is interrupted by user input.",
  ANIMATION_ALREADY_PLAYING: "Animation is already playing.",
  NOT_ALLOWED_IN_FRAMEWORK: "This behavior is not allowed in the frameworks like React, Vue, or Angular.",
  NOT_INITIALIZED: "Flicking is not initialized yet, call init() first.",
  NO_ACTIVE: "There's no active panel that Flicking has selected. This may be due to the absence of any panels.",
  NOT_ALLOWED_IN_VIRTUAL: "This behavior is not allowed when the virtual option is enabled"
};

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
/**
 * Event type object with event name strings of {@link Flicking}
 * @ko {@link Flicking}의 이벤트 이름 문자열들을 담은 객체
 * @type {object}
 * @property {"holdStart"} HOLD_START holdStart event<ko>holdStart 이벤트</ko>
 * @property {"holdEnd"} HOLD_END holdEnd event<ko>holdEnd 이벤트</ko>
 * @property {"moveStart"} MOVE_START moveStart event<ko>moveStart 이벤트</ko>
 * @property {"move"} MOVE move event<ko>move 이벤트</ko>
 * @property {"moveEnd"} MOVE_END moveEnd event<ko>moveEnd 이벤트</ko>
 * @property {"willChange"} WILL_CHANGE willChange event<ko>willChange 이벤트</ko>
 * @property {"changed"} CHANGED changed event<ko>changed 이벤트</ko>
 * @property {"willRestore"} WILL_RESTORE willRestore event<ko>willRestore 이벤트</ko>
 * @property {"restored"} RESTORED restored event<ko>restored 이벤트</ko>
 * @property {"select"} SELECT select event<ko>select 이벤트</ko>
 * @property {"needPanel"} NEED_PANEL needPanel event<ko>needPanel 이벤트</ko>
 * @property {"panelChange"} PANEL_CHANGE panelChange event<ko>panelChange 이벤트</ko>
 * @example
 * ```ts
 * import { EVENTS } from "@egjs/flicking";
 * EVENTS.MOVE_START; // "moveStart"
 * ```
 */
var flicking_esm_EVENTS = {
  READY: "ready",
  BEFORE_RESIZE: "beforeResize",
  AFTER_RESIZE: "afterResize",
  HOLD_START: "holdStart",
  HOLD_END: "holdEnd",
  MOVE_START: "moveStart",
  MOVE: "move",
  MOVE_END: "moveEnd",
  WILL_CHANGE: "willChange",
  CHANGED: "changed",
  WILL_RESTORE: "willRestore",
  RESTORED: "restored",
  SELECT: "select",
  NEED_PANEL: "needPanel",
  VISIBLE_CHANGE: "visibleChange",
  REACH_EDGE: "reachEdge",
  PANEL_CHANGE: "panelChange"
};
/**
 * An object with all possible predefined literal string for the {@link Flicking#align align} option
 * @ko {@link Flicking#align align} 옵션에 사용되는 미리 정의된 리터럴 상수들을 담고 있는 객체
 * @type {object}
 * @property {"prev"} PREV left/top align<ko>좌/상 정렬</ko>
 * @property {"center"} CENTER center align<ko>중앙 정렬</ko>
 * @property {"next"} NEXT right/bottom align<ko>우/하 정렬</ko>
 */
var ALIGN = {
  PREV: "prev",
  CENTER: "center",
  NEXT: "next"
};
/**
 * An object of directions
 * @ko 방향을 나타내는 값들을 담고 있는 객체
 * @type {object}
 * @property {"PREV"} PREV "left" when {@link Flicking#horizontal horizontal} is true, and "top" when {@link Flicking#horizontal horizontal} is false
 * <ko>{@link Flicking#horizontal horizontal}가 `true`일 경우 왼쪽, {@link Flicking#horizontal horizontal}가 `false`일 경우 위쪽을 의미합니다</ko>
 * @property {"NEXT"} NEXT "right" when {@link Flicking#horizontal horizontal} is true, and "bottom" when {@link Flicking#horizontal horizontal} is false
 * <ko>{@link Flicking#horizontal horizontal}가 `true`일 경우 오른쪽, {@link Flicking#horizontal horizontal}가 `false`일 경우 아래쪽을 의미합니다</ko>
 * @property {null} NONE This value usually means it's the same position<ko>주로 제자리인 경우를 의미합니다</ko>
 */
var DIRECTION = {
  PREV: "PREV",
  NEXT: "NEXT",
  NONE: null
};
/**
 * An object with all possible {@link Flicking#moveType moveType}s
 * @ko Flicking이 제공하는 {@link Flicking#moveType moveType}들을 담고 있는 객체
 * @type {object}
 * @property {"snap"} SNAP Flicking's {@link Flicking#moveType moveType} that enables {@link SnapControl} as a Flicking's {@link Flicking#control control}
 * <ko>Flicking의 {@link Flicking#control control}을 {@link SnapControl}로 설정하게 하는 {@link Flicking#moveType moveType}</ko>
 * @property {"freeScroll"} FREE_SCROLL Flicking's {@link Flicking#moveType moveType} that enables {@link FreeControl} as a Flicking's {@link Flicking#control control}
 * <ko>Flicking의 {@link Flicking#control control}을 {@link FreeControl}로 설정하게 하는 {@link Flicking#moveType moveType}</ko>
 * @property {"strict"} STRICT Flicking's {@link Flicking#moveType moveType} that enables {@link StrictControl} as a Flicking's {@link Flicking#control control}
 * <ko>Flicking의 {@link Flicking#control control}을 {@link StrictControl}로 설정하게 하는 {@link Flicking#moveType moveType}</ko>
 */
var MOVE_TYPE = {
  SNAP: "snap",
  FREE_SCROLL: "freeScroll",
  STRICT: "strict"
};
var CLASS = {
  VERTICAL: "vertical",
  HIDDEN: "flicking-hidden",
  DEFAULT_VIRTUAL: "flicking-panel"
};
/**
 * An object with all possible {@link Flicking#circularFallback circularFallback}s
 * @ko Flicking의 {@link Flicking#circularFallback circularFallback}에 설정 가능한 값들을 담고 있는 객체
 * @type {object}
 * @property {string} LINEAR "linear"
 * @property {string} BOUND "bound"
 */
var CIRCULAR_FALLBACK = {
  LINEAR: "linear",
  BOUND: "bound"
};

// eslint-disable-next-line @typescript-eslint/ban-types
var flicking_esm_merge = function (target) {
  var sources = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    sources[_i - 1] = arguments[_i];
  }
  sources.forEach(function (source) {
    Object.keys(source).forEach(function (key) {
      target[key] = source[key];
    });
  });
  return target;
};
var getElement = function (el, parent) {
  var targetEl = null;
  if (flicking_esm_isString(el)) {
    var parentEl = parent ? parent : document;
    var queryResult = parentEl.querySelector(el);
    if (!queryResult) {
      throw new FlickingError(MESSAGE.ELEMENT_NOT_FOUND(el), CODE.ELEMENT_NOT_FOUND);
    }
    targetEl = queryResult;
  } else if (el && el.nodeType === Node.ELEMENT_NODE) {
    targetEl = el;
  }
  if (!targetEl) {
    throw new FlickingError(MESSAGE.WRONG_TYPE(el, ["HTMLElement", "string"]), CODE.WRONG_TYPE);
  }
  return targetEl;
};
var checkExistence = function (value, nameOnErrMsg) {
  if (value == null) {
    throw new FlickingError(MESSAGE.VAL_MUST_NOT_NULL(value, nameOnErrMsg), CODE.VAL_MUST_NOT_NULL);
  }
};
var flicking_esm_clamp = function (x, min, max) {
  return Math.max(Math.min(x, max), min);
};
var getFlickingAttached = function (val) {
  if (!val) {
    throw new FlickingError(MESSAGE.NOT_ATTACHED_TO_FLICKING, CODE.NOT_ATTACHED_TO_FLICKING);
  }
  return val;
};
var flicking_esm_toArray = function (iterable) {
  return [].slice.call(iterable);
};
var parseAlign$1 = function (align, size) {
  var alignPoint;
  if (flicking_esm_isString(align)) {
    switch (align) {
      case ALIGN.PREV:
        alignPoint = 0;
        break;
      case ALIGN.CENTER:
        alignPoint = 0.5 * size;
        break;
      case ALIGN.NEXT:
        alignPoint = size;
        break;
      default:
        alignPoint = parseArithmeticSize(align, size);
        if (alignPoint == null) {
          throw new FlickingError(MESSAGE.WRONG_OPTION("align", align), CODE.WRONG_OPTION);
        }
    }
  } else {
    alignPoint = align;
  }
  return alignPoint;
};
var parseBounce = function (bounce, size) {
  var parsedBounce;
  if (Array.isArray(bounce)) {
    parsedBounce = bounce.map(function (val) {
      return parseArithmeticSize(val, size);
    });
  } else {
    var parsedVal = parseArithmeticSize(bounce, size);
    parsedBounce = [parsedVal, parsedVal];
  }
  return parsedBounce.map(function (val) {
    if (val == null) {
      throw new FlickingError(MESSAGE.WRONG_OPTION("bounce", bounce), CODE.WRONG_OPTION);
    }
    return val;
  });
};
var parseArithmeticSize = function (cssValue, base) {
  var parsed = parseArithmeticExpression(cssValue);
  if (parsed == null) return null;
  return parsed.percentage * base + parsed.absolute;
};
var parseArithmeticExpression = function (cssValue) {
  var cssRegex = /(?:(\+|\-)\s*)?(\d+(?:\.\d+)?(%|px)?)/g;
  if (typeof cssValue === "number") {
    return {
      percentage: 0,
      absolute: cssValue
    };
  }
  var parsed = {
    percentage: 0,
    absolute: 0
  };
  var idx = 0;
  var matchResult = cssRegex.exec(cssValue);
  while (matchResult != null) {
    var sign = matchResult[1];
    var value = matchResult[2];
    var unit = matchResult[3];
    var parsedValue = parseFloat(value);
    if (idx <= 0) {
      sign = sign || "+";
    }
    // Return default value for values not in good form
    if (!sign) {
      return null;
    }
    var signMultiplier = sign === "+" ? 1 : -1;
    if (unit === "%") {
      parsed.percentage += signMultiplier * (parsedValue / 100);
    } else {
      parsed.absolute += signMultiplier * parsedValue;
    }
    // Match next occurrence
    ++idx;
    matchResult = cssRegex.exec(cssValue);
  }
  // None-matched
  if (idx === 0) {
    return null;
  }
  return parsed;
};
var parseCSSSizeValue = function (val) {
  return flicking_esm_isString(val) ? val : val + "px";
};
var parsePanelAlign = function (align) {
  return typeof align === "object" ? align.panel : align;
};
var flicking_esm_getDirection = function (start, end) {
  if (start === end) return DIRECTION.NONE;
  return start < end ? DIRECTION.NEXT : DIRECTION.PREV;
};
var parseElement = function (element) {
  if (!Array.isArray(element)) {
    element = [element];
  }
  var elements = [];
  element.forEach(function (el) {
    if (flicking_esm_isString(el)) {
      var tempDiv = document.createElement("div");
      tempDiv.innerHTML = el;
      elements.push.apply(elements, flicking_esm_spread(flicking_esm_toArray(tempDiv.children)));
      while (tempDiv.firstChild) {
        tempDiv.removeChild(tempDiv.firstChild);
      }
    } else if (el && el.nodeType === Node.ELEMENT_NODE) {
      elements.push(el);
    } else {
      throw new FlickingError(MESSAGE.WRONG_TYPE(el, ["HTMLElement", "string"]), CODE.WRONG_TYPE);
    }
  });
  return elements;
};
var getMinusCompensatedIndex = function (idx, max) {
  return idx < 0 ? flicking_esm_clamp(idx + max, 0, max) : flicking_esm_clamp(idx, 0, max);
};
var includes = function (array, target) {
  var e_1, _a;
  try {
    for (var array_1 = flicking_esm_values(array), array_1_1 = array_1.next(); !array_1_1.done; array_1_1 = array_1.next()) {
      var val = array_1_1.value;
      if (val === target) return true;
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (array_1_1 && !array_1_1.done && (_a = array_1.return)) _a.call(array_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  return false;
};
var flicking_esm_isString = function (val) {
  return typeof val === "string";
};
var circulatePosition = function (pos, min, max) {
  var size = max - min;
  if (pos < min) {
    var offset = (min - pos) % size;
    pos = max - offset;
  } else if (pos > max) {
    var offset = (pos - max) % size;
    pos = min + offset;
  }
  return pos;
};
var flicking_esm_find = function (array, checker) {
  var e_2, _a;
  try {
    for (var array_2 = flicking_esm_values(array), array_2_1 = array_2.next(); !array_2_1.done; array_2_1 = array_2.next()) {
      var val = array_2_1.value;
      if (checker(val)) {
        return val;
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (array_2_1 && !array_2_1.done && (_a = array_2.return)) _a.call(array_2);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
  return null;
};
var findRight = function (array, checker) {
  for (var idx = array.length - 1; idx >= 0; idx--) {
    var val = array[idx];
    if (checker(val)) {
      return val;
    }
  }
  return null;
};
var flicking_esm_findIndex = function (array, checker) {
  for (var idx = 0; idx < array.length; idx++) {
    if (checker(array[idx])) {
      return idx;
    }
  }
  return -1;
};
var getProgress = function (pos, prev, next) {
  return (pos - prev) / (next - prev);
};
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
var getStyle = function (el) {
  return window.getComputedStyle(el) || el.currentStyle;
};
var setSize = function (el, _a) {
  var width = _a.width,
    height = _a.height;
  if (width != null) {
    if (flicking_esm_isString(width)) {
      el.style.width = width;
    } else {
      el.style.width = width + "px";
    }
  }
  if (height != null) {
    if (flicking_esm_isString(height)) {
      el.style.height = height;
    } else {
      el.style.height = height + "px";
    }
  }
};
var isBetween = function (val, min, max) {
  return val >= min && val <= max;
};
var circulateIndex = function (index, max) {
  if (index >= max) {
    return index % max;
  } else if (index < 0) {
    return getMinusCompensatedIndex((index + 1) % max - 1, max);
  } else {
    return index;
  }
};
var flicking_esm_range = function (end) {
  var arr = new Array(end);
  for (var i = 0; i < end; i++) {
    arr[i] = i;
  }
  return arr;
};
var getElementSize = function (_a) {
  var el = _a.el,
    horizontal = _a.horizontal,
    useFractionalSize = _a.useFractionalSize,
    useOffset = _a.useOffset,
    style = _a.style;
  if (useFractionalSize) {
    var baseSize = parseFloat(horizontal ? style.width : style.height);
    var isBorderBoxSizing = style.boxSizing === "border-box";
    var border = horizontal ? parseFloat(style.borderLeftWidth || "0") + parseFloat(style.borderRightWidth || "0") : parseFloat(style.borderTopWidth || "0") + parseFloat(style.borderBottomWidth || "0");
    if (isBorderBoxSizing) {
      return useOffset ? baseSize : baseSize - border;
    } else {
      var padding = horizontal ? parseFloat(style.paddingLeft || "0") + parseFloat(style.paddingRight || "0") : parseFloat(style.paddingTop || "0") + parseFloat(style.paddingBottom || "0");
      return useOffset ? baseSize + padding + border : baseSize + padding;
    }
  } else {
    var sizeStr = horizontal ? "Width" : "Height";
    return useOffset ? el["offset" + sizeStr] : el["client" + sizeStr];
  }
};
var setPrototypeOf = Object.setPrototypeOf || function (obj, proto) {
  obj.__proto__ = proto;
  return obj;
};

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
/**
 * Special type of known error that {@link Flicking} throws.
 * @ko Flicking 내부에서 알려진 오류 발생시 throw되는 에러
 * @property {number} code Error code<ko>에러 코드</ko>
 * @property {string} message Error message<ko>에러 메시지</ko>
 * @see {@link ERROR_CODE ERROR_CODE}
 * @example
 * ```ts
 * import Flicking, { FlickingError, ERROR_CODES } from "@egjs/flicking";
 * try {
 *   const flicking = new Flicking(".flicking-viewport")
 * } catch (e) {
 *   if (e instanceof FlickingError && e.code === ERROR_CODES.ELEMENT_NOT_FOUND) {
 *     console.error("Element not found")
 *   }
 * }
 * ```
 */
var FlickingError = /*#__PURE__*/function (_super) {
  flicking_esm_extends(FlickingError, _super);
  /**
   * @param message Error message<ko>에러 메시지</ko>
   * @param code Error code<ko>에러 코드</ko>
   */
  function FlickingError(message, code) {
    var _this = _super.call(this, message) || this;
    setPrototypeOf(_this, FlickingError.prototype);
    _this.name = "FlickingError";
    _this.code = code;
    return _this;
  }
  return FlickingError;
}(Error);

/**
 * A component that manages viewport size
 * @ko 뷰포트 크기 정보를 담당하는 컴포넌트
 */
var Viewport = /*#__PURE__*/function () {
  /**
   * @param el A viewport element<ko>뷰포트 엘리먼트</ko>
   */
  function Viewport(flicking, el) {
    this._flicking = flicking;
    this._el = el;
    this._width = 0;
    this._height = 0;
    this._padding = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    this._isBorderBoxSizing = false;
  }
  var __proto = Viewport.prototype;
  Object.defineProperty(__proto, "element", {
    /**
     * A viewport(root) element
     * @ko 뷰포트(root) 엘리먼트
     * @type {HTMLElement}
     * @readonly
     */
    get: function () {
      return this._el;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "width", {
    /**
     * Viewport width, without paddings
     * @ko 뷰포트 너비
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._width - this._padding.left - this._padding.right;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "height", {
    /**
     * Viewport height, without paddings
     * @ko 뷰포트 높이
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._height - this._padding.top - this._padding.bottom;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "padding", {
    /**
     * Viewport paddings
     * @ko 뷰포트 CSS padding 값
     * @type {object}
     * @property {number} left CSS `padding-left`
     * @property {number} right CSS `padding-right`
     * @property {number} top CSS `padding-top`
     * @property {number} bottom CSS `padding-bottom`
     * @readonly
     */
    get: function () {
      return this._padding;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Change viewport's size.
   * This will change the actual size of `.flicking-viewport` element by changing its CSS width/height property
   * @ko 뷰포트 크기를 변경합니다.
   * `.flicking-viewport` 엘리먼트에 해당 크기의 CSS width/height를 적용합니다
   * @param {object} [size] New viewport size<ko>새 뷰포트 크기</ko>
   * @param {number|string} [size.width] CSS string or number(in px)<ko>CSS 문자열 또는 숫자(px)</ko>
   * @param {number|string} [size.height] CSS string or number(in px)<ko>CSS 문자열 또는 숫자(px)</ko>
   */
  __proto.setSize = function (_a) {
    var width = _a.width,
      height = _a.height;
    var el = this._el;
    var padding = this._padding;
    var isBorderBoxSizing = this._isBorderBoxSizing;
    if (width != null) {
      if (flicking_esm_isString(width)) {
        el.style.width = width;
      } else {
        var newWidth = isBorderBoxSizing ? width + padding.left + padding.right : width;
        el.style.width = newWidth + "px";
      }
    }
    if (height != null) {
      if (flicking_esm_isString(height)) {
        el.style.height = height;
      } else {
        var newHeight = isBorderBoxSizing ? height + padding.top + padding.bottom : height;
        el.style.height = newHeight + "px";
      }
    }
    this.resize();
  };
  /**
   * Update width/height to the current viewport element's size
   * @ko 현재 뷰포트 엘리먼트의 크기로 너비/높이를 업데이트합니다
   */
  __proto.resize = function () {
    var el = this._el;
    var elStyle = getStyle(el);
    var useFractionalSize = this._flicking.useFractionalSize;
    this._width = getElementSize({
      el: el,
      horizontal: true,
      useFractionalSize: useFractionalSize,
      useOffset: false,
      style: elStyle
    });
    this._height = getElementSize({
      el: el,
      horizontal: false,
      useFractionalSize: useFractionalSize,
      useOffset: false,
      style: elStyle
    });
    this._padding = {
      left: elStyle.paddingLeft ? parseFloat(elStyle.paddingLeft) : 0,
      right: elStyle.paddingRight ? parseFloat(elStyle.paddingRight) : 0,
      top: elStyle.paddingTop ? parseFloat(elStyle.paddingTop) : 0,
      bottom: elStyle.paddingBottom ? parseFloat(elStyle.paddingBottom) : 0
    };
    this._isBorderBoxSizing = elStyle.boxSizing === "border-box";
  };
  return Viewport;
}();

var AutoResizer = /*#__PURE__*/function () {
  function AutoResizer(flicking) {
    var _this = this;
    this._onResize = function () {
      var flicking = _this._flicking;
      var resizeDebounce = flicking.resizeDebounce;
      var maxResizeDebounce = flicking.maxResizeDebounce;
      if (resizeDebounce <= 0) {
        void flicking.resize();
      } else {
        if (_this._maxResizeDebounceTimer <= 0) {
          if (maxResizeDebounce > 0 && maxResizeDebounce >= resizeDebounce) {
            _this._maxResizeDebounceTimer = window.setTimeout(_this._doScheduledResize, maxResizeDebounce);
          }
        }
        if (_this._resizeTimer > 0) {
          clearTimeout(_this._resizeTimer);
          _this._resizeTimer = 0;
        }
        _this._resizeTimer = window.setTimeout(_this._doScheduledResize, resizeDebounce);
      }
    };
    this._doScheduledResize = function () {
      clearTimeout(_this._resizeTimer);
      clearTimeout(_this._maxResizeDebounceTimer);
      _this._maxResizeDebounceTimer = -1;
      _this._resizeTimer = -1;
      void _this._flicking.resize();
    };
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this._skipFirstResize = function () {
      var isFirstResize = true;
      return function () {
        if (isFirstResize) {
          isFirstResize = false;
          return;
        }
        _this._onResize();
      };
    }();
    this._flicking = flicking;
    this._enabled = false;
    this._resizeObserver = null;
    this._resizeTimer = -1;
    this._maxResizeDebounceTimer = -1;
  }
  var __proto = AutoResizer.prototype;
  Object.defineProperty(__proto, "enabled", {
    get: function () {
      return this._enabled;
    },
    enumerable: false,
    configurable: true
  });
  __proto.enable = function () {
    var flicking = this._flicking;
    var viewport = flicking.viewport;
    if (this._enabled) {
      this.disable();
    }
    if (flicking.useResizeObserver && !!window.ResizeObserver) {
      var viewportSizeNot0 = viewport.width !== 0 || viewport.height !== 0;
      var resizeObserver = viewportSizeNot0 ? new ResizeObserver(this._skipFirstResize) : new ResizeObserver(this._onResize);
      resizeObserver.observe(flicking.viewport.element);
      this._resizeObserver = resizeObserver;
    } else {
      window.addEventListener("resize", this._onResize);
    }
    this._enabled = true;
    return this;
  };
  __proto.disable = function () {
    if (!this._enabled) return this;
    var resizeObserver = this._resizeObserver;
    if (resizeObserver) {
      resizeObserver.disconnect();
      this._resizeObserver = null;
    } else {
      window.removeEventListener("resize", this._onResize);
    }
    this._enabled = false;
    return this;
  };
  return AutoResizer;
}();

/**
 * @internal
 */
var VanillaElementProvider = /*#__PURE__*/function () {
  function VanillaElementProvider(element) {
    this._element = element;
    this._rendered = true;
  }
  var __proto = VanillaElementProvider.prototype;
  Object.defineProperty(__proto, "element", {
    get: function () {
      return this._element;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "rendered", {
    get: function () {
      return this._rendered;
    },
    enumerable: false,
    configurable: true
  });
  __proto.show = function (flicking) {
    var el = this.element;
    var cameraEl = flicking.camera.element;
    if (el.parentElement !== cameraEl) {
      cameraEl.appendChild(el);
      this._rendered = true;
    }
  };
  __proto.hide = function (flicking) {
    var el = this.element;
    var cameraEl = flicking.camera.element;
    if (el.parentElement === cameraEl) {
      cameraEl.removeChild(el);
      this._rendered = false;
    }
  };
  return VanillaElementProvider;
}();

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
/**
 * @internal
 */
var VirtualElementProvider = /*#__PURE__*/function () {
  function VirtualElementProvider(flicking) {
    this._flicking = flicking;
  }
  var __proto = VirtualElementProvider.prototype;
  Object.defineProperty(__proto, "element", {
    get: function () {
      return this._virtualElement.nativeElement;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "rendered", {
    get: function () {
      return this._virtualElement.visible;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "_virtualElement", {
    get: function () {
      var flicking = this._flicking;
      var elIndex = this._panel.elementIndex;
      var virtualElements = flicking.virtual.elements;
      return virtualElements[elIndex];
    },
    enumerable: false,
    configurable: true
  });
  __proto.init = function (panel) {
    this._panel = panel;
  };
  __proto.show = function () {
    // DO_NOTHING
    // Actual element visibility is controlled by VirtualManager
  };
  __proto.hide = function () {
    // DO_NOTHING
    // Actual element visibility is controlled by VirtualManager
  };
  return VirtualElementProvider;
}();

/**
 * A manager class to add / remove virtual panels
 */
var VirtualManager = /*#__PURE__*/function () {
  function VirtualManager(flicking, options) {
    var _a, _b, _c, _d;
    this._flicking = flicking;
    this._renderPanel = (_a = options === null || options === void 0 ? void 0 : options.renderPanel) !== null && _a !== void 0 ? _a : function () {
      return "";
    };
    this._initialPanelCount = (_b = options === null || options === void 0 ? void 0 : options.initialPanelCount) !== null && _b !== void 0 ? _b : -1;
    this._cache = (_c = options === null || options === void 0 ? void 0 : options.cache) !== null && _c !== void 0 ? _c : false;
    this._panelClass = (_d = options === null || options === void 0 ? void 0 : options.panelClass) !== null && _d !== void 0 ? _d : CLASS.DEFAULT_VIRTUAL;
    this._elements = [];
  }
  var __proto = VirtualManager.prototype;
  Object.defineProperty(__proto, "elements", {
    get: function () {
      return this._elements;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "renderPanel", {
    // Options
    /**
     * A rendering function for the panel element's innerHTML
     * @ko 패널 엘리먼트의 innerHTML을 렌더링하는 함수
     * @type {function}
     * @param {VirtualPanel} panel Instance of the panel<ko>패널 인스턴스</ko>
     * @param {number} index Index of the panel<ko>패널 인덱스</ko>
     * @default "() => {}"
     */
    get: function () {
      return this._renderPanel;
    },
    set: function (val) {
      this._renderPanel = val;
      this._flicking.renderer.panels.forEach(function (panel) {
        return panel.uncacheRenderResult();
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "initialPanelCount", {
    /**
     * Initial panel count to render
     * @ko 최초로 렌더링할 패널의 개수
     * @readonly
     * @type {number}
     * @default -1
     */
    get: function () {
      return this._initialPanelCount;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "cache", {
    /**
     * Whether to cache rendered panel's innerHTML
     * @ko 렌더링된 패널의 innerHTML 정보를 캐시할지 여부
     * @type {boolean}
     * @default false
     */
    get: function () {
      return this._cache;
    },
    set: function (val) {
      this._cache = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "panelClass", {
    /**
     * The class name that will be applied to rendered panel elements
     * @ko 렌더링되는 패널 엘리먼트에 적용될 클래스 이름
     * @type {string}
     * @default "flicking-panel"
     */
    get: function () {
      return this._panelClass;
    },
    set: function (val) {
      this._panelClass = val;
    },
    enumerable: false,
    configurable: true
  });
  __proto.init = function () {
    var flicking = this._flicking;
    if (!flicking.virtualEnabled) return;
    if (!flicking.externalRenderer && !flicking.renderExternal) {
      this._initVirtualElements();
    }
    var virtualElements = flicking.camera.children;
    this._elements = virtualElements.map(function (el) {
      return {
        nativeElement: el,
        visible: true
      };
    });
  };
  __proto.show = function (index) {
    var el = this._elements[index];
    var nativeEl = el.nativeElement;
    el.visible = true;
    if (nativeEl.style.display) {
      nativeEl.style.display = "";
    }
  };
  __proto.hide = function (index) {
    var el = this._elements[index];
    var nativeEl = el.nativeElement;
    el.visible = false;
    nativeEl.style.display = "none";
  };
  /**
   * Add new virtual panels at the end of the list
   * @ko 새로운 가상 패널들을 리스트의 끝에 추가합니다
   * @param {number} count The number of panels to add<ko>추가할 패널의 개수</ko>
   * @returns {Array<VirtualPanel>} The new panels added<ko>새롭게 추가된 패널들</ko>
   */
  __proto.append = function (count) {
    if (count === void 0) {
      count = 1;
    }
    var flicking = this._flicking;
    return this.insert(flicking.panels.length, count);
  };
  /**
   * Add new virtual panels at the start of the list
   * @ko 새로운 가상 패널들을 리스트의 시작에 추가합니다
   * @param {number} count The number of panels to add<ko>추가할 패널의 개수</ko>
   * @returns {Array<VirtualPanel>} The new panels added<ko>새롭게 추가된 패널들</ko>
   */
  __proto.prepend = function (count) {
    if (count === void 0) {
      count = 1;
    }
    return this.insert(0, count);
  };
  /**
   * Add new virtual panels at the given index
   * @ko 새로운 가상 패널들을 주어진 인덱스에 추가합니다
   * @param {number} count The number of panels to add<ko>추가할 패널의 개수</ko>
   * @returns {Array<VirtualPanel>} The new panels added<ko>새롭게 추가된 패널들</ko>
   */
  __proto.insert = function (index, count) {
    if (count === void 0) {
      count = 1;
    }
    if (count <= 0) return [];
    var flicking = this._flicking;
    return flicking.renderer.batchInsert({
      index: index,
      elements: flicking_esm_range(count),
      hasDOMInElements: false
    });
  };
  /**
   * Remove panels at the given index
   * @ko 주어진 인덱스에서 패널들을 삭제합니다
   * @param {number} count The number of panels to remove<ko>삭제할 패널의 개수</ko>
   * @returns {Array<VirtualPanel>} The panels removed<ko>삭제된 패널들</ko>
   */
  __proto.remove = function (index, count) {
    if (count <= 0) return [];
    var flicking = this._flicking;
    return flicking.renderer.batchRemove({
      index: index,
      deleteCount: count,
      hasDOMInElements: false
    });
  };
  __proto._initVirtualElements = function () {
    var _this = this;
    var flicking = this._flicking;
    var cameraElement = flicking.camera.element;
    var panelsPerView = flicking.panelsPerView;
    var fragment = document.createDocumentFragment();
    var newElements = flicking_esm_range(panelsPerView + 1).map(function (idx) {
      var panelEl = document.createElement("div");
      panelEl.className = _this._panelClass;
      panelEl.dataset.elementIndex = idx.toString();
      return panelEl;
    });
    newElements.forEach(function (el) {
      fragment.appendChild(el);
    });
    cameraElement.appendChild(fragment);
  };
  return VirtualManager;
}();

/**
 * All possible @egjs/axes event keys
 * @internal
 */
var EVENT = {
  HOLD: "hold",
  CHANGE: "change",
  RELEASE: "release",
  ANIMATION_END: "animationEnd",
  FINISH: "finish"
};
/**
 * An Axis key that Flicking uses
 * @internal
 */
var POSITION_KEY = "flick";

var STATE_TYPE;
(function (STATE_TYPE) {
  STATE_TYPE[STATE_TYPE["IDLE"] = 0] = "IDLE";
  STATE_TYPE[STATE_TYPE["HOLDING"] = 1] = "HOLDING";
  STATE_TYPE[STATE_TYPE["DRAGGING"] = 2] = "DRAGGING";
  STATE_TYPE[STATE_TYPE["ANIMATING"] = 3] = "ANIMATING";
  STATE_TYPE[STATE_TYPE["DISABLED"] = 4] = "DISABLED";
})(STATE_TYPE || (STATE_TYPE = {}));
/**
 * A component that shows the current status of the user input or the animation
 * @ko 현재 사용자 입력 또는 애니메이션 상태를 나타내는 컴포넌트
 * @internal
 */
var flicking_esm_State = /*#__PURE__*/function () {
  function State() {
    this._delta = 0;
    this._targetPanel = null;
  }
  var __proto = State.prototype;
  Object.defineProperty(__proto, "delta", {
    /**
     * A sum of delta values of change events from the last hold event of Axes
     * @ko 이전 hold이벤트부터 change에 의해 발생한 이동 delta값의 합산
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._delta;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "targetPanel", {
    /**
     * A panel to set as {@link Control#activePanel} after the animation is finished
     * @ko 애니메이션 종료시 {@link Control#activePanel}로 설정할 패널
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._targetPanel;
    },
    set: function (val) {
      this._targetPanel = val;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * An callback which is called when state has changed to this state
   * @ko 현재 상태로 돌입했을때 호출되는 콜백 함수
   * @param {State} prevState An previous state<ko>이전 상태값</ko>
   * @return {void}
   */
  __proto.onEnter = function (prevState) {
    this._delta = prevState._delta;
    this._targetPanel = prevState._targetPanel;
  };
  /**
   * An event handler for Axes's {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:hold hold} event
   * @ko Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:hold hold} 이벤트 핸들러
   * @param {object} [ctx] Event context<ko>이벤트 콘텍스트</ko>
   * @param {Flicking} [ctx.flicking] An instance of Flicking<ko>Flicking 인스턴스</ko>
   * @param {object} [ctx.axesEvent] A {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:hold hold} event of Axes
   * <ko>Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:hold hold} 이벤트</ko>
   * @param {function} [ctx.transitTo] A function for changing current state to other state<ko>다른 상태로 변경하기 위한 함수</ko>
   * @return {void}
   */
  __proto.onHold = function (ctx) {
    // DO NOTHING
  };
  /**
   * An event handler for Axes's {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:change change} event
   * @ko Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:change change} 이벤트 핸들러
   * @param {object} [ctx] Event context<ko>이벤트 콘텍스트</ko>
   * @param {Flicking} [ctx.flicking] An instance of Flicking<ko>Flicking 인스턴스</ko>
   * @param {object} [ctx.axesEvent] A {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:change change} event of Axes
   * <ko>Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:change change} 이벤트</ko>
   * @param {function} [ctx.transitTo] A function for changing current state to other state<ko>다른 상태로 변경하기 위한 함수</ko>
   * @return {void}
   */
  __proto.onChange = function (ctx) {
    // DO NOTHING
  };
  /**
   * An event handler for Axes's {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} event
   * @ko Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} 이벤트 핸들러
   * @param {object} [ctx] Event context<ko>이벤트 콘텍스트</ko>
   * @param {Flicking} [ctx.flicking] An instance of Flicking<ko>Flicking 인스턴스</ko>
   * @param {object} [ctx.axesEvent] A {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} event of Axes
   * <ko>Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} 이벤트</ko>
   * @param {function} [ctx.transitTo] A function for changing current state to other state<ko>다른 상태로 변경하기 위한 함수</ko>
   * @return {void}
   */
  __proto.onRelease = function (ctx) {
    // DO NOTHING
  };
  /**
   * An event handler for Axes's {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:animationEnd animationEnd} event
   * @ko Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:animationEnd animationEnd} 이벤트 핸들러
   * @param {object} [ctx] Event context<ko>이벤트 콘텍스트</ko>
   * @param {Flicking} [ctx.flicking] An instance of Flicking<ko>Flicking 인스턴스</ko>
   * @param {object} [ctx.axesEvent] A {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:animationEnd animationEnd} event of Axes
   * <ko>Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:animationEnd animationEnd} 이벤트</ko>
   * @param {function} [ctx.transitTo] A function for changing current state to other state<ko>다른 상태로 변경하기 위한 함수</ko>
   * @return {void}
   */
  __proto.onAnimationEnd = function (ctx) {
    // DO NOTHING
  };
  /**
   * An event handler for Axes's {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:finish finish} event
   * @ko Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:finish finish} 이벤트 핸들러
   * @param {object} [ctx] Event context<ko>이벤트 콘텍스트</ko>
   * @param {Flicking} [ctx.flicking] An instance of Flicking<ko>Flicking 인스턴스</ko>
   * @param {object} [ctx.axesEvent] A {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:finish finish} event of Axes<ko>Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:finish finish} 이벤트</ko>
   * @param {function} [ctx.transitTo] A function for changing current state to other state<ko>다른 상태로 변경하기 위한 함수</ko>
   * @return {void}
   */
  __proto.onFinish = function (ctx) {
    // DO NOTHING
  };
  __proto._moveToChangedPosition = function (ctx) {
    var flicking = ctx.flicking,
      axesEvent = ctx.axesEvent,
      transitTo = ctx.transitTo;
    var delta = axesEvent.delta[POSITION_KEY];
    if (!delta) {
      return;
    }
    this._delta += delta;
    var camera = flicking.camera;
    var prevPosition = camera.position;
    var position = axesEvent.pos[POSITION_KEY];
    var newPosition = flicking.circularEnabled ? circulatePosition(position, camera.range.min, camera.range.max) : position;
    camera.lookAt(newPosition);
    var moveEvent = new ComponentEvent$1(flicking_esm_EVENTS.MOVE, {
      isTrusted: axesEvent.isTrusted,
      holding: this.holding,
      direction: flicking_esm_getDirection(0, axesEvent.delta[POSITION_KEY]),
      axesEvent: axesEvent
    });
    flicking.trigger(moveEvent);
    if (moveEvent.isCanceled()) {
      // Return to previous position
      camera.lookAt(prevPosition);
      transitTo(STATE_TYPE.DISABLED);
    }
  };
  return State;
}();

/**
 * A default state when there's no user input and no animation's playing
 * @ko 사용자의 입력이 없고, 애니메이션이 동작하고있지 않은 기본 상태
 * @internal
 */
var flicking_esm_IdleState = /*#__PURE__*/function (_super) {
  flicking_esm_extends(IdleState, _super);
  function IdleState() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * Whether user is clicking or touching
     * @ko 현재 사용자가 클릭/터치중인지 여부
     * @type {false}
     * @readonly
     */
    _this.holding = false;
    /**
     * Whether Flicking's animating
     * @ko 현재 애니메이션 동작 여부
     * @type {false}
     * @readonly
     */
    _this.animating = false;
    return _this;
  }
  var __proto = IdleState.prototype;
  __proto.onEnter = function () {
    this._delta = 0;
    this._targetPanel = null;
  };
  __proto.onHold = function (ctx) {
    // Shouldn't do any action until any panels on flicking area
    var flicking = ctx.flicking,
      axesEvent = ctx.axesEvent,
      transitTo = ctx.transitTo;
    if (flicking.renderer.panelCount <= 0) {
      transitTo(STATE_TYPE.DISABLED);
      return;
    }
    var holdStartEvent = new ComponentEvent$1(flicking_esm_EVENTS.HOLD_START, {
      axesEvent: axesEvent
    });
    flicking.trigger(holdStartEvent);
    if (holdStartEvent.isCanceled()) {
      transitTo(STATE_TYPE.DISABLED);
    } else {
      transitTo(STATE_TYPE.HOLDING);
    }
  };
  // By methods call
  __proto.onChange = function (ctx) {
    var flicking = ctx.flicking,
      axesEvent = ctx.axesEvent,
      transitTo = ctx.transitTo;
    var controller = flicking.control.controller;
    var animatingContext = controller.animatingContext;
    var moveStartEvent = new ComponentEvent$1(flicking_esm_EVENTS.MOVE_START, {
      isTrusted: axesEvent.isTrusted,
      holding: this.holding,
      direction: flicking_esm_getDirection(animatingContext.start, animatingContext.end),
      axesEvent: axesEvent
    });
    flicking.trigger(moveStartEvent);
    if (moveStartEvent.isCanceled()) {
      transitTo(STATE_TYPE.DISABLED);
    } else {
      // Trigger AnimatingState's onChange, to trigger "move" event immediately
      transitTo(STATE_TYPE.ANIMATING).onChange(ctx);
    }
  };
  return IdleState;
}(flicking_esm_State);

/**
 * A state that activates when user's holding the Flicking area, but not moved a single pixel yet
 * @ko 사용자의 입력이 시작되었으나, 아직 움직이지는 않은 상태
 * @internal
 */
var flicking_esm_HoldingState = /*#__PURE__*/function (_super) {
  flicking_esm_extends(HoldingState, _super);
  function HoldingState() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * Whether user is clicking or touching
     * @ko 현재 사용자가 클릭/터치중인지 여부
     * @type {true}
     * @readonly
     */
    _this.holding = true;
    /**
     * Whether Flicking's animating
     * @ko 현재 애니메이션 동작 여부
     * @type {false}
     * @readonly
     */
    _this.animating = false;
    _this._releaseEvent = null;
    return _this;
  }
  var __proto = HoldingState.prototype;
  __proto.onChange = function (ctx) {
    var flicking = ctx.flicking,
      axesEvent = ctx.axesEvent,
      transitTo = ctx.transitTo;
    var inputEvent = axesEvent.inputEvent;
    var offset = flicking.horizontal ? inputEvent.offsetX : inputEvent.offsetY;
    var moveStartEvent = new ComponentEvent$1(flicking_esm_EVENTS.MOVE_START, {
      isTrusted: axesEvent.isTrusted,
      holding: this.holding,
      direction: flicking_esm_getDirection(0, -offset),
      axesEvent: axesEvent
    });
    flicking.trigger(moveStartEvent);
    if (moveStartEvent.isCanceled()) {
      transitTo(STATE_TYPE.DISABLED);
    } else {
      // Trigger DraggingState's onChange, to trigger "move" event immediately
      transitTo(STATE_TYPE.DRAGGING).onChange(ctx);
    }
  };
  __proto.onRelease = function (ctx) {
    var flicking = ctx.flicking,
      axesEvent = ctx.axesEvent,
      transitTo = ctx.transitTo;
    flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.HOLD_END, {
      axesEvent: axesEvent
    }));
    if (axesEvent.delta.flick !== 0) {
      // Sometimes "release" event on axes triggered before "change" event
      // Especially if user flicked panel fast in really short amount of time
      // if delta is not zero, that means above case happened.
      // Event flow should be HOLD_START -> MOVE_START -> MOVE -> HOLD_END
      // At least one move event should be included between holdStart and holdEnd
      axesEvent.setTo({
        flick: flicking.camera.position
      }, 0);
      transitTo(STATE_TYPE.IDLE);
      return;
    }
    // Can't handle select event here,
    // As "finish" axes event happens
    this._releaseEvent = axesEvent;
  };
  __proto.onFinish = function (ctx) {
    var e_1, _a;
    var flicking = ctx.flicking,
      transitTo = ctx.transitTo;
    // Should transite to IDLE state before select event
    // As user expects hold is already finished
    transitTo(STATE_TYPE.IDLE);
    if (!this._releaseEvent) {
      return;
    }
    // Handle release event here
    // To prevent finish event called twice
    var releaseEvent = this._releaseEvent;
    // Static click
    /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
    var srcEvent = releaseEvent.inputEvent.srcEvent;
    var clickedElement;
    if (srcEvent.type === "touchend") {
      var touchEvent = srcEvent;
      var touch = touchEvent.changedTouches[0];
      clickedElement = document.elementFromPoint(touch.clientX, touch.clientY);
    } else {
      clickedElement = srcEvent.target;
    }
    /* eslint-enable */
    var panels = flicking.renderer.panels;
    var clickedPanel = null;
    try {
      for (var panels_1 = flicking_esm_values(panels), panels_1_1 = panels_1.next(); !panels_1_1.done; panels_1_1 = panels_1.next()) {
        var panel = panels_1_1.value;
        if (panel.contains(clickedElement)) {
          clickedPanel = panel;
          break;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (panels_1_1 && !panels_1_1.done && (_a = panels_1.return)) _a.call(panels_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    if (clickedPanel) {
      var cameraPosition = flicking.camera.position;
      var clickedPanelPosition = clickedPanel.position;
      flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.SELECT, {
        index: clickedPanel.index,
        panel: clickedPanel,
        // Direction to the clicked panel
        direction: flicking_esm_getDirection(cameraPosition, clickedPanelPosition)
      }));
    }
  };
  return HoldingState;
}(flicking_esm_State);

/**
 * A state that activates when user's dragging the Flicking area
 * @ko 사용자가 드래깅중인 상태
 * @internal
 */
var flicking_esm_DraggingState = /*#__PURE__*/function (_super) {
  flicking_esm_extends(DraggingState, _super);
  function DraggingState() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * Whether user is clicking or touching
     * @ko 현재 사용자가 클릭/터치중인지 여부
     * @type {true}
     * @readonly
     */
    _this.holding = true;
    /**
     * Whether Flicking's animating
     * @ko 현재 애니메이션 동작 여부
     * @type {true}
     * @readonly
     */
    _this.animating = true;
    return _this;
  }
  var __proto = DraggingState.prototype;
  __proto.onChange = function (ctx) {
    this._moveToChangedPosition(ctx);
  };
  __proto.onRelease = function (ctx) {
    var _a;
    var flicking = ctx.flicking,
      axesEvent = ctx.axesEvent,
      transitTo = ctx.transitTo;
    // Update last position to cope with Axes's animating behavior
    // Axes uses start position when animation start
    flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.HOLD_END, {
      axesEvent: axesEvent
    }));
    if (flicking.renderer.panelCount <= 0) {
      // There're no panels
      transitTo(STATE_TYPE.IDLE);
      return;
    }
    transitTo(STATE_TYPE.ANIMATING);
    var control = flicking.control;
    var position = axesEvent.destPos[POSITION_KEY];
    var duration = Math.max(axesEvent.duration, flicking.duration);
    try {
      void control.moveToPosition(position, duration, axesEvent);
    } catch (err) {
      transitTo(STATE_TYPE.IDLE);
      axesEvent.setTo((_a = {}, _a[POSITION_KEY] = flicking.camera.position, _a), 0);
    }
  };
  return DraggingState;
}(flicking_esm_State);

/**
 * A state that activates when Flicking's animating by user input or method call
 * @ko 사용자 입력이나 메소드 호출에 의해 Flicking의 애니메이션이 동작중인 상태
 * @internal
 */
var flicking_esm_AnimatingState = /*#__PURE__*/function (_super) {
  flicking_esm_extends(AnimatingState, _super);
  function AnimatingState() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * Whether user is clicking or touching
     * @ko 현재 사용자가 클릭/터치중인지 여부
     * @type {false}
     * @readonly
     */
    _this.holding = false;
    /**
     * Whether Flicking's animating
     * @ko 현재 애니메이션 동작 여부
     * @type {true}
     * @readonly
     */
    _this.animating = true;
    return _this;
  }
  var __proto = AnimatingState.prototype;
  __proto.onHold = function (ctx) {
    var flicking = ctx.flicking,
      axesEvent = ctx.axesEvent,
      transitTo = ctx.transitTo;
    var targetPanel = this._targetPanel;
    var control = flicking.control;
    this._delta = 0;
    flicking.control.updateInput();
    if (flicking.changeOnHold && targetPanel) {
      control.setActive(targetPanel, control.activePanel, axesEvent.isTrusted);
    }
    var holdStartEvent = new ComponentEvent$1(flicking_esm_EVENTS.HOLD_START, {
      axesEvent: axesEvent
    });
    flicking.trigger(holdStartEvent);
    if (holdStartEvent.isCanceled()) {
      transitTo(STATE_TYPE.DISABLED);
    } else {
      transitTo(STATE_TYPE.DRAGGING);
    }
  };
  __proto.onChange = function (ctx) {
    this._moveToChangedPosition(ctx);
  };
  __proto.onFinish = function (ctx) {
    var flicking = ctx.flicking,
      axesEvent = ctx.axesEvent,
      transitTo = ctx.transitTo;
    var control = flicking.control;
    var controller = control.controller;
    var animatingContext = controller.animatingContext;
    transitTo(STATE_TYPE.IDLE);
    flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.MOVE_END, {
      isTrusted: axesEvent.isTrusted,
      direction: flicking_esm_getDirection(animatingContext.start, animatingContext.end),
      axesEvent: axesEvent
    }));
    var targetPanel = this._targetPanel;
    if (targetPanel) {
      control.setActive(targetPanel, control.activePanel, axesEvent.isTrusted);
    }
  };
  return AnimatingState;
}(flicking_esm_State);

/**
 * A state that activates when Flicking is stopped by event's `stop` method
 * @ko 이벤트의 `stop`호출에 의해 Flicking이 정지된 상태
 * @internal
 */
var DisabledState = /*#__PURE__*/function (_super) {
  flicking_esm_extends(DisabledState, _super);
  function DisabledState() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * Whether user is clicking or touching
     * @ko 현재 사용자가 클릭/터치중인지 여부
     * @type {false}
     * @readonly
     */
    _this.holding = false;
    /**
     * Whether Flicking's animating
     * @ko 현재 애니메이션 동작 여부
     * @type {true}
     * @readonly
     */
    _this.animating = true;
    return _this;
  }
  var __proto = DisabledState.prototype;
  __proto.onAnimationEnd = function (ctx) {
    var transitTo = ctx.transitTo;
    transitTo(STATE_TYPE.IDLE);
  };
  __proto.onChange = function (ctx) {
    var axesEvent = ctx.axesEvent,
      transitTo = ctx.transitTo;
    // Can stop Axes's change event
    axesEvent.stop();
    transitTo(STATE_TYPE.IDLE);
  };
  __proto.onRelease = function (ctx) {
    var axesEvent = ctx.axesEvent,
      transitTo = ctx.transitTo;
    // This is needed when stopped hold start event
    if (axesEvent.delta.flick === 0) {
      transitTo(STATE_TYPE.IDLE);
    }
  };
  return DisabledState;
}(flicking_esm_State);

/**
 * @internal
 */
var StateMachine = /*#__PURE__*/function () {
  function StateMachine() {
    var _this = this;
    this.transitTo = function (nextStateType) {
      var nextState;
      switch (nextStateType) {
        case STATE_TYPE.IDLE:
          nextState = new flicking_esm_IdleState();
          break;
        case STATE_TYPE.HOLDING:
          nextState = new flicking_esm_HoldingState();
          break;
        case STATE_TYPE.DRAGGING:
          nextState = new flicking_esm_DraggingState();
          break;
        case STATE_TYPE.ANIMATING:
          nextState = new flicking_esm_AnimatingState();
          break;
        case STATE_TYPE.DISABLED:
          nextState = new DisabledState();
          break;
      }
      nextState.onEnter(_this._state);
      _this._state = nextState;
      return _this._state;
    };
    this._state = new flicking_esm_IdleState();
  }
  var __proto = StateMachine.prototype;
  Object.defineProperty(__proto, "state", {
    get: function () {
      return this._state;
    },
    enumerable: false,
    configurable: true
  });
  __proto.fire = function (eventType, externalCtx) {
    var currentState = this._state;
    var ctx = flicking_esm_assign(flicking_esm_assign({}, externalCtx), {
      transitTo: this.transitTo
    });
    switch (eventType) {
      case EVENT.HOLD:
        currentState.onHold(ctx);
        break;
      case EVENT.CHANGE:
        currentState.onChange(ctx);
        break;
      case EVENT.RELEASE:
        currentState.onRelease(ctx);
        break;
      case EVENT.ANIMATION_END:
        currentState.onAnimationEnd(ctx);
        break;
      case EVENT.FINISH:
        currentState.onFinish(ctx);
        break;
    }
  };
  return StateMachine;
}();

/**
 * A controller that handles the {@link https://naver.github.io/egjs-axes/ @egjs/axes} events
 * @ko {@link https://naver.github.io/egjs-axes/ @egjs/axes}의 이벤트를 처리하는 컨트롤러 컴포넌트
 * @internal
 */
var flicking_esm_AxesController = /*#__PURE__*/function () {
  /** */
  function AxesController() {
    var _this = this;
    this._onAxesHold = function () {
      _this._dragged = false;
    };
    this._onAxesChange = function () {
      var _a;
      _this._dragged = !!((_a = _this._panInput) === null || _a === void 0 ? void 0 : _a.isEnabled());
    };
    this._preventClickWhenDragged = function (e) {
      if (_this._dragged) {
        e.preventDefault();
        e.stopPropagation();
      }
      _this._dragged = false;
    };
    this._resetInternalValues();
    this._stateMachine = new StateMachine();
  }
  var __proto = AxesController.prototype;
  Object.defineProperty(__proto, "axes", {
    /**
     * An {@link https://naver.github.io/egjs-axes/docs/api/Axes Axes} instance
     * @ko {@link https://naver.github.io/egjs-axes/docs/api/Axes Axes}의 인스턴스
     * @type {Axes | null}
     * @see https://naver.github.io/egjs-axes/docs/api/Axes
     * @readonly
     */
    get: function () {
      return this._axes;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "panInput", {
    /**
     * An {@link https://naver.github.io/egjs-axes/docs/api/PanInput PanInput} instance
     * @ko {@link https://naver.github.io/egjs-axes/docs/api/PanInput PanInput}의 인스턴스
     * @type {PanInput | null}
     * @see https://naver.github.io/egjs-axes/docs/api/PanInput
     * @readonly
     */
    get: function () {
      return this._panInput;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "stateMachine", {
    /**
     * @internal
     */
    get: function () {
      return this._stateMachine;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "state", {
    /**
     * A activated {@link State} that shows the current status of the user input or the animation
     * @ko 현재 활성화된 {@link State} 인스턴스로 사용자 입력 또는 애니메이션 상태를 나타냅니다
     * @type {State}
     */
    get: function () {
      return this._stateMachine.state;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "animatingContext", {
    /**
     * A context of the current animation playing
     * @ko 현재 재생중인 애니메이션 정보
     * @type {object}
     * @property {number} start A start position of the animation<ko>애니메이션 시작 지점</ko>
     * @property {number} end A end position of the animation<ko>애니메이션 끝 지점</ko>
     * @property {number} offset camera offset<ko>카메라 오프셋</ko>
     * @readonly
     */
    get: function () {
      return this._animatingContext;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "controlParams", {
    /**
     * A current control parameters of the Axes instance
     * @ko 활성화된 현재 Axes 패러미터들
     * @type {ControlParams}
     */
    get: function () {
      var axes = this._axes;
      if (!axes) {
        return {
          range: {
            min: 0,
            max: 0
          },
          position: 0,
          circular: false
        };
      }
      var axis = axes.axis[POSITION_KEY];
      return {
        range: {
          min: axis.range[0],
          max: axis.range[1]
        },
        circular: axis.circular[0],
        position: this.position
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "enabled", {
    /**
     * A Boolean indicating whether the user input is enabled
     * @ko 현재 사용자 입력이 활성화되었는지를 나타내는 값
     * @type {boolean}
     * @readonly
     */
    get: function () {
      var _a, _b;
      return (_b = (_a = this._panInput) === null || _a === void 0 ? void 0 : _a.isEnabled()) !== null && _b !== void 0 ? _b : false;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "position", {
    /**
     * Current position value in {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html Axes} instance
     * @ko {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html Axes} 인스턴스 내부의 현재 좌표 값
     * @type {number}
     * @readonly
     */
    get: function () {
      var _a, _b;
      return (_b = (_a = this._axes) === null || _a === void 0 ? void 0 : _a.get([POSITION_KEY])[POSITION_KEY]) !== null && _b !== void 0 ? _b : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "range", {
    /**
     * Current range value in {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html Axes} instance
     * @ko {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html Axes} 인스턴스 내부의 현재 이동 범위 값
     * @type {number[]}
     * @readonly
     */
    get: function () {
      var _a, _b;
      return (_b = (_a = this._axes) === null || _a === void 0 ? void 0 : _a.axis[POSITION_KEY].range) !== null && _b !== void 0 ? _b : [0, 0];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "bounce", {
    /**
     * Actual bounce size(px)
     * @ko 적용된 bounce 크기(px 단위)
     * @type {number[]}
     * @readonly
     */
    get: function () {
      var _a;
      return (_a = this._axes) === null || _a === void 0 ? void 0 : _a.axis[POSITION_KEY].bounce;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Initialize AxesController
   * @ko AxesController를 초기화합니다
   * @param {Flicking} flicking An instance of Flicking
   * @chainable
   * @return {this}
   */
  __proto.init = function (flicking) {
    var _a;
    var _this = this;
    this._flicking = flicking;
    this._axes = new axes_esm((_a = {}, _a[POSITION_KEY] = {
      range: [0, 0],
      circular: false,
      bounce: [0, 0]
    }, _a), {
      deceleration: flicking.deceleration,
      interruptable: flicking.interruptable,
      nested: flicking.nested,
      easing: flicking.easing
    });
    this._panInput = new PanInput(flicking.viewport.element, {
      inputType: flicking.inputType,
      threshold: 1,
      iOSEdgeSwipeThreshold: flicking.iOSEdgeSwipeThreshold,
      scale: flicking.horizontal ? [-1, 0] : [0, -1],
      releaseOnScroll: true
    });
    var axes = this._axes;
    axes.connect(flicking.horizontal ? [POSITION_KEY, ""] : ["", POSITION_KEY], this._panInput);
    var _loop_1 = function (key) {
      var eventType = EVENT[key];
      axes.on(eventType, function (e) {
        _this._stateMachine.fire(eventType, {
          flicking: flicking,
          axesEvent: e
        });
      });
    };
    for (var key in EVENT) {
      _loop_1(key);
    }
    return this;
  };
  /**
   * Destroy AxesController and return to initial state
   * @ko AxesController를 초기 상태로 되돌립니다
   * @return {void}
   */
  __proto.destroy = function () {
    var _a;
    if (this._axes) {
      this.removePreventClickHandler();
      this._axes.destroy();
    }
    (_a = this._panInput) === null || _a === void 0 ? void 0 : _a.destroy();
    this._resetInternalValues();
  };
  /**
   * Enable input from the user (mouse/touch)
   * @ko 사용자의 입력(마우스/터치)를 활성화합니다
   * @chainable
   * @return {this}
   */
  __proto.enable = function () {
    var _a;
    (_a = this._panInput) === null || _a === void 0 ? void 0 : _a.enable();
    return this;
  };
  /**
   * Disable input from the user (mouse/touch)
   * @ko 사용자의 입력(마우스/터치)를 막습니다
   * @chainable
   * @return {this}
   */
  __proto.disable = function () {
    var _a;
    (_a = this._panInput) === null || _a === void 0 ? void 0 : _a.disable();
    return this;
  };
  /**
   * Releases ongoing user input (mouse/touch)
   * @ko 사용자의 현재 입력(마우스/터치)를 중단시킵니다
   * @chainable
   * @return {this}
   */
  __proto.release = function () {
    var _a;
    (_a = this._panInput) === null || _a === void 0 ? void 0 : _a.release();
    return this;
  };
  /**
   * Change the destination and duration of the animation currently playing
   * @ko 재생 중인 애니메이션의 목적지와 재생 시간을 변경합니다
   * @param {number} position A position to move<ko>이동할 좌표</ko>
   * @param {number} duration Duration of the animation (unit: ms)<ko>애니메이션 진행 시간 (단위: ms)</ko>
   * @chainable
   * @return {this}
   */
  __proto.updateAnimation = function (position, duration) {
    var _a;
    var _b;
    this._animatingContext = flicking_esm_assign(flicking_esm_assign({}, this._animatingContext), {
      end: position
    });
    (_b = this._axes) === null || _b === void 0 ? void 0 : _b.updateAnimation({
      destPos: (_a = {}, _a[POSITION_KEY] = position, _a),
      duration: duration
    });
    return this;
  };
  /**
   * Stops the animation currently playing
   * @ko 재생 중인 애니메이션을 중단시킵니다
   * @chainable
   * @return {this}
   */
  __proto.stopAnimation = function () {
    var _a;
    (_a = this._axes) === null || _a === void 0 ? void 0 : _a.stopAnimation();
    return this;
  };
  /**
   * Update {@link https://naver.github.io/egjs-axes/ @egjs/axes}'s state
   * @ko {@link https://naver.github.io/egjs-axes/ @egjs/axes}의 상태를 갱신합니다
   * @chainable
   * @throws {FlickingError}
   * {@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} When {@link AxesController#init init} is not called before
   * <ko>{@link AxesController#init init}이 이전에 호출되지 않은 경우</ko>
   * @return {this}
   */
  __proto.update = function (controlParams) {
    var _a;
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    var axes = this._axes;
    var axis = axes.axis[POSITION_KEY];
    axis.circular = [controlParams.circular, controlParams.circular];
    axis.range = [controlParams.range.min, controlParams.range.max];
    axis.bounce = parseBounce(flicking.bounce, camera.size);
    axes.axisManager.set((_a = {}, _a[POSITION_KEY] = controlParams.position, _a));
    return this;
  };
  /**
   * Attach a handler to the camera element to prevent click events during animation
   * @ko 카메라 엘리먼트에 애니메이션 도중에 클릭 이벤트를 방지하는 핸들러를 부착합니다
   * @return {this}
   */
  __proto.addPreventClickHandler = function () {
    var flicking = getFlickingAttached(this._flicking);
    var axes = this._axes;
    var cameraEl = flicking.camera.element;
    axes.on(EVENT.HOLD, this._onAxesHold);
    axes.on(EVENT.CHANGE, this._onAxesChange);
    cameraEl.addEventListener("click", this._preventClickWhenDragged, true);
    return this;
  };
  /**
   * Detach a handler to the camera element to prevent click events during animation
   * @ko 카메라 엘리먼트에 애니메이션 도중에 클릭 이벤트를 방지하는 핸들러를 탈착합니다
   * @return {this}
   */
  __proto.removePreventClickHandler = function () {
    var flicking = getFlickingAttached(this._flicking);
    var axes = this._axes;
    var cameraEl = flicking.camera.element;
    axes.off(EVENT.HOLD, this._onAxesHold);
    axes.off(EVENT.CHANGE, this._onAxesChange);
    cameraEl.removeEventListener("click", this._preventClickWhenDragged, true);
    return this;
  };
  /**
   * Run Axes's {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#setTo setTo} using the given position
   * @ko Axes의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#setTo setTo} 메소드를 주어진 좌표를 이용하여 수행합니다
   * @param {number} position A position to move<ko>이동할 좌표</ko>
   * @param {number} duration Duration of the animation (unit: ms)<ko>애니메이션 진행 시간 (단위: ms)</ko>
   * @param {number} [axesEvent] If provided, it'll use its {@link https://naver#github#io/egjs-axes/release/latest/doc/eg#Axes#html#setTo setTo} method instead<ko>이 값이 주어졌을 경우, 해당 이벤트의 {@link https://naver#github#io/egjs-axes/release/latest/doc/eg#Axes#html#setTo setTo} 메소드를 대신해서 사용합니다.</ko>
   * @throws {FlickingError}
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING}|When {@link Control#init init} is not called before|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|When the animation is interrupted by user input|
   * <ko>
   *
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING}|{@link Control#init init}이 이전에 호출되지 않은 경우|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|사용자 입력에 의해 애니메이션이 중단된 경우|
   *
   * </ko>
   * @return {Promise<void>} A Promise which will be resolved after reaching the target position<ko>해당 좌표 도달시에 resolve되는 Promise</ko>
   */
  __proto.animateTo = function (position, duration, axesEvent) {
    var _this = this;
    var _a;
    var axes = this._axes;
    var state = this._stateMachine.state;
    if (!axes) {
      return Promise.reject(new FlickingError(MESSAGE.NOT_ATTACHED_TO_FLICKING, CODE.NOT_ATTACHED_TO_FLICKING));
    }
    var startPos = axes.get([POSITION_KEY])[POSITION_KEY];
    if (startPos === position) {
      var flicking = getFlickingAttached(this._flicking);
      flicking.camera.lookAt(position);
      if (state.targetPanel) {
        flicking.control.setActive(state.targetPanel, flicking.control.activePanel, (_a = axesEvent === null || axesEvent === void 0 ? void 0 : axesEvent.isTrusted) !== null && _a !== void 0 ? _a : false);
      }
      return Promise.resolve();
    }
    this._animatingContext = {
      start: startPos,
      end: position,
      offset: 0
    };
    var animate = function () {
      var _a, _b;
      var resetContext = function () {
        _this._animatingContext = {
          start: 0,
          end: 0,
          offset: 0
        };
      };
      axes.once(EVENT.FINISH, resetContext);
      if (axesEvent) {
        axesEvent.setTo((_a = {}, _a[POSITION_KEY] = position, _a), duration);
      } else {
        axes.setTo((_b = {}, _b[POSITION_KEY] = position, _b), duration);
      }
    };
    return new Promise(function (resolve, reject) {
      var animationFinishHandler = function () {
        axes.off(EVENT.HOLD, interruptionHandler);
        resolve();
      };
      var interruptionHandler = function () {
        axes.off(EVENT.FINISH, animationFinishHandler);
        reject(new FlickingError(MESSAGE.ANIMATION_INTERRUPTED, CODE.ANIMATION_INTERRUPTED));
      };
      axes.once(EVENT.FINISH, animationFinishHandler);
      axes.once(EVENT.HOLD, interruptionHandler);
      animate();
    });
  };
  __proto.updateDirection = function () {
    var flicking = getFlickingAttached(this._flicking);
    var axes = this._axes;
    var panInput = this._panInput;
    axes.disconnect(panInput);
    axes.connect(flicking.horizontal ? [POSITION_KEY, ""] : ["", POSITION_KEY], panInput);
    panInput.options.scale = flicking.horizontal ? [-1, 0] : [0, -1];
  };
  __proto._resetInternalValues = function () {
    this._flicking = null;
    this._axes = null;
    this._panInput = null;
    this._animatingContext = {
      start: 0,
      end: 0,
      offset: 0
    };
    this._dragged = false;
  };
  return AxesController;
}();

/**
 * A component that manages inputs and animation of Flicking
 * @ko Flicking의 입력 장치 & 애니메이션을 담당하는 컴포넌트
 */
var flicking_esm_Control = /*#__PURE__*/function () {
  /** */
  function Control() {
    this._flicking = null;
    this._controller = new flicking_esm_AxesController();
    this._activePanel = null;
  }
  var __proto = Control.prototype;
  Object.defineProperty(__proto, "controller", {
    /**
     * A controller that handles the {@link https://naver.github.io/egjs-axes/ @egjs/axes} events
     * @ko {@link https://naver.github.io/egjs-axes/ @egjs/axes}의 이벤트를 처리하는 컨트롤러 컴포넌트
     * @type {AxesController}
     * @readonly
     */
    get: function () {
      return this._controller;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "activeIndex", {
    /**
     * Index number of the {@link Flicking#currentPanel currentPanel}
     * @ko {@link Flicking#currentPanel currentPanel}의 인덱스 번호
     * @type {number}
     * @default 0
     * @readonly
     */
    get: function () {
      var _a, _b;
      return (_b = (_a = this._activePanel) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : -1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "activePanel", {
    /**
     * An active panel
     * @ko 현재 선택된 패널
     * @type {Panel | null}
     * @readonly
     */
    get: function () {
      return this._activePanel;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "animating", {
    /**
     * Whether Flicking's animating
     * @ko 현재 애니메이션 동작 여부
     * @type {boolean}
     * @readonly
     */
    get: function () {
      return this._controller.state.animating;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "holding", {
    /**
     * Whether user is clicking or touching
     * @ko 현재 사용자가 클릭/터치중인지 여부
     * @type {boolean}
     * @readonly
     */
    get: function () {
      return this._controller.state.holding;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Initialize Control
   * @ko Control을 초기화합니다
   * @param {Flicking} flicking An instance of {@link Flicking}<ko>Flicking의 인스턴스</ko>
   * @chainable
   * @return {this}
   */
  __proto.init = function (flicking) {
    this._flicking = flicking;
    this._controller.init(flicking);
    return this;
  };
  /**
   * Destroy Control and return to initial state
   * @ko Control을 초기 상태로 되돌립니다
   * @return {void}
   */
  __proto.destroy = function () {
    this._controller.destroy();
    this._flicking = null;
    this._activePanel = null;
  };
  /**
   * Enable input from the user (mouse/touch)
   * @ko 사용자의 입력(마우스/터치)를 활성화합니다
   * @chainable
   * @return {this}
   */
  __proto.enable = function () {
    this._controller.enable();
    return this;
  };
  /**
   * Disable input from the user (mouse/touch)
   * @ko 사용자의 입력(마우스/터치)를 막습니다
   * @chainable
   * @return {this}
   */
  __proto.disable = function () {
    this._controller.disable();
    return this;
  };
  /**
   * Releases ongoing user input (mouse/touch)
   * @ko 사용자의 현재 입력(마우스/터치)를 중단시킵니다
   * @chainable
   * @return {this}
   */
  __proto.release = function () {
    this._controller.release();
    return this;
  };
  /**
   * Change the destination and duration of the animation currently playing
   * @ko 재생 중인 애니메이션의 목적지와 재생 시간을 변경합니다
   * @param {Panel} panel The target panel to move<ko>이동할 패널</ko>
   * @param {number} duration Duration of the animation (unit: ms)<ko>애니메이션 진행 시간 (단위: ms)</ko>
   * @param {DIRECTION} direction Direction to move, only available in the {@link Flicking#circular circular} mode<ko>이동할 방향. {@link Flicking#circular circular} 옵션 활성화시에만 사용 가능합니다</ko>
   * @chainable
   * @throws {FlickingError}
   * {@link ERROR_CODE POSITION_NOT_REACHABLE} When the given panel is already removed or not in the Camera's {@link Camera#range range}
   * <ko>{@link ERROR_CODE POSITION_NOT_REACHABLE} 주어진 패널이 제거되었거나, Camera의 {@link Camera#range range} 밖에 있을 경우</ko>
   * @return {this}
   */
  __proto.updateAnimation = function (panel, duration, direction) {
    var state = this._controller.state;
    var position = this._getPosition(panel, direction !== null && direction !== void 0 ? direction : DIRECTION.NONE);
    state.targetPanel = panel;
    this._controller.updateAnimation(position, duration);
    return this;
  };
  /**
   * Stops the animation currently playing
   * @ko 재생 중인 애니메이션을 중단시킵니다
   * @chainable
   * @return {this}
   */
  __proto.stopAnimation = function () {
    var state = this._controller.state;
    state.targetPanel = null;
    this._controller.stopAnimation();
    return this;
  };
  /**
   * Update position after resizing
   * @ko resize 이후에 position을 업데이트합니다
   * @param {number} progressInPanel Previous camera's progress in active panel before resize<ko>Resize 이전 현재 선택된 패널 내에서의 카메라 progress 값</ko>
   * @throws {FlickingError}
   * {@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} When {@link Camera#init init} is not called before
   * <ko>{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} {@link Camera#init init}이 이전에 호출되지 않은 경우</ko>
   * @chainable
   * @return {Promise<void>}
   */
  __proto.updatePosition = function (progressInPanel) {
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    var activePanel = this._activePanel;
    if (activePanel) {
      camera.lookAt(camera.clampToReachablePosition(activePanel.position));
    }
  };
  /**
   * Update {@link Control#controller controller}'s state
   * @ko {@link Control#controller controller}의 내부 상태를 갱신합니다
   * @chainable
   * @return {this}
   */
  __proto.updateInput = function () {
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    this._controller.update(camera.controlParams);
    return this;
  };
  /**
   * Reset {@link Control#activePanel activePanel} to `null`
   * @ko {@link Control#activePanel activePanel}을 `null`로 초기화합니다
   * @chainable
   * @return {this}
   */
  __proto.resetActive = function () {
    this._activePanel = null;
    return this;
  };
  /**
   * Move {@link Camera} to the given panel
   * @ko {@link Camera}를 해당 패널 위로 이동합니다
   * @param {Panel} panel The target panel to move<ko>이동할 패널</ko>
   * @param {object} options An options object<ko>옵션 오브젝트</ko>
   * @param {number} duration Duration of the animation (unit: ms)<ko>애니메이션 진행 시간 (단위: ms)</ko>
   * @param {object} [axesEvent] {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} event of {@link https://naver.github.io/egjs-axes/ Axes}
   * <ko>{@link https://naver.github.io/egjs-axes/ Axes}의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} 이벤트</ko>
   * @param {DIRECTION} [direction=DIRECTION.NONE] Direction to move, only available in the {@link Flicking#circular circular} mode<ko>이동할 방향. {@link Flicking#circular circular} 옵션 활성화시에만 사용 가능합니다</ko>
   * @fires Flicking#moveStart
   * @fires Flicking#move
   * @fires Flicking#moveEnd
   * @fires Flicking#willChange
   * @fires Flicking#changed
   * @fires Flicking#willRestore
   * @fires Flicking#restored
   * @fires Flicking#needPanel
   * @fires Flicking#visibleChange
   * @fires Flicking#reachEdge
   * @throws {FlickingError}
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE POSITION_NOT_REACHABLE}|When the given panel is already removed or not in the Camera's {@link Camera#range range}|
   * |{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING}|When {@link Control#init init} is not called before|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|When the animation is interrupted by user input|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|When the animation is interrupted by user input|
   * <ko>
   *
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE POSITION_NOT_REACHABLE}|주어진 패널이 제거되었거나, Camera의 {@link Camera#range range} 밖에 있을 경우|
   * |{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING}|{@link Control#init init}이 이전에 호출되지 않은 경우|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|사용자 입력에 의해 애니메이션이 중단된 경우|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|발생된 이벤트들 중 하나라도 `stop()`이 호출된 경우|
   *
   * </ko>
   * @return {Promise<void>} A Promise which will be resolved after reaching the target panel<ko>해당 패널 도달시에 resolve되는 Promise</ko>
   */
  __proto.moveToPanel = function (panel, _a) {
    var duration = _a.duration,
      _b = _a.direction,
      direction = _b === void 0 ? DIRECTION.NONE : _b,
      axesEvent = _a.axesEvent;
    return __awaiter(this, void 0, void 0, function () {
      var position;
      return __generator(this, function (_c) {
        position = this._getPosition(panel, direction);
        this._triggerIndexChangeEvent(panel, panel.position, axesEvent);
        return [2 /*return*/, this._animateToPosition({
          position: position,
          duration: duration,
          newActivePanel: panel,
          axesEvent: axesEvent
        })];
      });
    });
  };
  /**
   * @internal
   */
  __proto.setActive = function (newActivePanel, prevActivePanel, isTrusted) {
    var _a;
    var flicking = getFlickingAttached(this._flicking);
    this._activePanel = newActivePanel;
    flicking.camera.updateAdaptiveHeight();
    if (newActivePanel !== prevActivePanel) {
      flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.CHANGED, {
        index: newActivePanel.index,
        panel: newActivePanel,
        prevIndex: (_a = prevActivePanel === null || prevActivePanel === void 0 ? void 0 : prevActivePanel.index) !== null && _a !== void 0 ? _a : -1,
        prevPanel: prevActivePanel,
        isTrusted: isTrusted,
        direction: prevActivePanel ? flicking_esm_getDirection(prevActivePanel.position, newActivePanel.position) : DIRECTION.NONE
      }));
    } else {
      flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.RESTORED, {
        isTrusted: isTrusted
      }));
    }
  };
  /**
   * @internal
   */
  __proto.copy = function (control) {
    this._flicking = control._flicking;
    this._activePanel = control._activePanel;
    this._controller = control._controller;
  };
  __proto._triggerIndexChangeEvent = function (panel, position, axesEvent) {
    var _a;
    var flicking = getFlickingAttached(this._flicking);
    var triggeringEvent = panel !== this._activePanel ? flicking_esm_EVENTS.WILL_CHANGE : flicking_esm_EVENTS.WILL_RESTORE;
    var camera = flicking.camera;
    var activePanel = this._activePanel;
    var event = new ComponentEvent$1(triggeringEvent, {
      index: panel.index,
      panel: panel,
      isTrusted: (axesEvent === null || axesEvent === void 0 ? void 0 : axesEvent.isTrusted) || false,
      direction: flicking_esm_getDirection((_a = activePanel === null || activePanel === void 0 ? void 0 : activePanel.position) !== null && _a !== void 0 ? _a : camera.position, position)
    });
    flicking.trigger(event);
    if (event.isCanceled()) {
      throw new FlickingError(MESSAGE.STOP_CALLED_BY_USER, CODE.STOP_CALLED_BY_USER);
    }
  };
  __proto._animateToPosition = function (_a) {
    var position = _a.position,
      duration = _a.duration,
      newActivePanel = _a.newActivePanel,
      axesEvent = _a.axesEvent;
    return __awaiter(this, void 0, void 0, function () {
      var flicking, animate, state;
      var _this = this;
      return __generator(this, function (_b) {
        flicking = getFlickingAttached(this._flicking);
        animate = function () {
          return _this._controller.animateTo(position, duration, axesEvent);
        };
        state = this._controller.state;
        state.targetPanel = newActivePanel;
        if (duration <= 0) {
          return [2 /*return*/, animate()];
        } else {
          return [2 /*return*/, animate().then(function () {
            return __awaiter(_this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, flicking.renderer.render()];
                  case 1:
                    _a.sent();
                    return [2 /*return*/];
                }
              });
            });
          }).catch(function (err) {
            if (axesEvent && err instanceof FlickingError && err.code === CODE.ANIMATION_INTERRUPTED) return;
            throw err;
          })];
        }
      });
    });
  };

  __proto._getPosition = function (panel, direction) {
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    var position = panel.position;
    var nearestAnchor = camera.findNearestAnchor(position);
    if (panel.removed || !nearestAnchor) {
      throw new FlickingError(MESSAGE.POSITION_NOT_REACHABLE(panel.position), CODE.POSITION_NOT_REACHABLE);
    }
    if (!camera.canReach(panel)) {
      // Override position & panel if that panel is not reachable
      position = nearestAnchor.position;
      panel = nearestAnchor.panel;
    } else if (flicking.circularEnabled) {
      // Circular mode is enabled, find nearest distance to panel
      var camPos_1 = this._controller.position; // Actual position of the Axes
      var camRangeDiff = camera.rangeDiff;
      var possiblePositions = [position, position + camRangeDiff, position - camRangeDiff].filter(function (pos) {
        if (direction === DIRECTION.NONE) return true;
        return direction === DIRECTION.PREV ? pos <= camPos_1 : pos >= camPos_1;
      });
      position = possiblePositions.reduce(function (nearestPosition, pos) {
        if (Math.abs(camPos_1 - pos) < Math.abs(camPos_1 - nearestPosition)) {
          return pos;
        } else {
          return nearestPosition;
        }
      }, Infinity);
    }
    return position;
  };
  return Control;
}();

/**
 * A data component that has actual position where the camera should be stopped at
 * @ko 카메라가 정지해야하는 실제 위치를 담고 있는 데이터 컴포넌트
 */
var AnchorPoint = /*#__PURE__*/function () {
  /**
   * @param {object} options An options object<ko>옵션 객체</ko>
   * @param {number} [options.index] Index of AnchorPoint<ko>AnchorPoint의 인덱스</ko>
   * @param {number} [options.position] Position of AnchorPoint<ko>AnchorPoint의 좌표</ko>
   * @param {Panel} [options.panel] A {@link Panel} instance AnchorPoint is referencing to<ko>AnchorPoint가 참조하고 있는 {@link Panel}</ko>
   */
  function AnchorPoint(_a) {
    var index = _a.index,
      position = _a.position,
      panel = _a.panel;
    this._index = index;
    this._pos = position;
    this._panel = panel;
  }
  var __proto = AnchorPoint.prototype;
  Object.defineProperty(__proto, "index", {
    /**
     * Index of AnchorPoint
     * @ko AnchorPoint의 인덱스
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._index;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "position", {
    /**
     * Position of AnchorPoint
     * @ko AnchorPoint의 좌표
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._pos;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "panel", {
    /**
     * A {@link Panel} instance AnchorPoint is referencing to
     * @ko AnchorPoint가 참조하고 있는 {@link Panel}
     * @type {Panel}
     * @readonly
     */
    get: function () {
      return this._panel;
    },
    enumerable: false,
    configurable: true
  });
  return AnchorPoint;
}();

/**
 * A {@link Control} that uses a release momentum to choose destination panel
 * @ko 입력을 중단한 시점의 가속도에 영향받아 도달할 패널을 계산하는 이동 방식을 사용하는 {@link Control}
 */
var SnapControl = /*#__PURE__*/function (_super) {
  flicking_esm_extends(SnapControl, _super);
  /** */
  function SnapControl(_a) {
    var _b = (_a === void 0 ? {} : _a).count,
      count = _b === void 0 ? Infinity : _b;
    var _this = _super.call(this) || this;
    _this._count = count;
    return _this;
  }
  var __proto = SnapControl.prototype;
  Object.defineProperty(__proto, "count", {
    /**
     * Maximum number of panels can go after release
     * @ko 입력 중단 이후 통과하여 이동할 수 있는 패널의 최대 갯수
     * @type {number}
     * @default Infinity
     */
    get: function () {
      return this._count;
    },
    set: function (val) {
      this._count = val;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Move {@link Camera} to the given position
   * @ko {@link Camera}를 주어진 좌표로 이동합니다
   * @param {number} position The target position to move<ko>이동할 좌표</ko>
   * @param {number} duration Duration of the panel movement animation (unit: ms).<ko>패널 이동 애니메이션 진행 시간 (단위: ms)</ko>
   * @param {object} [axesEvent] {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} event of {@link https://naver.github.io/egjs-axes/ Axes}
   * <ko>{@link https://naver.github.io/egjs-axes/ Axes}의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} 이벤트</ko>
   * @fires Flicking#moveStart
   * @fires Flicking#move
   * @fires Flicking#moveEnd
   * @fires Flicking#willChange
   * @fires Flicking#changed
   * @fires Flicking#willRestore
   * @fires Flicking#restored
   * @fires Flicking#needPanel
   * @fires Flicking#visibleChange
   * @fires Flicking#reachEdge
   * @throws {FlickingError}
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE POSITION_NOT_REACHABLE}|When the given panel is already removed or not in the Camera's {@link Camera#range range}|
   * |{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING}|When {@link Control#init init} is not called before|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|When the animation is interrupted by user input|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|When the animation is interrupted by user input|
   * <ko>
   *
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE POSITION_NOT_REACHABLE}|주어진 패널이 제거되었거나, Camera의 {@link Camera#range range} 밖에 있을 경우|
   * |{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING}|{@link Control#init init}이 이전에 호출되지 않은 경우|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|사용자 입력에 의해 애니메이션이 중단된 경우|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|발생된 이벤트들 중 하나라도 `stop()`이 호출된 경우|
   *
   * </ko>
   * @return {Promise<void>} A Promise which will be resolved after reaching the target position<ko>해당 좌표 도달시에 resolve되는 Promise</ko>
   */
  __proto.moveToPosition = function (position, duration, axesEvent) {
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    var activeAnchor = camera.findActiveAnchor();
    var anchorAtCamera = camera.findNearestAnchor(camera.position);
    var state = this._controller.state;
    if (!activeAnchor || !anchorAtCamera) {
      return Promise.reject(new FlickingError(MESSAGE.POSITION_NOT_REACHABLE(position), CODE.POSITION_NOT_REACHABLE));
    }
    var snapThreshold = this._calcSnapThreshold(position, activeAnchor);
    var posDelta = flicking.animating ? state.delta : position - camera.position;
    var absPosDelta = Math.abs(posDelta);
    var snapDelta = axesEvent && axesEvent.delta[POSITION_KEY] !== 0 ? Math.abs(axesEvent.delta[POSITION_KEY]) : absPosDelta;
    var targetAnchor;
    if (snapDelta >= snapThreshold && snapDelta > 0) {
      // Move to anchor at position
      targetAnchor = this._findSnappedAnchor(position, anchorAtCamera);
    } else if (absPosDelta >= flicking.threshold && absPosDelta > 0) {
      // Move to the adjacent panel
      targetAnchor = this._findAdjacentAnchor(position, posDelta, anchorAtCamera);
    } else {
      // Fallback to nearest panel from current camera
      return this.moveToPanel(anchorAtCamera.panel, {
        duration: duration,
        axesEvent: axesEvent
      });
    }
    this._triggerIndexChangeEvent(targetAnchor.panel, position, axesEvent);
    return this._animateToPosition({
      position: camera.clampToReachablePosition(targetAnchor.position),
      duration: duration,
      newActivePanel: targetAnchor.panel,
      axesEvent: axesEvent
    });
  };
  __proto._findSnappedAnchor = function (position, anchorAtCamera) {
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    var count = this._count;
    var currentPos = camera.position;
    var clampedPosition = camera.clampToReachablePosition(position);
    var anchorAtPosition = camera.findAnchorIncludePosition(clampedPosition);
    if (!anchorAtCamera || !anchorAtPosition) {
      throw new FlickingError(MESSAGE.POSITION_NOT_REACHABLE(position), CODE.POSITION_NOT_REACHABLE);
    }
    if (!isFinite(count)) {
      return anchorAtPosition;
    }
    var panelCount = flicking.panelCount;
    var anchors = camera.anchorPoints;
    var loopCount = Math.sign(position - currentPos) * Math.floor(Math.abs(position - currentPos) / camera.rangeDiff);
    if (position > currentPos && anchorAtPosition.index < anchorAtCamera.index || anchorAtPosition.position > anchorAtCamera.position && anchorAtPosition.index === anchorAtCamera.index) {
      loopCount += 1;
    } else if (position < currentPos && anchorAtPosition.index > anchorAtCamera.index || anchorAtPosition.position < anchorAtCamera.position && anchorAtPosition.index === anchorAtCamera.index) {
      loopCount -= 1;
    }
    var circularIndexOffset = loopCount * panelCount;
    var anchorAtPositionIndex = anchorAtPosition.index + circularIndexOffset;
    if (Math.abs(anchorAtPositionIndex - anchorAtCamera.index) <= count) {
      var anchor = anchors[anchorAtPosition.index];
      return new AnchorPoint({
        index: anchor.index,
        position: anchor.position + loopCount * camera.rangeDiff,
        panel: anchor.panel
      });
    }
    if (flicking.circularEnabled) {
      var targetAnchor = anchors[circulateIndex(anchorAtCamera.index + Math.sign(position - currentPos) * count, panelCount)];
      var loop = Math.floor(count / panelCount);
      if (position > currentPos && targetAnchor.index < anchorAtCamera.index) {
        loop += 1;
      } else if (position < currentPos && targetAnchor.index > anchorAtCamera.index) {
        loop -= 1;
      }
      return new AnchorPoint({
        index: targetAnchor.index,
        position: targetAnchor.position + loop * camera.rangeDiff,
        panel: targetAnchor.panel
      });
    } else {
      return anchors[flicking_esm_clamp(anchorAtCamera.index + Math.sign(position - currentPos) * count, 0, anchors.length - 1)];
    }
  };
  __proto._findAdjacentAnchor = function (position, posDelta, anchorAtCamera) {
    var _a;
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    if (camera.circularEnabled) {
      var anchorIncludePosition = camera.findAnchorIncludePosition(position);
      if (anchorIncludePosition && anchorIncludePosition.position !== anchorAtCamera.position) {
        return anchorIncludePosition;
      }
    }
    var adjacentAnchor = (_a = posDelta > 0 ? camera.getNextAnchor(anchorAtCamera) : camera.getPrevAnchor(anchorAtCamera)) !== null && _a !== void 0 ? _a : anchorAtCamera;
    return adjacentAnchor;
  };
  __proto._calcSnapThreshold = function (position, activeAnchor) {
    var isNextDirection = position > activeAnchor.position;
    var panel = activeAnchor.panel;
    var panelSize = panel.size;
    var alignPos = panel.alignPosition;
    // Minimum distance needed to decide prev/next panel as nearest
    /*
     * |  Prev  |     Next     |
     * |<------>|<------------>|
     * [        |<-Anchor      ]
     */
    return isNextDirection ? panelSize - alignPos + panel.margin.next : alignPos + panel.margin.prev;
  };
  return SnapControl;
}(flicking_esm_Control);

/**
 * A {@link Control} that can be scrolled freely without alignment
 * @ko 패널이 정해진 지점에 정렬되지 않고, 자유롭게 스크롤할 수 있는 이동 방식을 사용하는 {@link Control}
 */
var FreeControl = /*#__PURE__*/function (_super) {
  flicking_esm_extends(FreeControl, _super);
  /** */
  function FreeControl(_a) {
    var _b = (_a === void 0 ? {} : _a).stopAtEdge,
      stopAtEdge = _b === void 0 ? true : _b;
    var _this = _super.call(this) || this;
    _this._stopAtEdge = stopAtEdge;
    return _this;
  }
  var __proto = FreeControl.prototype;
  Object.defineProperty(__proto, "stopAtEdge", {
    /**
     * Make scroll animation to stop at the start/end of the scroll area, not going out the bounce area
     * @ko 스크롤 애니메이션을 스크롤 영역의 시작과 끝부분에서 멈추도록 하여, 바운스 영역을 넘어가지 않도록 합니다
     * @type {boolean}
     * @default true
     */
    get: function () {
      return this._stopAtEdge;
    },
    set: function (val) {
      this._stopAtEdge = val;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Update position after resizing
   * @ko resize 이후에 position을 업데이트합니다
   * @param {number} progressInPanel Previous camera's progress in active panel before resize<ko>Resize 이전 현재 선택된 패널 내에서의 카메라 progress 값</ko>
   * @throws {FlickingError}
   * {@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} When {@link Camera#init init} is not called before
   * <ko>{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} {@link Camera#init init}이 이전에 호출되지 않은 경우</ko>
   * @chainable
   * @return {Promise<void>}
   */
  __proto.updatePosition = function (progressInPanel) {
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    var activePanel = this._activePanel;
    if (activePanel) {
      var panelRange = activePanel.range;
      var newPosition = panelRange.min + (panelRange.max - panelRange.min) * progressInPanel;
      camera.lookAt(camera.clampToReachablePosition(newPosition));
    }
  };
  /**
   * Move {@link Camera} to the given position
   * @ko {@link Camera}를 주어진 좌표로 이동합니다
   * @param {number} position The target position to move<ko>이동할 좌표</ko>
   * @param {number} duration Duration of the panel movement animation (unit: ms).<ko>패널 이동 애니메이션 진행 시간 (단위: ms)</ko>
   * @param {object} [axesEvent] {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} event of {@link https://naver.github.io/egjs-axes/ Axes}
   * <ko>{@link https://naver.github.io/egjs-axes/ Axes}의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} 이벤트</ko>
   * @fires Flicking#moveStart
   * @fires Flicking#move
   * @fires Flicking#moveEnd
   * @fires Flicking#willChange
   * @fires Flicking#changed
   * @fires Flicking#willRestore
   * @fires Flicking#restored
   * @fires Flicking#needPanel
   * @fires Flicking#visibleChange
   * @fires Flicking#reachEdge
   * @throws {FlickingError}
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE POSITION_NOT_REACHABLE}|When the given panel is already removed or not in the Camera's {@link Camera#range range}|
   * |{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING}|When {@link Control#init init} is not called before|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|When the animation is interrupted by user input|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|When the animation is interrupted by user input|
   * <ko>
   *
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE POSITION_NOT_REACHABLE}|주어진 패널이 제거되었거나, Camera의 {@link Camera#range range} 밖에 있을 경우|
   * |{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING}|{@link Control#init init}이 이전에 호출되지 않은 경우|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|사용자 입력에 의해 애니메이션이 중단된 경우|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|발생된 이벤트들 중 하나라도 `stop()`이 호출된 경우|
   *
   * </ko>
   * @return {Promise<void>} A Promise which will be resolved after reaching the target position<ko>해당 좌표 도달시에 resolve되는 Promise</ko>
   */
  __proto.moveToPosition = function (position, duration, axesEvent) {
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    var targetPos = camera.clampToReachablePosition(position);
    var anchorAtPosition = camera.findAnchorIncludePosition(targetPos);
    if (!anchorAtPosition) {
      return Promise.reject(new FlickingError(MESSAGE.POSITION_NOT_REACHABLE(position), CODE.POSITION_NOT_REACHABLE));
    }
    var targetPanel = anchorAtPosition.panel;
    // Trigger only change event
    if (targetPanel !== this._activePanel) {
      this._triggerIndexChangeEvent(targetPanel, position, axesEvent);
    }
    return this._animateToPosition({
      position: this._stopAtEdge ? targetPos : position,
      duration: duration,
      newActivePanel: targetPanel,
      axesEvent: axesEvent
    });
  };
  return FreeControl;
}(flicking_esm_Control);

/**
 * A {@link Control} that allow you to select the maximum number of panels to move at a time
 * @ko 한번에 최대로 이동할 패널의 개수를 선택 가능한 {@link Control}
 */
var StrictControl = /*#__PURE__*/function (_super) {
  flicking_esm_extends(StrictControl, _super);
  /** */
  function StrictControl(_a) {
    var _b = (_a === void 0 ? {} : _a).count,
      count = _b === void 0 ? 1 : _b;
    var _this = _super.call(this) || this;
    _this.setActive = function (newActivePanel, prevActivePanel, isTrusted) {
      _super.prototype.setActive.call(_this, newActivePanel, prevActivePanel, isTrusted);
      _this.updateInput();
    };
    _this._count = count;
    _this._resetIndexRange();
    return _this;
  }
  var __proto = StrictControl.prototype;
  Object.defineProperty(__proto, "count", {
    /**
     * Maximum number of panels that can be moved at a time
     * @ko 최대로 움직일 수 있는 패널의 개수
     * @type {number}
     * @default 1
     */
    get: function () {
      return this._count;
    },
    set: function (val) {
      this._count = val;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Destroy Control and return to initial state
   * @ko Control을 초기 상태로 되돌립니다
   * @return {void}
   */
  __proto.destroy = function () {
    _super.prototype.destroy.call(this);
    this._resetIndexRange();
  };
  /**
   * Update {@link Control#controller controller}'s state
   * @ko {@link Control#controller controller}의 내부 상태를 갱신합니다
   * @chainable
   * @return {this}
   */
  __proto.updateInput = function () {
    var _a;
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    var renderer = flicking.renderer;
    var controller = this._controller;
    var controlParams = camera.controlParams;
    var count = this._count;
    var activePanel = controller.state.animating ? (_a = camera.findNearestAnchor(camera.position)) === null || _a === void 0 ? void 0 : _a.panel : this._activePanel;
    if (!activePanel) {
      controller.update(controlParams);
      this._resetIndexRange();
      return this;
    }
    var cameraRange = controlParams.range;
    var currentPos = activePanel.position;
    var currentIndex = activePanel.index;
    var panelCount = renderer.panelCount;
    var prevPanelIndex = currentIndex - count;
    var nextPanelIndex = currentIndex + count;
    if (prevPanelIndex < 0) {
      prevPanelIndex = flicking.circularEnabled ? getMinusCompensatedIndex((prevPanelIndex + 1) % panelCount - 1, panelCount) : flicking_esm_clamp(prevPanelIndex, 0, panelCount - 1);
    }
    if (nextPanelIndex >= panelCount) {
      nextPanelIndex = flicking.circularEnabled ? nextPanelIndex % panelCount : flicking_esm_clamp(nextPanelIndex, 0, panelCount - 1);
    }
    var prevPanel = renderer.panels[prevPanelIndex];
    var nextPanel = renderer.panels[nextPanelIndex];
    var prevPos = Math.max(prevPanel.position, cameraRange.min);
    var nextPos = Math.min(nextPanel.position, cameraRange.max);
    if (prevPos > currentPos) {
      prevPos -= camera.rangeDiff;
    }
    if (nextPos < currentPos) {
      nextPos += camera.rangeDiff;
    }
    controlParams.range = {
      min: prevPos,
      max: nextPos
    };
    if (controlParams.circular) {
      if (controlParams.position < prevPos) {
        controlParams.position += camera.rangeDiff;
      }
      if (controlParams.position > nextPos) {
        controlParams.position -= camera.rangeDiff;
      }
    }
    controlParams.circular = false;
    controller.update(controlParams);
    this._indexRange = {
      min: prevPanel.index,
      max: nextPanel.index
    };
    return this;
  };
  __proto.moveToPanel = function (panel, options) {
    return __awaiter(this, void 0, void 0, function () {
      var flicking, camera, controller;
      return __generator(this, function (_a) {
        flicking = getFlickingAttached(this._flicking);
        camera = flicking.camera;
        controller = this._controller;
        controller.update(camera.controlParams);
        return [2 /*return*/, _super.prototype.moveToPanel.call(this, panel, options)];
      });
    });
  };
  /**
   * Move {@link Camera} to the given position
   * @ko {@link Camera}를 주어진 좌표로 이동합니다
   * @param {number} position The target position to move<ko>이동할 좌표</ko>
   * @param {number} duration Duration of the panel movement animation (unit: ms).<ko>패널 이동 애니메이션 진행 시간 (단위: ms)</ko>
   * @param {object} [axesEvent] {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} event of {@link https://naver.github.io/egjs-axes/ Axes}
   * <ko>{@link https://naver.github.io/egjs-axes/ Axes}의 {@link https://naver.github.io/egjs-axes/release/latest/doc/eg.Axes.html#event:release release} 이벤트</ko>
   * @fires Flicking#moveStart
   * @fires Flicking#move
   * @fires Flicking#moveEnd
   * @fires Flicking#willChange
   * @fires Flicking#changed
   * @fires Flicking#willRestore
   * @fires Flicking#restored
   * @fires Flicking#needPanel
   * @fires Flicking#visibleChange
   * @fires Flicking#reachEdge
   * @throws {FlickingError}
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE POSITION_NOT_REACHABLE}|When the given panel is already removed or not in the Camera's {@link Camera#range range}|
   * |{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING}|When {@link Control#init init} is not called before|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|When the animation is interrupted by user input|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|When the animation is interrupted by user input|
   * <ko>
   *
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE POSITION_NOT_REACHABLE}|주어진 패널이 제거되었거나, Camera의 {@link Camera#range range} 밖에 있을 경우|
   * |{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING}|{@link Control#init init}이 이전에 호출되지 않은 경우|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|사용자 입력에 의해 애니메이션이 중단된 경우|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|발생된 이벤트들 중 하나라도 `stop()`이 호출된 경우|
   *
   * </ko>
   * @return {Promise<void>} A Promise which will be resolved after reaching the target position<ko>해당 좌표 도달시에 resolve되는 Promise</ko>
   */
  __proto.moveToPosition = function (position, duration, axesEvent) {
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    var activePanel = this._activePanel;
    var axesRange = this._controller.range;
    var indexRange = this._indexRange;
    var cameraRange = camera.range;
    var state = this._controller.state;
    var clampedPosition = flicking_esm_clamp(camera.clampToReachablePosition(position), axesRange[0], axesRange[1]);
    var anchorAtPosition = camera.findAnchorIncludePosition(clampedPosition);
    if (!anchorAtPosition || !activePanel) {
      return Promise.reject(new FlickingError(MESSAGE.POSITION_NOT_REACHABLE(position), CODE.POSITION_NOT_REACHABLE));
    }
    var prevPos = activePanel.position;
    var posDelta = flicking.animating ? state.delta : position - camera.position;
    var isOverThreshold = Math.abs(posDelta) >= flicking.threshold;
    var adjacentAnchor = position > prevPos ? camera.getNextAnchor(anchorAtPosition) : camera.getPrevAnchor(anchorAtPosition);
    var targetPos;
    var targetPanel;
    var anchors = camera.anchorPoints;
    var firstAnchor = anchors[0];
    var lastAnchor = anchors[anchors.length - 1];
    var shouldBounceToFirst = position <= cameraRange.min && isBetween(firstAnchor.panel.index, indexRange.min, indexRange.max);
    var shouldBounceToLast = position >= cameraRange.max && isBetween(lastAnchor.panel.index, indexRange.min, indexRange.max);
    var isAdjacent = adjacentAnchor && (indexRange.min <= indexRange.max ? isBetween(adjacentAnchor.index, indexRange.min, indexRange.max) : adjacentAnchor.index >= indexRange.min || adjacentAnchor.index <= indexRange.max);
    if (shouldBounceToFirst || shouldBounceToLast) {
      // In bounce area
      var targetAnchor = position < cameraRange.min ? firstAnchor : lastAnchor;
      targetPanel = targetAnchor.panel;
      targetPos = targetAnchor.position;
    } else if (isOverThreshold && anchorAtPosition.position !== activePanel.position) {
      // Move to anchor at position
      targetPanel = anchorAtPosition.panel;
      targetPos = anchorAtPosition.position;
    } else if (isOverThreshold && isAdjacent) {
      // Move to adjacent anchor
      targetPanel = adjacentAnchor.panel;
      targetPos = adjacentAnchor.position;
    } else {
      // Fallback to nearest panel from current camera
      var anchorAtCamera = camera.findNearestAnchor(camera.position);
      if (!anchorAtCamera) {
        return Promise.reject(new FlickingError(MESSAGE.POSITION_NOT_REACHABLE(position), CODE.POSITION_NOT_REACHABLE));
      }
      return this.moveToPanel(anchorAtCamera.panel, {
        duration: duration,
        axesEvent: axesEvent
      });
    }
    this._triggerIndexChangeEvent(targetPanel, position, axesEvent);
    return this._animateToPosition({
      position: targetPos,
      duration: duration,
      newActivePanel: targetPanel,
      axesEvent: axesEvent
    });
  };
  __proto._resetIndexRange = function () {
    this._indexRange = {
      min: 0,
      max: 0
    };
  };
  return StrictControl;
}(flicking_esm_Control);

/**
 * A mode of camera
 */
var CameraMode = /*#__PURE__*/function () {
  /** */
  function CameraMode(flicking) {
    this._flicking = flicking;
  }
  var __proto = CameraMode.prototype;
  __proto.getAnchors = function () {
    var panels = this._flicking.renderer.panels;
    return panels.map(function (panel, index) {
      return new AnchorPoint({
        index: index,
        position: panel.position,
        panel: panel
      });
    });
  };
  __proto.findAnchorIncludePosition = function (position) {
    var anchors = this._flicking.camera.anchorPoints;
    var anchorsIncludingPosition = anchors.filter(function (anchor) {
      return anchor.panel.includePosition(position, true);
    });
    return anchorsIncludingPosition.reduce(function (nearest, anchor) {
      if (!nearest) return anchor;
      return Math.abs(nearest.position - position) < Math.abs(anchor.position - position) ? nearest : anchor;
    }, null);
  };
  __proto.findNearestAnchor = function (position) {
    var anchors = this._flicking.camera.anchorPoints;
    if (anchors.length <= 0) return null;
    var prevDist = Infinity;
    for (var anchorIdx = 0; anchorIdx < anchors.length; anchorIdx++) {
      var anchor = anchors[anchorIdx];
      var dist = Math.abs(anchor.position - position);
      if (dist > prevDist) {
        // Return previous anchor
        return anchors[anchorIdx - 1];
      }
      prevDist = dist;
    }
    // Return last anchor
    return anchors[anchors.length - 1];
  };
  __proto.clampToReachablePosition = function (position) {
    var camera = this._flicking.camera;
    var range = camera.range;
    return flicking_esm_clamp(position, range.min, range.max);
  };
  __proto.getCircularOffset = function () {
    return 0;
  };
  __proto.canReach = function (panel) {
    var camera = this._flicking.camera;
    var range = camera.range;
    if (panel.removed) return false;
    var panelPos = panel.position;
    return panelPos >= range.min && panelPos <= range.max;
  };
  __proto.canSee = function (panel) {
    var camera = this._flicking.camera;
    var visibleRange = camera.visibleRange;
    // Should not include margin, as we don't declare what the margin is visible as what the panel is visible.
    return panel.isVisibleOnRange(visibleRange.min, visibleRange.max);
  };
  return CameraMode;
}();

var LinearCameraMode = /*#__PURE__*/function (_super) {
  flicking_esm_extends(LinearCameraMode, _super);
  function LinearCameraMode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  var __proto = LinearCameraMode.prototype;
  __proto.checkAvailability = function () {
    // It's always available
    return true;
  };
  __proto.getRange = function () {
    var _a, _b;
    var renderer = this._flicking.renderer;
    var firstPanel = renderer.getPanel(0);
    var lastPanel = renderer.getPanel(renderer.panelCount - 1);
    return {
      min: (_a = firstPanel === null || firstPanel === void 0 ? void 0 : firstPanel.position) !== null && _a !== void 0 ? _a : 0,
      max: (_b = lastPanel === null || lastPanel === void 0 ? void 0 : lastPanel.position) !== null && _b !== void 0 ? _b : 0
    };
  };
  return LinearCameraMode;
}(CameraMode);

/**
 * A {@link Camera} mode that connects the last panel and the first panel, enabling continuous loop
 * @ko 첫번째 패널과 마지막 패널이 이어진 상태로, 무한히 회전할 수 있는 종류의 {@link Camera} 모드
 */
var CircularCameraMode = /*#__PURE__*/function (_super) {
  flicking_esm_extends(CircularCameraMode, _super);
  function CircularCameraMode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  var __proto = CircularCameraMode.prototype;
  __proto.checkAvailability = function () {
    var flicking = this._flicking;
    var renderer = flicking.renderer;
    var panels = renderer.panels;
    if (panels.length <= 0) {
      return false;
    }
    var firstPanel = panels[0];
    var lastPanel = panels[panels.length - 1];
    var firstPanelPrev = firstPanel.range.min - firstPanel.margin.prev;
    var lastPanelNext = lastPanel.range.max + lastPanel.margin.next;
    var visibleSize = flicking.camera.size;
    var panelSizeSum = lastPanelNext - firstPanelPrev;
    var canSetCircularMode = panels.every(function (panel) {
      return panelSizeSum - panel.size >= visibleSize;
    });
    return canSetCircularMode;
  };
  __proto.getRange = function () {
    var flicking = this._flicking;
    var panels = flicking.renderer.panels;
    if (panels.length <= 0) {
      return {
        min: 0,
        max: 0
      };
    }
    var firstPanel = panels[0];
    var lastPanel = panels[panels.length - 1];
    var firstPanelPrev = firstPanel.range.min - firstPanel.margin.prev;
    var lastPanelNext = lastPanel.range.max + lastPanel.margin.next;
    return {
      min: firstPanelPrev,
      max: lastPanelNext
    };
  };
  __proto.getAnchors = function () {
    var flicking = this._flicking;
    var panels = flicking.renderer.panels;
    return panels.map(function (panel, index) {
      return new AnchorPoint({
        index: index,
        position: panel.position,
        panel: panel
      });
    });
  };
  __proto.findNearestAnchor = function (position) {
    var camera = this._flicking.camera;
    var anchors = camera.anchorPoints;
    if (anchors.length <= 0) return null;
    var camRange = camera.range;
    var minDist = Infinity;
    var minDistIndex = -1;
    for (var anchorIdx = 0; anchorIdx < anchors.length; anchorIdx++) {
      var anchor = anchors[anchorIdx];
      var dist = Math.min(Math.abs(anchor.position - position), Math.abs(anchor.position - camRange.min + camRange.max - position), Math.abs(position - camRange.min + camRange.max - anchor.position));
      if (dist < minDist) {
        minDist = dist;
        minDistIndex = anchorIdx;
      }
    }
    // Return last anchor
    return anchors[minDistIndex];
  };
  __proto.findAnchorIncludePosition = function (position) {
    var camera = this._flicking.camera;
    var range = camera.range;
    var anchors = camera.anchorPoints;
    var rangeDiff = camera.rangeDiff;
    var anchorCount = anchors.length;
    var positionInRange = circulatePosition(position, range.min, range.max);
    var anchorInRange = _super.prototype.findAnchorIncludePosition.call(this, positionInRange);
    if (anchorCount > 0 && (position === range.min || position === range.max)) {
      var possibleAnchors = [anchorInRange, new AnchorPoint({
        index: 0,
        position: anchors[0].position + rangeDiff,
        panel: anchors[0].panel
      }), new AnchorPoint({
        index: anchorCount - 1,
        position: anchors[anchorCount - 1].position - rangeDiff,
        panel: anchors[anchorCount - 1].panel
      })].filter(function (anchor) {
        return !!anchor;
      });
      anchorInRange = possibleAnchors.reduce(function (nearest, anchor) {
        if (!nearest) return anchor;
        return Math.abs(nearest.position - position) < Math.abs(anchor.position - position) ? nearest : anchor;
      }, null);
    }
    if (!anchorInRange) return null;
    if (position < range.min) {
      var loopCount = -Math.floor((range.min - position) / rangeDiff) - 1;
      return new AnchorPoint({
        index: anchorInRange.index,
        position: anchorInRange.position + rangeDiff * loopCount,
        panel: anchorInRange.panel
      });
    } else if (position > range.max) {
      var loopCount = Math.floor((position - range.max) / rangeDiff) + 1;
      return new AnchorPoint({
        index: anchorInRange.index,
        position: anchorInRange.position + rangeDiff * loopCount,
        panel: anchorInRange.panel
      });
    }
    return anchorInRange;
  };
  __proto.getCircularOffset = function () {
    var flicking = this._flicking;
    var camera = flicking.camera;
    if (!camera.circularEnabled) return 0;
    var toggled = flicking.panels.filter(function (panel) {
      return panel.toggled;
    });
    var toggledPrev = toggled.filter(function (panel) {
      return panel.toggleDirection === DIRECTION.PREV;
    });
    var toggledNext = toggled.filter(function (panel) {
      return panel.toggleDirection === DIRECTION.NEXT;
    });
    return this._calcPanelAreaSum(toggledPrev) - this._calcPanelAreaSum(toggledNext);
  };
  __proto.clampToReachablePosition = function (position) {
    // Basically all position is reachable for circular camera
    return position;
  };
  __proto.canReach = function (panel) {
    if (panel.removed) return false;
    // Always reachable on circular mode
    return true;
  };
  __proto.canSee = function (panel) {
    var camera = this._flicking.camera;
    var range = camera.range;
    var rangeDiff = camera.rangeDiff;
    var visibleRange = camera.visibleRange;
    var visibleInCurrentRange = _super.prototype.canSee.call(this, panel);
    // Check looped visible area for circular case
    if (visibleRange.min < range.min) {
      return visibleInCurrentRange || panel.isVisibleOnRange(visibleRange.min + rangeDiff, visibleRange.max + rangeDiff);
    } else if (visibleRange.max > range.max) {
      return visibleInCurrentRange || panel.isVisibleOnRange(visibleRange.min - rangeDiff, visibleRange.max - rangeDiff);
    }
    return visibleInCurrentRange;
  };
  __proto._calcPanelAreaSum = function (panels) {
    return panels.reduce(function (sum, panel) {
      return sum + panel.sizeIncludingMargin;
    }, 0);
  };
  return CircularCameraMode;
}(CameraMode);

var BoundCameraMode = /*#__PURE__*/function (_super) {
  flicking_esm_extends(BoundCameraMode, _super);
  function BoundCameraMode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  var __proto = BoundCameraMode.prototype;
  __proto.checkAvailability = function () {
    var flicking = this._flicking;
    var renderer = flicking.renderer;
    var firstPanel = renderer.getPanel(0);
    var lastPanel = renderer.getPanel(renderer.panelCount - 1);
    if (!firstPanel || !lastPanel) {
      return false;
    }
    var viewportSize = flicking.camera.size;
    var firstPanelPrev = firstPanel.range.min;
    var lastPanelNext = lastPanel.range.max;
    var panelAreaSize = lastPanelNext - firstPanelPrev;
    var isBiggerThanViewport = viewportSize < panelAreaSize;
    return isBiggerThanViewport;
  };
  __proto.getRange = function () {
    var flicking = this._flicking;
    var renderer = flicking.renderer;
    var alignPos = flicking.camera.alignPosition;
    var firstPanel = renderer.getPanel(0);
    var lastPanel = renderer.getPanel(renderer.panelCount - 1);
    if (!firstPanel || !lastPanel) {
      return {
        min: 0,
        max: 0
      };
    }
    var viewportSize = flicking.camera.size;
    var firstPanelPrev = firstPanel.range.min;
    var lastPanelNext = lastPanel.range.max;
    var panelAreaSize = lastPanelNext - firstPanelPrev;
    var isBiggerThanViewport = viewportSize < panelAreaSize;
    var firstPos = firstPanelPrev + alignPos;
    var lastPos = lastPanelNext - viewportSize + alignPos;
    if (isBiggerThanViewport) {
      return {
        min: firstPos,
        max: lastPos
      };
    } else {
      var align = flicking.camera.align;
      var alignVal = typeof align === "object" ? align.camera : align;
      var pos = firstPos + parseAlign$1(alignVal, lastPos - firstPos);
      return {
        min: pos,
        max: pos
      };
    }
  };
  __proto.getAnchors = function () {
    var flicking = this._flicking;
    var camera = flicking.camera;
    var panels = flicking.renderer.panels;
    if (panels.length <= 0) {
      return [];
    }
    var range = flicking.camera.range;
    var reachablePanels = panels.filter(function (panel) {
      return camera.canReach(panel);
    });
    if (reachablePanels.length > 0) {
      var shouldPrependBoundAnchor = reachablePanels[0].position !== range.min;
      var shouldAppendBoundAnchor = reachablePanels[reachablePanels.length - 1].position !== range.max;
      var indexOffset_1 = shouldPrependBoundAnchor ? 1 : 0;
      var newAnchors = reachablePanels.map(function (panel, idx) {
        return new AnchorPoint({
          index: idx + indexOffset_1,
          position: panel.position,
          panel: panel
        });
      });
      if (shouldPrependBoundAnchor) {
        newAnchors.splice(0, 0, new AnchorPoint({
          index: 0,
          position: range.min,
          panel: panels[reachablePanels[0].index - 1]
        }));
      }
      if (shouldAppendBoundAnchor) {
        newAnchors.push(new AnchorPoint({
          index: newAnchors.length,
          position: range.max,
          panel: panels[reachablePanels[reachablePanels.length - 1].index + 1]
        }));
      }
      return newAnchors;
    } else if (range.min !== range.max) {
      // There're more than 2 panels
      var nearestPanelAtMin = this._findNearestPanel(range.min, panels);
      var panelAtMin = nearestPanelAtMin.index === panels.length - 1 ? nearestPanelAtMin.prev() : nearestPanelAtMin;
      var panelAtMax = panelAtMin.next();
      return [new AnchorPoint({
        index: 0,
        position: range.min,
        panel: panelAtMin
      }), new AnchorPoint({
        index: 1,
        position: range.max,
        panel: panelAtMax
      })];
    } else {
      return [new AnchorPoint({
        index: 0,
        position: range.min,
        panel: this._findNearestPanel(range.min, panels)
      })];
    }
  };
  __proto.findAnchorIncludePosition = function (position) {
    var camera = this._flicking.camera;
    var range = camera.range;
    var anchors = camera.anchorPoints;
    if (anchors.length <= 0) return null;
    if (position <= range.min) {
      return anchors[0];
    } else if (position >= range.max) {
      return anchors[anchors.length - 1];
    } else {
      return _super.prototype.findAnchorIncludePosition.call(this, position);
    }
  };
  __proto._findNearestPanel = function (pos, panels) {
    var prevDist = Infinity;
    for (var panelIdx = 0; panelIdx < panels.length; panelIdx++) {
      var panel = panels[panelIdx];
      var dist = Math.abs(panel.position - pos);
      if (dist > prevDist) {
        // Return previous anchor
        return panels[panelIdx - 1];
      }
      prevDist = dist;
    }
    // Return last anchor
    return panels[panels.length - 1];
  };
  return BoundCameraMode;
}(CameraMode);

/**
 * A component that manages actual movement inside the viewport
 * @ko 뷰포트 내에서의 실제 움직임을 담당하는 컴포넌트
 */
var flicking_esm_Camera = /*#__PURE__*/function () {
  /** */
  function Camera(flicking, _a) {
    var _this = this;
    var _b = (_a === void 0 ? {} : _a).align,
      align = _b === void 0 ? ALIGN.CENTER : _b;
    this._checkTranslateSupport = function () {
      var e_1, _a;
      var transforms = ["webkitTransform", "msTransform", "MozTransform", "OTransform", "transform"];
      var supportedStyle = document.documentElement.style;
      var transformName = "";
      try {
        for (var transforms_1 = flicking_esm_values(transforms), transforms_1_1 = transforms_1.next(); !transforms_1_1.done; transforms_1_1 = transforms_1.next()) {
          var prefixedTransform = transforms_1_1.value;
          if (prefixedTransform in supportedStyle) {
            transformName = prefixedTransform;
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (transforms_1_1 && !transforms_1_1.done && (_a = transforms_1.return)) _a.call(transforms_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      if (!transformName) {
        throw new FlickingError(MESSAGE.TRANSFORM_NOT_SUPPORTED, CODE.TRANSFORM_NOT_SUPPORTED);
      }
      _this._transform = transformName;
    };
    this._flicking = flicking;
    this._resetInternalValues();
    // Options
    this._align = align;
  }
  var __proto = Camera.prototype;
  Object.defineProperty(__proto, "element", {
    // Internal states getter
    /**
     * The camera element(`.flicking-camera`)
     * @ko 카메라 엘리먼트(`.flicking-camera`)
     * @type {HTMLElement}
     * @readonly
     */
    get: function () {
      return this._el;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "children", {
    /**
     * An array of the child elements of the camera element(`.flicking-camera`)
     * @ko 카메라 엘리먼트(`.flicking-camera`)의 자식 엘리먼트 배열
     * @type {HTMLElement[]}
     * @readonly
     */
    get: function () {
      return flicking_esm_toArray(this._el.children);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "position", {
    /**
     * Current position of the camera
     * @ko Camera의 현재 좌표
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._position;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "alignPosition", {
    /**
     * Align position inside the viewport where {@link Panel}'s {@link Panel#alignPosition alignPosition} should be located at
     * @ko 패널의 정렬 기준 위치. 뷰포트 내에서 {@link Panel}의 {@link Panel#alignPosition alignPosition}이 위치해야 하는 곳입니다
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._alignPos;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "offset", {
    /**
     * Position offset, used for the {@link Flicking#renderOnlyVisible renderOnlyVisible} option
     * @ko Camera의 좌표 오프셋. {@link Flicking#renderOnlyVisible renderOnlyVisible} 옵션을 위해 사용됩니다.
     * @type {number}
     * @default 0
     * @readonly
     */
    get: function () {
      return this._offset - this._circularOffset;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "circularEnabled", {
    /**
     * Whether the `circular` option is enabled.
     * The {@link Flicking#circular circular} option can't be enabled when sum of the panel sizes are too small.
     * @ko {@link Flicking#circular circular} 옵션이 활성화되었는지 여부를 나타내는 멤버 변수.
     * {@link Flicking#circular circular} 옵션은 패널의 크기의 합이 충분하지 않을 경우 비활성화됩니다.
     * @type {boolean}
     * @default false
     * @readonly
     */
    get: function () {
      return this._circularEnabled;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "mode", {
    /**
     * A current camera mode
     * @type {CameraMode}
     * @readonly
     */
    get: function () {
      return this._mode;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "range", {
    /**
     * A range that Camera's {@link Camera#position position} can reach
     * @ko Camera의 {@link Camera#position position}이 도달 가능한 범위
     * @type {object}
     * @property {number} min A minimum position<ko>최소 위치</ko>
     * @property {number} max A maximum position<ko>최대 위치</ko>
     * @readonly
     */
    get: function () {
      return this._range;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "rangeDiff", {
    /**
     * A difference between Camera's minimum and maximum position that can reach
     * @ko Camera가 도달 가능한 최소/최대 좌표의 차이
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._range.max - this._range.min;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "visiblePanels", {
    /**
     * An array of visible panels from the current position
     * @ko 현재 보이는 패널들의 배열
     * @type {Panel[]}
     * @readonly
     */
    get: function () {
      return this._visiblePanels;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "visibleRange", {
    /**
     * A range of the visible area from the current position
     * @ko 현재 위치에서 보이는 범위
     * @type {object}
     * @property {number} min A minimum position<ko>최소 위치</ko>
     * @property {number} min A maximum position<ko>최대 위치</ko>
     * @readonly
     */
    get: function () {
      return {
        min: this._position - this._alignPos,
        max: this._position - this._alignPos + this.size
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "anchorPoints", {
    /**
     * An array of {@link AnchorPoint}s that Camera can be stopped at
     * @ko 카메라가 도달 가능한 {@link AnchorPoint}의 목록
     * @type {AnchorPoint[]}
     * @readonly
     */
    get: function () {
      return this._anchors;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "controlParams", {
    /**
     * A current parameters of the Camera for updating {@link AxesController}
     * @ko {@link AxesController}를 업데이트하기 위한 현재 Camera 패러미터들
     * @type {ControlParams}
     * @readonly
     */
    get: function () {
      return {
        range: this._range,
        position: this._position,
        circular: this._circularEnabled
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "atEdge", {
    /**
     * A Boolean value indicating whether Camera's over the minimum or maximum position reachable
     * @ko 현재 카메라가 도달 가능한 범위의 최소 혹은 최대점을 넘어섰는지를 나타냅니다
     * @type {boolean}
     * @readonly
     */
    get: function () {
      return this._position <= this._range.min || this._position >= this._range.max;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "size", {
    /**
     * Return the size of the viewport
     * @ko 뷰포트 크기를 반환합니다
     * @type {number}
     * @readonly
     */
    get: function () {
      var flicking = this._flicking;
      return flicking ? flicking.horizontal ? flicking.viewport.width : flicking.viewport.height : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "progress", {
    /**
     * Return the camera's position progress from the first panel to last panel
     * Range is from 0 to last panel's index
     * @ko 첫번째 패널로부터 마지막 패널까지의 카메라 위치의 진행도를 반환합니다
     * 범위는 0부터 마지막 패널의 인덱스까지입니다
     * @type {number}
     * @readonly
     */
    get: function () {
      var flicking = this._flicking;
      var position = this._position + this._offset;
      var nearestAnchor = this.findNearestAnchor(this._position);
      if (!flicking || !nearestAnchor) {
        return NaN;
      }
      var nearestPanel = nearestAnchor.panel;
      var panelPos = nearestPanel.position + nearestPanel.offset;
      var bounceSize = flicking.control.controller.bounce;
      var _a = this.range,
        prevRange = _a.min,
        nextRange = _a.max;
      var rangeDiff = this.rangeDiff;
      if (position === panelPos) {
        return nearestPanel.index;
      }
      if (position < panelPos) {
        var prevPanel = nearestPanel.prev();
        var prevPosition = prevPanel ? prevPanel.position + prevPanel.offset : prevRange - bounceSize[0];
        // Looped
        if (prevPosition > panelPos) {
          prevPosition -= rangeDiff;
        }
        return nearestPanel.index - 1 + getProgress(position, prevPosition, panelPos);
      } else {
        var nextPanel = nearestPanel.next();
        var nextPosition = nextPanel ? nextPanel.position + nextPanel.offset : nextRange + bounceSize[1];
        // Looped
        if (nextPosition < panelPos) {
          nextPosition += rangeDiff;
        }
        return nearestPanel.index + getProgress(position, panelPos, nextPosition);
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "align", {
    // Options Getter
    /**
     * A value indicating where the {@link Camera#alignPosition alignPosition} should be located at inside the viewport element
     * @ko {@link Camera#alignPosition alignPosition}이 뷰포트 엘리먼트 내의 어디에 위치해야 하는지를 나타내는 값
     * @type {ALIGN | string | number}
     */
    get: function () {
      return this._align;
    },
    // Options Setter
    set: function (val) {
      this._align = val;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Initialize Camera
   * @ko Camera를 초기화합니다
   * @throws {FlickingError}
   * {@link ERROR_CODE VAL_MUST_NOT_NULL} If the camera element(`.flicking-camera`) does not exist inside viewport element
   * <ko>{@link ERROR_CODE VAL_MUST_NOT_NULL} 뷰포트 엘리먼트 내부에 카메라 엘리먼트(`.flicking-camera`)가 존재하지 않을 경우</ko>
   * @return {this}
   */
  __proto.init = function () {
    var viewportEl = this._flicking.viewport.element;
    checkExistence(viewportEl.firstElementChild, "First element child of the viewport element");
    this._el = viewportEl.firstElementChild;
    this._checkTranslateSupport();
    this._updateMode();
    return this;
  };
  /**
   * Destroy Camera and return to initial state
   * @ko Camera를 초기 상태로 되돌립니다
   * @return {void}
   */
  __proto.destroy = function () {
    this._resetInternalValues();
    return this;
  };
  /**
   * Move to the given position and apply CSS transform
   * @ko 해당 좌표로 이동하고, CSS transform을 적용합니다
   * @param {number} pos A new position<ko>움직일 위치</ko>
   * @throws {FlickingError}
   * {@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} When {@link Camera#init init} is not called before
   * <ko>{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} {@link Camera#init init}이 이전에 호출되지 않은 경우</ko>
   * @return {this}
   */
  __proto.lookAt = function (pos) {
    var _this = this;
    var flicking = getFlickingAttached(this._flicking);
    var prevPos = this._position;
    this._position = pos;
    var toggled = this._togglePanels(prevPos, pos);
    this._refreshVisiblePanels();
    this._checkNeedPanel();
    this._checkReachEnd(prevPos, pos);
    if (toggled) {
      void flicking.renderer.render().then(function () {
        _this.updateOffset();
      });
    } else {
      this.applyTransform();
    }
  };
  /**
   * Return a previous {@link AnchorPoint} of given {@link AnchorPoint}
   * If it does not exist, return `null` instead
   * @ko 주어진 {@link AnchorPoint}의 이전 {@link AnchorPoint}를 반환합니다
   * 존재하지 않을 경우 `null`을 반환합니다
   * @param {AnchorPoint} anchor A reference {@link AnchorPoint}<ko>기준 {@link AnchorPoint}</ko>
   * @return {AnchorPoint | null} The previous {@link AnchorPoint}<ko>이전 {@link AnchorPoint}</ko>
   */
  __proto.getPrevAnchor = function (anchor) {
    if (!this._circularEnabled || anchor.index !== 0) {
      return this._anchors[anchor.index - 1] || null;
    } else {
      var anchors = this._anchors;
      var rangeDiff = this.rangeDiff;
      var lastAnchor = anchors[anchors.length - 1];
      return new AnchorPoint({
        index: lastAnchor.index,
        position: lastAnchor.position - rangeDiff,
        panel: lastAnchor.panel
      });
    }
  };
  /**
   * Return a next {@link AnchorPoint} of given {@link AnchorPoint}
   * If it does not exist, return `null` instead
   * @ko 주어진 {@link AnchorPoint}의 다음 {@link AnchorPoint}를 반환합니다
   * 존재하지 않을 경우 `null`을 반환합니다
   * @param {AnchorPoint} anchor A reference {@link AnchorPoint}<ko>기준 {@link AnchorPoint}</ko>
   * @return {AnchorPoint | null} The next {@link AnchorPoint}<ko>다음 {@link AnchorPoint}</ko>
   */
  __proto.getNextAnchor = function (anchor) {
    var anchors = this._anchors;
    if (!this._circularEnabled || anchor.index !== anchors.length - 1) {
      return anchors[anchor.index + 1] || null;
    } else {
      var rangeDiff = this.rangeDiff;
      var firstAnchor = anchors[0];
      return new AnchorPoint({
        index: firstAnchor.index,
        position: firstAnchor.position + rangeDiff,
        panel: firstAnchor.panel
      });
    }
  };
  /**
   * Return the camera's position progress in the panel below
   * Value is from 0 to 1 when the camera's inside panel
   * Value can be lower than 0 or bigger than 1 when it's in the margin area
   * @ko 현재 카메라 아래 패널에서의 위치 진행도를 반환합니다
   * 반환값은 카메라가 패널 내부에 있을 경우 0부터 1까지의 값을 갖습니다
   * 패널의 margin 영역에 있을 경우 0보다 작거나 1보다 큰 값을 반환할 수 있습니다
   */
  __proto.getProgressInPanel = function (panel) {
    var panelRange = panel.range;
    return (this._position - panelRange.min) / (panelRange.max - panelRange.min);
  };
  /**
   * Return {@link AnchorPoint} that includes given position
   * If there's no {@link AnchorPoint} that includes the given position, return `null` instead
   * @ko 주어진 좌표를 포함하는 {@link AnchorPoint}를 반환합니다
   * 주어진 좌표를 포함하는 {@link AnchorPoint}가 없을 경우 `null`을 반환합니다
   * @param {number} position A position to check<ko>확인할 좌표</ko>
   * @return {AnchorPoint | null} The {@link AnchorPoint} that includes the given position<ko>해당 좌표를 포함하는 {@link AnchorPoint}</ko>
   */
  __proto.findAnchorIncludePosition = function (position) {
    return this._mode.findAnchorIncludePosition(position);
  };
  /**
   * Return {@link AnchorPoint} nearest to given position
   * If there're no {@link AnchorPoint}s, return `null` instead
   * @ko 해당 좌표에서 가장 가까운 {@link AnchorPoint}를 반환합니다
   * {@link AnchorPoint}가 하나도 없을 경우 `null`을 반환합니다
   * @param {number} position A position to check<ko>확인할 좌표</ko>
   * @return {AnchorPoint | null} The {@link AnchorPoint} nearest to the given position<ko>해당 좌표에 가장 인접한 {@link AnchorPoint}</ko>
   */
  __proto.findNearestAnchor = function (position) {
    return this._mode.findNearestAnchor(position);
  };
  /**
   * Return {@link AnchorPoint} that matches {@link Flicking#currentPanel}
   * @ko 현재 {@link Flicking#currentPanel}에 해당하는 {@link AnchorPoint}를 반환합니다
   * @return {AnchorPoint | null}
   */
  __proto.findActiveAnchor = function () {
    var flicking = getFlickingAttached(this._flicking);
    var activeIndex = flicking.control.activeIndex;
    return flicking_esm_find(this._anchors, function (anchor) {
      return anchor.panel.index === activeIndex;
    });
  };
  /**
   * Clamp the given position between camera's range
   * @ko 주어진 좌표를 Camera가 도달 가능한 범위 사이의 값으로 만듭니다
   * @param {number} position A position to clamp<ko>범위를 제한할 좌표</ko>
   * @return {number} A clamped position<ko>범위 제한된 좌표</ko>
   */
  __proto.clampToReachablePosition = function (position) {
    return this._mode.clampToReachablePosition(position);
  };
  /**
   * Check whether the given panel is inside of the Camera's range
   * @ko 해당 {@link Panel}이 Camera가 도달 가능한 범위 내에 있는지를 반환합니다
   * @param panel An instance of {@link Panel} to check<ko>확인할 {@link Panel}의 인스턴스</ko>
   * @return {boolean} Whether the panel's inside Camera's range<ko>도달 가능한 범위 내에 해당 패널이 존재하는지 여부</ko>
   */
  __proto.canReach = function (panel) {
    return this._mode.canReach(panel);
  };
  /**
   * Check whether the given panel element is visible at the current position
   * @ko 현재 좌표에서 해당 패널 엘리먼트를 볼 수 있는지 여부를 반환합니다
   * @param panel An instance of {@link Panel} to check<ko>확인할 {@link Panel}의 인스턴스</ko>
   * @return Whether the panel element is visible at the current position<ko>현재 위치에서 해당 패널 엘리먼트가 보이는지 여부</ko>
   */
  __proto.canSee = function (panel) {
    return this._mode.canSee(panel);
  };
  /**
   * Update {@link Camera#range range} of Camera
   * @ko Camera의 {@link Camera#range range}를 업데이트합니다
   * @method
   * @abstract
   * @memberof Camera
   * @instance
   * @name updateRange
   * @chainable
   * @throws {FlickingError}
   * {@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} When {@link Camera#init init} is not called before
   * <ko>{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} {@link Camera#init init}이 이전에 호출되지 않은 경우</ko>
   * @return {this}
   */
  __proto.updateRange = function () {
    var flicking = getFlickingAttached(this._flicking);
    var renderer = flicking.renderer;
    var panels = renderer.panels;
    this._updateMode();
    this._range = this._mode.getRange();
    panels.forEach(function (panel) {
      return panel.updateCircularToggleDirection();
    });
    return this;
  };
  /**
   * Update Camera's {@link Camera#alignPosition alignPosition}
   * @ko Camera의 {@link Camera#alignPosition alignPosition}을 업데이트합니다
   * @chainable
   * @return {this}
   */
  __proto.updateAlignPos = function () {
    var align = this._align;
    var alignVal = typeof align === "object" ? align.camera : align;
    this._alignPos = parseAlign$1(alignVal, this.size);
    return this;
  };
  /**
   * Update Camera's {@link Camera#anchorPoints anchorPoints}
   * @ko Camera의 {@link Camera#anchorPoints anchorPoints}를 업데이트합니다
   * @throws {FlickingError}
   * {@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} When {@link Camera#init init} is not called before
   * <ko>{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} {@link Camera#init init}이 이전에 호출되지 않은 경우</ko>
   * @chainable
   * @return {this}
   */
  __proto.updateAnchors = function () {
    this._anchors = this._mode.getAnchors();
    return this;
  };
  /**
   * Update Viewport's height to active panel's height
   * @ko 현재 선택된 패널의 높이와 동일하도록 뷰포트의 높이를 업데이트합니다
   * @throws {FlickingError}
   * {@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} When {@link Camera#init init} is not called before
   * <ko>{@link ERROR_CODE NOT_ATTACHED_TO_FLICKING} {@link Camera#init init}이 이전에 호출되지 않은 경우</ko>
   * @chainable
   * @return {this}
   */
  __proto.updateAdaptiveHeight = function () {
    var flicking = getFlickingAttached(this._flicking);
    var activePanel = flicking.control.activePanel;
    if (!flicking.horizontal || !flicking.adaptive || !activePanel) return;
    flicking.viewport.setSize({
      height: activePanel.height
    });
  };
  /**
   * Update current offset of the camera
   * @ko 현재 카메라의 오프셋을 업데이트합니다
   * @chainable
   * @return {this}
   */
  __proto.updateOffset = function () {
    var flicking = getFlickingAttached(this._flicking);
    var position = this._position;
    var unRenderedPanels = flicking.panels.filter(function (panel) {
      return !panel.rendered;
    });
    this._offset = unRenderedPanels.filter(function (panel) {
      return panel.position + panel.offset < position;
    }).reduce(function (offset, panel) {
      return offset + panel.sizeIncludingMargin;
    }, 0);
    this._circularOffset = this._mode.getCircularOffset();
    this.applyTransform();
    return this;
  };
  /**
   * Reset the history of {@link Flicking#event:needPanel needPanel} events so it can be triggered again
   * @ko 발생한 {@link Flicking#event:needPanel needPanel} 이벤트들을 초기화하여 다시 발생할 수 있도록 합니다
   * @chainable
   * @return {this}
   */
  __proto.resetNeedPanelHistory = function () {
    this._needPanelTriggered = {
      prev: false,
      next: false
    };
    return this;
  };
  /**
   * Apply "transform" style with the current position to camera element
   * @ko 현재 위치를 기준으로한 transform 스타일을 카메라 엘리먼트에 적용합니다.
   * @return {this}
   */
  __proto.applyTransform = function () {
    var el = this._el;
    var flicking = getFlickingAttached(this._flicking);
    var renderer = flicking.renderer;
    if (renderer.rendering || !flicking.initialized) return this;
    var actualPosition = this._position - this._alignPos - this._offset + this._circularOffset;
    el.style[this._transform] = flicking.horizontal ? "translate(" + -actualPosition + "px)" : "translate(0, " + -actualPosition + "px)";
    return this;
  };
  __proto._resetInternalValues = function () {
    this._position = 0;
    this._alignPos = 0;
    this._offset = 0;
    this._circularOffset = 0;
    this._circularEnabled = false;
    this._range = {
      min: 0,
      max: 0
    };
    this._visiblePanels = [];
    this._anchors = [];
    this._needPanelTriggered = {
      prev: false,
      next: false
    };
  };
  __proto._refreshVisiblePanels = function () {
    var _this = this;
    var flicking = getFlickingAttached(this._flicking);
    var panels = flicking.renderer.panels;
    var newVisiblePanels = panels.filter(function (panel) {
      return _this.canSee(panel);
    });
    var prevVisiblePanels = this._visiblePanels;
    this._visiblePanels = newVisiblePanels;
    var added = newVisiblePanels.filter(function (panel) {
      return !includes(prevVisiblePanels, panel);
    });
    var removed = prevVisiblePanels.filter(function (panel) {
      return !includes(newVisiblePanels, panel);
    });
    if (added.length > 0 || removed.length > 0) {
      void flicking.renderer.render().then(function () {
        flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.VISIBLE_CHANGE, {
          added: added,
          removed: removed,
          visiblePanels: newVisiblePanels
        }));
      });
    }
  };
  __proto._checkNeedPanel = function () {
    var needPanelTriggered = this._needPanelTriggered;
    if (needPanelTriggered.prev && needPanelTriggered.next) return;
    var flicking = getFlickingAttached(this._flicking);
    var panels = flicking.renderer.panels;
    if (panels.length <= 0) {
      if (!needPanelTriggered.prev) {
        flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.NEED_PANEL, {
          direction: DIRECTION.PREV
        }));
        needPanelTriggered.prev = true;
      }
      if (!needPanelTriggered.next) {
        flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.NEED_PANEL, {
          direction: DIRECTION.NEXT
        }));
        needPanelTriggered.next = true;
      }
      return;
    }
    var cameraPosition = this._position;
    var cameraSize = this.size;
    var cameraRange = this._range;
    var needPanelThreshold = flicking.needPanelThreshold;
    var cameraPrev = cameraPosition - this._alignPos;
    var cameraNext = cameraPrev + cameraSize;
    var firstPanel = panels[0];
    var lastPanel = panels[panels.length - 1];
    if (!needPanelTriggered.prev) {
      var firstPanelPrev = firstPanel.range.min;
      if (cameraPrev <= firstPanelPrev + needPanelThreshold || cameraPosition <= cameraRange.min + needPanelThreshold) {
        flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.NEED_PANEL, {
          direction: DIRECTION.PREV
        }));
        needPanelTriggered.prev = true;
      }
    }
    if (!needPanelTriggered.next) {
      var lastPanelNext = lastPanel.range.max;
      if (cameraNext >= lastPanelNext - needPanelThreshold || cameraPosition >= cameraRange.max - needPanelThreshold) {
        flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.NEED_PANEL, {
          direction: DIRECTION.NEXT
        }));
        needPanelTriggered.next = true;
      }
    }
  };
  __proto._checkReachEnd = function (prevPos, newPos) {
    var flicking = getFlickingAttached(this._flicking);
    var range = this._range;
    var wasBetweenRange = prevPos > range.min && prevPos < range.max;
    var isBetweenRange = newPos > range.min && newPos < range.max;
    if (!wasBetweenRange || isBetweenRange) return;
    var direction = newPos <= range.min ? DIRECTION.PREV : DIRECTION.NEXT;
    flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.REACH_EDGE, {
      direction: direction
    }));
  };
  __proto._updateMode = function () {
    var flicking = getFlickingAttached(this._flicking);
    if (flicking.circular) {
      var circularMode = new CircularCameraMode(flicking);
      var canSetCircularMode = circularMode.checkAvailability();
      if (canSetCircularMode) {
        this._mode = circularMode;
      } else {
        var fallbackMode = flicking.circularFallback;
        this._mode = fallbackMode === CIRCULAR_FALLBACK.BOUND ? new BoundCameraMode(flicking) : new LinearCameraMode(flicking);
      }
      this._circularEnabled = canSetCircularMode;
    } else {
      this._mode = flicking.bound ? new BoundCameraMode(flicking) : new LinearCameraMode(flicking);
      this._circularEnabled = false;
    }
  };
  __proto._togglePanels = function (prevPos, pos) {
    if (pos === prevPos) return false;
    var flicking = getFlickingAttached(this._flicking);
    var panels = flicking.renderer.panels;
    var toggled = panels.map(function (panel) {
      return panel.toggle(prevPos, pos);
    });
    return toggled.some(function (isToggled) {
      return isToggled;
    });
  };
  return Camera;
}();

/**
 * A component that manages {@link Panel} and its elements
 * @ko {@link Panel}과 그 엘리먼트들을 관리하는 컴포넌트
 */
var flicking_esm_Renderer = /*#__PURE__*/function () {
  /**
   * @param {object} options An options object<ko>옵션 오브젝트</ko>
   * @param {Constants.ALIGN | string | number} [options.align="center"] An {@link Flicking#align align} value that will be applied to all panels<ko>전체 패널에 적용될 {@link Flicking#align align} 값</ko>
   * @param {object} [options.strategy] An instance of RenderingStrategy(internal module)<ko>RenderingStrategy의 인스턴스(내부 모듈)</ko>
   */
  function Renderer(_a) {
    var _b = _a.align,
      align = _b === void 0 ? ALIGN.CENTER : _b,
      strategy = _a.strategy;
    this._flicking = null;
    this._panels = [];
    this._rendering = false;
    // Bind options
    this._align = align;
    this._strategy = strategy;
  }
  var __proto = Renderer.prototype;
  Object.defineProperty(__proto, "panels", {
    // Internal states Getter
    /**
     * Array of panels
     * @ko 전체 패널들의 배열
     * @type {Panel[]}
     * @readonly
     * @see Panel
     */
    get: function () {
      return this._panels;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "rendering", {
    /**
     * A boolean value indicating whether rendering is in progress
     * @ko 현재 렌더링이 시작되어 끝나기 전까지의 상태인지의 여부
     * @type {boolean}
     * @readonly
     * @internal
     */
    get: function () {
      return this._rendering;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "panelCount", {
    /**
     * Count of panels
     * @ko 전체 패널의 개수
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._panels.length;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "strategy", {
    /**
     * @internal
     */
    get: function () {
      return this._strategy;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "align", {
    // Options Getter
    /**
     * A {@link Panel}'s {@link Panel#align align} value that applied to all panels
     * @ko {@link Panel}에 공통적으로 적용할 {@link Panel#align align} 값
     * @type {Constants.ALIGN | string | number}
     */
    get: function () {
      return this._align;
    },
    // Options Setter
    set: function (val) {
      this._align = val;
      var panelAlign = parsePanelAlign(val);
      this._panels.forEach(function (panel) {
        panel.align = panelAlign;
      });
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Initialize Renderer
   * @ko Renderer를 초기화합니다
   * @param {Flicking} flicking An instance of {@link Flicking}<ko>Flicking의 인스턴스</ko>
   * @chainable
   * @return {this}
   */
  __proto.init = function (flicking) {
    this._flicking = flicking;
    this._collectPanels();
    return this;
  };
  /**
   * Destroy Renderer and return to initial state
   * @ko Renderer를 초기 상태로 되돌립니다
   * @return {void}
   */
  __proto.destroy = function () {
    this._flicking = null;
    this._panels = [];
  };
  /**
   * Return the {@link Panel} at the given index. `null` if it doesn't exists.
   * @ko 주어진 인덱스에 해당하는 {@link Panel}을 반환합니다. 주어진 인덱스에 해당하는 패널이 존재하지 않을 경우 `null`을 반환합니다.
   * @return {Panel | null} Panel at the given index<ko>주어진 인덱스에 해당하는 패널</ko>
   * @see Panel
   */
  __proto.getPanel = function (index) {
    return this._panels[index] || null;
  };
  __proto.forceRenderAllPanels = function () {
    this._panels.forEach(function (panel) {
      return panel.markForShow();
    });
    return Promise.resolve();
  };
  /**
   * Update all panel sizes
   * @ko 모든 패널의 크기를 업데이트합니다
   * @chainable
   * @return {this}
   */
  __proto.updatePanelSize = function () {
    var flicking = getFlickingAttached(this._flicking);
    var panels = this._panels;
    if (panels.length <= 0) return this;
    if (flicking.panelsPerView > 0) {
      var firstPanel = panels[0];
      firstPanel.resize();
      this._updatePanelSizeByGrid(firstPanel, panels);
    } else {
      flicking.panels.forEach(function (panel) {
        return panel.resize();
      });
    }
    return this;
  };
  /**
   * Insert new panels at given index
   * This will increase index of panels after by the number of panels added
   * @ko 주어진 인덱스에 새로운 패널들을 추가합니다
   * 해당 인덱스보다 같거나 큰 인덱스를 가진 기존 패널들은 추가한 패널의 개수만큼 인덱스가 증가합니다.
   * @param {Array<object>} items An array of items to insert<ko>추가할 아이템들의 배열</ko>
   * @param {number} [items.index] Index to insert new panels at<ko>새로 패널들을 추가할 인덱스</ko>
   * @param {any[]} [items.elements] An array of element or framework component with element in it<ko>엘리먼트의 배열 혹은 프레임워크에서 엘리먼트를 포함한 컴포넌트들의 배열</ko>
   * @param {boolean} [items.hasDOMInElements] Whether it contains actual DOM elements. If set to true, renderer will add them to the camera element<ko>내부에 실제 DOM 엘리먼트들을 포함하고 있는지 여부. true로 설정할 경우, 렌더러는 해당 엘리먼트들을 카메라 엘리먼트 내부에 추가합니다</ko>
   * @return {Panel[]} An array of prepended panels<ko>추가된 패널들의 배열</ko>
   */
  __proto.batchInsert = function () {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      items[_i] = arguments[_i];
    }
    var allPanelsInserted = this.batchInsertDefer.apply(this, flicking_esm_spread(items));
    if (allPanelsInserted.length <= 0) return [];
    this.updateAfterPanelChange(allPanelsInserted, []);
    return allPanelsInserted;
  };
  /**
   * Defers update
   * camera position & others will be updated after calling updateAfterPanelChange
   * @internal
   */
  __proto.batchInsertDefer = function () {
    var _this = this;
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      items[_i] = arguments[_i];
    }
    var panels = this._panels;
    var flicking = getFlickingAttached(this._flicking);
    var prevFirstPanel = panels[0];
    var align = parsePanelAlign(this._align);
    var allPanelsInserted = items.reduce(function (addedPanels, item) {
      var _a;
      var insertingIdx = getMinusCompensatedIndex(item.index, panels.length);
      var panelsPushed = panels.slice(insertingIdx);
      var panelsInserted = item.elements.map(function (el, idx) {
        return _this._createPanel(el, {
          index: insertingIdx + idx,
          align: align,
          flicking: flicking
        });
      });
      panels.splice.apply(panels, flicking_esm_spread([insertingIdx, 0], panelsInserted));
      if (item.hasDOMInElements) {
        // Insert the actual elements as camera element's children
        _this._insertPanelElements(panelsInserted, (_a = panelsPushed[0]) !== null && _a !== void 0 ? _a : null);
      }
      // Resize the newly added panels
      if (flicking.panelsPerView > 0) {
        var firstPanel = prevFirstPanel || panelsInserted[0].resize();
        _this._updatePanelSizeByGrid(firstPanel, panelsInserted);
      } else {
        panelsInserted.forEach(function (panel) {
          return panel.resize();
        });
      }
      // Update panel indexes & positions
      panelsPushed.forEach(function (panel) {
        panel.increaseIndex(panelsInserted.length);
        panel.updatePosition();
      });
      return flicking_esm_spread(addedPanels, panelsInserted);
    }, []);
    return allPanelsInserted;
  };
  /**
   * Remove the panel at the given index
   * This will decrease index of panels after by the number of panels removed
   * @ko 주어진 인덱스의 패널을 제거합니다
   * 해당 인덱스보다 큰 인덱스를 가진 기존 패널들은 제거한 패널의 개수만큼 인덱스가 감소합니다
   * @param {Array<object>} items An array of items to remove<ko>제거할 아이템들의 배열</ko>
   * @param {number} [items.index] Index of panel to remove<ko>제거할 패널의 인덱스</ko>
   * @param {number} [items.deleteCount=1] Number of panels to remove from index<ko>`index` 이후로 제거할 패널의 개수</ko>
   * @param {boolean} [items.hasDOMInElements=1] Whether it contains actual DOM elements. If set to true, renderer will remove them from the camera element<ko>내부에 실제 DOM 엘리먼트들을 포함하고 있는지 여부. true로 설정할 경우, 렌더러는 해당 엘리먼트들을 카메라 엘리먼트 내부에서 제거합니다</ko>
   * @return An array of removed panels<ko>제거된 패널들의 배열</ko>
   */
  __proto.batchRemove = function () {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      items[_i] = arguments[_i];
    }
    var allPanelsRemoved = this.batchRemoveDefer.apply(this, flicking_esm_spread(items));
    if (allPanelsRemoved.length <= 0) return [];
    this.updateAfterPanelChange([], allPanelsRemoved);
    return allPanelsRemoved;
  };
  /**
   * Defers update
   * camera position & others will be updated after calling updateAfterPanelChange
   * @internal
   */
  __proto.batchRemoveDefer = function () {
    var _this = this;
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      items[_i] = arguments[_i];
    }
    var panels = this._panels;
    var flicking = getFlickingAttached(this._flicking);
    var control = flicking.control;
    var activePanel = control.activePanel;
    var allPanelsRemoved = items.reduce(function (removed, item) {
      var index = item.index,
        deleteCount = item.deleteCount;
      var removingIdx = getMinusCompensatedIndex(index, panels.length);
      var panelsPulled = panels.slice(removingIdx + deleteCount);
      var panelsRemoved = panels.splice(removingIdx, deleteCount);
      if (panelsRemoved.length <= 0) return [];
      // Update panel indexes & positions
      panelsPulled.forEach(function (panel) {
        panel.decreaseIndex(panelsRemoved.length);
        panel.updatePosition();
      });
      if (item.hasDOMInElements) {
        _this._removePanelElements(panelsRemoved);
      }
      // Remove panel elements
      panelsRemoved.forEach(function (panel) {
        return panel.destroy();
      });
      if (includes(panelsRemoved, activePanel)) {
        control.resetActive();
      }
      return flicking_esm_spread(removed, panelsRemoved);
    }, []);
    return allPanelsRemoved;
  };
  /**
   * @internal
   */
  __proto.updateAfterPanelChange = function (panelsAdded, panelsRemoved) {
    var _a;
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera,
      control = flicking.control;
    var panels = this._panels;
    var activePanel = control.activePanel;
    // Update camera & control
    this._updateCameraAndControl();
    void this.render();
    if (!flicking.animating) {
      if (!activePanel || activePanel.removed) {
        if (panels.length <= 0) {
          // All panels removed
          camera.lookAt(0);
        } else {
          var targetIndex = (_a = activePanel === null || activePanel === void 0 ? void 0 : activePanel.index) !== null && _a !== void 0 ? _a : 0;
          if (targetIndex > panels.length - 1) {
            targetIndex = panels.length - 1;
          }
          void control.moveToPanel(panels[targetIndex], {
            duration: 0
          }).catch(function () {
            return void 0;
          });
        }
      } else {
        void control.moveToPanel(activePanel, {
          duration: 0
        }).catch(function () {
          return void 0;
        });
      }
    }
    flicking.camera.updateOffset();
    if (panelsAdded.length > 0 || panelsRemoved.length > 0) {
      flicking.trigger(new ComponentEvent$1(flicking_esm_EVENTS.PANEL_CHANGE, {
        added: panelsAdded,
        removed: panelsRemoved
      }));
      this.checkPanelContentsReady(flicking_esm_spread(panelsAdded, panelsRemoved));
    }
  };
  /**
   * @internal
   */
  __proto.checkPanelContentsReady = function (checkingPanels) {
    var _this = this;
    var flicking = getFlickingAttached(this._flicking);
    var resizeOnContentsReady = flicking.resizeOnContentsReady;
    var panels = this._panels;
    if (!resizeOnContentsReady || flicking.virtualEnabled) return;
    var hasContents = function (panel) {
      return panel.element && !!panel.element.querySelector("img, video");
    };
    checkingPanels = checkingPanels.filter(function (panel) {
      return hasContents(panel);
    });
    if (checkingPanels.length <= 0) return;
    var contentsReadyChecker = new imready_esm();
    checkingPanels.forEach(function (panel) {
      panel.loading = true;
    });
    contentsReadyChecker.on("readyElement", function (e) {
      if (!_this._flicking) {
        // Renderer's destroy() is called before
        contentsReadyChecker.destroy();
        return;
      }
      var panel = checkingPanels[e.index];
      var camera = flicking.camera;
      var control = flicking.control;
      var prevProgressInPanel = control.activePanel ? camera.getProgressInPanel(control.activePanel) : 0;
      panel.loading = false;
      panel.resize();
      panels.slice(panel.index + 1).forEach(function (panelBehind) {
        return panelBehind.updatePosition();
      });
      if (!flicking.initialized) return;
      camera.updateRange();
      camera.updateOffset();
      camera.updateAnchors();
      if (control.animating) ; else {
        control.updatePosition(prevProgressInPanel);
        control.updateInput();
      }
    });
    contentsReadyChecker.on("preReady", function (e) {
      if (_this._flicking) {
        void _this.render();
      }
      if (e.readyCount === e.totalCount) {
        contentsReadyChecker.destroy();
      }
    });
    contentsReadyChecker.on("ready", function () {
      if (_this._flicking) {
        void _this.render();
      }
      contentsReadyChecker.destroy();
    });
    contentsReadyChecker.check(checkingPanels.map(function (panel) {
      return panel.element;
    }));
  };
  __proto._updateCameraAndControl = function () {
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera,
      control = flicking.control;
    camera.updateRange();
    camera.updateOffset();
    camera.updateAnchors();
    camera.resetNeedPanelHistory();
    control.updateInput();
  };
  __proto._showOnlyVisiblePanels = function (flicking) {
    var panels = flicking.renderer.panels;
    var camera = flicking.camera;
    var visibleIndexes = camera.visiblePanels.reduce(function (visibles, panel) {
      visibles[panel.index] = true;
      return visibles;
    }, {});
    panels.forEach(function (panel) {
      if (panel.index in visibleIndexes || panel.loading) {
        panel.markForShow();
      } else if (!flicking.holding) {
        // During the input sequence,
        // Do not remove panel elements as it won't trigger touchend event.
        panel.markForHide();
      }
    });
  };
  __proto._updatePanelSizeByGrid = function (referencePanel, panels) {
    var flicking = getFlickingAttached(this._flicking);
    var panelsPerView = flicking.panelsPerView;
    if (panelsPerView <= 0) {
      throw new FlickingError(MESSAGE.WRONG_OPTION("panelsPerView", panelsPerView), CODE.WRONG_OPTION);
    }
    if (panels.length <= 0) return;
    var viewportSize = flicking.camera.size;
    var gap = referencePanel.margin.prev + referencePanel.margin.next;
    var panelSize = (viewportSize - gap * (panelsPerView - 1)) / panelsPerView;
    var panelSizeObj = flicking.horizontal ? {
      width: panelSize
    } : {
      height: panelSize
    };
    var firstPanelSizeObj = flicking_esm_assign({
      size: panelSize,
      margin: referencePanel.margin
    }, !flicking.horizontal && {
      height: referencePanel.height
    });
    if (!flicking.noPanelStyleOverride) {
      this._strategy.updatePanelSizes(flicking, panelSizeObj);
    }
    flicking.panels.forEach(function (panel) {
      return panel.resize(firstPanelSizeObj);
    });
  };
  __proto._removeAllChildsFromCamera = function () {
    var flicking = getFlickingAttached(this._flicking);
    var cameraElement = flicking.camera.element;
    // Remove other elements
    while (cameraElement.firstChild) {
      cameraElement.removeChild(cameraElement.firstChild);
    }
  };
  __proto._insertPanelElements = function (panels, nextSibling) {
    if (nextSibling === void 0) {
      nextSibling = null;
    }
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    var cameraElement = camera.element;
    var nextSiblingElement = (nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.element) || null;
    var fragment = document.createDocumentFragment();
    panels.forEach(function (panel) {
      return fragment.appendChild(panel.element);
    });
    cameraElement.insertBefore(fragment, nextSiblingElement);
  };
  __proto._removePanelElements = function (panels) {
    var flicking = getFlickingAttached(this._flicking);
    var cameraElement = flicking.camera.element;
    panels.forEach(function (panel) {
      cameraElement.removeChild(panel.element);
    });
  };
  __proto._afterRender = function () {
    var flicking = getFlickingAttached(this._flicking);
    flicking.camera.applyTransform();
  };
  return Renderer;
}();

/**
 *
 */
var VanillaRenderer = /*#__PURE__*/function (_super) {
  flicking_esm_extends(VanillaRenderer, _super);
  function VanillaRenderer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  // eslint-disable-next-line @typescript-eslint/require-await
  var __proto = VanillaRenderer.prototype;
  __proto.render = function () {
    return __awaiter(this, void 0, void 0, function () {
      var flicking, strategy;
      return __generator(this, function (_a) {
        flicking = getFlickingAttached(this._flicking);
        strategy = this._strategy;
        strategy.updateRenderingPanels(flicking);
        strategy.renderPanels(flicking);
        this._resetPanelElementOrder();
        this._afterRender();
        return [2 /*return*/];
      });
    });
  };

  __proto._collectPanels = function () {
    var flicking = getFlickingAttached(this._flicking);
    var camera = flicking.camera;
    this._removeAllTextNodes();
    this._panels = this._strategy.collectPanels(flicking, camera.children);
  };
  __proto._createPanel = function (el, options) {
    return this._strategy.createPanel(el, options);
  };
  __proto._resetPanelElementOrder = function () {
    var flicking = getFlickingAttached(this._flicking);
    var cameraEl = flicking.camera.element;
    // We're using reversed panels here as last panel should be the last element of camera element
    var reversedElements = this._strategy.getRenderingElementsByOrder(flicking).reverse();
    reversedElements.forEach(function (el, idx) {
      var nextEl = reversedElements[idx - 1] ? reversedElements[idx - 1] : null;
      if (el.nextElementSibling !== nextEl) {
        cameraEl.insertBefore(el, nextEl);
      }
    });
  };
  __proto._removeAllTextNodes = function () {
    var flicking = getFlickingAttached(this._flicking);
    var cameraElement = flicking.camera.element;
    // Remove all text nodes in the camera element
    flicking_esm_toArray(cameraElement.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        cameraElement.removeChild(node);
      }
    });
  };
  return VanillaRenderer;
}(flicking_esm_Renderer);

/**
 * @internal
 */
var ExternalRenderer = /*#__PURE__*/function (_super) {
  flicking_esm_extends(ExternalRenderer, _super);
  function ExternalRenderer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /* eslint-disable @typescript-eslint/no-unused-vars */
  var __proto = ExternalRenderer.prototype;
  __proto._removePanelElements = function (panels) {
    // DO NOTHING, overrided to prevent an unexpected error
  };
  __proto._removeAllChildsFromCamera = function () {
    // DO NOTHING, overrided to prevent an unexpected error
  };
  return ExternalRenderer;
}(flicking_esm_Renderer);

/**
 * A slide data component that holds information of a single HTMLElement
 * @ko 슬라이드 데이터 컴포넌트로, 단일 HTMLElement의 정보를 갖고 있습니다
 */
var Panel = /*#__PURE__*/function () {
  /**
   * @param {object} options An options object<ko>옵션 오브젝트</ko>
   * @param {number} [options.index] An initial index of the panel<ko>패널의 초기 인덱스</ko>
   * @param {Constants.ALIGN | string | number} [options.align] An initial {@link Flicking#align align} value of the panel<ko>패널의 초기 {@link Flicking#align align}값</ko>
   * @param {Flicking} [options.flicking] A Flicking instance panel's referencing<ko>패널이 참조하는 {@link Flicking} 인스턴스</ko>
   * @param {Flicking} [options.elementProvider] A provider instance that redirects elements<ko>실제 엘리먼트를 반환하는 엘리먼트 공급자의 인스턴스</ko>
   */
  function Panel(_a) {
    var index = _a.index,
      align = _a.align,
      flicking = _a.flicking,
      elementProvider = _a.elementProvider;
    this._index = index;
    this._flicking = flicking;
    this._elProvider = elementProvider;
    this._align = align;
    this._removed = false;
    this._rendered = true;
    this._loading = false;
    this._resetInternalStates();
  }
  var __proto = Panel.prototype;
  Object.defineProperty(__proto, "element", {
    // Internal States Getter
    /**
     * `HTMLElement` that panel's referencing
     * @ko 패널이 참조하고 있는 `HTMLElement`
     * @type {HTMLElement}
     * @readonly
     */
    get: function () {
      return this._elProvider.element;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "elementProvider", {
    /**
     * @internal
     * @readonly
     */
    get: function () {
      return this._elProvider;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "index", {
    /**
     * Index of the panel
     * @ko 패널의 인덱스
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._index;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "position", {
    /**
     * Position of the panel, including {@link Panel#alignPosition alignPosition}
     * @ko 패널의 현재 좌표, {@link Panel#alignPosition alignPosition}을 포함하고 있습니다
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._pos + this._alignPos;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "size", {
    /**
     * Cached size of the panel element
     * This is equal to {@link Panel#element element}'s `offsetWidth` if {@link Flicking#horizontal horizontal} is `true`, and `offsetHeight` else
     * @ko 패널 엘리먼트의 캐시된 크기
     * 이 값은 {@link Flicking#horizontal horizontal}이 `true`일 경우 {@link Panel#element element}의 `offsetWidth`와 동일하고, `false`일 경우 `offsetHeight`와 동일합니다
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._size;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "sizeIncludingMargin", {
    /**
     * Panel's size including CSS `margin`
     * This value includes {@link Panel#element element}'s margin left/right if {@link Flicking#horizontal horizontal} is `true`, and margin top/bottom else
     * @ko CSS `margin`을 포함한 패널의 크기
     * 이 값은 {@link Flicking#horizontal horizontal}이 `true`일 경우 margin left/right을 포함하고, `false`일 경우 margin top/bottom을 포함합니다
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._size + this._margin.prev + this._margin.next;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "height", {
    /**
     * Height of the panel element
     * @ko 패널 엘리먼트의 높이
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._height;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "margin", {
    /**
     * Cached CSS `margin` value of the panel element
     * @ko 패널 엘리먼트의 CSS `margin` 값
     * @type {object}
     * @property {number} prev CSS `margin-left` when the {@link Flicking#horizontal horizontal} is `true`, and `margin-top` else
     * <ko>{@link Flicking#horizontal horizontal}이 `true`일 경우 `margin-left`, `false`일 경우 `margin-top`에 해당하는 값</ko>
     * @property {number} next CSS `margin-right` when the {@link Flicking#horizontal horizontal} is `true`, and `margin-bottom` else
     * <ko>{@link Flicking#horizontal horizontal}이 `true`일 경우 `margin-right`, `false`일 경우 `margin-bottom`에 해당하는 값</ko>
     * @readonly
     */
    get: function () {
      return this._margin;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "alignPosition", {
    /**
     * Align position inside the panel where {@link Camera}'s {@link Camera#alignPosition alignPosition} inside viewport should be located at
     * @ko 패널의 정렬 기준 위치. {@link Camera}의 뷰포트 내에서의 {@link Camera#alignPosition alignPosition}이 위치해야 하는 곳입니다
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._alignPos;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "removed", {
    /**
     * A value indicating whether the panel's {@link Flicking#remove remove}d
     * @ko 패널이 {@link Flicking#remove remove}되었는지 여부를 나타내는 값
     * @type {boolean}
     * @readonly
     */
    get: function () {
      return this._removed;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "rendered", {
    /**
     * A value indicating whether the panel's element is being rendered on the screen
     * @ko 패널의 엘리먼트가 화면상에 렌더링되고있는지 여부를 나타내는 값
     * @type {boolean}
     * @readonly
     */
    get: function () {
      return this._rendered;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "loading", {
    /**
     * A value indicating whether the panel's image/video is not loaded and waiting for resize
     * @ko 패널 내부의 이미지/비디오가 아직 로드되지 않아 {@link Panel#resize resize}될 것인지를 나타내는 값
     * @type {boolean}
     * @readonly
     */
    get: function () {
      return this._loading;
    },
    set: function (val) {
      this._loading = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "range", {
    /**
     * Panel element's range of the bounding box
     * @ko 패널 엘리먼트의 Bounding box 범위
     * @type {object}
     * @property {number} [min] Bounding box's left({@link Flicking#horizontal horizontal}: true) / top({@link Flicking#horizontal horizontal}: false)
     * @property {number} [max] Bounding box's right({@link Flicking#horizontal horizontal}: true) / bottom({@link Flicking#horizontal horizontal}: false)
     * @readonly
     */
    get: function () {
      return {
        min: this._pos,
        max: this._pos + this._size
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "toggled", {
    /**
     * A value indicating whether the panel's position is toggled by circular behavior
     * @ko 패널의 위치가 circular 동작에 의해 토글되었는지 여부를 나타내는 값
     * @type {boolean}
     * @readonly
     */
    get: function () {
      return this._toggled;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "toggleDirection", {
    /**
     * A direction where the panel's position is toggled
     * @ko 패널의 위치가 circular 동작에 의해 토글되는 방향
     * @type {DIRECTION}
     * @readonly
     */
    get: function () {
      return this._toggleDirection;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "offset", {
    /**
     * Actual position offset determined by {@link Panel#order}
     * @ko {@link Panel#order}에 의한 실제 위치 변경값
     * @type {number}
     * @readonly
     */
    get: function () {
      var toggleDirection = this._toggleDirection;
      var cameraRangeDiff = this._flicking.camera.rangeDiff;
      return toggleDirection === DIRECTION.NONE || !this._toggled ? 0 : toggleDirection === DIRECTION.PREV ? -cameraRangeDiff : cameraRangeDiff;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "progress", {
    /**
     * Progress of movement between previous or next panel relative to current panel
     * @ko 이 패널로부터 이전/다음 패널으로의 이동 진행률
     * @type {number}
     * @readonly
     */
    get: function () {
      var flicking = this._flicking;
      return this.index - flicking.camera.progress;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "outsetProgress", {
    /**
     * Progress of movement between points that panel is completely invisible outside of viewport(prev direction: -1, selected point: 0, next direction: 1)
     * @ko 현재 패널이 뷰포트 영역 밖으로 완전히 사라지는 지점을 기준으로 하는 진행도(prev방향: -1, 선택 지점: 0, next방향: 1)
     * @type {number}
     * @readonly
     */
    get: function () {
      var position = this.position + this.offset;
      var alignPosition = this._alignPos;
      var camera = this._flicking.camera;
      var camPos = camera.position;
      if (camPos === position) {
        return 0;
      }
      if (camPos < position) {
        var disappearPosNext = position + (camera.size - camera.alignPosition) + alignPosition;
        return -getProgress(camPos, position, disappearPosNext);
      } else {
        var disappearPosPrev = position - (camera.alignPosition + this._size - alignPosition);
        return 1 - getProgress(camPos, disappearPosPrev, position);
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "visibleRatio", {
    /**
     * Percentage of area where panel is visible in the viewport
     * @ko 뷰포트 안에서 패널이 보이는 영역의 비율
     * @type {number}
     * @readonly
     */
    get: function () {
      var range = this.range;
      var size = this._size;
      var offset = this.offset;
      var visibleRange = this._flicking.camera.visibleRange;
      var checkingRange = {
        min: range.min + offset,
        max: range.max + offset
      };
      if (checkingRange.max <= visibleRange.min || checkingRange.min >= visibleRange.max) {
        return 0;
      }
      var visibleSize = size;
      if (visibleRange.min > checkingRange.min) {
        visibleSize -= visibleRange.min - checkingRange.min;
      }
      if (visibleRange.max < checkingRange.max) {
        visibleSize -= checkingRange.max - visibleRange.max;
      }
      return visibleSize / size;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "align", {
    // Options Getter
    /**
     * A value indicating where the {@link Panel#alignPosition alignPosition} should be located at inside the panel element
     * @ko {@link Panel#alignPosition alignPosition}이 패널 내의 어디에 위치해야 하는지를 나타내는 값
     * @type {Constants.ALIGN | string | number}
     */
    get: function () {
      return this._align;
    },
    // Options Setter
    set: function (val) {
      this._align = val;
      this._updateAlignPos();
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Mark panel element to be appended on the camera element
   * @internal
   */
  __proto.markForShow = function () {
    this._rendered = true;
    this._elProvider.show(this._flicking);
  };
  /**
   * Mark panel element to be removed from the camera element
   * @internal
   */
  __proto.markForHide = function () {
    this._rendered = false;
    this._elProvider.hide(this._flicking);
  };
  /**
   * Update size of the panel
   * @ko 패널의 크기를 갱신합니다
   * @param {object} cached Predefined cached size of the panel<ko>사전에 캐시된 패널의 크기 정보</ko>
   * @chainable
   * @return {this}
   */
  __proto.resize = function (cached) {
    var _a;
    var el = this.element;
    var flicking = this._flicking;
    var horizontal = flicking.horizontal,
      useFractionalSize = flicking.useFractionalSize;
    if (cached) {
      this._size = cached.size;
      this._margin = flicking_esm_assign({}, cached.margin);
      this._height = (_a = cached.height) !== null && _a !== void 0 ? _a : getElementSize({
        el: el,
        horizontal: false,
        useFractionalSize: useFractionalSize,
        useOffset: true,
        style: getStyle(el)
      });
    } else {
      var elStyle = getStyle(el);
      this._size = getElementSize({
        el: el,
        horizontal: horizontal,
        useFractionalSize: useFractionalSize,
        useOffset: true,
        style: elStyle
      });
      this._margin = horizontal ? {
        prev: parseFloat(elStyle.marginLeft || "0"),
        next: parseFloat(elStyle.marginRight || "0")
      } : {
        prev: parseFloat(elStyle.marginTop || "0"),
        next: parseFloat(elStyle.marginBottom || "0")
      };
      this._height = horizontal ? getElementSize({
        el: el,
        horizontal: false,
        useFractionalSize: useFractionalSize,
        useOffset: true,
        style: elStyle
      }) : this._size;
    }
    this.updatePosition();
    this._updateAlignPos();
    return this;
  };
  /**
   * Change panel's size. This will change the actual size of the panel element by changing its CSS width/height property
   * @ko 패널 크기를 변경합니다. 패널 엘리먼트에 해당 크기의 CSS width/height를 적용합니다
   * @param {object} [size] New panel size<ko>새 패널 크기</ko>
   * @param {number|string} [size.width] CSS string or number(in px)<ko>CSS 문자열 또는 숫자(px)</ko>
   * @param {number|string} [size.height] CSS string or number(in px)<ko>CSS 문자열 또는 숫자(px)</ko>
   * @chainable
   * @return {this}
   */
  __proto.setSize = function (size) {
    setSize(this.element, size);
    return this;
  };
  /**
   * Check whether the given element is inside of this panel's {@link Panel#element element}
   * @ko 해당 엘리먼트가 이 패널의 {@link Panel#element element} 내에 포함되어 있는지를 반환합니다
   * @param {HTMLElement} element The HTMLElement to check<ko>확인하고자 하는 HTMLElement</ko>
   * @return {boolean} A Boolean value indicating the element is inside of this panel {@link Panel#element element}<ko>패널의 {@link Panel#element element}내에 해당 엘리먼트 포함 여부</ko>
   */
  __proto.contains = function (element) {
    var _a;
    return !!((_a = this.element) === null || _a === void 0 ? void 0 : _a.contains(element));
  };
  /**
   * Reset internal state and set {@link Panel#removed removed} to `true`
   * @ko 내부 상태를 초기화하고 {@link Panel#removed removed}를 `true`로 설정합니다.
   * @return {void}
   */
  __proto.destroy = function () {
    this._resetInternalStates();
    this._removed = true;
  };
  /**
   * Check whether the given position is inside of this panel's {@link Panel#range range}
   * @ko 주어진 좌표가 현재 패널의 {@link Panel#range range}내에 속해있는지를 반환합니다.
   * @param {number} pos A position to check<ko>확인하고자 하는 좌표</ko>
   * @param {boolean} [includeMargin=false] Include {@link Panel#margin margin} to the range<ko>패널 영역에 {@link Panel#margin margin}값을 포함시킵니다</ko>
   * @return {boolean} A Boolean value indicating whether the given position is included in the panel range<ko>해당 좌표가 패널 영역 내에 속해있는지 여부</ko>
   */
  __proto.includePosition = function (pos, includeMargin) {
    if (includeMargin === void 0) {
      includeMargin = false;
    }
    return this.includeRange(pos, pos, includeMargin);
  };
  /**
   * Check whether the given range is fully included in this panel's area (inclusive)
   * @ko 주어진 범위가 이 패널 내부에 완전히 포함되는지를 반환합니다
   * @param {number} min Minimum value of the range to check<ko>확인하고자 하는 최소 범위</ko>
   * @param {number} max Maximum value of the range to check<ko>확인하고자 하는 최대 범위</ko>
   * @param {boolean} [includeMargin=false] Include {@link Panel#margin margin} to the range<ko>패널 영역에 {@link Panel#margin margin}값을 포함시킵니다</ko>
   * @returns {boolean} A Boolean value indicating whether the given range is fully included in the panel range<ko>해당 범위가 패널 영역 내에 완전히 속해있는지 여부</ko>
   */
  __proto.includeRange = function (min, max, includeMargin) {
    if (includeMargin === void 0) {
      includeMargin = false;
    }
    var margin = this._margin;
    var panelRange = this.range;
    if (includeMargin) {
      panelRange.min -= margin.prev;
      panelRange.max += margin.next;
    }
    return max >= panelRange.min && min <= panelRange.max;
  };
  /**
   * Check whether the panel is visble in the given range (exclusive)
   * @ko 주어진 범위 내에서 이 패널의 일부가 보여지는지를 반환합니다
   * @param {number} min Minimum value of the range to check<ko>확인하고자 하는 최소 범위</ko>
   * @param {number} max Maximum value of the range to check<ko>확인하고자 하는 최대 범위</ko>
   * @returns {boolean} A Boolean value indicating whether the panel is visible<ko>해당 범위 내에서 패널을 볼 수 있는지 여부</ko>
   */
  __proto.isVisibleOnRange = function (min, max) {
    var panelRange = this.range;
    return max > panelRange.min && min < panelRange.max;
  };
  /**
   * Move {@link Camera} to this panel
   * @ko {@link Camera}를 이 패널로 이동합니다
   * @param {number} [duration] Duration of the animation (unit: ms)<ko>애니메이션 진행 시간 (단위: ms)</ko>
   * @returns {Promise<void>} A Promise which will be resolved after reaching the panel<ko>패널 도달시에 resolve되는 Promise</ko>
   */
  __proto.focus = function (duration) {
    return this._flicking.moveTo(this._index, duration);
  };
  /**
   * Get previous(`index - 1`) panel. When the previous panel does not exist, this will return `null` instead
   * If the {@link Flicking#circularEnabled circular} is enabled, this will return the last panel if called from the first panel
   * @ko 이전(`index - 1`) 패널을 반환합니다. 이전 패널이 없을 경우 `null`을 반환합니다
   * {@link Flicking#circularEnabled circular} 모드가 활성화되었을 때 첫번째 패널에서 이 메소드를 호출할 경우 마지막 패널을 반환합니다
   * @returns {Panel | null} The previous panel<ko>이전 패널</ko>
   */
  __proto.prev = function () {
    var index = this._index;
    var flicking = this._flicking;
    var renderer = flicking.renderer;
    var panelCount = renderer.panelCount;
    if (panelCount === 1) return null;
    return flicking.circularEnabled ? renderer.getPanel(index === 0 ? panelCount - 1 : index - 1) : renderer.getPanel(index - 1);
  };
  /**
   * Get next(`index + 1`) panel. When the next panel does not exist, this will return `null` instead
   * If the {@link Flicking#circularEnabled circular} is enabled, this will return the first panel if called from the last panel
   * @ko 다음(`index + 1`) 패널을 반환합니다. 다음 패널이 없을 경우 `null`을 반환합니다
   * {@link Flicking#circularEnabled circular} 모드가 활성화되었을 때 마지막 패널에서 이 메소드를 호출할 경우 첫번째 패널을 반환합니다
   * @returns {Panel | null} The previous panel<ko>다음 패널</ko>
   */
  __proto.next = function () {
    var index = this._index;
    var flicking = this._flicking;
    var renderer = flicking.renderer;
    var panelCount = renderer.panelCount;
    if (panelCount === 1) return null;
    return flicking.circularEnabled ? renderer.getPanel(index === panelCount - 1 ? 0 : index + 1) : renderer.getPanel(index + 1);
  };
  /**
   * Increase panel's index by the given value
   * @ko 패널의 인덱스를 주어진 값만큼 증가시킵니다
   * @internal
   * @chainable
   * @param val An integer greater than or equal to 0<ko>0보다 같거나 큰 정수</ko>
   * @returns {this}
   */
  __proto.increaseIndex = function (val) {
    this._index += Math.max(val, 0);
    return this;
  };
  /**
   * Decrease panel's index by the given value
   * @ko 패널의 인덱스를 주어진 값만큼 감소시킵니다
   * @internal
   * @chainable
   * @param val An integer greater than or equal to 0<ko>0보다 같거나 큰 정수</ko>
   * @returns {this}
   */
  __proto.decreaseIndex = function (val) {
    this._index -= Math.max(val, 0);
    return this;
  };
  /**
   * @internal
   */
  __proto.updatePosition = function () {
    var prevPanel = this._flicking.renderer.panels[this._index - 1];
    this._pos = prevPanel ? prevPanel.range.max + prevPanel.margin.next + this._margin.prev : this._margin.prev;
    return this;
  };
  /**
   * @internal
   * @return {boolean} toggled
   */
  __proto.toggle = function (prevPos, newPos) {
    var toggleDirection = this._toggleDirection;
    var togglePosition = this._togglePosition;
    if (toggleDirection === DIRECTION.NONE || newPos === prevPos) return false;
    var prevToggled = this._toggled;
    if (newPos > prevPos) {
      if (togglePosition >= prevPos && togglePosition <= newPos) {
        this._toggled = toggleDirection === DIRECTION.NEXT;
      }
    } else {
      if (togglePosition <= prevPos && togglePosition >= newPos) {
        this._toggled = toggleDirection !== DIRECTION.NEXT;
      }
    }
    return prevToggled !== this._toggled;
  };
  /**
   * @internal
   */
  __proto.updateCircularToggleDirection = function () {
    var flicking = this._flicking;
    if (!flicking.circularEnabled) {
      this._toggleDirection = DIRECTION.NONE;
      this._togglePosition = 0;
      this._toggled = false;
      return this;
    }
    var camera = flicking.camera;
    var camRange = camera.range;
    var camAlignPosition = camera.alignPosition;
    var camVisibleRange = camera.visibleRange;
    var camVisibleSize = camVisibleRange.max - camVisibleRange.min;
    var minimumVisible = camRange.min - camAlignPosition;
    var maximumVisible = camRange.max - camAlignPosition + camVisibleSize;
    var shouldBeVisibleAtMin = this.includeRange(maximumVisible - camVisibleSize, maximumVisible, false);
    var shouldBeVisibleAtMax = this.includeRange(minimumVisible, minimumVisible + camVisibleSize, false);
    this._toggled = false;
    if (shouldBeVisibleAtMin) {
      this._toggleDirection = DIRECTION.PREV;
      this._togglePosition = this.range.max + camRange.min - camRange.max + camAlignPosition;
      this.toggle(Infinity, camera.position);
    } else if (shouldBeVisibleAtMax) {
      this._toggleDirection = DIRECTION.NEXT;
      this._togglePosition = this.range.min + camRange.max - camVisibleSize + camAlignPosition;
      this.toggle(-Infinity, camera.position);
    } else {
      this._toggleDirection = DIRECTION.NONE;
      this._togglePosition = 0;
    }
    return this;
  };
  __proto._updateAlignPos = function () {
    this._alignPos = parseAlign$1(this._align, this._size);
  };
  __proto._resetInternalStates = function () {
    this._size = 0;
    this._pos = 0;
    this._margin = {
      prev: 0,
      next: 0
    };
    this._height = 0;
    this._alignPos = 0;
    this._toggled = false;
    this._togglePosition = 0;
    this._toggleDirection = DIRECTION.NONE;
  };
  return Panel;
}();

var NormalRenderingStrategy = /*#__PURE__*/function () {
  function NormalRenderingStrategy(_a) {
    var providerCtor = _a.providerCtor;
    this._providerCtor = providerCtor;
  }
  var __proto = NormalRenderingStrategy.prototype;
  __proto.renderPanels = function () {
    // DO_NOTHING
  };
  __proto.getRenderingIndexesByOrder = function (flicking) {
    var renderedPanels = flicking.renderer.panels.filter(function (panel) {
      return panel.rendered;
    });
    var toggledPrev = renderedPanels.filter(function (panel) {
      return panel.toggled && panel.toggleDirection === DIRECTION.PREV;
    });
    var toggledNext = renderedPanels.filter(function (panel) {
      return panel.toggled && panel.toggleDirection === DIRECTION.NEXT;
    });
    var notToggled = renderedPanels.filter(function (panel) {
      return !panel.toggled;
    });
    return flicking_esm_spread(toggledPrev, notToggled, toggledNext).map(function (panel) {
      return panel.index;
    });
  };
  __proto.getRenderingElementsByOrder = function (flicking) {
    var panels = flicking.panels;
    return this.getRenderingIndexesByOrder(flicking).map(function (index) {
      return panels[index].element;
    });
  };
  __proto.updateRenderingPanels = function (flicking) {
    if (flicking.renderOnlyVisible) {
      this._showOnlyVisiblePanels(flicking);
    } else {
      flicking.panels.forEach(function (panel) {
        return panel.markForShow();
      });
    }
  };
  __proto.collectPanels = function (flicking, elements) {
    var _this = this;
    var align = parsePanelAlign(flicking.renderer.align);
    return elements.map(function (el, index) {
      return new Panel({
        index: index,
        elementProvider: new _this._providerCtor(el),
        align: align,
        flicking: flicking
      });
    });
  };
  __proto.createPanel = function (element, options) {
    return new Panel(flicking_esm_assign(flicking_esm_assign({}, options), {
      elementProvider: new this._providerCtor(element)
    }));
  };
  __proto.updatePanelSizes = function (flicking, size) {
    flicking.panels.forEach(function (panel) {
      return panel.setSize(size);
    });
  };
  __proto._showOnlyVisiblePanels = function (flicking) {
    var panels = flicking.renderer.panels;
    var camera = flicking.camera;
    var visibleIndexes = camera.visiblePanels.reduce(function (visibles, panel) {
      visibles[panel.index] = true;
      return visibles;
    }, {});
    panels.forEach(function (panel) {
      if (panel.index in visibleIndexes || panel.loading) {
        panel.markForShow();
      } else if (!flicking.holding) {
        // During the input sequence,
        // Do not remove panel elements as it won't trigger touchend event.
        panel.markForHide();
      }
    });
    camera.updateOffset();
  };
  return NormalRenderingStrategy;
}();

/**
 * An slide data component that holds information of a single HTMLElement
 * @ko 슬라이드 데이터 컴포넌트로, 단일 HTMLElement의 정보를 갖고 있습니다
 */
var VirtualPanel = /*#__PURE__*/function (_super) {
  flicking_esm_extends(VirtualPanel, _super);
  /**
   * @param {object} options An options object<ko>옵션 오브젝트</ko>
   * @param {number} [options.index] An initial index of the panel<ko>패널의 초기 인덱스</ko>
   * @param {Constants.ALIGN | string | number} [options.align] An initial {@link Flicking#align align} value of the panel<ko>패널의 초기 {@link Flicking#align align}값</ko>
   * @param {Flicking} [options.flicking] A Flicking instance panel's referencing<ko>패널이 참조하는 {@link Flicking} 인스턴스</ko>
   */
  function VirtualPanel(options) {
    var _this = _super.call(this, options) || this;
    options.elementProvider.init(_this);
    _this._elProvider = options.elementProvider;
    _this._cachedInnerHTML = null;
    return _this;
  }
  var __proto = VirtualPanel.prototype;
  Object.defineProperty(__proto, "element", {
    /**
     * `HTMLElement` that panel's referencing
     * @ko 패널이 참조하고 있는 `HTMLElement`
     * @type {HTMLElement}
     * @readonly
     */
    get: function () {
      return this._elProvider.element;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "cachedInnerHTML", {
    /**
     * Cached innerHTML by the previous render function
     * @ko 이전 렌더링에서 캐시된 innerHTML 정보
     * @type {string|null}
     * @readonly
     */
    get: function () {
      return this._cachedInnerHTML;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "elementIndex", {
    /**
     * An number for indexing which element it will be rendered on
     * @ko 몇 번째 엘리먼트에 렌더링될 것인지를 나타내는 숫자
     * @type {number}
     * @readonly
     */
    get: function () {
      var flicking = this._flicking;
      var virtualElCount = flicking.panelsPerView + 1;
      var panelCount = flicking.panelCount;
      var index = this._index;
      if (this._toggled) {
        // To prevent element duplication
        index = this._toggleDirection === DIRECTION.NEXT ? index + panelCount : index - panelCount;
      }
      return circulateIndex(index, virtualElCount);
    },
    enumerable: false,
    configurable: true
  });
  __proto.cacheRenderResult = function (result) {
    this._cachedInnerHTML = result;
  };
  __proto.uncacheRenderResult = function () {
    this._cachedInnerHTML = null;
  };
  __proto.render = function () {
    var flicking = this._flicking;
    var _a = flicking.virtual,
      renderPanel = _a.renderPanel,
      cache = _a.cache;
    var element = this._elProvider.element;
    var newInnerHTML = this._cachedInnerHTML || renderPanel(this, this._index);
    if (newInnerHTML === element.innerHTML) return;
    element.innerHTML = newInnerHTML;
    if (cache) {
      this.cacheRenderResult(newInnerHTML);
    }
  };
  __proto.increaseIndex = function (val) {
    this.uncacheRenderResult();
    return _super.prototype.increaseIndex.call(this, val);
  };
  __proto.decreaseIndex = function (val) {
    this.uncacheRenderResult();
    return _super.prototype.decreaseIndex.call(this, val);
  };
  return VirtualPanel;
}(Panel);

var VirtualRenderingStrategy = /*#__PURE__*/function () {
  function VirtualRenderingStrategy() {}
  var __proto = VirtualRenderingStrategy.prototype;
  __proto.renderPanels = function (flicking) {
    var virtualManager = flicking.virtual;
    var visiblePanels = flicking.visiblePanels;
    var invisibleIndexes = flicking_esm_range(flicking.panelsPerView + 1);
    visiblePanels.forEach(function (panel) {
      var elementIndex = panel.elementIndex;
      panel.render();
      virtualManager.show(elementIndex);
      invisibleIndexes[elementIndex] = -1;
    });
    invisibleIndexes.filter(function (val) {
      return val >= 0;
    }).forEach(function (idx) {
      virtualManager.hide(idx);
    });
  };
  __proto.getRenderingIndexesByOrder = function (flicking) {
    var virtualManager = flicking.virtual;
    var visiblePanels = flicking_esm_spread(flicking.visiblePanels).filter(function (panel) {
      return panel.rendered;
    }).sort(function (panel1, panel2) {
      return panel1.position + panel1.offset - (panel2.position + panel2.offset);
    });
    if (visiblePanels.length <= 0) return virtualManager.elements.map(function (_, idx) {
      return idx;
    });
    var visibleIndexes = visiblePanels.map(function (panel) {
      return panel.elementIndex;
    });
    var invisibleIndexes = virtualManager.elements.map(function (el, idx) {
      return flicking_esm_assign(flicking_esm_assign({}, el), {
        idx: idx
      });
    }).filter(function (el) {
      return !el.visible;
    }).map(function (el) {
      return el.idx;
    });
    return flicking_esm_spread(visibleIndexes, invisibleIndexes);
  };
  __proto.getRenderingElementsByOrder = function (flicking) {
    var virtualManager = flicking.virtual;
    var elements = virtualManager.elements;
    return this.getRenderingIndexesByOrder(flicking).map(function (index) {
      return elements[index].nativeElement;
    });
  };
  __proto.updateRenderingPanels = function (flicking) {
    var panels = flicking.renderer.panels;
    var camera = flicking.camera;
    var visibleIndexes = camera.visiblePanels.reduce(function (visibles, panel) {
      visibles[panel.index] = true;
      return visibles;
    }, {});
    panels.forEach(function (panel) {
      if (panel.index in visibleIndexes || panel.loading) {
        panel.markForShow();
      } else {
        panel.markForHide();
      }
    });
    camera.updateOffset();
  };
  __proto.collectPanels = function (flicking) {
    var align = parsePanelAlign(flicking.renderer.align);
    return flicking_esm_range(flicking.virtual.initialPanelCount).map(function (index) {
      return new VirtualPanel({
        index: index,
        elementProvider: new VirtualElementProvider(flicking),
        align: align,
        flicking: flicking
      });
    });
  };
  __proto.createPanel = function (_el, options) {
    return new VirtualPanel(flicking_esm_assign(flicking_esm_assign({}, options), {
      elementProvider: new VirtualElementProvider(options.flicking)
    }));
  };
  __proto.updatePanelSizes = function (flicking, size) {
    flicking.virtual.elements.forEach(function (el) {
      setSize(el.nativeElement, size);
    });
    flicking.panels.forEach(function (panel) {
      return panel.setSize(size);
    });
  };
  return VirtualRenderingStrategy;
}();

/**
 * @extends Component
 * @support {"ie": "9+(with polyfill)", "ch" : "latest", "ff" : "latest",  "sf" : "latest", "edge" : "latest", "ios" : "7+", "an" : "4.X+"}
 * @requires {@link https://github.com/naver/egjs-component|@egjs/component}
 * @requires {@link https://github.com/naver/egjs-axes|@egjs/axes}
 */
var flicking_esm_Flicking = /*#__PURE__*/function (_super) {
  flicking_esm_extends(Flicking, _super);
  /**
   * @param root A root HTMLElement to initialize Flicking on it. When it's a typeof `string`, it should be a css selector string
   * <ko>Flicking을 초기화할 HTMLElement로, `string` 타입으로 지정시 css 선택자 문자열을 지정해야 합니다.</ko>
   * @param {object} [options={}] An options object for Flicking.<ko>Flicking에 적용할 옵션 오브젝트</ko>
   * @throws {FlickingError}
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE WRONG_TYPE}|When the root is not either string or HTMLElement|
   * |{@link ERROR_CODE ELEMENT_NOT_FOUND}|When the element with given CSS selector does not exist|
   * <ko>
   *
   * |code|조건|
   * |---|---|
   * |{@link ERROR_CODE WRONG_TYPE}|루트 엘리먼트가 string이나 HTMLElement가 아닐 경우|
   * |{@link ERROR_CODE ELEMENT_NOT_FOUND}|주어진 CSS selector로 엘리먼트를 찾지 못했을 경우|
   *
   * </ko>
   * @example
   * ```ts
   * import Flicking from "@egjs/flicking";
   *
   * // Creating new instance of Flicking with HTMLElement
   * const flicking = new Flicking(document.querySelector(".flicking-viewport"), { circular: true });
   *
   * // Creating new instance of Flicking with CSS selector
   * const flicking2 = new Flicking(".flicking-viewport", { circular: true });
   * ```
   */
  function Flicking(root, _a) {
    var _b = _a === void 0 ? {} : _a,
      _c = _b.align,
      align = _c === void 0 ? ALIGN.CENTER : _c,
      _d = _b.defaultIndex,
      defaultIndex = _d === void 0 ? 0 : _d,
      _e = _b.horizontal,
      horizontal = _e === void 0 ? true : _e,
      _f = _b.circular,
      circular = _f === void 0 ? false : _f,
      _g = _b.circularFallback,
      circularFallback = _g === void 0 ? CIRCULAR_FALLBACK.LINEAR : _g,
      _h = _b.bound,
      bound = _h === void 0 ? false : _h,
      _j = _b.adaptive,
      adaptive = _j === void 0 ? false : _j,
      _k = _b.panelsPerView,
      panelsPerView = _k === void 0 ? -1 : _k,
      _l = _b.noPanelStyleOverride,
      noPanelStyleOverride = _l === void 0 ? false : _l,
      _m = _b.resizeOnContentsReady,
      resizeOnContentsReady = _m === void 0 ? false : _m,
      _o = _b.nested,
      nested = _o === void 0 ? false : _o,
      _p = _b.needPanelThreshold,
      needPanelThreshold = _p === void 0 ? 0 : _p,
      _q = _b.preventEventsBeforeInit,
      preventEventsBeforeInit = _q === void 0 ? true : _q,
      _r = _b.deceleration,
      deceleration = _r === void 0 ? 0.0075 : _r,
      _s = _b.duration,
      duration = _s === void 0 ? 500 : _s,
      _t = _b.easing,
      easing = _t === void 0 ? function (x) {
        return 1 - Math.pow(1 - x, 3);
      } : _t,
      _u = _b.inputType,
      inputType = _u === void 0 ? ["mouse", "touch"] : _u,
      _v = _b.moveType,
      moveType = _v === void 0 ? "snap" : _v,
      _w = _b.threshold,
      threshold = _w === void 0 ? 40 : _w,
      _x = _b.interruptable,
      interruptable = _x === void 0 ? true : _x,
      _y = _b.bounce,
      bounce = _y === void 0 ? "20%" : _y,
      _z = _b.iOSEdgeSwipeThreshold,
      iOSEdgeSwipeThreshold = _z === void 0 ? 30 : _z,
      _0 = _b.preventClickOnDrag,
      preventClickOnDrag = _0 === void 0 ? true : _0,
      _1 = _b.disableOnInit,
      disableOnInit = _1 === void 0 ? false : _1,
      _2 = _b.changeOnHold,
      changeOnHold = _2 === void 0 ? false : _2,
      _3 = _b.renderOnlyVisible,
      renderOnlyVisible = _3 === void 0 ? false : _3,
      _4 = _b.virtual,
      virtual = _4 === void 0 ? null : _4,
      _5 = _b.autoInit,
      autoInit = _5 === void 0 ? true : _5,
      _6 = _b.autoResize,
      autoResize = _6 === void 0 ? true : _6,
      _7 = _b.useResizeObserver,
      useResizeObserver = _7 === void 0 ? true : _7,
      _8 = _b.resizeDebounce,
      resizeDebounce = _8 === void 0 ? 0 : _8,
      _9 = _b.maxResizeDebounce,
      maxResizeDebounce = _9 === void 0 ? 100 : _9,
      _10 = _b.useFractionalSize,
      useFractionalSize = _10 === void 0 ? false : _10,
      _11 = _b.externalRenderer,
      externalRenderer = _11 === void 0 ? null : _11,
      _12 = _b.renderExternal,
      renderExternal = _12 === void 0 ? null : _12;
    var _this = _super.call(this) || this;
    // Internal states
    _this._initialized = false;
    _this._plugins = [];
    // Bind options
    _this._align = align;
    _this._defaultIndex = defaultIndex;
    _this._horizontal = horizontal;
    _this._circular = circular;
    _this._circularFallback = circularFallback;
    _this._bound = bound;
    _this._adaptive = adaptive;
    _this._panelsPerView = panelsPerView;
    _this._noPanelStyleOverride = noPanelStyleOverride;
    _this._resizeOnContentsReady = resizeOnContentsReady;
    _this._nested = nested;
    _this._virtual = virtual;
    _this._needPanelThreshold = needPanelThreshold;
    _this._preventEventsBeforeInit = preventEventsBeforeInit;
    _this._deceleration = deceleration;
    _this._duration = duration;
    _this._easing = easing;
    _this._inputType = inputType;
    _this._moveType = moveType;
    _this._threshold = threshold;
    _this._interruptable = interruptable;
    _this._bounce = bounce;
    _this._iOSEdgeSwipeThreshold = iOSEdgeSwipeThreshold;
    _this._preventClickOnDrag = preventClickOnDrag;
    _this._disableOnInit = disableOnInit;
    _this._changeOnHold = changeOnHold;
    _this._renderOnlyVisible = renderOnlyVisible;
    _this._autoInit = autoInit;
    _this._autoResize = autoResize;
    _this._useResizeObserver = useResizeObserver;
    _this._resizeDebounce = resizeDebounce;
    _this._maxResizeDebounce = maxResizeDebounce;
    _this._useFractionalSize = useFractionalSize;
    _this._externalRenderer = externalRenderer;
    _this._renderExternal = renderExternal;
    // Create core components
    _this._viewport = new Viewport(_this, getElement(root));
    _this._autoResizer = new AutoResizer(_this);
    _this._renderer = _this._createRenderer();
    _this._camera = _this._createCamera();
    _this._control = _this._createControl();
    _this._virtualManager = new VirtualManager(_this, virtual);
    if (_this._autoInit) {
      void _this.init();
    }
    return _this;
  }
  var __proto = Flicking.prototype;
  Object.defineProperty(__proto, "control", {
    // Components
    /**
     * {@link Control} instance of the Flicking
     * @ko 현재 Flicking에 활성화된 {@link Control} 인스턴스
     * @type {Control}
     * @default SnapControl
     * @readonly
     * @see Control
     * @see SnapControl
     * @see FreeControl
     */
    get: function () {
      return this._control;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "camera", {
    /**
     * {@link Camera} instance of the Flicking
     * @ko 현재 Flicking에 활성화된 {@link Camera} 인스턴스
     * @type {Camera}
     * @default LinearCamera
     * @readonly
     * @see Camera
     * @see LinearCamera
     * @see BoundCamera
     * @see CircularCamera
     */
    get: function () {
      return this._camera;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "renderer", {
    /**
     * {@link Renderer} instance of the Flicking
     * @ko 현재 Flicking에 활성화된 {@link Renderer} 인스턴스
     * @type {Renderer}
     * @default VanillaRenderer
     * @readonly
     * @see Renderer
     * @see VanillaRenderer
     * @see ExternalRenderer
     */
    get: function () {
      return this._renderer;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "viewport", {
    /**
     * A component that manages viewport size
     * @ko 뷰포트 크기 정보를 담당하는 컴포넌트
     * @type {Viewport}
     * @readonly
     * @see Viewport
     */
    get: function () {
      return this._viewport;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "initialized", {
    // Internal States
    /**
     * Whether Flicking's {@link Flicking#init init()} is called.
     * This is `true` when {@link Flicking#init init()} is called, and is `false` after calling {@link Flicking#destroy destroy()}.
     * @ko Flicking의 {@link Flicking#init init()}이 호출되었는지를 나타내는 멤버 변수.
     * 이 값은 {@link Flicking#init init()}이 호출되었으면 `true`로 변하고, {@link Flicking#destroy destroy()}호출 이후에 다시 `false`로 변경됩니다.
     * @type {boolean}
     * @default false
     * @readonly
     */
    get: function () {
      return this._initialized;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "circularEnabled", {
    /**
     * Whether the `circular` option is enabled.
     * The {@link Flicking#circular circular} option can't be enabled when sum of the panel sizes are too small.
     * @ko {@link Flicking#circular circular} 옵션이 활성화되었는지 여부를 나타내는 멤버 변수.
     * {@link Flicking#circular circular} 옵션은 패널의 크기의 합이 충분하지 않을 경우 비활성화됩니다.
     * @type {boolean}
     * @default false
     * @readonly
     */
    get: function () {
      return this._camera.circularEnabled;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "virtualEnabled", {
    /**
     * Whether the `virtual` option is enabled.
     * The {@link Flicking#virtual virtual} option can't be enabled when  {@link Flicking#panelsPerView panelsPerView} is less or equal than zero.
     * @ko {@link Flicking#virtual virtual} 옵션이 활성화되었는지 여부를 나타내는 멤버 변수.
     * {@link Flicking#virtual virtual} 옵션은 {@link Flicking#panelsPerView panelsPerView} 옵션의 값이 0보다 같거나 작으면 비활성화됩니다.
     * @type {boolean}
     * @default false
     * @readonly
     */
    get: function () {
      return this._panelsPerView > 0 && this._virtual != null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "index", {
    /**
     * Index number of the {@link Flicking#currentPanel currentPanel}
     * @ko {@link Flicking#currentPanel currentPanel}의 인덱스 번호
     * @type {number}
     * @default 0
     * @readonly
     */
    get: function () {
      return this._control.activeIndex;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "element", {
    /**
     * The root(`.flicking-viewport`) element
     * @ko root(`.flicking-viewport`) 엘리먼트
     * @type {HTMLElement}
     * @readonly
     */
    get: function () {
      return this._viewport.element;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "currentPanel", {
    /**
     * Currently active panel
     * @ko 현재 선택된 패널
     * @type {Panel}
     * @readonly
     * @see Panel
     */
    get: function () {
      return this._control.activePanel;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "panels", {
    /**
     * Array of panels
     * @ko 전체 패널들의 배열
     * @type {Panel[]}
     * @readonly
     * @see Panel
     */
    get: function () {
      return this._renderer.panels;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "panelCount", {
    /**
     * Count of panels
     * @ko 전체 패널의 개수
     * @type {number}
     * @readonly
     */
    get: function () {
      return this._renderer.panelCount;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "visiblePanels", {
    /**
     * Array of panels that is visible at the current position
     * @ko 현재 보이는 패널의 배열
     * @type {Panel[]}
     * @readonly
     * @see Panel
     */
    get: function () {
      return this._camera.visiblePanels;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "animating", {
    /**
     * Whether Flicking's animating
     * @ko 현재 애니메이션 동작 여부
     * @type {boolean}
     * @readonly
     */
    get: function () {
      return this._control.animating;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "holding", {
    /**
     * Whether user is clicking or touching
     * @ko 현재 사용자가 클릭/터치중인지 여부
     * @type {boolean}
     * @readonly
     */
    get: function () {
      return this._control.holding;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "activePlugins", {
    /**
     * A current list of activated plugins
     * @ko 현재 활성화된 플러그인 목록
     * @type {Plugin[]}
     * @readonly
     */
    get: function () {
      return this._plugins;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "align", {
    // Options Getter
    // UI / LAYOUT
    /**
     * Align position of the panels within viewport. You can set different values each for the panel and camera
     * @ko 뷰포트 내에서 패널 정렬방식을 설정하는 옵션. 카메라와 패널 개별로 옵션을 설정할 수도 있습니다
     * @type {ALIGN | string | number | { panel: string | number, camera: string | number }}
     * @property {ALIGN | string | number} panel The align value for each {@link Panel}s<ko>개개의 {@link Panel}에 적용할 값</ko>
     * @property {ALIGN | string | number} camera The align value for {@link Camera}<ko>{@link Camera}에 적용할 값</ko>
     * @default "center"
     * @see {@link https://naver.github.io/egjs-flicking/Options#align align ( Options )}
     * @example
     * ```ts
     * const possibleOptions = [
     *   // Literal strings
     *   "prev", "center", "next",
     *   // % values, applied to both panel & camera
     *   "0%", "25%", "42%",
     *   // px values, arithmetic calculation with (+/-) is also allowed.
     *   "0px", "100px", "50% - 25px",
     *   // numbers, same to number + px ("0px", "100px")
     *   0, 100, 1000,
     *   // Setting a different value for panel & camera
     *   { panel: "10%", camera: "25%" }
     * ];
     *
     * possibleOptions.forEach(align => {
     *   new Flicking("#el", { align });
     * });
     * ```
     */
    get: function () {
      return this._align;
    },
    // Options Setter
    // UI / LAYOUT
    set: function (val) {
      this._align = val;
      this._renderer.align = val;
      this._camera.align = val;
      void this.resize();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "defaultIndex", {
    /**
     * Index of the panel to move when Flicking's {@link Flicking#init init()} is called. A zero-based integer
     * @ko Flicking의 {@link Flicking#init init()}이 호출될 때 이동할 디폴트 패널의 인덱스로, 0부터 시작하는 정수입니다
     * @type {number}
     * @default 0
     * @see {@link https://naver.github.io/egjs-flicking/Options#defaultindex defaultIndex ( Options )}
     */
    get: function () {
      return this._defaultIndex;
    },
    set: function (val) {
      this._defaultIndex = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "horizontal", {
    /**
     * Direction of panel movement (true: horizontal, false: vertical)
     * @ko 패널 이동 방향 (true: 가로방향, false: 세로방향)
     * @type {boolean}
     * @default true
     * @see {@link https://naver.github.io/egjs-flicking/Options#horizontal horizontal ( Options )}
     */
    get: function () {
      return this._horizontal;
    },
    set: function (val) {
      this._horizontal = val;
      this._control.controller.updateDirection();
      void this.resize();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "circular", {
    /**
     * Enables circular(continuous loop) mode, which connects first/last panel for continuous scrolling.
     * @ko 순환 모드를 활성화합니다. 순환 모드에서는 양 끝의 패널이 서로 연결되어 끊김없는 스크롤이 가능합니다.
     * @type {boolean}
     * @default false
     * @see {@link https://naver.github.io/egjs-flicking/Options#circular circular ( Options )}
     */
    get: function () {
      return this._circular;
    },
    set: function (val) {
      this._circular = val;
      void this.resize();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "circularFallback", {
    /**
     * Set panel control mode for the case when circular cannot be enabled.
     * "linear" will set the view's range from the top of the first panel to the top of the last panel.
     * "bound" will prevent the view from going out of the first/last panel, so it won't show empty spaces before/after the first/last panel.
     * @ko 순환 모드 사용 불가능시 사용할 패널 조작 범위 설정 방식을 변경합니다.
     * "linear" 사용시 시점이 첫번째 엘리먼트 위에서부터 마지막 엘리먼트 위까지 움직일 수 있도록 설정합니다.
     * "bound" 사용시 시점이 첫번째 엘리먼트와 마지막 엘리먼트의 끝과 끝 사이에서 움직일 수 있도록 설정합니다.
     * @see CIRCULAR_FALLBACK
     * @type {string}
     * @default "linear"
     * @see {@link https://naver.github.io/egjs-flicking/Options#circularfallback circularFallback ( Options )}
     */
    get: function () {
      return this._circularFallback;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "bound", {
    /**
     * Prevent the view(camera element) from going out of the first/last panel, so it won't show empty spaces before/after the first/last panel
     * Only can be enabled when `circular=false`
     * @ko 뷰(카메라 엘리먼트)가 첫번째와 마지막 패널 밖으로 넘어가지 못하게 하여, 첫번째/마지막 패널 전/후의 빈 공간을 보이지 않도록 하는 옵션입니다
     * `circular=false`인 경우에만 사용할 수 있습니다
     * @type {boolean}
     * @default false
     * @see {@link https://naver.github.io/egjs-flicking/Options#bound bound ( Options )}
     */
    get: function () {
      return this._bound;
    },
    set: function (val) {
      this._bound = val;
      void this.resize();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "adaptive", {
    /**
     * Update height of the viewport element after movement same to the height of the panel below. This can be only enabled when `horizontal=true`
     * @ko 이동한 후 뷰포트 엘리먼트의 크기를 현재 패널의 높이와 동일하게 설정합니다. `horizontal=true`인 경우에만 사용할 수 있습니다.
     * @type {boolean}
     * @default false
     * @see {@link https://naver.github.io/egjs-flicking/Options#adaptive adaptive ( Options )}
     */
    get: function () {
      return this._adaptive;
    },
    set: function (val) {
      this._adaptive = val;
      void this.resize();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "panelsPerView", {
    /**
     * A visible number of panels on viewport. Enabling this option will automatically resize panel size
     * @ko 한 화면에 보이는 패널의 개수. 이 옵션을 활성화할 경우 패널의 크기를 강제로 재조정합니다
     * @type {number}
     * @default -1
     * @see {@link https://naver.github.io/egjs-flicking/Options#panelsperview panelsPerView ( Options )}
     */
    get: function () {
      return this._panelsPerView;
    },
    set: function (val) {
      this._panelsPerView = val;
      void this.resize();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "noPanelStyleOverride", {
    /**
     * Enabling this option will not change `width/height` style of the panels if {@link Flicking#panelsPerView} is enabled.
     * This behavior can be useful in terms of performance when you're manually managing all panel sizes
     * @ko 이 옵션을 활성화할 경우, {@link Flicking#panelsPerView} 옵션이 활성화되었을 때 패널의 `width/height` 스타일을 변경하지 않도록 설정합니다.
     * 모든 패널들의 크기를 직접 관리하고 있을 경우, 이 옵션을 활성화하면 성능면에서 유리할 수 있습니다
     * @type {boolean}
     * @default false
     */
    get: function () {
      return this._noPanelStyleOverride;
    },
    set: function (val) {
      this._noPanelStyleOverride = val;
      void this.resize();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "resizeOnContentsReady", {
    /**
     * Enabling this option will automatically call {@link Flicking#resize} when all image/video inside panels are loaded.
     * This can be useful when you have contents inside Flicking that changes its size when it's loaded
     * @ko 이 옵션을 활성화할 경우, Flicking 패널 내부의 이미지/비디오들이 로드되었을 때 자동으로 {@link Flicking#resize}를 호출합니다.
     * 이 동작은 Flicking 내부에 로드 전/후로 크기가 변하는 콘텐츠를 포함하고 있을 때 유용하게 사용하실 수 있습니다.
     * @type {boolean}
     * @default false
     * @see {@link https://naver.github.io/egjs-flicking/Options#resizeOnContentsReady resizeOnContentsReady ( Options )}
     */
    get: function () {
      return this._resizeOnContentsReady;
    },
    set: function (val) {
      this._resizeOnContentsReady = val;
      if (val) {
        this._renderer.checkPanelContentsReady(this._renderer.panels);
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "nested", {
    /**
     * If you enable this option on child Flicking when the Flicking is placed inside the Flicking, the parent Flicking will move in the same direction after the child Flicking reaches the first/last panel.
     * If the parent Flicking and child Flicking have different horizontal option, you do not need to set this option.
     * @ko Flicking 내부에 Flicking이 배치될 때 하위 Flicking에서 이 옵션을 활성화하면 하위 Flicking이 첫/마지막 패널에 도달한 뒤부터 같은 방향으로 상위 Flicking이 움직입니다.
     * 만약 상위 Flicking과 하위 Flicking이 서로 다른 horizontal 옵션을 가지고 있다면 이 옵션을 설정할 필요가 없습니다.
     * @type {boolean}
     * @default false
     * @see {@link https://naver.github.io/egjs-flicking/Options#nested nested ( Options )}
     */
    get: function () {
      return this._nested;
    },
    set: function (val) {
      this._nested = val;
      var axes = this._control.controller.axes;
      if (axes) {
        axes.options.nested = val;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "needPanelThreshold", {
    // EVENTS
    /**
     * A Threshold from viewport edge before triggering `needPanel` event
     * @ko `needPanel`이벤트가 발생하기 위한 뷰포트 끝으로부터의 최대 거리
     * @type {number}
     * @default 0
     * @see {@link https://naver.github.io/egjs-flicking/Options#needpanelthreshold needPanelThreshold ( Options )}
     */
    get: function () {
      return this._needPanelThreshold;
    },
    // EVENTS
    set: function (val) {
      this._needPanelThreshold = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "preventEventsBeforeInit", {
    /**
     * When enabled, events are not triggered before `ready` when initializing
     * @ko 활성화할 경우 초기화시 `ready` 이벤트 이전의 이벤트가 발생하지 않습니다.
     * @type {boolean}
     * @default true
     * @see {@link https://naver.github.io/egjs-flicking/Options#preventeventsbeforeinit preventEventsBeforeInit ( Options )}
     */
    get: function () {
      return this._preventEventsBeforeInit;
    },
    set: function (val) {
      this._preventEventsBeforeInit = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "deceleration", {
    // ANIMATION
    /**
     * Deceleration value for panel movement animation which is triggered by user input. A higher value means a shorter animation time
     * @ko 사용자의 동작으로 가속도가 적용된 패널 이동 애니메이션의 감속도. 값이 높을수록 애니메이션 실행 시간이 짧아집니다
     * @type {number}
     * @default 0.0075
     * @see {@link https://naver.github.io/egjs-flicking/Options#deceleration deceleration ( Options )}
     */
    get: function () {
      return this._deceleration;
    },
    // ANIMATION
    set: function (val) {
      this._deceleration = val;
      var axes = this._control.controller.axes;
      if (axes) {
        axes.options.deceleration = val;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "easing", {
    /**
     * An easing function applied to the panel movement animation. Default value is `easeOutCubic`
     * @ko 패널 이동 애니메이션에 적용할 easing 함수. 기본값은 `easeOutCubic`이다
     * @type {function}
     * @default x => 1 - Math.pow(1 - x, 3)
     * @see Easing Functions Cheat Sheet {@link http://easings.net/} <ko>이징 함수 Cheat Sheet {@link http://easings.net/}</ko>
     * @see {@link https://naver.github.io/egjs-flicking/Options#easing Easing ( Options )}
     */
    get: function () {
      return this._easing;
    },
    set: function (val) {
      this._easing = val;
      var axes = this._control.controller.axes;
      if (axes) {
        axes.options.easing = val;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "duration", {
    /**
     * Default duration of the animation (ms)
     * @ko 디폴트 애니메이션 재생 시간 (ms)
     * @type {number}
     * @default 500
     * @see {@link https://naver.github.io/egjs-flicking/Options#duration duration ( Options )}
     */
    get: function () {
      return this._duration;
    },
    set: function (val) {
      this._duration = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "inputType", {
    // INPUT
    /**
     * Types of input devices to enable
     * @ko 활성화할 입력 장치 종류
     * @type {string[]}
     * @default ["touch", "mouse"]
     * @see {@link https://naver.github.io/egjs-axes/Options#paninput-options Possible values (PanInputOption#inputType)}
     * <ko>{@link https://naver.github.io/egjs-axes/Options#paninput-options 가능한 값들 (PanInputOption#inputType)}</ko>
     * @see {@link https://naver.github.io/egjs-flicking/Options#inputtype inputType ( Options )}
     */
    get: function () {
      return this._inputType;
    },
    // INPUT
    set: function (val) {
      this._inputType = val;
      var panInput = this._control.controller.panInput;
      if (panInput) {
        panInput.options.inputType = val;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "moveType", {
    /**
     * Movement style by user input. This will change instance type of {@link Flicking#control}
     * You can use the values of the constant {@link MOVE_TYPE}
     * @ko 사용자 입력에 의한 이동 방식. 이 값에 따라 {@link Flicking#control}의 인스턴스 타입이 결정됩니다
     * 상수 {@link MOVE_TYPE}에 정의된 값들을 이용할 수 있습니다
     * @type {MOVE_TYPE | Pair<string, object>}
     * @default "snap"
     * @see {@link https://naver.github.io/egjs-flicking/Options#movetype moveType ( Options )}
     * @example
     * |moveType|control|options|
     * |:---:|:---:|:---:|
     * |"snap"|{@link SnapControl}||
     * |"freeScroll"|{@link FreeControl}|{@link FreeControlOptions}|
     *
     * ```ts
     * import Flicking, { MOVE_TYPE } from "@egjs/flicking";
     *
     * const flicking = new Flicking({
     *   moveType: MOVE_TYPE.SNAP
     * });
     * ```
     *
     * ```ts
     * const flicking = new Flicking({
     *   // If you want more specific settings for the moveType
     *   // [moveType, options for that moveType]
     *   // In this case, it's ["freeScroll", FreeControlOptions]
     *   moveType: [MOVE_TYPE.FREE_SCROLL, { stopAtEdge: true }]
     * });
     * ```
     */
    get: function () {
      return this._moveType;
    },
    set: function (val) {
      this._moveType = val;
      var prevControl = this._control;
      var newControl = this._createControl();
      var activePanel = prevControl.activePanel;
      newControl.copy(prevControl);
      var prevProgressInPanel = activePanel ? this._camera.getProgressInPanel(activePanel) : 0;
      this._control = newControl;
      this._control.updatePosition(prevProgressInPanel);
      this._control.updateInput();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "threshold", {
    /**
     * Movement threshold to change panel (unit: px). It should be dragged above the threshold to change the current panel.
     * @ko 패널 변경을 위한 이동 임계값 (단위: px). 주어진 값 이상으로 스크롤해야만 패널 변경이 가능하다.
     * @type {number}
     * @default 40
     * @see {@link https://naver.github.io/egjs-flicking/Options#threshold Threshold ( Options )}
     */
    get: function () {
      return this._threshold;
    },
    set: function (val) {
      this._threshold = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "interruptable", {
    /**
     * Set animation to be interruptable by click/touch.
     * @ko 사용자의 클릭/터치로 인해 애니메이션을 도중에 멈출 수 있도록 설정합니다.
     * @type {boolean}
     * @default true
     * @see {@link https://naver.github.io/egjs-flicking/Options#interruptable Interruptable ( Options )}
     */
    get: function () {
      return this._interruptable;
    },
    set: function (val) {
      this._interruptable = val;
      var axes = this._control.controller.axes;
      if (axes) {
        axes.options.interruptable = val;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "bounce", {
    /**
     * The size value of the bounce area. Only can be enabled when `circular=false`.
     * You can set different bounce value for prev/next direction by using array.
     * `number` for px value, and `string` for px, and % value relative to viewport size.
     * You have to call {@link Control#updateInput} after changing this to take effect.
     * @ko Flicking이 최대 영역을 넘어서 갈 수 있는 최대 크기. `circular=false`인 경우에만 사용할 수 있습니다.
     * 배열을 통해 prev/next 방향에 대해 서로 다른 바운스 값을 지정할 수 있습니다.
     * `number`를 통해 px값을, `stirng`을 통해 px 혹은 뷰포트 크기 대비 %값을 사용할 수 있습니다.
     * 이 값을 변경시 {@link Control#updateInput}를 호출해야 합니다.
     * @type {string | number | Array<string | number>}
     * @default "20%"
     * @see {@link https://naver.github.io/egjs-flicking/Options#bounce bounce ( Options )}
     * @example
     * ```ts
     * const possibleOptions = [
     *   // % values, relative to viewport element(".flicking-viewport")'s size
     *   "0%", "25%", "42%",
     *   // px values, arithmetic calculation with (+/-) is also allowed.
     *   "0px", "100px", "50% - 25px",
     *   // numbers, same to number + px ("0px", "100px")
     *   0, 100, 1000
     * ];
     * ```
     *
     * @example
     * ```ts
     * const flicking = new Flicking("#el", { bounce: "20%" });
     *
     * flicking.bounce = "100%";
     * flicking.control.updateInput(); // Call this to update!
     * ```
     */
    get: function () {
      return this._bounce;
    },
    set: function (val) {
      this._bounce = val;
      this._control.updateInput();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "iOSEdgeSwipeThreshold", {
    /**
     * Size of the area from the right edge in iOS safari (in px) which enables swipe-back or swipe-forward
     * @ko iOS Safari에서 swipe를 통한 뒤로가기/앞으로가기를 활성화하는 오른쪽 끝으로부터의 영역의 크기 (px)
     * @type {number}
     * @default 30
     * @see {@link https://naver.github.io/egjs-flicking/Options#iosedgeswipethreshold iOSEdgeSwipeThreshold ( Options )}
     */
    get: function () {
      return this._iOSEdgeSwipeThreshold;
    },
    set: function (val) {
      this._iOSEdgeSwipeThreshold = val;
      var panInput = this._control.controller.panInput;
      if (panInput) {
        panInput.options.iOSEdgeSwipeThreshold = val;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "preventClickOnDrag", {
    /**
     * Automatically prevent `click` event if the user has dragged at least a single pixel on the viewport element
     * @ko 사용자가 뷰포트 영역을 1픽셀이라도 드래그했을 경우 자동으로 {@link https://developer.mozilla.org/ko/docs/Web/API/Element/click_event click} 이벤트를 취소합니다
     * @type {boolean}
     * @default true
     * @see {@link https://naver.github.io/egjs-flicking/Options#preventclickondrag preventClickOnDrag ( Options )}
     */
    get: function () {
      return this._preventClickOnDrag;
    },
    set: function (val) {
      var prevVal = this._preventClickOnDrag;
      if (val === prevVal) return;
      var controller = this._control.controller;
      if (val) {
        controller.addPreventClickHandler();
      } else {
        controller.removePreventClickHandler();
      }
      this._preventClickOnDrag = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "disableOnInit", {
    /**
     * Automatically call {@link Flicking#disableInput disableInput()} on initialization
     * @ko Flicking init시에 {@link Flicking#disableInput disableInput()}을 바로 호출합니다
     * @type {boolean}
     * @default false
     * @see {@link https://naver.github.io/egjs-flicking/Options#disableoninit disableOnInit ( Options )}
     */
    get: function () {
      return this._disableOnInit;
    },
    set: function (val) {
      this._disableOnInit = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "changeOnHold", {
    /**
     * Change active panel index on mouse/touch hold while animating.
     * `index` of the `willChange`/`willRestore` event will be used as new index.
     * @ko 애니메이션 도중 마우스/터치 입력시 현재 활성화된 패널의 인덱스를 변경합니다.
     * `willChange`/`willRestore` 이벤트의 `index`값이 새로운 인덱스로 사용될 것입니다.
     * @type {boolean}
     * @default false
     * @see {@link https://naver.github.io/egjs-flicking/Options#changeonhold changeOnHold ( Options )}
     */
    get: function () {
      return this._changeOnHold;
    },
    set: function (val) {
      this._changeOnHold = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "renderOnlyVisible", {
    // PERFORMANCE
    /**
     * Whether to render visible panels only. This can dramatically increase performance when there're many panels
     * @ko 보이는 패널만 렌더링할지 여부를 설정합니다. 패널이 많을 경우에 퍼포먼스를 크게 향상시킬 수 있습니다
     * @type {boolean}
     * @default false
     * @see {@link https://naver.github.io/egjs-flicking/Options#renderonlyvisible renderOnlyVisible ( Options )}
     */
    get: function () {
      return this._renderOnlyVisible;
    },
    // PERFORMANCE
    set: function (val) {
      this._renderOnlyVisible = val;
      void this._renderer.render();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "virtual", {
    /**
     * By enabling this option, it will reduce memory consumption by restricting the number of DOM elements to `panelsPerView + 1`
     * Must be used with `panelsPerview`.
     * After Flicking's initialized, this property can be used to add/remove the panel count.
     * @ko 이 옵션을 활성화할 경우 패널 엘리먼트의 개수를 `panelsPerView + 1` 개로 고정함으로써, 메모리 사용량을 줄일 수 있습니다.
     * `panelsPerView` 옵션과 함께 사용되어야만 합니다.
     * Flicking 초기화 이후에, 이 프로퍼티는 렌더링하는 패널의 개수를 추가/제거하기 위해 사용될 수 있습니다.
     * @type {VirtualManager}
     * @property {function} renderPanel A rendering function for the panel element's innerHTML<ko>패널 엘리먼트의 innerHTML을 렌더링하는 함수</ko>
     * @property {number} initialPanelCount Initial panel count to render<ko>최초로 렌더링할 패널의 개수</ko>
     * @property {boolean} [cache=false] Whether to cache rendered panel's innerHTML<ko>렌더링된 패널의 innerHTML 정보를 캐시할지 여부</ko>
     * @property {string} [panelClass="flicking-panel"] The class name that will be applied to rendered panel elements<ko>렌더링되는 패널 엘리먼트에 적용될 클래스 이름</ko>
     * @see {@link https://naver.github.io/egjs-flicking/Options#virtual virtual ( Options )}
     * @example
     * ```ts
     * import Flicking, { VirtualPanel } from "@egjs/flicking";
     *
     * const flicking = new Flicking("#some_el", {
     *   panelsPerView: 3,
     *   virtual: {
     *     renderPanel: (panel: VirtualPanel, index: number) => `Panel ${index}`,
     *     initialPanelCount: 100
     *   }
     * });
     *
     * // Add 100 virtual panels (at the end)
     * flicking.virtual.append(100);
     *
     * // Remove 100 virtual panels from 0 to 100
     * flicking.virtual.remove(0, 100);
     * ```
     */
    get: function () {
      return this._virtualManager;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "autoInit", {
    // OTHERS
    /**
     * Call {@link Flicking#init init()} automatically when creating Flicking's instance
     * @ko Flicking 인스턴스를 생성할 때 자동으로 {@link Flicking#init init()}를 호출합니다
     * @type {boolean}
     * @default true
     * @see {@link https://naver.github.io/egjs-flicking/Options#autoinit autoInit ( Options )}
     * @readonly
     */
    get: function () {
      return this._autoInit;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "autoResize", {
    /**
     * Whether to automatically call {@link Flicking#resize resize()} when the viewport element(.flicking-viewport)'s size is changed
     * @ko 뷰포트 엘리먼트(.flicking-viewport)의 크기 변경시 {@link Flicking#resize resize()} 메소드를 자동으로 호출할지 여부를 설정합니다
     * @type {boolean}
     * @default true
     */
    get: function () {
      return this._autoResize;
    },
    // OTHERS
    set: function (val) {
      this._autoResize = val;
      if (val) {
        this._autoResizer.enable();
      } else {
        this._autoResizer.disable();
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "useResizeObserver", {
    /**
     * Whether to listen {@link https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver ResizeObserver}'s event instead of Window's {@link https://developer.mozilla.org/ko/docs/Web/API/Window/resize_event resize} event when using the `autoResize` option
     * @ko autoResize 옵션 사용시 {@link https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver ResizeObserver}의 이벤트를 Window객체의 {@link https://developer.mozilla.org/ko/docs/Web/API/Window/resize_event resize} 이벤트 대신 수신할지 여부를 설정합니다
     * @type {boolean}
     * @default true
     * @see {@link https://naver.github.io/egjs-flicking/Options#useresizeobserver useResizeObserver ( Options )}
     */
    get: function () {
      return this._useResizeObserver;
    },
    set: function (val) {
      this._useResizeObserver = val;
      if (this._autoResize) {
        this._autoResizer.enable();
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "resizeDebounce", {
    /**
     * Delays size recalculation from `autoResize` by the given time in milisecond.
     * If the size is changed again while being delayed, it cancels the previous one and delays from the beginning again.
     * This can increase performance by preventing `resize` being called too often.
     * @ko `autoResize` 설정시에 호출되는 크기 재계산을 주어진 시간(단위: ms)만큼 지연시킵니다.
     * 지연시키는 도중 크기가 다시 변경되었을 경우, 이전 것을 취소하고 주어진 시간만큼 다시 지연시킵니다.
     * 이를 통해 `resize`가 너무 많이 호출되는 것을 방지하여 성능을 향상시킬 수 있습니다.
     * @type {number}
     * @default 0
     * @see {@link https://naver.github.io/egjs-flicking/Options#resizedebounce resizeDebounce ( Options )}
     */
    get: function () {
      return this._resizeDebounce;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "maxResizeDebounce", {
    /**
     * The maximum time for size recalculation delay when using `resizeDebounce`, in milisecond.
     * This guarantees that size recalculation is performed at least once every (n)ms.
     * @ko `resizeDebounce` 사용시에 크기 재계산이 지연되는 최대 시간을 지정합니다. (단위: ms)
     * 이를 통해, 적어도 (n)ms에 한번은 크기 재계산을 수행하는 것을 보장할 수 있습니다.
     * @type {number}
     * @default 100
     * @see {@link https://naver.github.io/egjs-flicking/Options#maxresizedebounce maxResizeDebounce ( Options )}
     */
    get: function () {
      return this._maxResizeDebounce;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "useFractionalSize", {
    /**
     * By enabling this, Flicking will calculate all internal size with CSS width computed with getComputedStyle.
     * This can prevent 1px offset issue in some cases where panel size has the fractional part.
     * All sizes will have the original size before CSS {@link https://developer.mozilla.org/en-US/docs/Web/CSS/transform transform} is applied on the element.
     * @ko 이 옵션을 활성화할 경우, Flicking은 내부의 모든 크기를 {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect getBoundingClientRect}를 이용하여 계산합니다.
     * 이를 통해, 패널 크기에 소수점을 포함할 경우에 발생할 수 있는 일부 1px 오프셋 이슈를 해결 가능합니다.
     * 모든 크기는 CSS {@link https://developer.mozilla.org/en-US/docs/Web/CSS/transform transform}이 엘리먼트에 적용되기 이전의 크기를 사용할 것입니다.
     * @type {boolean}
     * @default false
     * @see {@link https://naver.github.io/egjs-flicking/Options#usefractionalsize useFractionalSize ( Options )}
     */
    get: function () {
      return this._useFractionalSize;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "externalRenderer", {
    /**
     * This is an option for the frameworks(React, Vue, Angular, ...). Don't set it as it's automatically managed by Flicking.
     * @ko 프레임워크(React, Vue, Angular, ...)에서만 사용하는 옵션으로, 자동으로 설정되므로 따로 사용하실 필요 없습니다!
     * @default null
     * @internal
     * @readonly
     */
    get: function () {
      return this._externalRenderer;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "renderExternal", {
    /**
     * This is an option for the frameworks(React, Vue, Angular, ...). Don't set it as it's automatically managed by Flicking.
     * @ko 프레임워크(React, Vue, Angular, ...)에서만 사용하는 옵션으로, 자동으로 설정되므로 따로 사용하실 필요 없습니다!
     * @default null
     * @internal
     * @readonly
     * @deprecated
     */
    get: function () {
      return this._renderExternal;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Initialize Flicking and move to the default index
   * This is automatically called on Flicking's constructor when `autoInit` is true(default)
   * @ko Flicking을 초기화하고, 디폴트 인덱스로 이동합니다
   * 이 메소드는 `autoInit` 옵션이 true(default)일 경우 Flicking이 생성될 때 자동으로 호출됩니다
   * @fires Flicking#ready
   * @return {Promise<void>}
   */
  __proto.init = function () {
    var _this = this;
    if (this._initialized) return Promise.resolve();
    var camera = this._camera;
    var renderer = this._renderer;
    var control = this._control;
    var virtualManager = this._virtualManager;
    var originalTrigger = this.trigger;
    var preventEventsBeforeInit = this._preventEventsBeforeInit;
    camera.init();
    virtualManager.init();
    renderer.init(this);
    control.init(this);
    if (preventEventsBeforeInit) {
      this.trigger = function () {
        return _this;
      };
    }
    this._initialResize();
    // Look at initial panel
    this._moveToInitialPanel();
    if (this._autoResize) {
      this._autoResizer.enable();
    }
    if (this._preventClickOnDrag) {
      control.controller.addPreventClickHandler();
    }
    if (this._disableOnInit) {
      this.disableInput();
    }
    renderer.checkPanelContentsReady(renderer.panels);
    this._initialized = true;
    return renderer.render().then(function () {
      // Done initializing & emit ready event
      _this._plugins.forEach(function (plugin) {
        return plugin.init(_this);
      });
      if (preventEventsBeforeInit) {
        _this.trigger = originalTrigger;
      }
      _this.trigger(new ComponentEvent$1(flicking_esm_EVENTS.READY));
    });
  };
  /**
   * Destroy Flicking and remove all event handlers
   * @ko Flicking과 하위 컴포넌트들을 초기 상태로 되돌리고, 부착된 모든 이벤트 핸들러를 제거합니다
   * @return {void}
   */
  __proto.destroy = function () {
    this.off();
    this._autoResizer.disable();
    this._control.destroy();
    this._camera.destroy();
    this._renderer.destroy();
    this._plugins.forEach(function (plugin) {
      return plugin.destroy();
    });
    this._initialized = false;
  };
  /**
   * Move to the previous panel (current index - 1)
   * @ko 이전 패널로 이동합니다 (현재 인덱스 - 1)
   * @param {number} [duration={@link Flicking#duration options.duration}] Duration of the panel movement animation (unit: ms)<ko>패널 이동 애니메이션 진행 시간 (단위: ms)</ko>
   * @async
   * @fires Flicking#moveStart
   * @fires Flicking#move
   * @fires Flicking#moveEnd
   * @fires Flicking#willChange
   * @fires Flicking#changed
   * @fires Flicking#willRestore
   * @fires Flicking#restored
   * @fires Flicking#needPanel
   * @fires Flicking#visibleChange
   * @fires Flicking#reachEdge
   * @throws {FlickingError}
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE INDEX_OUT_OF_RANGE}|When the previous panel does not exist|
   * |{@link ERROR_CODE ANIMATION_ALREADY_PLAYING}|When the animation is already playing|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|When the animation is interrupted by user input|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|When the any of the event's `stop()` is called|
   * <ko>
   *
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE INDEX_OUT_OF_RANGE}|이전 패널이 존재하지 않을 경우|
   * |{@link ERROR_CODE ANIMATION_ALREADY_PLAYING}|애니메이션이 이미 진행중인 경우|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|사용자 입력에 의해 애니메이션이 중단된 경우|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|발생된 이벤트들 중 하나라도 `stop()`이 호출된 경우|
   * </ko>
   * @return {Promise<void>} A Promise which will be resolved after reaching the previous panel<ko>이전 패널 도달시에 resolve되는 Promise</ko>
   */
  __proto.prev = function (duration) {
    var _a, _b, _c;
    if (duration === void 0) {
      duration = this._duration;
    }
    return this.moveTo((_c = (_b = (_a = this._control.activePanel) === null || _a === void 0 ? void 0 : _a.prev()) === null || _b === void 0 ? void 0 : _b.index) !== null && _c !== void 0 ? _c : -1, duration, DIRECTION.PREV);
  };
  /**
   * Move to the next panel (current index + 1)
   * @ko 다음 패널로 이동합니다 (현재 인덱스 + 1)
   * @param {number} [duration={@link Flicking#duration options.duration}] Duration of the panel movement animation (unit: ms).<ko>패널 이동 애니메이션 진행 시간 (단위: ms)</ko>
   * @async
   * @fires Flicking#moveStart
   * @fires Flicking#move
   * @fires Flicking#moveEnd
   * @fires Flicking#willChange
   * @fires Flicking#changed
   * @fires Flicking#willRestore
   * @fires Flicking#restored
   * @fires Flicking#needPanel
   * @fires Flicking#visibleChange
   * @fires Flicking#reachEdge
   * @throws {FlickingError}
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE INDEX_OUT_OF_RANGE}|When the next panel does not exist|
   * |{@link ERROR_CODE ANIMATION_ALREADY_PLAYING}|When the animation is already playing|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|When the animation is interrupted by user input|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|When the any of the event's `stop()` is called|
   * <ko>
   *
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE INDEX_OUT_OF_RANGE}|다음 패널이 존재하지 않을 경우|
   * |{@link ERROR_CODE ANIMATION_ALREADY_PLAYING}|애니메이션이 이미 진행중인 경우|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|사용자 입력에 의해 애니메이션이 중단된 경우|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|발생된 이벤트들 중 하나라도 `stop()`이 호출된 경우|
   *
   * </ko>
   * @return {Promise<void>} A Promise which will be resolved after reaching the next panel<ko>다음 패널 도달시에 resolve되는 Promise</ko>
   */
  __proto.next = function (duration) {
    var _a, _b, _c;
    if (duration === void 0) {
      duration = this._duration;
    }
    return this.moveTo((_c = (_b = (_a = this._control.activePanel) === null || _a === void 0 ? void 0 : _a.next()) === null || _b === void 0 ? void 0 : _b.index) !== null && _c !== void 0 ? _c : this._renderer.panelCount, duration, DIRECTION.NEXT);
  };
  /**
   * Move to the panel with given index
   * @ko 주어진 인덱스에 해당하는 패널로 이동합니다
   * @param {number} index The index of the panel to move<ko>이동할 패널의 인덱스</ko>
   * @param {number} [duration={@link Flicking#duration options.duration}] Duration of the animation (unit: ms)<ko>애니메이션 진행 시간 (단위: ms)</ko>
   * @param {DIRECTION} [direction=DIRECTION.NONE] Direction to move, only available in the {@link Flicking#circular circular} mode<ko>이동할 방향. {@link Flicking#circular circular} 옵션 활성화시에만 사용 가능합니다</ko>
   * @async
   * @fires Flicking#moveStart
   * @fires Flicking#move
   * @fires Flicking#moveEnd
   * @fires Flicking#willChange
   * @fires Flicking#changed
   * @fires Flicking#willRestore
   * @fires Flicking#restored
   * @fires Flicking#needPanel
   * @fires Flicking#visibleChange
   * @fires Flicking#reachEdge
   * @throws {FlickingError}
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE INDEX_OUT_OF_RANGE}|When the root is not either string or HTMLElement|
   * |{@link ERROR_CODE ANIMATION_ALREADY_PLAYING}|When the animation is already playing|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|When the animation is interrupted by user input|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|When the any of the event's `stop()` is called|
   * <ko>
   *
   * |code|condition|
   * |---|---|
   * |{@link ERROR_CODE INDEX_OUT_OF_RANGE}|해당 인덱스를 가진 패널이 존재하지 않을 경우|
   * |{@link ERROR_CODE ANIMATION_ALREADY_PLAYING}|애니메이션이 이미 진행중인 경우|
   * |{@link ERROR_CODE ANIMATION_INTERRUPTED}|사용자 입력에 의해 애니메이션이 중단된 경우|
   * |{@link ERROR_CODE STOP_CALLED_BY_USER}|발생된 이벤트들 중 하나라도 `stop()`이 호출된 경우|
   *
   * </ko>
   * @return {Promise<void>} A Promise which will be resolved after reaching the target panel<ko>해당 패널 도달시에 resolve되는 Promise</ko>
   */
  __proto.moveTo = function (index, duration, direction) {
    if (duration === void 0) {
      duration = this._duration;
    }
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    var renderer = this._renderer;
    var panelCount = renderer.panelCount;
    var panel = renderer.getPanel(index);
    if (!panel) {
      return Promise.reject(new FlickingError(MESSAGE.INDEX_OUT_OF_RANGE(index, 0, panelCount - 1), CODE.INDEX_OUT_OF_RANGE));
    }
    if (this._control.animating) {
      return Promise.reject(new FlickingError(MESSAGE.ANIMATION_ALREADY_PLAYING, CODE.ANIMATION_ALREADY_PLAYING));
    }
    if (this._control.holding) {
      this._control.controller.release();
    }
    return this._control.moveToPanel(panel, {
      duration: duration,
      direction: direction
    });
  };
  /**
   * Change the destination and duration of the animation currently playing
   * @ko 재생 중인 애니메이션의 목적지와 재생 시간을 변경합니다
   * @param {number} index The index of the panel to move<ko>이동할 패널의 인덱스</ko>
   * @param {number} duration Duration of the animation (unit: ms)<ko>애니메이션 진행 시간 (단위: ms)</ko>
   * @param {DIRECTION} direction Direction to move, only available in the {@link Flicking#circular circular} mode<ko>이동할 방향. {@link Flicking#circular circular} 옵션 활성화시에만 사용 가능합니다</ko>
   * @throws {FlickingError}
   * {@link ERROR_CODE INDEX_OUT_OF_RANGE} When the root is not either string or HTMLElement
   * <ko>{@link ERROR_CODE INDEX_OUT_OF_RANGE} 해당 인덱스를 가진 패널이 존재하지 않을 경우</ko>
   * @return {void}
   */
  __proto.updateAnimation = function (index, duration, direction) {
    if (!this._control.animating) {
      return;
    }
    var renderer = this._renderer;
    var panelCount = renderer.panelCount;
    var panel = renderer.getPanel(index);
    if (!panel) {
      throw new FlickingError(MESSAGE.INDEX_OUT_OF_RANGE(index, 0, panelCount - 1), CODE.INDEX_OUT_OF_RANGE);
    }
    this._control.updateAnimation(panel, duration, direction);
  };
  /**
   * Stops the animation currently playing
   * @ko 재생 중인 애니메이션을 중단시킵니다
   * @fires Flicking#moveEnd
   * @return {void}
   */
  __proto.stopAnimation = function () {
    if (!this._control.animating) {
      return;
    }
    this._control.stopAnimation();
  };
  /**
   * Return the {@link Panel} at the given index. `null` if it doesn't exists.
   * @ko 주어진 인덱스에 해당하는 {@link Panel}을 반환합니다. 주어진 인덱스에 해당하는 패널이 존재하지 않을 경우 `null`을 반환합니다.
   * @return {Panel | null} Panel at the given index<ko>주어진 인덱스에 해당하는 패널</ko>
   * @see Panel
   * @example
   * ```ts
   * const panel = flicking.getPanel(0);
   * // Which is a shorthand to...
   * const samePanel = flicking.panels[0];
   * ```
   */
  __proto.getPanel = function (index) {
    return this._renderer.getPanel(index);
  };
  /**
   * Enable input from the user (mouse/touch)
   * @ko 사용자의 입력(마우스/터치)를 활성화합니다
   * @return {this}
   */
  __proto.enableInput = function () {
    this._control.enable();
    return this;
  };
  /**
   * Disable input from the user (mouse/touch)
   * @ko 사용자의 입력(마우스/터치)를 막습니다
   * @return {this}
   */
  __proto.disableInput = function () {
    this._control.disable();
    return this;
  };
  /**
   * Get current flicking status. You can restore current state by giving returned value to {@link Flicking#setStatus setStatus()}
   * @ko 현재 상태를 반환합니다. 반환받은 값을 {@link Flicking#setStatus setStatus()} 메소드의 인자로 지정하면 현재 상태를 복원할 수 있습니다
   * @param {object} options Status retrieving options<ko>Status 반환 옵션</ko>
   * @param {boolean} [options.index=true] Include current panel index to the returning status. Camera will automatically move to the given index when the {@link Flicking#setStatus setStatus} is called<ko>현재 패널 인덱스를 반환값에 포함시킵니다. {@link Flicking#setStatus setStatus} 호출시 자동으로 해당 인덱스로 카메라를 움직입니다</ko>
   * @param {boolean} [options.position=true] Include camera position to the returning status. This works only when the {@link Flicking#moveType moveType} is `freeScroll`<ko>카메라의 현재 위치를 반환값에 포함시킵니다. 이 옵션은 {@link Flicking#moveType moveType}이 `freeScroll`일 경우에만 동작합니다</ko>
   * @param {boolean} [options.includePanelHTML=false] Include panel's `outerHTML` to the returning status<ko>패널의 `outerHTML`을 반환값에 포함시킵니다</ko>
   * @param {boolean} [options.visiblePanelsOnly=false] Include only {@link Flicking#visiblePanel visiblePanel}'s HTML. This option is available only when the `includePanelHTML` is true
   * <ko>현재 보이는 패널({@link Flicking#visiblePanel visiblePanel})의 HTML만 반환합니다. `includePanelHTML`이 `true`일 경우에만 동작합니다.</ko>
   * @return {Status} An object with current status value information<ko>현재 상태값 정보를 가진 객체.</ko>
   */
  __proto.getStatus = function (_a) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a,
      _e = _d.index,
      index = _e === void 0 ? true : _e,
      _f = _d.position,
      position = _f === void 0 ? true : _f,
      _g = _d.includePanelHTML,
      includePanelHTML = _g === void 0 ? false : _g,
      _h = _d.visiblePanelsOnly,
      visiblePanelsOnly = _h === void 0 ? false : _h;
    var camera = this._camera;
    var panels = visiblePanelsOnly ? this.visiblePanels : this.panels;
    var status = {
      panels: panels.map(function (panel) {
        var panelInfo = {
          index: panel.index
        };
        if (includePanelHTML) {
          panelInfo.html = panel.element.outerHTML;
        }
        return panelInfo;
      })
    };
    if (index) {
      status.index = this.index;
    }
    if (position) {
      var nearestAnchor = camera.findNearestAnchor(camera.position);
      if (nearestAnchor) {
        status.position = {
          panel: nearestAnchor.panel.index,
          progressInPanel: camera.getProgressInPanel(nearestAnchor.panel)
        };
      }
    }
    if (visiblePanelsOnly) {
      var visiblePanels = this.visiblePanels;
      status.visibleOffset = (_c = (_b = visiblePanels[0]) === null || _b === void 0 ? void 0 : _b.index) !== null && _c !== void 0 ? _c : 0;
    }
    return status;
  };
  /**
   * Restore to the state of the given {@link Status}
   * @ko 주어진 {@link Status}의 상태로 복원합니다
   * @param {Partial<Status>} status Status value to be restored. You should use the return value of the {@link Flicking#getStatus getStatus()} method<ko>복원할 상태 값. {@link Flicking#getStatus getStatus()} 메서드의 반환값을 지정하면 됩니다</ko>
   * @return {void}
   */
  __proto.setStatus = function (status) {
    var _a;
    if (!this._initialized) {
      throw new FlickingError(MESSAGE.NOT_INITIALIZED, CODE.NOT_INITIALIZED);
    }
    var index = status.index,
      position = status.position,
      visibleOffset = status.visibleOffset,
      panels = status.panels;
    var renderer = this._renderer;
    var control = this._control;
    // Can't add/remove panels on external rendering
    if (((_a = panels[0]) === null || _a === void 0 ? void 0 : _a.html) && !this._renderExternal) {
      renderer.batchRemove({
        index: 0,
        deleteCount: this.panels.length,
        hasDOMInElements: true
      });
      renderer.batchInsert({
        index: 0,
        elements: parseElement(panels.map(function (panel) {
          return panel.html;
        })),
        hasDOMInElements: true
      });
    }
    if (index != null) {
      var panelIndex = visibleOffset ? index - visibleOffset : index;
      void this.moveTo(panelIndex, 0).catch(function () {
        return void 0;
      });
    }
    if (position && this._moveType === MOVE_TYPE.FREE_SCROLL) {
      var panel = position.panel,
        progressInPanel = position.progressInPanel;
      var panelIndex = visibleOffset ? panel - visibleOffset : panel;
      var panelRange = renderer.panels[panelIndex].range;
      var newCameraPos = panelRange.min + (panelRange.max - panelRange.min) * progressInPanel;
      void control.moveToPosition(newCameraPos, 0).catch(function () {
        return void 0;
      });
    }
  };
  /**
   * Add plugins that can have different effects on Flicking
   * @ko 플리킹에 다양한 효과를 부여할 수 있는 플러그인을 추가합니다
   * @param {...Plugin} plugins The plugin(s) to add<ko>추가할 플러그인(들)</ko>
   * @return {this}
   * @see https://github.com/naver/egjs-flicking-plugins
   */
  __proto.addPlugins = function () {
    var _a;
    var _this = this;
    var plugins = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      plugins[_i] = arguments[_i];
    }
    if (this._initialized) {
      plugins.forEach(function (item) {
        return item.init(_this);
      });
    }
    (_a = this._plugins).push.apply(_a, flicking_esm_spread(plugins));
    return this;
  };
  /**
   * Remove plugins from Flicking.
   * @ko 플리킹으로부터 플러그인들을 제거합니다.
   * @param {...Plugin} plugin The plugin(s) to remove.<ko>제거 플러그인(들).</ko>
   * @return {this}
   * @see https://github.com/naver/egjs-flicking-plugins
   */
  __proto.removePlugins = function () {
    var _this = this;
    var plugins = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      plugins[_i] = arguments[_i];
    }
    plugins.forEach(function (item) {
      var foundIndex = flicking_esm_findIndex(_this._plugins, function (val) {
        return val === item;
      });
      if (foundIndex >= 0) {
        item.destroy();
        _this._plugins.splice(foundIndex, 1);
      }
    });
    return this;
  };
  /**
   * Update viewport/panel sizes
   * @ko 패널 및 뷰포트의 크기를 갱신합니다
   * @method
   * @fires Flicking#beforeResize
   * @fires Flicking#afterResize
   * @return {this}
   */
  __proto.resize = function () {
    return __awaiter(this, void 0, void 0, function () {
      var viewport, renderer, camera, control, activePanel, prevWidth, prevHeight, prevProgressInPanel, newWidth, newHeight, sizeChanged;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            viewport = this._viewport;
            renderer = this._renderer;
            camera = this._camera;
            control = this._control;
            activePanel = control.activePanel;
            prevWidth = viewport.width;
            prevHeight = viewport.height;
            prevProgressInPanel = activePanel ? camera.getProgressInPanel(activePanel) : 0;
            this.trigger(new ComponentEvent$1(flicking_esm_EVENTS.BEFORE_RESIZE, {
              width: prevWidth,
              height: prevHeight,
              element: viewport.element
            }));
            viewport.resize();
            return [4 /*yield*/, renderer.forceRenderAllPanels()];
          case 1:
            _a.sent(); // Render all panel elements, to update sizes
            renderer.updatePanelSize();
            camera.updateAlignPos();
            camera.updateRange();
            camera.updateAnchors();
            camera.updateAdaptiveHeight();
            camera.updateOffset();
            return [4 /*yield*/, renderer.render()];
          case 2:
            _a.sent();
            if (control.animating) ; else {
              control.updatePosition(prevProgressInPanel);
              control.updateInput();
            }
            newWidth = viewport.width;
            newHeight = viewport.height;
            sizeChanged = newWidth !== prevWidth || newHeight !== prevHeight;
            this.trigger(new ComponentEvent$1(flicking_esm_EVENTS.AFTER_RESIZE, {
              width: viewport.width,
              height: viewport.height,
              prev: {
                width: prevWidth,
                height: prevHeight
              },
              sizeChanged: sizeChanged,
              element: viewport.element
            }));
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * Add new panels after the last panel
   * @ko 패널 목록의 제일 끝에 새로운 패널들을 추가합니다
   * @param {ElementLike | ElementLike[]} element A new HTMLElement, a outerHTML of element, or an array of both
   * <ko>새로운 HTMLElement, 혹은 엘리먼트의 outerHTML, 혹은 그것들의 배열</ko>
   * @return {Panel[]} An array of appended panels<ko>추가된 패널들의 배열</ko>
   * @see Panel
   * @see ElementLike
   * @throws {FlickingError} {@link ERROR_CODE ERROR_CODE.NOT_ALLOWED_IN_FRAMEWORK} if called on frameworks (React, Angular, Vue...)
   * @example
   * ```ts
   * const flicking = new Flicking("#flick");
   * // These are possible parameters
   * flicking.append(document.createElement("div"));
   * flicking.append("\<div\>Panel\</div\>");
   * flicking.append(["\<div\>Panel\</div\>", document.createElement("div")]);
   * // Even this is possible
   * flicking.append("\<div\>Panel 1\</div\>\<div\>Panel 2\</div\>");
   * ```
   */
  __proto.append = function (element) {
    return this.insert(this._renderer.panelCount, element);
  };
  /**
   * Add new panels before the first panel
   * This will increase index of panels after by the number of panels added
   * @ko 패널 목록의 제일 앞(index 0)에 새로운 패널들을 추가합니다
   * 추가한 패널의 개수만큼 기존 패널들의 인덱스가 증가합니다.
   * @param {ElementLike | ElementLike[]} element A new HTMLElement, a outerHTML of element, or an array of both
   * <ko>새로운 HTMLElement, 혹은 엘리먼트의 outerHTML, 혹은 그것들의 배열</ko>
   * @return {Panel[]} An array of prepended panels<ko>추가된 패널들의 배열</ko>
   * @see Panel
   * @see ElementLike
   * @throws {FlickingError} {@link ERROR_CODE ERROR_CODE.NOT_ALLOWED_IN_FRAMEWORK} if called on frameworks (React, Angular, Vue...)
   * @example
   * ```ts
   * const flicking = new eg.Flicking("#flick");
   * flicking.prepend(document.createElement("div"));
   * flicking.prepend("\<div\>Panel\</div\>");
   * flicking.prepend(["\<div\>Panel\</div\>", document.createElement("div")]);
   * // Even this is possible
   * flicking.prepend("\<div\>Panel 1\</div\>\<div\>Panel 2\</div\>");
   * ```
   */
  __proto.prepend = function (element) {
    return this.insert(0, element);
  };
  /**
   * Insert new panels at given index
   * This will increase index of panels after by the number of panels added
   * @ko 주어진 인덱스에 새로운 패널들을 추가합니다
   * 해당 인덱스보다 같거나 큰 인덱스를 가진 기존 패널들은 추가한 패널의 개수만큼 인덱스가 증가합니다.
   * @param {number} index Index to insert new panels at<ko>새로 패널들을 추가할 인덱스</ko>
   * @param {ElementLike | ElementLike[]} element A new HTMLElement, a outerHTML of element, or an array of both
   * <ko>새로운 HTMLElement, 혹은 엘리먼트의 outerHTML, 혹은 그것들의 배열</ko>
   * @return {Panel[]} An array of prepended panels<ko>추가된 패널들의 배열</ko>
   * @throws {FlickingError} {@link ERROR_CODE ERROR_CODE.NOT_ALLOWED_IN_FRAMEWORK} if called on frameworks (React, Angular, Vue...)
   * @example
   * ```ts
   * const flicking = new eg.Flicking("#flick");
   * flicking.insert(0, document.createElement("div"));
   * flicking.insert(2, "\<div\>Panel\</div\>");
   * flicking.insert(1, ["\<div\>Panel\</div\>", document.createElement("div")]);
   * // Even this is possible
   * flicking.insert(3, "\<div\>Panel 1\</div\>\<div\>Panel 2\</div\>");
   * ```
   */
  __proto.insert = function (index, element) {
    if (this._renderExternal) {
      throw new FlickingError(MESSAGE.NOT_ALLOWED_IN_FRAMEWORK, CODE.NOT_ALLOWED_IN_FRAMEWORK);
    }
    return this._renderer.batchInsert({
      index: index,
      elements: parseElement(element),
      hasDOMInElements: true
    });
  };
  /**
   * Remove the panel at the given index
   * This will decrease index of panels after by the number of panels removed
   * @ko 주어진 인덱스의 패널을 제거합니다
   * 해당 인덱스보다 큰 인덱스를 가진 기존 패널들은 제거한 패널의 개수만큼 인덱스가 감소합니다
   * @param {number} index Index of panel to remove<ko>제거할 패널의 인덱스</ko>
   * @param {number} [deleteCount=1] Number of panels to remove from index<ko>`index` 이후로 제거할 패널의 개수</ko>
   * @return {Panel[]} An array of removed panels<ko>제거된 패널들의 배열</ko>
   */
  __proto.remove = function (index, deleteCount) {
    if (deleteCount === void 0) {
      deleteCount = 1;
    }
    if (this._renderExternal) {
      throw new FlickingError(MESSAGE.NOT_ALLOWED_IN_FRAMEWORK, CODE.NOT_ALLOWED_IN_FRAMEWORK);
    }
    return this._renderer.batchRemove({
      index: index,
      deleteCount: deleteCount,
      hasDOMInElements: true
    });
  };
  __proto._createControl = function () {
    var _a;
    var moveType = this._moveType;
    var moveTypes = Object.keys(MOVE_TYPE).map(function (key) {
      return MOVE_TYPE[key];
    });
    var moveTypeStr = Array.isArray(moveType) ? moveType[0] : moveType;
    var moveTypeOptions = Array.isArray(moveType) ? (_a = moveType[1]) !== null && _a !== void 0 ? _a : {} : {};
    if (!includes(moveTypes, moveTypeStr)) {
      throw new FlickingError(MESSAGE.WRONG_OPTION("moveType", JSON.stringify(moveType)), CODE.WRONG_OPTION);
    }
    switch (moveTypeStr) {
      case MOVE_TYPE.SNAP:
        return new SnapControl(moveTypeOptions);
      case MOVE_TYPE.FREE_SCROLL:
        return new FreeControl(moveTypeOptions);
      case MOVE_TYPE.STRICT:
        return new StrictControl(moveTypeOptions);
    }
  };
  __proto._createCamera = function () {
    if (this._circular && this._bound) {
      // eslint-disable-next-line no-console
      console.warn("\"circular\" and \"bound\" option cannot be used together, ignoring bound.");
    }
    return new flicking_esm_Camera(this, {
      align: this._align
    });
  };
  __proto._createRenderer = function () {
    var externalRenderer = this._externalRenderer;
    if (this._virtual && this._panelsPerView <= 0) {
      // eslint-disable-next-line no-console
      console.warn("\"virtual\" and \"panelsPerView\" option should be used together, ignoring virtual.");
    }
    return externalRenderer ? externalRenderer : this._renderExternal ? this._createExternalRenderer() : this._createVanillaRenderer();
  };
  __proto._createExternalRenderer = function () {
    var _a = this._renderExternal,
      renderer = _a.renderer,
      rendererOptions = _a.rendererOptions;
    return new renderer(flicking_esm_assign({
      align: this._align
    }, rendererOptions));
  };
  __proto._createVanillaRenderer = function () {
    var virtual = this.virtualEnabled;
    return new VanillaRenderer({
      align: this._align,
      strategy: virtual ? new VirtualRenderingStrategy() : new NormalRenderingStrategy({
        providerCtor: VanillaElementProvider
      })
    });
  };
  __proto._moveToInitialPanel = function () {
    var renderer = this._renderer;
    var control = this._control;
    var camera = this._camera;
    var defaultPanel = renderer.getPanel(this._defaultIndex) || renderer.getPanel(0);
    if (!defaultPanel) return;
    var nearestAnchor = camera.findNearestAnchor(defaultPanel.position);
    var initialPanel = nearestAnchor && defaultPanel.index !== nearestAnchor.panel.index ? nearestAnchor.panel : defaultPanel;
    control.setActive(initialPanel, null, false);
    if (!nearestAnchor) {
      throw new FlickingError(MESSAGE.POSITION_NOT_REACHABLE(initialPanel.position), CODE.POSITION_NOT_REACHABLE);
    }
    var position = initialPanel.position;
    if (!camera.canReach(initialPanel)) {
      position = nearestAnchor.position;
    }
    camera.lookAt(position);
    control.updateInput();
    camera.updateOffset();
  };
  __proto._initialResize = function () {
    var viewport = this._viewport;
    var renderer = this._renderer;
    var camera = this._camera;
    var control = this._control;
    this.trigger(new ComponentEvent$1(flicking_esm_EVENTS.BEFORE_RESIZE, {
      width: 0,
      height: 0,
      element: viewport.element
    }));
    viewport.resize();
    renderer.updatePanelSize();
    camera.updateAlignPos();
    camera.updateRange();
    camera.updateAnchors();
    camera.updateOffset();
    control.updateInput();
    var newWidth = viewport.width;
    var newHeight = viewport.height;
    var sizeChanged = newWidth !== 0 || newHeight !== 0;
    this.trigger(new ComponentEvent$1(flicking_esm_EVENTS.AFTER_RESIZE, {
      width: viewport.width,
      height: viewport.height,
      prev: {
        width: 0,
        height: 0
      },
      sizeChanged: sizeChanged,
      element: viewport.element
    }));
  };
  /**
   * Version info string
   * @ko 버전정보 문자열
   * @type {string}
   * @readonly
   * @example
   * ```ts
   * Flicking.VERSION;  // ex) 4.0.0
   * ```
   */
  Flicking.VERSION = "4.10.8";
  return Flicking;
}(component_esm);

/**
 * Decorator that makes the method of flicking available in the framework.
 * @ko 프레임워크에서 플리킹의 메소드를 사용할 수 있게 하는 데코레이터.
 * @memberof eg.Flicking
 * @private
 * @example
 * ```js
 * import Flicking, { withFlickingMethods } from "@egjs/flicking";
 *
 * class Flicking extends React.Component<Partial<FlickingProps & FlickingOptions>> {
 *   &#64;withFlickingMethods
 *   private flicking: Flicking;
 * }
 * ```
 */
var withFlickingMethods = function (prototype, flickingName) {
  [component_esm.prototype, flicking_esm_Flicking.prototype].forEach(function (proto) {
    Object.getOwnPropertyNames(proto).filter(function (name) {
      return !prototype[name] && name.indexOf("_") !== 0 && name !== "constructor";
    }).forEach(function (name) {
      var descriptor = Object.getOwnPropertyDescriptor(proto, name);
      if (descriptor.value) {
        // Public Function
        Object.defineProperty(prototype, name, {
          value: function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return (_a = descriptor.value).call.apply(_a, flicking_esm_spread([this[flickingName]], args));
          }
        });
      } else {
        var getterDescriptor = {};
        if (descriptor.get) {
          getterDescriptor.get = function () {
            var _a;
            var flicking = this[flickingName];
            return flicking && ((_a = descriptor.get) === null || _a === void 0 ? void 0 : _a.call(flicking));
          };
        }
        if (descriptor.set) {
          getterDescriptor.set = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return (_a = descriptor.set) === null || _a === void 0 ? void 0 : _a.call.apply(_a, flicking_esm_spread([this[flickingName]], args));
          };
        }
        Object.defineProperty(prototype, name, getterDescriptor);
      }
    });
  });
};

var sync = (function (flicking, diffResult, rendered) {
  var renderer = flicking.renderer;
  var panels = renderer.panels;
  var prevList = flicking_esm_spread(diffResult.prevList);
  var added = [];
  var removed = [];
  if (diffResult.removed.length > 0) {
    var endIdx_1 = -1;
    var prevIdx_1 = -1;
    diffResult.removed.forEach(function (removedIdx) {
      if (endIdx_1 < 0) {
        endIdx_1 = removedIdx;
      }
      if (prevIdx_1 >= 0 && removedIdx !== prevIdx_1 - 1) {
        removed.push.apply(removed, flicking_esm_spread(batchRemove(renderer, prevIdx_1, endIdx_1 + 1)));
        endIdx_1 = removedIdx;
        prevIdx_1 = removedIdx;
      } else {
        prevIdx_1 = removedIdx;
      }
      prevList.splice(removedIdx, 1);
    });
    removed.push.apply(removed, flicking_esm_spread(batchRemove(renderer, prevIdx_1, endIdx_1 + 1)));
  }
  diffResult.ordered.forEach(function (_a) {
    var _b = flicking_esm_read(_a, 2),
      from = _b[0],
      to = _b[1];
    var prevPanel = panels.splice(from, 1)[0];
    panels.splice(to, 0, prevPanel);
  });
  if (diffResult.ordered.length > 0) {
    panels.forEach(function (panel, idx) {
      var indexDiff = idx - panel.index;
      if (indexDiff > 0) {
        panel.increaseIndex(indexDiff);
      } else {
        panel.decreaseIndex(-indexDiff);
      }
    });
    panels.sort(function (panel1, panel2) {
      return panel1.index - panel2.index;
    });
    panels.forEach(function (panel) {
      panel.updatePosition();
    });
  }
  if (diffResult.added.length > 0) {
    var startIdx_1 = -1;
    var prevIdx_2 = -1;
    var addedElements_1 = rendered.slice(prevList.length);
    diffResult.added.forEach(function (addedIdx, idx) {
      if (startIdx_1 < 0) {
        startIdx_1 = idx;
      }
      if (prevIdx_2 >= 0 && addedIdx !== prevIdx_2 + 1) {
        added.push.apply(added, flicking_esm_spread(batchInsert(renderer, diffResult, addedElements_1, startIdx_1, idx + 1)));
        startIdx_1 = -1;
        prevIdx_2 = -1;
      } else {
        prevIdx_2 = addedIdx;
      }
    });
    if (startIdx_1 >= 0) {
      added.push.apply(added, flicking_esm_spread(batchInsert(renderer, diffResult, addedElements_1, startIdx_1)));
    }
  }
  if (diffResult.added.length > 0 || diffResult.removed.length > 0) {
    renderer.updateAfterPanelChange(added, removed);
  }
});
var batchInsert = function (renderer, diffResult, addedElements, startIdx, endIdx) {
  return renderer.batchInsertDefer.apply(renderer, flicking_esm_spread(diffResult.added.slice(startIdx, endIdx).map(function (index, elIdx) {
    return {
      index: index,
      elements: [addedElements[elIdx]],
      hasDOMInElements: false
    };
  })));
};
var batchRemove = function (renderer, startIdx, endIdx) {
  var removed = renderer.panels.slice(startIdx, endIdx);
  return renderer.batchRemoveDefer({
    index: startIdx,
    deleteCount: removed.length,
    hasDOMInElements: false
  });
};

var getRenderingPanels = (function (flicking, diffResult) {
  var removedPanels = diffResult.removed.reduce(function (map, idx) {
    map[idx] = true;
    return map;
  }, {});
  var maintainedMap = diffResult.maintained.reduce(function (map, _a) {
    var _b = flicking_esm_read(_a, 2),
      prev = _b[0],
      current = _b[1];
    map[prev] = current;
    return map;
  }, {});
  return flicking_esm_spread(flicking.panels.filter(function (panel) {
    return !removedPanels[panel.index];
  })
  // Sort panels by position
  .sort(function (panel1, panel2) {
    return panel1.position + panel1.offset - (panel2.position + panel2.offset);
  }).map(function (panel) {
    return diffResult.list[maintainedMap[panel.index]];
  }), diffResult.added.map(function (idx) {
    return diffResult.list[idx];
  }));
});

var getDefaultCameraTransform = (function (align, horizontal, firstPanelSize) {
  if (align === void 0) {
    align = ALIGN.CENTER;
  }
  if (horizontal === void 0) {
    horizontal = true;
  }
  var cameraAlign = getCameraAlign(align);
  var panelAlign = getPanelAlign(align);
  if (panelAlign == null) return "";
  var camPosition = "calc(" + cameraAlign + " - (" + (firstPanelSize || "0px") + " * " + panelAlign.percentage + ") - " + panelAlign.absolute + "px)";
  return horizontal ? "translate(" + camPosition + ")" : "translate(0, " + camPosition + ")";
});
var getCameraAlign = function (align) {
  var alignVal = typeof align === "object" ? align.camera : align;
  return parseAlign(alignVal);
};
var getPanelAlign = function (align) {
  var alignVal = typeof align === "object" ? align.panel : align;
  return parseArithmeticExpression(parseAlign(alignVal));
};
var parseAlign = function (alignVal) {
  if (typeof alignVal === "number") {
    return alignVal + "px";
  }
  switch (alignVal) {
    case ALIGN.CENTER:
      return "50%";
    case ALIGN.NEXT:
      return "100%";
    case ALIGN.PREV:
      return "0%";
    default:
      return alignVal;
  }
};

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */


//# sourceMappingURL=flicking.esm.js.map

// CONCATENATED MODULE: ./node_modules/@egjs/flicking-plugins/dist/plugins.esm.js
/*
Copyright (c) 2019-present NAVER Corp.
name: @egjs/flicking-plugins
license: MIT
author: NAVER Corp.
repository: https://github.com/naver/egjs-flicking-plugins
version: 4.7.1
*/


/**
 * You can apply parallax effect while panel is moving.
 * @ko 패널들을 움직이면서 parallax 효과를 부여할 수 있습니다.
 * @memberof Flicking.Plugins
 */

var plugins_esm_Parallax =
/*#__PURE__*/
function () {
  /**
   * @param {string} selector Selector of the element to apply parallax effect<ko> Parallax 효과를 적용할 엘리먼트의 선택자 </ko>
   * @param {number} scale Effect amplication scale<ko>효과 증폭도</ko>
   * @example
   * ```ts
   * flicking.addPlugins(new Parallax("img", 1));
   * ```
   */
  function Parallax(selector, scale) {
    var _this = this;

    if (selector === void 0) {
      selector = "";
    }

    if (scale === void 0) {
      scale = 1;
    }

    this.update = function () {
      _this._onMove();
    };

    this._onMove = function () {
      var flicking = _this._flicking;
      if (!flicking) return;
      var panels = flicking.visiblePanels;
      panels.forEach(function (panel) {
        var progress = panel.outsetProgress;
        var el = panel.element;
        var target = _this._selector ? el.querySelector(_this._selector) : el;
        var parentTarget = target.parentNode;
        var rect = target.getBoundingClientRect();
        var parentRect = parentTarget.getBoundingClientRect();
        var position = (parentRect.width - rect.width) / 2 * progress * _this._scale;
        var transform = "translate(-50%) translate(" + position + "px)";
        var style = target.style;
        style.cssText += "transform: " + transform + ";-webkit-transform: " + transform + ";-ms-transform:" + transform;
      });
    };

    this._flicking = null;
    this._selector = selector;
    this._scale = scale;
  }

  var __proto = Parallax.prototype;
  Object.defineProperty(__proto, "selector", {
    get: function () {
      return this._selector;
    },
    set: function (val) {
      this._selector = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "scale", {
    get: function () {
      return this._scale;
    },
    set: function (val) {
      this._scale = val;
    },
    enumerable: false,
    configurable: true
  });

  __proto.init = function (flicking) {
    if (this._flicking) {
      this.destroy();
    }

    this._flicking = flicking;
    flicking.on(flicking_esm_EVENTS.MOVE, this._onMove);
    flicking.on(flicking_esm_EVENTS.AFTER_RESIZE, this.update);

    this._onMove();
  };

  __proto.destroy = function () {
    if (!this._flicking) return;

    this._flicking.off(flicking_esm_EVENTS.MOVE, this._onMove);

    this._flicking.off(flicking_esm_EVENTS.AFTER_RESIZE, this.update);

    this._flicking = null;
  };

  return Parallax;
}();

/**
 * You can apply fade in / out effect while panel is moving.
 * @ko 패널들을 움직이면서 fade in / out 효과를 부여할 수 있습니다.
 * @memberof Flicking.Plugins
 */

var plugins_esm_Fade =
/*#__PURE__*/
function () {
  /**
   * @param - The selector of the element to which the fade effect is to be applied. If the selector is blank, it applies to panel element. <ko>Fade 효과를 적용할 대상의 선택자. 선택자가 공백이면 패널 엘리먼트에 적용된다.</ko>
   * @param - Effect amplication scale<ko>효과 증폭도</ko>
   * @example
   * ```ts
   * flicking.addPlugins(new Fade("p", 1));
   * ```
   */
  function Fade(selector, scale) {
    var _this = this;

    if (selector === void 0) {
      selector = "";
    }

    if (scale === void 0) {
      scale = 1;
    }

    this.update = function () {
      _this._onMove();
    };

    this._onMove = function () {
      var flicking = _this._flicking;
      var selector = _this._selector;
      var scale = _this._scale;
      if (!flicking) return;
      var panels = flicking.visiblePanels;
      panels.forEach(function (panel) {
        var progress = panel.outsetProgress;
        var el = panel.element;
        var target = selector ? el.querySelector(selector) : el;

        if (target) {
          var opacity = Math.min(1, Math.max(0, 1 - Math.abs(progress * scale)));
          target.style.opacity = "" + opacity;
        }
      });
    };

    this._flicking = null;
    this._selector = selector;
    this._scale = scale;
  }

  var __proto = Fade.prototype;
  Object.defineProperty(__proto, "selector", {
    get: function () {
      return this._selector;
    },
    set: function (val) {
      this._selector = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "scale", {
    get: function () {
      return this._scale;
    },
    set: function (val) {
      this._scale = val;
    },
    enumerable: false,
    configurable: true
  });

  __proto.init = function (flicking) {
    if (this._flicking) {
      this.destroy();
    }

    this._flicking = flicking;
    flicking.on(flicking_esm_EVENTS.MOVE, this._onMove);
    flicking.on(flicking_esm_EVENTS.AFTER_RESIZE, this.update);

    this._onMove();
  };

  __proto.destroy = function () {
    if (!this._flicking) return;

    this._flicking.off(flicking_esm_EVENTS.MOVE, this._onMove);

    this._flicking.off(flicking_esm_EVENTS.AFTER_RESIZE, this.update);

    this._flicking = null;
  };

  return Fade;
}();

/**
 * Plugin that allow you to automatically move to the next/previous panel, on a specific time basis
 * @ko 일정 시간마다, 자동으로 다음/이전 패널로 넘어가도록 할 수 있는 플러그인
 * @memberof Flicking.Plugins
 */

var plugins_esm_AutoPlay =
/*#__PURE__*/
function () {
  /**
   * @param {AutoPlayOptions} options Options for the AutoPlay instance.<ko>AutoPlay 옵션</ko>
   * @param {number} options.duration Time to wait before moving on to the next panel.<ko>다음 패널로 움직이기까지 대기 시간</ko>
   * @param {number | undefined} options.animationDuration Duration of animation of moving to the next panel. If undefined, duration option of the Flicking instance is used instead.<ko>패널이 움직이는 애니메이션의 지속 시간, undefined라면 Flicking 인스턴스의 duration 값을 사용한다</ko>
   * @param {"PREV" | "NEXT"} options.direction The direction in which the panel moves.<ko>패널이 움직이는 방향</ko>
   * @param {boolean} options.stopOnHover Whether to stop when mouse hover upon the element.<ko>엘리먼트에 마우스를 올렸을 때 AutoPlay를 정지할지 여부</ko>
   * @param {number} options.delayAfterHover If stopOnHover is true, the amount of time to wait before moving on to the next panel when mouse leaves the element.<ko>stopOnHover를 사용한다면 마우스가 엘리먼트로부터 나간 뒤 다음 패널로 움직이기까지 대기 시간</ko>
   * @example
   * ```ts
   * flicking.addPlugins(new AutoPlay({ duration: 2000, direction: "NEXT" }));
   * ```
   */
  function AutoPlay(_a) {
    var _this = this;

    var _b = _a === void 0 ? {} : _a,
        _c = _b.duration,
        duration = _c === void 0 ? 2000 : _c,
        _d = _b.animationDuration,
        animationDuration = _d === void 0 ? undefined : _d,
        _e = _b.direction,
        direction = _e === void 0 ? DIRECTION.NEXT : _e,
        _f = _b.stopOnHover,
        stopOnHover = _f === void 0 ? false : _f,
        delayAfterHover = _b.delayAfterHover;
    /* Internal Values */


    this._flicking = null;
    this._timerId = 0;
    this._mouseEntered = false;
    this._playing = false;

    this.play = function () {
      _this._movePanel(_this._duration);
    };

    this.stop = function () {
      _this._playing = false;
      clearTimeout(_this._timerId);
    };

    this._onMouseEnter = function () {
      _this._mouseEntered = true;

      _this.stop();
    };

    this._onMouseLeave = function () {
      _this._mouseEntered = false;

      _this._movePanel(_this._delayAfterHover);
    };

    this._duration = duration;
    this._animationDuration = animationDuration;
    this._direction = direction;
    this._stopOnHover = stopOnHover;
    this._delayAfterHover = delayAfterHover !== null && delayAfterHover !== void 0 ? delayAfterHover : duration;
  }

  var __proto = AutoPlay.prototype;
  Object.defineProperty(__proto, "duration", {
    get: function () {
      return this._duration;
    },
    set: function (val) {
      this._duration = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "animationDuration", {
    get: function () {
      return this._animationDuration;
    },
    set: function (val) {
      this._animationDuration = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "direction", {
    get: function () {
      return this._direction;
    },
    set: function (val) {
      this._direction = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "stopOnHover", {
    get: function () {
      return this._stopOnHover;
    },
    set: function (val) {
      this._stopOnHover = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "delayAfterHover", {
    get: function () {
      return this._delayAfterHover;
    },
    set: function (val) {
      this._delayAfterHover = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "playing", {
    get: function () {
      return this._playing;
    },
    enumerable: false,
    configurable: true
  });

  __proto.init = function (flicking) {
    var _a;

    if (this._flicking) {
      this.destroy();
    }

    flicking.on((_a = {}, _a[flicking_esm_EVENTS.MOVE_START] = this.stop, _a[flicking_esm_EVENTS.HOLD_START] = this.stop, _a[flicking_esm_EVENTS.MOVE_END] = this.play, _a[flicking_esm_EVENTS.SELECT] = this.play, _a));
    this._flicking = flicking;

    if (this._stopOnHover) {
      var targetEl = this._flicking.element;
      targetEl.addEventListener("mouseenter", this._onMouseEnter, false);
      targetEl.addEventListener("mouseleave", this._onMouseLeave, false);
    }

    this.play();
  };

  __proto.destroy = function () {
    var flicking = this._flicking;
    this._mouseEntered = false;
    this.stop();

    if (!flicking) {
      return;
    }

    flicking.off(flicking_esm_EVENTS.MOVE_START, this.stop);
    flicking.off(flicking_esm_EVENTS.HOLD_START, this.stop);
    flicking.off(flicking_esm_EVENTS.MOVE_END, this.play);
    flicking.off(flicking_esm_EVENTS.SELECT, this.play);
    var targetEl = flicking.element;
    targetEl.removeEventListener("mouseenter", this._onMouseEnter, false);
    targetEl.removeEventListener("mouseleave", this._onMouseLeave, false);
    this._flicking = null;
  };

  __proto.update = function () {// DO-NOTHING
  };

  __proto._movePanel = function (duration) {
    var _this = this;

    var flicking = this._flicking;
    var direction = this._direction;

    if (!flicking) {
      return;
    }

    this.stop();

    if (this._mouseEntered || flicking.animating) {
      return;
    }

    this._playing = true;
    this._timerId = window.setTimeout(function () {
      var _a, _b;

      var animationDuration = _this._animationDuration || flicking.duration;
      var moveType = flicking.moveType; // for freeScroll

      if (moveType === MOVE_TYPE.FREE_SCROLL || (moveType === null || moveType === void 0 ? void 0 : moveType[0]) === MOVE_TYPE.FREE_SCROLL) {
        var range = flicking.camera.range;
        var cameraPosition = flicking.camera.position;
        var currentPanel = flicking.currentPanel;
        var prevPanel = currentPanel.prev();
        var nextPanel = currentPanel.next();
        var currentPosition = currentPanel.position;
        var nextPosition = (_a = nextPanel === null || nextPanel === void 0 ? void 0 : nextPanel.position) !== null && _a !== void 0 ? _a : range.max;
        var prevPosition = (_b = prevPanel === null || prevPanel === void 0 ? void 0 : prevPanel.position) !== null && _b !== void 0 ? _b : range.min; // circular: prev (last) > cur (0) => prev(-1) < cur(0)

        if (prevPosition > currentPosition) {
          prevPosition = range.min - (range.max - prevPosition);
        } // current (last) > next (0)


        if (nextPosition < currentPosition) {
          nextPosition += range.max;
        }

        if (direction === DIRECTION.NEXT) {
          // prev - cur - camera - next
          var size = nextPosition - currentPosition;
          var restSize = nextPosition - cameraPosition;

          if (cameraPosition < currentPosition) {
            // prev - camera - cur - next
            restSize = nextPosition - cameraPosition;
          }

          animationDuration *= restSize / size;
        } else {
          // prev - caemra - cur - next
          var size = currentPosition - prevPosition;
          var restSize = cameraPosition - prevPosition;

          if (cameraPosition > currentPosition) {
            // prev - cur - camera - next
            restSize = cameraPosition - prevPosition;
          }

          animationDuration *= restSize / size;
        }
      }

      if (direction === DIRECTION.NEXT) {
        flicking.next(animationDuration).catch(function () {
          return void 0;
        });
      } else {
        flicking.prev(animationDuration).catch(function () {
          return void 0;
        });
      }

      _this.play();
    }, duration);
  };

  return AutoPlay;
}();

var BROWSER = {
  CLICK: "click",
  MOUSE_DOWN: "mousedown",
  TOUCH_START: "touchstart"
};

var ARROW = {
  PREV_SELECTOR: ".flicking-arrow-prev",
  NEXT_SELECTOR: ".flicking-arrow-next",
  DISABLED_CLASS: "flicking-arrow-disabled"
};
var PAGINATION = {
  SELECTOR: ".flicking-pagination",
  PREFIX: "flicking-pagination",
  BULLET_WRAPPER_SUFFIX: "bullets",
  BULLET_SUFFIX: "bullet",
  BULLET_ACTIVE_SUFFIX: "bullet-active",
  FRACTION_WRAPPER_SUFFIX: "fraction",
  FRACTION_CURRENT_SUFFIX: "fraction-current",
  FRACTION_TOTAL_SUFFIX: "fraction-total",
  SCROLL_UNINIT_SUFFIX: "uninitialized",
  SCROLL_WRAPPER_SUFFIX: "scroll",
  SCROLL_SLIDER_SUFFIX: "slider",
  SCROLL_PREV_SUFFIX: "bullet-prev",
  SCROLL_NEXT_SUFFIX: "bullet-next",
  TYPE: {
    BULLET: "bullet",
    FRACTION: "fraction",
    SCROLL: "scroll"
  }
};
var SYNC = {
  TYPE: {
    CAMERA: "camera",
    INDEX: "index"
  }
};

var addClass = function (el, className) {
  if (!el) return;

  if (el.classList) {
    el.classList.add(className);
  } else {
    var classes = el.className.split(" ");

    if (classes.indexOf(className) < 0) {
      el.className = el.className + " " + className;
    }
  }
};
var removeClass = function (el, className) {
  if (!el) return;

  if (el.classList) {
    el.classList.remove(className);
  } else {
    var classRegex = new RegExp("( |^)" + className + "( |$)", "g");
    el.className.replace(classRegex, " ");
  }
};
var plugins_esm_getElement = function (selector, parent, pluginName) {
  var el = parent.querySelector(selector);

  if (!el) {
    throw new Error("[Flicking-" + pluginName + "] Couldn't find element with the given selector: " + selector);
  }

  return el;
};

/**
 * A plugin to easily create prev/right arrow button of Flicking
 * @ko 이전/다음 버튼을 쉽게 만들 수 있는 플러그인
 * @memberof Flicking.Plugins
 */

var plugins_esm_Arrow =
/*#__PURE__*/
function () {
  function Arrow(_a) {
    var _this = this;

    var _b = _a === void 0 ? {} : _a,
        _c = _b.parentEl,
        parentEl = _c === void 0 ? null : _c,
        _d = _b.prevElSelector,
        prevElSelector = _d === void 0 ? ARROW.PREV_SELECTOR : _d,
        _e = _b.nextElSelector,
        nextElSelector = _e === void 0 ? ARROW.NEXT_SELECTOR : _e,
        _f = _b.disabledClass,
        disabledClass = _f === void 0 ? ARROW.DISABLED_CLASS : _f,
        _g = _b.moveCount,
        moveCount = _g === void 0 ? 1 : _g,
        _h = _b.moveByViewportSize,
        moveByViewportSize = _h === void 0 ? false : _h;
    /* Internal Values */


    this._flicking = null;

    this._preventInputPropagation = function (e) {
      e.stopPropagation();
    };

    this._onPrevClick = function () {
      var flicking = _this._flicking;
      var camera = flicking.camera;
      var anchorPoints = camera.anchorPoints;
      if (flicking.animating || anchorPoints.length <= 0) return;
      var firstAnchor = anchorPoints[0];
      var moveCount = _this._moveCount;

      if (_this._moveByViewportSize) {
        flicking.control.moveToPosition(camera.position - camera.size, flicking.duration).catch(_this._onCatch);
      } else {
        if (flicking.circularEnabled) {
          var targetPanel = flicking.currentPanel;

          for (var i = 0; i < moveCount; i++) {
            targetPanel = targetPanel.prev();
          }

          targetPanel.focus().catch(_this._onCatch);
        } else if (flicking.index > firstAnchor.panel.index) {
          flicking.moveTo(Math.max(flicking.index - moveCount, firstAnchor.panel.index)).catch(_this._onCatch);
        } else if (camera.position > camera.range.min) {
          flicking.moveTo(flicking.index).catch(_this._onCatch);
        }
      }
    };

    this._onNextClick = function () {
      var flicking = _this._flicking;
      var camera = flicking.camera;
      var anchorPoints = camera.anchorPoints;
      if (flicking.animating || anchorPoints.length <= 0) return;
      var lastAnchor = anchorPoints[anchorPoints.length - 1];
      var moveCount = _this._moveCount;

      if (_this._moveByViewportSize) {
        flicking.control.moveToPosition(camera.position + camera.size, flicking.duration).catch(_this._onCatch);
      } else {
        if (flicking.circularEnabled) {
          var targetPanel = flicking.currentPanel;

          for (var i = 0; i < moveCount; i++) {
            targetPanel = targetPanel.next();
          }

          targetPanel.focus().catch(_this._onCatch);
        } else if (flicking.index < lastAnchor.panel.index) {
          flicking.moveTo(Math.min(flicking.index + moveCount, lastAnchor.panel.index)).catch(_this._onCatch);
        } else if (camera.position > camera.range.min) {
          flicking.moveTo(flicking.index).catch(_this._onCatch);
        }
      }
    };

    this._onAnimation = function () {
      var flicking = _this._flicking;
      var camera = flicking.camera;
      var controller = flicking.control.controller;

      if (flicking.holding) {
        _this._updateClass(camera.position);
      } else {
        _this._updateClass(controller.animatingContext.end);
      }
    };

    this._onCatch = function (err) {
      if (err instanceof FlickingError) return;
      throw err;
    };

    this._parentEl = parentEl;
    this._prevElSelector = prevElSelector;
    this._nextElSelector = nextElSelector;
    this._disabledClass = disabledClass;
    this._moveCount = moveCount;
    this._moveByViewportSize = moveByViewportSize;
  }

  var __proto = Arrow.prototype;
  Object.defineProperty(__proto, "prevEl", {
    get: function () {
      return this._prevEl;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "nextEl", {
    get: function () {
      return this._nextEl;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "parentEl", {
    get: function () {
      return this._parentEl;
    },
    set: function (val) {
      this._parentEl = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "prevElSelector", {
    get: function () {
      return this._prevElSelector;
    },
    set: function (val) {
      this._prevElSelector = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "nextElSelector", {
    get: function () {
      return this._nextElSelector;
    },
    set: function (val) {
      this._nextElSelector = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "disabledClass", {
    get: function () {
      return this._disabledClass;
    },
    set: function (val) {
      this._disabledClass = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "moveCount", {
    get: function () {
      return this._moveCount;
    },
    set: function (val) {
      this._moveCount = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "moveByViewportSize", {
    get: function () {
      return this._moveByViewportSize;
    },
    set: function (val) {
      this._moveByViewportSize = val;
    },
    enumerable: false,
    configurable: true
  });

  __proto.init = function (flicking) {
    var _this = this;

    if (this._flicking) {
      this.destroy();
    }

    this._flicking = flicking;
    flicking.on(flicking_esm_EVENTS.MOVE, this._onAnimation);
    var parentEl = this._parentEl ? this._parentEl : flicking.element;
    var prevEl = plugins_esm_getElement(this._prevElSelector, parentEl, "Arrow");
    var nextEl = plugins_esm_getElement(this._nextElSelector, parentEl, "Arrow");
    [BROWSER.MOUSE_DOWN, BROWSER.TOUCH_START].forEach(function (evt) {
      prevEl.addEventListener(evt, _this._preventInputPropagation, {
        passive: true
      });
      nextEl.addEventListener(evt, _this._preventInputPropagation, {
        passive: true
      });
    });
    prevEl.addEventListener(BROWSER.CLICK, this._onPrevClick);
    nextEl.addEventListener(BROWSER.CLICK, this._onNextClick);
    this._prevEl = prevEl;
    this._nextEl = nextEl;
    this.update();
  };

  __proto.destroy = function () {
    var _this = this;

    var flicking = this._flicking;

    if (!flicking) {
      return;
    }

    flicking.off(flicking_esm_EVENTS.MOVE, this._onAnimation);
    var prevEl = this._prevEl;
    var nextEl = this._nextEl;
    [BROWSER.MOUSE_DOWN, BROWSER.TOUCH_START].forEach(function (evt) {
      prevEl.removeEventListener(evt, _this._preventInputPropagation);
      nextEl.removeEventListener(evt, _this._preventInputPropagation);
    });
    prevEl.removeEventListener(BROWSER.CLICK, this._onPrevClick);
    nextEl.removeEventListener(BROWSER.CLICK, this._onNextClick);
    this._flicking = null;
  };

  __proto.update = function () {
    this._updateClass(this._flicking.camera.position);
  };

  __proto._updateClass = function (pos) {
    var flicking = this._flicking;
    var disabledClass = this._disabledClass;
    var prevEl = this._prevEl;
    var nextEl = this._nextEl;
    var cameraRange = flicking.camera.range;
    var stopAtPrevEdge = flicking.circularEnabled ? false : pos <= cameraRange.min;
    var stopAtNextEdge = flicking.circularEnabled ? false : pos >= cameraRange.max;

    if (stopAtPrevEdge) {
      addClass(prevEl, disabledClass);
    } else {
      removeClass(prevEl, disabledClass);
    }

    if (stopAtNextEdge) {
      addClass(nextEl, disabledClass);
    } else {
      removeClass(nextEl, disabledClass);
    }
  };

  return Arrow;
}();

/**
 * Plugin for synchronizing multiple flickings
 * @ko 다양한 형태로 Flicking들이 같이 움직이게 할 수 있습니다.
 * @memberof Flicking.Plugins
 */

var plugins_esm_Sync =
/*#__PURE__*/
function () {
  /** */
  function Sync(_a) {
    var _this = this;

    var _b = _a === void 0 ? {} : _a,
        _c = _b.type,
        type = _c === void 0 ? SYNC.TYPE.CAMERA : _c,
        _d = _b.synchronizedFlickingOptions,
        synchronizedFlickingOptions = _d === void 0 ? [] : _d;
    /* Internal Values */


    this._flicking = null;

    this._addEvents = function () {
      var type = _this._type;
      var synced = _this._synchronizedFlickingOptions;
      synced.forEach(function (_a) {
        var flicking = _a.flicking,
            isSlidable = _a.isSlidable,
            isClickable = _a.isClickable;

        if (type === SYNC.TYPE.CAMERA) {
          flicking.on(flicking_esm_EVENTS.MOVE, _this._onMove);
          flicking.on(flicking_esm_EVENTS.MOVE_START, _this._onMoveStart);
          flicking.on(flicking_esm_EVENTS.MOVE_END, _this._onMoveEnd);
        }

        if (type === SYNC.TYPE.INDEX && isSlidable) {
          flicking.on(flicking_esm_EVENTS.WILL_CHANGE, _this._onIndexChange);
          flicking.on(flicking_esm_EVENTS.WILL_RESTORE, _this._onIndexChange);
        }

        if (isClickable) {
          flicking.on(flicking_esm_EVENTS.SELECT, _this._onSelect);
        }
      });
    };

    this._removeEvents = function () {
      var type = _this._type;
      var synced = _this._synchronizedFlickingOptions;
      synced.forEach(function (_a) {
        var flicking = _a.flicking,
            isSlidable = _a.isSlidable,
            isClickable = _a.isClickable;

        if (type === SYNC.TYPE.CAMERA) {
          flicking.off(flicking_esm_EVENTS.MOVE, _this._onMove);
          flicking.off(flicking_esm_EVENTS.MOVE_START, _this._onMoveStart);
          flicking.off(flicking_esm_EVENTS.MOVE_END, _this._onMoveEnd);
        }

        if (type === SYNC.TYPE.INDEX && isSlidable) {
          flicking.off(flicking_esm_EVENTS.WILL_CHANGE, _this._onIndexChange);
          flicking.off(flicking_esm_EVENTS.WILL_RESTORE, _this._onIndexChange);
        }

        if (isClickable) {
          flicking.off(flicking_esm_EVENTS.SELECT, _this._onSelect);
        }
      });
    };

    this._onIndexChange = function (e) {
      var flicking = e.currentTarget;

      if (!flicking.initialized) {
        return;
      }

      _this._synchronizeByIndex(flicking, e.index);
    };

    this._onMove = function (e) {
      var camera = e.currentTarget.camera;
      var progress = (camera.position - camera.range.min) / camera.rangeDiff;

      _this._synchronizedFlickingOptions.forEach(function (_a) {
        var flicking = _a.flicking;
        if (flicking === e.currentTarget) return;
        var targetPosition = 0;

        if (camera.position < camera.range.min) {
          targetPosition = camera.position;
        } else if (camera.position > camera.range.max) {
          targetPosition = flicking.camera.range.max + camera.position - camera.range.max;
        } else {
          targetPosition = flicking.camera.range.min + flicking.camera.rangeDiff * progress;
        }

        void flicking.camera.lookAt(targetPosition);
      });
    };

    this._onMoveStart = function (e) {
      _this._synchronizedFlickingOptions.forEach(function (_a) {
        var flicking = _a.flicking;

        if (flicking !== e.currentTarget) {
          flicking.disableInput();
        }
      });
    };

    this._onMoveEnd = function (e) {
      _this._synchronizedFlickingOptions.forEach(function (_a) {
        var flicking = _a.flicking;

        if (flicking !== e.currentTarget) {
          flicking.enableInput();
          flicking.control.updateInput();
        }
      });
    };

    this._onSelect = function (e) {
      void e.currentTarget.moveTo(e.index).catch(function () {
        return void 0;
      });

      _this._synchronizeByIndex(e.currentTarget, e.index);
    };

    this._synchronizeByIndex = function (activeFlicking, index) {
      var synchronizedFlickingOptions = _this._synchronizedFlickingOptions;

      _this._preventEvent(function () {
        synchronizedFlickingOptions.forEach(function (options) {
          // Active class should be applied same to the Flicking which triggered event
          _this._updateClass(options, index);

          var flicking = options.flicking;
          if (flicking === activeFlicking) return;
          var targetIndex = flicking_esm_clamp(index, 0, flicking.panels.length);

          if (flicking.animating) {
            // Reserve moveTo once previous animation is finished
            flicking.once(flicking_esm_EVENTS.MOVE_END, function () {
              void flicking.moveTo(targetIndex).catch(function () {
                return void 0;
              });
            });
          } else {
            void flicking.moveTo(targetIndex);
          }
        });
      });
    };

    this._updateClass = function (_a, index) {
      var flicking = _a.flicking,
          activeClass = _a.activeClass;
      if (!activeClass) return;
      flicking.panels.forEach(function (panel) {
        if (panel.index === index) {
          addClass(panel.element, activeClass);
        } else {
          removeClass(panel.element, activeClass);
        }
      });
    };

    this._type = type;
    this._synchronizedFlickingOptions = synchronizedFlickingOptions;
  }

  var __proto = Sync.prototype;
  Object.defineProperty(__proto, "type", {
    get: function () {
      return this._type;
    },
    set: function (val) {
      this._type = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "synchronizedFlickingOptions", {
    get: function () {
      return this._synchronizedFlickingOptions;
    },
    set: function (val) {
      this._synchronizedFlickingOptions = val;
    },
    enumerable: false,
    configurable: true
  });

  __proto.init = function (flicking) {
    var _this = this;

    var synced = this._synchronizedFlickingOptions;

    if (this._flicking) {
      this.destroy();
    }

    this._flicking = flicking;

    this._addEvents();

    synced.forEach(function (options) {
      var syncedFlicking = options.flicking;

      _this._updateClass(options, syncedFlicking.defaultIndex);
    });
  };

  __proto.destroy = function () {
    var flicking = this._flicking;

    if (!flicking) {
      return;
    }

    this._removeEvents();

    this._flicking = null;
  };

  __proto.update = function () {
    var _this = this;

    this._synchronizedFlickingOptions.forEach(function (options) {
      _this._updateClass(options, options.flicking.index);
    });
  };

  __proto._preventEvent = function (fn) {
    this._removeEvents();

    fn();

    this._addEvents();
  };

  return Sync;
}();

/* eslint-disable no-underscore-dangle */
/**
 * You can apply perspective effect while panel is moving.
 * @ko 패널들을 움직이면서 입체감을 부여할 수 있습니다.
 * @memberof Flicking.Plugins
 */

var plugins_esm_Perspective =
/*#__PURE__*/
function () {
  /**
   * @param - The selector of the element to which the perspective effect is to be applied. If the selector is blank, it applies to panel element. <ko>입체 효과를 적용할 대상의 선택자. 선택자가 공백이면 패널 엘리먼트에 적용된다.</ko>
   * @param - Effect amplication scale.<ko>효과 증폭도</ko>
   * @param - Effect amplication rotate.<ko>회전 증폭도</ko>
   * @param - The value of perspective CSS property. <ko>css perspective 속성 값</ko>
   * @example
   * ```ts
   * flicking.addPlugins(new Perspective({ selector: "p", scale: 1, rotate: 1, perspective = 1000 }));
   * ```
   */
  function Perspective(_a) {
    var _this = this;

    var _b = _a === void 0 ? {} : _a,
        _c = _b.selector,
        selector = _c === void 0 ? "" : _c,
        _d = _b.scale,
        scale = _d === void 0 ? 1 : _d,
        _e = _b.rotate,
        rotate = _e === void 0 ? 1 : _e,
        _f = _b.perspective,
        perspective = _f === void 0 ? 1000 : _f;

    this.update = function () {
      _this._onMove();
    };

    this._onMove = function () {
      var flicking = _this._flicking;
      var selector = _this._selector;
      var scale = _this._scale;
      var rotate = _this._rotate;
      var perspective = _this._perspective;
      if (!flicking) return;
      var horizontal = flicking.horizontal;
      var panels = flicking.visiblePanels;
      panels.forEach(function (panel) {
        var progress = panel.outsetProgress;
        var el = panel.element;
        var target = selector ? el.querySelector(selector) : el;
        var panelScale = 1 / (Math.abs(progress * scale) + 1);
        var rotateDegree = progress > 0 ? Math.min(90, progress * 100 * rotate) : Math.max(-90, progress * 100 * rotate);

        var _a = horizontal ? [0, rotateDegree] : [rotateDegree, 0],
            rotateX = _a[0],
            rotateY = _a[1];

        target.style.transform = "perspective(" + perspective + "px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg) scale(" + panelScale + ")";
      });
    };

    this._flicking = null;
    this._selector = selector;
    this._scale = scale;
    this._rotate = rotate;
    this._perspective = perspective;
  }

  var __proto = Perspective.prototype;
  Object.defineProperty(__proto, "selector", {
    get: function () {
      return this._selector;
    },
    set: function (val) {
      this._selector = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "scale", {
    get: function () {
      return this._scale;
    },
    set: function (val) {
      this._scale = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "rotate", {
    get: function () {
      return this._rotate;
    },
    set: function (val) {
      this._rotate = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "perspective", {
    get: function () {
      return this._perspective;
    },
    set: function (val) {
      this._perspective = val;
    },
    enumerable: false,
    configurable: true
  });

  __proto.init = function (flicking) {
    if (this._flicking) {
      this.destroy();
    }

    this._flicking = flicking;
    flicking.on(flicking_esm_EVENTS.MOVE, this._onMove);
    flicking.on(flicking_esm_EVENTS.AFTER_RESIZE, this.update);

    this._onMove();
  };

  __proto.destroy = function () {
    if (!this._flicking) return;

    this._flicking.off(flicking_esm_EVENTS.MOVE, this._onMove);

    this._flicking.off(flicking_esm_EVENTS.AFTER_RESIZE, this.update);

    this._flicking = null;
  };

  return Perspective;
}();

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var plugins_esm_extendStatics = function (d, b) {
  plugins_esm_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };

  return plugins_esm_extendStatics(d, b);
};

function plugins_esm_extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  plugins_esm_extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function plugins_esm_spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || from);
}

var plugins_esm_Renderer =
/*#__PURE__*/
function () {
  function Renderer(_a) {
    var flicking = _a.flicking,
        pagination = _a.pagination,
        wrapper = _a.wrapper;
    this._flicking = flicking;
    this._pagination = pagination;
    this._wrapper = wrapper;
  }

  var __proto = Renderer.prototype;

  __proto._createBulletFromString = function (html, index) {
    var range = document.createRange();
    var frag = range.createContextualFragment(html);
    var bullet = frag.firstChild;

    this._addBulletEvents(bullet, index);

    return bullet;
  };

  __proto._addBulletEvents = function (bullet, index) {
    var _this = this;

    var anchorPoints = this._flicking.camera.anchorPoints;
    var panelIndex = anchorPoints[index].panel.index;
    bullet.addEventListener(BROWSER.MOUSE_DOWN, function (e) {
      e.stopPropagation();
    });
    bullet.addEventListener(BROWSER.TOUCH_START, function (e) {
      e.stopPropagation();
    }, {
      passive: true
    });
    bullet.addEventListener(BROWSER.CLICK, function () {
      _this._flicking.moveTo(panelIndex).catch(function (err) {
        if (err instanceof FlickingError) return;
        throw err;
      });
    });
  };

  return Renderer;
}();

var BulletRenderer =
/*#__PURE__*/
function (_super) {
  plugins_esm_extends(BulletRenderer, _super);

  function BulletRenderer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._bullets = [];
    _this._prevIndex = -1;
    return _this;
  }

  var __proto = BulletRenderer.prototype;
  Object.defineProperty(__proto, "_bulletClass", {
    get: function () {
      var pagination = this._pagination;
      return pagination.classPrefix + "-" + PAGINATION.BULLET_SUFFIX;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "_activeClass", {
    get: function () {
      var pagination = this._pagination;
      return pagination.classPrefix + "-" + PAGINATION.BULLET_ACTIVE_SUFFIX;
    },
    enumerable: false,
    configurable: true
  });

  __proto.destroy = function () {
    this._bullets = [];
    this._prevIndex = -1;
  };

  __proto.render = function () {
    var _this = this;

    var flicking = this._flicking;
    var pagination = this._pagination;
    var wrapper = this._wrapper;
    var bulletClass = this._bulletClass;
    var activeClass = this._activeClass;
    var renderBullet = pagination.renderBullet;
    var renderActiveBullet = pagination.renderActiveBullet;
    var bulletWrapperClass = pagination.classPrefix + "-" + PAGINATION.BULLET_WRAPPER_SUFFIX;
    var anchorPoints = flicking.camera.anchorPoints;
    addClass(wrapper, bulletWrapperClass);
    wrapper.innerHTML = anchorPoints.map(function (anchorPoint, index) {
      if (renderActiveBullet && anchorPoint.panel.index === flicking.index) {
        return renderActiveBullet(bulletClass, index);
      } else {
        return renderBullet(bulletClass, index);
      }
    }).join("\n");
    var bullets = [].slice.call(wrapper.children);
    bullets.forEach(function (bullet, index) {
      var anchorPoint = anchorPoints[index];

      if (anchorPoint.panel.index === flicking.index) {
        addClass(bullet, activeClass);
        _this._prevIndex = index;
      }

      _this._addBulletEvents(bullet, index);
    });
    this._bullets = bullets;
  };

  __proto.update = function (index) {
    var flicking = this._flicking;
    var pagination = this._pagination;
    var wrapper = this._wrapper;
    var bullets = this._bullets;
    var bulletClass = this._bulletClass;
    var activeClass = this._activeClass;
    var prevIndex = this._prevIndex;
    var anchorPoints = flicking.camera.anchorPoints;
    var renderBullet = pagination.renderBullet;
    var renderActiveBullet = pagination.renderActiveBullet;
    if (anchorPoints.length <= 0) return;
    var anchorOffset = anchorPoints[0].panel.index;
    var activeBulletIndex = index - anchorOffset;
    if (prevIndex === activeBulletIndex) return;

    if (renderActiveBullet) {
      var prevBullet = bullets[prevIndex];

      if (prevBullet) {
        var newBullet = this._createBulletFromString(renderBullet(bulletClass, prevIndex), prevIndex);

        prevBullet.parentElement.replaceChild(newBullet, prevBullet);
        bullets[prevIndex] = newBullet;
      }

      var activeBullet = bullets[activeBulletIndex];

      var newActiveBullet = this._createBulletFromString(renderActiveBullet(bulletClass + " " + activeClass, activeBulletIndex), activeBulletIndex);

      wrapper.replaceChild(newActiveBullet, activeBullet);
      bullets[activeBulletIndex] = newActiveBullet;
    } else {
      var activeBullet = bullets[activeBulletIndex];
      var prevBullet = bullets[prevIndex];

      if (prevBullet) {
        removeClass(prevBullet, activeClass);
      }

      addClass(activeBullet, activeClass);
    }

    this._prevIndex = activeBulletIndex;
  };

  return BulletRenderer;
}(plugins_esm_Renderer);

var FractionRenderer =
/*#__PURE__*/
function (_super) {
  plugins_esm_extends(FractionRenderer, _super);

  function FractionRenderer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._prevIndex = -1;
    _this._prevTotal = -1;
    return _this;
  }

  var __proto = FractionRenderer.prototype;

  __proto.destroy = function () {
    this._prevIndex = -1;
    this._prevTotal = -1;
  };

  __proto.render = function () {
    var flicking = this._flicking;
    var wrapper = this._wrapper;
    var pagination = this._pagination;
    var fractionWrapperClass = pagination.classPrefix + "-" + PAGINATION.FRACTION_WRAPPER_SUFFIX;
    var fractionCurrentClass = pagination.classPrefix + "-" + PAGINATION.FRACTION_CURRENT_SUFFIX;
    var fractionTotalClass = pagination.classPrefix + "-" + PAGINATION.FRACTION_TOTAL_SUFFIX;
    addClass(wrapper, fractionWrapperClass);
    wrapper.innerHTML = pagination.renderFraction(fractionCurrentClass, fractionTotalClass);
    this.update(flicking.index);
  };

  __proto.update = function (index) {
    var flicking = this._flicking;
    var wrapper = this._wrapper;
    var pagination = this._pagination;
    var anchorPoints = flicking.camera.anchorPoints;
    var currentIndex = anchorPoints.length > 0 ? index - anchorPoints[0].panel.index + 1 : 0;
    var anchorCount = anchorPoints.length;
    if (currentIndex === this._prevIndex && anchorCount === this._prevTotal) return;
    var fractionCurrentSelector = "." + pagination.classPrefix + "-" + PAGINATION.FRACTION_CURRENT_SUFFIX;
    var fractionTotalSelector = "." + pagination.classPrefix + "-" + PAGINATION.FRACTION_TOTAL_SUFFIX;
    var currentWrapper = wrapper.querySelector(fractionCurrentSelector);
    var totalWrapper = wrapper.querySelector(fractionTotalSelector);
    currentWrapper.innerHTML = pagination.fractionCurrentFormat(currentIndex);
    totalWrapper.innerHTML = pagination.fractionTotalFormat(anchorCount);
    this._prevIndex = currentIndex;
    this._prevTotal = anchorCount;
  };

  return FractionRenderer;
}(plugins_esm_Renderer);

var plugins_esm_ScrollBulletRenderer =
/*#__PURE__*/
function (_super) {
  plugins_esm_extends(ScrollBulletRenderer, _super);

  function ScrollBulletRenderer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._bullets = [];
    _this._bulletSize = 0;
    _this._previousIndex = -1;
    _this._sliderIndex = -1;

    _this.moveTo = function (index) {
      var pagination = _this._pagination;
      var sliderEl = _this._wrapper.firstElementChild;
      var bulletSize = _this._bulletSize;
      var wrapperSize = bulletSize * pagination.bulletCount;
      sliderEl.style.transform = "translate(" + (wrapperSize / 2 - (index + 0.5) * bulletSize) + "px)";
      _this._sliderIndex = index;
    };

    return _this;
  }

  var __proto = ScrollBulletRenderer.prototype;

  __proto.destroy = function () {
    this._bullets = [];
    this._bulletSize = 0;
    this._previousIndex = -1;
    this._sliderIndex = -1;
  };

  __proto.render = function () {
    var _this = this;

    var wrapper = this._wrapper;
    var flicking = this._flicking;
    var pagination = this._pagination;
    var renderBullet = pagination.renderBullet;
    var anchorPoints = flicking.camera.anchorPoints;
    var dynamicWrapperClass = pagination.classPrefix + "-" + PAGINATION.SCROLL_WRAPPER_SUFFIX;
    var bulletClass = pagination.classPrefix + "-" + PAGINATION.BULLET_SUFFIX;
    var sliderClass = pagination.classPrefix + "-" + PAGINATION.SCROLL_SLIDER_SUFFIX;
    var uninitClass = pagination.classPrefix + "-" + PAGINATION.SCROLL_UNINIT_SUFFIX;
    var sliderEl = document.createElement("div");
    addClass(sliderEl, sliderClass);
    addClass(wrapper, uninitClass);
    addClass(wrapper, dynamicWrapperClass);
    wrapper.appendChild(sliderEl);
    sliderEl.innerHTML = anchorPoints.map(function (_, index) {
      return renderBullet(bulletClass, index);
    }).join("\n");
    var bullets = [].slice.call(sliderEl.children);
    bullets.forEach(function (bullet, index) {
      _this._addBulletEvents(bullet, index);
    });
    if (bullets.length <= 0) return;
    var bulletStyle = getComputedStyle(bullets[0]);
    var bulletSize = bullets[0].clientWidth + parseFloat(bulletStyle.marginLeft) + parseFloat(bulletStyle.marginRight);
    wrapper.style.width = bulletSize * pagination.bulletCount + "px";
    this._bullets = bullets;
    this._bulletSize = bulletSize;
    this._previousIndex = -1;
    this.update(this._flicking.index);
    window.requestAnimationFrame(function () {
      removeClass(wrapper, uninitClass);
    });
  };

  __proto.update = function (index) {
    var pagination = this._pagination;
    var flicking = this._flicking;
    var bullets = this._bullets;
    var prevIndex = this._previousIndex;
    var renderBullet = pagination.renderBullet;
    var renderActiveBullet = pagination.renderActiveBullet;
    var anchorPoints = flicking.camera.anchorPoints;
    var anchorOffset = anchorPoints[0].panel.index;
    var activeIndex = index - anchorOffset;
    if (anchorPoints.length <= 0) return;
    var bulletClass = pagination.classPrefix + "-" + PAGINATION.BULLET_SUFFIX;
    var bulletActiveClass = pagination.classPrefix + "-" + PAGINATION.BULLET_ACTIVE_SUFFIX;
    var prevClassPrefix = pagination.classPrefix + "-" + PAGINATION.SCROLL_PREV_SUFFIX;
    var nextClassPrefix = pagination.classPrefix + "-" + PAGINATION.SCROLL_NEXT_SUFFIX;

    var bulletPrevClass = function (offset) {
      return "" + prevClassPrefix + (offset > 1 ? offset : "");
    };

    var bulletNextClass = function (offset) {
      return "" + nextClassPrefix + (offset > 1 ? offset : "");
    };

    var prevClassRegex = new RegExp("^" + prevClassPrefix);
    var nextClassRegex = new RegExp("^" + nextClassPrefix);

    if (renderActiveBullet) {
      var prevBullet = bullets[prevIndex];

      if (prevBullet) {
        var newBullet = this._createBulletFromString(renderBullet(bulletClass, prevIndex), prevIndex);

        prevBullet.parentElement.replaceChild(newBullet, prevBullet);
        bullets[prevIndex] = newBullet;
      }

      var activeBullet = bullets[activeIndex];

      if (activeBullet) {
        var newActiveBullet = this._createBulletFromString(renderActiveBullet(bulletClass, activeIndex), activeIndex);

        activeBullet.parentElement.replaceChild(newActiveBullet, activeBullet);
        bullets[activeIndex] = newActiveBullet;
      }
    }

    bullets.forEach(function (bullet, idx) {
      var indexOffset = idx - activeIndex;
      var classList = bullet.className.split(" ");

      for (var _i = 0, classList_1 = classList; _i < classList_1.length; _i++) {
        var className = classList_1[_i];

        if (className === bulletActiveClass || prevClassRegex.test(className) || nextClassRegex.test(className)) {
          removeClass(bullet, className);
        }
      }

      if (indexOffset === 0) {
        addClass(bullet, bulletActiveClass);
      } else if (indexOffset > 0) {
        addClass(bullet, bulletNextClass(Math.abs(indexOffset)));
      } else {
        addClass(bullet, bulletPrevClass(Math.abs(indexOffset)));
      }
    });
    pagination.scrollOnChange(activeIndex, {
      total: bullets.length,
      prevIndex: prevIndex,
      sliderIndex: this._sliderIndex,
      direction: activeIndex > prevIndex ? DIRECTION.NEXT : DIRECTION.PREV,
      bullets: plugins_esm_spreadArray([], bullets),
      moveTo: this.moveTo
    });
    this._previousIndex = activeIndex;
  };

  return ScrollBulletRenderer;
}(plugins_esm_Renderer);

/**
 * @memberof Flicking.Plugins
 */

var plugins_esm_Pagination =
/*#__PURE__*/
function () {
  function Pagination(_a) {
    var _this = this;

    var _b = _a === void 0 ? {} : _a,
        _c = _b.parentEl,
        parentEl = _c === void 0 ? null : _c,
        _d = _b.selector,
        selector = _d === void 0 ? PAGINATION.SELECTOR : _d,
        _e = _b.type,
        type = _e === void 0 ? PAGINATION.TYPE.BULLET : _e,
        _f = _b.classPrefix,
        classPrefix = _f === void 0 ? PAGINATION.PREFIX : _f,
        _g = _b.bulletCount,
        bulletCount = _g === void 0 ? 5 : _g,
        _h = _b.renderBullet,
        renderBullet = _h === void 0 ? function (className) {
      return "<span class=\"" + className + "\"></span>";
    } : _h,
        _j = _b.renderActiveBullet,
        renderActiveBullet = _j === void 0 ? null : _j,
        _k = _b.renderFraction,
        renderFraction = _k === void 0 ? function (currentClass, totalClass) {
      return "<span class=\"" + currentClass + "\"></span>/<span class=\"" + totalClass + "\"></span>";
    } : _k,
        _l = _b.fractionCurrentFormat,
        fractionCurrentFormat = _l === void 0 ? function (index) {
      return index.toString();
    } : _l,
        _m = _b.fractionTotalFormat,
        fractionTotalFormat = _m === void 0 ? function (index) {
      return index.toString();
    } : _m,
        _o = _b.scrollOnChange,
        scrollOnChange = _o === void 0 ? function (index, ctx) {
      return ctx.moveTo(index);
    } : _o;
    /* Internal Values */


    this._flicking = null;

    this.update = function () {
      _this._removeAllChilds();

      _this._renderer.render();
    };

    this._onIndexChange = function (evt) {
      _this._renderer.update(evt.index);
    };

    this._parentEl = parentEl;
    this._selector = selector;
    this._type = type;
    this._classPrefix = classPrefix;
    this._bulletCount = bulletCount;
    this._renderBullet = renderBullet;
    this._renderActiveBullet = renderActiveBullet;
    this._renderFraction = renderFraction;
    this._fractionCurrentFormat = fractionCurrentFormat;
    this._fractionTotalFormat = fractionTotalFormat;
    this._scrollOnChange = scrollOnChange;
  }

  var __proto = Pagination.prototype;
  Object.defineProperty(__proto, "parentEl", {
    get: function () {
      return this._parentEl;
    },
    set: function (val) {
      this._parentEl = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "selector", {
    get: function () {
      return this._selector;
    },
    set: function (val) {
      this._selector = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "type", {
    get: function () {
      return this._type;
    },
    set: function (val) {
      this._type = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "classPrefix", {
    get: function () {
      return this._classPrefix;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "bulletCount", {
    get: function () {
      return this._bulletCount;
    },
    set: function (val) {
      this._bulletCount = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "renderBullet", {
    get: function () {
      return this._renderBullet;
    },
    set: function (val) {
      this._renderBullet = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "renderActiveBullet", {
    get: function () {
      return this._renderActiveBullet;
    },
    set: function (val) {
      this._renderActiveBullet = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "renderFraction", {
    get: function () {
      return this._renderFraction;
    },
    set: function (val) {
      this._renderFraction = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "fractionCurrentFormat", {
    get: function () {
      return this._fractionCurrentFormat;
    },
    set: function (val) {
      this._fractionCurrentFormat = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "fractionTotalFormat", {
    get: function () {
      return this._fractionTotalFormat;
    },
    set: function (val) {
      this._fractionTotalFormat = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "scrollOnChange", {
    get: function () {
      return this._scrollOnChange;
    },
    set: function (val) {
      this._scrollOnChange = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "bulletWrapperclassPrefixClass", {
    set: function (val) {
      this._classPrefix = val;
    },
    enumerable: false,
    configurable: true
  });

  __proto.init = function (flicking) {
    if (this._flicking) {
      this.destroy();
    }

    this._flicking = flicking;
    var type = this._type;
    var selector = this._selector;
    var parentEl = this._parentEl ? this._parentEl : flicking.element;
    var wrapper = parentEl.querySelector(selector);

    if (!wrapper) {
      throw new Error("[Flicking-Pagination] Couldn't find element with the given selector: " + selector);
    }

    this._wrapper = wrapper;
    this._renderer = this._createRenderer(type);
    flicking.on(flicking_esm_EVENTS.WILL_CHANGE, this._onIndexChange);
    flicking.on(flicking_esm_EVENTS.WILL_RESTORE, this._onIndexChange);
    flicking.on(flicking_esm_EVENTS.PANEL_CHANGE, this.update);
    this.update();
  };

  __proto.destroy = function () {
    var flicking = this._flicking;

    if (!flicking) {
      return;
    }

    flicking.off(flicking_esm_EVENTS.WILL_CHANGE, this._onIndexChange);
    flicking.off(flicking_esm_EVENTS.WILL_RESTORE, this._onIndexChange);
    flicking.off(flicking_esm_EVENTS.PANEL_CHANGE, this.update);

    this._renderer.destroy();

    this._removeAllChilds();

    this._flicking = null;
  };

  __proto._createRenderer = function (type) {
    var options = {
      flicking: this._flicking,
      pagination: this,
      wrapper: this._wrapper
    };

    switch (type) {
      case PAGINATION.TYPE.BULLET:
        return new BulletRenderer(options);

      case PAGINATION.TYPE.FRACTION:
        return new FractionRenderer(options);

      case PAGINATION.TYPE.SCROLL:
        return new plugins_esm_ScrollBulletRenderer(options);

      default:
        throw new Error("[Flicking-Pagination] type \"" + type + "\" is not supported.");
    }
  };

  __proto._removeAllChilds = function () {
    var wrapper = this._wrapper;

    while (wrapper.firstChild) {
      wrapper.removeChild(wrapper.firstChild);
    }
  };

  return Pagination;
}();

/**
 * @namespace Flicking
 */


//# sourceMappingURL=plugins.esm.js.map

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-card-flicking.vue?vue&type=script&lang=js



// import '@egjs/flicking-plugins/dist/arrow.css'

/* harmony default export */ var hg_card_flickingvue_type_script_lang_js = ({
  props: {
    isCircular: {
      type: Boolean,
      default: false,
    },
    sideButtons: {
      type: Boolean,
      default: false,
    },
    fullWidthLeft: {
      type: Boolean,
      default: true,
    },
    fullWidthRight: {
      type: Boolean,
      default: true,
    },
    alignLeft: {
      type: Boolean,
      default: false,
    },
    panelsPerView: {
      type: Number,
      default: -1,
    },
  },
  data() {
    const flickingId = crypto.randomUUID()

    return {
      flickingId,
      plugins: [
        new plugins_esm_Pagination({
          type: 'bullet'
        }),
        new plugins_esm_Arrow({
          parentEl: document.body,
          prevElSelector: '.flicking-arrow-prev-' + flickingId,
          nextElSelector: '.flicking-arrow-next-' + flickingId,
        }),
      ],
      flickingOption: {
        align: 'prev',
        defaultIndex: 0,
        horizontal: true,
        circular: this.isCircular,
        bound: false,
        renderOnlyVisible: false,
        adaptive: false,
        deceleration: 0.0075,
        duration: 500,
        threshold: 40,
        moveType: 'snap',
        panelsPerView: this.panelsPerView,
      },
      prevButtonVisible: false,
      nextButtonVisible: true,
    }
  },
  methods: {
    flickingChanged(e) {
      if (!this.isCircular) {
        this.prevButtonVisible = e.index > 0
        this.nextButtonVisible = e.index < e.currentTarget.panelCount - 1
      }
    },
  },
  created() {
    // Set the initial value for prevButtonVisible
    this.prevButtonVisible = this.isCircular
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-card-flicking.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_card_flickingvue_type_script_lang_js = (hg_card_flickingvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-card-flicking.vue?vue&type=style&index=0&id=7821805c&prod&lang=postcss
var hg_card_flickingvue_type_style_index_0_id_7821805c_prod_lang_postcss = __webpack_require__("5861");

// EXTERNAL MODULE: ./src/components/ui/hg-card-flicking.vue?vue&type=style&index=1&id=7821805c&prod&lang=postcss&scoped=true
var hg_card_flickingvue_type_style_index_1_id_7821805c_prod_lang_postcss_scoped_true = __webpack_require__("125b");

// CONCATENATED MODULE: ./src/components/ui/hg-card-flicking.vue







/* normalize component */

var hg_card_flicking_component = normalizeComponent(
  ui_hg_card_flickingvue_type_script_lang_js,
  hg_card_flickingvue_type_template_id_7821805c_scoped_true_render,
  hg_card_flickingvue_type_template_id_7821805c_scoped_true_staticRenderFns,
  false,
  null,
  "7821805c",
  null
  
)

/* harmony default export */ var hg_card_flicking = (hg_card_flicking_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-card-flicking-new.vue?vue&type=template&id=435288de&scoped=true
var hg_card_flicking_newvue_type_template_id_435288de_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`hg-flicking ${
    _vm.sideButtons && !_vm.fullWidthLeft ? 'hg-flicking-padding-left' : ''
  } ${_vm.sideButtons && !_vm.fullWidthRight ? 'hg-flicking-padding-right' : ''}`},[_c('Flicking',{ref:"flicking",class:`hg-flicking-container ${
      _vm.alignLeft ? 'container-align-left' : ''
    }`,attrs:{"options":_vm.flickingOption,"plugins":_vm.plugins},on:{"changed":_vm.flickingChanged}},[_vm._t("default"),_c('div',{ref:"pagination",staticClass:"flicking-pagination",attrs:{"slot":"viewport"},slot:"viewport"})],2),_c('span',{class:`flicking-arrow-prev flicking-arrow-prev-${_vm.flickingId} hg-button hg-flicking-button-left ${
      _vm.sideButtons ? 'hg-side-button-left' : ''
    } ${_vm.prevButtonVisible ? '' : 'tw-visible'}`},[_c('HgIcon',{attrs:{"name":"chevron-left","size":_vm.sideButtons ? 'small' : 'regular'}})],1),_c('span',{class:`flicking-arrow-next flicking-arrow-next-${_vm.flickingId} hg-button hg-flicking-button-right ${
      _vm.sideButtons ? 'hg-side-button-right' : ''
    } ${_vm.nextButtonVisible ? '' : 'tw-visible'}`},[_c('HgIcon',{attrs:{"name":"chevron-right","size":_vm.sideButtons ? 'small' : 'regular'}})],1)],1)
}
var hg_card_flicking_newvue_type_template_id_435288de_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-card-flicking-new.vue?vue&type=template&id=435288de&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-card-flicking-new.vue?vue&type=script&lang=js




/* harmony default export */ var hg_card_flicking_newvue_type_script_lang_js = ({
  props: {
    isCircular: {
      type: Boolean,
      default: false,
    },
    sideButtons: {
      type: Boolean,
      default: false,
    },
    fullWidthLeft: {
      type: Boolean,
      default: true,
    },
    fullWidthRight: {
      type: Boolean,
      default: true,
    },
    alignLeft: {
      type: Boolean,
      default: true,
    },
    panelsPerView: {
      type: Number,
      default: -1,
    },
  },
  data() {
    const flickingId = crypto.randomUUID()

    return {
      flickingId,
      plugins: [
        new plugins_esm_Pagination({ type: 'bullet' }),
        new plugins_esm_Arrow({
          parentEl: document.body,
          prevElSelector: '.flicking-arrow-prev-' + this.flickingId,
          nextElSelector: '.flicking-arrow-next-' + this.flickingId,
        }),
      ],
      flickingOption: {
        align: 'prev',
        defaultIndex: 0,
        horizontal: true,
        circular: this.isCircular,
        bound: false,
        renderOnlyVisible: false,
        adaptive: false,
        deceleration: 0.0075,
        duration: 500,
        threshold: 40,
        moveType: 'snap',
        panelsPerView: this.panelsPerView,
      },
      prevButtonVisible: false,
      nextButtonVisible: true,
    }
  },
  methods: {
    flickingChanged(e) {
      if (!this.isCircular) {
        this.prevButtonVisible = e.index > 0
        this.nextButtonVisible = e.index < e.currentTarget.panelCount - 1
      }
    },
  },
  created() {
    // Set the initial value for prevButtonVisible
    this.prevButtonVisible = this.isCircular
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-card-flicking-new.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_card_flicking_newvue_type_script_lang_js = (hg_card_flicking_newvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-card-flicking-new.vue?vue&type=style&index=0&id=435288de&prod&lang=postcss
var hg_card_flicking_newvue_type_style_index_0_id_435288de_prod_lang_postcss = __webpack_require__("1ee6");

// EXTERNAL MODULE: ./src/components/ui/hg-card-flicking-new.vue?vue&type=style&index=1&id=435288de&prod&lang=postcss&scoped=true
var hg_card_flicking_newvue_type_style_index_1_id_435288de_prod_lang_postcss_scoped_true = __webpack_require__("4d70");

// CONCATENATED MODULE: ./src/components/ui/hg-card-flicking-new.vue







/* normalize component */

var hg_card_flicking_new_component = normalizeComponent(
  ui_hg_card_flicking_newvue_type_script_lang_js,
  hg_card_flicking_newvue_type_template_id_435288de_scoped_true_render,
  hg_card_flicking_newvue_type_template_id_435288de_scoped_true_staticRenderFns,
  false,
  null,
  "435288de",
  null
  
)

/* harmony default export */ var hg_card_flicking_new = (hg_card_flicking_new_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-flicking-slide.vue?vue&type=template&id=11ac3934
var hg_flicking_slidevue_type_template_id_11ac3934_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default")],2)
}
var hg_flicking_slidevue_type_template_id_11ac3934_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-flicking-slide.vue?vue&type=template&id=11ac3934

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-flicking-slide.vue?vue&type=script&lang=js

/* harmony default export */ var hg_flicking_slidevue_type_script_lang_js = ({});

// CONCATENATED MODULE: ./src/components/ui/hg-flicking-slide.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_flicking_slidevue_type_script_lang_js = (hg_flicking_slidevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-flicking-slide.vue?vue&type=style&index=0&id=11ac3934&prod&lang=css
var hg_flicking_slidevue_type_style_index_0_id_11ac3934_prod_lang_css = __webpack_require__("df2c");

// CONCATENATED MODULE: ./src/components/ui/hg-flicking-slide.vue






/* normalize component */

var hg_flicking_slide_component = normalizeComponent(
  ui_hg_flicking_slidevue_type_script_lang_js,
  hg_flicking_slidevue_type_template_id_11ac3934_render,
  hg_flicking_slidevue_type_template_id_11ac3934_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_flicking_slide = (hg_flicking_slide_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-tag-carousel.vue?vue&type=template&id=e3823b40&scoped=true
var hg_tag_carouselvue_type_template_id_e3823b40_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-tag-carousel-wrapper"},[_c('div',{staticClass:"tag-fade tag-fade--left"}),_c('div',{staticClass:"hg-tag-carousel"},[_vm._t("default"),_c('div',{staticClass:"hg-tag--spacer"})],2),_c('div',{staticClass:"tag-fade tag-fade--right"})])
}
var hg_tag_carouselvue_type_template_id_e3823b40_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-tag-carousel.vue?vue&type=template&id=e3823b40&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-tag-carousel.vue?vue&type=script&lang=js

/* harmony default export */ var hg_tag_carouselvue_type_script_lang_js = ({});

// CONCATENATED MODULE: ./src/components/ui/hg-tag-carousel.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_tag_carouselvue_type_script_lang_js = (hg_tag_carouselvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-tag-carousel.vue?vue&type=style&index=0&id=e3823b40&prod&scoped=true&lang=postcss
var hg_tag_carouselvue_type_style_index_0_id_e3823b40_prod_scoped_true_lang_postcss = __webpack_require__("a560");

// CONCATENATED MODULE: ./src/components/ui/hg-tag-carousel.vue






/* normalize component */

var hg_tag_carousel_component = normalizeComponent(
  ui_hg_tag_carouselvue_type_script_lang_js,
  hg_tag_carouselvue_type_template_id_e3823b40_scoped_true_render,
  hg_tag_carouselvue_type_template_id_e3823b40_scoped_true_staticRenderFns,
  false,
  null,
  "e3823b40",
  null
  
)

/* harmony default export */ var hg_tag_carousel = (hg_tag_carousel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-header-background.vue?vue&type=template&id=51a4a022&scoped=true
var hg_header_backgroundvue_type_template_id_51a4a022_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`hg-header${_vm.checkNewDesign()}`},[_c('hg-image',{class:`hg-header-background`,attrs:{"src":_vm.image.src,"src-placeholder":_vm.image.placeholderSrc}}),_c('div',{class:`hg-header-wrapper ${ _vm.$i18n.locale === 'es' ? 'es' : '' }`},[_c('div',{class:`hg-header-headline`},[_c(_vm.svgLanguage,{tag:"component",class:`hg-header-svg`,attrs:{"color":_vm.svgStyles.color}}),(_vm.showArrow)?_c('svg',{staticClass:"searchtabs-svg",attrs:{"width":"83","height":"93","viewBox":"0 0 83 93","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M80.1776 88.5129C79.662 81.8309 78.815 75.2474 78.6222 68.4817C78.437 61.9973 78.8448 54.8579 82.3487 48.9661C83.9853 46.2136 81.4974 43.5385 79.6525 46.6408C76.0716 52.6623 74.9056 59.5293 74.7895 66.4997C73.6195 59.2547 72.6584 51.9222 70.8413 44.9508C67.8094 33.3223 61.6686 23.141 54.2535 15.3365C41.5431 1.95892 20.0515 -5.05643 2.11821 6.05414C-0.558114 7.71268 0.551244 11.4247 3.25389 9.7501C11.3453 4.73731 20.3304 4.49979 28.4392 6.17984C37.6428 8.08537 45.4203 13.2256 51.9545 20.4751C58.8626 28.1382 64.1089 37.9708 66.8794 49.0644C69.0175 57.6246 69.8821 66.7201 71.5632 75.476C65.6045 67.7173 58.8246 61.0753 49.8001 58.0069C47.6742 57.2844 46.0217 62.6636 48.1642 63.3916C60.9884 67.7525 69.035 79.8255 76.8367 91.5628C78.1807 93.5852 80.3252 90.4295 80.1776 88.5129Z","fill":"#00D5E0"}})]):_vm._e()],1),_c('div',{class:`hg-header-content`},[_vm._t("default")],2)]),(_vm.image.location)?_c('div',{class:`hg-header-location-wrapper`},[_c('div',{staticClass:"hg-header-location"},[_c('hg-icon',{staticClass:"tw-mr-1",attrs:{"name":"map-marker-alt","size":"small"}}),_vm._v(" "+_vm._s(_vm.image.location)+" ")],1)]):_vm._e()],1)
}
var hg_header_backgroundvue_type_template_id_51a4a022_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-header-background.vue?vue&type=template&id=51a4a022&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-image.vue?vue&type=template&id=64a9d4dd
var hg_imagevue_type_template_id_64a9d4dd_render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-lazy-image',{attrs:{"src":_vm.src,"src-placeholder":_vm.srcPlaceholder,"alt":_vm.alt}})
}
var hg_imagevue_type_template_id_64a9d4dd_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-image.vue?vue&type=template&id=64a9d4dd

// CONCATENATED MODULE: ./node_modules/v-lazy-image/v2/v-lazy-image.mjs
const VLazyImageComponent = {
  props: {
    src: {
      type: String,
      required: true
    },
    srcPlaceholder: {
      type: String,
      default: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
    },
    srcset: {
      type: String
    },
    intersectionOptions: {
      type: Object,
      default: () => ({})
    },
    usePicture: {
      type: Boolean,
      default: false
    }
  },
  inheritAttrs: false,
  data: () => ({ observer: null, intersected: false, loaded: false }),
  computed: {
    srcImage() {
      return this.intersected && this.src ? this.src : this.srcPlaceholder;
    },
    srcsetImage() {
      return this.intersected && this.srcset ? this.srcset : false;
    }
  },
  methods: {
    load() {
      if (this.$el && this.$el.getAttribute("src") !== this.srcPlaceholder) {
        this.loaded = true;
        this.$emit("load", this.$el);
      }
    },
    error() {
      this.$emit("error", this.$el);
    }
  },
  render(h) {
    let img = h("img", {
      attrs: {
        src: this.srcImage,
        srcset: this.srcsetImage
      },
      domProps: this.$attrs,
      class: {
        "v-lazy-image": true,
        "v-lazy-image-loaded": this.loaded
      },
      on: { load: this.load, error: this.error }
    });
    if (this.usePicture) {
      return h("picture", { on: { load: this.load } }, this.intersected ? [this.$slots.default, img] : [img]);
    } else {
      return img;
    }
  },
  mounted() {
    if ("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver((entries) => {
        const image = entries[0];
        if (image.isIntersecting) {
          this.intersected = true;
          this.observer.disconnect();
          this.$emit("intersect");
        }
      }, this.intersectionOptions);
      this.observer.observe(this.$el);
    }
  },
  destroyed() {
    if ("IntersectionObserver" in window) {
      this.observer.disconnect();
    }
  }
};


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-image.vue?vue&type=script&lang=js



/* harmony default export */ var hg_imagevue_type_script_lang_js = ({
  components: {
    VLazyImage: VLazyImageComponent,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    srcPlaceholder: {
      type: String,
      default:
        'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
    },
    alt: {
      type: String,
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-image.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_imagevue_type_script_lang_js = (hg_imagevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/ui/hg-image.vue





/* normalize component */

var hg_image_component = normalizeComponent(
  ui_hg_imagevue_type_script_lang_js,
  hg_imagevue_type_template_id_64a9d4dd_render,
  hg_imagevue_type_template_id_64a9d4dd_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_image = (hg_image_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-header-background.vue?vue&type=script&lang=js



/* harmony default export */ var hg_header_backgroundvue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  props: {
    image: {
      type: Object,
      default: () => {},
    },
    svgLanguage: {
      type: String,
      default: '',
    },
    showArrow: {
      type: Boolean,
      default: false,
    },
    isNewDesign: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      svgStyles: {
        color: this.image.svgColor,
      },
    }
  },

  methods: {
    checkNewDesign() {
      return this.isNewDesign ? '--new' : ''
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-header-background.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_header_backgroundvue_type_script_lang_js = (hg_header_backgroundvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-header-background.vue?vue&type=style&index=0&id=51a4a022&prod&scoped=true&lang=postcss
var hg_header_backgroundvue_type_style_index_0_id_51a4a022_prod_scoped_true_lang_postcss = __webpack_require__("0fa7");

// CONCATENATED MODULE: ./src/components/ui/hg-header-background.vue






/* normalize component */

var hg_header_background_component = normalizeComponent(
  ui_hg_header_backgroundvue_type_script_lang_js,
  hg_header_backgroundvue_type_template_id_51a4a022_scoped_true_render,
  hg_header_backgroundvue_type_template_id_51a4a022_scoped_true_staticRenderFns,
  false,
  null,
  "51a4a022",
  null
  
)

/* harmony default export */ var hg_header_background = (hg_header_background_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-loading-screen.vue?vue&type=template&id=5713da89&scoped=true
var hg_loading_screenvue_type_template_id_5713da89_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading || _vm.isTimerRunning)?_c('div',{staticClass:"hg__loadingscreen"},[_c('div',{staticClass:"loadingscreen__details"},[_c('GuruLogoMobile',{staticClass:"pulse",attrs:{"locale":_vm.locale}}),_c('div',{staticClass:"loadingscreen__texts"},[_c('p',{staticClass:"loadingscreen__headline"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"loadingscreen__text"},[_vm._v(_vm._s(_vm.subtitle))])])],1)]):_vm._e()
}
var hg_loading_screenvue_type_template_id_5713da89_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-loading-screen.vue?vue&type=template&id=5713da89&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-loading-screen.vue?vue&type=script&lang=js

/* harmony default export */ var hg_loading_screenvue_type_script_lang_js = ({
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Loading',
    },
    subtitle: {
      type: String,
      default: 'Please wait...',
    },
    timer: {
      type: Number,
      default: 0,
    },
    locale: {
      type: String,
      default: 'de',
    },
  },

  data: () => ({
    isTimerRunning: false,
  }),

  watch: {
    isLoading() {
      if (this.isLoading && this.timer > 0) this.startTimer()
    },
  },

  methods: {
    startTimer() {
      this.isTimerRunning = true
      setTimeout(() => {
        this.isTimerRunning = false
      }, this.timer)
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-loading-screen.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_loading_screenvue_type_script_lang_js = (hg_loading_screenvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-loading-screen.vue?vue&type=style&index=0&id=5713da89&prod&scoped=true&lang=postcss
var hg_loading_screenvue_type_style_index_0_id_5713da89_prod_scoped_true_lang_postcss = __webpack_require__("0897");

// CONCATENATED MODULE: ./src/components/ui/hg-loading-screen.vue






/* normalize component */

var hg_loading_screen_component = normalizeComponent(
  ui_hg_loading_screenvue_type_script_lang_js,
  hg_loading_screenvue_type_template_id_5713da89_scoped_true_render,
  hg_loading_screenvue_type_template_id_5713da89_scoped_true_staticRenderFns,
  false,
  null,
  "5713da89",
  null
  
)

/* harmony default export */ var hg_loading_screen = (hg_loading_screen_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-link-handler.vue?vue&type=template&id=10f567b0
var hg_link_handlervue_type_template_id_10f567b0_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getLinkTag)?_c('nuxt-link',{attrs:{"to":{path: _vm.link},"target":_vm.linkTarget}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.link,"target":_vm.linkTarget}},[_vm._t("default")],2)
}
var hg_link_handlervue_type_template_id_10f567b0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-link-handler.vue?vue&type=template&id=10f567b0

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-link-handler.vue?vue&type=script&lang=js

/* harmony default export */ var hg_link_handlervue_type_script_lang_js = ({
  props: {
    link: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      linkTarget: '',
    }
  },
  computed: {
    getLinkTag() {
      const conditions = ['https://', 'http://'];

      if (!conditions.some(el => this.link.includes(el))) {
        !this.target ?
          this.linkTarget = '_self' :
          this.linkTarget = this.target
        return true
      } else {
        !this.target ?
          this.linkTarget = '_blank' :
          this.linkTarget = this.target
      }
    }
  }
});

// CONCATENATED MODULE: ./src/components/ui/hg-link-handler.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_link_handlervue_type_script_lang_js = (hg_link_handlervue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/ui/hg-link-handler.vue





/* normalize component */

var hg_link_handler_component = normalizeComponent(
  ui_hg_link_handlervue_type_script_lang_js,
  hg_link_handlervue_type_template_id_10f567b0_render,
  hg_link_handlervue_type_template_id_10f567b0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_link_handler = (hg_link_handler_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-like-bookmark.vue?vue&type=template&id=3f031b76&scoped=true
var hg_like_bookmarkvue_type_template_id_3f031b76_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meta-buttons"},[_c('button',{staticClass:"hg-button button--share",attrs:{"role":"button","type":"button","id":"shareButton"},on:{"click":function($event){$event.preventDefault();return _vm.clickShare.apply(null, arguments)}}},[_c('hg-icon',{staticClass:"share icon-light",attrs:{"name":"share","pack":"fal"}}),_c('hg-icon',{staticClass:"share icon-solid",attrs:{"name":"share","pack":"fas"}})],1),_c('button',{staticClass:"hg-button button--bookmark",class:{'button--active': _vm.hasBookmark},attrs:{"id":"likeButton","role":"button","type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.clickBookmark.apply(null, arguments)}}},[_c('hg-icon',{staticClass:"heart icon-light",attrs:{"name":"heart","pack":"fal"}}),_c('hg-icon',{staticClass:"heart icon-solid",attrs:{"name":"heart","pack":"fas"}})],1)])
}
var hg_like_bookmarkvue_type_template_id_3f031b76_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-like-bookmark.vue?vue&type=template&id=3f031b76&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-like-bookmark.vue?vue&type=script&lang=js


/* harmony default export */ var hg_like_bookmarkvue_type_script_lang_js = ({
  props: {
    hasBookmark: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    clickShare() {
      this.$emit('onClickShare')
    },
    clickBookmark() {
      this.$emit('onClickBookmark')
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-like-bookmark.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_like_bookmarkvue_type_script_lang_js = (hg_like_bookmarkvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-like-bookmark.vue?vue&type=style&index=0&id=3f031b76&prod&lang=postcss&scoped=true
var hg_like_bookmarkvue_type_style_index_0_id_3f031b76_prod_lang_postcss_scoped_true = __webpack_require__("afad");

// CONCATENATED MODULE: ./src/components/ui/hg-like-bookmark.vue






/* normalize component */

var hg_like_bookmark_component = normalizeComponent(
  ui_hg_like_bookmarkvue_type_script_lang_js,
  hg_like_bookmarkvue_type_template_id_3f031b76_scoped_true_render,
  hg_like_bookmarkvue_type_template_id_3f031b76_scoped_true_staticRenderFns,
  false,
  null,
  "3f031b76",
  null
  
)

/* harmony default export */ var hg_like_bookmark = (hg_like_bookmark_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-deal-type.vue?vue&type=template&id=453e7a06&scoped=true
var hg_deal_typevue_type_template_id_453e7a06_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-deal-type-label"},[_c('img',{staticClass:"hg-icon-catergory",attrs:{"src":_vm.icon,"alt":"icons"}}),_c('span',{staticClass:"deal-type"},[_vm._v(_vm._s(_vm.name))])])
}
var hg_deal_typevue_type_template_id_453e7a06_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-deal-type.vue?vue&type=template&id=453e7a06&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-deal-type.vue?vue&type=script&lang=js

/* harmony default export */ var hg_deal_typevue_type_script_lang_js = ({
  props: {
    icon: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-deal-type.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_deal_typevue_type_script_lang_js = (hg_deal_typevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-deal-type.vue?vue&type=style&index=0&id=453e7a06&prod&lang=postcss&scoped=true
var hg_deal_typevue_type_style_index_0_id_453e7a06_prod_lang_postcss_scoped_true = __webpack_require__("6348");

// CONCATENATED MODULE: ./src/components/ui/hg-deal-type.vue






/* normalize component */

var hg_deal_type_component = normalizeComponent(
  ui_hg_deal_typevue_type_script_lang_js,
  hg_deal_typevue_type_template_id_453e7a06_scoped_true_render,
  hg_deal_typevue_type_template_id_453e7a06_scoped_true_staticRenderFns,
  false,
  null,
  "453e7a06",
  null
  
)

/* harmony default export */ var hg_deal_type = (hg_deal_type_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-star-rating.vue?vue&type=template&id=6e7b4bf2&scoped=true
var hg_star_ratingvue_type_template_id_6e7b4bf2_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating-wrap"},_vm._l((_vm.stars),function(index){return _c('svg',{attrs:{"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[(_vm.starFill(index))?_c('path',{attrs:{"fill":_vm.starFill(index),"stroke":"#323231","stroke-width":"0.5","d":"M4.68829 14.8975L8.21212 13.0192L11.736 14.8975C12.3615 15.231 13.1083 14.6952 12.9869 13.9761L12.3129 9.99805L15.1627 7.18199C15.675 6.6762 15.3919 5.79311 14.6855 5.68922L10.7465 5.10687L8.98591 1.487C8.67046 0.841773 7.75647 0.833576 7.43833 1.487L5.67777 5.10687L1.73875 5.68922C1.03237 5.79311 0.749274 6.6762 1.26154 7.18199L4.11134 9.99805L3.43731 13.9761C3.31598 14.6952 4.06279 15.2337 4.68829 14.8975Z"}}):(_vm.halfStar(index))?_c('g',[_c('path',{attrs:{"d":"M4.68829 14.8975L8.21212 13.0192L11.736 14.8975C12.3615 15.231 13.1083 14.6952 12.9869 13.9761L12.3129 9.99805L15.1627 7.18199C15.675 6.6762 15.3919 5.79311 14.6855 5.68922L10.7465 5.10687L8.98591 1.487C8.67046 0.841773 7.75647 0.833576 7.43833 1.487L5.67777 5.10687L1.73875 5.68922C1.03237 5.79311 0.749274 6.6762 1.26154 7.18199L4.11134 9.99805L3.43731 13.9761C3.31598 14.6952 4.06279 15.2337 4.68829 14.8975Z","stroke":"#323231","stroke-width":"0.5"}}),_c('path',{attrs:{"d":"M4.72279 14.8975L8.27958 13.0192L9.06061 1.487C8.74221 0.841773 7.81966 0.833576 7.49855 1.487L5.72152 5.10687L1.74566 5.68922C1.03267 5.79311 0.746929 6.6762 1.26398 7.18199L4.14044 9.99805L3.4601 13.9761C3.33764 14.6952 4.09143 15.2337 4.72279 14.8975Z","fill":"#323231"}})]):(_vm.showEmptyStars)?_c('path',{attrs:{"stroke":_vm.starStroke(index),"stroke-width":"0.5","d":"M4.68829 14.8975L8.21212 13.0192L11.736 14.8975C12.3615 15.231 13.1083 14.6952 12.9869 13.9761L12.3129 9.99805L15.1627 7.18199C15.675 6.6762 15.3919 5.79311 14.6855 5.68922L10.7465 5.10687L8.98591 1.487C8.67046 0.841773 7.75647 0.833576 7.43833 1.487L5.67777 5.10687L1.73875 5.68922C1.03237 5.79311 0.749274 6.6762 1.26154 7.18199L4.11134 9.99805L3.43731 13.9761C3.31598 14.6952 4.06279 15.2337 4.68829 14.8975Z"}}):_vm._e()])}),0)
}
var hg_star_ratingvue_type_template_id_6e7b4bf2_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-star-rating.vue?vue&type=template&id=6e7b4bf2&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-star-rating.vue?vue&type=script&lang=js

/* harmony default export */ var hg_star_ratingvue_type_script_lang_js = ({
  props: {
    stars: {
      type: Number,
      default: 5,
    },
    rating: {
      type: Number,
      default: 2,
    },
    showEmptyStars: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // active
    starFill(val) {
      return val <= this.rating ? '#323231' : false
    },
    // half star
    halfStar(val) {
      const splitRating = this.rating.toString().split('.')
      if (parseFloat(splitRating[1]) > 0) {
        return parseFloat(splitRating[0]) === val - 1
      }
    },
    // inactive
    starStroke(val) {
      return val > this.rating ? '#323231' : false
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-star-rating.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_star_ratingvue_type_script_lang_js = (hg_star_ratingvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-star-rating.vue?vue&type=style&index=0&id=6e7b4bf2&prod&lang=postcss&scoped=true
var hg_star_ratingvue_type_style_index_0_id_6e7b4bf2_prod_lang_postcss_scoped_true = __webpack_require__("12b8");

// CONCATENATED MODULE: ./src/components/ui/hg-star-rating.vue






/* normalize component */

var hg_star_rating_component = normalizeComponent(
  ui_hg_star_ratingvue_type_script_lang_js,
  hg_star_ratingvue_type_template_id_6e7b4bf2_scoped_true_render,
  hg_star_ratingvue_type_template_id_6e7b4bf2_scoped_true_staticRenderFns,
  false,
  null,
  "6e7b4bf2",
  null
  
)

/* harmony default export */ var hg_star_rating = (hg_star_rating_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-login-button.vue?vue&type=template&id=22a07e14
var hg_login_buttonvue_type_template_id_22a07e14_render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"login-button",on:{"click":_vm.handleClick}},[(_vm.variant == 'apple')?_c('AppleLogo'):(_vm.variant == 'facebook')?_c('FacebookLogo'):_c('GoogleLogo'),_c('span',{staticClass:"login-button-label"},[_vm._v(_vm._s(_vm.label))])],1)
}
var hg_login_buttonvue_type_template_id_22a07e14_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-login-button.vue?vue&type=template&id=22a07e14

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-login-button.vue?vue&type=script&lang=js

/* harmony default export */ var hg_login_buttonvue_type_script_lang_js = ({
  props: {
    variant: {
      type: String,
      default: 'apple',
    },
  },
  computed: {
    label() {
      switch (this.variant) {
        case 'apple':
          return 'Apple'
        case 'facebook':
          return 'Facebook'
        default:
          return 'Google'
      }
    },
  },
  methods: {
    handleClick() {
      this.$emit('onClick')
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-login-button.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_login_buttonvue_type_script_lang_js = (hg_login_buttonvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-login-button.vue?vue&type=style&index=0&id=22a07e14&prod&lang=css
var hg_login_buttonvue_type_style_index_0_id_22a07e14_prod_lang_css = __webpack_require__("b09b");

// CONCATENATED MODULE: ./src/components/ui/hg-login-button.vue






/* normalize component */

var hg_login_button_component = normalizeComponent(
  ui_hg_login_buttonvue_type_script_lang_js,
  hg_login_buttonvue_type_template_id_22a07e14_render,
  hg_login_buttonvue_type_template_id_22a07e14_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_login_button = (hg_login_button_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-newsletter-banner.vue?vue&type=template&id=3cf66e80&scoped=true
var hg_newsletter_bannervue_type_template_id_3cf66e80_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsletter-banner"},[_c('div',{staticClass:"svg-container"},[(_vm.variant == 1 || _vm.variant == 2)?_c('NewsletterBannerMailSvg'):_c('NewsletterBannerFlightSvg')],1),_c('div',{staticClass:"container"},[_c('div',{staticClass:"description-container"},[_c('h2',{staticClass:"headline",domProps:{"innerHTML":_vm._s(_vm.selectedVariant.headline)}}),_c('div',{staticClass:"description"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.selectedVariant.description)}}),_c('ul',_vm._l((_vm.selectedVariant.listItems),function(item){return _c('li',{domProps:{"innerHTML":_vm._s(item)}})}),0)])]),_c('ValidationObserver',{ref:"observer",staticClass:"form-container",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},scopedSlots:_vm._u([{key:"default",fn:function({ invalid }){return [_c('HgTextInput',{attrs:{"label":"Vorname","name":"firstname","rules":"required"},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}}),_c('HgTextInput',{attrs:{"label":"E-Mail","type":"email","name":"email","rules":"required|email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c('HgButton',{attrs:{"id":'newsletter-banner-variant-' + _vm.variant + '-submit-button',"color":"teallight","type":"submit","nativeType":"submit","disabled":invalid === true}},[_vm._v(" Kostenlosen Newsletter abonnieren ")]),_c('p',{staticClass:"legal-text"},[_vm._v(" * Mit der Anmeldung akzeptierst du unsere "),_c('a',{attrs:{"href":"https://www.urlaubsguru.de/datenschutzerklaerung/","target":"_blank"}},[_vm._v(" Datenschutzrichtlinien")]),_vm._v(". ")])]}}])})],1)])
}
var hg_newsletter_bannervue_type_template_id_3cf66e80_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/hg-newsletter-banner.vue?vue&type=template&id=3cf66e80&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/newsletter-banner-mail-svg.vue?vue&type=template&id=f31f1908
var newsletter_banner_mail_svgvue_type_template_id_f31f1908_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"262","height":"180","viewBox":"0 0 262 180","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.53946 155.454C-2.23554 141.276 1.85099 127.707 4.02151 123.57C8.06935 115.849 14.5381 109.972 17.8591 101.8C24.6476 85.0913 19.714 78.79 27.2497 64.8346C28.9153 61.7513 35.7079 50.018 47.2955 46.2593C58.6979 42.5597 64.9427 49.7589 76.2575 51.4709C97.4435 54.6766 105.079 33.9036 130.533 23.1784C154.977 12.8776 192.521 13.2469 208.407 34.8402C222.931 54.5828 210.235 79.6777 229.218 99.612C238.93 109.811 246.279 107.472 251.744 118.969C258.42 133.012 255.099 152.583 247.621 164.027C241.926 172.742 234.154 176.754 234.154 176.754C231.46 178.145 229.057 178.868 227.349 179.266C156.426 179.064 85.5036 178.862 14.5789 178.66C13.1169 177.076 11.2009 174.807 9.21569 171.836C7.91867 169.895 3.65501 163.412 1.53743 155.456L1.53946 155.454Z","fill":"#ECFCCB"}}),_c('path',{attrs:{"d":"M221.442 142.882L225.376 146.792C228.287 145.75 231.517 144.465 234.753 143.28L231.775 140.346L236.48 142.66C240.791 141.141 245.017 139.907 248.41 139.781C244.26 136.065 238.737 133.787 232.987 132.521L225.21 135.858L230.695 132.071C225.388 131.152 220.016 131.037 215.46 131.403C205.273 132.224 197.217 143.892 197.217 143.892C197.217 143.892 210.75 150.206 218.966 148.685C220.416 148.417 222.128 147.909 224.007 147.269L221.442 142.879V142.882Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M186.433 142.497C185.691 138.485 188.41 132.528 188.41 132.528C188.41 132.528 192.751 137.39 192.639 141.853C192.6 143.416 192.264 144.64 191.842 145.57C192.926 144.268 194.173 142.805 195.568 141.228C195.074 140.887 192.888 139.197 192.448 135.616C191.951 131.572 195.028 125.745 195.028 125.745C195.028 125.745 199.063 130.81 198.679 135.262C198.549 136.773 198.16 137.952 197.704 138.853C198.931 137.513 200.245 136.117 201.634 134.693C201.143 134.318 199.318 132.723 199.068 129.543C198.776 125.867 201.785 120.682 201.785 120.682C201.785 120.682 205.237 125.39 204.716 129.412C204.541 130.755 204.154 131.798 203.715 132.595C204.727 131.592 205.772 130.583 206.851 129.571C206.354 129.162 204.717 127.595 204.572 124.602C204.401 121.07 207.435 116.169 207.435 116.169C207.435 116.169 210.604 120.761 209.988 124.604C209.778 125.914 209.364 126.922 208.908 127.68C209.927 126.761 210.943 125.872 211.954 125.012C211.526 124.614 210.006 122.993 210.084 120.03C210.174 116.585 213.477 111.987 213.477 111.987C213.477 111.987 216.217 116.633 215.34 120.337C215.047 121.574 214.584 122.514 214.099 123.223C215.328 122.221 216.552 121.269 217.768 120.358C217.401 119.942 216.138 118.283 216.519 115.485C216.962 112.223 220.563 108.127 220.563 108.127C220.563 108.127 222.675 112.754 221.461 116.198C221.1 117.221 220.636 118.012 220.163 118.62C221.33 117.798 222.491 117.014 223.643 116.279C223.286 115.754 222.321 114.02 222.988 111.368C223.795 108.155 227.835 104.386 227.835 104.386C227.835 104.386 229.412 109.182 227.816 112.509C227.416 113.342 226.964 114.005 226.509 114.529C227.606 113.892 228.692 113.295 229.77 112.741C229.538 112.275 228.761 110.376 229.919 107.712C231.259 104.634 235.879 101.425 235.879 101.425C235.879 101.425 236.625 106.385 234.49 109.473C233.996 110.189 233.481 110.753 232.98 111.198C234.269 110.626 235.545 110.116 236.805 109.669C236.65 109.054 236.416 107.362 237.746 105.279C239.424 102.65 244.077 100.29 244.077 100.29C244.077 100.29 243.992 104.869 241.595 107.415C241.149 107.888 240.706 108.273 240.28 108.584C241.549 108.243 242.803 107.97 244.038 107.763C244.003 107.078 244.132 105.719 245.356 104.195C247.116 102.005 251.475 100.302 251.475 100.302C251.475 100.302 250.912 104.348 248.527 106.403C248.048 106.816 247.584 107.134 247.146 107.383C248.203 107.303 249.246 107.272 250.274 107.293C250.28 106.772 250.446 105.673 251.553 104.493C253.084 102.86 256.625 101.745 256.625 101.745C256.625 101.745 255.908 104.904 253.894 106.399C253.21 106.907 252.578 107.206 252.037 107.383C252.338 107.408 252.639 107.436 252.939 107.471C253.217 107.161 254.196 106.236 256.165 105.964C258.542 105.636 261.999 106.89 261.999 106.89C261.999 106.89 259.054 108.855 256.429 108.794C254.891 108.758 253.931 108.347 253.396 108.012C252.825 107.936 252.251 107.877 251.67 107.836C252.256 108.023 252.962 108.363 253.663 108.988C255.327 110.471 256.167 113.668 256.167 113.668C256.167 113.668 252.68 112.764 251.23 110.871C250.071 109.357 250.165 108.183 250.249 107.772C248.772 107.74 247.264 107.818 245.727 108.003C245.294 108.135 244.928 108.196 244.654 108.222C245.437 108.255 246.948 108.492 248.515 109.689C250.782 111.42 252.19 115.385 252.19 115.385C252.19 115.385 247.681 114.536 245.641 112.269C243.63 110.032 244.084 108.286 244.097 108.238C242.041 108.584 239.934 109.12 237.781 109.843C238.721 109.837 240.296 110.027 242.026 111.086C244.8 112.785 246.912 117.065 246.912 117.065C246.912 117.065 241.743 116.588 239.152 114.268C237.086 112.42 236.869 110.759 236.867 110.159C234.989 110.832 233.074 111.644 231.129 112.599C232.172 112.504 233.769 112.573 235.629 113.38C238.951 114.822 242.028 119.147 242.028 119.147C242.028 119.147 236.33 119.364 233.091 117.224C230.659 115.618 230.039 113.959 229.881 113.232C228.251 114.076 226.602 115.015 224.931 116.049C225.945 115.807 227.568 115.641 229.604 116.21C233.14 117.198 236.921 121.062 236.921 121.062C236.921 121.062 231.31 122.022 227.737 120.335C224.936 119.012 224.085 117.374 223.847 116.728C222.326 117.703 220.791 118.759 219.241 119.887C220.237 119.592 221.739 119.365 223.658 119.72C227.295 120.395 231.497 123.904 231.497 123.904C231.497 123.904 226.012 125.346 222.262 123.981C219.411 122.943 218.354 121.452 218.01 120.796C216.519 121.916 215.016 123.103 213.501 124.361C214.512 123.976 216.038 123.624 218.045 123.821C221.93 124.203 226.735 127.496 226.735 127.496C226.735 127.496 221.156 129.488 217.072 128.396C213.933 127.555 212.66 126.069 212.239 125.424C211.177 126.329 210.113 127.263 209.043 128.233C208.815 128.44 208.586 128.649 208.36 128.858C209.366 128.396 210.92 127.927 213.03 128.011C217.045 128.17 222.226 131.255 222.226 131.255C222.226 131.255 216.655 133.626 212.382 132.75C209.037 132.064 207.626 130.574 207.17 129.961C205.766 131.28 204.414 132.6 203.122 133.901C204.154 133.389 205.771 132.853 207.998 132.89C212.191 132.957 217.694 136.045 217.694 136.045C217.694 136.045 211.959 138.653 207.473 137.844C203.991 137.216 202.469 135.719 201.961 135.081C200.202 136.888 198.567 138.646 197.076 140.302C198.187 139.692 199.966 139.018 202.469 138.975C207.101 138.894 212.718 142.377 212.718 142.377C212.718 142.377 207.116 145.184 202.126 144.457C198.248 143.893 196.496 142.295 195.907 141.612C194.152 143.599 192.633 145.404 191.386 146.925C192.465 146.271 194.192 145.536 196.653 145.376C201.277 145.079 207.69 147.979 207.69 147.979C207.69 147.979 201.675 151.352 196.643 150.862C192.736 150.482 190.888 148.974 190.257 148.318C188.543 150.457 187.584 151.764 187.556 151.804L187.1 151.55C187.129 151.511 188.122 150.156 189.892 147.951C189.385 147.64 187.088 146.059 186.43 142.497H186.433Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M196.363 109.052L193.117 98.5217C197.382 94.6642 202.335 90.5124 207.124 86.2488L209.537 94.1923L209.661 83.9632C215.941 78.2247 221.66 72.3447 224.789 66.7607C227.519 77.4601 226.635 89.0325 223.836 99.9752L211.5 109.731L222.628 104.282C219.627 114.132 215.205 123.289 210.668 130.593C200.526 146.919 173.83 148.82 173.83 148.82C173.83 148.82 174.759 119.731 184.395 107.422C186.097 105.248 188.427 102.872 191.126 100.352L196.361 109.057L196.363 109.052Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M25.2622 82.2729C26.2532 82.4803 27.0766 82.7696 27.7622 83.0937C26.6596 82.022 25.6338 80.9398 24.6865 79.8472C24.034 80.2567 22.1743 81.1873 19.3271 80.6976C15.7315 80.079 11.4171 76.3324 11.4171 76.3324C11.4171 76.3324 16.698 74.5376 20.4436 75.9195C21.1415 76.1774 21.7346 76.4684 22.2388 76.7716C21.4084 75.625 20.6617 74.4679 19.9988 73.3003C19.2259 73.6175 17.6244 74.0444 15.4506 73.4293C12.3312 72.5458 8.86996 68.8306 8.86996 68.8306C8.86996 68.8306 13.706 67.7398 16.8864 69.3116C17.5232 69.627 18.05 69.965 18.4862 70.3048C18.0274 69.268 17.6331 68.2259 17.3034 67.1752C16.7032 67.3825 15.386 67.6648 13.6519 67.0288C11.2496 66.1488 8.74609 63.0191 8.74609 63.0191C8.74609 63.0191 12.6156 62.4475 15.0267 63.873C15.8449 64.3574 16.4066 64.8749 16.7974 65.3489C16.7207 65.0335 16.6491 64.7164 16.5846 64.3992C16.1327 64.2441 14.7336 63.6325 13.7409 61.7487C12.5423 59.4764 12.7848 55.458 12.7848 55.458C12.7848 55.458 16.0577 57.6345 16.8934 60.3198C17.3836 61.8916 17.244 63.033 17.0434 63.7126C17.1533 64.3225 17.2842 64.929 17.4377 65.5336C17.4499 64.8627 17.5964 64.0071 18.071 63.04C19.1962 60.745 22.572 58.5807 22.572 58.5807C22.572 58.5807 22.7413 62.4841 21.0717 64.7321C19.7371 66.5287 18.3571 66.9155 17.8564 66.9992C18.3309 68.5065 18.9415 70.0016 19.6865 71.4828C19.9866 71.8662 20.1837 72.213 20.3093 72.4796C20.0755 71.6728 19.8243 70.0435 20.6565 67.9645C21.8585 64.9568 25.9164 61.9021 25.9164 61.9021C25.9164 61.9021 26.5026 66.8179 24.608 69.8169C22.7395 72.7741 20.5797 73.0302 20.5204 73.0372C21.6282 74.9785 22.9698 76.8918 24.5434 78.7773C24.2102 77.8276 23.884 76.1547 24.5016 73.966C25.489 70.4582 29.6673 66.56 29.6673 66.56C29.6673 66.56 30.9077 71.9917 29.144 75.5709C27.7378 78.4236 25.9095 79.3245 25.2238 79.5737C26.6457 81.2012 28.2385 82.8062 30.0058 84.3849C29.5347 83.3655 29.062 81.7223 29.3446 79.5057C29.8488 75.5483 33.7445 70.6534 33.7445 70.6534C33.7445 70.6534 35.9636 76.3359 34.6307 80.4972C33.6293 83.6199 31.9423 84.9304 31.1625 85.3887C32.6925 86.6921 34.3394 87.9781 36.1032 89.245C35.4751 88.3162 34.7267 86.7374 34.6743 84.4442C34.5836 80.4554 37.7082 75.0377 37.7082 75.0377C37.7082 75.0377 40.749 80.3282 40.0494 84.6411C39.5016 88.0217 37.9175 89.5587 37.2581 90.064C38.9015 91.2037 40.6444 92.3276 42.4727 93.4342C41.7923 92.5455 41.0107 91.1183 40.7543 89.0272C40.2693 85.0663 42.8408 79.3663 42.8408 79.3663C42.8408 79.3663 46.3911 84.3309 46.1224 88.6909C45.9183 92.0053 44.5732 93.6903 43.9399 94.3072C45.7386 95.358 47.621 96.3931 49.5854 97.4108C48.7934 96.5464 47.8635 95.1437 47.396 93.0282C46.4905 88.9348 48.6032 82.7138 48.6032 82.7138C48.6032 82.7138 52.8164 87.5477 52.9752 92.1342C53.0973 95.6595 51.8325 97.5606 51.2393 98.2507C52.6437 98.9547 54.0813 99.65 55.5642 100.335C55.8817 100.481 56.1992 100.628 56.5167 100.77C55.6392 99.9427 54.5645 98.5591 53.9312 96.3861C52.7257 92.2527 54.4721 85.7372 54.4721 85.7372C54.4721 85.7372 59.1162 90.4073 59.589 95.0966C59.9588 98.7682 58.7393 100.809 58.1933 101.522C60.1909 102.403 62.171 103.231 64.111 104.005C63.1671 103.168 61.993 101.752 61.2655 99.481C59.8925 95.2047 61.5307 88.3615 61.5307 88.3615C61.5307 88.3615 66.5046 93.1014 67.1274 97.9771C67.6124 101.764 66.4226 103.921 65.866 104.697C68.5457 105.737 71.1278 106.671 73.5423 107.5C72.4571 106.624 71.0702 105.099 70.156 102.581C68.462 97.9213 69.9833 90.301 69.9833 90.301C69.9833 90.301 75.6689 95.3214 76.5622 100.676C77.2565 104.838 76.0301 107.269 75.4509 108.145C78.3347 109.107 80.9307 109.905 83.1062 110.541C81.9844 109.719 80.5434 108.271 79.5106 105.843C77.5688 101.281 78.6784 93.591 78.6784 93.591C78.6784 93.591 84.6257 98.2995 85.8051 103.599C86.721 107.711 85.6306 110.203 85.0968 111.113C88.1411 111.97 89.9729 112.404 90.0287 112.418L89.8962 112.984C89.8403 112.97 87.944 112.522 84.8037 111.635C84.6222 112.279 83.6016 115.253 79.7478 117.384C75.4055 119.784 67.6333 119.477 67.6333 119.477C67.6333 119.477 71.7087 113.082 76.8623 111.364C78.6697 110.761 80.1875 110.599 81.4 110.642C79.5332 110.079 77.4223 109.417 75.1334 108.652C74.9135 109.293 73.7324 112.2 69.7774 114.117C65.3113 116.281 57.567 115.558 57.567 115.558C57.567 115.558 61.9791 109.391 67.2181 107.95C68.9959 107.46 70.4823 107.37 71.6721 107.464C69.7111 106.772 67.6577 106.014 65.5433 105.193C65.2833 105.845 64.0848 108.349 60.5276 109.909C56.4121 111.714 49.4267 110.794 49.4267 110.794C49.4267 110.794 53.6312 105.362 58.4236 104.238C60.0234 103.864 61.3545 103.827 62.4187 103.945C60.9184 103.332 59.3988 102.687 57.8671 102.011C57.5687 102.682 56.3388 104.984 52.956 106.361C48.9644 107.985 42.2948 106.925 42.2948 106.925C42.2948 106.925 46.4643 101.828 51.084 100.873C52.6594 100.547 53.9574 100.554 54.985 100.703C53.5771 100.047 52.2076 99.3851 50.8712 98.7142C50.5642 99.3119 49.2295 101.518 45.8066 102.656C41.8237 103.98 35.4106 102.522 35.4106 102.522C35.4106 102.522 39.7895 97.836 44.3394 97.2034C45.859 96.9925 47.0976 97.0744 48.0764 97.2748C46.5027 96.4401 44.9884 95.5915 43.5229 94.7342C43.1723 95.2778 41.7068 97.2382 38.3659 98.0015C34.472 98.892 28.5299 96.9281 28.5299 96.9281C28.5299 96.9281 33.1059 92.887 37.4744 92.704C38.7724 92.65 39.8384 92.7947 40.7002 93.0247C39.3534 92.1795 38.0536 91.3257 36.8115 90.4613C36.3335 91.0381 34.6778 92.7267 31.4067 93.1414C27.4447 93.6433 21.7259 91.1009 21.7259 91.1009C21.7259 91.1009 26.6806 87.532 31.0456 87.7812C32.1394 87.844 33.0553 88.0304 33.816 88.2744C32.7047 87.4258 31.6457 86.5701 30.6373 85.7058C30.1837 86.131 28.2751 87.7011 24.8208 87.6209C20.8274 87.5286 15.55 84.1654 15.55 84.1654C15.55 84.1654 20.9792 81.372 25.2605 82.2677L25.2622 82.2729Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M54.6247 76.9061L45.2492 77.2146C42.8521 72.5775 40.3399 67.2731 37.7038 62.0837L44.7695 61.8815L36.2837 59.3287C32.7038 52.489 28.9006 46.1042 24.8496 42.0439C34.267 42.2252 43.7244 45.7609 52.2939 50.8126L58.0633 63.8855L55.6453 52.8915C63.2692 57.8597 70.0452 63.8995 75.2563 69.596C86.9085 82.3308 83.4141 106.03 83.4141 106.03C83.4141 106.03 59.3944 98.2667 50.989 86.933C49.5043 84.9307 47.9708 82.3343 46.3884 79.3806L54.623 76.9026L54.6247 76.9061Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M21.2953 122.443C18.6505 126.263 14.3989 125.183 11.9355 124.331C12.8323 123.224 16.7297 118.956 21.2953 122.443Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M20.3202 122.922C20.2365 122.861 20.1737 122.771 20.1458 122.663C20.0864 122.419 20.2365 122.171 20.4807 122.112C27.9895 120.275 36.1472 119.388 44.0729 119.545C50.753 119.677 57.2429 120.551 62.3459 122.007C62.5884 122.075 62.728 122.328 62.6599 122.57C62.5901 122.812 62.3389 122.952 62.0964 122.882C52.9652 120.277 37.2934 118.939 20.6971 122.997C20.561 123.03 20.4249 122.999 20.3202 122.922Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M56.4194 119.019C49.0711 113.18 52.0073 106.945 54.0589 102.101C56.1717 104.058 64.0712 110.299 56.4194 119.019Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M47.5347 117.591C40.654 114.515 41.6903 109.081 42.3149 104.906C44.3491 106.006 51.7392 109.284 47.5347 117.591Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M37.7437 117.983C31.3742 116.796 31.1456 112.048 30.8281 108.434C32.7489 108.944 39.5843 110.197 37.7437 117.983Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M28.34 119.126C24.3326 119.52 23.3731 116.725 22.5566 114.621C23.7918 114.594 28.0888 114.16 28.34 119.126Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M54.8352 123.65C46.7245 125.339 46.5588 131.415 46.25 136.047C48.6942 135.343 57.398 133.557 54.8352 123.65Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M45.1451 122.277C38.0062 122.628 37.0501 127.784 36.1621 131.689C38.3376 131.417 45.9964 131.062 45.1451 122.277Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M33.4968 122.383C28.8753 123.96 29.2243 127.527 29.3813 130.258C30.7578 129.669 35.7194 127.99 33.4968 122.383Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M25.6547 123.004C22.8389 123.415 22.6575 125.494 22.4551 127.076C23.3064 126.885 26.3281 126.454 25.6547 123.004Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M192.002 157.209H62.6503C60.1122 157.209 58.0547 155.154 58.0547 152.619V80.1445L196.596 80.1387V152.619C196.596 155.154 194.538 157.209 192.002 157.209Z","fill":"#FDE68A"}}),_c('path',{attrs:{"d":"M58.0527 80.143L123.811 27.5351C125.865 25.8906 128.787 25.8906 130.841 27.5351L196.596 80.1488L58.0527 80.143Z","fill":"#FBBF24"}}),_c('path',{attrs:{"d":"M58.0527 80.1445L123.707 135.261C125.799 137.017 128.851 137.017 130.943 135.261L196.596 80.1387L127.326 80.1483L58.0527 80.1445Z","fill":"#FCD34D"}}),_c('path',{attrs:{"d":"M123.706 135.261C125.798 137.017 128.85 137.017 130.942 135.261L178.017 95.7383V28.141C178.017 26.9187 177.025 25.9297 175.804 25.9297H78.8447C77.621 25.9297 76.6309 26.9206 76.6309 28.141V95.744L123.706 135.263V135.261Z","fill":"#F5F5F5"}}),_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"mask0_164_6472","maskUnits":"userSpaceOnUse","x":"76","y":"20","width":"103","height":"117"}},[_c('path',{attrs:{"d":"M123.706 135.262C125.798 137.019 128.85 137.019 130.942 135.262L178.017 95.7391V22.7708C178.017 21.5486 177.025 20.5596 175.804 20.5596H78.8447C77.621 20.5596 76.6309 21.5505 76.6309 22.7708V95.7449L123.706 135.264V135.262Z","fill":"white"}})]),_c('g',{attrs:{"mask":"url(#mask0_164_6472)"}},[_c('path',{attrs:{"d":"M121.154 42.4131H84.2773V77.4658H121.154V42.4131Z","fill":"white"}}),_c('path',{attrs:{"d":"M118.825 44.6191H86.5879V75.2628H118.825V44.6191Z","fill":"#BAE6FD"}}),_c('path',{attrs:{"d":"M168.65 45.0732H127.282C127.131 45.0732 127.008 45.1958 127.008 45.347V45.6882C127.008 45.8394 127.131 45.962 127.282 45.962H168.65C168.801 45.962 168.924 45.8394 168.924 45.6882V45.347C168.924 45.1958 168.801 45.0732 168.65 45.0732Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M168.65 49.8799H127.282C127.131 49.8799 127.008 50.0024 127.008 50.1536V50.4949C127.008 50.6461 127.131 50.7686 127.282 50.7686H168.65C168.801 50.7686 168.924 50.6461 168.924 50.4949V50.1536C168.924 50.0024 168.801 49.8799 168.65 49.8799Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M168.65 54.6875H127.282C127.131 54.6875 127.008 54.8101 127.008 54.9613V55.3025C127.008 55.4537 127.131 55.5762 127.282 55.5762H168.65C168.801 55.5762 168.924 55.4537 168.924 55.3025V54.9613C168.924 54.8101 168.801 54.6875 168.65 54.6875Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M168.65 59.4961H127.282C127.131 59.4961 127.008 59.6187 127.008 59.7698V60.1111C127.008 60.2623 127.131 60.3848 127.282 60.3848H168.65C168.801 60.3848 168.924 60.2623 168.924 60.1111V59.7698C168.924 59.6187 168.801 59.4961 168.65 59.4961Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M168.65 64.3018H127.282C127.131 64.3018 127.008 64.4243 127.008 64.5755V64.9168C127.008 65.0679 127.131 65.1905 127.282 65.1905H168.65C168.801 65.1905 168.924 65.0679 168.924 64.9168V64.5755C168.924 64.4243 168.801 64.3018 168.65 64.3018Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M168.65 69.1104H127.282C127.131 69.1104 127.008 69.2329 127.008 69.3841V69.7253C127.008 69.8765 127.131 69.9991 127.282 69.9991H168.65C168.801 69.9991 168.924 69.8765 168.924 69.7253V69.3841C168.924 69.2329 168.801 69.1104 168.65 69.1104Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M155.344 73.918H127.236C127.11 73.918 127.008 74.0198 127.008 74.1455V74.5792C127.008 74.7049 127.11 74.8067 127.236 74.8067H155.344C155.469 74.8067 155.571 74.7049 155.571 74.5792V74.1455C155.571 74.0198 155.469 73.918 155.344 73.918Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M171.621 83.9707H142V112.214H171.621V83.9707Z","fill":"white"}}),_c('path',{attrs:{"d":"M169.769 85.9336H143.875V110.252H169.769V85.9336Z","fill":"#BAE6FD"}}),_c('path',{attrs:{"d":"M130.58 88.0322H87.6491C87.4977 88.0322 87.375 88.1548 87.375 88.306V88.6472C87.375 88.7984 87.4977 88.921 87.6491 88.921H130.58C130.732 88.921 130.854 88.7984 130.854 88.6472V88.306C130.854 88.1548 130.732 88.0322 130.58 88.0322Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M130.58 92.8398H87.6491C87.4977 92.8398 87.375 92.9624 87.375 93.1136V93.4548C87.375 93.606 87.4977 93.7286 87.6491 93.7286H130.58C130.732 93.7286 130.854 93.606 130.854 93.4548V93.1136C130.854 92.9624 130.732 92.8398 130.58 92.8398Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M130.58 97.6465H87.6491C87.4977 97.6465 87.375 97.769 87.375 97.9202V98.2615C87.375 98.4127 87.4977 98.5352 87.6491 98.5352H130.58C130.732 98.5352 130.854 98.4127 130.854 98.2615V97.9202C130.854 97.769 130.732 97.6465 130.58 97.6465Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M130.58 102.455H87.6491C87.4977 102.455 87.375 102.578 87.375 102.729V103.07C87.375 103.221 87.4977 103.344 87.6491 103.344H130.58C130.732 103.344 130.854 103.221 130.854 103.07V102.729C130.854 102.578 130.732 102.455 130.58 102.455Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M130.58 107.263H87.6491C87.4977 107.263 87.375 107.385 87.375 107.536V107.878C87.375 108.029 87.4977 108.151 87.6491 108.151H130.58C130.732 108.151 130.854 108.029 130.854 107.878V107.536C130.854 107.385 130.732 107.263 130.58 107.263Z","fill":"#A3A3A3"}}),_c('g',{attrs:{"clip-path":"url(#clip0_164_6472)"}},[_c('path',{attrs:{"d":"M154.53 104.021C155.169 104.021 155.704 104.465 155.842 105.062C155.957 105.005 156.088 104.973 156.226 104.973C156.665 104.973 157.028 105.299 157.086 105.722H153.232C153.201 105.609 153.184 105.489 153.184 105.366C153.184 104.623 153.786 104.021 154.53 104.021Z","fill":"white"}}),_c('path',{attrs:{"d":"M167.968 103.299L167.549 103.389C167.983 106.169 165.166 110.129 161.756 109.705C158.817 109.339 157.449 106.506 157.083 105.595L156.537 105.71C156.537 105.71 157.888 110.478 162.509 110.371C167.13 110.265 168.63 105.326 167.968 103.299H167.968Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M161.636 110.044C165.266 110.496 168.231 106.301 167.768 103.342L167.406 103.418C167.943 106.189 165.261 110.008 161.817 109.579C158.75 109.197 157.282 106.344 156.999 105.6L156.662 105.67C157.053 106.64 158.508 109.655 161.636 110.044H161.636Z","fill":"white"}}),_c('path',{attrs:{"d":"M161.564 109.663C164.8 110.066 168.155 106.612 167.419 103.413L156.947 105.601C157.213 106.3 158.682 109.305 161.564 109.663Z","fill":"#F43F5E"}}),_c('path',{attrs:{"d":"M162.245 110.128C161.527 110.128 160.982 109.956 160.741 109.863C160.331 109.705 159.567 109.412 158.786 108.769C158.371 108.428 157.991 108.021 157.654 107.56C157.26 107.019 156.915 106.388 156.629 105.684L156.696 105.657C157.936 108.707 159.92 109.47 160.767 109.796C161.086 109.918 161.945 110.182 163.035 109.985C164.2 109.774 165.255 109.114 166.171 108.023C167.258 106.729 167.625 105.526 167.741 104.744C167.867 103.9 167.735 103.356 167.734 103.35L167.804 103.333C167.809 103.356 167.94 103.896 167.812 104.755C167.738 105.258 167.589 105.766 167.369 106.263C167.095 106.885 166.711 107.492 166.226 108.069C165.73 108.66 165.186 109.131 164.608 109.47C164.113 109.761 163.588 109.958 163.048 110.055C162.763 110.107 162.494 110.128 162.246 110.128L162.245 110.128Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M158.482 105.454C158.482 105.454 159.229 105.686 160.943 105.336C160.943 105.336 160.021 105.989 159.62 106.738C159.62 106.738 160.795 106.497 161.514 105.866C161.514 105.866 160.407 107.589 160.66 108.027C160.66 108.027 161.272 107.788 162.127 106.433C162.127 106.433 162.501 108.217 162.95 107.687C163.015 107.611 163.029 105.906 163.029 105.906C163.029 105.906 164.672 107.845 164.925 107.735C165.179 107.626 163.889 105.174 163.889 105.174C163.889 105.174 165.11 106.129 165.536 105.926C165.963 105.723 164.467 104.746 164.467 104.746C164.467 104.746 166.999 104.888 166.916 104.57C166.891 104.474 165.049 104.377 164.542 104.239C164.542 104.239 165.885 103.833 166.071 103.691L158.482 105.454Z","fill":"#FB7185"}}),_c('path',{attrs:{"d":"M164.222 105.05C164.222 105.05 164.266 105.349 164.466 105.311C164.665 105.273 164.538 105.112 164.538 105.112C164.538 105.112 164.195 104.911 164.222 105.05H164.222Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M160.818 106.084C160.818 106.084 160.514 106.297 160.662 106.495C160.81 106.694 160.918 106.465 160.918 106.465C160.918 106.465 160.956 105.978 160.818 106.084Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M162.018 106.625C162.018 106.625 162.169 106.964 161.94 107.057C161.711 107.151 161.735 106.9 161.735 106.9C161.735 106.9 161.955 106.463 162.018 106.625Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M159.798 106.565C159.798 106.565 159.604 106.797 159.766 106.92C159.928 107.043 159.963 106.841 159.963 106.841C159.963 106.841 159.883 106.452 159.798 106.565Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M160.007 105.667C160.007 105.667 159.707 105.627 159.689 105.829C159.67 106.032 159.861 105.954 159.861 105.954C159.861 105.954 160.148 105.679 160.007 105.667V105.667Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M164.478 106.073C164.478 106.073 164.551 106.5 164.835 106.437C165.119 106.375 164.931 106.15 164.931 106.15C164.931 106.15 164.433 105.876 164.477 106.073H164.478Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M165.404 104.904C165.404 104.904 165.617 105.205 165.813 105.053C166.008 104.9 165.781 104.796 165.781 104.796C165.781 104.796 165.297 104.769 165.404 104.904H165.404Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M158.663 105.805C158.663 105.805 158.493 106.02 158.604 106.21C158.716 106.4 158.842 106.117 158.842 106.117C158.842 106.117 158.781 105.771 158.663 105.805Z","fill":"#3C353F"}}),_c('path',{attrs:{"d":"M162.828 105.54C162.828 105.54 162.615 105.713 162.684 105.923C162.752 106.133 162.936 105.883 162.936 105.883C162.936 105.883 162.95 105.532 162.828 105.54Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M163.555 106.288C163.555 106.288 163.424 106.583 163.608 106.766C163.793 106.949 163.851 106.59 163.851 106.59C163.851 106.59 163.678 106.214 163.555 106.288Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M160.883 107.702C160.883 107.702 160.71 107.63 160.833 107.458C160.957 107.286 161.096 107.387 161.096 107.387C161.096 107.387 161.097 107.67 160.883 107.702V107.702Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M162.685 107.116C162.685 107.116 163.151 107.303 162.91 107.633C162.669 107.962 162.578 107.345 162.685 107.116Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M156.992 105.601L157.047 105.849L158.303 105.5L163.138 104.605L167.424 103.413L156.992 105.601Z","fill":"#E11D48"}}),_c('path',{attrs:{"d":"M161.581 99.2188C161.388 98.7708 161.64 98.2592 162.108 98.1454C162.353 98.086 162.667 98.1131 163.025 98.3773C163.894 99.017 164.145 98.2113 164.52 99.09C164.832 99.8231 165.747 99.0423 165.836 100.247C165.925 101.452 163.999 102.53 162.998 101.555C161.997 100.579 162.577 100.31 161.926 99.6945C161.752 99.5307 161.645 99.3685 161.581 99.2188H161.581Z","fill":"#9A3412"}}),_c('path',{attrs:{"d":"M161.185 102.867C161.185 102.867 162.04 101.183 161.757 100.553C161.616 100.238 161.333 100.21 161.175 100.279C161.007 100.352 160.891 100.51 160.857 100.69L160.547 102.283C160.547 102.283 160.514 103.265 161.185 102.867Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M158.897 106.841C159.124 105.787 159.634 104.599 158.87 102.924C158.539 102.198 158.042 102.453 158.022 103.482C157.996 104.823 158.658 107.641 158.658 107.641C158.658 107.641 158.611 107.578 158.897 106.841H158.897Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M158.887 106.883C158.887 106.883 159.209 107.014 159.139 107.213C159.07 107.412 158.925 107.427 158.972 107.817C159.009 108.123 158.684 108.181 158.668 108.281C158.668 108.281 158.503 108.364 158.668 107.955C158.695 107.887 158.534 107.15 158.516 107.028C158.452 106.586 158.887 106.883 158.887 106.883Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M158.205 103.334C158.205 103.334 158.273 103.389 158.887 103.571C160.54 104.063 160.658 105.306 161.719 105.083C163.229 104.766 162.135 103.584 161.675 103.384C161.675 103.384 160.025 102.562 159.25 102.448C158.737 102.372 158.474 102.287 158.23 102.619C158.045 102.871 158.205 103.334 158.205 103.334Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M163.294 104.847C163.294 104.847 164.1 104.405 163.487 103.141C163.218 102.587 161.676 102.893 161.676 102.893C161.676 102.893 161.398 103.14 161.35 103.228C161.352 103.228 161.66 103.476 161.801 104.205C161.801 104.205 162.393 103.809 163.294 104.847Z","fill":"#80E9F2"}}),_c('path',{attrs:{"d":"M159.146 104.375C159.146 104.375 159.095 104.238 159.68 104.498C160.237 104.746 162.065 105.611 163.007 105.074C164.286 104.344 163.162 103.568 162.664 103.504C162.664 103.504 160.973 103.333 160.197 103.441C159.683 103.512 159.468 103.436 159.327 103.823C159.22 104.116 159.146 104.375 159.146 104.375Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M163.485 100.498C163.613 100.771 163.797 100.778 163.495 103.141C163.577 103.154 161.674 102.918 161.681 102.893C161.681 102.893 161.529 102.189 161.489 102.091C161.489 102.091 161.295 102.041 161.215 101.721C161.215 101.721 161.252 101.586 161.358 101.342C161.379 101.294 161.342 101.002 161.37 100.96L161.335 100.301C161.707 100.226 161.77 100.178 162.195 100.053L163.485 100.498Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M155.945 107.323C155.945 107.323 155.903 107.353 155.868 107.321C155.842 107.298 155.882 107.279 155.897 107.275C155.912 107.271 155.919 107.272 155.919 107.272C155.919 107.272 155.969 107.304 155.945 107.323H155.945Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M155.961 107.399C155.961 107.399 155.975 107.398 155.985 107.416C155.999 107.441 155.961 107.444 155.948 107.439C155.942 107.436 155.912 107.421 155.961 107.399H155.961Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M155.949 107.387C155.949 107.387 155.996 107.361 156.018 107.356C156.039 107.352 156.036 107.342 156.029 107.337C156.022 107.333 155.928 107.389 155.928 107.389L155.949 107.387L155.949 107.387Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M155.971 107.465C155.971 107.465 156.059 107.394 156.078 107.396C156.098 107.397 156.076 107.405 156.076 107.405C156.076 107.405 156.016 107.432 155.978 107.466C155.977 107.466 155.97 107.466 155.971 107.465Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M156.02 107.498C156.02 107.498 156.055 107.483 156.077 107.453C156.097 107.427 156.109 107.439 156.109 107.439C156.109 107.439 156.09 107.45 156.075 107.466C156.056 107.485 156.026 107.503 156.026 107.503L156.02 107.499V107.498Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M156.068 107.522C156.068 107.522 156.089 107.515 156.107 107.488C156.125 107.46 156.141 107.467 156.141 107.467C156.141 107.467 156.128 107.484 156.112 107.499C156.096 107.513 156.078 107.524 156.078 107.524L156.069 107.522L156.068 107.522Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M156.98 106.446C156.98 106.446 156.476 106.796 156.22 107.051C156.041 107.229 155.954 107.263 155.918 107.268C155.898 107.27 155.868 107.28 155.854 107.293C155.828 107.318 155.808 107.353 155.83 107.371C155.865 107.401 155.952 107.387 155.952 107.387C155.952 107.387 155.861 107.43 155.943 107.462C155.961 107.469 155.978 107.466 155.978 107.466C155.978 107.466 156.086 107.582 156.192 107.499C156.192 107.499 156.254 107.493 156.29 107.472C156.326 107.45 156.648 107.165 156.999 107.157C156.999 107.157 157.175 107.175 157.198 106.785C157.213 106.538 156.98 106.447 156.98 106.447L156.98 106.446Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M157.347 106.797C158.261 106.223 159.379 106.212 159.921 104.149C160.084 103.529 159.716 103.375 159.066 104.026L156.653 106.83C156.653 106.83 156.357 107.185 157.346 106.797H157.347Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M161.04 101.13C161.043 101.157 160.884 101.2 160.685 101.226C160.485 101.252 160.32 101.251 160.316 101.223C160.313 101.196 160.472 101.153 160.672 101.127C160.871 101.101 161.036 101.102 161.04 101.13Z","fill":"#F4EADE"}}),_c('path',{attrs:{"d":"M160.654 101.17C160.639 100.992 160.467 100.871 160.29 100.899C160.249 100.905 160.193 100.922 160.149 100.948C159.907 101.093 159.989 101.482 160.24 101.533C160.479 101.582 160.627 101.48 160.654 101.225C160.656 101.206 160.656 101.188 160.654 101.17V101.17Z","fill":"#FFBF00"}}),_c('path',{attrs:{"d":"M160.314 101.2L160.264 100.961C160.264 100.961 160.403 100.936 160.48 101L160.346 101.205C160.346 101.205 160.332 101.231 160.314 101.2H160.314Z","fill":"#FFBF00"}}),_c('path',{attrs:{"d":"M160.317 101.22L160.315 101.214L160.239 100.972C160.239 100.957 160.113 100.991 160.066 101.156L160.317 101.22H160.317Z","fill":"#FFBF00"}}),_c('path',{attrs:{"d":"M160.327 101.221L160.068 101.18C160.068 101.18 160.047 101.282 160.106 101.366L160.327 101.221V101.221Z","fill":"#FFBF00"}}),_c('path',{attrs:{"d":"M160.117 101.383C160.117 101.383 160.164 101.458 160.318 101.489L160.333 101.219L160.117 101.383H160.117Z","fill":"#FFBF00"}}),_c('path',{attrs:{"d":"M160.338 101.222L160.336 101.487C160.336 101.487 160.468 101.514 160.543 101.379L160.338 101.222H160.338Z","fill":"#FFBF00"}}),_c('path',{attrs:{"d":"M160.348 101.215L160.502 101.013C160.502 101.013 160.603 101.078 160.598 101.188L160.348 101.215H160.348Z","fill":"#FFBF00"}}),_c('path',{attrs:{"d":"M160.348 101.221L160.6 101.203C160.6 101.203 160.612 101.287 160.552 101.371L160.348 101.221V101.221Z","fill":"#FFBF00"}}),_c('path',{attrs:{"d":"M160.807 102.53L160.909 102.517V102.532C160.91 102.615 160.919 102.696 160.936 102.777L160.953 102.859L160.851 102.872L160.848 102.798C160.844 102.708 160.83 102.618 160.807 102.53Z","fill":"#E5E5E5"}}),_c('path',{attrs:{"d":"M161.009 102.395C161.022 102.497 160.959 102.589 160.868 102.601C160.777 102.613 160.693 102.539 160.679 102.437C160.666 102.335 160.729 102.242 160.82 102.231C160.911 102.219 160.996 102.292 161.009 102.395Z","fill":"#E5E5E5"}}),_c('path',{attrs:{"d":"M161.123 101.811C160.912 101.471 161.039 101.13 161.039 101.13L160.677 101.18L160.314 101.223C160.314 101.223 160.521 101.531 160.407 101.922C160.307 102.267 160.544 102.59 160.851 102.522C161.165 102.509 161.313 102.116 161.123 101.811L161.123 101.811Z","fill":"#E5E5E5"}}),_c('path',{attrs:{"d":"M160.967 101.479C160.961 101.409 160.96 101.325 160.966 101.22C160.815 101.28 160.559 101.314 160.398 101.296C160.439 101.394 160.462 101.475 160.474 101.544C160.555 101.55 160.728 101.548 160.967 101.479Z","fill":"#E5E5E5"}}),_c('path',{attrs:{"d":"M161.064 101.792C161.059 101.794 161.06 101.794 161.064 101.792V101.792Z","fill":"#FB923C"}}),_c('path',{attrs:{"d":"M160.436 102.192C160.752 102.335 160.894 102.159 161.173 102.089C161.173 102.078 161.173 102.068 161.172 102.057C161.159 101.943 161.122 101.883 161.082 101.82C161.037 101.81 160.944 101.814 160.786 101.924C160.578 102.068 160.458 101.992 160.431 101.97C160.422 102.024 160.418 102.082 160.428 102.153C160.43 102.167 160.433 102.179 160.436 102.192Z","fill":"#FB923C"}}),_c('path',{attrs:{"d":"M160.848 102.475C160.848 102.475 160.849 102.475 160.849 102.475H160.85C160.867 102.472 161.191 102.416 161.174 102.089C160.895 102.159 160.756 102.326 160.438 102.193C160.509 102.505 160.83 102.477 160.848 102.476V102.475Z","fill":"#FB923C"}}),_c('path',{attrs:{"d":"M161.141 102.805C161.136 102.767 161.023 102.749 160.889 102.766C160.754 102.784 160.649 102.829 160.654 102.868C160.66 102.907 160.772 102.924 160.907 102.907C161.041 102.89 161.146 102.844 161.141 102.805Z","fill":"#E5E5E5"}}),_c('path',{attrs:{"d":"M160.99 101.145C160.972 101.166 160.884 101.201 160.684 101.226C160.485 101.252 160.335 101.227 160.363 101.223C160.501 101.2 160.54 101.203 160.656 101.179C160.659 101.178 160.656 101.155 160.666 101.153C160.803 101.136 161.008 101.124 160.99 101.145L160.99 101.145Z","fill":"#F4EADE"}}),_c('path',{attrs:{"d":"M160.759 101.769C160.866 101.683 160.889 101.588 160.974 101.54C160.971 101.521 160.969 101.501 160.967 101.48C160.961 101.41 160.96 101.326 160.966 101.221C160.815 101.281 160.559 101.315 160.398 101.297C160.439 101.395 160.462 101.476 160.474 101.545C160.493 101.657 160.482 101.739 160.466 101.815C160.543 101.851 160.645 101.86 160.759 101.769L160.759 101.769Z","fill":"#F4EADE"}}),_c('path',{attrs:{"d":"M161.066 101.793C161.061 101.795 161.062 101.795 161.066 101.793V101.793Z","fill":"#FDBB1F"}}),_c('path',{attrs:{"d":"M160.432 101.971C160.459 101.994 160.579 102.07 160.787 101.926C160.945 101.816 161.038 101.812 161.083 101.821C161.077 101.812 161.071 101.803 161.065 101.794C161.061 101.796 161.061 101.796 161.065 101.794C161.029 101.734 160.993 101.664 160.974 101.54C160.89 101.588 160.866 101.684 160.759 101.77C160.646 101.861 160.544 101.851 160.467 101.815C160.461 101.842 160.454 101.868 160.448 101.895C160.442 101.92 160.436 101.945 160.432 101.971Z","fill":"#FB923C"}}),_c('path',{attrs:{"d":"M161.173 100.624L160.819 100.726H160.819H160.818L160.819 100.727L160.803 101.208C160.803 101.208 160.827 101.213 160.858 101.194L160.869 100.765L161.17 100.681C161.187 100.681 161.2 100.667 161.2 100.651C161.199 100.636 161.187 100.624 161.172 100.624H161.173Z","fill":"#AEF9FC"}}),_c('path',{attrs:{"d":"M160.807 101.273L160.795 101.728L160.84 101.681L160.863 101.26L160.807 101.273Z","fill":"#AEF9FC"}}),_c('path',{attrs:{"d":"M160.675 102.846C160.661 102.842 160.611 102.954 160.951 102.902C160.972 102.884 160.673 102.933 160.675 102.846Z","fill":"#F4EADE"}}),_c('path',{attrs:{"d":"M160.828 102.819C160.828 102.819 160.784 102.859 160.935 102.83C160.933 102.837 160.879 102.862 160.812 102.849C160.812 102.849 160.787 102.831 160.828 102.819Z","fill":"#F4EADE"}}),_c('path',{attrs:{"d":"M160.253 101.606C160.253 101.606 160.203 101.744 160.378 101.877C160.554 102.011 160.526 102.15 160.526 102.15L160.785 102.216C160.785 102.216 160.78 101.966 160.556 101.824C160.332 101.682 160.334 101.64 160.334 101.64C160.334 101.64 160.277 101.523 160.253 101.606H160.253Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M160.248 102.171C160.248 102.171 160.215 102.148 160.211 102.11C160.207 102.071 160.259 102.035 160.259 102.035L160.658 102.03C160.658 102.03 160.809 102.007 160.825 102.056C160.841 102.105 160.788 102.111 160.788 102.111C160.788 102.111 160.659 102.151 160.531 102.16C160.403 102.168 160.248 102.171 160.248 102.171Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M160.273 102.314C160.273 102.314 160.23 102.285 160.229 102.23C160.227 102.175 160.269 102.178 160.269 102.178L160.671 102.165C160.671 102.165 160.806 102.147 160.815 102.2C160.825 102.253 160.752 102.266 160.752 102.266L160.432 102.311L160.273 102.314V102.314Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M160.658 102.413L160.338 102.43C160.338 102.43 160.309 102.433 160.285 102.411C160.26 102.389 160.277 102.309 160.277 102.309C160.277 102.309 160.47 102.29 160.589 102.31C160.639 102.318 160.72 102.308 160.729 102.348C160.739 102.388 160.657 102.413 160.657 102.413H160.658Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M160.303 102.035C160.303 102.035 160.223 102.031 160.276 101.911C160.276 101.911 160.701 101.8 160.796 101.867C160.796 101.867 160.799 101.872 160.79 101.894C160.781 101.916 160.473 102.007 160.473 102.007L160.303 102.035V102.035Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M162.188 99.7161C163.001 99.6179 163.173 99.0753 163.087 98.7188C162.996 98.3396 162.615 98.1565 162.228 98.2147C161.843 98.273 161.637 98.5126 161.695 98.8982C161.754 99.2837 161.8 99.7627 162.188 99.7159L162.188 99.7161Z","fill":"#9A3412"}}),_c('path',{attrs:{"d":"M163.015 100.189C163.015 100.189 162.702 100.257 162.606 99.867C162.51 99.477 162.539 99.3154 162.539 99.3154L161.908 99.5326L162.003 100.569C162.003 100.569 162.485 100.887 163.015 100.189H163.015Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M162.383 99.6741C162.383 99.6741 162.112 99.9733 161.779 99.8553C161.695 99.8052 161.507 99.4473 161.627 99.0413C161.788 98.4957 161.96 98.2976 162.242 98.3836C162.465 98.4517 162.79 98.7214 162.655 99.1452C162.655 99.1452 162.484 99.5299 162.383 99.6741Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M162.541 98.5073C162.535 98.5227 162.51 98.5768 162.598 98.8166C162.678 99.0305 162.623 99.227 162.629 99.2248C162.793 99.1586 162.935 98.6843 162.597 98.435C162.59 98.4299 162.554 98.4721 162.541 98.5073H162.541Z","fill":"#9A3412"}}),_c('path',{attrs:{"d":"M161.658 98.8621C161.658 98.8621 161.831 98.6034 162.026 98.5491C162.244 98.4882 162.437 98.59 162.56 98.5451C162.575 98.5394 162.645 98.459 162.607 98.4187C162.528 98.335 162.234 98.2578 162.234 98.2578C162.127 98.2714 161.676 98.2626 161.658 98.8621H161.658Z","fill":"#9A3412"}}),_c('path',{attrs:{"d":"M162.06 98.9807C162.027 98.9422 161.983 98.9604 161.982 98.9606L161.984 98.9262C162.007 98.916 162.047 98.9097 162.088 98.9567L162.06 98.9807H162.06Z","fill":"#F26226"}}),_c('path',{attrs:{"d":"M162.672 99.178L162.434 99.0943L162.462 99.0283L162.703 99.1044L162.672 99.178Z","fill":"white"}}),_c('path',{attrs:{"d":"M162.642 99.0166C162.642 99.0166 162.651 99.0753 162.63 99.1969C162.594 99.4017 162.583 99.318 162.742 99.4521L162.838 99.3512C162.841 99.3536 162.724 99.5354 162.725 99.5316C162.747 99.4562 163.014 99.0711 162.642 99.0166H162.642Z","fill":"#9A3412"}}),_c('path',{attrs:{"d":"M162.506 99.2876C162.506 99.2876 162.659 99.0757 162.775 99.2026C162.891 99.3294 162.456 99.7209 162.473 99.4804C162.49 99.2399 162.506 99.2876 162.506 99.2876H162.506Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M165.217 102.137C165.217 102.137 164.177 100.126 163.491 100.023C162.947 99.9407 162.672 100.431 162.672 100.431L164.467 102.291C164.467 102.291 165.056 103.195 166.461 103.741C166.704 103.836 165.292 102.58 165.217 102.137H165.217Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M165.029 102.01C165.029 102.01 165.301 102.099 165.579 102.394C165.856 102.688 166.688 103.58 166.688 103.58L166.46 103.772C166.46 103.772 165.567 103.312 164.665 102.479C164.665 102.479 164.576 101.866 165.029 102.01V102.01Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M166.483 103.442C166.483 103.442 166.813 103.43 167.032 103.473C167.192 103.504 167.445 103.536 167.645 103.522C167.789 103.512 167.608 103.634 167.31 103.621L167.034 103.674L167.619 103.639C167.619 103.639 167.701 103.721 167.403 103.746C167.358 103.75 167.287 103.796 167.086 103.82C166.886 103.843 166.745 103.848 166.745 103.848C166.745 103.848 167.003 104.063 166.973 104.152C166.973 104.152 166.918 104.305 166.901 104.222C166.861 104.019 166.567 104.113 166.406 103.804C166.249 103.505 166.483 103.442 166.483 103.442L166.483 103.442Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M167.27 103.508C167.27 103.508 167.368 103.534 167.45 103.481C167.45 103.481 167.586 103.484 167.615 103.397L167.44 103.406L167.287 103.425L167.27 103.508H167.27Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M166.998 103.48C166.998 103.48 167.249 103.411 167.296 103.425C167.343 103.439 167.296 103.508 167.296 103.508L167.095 103.561L166.998 103.48V103.48Z","fill":"#FED7AA"}}),_c('path',{attrs:{"d":"M161.647 98.8174L161.635 98.8183C161.635 98.8183 161.717 98.1501 162.332 98.2628C162.906 98.3681 162.859 98.9955 162.709 99.2204L162.653 99.1804C162.653 99.1804 162.81 98.5776 162.404 98.4297C161.984 98.2762 161.757 98.5347 161.647 98.8174H161.647Z","fill":"#80E9F2"}}),_c('path',{attrs:{"d":"M162.573 98.4484C162.573 98.4484 163.117 98.5158 163.304 98.3013C163.304 98.3013 162.904 98.0709 162.619 98.3213C162.619 98.3213 162.636 97.9144 162.345 97.7432C162.345 97.7432 162.2 98.2474 162.615 98.4664L162.573 98.4484Z","fill":"#80E9F2"}}),_c('path',{attrs:{"d":"M161.497 98.7535L161.556 98.7707C161.576 98.7762 161.596 98.7731 161.613 98.763C161.663 98.7337 161.725 98.7225 161.786 98.7364C161.87 98.7553 161.941 98.8096 161.971 98.8801C161.978 98.8975 161.994 98.9102 162.012 98.9155L162.087 98.9375C162.09 98.9382 162.093 98.9388 162.095 98.9393C162.104 98.9406 162.113 98.9404 162.122 98.9379C162.128 98.9362 162.135 98.9333 162.141 98.9292C162.172 98.9072 162.21 98.8942 162.25 98.8902C162.26 98.8894 162.27 98.8889 162.281 98.8889C162.301 98.8891 162.322 98.8918 162.342 98.8964C162.342 98.8964 162.343 98.8964 162.343 98.8968C162.353 98.8993 162.364 98.9023 162.374 98.9059C162.4 98.9151 162.423 98.9283 162.444 98.9445C162.446 98.947 162.449 98.9492 162.452 98.9518C162.474 98.9714 162.493 98.9947 162.506 99.0204C162.515 99.0382 162.531 99.0518 162.55 99.0573L162.609 99.0745C162.612 99.0753 162.614 99.0769 162.616 99.0791C162.617 99.0804 162.618 99.0821 162.619 99.0839C162.62 99.0865 162.62 99.0894 162.619 99.0923L162.605 99.14C162.604 99.1428 162.602 99.1455 162.6 99.1472C162.598 99.149 162.595 99.1501 162.592 99.1503C162.575 99.1512 162.561 99.1551 162.551 99.1617C162.549 99.1626 162.548 99.1637 162.546 99.1648C162.537 99.171 162.53 99.1789 162.524 99.1879L162.524 99.1872C162.522 99.1925 162.521 99.198 162.519 99.2033C162.476 99.3237 162.342 99.3864 162.219 99.3429C162.215 99.3415 162.212 99.3402 162.208 99.3389C162.201 99.336 162.195 99.3327 162.188 99.3292C162.178 99.324 162.169 99.3178 162.16 99.311C162.155 99.3072 162.15 99.3031 162.145 99.2989C162.144 99.2974 162.142 99.2956 162.14 99.2938C162.135 99.2897 162.131 99.2853 162.127 99.2807C162.123 99.2767 162.12 99.2727 162.117 99.2686C162.113 99.2639 162.109 99.2591 162.106 99.2543C162.101 99.2481 162.097 99.2417 162.094 99.2351C162.061 99.1798 162.048 99.1127 162.061 99.0512C162.062 99.047 162.06 99.043 162.057 99.0404C162.057 99.0399 162.056 99.0395 162.056 99.0393C162.055 99.0391 162.054 99.0386 162.054 99.0386L161.986 99.0191C161.98 99.0175 161.975 99.0206 161.973 99.0257C161.932 99.1364 161.802 99.2149 161.684 99.1883C161.557 99.1597 161.476 99.0353 161.505 98.9105C161.506 98.905 161.507 98.8995 161.509 98.8942H161.508C161.508 98.8694 161.499 98.8461 161.471 98.8265C161.466 98.823 161.464 98.8168 161.465 98.8109L161.479 98.7632C161.481 98.7557 161.489 98.7513 161.497 98.7535H161.497Z","fill":"white"}}),_c('path',{attrs:{"d":"M162.456 99.186C162.493 99.0924 162.446 98.9856 162.351 98.9475C162.256 98.9094 162.148 98.9545 162.111 99.0482C162.073 99.1418 162.12 99.2486 162.215 99.2867C162.311 99.3248 162.418 99.2797 162.456 99.186Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M161.931 98.9976C161.95 98.8984 161.883 98.8029 161.782 98.7845C161.681 98.766 161.584 98.8314 161.566 98.9307C161.548 99.0299 161.615 99.1253 161.716 99.1438C161.817 99.1623 161.913 99.0968 161.931 98.9976Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M161.617 98.9233C161.61 98.9365 161.604 98.9772 161.611 99.0063C161.611 99.0074 161.611 99.0084 161.61 99.0089L161.603 99.011C161.603 99.011 161.601 99.011 161.6 99.01C161.596 98.9993 161.574 98.9465 161.601 98.8936C161.602 98.8917 161.618 98.9216 161.617 98.9235L161.617 98.9233Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M161.608 99.0251C161.609 99.0285 161.614 99.0364 161.617 99.0353L161.622 99.0327C161.623 99.0321 161.623 99.0307 161.622 99.0295L161.618 99.0219C161.617 99.0207 161.616 99.0201 161.615 99.0207L161.609 99.0217C161.607 99.0221 161.607 99.0237 161.608 99.0251H161.608Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M162.156 99.0854C162.149 99.0986 162.143 99.1394 162.15 99.1684C162.15 99.1695 162.15 99.1705 162.149 99.171L162.142 99.1731C162.142 99.1731 162.14 99.1731 162.139 99.1721C162.135 99.1614 162.113 99.1086 162.14 99.0558C162.141 99.0538 162.157 99.0837 162.156 99.0856L162.156 99.0854Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M162.147 99.1872C162.148 99.1906 162.153 99.1986 162.156 99.1974L162.161 99.1948C162.162 99.1942 162.162 99.1928 162.161 99.1916L162.157 99.184C162.156 99.1829 162.155 99.1823 162.154 99.1829L162.148 99.1838C162.146 99.1842 162.146 99.1858 162.147 99.1872H162.147Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M163.645 101.81L163.594 102.29L161.525 102.238L161.491 102.143C161.491 102.143 161.151 101.963 161.203 101.646L161.359 101.323C161.359 101.323 161.682 101.26 162.122 101.709C162.152 101.739 162.535 100.642 163.645 101.81L163.645 101.81Z","fill":"#80E9F2"}}),_c('path',{attrs:{"d":"M144.833 110.047C144.743 110.262 144.523 110.254 144.393 110.238C144.425 110.174 144.572 109.923 144.833 110.047Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M144.791 110.08C144.786 110.078 144.782 110.074 144.78 110.069C144.774 110.058 144.779 110.044 144.79 110.039C145.14 109.869 145.533 109.74 145.924 109.664C146.255 109.601 146.583 109.576 146.85 109.594C146.863 109.594 146.872 109.605 146.871 109.618C146.87 109.631 146.859 109.64 146.847 109.639C146.37 109.607 145.584 109.706 144.81 110.08C144.804 110.083 144.797 110.083 144.791 110.08V110.08Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M146.526 109.509C146.103 109.298 146.182 108.96 146.232 108.7C146.357 108.774 146.811 108.999 146.526 109.509Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M146.074 109.532C145.703 109.453 145.697 109.174 145.684 108.962C145.795 108.995 146.193 109.078 146.074 109.532Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M145.597 109.654C145.271 109.662 145.21 109.431 145.156 109.256C145.256 109.261 145.606 109.251 145.597 109.654Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M145.145 109.809C144.952 109.871 144.875 109.743 144.812 109.648C144.873 109.634 145.08 109.567 145.145 109.809Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M146.498 109.753C146.116 109.921 146.172 110.222 146.206 110.454C146.318 110.393 146.728 110.214 146.498 109.753Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M146.005 109.788C145.657 109.88 145.665 110.144 145.662 110.346C145.766 110.31 146.14 110.212 146.005 109.788Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M145.434 109.915C145.223 110.041 145.277 110.213 145.314 110.346C145.376 110.303 145.602 110.168 145.434 109.915Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M145.054 110.028C144.92 110.078 144.933 110.182 144.939 110.262C144.979 110.244 145.123 110.191 145.054 110.028Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M144.83 106.552C144.886 106.592 144.929 106.632 144.963 106.67C144.923 106.574 144.889 106.48 144.859 106.387C144.808 106.395 144.668 106.403 144.505 106.296C144.299 106.162 144.133 105.815 144.133 105.815C144.133 105.815 144.507 105.845 144.702 106.03C144.738 106.065 144.767 106.099 144.79 106.131C144.77 106.038 144.754 105.946 144.745 105.857C144.688 105.855 144.578 105.839 144.46 105.743C144.291 105.605 144.176 105.282 144.176 105.282C144.176 105.282 144.505 105.344 144.659 105.526C144.69 105.563 144.714 105.598 144.732 105.631C144.731 105.554 144.735 105.479 144.742 105.405C144.7 105.402 144.611 105.384 144.52 105.299C144.395 105.18 144.324 104.919 144.324 104.919C144.324 104.919 144.579 104.988 144.69 105.14C144.728 105.192 144.748 105.239 144.76 105.279C144.764 105.257 144.768 105.236 144.772 105.214C144.748 105.193 144.678 105.117 144.667 104.974C144.654 104.802 144.777 104.56 144.777 104.56C144.777 104.56 144.921 104.782 144.9 104.97C144.889 105.081 144.849 105.148 144.819 105.184C144.809 105.225 144.801 105.266 144.794 105.307C144.813 105.266 144.845 105.217 144.9 105.17C145.031 105.058 145.298 105.014 145.298 105.014C145.298 105.014 145.204 105.261 145.04 105.355C144.91 105.43 144.814 105.418 144.781 105.409C144.77 105.515 144.767 105.624 144.774 105.736C144.782 105.768 144.785 105.794 144.786 105.814C144.793 105.758 144.821 105.65 144.928 105.544C145.083 105.39 145.416 105.309 145.416 105.309C145.416 105.309 145.32 105.629 145.123 105.764C144.928 105.897 144.788 105.855 144.784 105.854C144.801 106.004 144.832 106.158 144.879 106.317C144.884 106.249 144.909 106.137 145.005 106.018C145.16 105.827 145.523 105.697 145.523 105.697C145.523 105.697 145.455 106.067 145.25 106.241C145.086 106.38 144.949 106.387 144.9 106.384C144.944 106.523 145 106.664 145.067 106.809C145.065 106.734 145.08 106.62 145.156 106.49C145.294 106.258 145.666 106.06 145.666 106.06C145.666 106.06 145.651 106.471 145.457 106.693C145.312 106.859 145.172 106.895 145.111 106.902C145.171 107.024 145.239 107.148 145.314 107.273C145.3 107.199 145.295 107.081 145.354 106.938C145.455 106.689 145.793 106.437 145.793 106.437C145.793 106.437 145.84 106.846 145.681 107.094C145.556 107.288 145.417 107.341 145.363 107.355C145.434 107.469 145.512 107.585 145.595 107.703C145.577 107.629 145.567 107.52 145.607 107.384C145.683 107.126 145.995 106.842 145.995 106.842C145.995 106.842 146.082 107.244 145.948 107.507C145.847 107.706 145.719 107.775 145.663 107.796C145.746 107.909 145.835 108.024 145.929 108.139C145.903 108.064 145.883 107.953 145.911 107.809C145.965 107.532 146.262 107.203 146.262 107.203C146.262 107.203 146.393 107.615 146.28 107.903C146.193 108.125 146.064 108.208 146.009 108.235C146.077 108.317 146.147 108.398 146.22 108.48C146.236 108.498 146.252 108.515 146.268 108.533C146.236 108.458 146.206 108.344 146.225 108.192C146.261 107.904 146.544 107.548 146.544 107.548C146.544 107.548 146.706 107.961 146.61 108.264C146.534 108.501 146.404 108.594 146.351 108.624C146.451 108.732 146.552 108.836 146.651 108.936C146.615 108.859 146.58 108.74 146.596 108.58C146.626 108.279 146.91 107.899 146.91 107.899C146.91 107.899 147.091 108.325 146.999 108.643C146.927 108.891 146.796 108.992 146.741 109.025C146.879 109.161 147.013 109.288 147.14 109.404C147.097 109.321 147.052 109.189 147.063 109.009C147.083 108.675 147.381 108.244 147.381 108.244C147.381 108.244 147.598 108.707 147.51 109.062C147.441 109.338 147.3 109.456 147.241 109.495C147.394 109.631 147.533 109.75 147.65 109.848C147.603 109.767 147.552 109.639 147.554 109.461C147.556 109.127 147.83 108.68 147.83 108.68C147.83 108.68 148.072 109.131 148.003 109.49C147.949 109.769 147.815 109.894 147.758 109.936C147.923 110.071 148.025 110.147 148.028 110.149L148.005 110.18C148.002 110.178 147.896 110.099 147.726 109.961C147.697 109.996 147.555 110.152 147.259 110.181C146.926 110.214 146.454 109.987 146.454 109.987C146.454 109.987 146.877 109.7 147.242 109.731C147.37 109.742 147.468 109.773 147.542 109.808C147.442 109.723 147.329 109.626 147.208 109.517C147.177 109.551 147.026 109.7 146.73 109.712C146.396 109.727 145.936 109.475 145.936 109.475C145.936 109.475 146.374 109.211 146.737 109.262C146.86 109.28 146.954 109.314 147.026 109.352C146.923 109.256 146.816 109.155 146.707 109.047C146.674 109.08 146.533 109.203 146.271 109.205C145.968 109.207 145.561 108.963 145.561 108.963C145.561 108.963 145.966 108.74 146.293 108.798C146.402 108.818 146.485 108.851 146.547 108.887C146.471 108.809 146.394 108.728 146.318 108.645C146.282 108.679 146.144 108.788 145.898 108.783C145.607 108.777 145.223 108.533 145.223 108.533C145.223 108.533 145.618 108.329 145.929 108.394C146.035 108.416 146.115 108.451 146.175 108.487C146.105 108.409 146.038 108.332 145.974 108.254C145.939 108.283 145.797 108.384 145.555 108.363C145.273 108.338 144.915 108.077 144.915 108.077C144.915 108.077 145.312 107.904 145.61 107.986C145.71 108.014 145.784 108.052 145.839 108.091C145.764 107.997 145.693 107.904 145.626 107.812C145.589 107.836 145.446 107.918 145.219 107.876C144.955 107.827 144.64 107.547 144.64 107.547C144.64 107.547 145.031 107.419 145.306 107.525C145.388 107.556 145.45 107.593 145.497 107.631C145.436 107.542 145.379 107.455 145.325 107.368C145.28 107.391 145.132 107.451 144.919 107.389C144.66 107.314 144.375 107.004 144.375 107.004C144.375 107.004 144.777 106.916 145.04 107.048C145.106 107.081 145.158 107.117 145.198 107.153C145.152 107.07 145.11 106.989 145.07 106.909C145.031 106.923 144.871 106.969 144.659 106.872C144.415 106.759 144.179 106.41 144.179 106.41C144.179 106.41 144.589 106.382 144.83 106.552L144.83 106.552Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M147.252 107.506L146.689 107.219C146.699 106.868 146.724 106.473 146.737 106.081L147.161 106.299L146.743 105.872C146.755 105.352 146.739 104.851 146.633 104.479C147.182 104.797 147.625 105.314 147.966 105.891L147.879 106.85L148.095 106.122C148.383 106.664 148.586 107.241 148.707 107.747C148.979 108.878 148 110.163 148 110.163C148 110.163 146.836 108.923 146.71 107.98C146.688 107.814 146.683 107.61 146.685 107.384L147.252 107.506Z","fill":"#ABE532"}}),_c('path',{attrs:{"d":"M154.424 102.787C154.21 102.623 153.477 102.557 153.266 102.748C153.123 102.876 152.998 103.939 152.931 104.618C152.897 104.967 152.671 105.267 152.345 105.397L151.955 105.553C151.944 106.053 151.933 106.584 151.924 107.082C152.409 107.023 153.689 106.833 153.953 106.45C154.28 105.976 154.736 103.564 154.736 103.564C154.736 103.564 154.637 102.951 154.424 102.787L154.424 102.787Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M150.845 109.731C151.105 109.8 151.201 110 151.567 110.021C151.715 110.03 151.918 109.965 152.114 109.883C152.054 109.711 151.951 109.394 151.916 109.181C151.867 108.874 151.996 103.607 152.018 103.394C152.04 103.182 152.724 99.564 152.697 98.974C152.669 98.3838 152.074 97.8212 151.789 97.5399C151.503 97.2585 150.771 97.3108 150.583 97.4064C150.395 97.5023 149.696 99.0892 149.488 99.7517C149.28 100.414 148.901 103.699 148.91 105.022C148.918 106.192 149.696 109.055 149.875 109.7C150.292 109.69 150.711 109.696 150.845 109.731V109.731Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M154.306 104.71L154.307 104.7C154.335 104.482 154.358 104.264 154.381 104.046C154.403 103.828 154.428 103.61 154.44 103.39C154.444 103.335 154.447 103.28 154.448 103.224C154.451 103.169 154.445 103.105 154.432 103.052C154.409 102.947 154.382 102.847 154.354 102.747C154.331 102.736 154.307 102.725 154.28 102.716C154.282 102.726 154.285 102.736 154.287 102.747C154.311 102.853 154.334 102.961 154.351 103.066C154.361 103.12 154.363 103.166 154.357 103.22C154.354 103.274 154.348 103.328 154.342 103.382C154.293 103.811 154.23 104.24 154.168 104.669C154.021 104.969 153.871 105.268 153.716 105.564L153.482 106.013L153.36 106.233C153.319 106.305 153.275 106.38 153.232 106.444C153.212 106.476 153.187 106.509 153.159 106.542C153.139 106.558 153.115 106.578 153.077 106.592C153.008 106.623 152.926 106.643 152.847 106.663C152.685 106.7 152.519 106.725 152.352 106.747C152.212 106.764 152.071 106.779 151.929 106.793C151.929 106.823 151.928 106.853 151.928 106.883C152.073 106.876 152.219 106.868 152.364 106.855C152.534 106.838 152.703 106.818 152.873 106.785C152.959 106.767 153.043 106.748 153.129 106.711C153.171 106.697 153.218 106.668 153.26 106.628C153.288 106.597 153.315 106.563 153.341 106.524C153.394 106.448 153.436 106.378 153.481 106.304L153.608 106.082C153.691 105.933 153.773 105.784 153.849 105.633C154.004 105.331 154.153 105.027 154.3 104.721L154.305 104.711L154.306 104.71Z","fill":"#3F6212"}}),_c('path',{attrs:{"d":"M151.939 106.367C151.978 106.365 152.016 106.363 152.054 106.361L152.141 106.358C152.175 106.353 152.203 106.345 152.231 106.335C152.287 106.316 152.341 106.293 152.394 106.268C152.499 106.219 152.604 106.169 152.707 106.115L152.86 106.034L152.937 105.993C152.963 105.976 152.991 105.96 153.014 105.938C153.111 105.857 153.175 105.752 153.231 105.648C153.285 105.542 153.331 105.433 153.369 105.324L153.429 105.162C153.448 105.102 153.462 105.043 153.475 104.987C153.529 104.76 153.566 104.533 153.607 104.305C153.647 104.078 153.687 103.85 153.723 103.622L153.825 102.937C153.838 102.836 153.852 102.736 153.865 102.636C153.849 102.635 153.833 102.634 153.817 102.634L153.622 103.604L153.491 104.284L153.354 104.96C153.342 105.016 153.33 105.07 153.315 105.12L153.258 105.284C153.22 105.393 153.183 105.5 153.136 105.602C153.09 105.703 153.034 105.801 152.957 105.873C152.938 105.892 152.916 105.906 152.895 105.921L152.821 105.966L152.673 106.055C152.574 106.112 152.474 106.17 152.371 106.22C152.319 106.244 152.267 106.268 152.214 106.287C152.188 106.297 152.161 106.305 152.137 106.309L152.051 106.315C152.014 106.317 151.977 106.318 151.941 106.321C151.94 106.337 151.94 106.352 151.94 106.367L151.939 106.367Z","fill":"#3F6212"}}),_c('path',{attrs:{"d":"M151.365 108.11C151.33 107.831 151.295 107.554 151.299 107.278C151.299 106.718 151.323 106.156 151.347 105.594C151.37 105.033 151.396 104.471 151.426 103.909L151.431 103.808L151.447 103.704L151.485 103.503L151.57 103.09L151.743 102.264L152.08 100.61L152.239 99.7803C152.286 99.502 152.341 99.2274 152.364 98.941C152.374 98.7939 152.35 98.657 152.335 98.5156C152.318 98.3756 152.297 98.2362 152.276 98.0971C152.273 98.0815 152.27 98.0661 152.268 98.0507C152.251 98.03 152.234 98.0102 152.218 97.9902C152.222 98.0278 152.228 98.0654 152.232 98.103C152.249 98.2426 152.264 98.3822 152.277 98.522L152.293 98.731C152.299 98.8009 152.303 98.8715 152.295 98.9377C152.267 99.2116 152.208 99.4894 152.155 99.7642L151.981 100.589L151.613 102.236C151.551 102.51 151.488 102.785 151.431 103.06L151.344 103.474L151.303 103.686L151.287 103.791L151.28 103.901C151.249 104.463 151.22 105.025 151.197 105.587C151.178 106.15 151.159 106.713 151.163 107.278C151.161 107.565 151.2 107.847 151.238 108.126C151.275 108.405 151.319 108.683 151.361 108.962L151.531 110.016C151.543 110.017 151.553 110.02 151.566 110.021C151.585 110.022 151.607 110.018 151.628 110.017L151.475 108.945L151.365 108.109V108.11Z","fill":"#3F6212"}}),_c('path',{attrs:{"d":"M150.671 109.362L150.374 108.517C150.261 108.239 150.231 107.943 150.205 107.646C150.159 107.052 150.157 106.456 150.155 105.859C150.148 105.559 150.151 105.264 150.162 104.965L150.199 104.071L150.242 103.178C150.25 103.029 150.258 102.879 150.27 102.734C150.274 102.657 150.284 102.592 150.302 102.52L150.35 102.303C150.487 101.723 150.633 101.144 150.775 100.564C150.848 100.274 150.917 99.9842 150.985 99.6932C151.05 99.401 151.124 99.1128 151.167 98.8134C151.211 98.5162 151.232 98.2177 151.249 97.9194C151.26 97.7269 151.268 97.5345 151.274 97.3419C151.266 97.3411 151.257 97.3397 151.248 97.3389C151.235 97.5314 151.22 97.7238 151.202 97.9159C151.173 98.2124 151.141 98.5092 151.093 98.8018C151.044 99.0926 150.963 99.3819 150.892 99.6708L150.669 100.538C150.522 101.116 150.371 101.693 150.228 102.274L150.177 102.493C150.16 102.566 150.148 102.649 150.144 102.722C150.134 102.874 150.127 103.022 150.119 103.172C150.106 103.47 150.093 103.768 150.085 104.067L150.068 104.963C150.063 105.261 150.069 105.564 150.082 105.86C150.102 106.456 150.107 107.054 150.159 107.651C150.189 107.946 150.22 108.252 150.33 108.531L150.621 109.378L150.734 109.714C150.758 109.717 150.78 109.719 150.799 109.723L150.671 109.363L150.671 109.362Z","fill":"#3F6212"}}),_c('path',{attrs:{"d":"M150.208 109.696C150.241 109.696 150.274 109.696 150.306 109.696C150.237 109.447 150.16 109.168 150.075 108.866C149.987 108.545 149.888 108.212 149.826 107.84C149.758 107.469 149.686 107.079 149.612 106.674C149.537 106.27 149.461 105.852 149.39 105.427C149.373 105.32 149.355 105.216 149.341 105.108C149.325 105.003 149.326 104.899 149.327 104.79C149.331 104.574 149.344 104.355 149.361 104.137C149.393 103.7 149.441 103.264 149.494 102.835C149.521 102.621 149.553 102.409 149.583 102.2C149.613 101.99 149.642 101.782 149.686 101.581C149.764 101.177 149.847 100.787 149.912 100.416C149.982 100.045 150.04 99.6939 150.093 99.3692C150.146 99.0473 150.184 98.7449 150.215 98.4802C150.242 98.2463 150.267 98.041 150.285 97.8643C150.254 97.924 150.222 97.988 150.19 98.0551C150.169 98.1812 150.147 98.3182 150.123 98.4672C150.077 98.7315 150.037 99.0276 149.978 99.3542C149.917 99.678 149.852 100.029 149.792 100.401C149.727 100.772 149.673 101.166 149.61 101.572C149.551 101.979 149.509 102.401 149.451 102.83C149.395 103.258 149.336 103.693 149.284 104.129C149.258 104.348 149.234 104.566 149.221 104.787C149.216 104.896 149.213 105.011 149.226 105.122C149.237 105.229 149.252 105.34 149.267 105.446C149.328 105.875 149.4 106.294 149.468 106.7C149.536 107.106 149.613 107.496 149.684 107.867C149.721 108.05 149.753 108.236 149.806 108.407C149.858 108.578 149.908 108.742 149.956 108.9C150.045 109.19 150.13 109.456 150.208 109.695L150.208 109.696Z","fill":"#3F6212"}}),_c('path',{attrs:{"d":"M146.372 100.269C146.372 100.269 146.723 99.7467 147.079 99.8859C147.434 100.025 147.696 100.283 147.745 100.495C147.793 100.707 147.878 102.738 147.951 103.044C148.024 103.351 148.574 104.315 148.787 104.384C149 104.454 149.544 104.474 149.544 104.474C149.544 104.474 149.879 105.038 149.81 105.416C149.742 105.795 149.436 105.986 149.436 105.986C149.436 105.986 148.565 106.464 148.304 106.277C148.043 106.09 146.616 104.777 146.472 104.424C146.328 104.071 145.764 101.028 146.373 100.269H146.372Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M149.793 105.089C149.718 105.189 149.631 105.314 149.517 105.438C149.484 105.471 149.463 105.496 149.423 105.523C149.383 105.548 149.342 105.573 149.3 105.599C149.216 105.653 149.128 105.709 149.036 105.768C148.944 105.825 148.846 105.882 148.744 105.927C148.693 105.948 148.638 105.968 148.605 105.969L148.582 105.967C148.594 105.969 148.58 105.964 148.58 105.963C148.573 105.958 148.567 105.958 148.554 105.948C148.531 105.931 148.508 105.917 148.484 105.897C148.295 105.744 148.102 105.56 147.906 105.372C147.709 105.182 147.511 104.981 147.316 104.771C147.219 104.667 147.12 104.558 147.035 104.449C147.012 104.423 146.992 104.392 146.971 104.362C146.95 104.336 146.939 104.303 146.922 104.274C146.896 104.21 146.872 104.142 146.852 104.072C146.771 103.794 146.724 103.504 146.681 103.22C146.643 102.935 146.613 102.654 146.593 102.38C146.582 102.243 146.571 102.108 146.561 101.976C146.547 101.841 146.537 101.723 146.539 101.597C146.544 101.347 146.549 101.11 146.554 100.892C146.56 100.673 146.566 100.472 146.572 100.294C146.574 100.203 146.576 100.118 146.578 100.039C146.548 100.066 146.52 100.094 146.495 100.12C146.49 100.174 146.485 100.23 146.479 100.289C146.462 100.466 146.45 100.668 146.437 100.887C146.425 101.107 146.411 101.344 146.418 101.598C146.42 101.662 146.42 101.726 146.427 101.794C146.434 101.864 146.448 101.923 146.457 101.989C146.477 102.12 146.497 102.253 146.517 102.388C146.56 102.66 146.597 102.941 146.638 103.226C146.656 103.369 146.677 103.513 146.7 103.657C146.721 103.802 146.744 103.947 146.777 104.091C146.792 104.164 146.812 104.236 146.837 104.308C146.854 104.344 146.865 104.382 146.887 104.416C146.906 104.447 146.924 104.478 146.947 104.509C147.035 104.633 147.128 104.743 147.222 104.854C147.413 105.073 147.609 105.279 147.802 105.476C147.998 105.671 148.188 105.856 148.394 106.014C148.418 106.034 148.449 106.053 148.477 106.071C148.488 106.08 148.512 106.091 148.533 106.1C148.547 106.104 148.546 106.108 148.573 106.111L148.596 106.112C148.686 106.109 148.744 106.078 148.801 106.053C148.913 105.997 149.01 105.934 149.103 105.872C149.193 105.808 149.279 105.748 149.361 105.69C149.403 105.661 149.443 105.632 149.482 105.604C149.519 105.577 149.559 105.53 149.585 105.498C149.678 105.379 149.749 105.27 149.808 105.173C149.804 105.144 149.799 105.116 149.793 105.088L149.793 105.089Z","fill":"#3F6212"}}),_c('path',{attrs:{"d":"M149.65 104.681C149.547 104.745 149.444 104.81 149.34 104.871C149.199 104.952 149.058 105.036 148.914 105.101C148.879 105.116 148.842 105.13 148.809 105.138C148.793 105.142 148.776 105.144 148.769 105.143L148.759 105.131L148.602 104.943C148.497 104.818 148.39 104.694 148.281 104.572C148.065 104.327 147.844 104.084 147.653 103.82C147.605 103.754 147.561 103.685 147.52 103.616C147.501 103.578 147.481 103.551 147.473 103.509C147.461 103.469 147.454 103.43 147.448 103.391C147.425 103.233 147.413 103.068 147.402 102.906L147.288 100.948L147.257 100.459L147.252 100.348C147.253 100.318 147.253 100.306 147.25 100.278C147.249 100.252 147.246 100.229 147.243 100.21C147.232 100.127 147.219 100.046 147.206 99.9649C147.205 99.957 147.203 99.9493 147.202 99.9414C147.165 99.9232 147.127 99.9062 147.088 99.8906C147.091 99.9203 147.094 99.9502 147.098 99.9799C147.106 100.061 147.116 100.142 147.122 100.222C147.124 100.243 147.125 100.261 147.125 100.277C147.127 100.289 147.125 100.318 147.125 100.329C147.121 100.385 147.123 100.42 147.123 100.463C147.123 100.628 147.131 100.792 147.138 100.955C147.153 101.283 147.179 101.61 147.208 101.936C147.236 102.263 147.269 102.589 147.316 102.914C147.341 103.077 147.362 103.238 147.397 103.403C147.405 103.444 147.413 103.485 147.426 103.524C147.434 103.563 147.461 103.605 147.48 103.639C147.523 103.711 147.571 103.777 147.618 103.845C147.809 104.112 148 104.378 148.199 104.64C148.297 104.771 148.4 104.899 148.506 105.024C148.558 105.088 148.613 105.149 148.667 105.21L148.677 105.222L148.682 105.228C148.686 105.231 148.692 105.236 148.697 105.24C148.72 105.258 148.74 105.26 148.757 105.262C148.791 105.265 148.814 105.258 148.838 105.252C148.884 105.24 148.923 105.222 148.962 105.204C149.116 105.131 149.254 105.041 149.389 104.946C149.487 104.878 149.582 104.808 149.675 104.735C149.667 104.716 149.659 104.698 149.651 104.68L149.65 104.681ZM148.771 105.145C148.771 105.145 148.771 105.145 148.771 105.145C148.773 105.146 148.774 105.148 148.774 105.148L148.771 105.145Z","fill":"#3F6212"}}),_c('path',{attrs:{"d":"M146.563 110.2C146.563 110.2 147.583 109.722 148.661 109.992C148.661 109.992 150.142 109.207 151.31 109.974C151.31 109.974 153.214 109.67 155.802 110.201C155.802 110.201 146.53 110.168 146.563 110.2Z","fill":"#FFBF00"}}),_c('path',{attrs:{"d":"M161.144 103.449C161.132 103.42 161.119 103.377 161.121 103.335","stroke":"#2D2D2D","stroke-width":"0.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M156.844 97.4203C157.708 96.5572 157.708 95.1577 156.844 94.2945C155.98 93.4314 154.58 93.4314 153.716 94.2945C152.852 95.1577 152.852 96.5572 153.716 97.4203C154.58 98.2835 155.98 98.2835 156.844 97.4203Z","fill":"#FFD900"}})])]),_c('g',{attrs:{"opacity":"0.5"}},[_c('path',{attrs:{"d":"M201.655 18.2188C201.655 18.2188 201.576 18.2766 201.424 18.3903","stroke":"#A3A3A3","stroke-miterlimit":"10","stroke-dasharray":"2 2"}}),_c('path',{attrs:{"d":"M200.813 18.8506C200.599 19.0125 200.344 19.2072 200.055 19.4289","stroke":"#A3A3A3","stroke-miterlimit":"10","stroke-dasharray":"2 2"}}),_c('path',{attrs:{"d":"M199.753 19.6631C188.043 28.7222 127.434 78.2012 165.222 104.226","stroke":"#A3A3A3","stroke-miterlimit":"10","stroke-dasharray":"2 2"}}),_c('path',{attrs:{"d":"M165.541 104.441C165.62 104.495 165.701 104.549 165.782 104.603","stroke":"#A3A3A3","stroke-miterlimit":"10","stroke-dasharray":"2 2"}})]),_c('path',{attrs:{"opacity":"0.5","d":"M39.2656 166.269C39.2656 166.269 136.114 196.849 127.508 133.189C126.435 125.257 112.905 108.635 97.6745 112.979","stroke":"#A3A3A3","stroke-miterlimit":"10","stroke-dasharray":"2 2"}}),_c('path',{attrs:{"d":"M24.0938 165.551L40.0943 165.195L42.8351 161.489L24.0938 165.551Z","fill":"#FDE68A"}}),_c('path',{attrs:{"d":"M24.0938 165.552L39.5423 166.547L36.9328 174.433L24.0938 165.552Z","fill":"#FDE68A"}}),_c('path',{attrs:{"d":"M40.0943 165.194L41.7948 169.569L39.5423 166.546L24.0938 165.551L40.0943 165.194Z","fill":"#FBBF24"}}),_c('path',{attrs:{"d":"M41.794 169.57L38.7676 168.883L39.5416 166.547L41.794 169.57Z","fill":"#FCD34D"}}),_c('path',{attrs:{"d":"M220.417 0L199.332 15.2341L192.139 13.1231L220.417 0Z","fill":"#FDE68A"}}),_c('path',{attrs:{"d":"M220.417 0L201.377 16.4448L212.514 24.1043L220.417 0Z","fill":"#FDE68A"}}),_c('path',{attrs:{"d":"M199.332 15.2341L201.43 22.5735L201.376 16.4448L220.417 0L199.332 15.2341Z","fill":"#FCD34D"}}),_c('path',{attrs:{"d":"M201.431 22.574L204.677 18.7144L201.377 16.4453L201.431 22.574Z","fill":"#FBBF24"}}),_c('path',{attrs:{"d":"M193.73 67.6188L193.742 66.2539L193.754 65.5579C193.771 65.4557 193.779 65.3613 193.796 65.2687C193.896 64.6229 194.062 64.0349 194.254 63.4777L194.115 63.4083C194.006 63.3543 193.929 63.2541 193.906 63.1365C193.883 63.0189 193.914 62.8974 193.991 62.8049L195.205 61.3841C195.265 61.3146 195.296 61.226 195.296 61.1354C195.282 59.0128 197 58.4151 197 58.4151L197.22 58.9896C197.297 58.9183 197.378 58.8393 197.452 58.7737C198.245 58.0874 198.847 57.75 198.847 57.75L202.242 61.7908L202.339 65.4615L202.455 69.4927V69.5023L202.702 74.8715L196.552 73.7726L196.35 70.233L196.375 70.1598L193.732 67.613L193.73 67.6188Z","fill":"#FFD5A2"}}),_c('path',{attrs:{"d":"M193.643 68.2241C193.346 67.3585 193.498 66.4486 193.624 65.9512C193.691 65.7025 193.751 65.5559 193.751 65.5559C193.769 65.4538 193.776 65.3593 193.794 65.2668C194.131 65.4499 194.533 65.4769 194.894 65.342C195.255 65.207 195.538 64.9236 195.674 64.5631C196.054 63.5548 196.496 62.3846 196.496 62.3846C196.843 61.465 197.308 60.8519 197.76 60.4413C196.87 59.9285 196.303 58.9395 196.393 57.8502C196.519 56.3445 197.843 55.2264 199.35 55.3536C199.899 55.3999 200.395 55.6081 200.798 55.9223C201.416 55.959 202.035 56.0862 202.579 56.2655C203.048 56.4178 203.44 56.7899 203.871 56.9383C207.806 58.2474 206.687 61.5903 206.687 61.5903C208.472 63.0015 207.706 65.5078 206.447 66.3637C205.397 67.0674 203.471 68.7986 202.828 69.3751C202.726 69.4695 202.581 69.5042 202.45 69.4946C202.413 69.4907 202.377 69.4792 202.34 69.4657L199.242 68.3032C197.335 67.2024 197.855 65.0701 197.855 65.0701C198.204 64.1582 197.936 63.6454 197.64 63.3562C197.536 63.2618 197.387 63.2213 197.252 63.2579C197.108 63.2926 196.996 63.3871 196.947 63.524L196.293 65.2591C196.061 65.8895 196.087 66.5893 196.366 67.1966C196.974 68.4805 196.727 69.4021 196.727 69.4021L196.546 69.886C196.527 69.9554 196.5 70.0171 196.473 70.0826L196.413 70.2426H196.405C196.089 70.8306 195.444 71.2066 194.736 71.1468C193.782 71.0678 193.074 70.2311 193.155 69.2787C193.189 68.8642 193.375 68.4998 193.643 68.2241Z","fill":"#713F12"}}),_c('path',{attrs:{"d":"M207.857 164.846L207.728 169.642C207.79 170.685 206.834 171.69 205.968 172.276C205.176 172.814 204.362 173.082 204.362 173.082L203.736 174.593H205.437L210.887 171.185L210.696 169.714L209.986 165.33L207.857 164.846Z","fill":"#FFD5A2"}}),_c('path',{attrs:{"d":"M210.887 171.185C210.887 171.185 212.339 173.272 212.242 175.769H199.405C199.125 175.769 198.882 175.58 198.812 175.31C198.743 175.04 198.864 174.757 199.11 174.622C199.542 174.385 200.173 174.252 201.09 174.425C201.374 174.479 201.665 174.439 201.924 174.31L204.363 173.082L204.844 173.849L210.889 171.185H210.887Z","fill":"#285E72"}}),_c('path',{attrs:{"d":"M197.148 112.411L202.9 145.025C203.037 145.798 203.184 146.571 203.336 147.34L206.922 169.463H211.51C210.927 163.59 212.624 162.266 211.972 156.143C211.474 151.447 210.74 147.201 209.449 144.223L207.847 117.774C209.455 114.225 209.09 110.928 208.274 108.455C207.382 105.76 205.952 104.044 205.952 104.044L197.967 106.292L197.15 112.409L197.148 112.411Z","fill":"#E4E4E4"}}),_c('path',{attrs:{"d":"M195.266 164.354L194.409 169.64C194.471 170.683 193.516 171.687 192.649 172.273C191.858 172.811 191.043 173.079 191.043 173.079L190.418 174.591H192.118L197.569 171.182L197.378 169.711L198.86 166.098L195.266 164.354Z","fill":"#FFD5A2"}}),_c('path',{attrs:{"d":"M197.569 171.184C197.569 171.184 199.02 173.271 198.924 175.768H186.087C185.807 175.768 185.563 175.579 185.494 175.309C185.425 175.039 185.546 174.756 185.791 174.621C186.224 174.384 186.855 174.251 187.772 174.424C188.055 174.478 188.347 174.438 188.605 174.309L191.045 173.081L191.526 173.848L197.571 171.184H197.569Z","fill":"#285E72"}}),_c('path',{attrs:{"d":"M191.887 140.61C192.929 151.663 192.366 157.934 193.537 169.262H198.318L200.27 156.116C200.27 156.116 200.14 147.741 199.123 144.225L199.995 133.431L200.561 126.517L201.223 118.337L201.269 117.977C202.227 117.443 203.238 116.82 203.73 115.989C204.215 115.183 204.599 114.138 204.634 113.464C204.821 109.768 204.477 106.89 204.477 106.89H190.546C190.505 107.422 190.465 107.971 190.441 108.536C189.998 117.078 190.733 128.358 191.887 140.612V140.61Z","fill":"#E4E4E4"}}),_c('path',{attrs:{"d":"M204.312 73.0437V73.2731C204.312 73.8032 194.988 73.6317 195.059 73.0379C195.059 73.0359 195.063 73.0321 195.063 73.0263C195.281 72.6542 195.69 71.8927 196.698 71.7597C196.709 71.7578 196.717 71.7578 196.729 71.7539H202.949C202.949 71.7539 204.171 71.8079 204.314 73.0437H204.312Z","fill":"#285E72"}}),_c('path',{attrs:{"d":"M189.4 107.824C189.527 107.608 189.716 107.278 189.94 106.862C189.796 106.303 189.821 105.62 190.099 104.781C190.685 102.998 190.973 100.906 191.033 98.7877C191.093 96.6362 190.923 94.4596 190.6 92.551C189.767 87.6214 188.147 83.1815 189.657 78.1497C190.832 74.2304 194.198 72.8288 197.902 72.4355C198.24 72.4008 198.799 72.4008 199.141 72.4413C199.247 72.4451 199.359 72.4451 199.467 72.4509C201.336 72.4953 202.818 72.4837 204.148 73.0563L204.262 73.0736C204.262 73.0736 207.412 74.7894 207.415 74.7894C210.446 76.4397 210.888 80.3147 210.836 83.2856C210.785 85.9808 209.469 88.354 208.398 90.7793C207.298 93.2739 206.831 95.5893 206.931 98.298C206.956 99.0171 208.919 103.954 209.641 106.37C209.845 107.051 209.568 107.777 208.956 108.173C208.296 108.601 207.199 109.092 205.429 109.412C203.434 109.775 200.581 109.919 196.524 109.509C195.31 109.458 193.75 109.509 192.992 109.983C192.397 110.357 191.683 110.534 190.954 110.492C190.017 110.436 189.066 110.029 189.172 108.562C189.191 108.302 189.269 108.053 189.404 107.822L189.4 107.824Z","fill":"#01758C"}}),_c('path',{attrs:{"d":"M189.013 96.267L189.619 84.5687C188.688 81.2681 189.453 74.7731 193.541 73.8901C193.778 73.8381 194.013 73.8092 194.259 73.8015C196.096 73.7475 197.918 75.0257 198.522 76.7241C199.057 78.224 198.509 79.6911 198.254 81.1852C197.507 85.5673 196.681 89.8954 195.71 94.2389C195.187 96.5735 194.571 98.8986 193.965 101.212C193.799 101.848 193.338 102.371 192.755 102.679C192.172 102.988 191.491 103.049 190.862 102.849L189.177 102.317L184.99 101.073L186.251 95.8834L189.013 96.267Z","fill":"#01758C"}}),_c('path',{attrs:{"d":"M163.686 90.0186C164.728 89.8952 165.388 91.4587 165.388 91.4587C165.388 91.4587 165.948 91.3257 166.975 91.6997C167.158 91.7652 167.326 91.8096 167.475 91.8288C167.629 91.8578 167.764 91.8597 167.882 91.8539C168.324 91.8423 168.552 91.6727 168.552 91.6727C167.687 91.0654 167.955 89.6561 167.955 89.6561C167.988 89.5674 168.021 89.498 168.056 89.4402C168.129 89.3187 168.268 89.2571 168.405 89.2802C168.54 89.3053 168.646 89.4132 168.669 89.5539C168.893 90.9536 169.808 91.3488 170.2 91.4548C170.474 91.53 170.717 91.6862 170.901 91.9098H170.903C171.146 92.199 171.445 92.6308 171.445 92.6308L186.249 95.9449L184.989 101.135L170.839 94.7129L165.749 93.2651C165.091 93.2246 164.788 92.5306 164.788 92.5306C164.358 92.6058 164.062 92.0448 164.062 92.0448L163.644 91.3931L162.574 89.7332C163.159 89.2416 163.684 90.0109 163.684 90.0109L163.686 90.0186Z","fill":"#FFD5A2"}}),_c('path',{attrs:{"d":"M187.757 95.6245C187.918 95.6534 188.035 95.7884 188.039 95.9503C188.103 98.2927 187.785 99.8851 186.715 102.013C186.642 102.16 186.472 102.233 186.314 102.189L183.222 101.285C183.094 101.248 183.011 101.125 183.025 100.994C183.247 98.6802 183.633 97.08 184.463 95.3025C184.528 95.1618 184.679 95.0827 184.831 95.1097L187.757 95.6245Z","fill":"#285E72"}}),_c('path',{attrs:{"d":"M112.908 58.3431C112.83 58.3431 112.757 58.359 112.689 58.3877C112.583 58.0833 112.294 57.864 111.952 57.864C111.848 57.864 111.748 57.8847 111.657 57.922C111.556 57.311 111.025 56.8451 110.384 56.8451C110.332 56.8451 110.282 56.8483 110.232 56.8543C109.949 56.2035 109.299 55.748 108.542 55.748C107.786 55.748 107.136 56.2035 106.853 56.8543C106.803 56.8486 106.753 56.8451 106.701 56.8451C106.07 56.8451 105.545 57.2967 105.433 57.8937C105.366 57.8749 105.295 57.864 105.222 57.864C104.908 57.864 104.638 58.0492 104.514 58.3157C104.45 58.2908 104.38 58.2768 104.308 58.2768C104.187 58.2768 104.076 58.3137 103.984 58.3765C103.856 57.9641 103.471 57.6645 103.015 57.6645C102.626 57.6645 102.288 57.8832 102.118 58.2038C101.989 58.1136 101.833 58.0604 101.664 58.0604C101.397 58.0604 101.163 58.1923 101.019 58.3934C100.923 58.3204 100.803 58.2768 100.673 58.2768C100.356 58.2768 100.1 58.533 100.1 58.8489C100.1 58.8658 100.101 58.8827 100.102 58.8992H100.876H101.244H102.025H102.452H103.737H104.004H104.486H104.879H105.664H105.958H107.257H107.739H109.345H109.827H111.216H111.421H112.35H112.688H113.465C113.465 58.592 113.215 58.3427 112.907 58.3427L112.908 58.3431Z","fill":"white"}}),_c('path',{attrs:{"d":"M96.1289 52.041C96.1289 52.041 96.1653 52.2128 96.2478 52.6029C96.2487 52.6035 96.25 52.6038 96.251 52.6045C96.3161 52.6354 96.3877 52.6663 96.465 52.6969C96.5554 52.7326 96.6535 52.768 96.758 52.8024C96.7835 52.811 96.8097 52.8193 96.8359 52.8276C96.8711 52.8387 96.9069 52.8499 96.9436 52.8607C97.9615 53.1667 99.4353 53.3872 100.225 53.2212L107.173 51.7589C107.214 51.7503 107.236 51.7455 107.236 51.7455H107.236L106.82 51.2499L106.486 50.8521L106.447 50.8047L106.417 50.7693L106.298 50.6271L106.131 50.4279L105.78 50.0098L96.1289 52.041Z","fill":"#F5F5F5"}}),_c('path',{attrs:{"d":"M105.16 51.375C105.176 51.4515 105.218 51.52 105.283 51.5793C105.578 51.8511 106.335 51.935 107.174 51.7584C107.195 51.7539 107.216 51.7495 107.237 51.7447C108.227 51.5219 108.95 51.0139 108.861 50.5957C108.852 50.5514 108.834 50.51 108.808 50.4711C108.786 50.4389 108.758 50.4086 108.726 50.3806C108.709 50.3653 108.69 50.3506 108.669 50.3366C108.653 50.3257 108.637 50.3155 108.619 50.3053C108.543 50.2614 108.45 50.2247 108.346 50.1957C107.969 50.0924 107.427 50.0896 106.847 50.212C106.588 50.2665 106.347 50.3404 106.132 50.4274C105.864 50.5358 105.637 50.6645 105.469 50.801C105.385 50.8698 105.316 50.9402 105.264 51.0113C105.252 51.0276 105.241 51.0438 105.231 51.0601C105.218 51.0811 105.206 51.1021 105.196 51.1232C105.156 51.2086 105.142 51.2931 105.16 51.3743V51.375Z","fill":"#F5F5F5"}}),_c('path',{attrs:{"d":"M96.2503 52.6036C96.3155 52.6345 96.3871 52.6654 96.4644 52.696C96.5548 52.7317 96.6529 52.7671 96.7574 52.8015C96.7829 52.8101 96.8091 52.8184 96.8353 52.8267C96.8705 52.8378 96.9062 52.849 96.943 52.8598C97.9609 53.1658 99.4347 53.3864 100.224 53.2203L107.172 51.758C107.214 51.7494 107.235 51.7446 107.235 51.7446H107.235C108.225 51.5215 108.948 51.0135 108.86 50.5953C108.85 50.551 108.832 50.5096 108.806 50.4707C108.708 50.6125 108.509 50.7952 108.106 50.9364C107.948 50.9918 107.473 51.1046 106.819 51.249C106.375 51.3472 105.848 51.4597 105.281 51.5789C102.618 52.1376 99.073 52.8378 99.073 52.8378C99.073 52.8378 98.4545 53.0013 97.8075 52.9076C97.4423 52.8547 96.781 52.7113 96.25 52.6036H96.2503Z","fill":"#F5F5F5"}}),_c('path',{attrs:{"d":"M104.78 50.6251C104.826 50.8392 105.364 50.9071 105.983 50.7771C106.601 50.6471 107.339 50.3242 107.205 50.1521C107.201 50.1476 107.198 50.1435 107.194 50.1393C107.132 50.0679 107.032 50.0154 106.906 49.9806C106.903 49.98 106.901 49.9793 106.899 49.9787C106.626 49.9057 106.231 49.915 105.819 50.0016C105.2 50.132 104.735 50.4109 104.78 50.6251Z","fill":"#F5F5F5"}}),_c('path',{attrs:{"d":"M94.7324 50.3511L94.8276 50.4697L94.942 50.6128L94.9704 50.6485L95.0088 50.6963L96.1056 52.0665L98.0174 51.6639L96.1666 50.4525L96.1021 50.4104L96.0538 50.3789L95.8605 50.2523L95.7002 50.1475L94.7324 50.3511Z","fill":"#285E72"}}),_c('path',{attrs:{"d":"M106.6 50.2975L107.174 50.1767C107.17 50.1722 107.167 50.1681 107.163 50.1639C107.101 50.0925 107.001 50.0399 106.875 50.0052C106.874 50.0052 106.873 50.0052 106.871 50.0049L106.416 50.1008C106.315 50.1222 106.5 50.3188 106.6 50.2978V50.2975Z","fill":"#285E72"}}),_c('path',{attrs:{"d":"M103.98 51.3275C103.448 51.4413 103.165 51.5369 103.056 51.586C103.029 51.5978 102.963 51.6535 102.945 51.6762L100.684 54.4774C100.684 54.4774 101.014 54.5459 101.344 54.4806C101.599 54.4302 101.994 54.2202 101.994 54.2202L105.175 51.2363C105.175 51.2363 104.414 51.2344 103.98 51.3272V51.3275Z","fill":"#285E72"}}),_c('path',{attrs:{"d":"M90.585 62.0337C90.9889 62.0337 91.3394 62.2616 91.5144 62.596C91.6074 62.5497 91.7119 62.523 91.8231 62.523C91.8387 62.523 91.8541 62.5242 91.8694 62.5252C91.863 62.4688 91.8595 62.4117 91.8595 62.3537C91.8595 61.5251 92.5327 60.8535 93.3633 60.8535C94.1119 60.8535 94.7327 61.3995 94.8474 62.1141C94.8592 62.1137 94.8713 62.1134 94.8831 62.1134C95.2288 62.1134 95.5221 62.3349 95.6292 62.6434C95.6665 62.6352 95.7049 62.631 95.7445 62.631C95.848 62.631 95.9445 62.6603 96.0269 62.7101C96.1573 62.5086 96.3838 62.3757 96.6416 62.3757C96.9825 62.3757 97.2691 62.6084 97.3503 62.9233C97.3883 62.9147 97.4276 62.9096 97.4685 62.9096C97.6388 62.9096 97.7902 62.9905 97.8864 63.1161H89.5377C89.5374 63.104 89.5371 63.0916 89.5371 63.0795C89.5371 62.5019 90.0064 62.0337 90.5857 62.0337H90.585Z","fill":"white"}}),_c('path',{attrs:{"d":"M102.904 59.5174C102.904 59.5174 102.426 58.9752 102.389 58.9341C102.352 58.8927 102.233 58.7579 102.274 58.6396C102.315 58.5214 102.605 58.2326 102.674 58.2807C102.743 58.3289 103.111 58.6909 103.162 58.8079C103.212 58.9249 103.101 59.3529 102.904 59.5174Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M102.904 59.5168C102.904 59.5168 103.602 61.7739 104.41 61.9355C105.073 62.0684 105.799 60.312 105.799 60.312C105.799 60.312 105.764 60.0506 105.477 59.8457C105.244 59.679 104.99 59.8186 104.99 59.8186C104.99 59.8186 104.485 60.733 104.438 60.8487C104.438 60.8487 104.033 60.2495 103.368 59.2803C103.368 59.2803 102.963 59.2908 102.905 59.5164L102.904 59.5168Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M106.272 60.3354C106.283 59.8436 106.45 59.1415 105.71 58.5107C105.71 58.5107 105.402 58.7549 105.244 59.05C104.973 59.5542 104.536 60.3953 104.377 60.6933C104.513 61.0232 105.137 61.3365 105.538 61.5153C106.009 60.8814 106.272 60.3357 106.272 60.3357V60.3354Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M102.826 57.5066L102.26 58.3652L102.721 58.6676L103.287 57.809L102.826 57.5066Z","fill":"#E5E5E5"}}),_c('path',{attrs:{"d":"M103.179 57.7379L102.613 58.5967L102.675 58.6369L103.24 57.7782L103.179 57.7379Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M102.585 57.7891L103.271 58.2388C103.3 58.2576 103.308 58.2961 103.289 58.3248L102.665 59.2717C102.646 59.3004 102.603 59.3164 102.574 59.2976L101.893 58.8402L102.585 57.7891H102.585Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M103.164 58.1687L102.467 59.2266L102.528 59.2668L103.225 58.209L103.164 58.1687Z","fill":"#FFEC1A"}}),_c('path',{attrs:{"d":"M102.585 58.1886C102.638 58.1086 102.746 58.0862 102.826 58.1388C102.906 58.1914 102.929 58.2992 102.876 58.3792C102.823 58.4592 102.715 58.4815 102.635 58.4289C102.555 58.3763 102.532 58.2686 102.585 58.1886Z","fill":"#ABE532"}}),_c('path',{attrs:{"d":"M103.368 59.2803C103.368 59.2803 103.267 58.7726 103.247 58.7223C103.227 58.6719 102.907 58.2429 102.861 58.2582C102.815 58.2735 102.77 58.3506 102.862 58.4851C102.954 58.6196 103.02 58.8137 103.02 58.8137C103.02 58.8137 102.816 59.0767 102.811 59.1882C102.807 59.2998 102.851 59.448 102.905 59.5162C102.905 59.5162 103.186 59.4926 103.368 59.28L103.368 59.2803Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M110.285 72.399L110.59 72.9227L111.067 72.6534L110.778 72.1211L110.285 72.399Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M110.122 73.135C110.15 73.1143 110.421 72.735 110.439 72.7236C110.439 72.7236 110.474 72.6745 110.675 72.7455C110.777 72.7816 110.934 72.5365 111.043 72.5591C111.043 72.5591 111.271 72.7379 111.215 72.902L111.236 73.0142C111.236 73.0142 111.085 73.173 110.908 73.209C110.908 73.209 110.725 73.1933 110.653 73.3011C110.517 73.5031 109.978 73.7769 109.863 73.5844L109.867 73.5825C109.857 73.5752 109.849 73.5663 109.844 73.5548C109.775 73.3999 109.98 73.238 110.122 73.135H110.122Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M105.846 72.54L105.793 73.1431L106.339 73.1972L106.41 72.5958L105.846 72.54Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M104.856 73.3898C104.867 73.2206 105.125 73.1734 105.298 73.1482C105.333 73.1431 105.75 72.9344 105.772 72.9325C105.772 72.9325 105.826 72.9054 105.97 73.0619C106.043 73.1412 106.297 72.9978 106.383 73.0689C106.383 73.0689 106.505 73.3388 106.378 73.4574L106.344 73.5664C106.344 73.5664 106.132 73.6308 105.959 73.5804C105.959 73.5804 105.804 73.4813 105.69 73.5428C105.475 73.6582 104.87 73.6483 104.859 73.4249H104.863C104.858 73.414 104.855 73.4022 104.856 73.3898Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M105.928 62.9502L105.913 64.3379C105.913 64.3379 105.83 68.1182 105.633 72.7138L106.592 72.8149C106.592 72.8149 107.462 66.1514 107.639 65.5184C107.639 65.5184 108.158 69.0989 108.433 69.6493C108.708 70.1998 110.175 72.6345 110.175 72.6345L111.011 72.209C111.011 72.209 109.706 69.3708 109.61 69.0055C109.514 68.6403 109.431 64.2748 109.431 64.2748V62.9482L105.928 62.9502Z","fill":"#164E63"}}),_c('path',{attrs:{"d":"M107.035 57.5777C107.035 57.5777 107.612 57.3839 108.137 57.5972L108.21 57.9238H106.93L107.035 57.5777Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M106.242 55.0902C106.411 54.6756 107.107 54.5656 107.796 54.8448C108.486 55.124 108.908 55.6865 108.739 56.1012C108.571 56.5159 107.875 56.6258 107.185 56.3466C106.496 56.0674 106.073 55.5049 106.242 55.0902Z","fill":"#164E63"}}),_c('path',{attrs:{"d":"M107.08 56.3828C107.08 56.3828 107.112 57.5292 107.08 57.6507C107.048 57.7721 106.843 57.913 106.436 58.1179C106.436 58.1179 106.838 58.8204 107.605 58.8044C108.372 58.7885 108.592 58.2878 108.714 58.1135C108.714 58.1135 108.107 57.8802 108.089 57.6733C108.068 57.4257 108.089 56.3831 108.089 56.3831H107.08L107.08 56.3828Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M108.278 55.9506C108.267 56.5798 107.923 57.0027 107.684 57.1841C107.515 57.3116 107.343 57.3214 107.19 57.3214C106.7 57.3214 106.579 56.7602 106.536 56.031C106.473 54.9658 106.761 54.9033 107.367 54.9033C108.041 54.9033 108.29 55.2255 108.278 55.951V55.9506Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M106.75 55.2773C106.75 55.2773 106.997 55.2078 107.03 55.3302C107.064 55.4526 107.074 55.5552 107.225 55.5737C107.375 55.5922 107.225 55.7917 107.433 55.7955C107.433 55.7955 107.391 55.741 107.406 55.7104C107.422 55.6798 107.437 55.6339 107.416 55.5941C107.416 55.5941 107.836 55.8105 107.836 55.9482L107.834 56.0502L107.909 56.0524L108.084 56.7013C108.084 56.7013 108.307 56.3695 108.401 56.1008C108.499 55.8207 108.512 55.5338 108.512 55.5338C108.512 55.5338 108.559 55.4325 108.541 55.3467C108.522 55.261 108.412 55.1778 108.394 55.0191C108.375 54.8601 108.191 54.7374 108.047 54.7587C107.903 54.7801 107.82 54.5413 107.609 54.6392C107.397 54.737 107.37 54.4052 107.205 54.6545C107.104 54.8091 106.875 54.5136 106.861 54.8534C106.861 54.8534 106.524 54.8747 106.557 54.9879C106.591 55.101 106.241 55.2569 106.428 55.4465L106.527 55.7576C106.539 55.6996 106.524 55.5644 106.545 55.4573C106.566 55.3502 106.62 55.2355 106.749 55.2766L106.75 55.2773Z","fill":"#FDBA74"}}),_c('path',{attrs:{"d":"M107.908 56.038C107.908 56.038 107.942 55.9163 108.106 55.9309C108.265 55.9449 108.264 56.328 108.124 56.3953C107.984 56.4622 107.898 56.2837 107.898 56.2837L107.908 56.0383V56.038Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M108.562 55.5306C108.562 55.5306 108.601 54.5541 108.058 54.5123C108.058 54.5123 108.01 54.5094 107.908 54.4431C107.805 54.3769 107.577 54.1815 106.768 54.8043C106.768 54.8043 107.768 55.2094 108.562 55.5306Z","fill":"#164E63"}}),_c('path',{attrs:{"d":"M108.549 55.2509C108.566 55.4099 108.562 55.531 108.562 55.531C107.768 55.2097 106.768 54.8046 106.768 54.8046C106.86 54.7336 106.944 54.6733 107.022 54.6223C107.832 54.571 108.333 55.0048 108.549 55.2509Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M107.564 55.299C107.029 55.0823 106.472 55.1827 106.25 55.5164C106.195 55.3685 106.188 55.2219 106.242 55.0902C106.411 54.6756 107.107 54.5656 107.796 54.8448C108.486 55.124 108.908 55.6865 108.739 56.1012C108.674 56.2622 108.529 56.3769 108.336 56.441C108.469 56.0327 108.133 55.5291 107.564 55.2987L107.564 55.299Z","fill":"#164E63"}}),_c('path',{attrs:{"d":"M107.768 54.9137C107.097 54.6418 106.42 54.7387 106.229 55.1266C106.232 55.1148 106.237 55.1027 106.241 55.0912C106.41 54.6765 107.106 54.5666 107.795 54.8458C108.485 55.125 108.907 55.6875 108.738 56.1022C108.734 56.114 108.728 56.1258 108.723 56.1369C108.857 55.7258 108.439 55.1855 107.768 54.9137Z","fill":"#164E63"}}),_c('path',{attrs:{"d":"M108.138 57.5937C108.138 57.5937 107.943 58.197 107.471 58.7197C107.471 58.7197 107.142 58.1508 107.036 57.5752C107.036 57.5752 106.825 57.784 106.719 57.8818C106.719 57.8818 106.724 57.9041 106.722 57.9051C106.343 58.0753 105.943 58.3185 105.709 58.5103C105.709 58.5103 105.792 62.9577 105.798 64.3053C105.798 64.3053 106.434 64.414 107.28 64.4417L107.39 63.4884L107.547 64.4446C108.057 64.4315 108.989 64.3792 109.491 64.2562C109.491 64.2562 109.574 58.6416 109.564 58.5103C109.564 58.5103 108.969 58.1578 108.442 57.9398C108.442 57.9398 108.444 57.9025 108.441 57.8872C108.441 57.8872 108.226 57.6587 108.137 57.5937H108.138Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M107.006 61.1272C107.006 61.1272 106.737 59.1109 106.662 57.9272C106.662 57.9272 106.679 57.904 106.708 57.9033C106.708 57.9033 107.006 60.7087 107.063 61.1157L107.006 61.1272Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M108.282 61.1116C108.282 61.1116 108.536 58.914 108.504 57.9575C108.504 57.9575 108.487 57.9279 108.442 57.939C108.442 57.939 108.436 58.9726 108.221 61.0963L108.282 61.1113V61.1116Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M107.213 60.998H107.014V61.0777H107.213V60.998Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M108.232 61.0371H107.034C106.978 61.0371 106.934 61.0818 106.934 61.1369V61.7743C106.934 61.8294 106.978 61.8741 107.034 61.8741H108.232C108.287 61.8741 108.332 61.8294 108.332 61.7743V61.1369C108.332 61.0818 108.287 61.0371 108.232 61.0371Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M107.838 61.7733C108.019 61.7439 108.142 61.5733 108.113 61.3923C108.083 61.2112 107.912 61.0883 107.731 61.1177C107.549 61.1471 107.426 61.3177 107.456 61.4987C107.485 61.6798 107.656 61.8027 107.838 61.7733Z","fill":"#737373"}}),_c('path',{attrs:{"d":"M107.473 61.1172H107.033V61.2169H107.473V61.1172Z","fill":"#737373"}}),_c('path',{attrs:{"d":"M108.252 61.0977H108.072V61.1773H108.252V61.0977Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M108.044 61.5541C108.103 61.4109 108.035 61.2466 107.891 61.1873C107.748 61.1279 107.583 61.1959 107.524 61.3392C107.464 61.4825 107.532 61.6467 107.676 61.7061C107.82 61.7654 107.984 61.6974 108.044 61.5541Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M107.783 61.6255C107.883 61.6255 107.963 61.5451 107.963 61.446C107.963 61.3469 107.883 61.2666 107.783 61.2666C107.684 61.2666 107.604 61.3469 107.604 61.446C107.604 61.5451 107.684 61.6255 107.783 61.6255Z","fill":"white"}}),_c('path',{attrs:{"d":"M110.675 61.6373C110.675 61.6373 110.838 62.0771 111.058 64.2371C111.058 64.2371 110.887 64.4104 110.595 64.3034C110.523 64.0293 110.257 63.097 109.949 61.9298C109.923 61.8282 109.773 61.4362 109.738 61.2169C110.129 61.1085 110.359 61.098 110.599 61.0068C110.628 61.1353 110.641 61.4935 110.675 61.6373Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M109.565 58.5107C109.565 58.5107 109.911 58.6774 110.104 59.1791C110.299 59.6849 110.313 59.617 110.801 61.3757C110.561 61.4669 110.037 61.6243 109.597 61.6852C109.459 60.8135 109.345 58.9432 109.565 58.5107Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M111.089 64.3226C111.089 64.3226 111.233 64.9075 111.138 65.3231C111.102 65.4799 111.105 65.5953 110.956 65.6692C110.956 65.6692 110.779 65.7719 110.714 65.7645C110.714 65.7645 110.674 65.7129 110.725 65.6406C110.776 65.5682 110.91 65.492 110.887 65.377C110.868 65.2836 110.822 64.9502 110.773 64.9811C110.723 65.012 110.729 65.4347 110.606 65.4337C110.606 65.4337 110.573 65.4343 110.552 65.3107C110.531 65.187 110.508 64.7013 110.531 64.6089C110.553 64.5164 110.573 64.2442 110.573 64.2442C110.573 64.2442 110.803 63.9373 111.045 64.1148L111.09 64.3226H111.089Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M99.4056 63.2304C99.4056 63.2304 99.6865 63.6725 99.7229 64.0415C99.7366 64.1805 99.7711 64.2752 99.6692 64.3768C99.6692 64.3768 99.5516 64.5104 99.4957 64.5225C99.4957 64.5225 99.4484 64.4909 99.4708 64.4173C99.4929 64.3434 99.5826 64.2439 99.5312 64.1553C99.4897 64.0836 99.3596 63.8216 99.3274 63.8605C99.2951 63.8994 99.4171 64.2462 99.3155 64.2796C99.3155 64.2796 99.2887 64.2892 99.2369 64.1933C99.1852 64.0973 99.0321 63.7031 99.0251 63.6208C99.0181 63.5386 98.959 63.3085 98.959 63.3085C98.959 63.3085 99.0631 62.992 99.312 63.0714L99.406 63.2304H99.4056Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M98.9679 61.5586C99.0561 61.9121 99.2423 62.4408 99.3947 63.2571C99.3947 63.2571 99.2532 63.4269 98.98 63.352C98.9091 63.1512 98.6187 62.5657 98.3359 61.7804C98.6554 61.7358 98.8564 61.6351 98.9682 61.5586H98.9679Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M96.9117 57.5477L96.6797 58.9072L97.4901 59.0448L97.7221 57.6853L96.9117 57.5477Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M97.6378 55.7609C97.6378 55.7609 98.2704 55.7889 98.294 56.5809C98.3007 56.8059 98.2167 57.0271 98.2768 57.1431C98.4043 57.3902 98.5975 57.517 98.2739 57.5706C98.2739 57.5706 98.2362 57.6633 98.2196 57.7793C98.1918 57.9725 98.156 58.2303 97.9592 58.2303C97.7298 58.2303 97.4404 57.9957 97.0768 57.7248C96.9487 57.6292 96.8403 57.4931 96.7624 57.3446C96.5483 56.9357 96.2566 55.9891 97.1582 55.7727C97.2905 55.7411 97.4487 55.7612 97.6378 55.7612V55.7609Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M97.1962 57.0809C97.1962 57.0809 97.1534 56.9553 96.9844 56.9699C96.8211 56.9843 96.8767 57.4024 97.0202 57.4713C97.1636 57.5401 97.2112 57.3323 97.2112 57.3323L97.1962 57.0809Z","fill":"#EA997D"}}),_c('path',{attrs:{"d":"M96.1019 57.9827C96.1019 57.9827 96.2252 58.2846 96.5725 58.1536C96.6185 58.1364 97.091 58.1788 97.1645 58.1972C97.2492 58.2186 97.4421 58.1325 97.354 57.3217C97.2897 56.7308 97.6789 56.6613 97.7057 56.4427C97.7057 56.4427 97.7172 56.5775 97.5846 56.742C97.5846 56.742 97.731 56.7713 97.8105 56.7273C97.892 56.6824 97.9527 56.5316 97.983 56.4051C97.983 56.4051 97.969 56.6075 97.8533 56.742C97.8533 56.742 97.9977 56.7968 98.0613 56.6435C98.0613 56.6435 98.0441 56.7273 98.0338 56.7493C98.0338 56.7493 98.1821 56.7764 98.2923 56.5887C98.2923 56.5887 98.269 56.7496 98.2568 56.9087C98.2568 56.9087 98.4457 56.5622 98.4882 56.4414C98.5712 56.2052 98.531 55.9216 98.2668 55.797C98.2668 55.797 98.1652 55.4094 97.6287 55.5362C97.429 55.5834 96.7965 55.5901 96.6207 55.7667C96.484 55.9041 96.2172 56.0816 96.237 56.5998C96.2728 57.5372 96.3453 57.5235 96.1016 57.9831L96.1019 57.9827Z","fill":"#9A3412"}}),_c('path',{attrs:{"d":"M98.8688 60.9739C98.8688 60.9739 98.9729 61.046 98.9736 61.1413C98.9742 61.2366 99.1167 61.1945 99.1065 61.3398C99.0959 61.4852 99.156 61.6598 99.156 61.6598C99.156 61.6598 98.9733 62.1825 98.3151 62.1688C98.3151 62.1688 98.2474 61.9961 98.2062 61.9789C98.1653 61.9613 97.9825 61.8702 97.9918 61.6876C98.0007 61.5049 97.7474 61.5629 97.7372 61.248C97.7269 60.9332 97.2298 59.3156 97.2298 59.3156C97.2298 59.3156 96.8982 58.8984 97.5429 58.7942C98.1487 58.6964 98.8199 60.8704 98.8688 60.9743V60.9739Z","fill":"#0891B2"}}),_c('path',{attrs:{"d":"M93.9766 63.9598C93.9766 63.9598 95.4152 65.6636 97.713 64.5271V62.959L95.4076 62.9628L93.9766 63.9594V63.9598Z","fill":"#0891B2"}}),_c('path',{attrs:{"d":"M100.006 73.295C99.8424 73.2695 99.4488 72.8723 99.4488 72.8723C99.4488 72.8723 99.3379 72.7174 99.3379 72.633C99.6797 72.5249 99.7762 72.633 99.7762 72.633L100.113 73.1222C100.113 73.1222 100.157 73.1503 100.235 73.1863C100.229 73.244 100.107 73.3112 100.006 73.2953L100.006 73.295Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M99.4866 72.8341C99.4866 72.8341 99.8428 73.2121 100.007 73.2376C100.108 73.2536 100.188 73.2166 100.235 73.1863C100.294 73.2134 100.373 73.2453 100.469 73.273C100.69 73.3371 100.552 73.5003 100.552 73.5003C100.437 73.5707 99.9856 73.5197 99.9022 73.5003C99.8188 73.4808 99.4671 73.0681 99.4671 73.0681L99.4862 73.5197H99.3706C99.3585 73.2905 99.314 73.1334 99.2907 73.0053C99.2383 72.7194 99.337 72.6426 99.337 72.6426C99.3805 72.6658 99.4862 72.8338 99.4862 72.8338L99.4866 72.8341Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M99.7762 72.6328L99.8918 70.7711L99.248 70.7695L99.3378 72.6331C99.3378 72.6331 99.6219 72.8062 99.7762 72.6331V72.6328Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M93.5341 72.624C93.4217 72.5025 93.3594 71.9477 93.3594 71.9477C93.3594 71.9477 93.3686 71.7577 93.421 71.6914C93.7565 71.8179 93.7651 71.9623 93.7651 71.9623L93.7258 72.5548C93.7258 72.5548 93.7428 72.6039 93.7821 72.6804C93.7408 72.7218 93.6038 72.6989 93.5341 72.624Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M93.4132 71.9408C93.4132 71.9408 93.4583 72.4577 93.5708 72.5791C93.6404 72.654 93.7263 72.6748 93.7816 72.6799C93.8113 72.7379 93.8538 72.8118 93.9117 72.8928C94.0458 73.0799 93.8359 73.1229 93.8359 73.1229C93.7014 73.1066 93.3791 72.7879 93.3257 72.721C93.272 72.6544 93.2567 72.1081 93.2567 72.1081L92.995 72.4695L92.9043 72.3981C93.0369 72.2113 93.096 72.0651 93.157 71.95C93.2934 71.6931 93.4168 71.6963 93.4168 71.6963C93.4362 71.7412 93.4132 71.9411 93.4132 71.9411V71.9408Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M93.764 71.9621L95.011 70.5722L94.5068 70.1729L93.4199 71.6912C93.4199 71.6912 93.5356 72.0026 93.764 71.9621Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M96.7345 58.4785C96.7345 58.4785 96.1389 59.5603 96.3044 60.4785C96.4699 61.3967 96.8786 62.0364 96.8786 62.0364C96.8786 62.0364 97.7291 62.2722 98.3591 61.9994C98.3591 61.9994 98.5057 60.3175 98.4294 59.9749C98.353 59.6323 97.5428 58.794 97.5428 58.794C97.5428 58.794 96.9613 58.8097 96.7348 58.4785H96.7345Z","fill":"white"}}),_c('path',{attrs:{"d":"M98.3584 61.9996C98.3584 61.9996 98.6837 62.8248 98.7409 64.1382C98.7409 64.1382 100.372 67.1332 100.516 70.9904C100.516 70.9904 99.191 71.5918 98.4504 71.2778C98.4504 71.2778 97.9252 69.0331 97.6651 68.4897C97.6651 68.4897 96.6868 69.9819 95.1051 70.9945C95.1051 70.9945 94.2542 70.345 93.8066 69.2027C93.8066 69.2027 96.107 66.7437 96.4945 65.9154C96.8821 65.0873 95.5785 64.9363 96.8779 62.0366C96.8779 62.0366 97.5469 61.8409 98.3584 61.9996Z","fill":"#285E72"}}),_c('path',{attrs:{"d":"M96.6124 58.56C96.6124 58.56 97.3948 59.0662 97.4616 60.2356C97.5699 62.1307 96.0047 64.3037 93.9689 65.5983C93.9689 65.5983 93.7782 65.7666 93.5587 65.4237C93.3392 65.0811 93.3104 64.0433 93.4823 63.729C93.6542 63.4148 95.5437 62.4057 95.5437 62.4057C95.5437 62.4057 95.5437 62.2247 95.7344 62.044C95.7344 62.044 96.3156 59.2737 96.4354 58.931C96.4354 58.931 96.4344 58.452 96.6124 58.5597V58.56Z","fill":"#0891B2"}}),_c('path',{attrs:{"d":"M95.2612 61.1849C95.2612 61.1849 94.5254 62.4257 94.0078 63.6502C94.0078 63.6502 94.0717 63.902 94.3132 63.8838C94.3132 63.8838 95.719 61.953 95.9228 61.5674L95.2612 61.1846V61.1849Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M96.1243 59.0438C96.1243 59.0438 95.3808 60.7117 95.3214 60.8098C95.3214 60.8098 95.2105 60.8707 95.2 60.9654C95.1894 61.06 95.0521 61.0036 95.0473 61.1493C95.0425 61.2949 94.9648 61.4626 94.9648 61.4626C94.9648 61.4626 95.0926 62.0012 95.7489 62.0554C95.7489 62.0554 95.8342 61.8906 95.8767 61.8775C95.9192 61.8645 96.1272 61.8265 96.1371 61.6439C96.147 61.4613 96.4102 61.5792 96.4527 61.2672C96.4955 60.9548 97.1792 60.0057 97.1792 60.0057C97.1792 60.0057 97.1639 59.2248 96.6131 58.8927C96.277 58.69 96.124 59.0441 96.124 59.0441L96.1243 59.0438Z","fill":"#0891B2"}}),_c('path',{attrs:{"d":"M93.9737 63.6981C93.9737 63.6981 93.6181 64.1453 93.5813 64.1874C93.5446 64.2295 93.5139 64.2903 93.5296 64.3643C93.5417 64.4216 93.6503 64.8538 93.7954 64.8258C93.9404 64.7977 94.1916 64.6757 94.1916 64.6757C94.1916 64.6757 94.2465 64.6569 94.2232 64.6049C94.2075 64.5702 94.1634 64.5632 94.1535 64.5632L94.2488 64.5214C94.2488 64.5214 94.2976 64.5026 94.2794 64.458C94.2641 64.4204 94.1973 64.4076 94.1973 64.4076C94.1973 64.4076 94.2686 64.3879 94.2532 64.3381C94.2424 64.3034 94.2075 64.2922 94.1932 64.2919C94.1932 64.2919 94.2344 64.2463 94.1893 64.204C94.1893 64.204 94.3331 64.042 94.3085 63.8119C94.3085 63.8119 94.3411 63.6589 94.1938 63.5993C94.0465 63.5397 93.973 63.6981 93.973 63.6981H93.9737Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M93.7474 64.3046C93.6414 64.3891 93.764 64.6708 93.796 64.7103C93.8356 64.7591 94.043 64.6813 94.1273 64.6507C94.1816 64.631 94.1954 64.5969 94.1989 64.5781C94.1807 64.5663 94.1596 64.5631 94.1532 64.5631L94.2484 64.5213C94.2484 64.5213 94.2973 64.5025 94.2791 64.4579C94.2637 64.4203 94.197 64.4076 94.197 64.4076C94.197 64.4076 94.2647 64.3938 94.2529 64.3381C94.2462 64.3068 94.2072 64.2922 94.1928 64.2919C94.1928 64.2919 94.234 64.2463 94.189 64.2039C93.949 64.1513 93.8529 64.2201 93.7468 64.3046H93.7474Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M94.1897 64.204C94.1897 64.204 94.1258 64.3063 94.0929 64.385C94.0472 64.494 94.0152 64.5667 93.9961 64.6257C93.9542 64.7528 93.8363 64.7066 93.8689 64.6018C93.8996 64.5026 93.9191 64.394 93.9184 64.3433C93.9175 64.2786 93.9015 64.2356 93.8922 64.2129C93.8922 64.2129 93.9328 64.0714 94.0679 64.0883C94.2028 64.1052 94.2079 64.1715 94.19 64.2043L94.1897 64.204Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M93.6643 64.4238L93.8784 64.5077L92.718 67.5836L92.5039 67.4998L93.6643 64.4238Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M93.9469 64.525C93.9827 64.4345 93.9379 64.3319 93.8469 64.2965C93.7561 64.2608 93.6533 64.3054 93.6178 64.3962C93.582 64.4868 93.6267 64.5891 93.7178 64.6248C93.8085 64.6605 93.9114 64.6158 93.9469 64.525Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M90.6254 72.9021C90.5542 73.0835 90.3487 73.1727 90.1673 73.1013L88.5056 72.4502C88.3238 72.3791 88.2344 72.1742 88.3059 71.9928L90.574 66.2316C90.6452 66.0503 90.8507 65.961 91.0321 66.0324L92.6938 66.6836C92.8756 66.7546 92.9651 66.9596 92.8935 67.1406L90.6254 72.9018V72.9021Z","fill":"#D4D4D4"}}),_c('path',{attrs:{"d":"M91.8204 66.3434L89.293 72.7607L89.3753 72.793L91.9028 66.3757L91.8204 66.3434Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M90.3055 73.3593C90.2627 73.468 90.1703 73.533 90.0988 73.5053C90.0272 73.4772 90.0042 73.3666 90.0467 73.2579C90.0895 73.1493 90.1818 73.0839 90.2534 73.112C90.3246 73.14 90.348 73.2506 90.3052 73.3593H90.3055Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M88.5437 72.6698C88.5008 72.7785 88.4085 72.8439 88.337 72.8158C88.2654 72.7878 88.2424 72.6772 88.2852 72.5685C88.328 72.4598 88.4203 72.3945 88.4919 72.4225C88.5632 72.4506 88.5865 72.5612 88.5437 72.6698Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M113.334 68.3331L113.536 68.3163C113.536 68.3071 113.483 67.4015 112.548 67.397C111.613 67.3925 111.551 68.2977 111.551 68.3069L111.753 68.3248C111.755 68.2984 111.806 67.6537 112.546 67.6571C113.287 67.6605 113.332 68.3057 113.333 68.3332L113.334 68.3331Z","fill":"#713F12"}}),_c('path',{attrs:{"d":"M114.202 68.1864L114.176 73.5947L116.365 73.6053L116.391 68.197L114.202 68.1864Z","fill":"#854D0E"}}),_c('path',{attrs:{"d":"M109.223 68.1611L109.197 73.5693L114.54 73.5951L114.567 68.1868L109.223 68.1611Z","fill":"#A16207"}}),_c('path',{attrs:{"d":"M109.204 68.8263C109.179 68.8073 109.167 68.7637 109.167 68.7153L109.169 68.233C109.169 68.1664 109.192 68.1089 109.23 68.1091L109.52 68.1104C109.548 68.1102 109.573 68.1426 109.583 68.1885C109.593 68.2343 109.587 68.2885 109.566 68.3224L109.275 68.8031C109.261 68.8248 109.246 68.836 109.229 68.8361C109.22 68.8361 109.213 68.833 109.204 68.8263Z","fill":"#713F12"}}),_c('path',{attrs:{"d":"M109.206 72.8718C109.224 72.8717 109.241 72.8834 109.254 72.9054L109.541 73.3889C109.561 73.4229 109.568 73.4754 109.557 73.5211C109.546 73.5667 109.521 73.5968 109.493 73.5966L109.203 73.5953C109.165 73.5951 109.143 73.5411 109.143 73.4744L109.146 72.9922C109.146 72.9441 109.158 72.9004 109.184 72.8818C109.193 72.8753 109.198 72.8721 109.207 72.8721L109.206 72.8718Z","fill":"#713F12"}}),_c('path',{attrs:{"d":"M114.585 68.8554C114.572 68.8771 114.555 68.8883 114.537 68.8884C114.536 68.8884 114.534 68.8878 114.532 68.8875C114.531 68.8875 114.529 68.8885 114.527 68.8885C114.51 68.8885 114.492 68.8768 114.479 68.8549L114.192 68.3714C114.171 68.3374 114.165 68.2832 114.176 68.2373C114.186 68.1916 114.212 68.1597 114.24 68.1598L114.53 68.1611C114.531 68.1611 114.533 68.1617 114.535 68.1621C114.537 68.162 114.539 68.1611 114.54 68.1611L114.83 68.1623C114.858 68.1622 114.883 68.1946 114.893 68.2402C114.904 68.286 114.897 68.3393 114.877 68.3731L114.585 68.8548L114.585 68.8554Z","fill":"#713F12"}}),_c('path',{attrs:{"d":"M114.458 72.9309C114.472 72.9091 114.489 72.8979 114.506 72.8978C114.508 72.8978 114.51 72.8984 114.512 72.8987C114.514 72.8987 114.515 72.8978 114.517 72.8978C114.535 72.8977 114.552 72.9094 114.565 72.9313L114.852 73.4149C114.872 73.4489 114.878 73.5014 114.868 73.5471C114.857 73.5927 114.832 73.6228 114.804 73.6226L114.514 73.6213C114.512 73.6213 114.511 73.6207 114.509 73.6204C114.507 73.6204 114.505 73.6213 114.503 73.6213L114.213 73.6201C114.185 73.6202 114.16 73.5897 114.15 73.5438C114.14 73.498 114.147 73.4457 114.167 73.4118L114.459 72.9312L114.458 72.9309Z","fill":"#713F12"}}),_c('path',{attrs:{"d":"M116.353 68.8706C116.336 68.8706 116.316 68.8586 116.303 68.8367L116.016 68.3528C115.995 68.3188 115.989 68.2656 116 68.2197C116.01 68.1741 116.036 68.1421 116.064 68.1423L116.353 68.1435C116.391 68.1437 116.441 68.2018 116.441 68.2684L116.438 68.7507C116.438 68.7988 116.412 68.8422 116.386 68.8612C116.377 68.8676 116.361 68.8705 116.353 68.8706L116.353 68.8706Z","fill":"#713F12"}}),_c('path',{attrs:{"d":"M116.366 72.9163C116.391 72.9353 116.418 72.9792 116.417 73.0273L116.415 73.5096C116.415 73.5762 116.363 73.6299 116.325 73.6298L116.036 73.6285C116.008 73.6287 115.982 73.5982 115.972 73.5523C115.962 73.5065 115.969 73.4542 115.989 73.4203L116.281 72.9396C116.294 72.9179 116.313 72.9067 116.331 72.9066C116.34 72.9065 116.357 72.91 116.366 72.9166L116.366 72.9163Z","fill":"#713F12"}}),_c('path',{attrs:{"d":"M110.397 68.1679L110.371 73.5762L110.658 73.5776L110.684 68.1693L110.397 68.1679Z","fill":"#713F12"}}),_c('path',{attrs:{"d":"M113.055 68.1806L113.029 73.5889L113.29 73.5901L113.316 68.1818L113.055 68.1806Z","fill":"#713F12"}}),_c('path',{attrs:{"d":"M113.431 69.8918C113.432 69.5502 113.649 69.2741 113.916 69.2752C114.182 69.2766 114.396 69.5545 114.395 69.8965C114.393 70.2382 114.176 70.5142 113.91 70.5132C113.643 70.5118 113.429 70.2338 113.431 69.8922L113.431 69.8918Z","fill":"#FFEC1A"}}),_c('path',{attrs:{"d":"M111.852 71.9583C111.835 72.047 111.878 72.1364 111.947 72.1574L112.523 72.334C112.592 72.355 112.662 72.3002 112.678 72.2116L112.92 70.9254C112.936 70.8367 112.894 70.7473 112.825 70.7263L112.249 70.5497C112.18 70.5287 112.11 70.5835 112.093 70.6721L111.852 71.9583Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M111.554 69.4194C111.553 69.5954 111.768 69.7391 112.034 69.7402C112.3 69.7416 112.516 69.5997 112.516 69.4241C112.517 69.2482 112.303 69.1044 112.037 69.1034C111.771 69.102 111.555 69.2435 111.554 69.4194Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M111.166 70.7886C111.167 70.5291 111.332 70.3196 111.534 70.3206C111.737 70.3217 111.899 70.5326 111.898 70.792C111.897 71.0515 111.732 71.261 111.53 71.2599C111.328 71.2589 111.165 71.048 111.166 70.7886Z","fill":"#ABE532"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_164_6472"}},[_c('rect',{attrs:{"width":"25.6704","height":"18.5076","fill":"white","transform":"translate(144.047 92.7314)"}})])])])
}
var newsletter_banner_mail_svgvue_type_template_id_f31f1908_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/newsletter-banner-mail-svg.vue?vue&type=template&id=f31f1908

// CONCATENATED MODULE: ./src/components/svg/decorations/newsletter-banner-mail-svg.vue

var newsletter_banner_mail_svg_script = {}


/* normalize component */

var newsletter_banner_mail_svg_component = normalizeComponent(
  newsletter_banner_mail_svg_script,
  newsletter_banner_mail_svgvue_type_template_id_f31f1908_render,
  newsletter_banner_mail_svgvue_type_template_id_f31f1908_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var newsletter_banner_mail_svg = (newsletter_banner_mail_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/newsletter-banner-flight-svg.vue?vue&type=template&id=3d742104
var newsletter_banner_flight_svgvue_type_template_id_3d742104_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"260","height":"155","viewBox":"0 0 260 155","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_158_3456)"}},[_c('path',{attrs:{"d":"M32.0118 124.469C28.6207 111.758 32.2916 99.593 34.2414 95.8848C37.8776 88.9625 43.6885 83.694 46.6717 76.3673C52.7697 61.3885 48.3379 55.7394 55.1073 43.2284C56.6034 40.4642 62.7052 29.9454 73.1143 26.5757C83.357 23.2591 88.9667 29.7131 99.1308 31.2479C118.162 34.1218 125.021 15.4989 147.886 5.88375C169.844 -3.35088 203.57 -3.01977 217.84 16.3386C230.887 34.0377 219.483 56.5352 236.535 74.4063C245.259 83.5494 251.86 81.453 256.77 91.7596C262.767 104.349 259.784 121.895 253.066 132.154C247.95 139.967 240.968 143.564 240.968 143.564C238.549 144.811 236.39 145.459 234.856 145.816C171.146 145.634 107.436 145.453 43.7251 145.272C42.4118 143.853 40.6907 141.818 38.9073 139.155C37.7422 137.415 33.9122 131.603 32.01 124.47L32.0118 124.469Z","fill":"#ECFCCB"}}),_c('path',{attrs:{"d":"M219.54 58.1593C219.093 58.1593 218.671 58.2508 218.285 58.4154C217.678 56.6684 216.02 55.4098 214.067 55.4098C213.469 55.4098 212.898 55.5287 212.377 55.7427C211.799 52.2359 208.755 49.5613 205.086 49.5613C204.792 49.5613 204.503 49.5796 204.218 49.6144C202.597 45.8788 198.877 43.2646 194.546 43.2646C190.214 43.2646 186.494 45.8788 184.873 49.6144C184.588 49.5814 184.299 49.5613 184.005 49.5613C180.392 49.5613 177.387 52.1535 176.743 55.5799C176.359 55.472 175.953 55.4098 175.534 55.4098C173.738 55.4098 172.193 56.4727 171.483 58.002C171.115 57.8593 170.718 57.7788 170.301 57.7788C169.614 57.7788 168.977 57.991 168.45 58.3514C167.715 55.9842 165.509 54.2646 162.899 54.2646C160.671 54.2646 158.738 55.5196 157.763 57.3599C157.028 56.8422 156.134 56.5367 155.166 56.5367C153.641 56.5367 152.296 57.294 151.475 58.4484C150.924 58.0294 150.239 57.7788 149.494 57.7788C147.681 57.7788 146.211 59.2496 146.211 61.0625C146.211 61.1595 146.216 61.2565 146.226 61.3516H150.654H152.763H157.231H159.676H167.033H168.566H171.32H173.57H178.064H179.748H187.189H189.945H199.142H201.898H209.849H211.023H216.341H218.276H222.728C222.728 59.5881 221.297 58.1575 219.534 58.1575L219.54 58.1593Z","fill":"white"}}),_c('path',{attrs:{"d":"M123.461 21.9876C123.461 21.9876 123.669 22.9737 124.141 25.2128C124.147 25.2165 124.154 25.2183 124.16 25.222C124.533 25.3994 124.942 25.5769 125.385 25.7525C125.903 25.9574 126.464 26.1604 127.062 26.358C127.209 26.4074 127.359 26.455 127.509 26.5025C127.71 26.5665 127.915 26.6306 128.125 26.6928C133.952 28.449 142.39 29.7149 146.911 28.7618L186.688 20.3687C186.924 20.3193 187.048 20.2918 187.048 20.2918H187.046L184.667 17.4472L182.757 15.1641L182.528 14.8915L182.358 14.6885L181.676 13.8726L180.719 12.7292L178.711 10.3291L123.461 21.9876Z","fill":"white"}}),_c('path',{attrs:{"d":"M175.155 18.1661C175.249 18.6052 175.49 18.9985 175.86 19.3388C177.548 20.8992 181.885 21.3803 186.688 20.3669C186.808 20.3412 186.927 20.3156 187.046 20.2882C192.714 19.0095 196.854 16.0935 196.347 13.6933C196.294 13.4391 196.19 13.2012 196.04 12.9781C195.915 12.7933 195.758 12.6195 195.573 12.4585C195.473 12.3707 195.365 12.2866 195.246 12.2061C195.156 12.1439 195.061 12.0853 194.96 12.0268C194.523 11.7743 193.995 11.564 193.395 11.3975C191.24 10.8048 188.138 10.7883 184.815 11.4908C183.333 11.8036 181.95 12.228 180.719 12.7274C179.187 13.3494 177.888 14.0885 176.928 14.8714C176.445 15.2666 176.048 15.6709 175.75 16.0788C175.682 16.1721 175.618 16.2654 175.561 16.3587C175.487 16.4795 175.421 16.6002 175.364 16.7209C175.134 17.2112 175.057 17.696 175.155 18.1625V18.1661Z","fill":"white"}}),_c('path',{attrs:{"d":"M124.158 25.2196C124.531 25.3971 124.941 25.5745 125.384 25.7502C125.901 25.955 126.463 26.1581 127.061 26.3557C127.207 26.4051 127.357 26.4526 127.507 26.5002C127.708 26.5642 127.913 26.6283 128.123 26.6905C133.951 28.4466 142.388 29.7126 146.91 28.7595L186.686 20.3663C186.922 20.3169 187.046 20.2895 187.046 20.2895H187.045C192.713 19.009 196.852 16.0929 196.345 13.6928C196.292 13.4385 196.188 13.2007 196.038 12.9775C195.478 13.7916 194.341 14.8398 192.031 15.6502C191.123 15.9685 188.407 16.6161 184.665 17.4448C182.123 18.0083 179.105 18.6541 175.858 19.3382C160.615 22.5451 140.318 26.5642 140.318 26.5642C140.318 26.5642 136.777 27.5027 133.073 26.9649C130.982 26.6612 127.196 25.838 124.156 25.2196H124.158Z","fill":"white"}}),_c('path',{attrs:{"d":"M172.986 13.8614C173.246 15.0907 176.326 15.4804 179.869 14.734C183.41 13.9876 187.637 12.1345 186.865 11.1466C186.845 11.121 186.826 11.0972 186.805 11.0734C186.448 10.6637 185.877 10.3618 185.153 10.1624C185.14 10.1588 185.127 10.1551 185.114 10.1514C183.551 9.73252 181.288 9.78557 178.93 10.2832C175.389 11.0314 172.728 12.6321 172.986 13.8614Z","fill":"white"}}),_c('path',{attrs:{"d":"M115.633 12.1494L116.178 12.83L116.833 13.6513L116.995 13.8562L117.215 14.1306L123.494 21.9951L134.439 19.6846L123.843 12.7312L123.474 12.4897L123.198 12.3086L122.091 11.5823L121.173 10.9805L115.633 12.1494Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M183.579 11.8395L186.862 11.1462C186.842 11.1206 186.824 11.0968 186.802 11.073C186.445 10.6632 185.875 10.3614 185.15 10.162C185.143 10.162 185.138 10.162 185.13 10.1602L182.524 10.7108C181.944 10.8334 183.001 11.9621 183.579 11.8413V11.8395Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M168.575 17.7547C165.526 18.4077 163.909 18.9566 163.284 19.2383C163.132 19.306 162.755 19.6261 162.651 19.756L149.703 35.8343C149.703 35.8343 151.593 36.2276 153.482 35.8526C154.942 35.5635 157.202 34.358 157.202 34.358L175.418 17.2315C175.418 17.2315 171.059 17.2205 168.575 17.7528V17.7547Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M91.7493 79.3386C94.0612 79.3386 96.0677 80.6466 97.07 82.5656C97.6023 82.3003 98.2004 82.1467 98.8369 82.1467C98.9265 82.1467 99.0143 82.154 99.1021 82.1595C99.0655 81.8357 99.0454 81.5082 99.0454 81.1753C99.0454 76.4189 102.899 72.5645 107.655 72.5645C111.94 72.5645 115.494 75.6982 116.151 79.7996C116.218 79.7978 116.288 79.7959 116.356 79.7959C118.335 79.7959 120.014 81.0673 120.626 82.8382C120.84 82.7906 121.06 82.7668 121.287 82.7668C121.879 82.7668 122.432 82.9351 122.904 83.2205C123.65 82.0643 124.947 81.3015 126.423 81.3015C128.374 81.3015 130.015 82.6369 130.48 84.4443C130.697 84.395 130.922 84.3657 131.156 84.3657C132.131 84.3657 132.998 84.8303 133.549 85.5511H85.7537C85.7518 85.4816 85.75 85.4103 85.75 85.3407C85.75 82.0259 88.4369 79.3386 91.753 79.3386H91.7493Z","fill":"white"}}),_c('path',{attrs:{"d":"M41.0948 149.241C40.3888 151.433 38.2186 151.528 36.9297 151.476C37.1962 150.823 38.4316 148.241 41.0948 149.241Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M40.7015 149.609C40.6528 149.592 40.6102 149.559 40.5822 149.511C40.5189 149.404 40.5542 149.265 40.6613 149.201C43.9561 147.256 47.694 145.669 51.472 144.608C54.6561 143.715 57.856 143.202 60.4826 143.162C60.6079 143.16 60.7102 143.26 60.7114 143.385C60.7138 143.509 60.614 143.613 60.4887 143.614C55.7893 143.683 48.1723 145.29 40.8889 149.59C40.8293 149.625 40.7599 149.63 40.6991 149.608L40.7015 149.609Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M57.2471 142.593C52.9299 140.874 53.4277 137.495 53.7064 134.903C54.9881 135.529 59.6242 137.361 57.2471 142.593Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M52.8322 143.186C49.1321 142.711 48.8448 139.986 48.543 137.915C49.664 138.146 53.6355 138.644 52.8322 143.186Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M48.2501 144.773C45.0624 145.121 44.2737 142.9 43.6055 141.231C44.5889 141.199 48.0067 140.816 48.2501 144.773Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M43.9591 146.66C42.1176 147.42 41.2619 146.232 40.5742 145.351C41.156 145.161 43.129 144.34 43.9591 146.66Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M57.1602 145.018C53.5587 146.979 54.3511 149.886 54.8671 152.127C55.9236 151.443 59.7929 149.351 57.1602 145.018Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M52.3728 145.753C49.0402 146.94 49.325 149.524 49.4638 151.504C50.4558 151.063 54.0342 149.799 52.3728 145.753Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M46.8697 147.468C44.9064 148.877 45.582 150.52 46.0469 151.793C46.6153 151.316 48.7258 149.811 46.8697 147.468Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M43.2401 148.886C41.9645 149.483 42.1763 150.496 42.3065 151.275C42.6826 151.062 44.0519 150.426 43.2401 148.886Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M30.0957 122.205C30.7359 122.405 31.2605 122.649 31.6914 122.906C31.0329 122.128 30.4255 121.348 29.8693 120.566C29.4129 120.795 28.1276 121.292 26.2799 120.787C23.9479 120.149 21.342 117.4 21.342 117.4C21.342 117.4 24.9386 116.552 27.3218 117.703C27.7648 117.917 28.1385 118.148 28.4513 118.38C27.9778 117.571 27.5579 116.759 27.1952 115.945C26.6645 116.105 25.5813 116.286 24.1876 115.741C22.1867 114.958 20.1406 112.285 20.1406 112.285C20.1406 112.285 23.3989 111.872 25.3975 113.113C25.7979 113.361 26.1229 113.618 26.3895 113.871C26.1533 113.158 25.9586 112.443 25.8089 111.73C25.3999 111.828 24.5138 111.932 23.4099 111.401C21.8824 110.667 20.4303 108.44 20.4303 108.44C20.4303 108.44 23.0192 108.309 24.5175 109.404C25.0263 109.776 25.3634 110.154 25.591 110.492C25.5606 110.279 25.5338 110.064 25.5119 109.851C25.2234 109.72 24.341 109.227 23.8055 107.921C23.1604 106.343 23.5766 103.706 23.5766 103.706C23.5766 103.706 25.5959 105.352 25.9769 107.178C26.1996 108.248 26.0353 108.993 25.86 109.429C25.8941 109.838 25.9416 110.248 26.0036 110.657C26.0547 110.215 26.2057 109.659 26.5793 109.051C27.4679 107.608 29.8316 106.394 29.8316 106.394C29.8316 106.394 29.694 108.983 28.4501 110.361C27.4557 111.463 26.5209 111.631 26.185 111.654C26.4016 112.68 26.7096 113.707 27.1064 114.732C27.2804 115.004 27.3875 115.245 27.4533 115.43C27.351 114.883 27.2889 113.791 27.9693 112.471C28.954 110.561 31.8252 108.803 31.8252 108.803C31.8252 108.803 31.8983 112.088 30.4584 113.946C29.0368 115.781 27.5969 115.811 27.5567 115.813C28.1628 117.165 28.9272 118.515 29.8437 119.859C29.6855 119.212 29.576 118.085 30.1225 116.678C30.9976 114.425 34.0015 112.116 34.0015 112.116C34.0015 112.116 34.4738 115.782 33.0826 118.033C31.9737 119.827 30.7103 120.306 30.2417 120.428C31.0755 121.593 32.0236 122.754 33.0886 123.909C32.8428 123.207 32.6359 122.091 32.9645 120.646C33.5499 118.064 36.4309 115.08 36.4309 115.08C36.4309 115.08 37.5325 118.974 36.3883 121.636C35.529 123.634 34.3326 124.393 33.7885 124.646C34.7148 125.604 35.7177 126.558 36.8009 127.507C36.4455 126.853 36.0524 125.763 36.1644 124.245C36.3591 121.605 38.7654 118.225 38.7654 118.225C38.7654 118.225 40.4341 121.913 39.6978 124.716C39.1208 126.915 37.9779 127.828 37.5105 128.12C38.522 128.977 39.5992 129.83 40.7348 130.678C40.3416 130.048 39.9181 129.055 39.8828 127.659C39.8158 125.012 41.8752 121.411 41.8752 121.411C41.8752 121.411 43.9006 124.916 43.4454 127.778C43.0997 129.955 42.1053 130.981 41.6476 131.349C42.7674 132.158 43.942 132.96 45.1737 133.758C44.7075 133.136 44.183 132.151 44.0089 130.724C43.6718 127.963 45.4634 123.99 45.4634 123.99C45.4634 123.99 47.9342 127.451 47.7468 130.49C47.6019 132.826 46.6465 134.001 46.2119 134.419C47.0932 134.973 47.9975 135.524 48.931 136.071C49.1319 136.188 49.3315 136.304 49.5311 136.419C49.0053 135.816 48.3846 134.834 48.1058 133.358C47.5739 130.552 49.1416 126.36 49.1416 126.36C49.1416 126.36 51.907 129.739 51.9191 132.867C51.9289 135.315 50.9953 136.584 50.5888 137.021C51.8498 137.731 53.1034 138.403 54.3328 139.037C53.7643 138.425 53.0803 137.415 52.7444 135.869C52.1115 132.958 53.628 128.543 53.628 128.543C53.628 128.543 56.6064 131.989 56.7062 135.249C56.7841 137.78 55.8627 139.129 55.4464 139.606C57.148 140.464 58.7912 141.246 60.3296 141.947C59.67 141.299 58.852 140.204 58.409 138.482C57.5886 135.296 59.0772 130.361 59.0772 130.361C59.0772 130.361 62.5071 134.039 62.7542 137.631C62.9465 140.424 61.9837 141.95 61.5444 142.493C63.3859 143.313 65.0461 144.005 66.4397 144.564C65.752 143.949 64.894 142.901 64.3669 141.232C63.3774 138.095 64.5994 133.088 64.5994 133.088C64.5994 133.088 68.2216 136.577 68.661 140.151C69.003 142.926 68.1255 144.502 67.7153 145.069C69.6688 145.829 70.8495 146.233 70.8848 146.245L70.7606 146.611C70.7241 146.598 69.5033 146.181 67.4877 145.394C67.327 145.807 66.4653 147.707 63.7863 148.869C60.769 150.177 55.6631 149.48 55.6631 149.48C55.6631 149.48 58.7583 145.516 62.2673 144.709C63.4979 144.427 64.5093 144.416 65.3066 144.522C64.1113 144.031 62.7615 143.459 61.2997 142.807C61.1147 143.217 60.1495 145.062 57.4194 146.076C54.3364 147.22 49.2743 146.25 49.2743 146.25C49.2743 146.25 52.5776 142.458 56.1244 141.84C57.3282 141.63 58.314 141.664 59.093 141.802C57.8442 141.22 56.5382 140.589 55.1957 139.911C54.9827 140.325 54.0321 141.902 51.5869 142.706C48.757 143.637 44.2097 142.585 44.2097 142.585C44.2097 142.585 47.3293 139.266 50.5608 138.829C51.6404 138.683 52.5204 138.744 53.2142 138.89C52.2636 138.39 51.3021 137.866 50.3356 137.323C50.0959 137.748 49.138 139.19 46.8193 139.883C44.0831 140.703 39.7525 139.577 39.7525 139.577C39.7525 139.577 42.8271 136.476 45.9356 136.14C46.9958 136.026 47.8514 136.112 48.5197 136.276C47.6336 135.754 46.7718 135.229 45.9332 134.701C45.6922 135.076 44.6722 136.448 42.3414 136.981C39.6308 137.602 35.4937 136.231 35.4937 136.231C35.4937 136.231 38.6802 133.416 41.7219 133.288C42.737 133.245 43.5488 133.378 44.1817 133.573C43.1971 132.921 42.2526 132.265 41.3409 131.605C41.0756 131.941 39.9838 133.143 37.7321 133.435C35.1079 133.776 31.3128 132.1 31.3128 132.1C31.3128 132.1 34.5882 129.723 37.4813 129.879C38.3406 129.925 39.0344 130.09 39.5882 130.296C38.7533 129.652 37.9512 129.005 37.1868 128.355C36.8338 128.706 35.6361 129.716 33.4514 129.781C30.8065 129.86 27.1964 127.816 27.1964 127.816C27.1964 127.816 30.6909 125.775 33.5548 126.217C34.2717 126.328 34.8645 126.51 35.3501 126.72C34.6722 126.09 34.0271 125.457 33.4173 124.821C33.0911 125.073 31.7315 125.987 29.4591 125.715C26.8313 125.399 23.5657 122.842 23.5657 122.842C23.5657 122.842 27.3242 121.343 30.0908 122.206L30.0957 122.205Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M49.8044 120.53L43.6018 120.136C42.3165 116.921 40.9971 113.258 39.5901 109.663L44.2627 109.98L38.8293 107.753C36.905 103.008 34.803 98.549 32.3906 95.6104C38.5908 96.3298 44.6023 99.2673 49.9322 103.149L52.9032 112.151L52.0098 104.737C56.7214 108.503 60.805 112.924 63.8795 117.018C70.7515 126.17 66.9369 141.598 66.9369 141.598C66.9369 141.598 51.5911 134.942 46.7688 126.922C45.9168 125.505 45.0721 123.694 44.2152 121.642L49.8044 120.531V120.53Z","fill":"#4D7C0F"}}),_c('path',{attrs:{"d":"M162.259 64.8894C162.259 64.8894 159.523 61.7777 159.313 61.5417C159.102 61.3039 158.418 60.5301 158.654 59.8514C158.89 59.1727 160.549 57.5153 160.944 57.7915C161.339 58.0677 163.445 60.1459 163.735 60.8173C164.024 61.4886 163.39 63.9455 162.259 64.8894Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M162.258 64.8896C162.258 64.8896 166.252 77.8452 170.876 78.7727C174.672 79.5355 178.829 69.4539 178.829 69.4539C178.829 69.4539 178.628 67.9538 176.987 66.7775C175.652 65.8208 174.198 66.622 174.198 66.622C174.198 66.622 171.306 71.8705 171.039 72.5345C171.039 72.5345 168.72 69.0953 164.912 63.5322C164.912 63.5322 162.594 63.5926 162.26 64.8878L162.258 64.8896Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M181.539 69.5893C181.6 66.7666 182.556 62.7365 178.32 59.1162C178.32 59.1162 176.555 60.5175 175.65 62.2115C174.102 65.1055 171.597 69.9332 170.688 71.6437C171.465 73.5371 175.037 75.3354 177.334 76.3616C180.028 72.723 181.539 69.5912 181.539 69.5912V69.5893Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M161.81 53.3568L158.57 58.2852L161.21 60.0206L164.449 55.0923L161.81 53.3568Z","fill":"#E5E5E5"}}),_c('path',{attrs:{"d":"M163.828 54.6766L160.59 59.6055L160.941 59.8365L164.18 54.9076L163.828 54.6766Z","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M160.43 54.9727L164.357 57.5539C164.522 57.6618 164.568 57.8832 164.458 58.0478L160.886 63.4829C160.778 63.6475 160.533 63.739 160.368 63.631L156.465 61.0059L160.428 54.9727H160.43Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M163.737 57.1489L159.746 63.2207L160.098 63.4518L164.088 57.38L163.737 57.1489Z","fill":"#FFEC1A"}}),_c('path',{attrs:{"d":"M160.429 57.2614C160.731 56.8022 161.349 56.6742 161.808 56.976C162.267 57.2779 162.395 57.8962 162.094 58.3553C161.792 58.8145 161.174 58.9426 160.714 58.6407C160.255 58.3389 160.127 57.7206 160.429 57.2614Z","fill":"#ABE532"}}),_c('path',{attrs:{"d":"M164.911 63.5341C164.911 63.5341 164.329 60.6199 164.216 60.3309C164.102 60.0418 162.268 57.5795 162.006 57.6673C161.745 57.7551 161.487 58.1978 162.013 58.9698C162.54 59.7418 162.917 60.8559 162.917 60.8559C162.917 60.8559 161.75 62.3651 161.723 63.0054C161.697 63.6457 161.948 64.4963 162.257 64.8878C162.257 64.8878 163.866 64.7525 164.909 63.5323L164.911 63.5341Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M204.516 138.824L206.259 141.829L208.993 140.284L207.336 137.229L204.516 138.824Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M203.571 143.046C203.734 142.927 205.283 140.75 205.389 140.684C205.389 140.684 205.591 140.402 206.739 140.81C207.323 141.017 208.223 139.61 208.848 139.74C208.848 139.74 210.154 140.766 209.828 141.708L209.949 142.352C209.949 142.352 209.088 143.263 208.076 143.47C208.076 143.47 207.028 143.38 206.615 143.999C205.837 145.159 202.75 146.73 202.093 145.625L202.113 145.614C202.057 145.572 202.011 145.521 201.982 145.455C201.585 144.566 202.763 143.636 203.573 143.046H203.571Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M179.095 139.629L178.789 143.09L181.915 143.401L182.319 139.949L179.095 139.629Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M173.419 144.503C173.483 143.531 174.959 143.26 175.952 143.116C176.15 143.087 178.539 141.888 178.663 141.877C178.663 141.877 178.972 141.722 179.797 142.62C180.216 143.076 181.67 142.252 182.162 142.66C182.162 142.66 182.862 144.21 182.133 144.89L181.939 145.516C181.939 145.516 180.726 145.886 179.733 145.597C179.733 145.597 178.849 145.028 178.195 145.381C176.966 146.043 173.501 145.986 173.437 144.704H173.461C173.43 144.642 173.414 144.574 173.419 144.503Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M179.563 84.592L179.481 92.5571C179.481 92.5571 179.005 114.255 177.875 140.633L183.364 141.213C183.364 141.213 188.345 102.966 189.358 99.3331C189.358 99.3331 192.33 119.884 193.905 123.043C195.48 126.203 203.88 140.177 203.88 140.177L208.667 137.735C208.667 137.735 201.194 121.445 200.645 119.348C200.096 117.252 199.619 92.1949 199.619 92.1949V84.5811L179.563 84.592Z","fill":"#164E63"}}),_c('path',{attrs:{"d":"M185.918 53.7597C185.918 53.7597 189.221 52.6475 192.223 53.8713L192.643 55.7464H185.312L185.918 53.7597Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M181.361 39.4783C182.327 37.0983 186.31 36.4672 190.257 38.0697C194.204 39.6722 196.623 42.901 195.657 45.281C194.691 47.661 190.707 48.2922 186.76 46.6896C182.813 45.0871 180.395 41.8583 181.361 39.4783Z","fill":"#164E63"}}),_c('path',{attrs:{"d":"M186.158 46.9004C186.158 46.9004 186.339 53.4806 186.158 54.1776C185.977 54.8746 184.801 55.6832 182.469 56.8594C182.469 56.8594 184.773 60.8914 189.163 60.7999C193.553 60.7084 194.813 57.8345 195.51 56.8338C195.51 56.8338 192.037 55.4947 191.936 54.3075C191.817 52.8861 191.936 46.9022 191.936 46.9022H186.16L186.158 46.9004Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M193.009 44.4117C192.949 48.0228 190.979 50.4504 189.609 51.4913C188.645 52.2231 187.659 52.2798 186.781 52.2798C183.975 52.2798 183.284 49.0583 183.037 44.8727C182.677 38.7589 184.326 38.4004 187.792 38.4004C191.655 38.4004 193.078 40.2499 193.009 44.4135V44.4117Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M184.266 40.5539C184.266 40.5539 185.68 40.1551 185.872 40.8576C186.064 41.5601 186.124 42.1491 186.984 42.2552C187.844 42.3613 186.988 43.5065 188.18 43.5285C188.18 43.5285 187.937 43.2157 188.025 43.04C188.113 42.8644 188.2 42.601 188.078 42.3723C188.078 42.3723 190.483 43.6145 190.483 44.4047L190.476 44.9901L190.904 45.0029L191.904 48.7275C191.904 48.7275 193.181 46.8232 193.72 45.281C194.282 43.673 194.353 42.0266 194.353 42.0266C194.353 42.0266 194.626 41.4448 194.52 40.9527C194.414 40.4606 193.783 39.9832 193.677 39.0721C193.57 38.1593 192.519 37.455 191.694 37.5775C190.869 37.7001 190.395 36.3299 189.184 36.8915C187.974 37.4532 187.814 35.5488 186.874 36.9793C186.293 37.8666 184.985 36.1708 184.903 38.1209C184.903 38.1209 182.971 38.2434 183.163 38.8929C183.357 39.5423 181.356 40.4368 182.426 41.5253L182.989 43.3108C183.059 42.9778 182.971 42.2022 183.094 41.5875C183.216 40.9729 183.523 40.3143 184.264 40.5503L184.266 40.5539Z","fill":"#FDBA74"}}),_c('path',{attrs:{"d":"M190.897 44.9186C190.897 44.9186 191.091 44.2198 192.031 44.3039C192.94 44.3844 192.934 46.5833 192.135 46.9693C191.334 47.3535 190.844 46.329 190.844 46.329L190.897 44.9204V44.9186Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M194.637 42.0063C194.637 42.0063 194.866 36.4012 191.753 36.1615C191.753 36.1615 191.48 36.1451 190.893 35.7646C190.306 35.384 189 34.2626 184.367 37.8372C184.367 37.8372 190.092 40.1623 194.637 42.0063Z","fill":"#164E63"}}),_c('path',{attrs:{"d":"M194.566 40.3981C194.665 41.3109 194.637 42.0061 194.637 42.0061C190.094 40.1621 184.367 37.837 184.367 37.837C184.896 37.429 185.379 37.0833 185.825 36.7906C190.462 36.496 193.328 38.9858 194.566 40.3981Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M188.929 40.6765C185.864 39.4326 182.677 40.0088 181.406 41.9242C181.09 41.0753 181.053 40.2338 181.36 39.4783C182.326 37.0983 186.31 36.4672 190.257 38.0697C194.204 39.6722 196.622 42.901 195.656 45.281C195.281 46.2049 194.451 46.8634 193.346 47.2311C194.109 44.8877 192.185 41.9973 188.927 40.6747L188.929 40.6765Z","fill":"#164E63"}}),_c('path',{attrs:{"d":"M190.101 38.4613C186.259 36.9008 182.385 37.457 181.289 39.6833C181.311 39.6156 181.335 39.5461 181.362 39.4802C182.328 37.1002 186.312 36.4691 190.259 38.0716C194.206 39.6742 196.624 42.903 195.658 45.283C195.631 45.3507 195.6 45.4184 195.568 45.4824C196.337 43.1225 193.944 40.0217 190.101 38.4613Z","fill":"#164E63"}}),_c('path',{attrs:{"d":"M192.221 53.8532C192.221 53.8532 191.105 57.3162 188.405 60.3163C188.405 60.3163 186.522 57.0509 185.916 53.7471C185.916 53.7471 184.705 54.9453 184.1 55.5069C184.1 55.5069 184.125 55.635 184.116 55.6405C181.949 56.6173 179.659 58.0131 178.316 59.1144C178.316 59.1144 178.79 84.6414 178.825 92.3759C178.825 92.3759 182.467 92.9997 187.31 93.1589L187.943 87.6873L188.837 93.1754C191.76 93.1003 197.092 92.8003 199.971 92.0942C199.971 92.0942 200.446 59.8681 200.384 59.1144C200.384 59.1144 196.978 57.0911 193.964 55.8399C193.964 55.8399 193.975 55.6258 193.957 55.538C193.957 55.538 192.728 54.2264 192.219 53.8532H192.221Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M185.747 74.1359C185.747 74.1359 184.207 62.5633 183.777 55.769C183.777 55.769 183.874 55.6355 184.043 55.6318C184.043 55.6318 185.747 71.7339 186.071 74.07L185.747 74.1359Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M193.052 74.0501C193.052 74.0501 194.506 61.4366 194.322 55.9467C194.322 55.9467 194.225 55.7766 193.969 55.8406C193.969 55.8406 193.934 61.7732 192.699 73.9623L193.052 74.0482V74.0501Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M186.936 73.4023H185.793V73.8597H186.936V73.4023Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M192.769 73.6309H185.908C185.592 73.6309 185.336 73.8872 185.336 74.2035V77.8622C185.336 78.1784 185.592 78.4348 185.908 78.4348H192.769C193.085 78.4348 193.342 78.1784 193.342 77.8622V74.2035C193.342 73.8872 193.085 73.6309 192.769 73.6309Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M190.504 77.8493C191.543 77.6806 192.248 76.7015 192.08 75.6623C191.911 74.6232 190.932 73.9175 189.893 74.0862C188.854 74.2549 188.148 75.234 188.317 76.2732C188.486 77.3123 189.465 78.018 190.504 77.8493Z","fill":"#737373"}}),_c('path',{attrs:{"d":"M188.423 74.0879H185.906V74.6605H188.423V74.0879Z","fill":"#737373"}}),_c('path',{attrs:{"d":"M192.885 73.9727H191.855V74.43H192.885V73.9727Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M191.684 76.5942C192.025 75.7718 191.634 74.829 190.812 74.4884C189.99 74.1478 189.047 74.5383 188.706 75.3606C188.366 76.183 188.756 77.1257 189.579 77.4664C190.401 77.807 191.343 77.4165 191.684 76.5942Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M190.194 77.0061C190.763 77.0061 191.224 76.545 191.224 75.9762C191.224 75.4074 190.763 74.9463 190.194 74.9463C189.625 74.9463 189.164 75.4074 189.164 75.9762C189.164 76.545 189.625 77.0061 190.194 77.0061Z","fill":"white"}}),_c('path',{attrs:{"d":"M206.74 77.0599C206.74 77.0599 207.673 79.5844 208.933 91.982C208.933 91.982 207.956 92.9772 206.281 92.3625C205.869 90.7893 204.347 85.4384 202.588 78.7392C202.434 78.1557 201.578 75.9056 201.379 74.647C203.618 74.025 204.933 73.9646 206.308 73.4414C206.475 74.1786 206.55 76.2348 206.74 77.0599Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M200.386 59.1143C200.386 59.1143 202.367 60.071 203.476 62.9504C204.591 65.8536 204.67 65.464 207.463 75.5584C206.088 76.0816 203.09 76.9853 200.573 77.3347C199.779 72.3314 199.128 61.5967 200.386 59.1143Z","fill":"#65A30D"}}),_c('path',{attrs:{"d":"M209.121 92.4709C209.121 92.4709 209.946 95.8278 209.4 98.2133C209.193 99.1133 209.209 99.7756 208.361 100.2C208.361 100.2 207.346 100.789 206.971 100.747C206.971 100.747 206.742 100.451 207.035 100.035C207.327 99.6201 208.097 99.1829 207.962 98.5225C207.852 97.9864 207.591 96.0729 207.309 96.2504C207.027 96.4278 207.06 98.8536 206.354 98.8481C206.354 98.8481 206.166 98.8517 206.045 98.1419C205.924 97.4321 205.796 94.6442 205.924 94.1137C206.052 93.5832 206.168 92.0209 206.168 92.0209C206.168 92.0209 207.483 90.2592 208.871 91.2782L209.123 92.4709H209.121Z","fill":"#FDD6A9"}}),_c('path',{attrs:{"d":"M142.233 86.2049C142.233 86.2049 143.841 88.7422 144.049 90.8606C144.128 91.6582 144.325 92.2016 143.742 92.7851C143.742 92.7851 143.069 93.5516 142.749 93.6211C142.749 93.6211 142.478 93.44 142.606 93.0174C142.732 92.593 143.246 92.0223 142.952 91.5137C142.714 91.1021 141.969 89.5984 141.785 89.8215C141.6 90.0447 142.299 92.0351 141.717 92.2272C141.717 92.2272 141.563 92.282 141.267 91.7314C140.971 91.1808 140.095 88.9178 140.054 88.4459C140.014 87.9739 139.676 86.6531 139.676 86.6531C139.676 86.6531 140.272 84.8365 141.697 85.292L142.235 86.2049H142.233Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M139.727 76.6084C140.232 78.6372 141.298 81.6721 142.171 86.3571C142.171 86.3571 141.361 87.3321 139.797 86.9022C139.391 85.7497 137.728 82.3892 136.109 77.8816C137.938 77.6255 139.089 77.0474 139.729 76.6084H139.727Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M127.98 53.5862L126.652 61.3896L131.292 62.1795L132.62 54.3761L127.98 53.5862Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M132.127 43.3273C132.127 43.3273 135.748 43.4883 135.884 48.0342C135.922 49.3258 135.441 50.5953 135.785 51.2612C136.515 52.679 137.621 53.4071 135.768 53.7144C135.768 53.7144 135.552 54.2468 135.457 54.9126C135.298 56.0212 135.093 57.5012 133.967 57.5012C132.653 57.5012 130.996 56.1548 128.915 54.5998C128.181 54.051 127.561 53.2699 127.115 52.4174C125.89 50.0703 124.22 44.6371 129.381 43.395C130.138 43.2139 131.044 43.3291 132.127 43.3291V43.3273Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M129.603 50.9062C129.603 50.9062 129.358 50.1854 128.391 50.2695C127.456 50.3519 127.774 52.752 128.596 53.1471C129.417 53.5423 129.689 52.3495 129.689 52.3495L129.603 50.9062Z","fill":"#EA997D"}}),_c('path',{attrs:{"d":"M123.338 56.0831C123.338 56.0831 124.044 57.8155 126.032 57.0637C126.295 56.9649 129.001 57.2082 129.421 57.3143C129.906 57.4369 131.011 56.9429 130.506 52.289C130.138 48.8974 132.366 48.4986 132.52 47.2436C132.52 47.2436 132.585 48.0175 131.826 48.9614C131.826 48.9614 132.664 49.1297 133.12 48.8773C133.586 48.6193 133.933 47.754 134.107 47.0278C134.107 47.0278 134.027 48.1894 133.365 48.9614C133.365 48.9614 134.191 49.2761 134.555 48.3961C134.555 48.3961 134.457 48.8773 134.398 49.0035C134.398 49.0035 135.247 49.159 135.878 48.0815C135.878 48.0815 135.744 49.0053 135.675 49.9182C135.675 49.9182 136.756 47.9296 136.999 47.2363C137.475 45.8808 137.244 44.2526 135.731 43.5373C135.731 43.5373 135.15 41.3128 132.079 42.0409C130.936 42.3117 127.314 42.3501 126.308 43.3636C125.525 44.152 123.998 45.171 124.111 48.1455C124.316 53.5257 124.732 53.447 123.336 56.085L123.338 56.0831Z","fill":"#9A3412"}}),_c('path',{attrs:{"d":"M139.164 73.257C139.164 73.257 139.76 73.6704 139.764 74.2174C139.768 74.7644 140.584 74.5229 140.525 75.3571C140.465 76.1913 140.809 77.1938 140.809 77.1938C140.809 77.1938 139.762 80.1939 135.994 80.1153C135.994 80.1153 135.607 79.1237 135.371 79.025C135.137 78.9243 134.09 78.4011 134.143 77.3529C134.195 76.3047 132.744 76.6376 132.686 74.8302C132.627 73.0228 129.781 63.7388 129.781 63.7388C129.781 63.7388 127.883 61.3441 131.574 60.7459C135.042 60.1843 138.884 72.6624 139.164 73.2588V73.257Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M111.152 90.3878C111.152 90.3878 119.389 100.168 132.543 93.644V84.6436L119.345 84.6655L111.152 90.3859V90.3878Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M145.684 143.97C144.747 143.823 142.494 141.544 142.494 141.544C142.494 141.544 141.859 140.655 141.859 140.17C143.816 139.55 144.369 140.17 144.369 140.17L146.298 142.978C146.298 142.978 146.549 143.139 146.997 143.346C146.959 143.677 146.262 144.063 145.682 143.972L145.684 143.97Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M142.713 141.32C142.713 141.32 144.752 143.49 145.691 143.636C146.27 143.728 146.729 143.515 146.997 143.342C147.337 143.497 147.79 143.68 148.337 143.839C149.605 144.207 148.815 145.144 148.815 145.144C148.152 145.548 145.57 145.255 145.092 145.144C144.615 145.032 142.601 142.663 142.601 142.663L142.711 145.255H142.049C141.979 143.94 141.725 143.038 141.592 142.303C141.292 140.662 141.857 140.221 141.857 140.221C142.106 140.354 142.711 141.318 142.711 141.318L142.713 141.32Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M144.367 140.168L145.029 129.483L141.344 129.474L141.858 140.17C141.858 140.17 143.484 141.163 144.367 140.17V140.168Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M108.629 140.124C107.986 139.427 107.629 136.242 107.629 136.242C107.629 136.242 107.682 135.152 107.982 134.771C109.902 135.498 109.952 136.326 109.952 136.326L109.727 139.727C109.727 139.727 109.824 140.009 110.049 140.448C109.813 140.686 109.028 140.554 108.629 140.124Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M107.937 136.208C107.937 136.208 108.195 139.175 108.839 139.872C109.238 140.302 109.73 140.421 110.046 140.45C110.216 140.783 110.459 141.207 110.79 141.672C111.559 142.746 110.357 142.993 110.357 142.993C109.587 142.9 107.741 141.07 107.436 140.686C107.129 140.304 107.041 137.168 107.041 137.168L105.543 139.243L105.023 138.833C105.782 137.761 106.121 136.921 106.47 136.261C107.251 134.786 107.957 134.805 107.957 134.805C108.069 135.063 107.937 136.21 107.937 136.21V136.208Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M109.95 136.327L117.089 128.349L114.203 126.057L107.98 134.772C107.98 134.772 108.643 136.559 109.95 136.327Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M126.949 58.9316C126.949 58.9316 123.539 65.1405 124.487 70.4109C125.434 75.6813 127.773 79.3528 127.773 79.3528C127.773 79.3528 132.642 80.7066 136.249 79.1406C136.249 79.1406 137.089 69.4871 136.652 67.5205C136.215 65.5539 131.576 60.7427 131.576 60.7427C131.576 60.7427 128.247 60.8324 126.95 58.9316H126.949Z","fill":"white"}}),_c('path',{attrs:{"d":"M136.25 79.1425C136.25 79.1425 138.112 83.8787 138.439 91.4175C138.439 91.4175 147.78 108.608 148.6 130.747C148.6 130.747 141.016 134.199 136.777 132.397C136.777 132.397 133.77 119.513 132.281 116.394C132.281 116.394 126.68 124.959 117.625 130.771C117.625 130.771 112.754 127.043 110.191 120.486C110.191 120.486 123.361 106.373 125.579 101.618C127.798 96.8654 120.335 95.9983 127.774 79.3547C127.774 79.3547 131.604 78.2315 136.25 79.1425Z","fill":"#285E72"}}),_c('path',{attrs:{"d":"M126.251 59.4C126.251 59.4 130.731 62.3051 131.113 69.017C131.733 79.8944 122.772 92.367 111.118 99.7979C111.118 99.7979 110.026 100.764 108.769 98.7954C107.513 96.8288 107.348 90.8724 108.332 89.0687C109.316 87.2649 120.133 81.4732 120.133 81.4732C120.133 81.4732 120.133 80.4341 121.225 79.3968C121.225 79.3968 124.552 63.496 125.238 61.5294C125.238 61.5294 125.233 58.7799 126.251 59.3982V59.4Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M118.515 74.4667C118.515 74.4667 114.303 81.5884 111.34 88.6168C111.34 88.6168 111.706 90.062 113.088 89.9577C113.088 89.9577 121.136 78.8754 122.303 76.6619L118.515 74.4648V74.4667Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M123.454 62.1769C123.454 62.1769 119.198 71.7499 118.858 72.3134C118.858 72.3134 118.223 72.6628 118.163 73.2061C118.102 73.7494 117.316 73.4256 117.288 74.2617C117.261 75.0977 116.816 76.0599 116.816 76.0599C116.816 76.0599 117.548 79.1516 121.305 79.4625C121.305 79.4625 121.793 78.5168 122.037 78.4418C122.28 78.3668 123.471 78.1491 123.527 77.1008C123.584 76.0526 125.091 76.7295 125.334 74.9385C125.579 73.1457 129.494 67.6979 129.494 67.6979C129.494 67.6979 129.406 63.216 126.253 61.3098C124.328 60.1463 123.452 62.1787 123.452 62.1787L123.454 62.1769Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M111.156 88.895C111.156 88.895 109.12 91.4616 108.91 91.7031C108.7 91.9446 108.524 92.294 108.614 92.7184C108.683 93.0477 109.305 95.5283 110.136 95.3673C110.966 95.2064 112.404 94.5057 112.404 94.5057C112.404 94.5057 112.718 94.3978 112.585 94.0996C112.495 93.9002 112.243 93.8599 112.186 93.8599L112.731 93.6203C112.731 93.6203 113.011 93.5124 112.907 93.2562C112.819 93.0404 112.437 92.9672 112.437 92.9672C112.437 92.9672 112.844 92.8538 112.757 92.5684C112.694 92.369 112.495 92.305 112.413 92.3031C112.413 92.3031 112.649 92.0415 112.391 91.7982C112.391 91.7982 113.214 90.8689 113.073 89.5481C113.073 89.5481 113.26 88.67 112.416 88.3279C111.573 87.9858 111.153 88.895 111.153 88.895H111.156Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M109.86 92.3767C109.252 92.8615 109.955 94.4787 110.138 94.7055C110.365 94.9854 111.552 94.539 112.034 94.3634C112.345 94.25 112.424 94.0543 112.444 93.9463C112.34 93.8786 112.219 93.8603 112.183 93.8603L112.728 93.6207C112.728 93.6207 113.007 93.5128 112.903 93.2567C112.815 93.0408 112.433 92.9676 112.433 92.9676C112.433 92.9676 112.821 92.889 112.753 92.5688C112.715 92.3895 112.492 92.3054 112.409 92.3036C112.409 92.3036 112.645 92.042 112.387 91.7987C111.014 91.4968 110.463 91.8919 109.856 92.3767H109.86Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M112.392 91.7981C112.392 91.7981 112.026 92.3853 111.838 92.8372C111.576 93.4628 111.393 93.8799 111.284 94.2183C111.044 94.9482 110.369 94.683 110.556 94.0811C110.731 93.5122 110.843 92.8884 110.839 92.5975C110.834 92.2261 110.742 91.9792 110.689 91.8493C110.689 91.8493 110.921 91.0371 111.695 91.134C112.467 91.231 112.496 91.6115 112.394 91.7999L112.392 91.7981Z","fill":"#F6A17C"}}),_c('path',{attrs:{"d":"M109.381 93.0547L110.607 93.5358L103.964 111.191L102.738 110.71L109.381 93.0547Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M111.001 93.6362C111.206 93.1166 110.95 92.5276 110.429 92.3245C109.909 92.1196 109.321 92.3757 109.117 92.8971C108.913 93.4166 109.169 94.0039 109.69 94.2088C110.209 94.4137 110.798 94.1575 111.001 93.6362Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M91.9748 141.714C91.567 142.755 90.3909 143.267 89.352 142.857L79.8391 139.12C78.7983 138.712 78.2862 137.536 78.6959 136.495L91.6804 103.427C92.0882 102.386 93.2643 101.874 94.3032 102.284L103.816 106.021C104.857 106.429 105.369 107.605 104.959 108.645L91.9748 141.712V141.714Z","fill":"#D4D4D4"}}),_c('path',{attrs:{"d":"M98.8289 104.074L84.3594 140.907L84.8309 141.093L99.3005 104.259L98.8289 104.074Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M90.1425 144.341C89.8974 144.964 89.3688 145.338 88.9591 145.179C88.5494 145.018 88.4177 144.383 88.661 143.759C88.9061 143.135 89.4347 142.76 89.8444 142.921C90.2522 143.082 90.3858 143.717 90.1407 144.341H90.1425Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M80.0638 140.382C79.8188 141.006 79.2902 141.381 78.8805 141.22C78.4707 141.059 78.3391 140.424 78.5841 139.8C78.8292 139.176 79.3578 138.801 79.7675 138.962C80.1754 139.123 80.3089 139.758 80.0638 140.382Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M221.976 115.5L223.133 115.404C223.131 115.351 222.828 110.153 217.476 110.127C212.124 110.102 211.773 115.297 211.769 115.35L212.926 115.453C212.936 115.301 213.23 111.6 217.468 111.62C221.706 111.64 221.966 115.343 221.974 115.5L221.976 115.5Z","fill":"#78350F"}}),_c('path',{attrs:{"d":"M226.947 114.655L226.797 145.697L239.331 145.758L239.481 114.715L226.947 114.655Z","fill":"#92400E"}}),_c('path',{attrs:{"d":"M198.447 114.517L198.297 145.56L228.885 145.707L229.035 114.665L198.447 114.517Z","fill":"#D97706"}}),_c('path',{attrs:{"d":"M198.334 118.331C198.189 118.222 198.12 117.971 198.121 117.693L198.134 114.925C198.136 114.543 198.266 114.213 198.484 114.214L200.141 114.221C200.302 114.221 200.448 114.407 200.505 114.67C200.563 114.933 200.524 115.244 200.408 115.439L198.738 118.197C198.661 118.322 198.576 118.387 198.477 118.387C198.424 118.387 198.384 118.369 198.334 118.331Z","fill":"#78350F"}}),_c('path',{attrs:{"d":"M198.357 141.553C198.456 141.553 198.555 141.62 198.629 141.746L200.273 144.521C200.389 144.716 200.425 145.018 200.364 145.28C200.303 145.542 200.157 145.714 199.996 145.713L198.339 145.706C198.121 145.705 197.994 145.394 197.996 145.012L198.009 142.244C198.01 141.968 198.082 141.717 198.228 141.61C198.279 141.573 198.306 141.555 198.359 141.555L198.357 141.553Z","fill":"#78350F"}}),_c('path',{attrs:{"d":"M229.111 118.492C229.035 118.617 228.938 118.681 228.837 118.682C228.828 118.682 228.819 118.678 228.81 118.677C228.801 118.677 228.79 118.682 228.781 118.682C228.682 118.683 228.577 118.615 228.502 118.489L226.858 115.714C226.742 115.519 226.706 115.208 226.767 114.945C226.828 114.683 226.973 114.499 227.136 114.5L228.793 114.507C228.804 114.507 228.815 114.511 228.824 114.513C228.835 114.513 228.845 114.507 228.856 114.507L230.513 114.514C230.674 114.514 230.819 114.7 230.877 114.961C230.937 115.224 230.898 115.53 230.78 115.724L229.109 118.489L229.111 118.492Z","fill":"#78350F"}}),_c('path',{attrs:{"d":"M228.394 141.887C228.47 141.763 228.567 141.698 228.667 141.698C228.678 141.698 228.689 141.701 228.7 141.703C228.711 141.703 228.72 141.698 228.731 141.698C228.83 141.697 228.929 141.764 229.003 141.89L230.647 144.665C230.763 144.861 230.799 145.162 230.738 145.424C230.677 145.686 230.531 145.859 230.37 145.858L228.713 145.85C228.702 145.85 228.693 145.847 228.682 145.845C228.671 145.845 228.66 145.85 228.649 145.851L226.992 145.843C226.831 145.844 226.686 145.669 226.628 145.406C226.57 145.143 226.609 144.842 226.725 144.648L228.395 141.889L228.394 141.887Z","fill":"#78350F"}}),_c('path',{attrs:{"d":"M239.261 118.581C239.162 118.581 239.048 118.512 238.974 118.386L237.331 115.609C237.215 115.414 237.178 115.109 237.239 114.845C237.301 114.583 237.446 114.399 237.607 114.401L239.264 114.408C239.482 114.409 239.765 114.742 239.763 115.125L239.75 117.892C239.749 118.169 239.598 118.418 239.452 118.527C239.401 118.564 239.31 118.58 239.259 118.581L239.261 118.581Z","fill":"#78350F"}}),_c('path',{attrs:{"d":"M239.34 141.804C239.485 141.913 239.636 142.165 239.634 142.441L239.621 145.209C239.619 145.592 239.324 145.9 239.106 145.9L237.449 145.892C237.288 145.893 237.143 145.718 237.085 145.455C237.027 145.192 237.066 144.891 237.182 144.697L238.853 141.938C238.927 141.813 239.038 141.749 239.137 141.749C239.19 141.748 239.289 141.768 239.338 141.806L239.34 141.804Z","fill":"#78350F"}}),_c('path',{attrs:{"d":"M205.165 114.554L205.016 145.596L206.656 145.604L206.806 114.561L205.165 114.554Z","fill":"#78350F"}}),_c('path',{attrs:{"d":"M220.38 114.622L220.23 145.664L221.723 145.671L221.873 114.629L220.38 114.622Z","fill":"#78350F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_158_3456"}},[_c('rect',{attrs:{"width":"260","height":"154.267","fill":"white"}})])])])
}
var newsletter_banner_flight_svgvue_type_template_id_3d742104_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/newsletter-banner-flight-svg.vue?vue&type=template&id=3d742104

// CONCATENATED MODULE: ./src/components/svg/decorations/newsletter-banner-flight-svg.vue

var newsletter_banner_flight_svg_script = {}


/* normalize component */

var newsletter_banner_flight_svg_component = normalizeComponent(
  newsletter_banner_flight_svg_script,
  newsletter_banner_flight_svgvue_type_template_id_3d742104_render,
  newsletter_banner_flight_svgvue_type_template_id_3d742104_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var newsletter_banner_flight_svg = (newsletter_banner_flight_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/hg-newsletter-banner.vue?vue&type=script&lang=js






/* harmony default export */ var hg_newsletter_bannervue_type_script_lang_js = ({
  components: {
    HgTextInput: hg_text_input,
    HgButton: hg_button,
    NewsletterBannerMailSvg: newsletter_banner_mail_svg,
    NewsletterBannerFlightSvg: newsletter_banner_flight_svg,
  },
  props: {
    variant: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      variant1: {
        headline:
          'Hole dir <b>deine Reisebegleitung</b> direkt in dein Postfach.',
        description:
          'Abonniere unseren Newsletter und freue dich zweimal wöchentlich auf <b>persönliche Post</b> – von unserem Team für dich zusammengestellt:',
        listItems: [
          'Entdecke unsere ausgewählten <b>Topseller-Angebote</b> der Woche',
          'Erfahre zuerst von <b>aktuellen Rabatten</b> und <b>Gutscheincodes</b>',
          'Erhalte <b>wertvolle Reiseinfos</b> und Inspiration für deine nächste Reise',
        ],
      },
      variant2: {
        headline:
          'Lasse <b>Urlaubsgefühle</b> direkt in dein Postfach flattern',
        description:
          'Werde Teil unserer <b>Urlaubsguru Community</b> mit über 110.000 Reisebegeisterten und entdecke zweimal wöchentlich:',
        listItems: [
          'Ausgewählte <b>Topseller-Angebote</b> der Woche - von unserem Team für dich zusammengestellt',
          'Aktuelle <b>Rabatte</b> und <b>Gutscheincodes</b>',
          '<b>Wertvolle Reiseinfos</b> und Inspiration für deine nächste Reise',
        ],
      },
      variant3: {
        headline:
          'Verpasse keine <b>Chance</b> mehr auf deinen <b>Traumurlaub</b>',
        description:
          'Abonniere unseren Newsletter und freue dich zweimal wöchentlich auf <b>Urlaubsguru Highlights</b> – persönlich von unserem Team für dich zusammengestellt:',
        listItems: [
          'Ausgewählte <b>Topseller-Angebote</b> der Woche',
          'Aktuelle <b>Rabatte</b> und <b>Gutscheincodes</b>',
          '<b>Wertvolle Reiseinfos</b> und Inspiration für deine nächste Reise',
        ],
      },
      firstName: '',
      email: '',
    }
  },
  computed: {
    selectedVariant() {
      if (this.variant == 3) {
        return this.variant3
      } else if (this.variant == 2) {
        return this.variant2
      } else {
        return this.variant1
      }
    },
  },
  methods: {
    submit() {
      this.$emit('onSubmit', {
        firstName: this.firstName,
        email: this.email,
      })
    },
  },
});

// CONCATENATED MODULE: ./src/components/ui/hg-newsletter-banner.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_hg_newsletter_bannervue_type_script_lang_js = (hg_newsletter_bannervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ui/hg-newsletter-banner.vue?vue&type=style&index=0&id=3cf66e80&prod&scoped=true&lang=css
var hg_newsletter_bannervue_type_style_index_0_id_3cf66e80_prod_scoped_true_lang_css = __webpack_require__("8cf5");

// CONCATENATED MODULE: ./src/components/ui/hg-newsletter-banner.vue






/* normalize component */

var hg_newsletter_banner_component = normalizeComponent(
  ui_hg_newsletter_bannervue_type_script_lang_js,
  hg_newsletter_bannervue_type_template_id_3cf66e80_scoped_true_render,
  hg_newsletter_bannervue_type_template_id_3cf66e80_scoped_true_staticRenderFns,
  false,
  null,
  "3cf66e80",
  null
  
)

/* harmony default export */ var hg_newsletter_banner = (hg_newsletter_banner_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dropdown/hg-dropdown-new.vue?vue&type=template&id=14d2e622&scoped=true
var hg_dropdown_newvue_type_template_id_14d2e622_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-drop-down"},[_c('button',{ref:"buttonRef",staticClass:"hg-drop-down-btn",attrs:{"aria-active":_vm.isActive,"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){return _vm.clickTrigger()}}},[_vm._v(" "+_vm._s(_vm.triggerText)+" "),(_vm.hasDropdownChevron)?_c('div',{staticClass:"hg-chevron-wrap"},[_c('span',{staticClass:"hg-dropdown__chevron",class:{ 'hg-dropdown__chevron--rotate-180': _vm.isActive }},[_c('hg-icon',{attrs:{"name":"chevron-down","size":"small"}})],1)]):_vm._e()]),_c('transition',{attrs:{"name":`${
      _vm.isFullscreenOnMobile || _vm.isInsidePortal
        ? 'hg-dropdown-slide'
        : 'hg-dropdown-fade'
    }`}},[(_vm.isActive)?_c('div',{ref:"contentRef",attrs:{"aria-expanded":_vm.isActive}},[(_vm.isFullscreenOnMobile)?_c('div',{staticClass:"close-container"},[_c('button',{staticClass:"close close-button hg-button hg-button--white",on:{"click":_vm.close}},[_c('hg-icon',{attrs:{"name":"times","pack":"fal"}})],1)]):_vm._e(),_vm._t("default")],2):_vm._e()])],1)
}
var hg_dropdown_newvue_type_template_id_14d2e622_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/dropdown/hg-dropdown-new.vue?vue&type=template&id=14d2e622&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dropdown/hg-dropdown-new.vue?vue&type=script&lang=js

/* harmony default export */ var hg_dropdown_newvue_type_script_lang_js = ({
  props: {
    triggerText: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    hasDropdownChevron: {
      type: Boolean,
      default: true,
    },
    isFullscreenOnMobile: {
      type: Boolean,
      default: false,
    },
    isInsidePortal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isActive: false,
  }),
  methods: {
    clickTrigger() {
      this.isActive = !this.isActive
    },
  },
});

// CONCATENATED MODULE: ./src/components/dropdown/hg-dropdown-new.vue?vue&type=script&lang=js
 /* harmony default export */ var dropdown_hg_dropdown_newvue_type_script_lang_js = (hg_dropdown_newvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/dropdown/hg-dropdown-new.vue?vue&type=style&index=0&id=14d2e622&prod&scoped=true&lang=postcss
var hg_dropdown_newvue_type_style_index_0_id_14d2e622_prod_scoped_true_lang_postcss = __webpack_require__("5589");

// CONCATENATED MODULE: ./src/components/dropdown/hg-dropdown-new.vue






/* normalize component */

var hg_dropdown_new_component = normalizeComponent(
  dropdown_hg_dropdown_newvue_type_script_lang_js,
  hg_dropdown_newvue_type_template_id_14d2e622_scoped_true_render,
  hg_dropdown_newvue_type_template_id_14d2e622_scoped_true_staticRenderFns,
  false,
  null,
  "14d2e622",
  null
  
)

/* harmony default export */ var hg_dropdown_new = (hg_dropdown_new_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/icon-with-headline/hg-icon-with-headline.vue?vue&type=template&id=7e39150c&scoped=true
var hg_icon_with_headlinevue_type_template_id_7e39150c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"hg-icon-with-headline-img",attrs:{"src":_vm.img}}),_c(_vm.tag,{tag:"component",staticClass:"hg-icon-with-headline-head"},[_vm._v(" "+_vm._s(_vm.headline))]),_c('p',{staticClass:"hg-icon-with-headline-sub"},[_vm._v(" "+_vm._s(_vm.subHeadline)+" ")])],1)
}
var hg_icon_with_headlinevue_type_template_id_7e39150c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/icon-with-headline/hg-icon-with-headline.vue?vue&type=template&id=7e39150c&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/icon-with-headline/hg-icon-with-headline.vue?vue&type=script&lang=js

/* harmony default export */ var hg_icon_with_headlinevue_type_script_lang_js = ({
  props: {
    img: {
      type: String,
      default: '',
    },
    headline: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'h2',
    },
    subHeadline: {
      type: String,
      default: '',
    },
  },
});

// CONCATENATED MODULE: ./src/components/icon-with-headline/hg-icon-with-headline.vue?vue&type=script&lang=js
 /* harmony default export */ var icon_with_headline_hg_icon_with_headlinevue_type_script_lang_js = (hg_icon_with_headlinevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/icon-with-headline/hg-icon-with-headline.vue?vue&type=style&index=0&id=7e39150c&prod&scoped=true&lang=postcss
var hg_icon_with_headlinevue_type_style_index_0_id_7e39150c_prod_scoped_true_lang_postcss = __webpack_require__("7691");

// CONCATENATED MODULE: ./src/components/icon-with-headline/hg-icon-with-headline.vue






/* normalize component */

var hg_icon_with_headline_component = normalizeComponent(
  icon_with_headline_hg_icon_with_headlinevue_type_script_lang_js,
  hg_icon_with_headlinevue_type_template_id_7e39150c_scoped_true_render,
  hg_icon_with_headlinevue_type_template_id_7e39150c_scoped_true_staticRenderFns,
  false,
  null,
  "7e39150c",
  null
  
)

/* harmony default export */ var hg_icon_with_headline = (hg_icon_with_headline_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-layout.vue?vue&type=template&id=2118e6b4&scoped=true
var hg_layoutvue_type_template_id_2118e6b4_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-app-wrapper"},[_c('div',{staticClass:"hg-app"},[_vm._t("default")],2)])
}
var hg_layoutvue_type_template_id_2118e6b4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-layout.vue?vue&type=template&id=2118e6b4&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-layout.vue?vue&type=script&lang=js

/* harmony default export */ var hg_layoutvue_type_script_lang_js = ({
  props: {
    isMobile: {
      type: Boolean,
      default: true,
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-layout.vue?vue&type=script&lang=js
 /* harmony default export */ var partials_hg_layoutvue_type_script_lang_js = (hg_layoutvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-layout.vue?vue&type=style&index=0&id=2118e6b4&prod&scoped=true&lang=postcss
var hg_layoutvue_type_style_index_0_id_2118e6b4_prod_scoped_true_lang_postcss = __webpack_require__("a28a");

// EXTERNAL MODULE: ./src/components/partials/hg-layout.vue?vue&type=style&index=1&id=2118e6b4&prod&lang=postcss
var hg_layoutvue_type_style_index_1_id_2118e6b4_prod_lang_postcss = __webpack_require__("323c");

// CONCATENATED MODULE: ./src/components/partials/hg-layout.vue







/* normalize component */

var hg_layout_component = normalizeComponent(
  partials_hg_layoutvue_type_script_lang_js,
  hg_layoutvue_type_template_id_2118e6b4_scoped_true_render,
  hg_layoutvue_type_template_id_2118e6b4_scoped_true_staticRenderFns,
  false,
  null,
  "2118e6b4",
  null
  
)

/* harmony default export */ var hg_layout = (hg_layout_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-navbar/index.vue?vue&type=template&id=687b2f39&scoped=true
var hg_navbarvue_type_template_id_687b2f39_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"hg-header",class:[
      _vm.isHamburgerActive && 'hg-header--active',
      _vm.showUserMenu && 'hg-header--active',
      _vm.showSupportBox && 'hg-header--active',
      _vm.showBorder && 'hg-header--border',
    ]},[_c('button',{staticClass:"hg-header__overlay",class:_vm.isHamburgerActive && 'hg-header__overlay--active',on:{"click":function($event){_vm.isHamburgerActive = false}}},[(_vm.isMounted)?_c('div',{ref:"navClose",staticClass:"hg-header__nav-close hg-header__nav-close--overlay",style:({ display: 'none' }),on:{"click":function($event){_vm.isHamburgerActive = false}}},[_c('hg-icon',{attrs:{"name":"times","pack":"fal","size":"large"}})],1):_vm._e()]),_c('div',{ref:"logo",staticClass:"hg-header__logo-container"},[_c(_vm.linkType,{tag:"component",attrs:{"to":_vm.locale.logo.url,"href":_vm.locale.logo.url}},[_c('GuruLogo',{staticClass:"hg-header__logo-nav",attrs:{"lang":_vm.locale.lang}})],1),(_vm.locale.lang === 'es' && _vm.showPremiosLogo)?_c('div',{staticClass:"premios-finalista-svg-container"},[_c('PremiosFinalistaSvg')],1):_vm._e()],1),_c('div',{staticClass:"hg-header__nav-container"},[_c('nav',{ref:"navDesktop",staticClass:"hg-header__nav hg-header__nav-desktop",class:_vm.isHamburgerActive && 'hg-header__nav--active'},_vm._l((_vm.locale.items),function(item){return _c(item.linkType ? item.linkType : _vm.linkType,{tag:"component",class:_vm.getClassForNavbarLink(item),attrs:{"to":item.url,"href":item.url}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1),_c('div',{staticClass:"hg-header__end"},[(_vm.locale.showSupportPage)?_c('a',{staticClass:"hg-button hg-header__button hg-header__button--contactpage",attrs:{"href":_vm.locale.supportPageUrl}},[_c('hg-icon',{attrs:{"name":"envelope","pack":"fal"}})],1):_vm._e(),(_vm.locale.showSupportPhone)?_c('button',{ref:"supportButton",class:`hg-button hg-header__button hg-header__button--support ${
              _vm.showSupportBox ? 'hg-header__button--active' : ''
            }`,on:{"click":_vm.clickSupportButton}},[_c('hg-icon',{attrs:{"name":"phone","pack":"fal"}})],1):_vm._e(),(_vm.showBookmarkButton)?_c('button',{ref:"bookmarkButton",staticClass:"hg-button hg-header__button",on:{"click":_vm.clickBookmarkButton}},[_c('hg-icon',{attrs:{"name":"heart","pack":"fal"}})],1):_vm._e(),(_vm.showUserButton)?_c('button',{ref:"userButton",staticClass:"hg-button hg-header__button",on:{"click":_vm.clickUserButton}},[_c('hg-icon',{attrs:{"name":"user","pack":"fal"}})],1):_vm._e(),_c('transition',{attrs:{"name":"hg-slide-fade","mode":"in-out"}},[(_vm.showUserMenu && _vm.user)?_c('nav',{ref:"userMenu",staticClass:"hg-header-menu hg-header__user-menu"},[_c('div',{staticClass:"hg-user-menu__header"},[_c('div',{staticClass:"initials"},[_c('span',[_vm._v(" "+_vm._s(_vm.user.profile.firstName[0])+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.user.profile.lastName[0])+" ")])]),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.user.profile.firstName)+" "+_vm._s(_vm.user.profile.lastName)+" ")])]),_c('div',{staticClass:"hg-user-menu__menu-list"},[_vm._t("user-menu")],2)]):_vm._e()]),_c('transition',{attrs:{"name":"hg-slide-fade","mode":"in-out"}},[(_vm.showSupportBox)?_c('div',{ref:"supportBox",staticClass:"hg-header-menu"},[(_vm.isMounted || true)?_c('Support',{attrs:{"support-title":_vm.locale.supportPhone.title,"support-subline":_vm.locale.supportPhone.subline,"support-phone":_vm.locale.supportPhone.phone,"support-phone-label":_vm.locale.supportPhone.phoneLabel}}):_vm._e()],1):_vm._e()]),(_vm.createdPortal)?_c('MountingPortal',{attrs:{"mountTo":"#hg-navbar-portal"}},[_c('div',{staticClass:"hg-header__nav-mobile-container",class:_vm.isHamburgerActive && 'hg-header__nav-mobile-container--active'},[(_vm.isMounted)?_c('div',{ref:"navClose",staticClass:"hg-header__nav-close hg-header__nav-close--mobile",style:({ display: 'none' }),on:{"click":function($event){_vm.isHamburgerActive = false}}},[_c('hg-icon',{attrs:{"name":"times","pack":"fal","size":"large"}})],1):_vm._e(),_c('nav',{ref:"navMobile",staticClass:"hg-header__nav hg-header__nav-mobile",style:({ display: 'none' })},[_c(_vm.linkType,{tag:"component",attrs:{"to":_vm.locale.logo.url,"href":_vm.locale.logo.url}},[_c('GuruLogo',{staticClass:"hg-header__logo-sidebar",attrs:{"lang":_vm.locale.lang}})],1),_vm._l((_vm.locale.items),function(item){return _c(item.linkType ? item.linkType : _vm.linkType,{tag:"component",class:_vm.getClassForNavbarLink(item),attrs:{"to":item.url,"href":item.url}},[_vm._v(" "+_vm._s(item.label)+" ")])})],2),(_vm.locale.supportPhone && _vm.isMounted)?[_c('Support',{attrs:{"support-title":_vm.locale.supportPhone.title,"support-subline":_vm.locale.supportPhone.subline,"support-phone":_vm.locale.supportPhone.phone,"support-phone-label":_vm.locale.supportPhone.phoneLabel}})]:_vm._e()],2)]):_vm._e(),_c('Hamburger',{staticClass:"hg-button hg-header__button",attrs:{"disabled":_vm.isHamburgerActive,"is-active":_vm.isHamburgerActive},on:{"onHamburgerClick":function($event){_vm.isHamburgerActive = !_vm.isHamburgerActive}}})],1)])]),(_vm.locale.lang === 'es' && _vm.showPremiosLogo)?_c('div',{staticClass:"premios-finalista-svg-mobile-container"},[_c('PremiosFinalistaSvg',{staticClass:"premios-finalista-svg-mobile"})],1):_vm._e()])
}
var hg_navbarvue_type_template_id_687b2f39_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-navbar/index.vue?vue&type=template&id=687b2f39&scoped=true

// EXTERNAL MODULE: ./node_modules/portal-vue/dist/portal-vue.common.js
var portal_vue_common = __webpack_require__("2b88");

// CONCATENATED MODULE: ./node_modules/date-fns/esm/isToday/index.js


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, Date.now());
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-navbar/hamburger.vue?vue&type=template&id=fe929f90&scoped=true
var hamburgervue_type_template_id_fe929f90_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['hamburger', _vm.isActive ? 'hamburger--active' : ''],on:{"click":_vm.clickHamburger}},[_c('hg-icon',{attrs:{"name":"bars","pack":"fal"}})],1)
}
var hamburgervue_type_template_id_fe929f90_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-navbar/hamburger.vue?vue&type=template&id=fe929f90&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-navbar/hamburger.vue?vue&type=script&lang=js

/* harmony default export */ var hamburgervue_type_script_lang_js = ({
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickHamburger() {
      this.$emit('onHamburgerClick')
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-navbar/hamburger.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_navbar_hamburgervue_type_script_lang_js = (hamburgervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-navbar/hamburger.vue?vue&type=style&index=0&id=fe929f90&prod&scoped=true&lang=postcss
var hamburgervue_type_style_index_0_id_fe929f90_prod_scoped_true_lang_postcss = __webpack_require__("ec62");

// CONCATENATED MODULE: ./src/components/partials/hg-navbar/hamburger.vue






/* normalize component */

var hamburger_component = normalizeComponent(
  hg_navbar_hamburgervue_type_script_lang_js,
  hamburgervue_type_template_id_fe929f90_scoped_true_render,
  hamburgervue_type_template_id_fe929f90_scoped_true_staticRenderFns,
  false,
  null,
  "fe929f90",
  null
  
)

/* harmony default export */ var hamburger = (hamburger_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-navbar/support.vue?vue&type=template&id=932a0416&scoped=true
var supportvue_type_template_id_932a0416_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-header-support",style:({ display: 'none' })},[(_vm.supportTitle)?_c('span',{staticClass:"hg-header-support-title"},[_vm._v(_vm._s(_vm.supportTitle))]):_vm._e(),(_vm.supportPhone)?_c('a',{staticClass:"hg-button hg-button--teal hg-button--regular",attrs:{"href":`tel:${_vm.supportPhone}`}},[(_vm.supportPhoneLabel || _vm.supportPhone)?_c('span',[_c('hg-icon',{attrs:{"name":"phone-alt","pack":"fas","size":"small"}}),_c('span',[_vm._v(" "+_vm._s(_vm.supportPhoneLabel || _vm.supportPhone)+" ")])],1):_vm._e()]):_vm._e(),(_vm.subline)?_c('span',{staticClass:"hg-header-support-subline",domProps:{"innerHTML":_vm._s(_vm.subline)}},[_vm._v(_vm._s(_vm.subline))]):_vm._e()])
}
var supportvue_type_template_id_932a0416_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-navbar/support.vue?vue&type=template&id=932a0416&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-navbar/support.vue?vue&type=script&lang=js

/* harmony default export */ var supportvue_type_script_lang_js = ({
  props: {
    supportTitle: {
      type: String,
      default: '',
    },
    supportSubline: {
      type: String,
      default: '',
    },
    supportPhone: {
      type: String,
      default: '',
    },
    supportPhoneLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      subline: '',
    }
  },
  mounted() {
    this.subline = this.supportSubline.replace(/\|/g, '<br/>')
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-navbar/support.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_navbar_supportvue_type_script_lang_js = (supportvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-navbar/support.vue?vue&type=style&index=0&id=932a0416&prod&lang=postcss&scoped=true
var supportvue_type_style_index_0_id_932a0416_prod_lang_postcss_scoped_true = __webpack_require__("42e3");

// CONCATENATED MODULE: ./src/components/partials/hg-navbar/support.vue






/* normalize component */

var support_component = normalizeComponent(
  hg_navbar_supportvue_type_script_lang_js,
  supportvue_type_template_id_932a0416_scoped_true_render,
  supportvue_type_template_id_932a0416_scoped_true_staticRenderFns,
  false,
  null,
  "932a0416",
  null
  
)

/* harmony default export */ var support = (support_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/premios-finalista-svg.vue?vue&type=template&id=7abc013c
var premios_finalista_svgvue_type_template_id_7abc013c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"40.5 35.5 254.62 57"}},[_c('g',{attrs:{"filter":"url(#filter0_d_14_1055)"}},[_c('rect',{attrs:{"x":"40.75","y":"35.75","width":"56.5","height":"56.5","rx":"28.25","stroke":"#FAB702","stroke-width":"0.5","shape-rendering":"crispEdges"}}),_c('path',{attrs:{"d":"M71.9116 67.7173L72.5715 63.4593L75.8774 65.284L73.8939 61.4987L85.0008 58.2535L73.8939 54.9422L76.075 50.9537L72.4386 53.049L68.9579 41.2193L65.4963 53.1163L61.9928 51.021L64.0422 54.8736L53 58.1862L64.0422 61.4314L61.9928 65.3513L65.2987 63.4593L65.9598 67.6793","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M67.9004 80.0466L68.9568 86.7807L70.0001 80.0466","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M69.1349 79.3729C68.6211 79.4011 68.0977 79.4525 67.5742 79.4513C67.1718 79.4501 66.7729 79.3803 66.4495 79.0827C66.289 78.9357 66.1896 78.7606 66.1453 78.5512C66.0567 78.1373 66.1034 77.754 66.4136 77.4429C66.6112 77.2446 66.8652 77.1735 67.1311 77.1588C67.3143 77.149 67.5072 77.1172 67.6689 77.2494C67.8413 77.3891 67.8905 77.5838 67.9048 77.7785C67.6844 77.8262 67.4784 77.8715 67.2724 77.9144C67.1107 77.9487 67.0388 78.0712 67.0185 78.2181C66.9993 78.3565 67.1419 78.55 67.2796 78.5794C67.585 78.6455 67.8929 78.6443 68.1791 78.5867C68.1791 78.0332 68.1899 77.4956 68.1743 76.958C68.1659 76.6665 68.0354 76.6053 67.7563 76.5661C67.5599 76.5392 67.3503 76.5735 67.1526 76.6127C66.7586 76.6898 66.4459 76.4326 66.4723 76.0175C66.4747 75.9759 66.5214 75.911 66.5597 75.8999C67.143 75.7224 67.7335 75.6366 68.3348 75.7897C68.8115 75.911 69.1062 76.2073 69.1242 76.7069C69.1553 77.5813 69.1325 78.4569 69.1325 79.3705L69.1349 79.3729Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M70.4994 75.2093V76.3494C70.8779 75.8424 71.3917 76.0579 71.8649 75.9967C71.8756 76.3371 71.8672 76.6494 71.5702 76.8392C71.4684 76.9053 71.3306 76.9311 71.2073 76.9396C70.9809 76.9555 70.7533 76.9445 70.5018 76.9445C70.5018 77.3229 70.4958 77.6928 70.5054 78.0626C70.5078 78.1728 70.5425 78.2855 70.5784 78.392C70.6264 78.5316 70.7306 78.5953 70.8791 78.5904C71.0564 78.5843 71.2336 78.5794 71.4109 78.5904C71.69 78.61 71.914 78.8757 71.9008 79.166C71.8984 79.2064 71.8613 79.2676 71.8277 79.2786C71.2923 79.4562 70.7473 79.5468 70.2 79.3484C69.849 79.2223 69.6622 78.937 69.5855 78.5745C69.5627 78.463 69.5508 78.3479 69.5496 78.234C69.546 77.5189 69.5639 76.8037 69.5424 76.0885C69.5268 75.5375 69.9832 75.1811 70.4994 75.2093Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M72.2809 79.4427C72.2809 78.5071 72.2761 77.5838 72.2833 76.6592C72.2857 76.3408 72.5551 76.0665 72.863 76.0383C73.1113 76.0155 73.2355 76.1318 73.2355 76.3874C73.2355 77.1319 73.2175 77.8765 73.2415 78.6198C73.2618 79.2492 72.8726 79.5003 72.2809 79.4427Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M64.7601 79.4587C64.7601 78.5255 64.7422 77.6193 64.7673 76.7131C64.7829 76.167 65.171 76.0286 65.5902 76.0041C65.7219 75.9967 65.7147 76.0861 65.7147 76.178C65.7147 77.0499 65.7147 77.923 65.7135 78.795C65.7135 78.8452 65.7004 78.8954 65.6896 78.9456C65.6081 79.3081 65.3327 79.4171 64.9985 79.4575C64.9266 79.466 64.8524 79.4587 64.7601 79.4587Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M64.6924 75.1701C64.6924 74.8541 64.9247 74.6129 65.2254 74.6055C65.6219 74.597 65.8195 74.8823 65.8099 75.186C65.7991 75.5338 65.6099 75.726 65.2434 75.753C64.9367 75.775 64.6936 75.5032 64.6924 75.1701Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M73.3048 75.1615C73.3551 75.4431 73.0964 75.7481 72.767 75.7566C72.4592 75.7652 72.228 75.5031 72.2089 75.1737C72.1909 74.8504 72.4628 74.5945 72.7634 74.6043C73.0976 74.6153 73.3036 74.8186 73.3036 75.1615H73.3048Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M59.4678 69.9704C59.4678 70.4198 59.318 70.7651 59.0174 71.0076C58.718 71.2501 58.288 71.3701 57.7298 71.3701H57.2183V73.1164H56.7129V68.6772H57.8388C58.924 68.6772 59.4666 69.1082 59.4666 69.9704H59.4678ZM57.2195 70.9268H57.6735C58.1215 70.9268 58.4449 70.8533 58.6449 70.7051C58.8449 70.557 58.9443 70.3206 58.9443 69.9949C58.9443 69.701 58.8497 69.483 58.6617 69.3385C58.4736 69.1952 58.1802 69.1229 57.7825 69.1229H57.2183V70.9268H57.2195Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M60.8805 71.2697V73.1164H60.375V68.6772H61.5656C62.0986 68.6772 62.4915 68.7813 62.7466 68.9895C63.0005 69.1976 63.1287 69.5124 63.1287 69.9312C63.1287 70.5178 62.8376 70.9145 62.2555 71.1215L63.4341 73.1164H62.8376L61.786 71.2697H60.8805ZM60.8805 70.8264H61.5728C61.9297 70.8264 62.1908 70.7541 62.3573 70.6096C62.5238 70.4651 62.6064 70.2484 62.6064 69.9581C62.6064 69.6679 62.5214 69.4536 62.3525 69.3238C62.1836 69.194 61.9117 69.1291 61.5368 69.1291H60.8805V70.8264Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M66.5574 73.1164H64.1367V68.6772H66.5574V69.1352H64.6422V70.5655H66.4424V71.0211H64.6422V72.6547H66.5574V73.1164Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M69.4417 73.1164L67.9685 69.1805H67.9445C67.9721 69.4928 67.9864 69.8626 67.9864 70.2924V73.1164H67.5205V68.6772H68.2811L69.6561 72.34H69.6801L71.0671 68.6772H71.8217V73.1164H71.3162V70.2557C71.3162 69.9275 71.3306 69.5711 71.3582 69.1866H71.3342L69.849 73.1164H69.4417Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M73.0117 73.1164V68.6772H73.5172V73.1164H73.0117Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M78.476 70.8901C78.476 71.6004 78.2999 72.1601 77.949 72.5666C77.598 72.9732 77.1093 73.1765 76.4829 73.1765C75.8565 73.1765 75.3498 72.9769 75.0025 72.5764C74.6551 72.176 74.4814 71.6127 74.4814 70.884C74.4814 70.1554 74.6551 69.6006 75.0037 69.2039C75.3522 68.8059 75.8469 68.6075 76.4889 68.6075C77.1309 68.6075 77.5992 68.8095 77.9502 69.2149C78.3011 69.6202 78.476 70.1786 78.476 70.8914V70.8901ZM75.0157 70.8901C75.0157 71.4914 75.1414 71.947 75.3917 72.258C75.6421 72.5691 76.0062 72.7246 76.4829 72.7246C76.9596 72.7246 77.3273 72.5703 77.5729 72.2605C77.8184 71.9506 77.9406 71.4939 77.9406 70.8914C77.9406 70.2889 77.8184 69.8407 77.5741 69.5321C77.3297 69.2235 76.968 69.0692 76.4889 69.0692C76.0098 69.0692 75.6421 69.2247 75.3917 69.5357C75.1414 69.8468 75.0157 70.2987 75.0157 70.8914V70.8901Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M81.8952 71.9347C81.8952 72.3254 81.7563 72.6303 81.4796 72.8483C81.2029 73.0675 80.8256 73.1765 80.3513 73.1765C79.8362 73.1765 79.441 73.1091 79.1631 72.9732V72.4748C79.3416 72.5519 79.5356 72.6119 79.7452 72.6572C79.9548 72.7013 80.1632 72.7246 80.3692 72.7246C80.7058 72.7246 80.9597 72.6597 81.1298 72.5286C81.2999 72.3976 81.3849 72.2164 81.3849 71.9837C81.3849 71.8294 81.355 71.7033 81.2939 71.6053C81.234 71.5073 81.1322 71.4167 80.9909 71.3334C80.8495 71.2502 80.6339 71.1559 80.3453 71.0506C79.9416 70.9024 79.653 70.7273 79.4793 70.5252C79.3056 70.3231 79.2194 70.0586 79.2194 69.7329C79.2194 69.3912 79.3451 69.1181 79.5967 68.9161C79.8482 68.714 80.1812 68.6124 80.5944 68.6124C81.0076 68.6124 81.4233 68.6932 81.785 68.8548L81.6281 69.3043C81.27 69.15 80.9214 69.074 80.5824 69.074C80.3153 69.074 80.1057 69.1328 79.956 69.2504C79.8051 69.3679 79.7308 69.5308 79.7308 69.739C79.7308 69.8933 79.7584 70.0194 79.8135 70.1174C79.8686 70.2154 79.962 70.306 80.0938 70.388C80.2255 70.4701 80.4267 70.5607 80.6986 70.6599C81.1538 70.8264 81.4676 71.004 81.6389 71.1938C81.8102 71.3836 81.8964 71.631 81.8964 71.9347H81.8952Z","fill":"#2D2D2D"}})]),_c('path',{attrs:{"d":"M105.77 60V52.08H110.539V53.4055H107.096V55.38H109.879V56.7H107.096V60H105.77ZM111.638 53.158V51.9425H112.963V53.158H111.638ZM111.638 60V54.06H112.963V60H111.638ZM118.719 60V57.14C118.719 56.953 118.706 56.7458 118.681 56.5185C118.655 56.2912 118.595 56.073 118.499 55.864C118.408 55.6513 118.268 55.4772 118.081 55.3415C117.898 55.2058 117.649 55.138 117.333 55.138C117.165 55.138 116.998 55.1655 116.833 55.2205C116.668 55.2755 116.517 55.3708 116.382 55.5065C116.25 55.6385 116.143 55.8218 116.063 56.0565C115.982 56.2875 115.942 56.5845 115.942 56.9475L115.155 56.612C115.155 56.106 115.252 55.6477 115.447 55.237C115.645 54.8263 115.934 54.5 116.316 54.258C116.697 54.0123 117.166 53.8895 117.724 53.8895C118.164 53.8895 118.527 53.9628 118.813 54.1095C119.099 54.2562 119.326 54.4432 119.495 54.6705C119.663 54.8978 119.788 55.1398 119.869 55.3965C119.949 55.6532 120.001 55.897 120.023 56.128C120.048 56.3553 120.061 56.5405 120.061 56.6835V60H118.719ZM114.6 60V54.06H115.782V55.9025H115.942V60H114.6ZM123.158 60.165C122.729 60.165 122.366 60.0843 122.069 59.923C121.772 59.758 121.546 59.5398 121.392 59.2685C121.242 58.9972 121.167 58.6983 121.167 58.372C121.167 58.086 121.214 57.8293 121.31 57.602C121.405 57.371 121.552 57.173 121.75 57.008C121.948 56.8393 122.204 56.7018 122.52 56.5955C122.758 56.5185 123.037 56.4488 123.356 56.3865C123.678 56.3242 124.027 56.2673 124.401 56.216C124.778 56.161 125.172 56.1023 125.583 56.04L125.11 56.3095C125.114 55.8988 125.022 55.5963 124.835 55.402C124.648 55.2077 124.333 55.1105 123.889 55.1105C123.621 55.1105 123.363 55.1728 123.114 55.2975C122.864 55.4222 122.69 55.6367 122.591 55.941L121.381 55.5615C121.528 55.0592 121.806 54.6558 122.217 54.3515C122.631 54.0472 123.189 53.895 123.889 53.895C124.417 53.895 124.881 53.9812 125.281 54.1535C125.684 54.3258 125.983 54.6082 126.177 55.0005C126.283 55.2095 126.348 55.424 126.37 55.644C126.392 55.8603 126.403 56.0968 126.403 56.3535V60H125.242V58.713L125.435 58.922C125.167 59.351 124.853 59.6663 124.494 59.868C124.138 60.066 123.693 60.165 123.158 60.165ZM123.422 59.109C123.722 59.109 123.979 59.0558 124.192 58.9495C124.404 58.8432 124.573 58.713 124.698 58.559C124.826 58.405 124.912 58.2602 124.956 58.1245C125.026 57.9558 125.064 57.7633 125.072 57.547C125.083 57.327 125.088 57.1492 125.088 57.0135L125.495 57.1345C125.095 57.1968 124.753 57.2518 124.467 57.2995C124.181 57.3472 123.935 57.393 123.73 57.437C123.524 57.4773 123.343 57.5232 123.185 57.5745C123.031 57.6295 122.901 57.6937 122.795 57.767C122.688 57.8403 122.606 57.9247 122.547 58.02C122.492 58.1153 122.465 58.2272 122.465 58.3555C122.465 58.5022 122.501 58.6323 122.575 58.746C122.648 58.856 122.754 58.944 122.894 59.01C123.037 59.076 123.213 59.109 123.422 59.109ZM127.944 60V51.915H129.27V60H127.944ZM131.027 53.158V51.9425H132.353V53.158H131.027ZM131.027 60V54.06H132.353V60H131.027ZM136.294 60.165C135.561 60.165 134.965 60 134.506 59.67C134.048 59.34 133.769 58.8762 133.67 58.2785L135.023 58.0695C135.093 58.3628 135.247 58.5938 135.485 58.7625C135.724 58.9312 136.024 59.0155 136.387 59.0155C136.706 59.0155 136.952 58.9532 137.124 58.8285C137.3 58.7002 137.388 58.526 137.388 58.306C137.388 58.1703 137.355 58.0622 137.289 57.9815C137.227 57.8972 137.088 57.8165 136.871 57.7395C136.655 57.6625 136.323 57.5653 135.876 57.448C135.377 57.316 134.981 57.1748 134.688 57.0245C134.395 56.8705 134.184 56.689 134.055 56.48C133.927 56.271 133.863 56.018 133.863 55.721C133.863 55.3507 133.96 55.028 134.154 54.753C134.349 54.478 134.62 54.2672 134.968 54.1205C135.317 53.9702 135.727 53.895 136.2 53.895C136.662 53.895 137.071 53.9665 137.427 54.1095C137.786 54.2525 138.076 54.456 138.296 54.72C138.516 54.984 138.652 55.2938 138.703 55.6495L137.35 55.8915C137.317 55.6385 137.201 55.4387 137.003 55.292C136.809 55.1453 136.549 55.0628 136.222 55.0445C135.911 55.0262 135.66 55.0738 135.469 55.1875C135.278 55.2975 135.183 55.4533 135.183 55.655C135.183 55.7687 135.221 55.8658 135.298 55.9465C135.375 56.0272 135.529 56.1078 135.76 56.1885C135.995 56.2692 136.343 56.3682 136.805 56.4855C137.278 56.6065 137.656 56.7458 137.938 56.9035C138.224 57.0575 138.43 57.2427 138.554 57.459C138.683 57.6753 138.747 57.9375 138.747 58.2455C138.747 58.8432 138.529 59.3125 138.092 59.6535C137.66 59.9945 137.06 60.165 136.294 60.165ZM143.433 60C143.041 60.0733 142.656 60.1045 142.278 60.0935C141.904 60.0862 141.569 60.0183 141.272 59.89C140.975 59.758 140.749 59.5508 140.595 59.2685C140.459 59.0118 140.388 58.7497 140.381 58.482C140.373 58.2143 140.37 57.9118 140.37 57.5745V52.41H141.69V57.4975C141.69 57.7358 141.691 57.9448 141.695 58.1245C141.702 58.3042 141.741 58.4508 141.811 58.5645C141.943 58.7845 142.153 58.9073 142.443 58.933C142.733 58.9587 143.063 58.944 143.433 58.889V60ZM139.292 55.0995V54.06H143.433V55.0995H139.292ZM146.371 60.165C145.942 60.165 145.579 60.0843 145.282 59.923C144.985 59.758 144.76 59.5398 144.606 59.2685C144.456 58.9972 144.38 58.6983 144.38 58.372C144.38 58.086 144.428 57.8293 144.523 57.602C144.619 57.371 144.765 57.173 144.963 57.008C145.161 56.8393 145.418 56.7018 145.733 56.5955C145.972 56.5185 146.25 56.4488 146.569 56.3865C146.892 56.3242 147.24 56.2673 147.614 56.216C147.992 56.161 148.386 56.1023 148.797 56.04L148.324 56.3095C148.328 55.8988 148.236 55.5963 148.049 55.402C147.862 55.2077 147.547 55.1105 147.103 55.1105C146.835 55.1105 146.577 55.1728 146.327 55.2975C146.078 55.4222 145.904 55.6367 145.805 55.941L144.595 55.5615C144.742 55.0592 145.02 54.6558 145.431 54.3515C145.845 54.0472 146.403 53.895 147.103 53.895C147.631 53.895 148.095 53.9812 148.494 54.1535C148.898 54.3258 149.197 54.6082 149.391 55.0005C149.497 55.2095 149.561 55.424 149.583 55.644C149.605 55.8603 149.616 56.0968 149.616 56.3535V60H148.456V58.713L148.648 58.922C148.381 59.351 148.067 59.6663 147.708 59.868C147.352 60.066 146.907 60.165 146.371 60.165ZM146.635 59.109C146.936 59.109 147.193 59.0558 147.405 58.9495C147.618 58.8432 147.787 58.713 147.911 58.559C148.04 58.405 148.126 58.2602 148.17 58.1245C148.24 57.9558 148.278 57.7633 148.285 57.547C148.296 57.327 148.302 57.1492 148.302 57.0135L148.709 57.1345C148.309 57.1968 147.966 57.2518 147.68 57.2995C147.394 57.3472 147.149 57.393 146.943 57.437C146.738 57.4773 146.557 57.5232 146.399 57.5745C146.245 57.6295 146.115 57.6937 146.008 57.767C145.902 57.8403 145.82 57.9247 145.761 58.02C145.706 58.1153 145.678 58.2272 145.678 58.3555C145.678 58.5022 145.715 58.6323 145.788 58.746C145.862 58.856 145.968 58.944 146.107 59.01C146.25 59.076 146.426 59.109 146.635 59.109ZM153.03 59.989V58.834L156.418 55.8145C156.682 55.5798 156.866 55.358 156.968 55.149C157.071 54.94 157.122 54.7383 157.122 54.544C157.122 54.28 157.066 54.0453 156.952 53.84C156.838 53.631 156.681 53.466 156.479 53.345C156.281 53.224 156.052 53.1635 155.791 53.1635C155.516 53.1635 155.273 53.2277 155.06 53.356C154.851 53.4807 154.688 53.6475 154.57 53.8565C154.453 54.0655 154.398 54.291 154.405 54.533H153.041C153.041 54.005 153.159 53.5448 153.393 53.1525C153.632 52.7602 153.958 52.4558 154.372 52.2395C154.79 52.0232 155.273 51.915 155.819 51.915C156.325 51.915 156.78 52.0287 157.183 52.256C157.586 52.4797 157.903 52.7913 158.134 53.191C158.365 53.587 158.481 54.0435 158.481 54.5605C158.481 54.9382 158.43 55.2553 158.327 55.512C158.224 55.7687 158.07 56.0052 157.865 56.2215C157.663 56.4378 157.412 56.678 157.111 56.942L154.708 59.0705L154.587 58.7405H158.481V59.989H153.03ZM162.652 60.165C162.091 60.165 161.596 60.0458 161.167 59.8075C160.738 59.5655 160.403 59.23 160.161 58.801C159.922 58.372 159.803 57.877 159.803 57.316V54.764C159.803 54.203 159.922 53.708 160.161 53.279C160.403 52.85 160.738 52.5163 161.167 52.278C161.596 52.036 162.091 51.915 162.652 51.915C163.213 51.915 163.706 52.036 164.132 52.278C164.561 52.5163 164.896 52.85 165.138 53.279C165.38 53.708 165.501 54.203 165.501 54.764V57.316C165.501 57.877 165.38 58.372 165.138 58.801C164.896 59.23 164.561 59.5655 164.132 59.8075C163.706 60.0458 163.213 60.165 162.652 60.165ZM162.652 58.9055C162.931 58.9055 163.184 58.8395 163.411 58.7075C163.639 58.5718 163.818 58.3922 163.95 58.1685C164.082 57.9412 164.148 57.6882 164.148 57.4095V54.665C164.148 54.3827 164.082 54.1297 163.95 53.906C163.818 53.6787 163.639 53.499 163.411 53.367C163.184 53.2313 162.931 53.1635 162.652 53.1635C162.374 53.1635 162.121 53.2313 161.893 53.367C161.666 53.499 161.486 53.6787 161.354 53.906C161.222 54.1297 161.156 54.3827 161.156 54.665V57.4095C161.156 57.6882 161.222 57.9412 161.354 58.1685C161.486 58.3922 161.666 58.5718 161.893 58.7075C162.121 58.8395 162.374 58.9055 162.652 58.9055ZM166.823 59.989V58.834L170.211 55.8145C170.475 55.5798 170.659 55.358 170.761 55.149C170.864 54.94 170.915 54.7383 170.915 54.544C170.915 54.28 170.859 54.0453 170.745 53.84C170.631 53.631 170.474 53.466 170.272 53.345C170.074 53.224 169.845 53.1635 169.584 53.1635C169.309 53.1635 169.066 53.2277 168.853 53.356C168.644 53.4807 168.481 53.6475 168.363 53.8565C168.246 54.0655 168.191 54.291 168.198 54.533H166.834C166.834 54.005 166.952 53.5448 167.186 53.1525C167.425 52.7602 167.751 52.4558 168.165 52.2395C168.583 52.0232 169.066 51.915 169.612 51.915C170.118 51.915 170.573 52.0287 170.976 52.256C171.379 52.4797 171.696 52.7913 171.927 53.191C172.158 53.587 172.274 54.0435 172.274 54.5605C172.274 54.9382 172.223 55.2553 172.12 55.512C172.017 55.7687 171.863 56.0052 171.658 56.2215C171.456 56.4378 171.205 56.678 170.904 56.942L168.501 59.0705L168.38 58.7405H172.274V59.989H166.823ZM175.945 60.165C175.541 60.165 175.166 60.0825 174.817 59.9175C174.469 59.7488 174.168 59.5178 173.915 59.2245C173.666 58.9312 173.486 58.5902 173.376 58.2015L174.652 57.8605C174.704 58.0732 174.797 58.2565 174.933 58.4105C175.072 58.5645 175.233 58.6837 175.417 58.768C175.604 58.8523 175.796 58.8945 175.994 58.8945C176.251 58.8945 176.486 58.8322 176.698 58.7075C176.911 58.5828 177.08 58.416 177.204 58.207C177.329 57.9943 177.391 57.7597 177.391 57.503C177.391 57.2463 177.327 57.0135 177.199 56.8045C177.074 56.5918 176.905 56.425 176.693 56.304C176.48 56.1793 176.247 56.117 175.994 56.117C175.69 56.117 175.437 56.172 175.235 56.282C175.037 56.392 174.885 56.5093 174.779 56.634L173.646 56.271L173.888 52.08H178.189V53.323H174.597L175.092 52.8555L174.916 55.7705L174.674 55.4735C174.88 55.2865 175.118 55.1472 175.389 55.0555C175.661 54.9638 175.923 54.918 176.176 54.918C176.671 54.918 177.109 55.0317 177.49 55.259C177.875 55.4827 178.176 55.7888 178.392 56.1775C178.612 56.5662 178.722 57.008 178.722 57.503C178.722 57.998 178.594 58.4472 178.337 58.8505C178.081 59.2502 177.741 59.5692 177.32 59.8075C176.902 60.0458 176.443 60.165 175.945 60.165Z","fill":"#525252"}}),_c('path',{attrs:{"d":"M105.77 77V69.08H106.513L109.626 75.7405L112.722 69.08H113.476V76.9945H112.706V70.884L109.884 77H109.362L106.546 70.884V77H105.77ZM117.533 77.165C116.953 77.165 116.451 77.0367 116.026 76.78C115.604 76.5233 115.276 76.1622 115.041 75.6965C114.806 75.2308 114.689 74.6845 114.689 74.0575C114.689 73.4085 114.805 72.8475 115.036 72.3745C115.267 71.9015 115.591 71.5367 116.009 71.28C116.431 71.0233 116.928 70.895 117.5 70.895C118.086 70.895 118.587 71.0307 119.001 71.302C119.415 71.5697 119.729 71.9547 119.942 72.457C120.154 72.9593 120.251 73.5588 120.233 74.2555H119.408V73.9695C119.393 73.1995 119.227 72.6183 118.908 72.226C118.592 71.8337 118.13 71.6375 117.522 71.6375C116.884 71.6375 116.394 71.8447 116.053 72.259C115.716 72.6733 115.547 73.2637 115.547 74.03C115.547 74.778 115.716 75.3592 116.053 75.7735C116.394 76.1842 116.876 76.3895 117.5 76.3895C117.925 76.3895 118.295 76.2923 118.611 76.098C118.93 75.9 119.181 75.6158 119.364 75.2455L120.118 75.537C119.883 76.054 119.536 76.4555 119.078 76.7415C118.623 77.0238 118.108 77.165 117.533 77.165ZM115.261 74.2555V73.579H119.799V74.2555H115.261ZM120.574 79.64V78.859H120.909C121.177 78.859 121.389 78.7893 121.547 78.65C121.708 78.5143 121.789 78.2852 121.789 77.9625V71.06H122.592V78.166C122.592 78.661 122.473 79.0295 122.235 79.2715C122 79.5172 121.639 79.64 121.151 79.64H120.574ZM121.789 69.9325V69.025H122.592V69.9325H121.789ZM126.695 77.165C126.105 77.165 125.6 77.0312 125.182 76.7635C124.764 76.4958 124.444 76.1255 124.22 75.6525C123.996 75.1795 123.884 74.6368 123.884 74.0245C123.884 73.4012 123.998 72.8548 124.225 72.3855C124.453 71.9162 124.775 71.5513 125.193 71.291C125.615 71.027 126.116 70.895 126.695 70.895C127.289 70.895 127.795 71.0288 128.213 71.2965C128.635 71.5605 128.955 71.929 129.175 72.402C129.399 72.8713 129.511 73.4122 129.511 74.0245C129.511 74.6478 129.399 75.196 129.175 75.669C128.952 76.1383 128.629 76.505 128.207 76.769C127.786 77.033 127.282 77.165 126.695 77.165ZM126.695 76.3895C127.355 76.3895 127.846 76.1713 128.169 75.735C128.492 75.295 128.653 74.7248 128.653 74.0245C128.653 73.3058 128.49 72.7338 128.163 72.3085C127.841 71.8832 127.351 71.6705 126.695 71.6705C126.251 71.6705 125.885 71.7713 125.595 71.973C125.309 72.171 125.094 72.4478 124.951 72.8035C124.812 73.1555 124.742 73.5625 124.742 74.0245C124.742 74.7395 124.907 75.3133 125.237 75.746C125.567 76.175 126.053 76.3895 126.695 76.3895ZM130.724 77V71.06H131.45V72.49L131.307 72.303C131.373 72.127 131.459 71.9657 131.566 71.819C131.672 71.6687 131.787 71.5458 131.912 71.4505C132.066 71.3148 132.246 71.2122 132.451 71.1425C132.656 71.0692 132.864 71.027 133.073 71.016C133.282 71.0013 133.472 71.016 133.645 71.06V71.819C133.428 71.764 133.192 71.7512 132.935 71.7805C132.678 71.8098 132.442 71.9125 132.226 72.0885C132.028 72.2425 131.879 72.4277 131.78 72.644C131.681 72.8567 131.615 73.084 131.582 73.326C131.549 73.5643 131.533 73.8008 131.533 74.0355V77H130.724ZM139.354 77.165C138.756 77.165 138.25 77.0312 137.836 76.7635C137.422 76.4958 137.106 76.1273 136.89 75.658C136.677 75.185 136.567 74.6423 136.56 74.03C136.567 73.4067 136.681 72.8603 136.901 72.391C137.121 71.918 137.438 71.5513 137.853 71.291C138.267 71.027 138.769 70.895 139.36 70.895C139.961 70.895 140.483 71.0417 140.927 71.335C141.374 71.6283 141.681 72.0298 141.846 72.5395L141.054 72.7925C140.914 72.4368 140.692 72.1618 140.388 71.9675C140.087 71.7695 139.743 71.6705 139.354 71.6705C138.918 71.6705 138.557 71.7713 138.271 71.973C137.985 72.171 137.772 72.4478 137.633 72.8035C137.493 73.1592 137.422 73.568 137.418 74.03C137.425 74.7413 137.59 75.3133 137.913 75.746C138.236 76.175 138.716 76.3895 139.354 76.3895C139.757 76.3895 140.1 76.2978 140.383 76.1145C140.669 75.9275 140.885 75.6562 141.032 75.3005L141.846 75.5425C141.626 76.0705 141.303 76.4738 140.878 76.7525C140.452 77.0275 139.944 77.165 139.354 77.165ZM142.981 77V71.06H143.707V72.49L143.564 72.303C143.63 72.127 143.716 71.9657 143.822 71.819C143.929 71.6687 144.044 71.5458 144.169 71.4505C144.323 71.3148 144.503 71.2122 144.708 71.1425C144.913 71.0692 145.12 71.027 145.329 71.016C145.538 71.0013 145.729 71.016 145.901 71.06V71.819C145.685 71.764 145.449 71.7512 145.192 71.7805C144.935 71.8098 144.699 71.9125 144.482 72.0885C144.284 72.2425 144.136 72.4277 144.037 72.644C143.938 72.8567 143.872 73.084 143.839 73.326C143.806 73.5643 143.789 73.8008 143.789 74.0355V77H142.981ZM149.351 77.165C148.772 77.165 148.269 77.0367 147.844 76.78C147.422 76.5233 147.094 76.1622 146.859 75.6965C146.625 75.2308 146.507 74.6845 146.507 74.0575C146.507 73.4085 146.623 72.8475 146.854 72.3745C147.085 71.9015 147.409 71.5367 147.827 71.28C148.249 71.0233 148.746 70.895 149.318 70.895C149.905 70.895 150.405 71.0307 150.819 71.302C151.234 71.5697 151.547 71.9547 151.76 72.457C151.973 72.9593 152.07 73.5588 152.051 74.2555H151.226V73.9695C151.212 73.1995 151.045 72.6183 150.726 72.226C150.411 71.8337 149.949 71.6375 149.34 71.6375C148.702 71.6375 148.212 71.8447 147.871 72.259C147.534 72.6733 147.365 73.2637 147.365 74.03C147.365 74.778 147.534 75.3592 147.871 75.7735C148.212 76.1842 148.695 76.3895 149.318 76.3895C149.743 76.3895 150.114 76.2923 150.429 76.098C150.748 75.9 150.999 75.6158 151.182 75.2455L151.936 75.537C151.701 76.054 151.355 76.4555 150.896 76.7415C150.442 77.0238 149.927 77.165 149.351 77.165ZM147.079 74.2555V73.579H151.617V74.2555H147.079ZM154.864 77.165C154.417 77.165 154.041 77.0843 153.737 76.923C153.436 76.7617 153.21 76.5472 153.06 76.2795C152.91 76.0118 152.835 75.7203 152.835 75.405C152.835 75.0823 152.899 74.8073 153.027 74.58C153.159 74.349 153.337 74.1602 153.561 74.0135C153.788 73.8668 154.05 73.755 154.347 73.678C154.648 73.6047 154.98 73.5405 155.343 73.4855C155.709 73.4268 156.067 73.3773 156.415 73.337C156.767 73.293 157.075 73.2508 157.339 73.2105L157.053 73.3865C157.064 72.7998 156.95 72.3653 156.712 72.083C156.474 71.8007 156.059 71.6595 155.469 71.6595C155.062 71.6595 154.717 71.7512 154.435 71.9345C154.156 72.1178 153.96 72.4075 153.847 72.8035L153.06 72.5725C153.196 72.0408 153.469 71.6283 153.88 71.335C154.29 71.0417 154.824 70.895 155.48 70.895C156.023 70.895 156.483 70.9977 156.861 71.203C157.242 71.4047 157.511 71.698 157.669 72.083C157.742 72.2553 157.79 72.4478 157.812 72.6605C157.834 72.8732 157.845 73.0895 157.845 73.3095V77H157.125V75.5095L157.334 75.5975C157.132 76.1072 156.818 76.4958 156.393 76.7635C155.968 77.0312 155.458 77.165 154.864 77.165ZM154.958 76.4665C155.335 76.4665 155.665 76.3987 155.948 76.263C156.23 76.1273 156.457 75.9422 156.63 75.7075C156.802 75.4692 156.914 75.2015 156.965 74.9045C157.009 74.7138 157.033 74.5048 157.037 74.2775C157.04 74.0465 157.042 73.8742 157.042 73.7605L157.35 73.92C157.075 73.9567 156.776 73.9933 156.454 74.03C156.135 74.0667 155.819 74.1088 155.508 74.1565C155.2 74.2042 154.921 74.261 154.672 74.327C154.503 74.3747 154.34 74.4425 154.182 74.5305C154.024 74.6148 153.894 74.7285 153.792 74.8715C153.693 75.0145 153.643 75.1923 153.643 75.405C153.643 75.5773 153.685 75.7442 153.77 75.9055C153.858 76.0668 153.997 76.2007 154.188 76.307C154.382 76.4133 154.639 76.4665 154.958 76.4665ZM161.741 77.165C161.143 77.165 160.637 77.0312 160.223 76.7635C159.809 76.4958 159.493 76.1273 159.277 75.658C159.064 75.185 158.954 74.6423 158.947 74.03C158.954 73.4067 159.068 72.8603 159.288 72.391C159.508 71.918 159.825 71.5513 160.239 71.291C160.654 71.027 161.156 70.895 161.746 70.895C162.348 70.895 162.87 71.0417 163.314 71.335C163.761 71.6283 164.067 72.0298 164.232 72.5395L163.44 72.7925C163.301 72.4368 163.079 72.1618 162.775 71.9675C162.474 71.7695 162.13 71.6705 161.741 71.6705C161.305 71.6705 160.943 71.7713 160.657 71.973C160.371 72.171 160.159 72.4478 160.019 72.8035C159.88 73.1592 159.809 73.568 159.805 74.03C159.812 74.7413 159.977 75.3133 160.3 75.746C160.623 76.175 161.103 76.3895 161.741 76.3895C162.144 76.3895 162.487 76.2978 162.769 76.1145C163.055 75.9275 163.272 75.6562 163.418 75.3005L164.232 75.5425C164.012 76.0705 163.69 76.4738 163.264 76.7525C162.839 77.0275 162.331 77.165 161.741 77.165ZM165.317 69.9325V69.025H166.125V69.9325H165.317ZM165.317 77V71.06H166.125V77H165.317ZM170.601 70.125H169.908L170.562 68.42H171.255L170.601 70.125ZM170.254 77.165C169.664 77.165 169.16 77.0312 168.742 76.7635C168.324 76.4958 168.003 76.1255 167.779 75.6525C167.556 75.1795 167.444 74.6368 167.444 74.0245C167.444 73.4012 167.558 72.8548 167.785 72.3855C168.012 71.9162 168.335 71.5513 168.753 71.291C169.175 71.027 169.675 70.895 170.254 70.895C170.848 70.895 171.354 71.0288 171.772 71.2965C172.194 71.5605 172.515 71.929 172.735 72.402C172.959 72.8713 173.07 73.4122 173.07 74.0245C173.07 74.6478 172.959 75.196 172.735 75.669C172.511 76.1383 172.189 76.505 171.767 76.769C171.345 77.033 170.841 77.165 170.254 77.165ZM170.254 76.3895C170.914 76.3895 171.406 76.1713 171.728 75.735C172.051 75.295 172.212 74.7248 172.212 74.0245C172.212 73.3058 172.049 72.7338 171.723 72.3085C171.4 71.8832 170.911 71.6705 170.254 71.6705C169.811 71.6705 169.444 71.7713 169.154 71.973C168.868 72.171 168.654 72.4478 168.511 72.8035C168.372 73.1555 168.302 73.5625 168.302 74.0245C168.302 74.7395 168.467 75.3133 168.797 75.746C169.127 76.175 169.613 76.3895 170.254 76.3895ZM178.574 77V73.9695C178.574 73.6395 178.543 73.337 178.48 73.062C178.418 72.7833 178.317 72.5413 178.178 72.336C178.042 72.127 177.864 71.9657 177.644 71.852C177.428 71.7383 177.164 71.6815 176.852 71.6815C176.566 71.6815 176.313 71.731 176.093 71.83C175.877 71.929 175.694 72.072 175.543 72.259C175.397 72.4423 175.285 72.666 175.208 72.93C175.131 73.194 175.092 73.4947 175.092 73.832L174.52 73.7055C174.52 73.0968 174.627 72.5853 174.839 72.171C175.052 71.7567 175.345 71.4432 175.719 71.2305C176.093 71.0178 176.522 70.9115 177.006 70.9115C177.362 70.9115 177.672 70.9665 177.936 71.0765C178.203 71.1865 178.429 71.335 178.612 71.522C178.799 71.709 178.95 71.9235 179.063 72.1655C179.177 72.4038 179.259 72.6587 179.311 72.93C179.362 73.1977 179.388 73.4653 179.388 73.733V77H178.574ZM174.278 77V71.06H175.01V72.523H175.092V77H174.278ZM185.322 77.165C184.768 77.165 184.295 77.0275 183.903 76.7525C183.51 76.4738 183.21 76.098 183.001 75.625C182.792 75.152 182.687 74.6185 182.687 74.0245C182.687 73.4342 182.79 72.9025 182.995 72.4295C183.204 71.9565 183.503 71.5825 183.892 71.3075C184.28 71.0325 184.746 70.895 185.289 70.895C185.846 70.895 186.315 71.0307 186.697 71.302C187.078 71.5733 187.366 71.9455 187.56 72.4185C187.758 72.8878 187.857 73.4232 187.857 74.0245C187.857 74.6148 187.76 75.1483 187.566 75.625C187.371 76.098 187.085 76.4738 186.708 76.7525C186.33 77.0275 185.868 77.165 185.322 77.165ZM185.404 76.4115C185.826 76.4115 186.174 76.3088 186.449 76.1035C186.724 75.8982 186.929 75.6158 187.065 75.2565C187.201 74.8935 187.269 74.4828 187.269 74.0245C187.269 73.5588 187.201 73.1482 187.065 72.7925C186.929 72.4332 186.724 72.1527 186.449 71.951C186.178 71.7493 185.835 71.6485 185.421 71.6485C184.995 71.6485 184.643 71.753 184.365 71.962C184.086 72.171 183.879 72.4552 183.743 72.8145C183.611 73.1738 183.545 73.5772 183.545 74.0245C183.545 74.4755 183.613 74.8825 183.749 75.2455C183.888 75.6048 184.095 75.889 184.37 76.098C184.645 76.307 184.99 76.4115 185.404 76.4115ZM187.269 77V72.5285H187.181V69.08H187.995V77H187.269ZM192.051 77.165C191.472 77.165 190.969 77.0367 190.544 76.78C190.122 76.5233 189.794 76.1622 189.56 75.6965C189.325 75.2308 189.208 74.6845 189.208 74.0575C189.208 73.4085 189.323 72.8475 189.554 72.3745C189.785 71.9015 190.11 71.5367 190.528 71.28C190.949 71.0233 191.446 70.895 192.018 70.895C192.605 70.895 193.105 71.0307 193.52 71.302C193.934 71.5697 194.247 71.9547 194.46 72.457C194.673 72.9593 194.77 73.5588 194.752 74.2555H193.927V73.9695C193.912 73.1995 193.745 72.6183 193.426 72.226C193.111 71.8337 192.649 71.6375 192.04 71.6375C191.402 71.6375 190.913 71.8447 190.572 72.259C190.234 72.6733 190.066 73.2637 190.066 74.03C190.066 74.778 190.234 75.3592 190.572 75.7735C190.913 76.1842 191.395 76.3895 192.018 76.3895C192.443 76.3895 192.814 76.2923 193.129 76.098C193.448 75.9 193.699 75.6158 193.883 75.2455L194.636 75.537C194.401 76.054 194.055 76.4555 193.597 76.7415C193.142 77.0238 192.627 77.165 192.051 77.165ZM189.78 74.2555V73.579H194.317V74.2555H189.78ZM200.638 77.165C200.041 77.165 199.535 77.0312 199.12 76.7635C198.706 76.4958 198.391 76.1273 198.174 75.658C197.962 75.185 197.852 74.6423 197.844 74.03C197.852 73.4067 197.965 72.8603 198.185 72.391C198.405 71.918 198.722 71.5513 199.137 71.291C199.551 71.027 200.053 70.895 200.644 70.895C201.245 70.895 201.768 71.0417 202.211 71.335C202.659 71.6283 202.965 72.0298 203.13 72.5395L202.338 72.7925C202.198 72.4368 201.977 72.1618 201.672 71.9675C201.372 71.7695 201.027 71.6705 200.638 71.6705C200.202 71.6705 199.841 71.7713 199.555 71.973C199.269 72.171 199.056 72.4478 198.917 72.8035C198.777 73.1592 198.706 73.568 198.702 74.03C198.71 74.7413 198.875 75.3133 199.197 75.746C199.52 76.175 200 76.3895 200.638 76.3895C201.042 76.3895 201.384 76.2978 201.667 76.1145C201.953 75.9275 202.169 75.6562 202.316 75.3005L203.13 75.5425C202.91 76.0705 202.587 76.4738 202.162 76.7525C201.736 77.0275 201.229 77.165 200.638 77.165ZM206.584 77.165C205.994 77.165 205.49 77.0312 205.072 76.7635C204.654 76.4958 204.333 76.1255 204.109 75.6525C203.886 75.1795 203.774 74.6368 203.774 74.0245C203.774 73.4012 203.888 72.8548 204.115 72.3855C204.342 71.9162 204.665 71.5513 205.083 71.291C205.505 71.027 206.005 70.895 206.584 70.895C207.178 70.895 207.684 71.0288 208.102 71.2965C208.524 71.5605 208.845 71.929 209.065 72.402C209.289 72.8713 209.4 73.4122 209.4 74.0245C209.4 74.6478 209.289 75.196 209.065 75.669C208.841 76.1383 208.519 76.505 208.097 76.769C207.675 77.033 207.171 77.165 206.584 77.165ZM206.584 76.3895C207.244 76.3895 207.736 76.1713 208.058 75.735C208.381 75.295 208.542 74.7248 208.542 74.0245C208.542 73.3058 208.379 72.7338 208.053 72.3085C207.73 71.8832 207.241 71.6705 206.584 71.6705C206.141 71.6705 205.774 71.7713 205.484 71.973C205.198 72.171 204.984 72.4478 204.841 72.8035C204.702 73.1555 204.632 73.5625 204.632 74.0245C204.632 74.7395 204.797 75.3133 205.127 75.746C205.457 76.175 205.943 76.3895 206.584 76.3895ZM214.904 77V73.9695C214.904 73.6395 214.873 73.337 214.81 73.062C214.748 72.7833 214.647 72.5413 214.508 72.336C214.372 72.127 214.194 71.9657 213.974 71.852C213.758 71.7383 213.494 71.6815 213.182 71.6815C212.896 71.6815 212.643 71.731 212.423 71.83C212.207 71.929 212.024 72.072 211.873 72.259C211.727 72.4423 211.615 72.666 211.538 72.93C211.461 73.194 211.422 73.4947 211.422 73.832L210.85 73.7055C210.85 73.0968 210.957 72.5853 211.169 72.171C211.382 71.7567 211.675 71.4432 212.049 71.2305C212.423 71.0178 212.852 70.9115 213.336 70.9115C213.692 70.9115 214.002 70.9665 214.266 71.0765C214.533 71.1865 214.759 71.335 214.942 71.522C215.129 71.709 215.28 71.9235 215.393 72.1655C215.507 72.4038 215.589 72.6587 215.641 72.93C215.692 73.1977 215.718 73.4653 215.718 73.733V77H214.904ZM210.608 77V71.06H211.34V72.523H211.422V77H210.608ZM220.379 77C220.045 77.0697 219.715 77.0972 219.389 77.0825C219.066 77.0678 218.777 76.9982 218.52 76.8735C218.267 76.7488 218.075 76.5545 217.943 76.2905C217.836 76.0705 217.778 75.8487 217.767 75.625C217.759 75.3977 217.756 75.1392 217.756 74.8495V69.41H218.559V74.8165C218.559 75.0658 218.56 75.2748 218.564 75.4435C218.571 75.6085 218.61 75.7552 218.68 75.8835C218.812 76.1292 219.021 76.2758 219.307 76.3235C219.596 76.3712 219.954 76.3602 220.379 76.2905V77ZM216.485 71.753V71.06H220.379V71.753H216.485ZM223.848 77.165C223.269 77.165 222.766 77.0367 222.341 76.78C221.919 76.5233 221.591 76.1622 221.356 75.6965C221.122 75.2308 221.004 74.6845 221.004 74.0575C221.004 73.4085 221.12 72.8475 221.351 72.3745C221.582 71.9015 221.906 71.5367 222.324 71.28C222.746 71.0233 223.243 70.895 223.815 70.895C224.402 70.895 224.902 71.0307 225.316 71.302C225.731 71.5697 226.044 71.9547 226.257 72.457C226.47 72.9593 226.567 73.5588 226.548 74.2555H225.723V73.9695C225.709 73.1995 225.542 72.6183 225.223 72.226C224.908 71.8337 224.446 71.6375 223.837 71.6375C223.199 71.6375 222.709 71.8447 222.368 72.259C222.031 72.6733 221.862 73.2637 221.862 74.03C221.862 74.778 222.031 75.3592 222.368 75.7735C222.709 76.1842 223.192 76.3895 223.815 76.3895C224.24 76.3895 224.611 76.2923 224.926 76.098C225.245 75.9 225.496 75.6158 225.679 75.2455L226.433 75.537C226.198 76.054 225.852 76.4555 225.393 76.7415C224.939 77.0238 224.424 77.165 223.848 77.165ZM221.576 74.2555V73.579H226.114V74.2555H221.576ZM231.898 77V73.9695C231.898 73.6395 231.867 73.337 231.804 73.062C231.742 72.7833 231.641 72.5413 231.502 72.336C231.366 72.127 231.188 71.9657 230.968 71.852C230.752 71.7383 230.488 71.6815 230.176 71.6815C229.89 71.6815 229.637 71.731 229.417 71.83C229.201 71.929 229.018 72.072 228.867 72.259C228.721 72.4423 228.609 72.666 228.532 72.93C228.455 73.194 228.416 73.4947 228.416 73.832L227.844 73.7055C227.844 73.0968 227.951 72.5853 228.163 72.171C228.376 71.7567 228.669 71.4432 229.043 71.2305C229.417 71.0178 229.846 70.9115 230.33 70.9115C230.686 70.9115 230.996 70.9665 231.26 71.0765C231.528 71.1865 231.753 71.335 231.936 71.522C232.123 71.709 232.274 71.9235 232.387 72.1655C232.501 72.4038 232.584 72.6587 232.635 72.93C232.686 73.1977 232.712 73.4653 232.712 73.733V77H231.898ZM227.602 77V71.06H228.334V72.523H228.416V77H227.602ZM234.249 69.9325V69.025H235.058V69.9325H234.249ZM234.249 77V71.06H235.058V77H234.249ZM239.011 77.165C238.457 77.165 237.984 77.0275 237.592 76.7525C237.2 76.4738 236.899 76.098 236.69 75.625C236.481 75.152 236.377 74.6185 236.377 74.0245C236.377 73.4342 236.479 72.9025 236.685 72.4295C236.894 71.9565 237.192 71.5825 237.581 71.3075C237.97 71.0325 238.435 70.895 238.978 70.895C239.535 70.895 240.005 71.0307 240.386 71.302C240.767 71.5733 241.055 71.9455 241.25 72.4185C241.448 72.8878 241.547 73.4232 241.547 74.0245C241.547 74.6148 241.449 75.1483 241.255 75.625C241.061 76.098 240.775 76.4738 240.397 76.7525C240.019 77.0275 239.557 77.165 239.011 77.165ZM239.094 76.4115C239.515 76.4115 239.864 76.3088 240.139 76.1035C240.414 75.8982 240.619 75.6158 240.755 75.2565C240.89 74.8935 240.958 74.4828 240.958 74.0245C240.958 73.5588 240.89 73.1482 240.755 72.7925C240.619 72.4332 240.414 72.1527 240.139 71.951C239.867 71.7493 239.524 71.6485 239.11 71.6485C238.685 71.6485 238.333 71.753 238.054 71.962C237.775 72.171 237.568 72.4552 237.433 72.8145C237.301 73.1738 237.235 73.5772 237.235 74.0245C237.235 74.4755 237.302 74.8825 237.438 75.2455C237.577 75.6048 237.785 75.889 238.06 76.098C238.335 76.307 238.679 76.4115 239.094 76.4115ZM240.958 77V72.5285H240.87V69.08H241.684V77H240.958ZM245.708 77.165C245.117 77.165 244.613 77.0312 244.195 76.7635C243.777 76.4958 243.456 76.1255 243.233 75.6525C243.009 75.1795 242.897 74.6368 242.897 74.0245C242.897 73.4012 243.011 72.8548 243.238 72.3855C243.465 71.9162 243.788 71.5513 244.206 71.291C244.628 71.027 245.128 70.895 245.708 70.895C246.302 70.895 246.808 71.0288 247.226 71.2965C247.647 71.5605 247.968 71.929 248.188 72.402C248.412 72.8713 248.524 73.4122 248.524 74.0245C248.524 74.6478 248.412 75.196 248.188 75.669C247.964 76.1383 247.642 76.505 247.22 76.769C246.798 77.033 246.294 77.165 245.708 77.165ZM245.708 76.3895C246.368 76.3895 246.859 76.1713 247.182 75.735C247.504 75.295 247.666 74.7248 247.666 74.0245C247.666 73.3058 247.502 72.7338 247.176 72.3085C246.853 71.8832 246.364 71.6705 245.708 71.6705C245.264 71.6705 244.897 71.7713 244.608 71.973C244.322 72.171 244.107 72.4478 243.964 72.8035C243.825 73.1555 243.755 73.5625 243.755 74.0245C243.755 74.7395 243.92 75.3133 244.25 75.746C244.58 76.175 245.066 76.3895 245.708 76.3895ZM254.243 77.165C253.69 77.165 253.217 77.0275 252.824 76.7525C252.432 76.4738 252.131 76.098 251.922 75.625C251.713 75.152 251.609 74.6185 251.609 74.0245C251.609 73.4342 251.712 72.9025 251.917 72.4295C252.126 71.9565 252.425 71.5825 252.813 71.3075C253.202 71.0325 253.668 70.895 254.21 70.895C254.768 70.895 255.237 71.0307 255.618 71.302C256 71.5733 256.288 71.9455 256.482 72.4185C256.68 72.8878 256.779 73.4232 256.779 74.0245C256.779 74.6148 256.682 75.1483 256.487 75.625C256.293 76.098 256.007 76.4738 255.629 76.7525C255.252 77.0275 254.79 77.165 254.243 77.165ZM254.326 76.4115C254.748 76.4115 255.096 76.3088 255.371 76.1035C255.646 75.8982 255.851 75.6158 255.987 75.2565C256.123 74.8935 256.19 74.4828 256.19 74.0245C256.19 73.5588 256.123 73.1482 255.987 72.7925C255.851 72.4332 255.646 72.1527 255.371 71.951C255.1 71.7493 254.757 71.6485 254.342 71.6485C253.917 71.6485 253.565 71.753 253.286 71.962C253.008 72.171 252.801 72.4552 252.665 72.8145C252.533 73.1738 252.467 73.5772 252.467 74.0245C252.467 74.4755 252.535 74.8825 252.67 75.2455C252.81 75.6048 253.017 75.889 253.292 76.098C253.567 76.307 253.912 76.4115 254.326 76.4115ZM256.19 77V72.5285H256.102V69.08H256.916V77H256.19ZM260.973 77.165C260.394 77.165 259.891 77.0367 259.466 76.78C259.044 76.5233 258.716 76.1622 258.481 75.6965C258.247 75.2308 258.129 74.6845 258.129 74.0575C258.129 73.4085 258.245 72.8475 258.476 72.3745C258.707 71.9015 259.031 71.5367 259.449 71.28C259.871 71.0233 260.368 70.895 260.94 70.895C261.527 70.895 262.027 71.0307 262.441 71.302C262.856 71.5697 263.169 71.9547 263.382 72.457C263.595 72.9593 263.692 73.5588 263.673 74.2555H262.848V73.9695C262.834 73.1995 262.667 72.6183 262.348 72.226C262.033 71.8337 261.571 71.6375 260.962 71.6375C260.324 71.6375 259.834 71.8447 259.493 72.259C259.156 72.6733 258.987 73.2637 258.987 74.03C258.987 74.778 259.156 75.3592 259.493 75.7735C259.834 76.1842 260.317 76.3895 260.94 76.3895C261.365 76.3895 261.736 76.2923 262.051 76.098C262.37 75.9 262.621 75.6158 262.804 75.2455L263.558 75.537C263.323 76.054 262.977 76.4555 262.518 76.7415C262.064 77.0238 261.549 77.165 260.973 77.165ZM258.701 74.2555V73.579H263.239V74.2555H258.701ZM268.702 77L266.546 71.06H267.366L269.12 75.944L270.864 71.06H271.694L269.538 77H268.702ZM272.792 69.9325V69.025H273.601V69.9325H272.792ZM272.792 77V71.06H273.601V77H272.792ZM276.949 77.165C276.502 77.165 276.126 77.0843 275.821 76.923C275.521 76.7617 275.295 76.5472 275.145 76.2795C274.995 76.0118 274.919 75.7203 274.919 75.405C274.919 75.0823 274.984 74.8073 275.112 74.58C275.244 74.349 275.422 74.1602 275.645 74.0135C275.873 73.8668 276.135 73.755 276.432 73.678C276.733 73.6047 277.064 73.5405 277.427 73.4855C277.794 73.4268 278.152 73.3773 278.5 73.337C278.852 73.293 279.16 73.2508 279.424 73.2105L279.138 73.3865C279.149 72.7998 279.035 72.3653 278.797 72.083C278.559 71.8007 278.144 71.6595 277.554 71.6595C277.147 71.6595 276.802 71.7512 276.52 71.9345C276.241 72.1178 276.045 72.4075 275.931 72.8035L275.145 72.5725C275.281 72.0408 275.554 71.6283 275.964 71.335C276.375 71.0417 276.909 70.895 277.565 70.895C278.108 70.895 278.568 70.9977 278.945 71.203C279.327 71.4047 279.596 71.698 279.754 72.083C279.827 72.2553 279.875 72.4478 279.897 72.6605C279.919 72.8732 279.93 73.0895 279.93 73.3095V77H279.209V75.5095L279.418 75.5975C279.217 76.1072 278.903 76.4958 278.478 76.7635C278.053 77.0312 277.543 77.165 276.949 77.165ZM277.042 76.4665C277.42 76.4665 277.75 76.3987 278.032 76.263C278.315 76.1273 278.542 75.9422 278.714 75.7075C278.887 75.4692 278.999 75.2015 279.05 74.9045C279.094 74.7138 279.118 74.5048 279.121 74.2775C279.125 74.0465 279.127 73.8742 279.127 73.7605L279.435 73.92C279.16 73.9567 278.861 73.9933 278.538 74.03C278.219 74.0667 277.904 74.1088 277.592 74.1565C277.284 74.2042 277.006 74.261 276.756 74.327C276.588 74.3747 276.425 74.4425 276.267 74.5305C276.109 74.6148 275.979 74.7285 275.876 74.8715C275.777 75.0145 275.728 75.1923 275.728 75.405C275.728 75.5773 275.77 75.7442 275.854 75.9055C275.942 76.0668 276.082 76.2007 276.272 76.307C276.467 76.4133 276.723 76.4665 277.042 76.4665ZM280.482 79.64V78.859H280.817C281.085 78.859 281.298 78.7893 281.455 78.65C281.617 78.5143 281.697 78.2852 281.697 77.9625V71.06H282.5V78.166C282.5 78.661 282.381 79.0295 282.143 79.2715C281.908 79.5172 281.547 79.64 281.059 79.64H280.482ZM281.697 69.9325V69.025H282.5V69.9325H281.697ZM286.636 77.165C286.057 77.165 285.554 77.0367 285.129 76.78C284.707 76.5233 284.379 76.1622 284.145 75.6965C283.91 75.2308 283.793 74.6845 283.793 74.0575C283.793 73.4085 283.908 72.8475 284.139 72.3745C284.37 71.9015 284.695 71.5367 285.113 71.28C285.534 71.0233 286.031 70.895 286.603 70.895C287.19 70.895 287.69 71.0307 288.105 71.302C288.519 71.5697 288.832 71.9547 289.045 72.457C289.258 72.9593 289.355 73.5588 289.337 74.2555H288.512V73.9695C288.497 73.1995 288.33 72.6183 288.011 72.226C287.696 71.8337 287.234 71.6375 286.625 71.6375C285.987 71.6375 285.498 71.8447 285.157 72.259C284.819 72.6733 284.651 73.2637 284.651 74.03C284.651 74.778 284.819 75.3592 285.157 75.7735C285.498 76.1842 285.98 76.3895 286.603 76.3895C287.028 76.3895 287.399 76.2923 287.714 76.098C288.033 75.9 288.284 75.6158 288.468 75.2455L289.221 75.537C288.986 76.054 288.64 76.4555 288.182 76.7415C287.727 77.0238 287.212 77.165 286.636 77.165ZM284.365 74.2555V73.579H288.902V74.2555H284.365ZM292.774 77.1595C292.077 77.1595 291.503 77.0092 291.052 76.7085C290.605 76.4078 290.33 75.9898 290.227 75.4545L291.052 75.317C291.14 75.6543 291.34 75.9238 291.652 76.1255C291.967 76.3235 292.356 76.4225 292.818 76.4225C293.269 76.4225 293.624 76.329 293.885 76.142C294.145 75.9513 294.275 75.6928 294.275 75.3665C294.275 75.1832 294.233 75.0347 294.149 74.921C294.068 74.8037 293.901 74.6955 293.648 74.5965C293.395 74.4975 293.017 74.3802 292.515 74.2445C291.976 74.0978 291.554 73.9512 291.25 73.8045C290.946 73.6578 290.729 73.4892 290.601 73.2985C290.473 73.1042 290.409 72.8677 290.409 72.589C290.409 72.2517 290.504 71.9565 290.695 71.7035C290.885 71.4468 291.149 71.2488 291.487 71.1095C291.824 70.9665 292.216 70.895 292.664 70.895C293.111 70.895 293.511 70.9683 293.863 71.115C294.218 71.258 294.504 71.4597 294.721 71.72C294.937 71.9803 295.065 72.2828 295.106 72.6275L294.281 72.776C294.226 72.4277 294.051 72.1527 293.758 71.951C293.468 71.7457 293.1 71.6393 292.653 71.632C292.231 71.621 291.888 71.7017 291.624 71.874C291.36 72.0427 291.228 72.2682 291.228 72.5505C291.228 72.7082 291.276 72.8438 291.371 72.9575C291.466 73.0675 291.639 73.172 291.888 73.271C292.141 73.37 292.5 73.4782 292.966 73.5955C293.512 73.7348 293.941 73.8815 294.253 74.0355C294.565 74.1895 294.787 74.371 294.919 74.58C295.051 74.789 295.117 75.0475 295.117 75.3555C295.117 75.9165 294.908 76.3583 294.49 76.681C294.075 77 293.503 77.1595 292.774 77.1595Z","fill":"#525252"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_14_1055","x":"0.5","y":"0.5","width":"157","height":"157","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","type":"matrix","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dx":"10","dy":"15"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"25"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"type":"matrix","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"}}),_c('feBlend',{attrs:{"mode":"normal","in2":"BackgroundImageFix","result":"effect1_dropShadow_14_1055"}}),_c('feBlend',{attrs:{"mode":"normal","in":"SourceGraphic","in2":"effect1_dropShadow_14_1055","result":"shape"}})],1)])])
}
var premios_finalista_svgvue_type_template_id_7abc013c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/premios-finalista-svg.vue?vue&type=template&id=7abc013c

// CONCATENATED MODULE: ./src/components/svg/decorations/premios-finalista-svg.vue

var premios_finalista_svg_script = {}


/* normalize component */

var premios_finalista_svg_component = normalizeComponent(
  premios_finalista_svg_script,
  premios_finalista_svgvue_type_template_id_7abc013c_render,
  premios_finalista_svgvue_type_template_id_7abc013c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var premios_finalista_svg = (premios_finalista_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-navbar/index.vue?vue&type=script&lang=js








const hg_navbarvue_type_script_lang_js_locales = {
  de: {
    lang: 'de',
    logo: {
      url: '/',
    },
    items: [
      {
        label: 'Angebote',
        url: '/angebote/',
      },
      {
        label: 'Last Minute',
        url: 'https://www.urlaubsguru.de/last-minute/',
        linkType: 'a',
      },
      {
        label: 'Frühbucher 2025',
        url: 'https://www.urlaubsguru.de/fruehbucher/',
        linkType: 'a',
      },
      {
        label: 'Urlaubsziele',
        url: 'https://www.urlaubsguru.de/urlaubsziele/',
        linkType: 'a',
      },
      {
        label: 'Reisemagazin',
        url: 'https://www.urlaubsguru.de/reisemagazin/',
        linkType: 'a',
      },
    ],
    showSupportPage: false,
    showSupportPhone: true,
    supportPhone: {
      title: 'Benötigst du Hilfe?',
      subline: 'täglich von 8 bis 22 Uhr',
      phone: '+4923018939742',
      phoneLabel: '+49 2301 89 39 742',
    },
  },
  at: {
    lang: 'at',
    logo: {
      url: '/',
    },
    items: [
      {
        label: 'Angebote',
        url: '/angebote/',
      },
      {
        label: 'Last Minute',
        url: 'https://www.urlaubsguru.at/last-minute/',
        linkType: 'a',
      },
      {
        label: 'Frühbucher 2025',
        url: 'https://www.urlaubsguru.at/fruehbucher/',
        linkType: 'a',
      },
      {
        label: 'Urlaubsziele',
        url: 'https://www.urlaubsguru.at/urlaubsziele/',
        linkType: 'a',
      },
      {
        label: 'Reisemagazin',
        url: 'https://www.urlaubsguru.at/reisemagazin/',
        linkType: 'a',
      },
    ],
    showSupportPage: false,
    showSupportPhone: true,
    supportPhone: {
      title: 'Benötigst du Hilfe?',
      subline: 'täglich von 8 bis 22 Uhr',
      phone: '+4313852397',
      phoneLabel: '+43 1 - 3852397',
    },
  },
  ch: {
    lang: 'ch',
    logo: {
      url: '/',
    },
    items: [
      {
        label: 'Angebote',
        url: '/angebote/',
      },
      {
        label: 'Last Minute',
        url: 'https://www.holidayguru.ch/last-minute/',
        linkType: 'a',
      },
      {
        label: 'Frühbucher 2025',
        url: 'https://www.holidayguru.ch/fruehbucher/',
        linkType: 'a',
      },
      {
        label: 'Ferienziele',
        url: 'https://www.holidayguru.ch/ferienziele/',
        linkType: 'a',
      },
      {
        label: 'Reisemagazin',
        url: 'https://www.holidayguru.ch/reisemagazin/',
        linkType: 'a',
      },
    ],
    showSupportPage: false,
    showSupportPhone: true,
    supportPhone: {
      title: 'Benötigst du Hilfe?',
      subline: 'täglich von 8 bis 22 Uhr',
      phone: '+41 4 45222063',
      phoneLabel: '+41 4 45222063',
    },
  },
  es: {
    lang: 'es',
    logo: {
      url: '/',
    },
    items: [
      {
        label: 'Ofertas',
        url: '/deals/',
      },
      {
        label: 'Vacaciones por España',
        url: 'https://www.holidayguru.es/tag/espana/',
        linkType: 'a',
      },
      {
        label: 'Destinos',
        url: 'https://www.holidayguru.es/destinos/',
        linkType: 'a',
      },
    ],
    showSupportPage: true,
    supportPageUrl: 'https://www.holidayguru.es/contacto/',
    showSupportPhone: false,
  },
  nl: {
    lang: 'nl',
    logo: {
      url: '/',
    },
    items: [
      {
        label: 'Aanbiedingen',
        url: '/aanbiedingen/',
      },
      {
        label: 'Bestemmingen',
        url: 'https://www.holidayguru.nl/vakantiebestemmingen/',
        linkType: 'a',
      },
    ],
    showSupportPage: false,
    showSupportPhone: false,
  },
}

/* harmony default export */ var hg_navbarvue_type_script_lang_js = ({
  components: {
    MountingPortal: portal_vue_common["MountingPortal"],
    Hamburger: hamburger,
    Support: support,
    PremiosFinalistaSvg: premios_finalista_svg,
  },
  data: () => ({
    locale: hg_navbarvue_type_script_lang_js_locales.de,
    show: true,
    showFade: true,
    logoClass: '',
    isHamburgerActive: false,
    showUserMenu: false,
    showSupportBox: false,
    createdPortal: false,
    isMounted: false,
  }),
  props: {
    lang: {
      type: String,
      default: 'de',
    },
    menu: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Object,
      default: () => {},
    },
    isMobile: {
      type: Boolean,
      default: true,
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
    linkType: {
      type: String,
      default: 'a',
    },
    pathName: {
      type: String,
      default: '',
    },
    showBookmarkButton: {
      type: Boolean,
      default: true,
    },
    showUserButton: {
      type: Boolean,
      default: true,
    },
    showPremiosLogo: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    lang() {
      this.setLocale()
    },
    isHamburgerActive() {
      if (this.isHamburgerActive) {
        this.showOverlay()
      } else {
        this.hideOverlay()
      }
    },
  },
  created() {
    // Adapt the support subline text for specific holidays
    let currentYear = new Date().getFullYear()
    let specialSubline = null

    if (
      isToday(new Date(currentYear, 11, 24)) ||
      isToday(new Date(currentYear, 11, 31))
    ) {
      specialSubline = 'heute von 8 bis 14 Uhr'
    } else if (
      isToday(new Date(currentYear, 11, 25)) ||
      isToday(new Date(currentYear, 11, 26)) ||
      isToday(new Date(currentYear, 0, 1))
    ) {
      specialSubline = 'heute von 10 bis 22 Uhr'
    }

    if (specialSubline) {
      hg_navbarvue_type_script_lang_js_locales.de.supportPhone.subline = specialSubline
      hg_navbarvue_type_script_lang_js_locales.at.supportPhone.subline = specialSubline
      hg_navbarvue_type_script_lang_js_locales.ch.supportPhone.subline = specialSubline
    }

    this.setLocale()

    if (this.pathName.length == 0 && window != null) {
      this.pathName = window.location.pathname
    }
  },
  mounted() {
    var navbarPortalTarget = document.createElement('div')
    navbarPortalTarget.id = 'hg-navbar-portal'
    document.body.appendChild(navbarPortalTarget)
    this.createdPortal = true

    document.addEventListener('click', this.onClickout)
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('click', this.onClickout)
    })

    this.isMounted = true
  },

  methods: {
    setLocale() {
      this.locale = getLocale(hg_navbarvue_type_script_lang_js_locales, this.lang)
    },
    getClassForNavbarLink(item) {
      if (item.promoted) {
        // Add class for promotion link
        return 'promotedLink'
      } else if (this.pathName.startsWith(item.url)) {
        // Add class for active link
        return 'nuxt-link-exact-active'
      }

      return ''
    },
    showOverlay() {
      document.documentElement.style.setProperty(
        'overflow',
        'hidden',
        'important'
      )
    },

    hideOverlay() {
      document.documentElement.style.setProperty(
        'overflow',
        'auto',
        'important'
      )
    },

    clickLogo() {
      this.$emit('onLogoClick')
    },

    clickBookmarkButton() {
      this.$emit('onClickBookmark')
    },
    clickSupportButton() {
      this.showSupportBox = !this.showSupportBox
    },
    clickUserButton() {
      if (this.user && this.user.profile) {
        this.showUserMenu = !this.showUserMenu
      } else {
        this.$emit('onClickUser')
      }
    },
    onClickout(event) {
      const composedPath = event.composedPath()

      if (
        composedPath.includes(this.$refs.navMobile) ||
        composedPath.includes(this.$refs.logo) ||
        composedPath.includes(this.$refs.bookmarkButton) ||
        composedPath.includes(this.$refs.userButton)
      ) {
        this.isHamburgerActive = false
      }

      if (
        !composedPath.includes(this.$refs.supportButton) &&
        !composedPath.includes(this.$refs.supportBox)
      ) {
        this.showSupportBox = false
      }

      if (!this.showUserMenu) return
      // Clicked outside
      if (
        !composedPath.includes(this.$refs.userButton) &&
        !composedPath.includes(this.$refs.userMenu)
      ) {
        this.showUserMenu = false
      }
      // Clicked an item inside
      if (composedPath.includes(this.$refs.userMenu)) {
        this.showUserMenu = false
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-navbar/index.vue?vue&type=script&lang=js
 /* harmony default export */ var partials_hg_navbarvue_type_script_lang_js = (hg_navbarvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-navbar/index.vue?vue&type=style&index=0&id=687b2f39&prod&scoped=true&lang=postcss
var hg_navbarvue_type_style_index_0_id_687b2f39_prod_scoped_true_lang_postcss = __webpack_require__("6da7");

// EXTERNAL MODULE: ./src/components/partials/hg-navbar/index.vue?vue&type=style&index=1&id=687b2f39&prod&lang=postcss
var hg_navbarvue_type_style_index_1_id_687b2f39_prod_lang_postcss = __webpack_require__("076b");

// CONCATENATED MODULE: ./src/components/partials/hg-navbar/index.vue







/* normalize component */

var hg_navbar_component = normalizeComponent(
  partials_hg_navbarvue_type_script_lang_js,
  hg_navbarvue_type_template_id_687b2f39_scoped_true_render,
  hg_navbarvue_type_template_id_687b2f39_scoped_true_staticRenderFns,
  false,
  null,
  "687b2f39",
  null
  
)

/* harmony default export */ var hg_navbar = (hg_navbar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer.vue?vue&type=template&id=e64e1fb6&scoped=true
var hg_footervue_type_template_id_e64e1fb6_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{key:"footer",class:[
    'footer hg-footer hg-reset',
    { 'footer-bottom-safe-space': _vm.hasBottomSafeSpace },
  ]},[_c('div',{staticClass:"left"}),_c('div',{staticClass:"footer__content"},[_c('div',{staticClass:"footer__secondary"},[(_vm.locale.corporate)?_c('div',{staticClass:"panel corporate-panel"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.locale.corporate.title))])]),_c('div',{staticClass:"panel-content"},[_c('ul',_vm._l((_vm.locale.corporate.data),function(element,index){return _c('li',{key:index},[_c('a',{staticClass:"link",attrs:{"href":element.url,"target":element.target}},[_c('span',[_vm._v(_vm._s(element.label))])])])}),0)])]):_vm._e(),(_vm.locale.informations)?_c('div',{staticClass:"panel information-panel"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.locale.informations.title))])]),_c('div',{staticClass:"panel-content"},[_c('ul',[_vm._l((_vm.locale.informations.data),function(element,index){return _c('li',{key:index},[_c('a',{staticClass:"link",attrs:{"href":element.url,"target":element.target}},[_c('span',[_vm._v(_vm._s(element.label))])])])}),(_vm.agbLink)?_c('li',[_c('a',{staticClass:"link",attrs:{"href":_vm.agbLink,"target":"blank"}},[_c('span',[_vm._v("AGB")])])]):_vm._e()],2)])]):_vm._e(),(_vm.locale.app)?_c('div',{staticClass:"panel app-panel"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.locale.app.title))])]),_c('div',{staticClass:"panel-content"},[_c('div',{staticClass:"badge-container"},[_c('a',{staticClass:"appstore app-badge",attrs:{"href":_vm.locale.app.appstore,"target":"_blank"}},[_c(`AppStore${_vm.locale.lang.toUpperCase()}`,{tag:"component"})],1),_c('a',{staticClass:"playstore app-badge",attrs:{"href":_vm.locale.app.playstore,"target":"_blank"}},[_c(`PlayStore${_vm.locale.lang.toUpperCase()}`,{tag:"component"})],1)])])]):_vm._e(),(_vm.locale.newsletter)?_c('div',{staticClass:"panel newsletter-panel"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.locale.newsletter.title))])]),_c('div',{staticClass:"panel-content"},[_c('hg-button',{staticClass:"tw-h-12",attrs:{"type":"submit","color":"teal","size":"full"},on:{"onClick":_vm.onNewsletterButtonClick}},[_c('span',[_vm._v(_vm._s(_vm.locale.newsletter.button))])])],1)]):_vm._e(),(_vm.locale.social)?_c('div',{staticClass:"panel social-panel"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.locale.social.title))])]),_c('div',{staticClass:"panel-content"},_vm._l((_vm.locale.social.data),function(element,index){return _c('a',{key:index,class:`social-link ${element.icon}`,attrs:{"href":element.url,"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"fa-icon icon-light",attrs:{"icon":['fab', element.icon]}}),_c('span',[_vm._v(_vm._s(element.label))])],1)}),0)]):_vm._e()]),_c('div',{staticClass:"footer__primary"},[_c('div',{staticClass:"logo__content"},[_c('GuruLogo',{attrs:{"lang":_vm.locale.lang}})],1),(_vm.locale.lang === 'de')?_c('div',{staticClass:"trust-pilot"},[_vm._m(0)]):_vm._e(),(_vm.locale === 'at')?_c('div',{staticClass:"trust-pilot"},[_vm._m(1)]):_vm._e(),(_vm.locale === 'ch')?_c('div',{staticClass:"trust-pilot"},[_vm._m(2)]):_vm._e(),(_vm.locale === 'nl')?_c('div',{staticClass:"trust-pilot"},[_vm._m(3)]):_vm._e(),(_vm.locale.footer)?_c('div',{staticClass:"buttons"},[_vm._l((_vm.locale.footer.data),function(element,index){return _c('a',{key:index,staticClass:"hg-button hg-button--tealdark hg-button--regular",attrs:{"href":element.url,"target":element.target}},[_c('span',[_vm._v(_vm._s(element.label))])])}),(_vm.activateCookieConsent)?_c('hg-button',{attrs:{"type":"submit","color":"tealdark","tag":"button"},on:{"onClick":_vm.onCookieButtonClick}},[_c('span',[_vm._v("Cookies")])]):_vm._e()],2):_vm._e()]),_c('div',{staticClass:"footer__copy"},[_c('span',{},[_vm._v(" Copyright © "+_vm._s(_vm.getTheYear)+" – "+_vm._s(_vm.locale.title)+" ")])])]),_c('div',{staticClass:"right"})])
}
var hg_footervue_type_template_id_e64e1fb6_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trustpilot-widget",attrs:{"data-locale":"de-DE","data-template-id":"53aa8807dec7e10d38f59f32","data-businessunit-id":"512d0e32000064000522fdf7","data-style-height":"150px","data-style-width":"100%","data-theme":"dark"}},[_c('a',{attrs:{"href":"https://de.trustpilot.com/review/www.urlaubsguru.de ","target":"_blank","rel":"noopener"}},[_vm._v("Trustpilot")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trustpilot-widget",attrs:{"data-locale":"de-AT","data-template-id":"53aa8807dec7e10d38f59f32","data-businessunit-id":"53941986000064000578e457","data-style-height":"150px","data-style-width":"100%","data-theme":"dark"}},[_c('a',{attrs:{"href":"https://at.trustpilot.com/review/urlaubsguru.at","target":"_blank","rel":"noopener"}},[_vm._v("Trustpilot")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trustpilot-widget",attrs:{"data-locale":"de-CH","data-template-id":"53aa8807dec7e10d38f59f32","data-businessunit-id":"5512c8f40000ff00057e4922","data-style-height":"150px","data-style-width":"100%","data-theme":"dark"}},[_c('a',{attrs:{"href":"https://ch.trustpilot.com/review/holidayguru.ch","target":"_blank","rel":"noopener"}},[_vm._v("Trustpilot")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trustpilot-widget",attrs:{"data-locale":"nl-NL","data-template-id":"53aa8807dec7e10d38f59f32","data-businessunit-id":"537611cd000064000578c3f8","data-style-height":"150px","data-style-width":"100%","data-theme":"dark"}},[_c('a',{attrs:{"href":"https://nl.trustpilot.com/review/holidayguru.nl","target":"_blank","rel":"noopener"}},[_vm._v("Trustpilot")])])
}]


// CONCATENATED MODULE: ./src/components/partials/hg-footer.vue?vue&type=template&id=e64e1fb6&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer.vue?vue&type=script&lang=js



const hg_footervue_type_script_lang_js_locales = {
  de: {
    lang: 'de',
    title: 'Urlaubsguru',
    corporate: {
      title: 'Unternehmen',
      data: [
        {
          label: 'Über Urlaubsguru',
          url: 'https://www.urlaubsguru.de/ueber-uns/',
          target: '_self',
        },
        {
          label: 'Jobs',
          url: 'https://www.urlaubsguru.de/jobs/',
          target: '_self',
        },
        {
          label: 'Werbung',
          url: 'https://www.urlaubsguru.de/werbung/',
          target: '_self',
        },
        {
          label: 'Presse',
          url: 'https://www.urlaubsguru.de/presse/',
          target: '_self',
        },
      ],
    },
    informations: {
      title: 'Informationen',
      data: [
        {
          label: 'Corona Reiseinformationen',
          url: 'https://www.urlaubsguru.de/corona/',
          target: '_self',
        },
        {
          label: 'Buchen beim Urlaubsguru',
          url: 'https://www.urlaubsguru.de/suchen-buchen-bei-urlaubsguru/',
          target: '_self',
        },
        {
          label: 'Urlaubsguru Feedback',
          url: 'https://www.urlaubsguru.de/urlaubsguru-feedback/',
          target: '_self',
        },
        {
          label: 'Nachhaltig Reisen',
          url: 'https://www.urlaubsguru.de/nachhaltiger-tourismus/',
          target: '_self',
        },
        {
          label: 'Messenger',
          url: 'https://www.urlaubsguru.de/messenger/',
          target: '_self',
        },
      ],
    },
    app: {
      title: 'Ladet euch die App herunter',
      appstore:
        'https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087',
      playstore:
        'https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru',
    },
    newsletter: {
      title: 'Meldet euch für den Newsletter an',
      button: 'Zum Newsletter',
      url: 'https://www.urlaubsguru.de/newsletter/',
    },
    social: {
      title: 'Folge uns',
      data: [
        {
          label: 'Facebook',
          icon: 'facebook',
          url: 'https://www.facebook.com/derurlaubsguru/',
        },
        {
          label: 'Instagram',
          icon: 'instagram',
          url: 'https://www.instagram.com/urlaubsguru/',
        },
        {
          label: 'YouTube',
          icon: 'youtube',
          url: 'https://www.youtube.com/channel/UCKDLTlnI9j6lyP6CyTp293g',
        },
        {
          label: 'TikTok',
          icon: 'tiktok',
          url: 'https://www.tiktok.com/@urlaubsguru.de',
        },
      ],
    },
    footer: {
      data: [
        {
          label: 'Datenschutzerklärung',
          url: 'https://www.urlaubsguru.de/datenschutzerklaerung/',
          target: '_self',
        },
        {
          label: 'Sitemap',
          url: 'https://www.urlaubsguru.de/sitemap/',
          target: '_self',
        },
        {
          label: 'Schlagworte',
          url: 'https://www.urlaubsguru.de/tag/',
          target: '_self',
        },
        {
          label: 'Impressum',
          url: 'https://www.urlaubsguru.de/impressum/',
          target: '_self',
        },
      ],
    },
  },
  at: {
    lang: 'at',
    title: 'Urlaubsguru',
    corporate: {
      title: 'Unternehmen',
      data: [
        {
          label: 'Über Urlaubsguru',
          url: 'https://www.urlaubsguru.at/ueber-uns/',
          target: '_self',
        },
        {
          label: 'Jobs',
          url: 'https://www.urlaubsguru.de/jobs/',
          target: '_self',
        },
        {
          label: 'Werbung und Kooperationen',
          url: 'https://www.urlaubsguru.at/werbung-und-kooperationen/',
          target: '_self',
        },
        {
          label: 'Presse',
          url: 'https://www.urlaubsguru.de/presse/',
          target: '_self',
        },
      ],
    },
    informations: {
      title: 'Informationen',
      data: [
        {
          label: 'Corona Infos',
          url: 'https://www.urlaubsguru.at/corona/',
          target: '_self',
        },
        {
          label: 'Buchen beim Urlaubsguru',
          url: 'https://www.urlaubsguru.at/suchen-buchen-urlaubsguru/',
          target: '_self',
        },
        {
          label: 'Dein Feedback an Uns',
          url: 'https://www.urlaubsguru.at/urlaubsguru-feedback/',
          target: '_self',
        },
        {
          label: 'Reisemagazin',
          url: 'https://www.urlaubsguru.at/reisemagazin/',
          target: '_self',
        },
        {
          label: 'Messenger',
          url: 'https://www.urlaubsguru.at/messenger/',
          target: '_self',
        },
      ],
    },
    app: {
      title: 'Ladet euch die App herunter',
      appstore:
        'https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087',
      playstore:
        'https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru',
    },
    newsletter: {
      title: 'Meldet euch für den Newsletter an',
      button: 'Newsletter',
      url: 'https://www.urlaubsguru.at/newsletter/',
    },
    social: {
      title: 'Folgt uns auf',
      data: [
        {
          label: 'Facebook',
          icon: 'facebook',
          url: 'https://www.facebook.com/urlaubsguruAT/',
        },
        {
          label: 'Instagram',
          icon: 'instagram',
          url: 'https://www.instagram.com/urlaubsguru_at/',
        },
      ],
    },
    footer: {
      data: [
        {
          label: 'Datenschutzerklärung',
          url: 'https://www.urlaubsguru.at/datenschutzerklaerung/',
          target: '_self',
        },
        {
          label: 'Sitemap',
          url: 'https://www.urlaubsguru.at/sitemap/',
          target: '_self',
        },
        {
          label: 'Schlagworte',
          url: 'https://www.urlaubsguru.at/tag/',
          target: '_self',
        },
        {
          label: 'Impressum/Rechtliche Hinweise',
          url: 'https://www.urlaubsguru.at/impressum/',
          target: '_self',
        },
      ],
    },
  },
  ch: {
    lang: 'ch',
    title: 'Holidayguru',
    corporate: {
      title: 'Unternehmen',
      data: [
        {
          label: 'Über Holidayguru',
          url: 'https://www.holidayguru.ch/ueber-uns/',
          target: '_self',
        },
        {
          label: 'Jobs',
          url: 'https://www.urlaubsguru.de/jobs/',
          target: '_self',
        },
        {
          label: 'Werbung',
          url: 'https://www.holidayguru.ch/werbung-und-kooperationen/',
          target: '_self',
        },
        {
          label: 'Presse',
          url: 'https://www.urlaubsguru.de/presse/',
          target: '_self',
        },
      ],
    },
    informations: {
      title: 'Informationen',
      data: [
        {
          label: 'Corona Infos',
          url: 'https://www.holidayguru.ch/reisemagazin/coronavirus-faq/',
          target: '_self',
        },
        {
          label: 'Buchen bei Holidayguru',
          url: 'https://www.holidayguru.ch/suchen-buchen-holidayguru/',
          target: '_self',
        },
        {
          label: 'Dein Feedback an Uns',
          url: 'https://www.holidayguru.ch/holidayguru-feedback/',
          target: '_self',
        },
        {
          label: 'Reisemagazin',
          url: 'https://www.holidayguru.ch/reisemagazin/',
          target: '_self',
        },
        {
          label: 'Messenger',
          url: 'https://www.holidayguru.ch/messenger/',
          target: '_self',
        },
      ],
    },
    app: {
      title: 'Ladet euch die App herunter',
      appstore:
        'https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087',
      playstore:
        'https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru',
    },
    newsletter: {
      title: 'Meldet euch für den Newsletter an',
      button: 'Newsletter',
      url: 'https://www.holidayguru.ch/newsletter/',
    },
    social: {
      title: 'Folgt uns auf',
      data: [
        {
          label: 'Facebook',
          icon: 'facebook',
          url: 'https://www.facebook.com/urlaubsguru.ch/',
        },
        {
          label: 'Instagram',
          icon: 'instagram',
          url: 'https://www.instagram.com/Holidayguru_ch/',
        },
      ],
    },
    footer: {
      data: [
        {
          label: 'Datenschutzerklärung',
          url: 'https://www.holidayguru.ch/datenschutzerklaerung/',
          target: '_self',
        },
        {
          label: 'Sitemap',
          url: 'https://www.holidayguru.ch/sitemap/',
          target: '_self',
        },
        {
          label: 'Schlagworte',
          url: 'https://www.holidayguru.ch/tag/',
          target: '_self',
        },
        {
          label: 'Impressum/Rechtliche Hinweise',
          url: 'https://www.holidayguru.ch/impressum/',
          target: '_self',
        },
        {
          label: 'Aktuelle Reiseinfos',
          url: 'https://www.holidayguru.ch/reisemagazin/wo-2020-ferien/',
          target: '_self',
        },
      ],
    },
  },
  es: {
    lang: 'es',
    title: 'Holidayguru',
    corporate: {
      title: 'Empresa',
      data: [
        {
          label: 'Sobre Holidayguru',
          url: 'https://www.holidayguru.es/sobre-mi/',
          target: '_self',
        },
        {
          label: 'Prensa',
          url: 'https://www.holidayguru.es/prensa/',
          target: '_self',
        },
        {
          label: 'Trabaja con nosotros',
          url: 'https://www.urlaubsguru.de/jobs/',
          target: '_self',
        },
        {
          label: 'App',
          url: 'https://www.holidayguru.es/app/',
          target: '_self',
        },
      ],
    },
    informations: {
      title: 'Información',
      data: [
        {
          label: 'Preguntas Frecuentes',
          url: 'https://www.holidayguru.es/preguntas-frecuentes-holidayguru/',
          target: '_self',
        },
        {
          label: 'Revista de viajes',
          url: 'https://www.holidayguru.es/revista-de-viajes/',
          target: '_self',
        },
        {
          label: 'Ofertas último minuto',
          url: 'https://www.holidayguru.es/ofertas-ultimo-minuto/',
          target: '_self',
        },
        {
          label: 'Ofertas con cancelación gratuita',
          url: 'https://www.holidayguru.es/viajes-con-cancelacion-gratuita/',
          target: '_self',
        },
      ],
    },
    app: {
      title: 'Descárgate mi App gratuita',
      appstore:
        'https://apps.apple.com/es/app/urlaubsguru-reise-schnappchen/id692735087',
      playstore:
        'https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru&hl=es',
    },
    newsletter: {
      title: 'Regístrate en mi Newsletter',
      button: 'Newsletter',
      url: 'https://www.holidayguru.es/newsletter/',
    },
    social: {
      title: 'Sígueme',
      data: [
        {
          label: 'Facebook',
          icon: 'facebook',
          url: 'https://www.facebook.com/Holidayguru.ES/',
        },
        {
          label: 'TikTok',
          icon: 'tiktok',
          url: 'https://www.tiktok.com/@holidayguru',
        },
        {
          label: 'Instagram',
          icon: 'instagram',
          url: 'https://www.instagram.com/holidayguru.es/',
        },
        {
          label: 'Pinterest',
          icon: 'pinterest',
          url: 'https://www.pinterest.de/holidayguru_es/',
        },
      ],
    },
    footer: {
      data: [
        {
          label: 'Política de privacidad',
          url: 'https://www.holidayguru.es/politica-de-privacidad/',
          target: '_self',
        },
        {
          label: 'Aviso legal/Referencias jurídicas',
          url: 'https://www.holidayguru.es/aviso-legal/',
          target: '_self',
        },
        {
          label: 'Palabras clave',
          url: 'https://www.holidayguru.es/tag/',
          target: '_self',
        },
      ],
    },
  },
  nl: {
    lang: 'nl',
    title: 'Holidayguru',
    corporate: {
      title: 'Holidayguru',
      data: [
        {
          label: 'Over ons',
          url: 'https://www.holidayguru.nl/over-mij/',
          target: '_self',
        },
        {
          label: 'Advertising and partnerships',
          url: 'https://www.holidayguru.nl/advertising-and-partnerships/',
          target: '_self',
        },
        {
          label: 'Pers',
          url: 'https://www.holidayguru.nl/pers/',
          target: '_self',
        },
        {
          label: 'Vacatures',
          url: 'https://www.holidayguru.nl/vacatures/',
          target: '_self',
        },
      ],
    },
    informations: {
      title: 'Informatie',
      data: [
        {
          label: 'Veelgestelde vragen',
          url: 'https://www.holidayguru.nl/faq/',
          target: '_self',
        },
        {
          label: 'Vakantie in coronatijden',
          url: 'https://www.holidayguru.nl/vakantie-en-corona-wat-moet-je-weten/',
          target: '_self',
        },
        {
          label: 'Topbestemmingen 2022',
          url: 'https://www.holidayguru.nl/travel-magazine/topbestemmingen-dit-jaar/',
          target: '_self',
        },
        {
          label: 'Duurzaam reizen',
          url: 'https://www.holidayguru.nl/travel-magazine/duurzaam-reizen-tips/',
          target: '_self',
        },
      ],
    },
    app: {
      title: 'Download mijn app',
      appstore:
        'https://itunes.apple.com/nl/app/urlaubsguru-reise-schnappchen/id692735087?mt=8',
      playstore:
        'https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru&hl=nl-nl',
    },
    newsletter: {
      title: 'Meld je aan voor mijn nieuwsbrief',
      button: 'E-mail nieuwsbrief',
      url: 'https://www.holidayguru.nl/newsletter/',
    },
    social: {
      title: 'Volg ons',
      data: [
        {
          label: 'Facebook',
          icon: 'facebook',
          url: 'https://www.facebook.com/holidayguru.nl/',
        },
        {
          label: 'Instagram',
          icon: 'instagram',
          url: 'https://www.instagram.com/holidaygurunl/',
        },
        {
          label: 'TikTok',
          icon: 'tiktok',
          url: 'https://www.tiktok.com/@holidayguru_nl',
        },
        {
          label: 'Pinterest',
          icon: 'pinterest',
          url: 'https://nl.pinterest.com/holidaygurunl/',
        },
      ],
    },
    footer: {
      data: [
        {
          label: 'Privacy statement',
          url: 'https://www.holidayguru.nl/privacy-statement/',
          target: '_self',
        },
        {
          label: 'Tags',
          url: 'https://www.holidayguru.nl/tag/',
          target: '_self',
        },
        {
          label: 'Impressum / wettelijke bepalingen',
          url: 'https://www.holidayguru.nl/imprint/',
          target: '_self',
        },
      ],
    },
  },
}

/* harmony default export */ var hg_footervue_type_script_lang_js = ({
  props: {
    lang: {
      type: String,
      default: 'de',
    },
    agbLink: {
      type: String,
      default: null,
    },
    activateCookieConsent: {
      type: Boolean,
      default: false,
    },
    hasBottomSafeSpace: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      locale: hg_footervue_type_script_lang_js_locales.de,
    }
  },
  watch: {
    lang() {
      this.setLocale()
    },
  },
  methods: {
    setLocale() {
      this.locale = getLocale(hg_footervue_type_script_lang_js_locales, this.lang)
    },
    onNewsletterButtonClick() {
      this.$emit('onNewsletterButtonClick')
    },
    onCookieButtonClick() {
      this.$emit('onCookieButtonClick')
    },
  },
  created() {
    this.setLocale()
  },
  mounted() {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute(
      'src',
      '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    )
    document.head.appendChild(recaptchaScript)
  },
  computed: {
    getTheYear() {
      const date = new Date()
      return date.getFullYear()
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-footer.vue?vue&type=script&lang=js
 /* harmony default export */ var partials_hg_footervue_type_script_lang_js = (hg_footervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-footer.vue?vue&type=style&index=0&id=e64e1fb6&prod&lang=postcss
var hg_footervue_type_style_index_0_id_e64e1fb6_prod_lang_postcss = __webpack_require__("bfea");

// EXTERNAL MODULE: ./src/components/partials/hg-footer.vue?vue&type=style&index=1&id=e64e1fb6&prod&scoped=true&lang=postcss
var hg_footervue_type_style_index_1_id_e64e1fb6_prod_scoped_true_lang_postcss = __webpack_require__("7dac");

// CONCATENATED MODULE: ./src/components/partials/hg-footer.vue







/* normalize component */

var hg_footer_component = normalizeComponent(
  partials_hg_footervue_type_script_lang_js,
  hg_footervue_type_template_id_e64e1fb6_scoped_true_render,
  hg_footervue_type_template_id_e64e1fb6_scoped_true_staticRenderFns,
  false,
  null,
  "e64e1fb6",
  null
  
)

/* harmony default export */ var hg_footer = (hg_footer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-modal-navbar.vue?vue&type=template&id=5fb9d48a&scoped=true
var hg_modal_navbarvue_type_template_id_5fb9d48a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-mobile-navbar"},[_c('h4',{staticClass:"hg-title"},[_vm._t("default")],2),_c('HgButton',{attrs:{"size":"small","color":"transparent"},on:{"onClick":function($event){return _vm.$emit('onClickBack')}}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('close'))+" ")]),_c('HgIcon',{attrs:{"name":"times","size":"small"}})],1)],1)
}
var hg_modal_navbarvue_type_template_id_5fb9d48a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-modal-navbar.vue?vue&type=template&id=5fb9d48a&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-modal-navbar.vue?vue&type=script&lang=js

/* harmony default export */ var hg_modal_navbarvue_type_script_lang_js = ({});

// CONCATENATED MODULE: ./src/components/partials/hg-modal-navbar.vue?vue&type=script&lang=js
 /* harmony default export */ var partials_hg_modal_navbarvue_type_script_lang_js = (hg_modal_navbarvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-modal-navbar.vue?vue&type=style&index=0&id=5fb9d48a&prod&lang=postcss&scoped=true
var hg_modal_navbarvue_type_style_index_0_id_5fb9d48a_prod_lang_postcss_scoped_true = __webpack_require__("e625");

// CONCATENATED MODULE: ./src/components/partials/hg-modal-navbar.vue






/* normalize component */

var hg_modal_navbar_component = normalizeComponent(
  partials_hg_modal_navbarvue_type_script_lang_js,
  hg_modal_navbarvue_type_template_id_5fb9d48a_scoped_true_render,
  hg_modal_navbarvue_type_template_id_5fb9d48a_scoped_true_staticRenderFns,
  false,
  null,
  "5fb9d48a",
  null
  
)

/* harmony default export */ var hg_modal_navbar = (hg_modal_navbar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-hero.vue?vue&type=template&id=2cb7cd6e&scoped=true
var hg_herovue_type_template_id_2cb7cd6e_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hg-hero"},[_c('h1',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"hg-subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]),_vm._t("default")],2)
}
var hg_herovue_type_template_id_2cb7cd6e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-hero.vue?vue&type=template&id=2cb7cd6e&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-hero.vue?vue&type=script&lang=js

/* harmony default export */ var hg_herovue_type_script_lang_js = ({
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-hero.vue?vue&type=script&lang=js
 /* harmony default export */ var partials_hg_herovue_type_script_lang_js = (hg_herovue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-hero.vue?vue&type=style&index=0&id=2cb7cd6e&prod&lang=postcss&scoped=true
var hg_herovue_type_style_index_0_id_2cb7cd6e_prod_lang_postcss_scoped_true = __webpack_require__("8cb5");

// CONCATENATED MODULE: ./src/components/partials/hg-hero.vue






/* normalize component */

var hg_hero_component = normalizeComponent(
  partials_hg_herovue_type_script_lang_js,
  hg_herovue_type_template_id_2cb7cd6e_scoped_true_render,
  hg_herovue_type_template_id_2cb7cd6e_scoped_true_staticRenderFns,
  false,
  null,
  "2cb7cd6e",
  null
  
)

/* harmony default export */ var hg_hero = (hg_hero_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-portal/hg-portal-dropdown-desktop.vue?vue&type=template&id=5d3136c4&scoped=true
var hg_portal_dropdown_desktopvue_type_template_id_5d3136c4_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stack",class:{ padding: _vm.padding }},[_vm._t("content-1"),_c('div',{staticClass:"message"},[_vm._t("message")],2),_vm._t("content-2")],2)
}
var hg_portal_dropdown_desktopvue_type_template_id_5d3136c4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-portal/hg-portal-dropdown-desktop.vue?vue&type=template&id=5d3136c4&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-portal/hg-portal-dropdown-desktop.vue?vue&type=script&lang=js

/* harmony default export */ var hg_portal_dropdown_desktopvue_type_script_lang_js = ({
  props: {
    padding: {
      type: Boolean,
      default: true,
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-portal/hg-portal-dropdown-desktop.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_portal_hg_portal_dropdown_desktopvue_type_script_lang_js = (hg_portal_dropdown_desktopvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-portal/hg-portal-dropdown-desktop.vue?vue&type=style&index=0&id=5d3136c4&prod&scoped=true&lang=css
var hg_portal_dropdown_desktopvue_type_style_index_0_id_5d3136c4_prod_scoped_true_lang_css = __webpack_require__("7039");

// CONCATENATED MODULE: ./src/components/partials/hg-portal/hg-portal-dropdown-desktop.vue






/* normalize component */

var hg_portal_dropdown_desktop_component = normalizeComponent(
  hg_portal_hg_portal_dropdown_desktopvue_type_script_lang_js,
  hg_portal_dropdown_desktopvue_type_template_id_5d3136c4_scoped_true_render,
  hg_portal_dropdown_desktopvue_type_template_id_5d3136c4_scoped_true_staticRenderFns,
  false,
  null,
  "5d3136c4",
  null
  
)

/* harmony default export */ var hg_portal_dropdown_desktop = (hg_portal_dropdown_desktop_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-portal/hg-portal-dropdown-mobile.vue?vue&type=template&id=b62e6636
var hg_portal_dropdown_mobilevue_type_template_id_b62e6636_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.createdPortal)?[_c('MountingPortal',{tag:"component",attrs:{"mountTo":"#mobile-portal","append":"","multiple":""}},[_c('div',{staticClass:"mobile-overlay"}),_c('div',{staticClass:"wrapper-mobile"},[_c('div',{staticClass:"stack",class:{ padding: _vm.padding }},[_c('div',{staticClass:"mobile-navbar"},[_c('div',{staticClass:"upper-navbar"},[_c('button',{staticClass:"hg-button hg-button--white",on:{"click":_vm.reset}},[_c('hg-icon',{attrs:{"name":"chevron-left","size":"small"}})],1),_c('label',[_vm._t("default")],2),_c('button',{staticClass:"hg-button hg-button--white",on:{"click":_vm.close}},[_c('hg-icon',{attrs:{"name":"times","pack":"fal","size":"small"}})],1)]),_c('div',{staticClass:"header-field"},[_vm._t("header-field")],2)]),_c('div',{staticClass:"message-field"},[_vm._t("message")],2),_vm._t("content-1"),_vm._t("content-2")],2),_c('HgButton',{staticClass:"hg-button-dropdown-mobile",attrs:{"color":_vm.submitButtonColor,"rounded":false,"size":"regular","tag":"button"},on:{"onClick":_vm.close}},[_vm._v(" "+_vm._s(_vm.$t('inputs.buttonTextApply'))+" ")])],1)])]:_vm._e()],2)
}
var hg_portal_dropdown_mobilevue_type_template_id_b62e6636_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-portal/hg-portal-dropdown-mobile.vue?vue&type=template&id=b62e6636

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-portal/hg-portal-dropdown-mobile.vue?vue&type=script&lang=js



/* harmony default export */ var hg_portal_dropdown_mobilevue_type_script_lang_js = ({
  props: {
    overlayActive: Boolean,
    padding: {
      type: Boolean,
      default: true,
    },
    theme: {
      type: String,
      default: null
    }
  },
  components: {
    MountingPortal: portal_vue_common["MountingPortal"],
  },
  data() {
    return {
      createdPortal: false,
    }
  },

  computed: {
    submitButtonColor() {
      switch (this.theme) {
        case 'bild':
          return 'bild-green'
        case '5vf':
          return '5vf'
        default:
          return 'teal'
      }
    },
  },

  mounted() {
    document.documentElement.style.setProperty(
      'overflow',
      'hidden',
      'important'
    )
    document.addEventListener('keyup', this.onKeyup)

    if (!document.getElementById('mobile-portal')) {
      const PortalTarget = document.createElement('div')
      PortalTarget.id = 'mobile-portal'
      document.body.appendChild(PortalTarget)
    }
    this.createdPortal = true
  },
  destroyed() {
    document.documentElement.style.setProperty('overflow', 'auto', 'important')
    document.removeEventListener('keyup', this.onKeyup)
  },
  methods: {
    onKeyup(e) {
      if (e.keyCode === 27) {
        this.close()
      }
    },
    close() {
      this.$emit('close')
    },
    reset() {
      this.$emit('reset')
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-portal/hg-portal-dropdown-mobile.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_portal_hg_portal_dropdown_mobilevue_type_script_lang_js = (hg_portal_dropdown_mobilevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-portal/hg-portal-dropdown-mobile.vue?vue&type=style&index=0&id=b62e6636&prod&lang=postcss
var hg_portal_dropdown_mobilevue_type_style_index_0_id_b62e6636_prod_lang_postcss = __webpack_require__("e8ab");

// CONCATENATED MODULE: ./src/components/partials/hg-portal/hg-portal-dropdown-mobile.vue






/* normalize component */

var hg_portal_dropdown_mobile_component = normalizeComponent(
  hg_portal_hg_portal_dropdown_mobilevue_type_script_lang_js,
  hg_portal_dropdown_mobilevue_type_template_id_b62e6636_render,
  hg_portal_dropdown_mobilevue_type_template_id_b62e6636_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_portal_dropdown_mobile = (hg_portal_dropdown_mobile_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-deal-search-wrapper.vue?vue&type=template&id=de763d8e&scoped=true
var hg_deal_search_wrappervue_type_template_id_de763d8e_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-deal-search-wrapper",class:_vm.isMobile && _vm.isOpen
      ? 'hg-deal-search-wrapper--mobile'
      : 'hg-deal-search-wrapper--desktop'},[(_vm.isMobile && _vm.isOpen)?[_c('header',{staticClass:"hg-deal-search-wrapper--header"},[_c('button',{staticClass:"hg-button hg-button--white",on:{"click":_vm.reset}},[_c('hg-icon',{attrs:{"name":"chevron-left","size":"small"}})],1),_c('label',{staticClass:"hg-deal-search-wrapper--title"},[_vm._v(_vm._s(_vm.$t('dealSearch.categoryLabel')))]),_c('button',{staticClass:"hg-button hg-button--white",on:{"click":_vm.close}},[_c('hg-icon',{attrs:{"name":"times","pack":"fal","size":"small"}})],1)])]:_vm._e(),_c('div',{class:_vm.isMobile && _vm.isOpen
        ? 'hg-deal-search-wrapper--content-mobile'
        : 'hg-deal-search-wrapper--content-desktop'},[_vm._t("default")],2)],2)
}
var hg_deal_search_wrappervue_type_template_id_de763d8e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-deal-search-wrapper.vue?vue&type=template&id=de763d8e&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-deal-search-wrapper.vue?vue&type=script&lang=js

/* harmony default export */ var hg_deal_search_wrappervue_type_script_lang_js = ({
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    document.documentElement.style.setProperty(
      'overflow',
      'hidden',
      'important'
    )
    document.addEventListener('keyup', this.onKeyup)
  },
  methods: {
    onKeyup(e) {
      if (e.keyCode === 'Escape') {
        this.close()
      }
    },
    close() {
      this.$emit('close')
    },
    reset() {
      this.$emit('close')
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-deal-search-wrapper.vue?vue&type=script&lang=js
 /* harmony default export */ var partials_hg_deal_search_wrappervue_type_script_lang_js = (hg_deal_search_wrappervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-deal-search-wrapper.vue?vue&type=style&index=0&id=de763d8e&prod&lang=postcss&scoped=true
var hg_deal_search_wrappervue_type_style_index_0_id_de763d8e_prod_lang_postcss_scoped_true = __webpack_require__("d03b");

// CONCATENATED MODULE: ./src/components/partials/hg-deal-search-wrapper.vue






/* normalize component */

var hg_deal_search_wrapper_component = normalizeComponent(
  partials_hg_deal_search_wrappervue_type_script_lang_js,
  hg_deal_search_wrappervue_type_template_id_de763d8e_scoped_true_render,
  hg_deal_search_wrappervue_type_template_id_de763d8e_scoped_true_staticRenderFns,
  false,
  null,
  "de763d8e",
  null
  
)

/* harmony default export */ var hg_deal_search_wrapper = (hg_deal_search_wrapper_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-travel-agent/email-register.vue?vue&type=template&id=dac8e610&scoped=true
var email_registervue_type_template_id_dac8e610_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('HgModal',{attrs:{"is-small-content":true},on:{"onClose":_vm.onClose}},[_c('div',{staticClass:"hg-modal-container"},[_c('PaperPlaneSvg',{staticClass:"hg-plane-svg"}),(_vm.step === '1')?[_c('ValidationObserver',{ref:"observer",staticClass:"form content",attrs:{"tag":"form","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},scopedSlots:_vm._u([{key:"default",fn:function({ invalid: invalidStep1 }){return [_c('h3',{staticClass:"hg-title",domProps:{"innerHTML":_vm._s(_vm.$t('travelAgent.emailRegister.title'))}}),_c('p',{staticClass:"tw-mb-1",domProps:{"innerHTML":_vm._s(_vm.$t('travelAgent.emailRegister.sub'))}}),_vm._t("errors"),_c('p',{staticClass:"hg-text tw-mb-3 tw-text-gray-600"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.mandatory'))+" ")]),_c('div',{staticClass:"md:tw-flex md:tw-justify-between"},[_c('HgTextInput',{staticClass:"tw-mb-5 md:tw-w-full md:tw-mr-3",attrs:{"label":_vm.$t('travelAgent.emailRegister.name'),"labelPosition":"inside","disableNumbers":"","required":"","name":"firstname","rules":"required","type":"text","teal":true,"transparent":true},on:{"blur":function($event){return _vm.pushGtmEvent('travelagent_name')}},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}}),_c('HgTextInput',{staticClass:"tw-mb-5 tw-w-full",attrs:{"label":_vm.$t('travelAgent.emailRegister.surname'),"labelPosition":"inside","disableNumbers":"","required":"","name":"lastname","rules":"required","type":"text","teal":true,"transparent":true},on:{"blur":function($event){return _vm.pushGtmEvent('travelagent_surname')}},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1),_c('HgTextInput',{staticClass:"tw-mb-5",attrs:{"label":_vm.$t('travelAgent.emailRegister.mail'),"labelPosition":"inside","required":"","name":"register-email","rules":"required","type":"email","teal":true,"transparent":true},on:{"blur":function($event){return _vm.pushGtmEvent('travelagent_email')}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c('HgButton',{staticClass:"tw-w-full",attrs:{"color":"teal","disabled":invalidStep1 === true},on:{"onClick":function($event){return _vm.nextStep('2')}}},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.emailRegister.namePasswort'))+" ")])]}}],null,true)})]:_vm._e(),(_vm.step === '2')?[_c('ValidationObserver',{ref:"observer",staticClass:"form content",attrs:{"tag":"form","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},scopedSlots:_vm._u([{key:"default",fn:function({ invalid: invalidStep2 }){return [_c('h3',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.emailRegister.secondScreen.title'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('travelAgent.emailRegister.secondScreen.sub'))+" ")]),_c('p',{staticClass:"hg-text tw-mb-3 tw-text-gray-600"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.mandatory'))+" ")]),_c('HgTextInput',{staticClass:"tw-mb-5",attrs:{"label":_vm.$t('travelAgent.emailRegister.passwort'),"labelPosition":"inside","required":"","name":"password","rules":"required|password","type":"password","teal":true,"transparent":true},on:{"blur":function($event){return _vm.pushGtmEvent('travelagent_password')}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_c('HgTextInput',{staticClass:"tw-mb-5",attrs:{"label":_vm.$t('travelAgent.emailRegister.repeatPasswort'),"labelPosition":"inside","required":"","name":"confirm","rules":"required|passwordConfirm:password","type":"password","teal":true,"transparent":true},on:{"blur":function($event){return _vm.pushGtmEvent('travelagent_password_confirm')}},model:{value:(_vm.passwordConfirm),callback:function ($$v) {_vm.passwordConfirm=$$v},expression:"passwordConfirm"}}),_c('hg-checkbox',{staticClass:"tw-mb-5",attrs:{"name":"privacy-consent","rules":"required","teal":true,"transparent":true},model:{value:(_vm.privacyConsent),callback:function ($$v) {_vm.privacyConsent=$$v},expression:"privacyConsent"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('travelAgent.checkBox.data'))}})]),_c('hg-checkbox',{staticClass:"tw-mb-5",attrs:{"name":"news-consent","teal":true,"transparent":true},model:{value:(_vm.newsletterConsent),callback:function ($$v) {_vm.newsletterConsent=$$v},expression:"newsletterConsent"}},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.checkBox.newsletter'))+" ")]),_c('HgButton',{staticClass:"tw-w-full",attrs:{"color":"teal","disabled":invalidStep2 === true || _vm.privacyConsent === false},on:{"onClick":function($event){return _vm.nextStep('success')}}},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.emailRegister.cta'))+" ")])]}}],null,false,1063578271)})]:_vm._e(),(_vm.step === 'success')?[_c('div',{staticClass:"hg-success-content"},[_c('h3',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.emailRegister.success.title'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('travelAgent.emailRegister.success.sub'))+" ")]),_c('SuccessSvg')],1)]:_vm._e()],2)])
}
var email_registervue_type_template_id_dac8e610_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-travel-agent/email-register.vue?vue&type=template&id=dac8e610&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/success-svg.vue?vue&type=template&id=62f53040
var success_svgvue_type_template_id_62f53040_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 304 247","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m231.13 187.17 2.85 7.21c4.31.29 9.16.44 13.96.73l-2.17-5.42 4.73 5.59c6.37.46 12.47 1.23 16.88 2.96-3.24-7.08-9.04-13.08-15.69-17.91l-11.82-.06 9.14-1.79c-6.28-4.14-13.09-7.28-19.13-9.35-13.5-4.63-30.33 5.83-30.33 5.83s13.8 15.64 25.17 18.28c2.01.47 4.48.77 7.24 1l-.83-7.07Z","fill":"#ABE532"}}),_c('path',{attrs:{"d":"M186.52 167.15c1.29-5.56 8.1-11.68 8.1-11.68s2.84 8.65.21 14.31c-.92 1.98-2.04 3.36-3.1 4.32 2.11-1.06 4.53-2.25 7.19-3.49-.44-.71-2.3-4.1-.86-8.93 1.62-5.46 8.81-11.21 8.81-11.21s2.34 8.74-.64 14.24c-1.01 1.86-2.17 3.16-3.25 4.06 2.32-1.03 4.78-2.09 7.35-3.14-.42-.75-1.86-3.82-.41-8.03 1.68-4.88 8.43-9.84 8.43-9.84s1.79 7.96-1.12 12.82c-.97 1.62-2.05 2.75-3.06 3.52 1.86-.72 3.76-1.43 5.7-2.13-.41-.8-1.63-3.72-.14-7.64 1.75-4.62 8.38-9.21 8.38-9.21s1.49 7.65-1.44 12.24c-1 1.56-2.09 2.62-3.1 3.34 1.82-.61 3.61-1.18 5.39-1.72-.33-.75-1.37-3.67.39-7.43 2.04-4.37 8.84-8.42 8.84-8.42s.92 7.48-2.28 11.74c-1.07 1.42-2.18 2.37-3.2 3.01 2.13-.6 4.23-1.14 6.3-1.62-.24-.74-.93-3.57 1.12-6.94 2.39-3.93 9.29-7.18 9.29-7.18s.12 7.11-3.36 10.85a12.05 12.05 0 0 1-3.01 2.38c1.95-.4 3.88-.76 5.76-1.06-.16-.87-.43-3.63 1.9-6.66 2.83-3.67 10.1-6.25 10.1-6.25s-.66 7.03-4.56 10.4c-.98.84-1.93 1.44-2.8 1.86 1.76-.21 3.48-.36 5.17-.47-.04-.73.03-3.59 3-6.36 3.43-3.2 11.14-4.73 11.14-4.73s-1.82 6.77-6.27 9.54c-1.03.64-2.01 1.08-2.9 1.37 1.97-.01 3.89.04 5.75.17.15-.87.79-3.17 3.66-5.1 3.62-2.43 10.89-2.86 10.89-2.86s-2.67 5.82-7.16 7.75c-.84.36-1.62.6-2.34.76 1.82.27 3.57.62 5.27 1.04.34-.9 1.26-2.57 3.68-3.84 3.48-1.82 10.01-1.58 10.01-1.58s-2.98 4.87-7.18 6.18c-.84.26-1.62.41-2.31.49 1.4.49 2.75 1.03 4.05 1.63.3-.66 1.13-1.98 3.2-2.87 2.87-1.24 8.03-.69 8.03-.69s-2.68 3.65-6.09 4.44c-1.16.27-2.14.3-2.93.23.37.2.74.4 1.11.61.53-.24 2.3-.88 4.97-.13 3.23.9 6.95 4.44 6.95 4.44s-4.87.88-8.19-.67c-1.95-.9-2.95-1.97-3.44-2.69-.69-.42-1.39-.81-2.11-1.19.65.57 1.36 1.4 1.91 2.59 1.3 2.83.59 7.39.59 7.39s-3.96-3.1-4.76-6.34c-.64-2.59.14-4.04.47-4.52-1.87-.86-3.85-1.6-5.92-2.22-.63-.07-1.13-.2-1.5-.32.99.48 2.79 1.62 4.13 4.03 1.93 3.48 1.52 9.35 1.52 9.35s-5.3-3.6-6.64-7.65c-1.33-3.99.23-5.97.27-6.03-2.83-.7-5.82-1.19-8.98-1.47 1.21.52 3.12 1.64 4.74 3.96 2.6 3.72 2.92 10.39 2.92 10.39s-6.35-3.49-8.37-7.91c-1.61-3.52-.96-5.77-.63-6.54-2.78-.19-5.68-.21-8.71-.07 1.39.46 3.39 1.44 5.33 3.51 3.45 3.7 4.97 10.96 4.97 10.96s-7.42-2.9-10.37-7.45c-2.22-3.41-2.08-5.89-1.88-6.91-2.56.17-5.19.45-7.91.85 1.43.26 3.6.95 5.89 2.81 3.98 3.24 6.66 10.3 6.66 10.3s-7.72-1.9-11.35-6.05c-2.85-3.26-3.02-5.83-2.97-6.79-2.49.4-5.05.9-7.66 1.48 1.44.18 3.49.72 5.75 2.25 4.28 2.89 7.7 9.74 7.7 9.74s-7.83-1.21-11.87-5.05c-3.07-2.92-3.59-5.42-3.66-6.45-2.53.6-5.12 1.29-7.76 2.05 1.51.07 3.66.47 6.12 1.84 4.76 2.66 9.07 9.56 9.07 9.56s-8.26-.56-12.87-4.24c-3.55-2.83-4.35-5.44-4.53-6.5a193.619 193.619 0 0 0-6.88 2.24c1.55-.03 3.8.24 6.45 1.52 5.05 2.44 9.96 9.29 9.96 9.29s-8.45-.07-13.44-3.58c-3.9-2.75-4.87-5.44-5.11-6.48-2.53.91-5 1.84-7.38 2.79 1.61-.08 3.98.14 6.81 1.42 5.33 2.43 10.65 9.45 10.65 9.45s-8.8.14-14.09-3.39c-4.11-2.75-5.22-5.51-5.51-6.62a247.93 247.93 0 0 0-9.17 3.97c1.76-.16 4.42-.03 7.65 1.31 5.97 2.48 11.22 10.08 11.22 10.08s-8.74.47-14.72-3.24c-4.65-2.89-6-5.91-6.37-7.12a248.58 248.58 0 0 0-8.75 4.29c1.75-.24 4.37-.22 7.61.95 6.09 2.2 12.68 9.49 12.68 9.49s-9.58.97-15.75-2.47c-4.79-2.67-6.31-5.63-6.76-6.82-3.39 1.79-5.35 2.93-5.4 2.96l-.44-.58c.06-.04 2.09-1.22 5.58-3.06-.52-.69-2.57-4-1.43-8.93Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"m233.99 129.09 1.73-15.31c7.62-2.56 16.27-5.12 24.79-7.92l-1.35 11.53 5.87-13.04c11.24-3.85 21.85-8.2 28.97-13.61-2.48 15.24-10.07 29.57-19.77 42.04l-21.24 5.62 17.29-.78c-9.34 10.95-20.12 20.22-30 27.05-22.1 15.27-57.34 2.81-57.34 2.81s17.43-36.77 36.64-47.17c3.39-1.84 7.7-3.58 12.57-5.31l1.84 14.09Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M21.75 65.52c1.31.27 2.39.66 3.29 1.08-1.45-1.41-2.8-2.84-4.05-4.28-.86.54-3.31 1.77-7.06 1.12-4.74-.82-10.42-5.76-10.42-5.76s6.96-2.37 11.89-.54c.92.34 1.7.72 2.37 1.12a49.2 49.2 0 0 1-2.95-4.58c-1.02.42-3.13.98-5.99.17C4.72 52.68.16 47.78.16 47.78s6.37-1.44 10.56.63c.84.42 1.53.86 2.11 1.31-.6-1.37-1.12-2.74-1.56-4.13-.79.27-2.53.65-4.81-.19C3.29 44.24 0 40.11 0 40.11s5.1-.75 8.28 1.13c1.08.64 1.82 1.32 2.33 1.95-.1-.42-.19-.83-.28-1.25-.59-.2-2.44-1.01-3.75-3.5-1.58-3-1.26-8.3-1.26-8.3s4.31 2.87 5.41 6.41c.65 2.07.46 3.58.2 4.48.15.8.32 1.6.52 2.4.02-.88.21-2.01.83-3.29 1.48-3.03 5.93-5.88 5.93-5.88s.22 5.15-1.98 8.11c-1.76 2.37-3.58 2.88-4.24 2.99a39.56 39.56 0 0 0 2.41 5.92c.4.51.65.96.82 1.32-.31-1.07-.64-3.21.46-5.96 1.58-3.97 6.93-8 6.93-8s.77 6.49-1.72 10.44c-2.46 3.9-5.31 4.24-5.39 4.25 1.46 2.56 3.23 5.09 5.3 7.57-.44-1.25-.87-3.46-.06-6.35 1.3-4.63 6.81-9.77 6.81-9.77s1.64 7.17-.69 11.89c-1.85 3.76-4.26 4.95-5.17 5.28 1.87 2.15 3.97 4.26 6.3 6.35-.62-1.34-1.24-3.51-.87-6.44.67-5.22 5.8-11.68 5.8-11.68s2.92 7.5 1.17 12.99c-1.32 4.12-3.54 5.85-4.57 6.45 2.02 1.72 4.19 3.42 6.51 5.09-.83-1.23-1.81-3.31-1.88-6.33-.12-5.26 4-12.41 4-12.41s4.01 6.98 3.09 12.67c-.72 4.46-2.81 6.49-3.68 7.15 2.17 1.5 4.46 2.99 6.87 4.45-.9-1.17-1.93-3.06-2.26-5.81-.64-5.22 2.75-12.74 2.75-12.74s4.68 6.55 4.32 12.3c-.27 4.37-2.04 6.6-2.88 7.41 2.37 1.39 4.85 2.75 7.44 4.09-1.04-1.14-2.27-2.99-2.89-5.78-1.19-5.4 1.59-13.61 1.59-13.61s5.55 6.38 5.76 12.43c.16 4.65-1.51 7.16-2.29 8.07 1.85.93 3.75 1.85 5.7 2.75.42.19.84.39 1.26.58-1.16-1.09-2.57-2.92-3.41-5.78-1.59-5.45.71-14.05.71-14.05s6.12 6.16 6.74 12.35c.49 4.84-1.12 7.54-1.84 8.48 2.63 1.16 5.24 2.25 7.8 3.28-1.24-1.1-2.79-2.97-3.75-5.97-1.81-5.64.35-14.67.35-14.67s6.55 6.25 7.38 12.68c.64 4.99-.93 7.84-1.66 8.86 3.53 1.37 6.93 2.61 10.11 3.7-1.43-1.16-3.26-3.17-4.46-6.49-2.23-6.15-.23-16.2-.23-16.2s7.49 6.62 8.67 13.69c.91 5.49-.7 8.7-1.47 9.85 3.8 1.27 7.22 2.32 10.09 3.16-1.48-1.09-3.38-3-4.74-6.2-2.56-6.02-1.1-16.16-1.1-16.16s7.84 6.21 9.39 13.2c1.21 5.43-.23 8.71-.93 9.91 4.01 1.13 6.43 1.7 6.5 1.72l-.18.75c-.07-.02-2.57-.61-6.71-1.78-.24.85-1.58 4.77-6.66 7.58-5.72 3.17-15.96 2.76-15.96 2.76s5.37-8.44 12.16-10.7c2.38-.8 4.38-1.01 5.98-.95-2.46-.74-5.24-1.62-8.26-2.63-.29.85-1.85 4.68-7.06 7.21-5.88 2.86-16.09 1.9-16.09 1.9s5.81-8.14 12.72-10.04c2.34-.65 4.3-.76 5.87-.64-2.58-.91-5.29-1.91-8.08-3-.34.86-1.92 4.16-6.61 6.22-5.42 2.38-14.63 1.17-14.63 1.17s5.54-7.16 11.85-8.65c2.11-.5 3.86-.54 5.26-.39-1.98-.81-3.98-1.66-6-2.55-.39.89-2.01 3.92-6.47 5.74-5.26 2.14-14.05.74-14.05.74s5.49-6.72 11.58-7.98c2.08-.43 3.79-.42 5.14-.22-1.85-.86-3.66-1.74-5.42-2.62-.4.79-2.16 3.7-6.67 5.2-5.25 1.75-13.7-.18-13.7-.18s5.77-6.18 11.77-7.02c2-.28 3.63-.17 4.92.09-2.07-1.1-4.07-2.22-6-3.35-.46.72-2.39 3.3-6.79 4.31-5.13 1.18-12.96-1.42-12.96-1.42s6.03-5.33 11.79-5.57c1.71-.07 3.12.12 4.25.42-1.78-1.11-3.49-2.24-5.12-3.38-.63.76-2.81 2.99-7.12 3.54-5.22.66-12.76-2.69-12.76-2.69s6.53-4.71 12.28-4.38c1.44.08 2.65.33 3.65.65a99.5 99.5 0 0 1-4.19-3.39c-.6.56-3.11 2.63-7.66 2.53-5.26-.12-12.21-4.56-12.21-4.56s7.17-3.67 12.81-2.49Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"m60.45 58.44-12.35.41c-3.16-6.12-6.47-13.11-9.94-19.96l9.31-.27-11.18-3.37c-4.72-9.02-9.73-17.45-15.07-22.8 12.41.24 24.87 4.9 36.16 11.57l7.6 17.25-3.19-14.5c10.05 6.55 18.98 14.51 25.84 22.03 15.35 16.8 10.75 48.06 10.75 48.06S66.73 86.62 55.65 71.67c-1.96-2.64-3.98-6.07-6.06-9.96l10.86-3.27Z","fill":"#ABE532"}}),_c('path',{attrs:{"d":"M16.53 118.51c-3.48 5.04-9.09 3.61-12.33 2.49 1.18-1.46 6.31-7.09 12.33-2.49Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M15.24 119.14a.63.63 0 0 1-.23-.34c-.08-.32.12-.65.44-.73 9.89-2.42 20.64-3.59 31.09-3.39 8.8.17 17.35 1.33 24.08 3.25.32.09.5.42.41.74-.09.32-.42.5-.74.41-12.03-3.44-32.68-5.2-54.55.15-.18.06-.36.01-.5-.09ZM62.81 113.99c-9.68-7.7-5.81-15.93-3.11-22.32 2.78 2.59 13.19 10.82 3.11 22.32ZM51.1 112.11c-9.07-4.06-7.7-11.22-6.88-16.73 2.69 1.45 12.42 5.77 6.88 16.73ZM38.2 112.63c-8.39-1.57-8.69-7.83-9.11-12.6 2.53.67 11.54 2.33 9.11 12.6ZM25.81 114.14c-5.28.52-6.54-3.17-7.62-5.94 1.63-.04 7.29-.61 7.62 5.94ZM60.72 120.1c-10.69 2.23-10.9 10.24-11.31 16.35 3.22-.92 14.69-3.28 11.31-16.35Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M47.95 118.29c-9.41.46-10.67 7.26-11.84 12.42 2.88-.36 12.97-.83 11.84-12.42ZM32.61 118.43c-6.09 2.08-5.63 6.79-5.42 10.39 1.81-.78 8.34-2.99 5.42-10.39ZM22.27 119.25c-3.71.54-3.95 3.29-4.22 5.37 1.13-.25 5.11-.82 4.22-5.37Z","fill":"#ABE57A"}}),_c('path',{attrs:{"opacity":".5","d":"M182.94 236.87s119.22-20.53 75.29-83.27c-5.47-7.82-28.89-18.03-42.63-5.11","stroke":"#2D2D2D","stroke-width":".372","stroke-miterlimit":"10","stroke-dasharray":"1.12 1.12"}}),_c('path',{attrs:{"d":"m166.49 244.4 16.74-9.12.87-5.42-17.61 14.54ZM166.49 244.4l16.89-7.39 1.56 9.78-18.45-2.39Z","fill":"#CEEDEB"}}),_c('path',{attrs:{"d":"m183.23 235.28 4.19 3.7-4.04-1.97-16.89 7.39 16.74-9.12Z","fill":"#81C1BC"}}),_c('path',{attrs:{"d":"m187.42 238.98-3.58.93-.46-2.9 4.04 1.97Z","fill":"#91D8D5"}}),_c('g',{attrs:{"opacity":".5","stroke":"#2D2D2D","stroke-width":".372","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M167.18 12.09s-.19-.02-.55-.05"}}),_c('path',{attrs:{"d":"M165.14 11.92c-.53-.04-1.15-.08-1.86-.13M162.54 11.74C141.27 10.4 54.56 8.01 66.32 59.03","stroke-dasharray":"1.12 1.12"}}),_c('path',{attrs:{"d":"M66.49 59.76c.04.18.09.36.14.54"}})]),_c('path',{attrs:{"d":"m198.32 10.82-30.83-3.23-4.7-7.59 35.53 10.82ZM198.32 10.82l-29.98-.53 3.79 15.65 26.19-15.12Z","fill":"#CEEDEB"}}),_c('path',{attrs:{"d":"m167.49 7.59-3.97 8.19 4.82-5.49 29.98.53-30.83-3.23Z","fill":"#81C1BC"}}),_c('path',{attrs:{"d":"m163.52 15.78 5.95-.85-1.13-4.64-4.82 5.49Z","fill":"#91D8D5"}}),_c('path',{attrs:{"d":"M197.67 40.33c2.84 0 5.86.14 9.09.44 19.67 1.79 42.41 18.54 45.18 50.63v10.68c-2.58 30.72-27.51 68.61-100.37 116.15C78.7 170.69 53.78 132.8 51.2 102.08V91.4c2.77-32.1 25.51-48.84 45.18-50.63 3.23-.29 6.26-.44 9.09-.44 22.72 0 33.62 9.14 46.1 22.97 12.48-13.84 23.37-22.97 46.1-22.97Z","fill":"#D4F9FA"}}),_c('path',{attrs:{"d":"M197.67 40.33c2.84 0 5.86.14 9.09.44 19.67 1.79 42.41 18.54 45.18 50.63v10.68c-2.58 30.72-27.51 68.61-100.37 116.15C78.7 170.69 53.78 132.8 51.2 102.08V91.4c2.77-32.1 25.51-48.84 45.18-50.63 3.23-.29 6.26-.44 9.09-.44 22.72 0 33.62 9.14 46.1 22.97 12.48-13.84 23.37-22.97 46.1-22.97Z","stroke":"#80E9F2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round","opacity":".6"}}),_c('path',{attrs:{"d":"M128.17 160.67s3.09 6.24 2.87 7.25c-.22 1.01-.71 5.06.19 4.86.9-.2.94-3.35 1.61-3.48.67-.13 4.89 7.34 5.62 6.86.74-.47-2.89-5.65-1.98-5.78.9-.12 3.97 5.01 4.82 4.28.85-.72-3.08-4.53-2.83-5.27.25-.74 3.62 4.09 4.48 3.22.85-.87-3.48-5.1-3.65-5.75-.17-.64 3.61 1.75 3.67 1.2.06-.55-1.49-1.9-3.14-3.35-1.65-1.45-3.16-2.51-4.14-3.41-.98-.89-4.3-4.12-4.3-4.12l-3.22 3.49ZM78.93 68.24l2.83 7.9-5.77 2.62-1.81-6.95.74-2.71 4.01-.86Z","fill":"#FCD0A3"}}),_c('path',{attrs:{"d":"m48.7 193.68-.82 4.1s-.87-.47-2.43-.03c-.27.07-.55.17-.86.3-1.06.46-2.12 3.08-3.21 5.73-.05.12-.1.25-.15.37-.07.17-.14.34-.21.5-.08.18-.15.36-.23.53-.89 2.08-1.8 3.93-2.77 4.45-.79.42-1.33.54-1.73.44a.978.978 0 0 1-.31-.14.864.864 0 0 1-.2-.17c-.1-.12-.2-.23-.27-.34-.49-.68-.49-1.19-.49-1.6-.05-2.75 2.18-7.84 2.82-9.48.64-1.64 3.01-8.29 5.19-8.84.18-.05.37-.05.57-.03.13.01.27.04.41.08.05.01.09.03.14.05.1.03.19.07.29.12.08.03.17.08.25.12.01.01.02.01.03.02 1.44.78 2.93 2.52 3.6 3.36.24.27.38.46.38.46Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M80.05 150.02s-11.76 7.02-15.31 10.3c-3.55 3.28-13.03 6.11-16.95 8.75-3.92 2.64-4.83 3.37-2.1 4.1 2.73.73 3.1-1 6.65 1.64 3.55 2.64 6.11 4.83 11.39 4.83 5.29 0 8.02.36 12.58 3.19 4.56 2.83 12.49 4.92 16.5 4.47 4.01-.46 4.19-3.28 9.66-4.01s9.66-13.21 8.48-16.68c-1.18-3.46-.36-2.19-2.19-5.47-1.82-3.28-4.42-5.65-8.77-6.47-4.35-.82-19.94-4.65-19.94-4.65Z","fill":"#FFD900"}}),_c('path',{attrs:{"d":"M101.87 168.24c4.08-1.7 7.28-4.86 10.36-7.93.26-.26-.14-.67-.41-.41-3.24 3.24-6.64 6.63-11.07 8.16-2.02.7-4.02.81-6 .59a43.95 43.95 0 0 0-.88-6.74c-.08-.36-.63-.21-.56.15.46 2.15.74 4.33.86 6.52-2.37-.32-4.72-1.06-7.05-1.76-2.47-.74-4.81-1.63-7.05-2.73.19-.55.36-1.11.53-1.67.11-.36-.45-.51-.56-.15-.16.53-.33 1.05-.5 1.57-.72-.36-1.42-.76-2.12-1.17 1.34-1.64 2.6-3.35 3.76-5.13.46.23.93.46 1.4.68 3.07 1.5 6.25 2.55 9.66 2.89 6.69.67 13.53-1.23 18.89-5.29.29-.22.01-.72-.29-.5-5.41 4.1-12.3 5.95-19.05 5.17-3.68-.43-7.01-1.78-10.29-3.45.25-.39.5-.78.75-1.18.19-.32-.31-.61-.5-.29-.25.41-.51.81-.77 1.21-1.23-.62-2.47-1.22-3.72-1.78 1.21-1.16 2.42-2.32 3.62-3.49.27-.26-.14-.67-.41-.41-1.25 1.2-2.49 2.43-3.73 3.67-1.9-.83-2.26-.33-.46.46-1.35 1.34-2.71 2.69-4.08 4.01-2.28-1.44-4.66-2.63-7.42-2.98-.37-.05-.36.53 0 .58 2.6.33 4.85 1.45 6.99 2.81-2.01 1.92-4.06 3.78-6.22 5.49-.52.42-1.06.8-1.6 1.17-1.9-1.31-3.55-3-4.8-4.96-.2-.31-.7-.02-.5.29 1.26 1.98 2.89 3.68 4.78 5.02-2.53 1.65-5.25 2.91-8.07 3.99-2-1.59-4-3.19-6-4.78-.29-.23-.7.18-.41.41 1.93 1.54 3.86 3.07 5.79 4.61-2.61.98-5.28 1.83-7.92 2.75-.35.12-.2.68.15.56 2.75-.96 5.56-1.84 8.31-2.87 1.74 1.39 3.45 2.92 5.4 4 .24.13.49.26.73.37a58.38 58.38 0 0 1-5.93 3.08c-.34.15-.05.65.29.5 2.17-.97 4.27-2.08 6.3-3.31 1.39.51 2.84.65 4.39.47 2.47-.28 4.89-1.03 7.38-.48a57.247 57.247 0 0 1-6.13 8.12c-.25.27.16.68.41.41 2.36-2.6 4.47-5.41 6.3-8.38 3.71 1.05 6.64 3.91 10.02 5.65 2.54 1.31 5.3 1.77 8.05 1.57-.78 2.67-1.8 5.27-3.09 7.76-.17.33.33.62.5.29 1.34-2.6 2.41-5.32 3.2-8.1 1.14-.12 2.28-.36 3.41-.69 5.05-1.52 9.28-4.84 13.37-8.05.29-.23-.12-.64-.41-.41-4.68 3.68-10.28 7.73-16.19 8.54.47-1.75.84-3.52 1.09-5.31 1.44-.04 2.87-.26 4.24-.62 4.66-1.22 8.72-3.98 12.66-6.64.31-.21.02-.71-.29-.5-4.32 2.92-8.84 6.02-14.08 6.93-.81.14-1.63.22-2.45.25.32-2.5.43-5.03.33-7.56 2.36.22 4.7.01 7.09-.98Zm-22.55-3.79c-.57 1.65-1.21 3.27-1.93 4.85-2.06-.13-4.13.15-6.19-.13 2.07-1.87 4.01-3.88 5.8-6.02.76.47 1.53.9 2.32 1.3Zm-6.54-5.16 4.01-3.86c1.3.58 2.58 1.2 3.87 1.83a60.362 60.362 0 0 1-3.74 5.08c-.61-.37-1.22-.76-1.82-1.18-.83-.57-1.66-1.15-2.5-1.7.05-.05.11-.11.18-.17Zm-7.47 6.75c2.44-1.87 4.64-4.02 6.85-6.15 1.47.95 2.9 2 4.36 2.95a59.047 59.047 0 0 1-6.04 6.21c-2.15-.41-4.18-1.23-6-2.4.27-.2.56-.4.83-.61Zm-3.32 9.27c-2.26-.95-4.16-2.7-6.05-4.21-.02-.01-.03-.03-.05-.04 2.82-1.09 5.55-2.37 8.06-4.06.84.55 1.73 1.04 2.66 1.44 1.06.46 2.17.82 3.31 1.07a57.16 57.16 0 0 1-7.93 5.8Zm12.16.13c-1.38-.32-2.78-.34-4.22-.14-2.41.32-4.86 1.06-7.25.27 2.82-1.75 5.48-3.73 7.96-5.91l.75.12c1.91.25 3.82.01 5.74.09-.9 1.91-1.88 3.77-2.98 5.57Zm18.51 7.29c-2.73.27-5.52-.17-8.31-1.68-3.11-1.68-5.8-4.15-9.17-5.32-.15-.05-.3-.1-.45-.14 1.11-1.84 2.11-3.74 3.01-5.69 4.37.4 6.44 4.52 10.2 6.23 1.83.84 3.84 1.2 5.85 1.22-.26 1.82-.64 3.61-1.13 5.38Zm1.21-5.96c-1.51 0-3.02-.21-4.45-.68-2.44-.8-4.13-2.42-6.01-4.08-1.54-1.37-3.13-2.38-5.21-2.64-.07-.01-.13-.01-.2-.02.68-1.52 1.29-3.07 1.84-4.65 3.08 1.48 6.38 2.46 9.68 3.4 1.58.45 3.14.83 4.68 1.03.11 2.56 0 5.12-.33 7.64Z","fill":"#FFEA00"}}),_c('path',{attrs:{"d":"M97.63 226.74c-.29 1.18-.18 3.01.15 5.56.01.06.02.11.02.17.02.13.03.25.05.39v.04c.01.05.01.1.02.15l.03.19c.03.24.07.48.1.72.33 2.29-.14 4.69-1.12 5.52-.15.13-.32.22-.5.27h-.01c-.12.03-.25.04-.38.02-.02 0-.03 0-.05-.01-.15-.03-.31-.08-.48-.17-.12-.07-.25-.15-.38-.26-2.11-1.75-6.4-16.4-4.82-17.99.14-.14.3-.28.47-.4.04-.03.08-.07.13-.1.12-.09.25-.17.38-.25.01 0 .01-.01.02-.01.04-.03.08-.05.12-.07.91-.53 2-.94 2.86-1.21.83-.26 1.43-.39 1.43-.39l4.31 4.39s-.67.68-1.3 1.52c-.46.61-.9 1.31-1.05 1.92Z","fill":"#FFD900"}}),_c('path',{attrs:{"d":"M97.63 226.74c-.29 1.18-.18 3.01.15 5.56.01.06.02.11.02.17.02.13.03.25.05.39v.04c.01.05.01.1.02.15l.03.19c.03.24.07.48.1.72.33 2.29-.14 4.69-1.12 5.52-.15.13-.32.22-.5.27h-.01c-.12.03-.25.04-.38.02-.02 0-.03 0-.05-.01-.15-.03-.31-.08-.48-.17-.12-.07-.25-.15-.38-.26-2.11-1.75-6.4-16.4-4.82-17.99.14-.14.3-.28.47-.4.04-.03.08-.07.13-.1.12-.09.25-.17.38-.25.01 0 .01-.01.02-.01.04-.03.08-.05.12-.07.91-.53 2-.94 2.86-1.21.83-.26 1.43-.39 1.43-.39l4.31 4.39s-.67.68-1.3 1.52c-.46.61-.9 1.31-1.05 1.92Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M78.89 70.43s.95-1.84 1.45-2.68c.46-.76 1.6-4.8.43-5.4-.75-.39-1.15-.19-1.62.02-.47.21-2.32-2.57-3.5-2.58-.84 0-.95.38-1.26.8-.31.42-1.05.21-1.52.79-.47.58-.37.89-.37.89s-.58-.31-1.01.22c-.27.33-.24.82-.24.82s-.89.47-.68 1.1c.21.63.52 1.1.58 1.26.05.16.63 3.56 1.73 4.76 1.1 1.2.68.48 1.31 1.37.63.89.68 1.14.84 1.19.15.06 3.86-2.56 3.86-2.56Z","fill":"#FCD0A3"}}),_c('path',{attrs:{"d":"M118.15 89.27s-.72-2.92-3.08-4.45c-2.36-1.53-3.46-1.37-5.96-2.16-2.5-.8-3.29-2.37-4.74-2.11-1.45.26-3.88 2.12-4.06 3.87-.18 1.75-.79 4.45-.16 6.32s-.47 1.97.34 4.7c.81 2.73.37 4.38 2 6.38s1.38 1.96 3.1.98c1.72-.97 4.93-5.2 5.02-5.39.08-.2 7.54-8.14 7.54-8.14Z","fill":"#24404F"}}),_c('path',{attrs:{"d":"M104.23 102.8s-1.38-.41-2.03.45c-.65.86-1.71 1.77-.53 2.2 1.18.42-1.01 1.43-.15 2.02.85.59 2.41 1.36 2.81.95.4-.42 1.63-2.28 1.94-3.16.31-.89-.22-3.18-.37-3.2-.16-.02-1.67.74-1.67.74Z","fill":"#876751"}}),_c('path',{attrs:{"d":"M119.43 96.04c-.01.56-.03 1.33-.1 2.24v.07l-.03.3c0 .05-.01.1-.01.16l-.01.14v.06c0 .03 0 .05-.01.08-.02.16-.03.32-.05.49-.29 2.59-.93 5.82-2.39 8.28-.78 1.32-1.37 2.6-3.09 2.05-.27-.09-1.52-.5-2.03-.18-.83.51-3.14 8.99.03 7.56.02.02.03.03.05.04.4.03.67.23.81.52.13.07.26.14.4.2 1.4.63.57 2.85-.82 2.29-.16.24-.4.44-.74.53-.93.27-1.8.29-2.64.12-2.49.59-7.02-.89-8.22-1.46-2.15-1.04-4.83-3.14-5.14-5.59-.25-.68-.39-1.4-.43-2.14-.01-.13.01-.26.03-.38-.22-.66.03-1.42.91-1.45 1.19-.05 2.39.47 3.51.13 1.03-.32 1.38-.47 2.22-1.11.31-.24.62-.54.94-.88 1.25-1.37 2.45-3.43 2.9-4.96.03-.12.07-.24.09-.34-.11-.16-.22-.32-.33-.49-1.52-2.31-2.88-5.08-.67-6.77.47-.35 1.16-.35 1.59.05.78-.72 1.64-1.38 2.07-2.37.39-.92 1.59-.93 2.11-.31 1.38-.15 2.73 0 4 .41 1.13.36 2.18.92 3.14 1.67.66-.49 1.73-.2 1.9.76v.01c0 .07.01.17.01.27Z","fill":"#FCD0A3"}}),_c('path',{attrs:{"d":"M122.29 93.77c-.56-1.17.41-1.73.31-3.1-.1-1.37-2.31-.37-2.58-1.18-.27-.81-1.26-1.48-3.61-1.08-2.36.41-2.84 1.75-4.09 1.62-1.25-.13-1.35.88-2.65 1.84-1.3.95-1.71.45-2.37.88-1.46.95-1.13 2.83-1.13 2.83s-.23 1.33.57 1.97c.8.64.99-.21.91-1.49-.01-.18 0-.36.03-.55.46-.03 1.18-.13 1.61-.51.35-.31.39-.87.35-1.34 1.06-.35 2.74-.58 4.33.61 1.82 1.37 3.27.94 4.85 1.31 1.57.36 2.66 1.17 3.5.69 1.23-.68.53-1.33-.03-2.5Z","fill":"#876751"}}),_c('path',{attrs:{"d":"M74.86 76.39c.75-.59 1.94-.61 3.65-1.22 1.7-.61 2.55-2.31 4.01-.97s2.49 6.26 3.34 8.57c.85 2.31 1.97 4.79 2.82 7.53.85 2.74 4.04 10.27 6.84 14.06 2.79 3.8 3.44 3.07 5.03 5.32 1.59 2.25 3.61 4.34 6.64 5.07 3.04.73 5.18 2.2 6.32 2.74 1.14.53 2.43.51 4 2.7 1.42 1.96 4.01 6.93 4.8 11.79.55 3.36 1.09 6.44 2.07 8.75.97 2.31.79 6.56 3.59 9.48 2.79 2.92 6.32 7.05 6.68 8.02.36.97-3.82 4.35-4.97 6.13-.93 1.44-2.2-.54-3.42-1.75-1.22-1.21-5.96-8.14-7.6-10.69-1.64-2.55-3.65-8.45-3.83-9.54-.18-1.09-1.98-4.96-2.59-3.39-.61 1.58-1.54 2.84-1.66 5.39-.12 2.55-1.6 5.47-2.32 8.63-.72 3.16-1.07 7.78-1.75 9.24-.67 1.46-9.91 3.4-13.92 2.55-4.01-.85-7.9-2.67-12.15-3.16-4.25-.49-4.86-5.71-2.92-9.11 1.94-3.4 4.13-12.27 4.86-15.8.73-3.52 1.7-8.38 2.43-11.06.73-2.67.46-5.16.33-7.72-.12-2.55-.91-7.84-2-11.85-1.09-4.01-4.77-13.37-5.74-16.53-.97-3.16-2.19-10.15-2.55-11.36-.36-1.21-.35-1.54.01-1.82Z","fill":"#00A8A8"}}),_c('path',{attrs:{"d":"M131.73 192.25c-.61-2.55-13.85-16.52-15.92-19.2-2.06-2.68-6.5-6.2-8.9-8.75-2.4-2.55-3.62-3.65-3.62-3.65l-25.15-3.04s-2.07 3.33-2.43 7.38c-.36 4.05-3.04 14.62-3.28 17.29-.24 2.67-3.04 13.24-3.89 15.07-.85 1.82-.49 3.4-2.68 3.28-2.19-.12-1.94-.97-6.56-2.43-4.62-1.46-7.29-5.23-9.11-5.35-.66-.04-1.3.09-1.86.34-1 .44-1.75 1.28-1.91 2.21-.03.2-.1.42-.19.64l-.08.19c-.2.47-.47.98-.7 1.51-.43.97-.71 1.99-.12 2.89 1.09 1.7 2.19 4.13 5.35 5.83 3.16 1.7 4.74 1.7 9.84 5.71s8.02 5.95 10.45 5.95c2.43 0 4.21-4.01 5.5-5.71 1.3-1.7 6.16-12.39 7.01-15.55.85-3.16 6.07-16.89 7.53-17.74 1.46-.85 14.84 7.29 17.15 8.75 2.31 1.46 8.5 3.16 8.75 5.35.24 2.19-4.43 6.2-7.08 8.63-2.64 2.43-7.63 11.06-10.3 12.88-2.67 1.82-7.17 2.19-5.35 4.49.01.02.03.04.05.06.9 1.16 1.98 2.83 3.12 4.18l.13.15c.39.45.79.86 1.2 1.2.74.61 1.5.97 2.24.86 2.38-.36 7-7.05 9.43-8.87 2.43-1.82 13.12-9.97 14.82-12.27 1.71-2.31 7.16-9.73 6.56-12.28Z","fill":"#CDCDCD"}}),_c('path',{attrs:{"d":"M93.07 160.88c-.19.07-.43.14-.74.19-.18.03-.39.06-.62.08-.04 0-.08.01-.12.01-.19.02-.4.03-.62.03-.16 0-.33.01-.51.01h-.1c-.35 0-.71 0-1.08-.01-.13 0-.26-.01-.4-.01-.4-.01-.81-.03-1.23-.05-.63-.03-1.27-.07-1.93-.11-.04 0-.08 0-.13-.01-.17-.01-.35-.03-.52-.04h-.03c-.42-.03-.84-.07-1.26-.1-.14-.01-.28-.03-.41-.04-.48-.04-.96-.09-1.43-.14-.14-.01-.27-.03-.41-.05-.83-.09-1.63-.2-2.35-.3-.05-.01-.1-.02-.16-.03-.12-.02-.24-.04-.35-.06-.09-.02-.18-.03-.27-.04-.35-.06-.68-.12-.98-.19-.13-.03-.27-.06-.39-.08-.62-.14-1.12-.29-1.44-.44-1.91-.91-1.91-4.55-1.91-4.55s.02-.25.1-.61c.03-.12.05-.26.09-.41.01-.05.03-.1.04-.16.05-.22.13-.45.22-.69.04-.1.08-.21.13-.31.05-.12.1-.24.17-.35.23-.44.52-.84.9-1.11.41-.3 1.77-.19 3.55.16l.3.06c.03 0 .06.01.09.02l.27.06c.08.02.16.03.24.05.2.04.4.08.6.13.84.2 1.73.42 2.63.67.14.04.27.07.41.12.56.16 1.12.32 1.67.49l.39.12a64.373 64.373 0 0 1 2.87.94c.32.12.63.22.91.33.1.03.2.08.3.11l.24.09c.14.06.27.11.39.16.41.17.74.32.99.45s.47.29.67.45c.17.14.32.3.45.45l.03.03c.03.03.05.07.08.1.01.01.02.02.02.03.18.23.32.48.44.73.04.08.07.17.11.25.06.14.11.29.15.42.04.13.07.27.1.4.07.31.1.59.12.82.02.23.02.42.02.54 0 .11-.01.17-.01.17s.85.77-.29 1.22ZM109.85 161.6c-.09 1.46-.85 3.4-.85 3.4s-.4 0-1.3-.09c-.15-.02-.31-.03-.49-.05l-.26-.03c-.02 0-.03-.01-.05-.01-.12-.02-.25-.03-.38-.05-.05 0-.09-.01-.14-.02-.59-.07-1.28-.17-2.1-.29-.1-.02-.21-.03-.32-.05-.08-.01-.15-.02-.22-.04-.12-.02-.24-.04-.36-.07h-.02c-.12-.02-.24-.05-.37-.08-.08-.02-.16-.03-.24-.06-.96-.22-1.93-.55-2.87-.95-.82-.34-1.6-.72-2.32-1.14-.13-.08-.27-.15-.39-.23-.07-.04-.13-.08-.2-.13-.08-.05-.15-.1-.23-.15-.13-.09-.26-.17-.39-.26-.02-.02-.04-.03-.06-.04-.01 0-.02-.01-.02-.01-.18-.13-.35-.25-.51-.38-.06-.05-.11-.09-.17-.13-.13-.1-.25-.21-.36-.32-.13-.12-.24-.23-.35-.34-.13-.14-.25-.28-.35-.41-.03-.04-.06-.08-.08-.12a.902.902 0 0 1-.17-.45c0-.05 0-.1.01-.15a.61.61 0 0 1 .15-.3c.07-.08.17-.16.28-.23.19-.12.44-.23.74-.32.03-.01.07-.02.11-.03.09-.03.19-.05.29-.08.02-.01.03-.01.05-.02.01 0 .02 0 .02-.01.13-.03.26-.06.4-.09h.03c.02 0 .03-.01.05-.01.13-.03.27-.05.42-.08.23-.04.47-.08.71-.12.64-.1 1.31-.18 1.96-.28.1-.02.21-.03.32-.04.15-.02.3-.05.45-.07.21-.03.41-.07.6-.11l.18-.03c.02 0 .05-.01.07-.01.11-.02.22-.05.34-.07 1.83-.38 3.47-.55 4.71-.56h.49c.14 0 .27.01.4.02.11.01.22.02.31.03l.23.03c.11.02.22.06.32.12.7.41 1.32 1.75 1.65 3.01.03.13.07.25.09.38v.01c.03.15.06.3.08.44 0 .02 0 .03.01.04.03.21.06.41.07.59.04.18.04.31.03.44Z","fill":"#FFD900"}}),_c('path',{attrs:{"d":"M97.57 162.09c0 .27-.13.49-.35.66-.06.05-.12.09-.2.13-.1.05-.2.1-.32.14-.01 0-.03.01-.04.02-.62.21-1.49.27-2.34.24-.51-.02-1.01-.07-1.45-.14-.29-.05-.56-.1-.79-.17-.69-.19-1.09-.53-1.38-.99-.14-.23-.25-.49-.35-.77-.12-.31-.23-.65-.35-1.03-.08-.24-.17-.5-.28-.76 0-.02-.01-.03-.02-.04-.28-.74-.11-1.26.32-1.7.13-.14.29-.27.47-.4.22-.17.48-.32.75-.48.13-.08.27-.16.42-.24.21-.12.43-.24.64-.37.01-.01.03-.02.04-.02.01-.01.03-.02.04-.02.01 0 .01-.01.02-.01.11-.07.22-.13.33-.2.03-.02.05-.03.08-.05.86-.56 1.55-.68 2.17-.53.15.03.29.08.43.14a4.638 4.638 0 0 1 1 .62c.09.07.19.15.28.23.1.08.2.17.3.25 0 0 .01 0 .02.01.11.1.2.19.28.3.19.26.27.54.29.81.04.66-.29 1.29-.46 1.57-.06.1-.1.16-.1.16s.13.27.26.73c.11.36.22.84.27 1.38.01.14.02.33.02.53Z","fill":"#FFD900"}}),_c('path',{attrs:{"d":"M93.57 161.2s-.29.78-.69 1.93c-.36 1.03-.82 2.35-1.26 3.68l-.15.45c-.12.36-.23.72-.34 1.06l-.06.18-.06.18c-.03.12-.07.24-.11.35-.1.34-.19.66-.27.96-.16.59-.39 1.26-.67 1.97-.05.12-.09.24-.14.36-.27.68-.58 1.39-.91 2.1-.05.12-.11.24-.17.36-.2.43-.4.85-.61 1.26-.07.15-.15.3-.22.45-.01.02-.02.03-.03.05-.04.08-.08.16-.13.24-.85 1.65-1.65 2.96-2.05 3.31-.46.42-2.12-.22-3.8-1.13-.06-.03-.13-.07-.19-.1-.08-.05-.17-.09-.25-.14-.03-.02-.06-.03-.09-.05l-.15-.09c-.04-.02-.08-.05-.12-.07-1.34-.79-2.57-1.67-3.06-2.23-.97-1.12.73-1.56 2.03-2.78.08-.07.16-.15.24-.24.21-.21.39-.45.55-.72.02-.03.04-.07.05-.1.1-.18.19-.35.26-.52 0-.01.01-.03.02-.04.05-.11.08-.22.12-.32.12-.36.2-.73.28-1.11.03-.17.06-.34.09-.52.17-1.01.32-2.16.91-3.66 0-.01.01-.02.01-.03.04-.12.09-.24.15-.37.03-.07.06-.15.09-.22.01-.02.02-.05.03-.08.05-.13.12-.26.18-.39.03-.06.06-.12.08-.18.86-1.75 2.75-3.02 4.49-3.86.48-.24.96-.44 1.39-.6a12.953 12.953 0 0 1 .97-.35c.29-.1.55-.17.76-.24.38-.11.6-.17.6-.17l.04.03.9.58.35.22.43.28.51.31ZM109.98 176.94c-.11.14-.24.27-.37.4-.19.19-.39.37-.61.53-.16.12-.33.24-.5.34l-.1.07c-.1.07-.22.13-.32.18-.74.39-1.56.63-2.32.63-1.55 0-2.85-.72-3.95-1.79-.09-.08-.18-.18-.27-.27-.35-.37-.68-.77-.99-1.19l-.24-.33c-.03-.04-.06-.09-.09-.13-.11-.16-.21-.32-.32-.48-.25-.39-.48-.79-.7-1.18l-.24-.42c-.08-.13-.15-.26-.23-.39-.84-1.4-1.76-2.67-2.53-3.92-.11-.17-.21-.35-.31-.52-.05-.08-.09-.15-.13-.23-.06-.1-.12-.2-.17-.31-.02-.04-.05-.09-.07-.13-.07-.13-.14-.27-.2-.4-.13-.27-.25-.53-.35-.8-.39-1-.55-2.25-.63-3.34-.1-1.39-.03-2.52-.03-2.52h1.89s.01 0 .02.01c.05.03.2.1.41.21.07.04.15.08.23.13a19.967 19.967 0 0 1 3.04 2.12c.52.45 1.03.94 1.49 1.49.08.1.17.2.25.3.37.47.69.97.94 1.5.03.07.06.13.1.2.08.16.16.31.24.46.01.02.02.03.02.04.09.17.19.33.29.49.46.73.98 1.38 1.55 1.98.09.1.18.19.27.28.15.15.3.3.46.44.1.1.2.19.31.28.05.05.11.1.17.14.16.14.32.28.49.41 1.11.9 2.29 1.67 3.4 2.39.18.12.34.25.46.39.12.13.21.27.29.42.33.78.03 1.7-.65 2.52Z","fill":"#FFD900"}}),_c('path',{attrs:{"d":"M78.83 65.63c-.03-.12-.2-.21-.33-.1-.29.25-.62.55-1.01.62h-.44c-.34-.09-.45-.28-.34-.57.03-.34.13-.46.34-.71.49-.58 1.06-1.08 1.68-1.53.2-.14.01-.48-.19-.33-.47.34-.92.72-1.33 1.13-.93-.46-1.58-1.33-1.7-2.37-.03-.24-.41-.25-.39 0 .13 1.14.8 2.13 1.81 2.66-.03.03-.05.06-.08.09-.24.28-.54.61-.61.98a.218.218 0 0 0-.08-.05c-1-.29-1.77-1.06-2.08-2.05-.07-.24-.44-.14-.37.1.28.9.9 1.63 1.72 2.06-.02.04-.04.08-.03.13.1.75-.7.96-1.23.81-.31-.09-.59-.27-.83-.49-.43-.39-.68-.89-.8-1.44-.05-.24-.43-.14-.37.1.21.94.86 1.84 1.8 2.16-.72.33-1.52.11-1.95-.61-.13-.21-.46-.02-.33.19.57.96 1.75 1.24 2.7.63.05-.03.07-.07.08-.11.72.03 1.35-.46 1.32-1.21.09.04.18.07.28.1.08.02.15-.01.19-.06.01.04.01.08.02.12.19.62.66.74 1.15.63-.7.83-.98 1.94-.75 3.09.05.24.42.14.37-.1-.3-1.5.39-2.89 1.75-3.57.12-.07.11-.21.03-.3Z","fill":"#F9BE8A"}}),_c('path',{attrs:{"d":"M99.86 109.95c-2.7 4.16-6.92 7.03-11.78 8.03-.36.07-.21.63.15.56 5-1.03 9.35-4.01 12.12-8.29.21-.32-.29-.62-.49-.3Z","fill":"#008E8A"}}),_c('path',{attrs:{"d":"M100.13 113.13c-3.58 3.58-8.35 5.6-13.4 5.69-.37.01-.37.58 0 .58 5.2-.09 10.13-2.18 13.81-5.86.26-.26-.15-.67-.41-.41ZM116.61 123.52c-.19 1.72-.61 3.36-1.26 4.93.52-2.75.69-5.56.48-8.39-.03-.37-.61-.37-.58 0 .44 5.97-.78 11.88-3.57 17.17-.17.33.33.62.5.29 1.16-2.2 2.06-4.51 2.68-6.89.06-.02.12-.06.16-.13 1.18-2.19 1.9-4.52 2.17-6.99.03-.36-.54-.35-.58.01ZM109.97 141.45a38.83 38.83 0 0 1-20.64 11.51c-.36.07-.21.63.15.56 8-1.62 15.31-5.71 20.89-11.66.27-.27-.14-.68-.4-.41Z","fill":"#008E8A"}}),_c('path',{attrs:{"d":"M111.64 108.99a6.57 6.57 0 0 1-3.12-2.53c-.2-.31-.7-.02-.5.29a7.258 7.258 0 0 0 3.46 2.8c.35.13.5-.43.16-.56Z","fill":"#F9BE8A"}}),_c('path',{attrs:{"d":"M38.07 203.1c.95.61 1.93 1.13 2.96 1.55-.08.18-.15.36-.23.53-1.03-.42-2.01-.93-2.95-1.53-.76 2.04-1.4 4.13-1.86 6.27a.21.21 0 0 1-.06-.04c-.05-.04-.1-.08-.14-.13-.1-.12-.2-.23-.27-.34 1.59-7.06 5.06-13.53 8.64-19.82.1.03.19.07.29.12.08.03.17.08.25.12-2.45 4.28-4.85 8.67-6.63 13.27Z","fill":"#00A8A8"}}),_c('path',{attrs:{"d":"M42.21 199.14c-.01-.03-.02-.05-.03-.07a.572.572 0 0 0-.07-.08.31.31 0 0 0-.27-.18c-.11 0-.19.06-.24.14-.22.15-.3.5-.05.7 0 0 .01 0 .01.01.09.1.26.13.38.07.01 0 .01-.01.02-.01a.46.46 0 0 0 .25-.58ZM43.89 197.19c-.01 0-.01 0-.02-.01-.11-.14-.35-.13-.46.01-.05.03-.1.08-.13.14-.13.22 0 .51.24.59.28.09.45-.11.47-.33l.01-.01c.08-.11.02-.32-.11-.39ZM94.32 233.3c.74 2.1 1.6 4.16 2.57 6.18-.15.13-.32.22-.5.27h-.01a62.953 62.953 0 0 1-5.64-18.82c.04-.03.08-.07.13-.1.12-.09.25-.17.38-.25.01 0 .01-.01.02-.01.54 4.15 1.5 8.22 2.85 12.15 1.25.04 2.47-.05 3.69-.25.02.13.03.25.05.39v.04c.01.05.01.1.02.15-1.17.19-2.36.28-3.56.25ZM97.02 225.51c-.15-.54-.88-.45-1.01.05-.03.13.02.23.1.29.02.05.06.1.1.14.36.36.94 0 .81-.48Z","fill":"#00A8A8"}}),_c('path',{attrs:{"d":"M96.52 228.71c0-.05-.01-.1-.02-.14 0-.04 0-.07-.01-.11a.286.286 0 0 0-.36-.2c-.04.01-.09.03-.13.04l-.06.03c-.02.01-.04.01-.05.02-.29.16-.28.56-.06.77.1.09.21.1.33.05.08-.01.16-.05.22-.14.01-.01.01-.03.02-.04a.45.45 0 0 0 .12-.28Z","fill":"#00A8A8"}}),_c('path',{attrs:{"d":"M76.4 158.96c-1.81-.51-2.89-2.18-2.57-4.05.06-.36-.49-.52-.56-.15-.37 2.17.84 4.16 2.98 4.76.36.1.51-.46.15-.56ZM109.31 163.04c-.15.65-.62 1.16-1.27 1.34-.36.1-.21.66.15.56.83-.23 1.48-.9 1.67-1.74.09-.36-.47-.52-.55-.16Z","fill":"#FFEA00"}}),_c('path',{attrs:{"d":"M106.45 171.24c-.17-.13-.33-.27-.49-.41-1.13.49-2.26 1.01-3.3 1.63-1.23-1.32-2.34-2.76-3.25-4.37.04-.01.08-.02.12-.02 1.17-.19 2.4-.31 3.39-.84-.01-.02-.02-.03-.02-.04-.08-.15-.17-.3-.24-.46-.98.58-2.29.72-3.51.89-.82-1.55-1.47-3.18-1.93-4.85-.09-.34-.17-.68-.25-1.02-.05-.21-.09-.42-.13-.62-.1-.48-.17-.96-.24-1.45.22.16.44.32.66.49.09.07.19.14.29.22 1.3.97 2.72 1.34 4.33 1.43.12.01.24 0 .35.01.2.79.33 1.6.52 2.38l.24.06c.12.03.24.06.37.08-.23-.82-.37-1.67-.55-2.5 1.27.03 2.54-.03 3.81-.16a36.16 36.16 0 0 0-.24 3.11c.05 0 .1.01.14.02.13.02.26.03.38.05.02 0 .03 0 .05.01.03-1.08.12-2.16.25-3.24.89-.1 1.77-.24 2.64-.4-.01-.18-.03-.38-.07-.59-.83.16-1.66.28-2.5.38.18-1.43.43-2.85.66-4.27a.746.746 0 0 0-.32-.12l-.23-.03c-.25 1.49-.5 2.99-.7 4.49-1.34.13-2.68.2-4.02.18-.07-.25-.14-.49-.23-.73-.4-1.15-.95-2.25-1.54-3.31-.19.04-.39.08-.6.11.7 1.25 1.34 2.54 1.77 3.92-2.02-.11-3.38-.76-4.96-1.95-.1-.08-.21-.16-.32-.25-.09-.07-.19-.14-.28-.21-.03-.3-.05-.61-.07-.92-.03-.6-.05-1.2-.03-1.8a7.02 7.02 0 0 0-.56-.39c-.02.77-.02 1.54.03 2.31 0 .12.02.25.02.37a10.393 10.393 0 0 0-2.84-1.26c-.07-.02-.13-.03-.2-.05-.23-.06-.47-.11-.71-.15.05-.24.11-.47.17-.71 0-.02.01-.04.01-.06-.02.01-.03.02-.04.02-.13-.16-.29-.31-.45-.45-.06.28-.12.55-.19.82-.02.09-.04.19-.07.28-.12-.02-.23-.03-.35-.04-1.13-.13-2.34-.16-3.58-.15.26-.82.49-1.66.68-2.52-.18-.06-.36-.12-.55-.19-.22.92-.46 1.83-.75 2.71-2.86.05-5.83.21-8.37-.47.17-1.7.84-3.04 1.69-4.39-.2-.05-.41-.09-.6-.13-.82 1.33-1.47 2.66-1.65 4.35-1.58-.52-2.96-1.41-3.99-2.93-.09.24-.16.47-.22.69 1.11 1.46 2.54 2.31 4.16 2.8-.06 1.23.08 2.45.33 3.65.08.01.18.03.27.04l.35.06c-.26-1.16-.41-2.35-.38-3.55v-.04c2.52.62 5.43.49 8.22.45-.47 1.31-1.05 2.58-1.8 3.8.18.01.35.03.52.04.04 0 .08 0 .13.01.74-1.24 1.31-2.52 1.77-3.86 1.03 0 2.04.01 3 .1.33.03.66.07.97.11-.22.86-.45 1.71-.71 2.56a53.284 53.284 0 0 1-2.81 7.31c-.09-.02-.18-.04-.28-.07-1.75-.38-3.35-.82-4.81-1.55-.03.07-.07.15-.09.22-.05.12-.1.25-.15.37 0 .01-.01.02-.01.03.6.32 1.24.59 1.9.79.97.31 2.1.5 3.19.75-.35.72-.71 1.43-1.09 2.14-.62 1.15-1.37 2.3-2.13 3.46-1.01-.69-2.1-1.2-3.26-1.53 0 .01-.01.03-.02.04-.07.17-.15.35-.26.52 1.14.36 2.15.9 3.16 1.55-.99 1.52-1.97 3.07-2.71 4.69.03.02.06.04.09.05.08.05.17.1.25.14.06.03.13.07.19.1.42-.94.94-1.85 1.49-2.73.4-.64.8-1.27 1.2-1.91.59.41 1.19.85 1.8 1.31.47.35.96.66 1.48.91.01-.02.02-.03.03-.05.07-.15.15-.3.22-.45-1.13-.58-2.17-1.53-3.17-2.29 1-1.6 1.98-3.19 2.84-4.89.16-.31.3-.63.45-.94.96.25 1.88.57 2.64 1.11.04-.12.07-.24.11-.35l.06-.18c-.76-.5-1.64-.85-2.56-1.1a53.09 53.09 0 0 0 2.19-5.43c.09-.26.18-.52.26-.77.15-.46.29-.93.43-1.39.23-.77.44-1.55.64-2.32.14.03.28.05.42.08.24.05.46.12.68.19.58.18 1.11.42 1.61.69.43.23.84.49 1.24.77.06.52.13 1.04.22 1.55.03.17.06.35.1.52a23.955 23.955 0 0 0 2.24 6.41c-.37.06-.73.13-1.06.22-.55.16-1.08.34-1.6.56.1.17.2.34.31.52.85-.34 1.72-.61 2.63-.8.94 1.69 2.08 3.19 3.36 4.56-.21.13-.41.27-.61.41-.66.48-1.18 1.09-1.67 1.73.1.16.21.32.32.48.48-.63 1-1.23 1.65-1.71.23-.17.47-.34.72-.49 1.8 1.85 3.83 3.48 5.93 5.03.17-.11.34-.22.5-.34-2.1-1.54-4.14-3.15-5.93-4.99 1.1-.65 2.26-1.17 3.41-1.66Z","fill":"#FFEA00"}}),_c('path',{attrs:{"d":"M192.98 126.55s4.96-.76 7.65-.65c2.7.11 5.71-.05 7.99 3.81 2.28 3.86 2.32 7.79 1.8 11.61-.52 3.83-.35 6.63-3.37 7.24-3.01.61-6.01 1.55-8.86 1.11-2.85-.44-6.61-1.93-6.75-3.23-.14-1.3.62-12.38.76-12.77.14-.37.78-7.12.78-7.12Z","fill":"#39565B"}}),_c('path',{attrs:{"d":"M204 129.97c-.31-4.36-1.01-9.19-2.7-12.8-.25-.54-.82.05-.69.61.94 4.17 1.98 8.02 2.29 12.48.07.99 1.17.7 1.1-.29Z","fill":"#39565B"}}),_c('path',{attrs:{"d":"M224.69 177.67s5.11-1.8 6-1.53c1.38.42 5.3 11.69 3.7 12.47-1.61.78-3.43-2.61-4.86-4.24-1.43-1.63-4.4-1.92-4.4-1.92l-.44-4.78ZM206.97 168.08s4.2-3.42 5.13-3.47c1.44-.07 8.26 8.39 7.01 9.67-1.25 1.28-3.43-.48-5.33-1.53s-4.79-.32-4.79-.32l-2.02-4.35Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M161.03 80.96s.96-6.02 1.63-6.63c.67-.61 3.07-3.25 2.33-3.56-.75-.31-2.36 1.91-2.91 1.67-.55-.25.23-7.71-.53-7.75-.76-.04-.81 5.5-1.51 5.13-.71-.37-.29-5.59-1.27-5.5-.97.09-.1 4.79-.65 5.2-.55.4-.51-4.76-1.56-4.57-1.05.19-.11 5.41-.31 5.95-.21.54-1.69-3.08-2.01-2.71-.33.36.1 2.11.54 3.98.44 1.87.98 3.39 1.23 4.53.25 1.14.98 5.12.98 5.12l4.04-.86ZM222.08 93.02s1.77-5.84 1.43-6.67c-.34-.84-1.34-4.27-.54-4.22.81.05 1.29 2.75 1.89 2.77.6.02 3.16-7.04 3.86-6.74.7.3-1.68 5.3-.88 5.27.8-.03 2.7-4.9 3.54-4.39.84.5-2.01 4.36-1.69 4.96.32.61 2.54-4.06 3.4-3.43.86.63-2.27 4.91-2.32 5.49-.05.58 2.86-2.03 2.99-1.56.13.47-1.01 1.86-2.23 3.35s-2.36 2.62-3.08 3.54c-.72.91-3.12 4.18-3.12 4.18l-3.25-2.55Z","fill":"#C1946C"}}),_c('path',{attrs:{"d":"M171.92 152.35s-.25 11.34.82 21.4c.53 5 1.86 9.55 4.13 15.97 1.29 3.65 2.55 5.99 6.04 6 3.49.01 5.44-3.3 7.42-2.58 1.98.72 2.98 3.11 6.54 2.36 4.55-.96 14.98-5.09 18.59-6.47 3.61-1.38 10.88-4.59 11.3-5.86.42-1.26.11-6.06-1.46-6.24-1.57-.17-10.98 2.06-13.46 2.53-2.48.47-10.63 3.13-13.15 2.29-2.52-.84-.91-12.9-1-17.21-.09-4.31-1.35-13.98-1.35-13.98l-24.42 1.79Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M176.69 98.16s-2.69-7.25.29-10.64c1.73-1.97 3.18-2.37 4.55-3.13 2.48-1.37 3.84-3.5 6.43-3.22 2.59.29 3.07 1.83 5.79 1.71 2.72-.12 3.74-2.03 7.61-2.4 3.87-.37 6.85-.43 8.72 1.09.79.65 1.04 1.4 1.66 2.97.62 1.56 1.79 1.97.97 3.89-.82 1.92-1.93 3.06-1.43 5.78.49 2.72 2.42 4.8.26 6.29-2.15 1.49-3.76.01-5.66 2.41-1.9 2.41-.72 5.29-4.04 5.68-3.31.38-4.75.69-6.7.15-1.95-.54-1.02-1.05-3.16-2.12-2.14-1.08-2.08.1-4.11-1.48-2.02-1.58-3.54-4.74-4.49-5.45-.94-.71-6.69-1.53-6.69-1.53Z","fill":"#5C3C30"}}),_c('path',{attrs:{"d":"M182.16 89.52s-3.38 2.37-5.21 6.87c-1.78 4.36-.72 7.39.19 7.93.85.51 2.34 1.11 2.11 2.77-.2 1.46-1.59 4.47-1.59 4.47s4.29 2.48 5.08 2.7c.79.21 3.3-1.64 3.3-1.64s-.62-5.16-.01-6.66 2.82-2.99 4.01-3.61c1.19-.62 2.7-1.88 2.81-3.43.11-1.55.83-4.72-1.26-6.63-2.09-1.91-5.38-3.76-6.67-3.91-1.31-.13-2.76 1.14-2.76 1.14Z","fill":"#C1946C"}}),_c('path',{attrs:{"d":"M179.86 88.93s-4.03 2.08 1.35 2.49c2.59.2 2.11-.16 3.56.74.8.5.02 1.8 2.17 3.19s.56 4.38 1.88 3.88c1.4-.53 1.54.73.7 2.1-.84 1.37-2.4 3.11-2.4 3.11l6.37-3.21.75-4.84s-1.69-6.17-1.85-6.4c-.16-.24-4.79-2.59-5.03-2.67-.24-.09-3.17-.6-3.91-.43-.74.17-3.59 2.04-3.59 2.04Z","fill":"#5C3C30"}}),_c('path',{attrs:{"d":"M186.15 178.03s13.85-8.04 17.72-9.77c4.18-1.88 4.7-.28 5.22 1 .51 1.27 1.57 1.9 1.42 3.19-.14 1.29-7.1 6.74-10.96 10.43-3.87 3.69-8.35 6.18-8.35 6.18l-5.05-11.03Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M178.1 108.89s.08 1.16 3.04 1.49c2.95.33 4.87-.62 4.87-.62s.81-.81 4.3-.33c3.5.48 3.88 1.27 6.22 1.25 2.34-.02 14.11-3.4 16.28-4.37 2.16-.98 7.29-16.11 9.23-15.9 1.94.21 6.17 3.37 6.1 4.82-.07 1.45-7.31 16.26-9.74 18.8-2.43 2.54-18.6 5.89-20.3 6.92-1.7 1.03-3.76 12.01-3.32 15.66.44 3.65 2.62 12.42 2.96 14.17.33 1.75-7.43 1.82-9.01 2.54-1.57.72-7.16.2-10.37.22-3.21.02-6.42 1.16-7.73.36-1.31-.8 1.76-15.14 1.11-16.85-.65-1.7-2.08-13.24-1.73-15.65.36-2.4-1.51-4.94-1.87-5.92-.36-.97-11.62-14.08-11.66-17.17-.03-3.09-2.09-16.59.15-18.3 2.25-1.71 3.64-1.65 5.25-1.01 1.61.65 1.54 14 2.21 16.41.67 2.41 10.81 12.13 11.96 12.72 1.15.6 2.05.76 2.05.76Z","fill":"#D28508"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"155","y":"78","width":"74","height":"77"}},[_c('path',{attrs:{"d":"M178.1 108.89s.08 1.16 3.04 1.49c2.95.33 4.87-.62 4.87-.62s.81-.81 4.3-.33c3.5.48 3.88 1.27 6.22 1.25 2.34-.02 14.11-3.4 16.28-4.37 2.16-.98 7.29-16.11 9.23-15.9 1.94.21 6.17 3.37 6.1 4.82-.07 1.45-7.31 16.26-9.74 18.8-2.43 2.54-18.6 5.89-20.3 6.92-1.7 1.03-3.76 12.01-3.32 15.66.44 3.65 2.62 12.42 2.96 14.17.33 1.75-7.43 1.82-9.01 2.54-1.57.72-7.16.2-10.37.22-3.21.02-6.42 1.16-7.73.36-1.31-.8 1.76-15.14 1.11-16.85-.65-1.7-2.08-13.24-1.73-15.65.36-2.4-1.51-4.94-1.87-5.92-.36-.97-11.62-14.08-11.66-17.17-.03-3.09-2.09-16.59.15-18.3 2.25-1.71 3.64-1.65 5.25-1.01 1.61.65 1.54 14 2.21 16.41.67 2.41 10.81 12.13 11.96 12.72 1.15.6 2.05.76 2.05.76Z","fill":"#D28508"}})]),_c('g',{attrs:{"mask":"url(#a)","fill":"#942437"}},[_c('path',{attrs:{"d":"M202.241 146.039c-5.98-1.16-12.37 1.47-18.25 2.3-5.59.79-12.04-.9-17.24 1.77-.52.27-.18 1.02.37.82 5.49-2.04 11.38-.6 17.07-1.4 2.83-.4 5.6-1.07 8.4-1.62 3.21-.63 6.29-.8 9.55-.87.63 0 .76-.87.1-1ZM202.92 140.41c-5.27-1.83-10.94-.45-16.05 1.21-2.83.92-5.66 1.9-8.64 2.21-3.18.33-5.89-.29-8.73-1.68-.41-.2-.69.4-.37.67 3.95 3.35 10.1 2.3 14.61.96 2.97-.88 5.88-2.03 8.93-2.64 3.44-.69 6.61-.31 10.03.2.52.08.74-.75.22-.93ZM199.461 135.529c-4.73-1.43-10.11-1.28-14.89-.13-5.19 1.25-10.49 3.95-15.54.78-.41-.26-.82.29-.45.6 3.58 3.05 8.66 1.82 12.7.6 2.81-.84 5.59-1.55 8.54-1.73 3.21-.2 6.25.27 9.39.84.56.11.8-.8.25-.96ZM198.73 122.53c-2.37-1.44-5.25-2.19-7.93-2.84-2.88-.7-5.81-1.17-8.77-1.37-2.78-.19-5.57-.14-8.34.12-3.75.35-7.21.87-10.62-1.13-.5-.29-1 .35-.55.73 1.97 1.67 4.6 1.98 7.1 1.88 3.32-.14 6.56-.67 9.9-.61 3.07.06 6.14.4 9.16 1.01 3.33.68 6.42 2.01 9.69 2.85.37.11.76-.39.36-.64ZM222.09 113.85c-5.35-2.4-11.23-3.84-17-4.84-6.08-1.05-12.231-1.13-18.341-1.86-6.12-.74-11.899-2.88-17.939-4.01-4.77-.9-10.41-1.17-14.8 1.26-.54.3-.2 1.1.39.88 5.34-1.98 10.499-1.88 16.009-.7 5.68 1.22 11.12 3.09 16.92 3.73 5.65.62 11.321.75 16.941 1.67 6.01.98 11.739 2.76 17.529 4.56.471.14.731-.49.291-.69ZM230.939 110.411c-5.02-3.34-11.02-4.57-16.82-5.83-6.82-1.49-13.64-2.97-20.46-4.46-6.65-1.45-13.37-3.1-20.22-3.05-6.63.05-13.97 3.01-20.12-.68-.41-.24-.85.32-.45.6 5.09 3.61 11.34 1.91 17.05 1.33 7-.71 13.95.76 20.76 2.24 6.82 1.48 13.63 2.97 20.45 4.46 6.61 1.44 13.35 2.63 19.2 6.21.55.34 1.17-.45.61-.82ZM228.241 105.91c-1.3-2.04-3.44-3.75-5.47-5.02-.95-.6-1.94-1.13-2.96-1.58-.76-.33-5.06-1.37-4.04-2.88.28-.42-.31-.85-.63-.47-1.84 2.2 1.79 3.29 3.21 3.83 3.8 1.44 6.37 3.88 9.19 6.68.41.41 1.01-.07.7-.56ZM230.919 97.01c-.68 1.28-4.14-1.92-4.84-2.38-.99-.66-2.02-1.25-3.08-1.77-2.31-1.13-4.94-2.09-7.53-2.27-.48-.03-.74.74-.22.87 3.86 1 7.39 2.03 10.71 4.36 1.46 1.02 4.33 4.279 5.75 1.51.27-.5-.53-.8-.79-.32ZM213.89 115.87c-9.08-1.04-18.35-.96-27.36-2.52-4.37-.76-8.52-2.45-12.91-3.1-4.3-.64-8.8-.57-13.12-.16-.51.05-.51.92.02.92 4.46.01 8.9-.34 13.33.37 4.38.7 8.53 2.38 12.91 3.1 4.32.72 8.72.95 13.08 1.3 4.64.38 9.29.88 13.93 1.1.66.04.78-.94.12-1.01ZM198.641 123.869c-4.79 2.81-10.56-.02-15.65-.26-4.63-.22-9.78.43-13.93 2.6-.5.26-.17.96.35.79 5.46-1.73 10.61-2.87 16.38-2.04 4.47.65 9.19 2.42 13.27-.39.4-.26-.01-.94-.42-.7ZM200.8 129.529c-5.39-.04-10.87.66-16.25 1.02-5.68.37-11.43.54-17.08 1.21-.45.05-.45.82.02.81 5.5-.08 11.01-.63 16.5-1 5.57-.37 11.3-.38 16.83-1.15.48-.08.49-.89-.02-.89ZM166.47 92.39c-2.72.15-5.45-.75-8.15-1.04-2.36-.26-4.84-.47-7.21-.16-.49.06-.48.84.02.87 2.72.19 5.42.12 8.13.47 2.4.31 4.94 1.23 7.35.76.59-.12.44-.93-.14-.9ZM171.371 81.66c-6.58-1.43-12.6 4.87-19.15 1.52-.4-.2-.75.44-.38.68 2.53 1.65 5.55 1.51 8.39.83 3.77-.9 7.09-2.35 11.05-2.16.57.03.64-.75.09-.87Z"}})]),_c('path',{attrs:{"d":"M171.34 143.17c-3.04-3.86-2.61-10.37-1.72-16.84.48-3.48 1.38-6.88 2.56-10.01.87-2.31 3.29-9.33 5.22-7.65.44.38-.02-1.21-.53-1.45-1.4-.63-2.7 2.14-3.78 4.35-1.79 3.65-3.13 7.92-3.95 12.26-1.44 7.62-2.15 16.4 1.85 20.76.05.06.11.09.16.11l.19-1.53ZM202.58 146.17c-5.17-3.04-11.02-7.65-11.82-16.39-.41-4.53.91-9.05 2.33-13.21.65-1.91 1.28-4.25 2.46-5.67 1.37-1.65 2.11-2.27 2.95-.52 0 0 .19 0 .43-.03.22-.03.47-.1.47-.1-1.01-3.21-3.68-2.3-5.37.85-1.09 2.05-1.83 4.58-2.55 6.89-.85 2.7-1.58 5.53-1.79 8.42-.82 11.21 6.21 17.51 12.44 21.18.62.36 1.06-1.06.45-1.42Z","fill":"#39565B"}}),_c('path',{attrs:{"d":"M189.43 191.29c-3.47-4.66-3.79-11.24-4.48-16.81-.47-3.8-.82-7.62-1.07-11.45 1.58.77 3.27 1.08 5.03.96.32-.02.24-.52-.08-.5-1.76.13-3.43-.23-4.99-1.04 0-.05-.01-.1-.01-.14.01 0 .01 0 .02.01 2.5.4 4.96 0 7.2-1.18.29-.15.08-.61-.21-.46-1.89 1-3.9 1.42-5.98 1.25.4-.32.59-.87.73-1.48.38-1.73.35-3.5.01-5.23-.06-.32-.56-.24-.5.08.2 1.02.3 2.04.25 3.08-.04.82-.12 3.27-1.3 3.34a.224.224 0 0 0-.18 0c-.02.01-.05.01-.07.02-.12-2.08-.22-4.16-.28-6.24-.01-.32-.51-.24-.5.08.06 2.11.16 4.21.28 6.31-1.77.52-3.59.4-5.32-.34-.3-.13-.49.34-.19.47 1.5.64 3.07.83 4.62.58-1.23.78-2.55 1.38-3.95 1.82-.31.1-.1.56.21.46 1.68-.52 3.24-1.29 4.67-2.29.27 4.32.68 8.64 1.23 12.94.69 5.4 1.1 11.56 4.46 16.08.2.26.59-.06.4-.32ZM175.5 154.73c-.37 1.56-1.5 2.77-2.99 3.32-.31.11-.1.57.21.46 1.68-.61 2.88-2 3.29-3.72.07-.32-.43-.37-.51-.06ZM196.35 155.99a5.809 5.809 0 0 1-3.49-2.31c-.19-.26-.59.05-.39.32.94 1.3 2.27 2.15 3.83 2.49.31.08.36-.43.05-.5ZM199.56 182.1c.19.08.39.14.61.17.32.05.38-.45.06-.5-2-.31-2.23-2.86-2.42-4.47-.19-1.63-.16-3.26.03-4.88.04-.32-.47-.38-.5-.06-.26 2.28-.22 4.61.28 6.86.2.93.55 1.82 1.2 2.41-.04.04-.07.09-.07.16-.02.99-.34 1.88-.95 2.65-.2.26.2.56.41.3.52-.66.85-1.41.98-2.22.4 1.23.59 2.49.56 3.79-.01.32.49.38.5.06.02-1.47-.21-2.9-.69-4.27Z","fill":"#008E8A"}}),_c('path',{attrs:{"d":"M182.6 104.76c-1.18.35-2.37.36-3.56.02-.31-.09-.48.39-.17.48 1.27.37 2.56.38 3.82 0 .32-.09.22-.59-.09-.5Z","fill":"#AF8664"}})])
}
var success_svgvue_type_template_id_62f53040_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/success-svg.vue?vue&type=template&id=62f53040

// CONCATENATED MODULE: ./src/components/svg/decorations/success-svg.vue

var success_svg_script = {}


/* normalize component */

var success_svg_component = normalizeComponent(
  success_svg_script,
  success_svgvue_type_template_id_62f53040_render,
  success_svgvue_type_template_id_62f53040_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var success_svg = (success_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-travel-agent/email-register.vue?vue&type=script&lang=js







/* harmony default export */ var email_registervue_type_script_lang_js = ({
  components: {
    HgButton: hg_button,
    HgTextInput: hg_text_input,
    PaperPlaneSvg: paper_plane_svg,
    SuccessSvg: success_svg,
    HgModal: hg_modal,
  },
  props: {
    travelAgent: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: [],
    },
  },
  data: () => ({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirm: '',
    newsletterConsent: false,
    privacyConsent: false,
    step: '1',
  }),
  watch: {
    errors() {
      this.nextStep('1')
    },
  },
  methods: {
    nextStep(step) {
      this.step = step
      if (step === '2') {
        this.pushGtmEvent('travelagent_nextstep')
      }
      if (step === 'success') {
        this.submit()
      }
    },
    submit() {
      const { firstName, lastName, email, password } = this

      this.$emit('onSubmit', {
        firstName,
        lastName,
        email,
        password,
      })
    },
    onClose() {
      this.$emit('onClose')
    },

    pushGtmEvent(event) {
      this.$emit('pushGtmEvent', event)
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-travel-agent/email-register.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_travel_agent_email_registervue_type_script_lang_js = (email_registervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-travel-agent/email-register.vue?vue&type=style&index=0&id=dac8e610&prod&lang=postcss&scoped=true
var email_registervue_type_style_index_0_id_dac8e610_prod_lang_postcss_scoped_true = __webpack_require__("5da8");

// CONCATENATED MODULE: ./src/components/partials/hg-travel-agent/email-register.vue






/* normalize component */

var email_register_component = normalizeComponent(
  hg_travel_agent_email_registervue_type_script_lang_js,
  email_registervue_type_template_id_dac8e610_scoped_true_render,
  email_registervue_type_template_id_dac8e610_scoped_true_staticRenderFns,
  false,
  null,
  "dac8e610",
  null
  
)

/* harmony default export */ var email_register = (email_register_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-travel-agent/data-register.vue?vue&type=template&id=4c8bd33a&scoped=true
var data_registervue_type_template_id_4c8bd33a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-container"},[_c('PaperPlaneSvg',{staticClass:"hg-plane-svg"}),(_vm.step === '1')?[_c('ValidationObserver',{ref:"observer",staticClass:"form content",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('h3',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.dataRegister.title'))+" ")]),_c('p',{staticClass:"tw-mb-1"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.dataRegister.sub'))+" ")]),_c('p',{staticClass:"hg-text tw-mb-3 tw-text-gray-600"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.mandatory'))+" ")]),_c('div',{staticClass:"hg-wrapper"},[_c('HgDestinationSelect',{staticClass:"tw-mb-5 md:tw-mb-1 md:tw-w-full md:tw-mr-3",attrs:{"isMobile":_vm.isMobile,"isLoading":_vm.isLoadingDestinations,"options":_vm.destinations,"label":_vm.$t('travelAgent.dataRegister.destination'),"placeholder":_vm.$t('travelAgent.dataRegister.destinationPlaceholder'),"noResult":_vm.$t('ibeSearch.destinationResult'),"teal":true,"transparent":true},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}}),_c('HgAirportSelect',{staticClass:"tw-mb-5 md:tw-mb-1 md:tw-w-full md:tw-mr-3",attrs:{"is-mobile":_vm.isMobile,"airports":_vm.airports,"searched-airports":_vm.searchedAirports,"placeholder":_vm.$t('ibeSearch.airportPlaceholder'),"label":_vm.$t('ibeSearch.airportLabel.with'),"teal":true,"transparent":true},on:{"onChangeAirportTerm":function($event){return _vm.$emit('onChangeAirportTerm', arguments[0])},"onSelectAirports":_vm.selectAirports}}),_c('HgDatepicker',{staticClass:"tw-mb-5 md:tw-mb-1 md:tw-w-full md:tw-mr-3",attrs:{"id":"hg-duration-select","isMobile":_vm.isMobile,"label":_vm.$t('travelAgent.dataRegister.datePicker'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate,"position":"bottom daterange"},on:{"onDateRangeSelect":_vm.updateDateRange}}),_c('HgTravelDurationSelect',{staticClass:"tw-mb-5 md:tw-mb-1 md:tw-w-full md:tw-mr-3",attrs:{"id":"hg-duration-select","isMobile":_vm.isMobile,"options":_vm.$t('ibeSearchControls.durationOptions'),"placeholder":_vm.$t('ibeSearch.durationPlaceholder'),"label":_vm.$t('travelAgent.dataRegister.duration')},on:{"onSelectTravelDuration":_vm.selectTravelDuration}}),_c('HgTextInput',{staticClass:"tw-mb-5 md:tw-mb-1 md:tw-h-4",attrs:{"placeholder":_vm.$t('travelAgent.dataRegister.moneyText'),"label":_vm.$t('travelAgent.dataRegister.budget'),"labelPosition":"inside","name":"ReiseBudget","teal":true},model:{value:(_vm.budget),callback:function ($$v) {_vm.budget=$$v},expression:"budget"}}),_c('HgTravelers',{staticClass:"tw-mb-5 md:tw-mb-1 md:tw-mb-5 md:tw-w-full md:tw-mr-3",attrs:{"lang":_vm.$i18n.locale,"show-errors":"","isMobile":_vm.isMobile,"max-children":4,"is-mobile":_vm.isMobile,"label":_vm.$t('travelAgent.dataRegister.travelersLabel')},on:{"onUpdateTravelers":_vm.updateTravelers}}),_c('hg-checkbox',{staticClass:"tw-mb-5 md:tw-mb-1",attrs:{"name":"news-consent","teal":true,"transparent":true},model:{value:(_vm.privacyConsent),callback:function ($$v) {_vm.privacyConsent=$$v},expression:"privacyConsent"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('travelAgent.checkBox.data'))}})])],1),_c('HgButton',{staticClass:"tw-w-full",attrs:{"color":"teal","disabled":_vm.invalid === true || _vm.privacyConsent === false},on:{"onClick":function($event){return _vm.nextStep('success')}}},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.dataRegister.cta'))+" ")])],1)]:_vm._e(),(_vm.step === 'success')?[_c('div',{staticClass:"hg-success-content"},[_c('h3',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.dataRegister.success.title'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('travelAgent.dataRegister.success.sub'))+" ")]),_c('NewsBlockSvg',{staticClass:"tw-mb-10"}),_c('div',{staticClass:"tw-mb-20"},[_c('h4',{staticClass:"hg-title hg-text-color"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.dataRegister.success.subTitle'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('travelAgent.dataRegister.success.subInfo'))+" ")])]),_c('p',{staticClass:"hg-text tw-mb-2 tw-text-gray-600"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.dataRegister.success.couponDuration'))+" ")]),_c('HgButton',{staticClass:"tw-w-full",attrs:{"color":"teal"},on:{"onClick":_vm.goToReisemagazin}},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.dataRegister.successCta'))+" ")])],1)]:_vm._e()],2)
}
var data_registervue_type_template_id_4c8bd33a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-travel-agent/data-register.vue?vue&type=template&id=4c8bd33a&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/news-block-svg.vue?vue&type=template&id=201b4e57
var news_block_svgvue_type_template_id_201b4e57_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"301","height":"213","viewBox":"0 0 301 213","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_1_4148)"}},[_c('path',{attrs:{"d":"M5.75347 0C8.48465 0 10.7691 1.90013 11.3573 4.44844C11.8526 4.20411 12.4086 4.0668 12.9989 4.0668C14.877 4.0668 16.4255 5.46009 16.6762 7.26733H0.204182C0.070756 6.78271 0 6.27385 0 5.74682C0 2.57254 2.57552 0 5.75347 0Z","fill":"white"}}),_c('path',{attrs:{"d":"M49.0076 173.004C45.2596 158.975 49.3169 145.547 51.4719 141.453C55.4909 133.813 61.9135 127.997 65.2107 119.91C71.9507 103.376 67.0524 97.1407 74.5343 83.331C76.188 80.2799 82.9321 68.6691 94.437 64.9496C105.758 61.2887 111.958 68.4127 123.192 70.1068C144.227 73.2791 151.808 52.723 177.08 42.1097C201.349 31.9165 238.626 32.282 254.398 53.6498C268.818 73.1862 256.213 98.0191 275.061 117.745C284.704 127.838 292 125.523 297.426 136.9C304.055 150.797 300.757 170.163 293.332 181.487C287.678 190.112 279.961 194.082 279.961 194.082C277.287 195.459 274.901 196.174 273.205 196.567C202.789 196.367 132.372 196.167 61.9539 195.968C60.5024 194.401 58.6001 192.155 56.629 189.215C55.3413 187.295 51.108 180.88 49.0056 173.006L49.0076 173.004Z","fill":"#DCFAF5"}}),_c('path',{attrs:{"d":"M25.5813 164.699C26.5032 164.986 27.2593 165.337 27.8799 165.707C26.9318 164.588 26.0564 163.465 25.2558 162.341C24.5988 162.67 22.747 163.385 20.0866 162.658C16.7287 161.741 12.9746 157.787 12.9746 157.787C12.9746 157.787 18.156 156.566 21.5866 158.223C22.2255 158.532 22.7632 158.864 23.214 159.197C22.5307 158.032 21.9283 156.865 21.4047 155.695C20.6405 155.926 19.0799 156.186 17.0724 155.401C14.1916 154.276 11.2441 150.429 11.2441 150.429C11.2441 150.429 15.9383 149.835 18.815 151.62C19.3912 151.978 19.8602 152.347 20.2423 152.711C19.9027 151.685 19.6216 150.657 19.4053 149.629C18.8171 149.771 17.5394 149.92 15.9504 149.157C13.7489 148.101 11.6586 144.898 11.6586 144.898C11.6586 144.898 15.3884 144.711 17.5455 146.286C18.2773 146.821 18.7645 147.364 19.092 147.851C19.0475 147.544 19.0091 147.237 18.9768 146.93C18.5623 146.742 17.2887 146.031 16.5205 144.151C15.5906 141.884 16.191 138.089 16.191 138.089C16.191 138.089 19.1001 140.456 19.6479 143.085C19.9694 144.624 19.7308 145.696 19.4801 146.322C19.5287 146.912 19.5974 147.499 19.6884 148.089C19.7611 147.453 19.9795 146.653 20.5192 145.779C21.7989 143.701 25.2033 141.956 25.2033 141.956C25.2033 141.956 25.0052 145.68 23.214 147.663C21.7807 149.246 20.4364 149.488 19.9532 149.522C20.2645 150.999 20.7072 152.475 21.2794 153.949C21.53 154.34 21.6837 154.688 21.7787 154.952C21.6311 154.163 21.5422 152.594 22.5226 150.696C23.9418 147.949 28.076 145.419 28.076 145.419C28.076 145.419 28.1811 150.144 26.1069 152.818C24.0611 155.455 21.9849 155.502 21.9283 155.502C22.8016 157.446 23.9014 159.389 25.2235 161.323C24.9951 160.39 24.8394 158.771 25.6258 156.747C26.8873 153.506 31.2115 150.185 31.2115 150.185C31.2115 150.185 31.8907 155.457 29.8873 158.696C28.2903 161.277 26.4708 161.965 25.7956 162.139C26.9964 163.815 28.361 165.485 29.8954 167.147C29.5416 166.135 29.2445 164.53 29.7155 162.452C30.5585 158.738 34.7088 154.445 34.7088 154.445C34.7088 154.445 36.2958 160.047 34.6462 163.877C33.409 166.751 31.6845 167.841 30.9022 168.207C32.2364 169.584 33.6819 170.957 35.2405 172.322C34.7291 171.383 34.163 169.814 34.3247 167.631C34.6057 163.835 38.0708 158.973 38.0708 158.973C38.0708 158.973 40.4724 164.277 39.4131 168.308C38.5822 171.47 36.9366 172.782 36.2635 173.202C37.719 174.436 39.2716 175.662 40.9071 176.881C40.341 175.975 39.7305 174.547 39.68 172.538C39.5829 168.732 42.5486 163.552 42.5486 163.552C42.5486 163.552 45.4658 168.592 44.8088 172.71C44.3114 175.84 42.8781 177.316 42.2191 177.845C43.8323 179.008 45.5244 180.165 47.2973 181.31C46.6242 180.415 45.8701 179 45.6194 176.946C45.1342 172.974 47.7138 167.26 47.7138 167.26C47.7138 167.26 51.2718 172.237 51.0029 176.609C50.7947 179.969 49.418 181.657 48.7933 182.261C50.0629 183.058 51.3648 183.85 52.7092 184.637C52.9983 184.807 53.2853 184.973 53.5744 185.138C52.8163 184.27 51.9228 182.858 51.5205 180.736C50.7543 176.7 53.0124 170.67 53.0124 170.67C53.0124 170.67 56.995 175.531 57.0131 180.029C57.0273 183.551 55.6829 185.379 55.0967 186.005C56.9141 187.024 58.7194 187.991 60.4883 188.904C59.6695 188.024 58.685 186.57 58.1998 184.347C57.2881 180.159 59.4734 173.808 59.4734 173.808C59.4734 173.808 63.7633 178.765 63.9068 183.454C64.02 187.095 62.6918 189.035 62.0914 189.722C64.5416 190.956 66.9089 192.08 69.1246 193.09C68.1744 192.159 66.9978 190.582 66.359 188.107C65.1784 183.525 67.3213 176.427 67.3213 176.427C67.3213 176.427 72.2601 181.718 72.6179 186.885C72.8948 190.901 71.508 193.098 70.8753 193.878C73.5276 195.055 75.9192 196.052 77.9266 196.856C76.936 195.972 75.7008 194.463 74.9427 192.064C73.5175 187.553 75.2783 180.349 75.2783 180.349C75.2783 180.349 80.494 185.366 81.1288 190.507C81.6201 194.498 80.3566 196.765 79.7663 197.581C82.5803 198.673 84.2805 199.255 84.331 199.271L84.1531 199.796C84.1006 199.778 82.3418 199.178 79.4388 198.047C79.2083 198.641 77.965 201.375 74.1078 203.045C69.7614 204.927 62.4068 203.923 62.4068 203.923C62.4068 203.923 66.8644 198.223 71.9184 197.062C73.6893 196.654 75.1469 196.64 76.2952 196.793C74.5728 196.089 72.628 195.265 70.5255 194.328C70.2587 194.918 68.8678 197.571 64.9358 199.029C60.4964 200.676 53.2045 199.279 53.2045 199.279C53.2045 199.279 57.9613 193.825 63.0699 192.937C64.8044 192.636 66.2236 192.684 67.3455 192.882C65.5463 192.046 63.6642 191.137 61.7316 190.162C61.4243 190.758 60.0557 193.025 56.534 194.183C52.4585 195.521 45.9085 194.007 45.9085 194.007C45.9085 194.007 50.4005 189.233 55.0562 188.603C56.6109 188.393 57.8784 188.482 58.8791 188.69C57.5105 187.969 56.1257 187.218 54.7348 186.437C54.3911 187.046 53.0104 189.12 49.6707 190.118C45.7306 191.295 39.492 189.678 39.492 189.678C39.492 189.678 43.9213 185.219 48.3971 184.734C49.9234 184.569 51.1566 184.694 52.1189 184.93C50.8432 184.179 49.602 183.424 48.3931 182.665C48.0474 183.204 46.5777 185.177 43.2198 185.944C39.3161 186.836 33.3584 184.866 33.3584 184.866C33.3584 184.866 37.9474 180.815 42.3283 180.631C43.7899 180.571 44.9604 180.76 45.8721 181.041C44.455 180.104 43.0924 179.159 41.7804 178.21C41.3983 178.695 39.8255 180.421 36.5829 180.841C32.8025 181.332 27.3381 178.921 27.3381 178.921C27.3381 178.921 32.0565 175.502 36.223 175.728C37.4602 175.795 38.4609 176.031 39.2574 176.328C38.0546 175.401 36.8982 174.472 35.7985 173.538C35.2911 174.042 33.5646 175.494 30.419 175.589C26.6083 175.702 21.4108 172.764 21.4108 172.764C21.4108 172.764 26.4445 169.828 30.5686 170.464C31.6016 170.624 32.4548 170.884 33.1542 171.187C32.1778 170.28 31.2499 169.37 30.3705 168.455C29.9015 168.819 27.9426 170.133 24.6696 169.741C20.8851 169.287 16.1809 165.61 16.1809 165.61C16.1809 165.61 21.5947 163.455 25.5793 164.697L25.5813 164.699Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M53.9666 162.29L45.0331 161.725C43.1813 157.101 41.283 151.83 39.2554 146.661L45.9853 147.115L38.1597 143.913C35.3881 137.088 32.3617 130.675 28.8866 126.446C37.816 127.482 46.4745 131.707 54.1505 137.29L58.4303 150.237L57.1425 139.574C63.929 144.991 69.8098 151.348 74.2371 157.238C84.1349 170.402 78.6402 192.595 78.6402 192.595C78.6402 192.595 56.536 183.022 49.5918 171.486C48.3647 169.449 47.1477 166.842 45.9145 163.892L53.9645 162.292L53.9666 162.29Z","fill":"#ABE532"}}),_c('path',{attrs:{"d":"M35.8248 209.543C34.9373 212.733 31.822 212.998 29.9622 213C30.3079 212.045 31.9332 208.261 35.8248 209.543Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M35.281 210.092C35.2103 210.07 35.1476 210.026 35.1031 209.959C35.0061 209.808 35.0485 209.608 35.2002 209.511C39.8276 206.52 45.1121 204.018 50.4875 202.272C55.0179 200.8 59.5928 199.873 63.3691 199.663C63.5491 199.653 63.7027 199.79 63.7108 199.968C63.7209 200.147 63.5834 200.299 63.4055 200.309C56.6453 200.687 45.7792 203.445 35.5519 210.054C35.469 210.108 35.368 210.119 35.281 210.092Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M58.677 199.035C52.3615 196.818 52.8791 191.933 53.1277 188.191C55.0078 189.015 61.7903 191.374 58.677 199.035Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M52.3595 200.147C47.0063 199.683 46.4322 195.782 45.8762 192.824C47.5036 193.09 53.247 193.571 52.3595 200.147Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M45.8579 202.698C41.2911 203.386 40.0256 200.242 38.9663 197.882C40.3794 197.777 45.2757 197.026 45.8579 202.698Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M39.7932 205.664C37.1874 206.866 35.8855 205.206 34.8444 203.982C35.6692 203.675 38.461 202.379 39.7932 205.664Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M58.6951 202.524C53.627 205.555 54.939 209.686 55.8143 212.877C57.2941 211.833 62.7403 208.596 58.6951 202.524Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M51.848 203.863C47.1235 205.765 47.6855 209.462 48.0009 212.299C49.4018 211.607 54.4781 209.581 51.848 203.863Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M44.0285 206.653C41.2852 208.796 42.3546 211.116 43.1006 212.917C43.889 212.198 46.8385 209.911 44.0285 206.653Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M38.8916 208.903C37.0924 209.838 37.4562 211.28 37.6887 212.392C38.2184 212.065 40.151 211.07 38.8916 208.903Z","fill":"#ABE57A"}}),_c('path',{attrs:{"d":"M245.446 90.675C256.474 79.6594 256.474 61.7996 245.446 50.7841C234.418 39.7685 216.537 39.7685 205.509 50.7841C194.481 61.7997 194.481 79.6594 205.509 90.6749C216.537 101.691 234.418 101.691 245.446 90.675Z","fill":"#FFD675"}}),_c('path',{attrs:{"d":"M171.915 81.1381C171.939 81.2532 172.04 81.3299 172.139 81.3097C172.238 81.2895 172.299 81.1785 172.275 81.0634L171.672 78.2101C171.648 78.095 171.547 78.0183 171.448 78.0385C171.349 78.0587 171.288 78.1698 171.312 78.2849L171.915 81.1381Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M170.876 81.3885C170.777 81.4086 170.714 81.5076 170.734 81.6065C170.754 81.7055 170.853 81.7681 170.952 81.7479L173.405 81.2309C173.504 81.2108 173.566 81.1118 173.546 81.0129C173.526 80.9139 173.427 80.8513 173.328 80.8715L170.876 81.3885Z","fill":"url(#paint0_linear_1_4148)"}}),_c('path',{attrs:{"d":"M175.068 80.6716C174.899 79.87 174.112 79.3571 173.31 79.5267C172.507 79.6963 171.994 80.4818 172.163 81.2834C172.333 82.0851 173.12 82.598 173.922 82.4284C174.725 82.2587 175.238 81.4733 175.068 80.6716Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M174.205 81.8104C174.661 81.4874 174.769 80.856 174.446 80.4001C174.122 79.9442 173.49 79.8365 173.034 80.1596C172.577 80.4826 172.469 81.114 172.793 81.5699C173.116 82.0258 173.748 82.1335 174.205 81.8104Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M174.211 80.8513C174.143 80.5222 173.819 80.3122 173.492 80.3829C173.162 80.4515 172.952 80.7746 173.023 81.1017C173.091 81.4309 173.415 81.6409 173.742 81.5702C174.072 81.5015 174.282 81.1785 174.211 80.8513Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M172.163 81.2814C171.994 80.4798 171.207 79.9669 170.405 80.1365C169.602 80.3061 169.089 81.0916 169.258 81.8933C169.428 82.6949 170.215 83.2078 171.017 83.0382C171.82 82.8686 172.333 82.0831 172.163 81.2814Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M171.703 81.3784C171.587 80.8311 171.05 80.4818 170.502 80.5969C169.954 80.712 169.604 81.2491 169.719 81.7963C169.835 82.3436 170.372 82.6929 170.92 82.5778C171.468 82.4627 171.818 81.9256 171.703 81.3784Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M171.306 81.4632C171.238 81.134 170.914 80.924 170.587 80.9947C170.257 81.0634 170.047 81.3864 170.118 81.7136C170.186 82.0427 170.51 82.2527 170.837 82.182C171.167 82.1134 171.377 81.7903 171.306 81.4632Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M196.402 75.9849C196.427 76.1 196.528 76.1767 196.627 76.1565C196.726 76.1363 196.787 76.0253 196.762 75.9102L196.16 73.057C196.136 72.9419 196.035 72.8651 195.935 72.8853C195.836 72.9055 195.776 73.0166 195.8 73.1317L196.402 75.9849Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M195.363 76.2353C195.264 76.2555 195.202 76.3544 195.222 76.4534C195.242 76.5523 195.341 76.6149 195.44 76.5947L197.892 76.0778C197.991 76.0576 198.054 75.9586 198.034 75.8597C198.014 75.7608 197.915 75.6982 197.816 75.7184L195.363 76.2353Z","fill":"url(#paint1_linear_1_4148)"}}),_c('path',{attrs:{"d":"M199.556 75.5185C199.386 74.7168 198.6 74.2039 197.797 74.3735C196.995 74.5432 196.481 75.3286 196.651 76.1303C196.821 76.9319 197.607 77.4448 198.41 77.2752C199.212 77.1056 199.726 76.3201 199.556 75.5185Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M199.095 75.6154C198.98 75.0682 198.442 74.7188 197.894 74.8339C197.347 74.949 196.997 75.4862 197.112 76.0334C197.227 76.5806 197.765 76.9299 198.313 76.8148C198.861 76.6997 199.21 76.1626 199.095 75.6154Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M198.699 75.6982C198.63 75.369 198.307 75.159 197.979 75.2297C197.65 75.2983 197.44 75.6214 197.51 75.9485C197.579 76.2777 197.902 76.4877 198.23 76.417C198.559 76.3484 198.77 76.0253 198.699 75.6982Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M196.651 76.1303C196.481 75.3286 195.695 74.8157 194.892 74.9854C194.09 75.155 193.576 75.9405 193.746 76.7421C193.916 77.5438 194.702 78.0567 195.505 77.887C196.307 77.7174 196.821 76.9319 196.651 76.1303Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M195.785 77.2717C196.241 76.9487 196.349 76.3173 196.026 75.8614C195.702 75.4055 195.07 75.2978 194.614 75.6208C194.157 75.9439 194.05 76.5753 194.373 77.0312C194.696 77.487 195.329 77.5947 195.785 77.2717Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M195.794 76.31C195.725 75.9808 195.402 75.7708 195.074 75.8415C194.745 75.9102 194.535 76.2332 194.605 76.5604C194.674 76.8895 194.997 77.0995 195.325 77.0288C195.654 76.9602 195.865 76.6371 195.794 76.31Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M212.563 72.2553C212.583 72.3543 212.682 72.4169 212.781 72.3967C212.88 72.3765 212.943 72.2776 212.923 72.1786L212.405 69.7292C212.385 69.6303 212.286 69.5677 212.187 69.5879C212.088 69.6081 212.025 69.707 212.046 69.806L212.563 72.2553Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M213.107 74.1946C213.914 74.0502 214.451 73.28 214.306 72.4743C214.162 71.6685 213.391 71.1324 212.584 71.2768C211.777 71.4212 211.24 72.1914 211.385 72.9971C211.53 73.8029 212.301 74.339 213.107 74.1946Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M213.841 72.5118C213.725 71.9646 213.188 71.6152 212.64 71.7303C212.092 71.8454 211.742 72.3826 211.858 72.9298C211.973 73.477 212.511 73.8263 213.058 73.7112C213.606 73.5961 213.956 73.059 213.841 72.5118Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M213.444 72.5966C213.376 72.2675 213.052 72.0575 212.725 72.1281C212.395 72.1968 212.185 72.5199 212.256 72.847C212.325 73.1761 212.648 73.3861 212.975 73.3155C213.305 73.2468 213.515 72.9237 213.444 72.5966Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M143.988 72.1382C143.988 72.1382 144.219 73.2266 144.738 75.6982C144.745 75.7022 144.753 75.7042 144.759 75.7083C145.171 75.9041 145.624 76.1 146.113 76.2938C146.685 76.52 147.306 76.7441 147.967 76.9622C148.129 77.0167 148.294 77.0692 148.46 77.1217C148.683 77.1924 148.909 77.2631 149.142 77.3317C155.58 79.2723 164.908 80.6736 169.903 79.6216L213.869 70.3693C214.13 70.3148 214.267 70.2845 214.267 70.2845H214.265L211.637 67.1446L209.527 64.6245L209.274 64.3236L209.086 64.0995L208.332 63.1989L207.275 61.9369L205.055 59.2876L143.986 72.1382H143.988Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M201.125 67.9361C201.228 68.4207 201.495 68.8549 201.903 69.2305C203.767 70.9529 208.562 71.486 213.869 70.3693C214.003 70.3411 214.134 70.3128 214.265 70.2825C220.53 68.8731 225.107 65.6564 224.547 63.0071C224.489 62.7264 224.373 62.4619 224.208 62.2176C224.07 62.0136 223.896 61.8218 223.692 61.6421C223.581 61.5452 223.462 61.4523 223.33 61.3634C223.231 61.2948 223.126 61.2302 223.015 61.1655C222.532 60.8869 221.947 60.6547 221.284 60.4709C218.903 59.8146 215.474 59.7985 211.801 60.5719C210.163 60.9172 208.635 61.3856 207.275 61.9369C205.581 62.6234 204.145 63.4372 203.084 64.3035C202.55 64.7376 202.111 65.1859 201.78 65.6362C201.705 65.7392 201.634 65.8421 201.572 65.9451C201.489 66.0784 201.416 66.2117 201.353 66.3449C201.099 66.8861 201.014 67.4212 201.123 67.9361H201.125Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M144.759 75.7083C145.171 75.9041 145.624 76.1 146.113 76.2939C146.685 76.52 147.306 76.7442 147.967 76.9622C148.129 77.0168 148.294 77.0693 148.46 77.1218C148.683 77.1924 148.909 77.2631 149.142 77.3318C155.58 79.2723 164.908 80.6736 169.903 79.6216L213.869 70.3693C214.13 70.3148 214.267 70.2845 214.267 70.2845H214.265C220.53 68.8731 225.107 65.6564 224.547 63.0051C224.489 62.7244 224.373 62.4599 224.208 62.2155C223.589 63.1141 222.332 64.2712 219.778 65.1637C218.776 65.515 215.773 66.2278 211.635 67.1426C208.825 67.7625 205.49 68.4753 201.901 69.2285C185.053 72.7642 162.618 77.1924 162.618 77.1924C162.618 77.1924 158.704 78.2283 154.61 77.6326C152.299 77.2974 148.115 76.3867 144.755 75.7042L144.759 75.7083Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M198.727 63.1868C199.014 64.5438 202.419 64.9759 206.335 64.152C210.248 63.3282 214.92 61.2847 214.069 60.1943C214.047 60.166 214.027 60.1397 214.002 60.1135C213.608 59.6612 212.978 59.328 212.177 59.1059C212.163 59.1018 212.149 59.0978 212.135 59.0938C210.406 58.6293 207.905 58.6899 205.3 59.2371C201.384 60.061 198.442 61.8278 198.729 63.1848L198.727 63.1868Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M178.719 77.7659C179.039 79.2763 180.523 80.2435 182.035 79.9245L189.521 78.3494C191.033 78.0304 191.379 76.6795 191.059 75.1691C190.74 73.6587 189.879 72.5602 188.367 72.8793L180.881 74.4543C179.368 74.7733 178.4 76.2555 178.719 77.7659Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M190.339 77.8636C190.824 77.7615 190.997 76.634 190.725 75.3452C190.453 74.0565 189.839 73.0945 189.354 73.1966C188.869 73.2987 188.696 74.4262 188.968 75.715C189.24 77.0037 189.854 77.9657 190.339 77.8636Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M138.275 63.3907L138.878 64.1439L139.602 65.0486L139.781 65.2747L140.024 65.5776L146.962 74.2604L159.059 71.7141L147.35 64.0369L146.942 63.7683L146.637 63.5684L145.414 62.7668L144.399 62.1004L138.275 63.3907Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M143.028 74.1999C143.236 75.1832 143.713 75.9142 144.698 75.7082L149.156 74.7693C150.14 74.5613 150.769 73.5981 150.563 72.6147C150.354 71.6314 149.39 71.0034 148.406 71.2093L143.948 72.1483C142.963 72.3563 142.822 73.2165 143.03 74.1999H143.028Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M210.438 60.9575L214.067 60.1943C214.045 60.166 214.025 60.1397 214 60.1135C213.606 59.6612 212.976 59.328 212.175 59.1059C212.167 59.1059 212.161 59.1059 212.153 59.1039L209.272 59.7096C208.631 59.8449 209.798 61.0908 210.438 60.9575Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M210.452 59.2765L210.256 59.5002L211.827 60.869L212.022 60.6453L210.452 59.2765Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M178.701 76.4978L185.741 75.0156L196.993 68.7176L178.279 72.6571L178.701 76.4978Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M196.846 68.0168L194.44 68.5231L194.586 69.2127L196.991 68.7064L196.846 68.0168Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M179.033 75.6952L178.557 75.7955L178.702 76.4851L179.179 76.3848L179.033 75.6952Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M178.556 75.8072L185.593 74.3271L196.847 68.027L178.133 71.9666L178.556 75.8072Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M147.852 75.678L151.434 74.9248L157.351 72.6471L146.683 74.8925L147.852 75.678Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M157.25 72.1429L154.095 72.8071L154.199 73.301L157.354 72.6369L157.25 72.1429Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M147.278 74.2741L146.588 74.4194L146.686 74.8837L147.376 74.7384L147.278 74.2741Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M147.749 75.1853L151.331 74.4301L157.248 72.1544L146.578 74.3978L147.749 75.1853Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M211.138 71.1932C211.164 71.3204 211.259 71.4072 211.35 71.3891C211.441 71.3709 211.492 71.2517 211.465 71.1245L210.804 67.9886C210.778 67.8614 210.683 67.7746 210.592 67.7927C210.501 67.8109 210.451 67.9301 210.477 68.0573L211.138 71.1932Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M211.833 73.648C212.566 73.4937 212.984 72.5361 212.768 71.5093C212.551 70.4824 211.781 69.7751 211.048 69.9294C210.315 70.0837 209.896 71.0412 210.113 72.0681C210.33 73.0949 211.1 73.8023 211.833 73.648Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M211.708 73.0592C212.208 72.9539 212.494 72.3006 212.346 71.6C212.199 70.8994 211.673 70.4169 211.173 70.5222C210.672 70.6275 210.387 71.2808 210.534 71.9814C210.682 72.682 211.208 73.1645 211.708 73.0592Z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M211.983 71.6899C211.894 71.2699 211.579 70.9791 211.279 71.0437C210.98 71.1063 210.808 71.4981 210.897 71.9201C210.986 72.3401 211.302 72.6309 211.601 72.5663C211.9 72.5037 212.072 72.1119 211.983 71.6899Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M230.094 185.714L222.97 196.186L224.962 196.214L232.557 188.609L230.094 185.714Z","fill":"#008E8A"}}),_c('path',{attrs:{"d":"M261.177 186.154L268.002 196.824L266.01 196.795L258.633 188.979L261.177 186.154Z","fill":"#008E8A"}}),_c('path',{attrs:{"d":"M261.633 187.738C270.346 179.035 270.346 164.924 261.633 156.22C252.919 147.517 238.792 147.517 230.078 156.22C221.365 164.924 221.365 179.035 230.078 187.738C238.792 196.442 252.919 196.442 261.633 187.738Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M263.17 172.134C263.35 162.345 255.551 154.264 245.75 154.084C235.949 153.904 227.859 161.695 227.679 171.484C227.499 181.273 235.298 189.354 245.099 189.534C254.9 189.714 262.99 181.924 263.17 172.134Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M244.597 185.891L244.901 188.098L244.135 188.07L244.597 185.891Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M245.655 157.276L245.354 155.071L246.12 155.1L245.655 157.276Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M259.45 172.112L261.66 171.811L261.632 172.576L259.45 172.112Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M230.802 171.056L228.594 171.357L228.623 170.593L230.802 171.056Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M252.747 159.457L253.59 157.396L254.239 157.803L252.747 159.457Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M237.506 183.711L236.665 185.772L236.016 185.364L237.506 183.711Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M238.421 158.928L237.057 157.169L237.734 156.812L238.421 158.928Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M251.831 184.24L253.197 185.998L252.518 186.356L251.831 184.24Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M232.985 163.972L230.923 163.132L231.33 162.484L232.985 163.972Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M257.267 179.196L259.331 180.038L258.923 180.686L257.267 179.196Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M257.797 164.887L259.557 163.524L259.915 164.2L257.797 164.887Z","fill":"#060633"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M232.458 178.281L230.695 179.644L230.337 178.967L232.458 178.281Z","fill":"#060633"}}),_c('path',{attrs:{"d":"M247.393 171.668C247.413 170.571 246.54 169.667 245.442 169.646C244.345 169.626 243.439 170.499 243.419 171.595C243.399 172.691 244.272 173.596 245.37 173.616C246.467 173.636 247.373 172.764 247.393 171.668Z","fill":"#0F2C60"}}),_c('path',{attrs:{"d":"M245.23 172.209L244.854 172.203C244.648 172.199 244.484 172.029 244.488 171.823C244.492 171.617 244.662 171.454 244.868 171.458H244.872L245.103 159.887L244.624 160.554C244.503 160.721 244.27 160.758 244.104 160.638C243.936 160.519 243.898 160.285 244.019 160.119L245.198 158.478C245.293 158.344 245.463 158.29 245.618 158.34C245.774 158.391 245.877 158.538 245.873 158.702L245.61 171.843C245.606 172.049 245.436 172.213 245.23 172.209Z","fill":"#0F2C60"}}),_c('path',{attrs:{"d":"M246.732 160.645C246.625 160.645 246.518 160.594 246.445 160.501L245.206 158.922C245.079 158.761 245.107 158.526 245.269 158.399C245.43 158.272 245.665 158.3 245.792 158.462L247.031 160.041C247.159 160.202 247.131 160.437 246.969 160.564C246.898 160.618 246.815 160.645 246.732 160.643V160.645Z","fill":"#0F2C60"}}),_c('path',{attrs:{"d":"M253.24 173.501C253.337 173.501 253.436 173.465 253.509 173.39L254.629 172.255C254.734 172.148 254.766 171.989 254.708 171.851C254.651 171.714 254.515 171.623 254.366 171.621L245.61 171.553C245.404 171.553 245.236 171.716 245.234 171.922L245.23 172.298C245.228 172.504 245.394 172.671 245.6 172.673C245.806 172.675 245.974 172.51 245.976 172.304V172.3L253.476 172.358L252.975 172.867C252.829 173.015 252.831 173.249 252.979 173.394C253.052 173.465 253.145 173.501 253.238 173.501H253.24Z","fill":"#0F2C60"}}),_c('path',{attrs:{"d":"M254.36 172.364C254.443 172.364 254.528 172.338 254.596 172.284C254.758 172.154 254.782 171.92 254.655 171.761L253.632 170.482C253.503 170.321 253.268 170.297 253.106 170.424C252.945 170.553 252.92 170.787 253.048 170.947L254.071 172.225C254.143 172.316 254.251 172.364 254.358 172.364H254.36Z","fill":"#0F2C60"}}),_c('path',{attrs:{"d":"M225.627 147.616C221.567 150.94 220.973 156.923 224.301 160.978L239.004 148.941C235.676 144.886 229.686 144.293 225.627 147.616Z","fill":"#008E8A"}}),_c('path',{attrs:{"d":"M267.328 148.705C263.57 145.044 257.552 145.118 253.887 148.872L267.496 162.131C271.161 158.377 271.086 152.366 267.328 148.705Z","fill":"#008E8A"}}),_c('path',{attrs:{"d":"M267.078 151.778C267.078 151.778 267.585 156.943 269.047 156.259C270.508 155.572 267.801 149.018 267.078 151.778Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M272.326 144.389C271.95 144.19 271.559 144.026 271.161 143.905C270.979 143.848 270.807 144.018 270.864 144.2C270.886 144.274 270.945 144.333 271.02 144.357C272.882 144.929 274.434 146.383 275.041 148.38C275.647 150.377 275.164 152.448 273.935 153.955C273.884 154.015 273.87 154.098 273.892 154.173C273.947 154.355 274.183 154.399 274.303 154.252C274.566 153.928 274.8 153.577 275.002 153.202C275.823 151.667 275.997 149.906 275.491 148.242C274.986 146.578 273.862 145.209 272.326 144.389Z","fill":"white"}}),_c('path',{attrs:{"d":"M275.196 141.124C274.652 140.834 274.088 140.599 273.512 140.424C273.249 140.343 273.003 140.587 273.082 140.85C273.114 140.959 273.199 141.044 273.308 141.076C275.997 141.902 278.245 144.004 279.12 146.889C279.998 149.775 279.298 152.769 277.521 154.948C277.448 155.037 277.426 155.154 277.458 155.263C277.539 155.526 277.879 155.592 278.053 155.378C278.433 154.912 278.773 154.403 279.064 153.86C280.25 151.643 280.501 149.096 279.769 146.691C279.039 144.287 277.414 142.31 275.194 141.124H275.196Z","fill":"white"}}),_c('path',{attrs:{"d":"M278.712 138.368C278.057 138.019 277.38 137.738 276.686 137.524C276.371 137.427 276.072 137.72 276.169 138.037C276.209 138.168 276.31 138.269 276.442 138.309C279.676 139.301 282.379 141.831 283.432 145.302C284.488 148.773 283.647 152.376 281.51 154.997C281.423 155.102 281.397 155.245 281.435 155.374C281.532 155.691 281.94 155.77 282.151 155.514C282.61 154.952 283.016 154.34 283.366 153.688C284.793 151.021 285.094 147.96 284.215 145.066C283.335 142.172 281.382 139.794 278.712 138.368Z","fill":"white"}}),_c('path',{attrs:{"d":"M223.603 144.03C224.026 143.963 224.446 143.939 224.863 143.955C225.053 143.963 225.158 144.177 225.046 144.331C225 144.394 224.925 144.43 224.846 144.428C222.902 144.353 220.953 145.215 219.722 146.901C218.49 148.588 218.262 150.702 218.925 152.529C218.951 152.604 218.939 152.685 218.893 152.749C218.78 152.903 218.543 152.868 218.478 152.689C218.337 152.297 218.232 151.889 218.165 151.467C217.896 149.749 218.315 148.028 219.339 146.625C220.366 145.219 221.879 144.299 223.599 144.03H223.603Z","fill":"white"}}),_c('path',{attrs:{"d":"M221.972 140.002C222.58 139.907 223.191 139.872 223.793 139.895C224.068 139.905 224.222 140.216 224.058 140.438C223.991 140.529 223.882 140.581 223.769 140.577C220.957 140.47 218.143 141.716 216.362 144.151C214.583 146.586 214.253 149.644 215.211 152.287C215.25 152.394 215.234 152.513 215.167 152.604C215.005 152.826 214.662 152.775 214.569 152.517C214.364 151.95 214.211 151.36 214.116 150.752C213.728 148.268 214.332 145.783 215.814 143.753C217.298 141.724 219.485 140.391 221.97 140.004L221.972 140.002Z","fill":"white"}}),_c('path',{attrs:{"d":"M219.562 136.242C220.296 136.127 221.028 136.084 221.753 136.113C222.085 136.125 222.269 136.5 222.073 136.767C221.992 136.878 221.862 136.94 221.725 136.934C218.343 136.805 214.957 138.303 212.816 141.233C210.675 144.163 210.279 147.84 211.431 151.019C211.478 151.148 211.457 151.289 211.376 151.4C211.18 151.667 210.768 151.606 210.655 151.295C210.408 150.613 210.224 149.904 210.111 149.171C209.644 146.185 210.37 143.194 212.155 140.751C213.94 138.309 216.57 136.706 219.56 136.24L219.562 136.242Z","fill":"white"}}),_c('path',{attrs:{"d":"M246.914 145.918L245.628 145.867L245.477 149.67L246.764 149.721L246.914 145.918Z","fill":"#0F2C60"}}),_c('path',{attrs:{"d":"M248.157 144.986L244.317 144.835L244.259 146.304L248.099 146.455L248.157 144.986Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M256.458 103.15C255.965 103.15 255.498 103.251 255.071 103.433C254.4 101.504 252.569 100.115 250.409 100.115C249.748 100.115 249.118 100.246 248.542 100.483C247.903 96.6117 244.539 93.6595 240.483 93.6595C240.158 93.6595 239.839 93.6797 239.523 93.7181C237.732 89.5948 233.62 86.7092 228.833 86.7092C224.046 86.7092 219.934 89.5948 218.143 93.7181C217.827 93.6817 217.508 93.6595 217.182 93.6595C213.19 93.6595 209.868 96.5208 209.157 100.303C208.732 100.184 208.283 100.115 207.82 100.115C205.835 100.115 204.127 101.288 203.343 102.976C202.936 102.819 202.498 102.73 202.037 102.73C201.277 102.73 200.573 102.964 199.991 103.362C199.178 100.749 196.74 98.8511 193.855 98.8511C191.393 98.8511 189.256 100.236 188.179 102.268C187.366 101.696 186.377 101.359 185.308 101.359C183.622 101.359 182.136 102.195 181.228 103.469C180.62 103.007 179.862 102.73 179.039 102.73C177.036 102.73 175.41 104.354 175.41 106.355C175.41 106.462 175.416 106.569 175.426 106.674H180.321H182.652H187.59H190.293H198.424H200.118H203.163H205.649H210.616H212.478H220.702H223.749H233.913H236.96H245.748H247.046H252.922H255.061H259.982C259.982 104.727 258.401 103.148 256.452 103.148L256.458 103.15Z","fill":"white"}}),_c('path',{attrs:{"d":"M60.8198 175.048C60.7854 174.888 58.1694 159.588 59.3137 138.36C60.373 118.731 66.6561 90.0006 85.3114 66.563L87.0601 67.3061C55.2139 106.385 65.3037 174.563 65.336 174.719C64.4303 175.959 62.5199 175.407 60.8198 175.048Z","fill":"#A04724"}}),_c('path',{attrs:{"d":"M103.473 28.8311L97.158 37.8955C97.158 37.8955 95.3022 39.7714 93.1512 43.7453L97.0812 45.391L92.4234 45.1447C89.9752 50.0979 87.3775 57.6924 86.7852 68.2612C86.7852 68.2612 109.831 50.5906 103.473 28.8311Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M74.039 40.246L78.8463 41.4232L74.2068 41.8109C74.5484 44.3713 75.3914 48.2725 77.4272 53.0562L81.719 51.9335L78.0417 54.4474C79.8976 58.49 82.5903 63.0879 86.5183 68.0007C86.5183 68.0007 91.8998 39.4827 72.636 27.5004L73.9783 38.4629C73.9783 38.4629 73.946 39.093 74.0349 40.248L74.039 40.246Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M86.7569 68.4207C86.7569 68.4207 80.2858 56.7575 71.4736 54.1809C62.3299 51.5074 49.1511 60.5012 49.1511 60.5012C49.1511 60.5012 70.7923 59.229 86.7569 68.4187V68.4207Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M75.8403 75.8617C81.0055 72.2493 86.7893 67.5706 86.7893 67.5706C86.7893 67.5706 73.8268 65.3918 65.1359 71.1791C63.9331 71.9807 62.7909 72.7238 61.7093 73.4144L63.0173 75.2862L60.931 73.9091C54.6519 77.877 50.7361 79.8659 50.7361 79.8659C50.7361 79.8659 66.6036 81.6873 72.1691 78.2929C72.9535 77.8144 73.8106 77.255 74.7001 76.6513L72.7432 73.7233L75.8423 75.8638L75.8403 75.8617Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M85.2589 66.4277C85.2589 66.4277 95.5913 74.0908 89.86 86.3579C84.8424 97.0983 77.4393 97.5567 77.4393 97.5567C77.4393 97.5567 87.2239 77.3035 85.2569 66.4277H85.2589Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M87.327 67.3122C87.327 67.3122 96.5415 63.8027 103.348 61.0706C110.157 58.3385 126.544 59.0998 126.544 59.0998C126.544 59.0998 114.625 69.5697 104.213 70.0563C93.8002 70.541 87.327 67.3142 87.327 67.3142V67.3122Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M84.9779 67.3828C84.9779 67.3828 104.519 67.7968 111.515 86.9233L114.857 98.3382C114.857 98.3382 87.6868 68.9498 84.9799 67.3828H84.9779Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M108.756 196.898C114.558 184.924 124.177 165.214 124.177 165.214C123.516 162.967 124.656 160.604 125.93 158.635C127.201 156.667 128.695 154.663 128.824 152.323C129.057 148.143 125.022 145.12 123.17 141.367C120.849 136.662 122.254 130.654 125.82 126.804C127.29 125.215 129.209 123.692 129.364 121.535C129.516 119.423 126.708 116.237 124.801 115.312C119.766 112.873 113.683 115.114 108.214 113.927C105.22 113.279 102.445 111.352 99.1413 111.334C95.6763 111.314 93.5334 112.719 90.8305 114.884C88.1276 117.051 86.4254 120.417 86.288 123.876C86.195 126.206 86.753 128.678 85.7583 130.79C84.8526 132.714 82.8775 133.861 81.0157 134.889C77.8478 136.64 66.7553 142.873 63.1326 145.27C62.5544 145.736 61.9762 146.203 61.4102 146.669C57.2922 150.072 53.7038 153.914 52.5414 159.292C51.375 164.683 52.5556 170.404 55.0785 175.242C57.8501 180.561 63.7876 185.348 67.5376 187.644C78.4705 194.342 97.2996 196.781 97.2996 196.781C99.7781 197.163 105.578 197.009 108.76 196.9L108.756 196.898Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M75.1146 191.014C75.1146 191.014 75.1065 191.022 75.0944 191.032C75.339 191.032 75.5856 191.03 75.8302 191.028C75.438 191.002 75.1348 190.992 75.1146 191.014Z","fill":"#7DC6C2"}}),_c('path',{attrs:{"d":"M106.257 152.388L98.0496 152.184L91.4107 153.159C91.4107 153.159 78.8222 155.261 76.6894 161.456C73.8288 169.766 72.9818 179.458 72.6927 188.171C72.5006 193.952 71.8396 203.998 77.5991 207.57C79.2467 208.592 81.7818 209.06 83.7023 208.911C83.8661 208.897 84.0298 208.883 84.1936 208.865C85.4995 208.717 86.7934 208.386 88.0508 207.928C88.5218 207.756 88.9888 207.566 89.4477 207.362C90.2139 207.021 90.972 206.651 91.6917 206.229C92.7955 205.581 94.8191 204.19 97.9485 201.527C99.7538 199.99 102.74 197.276 103.007 197.032C103.019 197.02 103.344 197.028 103.751 197.018C106.085 196.995 108.39 196.913 109.739 196.864C114.75 196.678 119.287 196.464 123.516 196.174C126.722 192.408 128.802 187.796 132.593 178.529C132.593 178.529 122.946 153.02 106.257 152.388Z","fill":"#008E8A"}}),_c('g',{staticStyle:{"mix-blend-mode":"soft-light"},attrs:{"opacity":"0.6"}},[_c('path',{attrs:{"d":"M76.3195 191.505C76.3943 185.849 77.0432 180.1 77.9428 174.521C78.5392 170.816 79.1356 166.939 80.3607 163.377C82.4935 157.184 95.082 155.081 95.082 155.081L101.721 154.106L109.929 154.308C111.981 154.387 113.925 154.841 115.759 155.578C112.914 153.739 109.741 152.521 106.259 152.39L98.0517 152.186L91.4128 153.161C91.4128 153.161 78.8243 155.263 76.6915 161.458C73.8309 169.768 72.9839 179.46 72.6948 188.173C72.5027 193.954 71.8417 204 77.6012 207.572C78.2441 207.972 79.0244 208.285 79.8492 208.511C75.7595 204.64 76.2528 196.513 76.3195 191.505Z","fill":"white"}})]),_c('path',{attrs:{"d":"M119.194 122.789C119.194 122.789 121.264 125.636 118.011 134.81C118.011 134.81 119.505 139.937 115.753 144.397C111.78 149.122 110.109 151.731 106.259 149.995L107.001 154.93C107.001 154.93 105.188 159.138 98.7108 158.306C92.6298 157.524 91.4108 153.159 91.4108 153.159C91.4108 153.159 96.2727 150.003 96.5739 143.353C96.8751 136.704 96.9621 137.166 96.9621 137.166C96.9621 137.166 92.6338 132.122 95.3933 129.753C98.1528 127.387 100.275 131.304 100.275 131.304C100.275 131.304 102.218 121.357 119.196 122.789H119.194Z","fill":"#F4AF9F"}}),_c('path',{attrs:{"d":"M103.437 150.352C104.387 150.98 105.491 151.303 106.468 151.467L106.259 149.995C107.394 150.508 108.34 150.639 109.211 150.451C109.737 150.294 110.27 150.005 110.853 149.563C98.4601 146.288 103.817 130.881 107.466 126.951C111.061 123.078 118.909 123.266 119.432 123.282C119.305 122.941 119.194 122.787 119.194 122.787C105.143 121.604 101.391 128.211 100.514 130.525C100.334 131.008 100.273 131.303 100.273 131.303C100.273 131.303 98.1508 127.385 95.3913 129.752C95.3044 129.825 95.2255 129.901 95.1548 129.98C95.1325 130.004 95.1144 130.031 95.0941 130.053C95.0456 130.109 94.9991 130.164 94.9567 130.222C94.9364 130.251 94.9203 130.283 94.9001 130.311C94.8637 130.366 94.8253 130.42 94.7949 130.477C94.7788 130.507 94.7666 130.539 94.7505 130.572C94.7222 130.628 94.6918 130.687 94.6696 130.745C94.6575 130.778 94.6474 130.808 94.6373 130.84C94.615 130.901 94.5928 130.961 94.5766 131.022C94.5685 131.052 94.5625 131.085 94.5564 131.115C94.5422 131.179 94.5261 131.242 94.5139 131.307C94.5099 131.337 94.5079 131.367 94.5038 131.398C94.4957 131.464 94.4856 131.531 94.4816 131.599C94.4816 131.628 94.4816 131.658 94.4796 131.686C94.4775 131.757 94.4735 131.828 94.4755 131.898C94.4755 131.927 94.4796 131.955 94.4796 131.983C94.4836 132.056 94.4856 132.129 94.4937 132.203C94.4957 132.229 94.4998 132.256 94.5038 132.282C94.5119 132.359 94.522 132.433 94.5341 132.508C94.5382 132.532 94.5443 132.559 94.5483 132.583C94.5625 132.662 94.5766 132.738 94.5948 132.817C94.6009 132.841 94.6069 132.864 94.613 132.886C94.6332 132.965 94.6514 133.045 94.6757 133.126C94.6817 133.148 94.6898 133.168 94.6959 133.191C94.7201 133.271 94.7444 133.352 94.7727 133.435C94.7788 133.453 94.7868 133.473 94.7929 133.494C94.8212 133.576 94.8515 133.659 94.8839 133.74C94.89 133.758 94.898 133.776 94.9041 133.792C94.9364 133.875 94.9708 133.958 95.0072 134.041C95.0133 134.057 95.0214 134.073 95.0274 134.089C95.0638 134.172 95.1002 134.255 95.1406 134.338C95.1467 134.352 95.1548 134.366 95.1608 134.38C95.2013 134.463 95.2417 134.546 95.2821 134.626C95.2882 134.638 95.2963 134.651 95.3024 134.663C95.3448 134.745 95.3873 134.826 95.4317 134.907C95.4378 134.917 95.4439 134.929 95.4499 134.939C95.4944 135.02 95.5389 135.099 95.5834 135.176C95.5894 135.186 95.5955 135.196 95.6016 135.206C95.646 135.285 95.6925 135.359 95.737 135.436C95.741 135.444 95.7471 135.452 95.7532 135.462C95.7997 135.537 95.8462 135.612 95.8906 135.684C95.8967 135.693 95.9008 135.701 95.9068 135.709C95.9533 135.781 95.9978 135.85 96.0423 135.917C96.0463 135.925 96.0503 135.931 96.0564 135.939C96.1009 136.006 96.1454 136.072 96.1898 136.135C96.1939 136.141 96.1999 136.147 96.204 136.155C96.2464 136.218 96.2889 136.278 96.3293 136.335C96.3334 136.341 96.3374 136.347 96.3415 136.353C96.3819 136.409 96.4223 136.464 96.4607 136.516C96.4648 136.52 96.4688 136.526 96.4729 136.533C96.5113 136.585 96.5477 136.634 96.582 136.678C96.5861 136.684 96.5901 136.688 96.5942 136.692C96.6285 136.739 96.6609 136.779 96.6912 136.819C96.6952 136.825 96.6993 136.829 96.7033 136.835C96.7316 136.872 96.7579 136.906 96.7842 136.938C96.7903 136.944 96.7943 136.951 96.7983 136.957C96.8206 136.985 96.8408 137.009 96.859 137.033C96.8651 137.039 96.8691 137.045 96.8731 137.051C96.8893 137.07 96.9035 137.088 96.9156 137.102C96.9217 137.108 96.9277 137.116 96.9318 137.122C96.9378 137.132 96.9459 137.138 96.95 137.144C96.956 137.15 96.9621 137.159 96.9641 137.161C96.9641 137.161 96.9641 137.161 96.9621 137.163C96.9621 137.163 96.956 137.175 96.954 137.189C96.954 137.191 96.954 137.193 96.954 137.195C96.954 137.199 96.954 137.203 96.952 137.207C96.952 137.211 96.952 137.215 96.95 137.219C96.95 137.223 96.95 137.227 96.9479 137.233C96.9479 137.239 96.9459 137.247 96.9439 137.253C96.9439 137.259 96.9439 137.266 96.9419 137.27C96.9419 137.278 96.9399 137.288 96.9378 137.296C96.9378 137.302 96.9378 137.308 96.9338 137.316C96.9338 137.328 96.9318 137.342 96.9297 137.354C96.9297 137.36 96.9297 137.366 96.9297 137.373C96.9257 137.415 96.9196 137.467 96.9136 137.528C96.9136 137.536 96.9136 137.544 96.9116 137.552C96.9095 137.576 96.9075 137.601 96.9035 137.629C96.9035 137.639 96.9014 137.649 96.9014 137.661C96.8994 137.688 96.8974 137.716 96.8954 137.746C96.8954 137.76 96.8934 137.774 96.8913 137.789C96.8893 137.817 96.8873 137.847 96.8832 137.877C96.8832 137.894 96.8812 137.912 96.8792 137.93C96.8772 137.964 96.8731 138.003 96.8711 138.039C96.8711 138.053 96.8711 138.069 96.8691 138.083C96.861 138.196 96.8509 138.326 96.8428 138.467C96.8428 138.473 96.8428 138.479 96.8428 138.485C96.8388 138.55 96.8347 138.616 96.8287 138.687C96.8287 138.707 96.8266 138.729 96.8246 138.75C96.8206 138.808 96.8165 138.871 96.8125 138.933C96.8125 138.96 96.8084 138.986 96.8084 139.014C96.8044 139.075 96.8004 139.137 96.7963 139.202C96.7963 139.234 96.7923 139.267 96.7903 139.299C96.7862 139.37 96.7822 139.442 96.7781 139.519C96.7781 139.545 96.7741 139.572 96.7741 139.6C96.77 139.683 96.764 139.769 96.7599 139.86C96.7599 139.889 96.7579 139.913 96.7559 139.941C96.7498 140.058 96.7438 140.179 96.7357 140.307C96.7357 140.311 96.7357 140.313 96.7357 140.317C96.7296 140.438 96.7235 140.565 96.7155 140.696C96.7155 140.731 96.7114 140.769 96.7094 140.805C96.7033 140.906 96.6993 141.011 96.6932 141.118C96.6912 141.167 96.6892 141.217 96.6851 141.266C96.6811 141.365 96.675 141.468 96.671 141.571C96.669 141.627 96.6649 141.684 96.6629 141.742C96.6588 141.849 96.6528 141.958 96.6467 142.069C96.6447 142.124 96.6407 142.18 96.6386 142.237C96.6305 142.382 96.6245 142.536 96.6184 142.691C96.6184 142.714 96.6164 142.734 96.6144 142.756C96.6063 142.946 96.5962 143.144 96.5881 143.348C96.5032 145.217 96.0584 146.813 95.4621 148.135C95.3953 148.283 95.3286 148.426 95.2579 148.567C95.0497 148.989 94.8253 149.381 94.5948 149.743C93.1392 152.04 91.4249 153.151 91.4249 153.151C91.4249 153.151 92.644 157.517 98.7249 158.298C98.731 158.298 98.7371 158.298 98.7431 158.3C94.3603 156.255 103.451 150.342 103.451 150.342L103.437 150.352Z","fill":"#F4907D"}}),_c('g',{staticStyle:{"mix-blend-mode":"overlay"},attrs:{"opacity":"0.72"}},[_c('path',{attrs:{"d":"M119.194 122.789C119.194 122.789 121.264 125.636 118.011 134.81C118.011 134.81 119.505 139.937 115.753 144.397C111.78 149.122 110.109 151.731 106.259 149.995L107.001 154.93C107.001 154.93 105.188 159.138 98.7108 158.306C92.6298 157.524 91.4108 153.159 91.4108 153.159C91.4108 153.159 96.2727 150.003 96.5739 143.353C96.8751 136.704 96.9621 137.166 96.9621 137.166C96.9621 137.166 92.6338 132.122 95.3933 129.753C98.1528 127.387 100.275 131.304 100.275 131.304C100.275 131.304 102.218 121.357 119.196 122.789H119.194Z","fill":"url(#paint2_linear_1_4148)"}}),_c('path',{attrs:{"d":"M103.437 150.352C104.387 150.98 105.491 151.303 106.468 151.467L106.259 149.995C107.394 150.508 108.34 150.639 109.211 150.451C109.737 150.294 110.27 150.005 110.853 149.563C98.4601 146.288 103.817 130.881 107.466 126.951C111.061 123.078 118.909 123.266 119.432 123.282C119.305 122.941 119.194 122.787 119.194 122.787C105.143 121.604 101.391 128.211 100.514 130.525C100.334 131.008 100.273 131.303 100.273 131.303C100.273 131.303 98.1508 127.385 95.3913 129.752C95.3044 129.825 95.2255 129.901 95.1548 129.98C95.1325 130.004 95.1144 130.031 95.0941 130.053C95.0456 130.109 94.9991 130.164 94.9567 130.222C94.9364 130.251 94.9203 130.283 94.9001 130.311C94.8637 130.366 94.8253 130.42 94.7949 130.477C94.7788 130.507 94.7666 130.539 94.7505 130.572C94.7222 130.628 94.6918 130.687 94.6696 130.745C94.6575 130.778 94.6474 130.808 94.6373 130.84C94.615 130.901 94.5928 130.961 94.5766 131.022C94.5685 131.052 94.5625 131.085 94.5564 131.115C94.5422 131.179 94.5261 131.242 94.5139 131.307C94.5099 131.337 94.5079 131.367 94.5038 131.398C94.4957 131.464 94.4856 131.531 94.4816 131.599C94.4816 131.628 94.4816 131.658 94.4796 131.686C94.4775 131.757 94.4735 131.828 94.4755 131.898C94.4755 131.927 94.4796 131.955 94.4796 131.983C94.4836 132.056 94.4856 132.129 94.4937 132.203C94.4957 132.229 94.4998 132.256 94.5038 132.282C94.5119 132.359 94.522 132.433 94.5341 132.508C94.5382 132.532 94.5443 132.559 94.5483 132.583C94.5625 132.662 94.5766 132.738 94.5948 132.817C94.6009 132.841 94.6069 132.864 94.613 132.886C94.6332 132.965 94.6514 133.045 94.6757 133.126C94.6817 133.148 94.6898 133.168 94.6959 133.191C94.7201 133.271 94.7444 133.352 94.7727 133.435C94.7788 133.453 94.7868 133.473 94.7929 133.494C94.8212 133.576 94.8515 133.659 94.8839 133.74C94.89 133.758 94.898 133.776 94.9041 133.792C94.9364 133.875 94.9708 133.958 95.0072 134.041C95.0133 134.057 95.0214 134.073 95.0274 134.089C95.0638 134.172 95.1002 134.255 95.1406 134.338C95.1467 134.352 95.1548 134.366 95.1608 134.38C95.2013 134.463 95.2417 134.546 95.2821 134.626C95.2882 134.638 95.2963 134.651 95.3024 134.663C95.3448 134.745 95.3873 134.826 95.4317 134.907C95.4378 134.917 95.4439 134.929 95.4499 134.939C95.4944 135.02 95.5389 135.099 95.5834 135.176C95.5894 135.186 95.5955 135.196 95.6016 135.206C95.646 135.285 95.6925 135.359 95.737 135.436C95.741 135.444 95.7471 135.452 95.7532 135.462C95.7997 135.537 95.8462 135.612 95.8906 135.684C95.8967 135.693 95.9008 135.701 95.9068 135.709C95.9533 135.781 95.9978 135.85 96.0423 135.917C96.0463 135.925 96.0503 135.931 96.0564 135.939C96.1009 136.006 96.1454 136.072 96.1898 136.135C96.1939 136.141 96.1999 136.147 96.204 136.155C96.2464 136.218 96.2889 136.278 96.3293 136.335C96.3334 136.341 96.3374 136.347 96.3415 136.353C96.3819 136.409 96.4223 136.464 96.4607 136.516C96.4648 136.52 96.4688 136.526 96.4729 136.533C96.5113 136.585 96.5477 136.634 96.582 136.678C96.5861 136.684 96.5901 136.688 96.5942 136.692C96.6285 136.739 96.6609 136.779 96.6912 136.819C96.6952 136.825 96.6993 136.829 96.7033 136.835C96.7316 136.872 96.7579 136.906 96.7842 136.938C96.7903 136.944 96.7943 136.951 96.7983 136.957C96.8206 136.985 96.8408 137.009 96.859 137.033C96.8651 137.039 96.8691 137.045 96.8731 137.051C96.8893 137.07 96.9035 137.088 96.9156 137.102C96.9217 137.108 96.9277 137.116 96.9318 137.122C96.9378 137.132 96.9459 137.138 96.95 137.144C96.956 137.15 96.9621 137.159 96.9641 137.161C96.9641 137.161 96.9641 137.161 96.9621 137.163C96.9621 137.163 96.956 137.175 96.954 137.189C96.954 137.191 96.954 137.193 96.954 137.195C96.954 137.199 96.954 137.203 96.952 137.207C96.952 137.211 96.952 137.215 96.95 137.219C96.95 137.223 96.95 137.227 96.9479 137.233C96.9479 137.239 96.9459 137.247 96.9439 137.253C96.9439 137.259 96.9439 137.266 96.9419 137.27C96.9419 137.278 96.9399 137.288 96.9378 137.296C96.9378 137.302 96.9378 137.308 96.9338 137.316C96.9338 137.328 96.9318 137.342 96.9297 137.354C96.9297 137.36 96.9297 137.366 96.9297 137.373C96.9257 137.415 96.9196 137.467 96.9136 137.528C96.9136 137.536 96.9136 137.544 96.9116 137.552C96.9095 137.576 96.9075 137.601 96.9035 137.629C96.9035 137.639 96.9014 137.649 96.9014 137.661C96.8994 137.688 96.8974 137.716 96.8954 137.746C96.8954 137.76 96.8934 137.774 96.8913 137.789C96.8893 137.817 96.8873 137.847 96.8832 137.877C96.8832 137.894 96.8812 137.912 96.8792 137.93C96.8772 137.964 96.8731 138.003 96.8711 138.039C96.8711 138.053 96.8711 138.069 96.8691 138.083C96.861 138.196 96.8509 138.326 96.8428 138.467C96.8428 138.473 96.8428 138.479 96.8428 138.485C96.8388 138.55 96.8347 138.616 96.8287 138.687C96.8287 138.707 96.8266 138.729 96.8246 138.75C96.8206 138.808 96.8165 138.871 96.8125 138.933C96.8125 138.96 96.8084 138.986 96.8084 139.014C96.8044 139.075 96.8004 139.137 96.7963 139.202C96.7963 139.234 96.7923 139.267 96.7903 139.299C96.7862 139.37 96.7822 139.442 96.7781 139.519C96.7781 139.545 96.7741 139.572 96.7741 139.6C96.77 139.683 96.764 139.769 96.7599 139.86C96.7599 139.889 96.7579 139.913 96.7559 139.941C96.7498 140.058 96.7438 140.179 96.7357 140.307C96.7357 140.311 96.7357 140.313 96.7357 140.317C96.7296 140.438 96.7235 140.565 96.7155 140.696C96.7155 140.731 96.7114 140.769 96.7094 140.805C96.7033 140.906 96.6993 141.011 96.6932 141.118C96.6912 141.167 96.6892 141.217 96.6851 141.266C96.6811 141.365 96.675 141.468 96.671 141.571C96.669 141.627 96.6649 141.684 96.6629 141.742C96.6588 141.849 96.6528 141.958 96.6467 142.069C96.6447 142.124 96.6407 142.18 96.6386 142.237C96.6305 142.382 96.6245 142.536 96.6184 142.691C96.6184 142.714 96.6164 142.734 96.6144 142.756C96.6063 142.946 96.5962 143.144 96.5881 143.348C96.5032 145.217 96.0584 146.813 95.4621 148.135C95.3953 148.283 95.3286 148.426 95.2579 148.567C95.0497 148.989 94.8253 149.381 94.5948 149.743C93.1392 152.04 91.4249 153.151 91.4249 153.151C91.4249 153.151 92.644 157.517 98.7249 158.298C98.731 158.298 98.7371 158.298 98.7431 158.3C94.3603 156.255 103.451 150.342 103.451 150.342L103.437 150.352Z","fill":"url(#paint3_linear_1_4148)"}})]),_c('g',{staticStyle:{"mix-blend-mode":"soft-light"}},[_c('path',{attrs:{"d":"M107.745 181.675L89.3224 191.188L91.1782 171.232L87.6708 194.251L108.598 183.442L107.745 181.675Z","fill":"#4A4A4A"}})]),_c('g',{staticStyle:{"mix-blend-mode":"soft-light"}},[_c('path',{attrs:{"d":"M103.753 197.018C106.088 196.995 108.392 196.913 109.741 196.864C114.752 196.678 122.293 196.23 126.52 195.939C128.873 191.507 130.23 188.179 132.445 179.351C132.253 179.24 119.404 181.033 119.404 181.033C119.404 181.033 117.835 182.138 113.173 186.919C108.511 191.701 103.009 197.032 103.009 197.032C103.021 197.02 103.346 197.028 103.753 197.018Z","fill":"#4A4A4A"}})]),_c('path',{attrs:{"d":"M126.623 177.848C126.623 177.848 127.953 180.821 131.406 181.471C134.859 182.119 141.91 178.979 141.809 177.261C141.708 175.542 138.108 171.651 138.108 171.651C138.108 171.651 126.342 171.871 126.621 177.848H126.623Z","fill":"#F4AF9F"}}),_c('path',{attrs:{"d":"M141.809 177.259C141.708 175.541 138.108 171.65 138.108 171.65C138.108 171.65 135.393 171.7 132.601 172.417C132.548 172.431 132.496 172.443 132.443 172.457C131.004 173.309 128.736 174.737 128.529 174.973C128.384 175.141 127.531 176.621 126.72 178.047C126.74 178.085 126.764 178.129 126.791 178.174C126.795 178.182 126.801 178.19 126.805 178.2C126.833 178.246 126.864 178.297 126.898 178.349C126.904 178.362 126.912 178.372 126.92 178.384C126.956 178.44 126.995 178.499 127.037 178.563C127.041 178.57 127.045 178.576 127.049 178.58C127.09 178.64 127.134 178.703 127.181 178.765C127.189 178.778 127.197 178.79 127.207 178.802C127.256 178.868 127.31 178.937 127.367 179.008C127.379 179.022 127.391 179.038 127.403 179.052C127.462 179.125 127.523 179.198 127.589 179.272C127.597 179.282 127.607 179.292 127.616 179.303C127.678 179.373 127.745 179.446 127.814 179.517C127.824 179.529 127.836 179.541 127.848 179.551C127.923 179.628 128 179.702 128.083 179.779C128.099 179.795 128.117 179.811 128.135 179.828C128.218 179.904 128.305 179.981 128.396 180.056C128.41 180.068 128.424 180.08 128.438 180.09C128.527 180.163 128.618 180.233 128.713 180.304C128.725 180.312 128.738 180.322 128.748 180.33C128.849 180.403 128.954 180.476 129.063 180.544C129.085 180.559 129.107 180.573 129.132 180.587C129.241 180.655 129.354 180.722 129.473 180.785C129.494 180.797 129.514 180.807 129.536 180.819C129.653 180.882 129.777 180.942 129.902 180.999C129.91 181.003 129.92 181.009 129.928 181.011C130.06 181.069 130.195 181.124 130.335 181.174C130.361 181.184 130.389 181.195 130.415 181.205C130.553 181.253 130.696 181.298 130.842 181.338C130.868 181.346 130.897 181.352 130.925 181.36C131.079 181.401 131.238 181.439 131.402 181.469H131.404C131.946 181.57 132.944 181.536 133.688 181.463C133.761 181.453 133.836 181.441 133.909 181.429C135.19 178.588 139.331 177.994 141.579 177.887C141.732 177.665 141.817 177.453 141.805 177.259H141.809Z","fill":"#E07146"}}),_c('g',{staticStyle:{"mix-blend-mode":"overlay"},attrs:{"opacity":"0.72"}},[_c('path',{attrs:{"d":"M126.623 177.848C126.623 177.848 127.953 180.821 131.406 181.471C134.859 182.119 141.91 178.979 141.809 177.261C141.708 175.542 138.108 171.651 138.108 171.651C138.108 171.651 126.342 171.871 126.621 177.848H126.623Z","fill":"url(#paint4_linear_1_4148)"}}),_c('path',{attrs:{"d":"M141.809 177.259C141.708 175.541 138.108 171.65 138.108 171.65C138.108 171.65 135.393 171.7 132.601 172.417C132.548 172.431 132.496 172.443 132.443 172.457C131.004 173.309 128.736 174.737 128.529 174.973C128.384 175.141 127.531 176.621 126.72 178.047C126.74 178.085 126.764 178.129 126.791 178.174C126.795 178.182 126.801 178.19 126.805 178.2C126.833 178.246 126.864 178.297 126.898 178.349C126.904 178.362 126.912 178.372 126.92 178.384C126.956 178.44 126.995 178.499 127.037 178.563C127.041 178.57 127.045 178.576 127.049 178.58C127.09 178.64 127.134 178.703 127.181 178.765C127.189 178.778 127.197 178.79 127.207 178.802C127.256 178.868 127.31 178.937 127.367 179.008C127.379 179.022 127.391 179.038 127.403 179.052C127.462 179.125 127.523 179.198 127.589 179.272C127.597 179.282 127.607 179.292 127.616 179.303C127.678 179.373 127.745 179.446 127.814 179.517C127.824 179.529 127.836 179.541 127.848 179.551C127.923 179.628 128 179.702 128.083 179.779C128.099 179.795 128.117 179.811 128.135 179.828C128.218 179.904 128.305 179.981 128.396 180.056C128.41 180.068 128.424 180.08 128.438 180.09C128.527 180.163 128.618 180.233 128.713 180.304C128.725 180.312 128.738 180.322 128.748 180.33C128.849 180.403 128.954 180.476 129.063 180.544C129.085 180.559 129.107 180.573 129.132 180.587C129.241 180.655 129.354 180.722 129.473 180.785C129.494 180.797 129.514 180.807 129.536 180.819C129.653 180.882 129.777 180.942 129.902 180.999C129.91 181.003 129.92 181.009 129.928 181.011C130.06 181.069 130.195 181.124 130.335 181.174C130.361 181.184 130.389 181.195 130.415 181.205C130.553 181.253 130.696 181.298 130.842 181.338C130.868 181.346 130.897 181.352 130.925 181.36C131.079 181.401 131.238 181.439 131.402 181.469H131.404C131.946 181.57 132.944 181.536 133.688 181.463C133.761 181.453 133.836 181.441 133.909 181.429C135.19 178.588 139.331 177.994 141.579 177.887C141.732 177.665 141.817 177.453 141.805 177.259H141.809Z","fill":"url(#paint5_linear_1_4148)"}}),_c('path',{attrs:{"d":"M141.809 177.259C141.708 175.541 138.108 171.65 138.108 171.65C138.108 171.65 135.393 171.7 132.601 172.417C132.548 172.431 132.496 172.443 132.443 172.457C131.004 173.309 128.736 174.737 128.529 174.973C128.384 175.141 127.531 176.621 126.72 178.047C126.74 178.085 126.764 178.129 126.791 178.174C126.795 178.182 126.801 178.19 126.805 178.2C126.833 178.246 126.864 178.297 126.898 178.349C126.904 178.362 126.912 178.372 126.92 178.384C126.956 178.44 126.995 178.499 127.037 178.563C127.041 178.57 127.045 178.576 127.049 178.58C127.09 178.64 127.134 178.703 127.181 178.765C127.189 178.778 127.197 178.79 127.207 178.802C127.256 178.868 127.31 178.937 127.367 179.008C127.379 179.022 127.391 179.038 127.403 179.052C127.462 179.125 127.523 179.198 127.589 179.272C127.597 179.282 127.607 179.292 127.616 179.303C127.678 179.373 127.745 179.446 127.814 179.517C127.824 179.529 127.836 179.541 127.848 179.551C127.923 179.628 128 179.702 128.083 179.779C128.099 179.795 128.117 179.811 128.135 179.828C128.218 179.904 128.305 179.981 128.396 180.056C128.41 180.068 128.424 180.08 128.438 180.09C128.527 180.163 128.618 180.233 128.713 180.304C128.725 180.312 128.738 180.322 128.748 180.33C128.849 180.403 128.954 180.476 129.063 180.544C129.085 180.559 129.107 180.573 129.132 180.587C129.241 180.655 129.354 180.722 129.473 180.785C129.494 180.797 129.514 180.807 129.536 180.819C129.653 180.882 129.777 180.942 129.902 180.999C129.91 181.003 129.92 181.009 129.928 181.011C130.06 181.069 130.195 181.124 130.335 181.174C130.361 181.184 130.389 181.195 130.415 181.205C130.553 181.253 130.696 181.298 130.842 181.338C130.868 181.346 130.897 181.352 130.925 181.36C131.079 181.401 131.238 181.439 131.402 181.469H131.404C131.946 181.57 132.944 181.536 133.688 181.463C133.761 181.453 133.836 181.441 133.909 181.429C135.19 178.588 139.331 177.994 141.579 177.887C141.732 177.665 141.817 177.453 141.805 177.259H141.809Z","fill":"url(#paint6_linear_1_4148)"}})]),_c('path',{attrs:{"d":"M126.623 177.848C126.623 177.848 127.953 180.821 131.406 181.471C134.859 182.119 141.91 178.979 141.809 177.261C141.708 175.542 138.108 171.651 138.108 171.651C138.108 171.651 126.342 171.871 126.621 177.848H126.623Z","fill":"#FFD6BF"}}),_c('path',{attrs:{"d":"M141.809 177.259C141.708 175.541 138.108 171.65 138.108 171.65C138.108 171.65 135.393 171.7 132.601 172.417C132.548 172.431 132.496 172.443 132.443 172.457C131.004 173.309 128.736 174.737 128.529 174.973C128.384 175.141 127.531 176.621 126.72 178.047C126.74 178.085 126.764 178.129 126.791 178.174C126.795 178.182 126.801 178.19 126.805 178.2C126.833 178.246 126.864 178.297 126.898 178.349C126.904 178.362 126.912 178.372 126.92 178.384C126.956 178.44 126.995 178.499 127.037 178.563C127.041 178.57 127.045 178.576 127.049 178.58C127.09 178.64 127.134 178.703 127.181 178.765C127.189 178.778 127.197 178.79 127.207 178.802C127.256 178.868 127.31 178.937 127.367 179.008C127.379 179.022 127.391 179.038 127.403 179.052C127.462 179.125 127.523 179.198 127.589 179.272C127.597 179.282 127.607 179.292 127.616 179.303C127.678 179.373 127.745 179.446 127.814 179.517C127.824 179.529 127.836 179.541 127.848 179.551C127.923 179.628 128 179.702 128.083 179.779C128.099 179.795 128.117 179.811 128.135 179.828C128.218 179.904 128.305 179.981 128.396 180.056C128.41 180.068 128.424 180.08 128.438 180.09C128.527 180.163 128.618 180.233 128.713 180.304C128.725 180.312 128.738 180.322 128.748 180.33C128.849 180.403 128.954 180.476 129.063 180.544C129.085 180.559 129.107 180.573 129.132 180.587C129.241 180.655 129.354 180.722 129.473 180.785C129.494 180.797 129.514 180.807 129.536 180.819C129.653 180.882 129.777 180.942 129.902 180.999C129.91 181.003 129.92 181.009 129.928 181.011C130.06 181.069 130.195 181.124 130.335 181.174C130.361 181.184 130.389 181.195 130.415 181.205C130.553 181.253 130.696 181.298 130.842 181.338C130.868 181.346 130.897 181.352 130.925 181.36C131.079 181.401 131.238 181.439 131.402 181.469H131.404C131.946 181.57 132.944 181.536 133.688 181.463C133.761 181.453 133.836 181.441 133.909 181.429C135.19 178.588 139.331 177.994 141.579 177.887C141.732 177.665 141.817 177.453 141.805 177.259H141.809Z","fill":"#FFD6BF"}}),_c('path',{attrs:{"d":"M141.809 177.259C141.708 175.541 138.108 171.65 138.108 171.65C138.108 171.65 135.393 171.7 132.601 172.417C132.548 172.431 132.496 172.443 132.443 172.457C131.004 173.309 128.736 174.737 128.529 174.973C128.384 175.141 127.531 176.621 126.72 178.047C126.74 178.085 126.764 178.129 126.791 178.174C126.795 178.182 126.801 178.19 126.805 178.2C126.833 178.246 126.864 178.297 126.898 178.349C126.904 178.362 126.912 178.372 126.92 178.384C126.956 178.44 126.995 178.499 127.037 178.563C127.041 178.57 127.045 178.576 127.049 178.58C127.09 178.64 127.134 178.703 127.181 178.765C127.189 178.778 127.197 178.79 127.207 178.802C127.256 178.868 127.31 178.937 127.367 179.008C127.379 179.022 127.391 179.038 127.403 179.052C127.462 179.125 127.523 179.198 127.589 179.272C127.597 179.282 127.607 179.292 127.616 179.303C127.678 179.373 127.745 179.446 127.814 179.517C127.824 179.529 127.836 179.541 127.848 179.551C127.923 179.628 128 179.702 128.083 179.779C128.099 179.795 128.117 179.811 128.135 179.828C128.218 179.904 128.305 179.981 128.396 180.056C128.41 180.068 128.424 180.08 128.438 180.09C128.527 180.163 128.618 180.233 128.713 180.304C128.725 180.312 128.738 180.322 128.748 180.33C128.849 180.403 128.954 180.476 129.063 180.544C129.085 180.559 129.107 180.573 129.132 180.587C129.241 180.655 129.354 180.722 129.473 180.785C129.494 180.797 129.514 180.807 129.536 180.819C129.653 180.882 129.777 180.942 129.902 180.999C129.91 181.003 129.92 181.009 129.928 181.011C130.06 181.069 130.195 181.124 130.335 181.174C130.361 181.184 130.389 181.195 130.415 181.205C130.553 181.253 130.696 181.298 130.842 181.338C130.868 181.346 130.897 181.352 130.925 181.36C131.079 181.401 131.238 181.439 131.402 181.469H131.404C131.946 181.57 132.944 181.536 133.688 181.463C133.761 181.453 133.836 181.441 133.909 181.429C135.19 178.588 139.331 177.994 141.579 177.887C141.732 177.665 141.817 177.453 141.805 177.259H141.809Z","fill":"#FFD6BF"}}),_c('path',{attrs:{"d":"M127.832 158.678C127.652 158.219 126.453 148.856 124.413 148.652C122.374 148.448 117.077 150.054 117.125 150.986C117.174 151.919 125.068 159.526 125.068 159.526L127.832 158.678Z","fill":"#008E8A"}}),_c('path',{staticStyle:{"mix-blend-mode":"multiply"},attrs:{"d":"M123.564 157.856C119.725 148.25 117.125 150.986 117.125 150.986C117.16 151.637 121.001 155.524 123.328 157.826C123.475 157.846 123.564 157.858 123.564 157.858V157.856Z","fill":"url(#paint7_linear_1_4148)"}}),_c('path',{staticStyle:{"mix-blend-mode":"multiply"},attrs:{"d":"M125.891 150.5L125.262 158.1C125.262 158.1 126.457 158.274 126.554 158.052C126.595 157.957 126.868 156.646 127.169 155.154C126.849 153.583 126.421 151.804 125.893 150.502L125.891 150.5Z","fill":"url(#paint8_linear_1_4148)"}}),_c('path',{attrs:{"d":"M126.188 157.608C126.352 157.016 126.603 145.264 129.099 144.743C131.598 144.222 138.368 145.514 138.429 146.675C138.49 147.836 129.72 158.294 129.72 158.294L126.186 157.608H126.188Z","fill":"#008E8A"}}),_c('path',{staticStyle:{"mix-blend-mode":"multiply"},attrs:{"d":"M129.823 157.622L130.302 157.595C132.259 155.237 138.482 147.655 138.431 146.675C138.431 146.675 135.11 142.726 129.823 157.622Z","fill":"url(#paint9_linear_1_4148)"}}),_c('path',{attrs:{"d":"M140.554 177.029L113.353 178.469C113.078 178.483 112.84 178.244 112.823 177.938L112.078 163.894C112.061 163.587 112.274 163.324 112.547 163.31L139.747 161.87C140.022 161.856 140.259 162.094 140.275 162.401L141.021 176.445C141.037 176.752 140.827 177.015 140.552 177.029H140.554Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M130.644 163.978L122.829 164.391L123.547 177.937L131.361 177.524L130.644 163.978Z","fill":"#008E8A"}}),_c('g',{staticStyle:{"mix-blend-mode":"soft-light"},attrs:{"opacity":"0.7"}},[_c('path',{attrs:{"d":"M140.234 163.461L113.034 164.901C112.759 164.915 112.547 165.152 112.561 165.426L112.631 166.763L140.831 165.271L140.76 163.934C140.746 163.661 140.509 163.447 140.234 163.461Z","fill":"black"}})]),_c('path',{attrs:{"d":"M185.14 96.5854L158.437 116.72C156.559 118.135 154.901 121.281 154.689 123.623L153.181 140.928C152.968 143.271 154.687 145.547 157.002 145.983L174.023 149.207C176.336 149.646 179.767 148.844 181.645 147.428L208.348 127.294C212.106 124.461 212.858 119.072 210.022 115.32L197.128 98.2594C194.292 94.5056 188.898 93.7524 185.14 96.5875V96.5854Z","fill":"#008E8A"}}),_c('path',{attrs:{"d":"M175.815 147.178C175.295 147.206 174.812 147.182 174.42 147.107L157.398 143.883C156.173 143.65 155.198 142.36 155.311 141.122L156.818 123.809C156.979 122.02 158.366 119.452 159.725 118.426L186.428 98.2917C187.447 97.5244 188.66 97.0822 189.937 97.0155C192.086 96.9025 194.138 97.8475 195.42 99.5477L208.314 116.606C210.447 119.427 209.882 123.458 207.056 125.588L180.353 145.722C179.332 146.492 177.464 147.091 175.812 147.178H175.815Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M179.191 119.603C181.251 122.329 180.63 125.744 177.972 127.749C175.313 129.754 171.852 129.415 169.792 126.689C167.75 123.987 168.373 120.57 171.031 118.565C173.69 116.56 177.151 116.899 179.191 119.601V119.603ZM176.67 121.503C175.683 120.199 174.017 120.088 172.871 120.954C171.678 121.852 171.351 123.466 172.337 124.77C173.324 126.075 174.967 126.204 176.16 125.305C177.306 124.441 177.656 122.81 176.67 121.503ZM182.783 134.687L181.424 111.27L183.923 109.386L185.282 132.803L182.783 134.687ZM197.148 117.172C199.208 119.898 198.588 123.314 195.927 125.318C193.269 127.323 189.81 126.981 187.75 124.257C185.71 121.556 186.331 118.139 188.989 116.136C191.648 114.131 195.107 114.468 197.148 117.172ZM194.628 119.074C193.657 117.792 191.991 117.683 190.825 118.563C189.654 119.446 189.327 121.057 190.295 122.339C191.3 123.668 192.944 123.795 194.112 122.913C195.281 122.032 195.632 120.401 194.63 119.072L194.628 119.074Z","fill":"white"}}),_c('g',{staticStyle:{"mix-blend-mode":"soft-light"}},[_c('path',{attrs:{"d":"M164.597 136.179C166.066 138.124 165.678 140.886 163.733 142.352C161.789 143.818 159.021 143.434 157.551 141.492C156.084 139.549 156.47 136.783 158.415 135.317C160.359 133.851 163.127 134.237 164.597 136.179Z","fill":"white"}})]),_c('path',{attrs:{"d":"M163.463 137.033C164.459 138.35 164.196 140.226 162.878 141.219C161.558 142.215 159.682 141.952 158.685 140.636C157.689 139.317 157.952 137.443 159.272 136.448C160.59 135.454 162.466 135.715 163.463 137.033Z","fill":"#DCFAF5"}}),_c('path',{attrs:{"d":"M140.453 158.765L141.003 157.805C141.029 157.761 143.653 153.224 151.844 143.006C155.19 138.832 157.78 136.983 159.533 137.51C161.144 137.992 161.368 140.222 161.376 140.317L160.737 140.377C160.735 140.357 160.543 138.481 159.345 138.124C158.33 137.819 156.288 138.489 152.344 143.408C146.386 150.839 143.388 155.245 142.197 157.097C145.402 155.304 154.943 149.706 158.778 144.571L159.292 144.955C154.586 151.257 141.963 157.967 141.427 158.248L140.449 158.763L140.453 158.765Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M110.482 158.511L142.078 156.84C142.162 156.836 142.235 156.901 142.239 156.986L142.606 163.906C142.61 163.991 142.545 164.063 142.461 164.067L110.865 165.738C110.78 165.742 110.708 165.678 110.703 165.593L110.336 158.672C110.332 158.588 110.397 158.516 110.482 158.511Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M130.992 157.427L121.787 157.913L122.169 165.138L131.375 164.651L130.992 157.427Z","fill":"#008E8A"}}),_c('path',{attrs:{"d":"M107.745 181.675L111.729 178.069C111.729 178.069 110.229 172.358 112.756 168.732C112.756 168.732 114.155 175.745 115.445 176.675C117.531 178.178 122.151 178.059 130.959 175.351C133.874 174.456 136.692 175.539 135.902 176.577C132.701 180.781 131.048 182.22 126.313 182.965C120.066 183.947 118.16 182.093 117.151 183.214C116.142 184.335 113.171 186.917 113.171 186.917C113.171 186.917 110.882 186.221 109.655 185.074C108.103 183.62 107.745 181.675 107.745 181.675Z","fill":"#F4AF9F"}}),_c('path',{attrs:{"d":"M109.627 185.047C109.637 185.055 109.646 185.065 109.656 185.075C109.745 185.158 109.838 185.237 109.937 185.313C109.967 185.338 109.999 185.362 110.032 185.386C110.1 185.439 110.171 185.491 110.244 185.542C110.28 185.568 110.317 185.592 110.353 185.616C110.428 185.665 110.505 185.713 110.582 185.762C110.614 185.782 110.646 185.802 110.681 185.822C110.788 185.885 110.895 185.947 111.004 186.006C111.006 186.006 111.01 186.01 111.012 186.01C114.685 182.186 116.669 182.385 117.572 182.927C117.633 182.904 117.696 182.888 117.76 182.874C117.77 182.874 117.78 182.87 117.789 182.868C117.855 182.856 117.926 182.848 117.999 182.844C118.076 182.84 118.156 182.84 118.243 182.844C118.247 182.844 118.249 182.844 118.253 182.844C118.34 182.848 118.431 182.854 118.526 182.864C122.661 179.094 131.568 176.39 136.035 176.188C135.985 175.298 133.508 174.567 130.957 175.35C122.149 178.056 117.53 178.177 115.443 176.675C115.241 176.53 115.037 176.237 114.837 175.843C114.756 175.686 114.677 175.514 114.596 175.328C114.518 175.142 114.439 174.944 114.362 174.739C114.247 174.428 114.133 174.094 114.024 173.753C113.952 173.525 113.881 173.293 113.812 173.059C113.743 172.824 113.677 172.588 113.614 172.356C113.519 172.004 113.428 171.659 113.345 171.328C113.288 171.108 113.238 170.894 113.187 170.688C113.163 170.585 113.139 170.486 113.117 170.389C113.072 170.195 113.03 170.013 112.991 169.844C112.957 169.688 112.925 169.545 112.896 169.418C112.803 168.994 112.753 168.733 112.753 168.733C112.328 169.343 112.019 170.011 111.796 170.702C111.744 170.868 111.693 171.035 111.649 171.205C111.562 171.534 111.493 171.865 111.441 172.194C111.402 172.429 111.372 172.663 111.35 172.897C111.336 173.04 111.325 173.182 111.315 173.323C111.299 173.563 111.289 173.804 111.285 174.038C111.281 174.286 111.285 174.531 111.291 174.767C111.303 175.118 111.325 175.453 111.354 175.766C111.364 175.871 111.374 175.974 111.384 176.073C111.461 176.77 111.564 177.333 111.637 177.683C111.689 177.931 111.726 178.07 111.726 178.07L107.739 181.677C107.739 181.677 107.879 182.436 108.362 183.361C108.507 183.637 108.683 183.93 108.895 184.221C108.982 184.338 109.075 184.455 109.174 184.572C109.31 184.734 109.46 184.891 109.621 185.047H109.627Z","fill":"#F4907D"}}),_c('g',{staticStyle:{"mix-blend-mode":"overlay"},attrs:{"opacity":"0.72"}},[_c('path',{attrs:{"d":"M107.745 181.675L111.729 178.069C111.729 178.069 110.229 172.358 112.756 168.732C112.756 168.732 114.155 175.745 115.445 176.675C117.531 178.178 122.151 178.059 130.959 175.351C133.874 174.456 136.692 175.539 135.902 176.577C132.701 180.781 131.048 182.22 126.313 182.965C120.066 183.947 118.16 182.093 117.151 183.214C116.142 184.335 113.171 186.917 113.171 186.917C113.171 186.917 110.882 186.221 109.655 185.074C108.103 183.62 107.745 181.675 107.745 181.675Z","fill":"url(#paint10_linear_1_4148)"}}),_c('path',{attrs:{"d":"M109.627 185.047C109.637 185.055 109.646 185.065 109.656 185.075C109.745 185.158 109.838 185.237 109.937 185.313C109.967 185.338 109.999 185.362 110.032 185.386C110.1 185.439 110.171 185.491 110.244 185.542C110.28 185.568 110.317 185.592 110.353 185.616C110.428 185.665 110.505 185.713 110.582 185.762C110.614 185.782 110.646 185.802 110.681 185.822C110.788 185.885 110.895 185.947 111.004 186.006C111.006 186.006 111.01 186.01 111.012 186.01C114.685 182.186 116.669 182.385 117.572 182.927C117.633 182.904 117.696 182.888 117.76 182.874C117.77 182.874 117.78 182.87 117.789 182.868C117.855 182.856 117.926 182.848 117.999 182.844C118.076 182.84 118.156 182.84 118.243 182.844C118.247 182.844 118.249 182.844 118.253 182.844C118.34 182.848 118.431 182.854 118.526 182.864C122.661 179.094 131.568 176.39 136.035 176.188C135.985 175.298 133.508 174.567 130.957 175.35C122.149 178.056 117.53 178.177 115.443 176.675C115.241 176.53 115.037 176.237 114.837 175.843C114.756 175.686 114.677 175.514 114.596 175.328C114.518 175.142 114.439 174.944 114.362 174.739C114.247 174.428 114.133 174.094 114.024 173.753C113.952 173.525 113.881 173.293 113.812 173.059C113.743 172.824 113.677 172.588 113.614 172.356C113.519 172.004 113.428 171.659 113.345 171.328C113.288 171.108 113.238 170.894 113.187 170.688C113.163 170.585 113.139 170.486 113.117 170.389C113.072 170.195 113.03 170.013 112.991 169.844C112.957 169.688 112.925 169.545 112.896 169.418C112.803 168.994 112.753 168.733 112.753 168.733C112.328 169.343 112.019 170.011 111.796 170.702C111.744 170.868 111.693 171.035 111.649 171.205C111.562 171.534 111.493 171.865 111.441 172.194C111.402 172.429 111.372 172.663 111.35 172.897C111.336 173.04 111.325 173.182 111.315 173.323C111.299 173.563 111.289 173.804 111.285 174.038C111.281 174.286 111.285 174.531 111.291 174.767C111.303 175.118 111.325 175.453 111.354 175.766C111.364 175.871 111.374 175.974 111.384 176.073C111.461 176.77 111.564 177.333 111.637 177.683C111.689 177.931 111.726 178.07 111.726 178.07L107.739 181.677C107.739 181.677 107.879 182.436 108.362 183.361C108.507 183.637 108.683 183.93 108.895 184.221C108.982 184.338 109.075 184.455 109.174 184.572C109.31 184.734 109.46 184.891 109.621 185.047H109.627Z","fill":"url(#paint11_linear_1_4148)"}})]),_c('path',{attrs:{"d":"M205.083 188.286C205.083 188.286 206.983 186.917 206.068 183.662C205.152 180.407 208.198 180.71 207.143 177.665C206.088 174.62 206.616 172.708 206.616 172.708C206.616 172.708 202.061 177.584 202.346 181.776C202.633 185.968 201.418 184.399 201.341 187.668C201.264 190.938 201.923 192.434 201.923 192.434L202.043 193.571C202.043 193.571 204.177 188.735 205.083 188.284V188.286Z","fill":"#1B896C"}}),_c('path',{attrs:{"d":"M202.085 192.494C202.085 192.494 202.217 188.129 200.638 186.091C199.059 184.054 200.423 180.892 197.537 179.111C194.65 177.33 195.594 175.698 193.821 174.511C193.821 174.511 194.114 175.989 194.245 179.399C194.377 182.808 196.031 183.385 195.416 185.314C194.801 187.242 201.833 194.035 201.833 194.035L202.085 192.494Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M202.097 194.148C202.097 194.148 204.093 189.144 206.054 188.078C208.015 187.014 211.102 184.777 213.194 183.686C214.775 182.863 218.224 184.106 219.811 184.763C220.003 184.841 219.948 185.128 219.74 185.132C218.133 185.164 214.872 185.324 214.207 186.063C213.317 187.052 211.666 189.684 210.25 191.454C208.835 193.225 201.679 195.089 201.679 195.089L202.095 194.148H202.097Z","fill":"#1B896C"}}),_c('path',{attrs:{"d":"M203.052 193.795C203.052 193.795 206.783 191.008 208.831 193.664C210.25 195.503 211.94 192.914 214.833 195.869C217.726 198.823 218.351 199.241 218.351 199.241C218.351 199.241 213.174 201.89 209.262 199.952C205.348 198.013 205.291 201.044 201.786 198.986C200.094 197.993 197.622 195.477 201.184 193.87C201.499 193.726 202.637 193.922 203.052 193.795Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M201.651 192.805C201.651 192.805 200.244 188.444 197.579 186.861C194.913 185.278 193.423 182.62 190.566 182.822C187.71 183.024 186.339 183.717 185.292 184.827C185.292 184.827 189.798 183.818 191.348 185.861C192.899 187.905 195.622 190.079 195.622 190.079C195.622 190.079 199.225 193.044 200.708 193.835C202.192 194.627 201.651 192.805 201.651 192.805Z","fill":"#1B896C"}}),_c('path',{attrs:{"d":"M202.291 193.688C202.291 193.688 199.012 189.213 195.384 188.838C191.753 188.462 189.307 188.193 189.307 188.193C189.307 188.193 184.253 189.601 183.499 191.321C182.745 193.042 182.005 194.827 182.005 194.827C182.005 194.827 187.366 191.174 188.577 191.412C189.786 191.65 191.882 192.454 193.712 192.026C195.541 191.596 200.357 193.936 200.357 193.936L202.291 193.692V193.688Z","fill":"#39B54A"}}),_c('path',{attrs:{"d":"M197.413 192.739C197.413 192.739 200.179 191.772 201.311 193.536C201.816 194.324 199.692 196.327 197.729 196.775C195.766 197.224 195.624 198.336 195.624 198.336C195.624 198.336 194.098 200.987 191.173 201.446C189.709 201.674 188.371 203.144 188.371 203.144C188.371 203.144 187.564 200.291 188.846 198.53C190.127 196.771 190.671 197.084 191.745 194.582C192.818 192.08 196.406 191.614 197.413 192.741V192.739Z","fill":"#1B896C"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_1_4148","x1":"172.041","y1":"81.4589","x2":"171.965","y2":"81.0993","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#A2CAF5"}}),_c('stop',{attrs:{"offset":"0.3","stop-color":"#9DC3F2"}}),_c('stop',{attrs:{"offset":"0.73","stop-color":"#91B0EB"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#88A1E6"}})],1),_c('linearGradient',{attrs:{"id":"paint1_linear_1_4148","x1":"196.528","y1":"76.3046","x2":"196.453","y2":"75.9449","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#A2CAF5"}}),_c('stop',{attrs:{"offset":"0.3","stop-color":"#9DC3F2"}}),_c('stop',{attrs:{"offset":"0.73","stop-color":"#91B0EB"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#88A1E6"}})],1),_c('linearGradient',{attrs:{"id":"paint2_linear_1_4148","x1":"90.78","y1":"141.444","x2":"120.583","y2":"139.865","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#808080"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#D6D6D6"}})],1),_c('linearGradient',{attrs:{"id":"paint3_linear_1_4148","x1":"-4.24315","y1":"146.363","x2":"120.577","y2":"139.749","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#808080"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#D6D6D6"}})],1),_c('linearGradient',{attrs:{"id":"paint4_linear_1_4148","x1":"126.571","y1":"177.076","x2":"141.746","y2":"176.272","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#808080"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#D6D6D6"}})],1),_c('linearGradient',{attrs:{"id":"paint5_linear_1_4148","x1":"126.571","y1":"177.064","x2":"141.746","y2":"176.26","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#808080"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#D6D6D6"}})],1),_c('linearGradient',{attrs:{"id":"paint6_linear_1_4148","x1":"126.571","y1":"177.064","x2":"141.746","y2":"176.26","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#808080"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#D6D6D6"}})],1),_c('linearGradient',{attrs:{"id":"paint7_linear_1_4148","x1":"120.825","y1":"163.656","x2":"120.166","y2":"151.184","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FECDFF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#CB96CC"}})],1),_c('linearGradient',{attrs:{"id":"paint8_linear_1_4148","x1":"125.055","y1":"154.392","x2":"127.111","y2":"154.283","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FECDFF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#CB96CC"}})],1),_c('linearGradient',{attrs:{"id":"paint9_linear_1_4148","x1":"134.741","y1":"163.925","x2":"133.848","y2":"147.025","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FECDFF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#CB96CC"}})],1),_c('linearGradient',{attrs:{"id":"paint10_linear_1_4148","x1":"107.546","y1":"178.12","x2":"136.049","y2":"176.61","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#808080"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#D6D6D6"}})],1),_c('linearGradient',{attrs:{"id":"paint11_linear_1_4148","x1":"107.519","y1":"177.61","x2":"136.022","y2":"176.099","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#808080"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#D6D6D6"}})],1),_c('clipPath',{attrs:{"id":"clip0_1_4148"}},[_c('rect',{attrs:{"width":"301","height":"213","fill":"white"}})])],1)])
}
var news_block_svgvue_type_template_id_201b4e57_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/news-block-svg.vue?vue&type=template&id=201b4e57

// CONCATENATED MODULE: ./src/components/svg/decorations/news-block-svg.vue

var news_block_svg_script = {}


/* normalize component */

var news_block_svg_component = normalizeComponent(
  news_block_svg_script,
  news_block_svgvue_type_template_id_201b4e57_render,
  news_block_svgvue_type_template_id_201b4e57_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var news_block_svg = (news_block_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfToday/index.js

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday() {
  return startOfDay(Date.now());
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-travel-agent/data-register.vue?vue&type=script&lang=js












/* harmony default export */ var data_registervue_type_script_lang_js = ({
  components: {
    HgDatepicker: hg_datepicker,
    HgTravelDurationSelect: hg_travel_duration_select,
    HgAirportSelect: hg_airport_select,
    HgDestinationSelect: hg_destination_select,
    HgButton: hg_button,
    HgTextInput: hg_text_input,
    PaperPlaneSvg: paper_plane_svg,
    HgTravelers: hg_travelers,
    NewsBlockSvg: news_block_svg,
  },
  props: {
    travelAgent: {
      type: String,
      default: '',
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    airports: {
      type: Array,
      default: () => [],
    },
    searchedAirports: {
      type: Array,
      required: true,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      step: '1',
      privacyConsent: false,
      invalid: true,
      selectedAirports: null,
      selectedDestination: null,
      travelers: { adults: 2 },
      selectedDateRange: null,
      selectedDuration: null,
      selectedTravelers: null,
      initialStartDate: null,
      initialEndDate: null,
      budget: null,
    }
  },

  created() {
    const today = startOfToday()
    this.initialStartDate = addDays(today, 1)
    this.initialEndDate = addMonths(today, 3)
  },

  methods: {
    nextStep(step) {
      this.step = step
      if (step === 'success') {
        this.submit()
      }
    },
    goToReisemagazin() {
      window.location.href = 'https://www.urlaubsguru.de/reisemagazin/'
    },
    submit() {
      this.$emit('onSubmit', {
        destination: this.selectedDestination,
        airports: this.selectedAirports,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
        budget: this.budget,
        travelers: this.selectedTravelers,
      })
    },

    selectAirports(airports) {
      this.selectedAirports = airports
      this.checkRequiredInputs()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.checkRequiredInputs()
    },

    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.checkRequiredInputs()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.checkRequiredInputs()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = dateRange
      this.checkRequiredInputs()
    },

    checkRequiredInputs() {
      this.invalid =
        Object.keys(this.selectedAirports ? this.selectedAirports : {})
          .length === 0 ||
        this.selectedDestination === null ||
        this.selectedDuration === null ||
        this.selectedDateRange === null
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-travel-agent/data-register.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_travel_agent_data_registervue_type_script_lang_js = (data_registervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-travel-agent/data-register.vue?vue&type=style&index=0&id=4c8bd33a&prod&lang=postcss&scoped=true
var data_registervue_type_style_index_0_id_4c8bd33a_prod_lang_postcss_scoped_true = __webpack_require__("c1cf");

// CONCATENATED MODULE: ./src/components/partials/hg-travel-agent/data-register.vue






/* normalize component */

var data_register_component = normalizeComponent(
  hg_travel_agent_data_registervue_type_script_lang_js,
  data_registervue_type_template_id_4c8bd33a_scoped_true_render,
  data_registervue_type_template_id_4c8bd33a_scoped_true_staticRenderFns,
  false,
  null,
  "4c8bd33a",
  null
  
)

/* harmony default export */ var data_register = (data_register_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-travel-agent/activate-account.vue?vue&type=template&id=6488a7ac&scoped=true
var activate_accountvue_type_template_id_6488a7ac_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-modal-container"},[_c('PaperPlaneSvg',{staticClass:"hg-plane-svg"}),[_c('div',{staticClass:"tw-mb-16"},[_c('h3',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.activateAccount.title'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('travelAgent.activateAccount.sub'))+" ")])]),_c('div',{staticClass:"tw-mb-4"},[_c('h3',{staticClass:"hg-title hg-title-color"},[_vm._v(" "+_vm._s(_vm.$t('travelAgent.activateAccount.couponTitle'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('travelAgent.activateAccount.couponSub'))+" ")])]),_c('HgCouponButton',{attrs:{"coupon-button-text":_vm.$t('travelAgent.couponButtonText.accountPage')},on:{"onClick":_vm.handleClick}})]],2)
}
var activate_accountvue_type_template_id_6488a7ac_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-travel-agent/activate-account.vue?vue&type=template&id=6488a7ac&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-travel-agent/activate-account.vue?vue&type=script&lang=js





/* harmony default export */ var activate_accountvue_type_script_lang_js = ({
  components: {
    HgModal: hg_modal,
    HgCouponButton: hg_coupon_button,
    PaperPlaneSvg: paper_plane_svg,
  },
  methods: {
    handleClick() {
      this.$emit('onClick')
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-travel-agent/activate-account.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_travel_agent_activate_accountvue_type_script_lang_js = (activate_accountvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-travel-agent/activate-account.vue?vue&type=style&index=0&id=6488a7ac&prod&lang=postcss&scoped=true
var activate_accountvue_type_style_index_0_id_6488a7ac_prod_lang_postcss_scoped_true = __webpack_require__("8f6e");

// CONCATENATED MODULE: ./src/components/partials/hg-travel-agent/activate-account.vue






/* normalize component */

var activate_account_component = normalizeComponent(
  hg_travel_agent_activate_accountvue_type_script_lang_js,
  activate_accountvue_type_template_id_6488a7ac_scoped_true_render,
  activate_accountvue_type_template_id_6488a7ac_scoped_true_staticRenderFns,
  false,
  null,
  "6488a7ac",
  null
  
)

/* harmony default export */ var activate_account = (activate_account_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-link-list/hg-destination.vue?vue&type=template&id=2a026ccb&scoped=true
var hg_destinationvue_type_template_id_2a026ccb_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-list-container"},[_c('p',{staticClass:"hg-list-head",domProps:{"innerHTML":_vm._s(_vm.destination)}}),_c('p',{staticClass:"hg-list-subhead",domProps:{"innerHTML":_vm._s(_vm.explanation)}})])
}
var hg_destinationvue_type_template_id_2a026ccb_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-link-list/hg-destination.vue?vue&type=template&id=2a026ccb&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-link-list/hg-destination.vue?vue&type=script&lang=js

/* harmony default export */ var hg_destinationvue_type_script_lang_js = ({
  props: {
    destination: {
      type: String,
      default: '',
    },
    explanation: {
      type: String,
      default: '',
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-link-list/hg-destination.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_link_list_hg_destinationvue_type_script_lang_js = (hg_destinationvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-link-list/hg-destination.vue?vue&type=style&index=0&id=2a026ccb&prod&scoped=true&lang=postcss
var hg_destinationvue_type_style_index_0_id_2a026ccb_prod_scoped_true_lang_postcss = __webpack_require__("1eb7");

// CONCATENATED MODULE: ./src/components/partials/hg-link-list/hg-destination.vue






/* normalize component */

var hg_destination_component = normalizeComponent(
  hg_link_list_hg_destinationvue_type_script_lang_js,
  hg_destinationvue_type_template_id_2a026ccb_scoped_true_render,
  hg_destinationvue_type_template_id_2a026ccb_scoped_true_staticRenderFns,
  false,
  null,
  "2a026ccb",
  null
  
)

/* harmony default export */ var hg_destination = (hg_destination_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-link-list/hg-link-list-text.vue?vue&type=template&id=c943ba90&scoped=true
var hg_link_list_textvue_type_template_id_c943ba90_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hg-head-wrap"},[_c('h1',{staticClass:"hg-headline",domProps:{"innerHTML":_vm._s(_vm.$t('LinkList.introduction.head'))}}),_c('p',{staticClass:"hg-subheadline"},[_vm._v(_vm._s(_vm.$t('LinkList.introduction.sub')))])]),_vm._t("gridContent")],2)
}
var hg_link_list_textvue_type_template_id_c943ba90_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-link-list/hg-link-list-text.vue?vue&type=template&id=c943ba90&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-link-list/hg-link-list-text.vue?vue&type=script&lang=js



/* harmony default export */ var hg_link_list_textvue_type_script_lang_js = ({
  components: { HgDestination: hg_destination },
});

// CONCATENATED MODULE: ./src/components/partials/hg-link-list/hg-link-list-text.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_link_list_hg_link_list_textvue_type_script_lang_js = (hg_link_list_textvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-link-list/hg-link-list-text.vue?vue&type=style&index=0&id=c943ba90&prod&scoped=true&lang=postcss
var hg_link_list_textvue_type_style_index_0_id_c943ba90_prod_scoped_true_lang_postcss = __webpack_require__("27de");

// CONCATENATED MODULE: ./src/components/partials/hg-link-list/hg-link-list-text.vue






/* normalize component */

var hg_link_list_text_component = normalizeComponent(
  hg_link_list_hg_link_list_textvue_type_script_lang_js,
  hg_link_list_textvue_type_template_id_c943ba90_scoped_true_render,
  hg_link_list_textvue_type_template_id_c943ba90_scoped_true_staticRenderFns,
  false,
  null,
  "c943ba90",
  null
  
)

/* harmony default export */ var hg_link_list_text = (hg_link_list_text_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-new.vue?vue&type=template&id=c5dde3c8&scoped=true
var hg_footer_newvue_type_template_id_c5dde3c8_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"hg-footer"},[_c('div',{staticClass:"hg-footer-content",style:({ maxWidth: _vm.maxWidth })},[_c('hg-footer-scroll-top',{attrs:{"locale":_vm.lang}}),_c('div',{staticClass:"top-container"},[_c('GuruLogo',{staticClass:"hg-footer-logo",attrs:{"lang":_vm.locale.lang}}),_c('hg-footer-social-media',{attrs:{"lang":_vm.locale.lang}})],1),_c('div',{staticClass:"center-container"},[_c('div',{staticClass:"center-wrap"},[_c('hg-footer-lists',{staticClass:"lists-area",attrs:{"lang":_vm.locale.lang}}),_c('div',[_c('hg-footer-newsletter',{staticClass:"newsletter-area",attrs:{"lang":_vm.locale.lang}}),_c('hg-footer-promotion',{attrs:{"lang":_vm.locale.lang}})],1)],1),_c('hg-footer-contact',{attrs:{"lang":_vm.locale.lang,"phoneNr":_vm.phoneNr}})],1),_c('hg-footer-footnote',{attrs:{"lang":_vm.locale.lang,"agbLink":_vm.agbLink,"showAccessibilityDeclaration":_vm.showAccessibilityDeclaration,"activate-cookie-consent":!_vm.noCookieConsent},on:{"onCookieButtonClick":_vm.cookieButtonClick}})],1)])
}
var hg_footer_newvue_type_template_id_c5dde3c8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-new.vue?vue&type=template&id=c5dde3c8&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-lists.vue?vue&type=template&id=4bf8b4be&scoped=true
var hg_footer_listsvue_type_template_id_4bf8b4be_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hg-footer-dropdown',{staticClass:"hg-dropdown-wrap",attrs:{"lang":_vm.locale.lang}}),[_c('div',{staticClass:"footer-lists-browser"},[_c('div',{staticClass:"panel corporate-panel"},[_c('div',[_c('h4',{staticClass:"column-headline"},[_vm._v(_vm._s(_vm.locale.corporate.title))])]),_c('div',{staticClass:"panel-content"},[_c('ul',_vm._l((_vm.locale.corporate.data),function(element,index){return _c('li',{key:index,staticClass:"list-content"},[_c('a',{staticClass:"link-type",attrs:{"href":element.url,"target":element.target}},[_c('span',[_vm._v(_vm._s(element.label))])])])}),0)])]),_c('div',{staticClass:"panel information-panel"},[_c('div',[_c('h4',{staticClass:"column-headline"},[_vm._v(" "+_vm._s(_vm.locale.informations.title)+" ")])]),_c('div',{staticClass:"panel-content"},[_c('ul',_vm._l((_vm.locale.informations.data),function(element,index){return _c('li',{key:index,staticClass:"list-content"},[_c('a',{staticClass:"link-type",attrs:{"href":element.url,"target":element.target}},[_c('span',[_vm._v(_vm._s(element.label))])])])}),0)])]),_c('div',{staticClass:"panel inspiration-panel"},[_c('div',[_c('h4',{staticClass:"column-headline"},[_vm._v(" "+_vm._s(_vm.locale.inspiration.title)+" ")])]),_c('div',{staticClass:"panel-content"},[_c('ul',_vm._l((_vm.locale.inspiration.data),function(element,index){return _c('li',{key:index,staticClass:"list-content"},[_c('a',{staticClass:"link-type",attrs:{"href":element.url,"target":element.target}},[_c('span',[_vm._v(_vm._s(element.label))])])])}),0)])])])]],2)
}
var hg_footer_listsvue_type_template_id_4bf8b4be_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-lists.vue?vue&type=template&id=4bf8b4be&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-dropdown.vue?vue&type=template&id=6a09efa2&scoped=true
var hg_footer_dropdownvue_type_template_id_6a09efa2_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.locale),function(element,index){return [(element.data)?_c('hg-dropdown-new',{key:index,staticClass:"link-list-mobile",attrs:{"trigger-text":element.title}},[_c('ul',_vm._l((element.data),function(subElement,index){return _c('li',{key:index,staticClass:"list-item"},[_c('a',{attrs:{"href":subElement.url,"target":subElement.target}},[_vm._v(" "+_vm._s(subElement.label)+" ")])])}),0)]):_vm._e()]})],2)
}
var hg_footer_dropdownvue_type_template_id_6a09efa2_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-dropdown.vue?vue&type=template&id=6a09efa2&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-dropdown.vue?vue&type=script&lang=js




/* harmony default export */ var hg_footer_dropdownvue_type_script_lang_js = ({
  props: {
    lang: {
      type: String,
      default: 'de',
    },
  },
  data() {
    return {
      locale: hg_footer_listsvue_type_script_lang_js_locales.de,
    }
  },
  watch: {
    lang() {
      this.setLocale()
    },
  },
  methods: {
    setLocale() {
      this.locale = getLocale(hg_footer_listsvue_type_script_lang_js_locales, this.lang)
    },
  },
  created() {
    this.setLocale()
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-dropdown.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_footer_hg_footer_dropdownvue_type_script_lang_js = (hg_footer_dropdownvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-footer/hg-footer-dropdown.vue?vue&type=style&index=0&id=6a09efa2&prod&lang=postcss&scoped=true
var hg_footer_dropdownvue_type_style_index_0_id_6a09efa2_prod_lang_postcss_scoped_true = __webpack_require__("b759");

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-dropdown.vue






/* normalize component */

var hg_footer_dropdown_component = normalizeComponent(
  hg_footer_hg_footer_dropdownvue_type_script_lang_js,
  hg_footer_dropdownvue_type_template_id_6a09efa2_scoped_true_render,
  hg_footer_dropdownvue_type_template_id_6a09efa2_scoped_true_staticRenderFns,
  false,
  null,
  "6a09efa2",
  null
  
)

/* harmony default export */ var hg_footer_dropdown = (hg_footer_dropdown_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-lists.vue?vue&type=script&lang=js




const hg_footer_listsvue_type_script_lang_js_locales = {
  de: {
    lang: 'de',
    corporate: {
      title: 'Urlaubsguru',
      data: [
        {
          label: 'Über uns',
          url: 'https://www.urlaubsguru.de/ueber-uns/',
          target: '_self',
        },
        {
          label: 'Karriere',
          url: 'https://www.urlaubsguru.de/karriere',
          target: '_self',
        },
        {
          label: 'Presse',
          url: 'https://www.urlaubsguru.de/presse/',
          target: '_self',
        },
        {
          label: 'Werbung',
          url: 'https://www.urlaubsguru.de/werbung/',
          target: '_self',
        },
      ],
    },
    informations: {
      title: 'Wissenswertes',
      data: [
        {
          label: 'Reiseplanung 2025',
          url: 'https://www.urlaubsguru.de/reiseplanung/',
          target: '_self',
        },
        {
          label: 'Nachhaltig Reisen',
          url: 'https://www.urlaubsguru.de/nachhaltiger-tourismus/',
          target: '_self',
        },
      ],
    },
    inspiration: {
      title: 'Inspiration',
      data: [
        {
          label: 'Reisemagazin',
          url: 'https://www.urlaubsguru.de/reisemagazin/',
          target: '_self',
        },
        {
          label: 'Reisekalender',
          url: 'https://www.urlaubsguru.de/reisekalender/',
          target: '_self',
        },
        {
          label: 'Beliebte Urlaubsziele',
          url: 'https://www.urlaubsguru.de/urlaubsziele/',
          target: '_self',
        },
      ],
    },
  },
  at: {
    lang: 'at',
    corporate: {
      title: 'Urlaubsguru',
      data: [
        {
          label: 'Über uns',
          url: 'https://www.urlaubsguru.at/ueber-uns/',
          target: '_self',
        },
        {
          label: 'Feedback an uns',
          url: 'https://www.urlaubsguru.at/urlaubsguru-feedback/',
          target: '_self',
        },
        {
          label: 'Presse',
          url: 'https://www.urlaubsguru.at/presse/',
          target: '_self',
        },
        {
          label: 'Werbung',
          url: 'https://www.urlaubsguru.de/werbung/',
          target: '_self',
        },
        {
          label: 'Karriere',
          url: 'https://www.urlaubsguru.at/karriere',
          target: '_self',
        },
      ],
    },
    informations: {
      title: 'Wissenswertes',
      data: [
        {
          label: 'Reiseplanung',
          url: 'https://www.urlaubsguru.at/reiseplanung/',
          target: '_self',
        },
        {
          label: 'Urlaub buchen bei Urlaubsguru',
          url: 'https://www.urlaubsguru.at/suchen-buchen-urlaubsguru/',
          target: '_self',
        },
        {
          label: 'Messenger',
          url: 'https://www.urlaubsguru.at/messenger/',
          target: '_self',
        },
      ],
    },
    inspiration: {
      title: 'Inspiration',
      data: [
        {
          label: 'Reisemagazin',
          url: 'https://www.urlaubsguru.at/reisemagazin/',
          target: '_self',
        },
        {
          label: 'Reisekalender',
          url: 'https://www.urlaubsguru.at/reisekalender/',
          target: '_self',
        },
        {
          label: 'Beliebte Urlaubsziele',
          url: 'https://www.urlaubsguru.at/urlaubsziele/',
          target: '_self',
        },
        {
          label: 'Urlaub in Österreich',
          url: 'https://www.urlaubsguru.at/oesterreichliebe/',
          target: '_self',
        },
      ],
    },
  },
  ch: {
    lang: 'ch',
    corporate: {
      title: 'Holidayguru',
      data: [
        {
          label: 'Über uns',
          url: 'https://www.holidayguru.ch/ueber-uns/',
          target: '_self',
        },
        {
          label: 'Individuelle Reiseanfrage',
          url: 'https://www.holidayguru.ch/individuelle-reiseanfrage/',
          target: '_self',
        },
        {
          label: 'Presse',
          url: 'https://www.holidayguru.ch/presse/#/',
          target: '_self',
        },
        {
          label: 'Werbung',
          url: 'https://www.urlaubsguru.de/werbung/',
          target: '_self',
        },
      ],
    },
    informations: {
      title: 'Wissenswertes',
      data: [
        {
          label: 'Reiseplanung',
          url: 'https://www.holidayguru.ch/reiseplanung/',
          target: '_self',
        },
        {
          label: 'Ferien buchen',
          url: 'https://www.holidayguru.ch/suchen-buchen-holidayguru/',
          target: '_self',
        },
        {
          label: 'Lexikon',
          url: 'https://www.holidayguru.ch/lexikon/',
          target: '_self',
        },
      ],
    },
    inspiration: {
      title: 'Inspiration',
      data: [
        {
          label: 'Reisemagazin',
          url: 'https://www.holidayguru.ch/reisemagazin/',
          target: '_self',
        },
        {
          label: 'Reisekalender',
          url: 'https://www.holidayguru.ch/reisekalender/',
          target: '_self',
        },
        {
          label: 'Beliebte Ferienziele',
          url: 'https://www.holidayguru.ch/ferienziele/',
          target: '_self',
        },
        {
          label: 'Ferien in der Schweiz',
          url: 'https://www.holidayguru.ch/schweizliebe/',
          target: '_self',
        },
      ],
    },
  },
  nl: {
    lang: 'nl',
    corporate: {
      title: 'Holidayguru',
      data: [
        {
          label: 'Over ons',
          url: 'https://www.holidayguru.nl/over-mij/',
          target: '_self',
        },
        {
          label: 'Vacatures',
          url: 'https://www.holidayguru.nl/vacatures/',
          target: '_self',
        },
        {
          label: 'Pers',
          url: 'https://www.holidayguru.nl/pers/',
          target: '_self',
        },
        {
          label: 'Partnerships',
          url: 'https://www.holidayguru.nl/advertising-and-partnerships/',
          target: '_self',
        },
      ],
    },
    informations: {
      title: 'Inspiratie',
      data: [
        {
          label: 'Reiskalender',
          url: 'https://www.holidayguru.nl/reiskalender/',
          target: '_self',
        },
        {
          label: 'Vakantiebestemmingen',
          url: 'https://www.holidayguru.nl/vakantiebestemmingen/',
          target: '_self',
        },
        {
          label: 'All inclusive',
          url: 'https://www.holidayguru.nl/last-minute/all-inclusive/',
          target: '_self',
        },
        {
          label: 'Last minute',
          url: 'https://www.holidayguru.nl/last-minute/',
          target: '_self',
        },
      ],
    },
    inspiration: {
      title: 'Vakantie boeken',
      data: [
        {
          label: 'Zonvakanties',
          url: 'https://reizen.holidayguru.nl/vakanties/zonvakanties',
          target: '_self',
        },
        {
          label: 'Stedentrips',
          url: 'https://reizen.holidayguru.nl/vakanties/stedentrip',
          target: '_self',
        },
        {
          label: 'Contact',
          url: 'https://reizen.holidayguru.nl/contact',
          target: '_self',
        },
        {
          label: 'Veelgestelde vragen',
          url: 'https://reizen.holidayguru.nl/veelgestelde-vragen',
          target: '_self',
        },
        {
          label: 'Alg. voorwaarden',
          url: 'https://reizen.holidayguru.nl/algemene-voorwaarden',
          target: '_self',
        },
      ],
    },
  },
  es: {
    lang: 'es',
    corporate: {
      title: 'Holidayguru',
      data: [
        {
          label: 'Sobre Holidayguru',
          url: 'https://www.holidayguru.es/sobre-mi/',
          target: '_self',
        },
        {
          label: 'Trabaja con nosotros',
          url: 'https://urlaubsguru.jobs.personio.de/',
          target: '_self',
        },
        {
          label: 'Prensa',
          url: 'https://www.holidayguru.es/prensa/',
          target: '_self',
        },
        {
          label: 'Publicidad',
          url: 'https://www.holidayguru.es/publicidad/',
          target: '_self',
        },
      ],
    },
    informations: {
      title: 'Enlaces de interés',
      data: [
        {
          label: 'Calendario de puentes',
          url: 'https://www.holidayguru.es/calendario-de-puentes/',
          target: '_self',
        },
        {
          label: 'La mejor época para viajar',
          url: 'https://www.holidayguru.es/calendario-de-viajes/mejor-epoca-para-viajar-a-los-mejores-destinos/',
          target: '_self',
        },
        {
          label: 'Preguntas frecuentes',
          url: 'https://www.holidayguru.es/preguntas-frecuentes-holidayguru/',
          target: '_self',
        },
      ],
    },
    inspiration: {
      title: 'Inspiración',
      data: [
        {
          label: 'Revista de viajes',
          url: 'https://www.holidayguru.es/revista-de-viajes/',
          target: '_self',
        },
        {
          label: 'Ofertas último minuto',
          url: 'https://www.holidayguru.es/ofertas-ultimo-minuto/',
          target: '_self',
        },
        {
          label: 'Vacaciones por España',
          url: 'https://www.holidayguru.es/destinos/espana/',
          target: '_self',
        },
        {
          label: 'Qué ver en...',
          url: 'https://www.holidayguru.es/destinos/que-ver-en-europa/',
          target: '_self',
        },
      ],
    },
  },
}

/* harmony default export */ var hg_footer_listsvue_type_script_lang_js = ({
  components: { HgFooterDropdown: hg_footer_dropdown },
  props: {
    lang: {
      type: String,
      default: 'de',
    },
  },
  data() {
    return {
      locale: hg_footer_listsvue_type_script_lang_js_locales.de,
    }
  },
  watch: {
    lang() {
      this.setLocale()
    },
  },
  methods: {
    setLocale() {
      this.locale = getLocale(hg_footer_listsvue_type_script_lang_js_locales, this.lang)
    },
  },
  created() {
    this.setLocale()
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-lists.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_footer_hg_footer_listsvue_type_script_lang_js = (hg_footer_listsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-footer/hg-footer-lists.vue?vue&type=style&index=0&id=4bf8b4be&prod&lang=postcss&scoped=true
var hg_footer_listsvue_type_style_index_0_id_4bf8b4be_prod_lang_postcss_scoped_true = __webpack_require__("8faf");

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-lists.vue






/* normalize component */

var hg_footer_lists_component = normalizeComponent(
  hg_footer_hg_footer_listsvue_type_script_lang_js,
  hg_footer_listsvue_type_template_id_4bf8b4be_scoped_true_render,
  hg_footer_listsvue_type_template_id_4bf8b4be_scoped_true_staticRenderFns,
  false,
  null,
  "4bf8b4be",
  null
  
)

/* harmony default export */ var hg_footer_lists = (hg_footer_lists_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-newsletter.vue?vue&type=template&id=20ae4065&scoped=true
var hg_footer_newslettervue_type_template_id_20ae4065_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"hg-newsletter-headline",domProps:{"innerHTML":_vm._s(_vm.locale.title)}}),_c('div',{staticClass:"panel-content"},[_c('hg-button',{staticClass:"tw-h-12",attrs:{"type":"submit","color":"teal","size":"full","tag":"a","href":_vm.locale.url}},[_c('span',[_vm._v(_vm._s(_vm.locale.button))])])],1)])
}
var hg_footer_newslettervue_type_template_id_20ae4065_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-newsletter.vue?vue&type=template&id=20ae4065&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-newsletter.vue?vue&type=script&lang=js



const hg_footer_newslettervue_type_script_lang_js_locales = {
  de: {
    title: '<span>Urlaubsfeelings</span> per Newsletter!',
    button: 'Melde dich jetzt an',
    url: 'https://www.urlaubsguru.de/newsletter/',
  },
  at: {
    title: '<span>Urlaubsfeelings</span> per Newsletter!',
    button: 'Melde dich jetzt an',
    url: 'https://www.urlaubsguru.at/newsletter/',
  },
  ch: {
    title: '<span>Reisefeelings</span> per Newsletter!',
    button: 'Melde dich jetzt an',
    url: 'https://www.holidayguru.ch/newsletter/',
  },
  es: {
    title: '<span>Inspiración</span> para tus vacaciones en mi Newsletter',
    button: 'Suscríbete ahora ',
    url: 'https://www.holidayguru.es/newsletter/',
  },
  nl: {
    title: '<span>Reisinspiratie</span> in je mailbox',
    button: 'Inschrijven',
    url: 'https://www.holidayguru.nl/newsletter/',
  },
}

/* harmony default export */ var hg_footer_newslettervue_type_script_lang_js = ({
  props: {
    lang: {
      type: String,
      default: 'de',
    },
  },
  data() {
    return {
      locale: hg_footer_newslettervue_type_script_lang_js_locales.de,
    }
  },
  watch: {
    lang() {
      this.setLocale()
    },
  },
  methods: {
    setLocale() {
      this.locale = getLocale(hg_footer_newslettervue_type_script_lang_js_locales, this.lang)
    },
  },
  created() {
    this.setLocale()
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-newsletter.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_footer_hg_footer_newslettervue_type_script_lang_js = (hg_footer_newslettervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-footer/hg-footer-newsletter.vue?vue&type=style&index=0&id=20ae4065&prod&lang=postcss&scoped=true
var hg_footer_newslettervue_type_style_index_0_id_20ae4065_prod_lang_postcss_scoped_true = __webpack_require__("6a55");

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-newsletter.vue






/* normalize component */

var hg_footer_newsletter_component = normalizeComponent(
  hg_footer_hg_footer_newslettervue_type_script_lang_js,
  hg_footer_newslettervue_type_template_id_20ae4065_scoped_true_render,
  hg_footer_newslettervue_type_template_id_20ae4065_scoped_true_staticRenderFns,
  false,
  null,
  "20ae4065",
  null
  
)

/* harmony default export */ var hg_footer_newsletter = (hg_footer_newsletter_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-footnote.vue?vue&type=template&id=bfc12f52&scoped=true
var hg_footer_footnotevue_type_template_id_bfc12f52_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-footnote-wrap"},[_c('div',{staticClass:"hg-copyright"},[_vm._v(" Copyright "+_vm._s(_vm.getTheYear)+" - "+_vm._s(_vm.locale.title)+" ")]),_c('div',{staticClass:"hg-container-footnote"},[_vm._l((_vm.locale.data),function(element,index){return _c('a',{key:index,staticClass:"hg-footnote-center",attrs:{"href":element.url,"target":element.target}},[_c('span',[_vm._v(_vm._s(element.label))])])}),(_vm.activateCookieConsent)?_c('hg-button',{staticClass:"hg-cookie",attrs:{"type":"submit","tag":"button"},on:{"onClick":_vm.onCookieButtonClick}},[_c('span',[_vm._v(_vm._s(_vm.locale.cookiesLabel || 'Cookies'))])]):_vm._e()],2),(_vm.locale.showHashtag)?_c('div',{staticClass:"hg-hash"},[_vm._v(" "+_vm._s(_vm.locale.hashtag)+" ")]):_vm._e()])
}
var hg_footer_footnotevue_type_template_id_bfc12f52_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-footnote.vue?vue&type=template&id=bfc12f52&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-footnote.vue?vue&type=script&lang=js



const hg_footer_footnotevue_type_script_lang_js_locales = {
  de: {
    title: 'Urlaubsguru',
    hashtag: '#inspirestobook',
    showHashtag: true,
    data: [
      {
        label: 'Datenschutzerklärung',
        url: 'https://www.urlaubsguru.de/datenschutzerklaerung/',
        target: '_self',
      },
      {
        label: 'Impressum',
        url: 'https://www.urlaubsguru.de/impressum/',
        target: '_self',
      },
      {
        label: 'Sitemap',
        url: 'https://www.urlaubsguru.de/sitemap/',
        target: '_self',
      },
      {
        label: 'Lexikon',
        url: 'https://www.urlaubsguru.de/lexikon/',
        target: '_self',
      },
    ],
    cookiesLabel: 'Einwilligungen widerrufen / ändern',
  },
  at: {
    title: 'Urlaubsguru',
    hashtag: '#inspirestobook',
    showHashtag: true,
    data: [
      {
        label: 'Datenschutzerklärung',
        url: 'https://www.urlaubsguru.at/datenschutzerklaerung/',
        target: '_self',
      },
      {
        label: 'Sitemap',
        url: 'https://www.urlaubsguru.at/sitemap/',
        target: '_self',
      },
      {
        label: 'Lexikon',
        url: 'https://www.urlaubsguru.at/lexikon/',
        target: '_self',
      },
      {
        label: 'Impressum',
        url: 'https://www.urlaubsguru.at/impressum/',
        target: '_self',
      },
    ],
    cookiesLabel: 'Einwilligungen widerrufen / ändern',
  },
  ch: {
    title: 'Holidayguru',
    hashtag: '#inspirestobook',
    showHashtag: true,
    data: [
      {
        label: 'Datenschutzerklärung',
        url: 'https://www.holidayguru.ch/datenschutzerklaerung/',
        target: '_self',
      },
      {
        label: 'Sitemap',
        url: 'https://www.holidayguru.ch/sitemap/',
        target: '_self',
      },
      {
        label: 'Impressum',
        url: 'https://www.holidayguru.ch/impressum/',
        target: '_self',
      },
    ],
    cookiesLabel: 'Einwilligungen widerrufen / ändern',
  },
  es: {
    title: 'Holidayguru',
    hashtag: '#inspirestobook',
    showHashtag: true,
    data: [
      {
        label: 'Política de privacidad',
        url: 'https://www.holidayguru.es/politica-de-privacidad/',
        target: '_self',
      },
      {
        label: 'Aviso legal',
        url: 'https://www.holidayguru.es/aviso-legal/',
        target: '_self',
      },
      {
        label: 'Palabras clave',
        url: 'https://www.holidayguru.es/tag/',
        target: '_self',
      },
    ],
    cookiesLabel: 'Revocar / Cambiar consentimiento',
  },
  nl: {
    title: 'Holidayguru',
    showHashtag: false,
    data: [
      {
        label: 'Privacy statement',
        url: 'https://www.holidayguru.nl/privacy-statement/',
        target: '_self',
      },
      {
        label: 'Impressum',
        url: 'https://www.holidayguru.nl/imprint/',
        target: '_self',
      },
      {
        label: 'Tags',
        url: 'https://www.holidayguru.nl/tag/',
        target: '_self',
      },
    ],
    cookiesLabel: 'Toestemming intrekken / wijzigen',
  },
}

/* harmony default export */ var hg_footer_footnotevue_type_script_lang_js = ({
  props: {
    lang: {
      type: String,
      default: 'de',
    },
    agbLink: {
      type: String,
      default: '',
    },
    showAccessibilityDeclaration: {
      type: Boolean,
      default: false,
    },
    activateCookieConsent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      locale: hg_footer_footnotevue_type_script_lang_js_locales.de,
    }
  },
  watch: {
    lang() {
      this.setLocale()
    },
    agbLink() {
      this.setLocale()
    },
  },
  methods: {
    setLocale() {
      this.locale = getLocale(hg_footer_footnotevue_type_script_lang_js_locales, this.lang)

      if (this.agbLink && this.agbLink.length > 0) {
        this.locale.data.splice(1, 0, {
          label: 'AGB',
          url: this.agbLink,
          target: 'blank',
        })
      }

      if (this.showAccessibilityDeclaration) {
        hg_footer_footnotevue_type_script_lang_js_locales.de.data.splice(1, 0, {
          label: 'Barrierefreiheitserklärung',
          url: `https://www.urlaubsguru.de/info/barrierefreiheitserklaerung/`,
          target: '_self',
        })

        hg_footer_footnotevue_type_script_lang_js_locales.at.data.splice(1, 0, {
          label: 'Barrierefreiheitserklärung',
          url: `https://www.urlaubsguru.at/info/barrierefreiheitserklaerung/`,
          target: '_self',
        })

        hg_footer_footnotevue_type_script_lang_js_locales.es.data.splice(1, 0, {
          label: 'Declaración de accesibilidad',
          url: `https://www.holidayguru.es/info/declaracion-de-accesibilidad/`,
          target: '_self',
        })
      }
    },
    onCookieButtonClick() {
      this.$emit('onCookieButtonClick')
    },
  },
  created() {
    this.setLocale()
  },
  computed: {
    getTheYear() {
      const date = new Date()
      return date.getFullYear()
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-footnote.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_footer_hg_footer_footnotevue_type_script_lang_js = (hg_footer_footnotevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-footer/hg-footer-footnote.vue?vue&type=style&index=0&id=bfc12f52&prod&lang=postcss&scoped=true
var hg_footer_footnotevue_type_style_index_0_id_bfc12f52_prod_lang_postcss_scoped_true = __webpack_require__("43d8");

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-footnote.vue






/* normalize component */

var hg_footer_footnote_component = normalizeComponent(
  hg_footer_hg_footer_footnotevue_type_script_lang_js,
  hg_footer_footnotevue_type_template_id_bfc12f52_scoped_true_render,
  hg_footer_footnotevue_type_template_id_bfc12f52_scoped_true_staticRenderFns,
  false,
  null,
  "bfc12f52",
  null
  
)

/* harmony default export */ var hg_footer_footnote = (hg_footer_footnote_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-social-media.vue?vue&type=template&id=ef3ca2a4&scoped=true
var hg_footer_social_mediavue_type_template_id_ef3ca2a4_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-social-media-wrap"},_vm._l((_vm.locale),function(element,index){return _c('a',{key:index,staticClass:"hg-social-wrap",attrs:{"href":element.url,"target":"_blank"}},[_c(element.component,{tag:"Component",staticClass:"hg-social-icon"})],1)}),0)
}
var hg_footer_social_mediavue_type_template_id_ef3ca2a4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-social-media.vue?vue&type=template&id=ef3ca2a4&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-social-media.vue?vue&type=script&lang=js



const hg_footer_social_mediavue_type_script_lang_js_locales = {
  de: {
    instagram: {
      url: 'https://www.instagram.com/urlaubsguru/',
      component: 'InstagramFooterSvg',
    },
    facebook: {
      url: 'https://www.facebook.com/derurlaubsguru/',
      component: 'FacebookFooterSvg',
    },
    youtube: {
      url: 'https://www.youtube.com/channel/UCKDLTlnI9j6lyP6CyTp293g',
      component: 'YoutubeFooterSvg'
    },
    tiktok: {
      url: 'https://www.tiktok.com/@urlaubsguru.de',
      component: 'TiktokFooterSvg'
    },
    linkedin: {
      url: 'https://de.linkedin.com/company/urlaubsguru-gmbh',
      component: 'LinkedinFooterSvg'
    },
    pinterest: {
      url: 'https://www.pinterest.de/urlaubsguru/',
      component: 'PinterestFooterSvg'
    },
    whatsapp: {
      url: 'https://www.urlaubsguru.de/messenger/',
      component: 'WhatsappFooterSvg'
    }
  },
  at: {
    instagram: {
      url: 'https://www.instagram.com/urlaubsguru_at/',
      component: 'InstagramFooterSvg'
    },
    facebook: {
      url: 'https://www.facebook.com/urlaubsguruAT/',
      component: 'FacebookFooterSvg'
    },
    tiktok: {
      url: 'https://www.tiktok.com/@urlaubsguru.at',
      component: 'TiktokFooterSvg'
    },
    whatsapp: {
      url: 'https://www.urlaubsguru.at/messenger/',
      component: 'WhatsappFooterSvg'
    }
  },
  ch: {
    instagram: {
      url: 'https://www.instagram.com/Holidayguru_ch/',
      component: 'InstagramFooterSvg'
    },
    facebook: {
      url: 'https://www.facebook.com/urlaubsguru.ch/',
      component: 'FacebookFooterSvg'
    }
  },
  es: {
    instagram: {
      url: 'https://www.instagram.com/holidayguru.es/',
      component: 'InstagramFooterSvg'
    },
    facebook: {
      url: 'https://www.facebook.com/Holidayguru.ES/',
      component: 'FacebookFooterSvg'
    },
    tiktok: {
      url: 'https://www.tiktok.com/@holidayguru',
      component: 'TiktokFooterSvg'
    },
    pinterest: {
      url: 'https://www.pinterest.de/holidayguru_es/',
      component: 'PinterestFooterSvg'
    },
    telegram: {
      url: 'https://t.me/holidayguruES',
      component: 'TelegramFooterSvg'
    }
  },
  nl: {
    instagram: {
      url: 'https://www.instagram.com/holidaygurunl/',
      component: 'InstagramFooterSvg'
    },
    facebook: {
      url: 'https://www.facebook.com/holidayguru.nl/',
      component: 'FacebookFooterSvg'
    },
    tiktok: {
      url: 'https://www.tiktok.com/@holidayguru_nl',
      component: 'TiktokFooterSvg'
    },
    pinterest: {
      url: 'https://nl.pinterest.com/holidaygurunl/',
      component: 'PinterestFooterSvg'
    }
  }
}

/* harmony default export */ var hg_footer_social_mediavue_type_script_lang_js = ({
  props: {
    icon: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    lang: {
      type: String,
      default: 'de',
    },
  },
  data() {
    return {
      locale: hg_footer_social_mediavue_type_script_lang_js_locales.de,
    }
  },
  watch: {
    lang() {
      this.setLocale()
    },
  },
  methods: {
    setLocale() {
      this.locale = getLocale(hg_footer_social_mediavue_type_script_lang_js_locales, this.lang)
    },
  },
  created() {
    this.setLocale()
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-social-media.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_footer_hg_footer_social_mediavue_type_script_lang_js = (hg_footer_social_mediavue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-footer/hg-footer-social-media.vue?vue&type=style&index=0&id=ef3ca2a4&prod&lang=postcss&scoped=true
var hg_footer_social_mediavue_type_style_index_0_id_ef3ca2a4_prod_lang_postcss_scoped_true = __webpack_require__("a2bf");

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-social-media.vue






/* normalize component */

var hg_footer_social_media_component = normalizeComponent(
  hg_footer_hg_footer_social_mediavue_type_script_lang_js,
  hg_footer_social_mediavue_type_template_id_ef3ca2a4_scoped_true_render,
  hg_footer_social_mediavue_type_template_id_ef3ca2a4_scoped_true_staticRenderFns,
  false,
  null,
  "ef3ca2a4",
  null
  
)

/* harmony default export */ var hg_footer_social_media = (hg_footer_social_media_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-scroll-top.vue?vue&type=template&id=430d67c2&scoped=true
var hg_footer_scroll_topvue_type_template_id_430d67c2_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-back-to-top"},[_c('button',{attrs:{"type":"button"},on:{"click":_vm.scrollToTop}},[_c('GuruScrollTop',{attrs:{"locale":_vm.locale}})],1)])
}
var hg_footer_scroll_topvue_type_template_id_430d67c2_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-scroll-top.vue?vue&type=template&id=430d67c2&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-scroll-top.vue?vue&type=script&lang=js

/* harmony default export */ var hg_footer_scroll_topvue_type_script_lang_js = ({
  props: {
    locale: {
      type: String,
      default: 'de',
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-scroll-top.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_footer_hg_footer_scroll_topvue_type_script_lang_js = (hg_footer_scroll_topvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-footer/hg-footer-scroll-top.vue?vue&type=style&index=0&id=430d67c2&prod&lang=postcss&scoped=true
var hg_footer_scroll_topvue_type_style_index_0_id_430d67c2_prod_lang_postcss_scoped_true = __webpack_require__("bd98");

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-scroll-top.vue






/* normalize component */

var hg_footer_scroll_top_component = normalizeComponent(
  hg_footer_hg_footer_scroll_topvue_type_script_lang_js,
  hg_footer_scroll_topvue_type_template_id_430d67c2_scoped_true_render,
  hg_footer_scroll_topvue_type_template_id_430d67c2_scoped_true_staticRenderFns,
  false,
  null,
  "430d67c2",
  null
  
)

/* harmony default export */ var hg_footer_scroll_top = (hg_footer_scroll_top_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-promotion.vue?vue&type=template&id=f2062e30&scoped=true
var hg_footer_promotionvue_type_template_id_f2062e30_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-app-wrap"},[(_vm.locale.appstore)?_c('a',{staticClass:"app-badge",attrs:{"href":_vm.locale.appstore,"target":"_blank"}},[_c(`AppStore${_vm.locale.lang.toUpperCase()}`,{tag:"component",staticClass:"hg-promotion-icon"})],1):_vm._e(),(_vm.locale.playstore)?_c('a',{staticClass:"app-badge",attrs:{"href":_vm.locale.playstore,"target":"_blank"}},[_c(`PlayStore${_vm.locale.lang.toUpperCase()}`,{tag:"component",staticClass:"hg-promotion-icon"})],1):_vm._e()])
}
var hg_footer_promotionvue_type_template_id_f2062e30_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-promotion.vue?vue&type=template&id=f2062e30&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-promotion.vue?vue&type=script&lang=js



const hg_footer_promotionvue_type_script_lang_js_locales = {
  de: {
    lang: "de",
    appstore: 'https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087',
    playstore: 'https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru'
  },
  at: {
    lang: "at",
    appstore: 'https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087',
    playstore: 'https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru'
  },
  ch: {
    lang: "ch",
    appstore: 'https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087',
    playstore: 'https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru'
  },
  es: {
    lang: "es",
    appstore: 'https://apps.apple.com/es/app/urlaubsguru-reise-schnappchen/id692735087',
    playstore: 'https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru&hl=es'
  },
  nl: {
    lang: "nl",
    appstore: 'https://itunes.apple.com/nl/app/urlaubsguru-reise-schnappchen/id692735087?mt=8',
    playstore: 'https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru&hl=nl-nl'
  }
}

/* harmony default export */ var hg_footer_promotionvue_type_script_lang_js = ({
  props: {
    lang: {
      type: String,
      default: 'de',
    },
  },
  data() {
    return {
      locale: hg_footer_promotionvue_type_script_lang_js_locales.de
    }
  },
  watch: {
    lang() {
      this.setLocale()
    },
  },
  methods: {
    setLocale() {
      this.locale = getLocale(hg_footer_promotionvue_type_script_lang_js_locales, this.lang)
    },
  },
  created() {
    this.setLocale()
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-promotion.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_footer_hg_footer_promotionvue_type_script_lang_js = (hg_footer_promotionvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-footer/hg-footer-promotion.vue?vue&type=style&index=0&id=f2062e30&prod&lang=postcss&scoped=true
var hg_footer_promotionvue_type_style_index_0_id_f2062e30_prod_lang_postcss_scoped_true = __webpack_require__("339c");

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-promotion.vue






/* normalize component */

var hg_footer_promotion_component = normalizeComponent(
  hg_footer_hg_footer_promotionvue_type_script_lang_js,
  hg_footer_promotionvue_type_template_id_f2062e30_scoped_true_render,
  hg_footer_promotionvue_type_template_id_f2062e30_scoped_true_staticRenderFns,
  false,
  null,
  "f2062e30",
  null
  
)

/* harmony default export */ var hg_footer_promotion = (hg_footer_promotion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-contact.vue?vue&type=template&id=008721bf&scoped=true
var hg_footer_contactvue_type_template_id_008721bf_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.locale.showContact)?_c('p',{staticClass:"hg-footer-help"},[_vm._v(" Du hast Fragen oder benötigst Hilfe bei einer Buchung? Rufe uns an unter "),_c('a',{attrs:{"href":`tel:${_vm.phoneNr && _vm.phoneNr.length > 0 ? _vm.phoneNr : _vm.locale.number}`}},[_vm._v(" "+_vm._s(_vm.phoneNr && _vm.phoneNr.length > 0 ? _vm.phoneNr : _vm.locale.number)+" ")]),_vm._v(" - "+_vm._s(_vm.locale.message)+" ")]):_vm._e()
}
var hg_footer_contactvue_type_template_id_008721bf_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-contact.vue?vue&type=template&id=008721bf&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-contact.vue?vue&type=script&lang=js



const hg_footer_contactvue_type_script_lang_js_locales = {
  de: {
    number: '+49 2301 8939742',
    message: 'Wir sind täglich von 8 bis 22 Uhr für dich da.',
    showContact: true,
  },
  at: {
    number: '+43 1 3852397',
    message: 'Wir sind täglich von 8 bis 22 Uhr für dich da.',
    showContact: true,
  },
  ch: {
    number: '+41 4 45222063',
    message: 'Wir sind täglich von 8 bis 22 Uhr für dich da.',
    showContact: true,
  },
  nl: {
    showContact: false,
  },
  es: {
    showContact: false,
  },
}

/* harmony default export */ var hg_footer_contactvue_type_script_lang_js = ({
  props: {
    lang: {
      type: String,
      default: 'de',
    },
    phoneNr: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      locale: hg_footer_contactvue_type_script_lang_js_locales.de,
    }
  },
  watch: {
    lang() {
      this.setLocale()
    },
  },
  methods: {
    setLocale() {
      this.locale = getLocale(hg_footer_contactvue_type_script_lang_js_locales, this.lang)
    },
  },
  created() {
    this.setLocale()
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-contact.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_footer_hg_footer_contactvue_type_script_lang_js = (hg_footer_contactvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-footer/hg-footer-contact.vue?vue&type=style&index=0&id=008721bf&prod&lang=postcss&scoped=true
var hg_footer_contactvue_type_style_index_0_id_008721bf_prod_lang_postcss_scoped_true = __webpack_require__("f056");

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-contact.vue






/* normalize component */

var hg_footer_contact_component = normalizeComponent(
  hg_footer_hg_footer_contactvue_type_script_lang_js,
  hg_footer_contactvue_type_template_id_008721bf_scoped_true_render,
  hg_footer_contactvue_type_template_id_008721bf_scoped_true_staticRenderFns,
  false,
  null,
  "008721bf",
  null
  
)

/* harmony default export */ var hg_footer_contact = (hg_footer_contact_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/partials/hg-footer/hg-footer-new.vue?vue&type=script&lang=js










const hg_footer_newvue_type_script_lang_js_locales = {
  de: {
    lang: 'de',
  },
  at: {
    lang: 'at',
  },
  ch: {
    lang: 'ch',
  },
  es: {
    lang: 'es',
  },
  nl: {
    lang: 'nl',
  },
}

/* harmony default export */ var hg_footer_newvue_type_script_lang_js = ({
  components: {
    HgFooterContact: hg_footer_contact,
    HgFooterScrollTop: hg_footer_scroll_top,
    HgFooterSocialMedia: hg_footer_social_media,
    HgFooterFootnote: hg_footer_footnote,
    HgFooterNewsletter: hg_footer_newsletter,
    HgFooterLists: hg_footer_lists,
    HgFooterPromotion: hg_footer_promotion,
  },
  props: {
    lang: {
      type: String,
      default: 'de',
    },
    phoneNr: {
      type: String,
      default: ''
    },
    agbLink: {
      type: String,
      default: ''
    },
    showAccessibilityDeclaration: {
      type: Boolean,
      default: false,
    },
    noCookieConsent: {
      type: Boolean,
      default: false,
    },
    noCookieLoader: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    locale: hg_footer_newvue_type_script_lang_js_locales.de,
  }),

  watch: {
    lang() {
      this.setLocale()
    },
  },
  methods: {
    setLocale() {
      this.locale = getLocale(hg_footer_newvue_type_script_lang_js_locales, this.lang)
    },
    cookieButtonClick() {
      window._sp_.gdpr.loadPrivacyManagerModal(this.$i18n.t('privacyManagerModalId'))
    },
  },
  created() {
    this.setLocale()
  },
});

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-new.vue?vue&type=script&lang=js
 /* harmony default export */ var hg_footer_hg_footer_newvue_type_script_lang_js = (hg_footer_newvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/partials/hg-footer/hg-footer-new.vue?vue&type=style&index=0&id=c5dde3c8&prod&lang=postcss&scoped=true
var hg_footer_newvue_type_style_index_0_id_c5dde3c8_prod_lang_postcss_scoped_true = __webpack_require__("767d");

// CONCATENATED MODULE: ./src/components/partials/hg-footer/hg-footer-new.vue






/* normalize component */

var hg_footer_new_component = normalizeComponent(
  hg_footer_hg_footer_newvue_type_script_lang_js,
  hg_footer_newvue_type_template_id_c5dde3c8_scoped_true_render,
  hg_footer_newvue_type_template_id_c5dde3c8_scoped_true_staticRenderFns,
  false,
  null,
  "c5dde3c8",
  null
  
)

/* harmony default export */ var hg_footer_new = (hg_footer_new_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-search-tabs.vue?vue&type=template&id=ccce72e6&scoped=true
var hg_search_tabsvue_type_template_id_ccce72e6_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tablist.length)?_c('div',{staticClass:"hg-search-tabs hg-reset"},[_c('div',{staticClass:"hg-search-tablist",attrs:{"role":"tablist","aria-orientation":_vm.orientation,"aria-label":_vm.label}},[_vm._l((_vm.tablist),function(tab,index){return [(tab.type === 'slot')?_c('button',{key:tab.data.key,ref:"tab",refInFor:true,staticClass:"hg-search-tab-button hg-button",attrs:{"aria-selected":index === _vm.activeIndex},on:{"keydown":_vm.onKeydown,"click":function($event){return _vm.click(index)}}},[(_vm.showIcon)?_c('hg-icon',{attrs:{"name":_vm.getIcon(tab.data.name)}}):_vm._e(),_c('span',[_vm._v(" "+_vm._s(tab.data.name)+" ")])],1):_c('a',{key:index,staticClass:"hg-search-tab-button hg-button",attrs:{"href":tab.data.link.url,"target":"_blank","rel":"noopener noreferrer"},on:{"click":function($event){return _vm.$emit('onLinkout', tab.data)}}},[(_vm.showIcon)?_c('hg-icon',{attrs:{"name":tab.data.link.icon}}):_vm._e(),_c('span',[_vm._v(" "+_vm._s(tab.data.link.label)+" ")])],1)]})],2),_c('div',{staticClass:"buttons"}),_vm._t("buttons"),_c('div',{staticClass:"hg-search-tab-content"},_vm._l((_vm.tablist),function(tab,index){return (tab.type === 'slot')?_c('div',{key:tab.data.key,class:[
        `hg-search-tab-panel--${index}`,
        'hg-search-tab-panel',
        { 'hg-search-tab-panel-switched': _vm.panelSwitched },
      ],attrs:{"id":`panel-${index}`,"aria-labelledby":`tab-${index}`,"hidden":index !== _vm.activeIndex,"role":"tabpanel"}},[_vm._t(tab.data.name)],2):_vm._e()}),0)],2):_vm._e()
}
var hg_search_tabsvue_type_template_id_ccce72e6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-search-tabs.vue?vue&type=template&id=ccce72e6&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-search-tabs.vue?vue&type=script&lang=js



/* harmony default export */ var hg_search_tabsvue_type_script_lang_js = ({
  props: {
    label: {
      type: String,
      default: '',
    },
    orientation: {
      type: String,
      default: 'horizontal',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    startingIndex: {
      type: Number,
      default: 0,
    },
    links: {
      type: Array,
      default: null,
    },
    panelSwitched: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: Number,
      default: null,
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    activeTab() {
      this.activeIndex = this.activeTab
    },
  },

  data: () => ({
    activeIndex: 0,
  }),

  computed: {
    tablist() {
      let items = []

      for (let slotName of Object.keys(this.$slots)) {
        items.push({
          type: 'slot',
          data: {
            key: slotName,
            name: slotName,
          },
        })
      }

      if (this.links) {
        for (let link of this.links) {
          let item = {
            type: 'link',
            data: {
              key: link.label,
              link,
            },
          }

          if (link.position != null) {
            items.splice(link.position, 0, item)
          } else {
            items.push(item)
          }
        }
      }

      return items
    },
  },

  mounted() {
    this.activeIndex = this.startingIndex
  },

  methods: {
    click(index) {
      this.$emit('onTabClicked', index)
      this.activeIndex = index
    },
    getIcon(tab) {
      switch (tab) {
        case 'Angebote':
          return 'star'
        case 'Bahnreisen':
          return 'train-subway'
        case 'Deals':
          return 'star'
        case 'Ofertas':
          return 'star'
        case 'Skireisen':
        case 'Wintersport':
          return 'wintersport'
        case 'Kurzreisen':
          return 'calendar-image'
        case 'Hotel':
        case 'Unterkunft':
        case 'Unterkünfte':
          return 'hotel'
        case 'Kreuzfahrten':
          return 'ship'
        case 'Rundreisen':
          return 'globe-americas'
        case 'Ferienwohnung':
        case 'Alquiler vacacional':
        case 'Vakantiehuizen':
          return 'home-alt'
        default:
          return 'deck-chair-sun'
      }
    },
    onKeydown(event) {
      const { keyCode } = event
      switch (keyCode) {
        case utils_keycodes.LEFT:
        case utils_keycodes.RIGHT:
        case utils_keycodes.UP:
        case utils_keycodes.DOWN:
          this.determineOrientation(event)
          break
      }
    },

    // Depending on the orientation only let UP/DOWN or LEFT/RIGHT keys proceed
    determineOrientation(event) {
      const { keyCode } = event
      let proceed = false
      if (this.orientation === 'vertical') {
        if (keyCode === utils_keycodes.UP || keyCode === utils_keycodes.DOWN) {
          event.preventDefault()
          proceed = true
        }
      } else {
        if (keyCode === utils_keycodes.LEFT || keyCode === utils_keycodes.RIGHT) {
          proceed = true
        }
      }
      if (proceed) {
        this.switchTabOnArrowPress(event)
        this.setFocus()
      }
    },

    switchTabOnArrowPress(event) {
      const keyCode = event.keyCode
      const directions = {
        [utils_keycodes.LEFT]: -1,
        [utils_keycodes.UP]: -1,
        [utils_keycodes.RIGHT]: 1,
        [utils_keycodes.DOWN]: 1,
      }

      if (!directions[keyCode]) return
      const nextIndex = this.activeIndex + directions[keyCode]
      if (nextIndex < 0) {
        this.activeIndex = this.$refs.tab.length - 1
      } else if (nextIndex >= this.$refs.tab.length) {
        this.activeIndex = 0
      } else {
        this.activeIndex = nextIndex
      }
    },

    setFocus() {
      this.$refs.tab[this.activeIndex].focus()
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-search-tabs.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_search_tabsvue_type_script_lang_js = (hg_search_tabsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-search-tabs.vue?vue&type=style&index=0&id=ccce72e6&prod&scoped=true&lang=postcss
var hg_search_tabsvue_type_style_index_0_id_ccce72e6_prod_scoped_true_lang_postcss = __webpack_require__("9bee");

// CONCATENATED MODULE: ./src/components/search/hg-search-tabs.vue






/* normalize component */

var hg_search_tabs_component = normalizeComponent(
  search_hg_search_tabsvue_type_script_lang_js,
  hg_search_tabsvue_type_template_id_ccce72e6_scoped_true_render,
  hg_search_tabsvue_type_template_id_ccce72e6_scoped_true_staticRenderFns,
  false,
  null,
  "ccce72e6",
  null
  
)

/* harmony default export */ var hg_search_tabs = (hg_search_tabs_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-deal-sort-filter.vue?vue&type=template&id=3e023578&scoped=true
var hg_deal_sort_filtervue_type_template_id_3e023578_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-deal-sort-filter"},[_c('div',[_c('hg-dropdown',{ref:"sortDropdown",attrs:{"trigger-color":"white"},on:{"onClick":_vm.selectSort},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [(_vm.currentSort)?[_c('span',[_vm._v(" "+_vm._s(_vm.currentSort.name)+" ")])]:[_c('span',{staticClass:"tw-mr-2"},[_vm._v(" Bitte wählen ")])]]},proxy:true}])},_vm._l((_vm.sortFilters),function(sort){return _c('button',{key:sort.value,staticClass:"dd-button",on:{"click":function($event){return _vm.selectSort(sort)}}},[_c('div',{staticClass:"tw-flex-col tw-items-start tw-text-left tw-px-2 tw-py-2"},[_c('span',{staticClass:"tw-block tw-font-bold tw-font-heading tw-leading-none"},[_vm._v(" "+_vm._s(sort.name)+" ")]),_c('small',{staticClass:"tw-text-gray-700"},[_vm._v(" "+_vm._s(sort.description)+" ")])])])}),0)],1),_c('div',[_c('div',{staticClass:"form-row form-row--addon"},[_c('hg-button',{class:['view-select', _vm.currentView === 'grid' && 'active'],attrs:{"size":"small","color":"transparent"},on:{"onClick":function($event){return _vm.selectView('grid')}}},[_c('hg-icon',{staticClass:"dd-icon",attrs:{"name":"th","pack":"fas","size":"small"}})],1),_c('hg-button',{class:['view-select', _vm.currentView === 'list' && 'active'],attrs:{"size":"small","color":"transparent"},on:{"onClick":function($event){return _vm.selectView('list')}}},[_c('hg-icon',{staticClass:"dd-icon",attrs:{"name":"bars","size":"small"}})],1)],1)])])
}
var hg_deal_sort_filtervue_type_template_id_3e023578_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-deal-sort-filter.vue?vue&type=template&id=3e023578&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-deal-sort-filter.vue?vue&type=script&lang=js



/* harmony default export */ var hg_deal_sort_filtervue_type_script_lang_js = ({
  components: {
    HgIcon: hg_icon,
  },
  props: {
    currentSort: {
      type: Object,
      default: () => {},
    },
    sortFilters: {
      type: Array,
      default: () => [],
    },
    currentView: {
      type: String,
      default: 'grid',
    },
  },
  methods: {
    selectSort(sort) {
      this.$emit('onSortSelected', sort)
      this.$refs.sortDropdown.close()
    },
    selectView(view) {
      this.$emit('onViewSelected', view)
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-deal-sort-filter.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_deal_sort_filtervue_type_script_lang_js = (hg_deal_sort_filtervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-deal-sort-filter.vue?vue&type=style&index=0&id=3e023578&prod&scoped=true&lang=postcss
var hg_deal_sort_filtervue_type_style_index_0_id_3e023578_prod_scoped_true_lang_postcss = __webpack_require__("65da");

// CONCATENATED MODULE: ./src/components/search/hg-deal-sort-filter.vue






/* normalize component */

var hg_deal_sort_filter_component = normalizeComponent(
  search_hg_deal_sort_filtervue_type_script_lang_js,
  hg_deal_sort_filtervue_type_template_id_3e023578_scoped_true_render,
  hg_deal_sort_filtervue_type_template_id_3e023578_scoped_true_staticRenderFns,
  false,
  null,
  "3e023578",
  null
  
)

/* harmony default export */ var hg_deal_sort_filter = (hg_deal_sort_filter_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-ibe-search.vue?vue&type=template&id=42ba11c8&scoped=true
var hg_ibe_searchvue_type_template_id_42ba11c8_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-ibe-search"},[_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"defaultValue":_vm.defaultDestinationName,"isMobile":_vm.isMobile,"isLoading":_vm.isLoadingDestinations,"label":_vm.$t('ibeSearch.destinationLabel'),"placeholder":_vm.$t('ibeSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ibeSearch.destinationResult')},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"position":"bottom daterange","placeholder":_vm.$t('ibeSearch.dateRangePlaceholder'),"label":_vm.$t('ibeSearch.dateRangeLabel'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row form-row--duration"},[_c('HgTravelDurationSelect',{attrs:{"label":_vm.$t('ibeSearch.durationLabel'),"placeholder":_vm.$t('ibeSearch.durationPlaceholder'),"is-mobile":_vm.isMobile,"options":_vm.$t('ibeSearchControls.durationOptions')},on:{"onSelectTravelDuration":_vm.selectTravelDuration}})],1),_c('div',{staticClass:"form-row form-row--airports"},[_c('HgAirportSelect',{attrs:{"is-mobile":_vm.isMobile,"airports":_vm.airports,"searched-airports":_vm.searchedAirports,"placeholder":_vm.$t('ibeSearch.airportPlaceholder'),"label":_vm.$t('ibeSearch.airportLabel.without')},on:{"onChangeAirportTerm":function($event){return _vm.$emit('onChangeAirportTerm', arguments[0])},"onSelectAirports":_vm.selectAirports}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"show-errors":"","max-children":4,"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder')},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('HgButton',{attrs:{"size":"full","color":"teal","tag":"a","target":"_blank","disabled":_vm.loading,"rel":"nofollow","href":_vm.ibeUrl},on:{"onClick":_vm.submit}},[(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")]:_c('HgLoadingBubble')],2)],1)])
}
var hg_ibe_searchvue_type_template_id_42ba11c8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-ibe-search.vue?vue&type=template&id=42ba11c8&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-ibe-search.vue?vue&type=script&lang=js


// import locale from 'date-fns/locale/de'


/* harmony default export */ var hg_ibe_searchvue_type_script_lang_js = ({
  components: { hgDatepicker: hg_datepicker },
  props: {
    defaultRegionId: Number,
    defaultCountryId: String,
    defaultDestinationName: {
      type: String,
      default: '',
    },
    defaultAdults: {
      type: Number,
      default: 2,
    },
    defaultDateRelative: {
      type: Number,
      default: 0,
    },
    defaultDuration: {
      type: String,
      default: '',
    },
    airports: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
    ibeUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    searchedAirports: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data: () => ({
    selectedDestination: null,
    selectedDateRange: null,
    selectedAirports: null,
    selectedDuration: null,
    selectedTravelers: null,
    selectedTags: null,
    initialStartDate: null,
    initialEndDate: null,
  }),

  created() {
    if (this.defaultRegionId) {
      if (['10000', '10001', '10005'].includes(this.defaultRegionId)) {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Region',
        }
      } else {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          regionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Destination',
        }
      }
    } else if (this.defaultCountryId) {
      this.selectedDestination = {
        id: this.defaultCountryId,
        countryISO3166: this.defaultCountryId,
        name: this.defaultDestinationName,
        type: 'Country',
      }
    }

    if (this.defaultDateRelative > 0) {
      this.setInitialDatesToRelative()
    } else {
      this.setInitialDatesToSummer()
    }
  },

  methods: {
    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    selectAirports(airports) {
      this.selectedAirports = airports
      this.update()
    },

    selectTags(tags) {
      this.selectedTags = tags
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = dateRange
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        airports: this.selectedAirports,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
        tags: this.selectedTags,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', {
        destination: this.selectedDestination,
        airports: this.selectedAirports,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
        tags: this.selectedTags,
      })
    },

    setInitialDatesToRelative() {
      const today = new Date()
      const new_today = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(new_today, 1)
      this.initialEndDate = addDays(new_today, this.defaultDateRelative)
    },

    setInitialDatesToSummer() {
      const today = new Date()
      const thisYear = today.getFullYear()
      const nextYear = thisYear + 1

      const startOfThisSummer = new Date(thisYear, 5, 1)
      const endOfThisSummer = new Date(thisYear, 8, 0)
      const startOfNextSummer = new Date(nextYear, 5, 1)
      const endOfNextSummer = new Date(nextYear, 8, 0)

      if (isBefore(today, startOfThisSummer)) {
        this.initialStartDate = startOfThisSummer
        this.initialEndDate = endOfThisSummer
      } else if (isAfter(today, endOfThisSummer)) {
        this.initialStartDate = startOfNextSummer
        this.initialEndDate = endOfNextSummer
      } else {
        this.initialStartDate = addDays(today, 1)
        this.initialEndDate = addMonths(today, 3)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-ibe-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_ibe_searchvue_type_script_lang_js = (hg_ibe_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-ibe-search.vue?vue&type=style&index=0&id=42ba11c8&prod&lang=postcss&scoped=true
var hg_ibe_searchvue_type_style_index_0_id_42ba11c8_prod_lang_postcss_scoped_true = __webpack_require__("6ee2");

// CONCATENATED MODULE: ./src/components/search/hg-ibe-search.vue






/* normalize component */

var hg_ibe_search_component = normalizeComponent(
  search_hg_ibe_searchvue_type_script_lang_js,
  hg_ibe_searchvue_type_template_id_42ba11c8_scoped_true_render,
  hg_ibe_searchvue_type_template_id_42ba11c8_scoped_true_staticRenderFns,
  false,
  null,
  "42ba11c8",
  null
  
)

/* harmony default export */ var hg_ibe_search = (hg_ibe_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-ski-search.vue?vue&type=template&id=3fcc6cce&scoped=true
var hg_ski_searchvue_type_template_id_3fcc6cce_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hg-ski-search"},[_c('div',{staticClass:"form-row"},[_c('HgDestinationSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"isMobile":_vm.isMobile,"label":_vm.$t('skiSearch.destinationLabel'),"placeholder":_vm.$t('skiSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ibeSearch.destinationResult')},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"label":_vm.$t('ibeSearch.dateRangeLabel'),"palceholder":_vm.$t('ibeSearch.dateRangePlaceholder'),"initial-start-date":_vm.startDate,"initial-end-date":_vm.endDate},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row"},[_c('HgTravelDurationSelect',{attrs:{"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.durationLabel'),"placeholder":_vm.$t('ibeSearch.durationPlaceholder'),"options":_vm.$t('skiSearchControls.durationOptions')},on:{"onSelectTravelDuration":_vm.updateTravelDuration}})],1),_c('div',{staticClass:"form-row"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"is-mobile":_vm.isMobile,"max-adults":8,"max-children":8,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder')},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('div',{staticClass:"ski-submit hg-control"},[_c('HgButton',{attrs:{"disabled":!_vm.searchUrl.length,"size":"full","color":"teal","tag":"a","target":"_blank","href":_vm.searchUrl},on:{"onClick":_vm.submit}},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")])],1)])])])
}
var hg_ski_searchvue_type_template_id_3fcc6cce_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-ski-search.vue?vue&type=template&id=3fcc6cce&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-ski-search.vue?vue&type=script&lang=js





/* harmony default export */ var hg_ski_searchvue_type_script_lang_js = ({
  components: { HgDatepicker: hg_datepicker },
  props: {
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    airports: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
    searchUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    dates: {
      type: Object,
      default: () => ({ startDate: null, relativeEndDays: null }),
    },
  },

  data: () => ({
    selectedDestination: null,
    selectedDateRange: null,
    selectedDuration: null,
    selectedTravelers: null,
    startDate: null,
    endDate: null,
  }),

  created() {
    this.setDates()
  },

  methods: {
    setDates() {
      if (this.dates.startDate && this.dates.relativeEndDays) {
        this.startDate = this.dates.startDate
        this.endDate = addDays(this.startDate, this.dates.relativeEndDays)
      } else if (this.dates.startDate) {
        this.startDate = this.dates.startDate
        this.endDate = addDays(this.startDate, this.dates.relativeEndDays)
      }
      {
        this.startDate = new Date().setHours(24)
      }
    },

    updateTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = dateRange
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', this.form)
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-ski-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_ski_searchvue_type_script_lang_js = (hg_ski_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-ski-search.vue?vue&type=style&index=0&id=3fcc6cce&prod&lang=postcss&scoped=true
var hg_ski_searchvue_type_style_index_0_id_3fcc6cce_prod_lang_postcss_scoped_true = __webpack_require__("e7e8");

// CONCATENATED MODULE: ./src/components/search/hg-ski-search.vue






/* normalize component */

var hg_ski_search_component = normalizeComponent(
  search_hg_ski_searchvue_type_script_lang_js,
  hg_ski_searchvue_type_template_id_3fcc6cce_scoped_true_render,
  hg_ski_searchvue_type_template_id_3fcc6cce_scoped_true_staticRenderFns,
  false,
  null,
  "3fcc6cce",
  null
  
)

/* harmony default export */ var hg_ski_search = (hg_ski_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-short-trip-search.vue?vue&type=template&id=77f91d9c&scoped=true
var hg_short_trip_searchvue_type_template_id_77f91d9c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hg-short-trip-search"},[_c('div',{staticClass:"form-row"},[_c('HgDestinationSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"isMobile":_vm.isMobile,"label":_vm.$t('shortTripSearch.destinationLabel'),"placeholder":_vm.$t('shortTripSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('shortTripSearch.noResult'),"theme":_vm.theme},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"label":_vm.$t('ibeSearch.dateRangeLabel'),"palceholder":_vm.$t('ibeSearch.dateRangePlaceholder'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate,"theme":_vm.theme},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder'),"max-adults":8,"max-children":6,"theme":_vm.theme},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('div',{staticClass:"short-trip-submit hg-control"},[_c('HgButton',{attrs:{"disabled":!_vm.searchUrl.length,"size":"full","color":_vm.submitButtonColor,"tag":"a","target":"_blank","href":_vm.searchUrl},on:{"onClick":_vm.submit}},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")])],1)]),(_vm.showCooperation)?_c('div',{staticClass:"form-row form-row--cooperation"},[_c('p',[_vm._v("in Kooperation mit")]),_c('GuruLogoPlain',{staticStyle:{"height":"28px"}})],1):_vm._e()])])
}
var hg_short_trip_searchvue_type_template_id_77f91d9c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-short-trip-search.vue?vue&type=template&id=77f91d9c&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-short-trip-search.vue?vue&type=script&lang=js




/* harmony default export */ var hg_short_trip_searchvue_type_script_lang_js = ({
  components: { HgDatepicker: hg_datepicker },
  props: {
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    locations: {
      type: Array,
      default: () => [],
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    recommendations: {
      type: Array,
      default: () => [],
    },
    searchUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    showCooperation: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null
    }
  },
  data: () => ({
    selectedDestination: null,
    selectedDateRange: null,
    selectedTravelers: null,
    initialStartDate: null,
    initialEndDate: null,
  }),
  computed: {
    submitButtonColor() {
      switch (this.theme) {
        case 'bild':
          return 'bild-green'
        case '5vf':
          return '5vf'
        default:
          return 'teal'
      }
    },
  },
  created() {
    this.setInitialDates()
  },
  methods: {
    setInitialDates() {
      const today = startOfToday()
      const newToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(newToday, 2)
      this.initialEndDate = addDays(newToday, 4)

      this.selectedDateRange = {
        start: this.initialStartDate,
        end: this.initialEndDate
      }
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = dateRange
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        dateRange: this.selectedDateRange,
        travelers: this.selectedTravelers,
      })
    },

    submit() {
      this.$emit('onTriggerSearch')
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-short-trip-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_short_trip_searchvue_type_script_lang_js = (hg_short_trip_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-short-trip-search.vue?vue&type=style&index=0&id=77f91d9c&prod&lang=postcss&scoped=true
var hg_short_trip_searchvue_type_style_index_0_id_77f91d9c_prod_lang_postcss_scoped_true = __webpack_require__("0812");

// CONCATENATED MODULE: ./src/components/search/hg-short-trip-search.vue






/* normalize component */

var hg_short_trip_search_component = normalizeComponent(
  search_hg_short_trip_searchvue_type_script_lang_js,
  hg_short_trip_searchvue_type_template_id_77f91d9c_scoped_true_render,
  hg_short_trip_searchvue_type_template_id_77f91d9c_scoped_true_staticRenderFns,
  false,
  null,
  "77f91d9c",
  null
  
)

/* harmony default export */ var hg_short_trip_search = (hg_short_trip_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-watado-search.vue?vue&type=template&id=3c36e99a&scoped=true
var hg_watado_searchvue_type_template_id_3c36e99a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-watado-search"},[_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"isMobile":_vm.isMobile,"isLoading":_vm.isLoadingDestinations,"label":_vm.$t('watadoSearch.destinationLabel'),"placeholder":_vm.$t('watadoSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ibeSearch.destinationResult'),"theme":_vm.theme},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"label":_vm.$t('ibeSearch.dateRangeLabel'),"palceholder":_vm.$t('ibeSearch.dateRangePlaceholder'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate,"theme":_vm.theme},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row form-row--duration"},[_c('HgTravelDurationSelect',{attrs:{"label":_vm.$t('ibeSearch.durationLabel'),"placeholder":_vm.$t('ibeSearch.durationPlaceholder'),"is-mobile":_vm.isMobile,"options":_vm.$t('ibeSearchControls.durationOptions'),"defaultValue":_vm.defaultDuration,"theme":_vm.theme},on:{"onSelectTravelDuration":_vm.selectTravelDuration}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"showErrors":"","is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder'),"roomLabel":_vm.roomLabel,"infoTextSingleRoom":_vm.infoTextSingleRoom,"infoTextSingles":_vm.infoTextSingles,"infoTextSingleRoomMultiple":_vm.infoTextSingleRoomMultiple,"infoTextMultipleSingular":_vm.infoTextMultipleSingular,"infoTextMultiplePlural":_vm.infoTextMultiplePlural,"showRooms":_vm.showRooms,"limitRooms":true,"theme":_vm.theme},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('div',{staticClass:"ski-submit hg-control"},[_c('HgButton',{attrs:{"size":"full","color":_vm.submitButtonColor,"tag":"a","target":"_blank","href":_vm.searchUrl},on:{"onClick":_vm.submit}},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")])],1)])])
}
var hg_watado_searchvue_type_template_id_3c36e99a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-watado-search.vue?vue&type=template&id=3c36e99a&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-watado-search.vue?vue&type=script&lang=js




/* harmony default export */ var hg_watado_searchvue_type_script_lang_js = ({
  components: { HgDatepicker: hg_datepicker },

  props: {
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    searchUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    defaultDuration: {
      type: String,
      default: '7',
    },
    roomLabel: {
      type: String,
      default: 'Rooms',
    },
    infoTextSingleRoom: {
      type: String,
    },
    infoTextSingles: {
      type: String,
    },
    infoTextSingleRoomMultiple: {
      type: String,
    },
    infoTextMultipleSingular: {
      type: String,
    },
    infoTextMultiplePlural: {
      type: String,
    },
    showRooms: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    selectedDestination: null,
    selectedDateRange: null,
    selectedTravelers: null,
    selectedDuration: '7',
    initialStartDate: null,
    initialEndDate: null,
  }),

  computed: {
    submitButtonColor() {
      switch (this.theme) {
        case 'bild':
          return 'bild-green'
        case '5vf':
          return '5vf'
        default:
          return 'teal'
      }
    },
  },

  created() {
    this.setInitialDates()
  },

  methods: {
    setInitialDatesToSummer() {
      const today = startOfToday()
      const thisYear = today.getFullYear()
      const nextYear = thisYear + 1

      const startOfThisSummer = new Date(thisYear, 5, 1)
      const endOfThisSummer = new Date(thisYear, 11, 0)
      const startOfNextSummer = new Date(nextYear, 5, 1)
      const endOfNextSummer = new Date(nextYear, 8, 0)

      if (isBefore(today, startOfThisSummer)) {
        this.initialStartDate = startOfThisSummer
        this.initialEndDate = endOfThisSummer
      } else if (
        isAfter(today, startOfThisSummer) &&
        isBefore(today, endOfThisSummer)
      ) {
        this.initialStartDate = addDays(new Date(), 2)
        this.initialEndDate = addMonths(new Date(), 3)
      } else if (isAfter(today, endOfThisSummer)) {
        this.initialStartDate = startOfNextSummer
        this.initialEndDate = endOfNextSummer
      } else {
        this.initialStartDate = addDays(today, 1)
        this.initialEndDate = addMonths(today, 3)
      }
    },

    setInitialDates() {
      const today = startOfToday()
      const newToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(newToday, 1)
      this.initialEndDate = addMonths(newToday, 6)
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = dateRange
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        dateRange: this.selectedDateRange,
        travelers: this.selectedTravelers,
        duration: this.selectedDuration,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', this.form)
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-watado-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_watado_searchvue_type_script_lang_js = (hg_watado_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-watado-search.vue?vue&type=style&index=0&id=3c36e99a&prod&lang=postcss&scoped=true
var hg_watado_searchvue_type_style_index_0_id_3c36e99a_prod_lang_postcss_scoped_true = __webpack_require__("3de7");

// CONCATENATED MODULE: ./src/components/search/hg-watado-search.vue






/* normalize component */

var hg_watado_search_component = normalizeComponent(
  search_hg_watado_searchvue_type_script_lang_js,
  hg_watado_searchvue_type_template_id_3c36e99a_scoped_true_render,
  hg_watado_searchvue_type_template_id_3c36e99a_scoped_true_staticRenderFns,
  false,
  null,
  "3c36e99a",
  null
  
)

/* harmony default export */ var hg_watado_search = (hg_watado_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-deal-dropdown-search.vue?vue&type=template&id=0a1aeabe&scoped=true
var hg_deal_dropdown_searchvue_type_template_id_0a1aeabe_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal-search"},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"form-row--addon form-row-search-input"},[_c('HgDealSearchDropdown',{attrs:{"isMobile":_vm.isMobile,"term":_vm.term,"placeholder":_vm.$t('dealSearch.placeholder'),"label-highlight-tags":_vm.$t('dealSearch.labelHighlightTags'),"label-deals":_vm.$t('dealSearch.labelDeals'),"options":_vm.isInitialSearch ? _vm.tags : _vm.searchTags},on:{"onUpdateSearchTerm":function($event){return _vm.$emit('onUpdateSearchTerm', arguments[0])},"onTriggerSearch":function($event){return _vm.$emit('onTriggerSearch', arguments[0])}}})],1)])])
}
var hg_deal_dropdown_searchvue_type_template_id_0a1aeabe_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-deal-dropdown-search.vue?vue&type=template&id=0a1aeabe&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-deal-dropdown-search.vue?vue&type=script&lang=js

/* harmony default export */ var hg_deal_dropdown_searchvue_type_script_lang_js = ({
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    term: {
      type: String,
      default: '',
    },
    isInitialSearch: {
      type: Boolean,
      default: true,
    },
    searchTags: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-deal-dropdown-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_deal_dropdown_searchvue_type_script_lang_js = (hg_deal_dropdown_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-deal-dropdown-search.vue?vue&type=style&index=0&id=0a1aeabe&prod&scoped=true&lang=postcss
var hg_deal_dropdown_searchvue_type_style_index_0_id_0a1aeabe_prod_scoped_true_lang_postcss = __webpack_require__("bc6f");

// CONCATENATED MODULE: ./src/components/search/hg-deal-dropdown-search.vue






/* normalize component */

var hg_deal_dropdown_search_component = normalizeComponent(
  search_hg_deal_dropdown_searchvue_type_script_lang_js,
  hg_deal_dropdown_searchvue_type_template_id_0a1aeabe_scoped_true_render,
  hg_deal_dropdown_searchvue_type_template_id_0a1aeabe_scoped_true_staticRenderFns,
  false,
  null,
  "0a1aeabe",
  null
  
)

/* harmony default export */ var hg_deal_dropdown_search = (hg_deal_dropdown_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-mobile-search.vue?vue&type=template&id=01eb1545
var hg_mobile_searchvue_type_template_id_01eb1545_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hg-text-input',{attrs:{"teal":"","type":"text","expanded":"","value":_vm.searchTerm,"placeholder":_vm.$t('dealSearch.placeholder'),"label-position":"outside","allow-submit-event":""},on:{"input":_vm.updateSearchTerm,"submit":_vm.search,"focus":function($event){_vm.focusActive = true},"blur":function($event){_vm.focusActive = false}}}),_c('hg-button',{staticClass:"tw-px-8 md:tw-px-12",attrs:{"color":"teal","aria-label":"search button"},on:{"onClick":_vm.search}})],1)
}
var hg_mobile_searchvue_type_template_id_01eb1545_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-mobile-search.vue?vue&type=template&id=01eb1545

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-mobile-search.vue?vue&type=script&lang=js

/* harmony default export */ var hg_mobile_searchvue_type_script_lang_js = ({
  data: () => ({
    searchTerm: '',
    activeTagIds: [],
    timerId: null,
    focusActive: false,
  }),

  methods: {
    updateSearchTerm(value) {
      this.searchTerm = value
    },
    search() {},
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-mobile-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_mobile_searchvue_type_script_lang_js = (hg_mobile_searchvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/search/hg-mobile-search.vue





/* normalize component */

var hg_mobile_search_component = normalizeComponent(
  search_hg_mobile_searchvue_type_script_lang_js,
  hg_mobile_searchvue_type_template_id_01eb1545_render,
  hg_mobile_searchvue_type_template_id_01eb1545_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_mobile_search = (hg_mobile_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-partner-slider.vue?vue&type=template&id=21f543e0&scoped=true
var hg_partner_slidervue_type_template_id_21f543e0_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-relative"},[_c('h5',{staticClass:"hg-title tw-mb-4 tw-select-none"},[_vm._v(" "+_vm._s(_vm.partners.headline)+" ")]),_c('Flicking',{ref:"flicking",staticClass:"hg-flicking-container",attrs:{"options":_vm.flickingOptions,"plugins":_vm.plugins}},_vm._l((_vm.partners.data),function(partner){return _c('hg-flicking-slide',{key:partner.label,staticClass:"tw-mr-4"},[_c('div',{staticClass:"partner"},[_c('div',{staticClass:"partner-name"},[_vm._v(" "+_vm._s(partner.label)+" ")]),_c('hg-image',{staticClass:"partner-image",attrs:{"src":partner.image,"alt":partner.sub}})],1)])}),1),_c('span',{staticClass:"flicking-arrow-prev hg-button hg-button--teal hg-button--rounded flicking-arrow-prev-partner-slider"},[_c('HgIcon',{attrs:{"name":"chevron-left","size":"small"}})],1),_c('span',{staticClass:"flicking-arrow-next hg-button hg-button--teal hg-button--rounded flicking-arrow-next-partner-slider"},[_c('HgIcon',{attrs:{"name":"chevron-right","size":"small"}})],1)],1)
}
var hg_partner_slidervue_type_template_id_21f543e0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-partner-slider.vue?vue&type=template&id=21f543e0&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-partner-slider.vue?vue&type=script&lang=js




/* harmony default export */ var hg_partner_slidervue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  props: {
    partners: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    flickingId: crypto.randomUUID(),
    plugins: [
      new plugins_esm_Arrow({
        parentEl: document.body,
        prevElSelector: '.flicking-arrow-prev-partner-slider',
        nextElSelector: '.flicking-arrow-next-partner-slider',
      }),
    ],
    flickingOptions: {
      align: 'prev',
      defaultIndex: 0,
      horizontal: true,
      circular: true,
      bound: false,
      renderOnlyVisible: false,
      adaptive: false,
      deceleration: 0.0075,
      duration: 500,
      threshold: 40,
      moveType: 'snap',
    },
  }),
});

// CONCATENATED MODULE: ./src/components/search/hg-partner-slider.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_partner_slidervue_type_script_lang_js = (hg_partner_slidervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-partner-slider.vue?vue&type=style&index=0&id=21f543e0&prod&scoped=true&lang=postcss
var hg_partner_slidervue_type_style_index_0_id_21f543e0_prod_scoped_true_lang_postcss = __webpack_require__("2a77");

// CONCATENATED MODULE: ./src/components/search/hg-partner-slider.vue






/* normalize component */

var hg_partner_slider_component = normalizeComponent(
  search_hg_partner_slidervue_type_script_lang_js,
  hg_partner_slidervue_type_template_id_21f543e0_scoped_true_render,
  hg_partner_slidervue_type_template_id_21f543e0_scoped_true_staticRenderFns,
  false,
  null,
  "21f543e0",
  null
  
)

/* harmony default export */ var hg_partner_slider = (hg_partner_slider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-vakantiediscounter-package-tour-search.vue?vue&type=template&id=57ea2242&scoped=true
var hg_vakantiediscounter_package_tour_searchvue_type_template_id_57ea2242_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-ibe-search"},[_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"defaultValue":_vm.defaultDestinationName,"isMobile":_vm.isMobile,"label":_vm.$t('ibeSearch.destinationLabel'),"placeholder":_vm.$t('ibeSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ibeSearch.destinationResult')},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('HgSingleDatepicker',{attrs:{"isMobile":_vm.isMobile,"position":"bottom daterange","placeholder":_vm.$t('ibeSearch.dateRangeStartPlaceholder'),"label":_vm.$t('ibeSearch.chooseDate'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate},on:{"onDateSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row form-row--duration"},[_c('HgTravelDurationSelect',{attrs:{"label":_vm.$t('ibeSearch.durationLabel'),"placeholder":_vm.$t('ibeSearch.durationPlaceholder'),"is-mobile":_vm.isMobile,"singleAirport":true,"options":_vm.$t('ibeSearchControls.durationOptions')},on:{"onSelectTravelDuration":_vm.selectTravelDuration}})],1),_c('div',{staticClass:"form-row form-row--airports"},[_c('HgAirportSelect',{attrs:{"is-mobile":_vm.isMobile,"airports":_vm.airports,"searched-airports":_vm.searchedAirports,"placeholder":_vm.$t('ibeSearch.airportPlaceholder'),"label":_vm.$t('ibeSearch.airportLabel.without')},on:{"onChangeAirportTerm":function($event){return _vm.$emit('onChangeAirportTerm', arguments[0])},"onSelectAirports":_vm.selectAirports}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"show-errors":false,"max-children":4,"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder')},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('HgButton',{attrs:{"size":"full","color":"teal","tag":"a","target":"_blank","disabled":_vm.loading || _vm.selectedDate === null || _vm.selectedDestination === null,"rel":"nofollow","href":_vm.searchUrl},on:{"onClick":_vm.submit}},[(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")]:_c('HgLoadingBubble')],2)],1)])
}
var hg_vakantiediscounter_package_tour_searchvue_type_template_id_57ea2242_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-vakantiediscounter-package-tour-search.vue?vue&type=template&id=57ea2242&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-vakantiediscounter-package-tour-search.vue?vue&type=script&lang=js




/* harmony default export */ var hg_vakantiediscounter_package_tour_searchvue_type_script_lang_js = ({
  components: { hgDatepicker: hg_datepicker },
  props: {
    defaultRegionId: Number,
    defaultCountryId: String,
    defaultDestinationName: {
      type: String,
      default: '',
    },
    defaultAdults: {
      type: Number,
      default: 2,
    },
    defaultDateRelative: {
      type: Number,
      default: 0,
    },
    defaultDuration: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    airports: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
    searchUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    searchedAirports: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data: () => ({
    selectedDestination: null,
    selectedDate: null,
    selectedAirports: [],
    selectedDuration: null,
    selectedTravelers: null,
    selectedTags: null,
    initialStartDate: null,
    initialEndDate: null,
  }),

  created() {
    this.selectedDate = format(new Date(), 'yyyy-MM-dd')

    if (this.defaultRegionId) {
      if (['10000', '10001', '10005'].includes(this.defaultRegionId)) {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Region',
        }
      } else {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          regionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Destination',
        }
      }
    } else if (this.defaultCountryId) {
      this.selectedDestination = {
        id: this.defaultCountryId,
        countryISO3166: this.defaultCountryId,
        name: this.defaultDestinationName,
        type: 'Country',
      }
    }

    if (this.defaultDateRelative > 0) {
      this.setInitialDatesToRelative()
    } else {
      this.setInitialDatesToSummer()
    }
  },

  methods: {
    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    selectAirports(airports) {
      this.selectedAirports = airports
      this.update()
    },

    selectTags(tags) {
      this.selectedTags = tags
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDate = dateRange.start
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        airports: this.selectedAirports.map((airport) => airport.iataCode),
        startDate: this.selectedDate,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', {
        destination: this.selectedDestination,
        airports: this.selectedAirports.map((airport) => airport.iataCode),
        startDate: this.selectedDate,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
      })
    },

    setInitialDatesToRelative() {
      const today = startOfToday()
      const new_today = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(new_today, 1)
      this.initialEndDate = addDays(new_today, this.defaultDateRelative)
    },

    setInitialDatesToSummer() {
      const today = startOfToday()
      const thisYear = today.getFullYear()
      const nextYear = thisYear + 1

      const startOfThisSummer = new Date(thisYear, 5, 1)
      const endOfThisSummer = new Date(thisYear, 8, 0)
      const startOfNextSummer = new Date(nextYear, 5, 1)
      const endOfNextSummer = new Date(nextYear, 8, 0)

      if (isBefore(today, startOfThisSummer)) {
        this.initialStartDate = startOfThisSummer
        this.initialEndDate = endOfThisSummer
      } else if (isAfter(today, endOfThisSummer)) {
        this.initialStartDate = startOfNextSummer
        this.initialEndDate = endOfNextSummer
      } else {
        this.initialStartDate = addDays(today, 1)
        this.initialEndDate = addMonths(today, 3)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-vakantiediscounter-package-tour-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_vakantiediscounter_package_tour_searchvue_type_script_lang_js = (hg_vakantiediscounter_package_tour_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-vakantiediscounter-package-tour-search.vue?vue&type=style&index=0&id=57ea2242&prod&lang=postcss&scoped=true
var hg_vakantiediscounter_package_tour_searchvue_type_style_index_0_id_57ea2242_prod_lang_postcss_scoped_true = __webpack_require__("2c30");

// CONCATENATED MODULE: ./src/components/search/hg-vakantiediscounter-package-tour-search.vue






/* normalize component */

var hg_vakantiediscounter_package_tour_search_component = normalizeComponent(
  search_hg_vakantiediscounter_package_tour_searchvue_type_script_lang_js,
  hg_vakantiediscounter_package_tour_searchvue_type_template_id_57ea2242_scoped_true_render,
  hg_vakantiediscounter_package_tour_searchvue_type_template_id_57ea2242_scoped_true_staticRenderFns,
  false,
  null,
  "57ea2242",
  null
  
)

/* harmony default export */ var hg_vakantiediscounter_package_tour_search = (hg_vakantiediscounter_package_tour_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-logitravel-package-tour-search.vue?vue&type=template&id=52840c71&scoped=true
var hg_logitravel_package_tour_searchvue_type_template_id_52840c71_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-ibe-search"},[_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"defaultValue":_vm.defaultDestinationName,"isMobile":_vm.isMobile,"label":_vm.$t('ibeSearch.destinationLabel'),"placeholder":_vm.$t('ibeSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ibeSearch.destinationResult')},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"position":"bottom daterange","placeholder":_vm.$t('ibeSearch.dateRangeStartPlaceholder'),"label":_vm.$t('ibeSearch.chooseDate'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row form-row--airports"},[_c('HgAirportSelect',{attrs:{"is-mobile":_vm.isMobile,"airports":_vm.airports,"singleAirport":true,"searched-airports":_vm.searchedAirports,"placeholder":_vm.$t('ibeSearch.airportPlaceholder'),"label":_vm.$t('ibeSearch.airportLabel.without')},on:{"onChangeAirportTerm":function($event){return _vm.$emit('onChangeAirportTerm', arguments[0])},"onSelectAirports":_vm.selectAirports}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"show-errors":false,"max-children":4,"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder')},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('HgButton',{attrs:{"size":"full","color":"teal","tag":"a","target":"_blank","disabled":_vm.loading || _vm.isButtonDisabled,"rel":"nofollow","href":_vm.searchUrl},on:{"onClick":_vm.submit}},[(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")]:_c('HgLoadingBubble')],2)],1)])
}
var hg_logitravel_package_tour_searchvue_type_template_id_52840c71_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-logitravel-package-tour-search.vue?vue&type=template&id=52840c71&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-logitravel-package-tour-search.vue?vue&type=script&lang=js




/* harmony default export */ var hg_logitravel_package_tour_searchvue_type_script_lang_js = ({
  components: { HgDatepicker: hg_datepicker },
  props: {
    defaultRegionId: Number,
    defaultCountryId: String,
    defaultDestinationName: {
      type: String,
      default: '',
    },
    defaultAdults: {
      type: Number,
      default: 2,
    },
    defaultDateRelative: {
      type: Number,
      default: 0,
    },
    defaultDuration: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    airports: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
    searchUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    searchedAirports: {
      type: Array,
      required: true,
      default: () => [],
    },
    isButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    selectedDestination: null,
    selectedDate: null,
    selectedAirports: [],
    selectedDuration: null,
    selectedTravelers: null,
    selectedTags: null,
    initialStartDate: null,
    initialEndDate: null,
  }),

  created() {
    this.selectedDate = format(new Date(), 'yyyy-MM-dd')

    if (this.defaultRegionId) {
      if (['10000', '10001', '10005'].includes(this.defaultRegionId)) {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Region',
        }
      } else {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          regionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Destination',
        }
      }
    } else if (this.defaultCountryId) {
      this.selectedDestination = {
        id: this.defaultCountryId,
        countryISO3166: this.defaultCountryId,
        name: this.defaultDestinationName,
        type: 'Country',
      }
    }

    if (this.defaultDateRelative > 0) {
      this.setInitialDatesToRelative()
    } else {
      this.setInitialDatesToSummer()
    }
  },

  methods: {
    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    selectAirports(airports) {
      this.selectedAirports = airports
      this.update()
    },

    selectTags(tags) {
      this.selectedTags = tags
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDate = dateRange
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        airports: this.selectedAirports.map((airport) => airport.iataCode),
        startDate: this.selectedDate,
        travelers: this.selectedTravelers,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', {
        destination: this.selectedDestination,
        airports: this.selectedAirports.map((airport) => airport.iataCode),
        startDate: this.selectedDate,
        travelers: this.selectedTravelers,
      })
    },

    setInitialDatesToRelative() {
      const today = startOfToday()
      const new_today = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(new_today, 2)
      this.initialEndDate = addDays(new_today, this.defaultDateRelative)
    },

    setInitialDatesToSummer() {
      const today = startOfToday()
      const thisYear = today.getFullYear()
      const nextYear = thisYear + 1

      const startOfThisSummer = new Date(thisYear, 5, 1)
      const endOfThisSummer = new Date(thisYear, 8, 0)
      const startOfNextSummer = new Date(nextYear, 5, 1)
      const endOfNextSummer = new Date(nextYear, 8, 0)

      if (isBefore(today, startOfThisSummer)) {
        this.initialStartDate = startOfThisSummer
        this.initialEndDate = endOfThisSummer
      } else if (isAfter(today, endOfThisSummer)) {
        this.initialStartDate = startOfNextSummer
        this.initialEndDate = endOfNextSummer
      } else {
        this.initialStartDate = addDays(today, 1)
        this.initialEndDate = addMonths(today, 3)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-logitravel-package-tour-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_logitravel_package_tour_searchvue_type_script_lang_js = (hg_logitravel_package_tour_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-logitravel-package-tour-search.vue?vue&type=style&index=0&id=52840c71&prod&lang=postcss&scoped=true
var hg_logitravel_package_tour_searchvue_type_style_index_0_id_52840c71_prod_lang_postcss_scoped_true = __webpack_require__("e138");

// CONCATENATED MODULE: ./src/components/search/hg-logitravel-package-tour-search.vue






/* normalize component */

var hg_logitravel_package_tour_search_component = normalizeComponent(
  search_hg_logitravel_package_tour_searchvue_type_script_lang_js,
  hg_logitravel_package_tour_searchvue_type_template_id_52840c71_scoped_true_render,
  hg_logitravel_package_tour_searchvue_type_template_id_52840c71_scoped_true_staticRenderFns,
  false,
  null,
  "52840c71",
  null
  
)

/* harmony default export */ var hg_logitravel_package_tour_search = (hg_logitravel_package_tour_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-h2go-search.vue?vue&type=template&id=ea81c080&scoped=true
var hg_h2go_searchvue_type_template_id_ea81c080_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hg-short-trip-search"},[_c('div',{staticClass:"form-row"},[_c('HgDestinationSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"isLoading":_vm.isLoadingDestinations,"isMobile":_vm.isMobile,"showMadeByGoogle":_vm.showMadeByGoogle,"label":_vm.$t('home2goSearch.destinationLabel'),"placeholder":_vm.$t('home2goSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ibeSearch.destinationResult')},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"label":_vm.$t('ibeSearch.dateRangeLabel'),"palceholder":_vm.$t('ibeSearch.dateRangePlaceholder'),"initial-start-date":new Date().setHours(24),"initial-end-date":new Date().setHours(72)},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder'),"maxAdults":99,"maxChildren":99,"roomLabel":_vm.roomLabel,"infoTextSingleRoom":_vm.infoTextSingleRoom,"infoTextSingles":_vm.infoTextSingles,"infoTextSingleRoomMultiple":_vm.infoTextSingleRoomMultiple,"infoTextMultipleSingular":_vm.infoTextMultipleSingular,"infoTextMultiplePlural":_vm.infoTextMultiplePlural,"showRooms":_vm.showRooms},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('div',{staticClass:"short-trip-submit hg-control"},[_c('HgButton',{attrs:{"disabled":!_vm.searchUrl.length,"size":"full","color":"teal","tag":"a","target":"_blank","href":_vm.searchUrl},on:{"onClick":_vm.submit}},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")])],1)])])])
}
var hg_h2go_searchvue_type_template_id_ea81c080_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-h2go-search.vue?vue&type=template&id=ea81c080&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-h2go-search.vue?vue&type=script&lang=js


/* harmony default export */ var hg_h2go_searchvue_type_script_lang_js = ({
  components: { hgDatepicker: hg_datepicker },
  props: {
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    showMadeByGoogle: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    searchUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    roomLabel: {
      type: String,
      default: 'Rooms',
    },
    infoTextSingleRoom: {
      type: String,
    },
    infoTextSingles: {
      type: String,
    },
    infoTextSingleRoomMultiple: {
      type: String,
    },
    infoTextMultipleSingular: {
      type: String,
    },
    infoTextMultiplePlural: {
      type: String,
    },
    showRooms: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedDestination: null,
    selectedDateRange: null,
    selectedTravelers: null,
  }),
  methods: {
    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = dateRange
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        dateRange: this.selectedDateRange,
        travelers: this.selectedTravelers,
      })
    },

    submit() {
      this.$emit('onTriggerSearch')
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-h2go-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_h2go_searchvue_type_script_lang_js = (hg_h2go_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-h2go-search.vue?vue&type=style&index=0&id=ea81c080&prod&lang=postcss&scoped=true
var hg_h2go_searchvue_type_style_index_0_id_ea81c080_prod_lang_postcss_scoped_true = __webpack_require__("bfad");

// CONCATENATED MODULE: ./src/components/search/hg-h2go-search.vue






/* normalize component */

var hg_h2go_search_component = normalizeComponent(
  search_hg_h2go_searchvue_type_script_lang_js,
  hg_h2go_searchvue_type_template_id_ea81c080_scoped_true_render,
  hg_h2go_searchvue_type_template_id_ea81c080_scoped_true_staticRenderFns,
  false,
  null,
  "ea81c080",
  null
  
)

/* harmony default export */ var hg_h2go_search = (hg_h2go_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-amadeus-package-tour-search.vue?vue&type=template&id=128f9186&scoped=true
var hg_amadeus_package_tour_searchvue_type_template_id_128f9186_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-ibe-search"},[_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"defaultValue":_vm.defaultDestinationName,"isMobile":_vm.isMobile,"isLoading":_vm.isLoadingDestinations,"label":_vm.$t('ibeSearch.destinationLabel'),"placeholder":_vm.$t('ibeSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ibeSearch.destinationResult'),"theme":_vm.theme},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"position":"bottom daterange","placeholder":_vm.$t('ibeSearch.dateRangePlaceholder'),"label":_vm.$t('ibeSearch.dateRangeLabel'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate,"theme":_vm.theme},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row form-row--duration"},[_c('HgTravelDurationSelect',{attrs:{"label":_vm.$t('ibeSearch.durationLabel'),"placeholder":_vm.$t('ibeSearch.durationPlaceholder'),"is-mobile":_vm.isMobile,"options":_vm.$t('ibeSearchControls.durationOptions'),"defaultValue":_vm.defaultDuration,"theme":_vm.theme},on:{"onSelectTravelDuration":_vm.selectTravelDuration}})],1),_c('div',{staticClass:"form-row form-row--airports"},[_c('HgAirportSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"is-mobile":_vm.isMobile,"airports":_vm.airports,"searched-airports":_vm.searchedAirports,"placeholder":_vm.$t('ibeSearch.airportPlaceholder'),"label":_vm.$t('ibeSearch.airportLabel.without'),"theme":_vm.theme},on:{"onChangeAirportTerm":function($event){return _vm.$emit('onChangeAirportTerm', arguments[0])},"onSelectAirports":_vm.selectAirports}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"show-errors":"","max-children":4,"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder'),"roomLabel":_vm.roomLabel,"default-child-ages":_vm.defaultChildAges,"infoTextSingleRoom":_vm.infoTextSingleRoom,"infoTextSingles":_vm.infoTextSingles,"infoTextSingleRoomMultiple":_vm.infoTextSingleRoomMultiple,"infoTextMultipleSingular":_vm.infoTextMultipleSingular,"infoTextMultiplePlural":_vm.infoTextMultiplePlural,"showRooms":_vm.showRooms,"limitRooms":true,"theme":_vm.theme},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('HgButton',{attrs:{"size":"full","color":_vm.submitButtonColor,"tag":"a","target":"_blank","disabled":_vm.loading,"rel":"nofollow","href":_vm.ibeUrl},on:{"onClick":_vm.submit}},[(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")]:_c('HgLoadingBubble')],2)],1),(_vm.showCooperation)?_c('div',{staticClass:"form-row form-row--cooperation"},[_c('p',[_vm._v("in Kooperation mit")]),_c('GuruLogoPlain',{staticStyle:{"height":"28px"}})],1):_vm._e()])
}
var hg_amadeus_package_tour_searchvue_type_template_id_128f9186_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-amadeus-package-tour-search.vue?vue&type=template&id=128f9186&scoped=true

// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDate/index.js


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/fp/_lib/convertToFP/index.js
function convertToFP(fn, arity) {
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (a.length >= arity) {
    return fn.apply(null, a.slice(0, arity).reverse());
  }
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return convertToFP(fn, arity, a.concat(args));
  };
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/fp/getDate/index.js
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.


/* harmony default export */ var fp_getDate = (convertToFP(getDate, 1));
// CONCATENATED MODULE: ./node_modules/date-fns/esm/fp/getMonth/index.js
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.


/* harmony default export */ var fp_getMonth = (convertToFP(getMonth, 1));
// CONCATENATED MODULE: ./node_modules/date-fns/esm/getYear/index.js


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/fp/getYear/index.js
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.


/* harmony default export */ var fp_getYear = (convertToFP(getYear, 1));
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-amadeus-package-tour-search.vue?vue&type=script&lang=js







/* harmony default export */ var hg_amadeus_package_tour_searchvue_type_script_lang_js = ({
  components: { HgDatepicker: hg_datepicker },
  props: {
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    defaultRegionId: Number,
    defaultCountryId: String,
    defaultDestinationName: {
      type: String,
      default: '',
    },
    defaultAdults: {
      type: Number,
      default: 2,
    },
    defaultDateRelative: {
      type: Number,
      default: 0,
    },
    defaultDuration: {
      type: String,
      default: '7',
    },
    defaultChildAges: {
      type: Number,
      default: 6,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    airports: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
    ibeUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    searchedAirports: {
      type: Array,
      required: true,
      default: () => [],
    },
    roomLabel: {
      type: String,
      default: 'Rooms',
    },
    infoTextSingleRoom: {
      type: String,
    },
    infoTextSingles: {
      type: String,
    },
    infoTextSingleRoomMultiple: {
      type: String,
    },
    infoTextMultipleSingular: {
      type: String,
    },
    infoTextMultiplePlural: {
      type: String,
    },
    showRooms: {
      type: Boolean,
      default: false,
    },
    showCooperation: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    selectedDestination: null,
    selectedDateRange: null,
    selectedAirports: null,
    selectedDuration: '7',
    selectedTravelers: null,
    selectedTags: null,
    initialStartDate: null,
    initialEndDate: null,
  }),

  computed: {
    submitButtonColor() {
      switch (this.theme) {
        case 'bild':
          return 'bild-green'
        case '5vf':
          return '5vf'
        default:
          return 'teal'
      }
    },
  },

  created() {
    if (this.defaultRegionId) {
      if (['10000', '10001', '10005'].includes(this.defaultRegionId)) {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Region',
        }
      } else {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          regionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Destination',
        }
      }
    } else if (this.defaultCountryId) {
      this.selectedDestination = {
        id: this.defaultCountryId,
        countryISO3166: this.defaultCountryId,
        name: this.defaultDestinationName,
        type: 'Country',
      }
    }

    if (this.defaultDateRelative > 0) {
      this.setInitialDatesToRelative()
    } else {
      this.setInitialDates()
    }
  },

  methods: {
    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    selectAirports(airports) {
      this.selectedAirports = airports
      this.update()
    },

    selectTags(tags) {
      this.selectedTags = tags
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = {
        start: new Date(
          fp_getYear(dateRange.start),
          fp_getMonth(dateRange.start),
          fp_getDate(dateRange.start)
        ),
        end: new Date(
          fp_getYear(dateRange.end),
          fp_getMonth(dateRange.end),
          fp_getDate(dateRange.end)
        ),
      }
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        airports: this.selectedAirports,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
        tags: this.selectedTags,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', {
        destination: this.selectedDestination,
        airports: this.selectedAirports,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
        tags: this.selectedTags,
      })
    },

    setInitialDates() {
      const today = startOfToday()
      const newToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(newToday, 1)
      this.initialEndDate = addMonths(newToday, 6)
    },

    setInitialDatesToRelative() {
      const today = startOfToday()
      const new_today = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(new_today, 1)
      this.initialEndDate = addDays(new_today, this.defaultDateRelative)
    },

    setInitialDatesToSummer() {
      const today = startOfToday()
      const thisYear = today.getFullYear()
      const nextYear = thisYear + 1

      const startOfThisSummer = new Date(thisYear, 5, 1)
      const endOfThisSummer = new Date(thisYear, 11, 0)
      const startOfNextSummer = new Date(nextYear, 5, 1)
      const endOfNextSummer = new Date(nextYear, 8, 0)

      if (isBefore(today, startOfThisSummer)) {
        this.initialStartDate = startOfThisSummer
        this.initialEndDate = endOfThisSummer
      } else if (
        isAfter(today, startOfThisSummer) &&
        isBefore(today, endOfThisSummer)
      ) {
        this.initialStartDate = addDays(new Date(), 2)
        this.initialEndDate = addMonths(new Date(), 3)
      } else if (isAfter(today, endOfThisSummer)) {
        this.initialStartDate = startOfNextSummer
        this.initialEndDate = endOfNextSummer
      } else {
        this.initialStartDate = addDays(today, 1)
        this.initialEndDate = addMonths(today, 3)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-amadeus-package-tour-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_amadeus_package_tour_searchvue_type_script_lang_js = (hg_amadeus_package_tour_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-amadeus-package-tour-search.vue?vue&type=style&index=0&id=128f9186&prod&lang=postcss&scoped=true
var hg_amadeus_package_tour_searchvue_type_style_index_0_id_128f9186_prod_lang_postcss_scoped_true = __webpack_require__("64b5");

// CONCATENATED MODULE: ./src/components/search/hg-amadeus-package-tour-search.vue






/* normalize component */

var hg_amadeus_package_tour_search_component = normalizeComponent(
  search_hg_amadeus_package_tour_searchvue_type_script_lang_js,
  hg_amadeus_package_tour_searchvue_type_template_id_128f9186_scoped_true_render,
  hg_amadeus_package_tour_searchvue_type_template_id_128f9186_scoped_true_staticRenderFns,
  false,
  null,
  "128f9186",
  null
  
)

/* harmony default export */ var hg_amadeus_package_tour_search = (hg_amadeus_package_tour_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-amadeus-hotel-tour-search.vue?vue&type=template&id=50e571d7&scoped=true
var hg_amadeus_hotel_tour_searchvue_type_template_id_50e571d7_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-amadeus-hotel-tour-search"},[_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"defaultValue":_vm.defaultDestinationName,"isMobile":_vm.isMobile,"isLoading":_vm.isLoadingDestinations,"label":_vm.$t('ibeSearch.destinationLabel'),"placeholder":_vm.$t('ibeSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ibeSearch.destinationResult'),"theme":_vm.theme},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"position":"bottom daterange","placeholder":_vm.$t('ibeSearch.dateRangePlaceholder'),"label":_vm.$t('ibeSearch.dateRangeLabel'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate,"theme":_vm.theme},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row form-row--duration"},[_c('HgTravelDurationSelect',{attrs:{"label":_vm.$t('ibeSearch.durationLabel'),"placeholder":_vm.$t('ibeSearch.durationPlaceholder'),"is-mobile":_vm.isMobile,"options":_vm.$t('ibeSearchControls.durationOptions'),"defaultValue":_vm.defaultDuration,"theme":_vm.theme},on:{"onSelectTravelDuration":_vm.selectTravelDuration}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"show-errors":"","max-children":4,"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder'),"showRooms":_vm.showRooms,"limitRooms":true,"theme":_vm.theme},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('HgButton',{attrs:{"size":"full","color":_vm.submitButtonColor,"tag":"a","target":"_blank","disabled":_vm.loading,"rel":"nofollow","href":_vm.ibeUrl},on:{"onClick":_vm.submit}},[(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")]:_c('HgLoadingBubble')],2)],1),(_vm.showCooperation)?_c('div',{staticClass:"form-row form-row--cooperation"},[_c('p',[_vm._v("in Kooperation mit")]),_c('GuruLogoPlain',{staticStyle:{"height":"28px"}})],1):_vm._e()])
}
var hg_amadeus_hotel_tour_searchvue_type_template_id_50e571d7_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-amadeus-hotel-tour-search.vue?vue&type=template&id=50e571d7&scoped=true

// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfDay/index.js


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfToday/index.js

/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday_endOfToday() {
  return endOfDay(Date.now());
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-amadeus-hotel-tour-search.vue?vue&type=script&lang=js




/* harmony default export */ var hg_amadeus_hotel_tour_searchvue_type_script_lang_js = ({
  components: { hgDatepicker: hg_datepicker },
  props: {
    defaultRegionId: Number,
    defaultCountryId: String,
    defaultDestinationName: {
      type: String,
      default: '',
    },
    defaultAdults: {
      type: Number,
      default: 2,
    },
    defaultDateRelative: {
      type: Number,
      default: 0,
    },
    defaultDuration: {
      type: String,
      default: '7',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
    ibeUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    showRooms: {
      type: Boolean,
      default: false,
    },
    showCooperation: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null
    }
  },

  data: () => ({
    selectedDestination: null,
    selectedDateRange: null,
    selectedDuration: '7',
    selectedTravelers: null,
    initialStartDate: null,
    initialEndDate: null,
  }),

  computed: {
    submitButtonColor() {
      switch (this.theme) {
        case 'bild':
          return 'bild-green'
        case '5vf':
          return '5vf'
        default:
          return 'teal'
      }
    },
  },

  created() {
    if (this.defaultRegionId) {
      if (['10000', '10001', '10005'].includes(this.defaultRegionId)) {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Region',
        }
      } else {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          regionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Destination',
        }
      }
    } else if (this.defaultCountryId) {
      this.selectedDestination = {
        id: this.defaultCountryId,
        countryISO3166: this.defaultCountryId,
        name: this.defaultDestinationName,
        type: 'Country',
      }
    }

    if (this.defaultDateRelative > 0) {
      this.setInitialDatesToRelative()
    } else {
      this.setInitialDatesToSummer()
    }
  },

  methods: {
    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = dateRange
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', {
        destination: this.selectedDestination,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
      })
    },

    setInitialDatesToRelative() {
      const today = endOfToday_endOfToday()
      const new_today = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(new_today, 1)
      this.initialEndDate = addDays(new_today, this.defaultDateRelative)
    },

    setInitialDatesToSummer() {
      const today = startOfToday()
      const thisYear = today.getFullYear()
      const nextYear = thisYear + 1

      const startOfThisSummer = new Date(thisYear, 5, 1)
      const endOfThisSummer = new Date(thisYear, 8, 0)
      const startOfNextSummer = new Date(nextYear, 5, 1)
      const endOfNextSummer = new Date(nextYear, 8, 0)

      if (isBefore(today, startOfThisSummer)) {
        this.initialStartDate = startOfThisSummer
        this.initialEndDate = endOfThisSummer
      } else if (isAfter(today, endOfThisSummer)) {
        this.initialStartDate = startOfNextSummer
        this.initialEndDate = endOfNextSummer
      } else {
        this.initialStartDate = addDays(today, 1)
        this.initialEndDate = addMonths(today, 3)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-amadeus-hotel-tour-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_amadeus_hotel_tour_searchvue_type_script_lang_js = (hg_amadeus_hotel_tour_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-amadeus-hotel-tour-search.vue?vue&type=style&index=0&id=50e571d7&prod&lang=postcss&scoped=true
var hg_amadeus_hotel_tour_searchvue_type_style_index_0_id_50e571d7_prod_lang_postcss_scoped_true = __webpack_require__("e24f");

// CONCATENATED MODULE: ./src/components/search/hg-amadeus-hotel-tour-search.vue






/* normalize component */

var hg_amadeus_hotel_tour_search_component = normalizeComponent(
  search_hg_amadeus_hotel_tour_searchvue_type_script_lang_js,
  hg_amadeus_hotel_tour_searchvue_type_template_id_50e571d7_scoped_true_render,
  hg_amadeus_hotel_tour_searchvue_type_template_id_50e571d7_scoped_true_staticRenderFns,
  false,
  null,
  "50e571d7",
  null
  
)

/* harmony default export */ var hg_amadeus_hotel_tour_search = (hg_amadeus_hotel_tour_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-netmatch-hotel-tour-search.vue?vue&type=template&id=23cf52fb&scoped=true
var hg_netmatch_hotel_tour_searchvue_type_template_id_23cf52fb_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-amadeus-hotel-tour-search"},[_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"defaultValue":_vm.defaultDestinationName,"isMobile":_vm.isMobile,"isLoading":_vm.isLoadingDestinations,"label":_vm.translations.destinationLabel,"placeholder":_vm.translations.destinationPlaceholder,"options":_vm.destinations,"noResult":_vm.translations.destinationResult},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('hgSingleDatePicker',{attrs:{"isMobile":_vm.isMobile,"position":"bottom daterange","placeholder":_vm.translations.dateRangePlaceholder,"label":_vm.translations.dateRangeLabel,"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate},on:{"onDateSelect":_vm.updateDepartureDate}})],1),_c('div',{staticClass:"form-row form-row--duration"},[_c('HgTravelDurationSelect',{attrs:{"label":_vm.translations.durationLabel,"placeholder":_vm.translations.durationPlaceholder,"is-mobile":_vm.isMobile,"options":_vm.$t('ibeSearchControls.durationOptions')},on:{"onSelectTravelDuration":_vm.selectTravelDuration}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"show-errors":"","max-children":4,"is-mobile":_vm.isMobile,"label":_vm.translations.travelersLabel,"placeholder":_vm.translations.travelersPlaceholder},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('HgButton',{attrs:{"size":"full","color":"teal","tag":"a","target":"_blank","disabled":_vm.loading,"rel":"nofollow","href":_vm.ibeUrl},on:{"onClick":_vm.submit}},[(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.translations.buttonText)+" ")]:_c('HgLoadingBubble')],2)],1)])
}
var hg_netmatch_hotel_tour_searchvue_type_template_id_23cf52fb_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-netmatch-hotel-tour-search.vue?vue&type=template&id=23cf52fb&scoped=true

// CONCATENATED MODULE: ./node_modules/date-fns/esm/constants/index.js
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;

/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */
var daysInYear = 365.2425;

/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInSecond = 1000;

/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */
var minTime = -maxTime;

/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */
var minutesInHour = 60;

/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var monthsInQuarter = 3;

/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */
var monthsInYear = 12;

/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */
var quartersInYear = 4;

/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */
var secondsInHour = 3600;

/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var secondsInMinute = 60;

/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */
var secondsInDay = secondsInHour * 24;

/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */
var secondsInWeek = secondsInDay * 7;

/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */
var secondsInYear = secondsInDay * daysInYear;

/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */
var secondsInMonth = secondsInYear / 12;

/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var secondsInQuarter = secondsInMonth * 3;
// CONCATENATED MODULE: ./node_modules/date-fns/esm/parseISO/index.js



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-netmatch-hotel-tour-search.vue?vue&type=script&lang=js




/* harmony default export */ var hg_netmatch_hotel_tour_searchvue_type_script_lang_js = ({
  components: { hgSingleDatePicker: hg_single_datepicker },
  props: {
    defaultRegionId: Number,
    defaultCountryId: String,
    defaultDestinationName: {
      type: String,
      default: '',
    },
    defaultAdults: {
      type: Number,
      default: 2,
    },
    defaultDateRelative: {
      type: Number,
      default: 0,
    },
    defaultDuration: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
    ibeUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    translations: {
      type: Object,
      default: () => ({
        destinationLabel: 'Reiseziel oder Hotel',
        destinationPlaceholder: 'Wo soll die Reise hingehen?',
        destinationResult: 'Trage dein Reiseziel ein',
        dateRangePlaceholder: 'TT.MM.JJJJ - TT.MM.JJJJ',
        dateRangeLabel: 'Zeitraum',
        durationLabel: 'Reisedauer',
        durationPlaceholder: 'Bitte wählen',
        travelersLabel: 'Reisende',
        travelersPlaceholder: '2 Erwachsene',
        buttonText: 'Suchen',
      }),
    },
  },

  data: () => ({
    selectedDestination: null,
    selectedDepartureDate: null,
    selectedDuration: null,
    selectedTravelers: null,
    initialStartDate: null,
    initialEndDate: null,
  }),

  created() {
    if (this.defaultRegionId) {
      if (['10000', '10001', '10005'].includes(this.defaultRegionId)) {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Region',
        }
      } else {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          regionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Destination',
        }
      }
    } else if (this.defaultCountryId) {
      this.selectedDestination = {
        id: this.defaultCountryId,
        countryISO3166: this.defaultCountryId,
        name: this.defaultDestinationName,
        type: 'Country',
      }
    }

    if (this.defaultDateRelative > 0) {
      this.setInitialDatesToRelative()
    } else {
      this.setInitialDatesToSummer()
    }
  },

  methods: {
    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDepartureDate(departureDate) {
      this.selectedDepartureDate = new Date(
        getYear(parseISO(departureDate)),
        getMonth(parseISO(departureDate)),
        getDate(parseISO(departureDate))
      )
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        dateRange: this.selectedDepartureDate,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', {
        destination: this.selectedDestination,
        dateRange: this.selectedDepartureDate,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
      })
    },

    setInitialDatesToRelative() {
      const today = endOfToday()
      const new_today = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(new_today, 1)
      this.initialEndDate = addDays(new_today, this.defaultDateRelative)
    },

    setInitialDatesToSummer() {
      const today = startOfToday()
      const thisYear = today.getFullYear()
      const nextYear = thisYear + 1

      const startOfThisSummer = new Date(thisYear, 5, 1)
      const endOfThisSummer = new Date(thisYear, 8, 0)
      const startOfNextSummer = new Date(nextYear, 5, 1)
      const endOfNextSummer = new Date(nextYear, 8, 0)

      if (isBefore(today, startOfThisSummer)) {
        this.initialStartDate = startOfThisSummer
        this.initialEndDate = endOfThisSummer
      } else if (isAfter(today, endOfThisSummer)) {
        this.initialStartDate = startOfNextSummer
        this.initialEndDate = endOfNextSummer
      } else {
        this.initialStartDate = addDays(today, 1)
        this.initialEndDate = addMonths(today, 3)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-netmatch-hotel-tour-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_netmatch_hotel_tour_searchvue_type_script_lang_js = (hg_netmatch_hotel_tour_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-netmatch-hotel-tour-search.vue?vue&type=style&index=0&id=23cf52fb&prod&lang=postcss&scoped=true
var hg_netmatch_hotel_tour_searchvue_type_style_index_0_id_23cf52fb_prod_lang_postcss_scoped_true = __webpack_require__("9050");

// CONCATENATED MODULE: ./src/components/search/hg-netmatch-hotel-tour-search.vue






/* normalize component */

var hg_netmatch_hotel_tour_search_component = normalizeComponent(
  search_hg_netmatch_hotel_tour_searchvue_type_script_lang_js,
  hg_netmatch_hotel_tour_searchvue_type_template_id_23cf52fb_scoped_true_render,
  hg_netmatch_hotel_tour_searchvue_type_template_id_23cf52fb_scoped_true_staticRenderFns,
  false,
  null,
  "23cf52fb",
  null
  
)

/* harmony default export */ var hg_netmatch_hotel_tour_search = (hg_netmatch_hotel_tour_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-netmatch-package-tour-search.vue?vue&type=template&id=291d5b6e&scoped=true
var hg_netmatch_package_tour_searchvue_type_template_id_291d5b6e_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-ibe-search"},[_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"defaultValue":_vm.defaultDestinationName,"isMobile":_vm.isMobile,"isLoading":_vm.isLoadingDestinations,"label":_vm.translations.destinationLabel,"placeholder":_vm.translations.destinationPlaceholder,"options":_vm.destinations,"noResult":_vm.translations.destinationResult},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('HgSingleDatePicker',{attrs:{"isMobile":_vm.isMobile,"position":"bottom daterange","placeholder":_vm.translations.dateRangePlaceholder,"label":_vm.translations.dateRangeLabel,"initial-start-date":_vm.initialStartDate,"min-date":_vm.initialStartDate},on:{"onDateSelect":_vm.updateDepartureDate}})],1),_c('div',{staticClass:"form-row form-row--duration"},[_c('HgTravelDurationSelect',{attrs:{"label":_vm.translations.durationLabel,"placeholder":_vm.translations.durationPlaceholder,"is-mobile":_vm.isMobile,"options":_vm.$t('ibeSearchControls.durationOptions'),"default-value":"5,10"},on:{"onSelectTravelDuration":_vm.selectTravelDuration}})],1),_c('div',{staticClass:"form-row form-row--airports"},[_c('HgAirportSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"is-mobile":_vm.isMobile,"airports":_vm.airports,"searched-airports":_vm.searchedAirports,"placeholder":_vm.translations.airportPlaceholder,"label":_vm.translations.airportLabel},on:{"onChangeAirportTerm":function($event){return _vm.$emit('onChangeAirportTerm', arguments[0])},"onSelectAirports":_vm.selectAirports}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"show-errors":"","max-children":4,"is-mobile":_vm.isMobile,"label":_vm.translations.travelersLabel,"placeholder":_vm.translations.travelersPlaceholder,"roomLabel":_vm.roomLabel,"infoTextSingleRoom":_vm.infoTextSingleRoom,"infoTextSingles":_vm.infoTextSingles,"infoTextSingleRoomMultiple":_vm.infoTextSingleRoomMultiple,"infoTextMultipleSingular":_vm.infoTextMultipleSingular,"infoTextMultiplePlural":_vm.infoTextMultiplePlural,"showRooms":_vm.showRooms,"limitRooms":true},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('HgButton',{attrs:{"size":"full","color":"teal","tag":"a","target":"_blank","disabled":_vm.loading,"rel":"nofollow","href":_vm.ibeUrl},on:{"onClick":_vm.submit}},[(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.translations.buttonText)+" ")]:_c('HgLoadingBubble')],2)],1)])
}
var hg_netmatch_package_tour_searchvue_type_template_id_291d5b6e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-netmatch-package-tour-search.vue?vue&type=template&id=291d5b6e&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-netmatch-package-tour-search.vue?vue&type=script&lang=js




/* harmony default export */ var hg_netmatch_package_tour_searchvue_type_script_lang_js = ({
  components: { HgSingleDatePicker: hg_single_datepicker },
  props: {
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    defaultRegionId: Number,
    defaultCountryId: String,
    defaultDestinationName: {
      type: String,
      default: '',
    },
    defaultAdults: {
      type: Number,
      default: 2,
    },
    defaultDateRelative: {
      type: Number,
      default: 0,
    },
    defaultDuration: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    airports: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
    ibeUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    searchedAirports: {
      type: Array,
      required: true,
      default: () => [],
    },
    roomLabel: {
      type: String,
      default: 'Rooms',
    },
    infoTextSingleRoom: {
      type: String,
    },
    infoTextSingles: {
      type: String,
    },
    infoTextSingleRoomMultiple: {
      type: String,
    },
    infoTextMultipleSingular: {
      type: String,
    },
    infoTextMultiplePlural: {
      type: String,
    },
    showRooms: {
      type: Boolean,
      default: false,
    },
    translations: {
      type: Object,
      default: () => ({
        destinationLabel: 'Reiseziel oder Hotel',
        destinationPlaceholder: 'Wo soll die Reise hingehen?',
        destinationResult: 'Trage dein Reiseziel ein',
        dateRangePlaceholder: 'TT.MM.JJJJ - TT.MM.JJJJ',
        dateRangeLabel: 'Zeitraum',
        durationLabel: 'Reisedauer',
        durationPlaceholder: 'Bitte wählen',
        travelersLabel: 'Reisende',
        travelersPlaceholder: '2 Erwachsene',
        buttonText: 'Suchen',
        airportPlaceholder: 'Flughafen',
        airportLabel: 'Abflughafen',
      }),
    },
  },

  data: () => ({
    selectedDestination: null,
    selectedDepartureDate: null,
    selectedAirports: null,
    selectedDuration: null,
    selectedTravelers: null,
    selectedTags: null,
    initialStartDate: null,
    initialEndDate: null,
  }),

  created() {
    if (this.defaultRegionId) {
      this.selectedDestination = {
        id: this.defaultRegionId,
        name: this.defaultDestinationName,
        type: 'Region',
      }
    } else if (this.defaultCountryId) {
      this.selectedDestination = {
        id: this.defaultCountryId,
        name: this.defaultDestinationName,
        type: 'Country',
      }
    }

    if (this.defaultDateRelative > 0) {
      this.setInitialDatesToRelative()
    } else {
      this.setInitialDatesToSummer()
    }
  },

  methods: {
    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    selectAirports(airports) {
      this.selectedAirports = airports
      this.update()
    },

    selectTags(tags) {
      this.selectedTags = tags
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDepartureDate(departureDate) {
      this.selectedDepartureDate = new Date(
        getYear(parseISO(departureDate)),
        getMonth(parseISO(departureDate)),
        getDate(parseISO(departureDate))
      )
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        airports: this.selectedAirports,
        departureDate: this.selectedDepartureDate,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
        tags: this.selectedTags,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', {
        destination: this.selectedDestination,
        airports: this.selectedAirports,
        departureDate: this.selectedDepartureDate,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
        tags: this.selectedTags,
      })
    },

    setInitialDatesToRelative() {
      const today = startOfToday()
      const new_today = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(new_today, this.defaultDateRelative)
    },

    setInitialDatesToSummer() {
      const today = startOfToday()
      const thisYear = today.getFullYear()
      const nextYear = thisYear + 1

      const startOfThisSummer = new Date(thisYear, 5, 1)
      const endOfThisSummer = new Date(thisYear, 11, 0)
      const startOfNextSummer = new Date(nextYear, 5, 1)
      const endOfNextSummer = new Date(nextYear, 8, 0)

      if (isBefore(today, startOfThisSummer)) {
        this.initialStartDate = startOfThisSummer
        this.initialEndDate = endOfThisSummer
      } else if (
        isAfter(today, startOfThisSummer) &&
        isBefore(today, endOfThisSummer)
      ) {
        this.initialStartDate = addDays(new Date(), 2)
        this.initialEndDate = addMonths(new Date(), 3)
      } else if (isAfter(today, endOfThisSummer)) {
        this.initialStartDate = startOfNextSummer
        this.initialEndDate = endOfNextSummer
      } else {
        this.initialStartDate = addDays(today, 1)
        this.initialEndDate = addMonths(today, 3)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-netmatch-package-tour-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_netmatch_package_tour_searchvue_type_script_lang_js = (hg_netmatch_package_tour_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-netmatch-package-tour-search.vue?vue&type=style&index=0&id=291d5b6e&prod&lang=postcss&scoped=true
var hg_netmatch_package_tour_searchvue_type_style_index_0_id_291d5b6e_prod_lang_postcss_scoped_true = __webpack_require__("58c1");

// CONCATENATED MODULE: ./src/components/search/hg-netmatch-package-tour-search.vue






/* normalize component */

var hg_netmatch_package_tour_search_component = normalizeComponent(
  search_hg_netmatch_package_tour_searchvue_type_script_lang_js,
  hg_netmatch_package_tour_searchvue_type_template_id_291d5b6e_scoped_true_render,
  hg_netmatch_package_tour_searchvue_type_template_id_291d5b6e_scoped_true_staticRenderFns,
  false,
  null,
  "291d5b6e",
  null
  
)

/* harmony default export */ var hg_netmatch_package_tour_search = (hg_netmatch_package_tour_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-hotd-filter.vue?vue&type=template&id=f1c73da8&scoped=true
var hg_hotd_filtervue_type_template_id_f1c73da8_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-hotd-filter"},[_c('div',{staticClass:"top-section"},[_c('div',{staticClass:"headline-container"},[_c('h2',{staticClass:"headline"},[_vm._v(_vm._s(_vm.headline))]),_c('div',{staticClass:"burger-button-container"},[_c('div',{staticClass:"reset-filter-burger"},[(_vm.choosenFilters.length > 0)?_c('button',{staticClass:"reset-button",on:{"click":function($event){return _vm.resetFilters()}}},[_vm._v(" "+_vm._s(_vm.lang.resetAllFilters)+" ")]):_vm._e()]),_c('button',{staticClass:"burger-button",on:{"click":function($event){return _vm.toggleSideBar()}}},[_c('FilterSvg')],1)])]),(_vm.choosenFilters.length > 0)?_c('div',{staticClass:"selected-filter-container"},[_c('p',{staticClass:"paragraph-display"},[_vm._v(_vm._s(_vm.lang.choosenFilters))]),_c('ul',{staticClass:"selected-filter-list"},_vm._l((_vm.choosenFilters),function(filter,index){return _c('li',{key:index,staticClass:"selected-filter-item mouse-over",on:{"click":function($event){return _vm.removeFilter(filter.id, 'badge')}}},[_c('p',[_vm._v(_vm._s(filter.name))]),_c('div',[_c('hg-icon',{staticClass:"mouse-over-badge",attrs:{"name":"times","color":"black","pack":"fal","size":"small"}})],1)])}),0)]):_vm._e()]),_c('div',{class:`sidebar-background ${
      !_vm.sidebarIsVisible && _vm.sidebarIsVisible !== null
        ? 'sidebar-background--hidden'
        : ''
    } ${_vm.sidebarIsVisible && _vm.sidebarIsVisible !== null ? 'animationIn' : ''}`,on:{"click":function($event){return _vm.toggleSideBar('hidden')}}}),_c('div',{class:`filters-sidebar ${
      _vm.sidebarIsVisible && _vm.sidebarIsVisible !== null ? 'animationIn' : ''
    } ${!_vm.sidebarIsVisible && _vm.sidebarIsVisible !== null ? 'hidden' : ''}`},[_c('div',{staticClass:"sidebar-headline"},[_c('h2',[_vm._v(_vm._s(_vm.lang.headline))]),_c('button',{on:{"click":function($event){return _vm.toggleSideBar()}}},[_c('hg-icon',{staticClass:"mouse-over",attrs:{"name":"times","color":"black","pack":"fal"}})],1)]),_c('div',{staticClass:"sidebar-middleSection"},[_c('div',{staticClass:"sidebar-search"},[_c('HgTextInput',{staticClass:"sidebar-search-input",attrs:{"type":"text","teal":true,"label-position":"default","placeholder":"Welche Hotels interessieren dich?"},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1),_c('div',{staticClass:"sidebar-filters"},[_c('div',{staticClass:"sidebar-subheadline"},[_c('h2',[_vm._v(_vm._s(_vm.lang.subHeadline))])]),_c('ul',{staticClass:"filters-list"},_vm._l((_vm.sortedFilters),function(filterItem,index){return _c('li',{key:index,on:{"click":(e) => _vm.addFilter(e, filterItem)}},[_c('span',{staticClass:"sidebar-list-element"},[_c('div',[(_vm.isChecked(filterItem.id))?_c('svg',{class:`sidebar-checkbox__svg`,attrs:{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":".5","width":"16","height":"16","rx":"4","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"m6.834 11.552 6.495-6.495a.26.26 0 0 0 0-.368l-.613-.613a.26.26 0 0 0-.367 0L6.65 9.775 4.557 7.68a.26.26 0 0 0-.368 0l-.613.612a.26.26 0 0 0 0 .368l2.89 2.89a.26.26 0 0 0 .368 0z","fill":"#323231"}})]):_c('div',{class:`sidebar-checkbox`})]),_c('div',{staticClass:"sidebar-list-element--desciption"},[_c('p',{staticClass:"sidebar-list-element--desciption--name"},[_vm._v(" "+_vm._s(filterItem.name)+" ")])])])])}),0)])]),_c('div',{staticClass:"sidebar-bottom"},[_c('button',{class:`hg-left-btn ${_vm.selectedFilters.length > 0 ? '' : 'disabled'}`,attrs:{"disabled":!_vm.selectedFilters.length > 0},on:{"click":function($event){return _vm.resetFilters()}}},[_vm._v(" "+_vm._s(_vm.lang.resetFilters)+" ")]),_c('button',{staticClass:"hg-right-btn",on:{"click":function($event){return _vm.filtersChanged()}}},[_vm._v(" "+_vm._s(_vm.lang.acceptFilters)+" ")])])])])
}
var hg_hotd_filtervue_type_template_id_f1c73da8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-hotd-filter.vue?vue&type=template&id=f1c73da8&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/filter-svg.vue?vue&type=template&id=6e095710
var filter_svgvue_type_template_id_6e095710_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 24 24","fill":"#000","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.4938 2.71409C12.4289 2.03152 11.8562 1.5 11.1562 1.5H9.46874L9.33908 1.50614L9.21296 1.52417C8.59214 1.64317 8.12499 2.18753 8.12499 2.84375L8.124 3.749L3.28125 3.75L3.17537 3.75714C2.79444 3.80895 2.5 4.13631 2.5 4.53124V5.09374L2.50714 5.19962L2.52795 5.30121C2.61904 5.63166 2.92221 5.87499 3.28125 5.87499L8.124 5.874L8.12499 6.78124L8.13112 6.9109C8.19608 7.59347 8.76877 8.12499 9.46874 8.12499H11.1562L11.2859 8.11885L11.412 8.10082C12.0328 7.98181 12.5 7.43746 12.5 6.78124L12.499 5.874L20.7187 5.87499L20.8246 5.86785C21.2055 5.81603 21.5 5.48868 21.5 5.09374V4.53124L21.4928 4.42537L21.472 4.32378C21.3809 3.99333 21.0777 3.75 20.7187 3.75L12.499 3.749L12.5 2.84375L12.4938 2.71409ZM16.7812 8.56249C17.4812 8.56249 18.0539 9.09401 18.1188 9.77658L18.125 9.90624L18.124 10.812L20.7187 10.8125C21.0777 10.8125 21.3809 11.0558 21.472 11.3863L21.4928 11.4879L21.5 11.5937V12.1562C21.5 12.5512 21.2055 12.8785 20.8246 12.9303L20.7187 12.9375L18.124 12.937L18.125 13.8437C18.125 14.4999 17.6578 15.0443 17.037 15.1633L16.9109 15.1813L16.7812 15.1875H15.0937C14.3938 15.1875 13.8211 14.656 13.7561 13.9734L13.75 13.8437L13.749 12.937L3.28125 12.9375C2.92221 12.9375 2.61904 12.6941 2.52795 12.3637L2.50714 12.2621L2.5 12.1562V11.5937C2.5 11.1988 2.79444 10.8714 3.17537 10.8196L3.28125 10.8125L13.749 10.812L13.75 9.90624C13.75 9.25002 14.2171 8.70566 14.8379 8.58666L14.9641 8.56863L15.0937 8.56249H16.7812ZM8.90624 15.625C9.6062 15.625 10.1789 16.1565 10.2438 16.8391L10.25 16.9687L10.249 17.874L20.7187 17.875C21.0777 17.875 21.3809 18.1183 21.472 18.4488L21.4928 18.5503L21.5 18.6562V19.2187C21.5 19.6137 21.2055 19.941 20.8246 19.9928L20.7187 20L10.249 19.999L10.25 20.9062C10.25 21.5624 9.78283 22.1068 9.16202 22.2258L9.0359 22.2438L8.90624 22.25H7.21874C6.51878 22.25 5.94608 21.7184 5.88113 21.0359L5.87499 20.9062L5.874 19.999L3.28125 20C2.92221 20 2.61904 19.7566 2.52795 19.4262L2.50714 19.3246L2.5 19.2187V18.6562C2.5 18.2613 2.79444 17.9339 3.17537 17.8821L3.28125 17.875L5.874 17.874L5.87499 16.9687C5.87499 16.3125 6.34215 15.7682 6.96296 15.6492L7.08908 15.6311L7.21874 15.625H8.90624ZM10.875 6.49999H9.74999V3.125H10.875V6.49999ZM16.5 13.5625H15.375V10.1875H16.5V13.5625ZM8.62499 20.625H7.49999V17.25H8.62499V20.625Z"}})])
}
var filter_svgvue_type_template_id_6e095710_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/filter-svg.vue?vue&type=template&id=6e095710

// CONCATENATED MODULE: ./src/components/svg/ui/filter-svg.vue

var filter_svg_script = {}


/* normalize component */

var filter_svg_component = normalizeComponent(
  filter_svg_script,
  filter_svgvue_type_template_id_6e095710_render,
  filter_svgvue_type_template_id_6e095710_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var filter_svg = (filter_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-hotd-filter.vue?vue&type=script&lang=js



/* harmony default export */ var hg_hotd_filtervue_type_script_lang_js = ({
  name: 'hg-hotd-filter',
  props: {
    headline: {
      type: String,
      default: '',
    },
    filters: {
      type: Array,
      default: () => [],
    },
    lang: {
      type: Object,
      default: () => {
        return {
          choosenFilters: 'Ausgewählte Filter:',
          resetAllFilters: 'Alle Filter zurücksetzen',
          resetFilters: 'Filter zurücksetzen',
          headline: 'Filter',
          subHeadline: 'Art des Hotels',
          acceptFilters: 'Filter anwenden',
        }
      },
    },
  },

  data() {
    return {
      inputValue: '',
      selectedFilters: [],
      choosenFilters: [],
      sidebarIsVisible: null,
      sortedFilters: [],
    }
  },

  mounted() {
    this.addClickaway()
    this.sortFilters()
  },

  onBeforeUnmount() {
    document.removeEventListener('click', this.onClickout)
  },

  watch: {
    inputValue() {
      this.sortFilters()
    },
  },

  methods: {
    sortFilters() {
      if (this.inputValue !== '') {
        this.sortedFilters = this.filters.filter((filter) =>
          filter.name.toLowerCase().includes(this.inputValue.toLowerCase())
        )
      } else {
        this.sortedFilters = this.filters
      }
    },
    onClickout(event) {
      if (!event.composedPath().includes(this.$el) && this.sidebarIsVisible) {
        this.toggleSideBar()
      }
    },
    addClickaway() {
      document.addEventListener('click', this.onClickout)
    },
    addFilter(e, item) {
      if (
        !(
          this.selectedFilters.some((filter) => filter.id === item.id) ||
          this.choosenFilters.some((filter) => filter.id === item.id)
        )
      ) {
        this.selectedFilters.push(item)
      } else {
        this.removeFilter(item.id)
      }
    },
    removeFilter(id, origin) {
      this.selectedFilters = this.selectedFilters.filter(
        (item) => item.id !== id
      )
      if (origin == 'badge') this.filtersChanged()
    },
    filtersChanged() {
      this.choosenFilters = [...this.selectedFilters]
      this.$emit('filtersChanged', this.choosenFilters)
      if (this.sidebarIsVisible) this.toggleSideBar()
    },
    isChecked(id) {
      const bool = this.selectedFilters.some((filter) => filter.id === id)
      return bool
    },
    toggleSideBar(mode) {
      if (mode == 'visible') {
        this.sidebarIsVisible = true
      } else if (mode == 'hidden') {
        this.sidebarIsVisible = false
      } else {
        this.sidebarIsVisible = !this.sidebarIsVisible
      }
    },
    resetFilters() {
      this.selectedFilters = []
      this.choosenFilters = []
      this.$emit('filtersChanged', this.choosenFilters)
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-hotd-filter.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_hotd_filtervue_type_script_lang_js = (hg_hotd_filtervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-hotd-filter.vue?vue&type=style&index=0&id=f1c73da8&prod&lang=postcss&scoped=true
var hg_hotd_filtervue_type_style_index_0_id_f1c73da8_prod_lang_postcss_scoped_true = __webpack_require__("e70d");

// CONCATENATED MODULE: ./src/components/search/hg-hotd-filter.vue






/* normalize component */

var hg_hotd_filter_component = normalizeComponent(
  search_hg_hotd_filtervue_type_script_lang_js,
  hg_hotd_filtervue_type_template_id_f1c73da8_scoped_true_render,
  hg_hotd_filtervue_type_template_id_f1c73da8_scoped_true_staticRenderFns,
  false,
  null,
  "f1c73da8",
  null
  
)

/* harmony default export */ var hg_hotd_filter = (hg_hotd_filter_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-cruise-search.vue?vue&type=template&id=7e6d4ce6&scoped=true
var hg_cruise_searchvue_type_template_id_7e6d4ce6_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hg-short-trip-search"},[_c('div',{staticClass:"form-row"},[_c('HgCruiseSelect',{attrs:{"is-mobile":_vm.isMobile,"options":_vm.sortedCruiseLines,"label":_vm.lang.cruiseLineLabel,"theme":_vm.theme},on:{"onChangeSearchTerm":_vm.changeCruiseTerm,"onSelect":_vm.updateCruises}})],1),_c('div',{staticClass:"form-row"},[_c('HgCruiseSelect',{attrs:{"is-mobile":_vm.isMobile,"options":_vm.sortedRegions,"label":_vm.lang.regionLabel,"theme":_vm.theme},on:{"onChangeSearchTerm":_vm.changeRegionsTerm,"onSelect":_vm.updateRegions}})],1),_c('div',{staticClass:"form-row"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"label":_vm.$t('ibeSearch.dateRangeLabel'),"palceholder":_vm.$t('ibeSearch.dateRangePlaceholder'),"initial-start-date":new Date().setHours(24),"initial-end-date":new Date().setHours(24 * 30 * 6),"theme":_vm.theme},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder'),"maxAdults":99,"maxChildren":99,"theme":_vm.theme},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('div',{staticClass:"short-trip-submit hg-control"},[_c('HgButton',{attrs:{"disabled":_vm.searchUrl === '' || !_vm.searchUrl,"size":"full","color":_vm.submitButtonColor,"tag":"a","target":"_blank","href":_vm.searchUrl},on:{"onClick":_vm.submit}},[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")])],1)]),(_vm.showCooperation)?_c('div',{staticClass:"form-row form-row--cooperation"},[_c('p',[_vm._v("in Kooperation mit")]),_c('GuruLogoPlain',{staticStyle:{"height":"28px"}})],1):_vm._e()])])
}
var hg_cruise_searchvue_type_template_id_7e6d4ce6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-cruise-search.vue?vue&type=template&id=7e6d4ce6&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-cruise-search.vue?vue&type=script&lang=js




/* harmony default export */ var hg_cruise_searchvue_type_script_lang_js = ({
  components: { HgDatepicker: hg_datepicker, HgCruiseSelect: hg_cruise_select },
  props: {
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    showMadeByGoogle: {
      type: Boolean,
      default: false,
    },
    searchUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    lang: {
      type: Object,
      default: () => ({
        cruiseLineLabel: 'Reederei',
        cruiseLinePlaceholder: 'Wähle deine Reederei',
        regionLabel: 'Region',
        regionPlaceholder: 'Wähle deine Region',
      }),
    },
    cruiseLines: {
      type: Array,
      default: () => [],
    },
    regions: {
      type: Array,
      default: () => [],
    },
    showCooperation: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    selectedCruises: null,
    selectedDateRange: null,
    selectedTravelers: null,
    selectedRegion: null,
    sortedCruiseLines: [],
    sortedRegions: [],
  }),
  computed: {
    submitButtonColor() {
      switch (this.theme) {
        case 'bild':
          return 'bild-green'
        default:
          return 'teal'
      }
    },
  },
  watch: {
    cruiseLines() {
      this.changeCruiseTerm('')
    },
    regions() {
      this.changeRegionsTerm('')
    },
  },
  methods: {
    changeCruiseTerm(searchTerm) {
      this.sortedCruiseLines = []
      if (Boolean(searchTerm) && searchTerm !== '') {
        this.cruiseLines.forEach((cruiseLine) => {
          if (
            cruiseLine.name.toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            this.sortedCruiseLines.push(cruiseLine)
          }
        })
      } else {
        this.sortedCruiseLines = this.cruiseLines
      }
    },

    changeRegionsTerm(searchTerm) {
      this.sortedRegions = []
      if (Boolean(searchTerm) && searchTerm !== '') {
        this.regions.forEach((region) => {
          if (region.name.toLowerCase().includes(searchTerm.toLowerCase())) {
            this.sortedRegions.push(region)
          }
        })
      } else {
        this.sortedRegions = this.regions
      }
    },

    updateCruises(cruises) {
      this.selectedCruises = cruises
      this.update()
    },

    updateRegions(regions) {
      this.selectedRegion = regions
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = dateRange
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        region: this.selectedRegion,
        dateRange: this.selectedDateRange,
        travelers: this.selectedTravelers,
        cruiseLine: this.selectedCruises,
      })
    },

    submit() {
      this.$emit('onTriggerSearch')
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-cruise-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_cruise_searchvue_type_script_lang_js = (hg_cruise_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-cruise-search.vue?vue&type=style&index=0&id=7e6d4ce6&prod&lang=postcss&scoped=true
var hg_cruise_searchvue_type_style_index_0_id_7e6d4ce6_prod_lang_postcss_scoped_true = __webpack_require__("408d");

// CONCATENATED MODULE: ./src/components/search/hg-cruise-search.vue






/* normalize component */

var hg_cruise_search_component = normalizeComponent(
  search_hg_cruise_searchvue_type_script_lang_js,
  hg_cruise_searchvue_type_template_id_7e6d4ce6_scoped_true_render,
  hg_cruise_searchvue_type_template_id_7e6d4ce6_scoped_true_staticRenderFns,
  false,
  null,
  "7e6d4ce6",
  null
  
)

/* harmony default export */ var hg_cruise_search = (hg_cruise_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-journaway-search.vue?vue&type=template&id=61e17084&scoped=true
var hg_journaway_searchvue_type_template_id_61e17084_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-ibe-search"},[_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"defaultValue":_vm.defaultDestinationName,"isMobile":_vm.isMobile,"isLoading":_vm.isLoadingDestinations,"label":_vm.$t('ibeSearch.shortDestinationLabel'),"placeholder":_vm.$t('ibeSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ibeSearch.destinationResult')},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"position":"bottom daterange","placeholder":_vm.$t('ibeSearch.dateRangePlaceholder'),"label":_vm.$t('ibeSearch.dateRangeLabel'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row form-row--duration"},[_c('HgTravelDurationSelect',{attrs:{"label":_vm.$t('ibeSearch.durationLabel'),"placeholder":_vm.$t('ibeSearch.durationPlaceholder'),"is-mobile":_vm.isMobile,"options":_vm.$t('ibeSearchControls.durationOptions')},on:{"onSelectTravelDuration":_vm.selectTravelDuration}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('HgButton',{attrs:{"size":"full","color":"teal","tag":"a","target":"_blank","disabled":_vm.loading,"rel":"nofollow","href":_vm.ibeUrl},on:{"onClick":_vm.submit}},[(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")]:_c('HgLoadingBubble')],2)],1)])
}
var hg_journaway_searchvue_type_template_id_61e17084_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-journaway-search.vue?vue&type=template&id=61e17084&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-journaway-search.vue?vue&type=script&lang=js







/* harmony default export */ var hg_journaway_searchvue_type_script_lang_js = ({
  components: { HgDatepicker: hg_datepicker },
  props: {
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    defaultRegionId: Number,
    defaultDestinationName: {
      type: String,
      default: '',
    },
    defaultDateRelative: {
      type: Number,
      default: 0,
    },
    defaultDuration: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
    ibeUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    selectedDestination: null,
    selectedDateRange: null,
    selectedDuration: null,
    initialStartDate: null,
    initialEndDate: null,
  }),

  created() {
    if (this.defaultRegionId) {
      if (['10000', '10001', '10005'].includes(this.defaultRegionId)) {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Region',
        }
      } else {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          regionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Destination',
        }
      }
    } else if (this.defaultCountryId) {
      this.selectedDestination = {
        id: this.defaultCountryId,
        countryISO3166: this.defaultCountryId,
        name: this.defaultDestinationName,
        type: 'Country',
      }
    }

    if (this.defaultDateRelative > 0) {
      this.setInitialDatesToRelative()
    } else {
      this.setInitialDates()
    }
  },

  methods: {
    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = {
        start: new Date(
          fp_getYear(dateRange.start),
          fp_getMonth(dateRange.start),
          fp_getDate(dateRange.start)
        ),
        end: new Date(
          fp_getYear(dateRange.end),
          fp_getMonth(dateRange.end),
          fp_getDate(dateRange.end)
        ),
      }
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', {
        destination: this.selectedDestination,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
      })
    },

    setInitialDates() {
      const today = startOfToday()
      const newToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(newToday, 1)
      this.initialEndDate = addMonths(newToday, 6)
    },

    setInitialDatesToRelative() {
      const today = startOfToday()
      const new_today = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(new_today, 1)
      this.initialEndDate = addDays(new_today, this.defaultDateRelative)
    },

    setInitialDatesToSummer() {
      const today = startOfToday()
      const thisYear = today.getFullYear()
      const nextYear = thisYear + 1

      const startOfThisSummer = new Date(thisYear, 5, 1)
      const endOfThisSummer = new Date(thisYear, 11, 0)
      const startOfNextSummer = new Date(nextYear, 5, 1)
      const endOfNextSummer = new Date(nextYear, 8, 0)

      if (isBefore(today, startOfThisSummer)) {
        this.initialStartDate = startOfThisSummer
        this.initialEndDate = endOfThisSummer
      } else if (
        isAfter(today, startOfThisSummer) &&
        isBefore(today, endOfThisSummer)
      ) {
        this.initialStartDate = addDays(new Date(), 2)
        this.initialEndDate = addMonths(new Date(), 3)
      } else if (isAfter(today, endOfThisSummer)) {
        this.initialStartDate = startOfNextSummer
        this.initialEndDate = endOfNextSummer
      } else {
        this.initialStartDate = addDays(today, 1)
        this.initialEndDate = addMonths(today, 3)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-journaway-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_journaway_searchvue_type_script_lang_js = (hg_journaway_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-journaway-search.vue?vue&type=style&index=0&id=61e17084&prod&lang=postcss&scoped=true
var hg_journaway_searchvue_type_style_index_0_id_61e17084_prod_lang_postcss_scoped_true = __webpack_require__("f8fd");

// CONCATENATED MODULE: ./src/components/search/hg-journaway-search.vue






/* normalize component */

var hg_journaway_search_component = normalizeComponent(
  search_hg_journaway_searchvue_type_script_lang_js,
  hg_journaway_searchvue_type_template_id_61e17084_scoped_true_render,
  hg_journaway_searchvue_type_template_id_61e17084_scoped_true_staticRenderFns,
  false,
  null,
  "61e17084",
  null
  
)

/* harmony default export */ var hg_journaway_search = (hg_journaway_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-ameropa-search.vue?vue&type=template&id=598de7dd&scoped=true
var hg_ameropa_searchvue_type_template_id_598de7dd_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-ibe-search"},[_c('div',{staticClass:"form-row form-row--departure"},[_c('HgDestinationSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"isMobile":_vm.isMobile,"isLoading":_vm.isLoadingDepartures,"label":_vm.$t('ameropaSearch.departureLabel'),"placeholder":_vm.$t('ameropaSearch.departurePlaceholder'),"options":_vm.departures,"noResult":_vm.$t('ameropaSearch.departureResult')},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDepartureTerm', arguments[0])},"onSelectDestination":_vm.selectDeparture}})],1),_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"allowHotjarRecord":_vm.allowHotjarRecord,"isMobile":_vm.isMobile,"isLoading":_vm.isLoadingDestinations,"label":_vm.$t('ameropaSearch.destinationLabel'),"placeholder":_vm.$t('ameropaSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ameropaSearch.destinationResult')},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"position":"bottom daterange","placeholder":_vm.$t('ibeSearch.dateRangePlaceholder'),"label":_vm.$t('ibeSearch.dateRangeLabel'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row form-row--duration"},[_c('HgTravelDurationSelect',{attrs:{"label":_vm.$t('ibeSearch.durationLabel'),"placeholder":_vm.$t('ibeSearch.durationPlaceholder'),"is-mobile":_vm.isMobile,"options":_vm.$t('ameropaSearchControls.durationOptions'),"default-value":'2'},on:{"onSelectTravelDuration":_vm.selectTravelDuration}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder'),"max-adults":8,"max-children":6,"default-child-ages":_vm.defaultChildAges,"showRooms":true,"limitRooms":true},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('HgButton',{attrs:{"size":"full","color":"teal","tag":"a","target":"_blank","disabled":_vm.loading || _vm.searchUrl === '',"rel":"nofollow","href":_vm.searchUrl},on:{"onClick":_vm.submit}},[(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")]:_c('HgLoadingBubble')],2)],1)])
}
var hg_ameropa_searchvue_type_template_id_598de7dd_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-ameropa-search.vue?vue&type=template&id=598de7dd&scoped=true

// CONCATENATED MODULE: ./node_modules/date-fns/esm/addWeeks/index.js



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-ameropa-search.vue?vue&type=script&lang=js







/* harmony default export */ var hg_ameropa_searchvue_type_script_lang_js = ({
  components: { hgDatepicker: hg_datepicker },
  props: {
    allowHotjarRecord: {
      type: Boolean,
      default: false,
    },
    defaultChildAges: {
      type: Number,
      default: 6,
    },
    defaultDuration: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    departures: {
      type: Array,
      default: () => [],
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    searchUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDepartures: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    selectedDeparture: null,
    selectedDestination: null,
    selectedDateRange: null,
    selectedDuration: '2',
    selectedTravelers: null,
    initialStartDate: null,
    initialEndDate: null,
  }),

  created() {
    this.setInitialDates()
  },

  methods: {
    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDeparture(departure) {
      this.selectedDeparture = departure
      this.update()
    },

    selectDestination(destination) {
      this.selectedDestination = destination
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDateRange = {
        start: new Date(
          fp_getYear(dateRange.start),
          fp_getMonth(dateRange.start),
          fp_getDate(dateRange.start)
        ),
        end: new Date(
          fp_getYear(dateRange.end),
          fp_getMonth(dateRange.end),
          fp_getDate(dateRange.end)
        ),
      }
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        departure: this.selectedDeparture,
        destination: this.selectedDestination,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', {
        departure: this.selectedDeparture,
        destination: this.selectedDestination,
        dateRange: this.selectedDateRange,
        duration: this.selectedDuration,
        travelers: this.selectedTravelers,
      })
    },

    setInitialDates() {
      const today = startOfToday()
      const newToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addWeeks(newToday, 2)
      this.initialEndDate = addWeeks(newToday, 3)
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-ameropa-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_ameropa_searchvue_type_script_lang_js = (hg_ameropa_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-ameropa-search.vue?vue&type=style&index=0&id=598de7dd&prod&lang=postcss&scoped=true
var hg_ameropa_searchvue_type_style_index_0_id_598de7dd_prod_lang_postcss_scoped_true = __webpack_require__("bbcf");

// CONCATENATED MODULE: ./src/components/search/hg-ameropa-search.vue






/* normalize component */

var hg_ameropa_search_component = normalizeComponent(
  search_hg_ameropa_searchvue_type_script_lang_js,
  hg_ameropa_searchvue_type_template_id_598de7dd_scoped_true_render,
  hg_ameropa_searchvue_type_template_id_598de7dd_scoped_true_staticRenderFns,
  false,
  null,
  "598de7dd",
  null
  
)

/* harmony default export */ var hg_ameropa_search = (hg_ameropa_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-lastminute-package-tour-search.vue?vue&type=template&id=101e1317&scoped=true
var hg_lastminute_package_tour_searchvue_type_template_id_101e1317_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-ibe-search"},[_c('div',{staticClass:"form-row form-row--destination"},[_c('HgDestinationSelect',{attrs:{"defaultValue":_vm.defaultDestinationName,"isMobile":_vm.isMobile,"label":_vm.$t('ibeSearch.destinationLabel'),"placeholder":_vm.$t('ibeSearch.destinationPlaceholder'),"options":_vm.destinations,"noResult":_vm.$t('ibeSearch.destinationResult')},on:{"onUpdateDestinationTerm":function($event){return _vm.$emit('onUpdateDestinationTerm', arguments[0])},"onSelectDestination":_vm.selectDestination}})],1),_c('div',{staticClass:"form-row form-row--daterange"},[_c('HgDatepicker',{attrs:{"isMobile":_vm.isMobile,"position":"bottom daterange","placeholder":_vm.$t('ibeSearch.dateRangeStartPlaceholder'),"label":_vm.$t('ibeSearch.chooseDate'),"initial-start-date":_vm.initialStartDate,"initial-end-date":_vm.initialEndDate},on:{"onDateRangeSelect":_vm.updateDateRange}})],1),_c('div',{staticClass:"form-row form-row--airports"},[_c('HgAirportSelect',{attrs:{"is-mobile":_vm.isMobile,"airports":_vm.airports,"singleAirport":true,"searched-airports":_vm.searchedAirports,"placeholder":_vm.$t('ibeSearch.airportPlaceholder'),"label":_vm.$t('ibeSearch.airportLabel.without')},on:{"onChangeAirportTerm":function($event){return _vm.$emit('onChangeAirportTerm', arguments[0])},"onSelectAirports":_vm.selectAirports}})],1),_c('div',{staticClass:"form-row form-row--travelers"},[_c('HgTravelers',{attrs:{"lang":_vm.$i18n.locale,"show-errors":false,"max-children":4,"is-mobile":_vm.isMobile,"label":_vm.$t('ibeSearch.travelersLabel'),"placeholder":_vm.$t('ibeSearch.travelersPlaceholder')},on:{"onUpdateTravelers":_vm.updateTravelers}})],1),_c('div',{staticClass:"form-row form-row--submit"},[_c('HgButton',{attrs:{"size":"full","color":"teal","tag":"a","target":"_blank","disabled":_vm.loading || _vm.isButtonDisabled,"rel":"nofollow","href":_vm.searchUrl},on:{"onClick":_vm.submit}},[(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.$t('ibeSearch.buttonText'))+" ")]:_c('HgLoadingBubble')],2)],1)])
}
var hg_lastminute_package_tour_searchvue_type_template_id_101e1317_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/search/hg-lastminute-package-tour-search.vue?vue&type=template&id=101e1317&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/search/hg-lastminute-package-tour-search.vue?vue&type=script&lang=js




/* harmony default export */ var hg_lastminute_package_tour_searchvue_type_script_lang_js = ({
  components: { HgDatepicker: hg_datepicker },
  props: {
    defaultRegionId: Number,
    defaultCountryId: String,
    defaultDestinationName: {
      type: String,
      default: '',
    },
    defaultAdults: {
      type: Number,
      default: 2,
    },
    defaultDateRelative: {
      type: Number,
      default: 0,
    },
    defaultDuration: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    airports: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
    searchUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLoadingDestinations: {
      type: Boolean,
      default: false,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    searchedAirports: {
      type: Array,
      required: true,
      default: () => [],
    },
    isButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    selectedDestination: null,
    selectedDate: null,
    selectedAirports: [],
    selectedDuration: null,
    selectedTravelers: null,
    selectedTags: null,
    initialStartDate: null,
    initialEndDate: null,
  }),

  created() {
    this.selectedDate = format(new Date(), 'yyyy-MM-dd')

    if (this.defaultRegionId) {
      if (['10000', '10001', '10005'].includes(this.defaultRegionId)) {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Region',
        }
      } else {
        this.selectedDestination = {
          id: this.defaultRegionId,
          iffRegionId: this.defaultRegionId,
          regionId: this.defaultRegionId,
          name: this.defaultDestinationName,
          type: 'Destination',
        }
      }
    } else if (this.defaultCountryId) {
      this.selectedDestination = {
        id: this.defaultCountryId,
        countryISO3166: this.defaultCountryId,
        name: this.defaultDestinationName,
        type: 'Country',
      }
    }

    if (this.defaultDateRelative > 0) {
      this.setInitialDatesToRelative()
    } else {
      this.setInitialDatesToSummer()
    }
  },

  methods: {
    selectTravelDuration(duration) {
      this.selectedDuration = duration.value
      this.update()
    },

    selectDestination(destination) {
      console.log("selectedDestination", destination)
      this.selectedDestination = destination
      this.update()
    },

    selectAirports(airports) {
      this.selectedAirports = airports
      this.update()
    },

    selectTags(tags) {
      this.selectedTags = tags
      this.update()
    },

    updateTravelers(travelers) {
      this.selectedTravelers = travelers
      this.update()
    },

    updateDateRange(dateRange) {
      this.selectedDate = dateRange
      this.update()
    },

    update() {
      this.$emit('onUpdateSearchParameters', {
        destination: this.selectedDestination,
        airports: this.selectedAirports.map((airport) => airport.iataCode),
        startDate: this.selectedDate,
        travelers: this.selectedTravelers,
      })
    },

    submit() {
      this.$emit('onTriggerSearch', {
        destination: this.selectedDestination,
        airports: this.selectedAirports.map((airport) => airport.iataCode),
        startDate: this.selectedDate,
        travelers: this.selectedTravelers,
      })
    },

    setInitialDatesToRelative() {
      const today = startOfToday()
      const new_today = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
      this.initialStartDate = addDays(new_today, 2)
      this.initialEndDate = addDays(new_today, this.defaultDateRelative)
    },

    setInitialDatesToSummer() {
      const today = startOfToday()
      const thisYear = today.getFullYear()
      const nextYear = thisYear + 1

      const startOfThisSummer = new Date(thisYear, 5, 1)
      const endOfThisSummer = new Date(thisYear, 8, 0)
      const startOfNextSummer = new Date(nextYear, 5, 1)
      const endOfNextSummer = new Date(nextYear, 8, 0)

      if (isBefore(today, startOfThisSummer)) {
        this.initialStartDate = startOfThisSummer
        this.initialEndDate = endOfThisSummer
      } else if (isAfter(today, endOfThisSummer)) {
        this.initialStartDate = startOfNextSummer
        this.initialEndDate = endOfNextSummer
      } else {
        this.initialStartDate = addDays(today, 1)
        this.initialEndDate = addMonths(today, 3)
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/search/hg-lastminute-package-tour-search.vue?vue&type=script&lang=js
 /* harmony default export */ var search_hg_lastminute_package_tour_searchvue_type_script_lang_js = (hg_lastminute_package_tour_searchvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/search/hg-lastminute-package-tour-search.vue?vue&type=style&index=0&id=101e1317&prod&lang=postcss&scoped=true
var hg_lastminute_package_tour_searchvue_type_style_index_0_id_101e1317_prod_lang_postcss_scoped_true = __webpack_require__("4087");

// CONCATENATED MODULE: ./src/components/search/hg-lastminute-package-tour-search.vue






/* normalize component */

var hg_lastminute_package_tour_search_component = normalizeComponent(
  search_hg_lastminute_package_tour_searchvue_type_script_lang_js,
  hg_lastminute_package_tour_searchvue_type_template_id_101e1317_scoped_true_render,
  hg_lastminute_package_tour_searchvue_type_template_id_101e1317_scoped_true_staticRenderFns,
  false,
  null,
  "101e1317",
  null
  
)

/* harmony default export */ var hg_lastminute_package_tour_search = (hg_lastminute_package_tour_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-content-card.vue?vue&type=template&id=15bbf0cc&scoped=true
var hg_content_cardvue_type_template_id_15bbf0cc_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"hg-content-card__wrapper"},[_c(_vm.computedTag,_vm._b({tag:"component",staticClass:"hg-content-card",on:{"click":function($event){return _vm.$emit('onCardClick')}}},'component',_vm.$attrs,false),[_c('div',{staticClass:"hg-content-card__image"},[_c('hg-image',{attrs:{"src":_vm.imageSrc,"src-placeholder":_vm.placeholderSrc}})],1),_c('div',{staticClass:"hg-content-card__content"},[_c('h3',{staticClass:"hg-content-card__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"hg-content-card__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")]),(_vm.buttonText)?_c('hg-link-button',{attrs:{"tag":"a","href":_vm.buttonLink,"button-text":_vm.buttonText,"align-self":_vm.size === 'small' ? 'end' : 'start',"rounded":"","color":"teal","size":_vm.size}}):_vm._e()],1)])],1)
}
var hg_content_cardvue_type_template_id_15bbf0cc_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/cards/hg-content-card.vue?vue&type=template&id=15bbf0cc&scoped=true

// CONCATENATED MODULE: ./src/components/cards/CardMixin.js
/**
 * HG Cards - Deals/Magazine/Content/etc...
 * Card Mixin
 */
/* harmony default export */ var CardMixin = ({
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    image: {
      type: Object,
      default: () => {},
    },
    tag: {
      type: String,
      default: 'button',
      validator: (value) => {
        return ['button', 'a', 'nuxt-link', 'div', 'span'].indexOf(value) >= 0
      },
    },
  },
  computed: {
    imageSrc() {
      if (this.imageUrl) {
        return this.imageUrl + '&width=420&height=200&mimetype=webp'
      }

      if (this.image) {
        return this.image.url + '?width=420&height=200&mimetype=webp'
      }

      return ''
    },
    placeholderSrc() {
      if (this.imageUrl) return this.imageUrl + '&width=10&mimetype=webp'
      if (this.image) return this.image.url + '?width=10&mimetype=webp'
      return ''
    },
    computedTag() {
      return this.tag
    },
  },
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-content-card.vue?vue&type=script&lang=js




/* harmony default export */ var hg_content_cardvue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  mixins: [CardMixin],
  props: {
    category: {
      type: String,
      default: undefined,
    },
    buttonText: {
      type: String,
      default: 'Mehr',
    },
    buttonLink: {
      type: String,
      default: 'https://www.urlaubsguru.de',
    },
    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return ['small', 'regular'].indexOf(value) >= 0
      },
    },
  },
});

// CONCATENATED MODULE: ./src/components/cards/hg-content-card.vue?vue&type=script&lang=js
 /* harmony default export */ var cards_hg_content_cardvue_type_script_lang_js = (hg_content_cardvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/cards/hg-content-card.vue?vue&type=style&index=0&id=15bbf0cc&prod&scoped=true&lang=postcss
var hg_content_cardvue_type_style_index_0_id_15bbf0cc_prod_scoped_true_lang_postcss = __webpack_require__("a8de");

// CONCATENATED MODULE: ./src/components/cards/hg-content-card.vue






/* normalize component */

var hg_content_card_component = normalizeComponent(
  cards_hg_content_cardvue_type_script_lang_js,
  hg_content_cardvue_type_template_id_15bbf0cc_scoped_true_render,
  hg_content_cardvue_type_template_id_15bbf0cc_scoped_true_staticRenderFns,
  false,
  null,
  "15bbf0cc",
  null
  
)

/* harmony default export */ var hg_content_card = (hg_content_card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-magazine-card.vue?vue&type=template&id=9583825a&scoped=true
var hg_magazine_cardvue_type_template_id_9583825a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"hg-magazine-card__wrapper"},[_c(_vm.computedTag,_vm._b({tag:"component",class:'hg-magazine-card ' + _vm.size,on:{"click":function($event){return _vm.$emit('onCardClick')}}},'component',_vm.$attrs,false),[_c('div',{staticClass:"hg-magazine-card__image"},[_c('hg-image',{attrs:{"src":_vm.imageSrc,"src-placeholder":_vm.placeholderSrc,"alt":_vm.title}})],1),_c('div',{staticClass:"hg-magazine-card__content"},[_c('div',{staticClass:"hg-magazine-card__header"},[_vm._v(_vm._s(_vm.header))]),_c('h3',{staticClass:"hg-magazine-card__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.size !== 'small')?_c('p',{staticClass:"hg-magazine-card__description"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])])],1)
}
var hg_magazine_cardvue_type_template_id_9583825a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/cards/hg-magazine-card.vue?vue&type=template&id=9583825a&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-magazine-card.vue?vue&type=script&lang=js




/* harmony default export */ var hg_magazine_cardvue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  mixins: [CardMixin],
  props: {
    subtitle: {
      type: String,
      default: '',
    },
    header: {
      type: String,
      default: 'Reisebericht',
    },
    excerpt: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'Mehr',
    },
    baseLink: {
      type: String,
      default: 'https://www.urlaubsguru.de/reisemagazin/',
    },
    link: {
      type: String,
      default: undefined,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return ['small', 'regular'].indexOf(value) >= 0
      },
    },
  },
  computed: {
    computedLink() {
      return baseLink + link
    },
  },
});

// CONCATENATED MODULE: ./src/components/cards/hg-magazine-card.vue?vue&type=script&lang=js
 /* harmony default export */ var cards_hg_magazine_cardvue_type_script_lang_js = (hg_magazine_cardvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/cards/hg-magazine-card.vue?vue&type=style&index=0&id=9583825a&prod&scoped=true&lang=postcss
var hg_magazine_cardvue_type_style_index_0_id_9583825a_prod_scoped_true_lang_postcss = __webpack_require__("b5e0");

// CONCATENATED MODULE: ./src/components/cards/hg-magazine-card.vue






/* normalize component */

var hg_magazine_card_component = normalizeComponent(
  cards_hg_magazine_cardvue_type_script_lang_js,
  hg_magazine_cardvue_type_template_id_9583825a_scoped_true_render,
  hg_magazine_cardvue_type_template_id_9583825a_scoped_true_staticRenderFns,
  false,
  null,
  "9583825a",
  null
  
)

/* harmony default export */ var hg_magazine_card = (hg_magazine_card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-card.vue?vue&type=template&id=3f6d751c&scoped=true
var hg_cardvue_type_template_id_3f6d751c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"hgDealCardRedesignContainer",staticClass:"deal-card-wrap"},[_c('div',{staticClass:"badge-wrapper"},[_vm._t("badge")],2),_c('div',{class:['deal-card', { 'deal-card--expired': _vm.isExpired }],on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}},[(_vm.hasMetaButtons && !_vm.isExpired && (_vm.isMobile || _vm.mouseIn))?_c('div',{staticClass:"deal-meta"},[_c('hg-like-bookmark',{attrs:{"has-bookmark":_vm.hasBookmark},on:{"onClickShare":_vm.clickShare,"onClickBookmark":_vm.clickBookmark}})],1):_vm._e(),_c('hg-deal-image-gallery',{attrs:{"images":_vm.images,"width":_vm.width,"height":250,"show-border":false,"show-controls":_vm.isMobile || _vm.mouseIn,"is-circular":true,"is-responsive":false}}),_c('div',{staticClass:"deal-content-wrap"},[_c('div',{staticClass:"deal-content"},[_vm._t("content")],2)])],1)])
}
var hg_cardvue_type_template_id_3f6d751c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/cards/hg-card.vue?vue&type=template&id=3f6d751c&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-card.vue?vue&type=script&lang=js

/* harmony default export */ var hg_cardvue_type_script_lang_js = ({
  props: {
    hasMetaButtons: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isExpired: {
      type: Boolean,
      default: false,
    },
    hasBookmark: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      width: 0,
      mouseIn: false,
    }
  },
  mounted() {
    // Set the initial image width
    this.width = this.$refs.hgDealCardRedesignContainer.clientWidth

    window.addEventListener('resize', this.handleResize)
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleMouseEnter(e) {
      if (!e.sourceCapabilities || !e.sourceCapabilities.firesTouchEvents) {
        this.mouseIn = true
      }
    },
    handleMouseLeave(e) {
      if (!e.sourceCapabilities || !e.sourceCapabilities.firesTouchEvents) {
        this.mouseIn = false
      }
    },
    clickBookmark() {
      this.$emit('onClickBookmark')
    },
    clickShare() {
      this.$emit('onClickShare')
    },
    handleResize() {
      this.width = this.$refs.hgDealCardRedesignContainer.clientWidth
    },
  },
});

// CONCATENATED MODULE: ./src/components/cards/hg-card.vue?vue&type=script&lang=js
 /* harmony default export */ var cards_hg_cardvue_type_script_lang_js = (hg_cardvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/cards/hg-card.vue?vue&type=style&index=0&id=3f6d751c&prod&scoped=true&lang=postcss
var hg_cardvue_type_style_index_0_id_3f6d751c_prod_scoped_true_lang_postcss = __webpack_require__("664a");

// CONCATENATED MODULE: ./src/components/cards/hg-card.vue






/* normalize component */

var hg_card_component = normalizeComponent(
  cards_hg_cardvue_type_script_lang_js,
  hg_cardvue_type_template_id_3f6d751c_scoped_true_render,
  hg_cardvue_type_template_id_3f6d751c_scoped_true_staticRenderFns,
  false,
  null,
  "3f6d751c",
  null
  
)

/* harmony default export */ var hg_card = (hg_card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-card-hotel-of-the-day.vue?vue&type=template&id=f6a5bc7e&scoped=true
var hg_card_hotel_of_the_dayvue_type_template_id_f6a5bc7e_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('hg-card',{attrs:{"images":_vm.images,"is-mobile":_vm.isMobile},scopedSlots:_vm._u([(_vm.showCircle)?{key:"badge",fn:function(){return [_c('HotelOfTheDaySvg',{staticClass:"hotd-circle"})]},proxy:true}:null,{key:"content",fn:function(){return [_c('hg-deal-type',{attrs:{"icon":_vm.dealType.icon,"name":_vm.dealType.name}}),_c('div',{staticClass:"upperSection"},[_c('h2',[_vm._v(_vm._s(_vm.headline))]),(_vm.description)?_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()]),(_vm.rating != null)?_c('hg-star-rating',{staticClass:"hg-stars-hotd",attrs:{"rating":_vm.rating,"showEmptyStars":false}}):_c('p',[_vm._v(_vm._s(_vm.ratingText))]),_c('div',{staticClass:"organizer-wrap"},[(_vm.orgaLogo || _vm.organizer)?_c('div',{staticClass:"organizer-content"},[_c('div',{staticClass:"hg-organizer"},[_vm._v(" "+_vm._s(_vm.$t('hotel-of-the-day.organizer'))+": ")]),(_vm.orgaLogo)?_c('img',{attrs:{"src":_vm.orgaLogo,"alt":"icon"}}):_c('p',{staticClass:"hg-organizer-name"},[_vm._v(_vm._s(_vm.organizer))])]):_vm._e()]),_c('HgButton',{staticClass:"card-cta",attrs:{"color":"teal-outline","tag":"a","href":_vm.link,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.button)+" ")])]},proxy:true}],null,true)})
}
var hg_card_hotel_of_the_dayvue_type_template_id_f6a5bc7e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/cards/hg-card-hotel-of-the-day.vue?vue&type=template&id=f6a5bc7e&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/hotel-of-the-day-circle-svg.vue?vue&type=template&id=1ba1fb94&scoped=true
var hotel_of_the_day_circle_svgvue_type_template_id_1ba1fb94_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116 116","width":"116","height":"116"}},[_c('circle',{staticStyle:{"fill":"none","stroke":"#fff","stroke-width":"23px"},attrs:{"cx":"58.57","cy":"60.57","r":"43.5","shape-rendering":"crispEdges"}}),_c('path',{attrs:{"fill":"#00d5e0","d":"M15.41 58.16c-.9.04-1.57.21-2.01.5-.44.29-.64.71-.62 1.27.03.56.27.96.74 1.21s1.15.35 2.05.31c1.82-.09 2.7-.68 2.65-1.79-.02-.56-.27-.96-.75-1.2-.47-.25-1.16-.35-2.06-.3ZM16.26 41.55c-.38.09-.64.34-.79.74-.3.83.09 1.53 1.16 2.12l.98-2.72c-.52-.18-.96-.23-1.34-.14ZM79.84 18.37c-.04-.39-.25-.68-.64-.88-.78-.4-1.54-.11-2.25.88l2.58 1.31c.25-.49.35-.93.31-1.32ZM101.73 61.8l-.35 2.87c.54.07.99.01 1.34-.16.35-.17.55-.47.6-.9.11-.87-.43-1.48-1.6-1.81ZM54.93 15.19c-.21-1.76-.79-2.58-1.74-2.47-.57.07-1.01.47-1.33 1.22l.47 3.95c.43.18.85.24 1.28.19 1.1-.13 1.54-1.09 1.33-2.89ZM44.52 17.31c-.63-1.66-1.4-2.31-2.3-1.97-.53.2-.86.7-.99 1.51l1.42 3.72c.46.07.89.02 1.29-.13 1.03-.4 1.23-1.44.58-3.13ZM67.39 18.8c.55.14 1.11-.09 1.67-.68l.93-3.87c-.34-.31-.72-.52-1.13-.62-1.08-.26-1.83.49-2.25 2.25-.41 1.72-.15 2.7.78 2.92ZM94.92 51.74c-.25.03-.43.2-.53.52-.11.32-.12.8-.05 1.44.07.6.2 1.05.39 1.34.19.29.42.42.69.39.27-.03.45-.25.53-.66.08-.41.1-1.13.05-2.17a1.9 1.9 0 0 0-.5-.65c-.19-.15-.38-.22-.57-.19ZM102.1 51.33c-.42.05-.71.21-.89.48-.18.27-.25.6-.2.99.04.39.18.7.42.92.24.22.56.31.97.27.43-.05.73-.21.91-.48.18-.27.25-.6.2-.99-.04-.39-.19-.7-.42-.92-.24-.22-.57-.31-.99-.26ZM96 42.4c-.22.08-.38.22-.46.41-.08.19-.07.42.03.69.11.31.32.57.63.78.3.21.63.32.98.34l.92-.34c-.57-1.57-1.27-2.2-2.1-1.89Z"}}),_c('path',{attrs:{"fill":"#00d5e0","d":"M36.39 4.2C6.66 16.15-7.75 49.92 4.2 79.65c11.95 29.72 45.72 44.13 75.45 32.19 29.72-11.95 44.13-45.72 32.19-75.45C99.89 6.66 66.11-7.75 36.39 4.2ZM86.1 20.47c.78-.04 1.56.26 2.33.89.49.4.9.85 1.24 1.35.34.5.4.88.19 1.14-.14.18-.39.35-.76.51-.36.17-.61.2-.72.1-.04-.03-.13-.19-.29-.47-.15-.28-.38-.54-.67-.79-.49-.4-.87-.43-1.13-.11-.16.2-.21.43-.14.67.07.24.22.57.45.99.03.07.09.18.17.32.08.14.15.27.19.38.22.47.33.95.3 1.43-.03.48-.24.96-.65 1.46-.58.72-1.29 1.1-2.12 1.14-.83.04-1.67-.28-2.52-.97-.57-.47-1.03-.98-1.37-1.54-.34-.56-.4-.99-.17-1.26.15-.18.42-.34.81-.46.39-.12.65-.12.79-.01.07.06.15.18.22.36.13.24.25.45.37.64.12.18.29.36.5.53.26.21.5.32.72.33s.41-.08.56-.26c.13-.17.19-.34.17-.53-.02-.18-.06-.35-.14-.5-.08-.15-.24-.44-.48-.85-.32-.57-.51-1.11-.56-1.65-.05-.53.17-1.1.67-1.71.58-.71 1.25-1.08 2.03-1.12Zm-5.94-4.58c1.18.6 1.85 1.42 2.02 2.47.17 1.05-.05 2.18-.67 3.38-.06.13-.27.26-.61.4s-.57.18-.68.13l-4.06-2.06c-.25.63-.29 1.15-.11 1.57.18.41.54.76 1.09 1.04.3.15.58.25.86.31.28.05.58.1.9.12.21 0 .35.02.42.05.11.05.18.19.24.41.05.22.08.45.07.7s-.04.42-.09.52c-.12.25-.39.37-.81.38-.42 0-.87-.06-1.38-.21-.5-.15-.92-.31-1.26-.48-1.4-.71-2.25-1.61-2.56-2.71-.3-1.09-.12-2.31.55-3.63.76-1.49 1.66-2.42 2.7-2.77 1.04-.35 2.16-.22 3.37.39Zm-16.34 2.23c-.11-.77-.04-1.65.19-2.63.35-1.44.94-2.49 1.78-3.18.84-.69 1.84-.89 3-.61.68.16 1.23.49 1.64.96l.93-3.85c.09-.37.48-.47 1.17-.3l.49.12c.69.17.99.44.91.8l-2.28 9.47c-.13.53-.21.94-.25 1.23-.04.29-.07.6-.11.95 0 .16-.01.29-.04.39-.05.18-.31.27-.8.25-.49-.02-.91-.07-1.27-.16-.21-.05-.33-.17-.37-.35-.04-.19-.06-.38-.05-.58s.01-.34.02-.41c-.3.33-.69.57-1.15.71-.47.14-.97.15-1.49.03-.63-.15-1.14-.47-1.54-.95-.41-.48-.66-1.11-.77-1.88Zm-13.49 5.66-1.08-9.23c-.06-.52-.12-.92-.19-1.19-.06-.27-.14-.58-.22-.92-.05-.16-.09-.28-.1-.37-.02-.19.2-.36.67-.51.47-.15.89-.25 1.25-.29.21-.02.37.04.47.19.1.15.18.31.25.49.06.18.11.3.13.37.17-.41.44-.77.84-1.07.39-.3.85-.48 1.38-.54.64-.08 1.23.04 1.77.36.55.32 1 .81 1.37 1.5.37.69.61 1.53.73 2.54.17 1.47-.02 2.67-.57 3.6-.56.93-1.43 1.47-2.6 1.61-.7.08-1.32-.03-1.87-.34l.41 3.49c.04.38-.29.61-.99.69l-.5.06c-.71.08-1.08-.06-1.13-.44Zm-12.11-8.61c.42-.26.8-.46 1.14-.59.2-.08.37-.05.5.07.13.12.25.26.36.42.11.16.18.27.21.33.06-.44.24-.86.55-1.24.31-.38.71-.67 1.21-.86.6-.23 1.2-.26 1.81-.09.61.17 1.17.54 1.7 1.12.52.58.97 1.34 1.33 2.28.53 1.38.63 2.59.32 3.63s-1.02 1.77-2.13 2.2c-.66.25-1.29.3-1.9.13l1.25 3.28c.14.36-.13.66-.8.92l-.47.18c-.67.25-1.07.2-1.2-.15l-3.32-8.69c-.19-.49-.34-.86-.47-1.11-.13-.25-.27-.53-.44-.83-.09-.14-.16-.25-.18-.33-.07-.18.11-.4.52-.66Zm-3.27 2.18 4.29 7.06c.2.32 0 .67-.62 1.04l-.43.26c-.61.37-1.02.39-1.21.07l-4.29-7.06c-.2-.33.01-.67.62-1.04l.43-.26c.61-.37 1.02-.39 1.21-.07Zm-3.36-2.99c.75-.46 1.24-.5 1.47-.12l.66 1.08c.24.39-.02.81-.78 1.27-.75.46-1.24.49-1.48.11l-.66-1.08c-.23-.38.03-.79.79-1.25Zm-10.21 9.05c-.03-.16.02-.31.16-.43l6.32-5.59c.14-.13.29-.16.45-.11.16.05.34.19.54.42l.37.41c.21.23.32.43.36.59.03.16-.02.31-.17.43l-2.13 1.88 6.37 7.21c.25.28.11.66-.42 1.14l-.47.42c-.53.47-.93.57-1.18.28l-6.37-7.21-2.13 1.88c-.14.13-.29.16-.45.11-.16-.05-.34-.19-.54-.42l-.37-.41c-.21-.23-.32-.43-.36-.59Zm1.09 9.33 2.22-2.88c.12-.15.26-.21.42-.2.16.02.37.12.61.32l.1.08c.25.19.4.36.46.51.06.16.03.31-.08.46l-2.22 2.88c-.12.15-.26.21-.42.2-.16-.02-.37-.13-.61-.32l-.1-.08c-.25-.19-.4-.36-.46-.51-.06-.15-.03-.31.08-.46Zm-9.1-.05.25-.43c.36-.62.7-.83 1.03-.64l8.81 5.09c.24.14.43.19.59.16s.29-.14.4-.34c.03-.05.06-.13.09-.23s.06-.17.09-.23c.06-.09.18-.13.37-.11.2.02.4.06.61.12.21.07.34.12.41.15.51.29.47.93-.1 1.92-.87 1.5-2.14 1.77-3.81.81l-8.78-5.07c-.33-.19-.32-.6.04-1.21Zm7.53 33.82.2.59c.23.68.17 1.08-.2 1.2l-4.41 1.51 1.56 4.56 4.41-1.51c.36-.12.65.15.89.83l.2.59c.23.68.17 1.08-.2 1.2l-10.81 3.69c-.36.12-.65-.15-.89-.83l-.2-.59c-.23-.68-.17-1.08.2-1.2l4.17-1.43-1.56-4.56-4.17 1.43c-.36.12-.65-.15-.89-.83l-.2-.59c-.23-.68-.17-1.08.2-1.2l10.81-3.69c.36-.13.65.15.89.83Zm-.58-6.67c.07 1.42-.29 2.51-1.08 3.29-.79.78-1.96 1.2-3.52 1.28-1.55.07-2.76-.24-3.62-.93-.85-.7-1.32-1.75-1.38-3.17-.07-1.42.29-2.51 1.08-3.28s1.96-1.19 3.51-1.27c1.56-.08 2.77.23 3.63.93.86.69 1.32 1.74 1.39 3.16Zm.53-8.4c-.26 1.72-1.35 2.43-3.25 2.14l-4.45-.68-.04.28c-.03.19-.12.31-.27.37-.15.06-.38.07-.69.02l-.3-.05c-.31-.05-.52-.12-.65-.23-.13-.1-.18-.25-.15-.44l.04-.28-1.64-.49c-.37-.12-.51-.46-.42-1.04l.08-.55c.09-.59.32-.85.7-.8l1.68.26.13-.87c.03-.19.12-.31.27-.37.15-.06.38-.07.69-.02l.3.05c.31.05.52.12.65.23.13.11.18.25.15.44l-.13.87 4.48.68c.27.04.47.02.61-.06.13-.08.22-.23.25-.46v-.48c.02-.11.12-.19.31-.24.19-.06.39-.09.61-.11.22-.01.36-.02.44 0 .58.09.78.7.61 1.83Zm-4.2-3.89c-1.58-.57-2.61-1.34-3.09-2.33s-.49-2.12-.03-3.4c.45-1.24 1.18-2.01 2.19-2.31 1.02-.3 2.17-.22 3.44.24.14.05.29.24.47.56.18.32.25.54.21.65l-1.53 4.29c.66.17 1.18.14 1.57-.08.39-.23.68-.64.89-1.22.11-.31.18-.61.2-.9.02-.28.02-.59.01-.91-.03-.21-.03-.35 0-.42.04-.11.17-.21.38-.29.21-.09.44-.13.68-.15.24-.02.42-.01.53.03.26.09.42.34.48.76.06.41.05.88-.03 1.39-.08.51-.19.95-.32 1.31-.53 1.48-1.32 2.44-2.37 2.88-1.05.44-2.27.41-3.67-.09h-.01Zm51.91 37.11c-14.59 5.87-31.18-1.21-37.04-15.8-5.86-14.59 1.21-31.18 15.8-37.04 14.59-5.86 31.18 1.21 37.04 15.8 5.86 14.59-1.21 31.18-15.8 37.04Zm34.57-10.93c-.2.6-.48 1.14-.84 1.63-.35.49-.69.68-1.01.57-.22-.08-.46-.25-.74-.54-.28-.28-.39-.5-.34-.65.02-.05.13-.19.34-.43.22-.24.38-.54.51-.9.2-.6.11-.96-.28-1.1a.718.718 0 0 0-.68.1c-.2.15-.46.4-.77.76-.06.06-.14.15-.24.27-.11.13-.21.23-.3.32-.37.38-.78.64-1.24.77-.46.14-.99.11-1.59-.1-.88-.3-1.48-.83-1.81-1.6-.32-.77-.31-1.67.05-2.7.24-.7.57-1.3.98-1.82.41-.51.79-.71 1.13-.6.22.08.46.28.71.6.25.32.34.57.28.74-.03.09-.12.2-.26.32-.18.2-.34.39-.47.57-.13.18-.24.39-.33.65-.11.32-.13.58-.06.79.07.21.21.35.44.43.2.07.39.06.55-.02.17-.08.31-.18.43-.31.12-.12.33-.37.63-.75.42-.5.87-.86 1.35-1.09.48-.23 1.09-.22 1.84.03.87.3 1.45.81 1.75 1.52.3.72.29 1.55-.03 2.5Zm2.27-9.62c-.16 1.31-.7 2.22-1.63 2.74-.93.52-2.06.69-3.41.53-.14-.02-.34-.17-.58-.44-.25-.28-.36-.47-.35-.59l.55-4.52c-.68-.02-1.18.12-1.51.43-.33.31-.53.77-.6 1.38-.04.33-.04.64 0 .92s.11.58.19.89c.07.2.1.34.09.41-.01.12-.11.24-.31.37-.19.13-.4.23-.63.3-.23.07-.41.1-.52.09-.27-.03-.48-.24-.63-.63-.15-.39-.24-.84-.28-1.36-.03-.52-.03-.97.02-1.35.19-1.56.75-2.67 1.67-3.33.93-.66 2.13-.9 3.6-.72 1.67.2 2.84.73 3.53 1.59.69.86.95 1.96.78 3.31Zm.06-11.57c.05.46.06.92.02 1.38l.33 2.85c.02.19-.03.33-.17.43-.13.1-.35.16-.66.2l-.3.04c-.55.07-.85-.05-.88-.33-.01-.1-.02-.22-.02-.38v-.39l-.08-.03c-.1.1-.24.18-.43.26a1.9 1.9 0 0 1-.53.14c-1.05.12-1.88-.12-2.48-.73-.6-.61-.96-1.45-1.08-2.52-.08-.72-.29-1.06-.61-1.03-.2.02-.33.16-.37.42-.05.26-.08.69-.11 1.31 0 .43 0 .76-.03.99-.07.86-.26 1.56-.58 2.1-.31.54-.88.86-1.68.95-.6.07-1.15-.06-1.65-.38-.5-.33-.91-.82-1.24-1.48-.33-.66-.54-1.45-.65-2.36-.33-2.81.33-4.31 1.96-4.5.46-.05.88.04 1.27.27.39.24.71.6.97 1.1h.07c.09-.25.25-.46.47-.62.22-.16.48-.25.78-.29.29-.03.58.02.86.18.27.16.52.39.74.72.42-1.02 1.25-1.6 2.47-1.74 1.07-.12 1.91.14 2.5.78.6.64.96 1.53 1.09 2.67Zm-2.65-11c.46 1.26.55 2.27.26 3.02-.29.75-.87 1.29-1.74 1.61l-3.15 1.16c-.51.19-.9.35-1.16.47-.26.13-.54.27-.85.43-.13.09-.25.15-.35.19-.18.06-.39-.11-.65-.53-.26-.42-.45-.8-.57-1.15-.07-.2-.04-.37.09-.51s.29-.26.46-.37c.17-.11.3-.18.36-.22-.15-.02-.36-.1-.63-.23s-.55-.34-.85-.64c-.3-.3-.53-.67-.7-1.13-.32-.86-.32-1.57-.02-2.13.3-.56.82-.98 1.56-1.25.89-.33 1.76-.27 2.59.16.83.44 1.6 1.61 2.29 3.5l.55-.2c.33-.12.53-.31.61-.57.08-.26.04-.63-.13-1.08-.14-.38-.3-.7-.48-.95-.18-.26-.36-.48-.55-.66-.18-.19-.28-.3-.29-.33-.04-.11 0-.26.11-.46.12-.2.27-.38.45-.57s.33-.29.46-.34c.19-.07.42 0 .71.22s.57.55.86 1c.29.45.54.97.76 1.56Zm-.32-6.52-.46.3c-.26.17-.47.26-.64.26-.17 0-.3-.07-.4-.23l-1.54-2.38-8.07 5.23c-.32.21-.67 0-1.06-.59l-.34-.53c-.39-.6-.42-1-.1-1.21l8.07-5.23-1.54-2.38c-.1-.16-.12-.31-.04-.46.07-.15.24-.31.5-.47l.46-.3c.26-.17.47-.25.64-.26.17 0 .3.07.4.23l4.59 7.08c.1.16.12.31.04.46-.07.15-.24.31-.5.47Z"}}),_c('path',{staticStyle:{"fill-rule":"evenodd","fill":"#fff"},attrs:{"d":"M60.55 108.18c2.28 0 3.31-1.16 3.33-2.81.39-.54.6-1.27.51-1.98.29-.54.4-1.19.27-1.86.26-.44.41-.9.41-1.47 0-1.3-1.1-2.53-2.53-2.53h-1.08c.15-.38.26-.83.26-1.37 0-2.15-1.11-3.09-2.81-3.09-1.29 0-1.61 1.4-1.83 2.37-.09.4-.17.72-.28.84-.33.32-.68.79-1.02 1.25-.36.49-.72.95-1.01 1.21h-2.91c-.52 0-.94.42-.94.94v7.08c0 .52.42.94.94.94h1.89c.44 0 .81-.3.91-.71.51.01.96.19 1.5.41.84.34 1.9.77 3.75.77h.66Zm.31-1.42h-1.12c-1.13 0-2.05-.32-2.91-.62-.74-.26-1.43-.5-2.16-.5v-5.5h.32c.56 0 1.28-.95 1.93-1.81.31-.41.61-.81.86-1.06.46-.46.58-1.09.69-1.66.09-.46.17-.88.42-1.13 1.4 0 1.4.97 1.4 1.67 0 .58-.21 1-.42 1.42-.21.41-.41.82-.41 1.37h3.07c.62 0 1.11.56 1.12 1.12 0 .56-.38 1.12-.66 1.12.4.43.48 1.33-.15 1.94.37.62.04 1.46-.41 1.7.23 1.44-.52 1.94-1.57 1.94Zm-8.78-.94c0 .39.32.71.71.71s.71-.32.71-.71-.32-.71-.71-.71-.71.32-.71.71Z"}}),_c('path',{attrs:{"fill":"#fff","d":"m29.43 85.24-.77 3.18 2.79 1.71-3.26.25-.77 3.18-1.25-3.02-3.26.25 2.49-2.12-1.25-3.02 2.79 1.71 2.49-2.12ZM89.44 84.78v3.27l3.13 1-3.11 1.02v3.27l-1.92-2.64-3.1 1.02 1.91-2.65-1.93-2.64 3.11 1 1.91-2.65Z"}})])
}
var hotel_of_the_day_circle_svgvue_type_template_id_1ba1fb94_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/hotel-of-the-day-circle-svg.vue?vue&type=template&id=1ba1fb94&scoped=true

// EXTERNAL MODULE: ./src/components/svg/decorations/hotel-of-the-day-circle-svg.vue?vue&type=style&index=0&id=1ba1fb94&prod&lang=postcss&scoped=true
var hotel_of_the_day_circle_svgvue_type_style_index_0_id_1ba1fb94_prod_lang_postcss_scoped_true = __webpack_require__("595b");

// CONCATENATED MODULE: ./src/components/svg/decorations/hotel-of-the-day-circle-svg.vue

var hotel_of_the_day_circle_svg_script = {}



/* normalize component */

var hotel_of_the_day_circle_svg_component = normalizeComponent(
  hotel_of_the_day_circle_svg_script,
  hotel_of_the_day_circle_svgvue_type_template_id_1ba1fb94_scoped_true_render,
  hotel_of_the_day_circle_svgvue_type_template_id_1ba1fb94_scoped_true_staticRenderFns,
  false,
  null,
  "1ba1fb94",
  null
  
)

/* harmony default export */ var hotel_of_the_day_circle_svg = (hotel_of_the_day_circle_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-card-hotel-of-the-day.vue?vue&type=script&lang=js



/* harmony default export */ var hg_card_hotel_of_the_dayvue_type_script_lang_js = ({
  components: {
    HotelOfTheDaySvg: hotel_of_the_day_circle_svg,
  },
  props: {
    description: {
      type: String,
      default: '',
    },
    images: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    headline: {
      type: String,
      default: '',
    },
    ratingText: {
      type: String,
      default: '',
    },
    organizer: {
      type: String,
      default: '',
    },
    button: {
      type: String,
      default: '',
    },
    orgaLogo: {
      type: String,
      default: '',
    },
    dealType: {
      type: Object,
      default: () => {},
    },
    showCircle: {
      type: Boolean,
      default: false,
    },
    rating: {
      type: Number,
      default: null,
    },
    link: {
      type: String,
      default: undefined,
    },
  },
});

// CONCATENATED MODULE: ./src/components/cards/hg-card-hotel-of-the-day.vue?vue&type=script&lang=js
 /* harmony default export */ var cards_hg_card_hotel_of_the_dayvue_type_script_lang_js = (hg_card_hotel_of_the_dayvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/cards/hg-card-hotel-of-the-day.vue?vue&type=style&index=0&id=f6a5bc7e&prod&lang=postcss&scoped=true
var hg_card_hotel_of_the_dayvue_type_style_index_0_id_f6a5bc7e_prod_lang_postcss_scoped_true = __webpack_require__("743c");

// CONCATENATED MODULE: ./src/components/cards/hg-card-hotel-of-the-day.vue






/* normalize component */

var hg_card_hotel_of_the_day_component = normalizeComponent(
  cards_hg_card_hotel_of_the_dayvue_type_script_lang_js,
  hg_card_hotel_of_the_dayvue_type_template_id_f6a5bc7e_scoped_true_render,
  hg_card_hotel_of_the_dayvue_type_template_id_f6a5bc7e_scoped_true_staticRenderFns,
  false,
  null,
  "f6a5bc7e",
  null
  
)

/* harmony default export */ var hg_card_hotel_of_the_day = (hg_card_hotel_of_the_day_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-card-category.vue?vue&type=template&id=0ad51ea0&scoped=true
var hg_card_categoryvue_type_template_id_0ad51ea0_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hg-category-wrapper",attrs:{"role":"button","type":"button"},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"hg-img-wrap"},[_c('img',{staticClass:"hg-category-img",attrs:{"src":_vm.image,"alt":_vm.alt}})]),_c('div',{staticClass:"hg-text-content",attrs:{"id":"textContent"}},[_c('div',{staticClass:"hg-category"},[_vm._v(_vm._s(_vm.category))]),_c('div',{staticClass:"hg-offer"},[_c('div',{staticClass:"tw-mr-2"},[_vm._v(_vm._s(_vm.deals))]),_c('ButtonCircleSvg',{staticClass:"hg-arrow"})],1)])])
}
var hg_card_categoryvue_type_template_id_0ad51ea0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/cards/hg-card-category.vue?vue&type=template&id=0ad51ea0&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/button-circle-svg.vue?vue&type=template&id=5933b375
var button_circle_svgvue_type_template_id_5933b375_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"8.84863","cy":"8.07422","r":"8","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M10.6227 8.0206L7.65377 5.05167C7.58713 4.98505 7.47938 4.98505 7.41274 5.05167L7.13201 5.33241C7.06537 5.39904 7.06537 5.5068 7.13201 5.57344L9.69402 8.14111L7.13201 10.7088C7.06537 10.7754 7.06537 10.8832 7.13201 10.9498L7.41274 11.2305C7.47938 11.2972 7.58713 11.2972 7.65377 11.2305L10.6227 8.26163C10.6893 8.19499 10.6893 8.08724 10.6227 8.0206Z","fill":"#323231"}})])
}
var button_circle_svgvue_type_template_id_5933b375_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/button-circle-svg.vue?vue&type=template&id=5933b375

// CONCATENATED MODULE: ./src/components/svg/decorations/button-circle-svg.vue

var button_circle_svg_script = {}


/* normalize component */

var button_circle_svg_component = normalizeComponent(
  button_circle_svg_script,
  button_circle_svgvue_type_template_id_5933b375_render,
  button_circle_svgvue_type_template_id_5933b375_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var button_circle_svg = (button_circle_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-card-category.vue?vue&type=script&lang=js



/**
 * HG Card Category
 */
/* harmony default export */ var hg_card_categoryvue_type_script_lang_js = ({
  components: {
    ButtonCircleSvg: button_circle_svg,
  },
  props: {
    category: {
      type: String,
      default: '',
    },
    deals: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleClick(e) {
      if (e.composedPath().filter((el) => el.id === 'textContent').length > 0) {
        this.$emit('onClick', {
          event: 'gtmEvent',
          eventName: 'homepage_click_holiday_category',
          categoryName: 'text',
          elementName: this.category,
        })
      } else {
        this.$emit('onClick', {
          event: 'gtmEvent',
          eventName: 'homepage_click_holiday_category',
          categoryName: 'card',
          elementName: this.category,
        })
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/cards/hg-card-category.vue?vue&type=script&lang=js
 /* harmony default export */ var cards_hg_card_categoryvue_type_script_lang_js = (hg_card_categoryvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/cards/hg-card-category.vue?vue&type=style&index=0&id=0ad51ea0&prod&scoped=true&lang=postcss
var hg_card_categoryvue_type_style_index_0_id_0ad51ea0_prod_scoped_true_lang_postcss = __webpack_require__("3a94");

// CONCATENATED MODULE: ./src/components/cards/hg-card-category.vue






/* normalize component */

var hg_card_category_component = normalizeComponent(
  cards_hg_card_categoryvue_type_script_lang_js,
  hg_card_categoryvue_type_template_id_0ad51ea0_scoped_true_render,
  hg_card_categoryvue_type_template_id_0ad51ea0_scoped_true_staticRenderFns,
  false,
  null,
  "0ad51ea0",
  null
  
)

/* harmony default export */ var hg_card_category = (hg_card_category_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-hotel-of-the-day-landing.vue?vue&type=template&id=df756024&scoped=true
var hg_hotel_of_the_day_landingvue_type_template_id_df756024_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-hotel-landing--wrap",on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}},[_c('div',{ref:"hgDealCardRedesignContainer",staticClass:"hg-img-container",attrs:{"id":"hotd__container"}},[(_vm.images.length > 0)?_c('hg-deal-image-gallery',{staticClass:"hg-test",attrs:{"images":_vm.images,"width":_vm.width,"height":_vm.height,"show-border":false,"show-controls":_vm.isMobile || _vm.mouseIn,"is-circular":true,"is-responsive":false}}):_vm._e(),(_vm.showCircle)?_c('HotelOfTheDaySvg',{staticClass:"hg-hotd-circle"}):_vm._e()],1),_c('div',{staticClass:"hg-landing-content"},[_c('div',{staticClass:"hg-landing-direction"},[_c('hg-deal-type',{attrs:{"icon":_vm.dealType.icon,"name":_vm.dealType.name}})],1),_c('h2',{staticClass:"hg-hotel-landing-headline"},[_vm._v(_vm._s(_vm.headline))]),(_vm.rating != null)?_c('hg-star-rating',{staticClass:"hg-hotd-stars",attrs:{"rating":_vm.rating,"showEmptyStars":false}}):_c('p',{staticClass:"hg-hotel-landing-rating-text"},[_vm._v(" "+_vm._s(_vm.ratingText)+" ")]),_c('p',{staticClass:"hg-hotel-landing-description"},[_vm._v(" "+_vm._s(_vm.description)+" ")]),(_vm.orgaLogo || _vm.organizer)?_c('div',{staticClass:"hg-landing-organizer"},[_c('div',{staticClass:"hg-organizer"},[_vm._v(_vm._s(_vm.$t('hotel-of-the-day.organizer'))+":")]),(_vm.orgaLogo)?_c('img',{attrs:{"src":_vm.orgaLogo,"alt":"icons"}}):_c('p',{staticClass:"hg-organizer-name"},[_vm._v(_vm._s(_vm.organizer))])]):_vm._e(),_c('div',{class:['hg-cta-wrap', { [`hg-cta-wrap--theme-${_vm.theme}`]: _vm.theme }]},[_c('HgButton',{staticClass:"hg-cta-width",attrs:{"color":"teal","tag":"a","target":"_blank","href":_vm.link},on:{"onClick":function($event){return _vm.$emit('onClick')}}},[_vm._v(" "+_vm._s(_vm.button)+" "),_c('ArrowSvg',{staticClass:"hg-cta-arrow"})],1)],1)],1)])
}
var hg_hotel_of_the_day_landingvue_type_template_id_df756024_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/cards/hg-hotel-of-the-day-landing.vue?vue&type=template&id=df756024&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-hotel-of-the-day-landing.vue?vue&type=script&lang=js

/* harmony default export */ var hg_hotel_of_the_day_landingvue_type_script_lang_js = ({
  props: {
    img: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    orgaLogo: {
      type: String,
      default: '',
    },
    ratingText: {
      type: String,
      default: '',
    },
    rating: {
      type: Number,
      default: null,
    },
    showRatingText: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: '',
    },
    images: {
      type: Array,
      default: () => [],
    },
    button: {
      type: String,
      default: '',
    },
    headline: {
      type: String,
      default: '',
    },
    organizer: {
      type: String,
      default: '',
    },
    dealType: {
      type: Object,
      default: () => {},
    },
    showCircle: {
      type: Boolean,
      default: true,
    },
    link: {
      type: String,
      default: undefined,
    },
  },

  data() {
    return {
      width: 0,
      height: 50,
      mouseIn: false,
    }
  },

  watch: {
    headline() {
      this.handleResize()
    },
    description() {
      this.handleResize()
    },
  },

  mounted() {
    // Set the initial image width
    this.width = this.$refs.hgDealCardRedesignContainer.clientWidth
    this.height = this.$refs.hgDealCardRedesignContainer.clientHeight

    window.addEventListener('resize', this.handleResize)
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleMouseEnter(e) {
      if (!e.sourceCapabilities || !e.sourceCapabilities.firesTouchEvents) {
        this.mouseIn = true
      }
    },
    handleMouseLeave(e) {
      if (!e.sourceCapabilities || !e.sourceCapabilities.firesTouchEvents) {
        this.mouseIn = false
      }
    },
    handleResize() {
      // Reset the width and height on resize
      this.height = 0

      // Set the new width and height after a short delay, so the div is set to the correct size
      setTimeout(() => {
        this.width = this.$refs.hgDealCardRedesignContainer.clientWidth
        this.height = this.$refs.hgDealCardRedesignContainer.clientHeight
      }, 5)
    },
  },
});

// CONCATENATED MODULE: ./src/components/cards/hg-hotel-of-the-day-landing.vue?vue&type=script&lang=js
 /* harmony default export */ var cards_hg_hotel_of_the_day_landingvue_type_script_lang_js = (hg_hotel_of_the_day_landingvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/cards/hg-hotel-of-the-day-landing.vue?vue&type=style&index=0&id=df756024&prod&scoped=true&lang=postcss
var hg_hotel_of_the_day_landingvue_type_style_index_0_id_df756024_prod_scoped_true_lang_postcss = __webpack_require__("c89a");

// CONCATENATED MODULE: ./src/components/cards/hg-hotel-of-the-day-landing.vue






/* normalize component */

var hg_hotel_of_the_day_landing_component = normalizeComponent(
  cards_hg_hotel_of_the_day_landingvue_type_script_lang_js,
  hg_hotel_of_the_day_landingvue_type_template_id_df756024_scoped_true_render,
  hg_hotel_of_the_day_landingvue_type_template_id_df756024_scoped_true_staticRenderFns,
  false,
  null,
  "df756024",
  null
  
)

/* harmony default export */ var hg_hotel_of_the_day_landing = (hg_hotel_of_the_day_landing_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-card-moods.vue?vue&type=template&id=4c2e0b3d&scoped=true
var hg_card_moodsvue_type_template_id_4c2e0b3d_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['hg-mood-wrap', { [`hg-mood-wrap--theme-${_vm.theme}`]: _vm.theme }],on:{"click":_vm.handleClick}},[_c('img',{staticClass:"hg-mood-img",attrs:{"src":_vm.image,"alt":_vm.alt}}),_c('div',{staticClass:"hg-link-icon-mobile"},[_c('LinkOutWhiteSvg')],1),_c('div',{staticClass:"hg-mood-text-content"},[_c('h1',{staticClass:"hg-headline-mood"},[_vm._v(" "+_vm._s(_vm.mood)+" ")]),_c('div',{staticClass:"hg-mood-cta"},[_c('a',{staticClass:"hg-mood-cta-text"},[_vm._v(" "+_vm._s(_vm.deals)+" "),_c('LinkOutSvg',{staticClass:"hg-outside-arrow"}),_c('LinkInsideArrowSvg',{staticClass:"hg-inside-arrow"})],1)])])])
}
var hg_card_moodsvue_type_template_id_4c2e0b3d_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/cards/hg-card-moods.vue?vue&type=template&id=4c2e0b3d&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/link-out-svg.vue?vue&type=template&id=89b4d386
var link_out_svgvue_type_template_id_89b4d386_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.30664 0.875H10.8223C11.2112 0.875 11.5254 1.18921 11.5254 1.57812V5.09375C11.5254 5.48267 11.2112 5.79688 10.8223 5.79688C10.4333 5.79688 10.1191 5.48267 10.1191 5.09375V3.27661L4.99072 8.40283C4.71606 8.67749 4.27002 8.67749 3.99536 8.40283C3.7207 8.12817 3.7207 7.68213 3.99536 7.40747L9.12378 2.28125H7.30664C6.91772 2.28125 6.60352 1.96704 6.60352 1.57812C6.60352 1.18921 6.91772 0.875 7.30664 0.875ZM4.37769 2.34937C4.76001 2.28564 5.12256 2.54272 5.18848 2.92725C5.25439 3.31177 4.99512 3.67212 4.6106 3.73804C2.94727 4.01489 1.68164 5.46289 1.68164 7.20312C1.68164 9.14551 3.25488 10.7188 5.19727 10.7188C6.9375 10.7188 8.3855 9.45312 8.66455 7.78979C8.72827 7.40747 9.09082 7.14819 9.47534 7.21191C9.85986 7.27563 10.1169 7.63818 10.0532 8.02271C9.65991 10.3518 7.63623 12.125 5.19727 12.125C2.47925 12.125 0.275391 9.92114 0.275391 7.20312C0.275391 4.76416 2.04858 2.74048 4.37769 2.34937Z","fill":"#2D2D2D"}})])
}
var link_out_svgvue_type_template_id_89b4d386_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/link-out-svg.vue?vue&type=template&id=89b4d386

// CONCATENATED MODULE: ./src/components/svg/decorations/link-out-svg.vue

var link_out_svg_script = {}


/* normalize component */

var link_out_svg_component = normalizeComponent(
  link_out_svg_script,
  link_out_svgvue_type_template_id_89b4d386_render,
  link_out_svgvue_type_template_id_89b4d386_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var link_out_svg = (link_out_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/link-out-white-svg.vue?vue&type=template&id=13cd10b7
var link_out_white_svgvue_type_template_id_13cd10b7_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.75781 0.141602H11.2734C11.4668 0.141602 11.625 0.299805 11.625 0.493164V4.00879C11.625 4.20215 11.4668 4.36035 11.2734 4.36035C11.0801 4.36035 10.9219 4.20215 10.9219 4.00879V1.34131L5.01782 7.24536C4.88159 7.38159 4.65747 7.38159 4.52124 7.24536C4.38501 7.10913 4.38501 6.88501 4.52124 6.74878L10.4253 0.844727H7.75781C7.56445 0.844727 7.40625 0.686523 7.40625 0.493164C7.40625 0.299805 7.56445 0.141602 7.75781 0.141602ZM5.29688 1.54785C5.49023 1.54785 5.64844 1.70605 5.64844 1.89941C5.64844 2.09277 5.49023 2.25098 5.29688 2.25098C2.96777 2.25098 1.07812 4.14062 1.07812 6.46973C1.07812 8.79883 2.96777 10.6885 5.29688 10.6885C7.62598 10.6885 9.51562 8.79883 9.51562 6.46973C9.51562 6.27637 9.67383 6.11816 9.86719 6.11816C10.0605 6.11816 10.2188 6.27637 10.2188 6.46973C10.2188 9.18774 8.01489 11.3916 5.29688 11.3916C2.57886 11.3916 0.375 9.18774 0.375 6.46973C0.375 3.75171 2.57886 1.54785 5.29688 1.54785Z","fill":"white"}})])
}
var link_out_white_svgvue_type_template_id_13cd10b7_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/link-out-white-svg.vue?vue&type=template&id=13cd10b7

// CONCATENATED MODULE: ./src/components/svg/decorations/link-out-white-svg.vue

var link_out_white_svg_script = {}


/* normalize component */

var link_out_white_svg_component = normalizeComponent(
  link_out_white_svg_script,
  link_out_white_svgvue_type_template_id_13cd10b7_render,
  link_out_white_svgvue_type_template_id_13cd10b7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var link_out_white_svg = (link_out_white_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/link-inside-arrow-svg.vue?vue&type=template&id=6e9f8730
var link_inside_arrow_svgvue_type_template_id_6e9f8730_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.8183 5.92842C10.9337 5.81804 11 5.66351 11 5.50162C11 5.33973 10.9337 5.18766 10.8183 5.07483L6.49687 0.954061C6.26116 0.7284 5.88795 0.738212 5.66451 0.973684C5.44107 1.20916 5.44844 1.58199 5.68415 1.8052L8.93996 4.91294H0.589286C0.262723 4.91294 0 5.17539 0 5.50162C0 5.82785 0.262723 6.0903 0.589286 6.0903H8.93996L5.6817 9.1956C5.44598 9.42126 5.43862 9.79163 5.66205 10.0271C5.88549 10.2626 6.25871 10.2699 6.49442 10.0467L10.8158 5.92596L10.8183 5.92842Z","fill":"#2D2D2D"}})])
}
var link_inside_arrow_svgvue_type_template_id_6e9f8730_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/link-inside-arrow-svg.vue?vue&type=template&id=6e9f8730

// CONCATENATED MODULE: ./src/components/svg/decorations/link-inside-arrow-svg.vue

var link_inside_arrow_svg_script = {}


/* normalize component */

var link_inside_arrow_svg_component = normalizeComponent(
  link_inside_arrow_svg_script,
  link_inside_arrow_svgvue_type_template_id_6e9f8730_render,
  link_inside_arrow_svgvue_type_template_id_6e9f8730_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var link_inside_arrow_svg = (link_inside_arrow_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-card-moods.vue?vue&type=script&lang=js





/* harmony default export */ var hg_card_moodsvue_type_script_lang_js = ({
  components: {
    LinkOutSvg: link_out_svg,
    LinkOutWhiteSvg: link_out_white_svg,
    LinkInsideArrowSvg: link_inside_arrow_svg,
  },
  props: {
    mood: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    deals: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleClick(e) {
      this.$emit('onClick', e)
    },
  },
});

// CONCATENATED MODULE: ./src/components/cards/hg-card-moods.vue?vue&type=script&lang=js
 /* harmony default export */ var cards_hg_card_moodsvue_type_script_lang_js = (hg_card_moodsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/cards/hg-card-moods.vue?vue&type=style&index=0&id=4c2e0b3d&prod&scoped=true&lang=postcss
var hg_card_moodsvue_type_style_index_0_id_4c2e0b3d_prod_scoped_true_lang_postcss = __webpack_require__("29d5");

// CONCATENATED MODULE: ./src/components/cards/hg-card-moods.vue






/* normalize component */

var hg_card_moods_component = normalizeComponent(
  cards_hg_card_moodsvue_type_script_lang_js,
  hg_card_moodsvue_type_template_id_4c2e0b3d_scoped_true_render,
  hg_card_moodsvue_type_template_id_4c2e0b3d_scoped_true_staticRenderFns,
  false,
  null,
  "4c2e0b3d",
  null
  
)

/* harmony default export */ var hg_card_moods = (hg_card_moods_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-promotionbanner.vue?vue&type=template&id=5ebd11d8&scoped=true
var hg_promotionbannervue_type_template_id_5ebd11d8_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-ad_wrapper"},[_c('div',{staticClass:"hg-ad_image",style:(`background-image: url(${_vm.ad.imageSrc});`)}),_c('div',{staticClass:"hg-ad_overlay"}),_c('div',{staticClass:"ad-wrapper_content"},[_c('h2',[_vm._v(_vm._s(_vm.ad.title))]),_c('p',[_vm._v(_vm._s(_vm.ad.subtitle))])]),_c('button',{staticClass:"ad-wrapper_cta",on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.ad.buttonText)+" ")])])
}
var hg_promotionbannervue_type_template_id_5ebd11d8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/cards/hg-promotionbanner.vue?vue&type=template&id=5ebd11d8&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cards/hg-promotionbanner.vue?vue&type=script&lang=js

/* harmony default export */ var hg_promotionbannervue_type_script_lang_js = ({
  name: 'HgPromotionbanner',
  props: {
    ad: {
      type: Object,
      required: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('onClick', this.ad)
    },
  },
});

// CONCATENATED MODULE: ./src/components/cards/hg-promotionbanner.vue?vue&type=script&lang=js
 /* harmony default export */ var cards_hg_promotionbannervue_type_script_lang_js = (hg_promotionbannervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/cards/hg-promotionbanner.vue?vue&type=style&index=0&id=5ebd11d8&prod&scoped=true&lang=postcss
var hg_promotionbannervue_type_style_index_0_id_5ebd11d8_prod_scoped_true_lang_postcss = __webpack_require__("09e6");

// CONCATENATED MODULE: ./src/components/cards/hg-promotionbanner.vue






/* normalize component */

var hg_promotionbanner_component = normalizeComponent(
  cards_hg_promotionbannervue_type_script_lang_js,
  hg_promotionbannervue_type_template_id_5ebd11d8_scoped_true_render,
  hg_promotionbannervue_type_template_id_5ebd11d8_scoped_true_staticRenderFns,
  false,
  null,
  "5ebd11d8",
  null
  
)

/* harmony default export */ var hg_promotionbanner = (hg_promotionbanner_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-top-deal-card.vue?vue&type=template&id=f7c69882&scoped=true
var hg_top_deal_cardvue_type_template_id_f7c69882_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"deal-card top-deal-card",class:_vm.isExpired && 'deal-card--expired',on:{"click":function($event){return _vm.onClick()}}},[_c('div',{staticClass:"deal-meta"},[(_vm.isExpired)?_c('span',{staticClass:"deal-badge deal-badge--expired"},[_vm._v(" "+_vm._s(_vm.$t('expired'))+" ")]):(_vm.badge)?_c('span',{staticClass:"deal-badge"},[_c('font-awesome-icon',{staticClass:"fa-icon star icon-light",attrs:{"icon":['far', 'star']}}),_vm._v(" "+_vm._s(_vm.badge)+" ")],1):_c('span'),(_vm.showButtons && !_vm.isExpired)?_c('div',{staticClass:"deal-meta-buttons"},[_c('HgButton',{staticClass:"hg-button button--share",attrs:{"role":"button","type":"button"},on:{"onClick":_vm.clickShare}},[_c('hg-icon',{staticClass:"share icon-light",attrs:{"name":"share","pack":"fal"}}),_c('hg-icon',{staticClass:"share icon-solid",attrs:{"name":"share","pack":"fas"}})],1),_c('HgButton',{staticClass:"hg-button button--bookmark",class:_vm.hasBookmark ? 'button--active' : '',attrs:{"role":"button","type":"button"},on:{"onClick":_vm.clickBookmark}},[_c('hg-icon',{staticClass:"heart icon-light",attrs:{"name":"heart","pack":"fal"}}),_c('hg-icon',{staticClass:"heart icon-solid",attrs:{"name":"heart","pack":"fas"}})],1)],1):_vm._e()]),_c(_vm.computedTag,_vm._b({tag:"component",staticClass:"deal-button tw-group",on:{"click":function($event){return _vm.clickDeal()}}},'component',_vm.$attrs,false),[_c('div',{staticClass:"image-area"},[_c('hg-image',{staticClass:"deal-image",attrs:{"alt":"alt test","src":_vm.imageSrc,"src-placeholder":_vm.placeholderSrc}}),_c('div',{staticClass:"bg-fade"}),_c('div',{staticClass:"hg-deal-type-label"},[_c('span',{staticClass:"deal-type"},[_vm._v(_vm._s(_vm.typeLabel))])]),(_vm.price)?_c('div',{staticClass:"hg-deal-price"},[_c('DealPrice',{attrs:{"teal":"","price":_vm.price}})],1):_vm._e()],1),_c('div',{staticClass:"deal-content"},[_c('div',{staticClass:"content-wrapper"},[_c('h2',{class:`group-hover:${
            _vm.underlineOnHover ? 'tw-underline' : 'tw-no-underline'
          } hover:${_vm.underlineOnHover ? 'tw-underline' : 'tw-no-underline'}`},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]),(_vm.voting)?_c('div',{staticClass:"deal-voting"},[_c('HgDealVoting',{attrs:{"deal":_vm.deal},on:{"thumbsUp":_vm.onThumbsUp,"thumbsDown":_vm.onThumbsDown,"clearVote":_vm.onClearVote}})],1):_vm._e()])])],1)
}
var hg_top_deal_cardvue_type_template_id_f7c69882_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deals/hg-top-deal-card.vue?vue&type=template&id=f7c69882&scoped=true

// CONCATENATED MODULE: ./src/components/deals/DealMixin.js


/* harmony default export */ var DealMixin = ({
  inheritAttrs: false,
  components: {
    DealPrice: hg_deal_price,
  },
  props: {
    skeleton: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    typeLabel: {
      type: String,
      default: '',
    },
    badge: {
      type: String,
      default: '',
    },
    expiryDate: {
      type: String | Date,
      default: '',
    },
    image: {
      type: Object,
      default: () => { },
    },
    price: {
      type: Object,
      default: () => { },
    },
    voting: {
      type: Object,
      default: () => { },
    },
    bookmark: {
      type: Object,
      default: () => { },
    },
    tag: {
      type: String,
      default: 'button',
      validator: (value) => {
        return ['button', 'a', 'nuxt-link', 'div', 'span'].indexOf(value) >= 0
      },
    },
    showButtons: {
      type: Boolean,
      default: false,
    },
    showCta: {
      type: Boolean,
      default: false,
    },
    underlineOnHover: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoadingVoting: false,
  }),
  computed: {
    isExpired() {
      if (!this.expiryDate) return false
      return new Date(this.expiryDate) <= new Date()
    },

    computedTag() {
      if (
        this.$attrs.disabled !== undefined &&
        this.$attrs.disabled !== false
      ) {
        return 'button'
      }
      return this.tag
    },

    hasBookmark() {
      if (this.bookmark) return true
      return false
    },

    imageSrc() {
      if (this.image) {
        return this.image.url + '?width=420&height=200&mimetype=webp'
      }

      return ''
    },
    placeholderSrc() {
      if (this.image) return this.image.url + '?width=10&mimetype=webp'
      return ''
    },
  },
  methods: {
    clickDeal() {
      this.$emit('onClickDeal', this.dealId)
    },
    clickBookmark(e) {
      this.$emit('onClickBookmark', this.dealId)
    },
    clickShare(e) {
      this.$emit('onClickShare', this.dealId)
    },
    onClick() {
      this.$emit('onClick')
    },
  },
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-top-deal-card.vue?vue&type=script&lang=js




/**
 * HG TOP-Deal Card Component
 */
/* harmony default export */ var hg_top_deal_cardvue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  mixins: [DealMixin],
});

// CONCATENATED MODULE: ./src/components/deals/hg-top-deal-card.vue?vue&type=script&lang=js
 /* harmony default export */ var deals_hg_top_deal_cardvue_type_script_lang_js = (hg_top_deal_cardvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deals/hg-top-deal-card.vue?vue&type=style&index=0&id=f7c69882&prod&scoped=true&lang=postcss
var hg_top_deal_cardvue_type_style_index_0_id_f7c69882_prod_scoped_true_lang_postcss = __webpack_require__("34e2");

// CONCATENATED MODULE: ./src/components/deals/hg-top-deal-card.vue






/* normalize component */

var hg_top_deal_card_component = normalizeComponent(
  deals_hg_top_deal_cardvue_type_script_lang_js,
  hg_top_deal_cardvue_type_template_id_f7c69882_scoped_true_render,
  hg_top_deal_cardvue_type_template_id_f7c69882_scoped_true_staticRenderFns,
  false,
  null,
  "f7c69882",
  null
  
)

/* harmony default export */ var hg_top_deal_card = (hg_top_deal_card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-deal-card.vue?vue&type=template&id=78e26094&scoped=true
var hg_deal_cardvue_type_template_id_78e26094_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"deal-card group",class:_vm.isExpired && 'deal-card--expired',on:{"click":function($event){return _vm.onClick()}}},[_c('div',{staticClass:"deal-meta"},[(_vm.isExpired)?_c('span',{staticClass:"deal-badge deal-badge--expired"},[_vm._v(" "+_vm._s(_vm.$t('expired'))+" ")]):(_vm.badge)?_c('span',{staticClass:"deal-badge deal-badge--yellow"},[_vm._v(" "+_vm._s(_vm.badge)+" ")]):_c('span'),(_vm.showButtons && !_vm.isExpired)?_c('div',{staticClass:"deal-meta-buttons"},[_c('hg-button',{staticClass:"hg-button button--share",attrs:{"role":"button","type":"button"},on:{"onClick":_vm.clickShare}},[_c('hg-icon',{staticClass:"share icon-light",attrs:{"name":"share","pack":"fal"}}),_c('hg-icon',{staticClass:"share icon-solid",attrs:{"name":"share","pack":"fas"}})],1),_c('hg-button',{staticClass:"hg-button button--bookmark",class:_vm.hasBookmark ? 'button--active' : '',attrs:{"role":"button","type":"button"},on:{"onClick":_vm.clickBookmark}},[_c('hg-icon',{staticClass:"heart icon-light",attrs:{"name":"heart","pack":"fal"}}),_c('hg-icon',{staticClass:"heart icon-solid",attrs:{"name":"heart","pack":"fas"}})],1)],1):_vm._e()]),_c(_vm.computedTag,_vm._b({tag:"component",staticClass:"deal-button tw-group",on:{"click":function($event){return _vm.clickDeal()}}},'component',_vm.$attrs,false),[_c('div',{staticClass:"image-area"},[_c('hg-image',{staticClass:"deal-image",attrs:{"alt":"alt test","src":_vm.imageSrc,"src-placeholder":_vm.placeholderSrc}}),_c('div',{staticClass:"bg-fade"}),(_vm.price)?_c('div',{staticClass:"hg-deal-price"},[_c('DealPrice',{attrs:{"teal":"","price":_vm.price}})],1):_vm._e()],1),_c('div',{staticClass:"deal-content"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"deal-topline"},[_c('span',{staticClass:"deal-type"},[_vm._v(_vm._s(_vm.typeLabel))])]),_c('h2',{class:`group-hover:${
            _vm.underlineOnHover ? 'tw-underline' : 'tw-no-underline'
          } hover:${_vm.underlineOnHover ? 'tw-underline' : 'tw-no-underline'}`},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]),(_vm.showCta)?_c('div',{staticClass:"deal-cta"},[_c('HgButton',{staticClass:"tw-w-full",attrs:{"color":"teal"},on:{"onClick":_vm.clickDeal}},[_vm._v(" Zum Deal ")])],1):_vm._e()])])],1)
}
var hg_deal_cardvue_type_template_id_78e26094_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deals/hg-deal-card.vue?vue&type=template&id=78e26094&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-deal-card.vue?vue&type=script&lang=js




/**
 * HG Deal Card Component
 */
/* harmony default export */ var hg_deal_cardvue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  mixins: [DealMixin],
});

// CONCATENATED MODULE: ./src/components/deals/hg-deal-card.vue?vue&type=script&lang=js
 /* harmony default export */ var deals_hg_deal_cardvue_type_script_lang_js = (hg_deal_cardvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deals/hg-deal-card.vue?vue&type=style&index=0&id=78e26094&prod&scoped=true&lang=postcss
var hg_deal_cardvue_type_style_index_0_id_78e26094_prod_scoped_true_lang_postcss = __webpack_require__("63c6");

// CONCATENATED MODULE: ./src/components/deals/hg-deal-card.vue






/* normalize component */

var hg_deal_card_component = normalizeComponent(
  deals_hg_deal_cardvue_type_script_lang_js,
  hg_deal_cardvue_type_template_id_78e26094_scoped_true_render,
  hg_deal_cardvue_type_template_id_78e26094_scoped_true_staticRenderFns,
  false,
  null,
  "78e26094",
  null
  
)

/* harmony default export */ var hg_deal_card = (hg_deal_card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-deal-listing.vue?vue&type=template&id=1f5367ac&scoped=true
var hg_deal_listingvue_type_template_id_1f5367ac_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"listing group",class:_vm.isExpired && 'deal--expired',on:{"click":function($event){return _vm.onClick()}}},[_c(_vm.computedTag,_vm._b({tag:"component",staticClass:"deal-button group",on:{"click":function($event){return _vm.clickDeal()}}},'component',_vm.$attrs,false),[_c('div',{staticClass:"image-area"},[_c('hg-image',{staticClass:"deal-image",attrs:{"alt":"alt test","src":_vm.imageSrc,"src-placeholder":_vm.placeholderSrc}}),_c('div',{staticClass:"bg-fade"})],1),_c('div',{staticClass:"deal-main"},[_c('span',{staticClass:"deal-type"},[_vm._v(_vm._s(_vm.typeLabel))]),(_vm.isExpired)?_c('span',{staticClass:"deal-badge deal-badge--expired"},[_vm._v(" "+_vm._s(_vm.$t('expired'))+" ")]):(_vm.badge)?_c('span',{staticClass:"deal-badge deal-badge--yellow"},[_vm._v(" "+_vm._s(_vm.badge)+" ")]):_vm._e(),_c('h2',{staticClass:"deal-title group-hover:underline"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]),_c('div',{staticClass:"deal-information"},[(_vm.price)?_c('div',{staticClass:"deal-price"},[_c('DealPrice',{attrs:{"price":_vm.price}})],1):_vm._e()])]),_c('div',{staticClass:"deal-meta-buttons"},[(_vm.showButtons && !_vm.isExpired)?_c('hg-button',{staticClass:"hg-button button--share",on:{"onClick":_vm.clickShare}},[_c('hg-icon',{staticClass:"share icon-light",attrs:{"name":"share","pack":"fal"}}),_c('hg-icon',{staticClass:"share icon-solid",attrs:{"name":"share","pack":"fas"}})],1):_vm._e(),(_vm.showButtons && !_vm.isExpired)?_c('hg-button',{staticClass:"hg-button button--bookmark",class:_vm.hasBookmark ? 'button--active' : '',on:{"onClick":_vm.clickBookmark}},[_c('hg-icon',{staticClass:"heart icon-light",attrs:{"name":"heart","pack":"fal"}}),_c('hg-icon',{staticClass:"heart icon-solid",attrs:{"name":"heart","pack":"fas"}})],1):_vm._e()],1)],1)
}
var hg_deal_listingvue_type_template_id_1f5367ac_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deals/hg-deal-listing.vue?vue&type=template&id=1f5367ac&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-deal-listing.vue?vue&type=script&lang=js




/**
 * HG Deal Listing
 */

/* harmony default export */ var hg_deal_listingvue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  mixins: [DealMixin],
});

// CONCATENATED MODULE: ./src/components/deals/hg-deal-listing.vue?vue&type=script&lang=js
 /* harmony default export */ var deals_hg_deal_listingvue_type_script_lang_js = (hg_deal_listingvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deals/hg-deal-listing.vue?vue&type=style&index=0&id=1f5367ac&prod&scoped=true&lang=postcss
var hg_deal_listingvue_type_style_index_0_id_1f5367ac_prod_scoped_true_lang_postcss = __webpack_require__("53a2");

// CONCATENATED MODULE: ./src/components/deals/hg-deal-listing.vue






/* normalize component */

var hg_deal_listing_component = normalizeComponent(
  deals_hg_deal_listingvue_type_script_lang_js,
  hg_deal_listingvue_type_template_id_1f5367ac_scoped_true_render,
  hg_deal_listingvue_type_template_id_1f5367ac_scoped_true_staticRenderFns,
  false,
  null,
  "1f5367ac",
  null
  
)

/* harmony default export */ var hg_deal_listing = (hg_deal_listing_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-deal-card-skeleton.vue?vue&type=template&id=f828fa8a&scoped=true
var hg_deal_card_skeletonvue_type_template_id_f828fa8a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var hg_deal_card_skeletonvue_type_template_id_f828fa8a_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"deal-card-placeholder"},[_c('div',{staticClass:"image hg-skeleton"}),_c('div',{staticClass:"placeholder-content"},[_c('div',{staticClass:"title hg-skeleton"}),_c('div',{staticClass:"info hg-skeleton"}),_c('div',{staticClass:"info hg-skeleton"}),_c('div',{staticClass:"info hg-skeleton"}),_c('div',{staticClass:"price"},[_c('div',{staticClass:"hg-skeleton hg-skeleton--teal tw-h-8 tw-flex-grow"})])])])
}]


// CONCATENATED MODULE: ./src/components/deals/hg-deal-card-skeleton.vue?vue&type=template&id=f828fa8a&scoped=true

// EXTERNAL MODULE: ./src/components/deals/hg-deal-card-skeleton.vue?vue&type=style&index=0&id=f828fa8a&prod&scoped=true&lang=postcss
var hg_deal_card_skeletonvue_type_style_index_0_id_f828fa8a_prod_scoped_true_lang_postcss = __webpack_require__("b091");

// CONCATENATED MODULE: ./src/components/deals/hg-deal-card-skeleton.vue

var hg_deal_card_skeleton_script = {}



/* normalize component */

var hg_deal_card_skeleton_component = normalizeComponent(
  hg_deal_card_skeleton_script,
  hg_deal_card_skeletonvue_type_template_id_f828fa8a_scoped_true_render,
  hg_deal_card_skeletonvue_type_template_id_f828fa8a_scoped_true_staticRenderFns,
  false,
  null,
  "f828fa8a",
  null
  
)

/* harmony default export */ var hg_deal_card_skeleton = (hg_deal_card_skeleton_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-deal-card-skeleton-redesign.vue?vue&type=template&id=95de6c6c&scoped=true
var hg_deal_card_skeleton_redesignvue_type_template_id_95de6c6c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"deal-card-placeholder"},[_c('div',{staticClass:"skeleton-image"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 241.5 268.3"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 241.5 268.3","xml:space":"preserve"}},[_c('path',{staticStyle:{"fill":"#2d2d2d"},attrs:{"d":"M143.9 155.6v-33.1c0-1.5.3-2.5 1.7-3.3 4.6-3 8.3-7 11.4-11.5.9-1.3 1-1.4 2.1-.5 16.5 12.8 30 28 38.2 47.5 4 9.5 6 19.4 6 29.6 0 7.6 0 15.2-1.3 22.7-4.5 26.6-19.4 44.6-44.3 54.6-8.1 3.2-16.6 4.7-25.2 5.7-8.1 1-16.3 1.3-24.4.6-17.3-1.6-33.4-6.6-47.2-17.4-13.2-10.3-20.8-23.9-22.7-40.5-1.2-10.8-1.7-21.7-.9-32.6.8-10.1 3.8-19.6 8.4-28.6 6.7-13.2 16-24.5 26.9-34.4 2.8-2.6 5.8-5 8.9-7.3.9-.7 1.4-.6 2 .4 3.1 4.6 6.9 8.6 11.6 11.7 1 .7 1.1 1.6 1.1 2.7V184.7c0 4.7.5 9.4 2 13.9 3 9.3 9.7 14.5 19.5 15 2.5.1 5 .2 7.4-.3 8.9-1.7 15.4-8.1 17.3-17.1 1-4.9 1.3-9.8 1.3-14.8.1-8.6 0-17.3 0-25.9h.2z"}}),_c('path',{staticStyle:{"fill":"#00d6e1"},attrs:{"d":"M28 180.7c-3.3-3-6.1-5.9-8.7-9.1-8.9-10.7-14.2-23-16.9-36.6-1.6-8-2.5-16.1-2.3-24.3.7-39.3 21.8-76.3 55.3-95.2 12.7-7.1 26.3-11.7 40.7-14C104.7.1 113.4-.2 122.2.2c9.7.4 19 2.4 27.6 7 6.3 3.4 11.7 7.8 16.3 13.2 5.3 6.3 8.2 13.7 9.8 21.6 3.3 16.1-.4 30.6-10 43.7-.3.4-.5 1-1.4 1.2v-2.8c.7-20.4-12.8-38.2-31.8-43.8-25.4-7.5-51.9 9.1-56.1 35.1-1.2 7.1-.8 14 1.4 20.9.6 2 .6 2-1.1 3.3-15.2 11.4-28 25.1-37.3 41.7-6.7 12-10.7 24.7-11.5 38.5.1.1 0 .3-.1.9"}}),_c('path',{staticStyle:{"fill":"#ace632"},attrs:{"d":"M184 70c1.1.1 1.6 1 2.3 1.6 7.6 7.5 13 16.4 17.1 26.1 1.4 3.4 2.6 6.9 3.7 10.4.2.5.2 1.1.8 1.6.5-.4.3-1 .3-1.5-.5-6.2-2-12.1-4.1-17.9-.4-1.1-.9-2.2-1.3-3.3-.6-1.5-.5-1.7 1-1.9 6.3-.9 12.7-1.6 19.1-.6.1 0 .3 0 .6-.1-.5-.9-1.4-1-2.2-1.3-3.1-1.1-6.3-1.6-9.7-1.6-3 0-6.1-.1-9.1.4-1 .2-2 .3-2.6-1-2.6-5-6-9.4-10-13.7 7.4-6.6 16.1-10.9 24.9-15.2-2.1-.1-4 .4-5.9.9-7.6 2.1-14.7 5.4-20.8 10.5-.5.4-.8 1.1-1.6.6-.8-.4-1-1-.9-2 .5-3.2.7-6.3.7-9.6-.1-10.4-2.6-20.2-7.3-29.5-.4-.7-.9-1.3-.9-2.3 1-.4 1.8.3 2.6.7 7.3 3.6 14.1 7.8 20.6 12.7 13.1 10 23.6 22.2 30.7 37.2 5 10.6 8.3 21.8 9.3 33.5.8 9.7 0 19.3-2.7 28.7-3.6 12.6-8.7 24.6-16.3 35.3-1.9 2.7-4 5.2-6.4 7.4-1 .9-2 1.8-3.5 2.2-.3-2.7-.6-5.2-1-7.7-2-13.4-7.2-25.6-14.6-36.9-8-12.4-18.1-23-29.6-32.2-.3-.3-.6-.5-1-.7-.8-.5-.8-1-.1-1.7 2.2-2.3 4.3-4.7 6.2-7.3 4.8-6.3 8.6-13.1 11-20.6.2-.2.3-.7.7-1.2"}}),_c('path',{staticStyle:{"fill":"#ffeb00"},attrs:{"d":"M120 118.8c-19.6.1-36-16.4-35.7-36.3.2-20 16.4-35.9 36.5-35.8 19.7.1 35.8 16.5 35.6 36.5-.2 20.6-17.5 36-36.4 35.6"}})])]),_vm._m(0)])
}
var hg_deal_card_skeleton_redesignvue_type_template_id_95de6c6c_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder-content"},[_c('div',{staticClass:"skeleton-text skeleton-text--headline"}),_c('div',{staticClass:"skeleton-text"}),_c('div',{staticClass:"skeleton-text"}),_c('div',{staticClass:"skeleton-text"})])
}]


// CONCATENATED MODULE: ./src/components/deals/hg-deal-card-skeleton-redesign.vue?vue&type=template&id=95de6c6c&scoped=true

// EXTERNAL MODULE: ./src/components/deals/hg-deal-card-skeleton-redesign.vue?vue&type=style&index=0&id=95de6c6c&prod&lang=postcss&scoped=true
var hg_deal_card_skeleton_redesignvue_type_style_index_0_id_95de6c6c_prod_lang_postcss_scoped_true = __webpack_require__("c620");

// CONCATENATED MODULE: ./src/components/deals/hg-deal-card-skeleton-redesign.vue

var hg_deal_card_skeleton_redesign_script = {}



/* normalize component */

var hg_deal_card_skeleton_redesign_component = normalizeComponent(
  hg_deal_card_skeleton_redesign_script,
  hg_deal_card_skeleton_redesignvue_type_template_id_95de6c6c_scoped_true_render,
  hg_deal_card_skeleton_redesignvue_type_template_id_95de6c6c_scoped_true_staticRenderFns,
  false,
  null,
  "95de6c6c",
  null
  
)

/* harmony default export */ var hg_deal_card_skeleton_redesign = (hg_deal_card_skeleton_redesign_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-deal-listing-skeleton.vue?vue&type=template&id=4baa0054&scoped=true
var hg_deal_listing_skeletonvue_type_template_id_4baa0054_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var hg_deal_listing_skeletonvue_type_template_id_4baa0054_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"listing-placeholder"},[_c('div',{staticClass:"image hg-skeleton"}),_c('div',{staticClass:"main"},[_c('div',{staticClass:"title hg-skeleton"})]),_c('div',{staticClass:"deal-information"},[_c('div',{staticClass:"information"},[_c('span',{staticClass:"info hg-skeleton"}),_c('span',{staticClass:"info hg-skeleton"}),_c('span',{staticClass:"info hg-skeleton"})]),_c('div',{staticClass:"deal-price hg-skeleton hg-skeleton--teal"})])])
}]


// CONCATENATED MODULE: ./src/components/deals/hg-deal-listing-skeleton.vue?vue&type=template&id=4baa0054&scoped=true

// EXTERNAL MODULE: ./src/components/deals/hg-deal-listing-skeleton.vue?vue&type=style&index=0&id=4baa0054&prod&scoped=true&lang=postcss
var hg_deal_listing_skeletonvue_type_style_index_0_id_4baa0054_prod_scoped_true_lang_postcss = __webpack_require__("b95d");

// CONCATENATED MODULE: ./src/components/deals/hg-deal-listing-skeleton.vue

var hg_deal_listing_skeleton_script = {}



/* normalize component */

var hg_deal_listing_skeleton_component = normalizeComponent(
  hg_deal_listing_skeleton_script,
  hg_deal_listing_skeletonvue_type_template_id_4baa0054_scoped_true_render,
  hg_deal_listing_skeletonvue_type_template_id_4baa0054_scoped_true_staticRenderFns,
  false,
  null,
  "4baa0054",
  null
  
)

/* harmony default export */ var hg_deal_listing_skeleton = (hg_deal_listing_skeleton_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-getyourguide-card.vue?vue&type=template&id=48195939&scoped=true
var hg_getyourguide_cardvue_type_template_id_48195939_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.deal)?_c(_vm.deal && _vm.deal.price.url ? 'a' : 'div',{tag:"component",staticClass:"hg-gyg-card",attrs:{"href":_vm.deal ? _vm.deal.price.url : null,"target":"_blank"},on:{"mouseenter":function($event){_vm.hover = 'hoverIn'},"mouseleave":function($event){_vm.hover = 'hoverOut'}}},[_c('div',{staticClass:"hg-gyg-card__header"},[_c('div',{staticClass:"hg-gyg-card__header-img"},[_c('img',{class:`hg-gyg-card__img hg-gyg-card__img--${_vm.hover}`,attrs:{"src":_vm.imgSrc}}),_c('div',{staticClass:"hg-gyg-card__tags"},[_c('div',{staticClass:"hg-gyg-card__category"},[_c('span',{staticClass:"category__text"},[_vm._v(_vm._s(_vm.deal.categories.length > 0 && _vm.deal.categories[0].name))])]),(_vm.deal.rating > 0)?_c('div',{staticClass:"hg-gyg-card__rating"},[_c('span',{staticClass:"rating__text"},[_vm._v(_vm._s(_vm.deal.rating.toFixed(1).toString().replaceAll('.', ',')))]),_c('hg-icon',{staticClass:"rating__svg",attrs:{"name":"star","pack":"fas"}})],1):_vm._e()])]),_c('div',{staticClass:"hg-gyg-card__content-wrapper"},[_c('div',{staticClass:"hg-gyg-card__content"},[_c('div',{staticClass:"hg-gyg-card__title"},[_vm._v(" "+_vm._s(_vm.titleText)+" ")]),_c('div',{staticClass:"hg-gyg-card__logo"},[_c('GygLogo',{staticClass:"right__svg"})],1)]),_c('div',{staticClass:"hg-gyg-card__description-wrapper"},[_c('div',{staticClass:"hg-gyg-card__description"},[(_vm.deal.duration)?_c('div',{staticClass:"hg-gyg-card__description-duration hg-gyg-card__description-info"},[_c('hg-icon',{staticClass:"fa-icon__description",attrs:{"name":"clock","pack":"far"}}),_c('p',{staticClass:"hg-gyg-card__description-text"},[_vm._v(" "+_vm._s(_vm.getDurationText())+" ")])],1):_vm._e(),(_vm.deal.hasPickup)?_c('div',{staticClass:"hg-gyg-card__description-pickup hg-gyg-card__description-info"},[_c('hg-icon',{staticClass:"fa-icon__description",attrs:{"name":"bus","pack":"fas"}}),_c('p',{staticClass:"hg-gyg-card__description-text"},[_vm._v(" "+_vm._s(_vm.$t('getYourGuide.transferPossible'))+" ")])],1):_vm._e()])])]),_c('div',{staticClass:"hg-gyg-card__footer"},[_c('HgDealPrice',{attrs:{"addPrefix":"","teal":"","price":_vm.deal.price}})],1)])]):_vm._e()
}
var hg_getyourguide_cardvue_type_template_id_48195939_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deals/hg-getyourguide-card.vue?vue&type=template&id=48195939&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-getyourguide-card.vue?vue&type=script&lang=js

/* harmony default export */ var hg_getyourguide_cardvue_type_script_lang_js = ({
  props: {
    deal: {
      required: true,
    },
  },

  data: () => ({
    hover: '',
    imgSrc: '',
    titleText: '',
  }),

  methods: {
    getImg() {
      this.imgSrc = this.deal
        ? this.deal.images[Math.floor(Math.random() * this.deal.images.length)]
            .url
        : ''
    },
    getDurationText() {
      // Build the duration string
      let duration = `{0} {1}`

      duration = duration.replace(
        '{0}',
        this.deal.duration.value.toString().replaceAll('.', ',')
      )

      // Use the appropriate time unit
      if (this.deal.duration.value == 1) {
        duration = duration.replace(
          '{1}',
          this.$i18n.t(this.deal.duration.unit)
        )
      } else {
        duration = duration.replace(
          '{1}',
          this.$i18n.t(`${this.deal.duration.unit}s`)
        )
      }

      return duration
    },
    updateLayout() {
      let maxTitleLength = 60

      if (this.deal.title.length > maxTitleLength) {
        this.titleText = this.deal.title.slice(0, maxTitleLength) + '…'
      } else {
        this.titleText = this.deal.title
      }
    },
  },
  created() {
    window.addEventListener('resize', this.updateLayout)
  },
  destroyed() {
    window.removeEventListener('resize', this.updateLayout)
  },
  mounted() {
    this.updateLayout()
    this.getImg()
  },
});

// CONCATENATED MODULE: ./src/components/deals/hg-getyourguide-card.vue?vue&type=script&lang=js
 /* harmony default export */ var deals_hg_getyourguide_cardvue_type_script_lang_js = (hg_getyourguide_cardvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deals/hg-getyourguide-card.vue?vue&type=style&index=0&id=48195939&prod&scoped=true&lang=postcss
var hg_getyourguide_cardvue_type_style_index_0_id_48195939_prod_scoped_true_lang_postcss = __webpack_require__("e4c8");

// CONCATENATED MODULE: ./src/components/deals/hg-getyourguide-card.vue






/* normalize component */

var hg_getyourguide_card_component = normalizeComponent(
  deals_hg_getyourguide_cardvue_type_script_lang_js,
  hg_getyourguide_cardvue_type_template_id_48195939_scoped_true_render,
  hg_getyourguide_cardvue_type_template_id_48195939_scoped_true_staticRenderFns,
  false,
  null,
  "48195939",
  null
  
)

/* harmony default export */ var hg_getyourguide_card = (hg_getyourguide_card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-deal-card-redesign.vue?vue&type=template&id=a03dbb62&scoped=true
var hg_deal_card_redesignvue_type_template_id_a03dbb62_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"hgDealCardRedesignContainer"},[_c('hg-card',{attrs:{"images":_vm.images,"is-mobile":_vm.isMobile,"has-bookmark":_vm.bookmarked,"has-meta-buttons":""},on:{"onClickShare":_vm.clickShare,"onClickBookmark":_vm.clickBookmark},scopedSlots:_vm._u([{key:"badge",fn:function(){return [(_vm.topDeal)?_c('div',{staticClass:"top-deal-badge",attrs:{"id":"badge"}},[_c('BlueStarSvg'),_vm._v(" "+_vm._s(_vm.badgeLabel)+" ")],1):_vm._e()]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"deal-container"},[_c('div',[(_vm.dealType && _vm.dealType.icon && _vm.dealType.name)?_c('hg-deal-type',{staticClass:"deal-type-spacing",attrs:{"icon":_vm.dealType.icon,"name":_vm.dealType.name}}):_vm._e(),_c('div',{staticClass:"content-wrapper"},[(_vm.title)?_c('h2',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.subtitle)?_c('p',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()]),_c('div',{staticClass:"hg-deal-secondary-info"},[(_vm.isExpired)?_c('span',{staticClass:"deal-badge deal-badge--expired"},[_vm._v(" "+_vm._s(_vm.$t('expired'))+" ")]):(_vm.badge)?_c('span',{staticClass:"deal-badge"},[_vm._v(" "+_vm._s(_vm.badge)+" ")]):_vm._e()])],1),_c('div',{staticClass:"hg-deal-wrapper-bottom"},[_c('div',{staticClass:"cta-button-container"},[(_vm.buttonLabel)?_c('HgButton',{attrs:{"color":"teal-outline","tag":_vm.dealCardType,"href":_vm.href,"to":_vm.href,"target":_vm.target}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e()],1),_c('div',{staticClass:"hg-deal-price",attrs:{"id":"priceLabel"}},[_c('DealPrice',{attrs:{"price":_vm.price,"priceSize":"xl"}})],1)])])]},proxy:true}])})],1)
}
var hg_deal_card_redesignvue_type_template_id_a03dbb62_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deals/hg-deal-card-redesign.vue?vue&type=template&id=a03dbb62&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/blue-star-svg.vue?vue&type=template&id=28e1ad0d
var blue_star_svgvue_type_template_id_28e1ad0d_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m10.5 0 2.357 7.255h7.63l-6.173 4.484 2.358 7.256L10.5 14.51l-6.172 4.484 2.358-7.256L.514 7.255h7.629L10.5 0Z","fill":"#00D5E0"}})])
}
var blue_star_svgvue_type_template_id_28e1ad0d_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/blue-star-svg.vue?vue&type=template&id=28e1ad0d

// CONCATENATED MODULE: ./src/components/svg/ui/blue-star-svg.vue

var blue_star_svg_script = {}


/* normalize component */

var blue_star_svg_component = normalizeComponent(
  blue_star_svg_script,
  blue_star_svgvue_type_template_id_28e1ad0d_render,
  blue_star_svgvue_type_template_id_28e1ad0d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var blue_star_svg = (blue_star_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deals/hg-deal-card-redesign.vue?vue&type=script&lang=js




/**
 * HG DealCardRedesign Component
 */
/* harmony default export */ var hg_deal_card_redesignvue_type_script_lang_js = ({
  components: {
    BlueStarSvg: blue_star_svg,
  },
  props: {
    lang: {
      type: String,
      default: 'de',
    },
    id: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    topDeal: {
      type: Boolean,
      default: false,
    },
    dealType: {
      type: Object,
      default: null,
    },
    badgeLabel: {
      type: String,
      default: 'Top Angebot',
    },
    buttonLabel: {
      type: String,
      default: '',
    },
    images: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    bookmarked: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      href: '',
      target: '_self',
      dealCardType: 'a',
      width: 0,
      mouseIn: false,
    }
  },

  mixins: [DealMixin],
  inheritAttrs: true,
  created() {
    this.checkTag()
  },
  mounted() {
    // Set the initial image width
    this.width = this.$refs.hgDealCardRedesignContainer.clientWidth
  },

  methods: {
    checkTag() {
      if (this.link.includes('https://') || this.link.includes('http://')) {
        this.href = this.link
        this.dealCardType = 'a'
        this.target = '_blank'
      } else {
        this.href = this.link
        this.dealCardType = 'nuxt-link'
        this.target = '_self'
      }
    },
    handleClick(e) {
      let clickedElement = 'card'

      if (e.composedPath().filter((el) => el.id === 'priceLabel').length > 0) {
        clickedElement = 'priceLabel'
      } else if (
        e.composedPath().filter((el) => el.id === 'badge').length > 0
      ) {
        clickedElement = 'badge'
      } else if (
        e
          .composedPath()
          .filter(
            (el) =>
              el.classList &&
              (el.classList.contains('controls') ||
                el.classList.contains('cta-button-container') ||
                el.id === 'shareButton' ||
                el.id === 'likeButton')
          ).length > 0
      ) {
        return
      }

      this.$emit('onClick', {
        event: 'gtmEvent',
        eventName: 'click_to_deal',
        clickedElement,
        dealName: this.title,
        isTopDeal: this.topDeal,
        uId: this.id,
      })
    },
    clickBookmark() {
      this.$emit('onClickBookmark')
    },
    clickShare() {
      this.$emit('onClickShare')
    },
    handleMouseEnter(e) {
      if (!e.sourceCapabilities || !e.sourceCapabilities.firesTouchEvents) {
        this.mouseIn = true
      }
    },
    handleMouseLeave(e) {
      if (!e.sourceCapabilities || !e.sourceCapabilities.firesTouchEvents) {
        this.mouseIn = false
      }
    },
  },
});

// CONCATENATED MODULE: ./src/components/deals/hg-deal-card-redesign.vue?vue&type=script&lang=js
 /* harmony default export */ var deals_hg_deal_card_redesignvue_type_script_lang_js = (hg_deal_card_redesignvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deals/hg-deal-card-redesign.vue?vue&type=style&index=0&id=a03dbb62&prod&scoped=true&lang=postcss
var hg_deal_card_redesignvue_type_style_index_0_id_a03dbb62_prod_scoped_true_lang_postcss = __webpack_require__("2c4b");

// CONCATENATED MODULE: ./src/components/deals/hg-deal-card-redesign.vue






/* normalize component */

var hg_deal_card_redesign_component = normalizeComponent(
  deals_hg_deal_card_redesignvue_type_script_lang_js,
  hg_deal_card_redesignvue_type_template_id_a03dbb62_scoped_true_render,
  hg_deal_card_redesignvue_type_template_id_a03dbb62_scoped_true_staticRenderFns,
  false,
  null,
  "a03dbb62",
  null
  
)

/* harmony default export */ var hg_deal_card_redesign = (hg_deal_card_redesign_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-detail-skeleton.vue?vue&type=template&id=0f2bf358&scoped=true
var hg_deal_detail_skeletonvue_type_template_id_0f2bf358_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"img-skeleton-wrap"},[_c('div',{staticClass:"img-skeleton"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 241.5 268.3"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 241.5 268.3","xml:space":"preserve"}},[_c('path',{staticStyle:{"fill":"#2d2d2d"},attrs:{"d":"M143.9 155.6v-33.1c0-1.5.3-2.5 1.7-3.3 4.6-3 8.3-7 11.4-11.5.9-1.3 1-1.4 2.1-.5 16.5 12.8 30 28 38.2 47.5 4 9.5 6 19.4 6 29.6 0 7.6 0 15.2-1.3 22.7-4.5 26.6-19.4 44.6-44.3 54.6-8.1 3.2-16.6 4.7-25.2 5.7-8.1 1-16.3 1.3-24.4.6-17.3-1.6-33.4-6.6-47.2-17.4-13.2-10.3-20.8-23.9-22.7-40.5-1.2-10.8-1.7-21.7-.9-32.6.8-10.1 3.8-19.6 8.4-28.6 6.7-13.2 16-24.5 26.9-34.4 2.8-2.6 5.8-5 8.9-7.3.9-.7 1.4-.6 2 .4 3.1 4.6 6.9 8.6 11.6 11.7 1 .7 1.1 1.6 1.1 2.7V184.7c0 4.7.5 9.4 2 13.9 3 9.3 9.7 14.5 19.5 15 2.5.1 5 .2 7.4-.3 8.9-1.7 15.4-8.1 17.3-17.1 1-4.9 1.3-9.8 1.3-14.8.1-8.6 0-17.3 0-25.9h.2z"}}),_c('path',{staticStyle:{"fill":"#00d6e1"},attrs:{"d":"M28 180.7c-3.3-3-6.1-5.9-8.7-9.1-8.9-10.7-14.2-23-16.9-36.6-1.6-8-2.5-16.1-2.3-24.3.7-39.3 21.8-76.3 55.3-95.2 12.7-7.1 26.3-11.7 40.7-14C104.7.1 113.4-.2 122.2.2c9.7.4 19 2.4 27.6 7 6.3 3.4 11.7 7.8 16.3 13.2 5.3 6.3 8.2 13.7 9.8 21.6 3.3 16.1-.4 30.6-10 43.7-.3.4-.5 1-1.4 1.2v-2.8c.7-20.4-12.8-38.2-31.8-43.8-25.4-7.5-51.9 9.1-56.1 35.1-1.2 7.1-.8 14 1.4 20.9.6 2 .6 2-1.1 3.3-15.2 11.4-28 25.1-37.3 41.7-6.7 12-10.7 24.7-11.5 38.5.1.1 0 .3-.1.9"}}),_c('path',{staticStyle:{"fill":"#ace632"},attrs:{"d":"M184 70c1.1.1 1.6 1 2.3 1.6 7.6 7.5 13 16.4 17.1 26.1 1.4 3.4 2.6 6.9 3.7 10.4.2.5.2 1.1.8 1.6.5-.4.3-1 .3-1.5-.5-6.2-2-12.1-4.1-17.9-.4-1.1-.9-2.2-1.3-3.3-.6-1.5-.5-1.7 1-1.9 6.3-.9 12.7-1.6 19.1-.6.1 0 .3 0 .6-.1-.5-.9-1.4-1-2.2-1.3-3.1-1.1-6.3-1.6-9.7-1.6-3 0-6.1-.1-9.1.4-1 .2-2 .3-2.6-1-2.6-5-6-9.4-10-13.7 7.4-6.6 16.1-10.9 24.9-15.2-2.1-.1-4 .4-5.9.9-7.6 2.1-14.7 5.4-20.8 10.5-.5.4-.8 1.1-1.6.6-.8-.4-1-1-.9-2 .5-3.2.7-6.3.7-9.6-.1-10.4-2.6-20.2-7.3-29.5-.4-.7-.9-1.3-.9-2.3 1-.4 1.8.3 2.6.7 7.3 3.6 14.1 7.8 20.6 12.7 13.1 10 23.6 22.2 30.7 37.2 5 10.6 8.3 21.8 9.3 33.5.8 9.7 0 19.3-2.7 28.7-3.6 12.6-8.7 24.6-16.3 35.3-1.9 2.7-4 5.2-6.4 7.4-1 .9-2 1.8-3.5 2.2-.3-2.7-.6-5.2-1-7.7-2-13.4-7.2-25.6-14.6-36.9-8-12.4-18.1-23-29.6-32.2-.3-.3-.6-.5-1-.7-.8-.5-.8-1-.1-1.7 2.2-2.3 4.3-4.7 6.2-7.3 4.8-6.3 8.6-13.1 11-20.6.2-.2.3-.7.7-1.2"}}),_c('path',{staticStyle:{"fill":"#ffeb00"},attrs:{"d":"M120 118.8c-19.6.1-36-16.4-35.7-36.3.2-20 16.4-35.9 36.5-35.8 19.7.1 35.8 16.5 35.6 36.5-.2 20.6-17.5 36-36.4 35.6"}})])]),_c('div',{staticClass:"img-skeleton hg-block"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 241.5 268.3"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 241.5 268.3","xml:space":"preserve"}},[_c('path',{staticStyle:{"fill":"#2d2d2d"},attrs:{"d":"M143.9 155.6v-33.1c0-1.5.3-2.5 1.7-3.3 4.6-3 8.3-7 11.4-11.5.9-1.3 1-1.4 2.1-.5 16.5 12.8 30 28 38.2 47.5 4 9.5 6 19.4 6 29.6 0 7.6 0 15.2-1.3 22.7-4.5 26.6-19.4 44.6-44.3 54.6-8.1 3.2-16.6 4.7-25.2 5.7-8.1 1-16.3 1.3-24.4.6-17.3-1.6-33.4-6.6-47.2-17.4-13.2-10.3-20.8-23.9-22.7-40.5-1.2-10.8-1.7-21.7-.9-32.6.8-10.1 3.8-19.6 8.4-28.6 6.7-13.2 16-24.5 26.9-34.4 2.8-2.6 5.8-5 8.9-7.3.9-.7 1.4-.6 2 .4 3.1 4.6 6.9 8.6 11.6 11.7 1 .7 1.1 1.6 1.1 2.7V184.7c0 4.7.5 9.4 2 13.9 3 9.3 9.7 14.5 19.5 15 2.5.1 5 .2 7.4-.3 8.9-1.7 15.4-8.1 17.3-17.1 1-4.9 1.3-9.8 1.3-14.8.1-8.6 0-17.3 0-25.9h.2z"}}),_c('path',{staticStyle:{"fill":"#00d6e1"},attrs:{"d":"M28 180.7c-3.3-3-6.1-5.9-8.7-9.1-8.9-10.7-14.2-23-16.9-36.6-1.6-8-2.5-16.1-2.3-24.3.7-39.3 21.8-76.3 55.3-95.2 12.7-7.1 26.3-11.7 40.7-14C104.7.1 113.4-.2 122.2.2c9.7.4 19 2.4 27.6 7 6.3 3.4 11.7 7.8 16.3 13.2 5.3 6.3 8.2 13.7 9.8 21.6 3.3 16.1-.4 30.6-10 43.7-.3.4-.5 1-1.4 1.2v-2.8c.7-20.4-12.8-38.2-31.8-43.8-25.4-7.5-51.9 9.1-56.1 35.1-1.2 7.1-.8 14 1.4 20.9.6 2 .6 2-1.1 3.3-15.2 11.4-28 25.1-37.3 41.7-6.7 12-10.7 24.7-11.5 38.5.1.1 0 .3-.1.9"}}),_c('path',{staticStyle:{"fill":"#ace632"},attrs:{"d":"M184 70c1.1.1 1.6 1 2.3 1.6 7.6 7.5 13 16.4 17.1 26.1 1.4 3.4 2.6 6.9 3.7 10.4.2.5.2 1.1.8 1.6.5-.4.3-1 .3-1.5-.5-6.2-2-12.1-4.1-17.9-.4-1.1-.9-2.2-1.3-3.3-.6-1.5-.5-1.7 1-1.9 6.3-.9 12.7-1.6 19.1-.6.1 0 .3 0 .6-.1-.5-.9-1.4-1-2.2-1.3-3.1-1.1-6.3-1.6-9.7-1.6-3 0-6.1-.1-9.1.4-1 .2-2 .3-2.6-1-2.6-5-6-9.4-10-13.7 7.4-6.6 16.1-10.9 24.9-15.2-2.1-.1-4 .4-5.9.9-7.6 2.1-14.7 5.4-20.8 10.5-.5.4-.8 1.1-1.6.6-.8-.4-1-1-.9-2 .5-3.2.7-6.3.7-9.6-.1-10.4-2.6-20.2-7.3-29.5-.4-.7-.9-1.3-.9-2.3 1-.4 1.8.3 2.6.7 7.3 3.6 14.1 7.8 20.6 12.7 13.1 10 23.6 22.2 30.7 37.2 5 10.6 8.3 21.8 9.3 33.5.8 9.7 0 19.3-2.7 28.7-3.6 12.6-8.7 24.6-16.3 35.3-1.9 2.7-4 5.2-6.4 7.4-1 .9-2 1.8-3.5 2.2-.3-2.7-.6-5.2-1-7.7-2-13.4-7.2-25.6-14.6-36.9-8-12.4-18.1-23-29.6-32.2-.3-.3-.6-.5-1-.7-.8-.5-.8-1-.1-1.7 2.2-2.3 4.3-4.7 6.2-7.3 4.8-6.3 8.6-13.1 11-20.6.2-.2.3-.7.7-1.2"}}),_c('path',{staticStyle:{"fill":"#ffeb00"},attrs:{"d":"M120 118.8c-19.6.1-36-16.4-35.7-36.3.2-20 16.4-35.9 36.5-35.8 19.7.1 35.8 16.5 35.6 36.5-.2 20.6-17.5 36-36.4 35.6"}})])])]),_vm._m(0)])
}
var hg_deal_detail_skeletonvue_type_template_id_0f2bf358_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-text-block"},[_c('h1',{staticClass:"hg-title"}),_c('div',{staticClass:"hg-subtitle"})])
}]


// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-detail-skeleton.vue?vue&type=template&id=0f2bf358&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-detail-skeleton.vue?vue&type=script&lang=js

/* harmony default export */ var hg_deal_detail_skeletonvue_type_script_lang_js = ({});

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-detail-skeleton.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_detail_hg_deal_detail_skeletonvue_type_script_lang_js = (hg_deal_detail_skeletonvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-detail/hg-deal-detail-skeleton.vue?vue&type=style&index=0&id=0f2bf358&prod&lang=postcss&scoped=true
var hg_deal_detail_skeletonvue_type_style_index_0_id_0f2bf358_prod_lang_postcss_scoped_true = __webpack_require__("dc51");

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-detail-skeleton.vue






/* normalize component */

var hg_deal_detail_skeleton_component = normalizeComponent(
  deal_detail_hg_deal_detail_skeletonvue_type_script_lang_js,
  hg_deal_detail_skeletonvue_type_template_id_0f2bf358_scoped_true_render,
  hg_deal_detail_skeletonvue_type_template_id_0f2bf358_scoped_true_staticRenderFns,
  false,
  null,
  "0f2bf358",
  null
  
)

/* harmony default export */ var hg_deal_detail_skeleton = (hg_deal_detail_skeleton_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-image-gallery.vue?vue&type=template&id=46912c22&scoped=true
var hg_deal_image_galleryvue_type_template_id_46912c22_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('hg-snap-slider',{attrs:{"height":_vm.height,"show-controls":_vm.showControls,"is-circular":_vm.isCircular,"is-responsive":_vm.images.length > 1 && _vm.isResponsive},on:{"onHandleScroll":function($event){return _vm.$emit('onHandleScroll')}}},_vm._l((_vm.images),function(image,i){return _c('div',{key:i,staticClass:"slide",class:_vm.images.length === 1 && 'slide--single',style:({ width: `${_vm.width}px`, height: `${_vm.height}px` })},[(image)?_c('hg-image',{class:{ 'slider-image': true, border: _vm.showBorder },attrs:{"alt":image.title,"src":_vm.getImgSource(image),"src-placeholder":`${image.url}?width=20&height=10&mimetype=webp`}}):_vm._e()],1)}),0)
}
var hg_deal_image_galleryvue_type_template_id_46912c22_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-image-gallery.vue?vue&type=template&id=46912c22&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-image-gallery.vue?vue&type=script&lang=js



const maxImageWidth = 2000

/* harmony default export */ var hg_deal_image_galleryvue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  data: () => {
    return {
      imageUrls: [],
    }
  },
  props: {
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    images: {
      type: Array,
      default: () => [],
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
    showControls: {
      type: Boolean,
      default: true,
    },
    isCircular: {
      type: Boolean,
      default: false,
    },
    isResponsive: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getImgSource(image) {
      if (
        image == null ||
        image.width == 0 ||
        image.height == 0 ||
        image.url == null
      ) {
        return ''
      }

      let imageUrl = this.imageUrls.find((i) => i.startsWith(image.url))
      if (imageUrl != null) return imageUrl

      this.imageUrls.push(image.url)
      let height = +this.height || image.height

      let width = this.calculateWidth(+this.width || image.width, height)

      if (+this.width == 0 || width == maxImageWidth) {
        return `${image.url}?height=${height}&mimetype=webp`
      }

      return `${image.url}?width=${width}&height=${height}&mimetype=webp`
    },
    calculateWidth(width, height) {
      const newWidth = width / (height / this.height)
      return newWidth > maxImageWidth ? maxImageWidth : newWidth
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-image-gallery.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_detail_hg_deal_image_galleryvue_type_script_lang_js = (hg_deal_image_galleryvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-detail/hg-deal-image-gallery.vue?vue&type=style&index=0&id=46912c22&prod&scoped=true&lang=postcss
var hg_deal_image_galleryvue_type_style_index_0_id_46912c22_prod_scoped_true_lang_postcss = __webpack_require__("f225");

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-image-gallery.vue






/* normalize component */

var hg_deal_image_gallery_component = normalizeComponent(
  deal_detail_hg_deal_image_galleryvue_type_script_lang_js,
  hg_deal_image_galleryvue_type_template_id_46912c22_scoped_true_render,
  hg_deal_image_galleryvue_type_template_id_46912c22_scoped_true_staticRenderFns,
  false,
  null,
  "46912c22",
  null
  
)

/* harmony default export */ var hg_deal_image_gallery = (hg_deal_image_gallery_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-hotel-attributes.vue?vue&type=template&id=a9a08254&scoped=true
var hg_deal_hotel_attributesvue_type_template_id_a9a08254_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-content"},[_c('ul',{staticClass:"hg-hotel-attribute-list"},[(_vm.name)?_c('li',[_c('hg-icon',{attrs:{"name":"hotel"}}),_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")])],1):_vm._e(),(_vm.stars)?_c('li',[_c('div',{staticClass:"tw-flex tw-items-center"},[_c('hg-icon',{attrs:{"name":"star"}}),_c('div',{staticClass:"tw-flex tw-flex-col tw-ml-4"},[_c('div',[_vm._v(_vm._s(_vm.stars)+" "+_vm._s(_vm.starsText))]),_c('hg-stars',{attrs:{"rating":_vm.stars}})],1)],1)]):_vm._e(),_vm._l((_vm.attributes),function(hotelAttr){return _c('li',{key:hotelAttr.id},[_c('hg-icon',{attrs:{"name":hotelAttr.icon}}),_c('span',[_vm._v(" "+_vm._s(hotelAttr.name)+" ")])],1)})],2)])
}
var hg_deal_hotel_attributesvue_type_template_id_a9a08254_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-hotel-attributes.vue?vue&type=template&id=a9a08254&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-hotel-attributes.vue?vue&type=script&lang=js

/* harmony default export */ var hg_deal_hotel_attributesvue_type_script_lang_js = ({
  props: {
    name: {
      type: String,
      default: '',
    },
    stars: {
      type: Number,
      default: 0.0,
    },
    attributes: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    starsText: '',
  }),
  mounted() {
    if (!this.$i18n) return
    if (this.stars === 1.0) {
      this.starsText = this.$i18n.t('star')
    }
    this.starsText = this.$i18n.t('stars')
    this.starsText += ' ' + this.$i18n.t('hotel')
  },
});

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-hotel-attributes.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_detail_hg_deal_hotel_attributesvue_type_script_lang_js = (hg_deal_hotel_attributesvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-detail/hg-deal-hotel-attributes.vue?vue&type=style&index=0&id=a9a08254&prod&scoped=true&lang=postcss
var hg_deal_hotel_attributesvue_type_style_index_0_id_a9a08254_prod_scoped_true_lang_postcss = __webpack_require__("35e9");

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-hotel-attributes.vue






/* normalize component */

var hg_deal_hotel_attributes_component = normalizeComponent(
  deal_detail_hg_deal_hotel_attributesvue_type_script_lang_js,
  hg_deal_hotel_attributesvue_type_template_id_a9a08254_scoped_true_render,
  hg_deal_hotel_attributesvue_type_template_id_a9a08254_scoped_true_staticRenderFns,
  false,
  null,
  "a9a08254",
  null
  
)

/* harmony default export */ var hg_deal_hotel_attributes = (hg_deal_hotel_attributes_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-voucher.vue?vue&type=template&id=bc370548&scoped=true
var hg_deal_vouchervue_type_template_id_bc370548_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.vouchers),function(voucher,index){return _c('div',{key:voucher.id,staticClass:"voucher"},[(index === 0)?_c('hg-tooltip',{attrs:{"is-visible":_vm.voucherTooltipVisible,"is-mobile":_vm.isMobile,"tipPosition":"middle","tooltipContent":_vm.$t('deal.tooltipVoucherCode')}}):_vm._e(),_c('div',{staticClass:"voucher-container",class:!_vm.isMobile && 'desktop',on:{"mouseover":function($event){_vm.voucherTooltipVisible = true},"mouseleave":function($event){_vm.voucherTooltipVisible = false}}},[_vm._v(" "+_vm._s(_vm.$t('deal.voucherCode'))+" "),_c('hg-text-link',{staticClass:"voucher-code",on:{"linkClicked":function($event){return _vm.copyVoucher(index)}}},[_vm._v(_vm._s(voucher.code)+" "),(!_vm.voucherCopyState[index])?_c('span',[_c('hg-icon',{staticClass:"voucher-info",attrs:{"name":"copy","size":"small"}})],1):_vm._e(),(_vm.voucherCopyState[index])?_c('span',[_c('hg-icon',{staticClass:"voucher-check",attrs:{"name":"check","size":"small"}})],1):_vm._e()])],1)],1)}),0)
}
var hg_deal_vouchervue_type_template_id_bc370548_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-voucher.vue?vue&type=template&id=bc370548&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-voucher.vue?vue&type=script&lang=js

/* harmony default export */ var hg_deal_vouchervue_type_script_lang_js = ({
  props: {
    vouchers: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      voucherTooltipVisible: false,
      voucherCopyState: [],
    }
  },
  created() {
    this.voucherCopyState = [...this.vouchers.map(() => false)]
  },
  methods: {
    copyVoucher(voucherIndex) {
      const voucherDummy = document.createElement('textarea')
      voucherDummy.value = this.vouchers[voucherIndex].code
      voucherDummy.setAttribute('readonly', '')
      voucherDummy.style.position = 'absolute'
      voucherDummy.style.left = '-9999px'
      document.body.appendChild(voucherDummy)
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false
      voucherDummy.select()
      document.execCommand('copy')
      document.body.removeChild(voucherDummy)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      this.voucherCopyState[voucherIndex] = true
      this.voucherTooltipVisible = false
      // this.$nextTick().then(() => (this.voucherCopyState[voucherIndex] = false))
      setTimeout(() => (this.voucherCopyState[voucherIndex] = false), 2000)
    },
    getTooltipTip(voucher) {
      const factor = 2.55
      const setoff = 37 + factor * 3
      if (!voucher.code) return 10
      if (setoff + voucher.code.length * factor >= 90) return 90
      return setoff + voucher.code.length * factor
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-voucher.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_detail_hg_deal_vouchervue_type_script_lang_js = (hg_deal_vouchervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-detail/hg-deal-voucher.vue?vue&type=style&index=0&id=bc370548&prod&lang=postcss&scoped=true
var hg_deal_vouchervue_type_style_index_0_id_bc370548_prod_lang_postcss_scoped_true = __webpack_require__("ff81");

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-voucher.vue






/* normalize component */

var hg_deal_voucher_component = normalizeComponent(
  deal_detail_hg_deal_vouchervue_type_script_lang_js,
  hg_deal_vouchervue_type_template_id_bc370548_scoped_true_render,
  hg_deal_vouchervue_type_template_id_bc370548_scoped_true_staticRenderFns,
  false,
  null,
  "bc370548",
  null
  
)

/* harmony default export */ var hg_deal_voucher = (hg_deal_voucher_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-support-box.vue?vue&type=template&id=4f398480&scoped=true
var hg_deal_support_boxvue_type_template_id_4f398480_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-deal-support-box",class:!_vm.isMobile && 'desktop'},[_c('div',{staticClass:"support-svg"},[_c('support-box-svg')],1),_c('div',{staticClass:"support-content-wrapper"},[_c('div',{staticClass:"support-profile"},[_c('div',{staticClass:"support-image"},[_c('hg-image',{staticClass:"support-img",attrs:{"alt":"Support Person Lena","src":_vm.imageSrc}})],1),_c('span',[_vm._v(" "+_vm._s(_vm.$t('supportPerson.name'))+" ")])]),_c('div',{staticClass:"support-content"},[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('supportPerson.title'))+" ")]),(_vm.showPhone)?_c('a',{staticClass:"tw-font-bold",attrs:{"href":`tel:${_vm.$t('supportPerson.telephone')}`}},[_vm._v(" "+_vm._s(_vm.$t('supportPerson.telephone'))+" ")]):_vm._e(),(_vm.showMail)?_c('hg-text-link',{attrs:{"href":_vm.mailTo}},[_vm._v(" "+_vm._s(_vm.$t('supportPerson.mail'))+" ")]):_vm._e(),(_vm.dealId)?_c('div',{staticClass:"deal-id-wrapper"},[_c('hg-tooltip',{attrs:{"is-visible":_vm.dealIdTooltipVisible,"is-mobile":_vm.isMobile,"px-center":_vm.tooltipActivatorPos.center,"px-bottom":_vm.tooltipActivatorPos.top,"tip-position":"left","tooltip-content":_vm.$t('supportPerson.tooltip.content'),"tooltip-highlight-content":_vm.dealId,"closable":""},on:{"onCloseTooltip":function($event){_vm.dealIdTooltipVisible = false}}}),_vm._v(" Deal-ID: "),_c('span',{ref:"tooltipActivator",staticClass:"deal-id-clicker tooltip-activator",on:{"click":_vm.toggleTooltip}},[_vm._v(_vm._s(_vm.$t('display')))])],1):_vm._e()],1)])])
}
var hg_deal_support_boxvue_type_template_id_4f398480_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-support-box.vue?vue&type=template&id=4f398480&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-support-box.vue?vue&type=script&lang=js



/* harmony default export */ var hg_deal_support_boxvue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  props: {
    imageSrc: {
      type: String,
      default: '/images/callcenter_lena.jpg',
    },
    showMail: {
      type: Boolean,
      default: true,
    },
    showPhone: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    mailSubject: {
      type: String,
      default: '',
    },
    mailBody: {
      type: String,
      default: '',
    },
    dealId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dealIdTooltipVisible: false,
      tooltipActivatorPos: {
        top: undefined,
        center: undefined,
      },
    }
  },
  computed: {
    mailTo() {
      let res = `mailto:${this.$t('supportPerson.mail')}`
      if (this.mailSubject || this.mailBody) res += '?'
      if (this.mailSubject) {
        res += res[res.length - 1] === '?' ? '' : '&'
        res += `subject=${encodeURIComponent(this.mailSubject)}`
      }
      if (this.mailBody) {
        res += res[res.length - 1] === '?' ? '' : '&'
        res += `body=${encodeURIComponent(this.mailBody)}`
      }
      return res
    },
  },

  methods: {
    toggleTooltip() {
      this.getPos()
      this.dealIdTooltipVisible = !this.dealIdTooltipVisible
    },
    getPos() {
      const { left, top, right, bottom } =
        this.$refs.tooltipActivator.getBoundingClientRect()
      const center = left + (right - left) / 2
      this.tooltipActivatorPos.top = top
      this.tooltipActivatorPos.center = center
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-support-box.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_detail_hg_deal_support_boxvue_type_script_lang_js = (hg_deal_support_boxvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-detail/hg-deal-support-box.vue?vue&type=style&index=0&id=4f398480&prod&scoped=true&lang=postcss
var hg_deal_support_boxvue_type_style_index_0_id_4f398480_prod_scoped_true_lang_postcss = __webpack_require__("f325");

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-support-box.vue






/* normalize component */

var hg_deal_support_box_component = normalizeComponent(
  deal_detail_hg_deal_support_boxvue_type_script_lang_js,
  hg_deal_support_boxvue_type_template_id_4f398480_scoped_true_render,
  hg_deal_support_boxvue_type_template_id_4f398480_scoped_true_staticRenderFns,
  false,
  null,
  "4f398480",
  null
  
)

/* harmony default export */ var hg_deal_support_box = (hg_deal_support_box_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-title.vue?vue&type=template&id=e6e9d84c&scoped=true
var hg_deal_titlevue_type_template_id_e6e9d84c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"placeholder"}):_vm._e(),(_vm.badge)?_c('span',{staticClass:"hg-badge"},[_c('badge-svg'),_c('span',[_vm._v(" "+_vm._s(_vm.badge)+" ")])],1):_vm._e(),(_vm.title)?_c('h1',{staticClass:"hg-title",class:_vm.loading && 'hg-skeleton'},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.subtitle)?_c('p',{staticClass:"hg-subtitle",class:_vm.loading && 'hg-skeleton'},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e(),(_vm.location)?_c('button',{staticClass:"hg-button location-button",class:_vm.loading && 'hg-skeleton hg-skeleton--teal',on:{"click":function($event){return _vm.$emit('onLocationButtonClick')}}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'map-marker-alt']}}),_c('span',[_vm._v(" "+_vm._s(_vm.location)+" ")])],1):_vm._e()])
}
var hg_deal_titlevue_type_template_id_e6e9d84c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-title.vue?vue&type=template&id=e6e9d84c&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-title.vue?vue&type=script&lang=js

/* harmony default export */ var hg_deal_titlevue_type_script_lang_js = ({
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    badge: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    location: {
      type: String,
      default: '',
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-title.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_detail_hg_deal_titlevue_type_script_lang_js = (hg_deal_titlevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-detail/hg-deal-title.vue?vue&type=style&index=0&id=e6e9d84c&prod&scoped=true&lang=postcss
var hg_deal_titlevue_type_style_index_0_id_e6e9d84c_prod_scoped_true_lang_postcss = __webpack_require__("1d41");

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-title.vue






/* normalize component */

var hg_deal_title_component = normalizeComponent(
  deal_detail_hg_deal_titlevue_type_script_lang_js,
  hg_deal_titlevue_type_template_id_e6e9d84c_scoped_true_render,
  hg_deal_titlevue_type_template_id_e6e9d84c_scoped_true_staticRenderFns,
  false,
  null,
  "e6e9d84c",
  null
  
)

/* harmony default export */ var hg_deal_title = (hg_deal_title_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-footer.vue?vue&type=template&id=01a74078&scoped=true
var hg_deal_footervue_type_template_id_01a74078_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"hg-deal-footer"},[(_vm.dealId)?_c('div',{staticClass:"hg-deal-footer__deal-id"},[_c('span',[_vm._v("Deal ID:")]),_c('span',[_vm._v(_vm._s(_vm.dealId))])]):_vm._e(),(_vm.screenshots.length)?_c('div',{staticClass:"hg-deal-footer__screenshot-button"},[_c('HgButton',{attrs:{"type":"submit","color":"transparent--teal","size":"full"},on:{"onClick":_vm.openModal}},[_c('hg-icon',{attrs:{"name":"camera","size":"small"}}),(_vm.screenshots.length == 1)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('deal.showScreenshot'))+" ")]):_vm._e(),(_vm.screenshots.length > 1)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('deal.showScreenshots'))+" ")]):_vm._e()],1)],1):_vm._e(),(_vm.showScreenshot)?_c('hg-modal',{staticClass:"screenshot-modal",attrs:{"isFullscreen":false},on:{"onClose":function($event){_vm.showScreenshot = false}}},[_c('p',{staticClass:"tw-pl-4 tw-pr-8 tw-pt-4"},[_vm._v(_vm._s(_vm.screenshotNotice))]),_c('hg-snap-slider',{attrs:{"height":_vm.sliderHeight}},_vm._l((_vm.screenshots),function(screenshot,i){return _c('div',{key:i,ref:'slide' + i,refInFor:true,staticClass:"slide",class:_vm.screenshots.length === 1 && 'slide--single'},[_c('div',{ref:'slideImage' + i,refInFor:true,staticClass:"drag-div",on:{"mouseup":function($event){return _vm.stopDrag()},"mousedown":function($event){return _vm.startDrag(i)},"mousemove":function($event){return _vm.elementDrag()}}},[_c('hg-image',{staticClass:"slide-image",attrs:{"alt":screenshot.image.title,"src":_vm.getScreenshotUrl(screenshot),"src-placeholder":`${screenshot.image.url}?width=20&height=10`,"object-fit":"contain"}})],1)])}),0)],1):_vm._e()],1)
}
var hg_deal_footervue_type_template_id_01a74078_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-footer.vue?vue&type=template&id=01a74078&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-detail/hg-deal-footer.vue?vue&type=script&lang=js



/* harmony default export */ var hg_deal_footervue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  props: {
    dealId: {
      type: String,
      default: '',
    },
    screenshots: {
      type: Array,
      default: () => [],
    },
    screenshotHeight: {
      type: Number,
      default: 500,
    },
  },
  mounted() {
    if (!this.$i18n) return
    this.screenshotNotice = this.$i18n.t('screenshot.notice')
    this.windowWidth = window.innerWidth
    this.windowHeight = window.innerHeight
  },
  data: () => ({
    showScreenshot: false,
    screenshotNotice: '',
    windowWidth: 0,
    windowHeight: 0,
    screenshotWidth: 800,
    sliderHeight: 500,
    timeoutId: null,
    pos1: 0,
    pos2: 0,
    pos3: 0,
    pos4: 0,
    dragElem: null,
    dragging: false,
  }),
  methods: {
    openModal() {
      this.$emit('onOpenScreenshots')
      this.showScreenshot = true
    },

    startDrag(e) {
      e = window.event
    },

    elementDrag(e) {
      if (this.dragging) {
        e = e || window.event
        e.preventDefault()

        // calculate the new cursor position:
        this.pos1 = this.pos3 - e.clientX
        this.pos2 = this.pos4 - e.clientY
        this.pos3 = e.clientX
        this.pos4 = e.clientY

        // set the element's new position:
        if (
          this.dragElem.offsetLeft - this.pos1 < 0 &&
          this.dragElem.offsetLeft - this.pos1 >
            this.windowWidth - this.screenshotWidth
        )
          this.dragElem.style.left = this.dragElem.offsetLeft - this.pos1 + 'px'
      }
    },

    stopDrag() {
      this.dragging = false
    },

    getScreenshotUrl(screenshot) {
      let h = this.screenshotHeight
      let w =
        screenshot.image.width /
        (screenshot.image.height / this.screenshotHeight)

      if (w > 2000) {
        w = 2000
        h = w * (screenshot.image.height / screenshot.image.width)
      }

      return `${screenshot.image.url}?width=${w}&height=${h}&mimetype=webp`
    },
  },
  computed: {
    imageUrl() {
      if (!this.screenshots || !this.screenshots.length) return ''
      return this.screenshots[0].image.url
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-footer.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_detail_hg_deal_footervue_type_script_lang_js = (hg_deal_footervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-detail/hg-deal-footer.vue?vue&type=style&index=0&id=01a74078&prod&scoped=true&lang=postcss
var hg_deal_footervue_type_style_index_0_id_01a74078_prod_scoped_true_lang_postcss = __webpack_require__("2597");

// EXTERNAL MODULE: ./src/components/deal-detail/hg-deal-footer.vue?vue&type=style&index=1&id=01a74078&prod&lang=css
var hg_deal_footervue_type_style_index_1_id_01a74078_prod_lang_css = __webpack_require__("36e4");

// CONCATENATED MODULE: ./src/components/deal-detail/hg-deal-footer.vue







/* normalize component */

var hg_deal_footer_component = normalizeComponent(
  deal_detail_hg_deal_footervue_type_script_lang_js,
  hg_deal_footervue_type_template_id_01a74078_scoped_true_render,
  hg_deal_footervue_type_template_id_01a74078_scoped_true_staticRenderFns,
  false,
  null,
  "01a74078",
  null
  
)

/* harmony default export */ var hg_deal_footer = (hg_deal_footer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-skeleton.vue?vue&type=template&id=9b5b01fe&scoped=true
var hg_deal_box_skeletonvue_type_template_id_9b5b01fe_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-deal-box-skeleton",class:!_vm.isMobile && 'desktop'},[_vm._m(0),_vm._m(1)])
}
var hg_deal_box_skeletonvue_type_template_id_9b5b01fe_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-deal-box-header"},[_c('div',{staticClass:"price hg-skeleton hg-skeleton--teal"}),_c('div',{staticClass:"button hg-skeleton hg-skeleton--teal"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-deal-box-content"},[_c('div',{staticClass:"info hg-skeleton"}),_c('div',{staticClass:"info hg-skeleton"}),_c('div',{staticClass:"info hg-skeleton"}),_c('div',{staticClass:"info hg-skeleton"})])
}]


// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-skeleton.vue?vue&type=template&id=9b5b01fe&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-skeleton.vue?vue&type=script&lang=js

/* harmony default export */ var hg_deal_box_skeletonvue_type_script_lang_js = ({
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-skeleton.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_box_hg_deal_box_skeletonvue_type_script_lang_js = (hg_deal_box_skeletonvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/hg-deal-box-skeleton.vue?vue&type=style&index=0&id=9b5b01fe&prod&scoped=true&lang=postcss
var hg_deal_box_skeletonvue_type_style_index_0_id_9b5b01fe_prod_scoped_true_lang_postcss = __webpack_require__("c735");

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-skeleton.vue






/* normalize component */

var hg_deal_box_skeleton_component = normalizeComponent(
  deal_box_hg_deal_box_skeletonvue_type_script_lang_js,
  hg_deal_box_skeletonvue_type_template_id_9b5b01fe_scoped_true_render,
  hg_deal_box_skeletonvue_type_template_id_9b5b01fe_scoped_true_staticRenderFns,
  false,
  null,
  "9b5b01fe",
  null
  
)

/* harmony default export */ var hg_deal_box_skeleton = (hg_deal_box_skeleton_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-basic.vue?vue&type=template&id=e2e335c6&scoped=true
var hg_deal_box_basicvue_type_template_id_e2e335c6_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal-box",class:!_vm.isMobile && 'desktop'},[(!_vm.isMobile && _vm.badges.length)?_c('div',{staticClass:"deal-badge-container"},[_c('hg-cancellation-badge',{attrs:{"badges":_vm.badges}})],1):_vm._e(),_c('hg-box-section-social',{staticClass:"cta-box deal-box-social",class:!_vm.isMobile && 'desktop',attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}),_c('div',{staticClass:"cta-box deal-cta",class:_vm.dealCtaClass,style:(_vm.dealCtaStyle)},[_c('div',{staticClass:"cta price-tag",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-price',{attrs:{"teal":"","price":_vm.currentDealPrice,"perPerson":true,"rounded":_vm.roundDealPrice,"priceSize":_vm.isMobile ? '2xl' : '3xl'}})],1),(!_vm.isExpired)?_c('div',{staticClass:"cta cta-button",class:!_vm.isMobile && 'desktop'},[_c('hg-button',{staticClass:"hg-deal-button",attrs:{"type":"submit","color":"teal","size":"full","tag":"a","href":_vm.dealPriceForwarderUrl,"data-partner":_vm.getDataPartner(_vm.dealPriceUrl),"target":"_blank","rel":"noopener","disabled":_vm.isExpired},on:{"onClick":_vm.clickDealButton}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('goToDeal'))+" ")])])],1):_vm._e(),(_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.dealVouchers.length && !_vm.isExpired)?_c('div',{staticClass:"cta deal-voucher",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-voucher',{attrs:{"vouchers":_vm.dealVouchers,"isMobile":_vm.isMobile}})],1):_vm._e(),(_vm.isExpired)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e()]),(_vm.isExpired && !_vm.isMobile)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-trust',{staticClass:"trust-usp cta-box",class:!_vm.isMobile && 'desktop'}):_vm._e(),(!_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),_c('div',{staticClass:"pointy-divider-outer",class:!_vm.isMobile && 'desktop'},[_c('div',{staticClass:"pointy-divider-inner",class:!_vm.isMobile && 'desktop'})]),(_vm.isExpired)?_c('hg-box-section-reminder',{staticClass:"reminder-box",class:!_vm.isMobile && 'desktop',attrs:{"isMobile":_vm.isMobile,"currentPeriod":_vm.currentDealPeriod},scopedSlots:_vm._u([{key:"reminderEmail",fn:function(){return [_c('hg-text-input',{ref:"emailinput",attrs:{"label":"Deine E-Mail Adresse","labelPosition":"inside","placeholder":"info@example.com","validate":"","required":"","type":"email","name":"email"},on:{"input":_vm.onChange},model:{value:(_vm.expiredEmail),callback:function ($$v) {_vm.expiredEmail=$$v},expression:"expiredEmail"}})]},proxy:true},{key:"reminderSubmit",fn:function(){return [_c('div',{staticClass:"button-box"},[_c('hg-button',{attrs:{"type":"submit","color":"teal","size":"full","disabled":!_vm.expiredEmailValid},on:{"onClick":_vm.subscribeNotification}},[_vm._v(" "+_vm._s(_vm.$t('dealBox.notifyMe'))+" ")])],1)]},proxy:true}],null,false,3530167088)}):_vm._e(),(_vm.isMobile && _vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),_c('hg-box-section-highlights',{staticClass:"area",attrs:{"itemList":_vm.dealHighlights,"maxItemsToShow":_vm.maxHighlights,"isMobile":_vm.isMobile},on:{"onClickShowMoreHighlights":function($event){return _vm.$emit('onClickShowMoreHighlights')}},scopedSlots:_vm._u([{key:"social",fn:function(){return [(_vm.isMobile)?_c('hg-box-section-social',{staticClass:"deal-box-social",attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}):_vm._e()]},proxy:true}])})],1)
}
var hg_deal_box_basicvue_type_template_id_e2e335c6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-basic.vue?vue&type=template&id=e2e335c6&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-reminder.vue?vue&type=template&id=5d5fec63&scoped=true
var hg_box_section_remindervue_type_template_id_5d5fec63_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`reminder-box ${_vm.activatedForm ? '' : 'no-form'}`},[_c('div',{staticClass:"reminder-title"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderHeadline'))+" ")]),_c('div',{staticClass:"reminder-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]),(_vm.activatedForm)?_c('div',{staticClass:"reminder-text-container"},[(_vm.currentPeriod && _vm.currentPeriod.flights)?_c('span',{staticClass:"reminder-text"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderTextFlight'))+" ")]):_c('span',{staticClass:"reminder-text"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderTextDefault'))+" ")]),_c('span',{staticClass:"reminder-text"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderTextNotice'))+" ")])]):_vm._e(),(_vm.activatedForm)?_vm._t("reminderDeparture"):_vm._e(),(_vm.activatedForm)?_vm._t("reminderEmail"):_vm._e(),(_vm.activatedForm)?_vm._t("reminderSubmit"):_vm._e()],2)
}
var hg_box_section_remindervue_type_template_id_5d5fec63_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-reminder.vue?vue&type=template&id=5d5fec63&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-reminder.vue?vue&type=script&lang=js

/* harmony default export */ var hg_box_section_remindervue_type_script_lang_js = ({
  props: {
    currentPeriod: {
      type: Object,
      default: () => {},
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activatedForm: false,
    }
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-reminder.vue?vue&type=script&lang=js
 /* harmony default export */ var box_sections_hg_box_section_remindervue_type_script_lang_js = (hg_box_section_remindervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/box-sections/hg-box-section-reminder.vue?vue&type=style&index=0&id=5d5fec63&prod&lang=postcss&scoped=true
var hg_box_section_remindervue_type_style_index_0_id_5d5fec63_prod_lang_postcss_scoped_true = __webpack_require__("ada6");

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-reminder.vue






/* normalize component */

var hg_box_section_reminder_component = normalizeComponent(
  box_sections_hg_box_section_remindervue_type_script_lang_js,
  hg_box_section_remindervue_type_template_id_5d5fec63_scoped_true_render,
  hg_box_section_remindervue_type_template_id_5d5fec63_scoped_true_staticRenderFns,
  false,
  null,
  "5d5fec63",
  null
  
)

/* harmony default export */ var hg_box_section_reminder = (hg_box_section_reminder_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-trust.vue?vue&type=template&id=7d3f5686&scoped=true
var hg_box_section_trustvue_type_template_id_7d3f5686_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trust-container"},[_c('div',{staticClass:"trust"},[_c('font-awesome-icon',{staticClass:"fa-icon star icon-light trust-icon",attrs:{"icon":['far', 'star']}}),_vm._v(" "+_vm._s(_vm.$t('dealBox.topPricePerformance'))+" ")],1),_c('div',{staticClass:"usp"},[_c('font-awesome-icon',{staticClass:"fa-icon thumbs-up icon-light usp-icon",attrs:{"icon":['far', 'thumbs-up']}}),_vm._v(" "+_vm._s(_vm.$t('dealBox.handpickedDeal'))+" ")],1)])
}
var hg_box_section_trustvue_type_template_id_7d3f5686_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-trust.vue?vue&type=template&id=7d3f5686&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-trust.vue?vue&type=script&lang=js

/* harmony default export */ var hg_box_section_trustvue_type_script_lang_js = ({});

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-trust.vue?vue&type=script&lang=js
 /* harmony default export */ var box_sections_hg_box_section_trustvue_type_script_lang_js = (hg_box_section_trustvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/box-sections/hg-box-section-trust.vue?vue&type=style&index=0&id=7d3f5686&prod&lang=postcss&scoped=true
var hg_box_section_trustvue_type_style_index_0_id_7d3f5686_prod_lang_postcss_scoped_true = __webpack_require__("36f4");

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-trust.vue






/* normalize component */

var hg_box_section_trust_component = normalizeComponent(
  box_sections_hg_box_section_trustvue_type_script_lang_js,
  hg_box_section_trustvue_type_template_id_7d3f5686_scoped_true_render,
  hg_box_section_trustvue_type_template_id_7d3f5686_scoped_true_staticRenderFns,
  false,
  null,
  "7d3f5686",
  null
  
)

/* harmony default export */ var hg_box_section_trust = (hg_box_section_trust_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-social.vue?vue&type=template&id=3049c524&scoped=true
var hg_box_section_socialvue_type_template_id_3049c524_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-buttons"},[_c('hg-button',{staticClass:"hg-button button--share",attrs:{"role":"button","aria-label":"share","color":"bookmark","type":"button"},on:{"onClick":_vm.clickShare}},[_c('hg-icon',{staticClass:"share icon-light",attrs:{"name":"share","pack":"fal"}}),_c('hg-icon',{staticClass:"share icon-solid",attrs:{"name":"share","pack":"fas"}})],1),_c('hg-button',{staticClass:"hg-button button--bookmark",class:_vm.hasBookmark ? 'button--active' : '',attrs:{"role":"button","color":"bookmark","aria-label":"bookmark","type":"button"},on:{"onClick":_vm.clickBookmark}},[_c('hg-icon',{staticClass:"heart icon-light",attrs:{"name":"heart","pack":"fal"}}),_c('hg-icon',{staticClass:"heart icon-solid",attrs:{"name":"heart","pack":"fas"}})],1)],1)
}
var hg_box_section_socialvue_type_template_id_3049c524_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-social.vue?vue&type=template&id=3049c524&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-social.vue?vue&type=script&lang=js


/* harmony default export */ var hg_box_section_socialvue_type_script_lang_js = ({
  components: { HgButton: hg_button },
  props: {
    dealId: {
      type: String,
      default: '',
    },
    dealBookmark: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasBookmark() {
      if (this.dealBookmark) return true
      return false
    },
  },
  methods: {
    clickBookmark() {
      this.$emit('onClickBookmark', this.dealId)
    },
    clickShare() {
      this.$emit('onClickShare', this.dealId)
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-social.vue?vue&type=script&lang=js
 /* harmony default export */ var box_sections_hg_box_section_socialvue_type_script_lang_js = (hg_box_section_socialvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/box-sections/hg-box-section-social.vue?vue&type=style&index=0&id=3049c524&prod&scoped=true&lang=postcss
var hg_box_section_socialvue_type_style_index_0_id_3049c524_prod_scoped_true_lang_postcss = __webpack_require__("570f");

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-social.vue






/* normalize component */

var hg_box_section_social_component = normalizeComponent(
  box_sections_hg_box_section_socialvue_type_script_lang_js,
  hg_box_section_socialvue_type_template_id_3049c524_scoped_true_render,
  hg_box_section_socialvue_type_template_id_3049c524_scoped_true_staticRenderFns,
  false,
  null,
  "3049c524",
  null
  
)

/* harmony default export */ var hg_box_section_social = (hg_box_section_social_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-highlights.vue?vue&type=template&id=1fbbcb23&scoped=true
var hg_box_section_highlightsvue_type_template_id_1fbbcb23_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal-highlights"},[_c('div',{staticClass:"heading-container"},[_c('h3',{staticClass:"highlights-heading hg-title"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.dealOverview'))+" ")]),_vm._t("social")],2),_c('ul',{staticClass:"highlight-list"},_vm._l((_vm.itemsToShow),function(item){return _c('li',{key:item.label,staticClass:"highlight-item"},[_c('font-awesome-icon',{staticClass:"fa-icon check icon-light item-check",attrs:{"icon":['far', 'check']}}),_vm._v(" "+_vm._s(item.label)+" ")],1)}),0),(_vm.moreHighlights)?_c('hg-text-link',{staticClass:"show-more",class:!_vm.isMobile && 'desktop',on:{"linkClicked":_vm.toggleMoreHighlights}},[_vm._v(" "+_vm._s(_vm.$t('dealBox.showMore'))+" ")]):_vm._e(),(_vm.modalHighlightsOpen)?_c('hg-modal',{staticClass:"highlights-modal",class:!_vm.isMobile && 'desktop',attrs:{"isFullscreen":_vm.isMobile},on:{"onClose":_vm.toggleMoreHighlights}},[_c('h3',{staticClass:"modal-caption hg-title"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.dealOverview'))+" ")]),_c('ul',{staticClass:"highlight-list"},_vm._l((_vm.itemList),function(item){return _c('li',{key:item.id,staticClass:"highlight-item"},[_c('font-awesome-icon',{staticClass:"fa-icon check icon-light item-check",attrs:{"icon":['far', 'check']}}),_vm._v(" "+_vm._s(item.label)+" ")],1)}),0)]):_vm._e()],1)
}
var hg_box_section_highlightsvue_type_template_id_1fbbcb23_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-highlights.vue?vue&type=template&id=1fbbcb23&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-highlights.vue?vue&type=script&lang=js

/* harmony default export */ var hg_box_section_highlightsvue_type_script_lang_js = ({
  data() {
    return {
      modalHighlightsOpen: false,
    }
  },
  props: {
    itemList: {
      type: Array,
      default: () => [],
    },
    maxItemsToShow: {
      type: Number,
      default: 1,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    itemsToShow() {
      return this.itemList.filter((item, index) => index < this.maxItemsToShow)
    },
    moreHighlights() {
      return this.itemList.length > this.maxItemsToShow
    },
  },
  methods: {
    toggleMoreHighlights() {
      this.$emit('onClickShowMoreHighlights')
      this.modalHighlightsOpen = !this.modalHighlightsOpen
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-highlights.vue?vue&type=script&lang=js
 /* harmony default export */ var box_sections_hg_box_section_highlightsvue_type_script_lang_js = (hg_box_section_highlightsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/box-sections/hg-box-section-highlights.vue?vue&type=style&index=0&id=1fbbcb23&prod&lang=postcss&scoped=true
var hg_box_section_highlightsvue_type_style_index_0_id_1fbbcb23_prod_lang_postcss_scoped_true = __webpack_require__("8211");

// EXTERNAL MODULE: ./src/components/deal-box/box-sections/hg-box-section-highlights.vue?vue&type=style&index=1&id=1fbbcb23&prod&lang=css
var hg_box_section_highlightsvue_type_style_index_1_id_1fbbcb23_prod_lang_css = __webpack_require__("b2a2");

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-highlights.vue







/* normalize component */

var hg_box_section_highlights_component = normalizeComponent(
  box_sections_hg_box_section_highlightsvue_type_script_lang_js,
  hg_box_section_highlightsvue_type_template_id_1fbbcb23_scoped_true_render,
  hg_box_section_highlightsvue_type_template_id_1fbbcb23_scoped_true_staticRenderFns,
  false,
  null,
  "1fbbcb23",
  null
  
)

/* harmony default export */ var hg_box_section_highlights = (hg_box_section_highlights_component.exports);
// CONCATENATED MODULE: ./src/components/deal-box/mixins/BasicDealBoxMixin.js








/* harmony default export */ var BasicDealBoxMixin = ({
  components: {
    HgBoxSectionReminder: hg_box_section_reminder,
    HgBoxSectionTrust: hg_box_section_trust,
    HgBoxSectionSocial: hg_box_section_social,
    HgBoxSectionHighlights: hg_box_section_highlights,
    HgDealPrice: hg_deal_price,
    HgCancellationBadge: hg_cancellation_badge,
  },
  data() {
    return {
      bestDeal: true,
      maxHighlights: 4,
      modalDealBookingOpen: false,
      expiredEmailValidMobile: false,
      expiredEmailValid: false,
      expiredEmailMobile: '',
      expiredEmail: undefined,
      currentDealPrice: {
        value: 0,
        currency: 'EUR',
        url: '',
        forwarderUrl: '',
      },
    }
  },
  props: {
    dealId: {
      type: String,
      default: undefined,
    },
    dealPriceForwarderUrl: {
      type: String,
      default: undefined,
    },
    dealPriceUrl: {
      type: String,
      default: undefined,
    },
    dealExpiryDate: {
      type: String | Date,
      default: '',
    },
    dealPriceValue: {
      type: Number,
      default: 0,
    },
    dealPriceCurrency: {
      type: String,
      default: '',
    },
    dealHighlights: {
      type: Array,
      default: () => [],
    },
    dealVouchers: {
      type: Array,
      default: () => [],
    },
    dealBookmark: {
      type: Object,
      default: () => {},
    },
    dealTypeLabel: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    dealDuration: {
      type: Number,
      default: 0,
    },
    dealDurationFrom: {
      type: Number,
      default: 0,
    },
    dealDurationTo: {
      type: Number,
      default: 0,
    },
    showPricePerDate: {
      type: Boolean,
      default: false,
    },
    roundCalendarPrices: {
      type: Boolean,
      default: false,
    },
    roundDealPrice: {
      type: Boolean,
      default: false,
    },
    dealProviderCancellationConditions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    subscribeNotification() {
      this.$emit('onNotificationSubscription', {
        email: this.expiredEmail,
        airport: this.desiredAirport,
      })
    },
    toggleDealBookingModal() {
      this.modalDealBookingOpen = !this.modalDealBookingOpen
    },
    clickDealButtonUrl(url) {
      this.$emit('onClickBookingUrl', url)
    },
    clickBookmark(e) {
      this.$emit('onClickBookmark', this.dealId)
    },
    clickShare(e) {
      this.$emit('onClickShare', this.dealId)
    },
    format: format,
    differenceInDays: differenceInDays,
    isSameDay: isSameDay,
    parseISO: parseISO,
    getFormat(date, formatString) {
      return this.format(date, formatString, { locale: de })
    },
    getDataPartner(dealUrl) {
      // retrieve base host and domain from dealUrl
      if (dealUrl) {
        const match = dealUrl.match(/^(https?:\/\/)?([a-zA-Z0-9-._~]+)/)
        // if found and if not part of the holidayguru domains and
        // https://urlaubsguru-gutschein.de/
        // https://urlaubsguru-gutschein.watado.de/
        // https://urlaubsguru.urlaubsgutschein.kaufen/
        if (
          match &&
          match.length &&
          !match[match.length - 1].match(
            /urlaubsguru\.de|urlaubsguru\.at|holidayguru\.es|holidayguru\.nl|holidayguru\.ch|urlaubsguru-gutschein\.de|urlaubsguru-gutschein\.watado\.de|urlaubsguru\.urlaubsgutschein\.kaufen/
          )
        ) {
          // return the found host and domain
          return match[match.length - 1]
        }
      }
      return null
    },
  },
  computed: {
    isExpired() {
      if (!this.dealExpiryDate) return false
      return new Date(this.dealExpiryDate) < new Date()
    },
    badges() {
      if (!this.dealProviderCancellationConditions.length) return []
      const badges = this.dealProviderCancellationConditions[0].badge.map(
        (item) => {
          return {
            tooltipContent: this.$t(`providerConditions.${item}.tooltip`),
            badgeText: this.$t(`providerConditions.${item}.badge`),
          }
        }
      )
      return badges
    },
    dealCtaClass() {
      let res = !this.isMobile && 'desktop'
      if (this.badges.length > 1) res += ' badge-buffer'
      return res
    },
    dealCtaStyle() {
      return this.badges.length > 1 ? 'padding-top: 2rem;' : ''
    },
  },
  created() {
    if (this.isMobile) {
      document.body.classList.add('extra-footer-space')
    }

    if (!this.dealPeriods) {
      this.currentDealPrice.value = this.dealPriceValue
      this.currentDealPrice.currency = this.dealPriceCurrency
      this.currentDealPrice.url = this.dealPriceUrl
      this.currentDealPrice.forwarderUrl = this.dealPriceForwarderUrl
    }
  },

  beforeDestroy() {
    document.body.classList.remove('extra-footer-space')
  },
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-basic.vue?vue&type=script&lang=js



/**
 * HG Deal Box Component for Deals of type BasicDeal
 * @displayName BasicDealBox
 */
/* harmony default export */ var hg_deal_box_basicvue_type_script_lang_js = ({
  mixins: [BasicDealBoxMixin],
  methods: {
    onChange() {
      this.expiredEmailValid = this.$refs.emailinput.isValid
    },
    clickDealButton() {
      if (this.dealPriceForwarderUrl) {
        this.$emit('onBookingUrlClick', this.dealPriceForwarderUrl)
      }
    },
  },
  mounted() {
    if (this.isExpired) {
      this.expiredEmailValid = false
    }
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-basic.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_box_hg_deal_box_basicvue_type_script_lang_js = (hg_deal_box_basicvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/hg-deal-box-basic.vue?vue&type=style&index=0&id=e2e335c6&prod&scoped=true&lang=postcss
var hg_deal_box_basicvue_type_style_index_0_id_e2e335c6_prod_scoped_true_lang_postcss = __webpack_require__("5615");

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-basic.vue






/* normalize component */

var hg_deal_box_basic_component = normalizeComponent(
  deal_box_hg_deal_box_basicvue_type_script_lang_js,
  hg_deal_box_basicvue_type_template_id_e2e335c6_scoped_true_render,
  hg_deal_box_basicvue_type_template_id_e2e335c6_scoped_true_staticRenderFns,
  false,
  null,
  "e2e335c6",
  null
  
)

/* harmony default export */ var hg_deal_box_basic = (hg_deal_box_basic_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-travel-basic.vue?vue&type=template&id=3bece8be&scoped=true
var hg_deal_box_travel_basicvue_type_template_id_3bece8be_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal-box",class:!_vm.isMobile && 'desktop'},[(!_vm.isMobile && _vm.badges.length)?_c('div',{staticClass:"deal-badge-container"},[_c('hg-cancellation-badge',{attrs:{"badges":_vm.badges}})],1):_vm._e(),_c('hg-box-section-social',{staticClass:"cta-box deal-box-social",class:!_vm.isMobile && 'desktop',attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}),_c('div',{staticClass:"cta-box deal-cta",class:_vm.dealCtaClass,style:(_vm.dealCtaStyle)},[_c('div',{staticClass:"cta price-tag",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-price',{attrs:{"teal":"","price":_vm.currentDealPrice,"perPerson":true,"rounded":_vm.roundDealPrice,"priceSize":_vm.isMobile ? '2xl' : '3xl'}})],1),(!_vm.isExpired)?_c('div',{staticClass:"cta cta-button",class:!_vm.isMobile && 'desktop'},[_c('hg-button',{staticClass:"hg-deal-button",attrs:{"type":"submit","color":"teal","size":"full","tag":"a","href":_vm.dealPriceForwarderUrl,"data-partner":_vm.getDataPartner(_vm.dealPriceUrl),"target":"_blank","rel":"noopener","disabled":_vm.isExpired},on:{"onClick":_vm.clickDealButton}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('goToDeal'))+" ")])])],1):_vm._e(),(_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.dealNumberOfAdults > 0)?_c('div',{staticClass:"cta offer-persons",class:[_vm.isExpired && 'expired', !_vm.isMobile && 'desktop']},[_vm._v(" "+_vm._s(_vm.$t('dealBox.dealIsValidFor'))+" "+_vm._s(_vm.dealNumberOfAdults)+" "+_vm._s(_vm.$t('dealBox.travelers'))+" ")]):_vm._e(),(_vm.dealVouchers.length && !_vm.isExpired)?_c('div',{staticClass:"cta deal-voucher",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-voucher',{attrs:{"vouchers":_vm.dealVouchers,"isMobile":_vm.isMobile}})],1):_vm._e(),(_vm.isExpired)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e()]),(_vm.isExpired && !_vm.isMobile)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-trust',{staticClass:"trust-usp cta-box",class:!_vm.isMobile && 'desktop'}):_vm._e(),(!_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),_c('div',{staticClass:"pointy-divider-outer",class:!_vm.isMobile && 'desktop'},[_c('div',{staticClass:"pointy-divider-inner",class:!_vm.isMobile && 'desktop'})]),(_vm.isExpired)?_c('hg-box-section-reminder',{staticClass:"reminder-box",class:!_vm.isMobile && 'desktop',attrs:{"isMobile":_vm.isMobile},scopedSlots:_vm._u([{key:"reminderEmail",fn:function(){return [_c('hg-text-input',{ref:"emailinput",attrs:{"label":"Deine E-Mail Adresse","labelPosition":"inside","placeholder":"info@example.com","validate":"","required":"","type":"email","name":"email"},on:{"input":_vm.onChange},model:{value:(_vm.expiredEmail),callback:function ($$v) {_vm.expiredEmail=$$v},expression:"expiredEmail"}})]},proxy:true},{key:"reminderSubmit",fn:function(){return [_c('div',{staticClass:"button-box"},[_c('hg-button',{attrs:{"type":"submit","color":"teal","size":"full","disabled":!_vm.expiredEmailValid},on:{"onClick":_vm.subscribeNotification}},[_vm._v(" "+_vm._s(_vm.$t('dealBox.notifyMe'))+" ")])],1)]},proxy:true}],null,false,3530167088)}):_vm._e(),(_vm.isMobile && _vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),_c('hg-box-section-highlights',{staticClass:"area",attrs:{"itemList":_vm.dealHighlights,"maxItemsToShow":_vm.maxHighlights,"isMobile":_vm.isMobile},on:{"onClickShowMoreHighlights":function($event){return _vm.$emit('onClickShowMoreHighlights')}},scopedSlots:_vm._u([{key:"social",fn:function(){return [(_vm.isMobile)?_c('hg-box-section-social',{staticClass:"deal-box-social",attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}):_vm._e()]},proxy:true}])})],1)
}
var hg_deal_box_travel_basicvue_type_template_id_3bece8be_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-travel-basic.vue?vue&type=template&id=3bece8be&scoped=true

// CONCATENATED MODULE: ./src/components/deal-box/mixins/TravelBasicDealBoxMixin.js
/* harmony default export */ var TravelBasicDealBoxMixin = ({
  props: {
    dealDuration: {
      type: Number,
      default: 0,
    },
    dealNumberOfAdults: {
      type: Number,
      default: 0,
    },
  },
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-travel-basic.vue?vue&type=script&lang=js



/**
 * HG Deal Box Component for Deals of type TravelBasicDeal
 * @displayName TravelBasicDealBox
 */
/* harmony default export */ var hg_deal_box_travel_basicvue_type_script_lang_js = ({
  mixins: [BasicDealBoxMixin, TravelBasicDealBoxMixin],

  methods: {
    onChange() {
      this.expiredEmailValid = this.$refs.emailinput.isValid
    },
    clickDealButton() {
      if (this.dealPriceForwarderUrl) {
        this.$emit('onBookingUrlClick', this.dealPriceForwarderUrl)
      }
    },
  },
  mounted() {
    if (this.isExpired) {
      this.expiredEmailValid = false
    }
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-travel-basic.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_box_hg_deal_box_travel_basicvue_type_script_lang_js = (hg_deal_box_travel_basicvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/hg-deal-box-travel-basic.vue?vue&type=style&index=0&id=3bece8be&prod&scoped=true&lang=postcss
var hg_deal_box_travel_basicvue_type_style_index_0_id_3bece8be_prod_scoped_true_lang_postcss = __webpack_require__("e292");

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-travel-basic.vue






/* normalize component */

var hg_deal_box_travel_basic_component = normalizeComponent(
  deal_box_hg_deal_box_travel_basicvue_type_script_lang_js,
  hg_deal_box_travel_basicvue_type_template_id_3bece8be_scoped_true_render,
  hg_deal_box_travel_basicvue_type_template_id_3bece8be_scoped_true_staticRenderFns,
  false,
  null,
  "3bece8be",
  null
  
)

/* harmony default export */ var hg_deal_box_travel_basic = (hg_deal_box_travel_basic_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-accommodation.vue?vue&type=template&id=688d563a&scoped=true
var hg_deal_box_accommodationvue_type_template_id_688d563a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal-box",class:!_vm.isMobile && 'desktop'},[(!_vm.isMobile && _vm.badges.length)?_c('div',{staticClass:"deal-badge-container"},[_c('hg-cancellation-badge',{attrs:{"badges":_vm.badges}})],1):_vm._e(),_c('hg-box-section-social',{staticClass:"cta-box deal-box-social",class:!_vm.isMobile && 'desktop',attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}),_c('div',{staticClass:"cta-box deal-cta",class:_vm.dealCtaClass,style:(_vm.dealCtaStyle)},[_c('div',{staticClass:"cta price-tag",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-price',{attrs:{"teal":"","price":_vm.currentDealPrice,"perPerson":true,"rounded":_vm.roundDealPrice,"priceSize":_vm.isMobile ? '2xl' : '3xl'}})],1),(!_vm.isExpired)?_c('div',{staticClass:"cta cta-button",class:!_vm.isMobile && 'desktop'},[_c('hg-button',{staticClass:"hg-deal-button",attrs:{"type":"submit","color":"teal","size":"full","tag":"a","href":_vm.currentDealPrice.forwarderUrl,"data-partner":_vm.getDataPartner(_vm.currentDealPrice.url),"target":"_blank","rel":"noopener","disabled":_vm.isExpired},on:{"onClick":_vm.clickDealButton}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('goToDeal'))+" ")])])],1):_vm._e(),(_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.dealNumberOfAdults > 0)?_c('div',{staticClass:"cta offer-persons",class:[_vm.isExpired && 'expired', !_vm.isMobile && 'desktop']},[_vm._v(" "+_vm._s(_vm.$t('dealBox.dealIsValidFor'))+" "+_vm._s(_vm.dealNumberOfAdults)+" "+_vm._s(_vm.$t('dealBox.travelers'))+" ")]):_vm._e(),(_vm.dealVouchers.length && !_vm.isExpired)?_c('div',{staticClass:"cta deal-voucher",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-voucher',{attrs:{"vouchers":_vm.dealVouchers,"isMobile":_vm.isMobile}})],1):_vm._e(),(_vm.isExpired)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e()]),(_vm.isExpired && !_vm.isMobile)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-trust',{staticClass:"trust-usp cta-box",class:!_vm.isMobile && 'desktop'}):_vm._e(),(!_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),_c('div',{staticClass:"pointy-divider-outer",class:!_vm.isMobile && 'desktop'},[_c('div',{staticClass:"pointy-divider-inner",class:!_vm.isMobile && 'desktop'})]),(_vm.isExpired)?_c('hg-box-section-reminder',{staticClass:"reminder-box",class:!_vm.isMobile && 'desktop',attrs:{"isMobile":_vm.isMobile,"currentDealPeriod":_vm.currentDealPeriod},scopedSlots:_vm._u([{key:"reminderEmail",fn:function(){return [_c('hg-text-input',{ref:"emailinput",attrs:{"label":"Deine E-Mail Adresse","labelPosition":"inside","placeholder":"info@example.com","validate":"","required":"","type":"email","name":"email"},on:{"input":_vm.onChange},model:{value:(_vm.expiredEmail),callback:function ($$v) {_vm.expiredEmail=$$v},expression:"expiredEmail"}})]},proxy:true},{key:"reminderSubmit",fn:function(){return [_c('div',{staticClass:"button-box"},[_c('hg-button',{attrs:{"type":"submit","color":"teal","size":"full","disabled":!_vm.expiredEmailValid},on:{"onClick":_vm.subscribeNotification}},[_vm._v(" "+_vm._s(_vm.$t('dealBox.notifyMe'))+" ")])],1)]},proxy:true}],null,false,3530167088)}):_vm._e(),(_vm.isMobile && _vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),_c('hg-box-section-highlights',{staticClass:"area",attrs:{"itemList":_vm.dealHighlights,"maxItemsToShow":_vm.maxHighlights,"isMobile":_vm.isMobile},on:{"onClickShowMoreHighlights":function($event){return _vm.$emit('onClickShowMoreHighlights')}},scopedSlots:_vm._u([{key:"social",fn:function(){return [(_vm.isMobile)?_c('hg-box-section-social',{staticClass:"deal-box-social",attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}):_vm._e()]},proxy:true}])}),(_vm.hasPeriods && !_vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-periods',_vm._g({staticClass:"area",attrs:{"current-deal-period":_vm.currentDealPeriod,"deal-periods":_vm.dealPeriods,"is-relative":_vm.hasRelativePeriods,"deal-duration":_vm.dealDuration,"current-period-nights":_vm.currentPeriodNights,"current-deal-price":_vm.currentDealPrice,"best-deal-period":_vm.bestDealPeriod,"best-deal":_vm.bestDeal,"deal-number-of-adults":_vm.dealNumberOfAdults,"has-more-periods":_vm.hasMorePeriods,"tagline":_vm.tagline,"is-expired":_vm.isExpired,"is-mobile":_vm.isMobile,"show-price-per-date":_vm.showPricePerDate,"round-calendar-prices":_vm.roundCalendarPrices,"round-deal-price":_vm.roundDealPrice},on:{"onSelectNewPeriod":_vm.selectNewPeriod}},_vm.$listeners)):_vm._e()],1)
}
var hg_deal_box_accommodationvue_type_template_id_688d563a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-accommodation.vue?vue&type=template&id=688d563a&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-periods.vue?vue&type=template&id=3107b8f0&scoped=true
var hg_box_section_periodsvue_type_template_id_3107b8f0_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isRelative || _vm.dealPeriods.length === 1)?_c('div',{staticClass:"deal-periods area"},[_c('div',{staticClass:"periods-heading area-heading"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.periodsHeading'))+" ")]),_c('div',{staticClass:"period-tagline"},[_vm._v(" "+_vm._s(_vm.tagline)+" ")]),(
        _vm.currentDealPeriod &&
        _vm.currentDealPeriod.period &&
        _vm.currentDealPeriod.period.startDate
      )?_c('div',{staticClass:"period-box"},[_c('HgPeriodLabel',{attrs:{"hide-top-line":"","startDate":_vm.currentDealPeriod.period.startDate,"endDate":_vm.currentDealPeriod.period.endDate}})],1):_vm._e(),(_vm.dealDuration > 0 || _vm.dealDurationFrom > 0)?_c('div',{staticClass:"period-tagline"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.stayDuration'))+" "),_c('span',{staticClass:"tw-font-bold"},[_vm._v("   "+_vm._s(_vm.dealDurationString)+" ")])]):_vm._e()]):_c('div',{staticClass:"deal-periods area"},[_c('div',{staticClass:"periods-heading area-heading"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.periodsHeading'))+" ")]),_c('div',{staticClass:"current-period"},[_c('div',{staticClass:"period-tagline"},[_vm._v(" "+_vm._s(_vm.tagline)+" ")]),_c('div',{staticClass:"period-box"},[(
            _vm.currentDealPeriod &&
            _vm.currentDealPeriod.period &&
            _vm.currentDealPeriod.period.startDate
          )?_c('div',{staticClass:"period-datepicker"},[_c('HgPeriodpicker',{attrs:{"date-format-string":"dd.MM.yy","initial-start-date":_vm.currentDealPeriod.period.startDate,"initial-end-date":_vm.currentDealPeriod.period.endDate,"valid-periods":_vm.dealPeriods,"current-deal-period":_vm.currentDealPeriod,"current-period-nights":_vm.currentPeriodNights,"current-period-possible-airports":_vm.currentPeriodPossibleAirports,"current-deal-price":_vm.currentDealPrice,"best-deal-period":_vm.bestDealPeriod,"deal-number-of-adults":_vm.dealNumberOfAdults,"disabled":_vm.isExpired || !_vm.hasMorePeriods,"isMobile":_vm.isMobile,"show-price-per-date":_vm.showPricePerDate,"round-calendar-prices":_vm.roundCalendarPrices,"round-deal-price":_vm.roundDealPrice},on:{"onDateRangeSelect":_vm.selectNewPeriod,"onUpdateMonth":_vm.$parent.updateMonth},scopedSlots:_vm._u([{key:"inputOverlay",fn:function(){return [_c('HgPeriodLabel',{attrs:{"startDate":_vm.currentDealPeriod.period.startDate,"endDate":_vm.currentDealPeriod.period.endDate}})]},proxy:true}],null,false,2102423026)})],1):_vm._e()])])])])
}
var hg_box_section_periodsvue_type_template_id_3107b8f0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-periods.vue?vue&type=template&id=3107b8f0&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-periods.vue?vue&type=script&lang=js



/* harmony default export */ var hg_box_section_periodsvue_type_script_lang_js = ({
  props: {
    isRelative: {
      type: Boolean,
      default: false,
    },
    currentDealPeriod: {
      type: Object,
      default: () => {},
    },
    isExpired: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    hasMorePeriods: {
      type: Boolean,
      default: false,
    },
    dealDuration: {
      type: Number,
      default: 0,
    },
    dealDurationTo: {
      type: Number,
      default: 0,
    },
    dealDurationFrom: {
      type: Number,
      default: 0,
    },
    bestDeal: {
      type: Boolean,
      default: false,
    },
    showPricePerDate: {
      type: Boolean,
      default: false,
    },
    roundCalendarPrices: {
      type: Boolean,
      default: false,
    },
    roundDealPrice: {
      type: Boolean,
      default: false,
    },
    dealPeriods: {
      type: Array,
      default: () => [],
    },
    currentPeriodNights: {
      type: Number,
      default: 0,
    },
    currentPeriodPossibleAirports: {
      type: Array,
      default: () => [],
    },
    dealNumberOfAdults: {
      type: Number,
      default: 0,
    },
    currentDealPrice: {
      type: Object,
      default: () => {},
    },
    bestDealPeriod: {
      type: Object,
      default: () => {},
    },
    tagline: {
      type: String,
      default: '',
    },
  },
  computed: {
    dealDurationString() {
      let res = ''
      if (this.dealDuration !== 0) {
        res = `${this.dealDuration} ${
          this.dealDuration === 1 ? this.$t('night') : this.$t('nights')
        }`
      } else {
        res =
          this.dealDurationFrom === this.dealDurationTo
            ? `${this.dealDurationFrom} ${this.$t('night')}`
            : `${this.dealDurationTo} - ${this.dealDurationFrom} ${this.$t(
                'nights'
              )}`
      }
      return res
    },
  },
  methods: {
    selectNewPeriod(e) {
      this.$emit('onSelectNewPeriod', e)
    },
    format: format,
    getFormat(date, formatString) {
      return this.format(date, formatString, { locale: de })
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-periods.vue?vue&type=script&lang=js
 /* harmony default export */ var box_sections_hg_box_section_periodsvue_type_script_lang_js = (hg_box_section_periodsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/box-sections/hg-box-section-periods.vue?vue&type=style&index=0&id=3107b8f0&prod&lang=postcss&scoped=true
var hg_box_section_periodsvue_type_style_index_0_id_3107b8f0_prod_lang_postcss_scoped_true = __webpack_require__("3f99");

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-periods.vue






/* normalize component */

var hg_box_section_periods_component = normalizeComponent(
  box_sections_hg_box_section_periodsvue_type_script_lang_js,
  hg_box_section_periodsvue_type_template_id_3107b8f0_scoped_true_render,
  hg_box_section_periodsvue_type_template_id_3107b8f0_scoped_true_staticRenderFns,
  false,
  null,
  "3107b8f0",
  null
  
)

/* harmony default export */ var hg_box_section_periods = (hg_box_section_periods_component.exports);
// CONCATENATED MODULE: ./src/components/deal-box/mixins/AccommodationDealBoxMixin.js



/* harmony default export */ var AccommodationDealBoxMixin = ({
  components: { HgBoxSectionPeriods: hg_box_section_periods },
  data() {
    return {
      currentDealPeriod: {
        type: Object,
        default: () => {},
      },
      currentPeriodNights: 0,
      tagline: this.$t('dealBox.periodsTaglineCheapest'),
      bestDeal: true,
    }
  },
  props: {
    dealPeriods: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    selectNewPeriod(e) {
      this.$emit('onSelectPeriod', e.period)
      this.currentDealPeriod = e.period
    },
    updateMonth({ startDate, endDate }) {
      this.$emit('onUpdateMonth', {
        startDate,
        endDate,
      })
    },
  },
  computed: {
    hasPeriods() {
      return this.dealPeriods.length > 0
    },
    dealRelativePeriods() {
      return this.dealPeriods.filter((period) => period.relative)
    },
    hasRelativePeriods() {
      return this.dealRelativePeriods.length > 0
    },
    hasMorePeriods() {
      return this.dealPeriods.length > 1
    },
    bestDealPeriod() {
      if (!this.dealPeriods || !this.dealPeriods.length) return {}
      if (this.hasRelativePeriods) {
        const periodsToCheck = this.dealRelativePeriods

        const current = {
          period: periodsToCheck[0],
          mainPeriod: undefined,
        }
        periodsToCheck[0].periodPrice = periodsToCheck[0].price
        if (periodsToCheck.length > 1) {
          periodsToCheck.forEach((period) => {
            period.periodPrice = period.price
            if (period.main) current.mainPeriod = period
            if (period.price.value < current.period.price.value) {
              current.period = period
            }
          })
        }

        return current.mainPeriod ? current.mainPeriod : current.period
      }

      const periodsToCheck = this.dealPeriods

      const current = {
        period: periodsToCheck[0],
        mainPeriod: undefined,
      }
      periodsToCheck[0].periodPrice = periodsToCheck[0].price
      if (periodsToCheck.length > 1) {
        periodsToCheck.forEach((period) => {
          period.periodPrice = period.price
          if (period.main) current.mainPeriod = period
          if (period.price.value < current.period.price.value) {
            current.period = period
          }
        })
      }

      return current.mainPeriod &&
        isAfter(parseISO(current.mainPeriod.period.startDate), new Date())
        ? current.mainPeriod
        : current.period
    },
  },
  watch: {
    bestDeal: function (newBestDeal, oldBestDeal) {
      this.tagline = newBestDeal
        ? this.$t('dealBox.periodsTaglineCheapest')
        : this.$t('dealBox.periodsTaglineDefault')
    },
    currentDealPeriod: function (newCurrentDealPeriod, oldCurrentDealPeriod) {
      if (!newCurrentDealPeriod || !newCurrentDealPeriod.id) return
      this.bestDeal = newCurrentDealPeriod === this.bestDealPeriod
      this.currentDealPrice = newCurrentDealPeriod.price
      this.currentPeriodNights = this.differenceInDays(
        new Date(newCurrentDealPeriod.period.endDate),
        new Date(newCurrentDealPeriod.period.startDate)
      )
    },
  },
  created() {
    // set current Period to the best Deal possible
    this.currentDealPeriod =
      !this.dealPeriods || !this.dealPeriods.length ? {} : this.bestDealPeriod
    if (this.isMobile) document.body.classList.add('extra-footer-space')
  },
  beforeDestroy() {
    document.body.classList.remove('extra-footer-space')
  },
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-accommodation.vue?vue&type=script&lang=js



/**
 * HG Deal Box Component for Deals of type HOTEL
 * @displayName DealBoxHotel
 */
/* harmony default export */ var hg_deal_box_accommodationvue_type_script_lang_js = ({
  mixins: [
    BasicDealBoxMixin,
    TravelBasicDealBoxMixin,
    AccommodationDealBoxMixin,
  ],
  methods: {
    onChange() {
      this.expiredEmailValid = this.$refs.emailinput.isValid
    },
    clickDealButton() {
      if (this.currentDealPrice.forwarderUrl) {
        this.$emit('onBookingUrlClick', this.currentDealPrice.forwarderUrl)
      }
    },
  },
  mounted() {
    if (this.isExpired) {
      this.expiredEmailValid = false
    }
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-accommodation.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_box_hg_deal_box_accommodationvue_type_script_lang_js = (hg_deal_box_accommodationvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/hg-deal-box-accommodation.vue?vue&type=style&index=0&id=688d563a&prod&scoped=true&lang=postcss
var hg_deal_box_accommodationvue_type_style_index_0_id_688d563a_prod_scoped_true_lang_postcss = __webpack_require__("5fe6");

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-accommodation.vue






/* normalize component */

var hg_deal_box_accommodation_component = normalizeComponent(
  deal_box_hg_deal_box_accommodationvue_type_script_lang_js,
  hg_deal_box_accommodationvue_type_template_id_688d563a_scoped_true_render,
  hg_deal_box_accommodationvue_type_template_id_688d563a_scoped_true_staticRenderFns,
  false,
  null,
  "688d563a",
  null
  
)

/* harmony default export */ var hg_deal_box_accommodation = (hg_deal_box_accommodation_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-flight.vue?vue&type=template&id=3bffadc2&scoped=true
var hg_deal_box_flightvue_type_template_id_3bffadc2_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal-box",class:!_vm.isMobile && 'desktop'},[(!_vm.isMobile && _vm.badges.length)?_c('div',{staticClass:"deal-badge-container"},[_c('hg-cancellation-badge',{attrs:{"badges":_vm.badges}})],1):_vm._e(),_c('hg-box-section-social',{staticClass:"cta-box deal-box-social",class:!_vm.isMobile && 'desktop',attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}),_c('div',{staticClass:"cta-box deal-cta",class:_vm.dealCtaClass,style:(_vm.dealCtaStyle)},[_c('div',{staticClass:"cta price-tag",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-price',{attrs:{"teal":"","price":_vm.currentDealPrice,"perPerson":true,"rounded":_vm.roundDealPrice,"priceSize":_vm.isMobile ? '2xl' : '3xl'}})],1),(!_vm.isExpired)?_c('div',{staticClass:"cta cta-button",class:!_vm.isMobile && 'desktop'},[_c('hg-button',{staticClass:"hg-deal-button",attrs:{"type":"submit","color":"teal","size":"full","tag":"a","href":_vm.currentDealPrice.forwarderUrl,"data-partner":_vm.getDataPartner(_vm.currentDealPrice.url),"target":"_blank","rel":"noopener","disabled":_vm.isExpired},on:{"onClick":_vm.clickDealButton}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('goToDeal'))+" ")])])],1):_vm._e(),(_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.dealVouchers.length && !_vm.isExpired)?_c('div',{staticClass:"cta deal-voucher",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-voucher',{attrs:{"vouchers":_vm.dealVouchers,"isMobile":_vm.isMobile}})],1):_vm._e(),(_vm.isExpired)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e()]),(_vm.isExpired && !_vm.isMobile)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-trust',{staticClass:"trust-usp cta-box",class:!_vm.isMobile && 'desktop'}):_vm._e(),(!_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),_c('div',{staticClass:"pointy-divider-outer",class:!_vm.isMobile && 'desktop'},[_c('div',{staticClass:"pointy-divider-inner",class:!_vm.isMobile && 'desktop'})]),(_vm.isExpired)?_c('hg-box-section-reminder',{staticClass:"reminder-box",class:!_vm.isMobile && 'desktop',attrs:{"isMobile":_vm.isMobile,"currentPeriod":_vm.currentDealPeriod},scopedSlots:_vm._u([{key:"reminderEmail",fn:function(){return [_c('hg-text-input',{ref:"emailinput",attrs:{"label":"Deine E-Mail Adresse","labelPosition":"inside","placeholder":"info@example.com","validate":"","required":"","type":"email","name":"email"},on:{"input":_vm.onChange},model:{value:(_vm.expiredEmail),callback:function ($$v) {_vm.expiredEmail=$$v},expression:"expiredEmail"}})]},proxy:true},{key:"reminderSubmit",fn:function(){return [_c('div',{staticClass:"button-box"},[_c('hg-button',{attrs:{"type":"submit","color":"teal","size":"full","disabled":!_vm.expiredEmailValid},on:{"onClick":_vm.subscribeNotification}},[_vm._v(" "+_vm._s(_vm.$t('dealBox.notifyMe'))+" ")])],1)]},proxy:true}],null,false,3530167088)}):_vm._e(),(_vm.isMobile && _vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),_c('hg-box-section-highlights',{staticClass:"area",attrs:{"itemList":_vm.dealHighlights,"maxItemsToShow":_vm.maxHighlights,"isMobile":_vm.isMobile},on:{"onClickShowMoreHighlights":function($event){return _vm.$emit('onClickShowMoreHighlights')}},scopedSlots:_vm._u([{key:"social",fn:function(){return [(_vm.isMobile)?_c('hg-box-section-social',{staticClass:"deal-box-social",attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}):_vm._e()]},proxy:true}])}),(_vm.hasPeriods && !_vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-periods',_vm._g({staticClass:"area",attrs:{"current-deal-period":_vm.currentDealPeriod,"deal-periods":_vm.dealPeriods,"is-relative":_vm.hasRelativePeriods,"deal-duration":_vm.dealDuration,"current-period-nights":_vm.currentPeriodNights,"current-period-possible-airports":_vm.currentPeriodPossibleAirports,"current-deal-price":_vm.currentDealPrice,"best-deal-period":_vm.bestDealPeriod,"best-deal":_vm.bestDeal,"has-more-periods":_vm.hasMorePeriods,"tagline":_vm.tagline,"is-expired":_vm.isExpired,"is-mobile":_vm.isMobile,"show-price-per-date":_vm.showPricePerDate,"round-calendar-prices":_vm.roundCalendarPrices,"round-deal-price":_vm.roundDealPrice},on:{"onSelectNewPeriod":_vm.selectNewPeriod}},_vm.$listeners)):_vm._e(),(_vm.hasFlights && !_vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.hasFlights && !_vm.isExpired)?_c('hg-box-section-flights',_vm._g({attrs:{"currentDealPeriod":_vm.currentDealPeriod,"currentAirport":_vm.currentAirport,"currentPeriodPossibleAirports":_vm.currentPeriodPossibleAirports}},_vm.$listeners)):_vm._e()],1)
}
var hg_deal_box_flightvue_type_template_id_3bffadc2_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-flight.vue?vue&type=template&id=3bffadc2&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-flights.vue?vue&type=template&id=5eefb2d4&scoped=true
var hg_box_section_flightsvue_type_template_id_5eefb2d4_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"period-flights area"},[_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"flights-heading area-heading"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.flight'))+" ")]),_c('div',{staticClass:"airline-container"},[_c('span',{staticClass:"airline-label"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.airline'))+" ")]),_c('span',{staticClass:"airline"},[_vm._v(_vm._s(_vm.currentDealPeriod.flight.airline))])])]),(_vm.currentPeriodPossibleAirports.length > 1)?_c('hg-select',{staticClass:"departure-select",attrs:{"value":_vm.currentAirport,"displayProperty":"name","options":_vm.currentPeriodPossibleAirports,"placeholder":_vm.$t('dealBox.departureSelectPlaceholder'),"label":_vm.$t('dealBox.departureSelectLabel'),"disabled":_vm.currentPeriodPossibleAirports.length <= 1},on:{"change":_vm.$parent.setCurrentAirport}}):_c('div',{staticClass:"departure-info"},[_c('div',{staticClass:"departure-info__label"},[_vm._v(_vm._s(_vm.$t('dealBox.departureFrom')))]),_c('div',{staticClass:"departure-info__airport"},[_vm._v(_vm._s(_vm.currentAirport.name))])])],1)
}
var hg_box_section_flightsvue_type_template_id_5eefb2d4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-flights.vue?vue&type=template&id=5eefb2d4&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/box-sections/hg-box-section-flights.vue?vue&type=script&lang=js

/* harmony default export */ var hg_box_section_flightsvue_type_script_lang_js = ({
  props: {
    currentDealPeriod: {
      type: Object,
      default: () => {},
    },
    currentAirport: {
      type: Object,
      default: () => {},
    },
    currentPeriodPossibleAirports: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {},
});

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-flights.vue?vue&type=script&lang=js
 /* harmony default export */ var box_sections_hg_box_section_flightsvue_type_script_lang_js = (hg_box_section_flightsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/box-sections/hg-box-section-flights.vue?vue&type=style&index=0&id=5eefb2d4&prod&lang=postcss&scoped=true
var hg_box_section_flightsvue_type_style_index_0_id_5eefb2d4_prod_lang_postcss_scoped_true = __webpack_require__("f7d9");

// CONCATENATED MODULE: ./src/components/deal-box/box-sections/hg-box-section-flights.vue






/* normalize component */

var hg_box_section_flights_component = normalizeComponent(
  box_sections_hg_box_section_flightsvue_type_script_lang_js,
  hg_box_section_flightsvue_type_template_id_5eefb2d4_scoped_true_render,
  hg_box_section_flightsvue_type_template_id_5eefb2d4_scoped_true_staticRenderFns,
  false,
  null,
  "5eefb2d4",
  null
  
)

/* harmony default export */ var hg_box_section_flights = (hg_box_section_flights_component.exports);
// CONCATENATED MODULE: ./src/components/deal-box/mixins/FlightDealBoxMixin.js


/* harmony default export */ var FlightDealBoxMixin = ({
  components: { HgBoxSectionFlights: hg_box_section_flights },
  data() {
    return {
      desiredAirport: '',
      currentAirport: {
        type: Object,
        default: () => {},
      },
      currentFlight: {
        type: Object,
        default: () => {},
      },
    }
  },
  props: {},
  methods: {
    getBestFlight() {},
    setCurrentAirport(e) {
      this.$emit('onSelectAirport', e)
      this.currentAirport = e
      this.currentDealPeriod = e.belongsToPeriod
    },
  },
  computed: {
    hasFlights() {
      return this.currentDealPeriod && this.currentDealPeriod.flight
        ? true
        : false
    },
    allDealDepartureAirports() {
      let result = []

      for (let i = 0; i < this.dealPeriods.length; i++) {
        result.push(this.dealPeriods[i].flight.departureAirport)
      }
      return result
    },
    currentPeriodPossibleAirports() {
      let result = []
      for (let i = 0; i < this.dealPeriods.length; i++) {
        this.dealPeriods[i].flight.departureAirport.belongsToPeriod =
          this.dealPeriods[i]
        if (
          this.currentDealPeriod &&
          this.dealPeriods[i] === this.currentDealPeriod
        ) {
          result.push(this.dealPeriods[i].flight.departureAirport)
        } else if (
          this.currentDealPeriod &&
          this.isSameDay(
            this.parseISO(this.dealPeriods[i].period.startDate),
            this.parseISO(this.currentDealPeriod.period.startDate)
          ) &&
          this.isSameDay(
            this.parseISO(this.dealPeriods[i].period.endDate),
            this.parseISO(this.currentDealPeriod.period.endDate)
          )
        ) {
          result.push(this.dealPeriods[i].flight.departureAirport)
        }
      }
      return result
    },
  },

  watch: {
    currentDealPeriod: function (newCurrentDealPeriod, oldCurrentDealPeriod) {
      if (!newCurrentDealPeriod || !newCurrentDealPeriod.period) return
      this.bestDeal = newCurrentDealPeriod === this.bestDealPeriod
      this.currentDealPrice = newCurrentDealPeriod.price
      this.currentPeriodNights = this.differenceInDays(
        new Date(newCurrentDealPeriod.period.endDate),
        new Date(newCurrentDealPeriod.period.startDate)
      )
      this.currentAirport = this.currentDealPeriod.flight.departureAirport
    },
  },

  created() {
    this.currentAirport =
      this.currentDealPeriod && this.currentDealPeriod.flight
        ? this.currentDealPeriod.flight.departureAirport
        : {}
  },
  beforeDestroy() {},
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-flight.vue?vue&type=script&lang=js



/**
 * HG Deal Box Component for Deals of type Flight
 * @displayName DealBoxFlight
 */
/* harmony default export */ var hg_deal_box_flightvue_type_script_lang_js = ({
  name: 'HgDealBoxFlight',
  mixins: [
    BasicDealBoxMixin,
    TravelBasicDealBoxMixin,
    AccommodationDealBoxMixin,
    FlightDealBoxMixin,
  ],
  methods: {
    onChange() {
      this.expiredEmailValid = this.$refs.emailinput.isValid
    },
    clickDealButton() {
      if (this.currentDealPrice.forwarderUrl) {
        this.$emit('onBookingUrlClick', this.currentDealPrice.forwarderUrl)
      }
    },
  },
  mounted() {
    if (this.isExpired) {
      this.expiredEmailValid = false
    }
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-flight.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_box_hg_deal_box_flightvue_type_script_lang_js = (hg_deal_box_flightvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/hg-deal-box-flight.vue?vue&type=style&index=0&id=3bffadc2&prod&scoped=true&lang=postcss
var hg_deal_box_flightvue_type_style_index_0_id_3bffadc2_prod_scoped_true_lang_postcss = __webpack_require__("9e52");

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-flight.vue






/* normalize component */

var hg_deal_box_flight_component = normalizeComponent(
  deal_box_hg_deal_box_flightvue_type_script_lang_js,
  hg_deal_box_flightvue_type_template_id_3bffadc2_scoped_true_render,
  hg_deal_box_flightvue_type_template_id_3bffadc2_scoped_true_staticRenderFns,
  false,
  null,
  "3bffadc2",
  null
  
)

/* harmony default export */ var hg_deal_box_flight = (hg_deal_box_flight_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-package-tour.vue?vue&type=template&id=9869dcba&scoped=true
var hg_deal_box_package_tourvue_type_template_id_9869dcba_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal-box",class:!_vm.isMobile && 'desktop'},[(!_vm.isMobile && _vm.badges.length)?_c('div',{staticClass:"deal-badge-container"},[_c('hg-cancellation-badge',{attrs:{"badges":_vm.badges}})],1):_vm._e(),_c('hg-box-section-social',{staticClass:"cta-box deal-box-social",class:!_vm.isMobile && 'desktop',attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}),_c('div',{staticClass:"cta-box deal-cta",class:_vm.dealCtaClass,style:(_vm.dealCtaStyle)},[_c('div',{staticClass:"cta price-tag",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-price',{attrs:{"teal":"","price":_vm.currentDealPrice,"perPerson":true,"rounded":_vm.roundDealPrice,"priceSize":_vm.isMobile ? '2xl' : '3xl'}})],1),(!_vm.isExpired)?_c('div',{staticClass:"cta cta-button",class:!_vm.isMobile && 'desktop'},[_c('hg-button',{staticClass:"hg-deal-button",attrs:{"type":"submit","color":"teal","size":"full","tag":"a","href":_vm.currentDealPrice.forwarderUrl,"data-partner":_vm.getDataPartner(_vm.currentDealPrice.url),"target":"_blank","rel":"noopener","disabled":_vm.isExpired},on:{"onClick":_vm.clickDealButton}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('goToDeal'))+" ")])])],1):_vm._e(),(_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.dealNumberOfAdults > 0)?_c('div',{staticClass:"cta offer-persons",class:[_vm.isExpired && 'expired', !_vm.isMobile && 'desktop']},[_vm._v(" "+_vm._s(_vm.$t('dealBox.dealIsValidFor'))+" "+_vm._s(_vm.dealNumberOfAdults)+" "+_vm._s(_vm.$t('dealBox.travelers'))+" ")]):_vm._e(),(_vm.dealVouchers.length && !_vm.isExpired)?_c('div',{staticClass:"cta deal-voucher",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-voucher',{attrs:{"vouchers":_vm.dealVouchers,"isMobile":_vm.isMobile}})],1):_vm._e(),(_vm.isExpired)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e()]),(_vm.isExpired && !_vm.isMobile)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-trust',{staticClass:"trust-usp cta-box",class:!_vm.isMobile && 'desktop'}):_vm._e(),(!_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),_c('div',{staticClass:"pointy-divider-outer",class:!_vm.isMobile && 'desktop'},[_c('div',{staticClass:"pointy-divider-inner",class:!_vm.isMobile && 'desktop'})]),(_vm.isExpired)?_c('hg-box-section-reminder',{staticClass:"reminder-box",class:!_vm.isMobile && 'desktop',attrs:{"isMobile":_vm.isMobile,"currentPeriod":_vm.currentDealPeriod},scopedSlots:_vm._u([{key:"reminderEmail",fn:function(){return [_c('hg-text-input',{ref:"emailinput",attrs:{"label":"Deine E-Mail Adresse","labelPosition":"inside","placeholder":"info@example.com","validate":"","required":"","type":"email","name":"email"},on:{"input":_vm.onChange},model:{value:(_vm.expiredEmail),callback:function ($$v) {_vm.expiredEmail=$$v},expression:"expiredEmail"}})]},proxy:true},{key:"reminderSubmit",fn:function(){return [_c('div',{staticClass:"button-box"},[_c('hg-button',{attrs:{"type":"submit","color":"teal","size":"full","disabled":!_vm.expiredEmailValid},on:{"onClick":_vm.subscribeNotification}},[_vm._v(" "+_vm._s(_vm.$t('dealBox.notifyMe'))+" ")])],1)]},proxy:true}],null,false,3530167088)}):_vm._e(),(_vm.isMobile && _vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),_c('hg-box-section-highlights',{staticClass:"area",attrs:{"itemList":_vm.dealHighlights,"maxItemsToShow":_vm.maxHighlights,"isMobile":_vm.isMobile},on:{"onClickShowMoreHighlights":function($event){return _vm.$emit('onClickShowMoreHighlights')}},scopedSlots:_vm._u([{key:"social",fn:function(){return [(_vm.isMobile)?_c('hg-box-section-social',{staticClass:"deal-box-social",attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}):_vm._e()]},proxy:true}])}),(_vm.hasPeriods && !_vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-periods',_vm._g({staticClass:"area",attrs:{"current-deal-period":_vm.currentDealPeriod,"deal-periods":_vm.dealPeriods,"is-relative":_vm.hasRelativePeriods,"deal-duration":_vm.dealDuration,"current-period-nights":_vm.currentPeriodNights,"current-period-possible-airports":_vm.currentPeriodPossibleAirports,"current-deal-price":_vm.currentDealPrice,"best-deal-period":_vm.bestDealPeriod,"best-deal":_vm.bestDeal,"has-more-periods":_vm.hasMorePeriods,"tagline":_vm.tagline,"is-expired":_vm.isExpired,"is-mobile":_vm.isMobile,"show-price-per-date":_vm.showPricePerDate,"round-calendar-prices":_vm.roundCalendarPrices,"round-deal-price":_vm.roundDealPrice},on:{"onSelectNewPeriod":_vm.selectNewPeriod}},_vm.$listeners)):_vm._e(),(_vm.hasFlights && !_vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.hasFlights && !_vm.isExpired)?_c('hg-box-section-flights',{attrs:{"currentDealPeriod":_vm.currentDealPeriod,"currentAirport":_vm.currentAirport,"currentPeriodPossibleAirports":_vm.currentPeriodPossibleAirports}}):_vm._e()],1)
}
var hg_deal_box_package_tourvue_type_template_id_9869dcba_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-package-tour.vue?vue&type=template&id=9869dcba&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-package-tour.vue?vue&type=script&lang=js



/**
 * HG Deal Box Component for Deals of type PackageTour
 * @displayName DealBoxPackageTour
 */
/* harmony default export */ var hg_deal_box_package_tourvue_type_script_lang_js = ({
  name: 'HgDealBoxPackageTour',
  mixins: [
    BasicDealBoxMixin,
    TravelBasicDealBoxMixin,
    AccommodationDealBoxMixin,
    FlightDealBoxMixin,
  ],
  methods: {
    onChange() {
      this.expiredEmailValid = this.$refs.emailinput.isValid
    },
    clickDealButton() {
      if (this.currentDealPrice.forwarderUrl) {
        this.$emit('onBookingUrlClick', this.currentDealPrice.forwarderUrl)
      }
    },
  },
  mounted() {
    if (this.isExpired) {
      this.expiredEmailValid = false
    }
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-package-tour.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_box_hg_deal_box_package_tourvue_type_script_lang_js = (hg_deal_box_package_tourvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/hg-deal-box-package-tour.vue?vue&type=style&index=0&id=9869dcba&prod&scoped=true&lang=postcss
var hg_deal_box_package_tourvue_type_style_index_0_id_9869dcba_prod_scoped_true_lang_postcss = __webpack_require__("cbc5");

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-package-tour.vue






/* normalize component */

var hg_deal_box_package_tour_component = normalizeComponent(
  deal_box_hg_deal_box_package_tourvue_type_script_lang_js,
  hg_deal_box_package_tourvue_type_template_id_9869dcba_scoped_true_render,
  hg_deal_box_package_tourvue_type_template_id_9869dcba_scoped_true_staticRenderFns,
  false,
  null,
  "9869dcba",
  null
  
)

/* harmony default export */ var hg_deal_box_package_tour = (hg_deal_box_package_tour_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-amadeus-package-tour.vue?vue&type=template&id=b90654a0&scoped=true
var hg_deal_box_amadeus_package_tourvue_type_template_id_b90654a0_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal-box",class:!_vm.isMobile && 'desktop'},[(!_vm.isMobile && _vm.badges.length)?_c('div',{staticClass:"deal-badge-container"},[_c('hg-cancellation-badge',{attrs:{"badges":_vm.badges}})],1):_vm._e(),_c('hg-box-section-social',{staticClass:"cta-box deal-box-social",class:!_vm.isMobile && 'desktop',attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}),_c('div',{staticClass:"cta-box deal-cta",class:_vm.dealCtaClass,style:(_vm.dealCtaStyle)},[_c('div',{staticClass:"cta price-tag",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-price',{attrs:{"teal":"","price":_vm.currentDealPrice,"perPerson":true,"rounded":_vm.roundDealPrice,"priceSize":_vm.isMobile ? '2xl' : '3xl'}})],1),(!_vm.isExpired)?_c('div',{staticClass:"cta cta-button",class:!_vm.isMobile && 'desktop'},[_c('hg-button',{staticClass:"hg-deal-button",attrs:{"type":"submit","color":"teal","size":"full","tag":"a","href":_vm.currentDealPrice.forwarderUrl,"data-partner":_vm.getDataPartner(_vm.currentDealPrice.url),"target":"_blank","rel":"noopener","disabled":_vm.isExpired},on:{"onClick":_vm.clickDealButton}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('goToDeal'))+" ")])])],1):_vm._e(),(_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.dealNumberOfAdults > 0)?_c('div',{staticClass:"cta offer-persons",class:[_vm.isExpired && 'expired', !_vm.isMobile && 'desktop']},[_vm._v(" "+_vm._s(_vm.$t('dealBox.dealIsValidFor'))+" "+_vm._s(_vm.dealNumberOfAdults)+" "+_vm._s(_vm.$t('dealBox.travelers'))+" ")]):_vm._e(),(_vm.dealVouchers.length && !_vm.isExpired)?_c('div',{staticClass:"cta deal-voucher",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-voucher',{attrs:{"vouchers":_vm.dealVouchers,"isMobile":_vm.isMobile}})],1):_vm._e(),(_vm.isExpired)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e()]),(_vm.isExpired && !_vm.isMobile)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-trust',{staticClass:"trust-usp cta-box",class:!_vm.isMobile && 'desktop'}):_vm._e(),(!_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),_c('div',{staticClass:"pointy-divider-outer",class:!_vm.isMobile && 'desktop'},[_c('div',{staticClass:"pointy-divider-inner",class:!_vm.isMobile && 'desktop'})]),(_vm.isExpired)?_c('hg-box-section-reminder',{staticClass:"reminder-box",class:!_vm.isMobile && 'desktop',attrs:{"isMobile":_vm.isMobile,"currentPeriod":_vm.currentDealPeriod},scopedSlots:_vm._u([{key:"reminderEmail",fn:function(){return [_c('hg-text-input',{ref:"emailinput",attrs:{"label":"Deine E-Mail Adresse","labelPosition":"inside","placeholder":"info@example.com","validate":"","required":"","type":"email","name":"email"},on:{"input":_vm.onChange},model:{value:(_vm.expiredEmail),callback:function ($$v) {_vm.expiredEmail=$$v},expression:"expiredEmail"}})]},proxy:true},{key:"reminderSubmit",fn:function(){return [_c('div',{staticClass:"button-box"},[_c('hg-button',{attrs:{"type":"submit","color":"teal","size":"full","disabled":!_vm.expiredEmailValid},on:{"onClick":_vm.subscribeNotification}},[_vm._v(" "+_vm._s(_vm.$t('dealBox.notifyMe'))+" ")])],1)]},proxy:true}],null,false,3530167088)}):_vm._e(),(_vm.isMobile && _vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),_c('hg-box-section-highlights',{staticClass:"area",attrs:{"itemList":_vm.dealHighlights,"maxItemsToShow":_vm.maxHighlights,"isMobile":_vm.isMobile},on:{"onClickShowMoreHighlights":function($event){return _vm.$emit('onClickShowMoreHighlights')}},scopedSlots:_vm._u([{key:"social",fn:function(){return [(_vm.isMobile)?_c('hg-box-section-social',{staticClass:"deal-box-social",attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}):_vm._e()]},proxy:true}])}),(_vm.hasPeriods && !_vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-periods',_vm._g({staticClass:"area",attrs:{"current-deal-period":_vm.currentDealPeriod,"deal-periods":_vm.dealPeriods,"is-relative":_vm.hasRelativePeriods,"deal-duration-to":_vm.dealDurationTo,"deal-duration-from":_vm.dealDurationFrom,"current-period-nights":_vm.currentPeriodNights,"current-period-possible-airports":_vm.currentPeriodPossibleAirports,"current-deal-price":_vm.currentDealPrice,"best-deal-period":_vm.bestDealPeriod,"best-deal":_vm.bestDeal,"has-more-periods":_vm.hasMorePeriods,"tagline":_vm.tagline,"is-expired":_vm.isExpired,"is-mobile":_vm.isMobile,"show-price-per-date":_vm.showPricePerDate,"round-calendar-prices":_vm.roundCalendarPrices,"round-deal-price":_vm.roundDealPrice},on:{"onSelectNewPeriod":_vm.selectNewPeriod}},_vm.$listeners)):_vm._e(),(_vm.hasFlights && !_vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.hasFlights && !_vm.isExpired)?_c('hg-box-section-flights',{attrs:{"currentDealPeriod":_vm.currentDealPeriod,"currentAirport":_vm.currentAirport,"currentPeriodPossibleAirports":_vm.currentPeriodPossibleAirports}}):_vm._e()],1)
}
var hg_deal_box_amadeus_package_tourvue_type_template_id_b90654a0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-amadeus-package-tour.vue?vue&type=template&id=b90654a0&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-amadeus-package-tour.vue?vue&type=script&lang=js



/**
 * HG Deal Box Component for Deals of type PackageTour
 * @displayName DealBoxPackageTour
 */
/* harmony default export */ var hg_deal_box_amadeus_package_tourvue_type_script_lang_js = ({
  name: 'HgDealBoxAmadeusPackageTour',
  mixins: [
    BasicDealBoxMixin,
    TravelBasicDealBoxMixin,
    AccommodationDealBoxMixin,
    FlightDealBoxMixin,
  ],

  methods: {
    onChange() {
      this.expiredEmailValid = this.$refs.emailinput.isValid
    },
    clickDealButton() {
      if (this.currentDealPrice.forwarderUrl) {
        this.$emit('onBookingUrlClick', this.currentDealPrice.forwarderUrl)
      }
    },
  },
  mounted() {
    if (this.isExpired) {
      this.expiredEmailValid = false
    }
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-amadeus-package-tour.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_box_hg_deal_box_amadeus_package_tourvue_type_script_lang_js = (hg_deal_box_amadeus_package_tourvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/hg-deal-box-amadeus-package-tour.vue?vue&type=style&index=0&id=b90654a0&prod&scoped=true&lang=postcss
var hg_deal_box_amadeus_package_tourvue_type_style_index_0_id_b90654a0_prod_scoped_true_lang_postcss = __webpack_require__("9ee2");

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-amadeus-package-tour.vue






/* normalize component */

var hg_deal_box_amadeus_package_tour_component = normalizeComponent(
  deal_box_hg_deal_box_amadeus_package_tourvue_type_script_lang_js,
  hg_deal_box_amadeus_package_tourvue_type_template_id_b90654a0_scoped_true_render,
  hg_deal_box_amadeus_package_tourvue_type_template_id_b90654a0_scoped_true_staticRenderFns,
  false,
  null,
  "b90654a0",
  null
  
)

/* harmony default export */ var hg_deal_box_amadeus_package_tour = (hg_deal_box_amadeus_package_tour_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-travel-combination.vue?vue&type=template&id=3149169c&scoped=true
var hg_deal_box_travel_combinationvue_type_template_id_3149169c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal-box",class:!_vm.isMobile && 'desktop'},[(!_vm.isMobile && _vm.badges.length)?_c('div',{staticClass:"deal-badge-container"},[_c('hg-cancellation-badge',{attrs:{"badges":_vm.badges}})],1):_vm._e(),_c('hg-box-section-social',{staticClass:"cta-box deal-box-social",class:!_vm.isMobile && 'desktop',attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}),_c('div',{staticClass:"cta-box deal-cta",class:_vm.dealCtaClass,style:(_vm.dealCtaStyle)},[_c('div',{staticClass:"cta price-tag",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-price',{attrs:{"teal":"","price":_vm.currentDealPrice,"perPerson":true,"rounded":_vm.roundDealPrice,"priceSize":_vm.isMobile ? '2xl' : '3xl'}})],1),(!_vm.isExpired)?_c('div',{staticClass:"cta cta-button",class:!_vm.isMobile && 'desktop'},[_c('hg-button',{staticClass:"hg-deal-button",attrs:{"type":"submit","color":"teal","size":"full","tag":_vm.singleBookingUrl ? 'a' : 'button',"href":_vm.singleBookingUrl,"target":"_blank","rel":"noopener","disabled":_vm.isExpired},on:{"onClick":_vm.clickDealButton}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('goToDeal'))+" ")])])],1):_vm._e(),(_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.dealNumberOfAdults > 0)?_c('div',{staticClass:"cta offer-persons",class:[_vm.isExpired && 'expired', !_vm.isMobile && 'desktop']},[_vm._v(" "+_vm._s(_vm.$t('dealBox.dealIsValidFor'))+" "+_vm._s(_vm.dealNumberOfAdults)+" "+_vm._s(_vm.$t('dealBox.travelers'))+" ")]):_vm._e(),(_vm.dealVouchers.length && !_vm.isExpired)?_c('div',{staticClass:"cta deal-voucher",class:!_vm.isMobile && 'desktop'},[_c('hg-deal-voucher',{attrs:{"vouchers":_vm.dealVouchers,"isMobile":_vm.isMobile}})],1):_vm._e(),(_vm.isExpired)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e()]),(_vm.isExpired && !_vm.isMobile)?_c('div',{staticClass:"cta-box expired-subtitle",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.reminderSubtitle'))+" ")]):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-trust',{staticClass:"trust-usp cta-box",class:!_vm.isMobile && 'desktop'}):_vm._e(),(!_vm.isMobile)?_c('div',{staticClass:"divider"}):_vm._e(),_c('div',{staticClass:"pointy-divider-outer",class:!_vm.isMobile && 'desktop'},[_c('div',{staticClass:"pointy-divider-inner",class:!_vm.isMobile && 'desktop'})]),(_vm.isExpired)?_c('hg-box-section-reminder',{staticClass:"reminder-box",class:!_vm.isMobile && 'desktop',attrs:{"isMobile":_vm.isMobile,"currentPeriod":_vm.currentDealPeriod},scopedSlots:_vm._u([{key:"reminderEmail",fn:function(){return [_c('hg-text-input',{ref:"emailinput",attrs:{"label":"Deine E-Mail Adresse","labelPosition":"inside","placeholder":"info@example.com","validate":"","required":"","type":"email","name":"email"},on:{"input":_vm.onChange},model:{value:(_vm.expiredEmail),callback:function ($$v) {_vm.expiredEmail=$$v},expression:"expiredEmail"}})]},proxy:true},{key:"reminderSubmit",fn:function(){return [_c('div',{staticClass:"button-box"},[_c('hg-button',{attrs:{"type":"submit","color":"teal","size":"full","disabled":!_vm.expiredEmailValid},on:{"onClick":_vm.subscribeNotification}},[_vm._v(" "+_vm._s(_vm.$t('dealBox.notifyMe'))+" ")])],1)]},proxy:true}],null,false,3530167088)}):_vm._e(),(_vm.isMobile && _vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),_c('hg-box-section-highlights',{staticClass:"area",attrs:{"itemList":_vm.dealHighlights,"maxItemsToShow":_vm.maxHighlights,"isMobile":_vm.isMobile},on:{"onClickShowMoreHighlights":function($event){return _vm.$emit('onClickShowMoreHighlights')}},scopedSlots:_vm._u([{key:"social",fn:function(){return [(_vm.isMobile)?_c('hg-box-section-social',{staticClass:"deal-box-social",attrs:{"dealId":_vm.dealId,"dealBookmark":_vm.dealBookmark},on:{"onClickBookmark":_vm.clickBookmark,"onClickShare":_vm.clickShare}}):_vm._e()]},proxy:true}])}),(_vm.hasPeriods && !_vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),(!_vm.isExpired)?_c('hg-box-section-periods',_vm._g({staticClass:"area",attrs:{"current-deal-period":_vm.currentDealPeriod,"deal-periods":_vm.dealPeriods,"is-relative":_vm.hasRelativePeriods,"deal-duration":_vm.dealDuration,"current-period-nights":_vm.currentPeriodNights,"current-period-possible-airports":_vm.currentPeriodPossibleAirports,"current-deal-price":_vm.currentDealPrice,"best-deal-period":_vm.bestDealPeriod,"best-deal":_vm.bestDeal,"has-more-periods":_vm.hasMorePeriods,"tagline":_vm.tagline,"is-expired":_vm.isExpired,"is-mobile":_vm.isMobile,"show-price-per-date":_vm.showPricePerDate,"round-calendar-prices":_vm.roundCalendarPrices,"round-deal-price":_vm.roundDealPrice},on:{"onSelectNewPeriod":_vm.selectNewPeriod}},_vm.$listeners)):_vm._e(),(_vm.hasFlights && !_vm.isExpired)?_c('div',{staticClass:"divider"}):_vm._e(),(_vm.hasFlights && !_vm.isExpired)?_c('hg-box-section-flights',{attrs:{"currentDealPeriod":_vm.currentDealPeriod,"currentAirport":_vm.currentAirport,"currentPeriodPossibleAirports":_vm.currentPeriodPossibleAirports}}):_vm._e(),(_vm.modalDealBookingOpen)?_c('hg-modal',{staticClass:"booking-modal",attrs:{"isFullscreen":_vm.isMobile},on:{"onClose":_vm.toggleDealBookingModal}},[_c('div',{staticClass:"booking-box"},[_c('div',{staticClass:"booking-header"},[_c('div',{staticClass:"modal-subtitle"},[_vm._v(" "+_vm._s(_vm.currentPeriodNights)+" "+_vm._s(_vm.currentPeriodNights === 1 ? _vm.$t('night') : _vm.$t('nights'))+" | "+_vm._s(_vm.getFormat( new Date(_vm.currentDealPeriod.period.startDate), 'dd.MM.yy' ) + ' - ' + _vm.getFormat(new Date(_vm.currentDealPeriod.period.endDate), 'dd.MM.yy'))+" ")]),_c('div',{staticClass:"modal-explanation"}),_c('div',{staticClass:"booking-container"},[_c('div',{staticClass:"booking-step"},[_c('div',{staticClass:"booking-caption"},[_c('span',{staticClass:"booking-no"},[_vm._v("1.")]),_vm._v(" "+_vm._s(_vm.$t('dealBox.bookYourFlightHere'))+": ")]),_c('div',{staticClass:"booking-item-airline"},[_c('div',{staticClass:"booking-airline",class:[!_vm.isMobile && 'desktop']},[_c('div',{staticClass:"flight-header-airport"},[_vm._v(" "+_vm._s(_vm.$t('departureAirport'))+": ")]),_c('div',{staticClass:"flight-content-airport"},[_vm._v(" "+_vm._s(_vm.currentDealPeriod.flight.departureAirport.name + ' - ' + _vm.currentDealPeriod.flight.arrivalAirport.name)+" ")]),_c('div',{staticClass:"flight-header-airline"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.airline'))+": ")]),_c('div',{staticClass:"flight-content-airline"},[_vm._v(" "+_vm._s(_vm.currentDealPeriod.flight.airline)+" ")]),_c('div',{staticClass:"booking-icon",class:!_vm.isMobile && 'desktop'},[_c('font-awesome-icon',{staticClass:"fa-icon plane icon-light plane-icon",attrs:{"icon":['far', 'plane']}})],1),_c('div',{staticClass:"booking-button",class:!_vm.isMobile && 'desktop'},[_c('hg-button',{staticClass:"hg-deal-button",attrs:{"type":"submit","color":"teal","size":"full","tag":"a","href":_vm.currentDealPeriod.transportPrice.forwarderUrl,"data-partner":_vm.getDataPartner(_vm.currentDealPeriod.transportPrice.url),"target":"_blank","rel":"noopener","disabled":_vm.isExpired},on:{"onClick":function($event){return _vm.clickDealButtonUrl(
                        _vm.currentDealPeriod.transportPrice.forwarderUrl
                      )}}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('dealBox.goToFlightBooking'))+" ")])]),_c('div',{staticClass:"booking-disclaimer"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.includedInPrice'))+" ")])],1)]),_c('div',{staticClass:"booking-divider"},[_c('div',{staticClass:"divider-icon-container"},[_c('font-awesome-icon',{staticClass:"fa-icon plus icon-light divider-icon",attrs:{"icon":['far', 'plus']}})],1)])])]),_c('div',{staticClass:"booking-step"},[_c('div',{staticClass:"booking-caption"},[_c('span',{staticClass:"booking-no"},[_vm._v("2.")]),_vm._v(" "+_vm._s(_vm.$t('dealBox.bookYourAccommodationHere'))+": ")]),_vm._l((_vm.dealAccommodations),function(accommodation,index){return _c('div',{key:accommodation.id,staticClass:"booking-item-accommodation"},[_c('div',{staticClass:"booking-hotel",class:[
                  !_vm.isMobile && 'desktop',
                  index === _vm.dealAccommodations.length - 1 && 'pb-5',
                ]},[_c('div',{staticClass:"hotel-name"},[_vm._v(" "+_vm._s(accommodation.hotel.name)+" ")]),_c('div',{staticClass:"hotel-class"},[_c('hg-stars',{staticClass:"tw-mr-2",attrs:{"rating":accommodation.hotel.rating}}),_vm._v(" "+_vm._s(accommodation.hotel.rating)+" "+_vm._s(_vm.$t('stars'))+" "+_vm._s(accommodation.type)+" ")],1),_c('div',{staticClass:"booking-icon",class:!_vm.isMobile && 'desktop'},[_c('font-awesome-icon',{staticClass:"fa-icon hotel icon-light plane-icon",attrs:{"icon":['far', 'hotel']}})],1),(index === 0)?_c('div',{staticClass:"booking-button",class:!_vm.isMobile && 'desktop'},[_c('hg-button',{staticClass:"hg-deal-button",attrs:{"type":"submit","color":"teal","size":"full","tag":"a","href":_vm.currentDealPeriod.accommodationPrice.forwarderUrl,"data-partner":_vm.getDataPartner(_vm.currentDealPeriod.accommodationPrice.url),"target":"_blank","rel":"noopener","disabled":_vm.isExpired},on:{"onClick":function($event){return _vm.clickDealButtonUrl(
                        _vm.currentDealPeriod.accommodationPrice.forwarderUrl
                      )}}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('dealBox.goToHotelBooking'))+" ")])]),_c('div',{staticClass:"booking-disclaimer"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.includedInPrice'))+" ")])],1):_vm._e()]),(index < _vm.dealAccommodations.length - 1)?_c('div',{staticClass:"booking-divider"}):_vm._e()])})],2),_c('div',{staticClass:"booking-divider"},[_c('div',{staticClass:"divider-icon-container"},[_c('hg-icon',{staticClass:"equals-icon",attrs:{"name":"equals"}})],1)]),_c('div',{staticClass:"booking-currentchoice"},[_c('div',{staticClass:"current-price"},[_c('div',{staticClass:"price-tag"},[_c('hg-deal-price',{attrs:{"teal":"","price":_vm.currentDealPrice,"rounded":_vm.roundDealPrice,"perPerson":true,"priceSize":"3xl"}})],1),_c('div',{staticClass:"price-legal"},[_vm._v("*")])]),_c('div',{staticClass:"current-persons"},[(_vm.dealNumberOfAdults)?_c('span',{staticClass:"offer-persons",class:!_vm.isMobile && 'desktop'},[_vm._v(" "+_vm._s(_vm.$t('dealBox.dealIsValidFor'))+" "+_vm._s(_vm.dealNumberOfAdults)+" "+_vm._s(_vm.$t('dealBox.travelers'))+" ")]):_vm._e()]),_c('div',{staticClass:"booking-legal"},[_vm._v(" "+_vm._s(_vm.$t('dealBox.priceNotice'))+" ")])])])])])]):_vm._e()],1)
}
var hg_deal_box_travel_combinationvue_type_template_id_3149169c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-travel-combination.vue?vue&type=template&id=3149169c&scoped=true

// CONCATENATED MODULE: ./src/components/deal-box/mixins/TravelCombinationDealBoxMixin.js


/* harmony default export */ var TravelCombinationDealBoxMixin = ({
  components: { HgBoxSectionPeriods: hg_box_section_periods },
  props: {
    dealPeriods: {
      type: Array,
      default: () => [],
    },
    dealAccommodations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // bestDealPeriod: {},
      currentDealPeriod: {
        type: Object,
        default: () => {},
      },
      currentPeriodNights: 0,
      tagline: this.$t('dealBox.periodsTaglineCheapest'),
      bestDeal: true,
    }
  },
  computed: {
    hasPeriods() {
      return this.dealPeriods.length > 0
    },
    dealRelativePeriods() {
      return this.dealPeriods.filter((period) => period.relative)
    },
    hasRelativePeriods() {
      return this.dealRelativePeriods.length > 0
    },
    hasMorePeriods() {
      return this.dealPeriods.length > 1
    },
    hasFlights() {
      return this.currentDealPeriod.flight ? true : false
    },
    allDealDepartureAirports() {
      let result = []

      for (let i = 0; i < this.dealPeriods.length; i++) {
        result.push(this.dealPeriods[i].flight.departureAirport)
      }
      return result
    },
    currentPeriodPossibleAirports() {
      let result = []

      for (let i = 0; i < this.dealPeriods.length; i++) {
        // Set belongsToPeriod!
        this.dealPeriods[i].flight.departureAirport.belongsToPeriod =
          this.dealPeriods[i]
        if (this.dealPeriods[i] === this.currentDealPeriod) {
          result.push(this.dealPeriods[i].flight.departureAirport)
        } else if (
          this.isSameDay(
            this.parseISO(this.dealPeriods[i].period.startDate),
            this.parseISO(this.currentDealPeriod.period.startDate)
          ) &&
          this.isSameDay(
            this.parseISO(this.dealPeriods[i].period.endDate),
            this.parseISO(this.currentDealPeriod.period.endDate)
          )
        ) {
          result.push(this.dealPeriods[i].flight.departureAirport)
        }
      }
      return result
    },
    singleBookingUrl() {
      const periodPriceToCheck = this.currentDealPeriod.periodPrice
      if (!periodPriceToCheck) return null
      if (
        periodPriceToCheck.transportForwarderUrl &&
        !periodPriceToCheck.accommodationForwarderUrl
      )
        return periodPriceToCheck.transportForwarderUrl
      if (
        !periodPriceToCheck.transportForwarderUrl &&
        periodPriceToCheck.accommodationForwarderUrl
      )
        return periodPriceToCheck.accommodationForwarderUrl

      if (
        periodPriceToCheck.transportForwarderUrl ===
        periodPriceToCheck.accommodationForwarderUrl
      )
        return periodPriceToCheck.transportForwarderUrl
      return null
    },
    bestDealPeriod() {
      if (!this.dealPeriods) return {}
      const periodsToCheck = this.hasRelativePeriods
        ? this.dealRelativePeriods
        : this.dealPeriods
      const current = {
        period: periodsToCheck[0],
        mainPeriod: undefined,
      }
      for (let i = 1; i < periodsToCheck.length; i++) {
        if (periodsToCheck[i].main) current.mainPeriod = periodsToCheck[i]
        if (
          periodsToCheck[i].periodPrice.value < current.period.periodPrice.value
        ) {
          current.period = periodsToCheck[i]
        }
      }
      return current.mainPeriod ? current.mainPeriod : current.period
    },
  },
  methods: {
    getPeriodPrice(period) {
      const periodPrice = {
        value: 0,
        currency: '',
        accommodationUrl: period.accommodationPrice.url,
        accommodationForwarderUrl: period.accommodationPrice.forwarderUrl,
        transportUrl: period.transportPrice.url,
        transportForwarderUrl: period.transportPrice.forwarderUrl,
      }
      periodPrice.value += period.accommodationPrice.value
        ? period.accommodationPrice.value
        : 0
      periodPrice.currency = period.accommodationPrice.currency
        ? period.accommodationPrice.currency
        : 'EUR'
      periodPrice.value += period.transportPrice.value
        ? period.transportPrice.value
        : 0
      periodPrice.currency = period.transportPrice.currency
        ? period.transportPrice.currency
        : periodPrice.currency
        ? periodPrice.currency
        : 'EUR'
      return periodPrice
    },
    selectNewPeriod(e) {
      this.$emit('onSelectPeriod', e.period)
      this.currentDealPeriod = e.period
    },
    updateMonth({ startDate, endDate }) {
      this.$emit('onUpdateMonth', {
        startDate,
        endDate,
      })
    },
  },

  watch: {
    currentDealPeriod: function (newCurrentDealPeriod, oldCurrentDealPeriod) {
      this.bestDeal = newCurrentDealPeriod === this.bestDealPeriod
      this.currentDealPrice = newCurrentDealPeriod.periodPrice
      this.currentPeriodNights = this.differenceInDays(
        new Date(newCurrentDealPeriod.period.endDate),
        new Date(newCurrentDealPeriod.period.startDate)
      )
      this.currentAirport = this.currentDealPeriod.flight.departureAirport
    },
    dealPeriods: function (newPeriods) {
      // calculate total per period
      // get best DealPeriod
      this.bestDealPeriod = this.getBestDealPeriod()

      // set current Period to the best Deal possible
      this.currentDealPeriod = this.bestDealPeriod
      this.currentAirport = this.currentDealPeriod.flight.departureAirport
    },
  },
  created() {
    // calculate periodPrices
    for (let i = 0; i < this.dealPeriods.length; i++) {
      this.dealPeriods[i].periodPrice = this.getPeriodPrice(this.dealPeriods[i])
    }
    // set current Period to the best Deal possible
    this.currentDealPeriod = !this.dealPeriods ? {} : this.bestDealPeriod
    if (this.isMobile) document.body.classList.add('extra-footer-space')
  },
  beforeDestroy() {
    document.body.classList.remove('extra-footer-space')
  },
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/hg-deal-box-travel-combination.vue?vue&type=script&lang=js



/**
 * HG Deal Box Component for Deals of type TravelCombination
 * @displayName DealBoxTravelCombination
 */
/* harmony default export */ var hg_deal_box_travel_combinationvue_type_script_lang_js = ({
  name: 'HgDealBoxTravelCombination',
  mixins: [
    BasicDealBoxMixin,
    TravelBasicDealBoxMixin,
    // AccommodationDealBoxMixin,
    FlightDealBoxMixin,
    TravelCombinationDealBoxMixin,
  ],
  methods: {
    onChange() {
      this.expiredEmailValid = this.$refs.emailinput.isValid
    },
    clickDealButton() {
      if (this.singleBookingUrl) {
        this.$emit('onBookingUrlClick', this.singleBookingUrl)
      } else if (
        this.currentDealPeriod.periodPrice.transportForwarderUrl &&
        !this.currentDealPeriod.periodPrice.accommodationForwarderUrl
      ) {
        this.$emit(
          'onBookingUrlClick',
          this.currentDealPeriod.periodPrice.transportForwarderUrl
        )
      } else if (
        !this.currentDealPeriod.periodPrice.transportForwarderUrl &&
        this.currentDealPeriod.periodPrice.accommodationForwarderUrl
      ) {
        this.$emit(
          'onBookingUrlClick',
          this.currentDealPeriod.periodPrice.accommodationForwarderUrl
        )
      } else if (
        this.currentDealPeriod.periodPrice.transportForwarderUrl &&
        this.currentDealPeriod.periodPrice.accommodationForwarderUrl
      ) {
        if (
          this.currentDealPeriod.periodPrice.transportForwarderUrl ===
          this.currentDealPeriod.periodPrice.accommodationForwarderUrl
        ) {
          this.$emit(
            'onBookingUrlClick',
            this.currentDealPeriod.periodPrice.transportForwarderUrl
          )
        } else {
          this.toggleDealBookingModal()
        }
      }
    },
  },
  mounted() {
    if (this.isExpired) {
      this.expiredEmailValid = false
      // this.$watch(
      //   () => {
      //     return this.$refs.emailinput.isValid
      //   },
      //   (newValue) => {
      //     if (newValue === false) this.expiredEmailValid = newValue
      //     else
      //       this.expiredEmailValid =
      //         newValue && this.$refs.emailinput.computedValue !== ''
      //           ? true
      //           : false
      //   }
      // )
    }
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-travel-combination.vue?vue&type=script&lang=js
 /* harmony default export */ var deal_box_hg_deal_box_travel_combinationvue_type_script_lang_js = (hg_deal_box_travel_combinationvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/hg-deal-box-travel-combination.vue?vue&type=style&index=0&id=3149169c&prod&scoped=true&lang=postcss
var hg_deal_box_travel_combinationvue_type_style_index_0_id_3149169c_prod_scoped_true_lang_postcss = __webpack_require__("f6f7");

// CONCATENATED MODULE: ./src/components/deal-box/hg-deal-box-travel-combination.vue






/* normalize component */

var hg_deal_box_travel_combination_component = normalizeComponent(
  deal_box_hg_deal_box_travel_combinationvue_type_script_lang_js,
  hg_deal_box_travel_combinationvue_type_template_id_3149169c_scoped_true_render,
  hg_deal_box_travel_combinationvue_type_template_id_3149169c_scoped_true_staticRenderFns,
  false,
  null,
  "3149169c",
  null
  
)

/* harmony default export */ var hg_deal_box_travel_combination = (hg_deal_box_travel_combination_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/partials/hg-period-label.vue?vue&type=template&id=48565fd1&scoped=true
var hg_period_labelvue_type_template_id_48565fd1_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-period-label"},[(!_vm.hideTopLine)?[_c('div',{staticClass:"hg-period-label__from-day"},[_vm._v(" "+_vm._s(_vm.getFormat(new Date(_vm.startDate), 'eeeeee'))+". ")]),_c('div',{staticClass:"hg-period-label__nights"},[_vm._v(" "+_vm._s(_vm.differenceInDays(_vm.parseISO(_vm.endDate), _vm.parseISO(_vm.startDate)))+" "+_vm._s(_vm.differenceInDays(_vm.parseISO(_vm.endDate), _vm.parseISO(_vm.startDate)) === 1 ? _vm.$t('night') : _vm.$t('nights'))+" ")]),_c('div',{staticClass:"hg-period-label__till-day"},[_vm._v(" "+_vm._s(_vm.getFormat(new Date(_vm.endDate), 'eeeeee'))+". ")])]:_vm._e(),_c('span',{staticClass:"hg-period-label__period-date"},[_vm._v(" "+_vm._s(_vm.getFormat(new Date(_vm.startDate), 'dd.MM.yy'))+" ")]),_c('span',{staticClass:"hg-period-label__nights-box"},[_c('ArrowRightLongSvg',{staticClass:"nights-icon"})],1),_c('span',{staticClass:"hg-period-label__period-date"},[_vm._v(" "+_vm._s(_vm.getFormat(new Date(_vm.endDate), 'dd.MM.yy'))+" ")])],2)
}
var hg_period_labelvue_type_template_id_48565fd1_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/deal-box/partials/hg-period-label.vue?vue&type=template&id=48565fd1&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/deal-box/partials/hg-period-label.vue?vue&type=script&lang=js





let hg_period_labelvue_type_script_lang_js_locale = de

/* harmony default export */ var hg_period_labelvue_type_script_lang_js = ({
  props: {
    startDate: {
      type: String,
      default: () => new Date().toString(),
    },
    endDate: {
      type: String,
      default: () => new Date().toString(),
    },
    hideTopLine: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    let currentLocale = this.$i18n.locale
    switch (currentLocale) {
      case 'nl':
        hg_period_labelvue_type_script_lang_js_locale = nl
        break
      case 'es':
        hg_period_labelvue_type_script_lang_js_locale = es
        break
      default:
        hg_period_labelvue_type_script_lang_js_locale = de
        break
    }
  },
  methods: {
    format: format,
    differenceInDays: differenceInDays,
    parseISO: parseISO,
    getFormat(date, formatString) {
      return this.format(date, formatString, { locale: hg_period_labelvue_type_script_lang_js_locale })
    },
  },
});

// CONCATENATED MODULE: ./src/components/deal-box/partials/hg-period-label.vue?vue&type=script&lang=js
 /* harmony default export */ var partials_hg_period_labelvue_type_script_lang_js = (hg_period_labelvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/deal-box/partials/hg-period-label.vue?vue&type=style&index=0&id=48565fd1&prod&lang=postcss&scoped=true
var hg_period_labelvue_type_style_index_0_id_48565fd1_prod_lang_postcss_scoped_true = __webpack_require__("35b1");

// CONCATENATED MODULE: ./src/components/deal-box/partials/hg-period-label.vue






/* normalize component */

var hg_period_label_component = normalizeComponent(
  partials_hg_period_labelvue_type_script_lang_js,
  hg_period_labelvue_type_template_id_48565fd1_scoped_true_render,
  hg_period_labelvue_type_template_id_48565fd1_scoped_true_staticRenderFns,
  false,
  null,
  "48565fd1",
  null
  
)

/* harmony default export */ var hg_period_label = (hg_period_label_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/hotel/hg-hotel-detail-view.vue?vue&type=template&id=70d4000c&scoped=true
var hg_hotel_detail_viewvue_type_template_id_70d4000c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hg-snap-slider',{attrs:{"height":320}},_vm._l((_vm.images),function(hotelImage,i){return _c('div',{key:i,staticClass:"slide",class:_vm.images.length === 1 && 'slide--single'},[_c('hg-image',{staticClass:"slide-image",attrs:{"alt":hotelImage.image.title,"src":`${hotelImage.image.url}?width=600&height=480&mimetype=webp`,"src-placeholder":`${hotelImage.image.url}?width=20&height=10&mimetype=webp`}})],1)}),0),_c('div',{staticClass:"hg-hotel__content"},[_c('hg-stars',{attrs:{"rating":_vm.rating}}),_c('h2',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"hg-button location-button"},[_c('hg-icon',{attrs:{"name":"map-marker-alt"}}),(_vm.location.address.city)?_c('span',[_vm._v(" "+_vm._s(_vm.location.address.city)+", "+_vm._s(_vm.location.address.country)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.location.address.country)+" ")])],1),_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}),(_vm.attributes)?_c('h3',{staticClass:"hg-title hg-title__highlights"},[_vm._v(" Highlights ")]):_vm._e(),_c('HgDealHotelAttributes',{attrs:{"attributes":_vm.attributes}}),_vm._t("hotel-extras")],2)],1)
}
var hg_hotel_detail_viewvue_type_template_id_70d4000c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/hotel/hg-hotel-detail-view.vue?vue&type=template&id=70d4000c&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/hotel/hg-hotel-detail-view.vue?vue&type=script&lang=js



/* harmony default export */ var hg_hotel_detail_viewvue_type_script_lang_js = ({
  components: {
    HgImage: hg_image,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    rating: {
      type: Number,
      default: 0.0,
    },
    images: {
      type: Array,
      default: () => [],
    },
    location: {
      type: Object,
      default: () => {},
    },
    attributes: {
      type: Array,
      default: () => [],
    },
  },
});

// CONCATENATED MODULE: ./src/components/hotel/hg-hotel-detail-view.vue?vue&type=script&lang=js
 /* harmony default export */ var hotel_hg_hotel_detail_viewvue_type_script_lang_js = (hg_hotel_detail_viewvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/hotel/hg-hotel-detail-view.vue?vue&type=style&index=0&id=70d4000c&prod&lang=postcss&scoped=true
var hg_hotel_detail_viewvue_type_style_index_0_id_70d4000c_prod_lang_postcss_scoped_true = __webpack_require__("cb0b");

// CONCATENATED MODULE: ./src/components/hotel/hg-hotel-detail-view.vue






/* normalize component */

var hg_hotel_detail_view_component = normalizeComponent(
  hotel_hg_hotel_detail_viewvue_type_script_lang_js,
  hg_hotel_detail_viewvue_type_template_id_70d4000c_scoped_true_render,
  hg_hotel_detail_viewvue_type_template_id_70d4000c_scoped_true_staticRenderFns,
  false,
  null,
  "70d4000c",
  null
  
)

/* harmony default export */ var hg_hotel_detail_view = (hg_hotel_detail_view_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/hotel/hg-stars.vue?vue&type=template&id=37ef1096&scoped=true
var hg_starsvue_type_template_id_37ef1096_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg-stars"},[_vm._l((Math.floor(_vm.rating)),function(star){return _c('hg-icon',{key:star,staticClass:"hg-stars__star",attrs:{"size":"small","name":"star","pack":"fas"}})}),(_vm.hasHalfStar)?_c('hg-icon',{staticClass:"hg-stars__star-half",attrs:{"size":"small","name":"star-half","pack":"fas"}}):_vm._e()],2)
}
var hg_starsvue_type_template_id_37ef1096_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/hotel/hg-stars.vue?vue&type=template&id=37ef1096&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/hotel/hg-stars.vue?vue&type=script&lang=js

/* harmony default export */ var hg_starsvue_type_script_lang_js = ({
  props: {
    rating: {
      type: Number,
      default: 0.0,
    },
  },
  computed: {
    hasHalfStar() {
      return this.rating % 1 !== 0
    },
  },
});

// CONCATENATED MODULE: ./src/components/hotel/hg-stars.vue?vue&type=script&lang=js
 /* harmony default export */ var hotel_hg_starsvue_type_script_lang_js = (hg_starsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/hotel/hg-stars.vue?vue&type=style&index=0&id=37ef1096&prod&lang=postcss&scoped=true
var hg_starsvue_type_style_index_0_id_37ef1096_prod_lang_postcss_scoped_true = __webpack_require__("ef3b");

// CONCATENATED MODULE: ./src/components/hotel/hg-stars.vue






/* normalize component */

var hg_stars_component = normalizeComponent(
  hotel_hg_starsvue_type_script_lang_js,
  hg_starsvue_type_template_id_37ef1096_scoped_true_render,
  hg_starsvue_type_template_id_37ef1096_scoped_true_staticRenderFns,
  false,
  null,
  "37ef1096",
  null
  
)

/* harmony default export */ var hg_stars = (hg_stars_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-activate-form.vue?vue&type=template&id=623a2b90
var hg_activate_formvue_type_template_id_623a2b90_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form"},[(!_vm.isTravelAgent)?_c('h2',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.$t('activate.title'))+" ")]):_vm._e(),(!_vm.isTravelAgent)?_c('p',[_vm._v(" "+_vm._s(_vm.$t('activate.subline'))+" ")]):_vm._e(),(_vm.loading)?_c('hg-loading-bar',{attrs:{"loading":_vm.loading}}):_vm._e(),(_vm.couldActivate && !_vm.loading && !_vm.isTravelAgent)?_c('HgAlertBox',{attrs:{"title":_vm.$t('authSuccessTitle'),"type":"success"}},[_vm._v(" "+_vm._s(_vm.$t('activate.success'))+" ")]):_vm._e(),(_vm.couldActivate && !_vm.loading && _vm.isTravelAgent)?_c('HgActivateAccount',{on:{"onClick":_vm.handleClick}}):_vm._e(),(!_vm.couldActivate && !_vm.loading)?_c('HgAlertBox',{attrs:{"title":_vm.$t('errorHandling.errorBoxTitle'),"type":"info"}},[_vm._v(" "+_vm._s(_vm.$t('activate.fail'))+" ")]):_vm._e(),_c('div',{staticClass:"hg-form-footer"},[_vm._t("form-footer")],2)],1)
}
var hg_activate_formvue_type_template_id_623a2b90_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/forms/hg-activate-form.vue?vue&type=template&id=623a2b90

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-activate-form.vue?vue&type=script&lang=js

/* harmony default export */ var hg_activate_formvue_type_script_lang_js = ({
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    isAccountActive: {
      type: Boolean,
      default: true,
    },
    couldActivate: {
      type: Boolean,
      default: true,
    },
    isTravelAgent: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleClick() {
      this.$emit('onClick')
    },
  },
});

// CONCATENATED MODULE: ./src/components/forms/hg-activate-form.vue?vue&type=script&lang=js
 /* harmony default export */ var forms_hg_activate_formvue_type_script_lang_js = (hg_activate_formvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/forms/hg-activate-form.vue





/* normalize component */

var hg_activate_form_component = normalizeComponent(
  forms_hg_activate_formvue_type_script_lang_js,
  hg_activate_formvue_type_template_id_623a2b90_render,
  hg_activate_formvue_type_template_id_623a2b90_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_activate_form = (hg_activate_form_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-login-form.vue?vue&type=template&id=6fb4033a&scoped=true
var hg_login_formvue_type_template_id_6fb4033a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"observer",staticClass:"form",attrs:{"tag":"form","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},scopedSlots:_vm._u([{key:"default",fn:function({ invalid }){return [_c('h2',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.$t('authModal.login'))+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.$t('authModal.loginTitle'))+" ")]),_c('hg-loading-bar',{staticClass:"tw-my-4",attrs:{"loading":_vm.loading}}),_c('div',{staticClass:"tw-mb-6"},[_vm._t("errors")],2),_c('div',[_vm._t("success")],2),(!_vm.$slots.success)?[_c('div',{staticClass:"form-row"},[_c('hg-text-input',{attrs:{"label":_vm.$t('authModal.emailLabel'),"rules":"required|email","label-position":"inside","type":"email","name":"email-login"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_c('div',{staticClass:"form-row"},[_c('hg-text-input',{attrs:{"label-position":"inside","rules":"required|password","type":"password","name":"password-login","label":_vm.$t('authModal.passwordLabel')},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),(_vm.forgotPasswordLink != null)?_c('div',{staticClass:"form-row forgot-password-link-container"},[_c('nuxt-link',{staticClass:"hg-text-link link",attrs:{"to":_vm.forgotPasswordLink}},[_vm._v(" "+_vm._s(_vm.$t('authModal.forgotPassword'))+" ")])],1):_vm._e(),_c('div',{staticClass:"form-row"},[_c('hg-button',{attrs:{"nativeType":"submit","type":"submit","color":"teal","disabled":invalid}},[_vm._v(" "+_vm._s(_vm.$t('authModal.loginNow'))+" ")])],1)]:_vm._e(),_c('div',{staticClass:"form-footer"},[_vm._t("form-footer")],2)]}}],null,true)})
}
var hg_login_formvue_type_template_id_6fb4033a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/forms/hg-login-form.vue?vue&type=template&id=6fb4033a&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-login-form.vue?vue&type=script&lang=js

/* harmony default export */ var hg_login_formvue_type_script_lang_js = ({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    forgotPasswordLink: {
      type: String,
      default: null,
    },
    errors: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    email: '',
    password: '',
  }),

  methods: {
    async submit() {
      this.$emit('onSubmit', {
        email: this.email,
        password: this.password,
      })
    },
  },
});

// CONCATENATED MODULE: ./src/components/forms/hg-login-form.vue?vue&type=script&lang=js
 /* harmony default export */ var forms_hg_login_formvue_type_script_lang_js = (hg_login_formvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/forms/hg-login-form.vue?vue&type=style&index=0&id=6fb4033a&prod&lang=postcss&scoped=true
var hg_login_formvue_type_style_index_0_id_6fb4033a_prod_lang_postcss_scoped_true = __webpack_require__("ba42");

// CONCATENATED MODULE: ./src/components/forms/hg-login-form.vue






/* normalize component */

var hg_login_form_component = normalizeComponent(
  forms_hg_login_formvue_type_script_lang_js,
  hg_login_formvue_type_template_id_6fb4033a_scoped_true_render,
  hg_login_formvue_type_template_id_6fb4033a_scoped_true_staticRenderFns,
  false,
  null,
  "6fb4033a",
  null
  
)

/* harmony default export */ var hg_login_form = (hg_login_form_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-register-form.vue?vue&type=template&id=c410030e&scoped=true
var hg_register_formvue_type_template_id_c410030e_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"observer",staticClass:"form content",attrs:{"tag":"form","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},scopedSlots:_vm._u([{key:"default",fn:function({ invalid }){return [_c('h2',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.$t('authModal.register'))+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.$t('authModal.registerTitle'))+" ")]),_c('hg-loading-bar',{staticClass:"tw-my-4",attrs:{"loading":_vm.loading}}),_c('div',{staticClass:"tw-mb-6"},[_vm._t("errors")],2),_c('div',[_vm._t("success")],2),(!_vm.$slots.success)?[_c('div',{staticClass:"form-row form-row--2 from-row--addon"},[_c('hg-text-input',{attrs:{"label":_vm.$t('authModal.firstNameLabel'),"expanded":"","rules":"required","name":"firstname","type":"text"},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}}),_c('hg-text-input',{attrs:{"label":_vm.$t('authModal.lastNameLabel'),"expanded":"","rules":"required","name":"lastname","type":"text"},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1),_c('div',{staticClass:"form-row"},[_c('hg-text-input',{attrs:{"label":_vm.$t('authModal.emailLabel'),"rules":"required","name":"register-email","type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_c('div',{staticClass:"form-row"},[_c('hg-text-input',{attrs:{"label":_vm.$t('authModal.passwordLabel'),"rules":"required|password","name":"password","type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_c('div',{staticClass:"form-row"},[_c('hg-text-input',{attrs:{"rules":"required|passwordConfirm:password","name":"confirm","type":"password","label":_vm.$t('authModal.passwordConfirmLabel')},model:{value:(_vm.passwordConfirm),callback:function ($$v) {_vm.passwordConfirm=$$v},expression:"passwordConfirm"}})],1),_c('div',{staticClass:"form-row"},[_c('hg-checkbox',{attrs:{"name":"news-consent"},model:{value:(_vm.newsletterConsent),callback:function ($$v) {_vm.newsletterConsent=$$v},expression:"newsletterConsent"}},[_vm._v(" "+_vm._s(_vm.$t('authModal.newsLetterConsent'))+" ")])],1),_c('div',{staticClass:"form-row"},[_c('hg-checkbox',{attrs:{"rules":"required","name":"privacy-consent"},model:{value:(_vm.privacyConsent),callback:function ($$v) {_vm.privacyConsent=$$v},expression:"privacyConsent"}},[_vm._v(" "+_vm._s(_vm.$t('authModal.privacyConsent'))+" | "),_c('a',{attrs:{"href":_vm.$t('footer.buttons[0].url'),"target":"_blank"}},[_c('small',[_vm._v(" "+_vm._s(_vm.$t('footer.buttons[0].label'))+" ")])])])],1),_c('div',{staticClass:"form-row"},[_c('hg-button',{attrs:{"nativeType":"submit","type":"submit","color":"teal","disabled":invalid === true || _vm.privacyConsent === false}},[_vm._v(" "+_vm._s(_vm.$t('authModal.registerNow'))+" ")])],1)]:_vm._e(),_c('div',{staticClass:"form-footer"},[_vm._t("form-footer")],2)]}}],null,true)})
}
var hg_register_formvue_type_template_id_c410030e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/forms/hg-register-form.vue?vue&type=template&id=c410030e&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-register-form.vue?vue&type=script&lang=js

/* harmony default export */ var hg_register_formvue_type_script_lang_js = ({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirm: '',
    salutation: '',
    newsletterConsent: false,
    privacyConsent: false,
  }),

  methods: {
    submit() {
      const { firstName, lastName, email, password, salutation } = this

      this.$emit('onSubmit', {
        firstName,
        lastName,
        email,
        password,
        salutation,
      })
    },
  },
});

// CONCATENATED MODULE: ./src/components/forms/hg-register-form.vue?vue&type=script&lang=js
 /* harmony default export */ var forms_hg_register_formvue_type_script_lang_js = (hg_register_formvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/forms/hg-register-form.vue?vue&type=style&index=0&id=c410030e&prod&lang=postcss&scoped=true
var hg_register_formvue_type_style_index_0_id_c410030e_prod_lang_postcss_scoped_true = __webpack_require__("9592");

// CONCATENATED MODULE: ./src/components/forms/hg-register-form.vue






/* normalize component */

var hg_register_form_component = normalizeComponent(
  forms_hg_register_formvue_type_script_lang_js,
  hg_register_formvue_type_template_id_c410030e_scoped_true_render,
  hg_register_formvue_type_template_id_c410030e_scoped_true_staticRenderFns,
  false,
  null,
  "c410030e",
  null
  
)

/* harmony default export */ var hg_register_form = (hg_register_form_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-new-password-form.vue?vue&type=template&id=6d9fa799
var hg_new_password_formvue_type_template_id_6d9fa799_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"observer",staticClass:"form",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},scopedSlots:_vm._u([{key:"default",fn:function({ invalid }){return [_c('h2',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.$t('resetPassword.title'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('resetPassword.description'))+" ")]),_c('hg-loading-bar',{staticClass:"tw-my-4",attrs:{"loading":_vm.loading}}),(_vm.success)?_c('HgAlertBox',{staticClass:"tw-mb-6",attrs:{"title":_vm.$t('authSuccessTitle'),"type":"success"}},[_vm._v(" "+_vm._s(_vm.$t('resetPassword.success'))+" ")]):_vm._e(),(_vm.errors.length)?_c('HgAlertBox',{staticClass:"tw-mb-6",attrs:{"title":_vm.$t('errorHandling.errorBoxTitle'),"type":"error","closable":""}},[_c('HgApiErrors',{attrs:{"errors":_vm.errors}})],1):_vm._e(),(!_vm.success)?[_c('div',{staticClass:"form-row"},[_c('hg-text-input',{attrs:{"rules":"required|password","type":"password","name":"password","label":_vm.$t('resetPassword.newPassword')},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_c('div',{staticClass:"form-row"},[_c('hg-text-input',{attrs:{"rules":"required|passwordConfirm:password","type":"password","name":"confirm-password","label":_vm.$t('resetPassword.passwordConfirm')},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1),_c('span',{staticClass:"tw-my-2 tw-text-xs"},[_vm._v(" "+_vm._s(_vm.$t('resetPassword.passwordRequirements'))+" ")]),_c('div',{staticClass:"form-footer"},[_c('div'),_c('hg-button',{attrs:{"nativeType":"submit","type":"submit","color":"teal","disabled":invalid}},[_vm._v(" "+_vm._s(_vm.$t('confirm'))+" ")])],1)]:_vm._e()]}}])})
}
var hg_new_password_formvue_type_template_id_6d9fa799_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/forms/hg-new-password-form.vue?vue&type=template&id=6d9fa799

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-new-password-form.vue?vue&type=script&lang=js

/* harmony default export */ var hg_new_password_formvue_type_script_lang_js = ({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    password: '',
    confirmPassword: '',
  }),

  methods: {
    submit() {
      this.$emit('onSubmit', {
        password: this.password,
      })
    },
  },
});

// CONCATENATED MODULE: ./src/components/forms/hg-new-password-form.vue?vue&type=script&lang=js
 /* harmony default export */ var forms_hg_new_password_formvue_type_script_lang_js = (hg_new_password_formvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/forms/hg-new-password-form.vue





/* normalize component */

var hg_new_password_form_component = normalizeComponent(
  forms_hg_new_password_formvue_type_script_lang_js,
  hg_new_password_formvue_type_template_id_6d9fa799_render,
  hg_new_password_formvue_type_template_id_6d9fa799_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_new_password_form = (hg_new_password_form_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-forgot-password-form.vue?vue&type=template&id=8bb9149a
var hg_forgot_password_formvue_type_template_id_8bb9149a_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"observer",staticClass:"form",attrs:{"tag":"form","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},scopedSlots:_vm._u([{key:"default",fn:function({ invalid }){return [_c('h2',{staticClass:"hg-title"},[_vm._v(" "+_vm._s(_vm.$t('forgotPassword.title'))+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.$t('forgotPassword.description'))+" ")]),_c('hg-loading-bar',{staticClass:"tw-my-4",attrs:{"loading":_vm.loading}}),(_vm.success)?_c('HgAlertBox',{staticClass:"tw-mb-6",attrs:{"title":_vm.$t('authSuccessTitle'),"type":"success"}},[_vm._v(" "+_vm._s(_vm.$t('forgotPassword.checkMail', { email: _vm.email }))+" ")]):_vm._e(),(_vm.errors.length)?_c('HgAlertBox',{staticClass:"tw-mb-6",attrs:{"title":_vm.$t('errorHandling.errorBoxTitle'),"type":"error","closable":""}},[_c('HgApiErrors',{attrs:{"errors":_vm.errors}})],1):_vm._e(),(!_vm.success)?[_c('hg-text-input',{attrs:{"label":_vm.$t('authModal.emailLabel'),"placeholder":_vm.$t('authModal.emailPlaceholder'),"rules":"required|email","label-position":"inside","type":"email","name":"email-login"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c('div',{staticClass:"form-row"},[_c('hg-button',{attrs:{"nativeType":"submit","type":"submit","color":"teal","disabled":invalid}},[_vm._v(" "+_vm._s(_vm.$t('confirm'))+" ")])],1)]:_vm._e()]}}])})
}
var hg_forgot_password_formvue_type_template_id_8bb9149a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/forms/hg-forgot-password-form.vue?vue&type=template&id=8bb9149a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-forgot-password-form.vue?vue&type=script&lang=js

/* harmony default export */ var hg_forgot_password_formvue_type_script_lang_js = ({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    email: '',
  }),

  methods: {
    submit() {
      this.$emit('onSubmit', {
        email: this.email,
      })
    },
  },
});

// CONCATENATED MODULE: ./src/components/forms/hg-forgot-password-form.vue?vue&type=script&lang=js
 /* harmony default export */ var forms_hg_forgot_password_formvue_type_script_lang_js = (hg_forgot_password_formvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/forms/hg-forgot-password-form.vue





/* normalize component */

var hg_forgot_password_form_component = normalizeComponent(
  forms_hg_forgot_password_formvue_type_script_lang_js,
  hg_forgot_password_formvue_type_template_id_8bb9149a_render,
  hg_forgot_password_formvue_type_template_id_8bb9149a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_forgot_password_form = (hg_forgot_password_form_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-account-activation-form.vue?vue&type=template&id=f78b287a
var hg_account_activation_formvue_type_template_id_f78b287a_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"observer",staticClass:"form content",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('h1',[_vm._v("Aktivieren")]),_c('hg-loading-bar',{attrs:{"loading":_vm.loading}}),_c('hg-text-input',{attrs:{"rules":"required","type":"email","name":"email","label":"E-Mail"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c('div',{staticClass:"items-end form-footer"},[_c('hg-text-input',{staticClass:"mb-0",attrs:{"rules":"required","type":"email","name":"email","label":"E-Mail"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c('hg-button',{staticClass:"button button--green",attrs:{"type":"submit"}},[_vm._v(" Bestätigen ")])],1)],1)
}
var hg_account_activation_formvue_type_template_id_f78b287a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/forms/hg-account-activation-form.vue?vue&type=template&id=f78b287a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-account-activation-form.vue?vue&type=script&lang=js

/* harmony default export */ var hg_account_activation_formvue_type_script_lang_js = ({
  data: () => ({
    email: 'asdf',
    loading: false,
  }),
});

// CONCATENATED MODULE: ./src/components/forms/hg-account-activation-form.vue?vue&type=script&lang=js
 /* harmony default export */ var forms_hg_account_activation_formvue_type_script_lang_js = (hg_account_activation_formvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/forms/hg-account-activation-form.vue





/* normalize component */

var hg_account_activation_form_component = normalizeComponent(
  forms_hg_account_activation_formvue_type_script_lang_js,
  hg_account_activation_formvue_type_template_id_f78b287a_render,
  hg_account_activation_formvue_type_template_id_f78b287a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_account_activation_form = (hg_account_activation_form_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-newsletter-box.vue?vue&type=template&id=e6de27ba&scoped=true
var hg_newsletter_boxvue_type_template_id_e6de27ba_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"observer",staticClass:"hg-newsletter-box",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},scopedSlots:_vm._u([{key:"default",fn:function({ invalid }){return [_c('div',{staticClass:"svg-container"},[_c('EnvelopeSvg',{staticClass:"envelope"})],1),_c('HgLoadingBar',{staticClass:"loading-bar",attrs:{"loading":_vm.loading}}),(!_vm.success)?_c('div',{staticClass:"newsletter-box__form"},[_c('div',{staticClass:"form__description"},[_c('h3',{staticClass:"description__title"},[_vm._v(" "+_vm._s(_vm.$t('newsletterBox.title'))+" ")]),_c('p',{staticClass:"description__subtitle",domProps:{"innerHTML":_vm._s(_vm.$t('newsletterBox.subtitle'))}}),(_vm.userEMail)?_c('p',{staticClass:"description__subtitle"},[_vm._v(" "+_vm._s(_vm.$t('newsletterBox.alreadyRegisteredMessage'))+" ")]):_vm._e()]),_c('div',{staticClass:"form__inputs"},[_c('hg-text-input',{attrs:{"type":"email","name":"email","required":true,"teal":true,"label-position":"outside","placeholder":_vm.$t('newsletterBox.placeholder')},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c('hg-checkbox',{staticClass:"inputs__checkbox",attrs:{"teal":"","rules":"required"},model:{value:(_vm.hasAcceptedPrivacy),callback:function ($$v) {_vm.hasAcceptedPrivacy=$$v},expression:"hasAcceptedPrivacy"}},[_vm._v(" "+_vm._s(_vm.privacyTextFirst)+" "),_c('a',{staticClass:"checkbox__link",attrs:{"href":_vm.$t('newsletterBox.privacyButtonUrl'),"target":"_blank"}},[_vm._v(_vm._s(_vm.privacyTextSecond))]),_vm._v(_vm._s(_vm.privacyTextThird)+" ")]),_c('hg-button',{staticClass:"inputs__button",attrs:{"disabled":invalid || !_vm.hasAcceptedPrivacy,"color":"teal"},on:{"onClick":function($event){return _vm.$emit('onSubscribe', _vm.userEMail || _vm.email)}}},[_vm._v(" "+_vm._s(_vm.$t('newsletterBox.send'))+" ")])],1)]):(_vm.success)?_c('div',{staticClass:"newsletter-box__success"},[_c('h2',{staticClass:"success__title"},[_vm._v(" "+_vm._s(_vm.$t('newsletterBox.successTitle'))+" ")]),_c('p',{staticClass:"success__subtitle"},[_vm._v(" "+_vm._s(_vm.$t('newsletterBox.successSubtitleFirst'))+" ")]),_c('p',{staticClass:"success__subtitle"},[_vm._v(" "+_vm._s(_vm.$t('newsletterBox.successSubtitleSecond'))+" ")])]):_vm._e()]}}])})
}
var hg_newsletter_boxvue_type_template_id_e6de27ba_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/forms/hg-newsletter-box.vue?vue&type=template&id=e6de27ba&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-newsletter-box.vue?vue&type=script&lang=js

/* harmony default export */ var hg_newsletter_boxvue_type_script_lang_js = ({
  data: () => ({
    email: '',
    hasAcceptedPrivacy: false,
    privacyTextFirst: '',
    privacyTextSecond: '',
    privacyTextThird: '',
    isValid: false,
    buttonDisabled: true,
  }),

  props: {
    success: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    userEMail: {
      type: String,
      default: '',
    },
  },

  mounted() {
    this.changePrivacyText()
  },

  methods: {
    onChangeMail() {
      this.email = this.$refs.input.newValue
    },
    onChangePrivacy(bool) {
      this.hasAcceptedPrivacy = bool
    },

    changePrivacyText() {
      let text = this.$i18n.t('newsletterBox.privacyText').split(' ')
      this.privacyTextFirst = text[0]
      this.privacyTextSecond = text[1]
      text.splice(0, 2)
      this.privacyTextThird = ` ${text.toString().replaceAll(',', ' ')}`
    },
  },
});

// CONCATENATED MODULE: ./src/components/forms/hg-newsletter-box.vue?vue&type=script&lang=js
 /* harmony default export */ var forms_hg_newsletter_boxvue_type_script_lang_js = (hg_newsletter_boxvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/forms/hg-newsletter-box.vue?vue&type=style&index=0&id=e6de27ba&prod&scoped=true&lang=postcss
var hg_newsletter_boxvue_type_style_index_0_id_e6de27ba_prod_scoped_true_lang_postcss = __webpack_require__("25f7");

// CONCATENATED MODULE: ./src/components/forms/hg-newsletter-box.vue






/* normalize component */

var hg_newsletter_box_component = normalizeComponent(
  forms_hg_newsletter_boxvue_type_script_lang_js,
  hg_newsletter_boxvue_type_template_id_e6de27ba_scoped_true_render,
  hg_newsletter_boxvue_type_template_id_e6de27ba_scoped_true_staticRenderFns,
  false,
  null,
  "e6de27ba",
  null
  
)

/* harmony default export */ var hg_newsletter_box = (hg_newsletter_box_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-user-profile-form.vue?vue&type=template&id=429adc3f
var hg_user_profile_formvue_type_template_id_429adc3f_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"observer",staticClass:"form",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},scopedSlots:_vm._u([{key:"default",fn:function({ invalid }){return [_c('hg-loading-bar',{staticClass:"tw-my-4",attrs:{"loading":_vm.loading}}),_c('div',{staticClass:"tw-mb-6"},[_vm._t("errors")],2),_c('div',[_vm._t("success")],2),(!_vm.$slots.success)?[_c('div',{staticClass:"form-row"},[_c('hg-select',{attrs:{"value":_vm.selectedSex,"displayProperty":"name","options":_vm.availableSexes,"placeholder":_vm.$t('profile.sex.placeholder'),"label":_vm.$t('profile.sex.label')},on:{"change":_vm.selectSex}})],1),_c('div',{staticClass:"form-row"},[_c('hg-text-input',{attrs:{"label":_vm.$t('firstName'),"placeholder":_vm.$t('firstNamePlaceholder'),"rules":"required","label-position":"inside","type":"text","name":"firstName"},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}})],1),_c('div',{staticClass:"form-row"},[_c('hg-text-input',{attrs:{"label":_vm.$t('lastName'),"placeholder":_vm.$t('lastNamePlaceholder'),"rules":"required","label-position":"inside","type":"text","name":"lastName"},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"ibe-submit hg-control"},[_c('HgButton',{attrs:{"color":"teal","disabled":invalid || _vm.selectedSex === null},on:{"onClick":_vm.submit}},[_vm._v(" "+_vm._s(_vm.$t('save'))+" ")])],1)])]:_vm._e()]}}],null,true)})
}
var hg_user_profile_formvue_type_template_id_429adc3f_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/forms/hg-user-profile-form.vue?vue&type=template&id=429adc3f

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/hg-user-profile-form.vue?vue&type=script&lang=js

/* harmony default export */ var hg_user_profile_formvue_type_script_lang_js = ({
  data: () => ({
    firstName: '',
    lastName: '',
    selectedSex: null,
    availableSexes: null,
  }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.availableSexes = [
      {
        name: this.$i18n.t('profile.sex.male'),
        value: 'MALE',
      },
      {
        name: this.$i18n.t('profile.sex.female'),
        value: 'FEMALE',
      },
      {
        name: this.$i18n.t('profile.sex.other'),
        value: 'OTHER',
      },
    ]
  },
  beforeMount() {
    if (!this.user || !this.user.profile) return
    const { firstName, lastName, sex } = this.user.profile

    this.firstName = firstName
    this.lastName = lastName
    this.availableSexes.forEach((availableSex) => {
      if (availableSex.value === sex) {
        this.selectedSex = availableSex
      }
    })
  },
  methods: {
    submit() {
      this.$emit('onSubmit', {
        firstName: this.firstName,
        lastName: this.lastName,
        sex: this.selectedSex,
      })
    },
    selectSex(gender) {
      this.selectedSex = gender
    },
  },
});

// CONCATENATED MODULE: ./src/components/forms/hg-user-profile-form.vue?vue&type=script&lang=js
 /* harmony default export */ var forms_hg_user_profile_formvue_type_script_lang_js = (hg_user_profile_formvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/forms/hg-user-profile-form.vue





/* normalize component */

var hg_user_profile_form_component = normalizeComponent(
  forms_hg_user_profile_formvue_type_script_lang_js,
  hg_user_profile_formvue_type_template_id_429adc3f_render,
  hg_user_profile_formvue_type_template_id_429adc3f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hg_user_profile_form = (hg_user_profile_form_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/modals/hg-auth-modal.vue?vue&type=template&id=27fc1204&scoped=true
var hg_auth_modalvue_type_template_id_27fc1204_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('HgModal',{staticClass:"hg-auth-modal",class:!_vm.isMobile && 'hg-auth-modal--desktop',attrs:{"isFullscreen":_vm.isMobile},on:{"onClose":function($event){return _vm.$emit('onClose')}}},[_c('div',{staticClass:"hg-auth-modal-title"},[_c('h2',{staticClass:"hg-title"},[_vm._v(_vm._s(_vm.$t('authModal.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('authModal.subline')))])]),_vm._t("default")],2)
}
var hg_auth_modalvue_type_template_id_27fc1204_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/modals/hg-auth-modal.vue?vue&type=template&id=27fc1204&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/modals/hg-auth-modal.vue?vue&type=script&lang=js

/* harmony default export */ var hg_auth_modalvue_type_script_lang_js = ({
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
});

// CONCATENATED MODULE: ./src/components/modals/hg-auth-modal.vue?vue&type=script&lang=js
 /* harmony default export */ var modals_hg_auth_modalvue_type_script_lang_js = (hg_auth_modalvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/modals/hg-auth-modal.vue?vue&type=style&index=0&id=27fc1204&prod&scoped=true&lang=postcss
var hg_auth_modalvue_type_style_index_0_id_27fc1204_prod_scoped_true_lang_postcss = __webpack_require__("51d1");

// EXTERNAL MODULE: ./src/components/modals/hg-auth-modal.vue?vue&type=style&index=1&id=27fc1204&prod&lang=postcss
var hg_auth_modalvue_type_style_index_1_id_27fc1204_prod_lang_postcss = __webpack_require__("aa02");

// CONCATENATED MODULE: ./src/components/modals/hg-auth-modal.vue







/* normalize component */

var hg_auth_modal_component = normalizeComponent(
  modals_hg_auth_modalvue_type_script_lang_js,
  hg_auth_modalvue_type_template_id_27fc1204_scoped_true_render,
  hg_auth_modalvue_type_template_id_27fc1204_scoped_true_staticRenderFns,
  false,
  null,
  "27fc1204",
  null
  
)

/* harmony default export */ var hg_auth_modal = (hg_auth_modal_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-svg.vue?vue&type=template&id=2e47b090&scoped=true
var guru_svgvue_type_template_id_2e47b090_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.type,attrs:{"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"}},[_c('path',{staticClass:"hair",attrs:{"d":"M29.057 6.89C26.991 2.275 17.186 4.3 14.09 5.64c0 0-1.352.446-2.885 2.232-1.533 1.786-3.484 5.524-3.426 7.054.058 1.53-4.246 6.925-4.779 7.59 1.762-.348 2.617-.73 3.877-1.786 0 0-.18 2.769-.631 5.447-.45 2.68-3.066 5.626-3.066 5.626s1.804-.134 3.697-1.607c1.893-1.474 1.984-1.25 1.984-1.25s0 .803-.27 1.74c-.271.939-.271 1.742-.271 1.742 2.252-.1 3.309-.404 4.868-1.34.538.87.878 1.25 1.533 1.787l.722-.715c1.573 1.656 2.517 2.5 4.327 3.84 1.819-1.355 2.716-2.204 4.148-3.84l.992.715c.675-.61 1.003-.991 1.442-1.786 2.312 1.075 4.297 1.415 6.763 1.786-.45-2.568-.613-4.202-.615-6.875 1.113.257 2.1.958 3.5 1-.132-.215-2.86-4.2-3.516-6.002-.657-1.802-.722-6.518-.722-6.518l2.074.357c-.317-.364-2.616-3.12-4.779-7.947z"}}),_c('path',{staticClass:"face",attrs:{"d":"M18.958 10c-.268 1.118-.697 1.78-1.47 2.953 2.084-.94 3.16-1.558 4.778-2.953 2.582.473 4.173 1.26 6.155 3.49.44 1.193.618 2.021.551 4.384 0 0 1.195-.895 1.838.179.643 1.073-.551 3.847-.551 3.847l-1.287.358C28.432 24.5 27.911 25.575 26.4 27c.006-1.838-.18-3.03-.919-3.49h-11.76c-.705.387-.958 1.186-1.194 3.49-1.27-1.21-1.87-2.201-2.664-4.742L8.668 21.9c-.334-1.11-1.01-3.668-.46-4.116.552-.447 1.93.09 1.93.09 1.107-1.649 1.561-2.607 2.021-4.384.71-.06.92.063 1.562.626 2.264-1.48 3.382-2.397 5.237-4.116z"}}),_c('path',{staticClass:"mouth",attrs:{"d":"M19.447 29.491L17.464 30c-1.621-.25-2.385-.683-3.335-2.288-.278-1.073-.162-1.668.901-2.712.661.029.951.148 1.352.509.992.101 1.473.024 2.254-.255h1.442c.79.355 1.524.37 3.064.255.587-.417.87-.401 1.352-.255.613 1.12.664 1.769.18 2.966-.942 1.208-1.678 1.557-3.244 1.78l-1.983-.509z"}})])
}
var guru_svgvue_type_template_id_2e47b090_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/guru-svg.vue?vue&type=template&id=2e47b090&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-svg.vue?vue&type=script&lang=js

/* harmony default export */ var guru_svgvue_type_script_lang_js = ({
  props: {
    type: {
      type: String,
      default: 'full',
    },
  },
});

// CONCATENATED MODULE: ./src/components/svg/logos/guru-svg.vue?vue&type=script&lang=js
 /* harmony default export */ var logos_guru_svgvue_type_script_lang_js = (guru_svgvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/svg/logos/guru-svg.vue?vue&type=style&index=0&id=2e47b090&prod&scoped=true&lang=postcss
var guru_svgvue_type_style_index_0_id_2e47b090_prod_scoped_true_lang_postcss = __webpack_require__("f136");

// CONCATENATED MODULE: ./src/components/svg/logos/guru-svg.vue






/* normalize component */

var guru_svg_component = normalizeComponent(
  logos_guru_svgvue_type_script_lang_js,
  guru_svgvue_type_template_id_2e47b090_scoped_true_render,
  guru_svgvue_type_template_id_2e47b090_scoped_true_staticRenderFns,
  false,
  null,
  "2e47b090",
  null
  
)

/* harmony default export */ var guru_svg = (guru_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-logo.vue?vue&type=template&id=03134204&scoped=true
var guru_logovue_type_template_id_03134204_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(['de', 'at'].includes(_vm.lang))?[_c('svg',{attrs:{"viewBox":"0 0 221 63","xmlns":"http://www.w3.org/2000/svg","fill":"none"}},[_c('path',{attrs:{"d":"M6.15039 49.8476V48.6174H7.22764V49.8476H6.15039ZM6.15039 59.421V51.375H7.22764V59.421H6.15039Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M9.92578 59.421V51.3749H10.9008V53.3558H11.0103V59.421H9.92578ZM15.6444 59.421V55.3143C15.6444 54.8684 15.6042 54.4558 15.5202 54.0805C15.4362 53.7051 15.3048 53.3781 15.1222 53.0956C14.9396 52.8169 14.7022 52.5976 14.4137 52.4453C14.1216 52.2892 13.771 52.2149 13.3547 52.2149C12.975 52.2149 12.639 52.2817 12.3469 52.4155C12.0547 52.5493 11.8137 52.7426 11.6165 52.9916C11.4193 53.2406 11.2696 53.5453 11.1674 53.9058C11.0651 54.2626 11.014 54.6714 11.014 55.1285L10.2508 54.9613C10.2508 54.1362 10.3932 53.445 10.6744 52.8838C10.9556 52.3226 11.3463 51.899 11.8466 51.6091C12.3469 51.3192 12.9165 51.178 13.5592 51.178C14.034 51.178 14.4466 51.2523 14.8008 51.401C15.155 51.5496 15.4545 51.7503 15.7028 52.003C15.9511 52.2557 16.1483 52.5456 16.298 52.8727C16.4477 53.1997 16.5573 53.5416 16.6267 53.9095C16.6961 54.2737 16.7289 54.6379 16.7289 55.0022V59.421H15.6444Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M22.0975 59.6402C21.17 59.6402 20.4068 59.4358 19.8079 59.0308C19.209 58.622 18.8438 58.0571 18.7051 57.3324L19.8042 57.1465C19.9211 57.6037 20.1877 57.9679 20.6076 58.2392C21.0239 58.5105 21.5425 58.6443 22.1559 58.6443C22.7548 58.6443 23.2295 58.5179 23.5765 58.2615C23.9234 58.005 24.095 57.6557 24.095 57.2134C24.095 56.9644 24.0402 56.7638 23.9307 56.6077C23.8211 56.4516 23.5984 56.3066 23.2624 56.1728C22.9265 56.0391 22.4225 55.8792 21.7543 55.6971C21.0385 55.4965 20.4762 55.2995 20.0708 55.1025C19.6655 54.9056 19.377 54.6751 19.2054 54.415C19.0337 54.1548 18.9497 53.8352 18.9497 53.4562C18.9497 52.999 19.0776 52.5977 19.3295 52.252C19.5815 51.9064 19.9357 51.6388 20.3849 51.4456C20.834 51.2523 21.3562 51.1594 21.9514 51.1594C22.5467 51.1594 23.0798 51.256 23.5509 51.453C24.022 51.65 24.4017 51.925 24.6902 52.2781C24.9787 52.6311 25.1503 53.0399 25.2015 53.5082L24.1023 53.7089C24.0293 53.2369 23.7992 52.8615 23.4121 52.5865C23.0251 52.3115 22.5321 52.1666 21.9368 52.1591C21.3745 52.1443 20.918 52.252 20.5675 52.4825C20.2169 52.7129 20.0416 53.0213 20.0416 53.4041C20.0416 53.6197 20.1037 53.8018 20.2315 53.9504C20.3593 54.1028 20.5894 54.244 20.9217 54.3778C21.2576 54.5116 21.7323 54.6566 22.3531 54.8164C23.0798 55.0059 23.6531 55.2029 24.0658 55.411C24.4821 55.6191 24.7742 55.8644 24.9532 56.1505C25.1284 56.433 25.2161 56.7823 25.2161 57.2023C25.2161 57.9604 24.9386 58.5588 24.3835 58.9936C23.8284 59.4284 23.0689 59.6402 22.0975 59.6402Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M27.6289 62.9999V51.375H28.5966V57.4328H28.7135V62.9999H27.6289ZM31.1893 59.6477C30.4626 59.6477 29.8455 59.4619 29.3452 59.0866C28.8413 58.7112 28.4615 58.2021 28.2022 57.5591C27.943 56.9162 27.8151 56.1952 27.8151 55.3925C27.8151 54.5786 27.9466 53.8502 28.2059 53.2147C28.4651 52.5754 28.8522 52.0737 29.3598 51.7058C29.8674 51.3379 30.4919 51.1558 31.2331 51.1558C31.9562 51.1558 32.577 51.3416 33.0919 51.7132C33.6068 52.0849 34.0048 52.594 34.2823 53.2332C34.5562 53.8725 34.695 54.5934 34.695 55.3925C34.695 56.1989 34.5562 56.9199 34.2787 57.5591C34.0011 58.1983 33.5995 58.7075 33.0773 59.0828C32.5551 59.4582 31.927 59.6477 31.1893 59.6477ZM31.0798 58.6257C31.6312 58.6257 32.0913 58.4845 32.4565 58.2021C32.8216 57.9196 33.0955 57.5331 33.2818 57.0425C33.4643 56.552 33.5556 56.002 33.5556 55.3925C33.5556 54.7867 33.4643 54.2404 33.2854 53.7535C33.1065 53.2667 32.8289 52.8802 32.4601 52.5977C32.0913 52.3153 31.6239 52.1741 31.0579 52.1741C30.5065 52.1741 30.05 52.3116 29.6848 52.5829C29.3197 52.8579 29.0494 53.2332 28.8668 53.7201C28.6879 54.2032 28.5966 54.7607 28.5966 55.3925C28.5966 56.0131 28.6879 56.5706 28.8668 57.0574C29.0458 57.5443 29.3196 57.9308 29.6885 58.2095C30.0536 58.4882 30.5174 58.6257 31.0798 58.6257Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M36.9668 49.8476V48.6174H38.0441V49.8476H36.9668ZM36.9668 59.421V51.375H38.0441V59.421H36.9668Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M41.0469 59.4209V51.3749H42.0146V53.3112L41.8247 53.0585C41.9123 52.8206 42.0255 52.6013 42.168 52.4006C42.3104 52.2 42.4637 52.0327 42.6281 51.9064C42.8326 51.7243 43.0736 51.583 43.3438 51.4864C43.614 51.3898 43.8916 51.334 44.1727 51.3155C44.4503 51.2969 44.7059 51.3192 44.9359 51.3786V52.4081C44.6475 52.3338 44.3334 52.3152 43.9902 52.3561C43.6469 52.3969 43.3328 52.5344 43.0444 52.7723C42.7814 52.9804 42.5842 53.2294 42.4528 53.523C42.3213 53.8129 42.2337 54.1213 42.1899 54.4484C42.146 54.7754 42.1241 55.095 42.1241 55.4147V59.4209H41.0469Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M49.7402 59.6477C48.9697 59.6477 48.3014 59.4731 47.7391 59.1274C47.1767 58.7781 46.7385 58.2913 46.4244 57.6595C46.1104 57.0277 45.957 56.2881 45.957 55.4408C45.957 54.56 46.1104 53.8018 46.4172 53.1589C46.7239 52.516 47.1584 52.0254 47.7172 51.6761C48.2759 51.3267 48.9368 51.1558 49.6964 51.1558C50.4779 51.1558 51.1425 51.3379 51.6939 51.7021C52.2453 52.0663 52.6616 52.5903 52.9464 53.2704C53.2276 53.9505 53.359 54.7644 53.3335 55.7084H52.2343V55.3218C52.2161 54.2775 51.9933 53.4897 51.5734 52.9582C51.1498 52.4268 50.5363 52.1592 49.7256 52.1592C48.8748 52.1592 48.2247 52.4379 47.7756 53.0028C47.3264 53.5677 47.1 54.363 47.1 55.4036C47.1 56.4182 47.3264 57.2023 47.7756 57.7635C48.2247 58.3247 48.8674 58.6034 49.6964 58.6034C50.2624 58.6034 50.7554 58.4696 51.179 58.2058C51.6026 57.9419 51.9349 57.5554 52.1796 57.0537L53.1838 57.4476C52.8697 58.1463 52.4096 58.6926 51.8034 59.0754C51.1936 59.4545 50.5071 59.6477 49.7402 59.6477ZM46.7166 55.7046V54.7867H52.7565V55.7046H46.7166Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M58.4178 59.6402C57.4903 59.6402 56.7271 59.4358 56.1282 59.0308C55.5293 58.622 55.1642 58.0571 55.0254 57.3324L56.1246 57.1465C56.2414 57.6037 56.508 57.9679 56.9279 58.2392C57.3442 58.5105 57.8628 58.6443 58.4763 58.6443C59.0751 58.6443 59.5499 58.5179 59.8968 58.2615C60.2437 58.005 60.4153 57.6557 60.4153 57.2134C60.4153 56.9644 60.3605 56.7638 60.251 56.6077C60.1414 56.4516 59.9187 56.3066 59.5827 56.1728C59.2468 56.0391 58.7428 55.8792 58.0746 55.6971C57.3588 55.4965 56.7965 55.2995 56.3911 55.1025C55.9858 54.9056 55.6973 54.6751 55.5257 54.415C55.354 54.1548 55.2701 53.8352 55.2701 53.4562C55.2701 52.999 55.3979 52.5977 55.6498 52.252C55.9018 51.9064 56.256 51.6388 56.7052 51.4456C57.1543 51.2523 57.6765 51.1594 58.2718 51.1594C58.867 51.1594 59.4001 51.256 59.8712 51.453C60.3423 51.65 60.7221 51.925 61.0105 52.2781C61.299 52.6311 61.4707 53.0399 61.5218 53.5082L60.4226 53.7089C60.3496 53.2369 60.1195 52.8615 59.7324 52.5865C59.3454 52.3115 58.8524 52.1666 58.2572 52.1591C57.6948 52.1443 57.2383 52.252 56.8878 52.4825C56.5372 52.7129 56.3619 53.0213 56.3619 53.4041C56.3619 53.6197 56.424 53.8018 56.5518 53.9504C56.6796 54.1028 56.9097 54.244 57.242 54.3778C57.5779 54.5116 58.0527 54.6566 58.6735 54.8164C59.4001 55.0059 59.9735 55.2029 60.3861 55.411C60.8024 55.6191 61.0945 55.8644 61.2735 56.1505C61.4488 56.433 61.5364 56.7823 61.5364 57.2023C61.5364 57.9604 61.2589 58.5588 60.7038 58.9936C60.1487 59.4284 59.3892 59.6402 58.4178 59.6402Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M66.2324 52.3153V51.375H71.4179V52.3153H66.2324ZM71.4142 59.421C70.9687 59.5139 70.5305 59.5511 70.0996 59.5325C69.6687 59.5139 69.2816 59.4173 68.942 59.2501C68.6024 59.0791 68.3468 58.819 68.1678 58.4585C68.0254 58.1612 67.9487 57.8601 67.9378 57.5517C67.9268 57.2469 67.9195 56.8976 67.9195 56.5037V49.134H68.9895V56.4591C68.9895 56.7972 68.9931 57.0797 69.0004 57.3064C69.0077 57.5331 69.0588 57.7338 69.1501 57.9047C69.3254 58.2392 69.6066 58.4362 69.99 58.4994C70.3735 58.5625 70.8482 58.5477 71.4142 58.4548V59.421Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M76.4972 59.6477C75.712 59.6477 75.0401 59.4656 74.4851 59.1051C73.93 58.7409 73.5028 58.2392 73.2033 57.6C72.9039 56.9608 72.7578 56.2249 72.7578 55.3925C72.7578 54.5488 72.9075 53.8093 73.2106 53.1738C73.5137 52.5383 73.9446 52.044 74.5033 51.6872C75.062 51.3304 75.7267 51.1558 76.4972 51.1558C77.2896 51.1558 77.9615 51.3342 78.5202 51.6946C79.0789 52.0551 79.5062 52.5531 79.802 53.1924C80.0977 53.8316 80.2438 54.5637 80.2438 55.3925C80.2438 56.2361 80.0941 56.9794 79.7983 57.6186C79.4989 58.2578 79.0716 58.7558 78.5093 59.1126C77.9469 59.4656 77.275 59.6477 76.4972 59.6477ZM76.4972 58.596C77.3772 58.596 78.0309 58.2987 78.4581 57.7041C78.889 57.1094 79.1008 56.3401 79.1008 55.3887C79.1008 54.415 78.8854 53.642 78.4545 53.066C78.0236 52.4899 77.3699 52.2001 76.4972 52.2001C75.9056 52.2001 75.4199 52.3339 75.0365 52.6052C74.653 52.8765 74.3682 53.2518 74.1783 53.7312C73.9884 54.2106 73.8971 54.7644 73.8971 55.3887C73.8971 56.3587 74.1162 57.1355 74.5544 57.7189C74.9963 58.3024 75.6427 58.596 76.4972 58.596Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M85.8008 59.4209V48.6917H86.8853V53.3632H86.7685V59.4209H85.8008ZM89.3575 59.6476C88.6309 59.6476 88.0137 59.4618 87.5134 59.0864C87.0095 58.7111 86.6297 58.2019 86.3704 57.559C86.1112 56.916 85.9834 56.1951 85.9834 55.3923C85.9834 54.5784 86.1148 53.85 86.3741 53.2145C86.6334 52.5753 87.0204 52.0736 87.528 51.7057C88.0356 51.3377 88.6601 51.1556 89.4014 51.1556C90.1244 51.1556 90.7452 51.3414 91.2601 51.7131C91.775 52.0847 92.173 52.5939 92.4505 53.2331C92.7244 53.8723 92.8632 54.5933 92.8632 55.3923C92.8632 56.1988 92.7244 56.9198 92.4469 57.559C92.1694 58.1982 91.7677 58.7073 91.2455 59.0827C90.7269 59.4581 90.0952 59.6476 89.3575 59.6476ZM89.248 58.6256C89.7994 58.6256 90.2595 58.4844 90.6247 58.2019C90.9899 57.9195 91.2637 57.533 91.45 57.0424C91.6326 56.5518 91.7239 56.0018 91.7239 55.3923C91.7239 54.7865 91.6326 54.2402 91.4536 53.7534C91.2747 53.2665 90.9972 52.88 90.6283 52.5976C90.2595 52.3151 89.7921 52.1739 89.2261 52.1739C88.6747 52.1739 88.2182 52.3114 87.853 52.5827C87.4879 52.8577 87.2176 53.2331 87.0351 53.7199C86.8561 54.2031 86.7648 54.7605 86.7648 55.3923C86.7648 56.013 86.8561 56.5704 87.0351 57.0573C87.214 57.5441 87.4879 57.9306 87.8567 58.2094C88.2255 58.4881 88.6893 58.6256 89.248 58.6256Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M98.2901 59.6477C97.505 59.6477 96.8331 59.4656 96.278 59.1051C95.723 58.7409 95.2957 58.2392 94.9963 57.6C94.6969 56.9608 94.5508 56.2249 94.5508 55.3925C94.5508 54.5488 94.7005 53.8093 95.0036 53.1738C95.3067 52.5383 95.7376 52.044 96.2963 51.6872C96.855 51.3304 97.5196 51.1558 98.2901 51.1558C99.0826 51.1558 99.7545 51.3342 100.313 51.6946C100.872 52.0551 101.299 52.5531 101.595 53.1924C101.891 53.8316 102.037 54.5637 102.037 55.3925C102.037 56.2361 101.887 56.9794 101.591 57.6186C101.292 58.2578 100.865 58.7558 100.302 59.1126C99.7435 59.4656 99.0716 59.6477 98.2901 59.6477ZM98.2901 58.596C99.1702 58.596 99.8238 58.2987 100.251 57.7041C100.682 57.1094 100.894 56.3401 100.894 55.3887C100.894 54.415 100.678 53.642 100.247 53.066C99.8166 52.4899 99.1629 52.2001 98.2901 52.2001C97.6986 52.2001 97.2129 52.3339 96.8294 52.6052C96.446 52.8765 96.1612 53.2518 95.9713 53.7312C95.7814 54.2106 95.6901 54.7644 95.6901 55.3887C95.6901 56.3587 95.9092 57.1355 96.3474 57.7189C96.7893 58.3024 97.4356 58.596 98.2901 58.596Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M107.468 59.6477C106.683 59.6477 106.011 59.4656 105.456 59.1051C104.897 58.7409 104.473 58.2392 104.174 57.6C103.878 56.9608 103.729 56.2249 103.729 55.3925C103.729 54.5488 103.878 53.8093 104.181 53.1738C104.484 52.5383 104.915 52.044 105.474 51.6872C106.033 51.3304 106.697 51.1558 107.468 51.1558C108.257 51.1558 108.932 51.3342 109.491 51.6946C110.05 52.0551 110.477 52.5531 110.773 53.1924C111.068 53.8316 111.215 54.5637 111.215 55.3925C111.215 56.2361 111.065 56.9794 110.769 57.6186C110.47 58.2578 110.042 58.7558 109.48 59.1126C108.918 59.4656 108.249 59.6477 107.468 59.6477ZM107.468 58.596C108.348 58.596 109.002 58.2987 109.429 57.7041C109.86 57.1094 110.072 56.3401 110.072 55.3887C110.072 54.415 109.856 53.642 109.425 53.066C108.994 52.4899 108.341 52.2001 107.468 52.2001C106.876 52.2001 106.391 52.3339 106.007 52.6052C105.624 52.8765 105.339 53.2518 105.149 53.7312C104.959 54.2106 104.868 54.7644 104.868 55.3887C104.868 56.3587 105.087 57.1355 105.525 57.7189C105.967 58.3024 106.613 58.596 107.468 58.596Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M113.332 59.4209L113.339 48.6917H114.424V55.2474L117.951 51.3712H119.387L115.68 55.396L119.869 59.4209H118.302L114.42 55.5447V59.4209H113.332Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M150.472 26.6052C148.519 26.5829 147.084 27.9988 147.069 29.9611C147.054 31.9456 148.453 33.4396 150.345 33.4694C152.309 33.4991 153.839 31.994 153.854 30.0168C153.869 28.1103 152.397 26.6275 150.472 26.6052ZM153.879 22.2756C153.879 21.8445 153.865 21.4654 153.883 21.09C153.909 20.6069 154.015 20.4805 154.478 20.4694C156.063 20.4397 157.652 20.3988 159.226 20.6106C160.365 20.763 161 21.365 161.285 22.4985C161.428 23.0597 161.515 23.6321 161.512 24.2118C161.501 29.0766 161.541 33.9376 161.406 38.8024C161.373 39.9656 161.161 41.0954 160.829 42.2066C160.215 44.2655 158.981 45.8078 157.144 46.867C155.384 47.8816 153.47 48.3907 151.473 48.5617C147.788 48.8776 144.257 48.3052 140.945 46.5771C139.455 45.8004 139.725 45.845 140.434 44.7226C141.19 43.5297 141.957 42.3404 142.723 41.1549C143.118 40.5454 143.169 40.5305 143.797 40.891C144.893 41.5228 146.014 42.0877 147.266 42.307C148.595 42.5374 149.91 42.4891 151.192 42.0543C152.755 41.5228 153.704 40.0623 153.573 38.4419C153.554 38.2264 153.562 37.9922 153.321 37.8919C153.109 37.8064 152.974 37.9774 152.824 38.0889C148.471 41.2887 142.65 39.6683 140.573 34.6363C138.798 30.3364 139.262 26.3116 142.194 22.6584C144.747 19.4771 149.852 18.8119 152.992 21.707C153.226 21.9411 153.456 22.1864 153.879 22.2756Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M110.739 33.4769C112.641 33.4918 114.091 32.0238 114.109 30.069C114.124 28.0918 112.736 26.6313 110.804 26.6053C108.822 26.5756 107.354 28.0101 107.339 29.9872C107.324 31.9235 108.822 33.462 110.739 33.4769ZM106.82 37.7248C106.82 38.2265 106.835 38.6353 106.817 39.0404C106.795 39.5272 106.726 39.6127 106.284 39.6164C104.275 39.6276 102.263 39.6276 100.255 39.6127C99.8092 39.609 99.7361 39.5123 99.6923 39.0515C99.6704 38.8137 99.6741 38.5721 99.6741 38.3305C99.6741 31.039 99.6777 23.7474 99.6741 16.4558C99.6741 15.8054 99.696 15.1551 99.7617 14.5084C99.926 12.9438 100.689 12.1894 102.23 12.063C103.811 11.9367 105.396 11.9738 106.981 11.985C107.617 11.9887 107.66 12.0296 107.664 12.6911C107.675 14.5196 107.671 16.348 107.675 18.1765C107.675 19.139 107.664 20.1016 107.679 21.0641C107.69 21.6848 107.795 21.7517 108.358 21.4915C108.811 21.2834 109.245 21.0418 109.687 20.8151C112.835 19.1874 116.267 19.7745 118.721 22.35C120.35 24.0596 121.197 26.1407 121.457 28.4746C121.756 31.1542 121.296 33.6962 119.959 36.0524C117.987 39.5309 114.058 41.0584 110.315 39.7985C109.38 39.4826 108.559 38.9772 107.814 38.3305C107.551 38.1038 107.295 37.8585 106.82 37.7248Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M12.1175 15.9243C12.6543 16.6825 13.213 17.3365 13.9251 17.8197C14.1734 17.9869 14.1332 18.2285 14.1332 18.4626C14.1332 19.8823 14.1332 21.3019 14.1332 22.7216C14.1332 24.3345 14.1369 25.9474 14.1405 27.5604C14.1405 28.0918 14.1734 28.6158 14.2756 29.1398C14.6956 31.3065 16.1197 32.139 18.1464 31.9383C19.6729 31.7896 20.7392 30.645 20.9583 29.0432C21.0496 28.3743 21.1043 27.7053 21.1043 27.0289C21.1007 24.2379 21.1226 21.4432 21.108 18.6522C21.1043 18.1988 21.2139 17.9014 21.601 17.6413C22.2327 17.2102 22.7184 16.6081 23.1383 15.9801C23.3976 16.0024 23.5364 16.1845 23.6934 16.3145C25.6142 17.8829 27.2392 19.7076 28.4041 21.93C29.2842 23.6098 29.8064 25.3826 29.8173 27.3114C29.8283 28.902 29.8502 30.4926 29.4448 32.0423C28.5794 35.3611 26.5782 37.7507 23.4487 38.9734C19.5925 40.4786 15.6523 40.5789 11.7377 39.0701C10.5801 38.6241 9.5211 37.9886 8.58261 37.1635C6.67277 35.48 5.70507 33.3171 5.53709 30.7862C5.45675 29.5895 5.42023 28.3854 5.44945 27.1813C5.49327 25.4123 5.96434 23.7659 6.74945 22.205C8.01295 19.689 9.85706 17.6859 12.1175 15.9243Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M220.998 31.444C220.998 33.8745 221.001 36.3088 220.998 38.7393C220.998 39.542 220.928 39.6164 220.158 39.6164C218.098 39.6201 216.042 39.6201 213.983 39.6126C213.252 39.6089 213.22 39.5681 213.19 38.8434C213.176 38.5312 213.19 38.2116 213.081 37.9143C212.99 37.6653 212.781 37.6169 212.573 37.7805C212.5 37.8399 212.442 37.918 212.38 37.9886C210.459 40.1106 207.457 40.7907 204.777 39.7241C202.352 38.7616 201.198 36.8588 200.869 34.3316C200.778 33.6144 200.745 32.8934 200.749 32.1687C200.753 28.679 200.749 25.1856 200.749 21.6959C200.749 21.5509 200.745 21.406 200.753 21.2611C200.775 20.5401 200.866 20.4397 201.596 20.4435C202.896 20.4472 204.2 20.4583 205.5 20.4806C205.996 20.4881 206.489 20.5624 206.964 20.7222C207.936 21.0418 208.502 21.7182 208.673 22.7365C208.754 23.2122 208.783 23.6916 208.79 24.1747C208.819 26.3414 208.848 28.508 208.892 30.6747C208.903 31.2024 208.914 31.7339 209.093 32.243C209.367 33.0235 209.933 33.4434 210.751 33.4732C211.569 33.4992 212.084 33.1758 212.427 32.4028C212.785 31.5927 212.851 30.7342 212.854 29.8608C212.858 27.1404 212.869 24.42 212.873 21.6996C212.876 20.4546 212.876 20.4472 214.067 20.462C215.25 20.4732 216.433 20.4918 217.616 20.5178C218.138 20.5289 218.657 20.5698 219.154 20.7408C219.95 21.0121 220.49 21.5509 220.727 22.3723C220.928 23.0709 220.998 23.7882 220.998 24.5129C220.994 26.8208 220.994 29.1324 220.998 31.444Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M175.549 37.7655C175.122 37.9141 174.848 38.178 174.556 38.4158C173.508 39.2706 172.361 39.9284 171.017 40.1551C167.19 40.8018 164.094 38.4976 163.513 34.7923C163.352 33.7703 163.276 32.7372 163.272 31.7003C163.265 28.4261 163.257 25.152 163.254 21.8778C163.254 21.6623 163.246 21.443 163.261 21.2275C163.294 20.7406 163.393 20.6031 163.849 20.5994C165.551 20.5883 167.256 20.5548 168.958 20.6217C170.291 20.6737 171.072 21.5099 171.215 22.8553C171.361 24.2452 171.306 25.6463 171.335 27.0399C171.364 28.4819 171.295 29.9276 171.456 31.3695C171.488 31.6817 171.525 31.9939 171.631 32.2875C171.897 33.0382 172.504 33.4581 173.325 33.4693C174.114 33.4804 174.695 33.1051 174.983 32.3581C175.341 31.4253 175.403 30.433 175.414 29.4482C175.436 26.8467 175.436 24.2489 175.447 21.6474C175.447 21.4542 175.458 21.2609 175.45 21.0714C175.436 20.6997 175.626 20.5474 175.969 20.5511C176.396 20.5548 176.82 20.5511 177.247 20.5548C178.383 20.5622 179.519 20.5697 180.654 20.5883C182.407 20.618 183.203 21.3538 183.426 23.1043C183.488 23.606 183.528 24.1077 183.528 24.6131C183.528 29.2103 183.535 33.8075 183.539 38.4047C183.539 38.5979 183.539 38.7912 183.535 38.9807C183.528 39.3226 183.364 39.5233 183.02 39.5419C180.727 39.6683 178.438 39.724 176.144 39.5456C175.786 39.5196 175.659 39.3152 175.637 38.9844C175.6 38.6091 175.666 38.2226 175.549 37.7655Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M89.7823 37.9699C89.3733 37.8621 89.1031 38.126 88.8219 38.3341C87.9346 38.9808 86.9997 39.5419 85.9553 39.8913C82.2306 41.1325 78.546 39.0477 77.6952 35.2086C77.5527 34.5768 77.4797 33.9264 77.4797 33.2761C77.4724 29.9536 77.4724 26.6312 77.4688 23.3087C77.4688 22.9445 77.5235 22.5877 77.6294 22.2421C77.8997 21.3613 78.4547 20.8001 79.3786 20.6663C79.6342 20.6292 79.8971 20.6032 80.1564 20.5994C81.6938 20.5846 83.2311 20.5771 84.7685 20.5771C85.4222 20.5771 85.4404 20.5994 85.4368 21.2758C85.4331 24.5017 85.4331 27.7275 85.5536 30.9533C85.5682 31.3881 85.5792 31.8192 85.7289 32.2318C86.0028 32.9788 86.5104 33.4173 87.3101 33.473C88.139 33.5288 88.7489 33.1943 89.0995 32.4473C89.4208 31.7635 89.534 31.0277 89.545 30.2732C89.5851 28.0583 89.6326 25.8433 89.6764 23.632C89.6801 23.4388 89.6837 23.2455 89.702 23.056C89.8481 21.5471 90.6916 20.6998 92.1778 20.5957C92.7439 20.5548 93.3135 20.5474 93.8795 20.5437C94.8984 20.54 95.9135 20.54 96.9324 20.5586C97.4436 20.5697 97.4911 20.6366 97.513 21.1532C97.5166 21.2721 97.513 21.3947 97.513 21.5137C97.513 27.2444 97.5166 32.9751 97.5166 38.702C97.5166 38.847 97.5093 38.9919 97.5166 39.1368C97.5386 39.4825 97.356 39.6125 97.0456 39.62C96.8812 39.6237 96.7133 39.6237 96.5489 39.6237C94.6793 39.6237 92.8132 39.6237 90.9436 39.6237C90.7537 39.6237 90.5638 39.6311 90.3776 39.6163C89.9065 39.5791 89.8627 39.5271 89.8334 39.0514C89.8079 38.6909 89.8773 38.3267 89.7823 37.9699Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M68.6019 32.4177C68.591 32.2505 68.58 32.0833 68.5727 31.916C68.5618 31.589 68.4047 31.4217 68.0797 31.4775C67.0098 31.6521 65.9325 31.7711 64.8881 32.0721C64.2235 32.2616 63.8547 32.7076 63.778 33.4026C63.7013 34.0938 63.9606 34.6178 64.5339 34.9858C65.5053 35.6138 66.8235 35.4875 67.6744 34.6736C68.3061 34.0604 68.5983 33.3022 68.6019 32.4177ZM75.6862 33.332C75.6862 35.1604 75.6899 36.9889 75.6826 38.8211C75.6789 39.5644 75.6643 39.5867 74.9157 39.5904C73.0461 39.6015 71.18 39.6015 69.3104 39.5978C68.5764 39.5941 68.5654 39.5755 68.4157 38.8731C68.2988 38.3119 68.2623 38.2822 67.7985 38.5832C66.7943 39.2299 65.7536 39.7948 64.5704 40.0215C62.9418 40.3337 61.3642 40.2073 59.8999 39.3562C57.2159 37.7954 56.3285 34.6736 57.3693 31.9272C57.833 30.7045 58.7167 29.8534 59.8378 29.2476C61.1707 28.5304 62.6022 28.1327 64.0921 27.958C65.1255 27.8391 66.1626 27.7685 67.1997 27.6719C67.9592 27.6013 68.1528 27.2854 67.8898 26.5681C67.7182 26.0998 67.3749 25.8285 66.9258 25.6836C66.064 25.4012 65.2058 25.4235 64.3513 25.7171C63.6064 25.9698 62.9162 26.334 62.2406 26.7354C61.6892 27.0624 61.5943 27.0401 61.1597 26.5495C60.685 26.0144 60.203 25.4829 59.7429 24.9329C58.5305 23.4872 58.64 22.5767 60.1811 21.4915C61.1634 20.7965 62.2845 20.4063 63.4311 20.1053C65.7755 19.4847 68.1126 19.5367 70.4314 20.2316C73.2104 21.0678 74.7258 23.0524 75.3357 25.8583C75.5584 26.8952 75.6789 27.9432 75.6716 29.0061C75.6643 30.4518 75.668 31.8937 75.668 33.3394H75.6862V33.332Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M24.1419 12.9623C24.1419 12.193 24.1273 11.5055 23.9739 10.8179C23.3604 8.09382 20.6655 5.3474 16.7362 5.83425C13.6359 6.22075 11.182 9.05637 11.1528 12.3082C11.1491 12.94 11.182 13.5681 11.3901 14.159C11.5435 14.5864 11.3901 14.8056 11.0688 15.0546C9.03478 16.6304 7.31848 18.5035 6.01482 20.7556C5.00694 22.4986 4.33868 24.3605 4.17435 26.3897C4.1634 26.5086 4.14514 26.6275 4.11958 26.7464C4.11227 26.791 4.07941 26.8319 4.05385 26.8765C3.853 26.9025 3.77997 26.7241 3.67042 26.6164C1.80074 24.7767 0.708881 22.5135 0.277979 19.9306C-0.686073 14.1181 0.858601 9.06008 4.89374 4.83825C7.24544 2.378 10.207 1.03638 13.4753 0.363707C15.4399 -0.041381 17.4301 -0.134291 19.402 0.218767C26.0737 1.42288 27.622 8.51006 24.3318 12.8397C24.3135 12.8731 24.2624 12.888 24.1419 12.9623Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M129.874 40.3782C127.11 40.3484 124.484 39.7724 122.089 38.3007C121.252 37.7878 121.249 37.747 121.935 37C122.6 36.279 123.272 35.5691 123.918 34.837C124.495 34.1829 125.174 33.9339 126.018 34.1458C126.956 34.3799 127.899 34.6103 128.841 34.8333C129.359 34.9597 129.874 34.982 130.342 34.6512C130.897 34.2573 130.908 33.6924 130.363 33.291C130.152 33.1349 129.903 33.0494 129.659 32.9602C128.611 32.5923 127.563 32.2207 126.515 31.849C126.292 31.771 126.069 31.6892 125.85 31.5963C122.344 30.1209 121.234 25.9102 123.568 22.8553C124.879 21.1421 126.664 20.1907 128.746 19.8674C132.062 19.3508 135.184 19.9974 138.101 21.6772C138.185 21.7256 138.262 21.7776 138.346 21.8259C138.635 21.9894 138.697 22.1901 138.467 22.4614C138.248 22.7141 138.05 22.9854 137.839 23.2418C137.141 24.0929 136.425 24.9254 135.783 25.8173C135.355 26.4082 135.071 26.4788 134.373 26.2558C133.606 26.0106 132.839 25.769 132.072 25.5349C131.583 25.3862 131.094 25.3825 130.608 25.5497C130.239 25.6761 129.896 25.8396 129.87 26.3153C129.849 26.6981 130.02 26.9322 130.542 27.1255C131.207 27.3708 131.886 27.5789 132.558 27.8019C133.278 28.0397 133.993 28.2813 134.713 28.5191C138.941 29.9165 139.303 35.231 136.907 37.7321C135.534 39.1629 133.895 40.0251 131.937 40.2481C131.247 40.3224 130.564 40.3819 129.874 40.3782Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M55.4184 25.8135C55.4184 30.1692 55.4221 34.5248 55.4148 38.8841C55.4148 39.5345 55.3637 39.5828 54.721 39.5865C52.4971 39.5939 50.2732 39.5939 48.0529 39.5865C47.3591 39.5828 47.2934 39.5159 47.2861 38.7801C47.2715 36.9739 47.2788 35.1714 47.2824 33.3653C47.2897 29.0802 47.308 24.799 47.308 20.5139C47.308 18.7338 47.2313 16.9536 47.3628 15.1735C47.4066 14.5937 47.5161 14.0288 47.6914 13.4788C47.958 12.6426 48.5313 12.152 49.3895 12.0517C51.1532 11.8473 52.9243 11.7767 54.6991 11.8547C55.3089 11.8807 55.3308 11.903 55.36 12.5274C55.3892 13.0811 55.3929 13.6349 55.3929 14.1886C55.3965 18.0648 55.3929 21.9373 55.3929 25.8135C55.4111 25.8135 55.4148 25.8135 55.4184 25.8135Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M31.9356 31.3214C31.9356 28.9652 31.932 26.6053 31.9356 24.2491C31.9356 23.5987 31.9941 22.9521 32.1949 22.3277C32.4944 21.4023 33.0896 20.8151 34.0609 20.6813C34.364 20.6405 34.6708 20.5921 34.9775 20.5884C36.2775 20.5736 37.5775 20.5698 38.8775 20.5736C39.5202 20.5736 39.5239 20.5921 39.5641 21.2722C39.575 21.4655 39.575 21.6588 39.6079 21.8483C39.67 22.1976 39.7941 22.2608 40.0899 22.101C40.2141 22.0341 40.3236 21.9375 40.4405 21.8557C41.0174 21.4395 41.5908 21.0121 42.175 20.607C43.1902 19.9009 44.3113 19.7671 45.4981 19.9901C45.845 20.0533 45.9874 20.2391 45.9582 20.5847C45.8961 21.328 45.8377 22.0713 45.772 22.8146C45.6916 23.7474 45.604 24.6839 45.5164 25.6167C45.5018 25.784 45.4908 25.9512 45.4652 26.1184C45.363 26.7539 45.3228 26.7874 44.7093 26.8283C44.2127 26.858 43.7197 26.884 43.2231 26.9323C41.1708 27.1256 40.0023 28.3966 39.984 30.4852C39.9658 32.8897 39.9694 35.2979 39.9658 37.7025C39.9658 38.0629 39.9694 38.4234 39.9621 38.7839C39.9511 39.5644 39.9329 39.5867 39.1551 39.5904C37.0042 39.5941 34.8534 39.5941 32.6988 39.5904C31.9429 39.5867 31.9137 39.5569 31.9137 38.7653C31.9101 36.2865 31.9137 33.8077 31.9137 31.3288H31.9356V31.3214Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M193.318 22.5804C193.683 22.3983 193.873 22.0787 194.117 21.826C195.268 20.6516 196.652 20.1908 198.255 20.4138C199.168 20.5401 199.449 20.8672 199.431 21.7926C199.405 23.0227 199.19 24.2342 199.084 25.4532C199.076 25.5238 199.054 25.5944 199.051 25.6651C198.992 26.9807 198.773 26.78 197.765 26.8692C197.156 26.9249 196.535 26.9063 195.936 27.081C194.599 27.4749 193.796 28.3371 193.584 29.7568C193.526 30.1396 193.497 30.5224 193.497 30.9052C193.493 33.4323 193.489 35.9632 193.486 38.4903C193.486 38.7059 193.482 38.9252 193.475 39.1407C193.467 39.3637 193.358 39.5012 193.135 39.5272C192.854 39.557 192.573 39.5978 192.288 39.6127C190.349 39.7205 188.41 39.6573 186.471 39.6573C186.354 39.6573 186.233 39.6499 186.116 39.635C185.602 39.5755 185.518 39.4975 185.51 38.9512C185.499 37.4572 185.503 35.9669 185.499 34.4729C185.496 30.1619 185.492 25.8509 185.496 21.5436C185.496 20.4286 185.521 20.4026 186.613 20.4249C188.077 20.4584 189.545 20.4807 191.01 20.5327C192.058 20.5699 192.7 21.0344 193.015 22.023C193.073 22.2125 193.124 22.3983 193.318 22.5804Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M22.9487 12.3751C22.956 15.3259 20.5897 17.7639 17.6866 17.7936C14.7871 17.8233 12.3295 15.3296 12.3478 12.3751C12.3624 9.42798 14.7615 7.00117 17.6537 7.00489C20.5641 7.00489 22.945 9.42055 22.9487 12.3751Z","fill":"#FFEA00"}}),_c('path',{attrs:{"d":"M33.7717 10.1936C32.143 7.02348 29.5905 4.83452 26.4938 3.25134C26.3989 3.20302 26.3003 3.1064 26.1761 3.18072C26.125 3.25505 26.1615 3.31823 26.1907 3.38141C27.0854 5.18758 27.5126 7.07923 27.2424 9.10467C27.2315 9.19758 27.2242 9.29792 27.2388 9.39083C27.2643 9.58037 27.3848 9.6324 27.5419 9.54692C27.6843 9.46516 27.8157 9.35738 27.9472 9.25704C28.6812 8.71073 29.4882 8.32051 30.3537 8.05293C30.518 8.0009 30.6969 7.89312 30.9306 8.07894C29.8826 8.71073 28.7725 9.20501 27.8997 10.0895C28.3817 10.699 28.8711 11.2602 29.2034 11.9254C29.3714 12.2636 29.5941 12.3342 29.9483 12.2636C30.6787 12.115 31.409 12.2041 32.1321 12.3491C32.2745 12.3788 32.4498 12.39 32.4936 12.6055C31.7231 12.6018 30.9635 12.5684 30.2149 12.6873C29.711 12.769 29.6818 12.8136 29.8643 13.2856C30.1054 13.9137 30.2843 14.5603 30.4304 15.2181C30.4596 15.3594 30.4851 15.5043 30.4924 15.6455C30.4961 15.7645 30.5655 15.9094 30.3902 16.0469C30.0141 14.9729 29.6233 13.9434 29.0573 12.9995C28.4986 12.0704 27.8961 11.1747 26.9978 10.4351C26.6107 11.6504 26.1104 12.6798 25.4166 13.6089C25.1317 13.9917 24.8359 14.3708 24.5146 14.7239C24.2918 14.9691 24.3357 15.1327 24.573 15.3036C24.668 15.3742 24.7593 15.4523 24.8505 15.5266C26.6472 17.0801 28.2101 18.8379 29.3823 20.9377C29.8388 21.7516 30.1893 22.6175 30.6202 23.4537C30.6714 23.1452 30.7152 22.8368 30.7736 22.532C31.1315 20.6218 32.395 19.4363 34.2427 19.2765C35.2689 19.1873 35.2689 19.1873 35.404 18.1318C35.4149 18.0352 35.4222 17.9386 35.4296 17.8456C35.6012 15.1327 35.0023 12.5869 33.7717 10.1936Z","fill":"#ABE532"}})])]:[_c('svg',{attrs:{"viewBox":"0 0 221 62","xmlns":"http://www.w3.org/2000/svg","fill":"none"}},[_c('path',{attrs:{"d":"M5.49609 49.1825V48.0698H6.48842V49.1825H5.49609ZM5.49609 57.8545V50.5652H6.48842V57.8545H5.49609Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M8.98047 57.8545V50.5652H9.87794V52.3602H9.9801V57.8545H8.98047ZM14.2486 57.8545V54.1369C14.2486 53.7319 14.2121 53.3598 14.1355 53.0205C14.0589 52.6812 13.9348 52.3821 13.767 52.1303C13.5992 51.875 13.3803 51.678 13.114 51.5393C12.8476 51.4007 12.5229 51.3314 12.1399 51.3314C11.7896 51.3314 11.4795 51.3934 11.2132 51.5138C10.9469 51.6342 10.7207 51.8093 10.5383 52.0355C10.3559 52.2617 10.2172 52.539 10.1224 52.8636C10.0275 53.1883 9.9801 53.5568 9.9801 53.9691L9.27963 53.8122C9.27963 53.0643 9.41096 52.4368 9.66999 51.9297C9.92902 51.4226 10.2902 51.0359 10.7499 50.7768C11.2096 50.5178 11.7349 50.3865 12.3296 50.3865C12.7674 50.3865 13.1468 50.4521 13.4751 50.5871C13.7998 50.7221 14.0771 50.9045 14.3033 51.1344C14.5295 51.3642 14.7155 51.6269 14.8542 51.9187C14.9928 52.2143 15.095 52.5244 15.157 52.8564C15.219 53.1883 15.2518 53.5167 15.2518 53.845V57.8545H14.2486Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M20.1952 58.0514C19.3415 58.0514 18.6374 57.8653 18.0865 57.4969C17.5356 57.1284 17.1963 56.614 17.0723 55.9573L18.0828 55.7895C18.1923 56.2054 18.4367 56.5337 18.8234 56.7782C19.2065 57.0226 19.6844 57.1466 20.2499 57.1466C20.8044 57.1466 21.2386 57.0299 21.5596 56.8C21.8807 56.5666 22.0376 56.2528 22.0376 55.8515C22.0376 55.6253 21.9865 55.4429 21.8843 55.3006C21.7822 55.1583 21.5779 55.027 21.2678 54.9066C20.9577 54.7862 20.4943 54.6403 19.8778 54.4761C19.2174 54.2973 18.6994 54.1149 18.3273 53.9362C17.9551 53.7574 17.6888 53.5494 17.5319 53.3123C17.3751 53.0752 17.2948 52.7869 17.2948 52.444C17.2948 52.0318 17.4116 51.6669 17.645 51.3532C17.8785 51.0394 18.2032 50.7986 18.6155 50.6235C19.0277 50.4521 19.5093 50.3645 20.0602 50.3645C20.6074 50.3645 21.1 50.4521 21.5341 50.6308C21.9682 50.8096 22.3185 51.0577 22.5848 51.3751C22.8511 51.6961 23.008 52.0646 23.0554 52.4878L22.0449 52.6702C21.9755 52.2434 21.7639 51.9041 21.4064 51.656C21.0489 51.4079 20.5965 51.2766 20.0456 51.2693C19.5275 51.2547 19.108 51.3532 18.7833 51.5611C18.4586 51.7691 18.2981 52.05 18.2981 52.3929C18.2981 52.5863 18.3565 52.7505 18.4732 52.8891C18.5899 53.0277 18.8015 53.1554 19.1116 53.2758C19.4181 53.3962 19.8595 53.5312 20.4323 53.6735C21.1036 53.8449 21.6289 54.0237 22.012 54.2134C22.3951 54.4031 22.6651 54.6257 22.8292 54.8811C22.9898 55.1364 23.0737 55.4538 23.0737 55.8333C23.0737 56.5228 22.8183 57.0627 22.3075 57.4567C21.7968 57.8507 21.089 58.0514 20.1952 58.0514Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M25.2949 61.094V50.5688H26.1851V56.0558H26.2945V61.0977H25.2949V61.094ZM28.5747 58.0587C27.9034 58.0587 27.338 57.8872 26.8746 57.5479C26.4113 57.2086 26.0611 56.7453 25.8203 56.1652C25.5831 55.5815 25.4627 54.9285 25.4627 54.2061C25.4627 53.4692 25.5831 52.8088 25.8239 52.2324C26.0647 51.656 26.4186 51.2 26.8856 50.8643C27.3525 50.5323 27.929 50.3645 28.6148 50.3645C29.2788 50.3645 29.8516 50.5323 30.3295 50.8716C30.8075 51.2109 31.1723 51.6669 31.4277 52.247C31.683 52.8271 31.8107 53.4801 31.8107 54.2025C31.8107 54.9321 31.683 55.5852 31.4277 56.1652C31.1723 56.7453 30.8038 57.205 30.3222 57.5443C29.8334 57.8872 29.2533 58.0587 28.5747 58.0587ZM28.4726 57.132C28.9797 57.132 29.4029 57.0043 29.7422 56.749C30.0778 56.4936 30.3332 56.1434 30.501 55.6983C30.6688 55.2568 30.7527 54.757 30.7527 54.2025C30.7527 53.6552 30.6688 53.1591 30.5046 52.7176C30.3368 52.2762 30.0851 51.9296 29.7458 51.6706C29.4065 51.4152 28.976 51.2875 28.4543 51.2875C27.9472 51.2875 27.524 51.4116 27.1884 51.6596C26.8527 51.9077 26.601 52.2507 26.4368 52.6884C26.269 53.1262 26.1887 53.6333 26.1887 54.2025C26.1887 54.7643 26.2727 55.2678 26.4368 55.7092C26.6047 56.1506 26.8564 56.5009 27.192 56.7526C27.5277 57.008 27.9582 57.132 28.4726 57.132Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M33.8984 49.1825V48.0698H34.8908V49.1825H33.8984ZM33.8984 57.8545V50.5652H34.8908V57.8545H33.8984Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M37.6602 57.8544V50.5651H38.5503V52.32L38.3752 52.0901C38.4555 51.8749 38.5613 51.6742 38.6926 51.4918C38.824 51.3094 38.9662 51.1598 39.1195 51.0431C39.3092 50.8752 39.5281 50.7512 39.7798 50.66C40.0315 50.5688 40.2869 50.5214 40.5423 50.5031C40.7977 50.4885 41.0312 50.5068 41.2428 50.5615V51.4918C40.9764 51.4261 40.6882 51.4079 40.3708 51.4444C40.0571 51.4808 39.7652 51.6049 39.4989 51.8238C39.2545 52.0135 39.072 52.2397 38.9516 52.5024C38.8313 52.765 38.751 53.046 38.7072 53.3378C38.6671 53.6333 38.6452 53.9252 38.6452 54.2097V57.8471H37.6602V57.8544Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M45.6752 58.0587C44.9638 58.0587 44.3509 57.9018 43.8292 57.5881C43.3112 57.2743 42.9062 56.8293 42.618 56.2601C42.3298 55.691 42.1875 55.0197 42.1875 54.2499C42.1875 53.4546 42.3298 52.7651 42.6143 52.185C42.8989 51.6049 43.2966 51.1562 43.811 50.8424C44.3254 50.5287 44.9346 50.3718 45.6351 50.3718C46.3538 50.3718 46.9704 50.536 47.4775 50.868C47.9846 51.2 48.3713 51.6706 48.6303 52.2872C48.8894 52.9037 49.0098 53.6407 48.9879 54.4944H47.9773V54.1441C47.9591 53.1992 47.7548 52.4878 47.368 52.0062C46.9777 51.5247 46.4122 51.2839 45.6643 51.2839C44.8799 51.2839 44.2816 51.5393 43.8657 52.0464C43.4498 52.5535 43.2418 53.2795 43.2418 54.2207C43.2418 55.1401 43.4498 55.8515 43.8657 56.355C44.2816 56.8621 44.8726 57.1138 45.6388 57.1138C46.1605 57.1138 46.6165 56.9934 47.0069 56.7526C47.3972 56.5119 47.7037 56.1653 47.9262 55.7092L48.8492 56.0668C48.561 56.7016 48.1378 57.1941 47.576 57.5407C47.0142 57.8836 46.3794 58.0587 45.6752 58.0587ZM42.888 54.4871V53.6553H48.4552V54.4871H42.888Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M53.6717 58.0514C52.818 58.0514 52.1139 57.8653 51.563 57.4969C51.0122 57.1284 50.6729 56.614 50.5488 55.9573L51.5594 55.7895C51.6688 56.2054 51.9133 56.5337 52.3 56.7782C52.6831 57.0226 53.161 57.1466 53.7265 57.1466C54.281 57.1466 54.7151 57.0299 55.0362 56.8C55.3572 56.5666 55.5141 56.2528 55.5141 55.8515C55.5141 55.6253 55.463 55.4429 55.3609 55.3006C55.2587 55.1583 55.0544 55.027 54.7443 54.9066C54.4342 54.7862 53.9709 54.6403 53.3543 54.4761C52.694 54.2973 52.176 54.1149 51.8038 53.9362C51.4317 53.7574 51.1654 53.5494 51.0085 53.3123C50.8516 53.0752 50.7714 52.7869 50.7714 52.444C50.7714 52.0318 50.8881 51.6669 51.1216 51.3532C51.3551 51.0394 51.6798 50.7986 52.092 50.6235C52.5043 50.4521 52.9859 50.3645 53.5368 50.3645C54.084 50.3645 54.5765 50.4521 55.0107 50.6308C55.4448 50.8096 55.795 51.0577 56.0614 51.3751C56.3277 51.6961 56.4846 52.0646 56.532 52.4878L55.5214 52.6702C55.4521 52.2434 55.2405 51.9041 54.883 51.656C54.5254 51.4079 54.073 51.2766 53.5222 51.2693C53.0041 51.2547 52.5846 51.3532 52.2599 51.5611C51.9352 51.7691 51.7746 52.05 51.7746 52.3929C51.7746 52.5863 51.833 52.7505 51.9498 52.8891C52.0665 53.0277 52.2781 53.1554 52.5882 53.2758C52.8947 53.3962 53.3361 53.5312 53.9089 53.6735C54.5802 53.8449 55.1055 54.0237 55.4886 54.2134C55.8716 54.4031 56.1416 54.6257 56.3058 54.8811C56.4663 55.1364 56.5502 55.4538 56.5502 55.8333C56.5502 56.5228 56.2948 57.0627 55.7841 57.4567C55.2733 57.8507 54.5656 58.0514 53.6717 58.0514Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M60.8691 51.419V50.569H65.6484V51.419H60.8691ZM65.6484 57.8546C65.2398 57.9385 64.8348 57.975 64.4371 57.9567C64.0395 57.9385 63.682 57.8546 63.3719 57.7013C63.0581 57.5481 62.821 57.311 62.6604 56.9863C62.5291 56.7163 62.4598 56.4427 62.4488 56.1654C62.4379 55.8881 62.4306 55.5707 62.4306 55.2169V48.5442H63.4156V55.1767C63.4156 55.4832 63.4193 55.7386 63.4266 55.9429C63.4339 56.1472 63.4813 56.3296 63.5652 56.4865C63.7257 56.7893 63.9848 56.968 64.3386 57.0264C64.6925 57.0848 65.1303 57.0702 65.652 56.9863V57.8546H65.6484Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M70.3302 58.0587C69.6042 58.0587 68.9876 57.8945 68.4732 57.5662C67.9588 57.2378 67.5648 56.7818 67.2912 56.2017C67.0175 55.6217 66.8789 54.954 66.8789 54.2025C66.8789 53.4363 67.0175 52.7687 67.2985 52.1923C67.5757 51.6159 67.9734 51.1671 68.4878 50.8461C69.0022 50.525 69.6151 50.3645 70.3265 50.3645C71.0562 50.3645 71.6764 50.5287 72.1908 50.8534C72.7052 51.1781 73.0992 51.6304 73.3728 52.2105C73.6464 52.7869 73.7814 53.4546 73.7814 54.2061C73.7814 54.9723 73.6428 55.6435 73.3692 56.22C73.0956 56.7964 72.6979 57.2488 72.1798 57.5735C71.6691 57.8945 71.0525 58.0587 70.3302 58.0587ZM70.3302 57.1065C71.1401 57.1065 71.742 56.8365 72.1397 56.3002C72.5337 55.7639 72.7344 55.0635 72.7344 54.2061C72.7344 53.3232 72.5337 52.6228 72.1361 52.1011C71.7384 51.5794 71.1364 51.3167 70.3302 51.3167C69.7866 51.3167 69.3378 51.4407 68.984 51.6852C68.6301 51.9296 68.3674 52.2689 68.1959 52.703C68.0208 53.1372 67.9369 53.637 67.9369 54.2061C67.9369 55.0817 68.1376 55.7858 68.5425 56.3148C68.9475 56.8402 69.5458 57.1065 70.3302 57.1065Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M78.9062 57.8545V48.1392H79.9059V52.3711H79.7964V57.8581H78.9062V57.8545ZM82.186 58.0588C81.5148 58.0588 80.9493 57.8873 80.486 57.548C80.0226 57.2087 79.6724 56.7454 79.4316 56.1653C79.1945 55.5816 79.0741 54.9286 79.0741 54.2062C79.0741 53.4693 79.1945 52.8089 79.4353 52.2325C79.676 51.6561 80.0299 51.2001 80.4969 50.8644C80.9639 50.5324 81.5403 50.3646 82.2262 50.3646C82.8902 50.3646 83.4629 50.5324 83.9409 50.8717C84.4188 51.211 84.7836 51.667 85.039 52.2471C85.2944 52.8272 85.4221 53.4802 85.4221 54.2026C85.4221 54.9322 85.2944 55.5853 85.039 56.1653C84.7836 56.7454 84.4151 57.2051 83.9336 57.5444C83.4447 57.8873 82.8646 58.0588 82.186 58.0588ZM82.0839 57.1321C82.591 57.1321 83.0142 57.0044 83.3535 56.7491C83.6891 56.4937 83.9445 56.1435 84.1123 55.6984C84.2801 55.2569 84.364 54.7571 84.364 54.2026C84.364 53.6553 84.2801 53.1592 84.116 52.7177C83.9482 52.2763 83.6964 51.9297 83.3571 51.6707C83.0178 51.4153 82.5873 51.2876 82.0656 51.2876C81.5585 51.2876 81.1353 51.4117 80.7997 51.6597C80.4641 51.9078 80.2123 52.2508 80.0482 52.6885C79.8803 53.1263 79.8001 53.6334 79.8001 54.2026C79.8001 54.7644 79.884 55.2679 80.0482 55.7093C80.2123 56.1507 80.4677 56.501 80.8034 56.7527C81.1426 57.0081 81.5695 57.1321 82.0839 57.1321Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M90.42 58.0587C89.694 58.0587 89.0774 57.8945 88.563 57.5662C88.0486 57.2378 87.6546 56.7818 87.381 56.2017C87.1074 55.6217 86.9688 54.954 86.9688 54.2025C86.9688 53.4363 87.1074 52.7687 87.3883 52.1923C87.6656 51.6159 88.0632 51.1671 88.5776 50.8461C89.092 50.525 89.705 50.3645 90.4164 50.3645C91.146 50.3645 91.7662 50.5287 92.2806 50.8534C92.795 51.1781 93.189 51.6304 93.4627 52.2105C93.7363 52.7869 93.8713 53.4546 93.8713 54.2061C93.8713 54.9723 93.7326 55.6435 93.459 56.22C93.1854 56.7964 92.7877 57.2488 92.2697 57.5735C91.7589 57.8945 91.1387 58.0587 90.42 58.0587ZM90.42 57.1065C91.2299 57.1065 91.8319 56.8365 92.2295 56.3002C92.6236 55.7639 92.8242 55.0635 92.8242 54.2061C92.8242 53.3232 92.6236 52.6228 92.2259 52.1011C91.8282 51.5794 91.2263 51.3167 90.42 51.3167C89.8764 51.3167 89.4277 51.4407 89.0738 51.6852C88.7199 51.9296 88.4572 52.2689 88.2858 52.703C88.1107 53.1372 88.0267 53.637 88.0267 54.2061C88.0267 55.0817 88.2274 55.7858 88.6324 56.3148C89.0373 56.8402 89.632 57.1065 90.42 57.1065Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M98.8731 58.0587C98.1471 58.0587 97.5306 57.8945 97.0162 57.5662C96.5018 57.2378 96.1114 56.7818 95.8341 56.2017C95.5605 55.6217 95.4219 54.954 95.4219 54.2025C95.4219 53.4363 95.5605 52.7687 95.8414 52.1923C96.1224 51.6159 96.5164 51.1671 97.0308 50.8461C97.5452 50.525 98.1581 50.3645 98.8695 50.3645C99.5991 50.3645 100.219 50.5287 100.734 50.8534C101.248 51.1781 101.642 51.6304 101.916 52.2105C102.189 52.7869 102.324 53.4546 102.324 54.2061C102.324 54.9723 102.186 55.6435 101.912 56.22C101.639 56.7964 101.241 57.2488 100.723 57.5735C100.212 57.8945 99.5955 58.0587 98.8731 58.0587ZM98.8731 57.1065C99.6831 57.1065 100.285 56.8365 100.683 56.3002C101.077 55.7639 101.277 55.0635 101.277 54.2061C101.277 53.3232 101.077 52.6228 100.679 52.1011C100.281 51.5794 99.6794 51.3167 98.8731 51.3167C98.3295 51.3167 97.8808 51.4407 97.5269 51.6852C97.173 51.9296 96.9104 52.2689 96.7389 52.703C96.5638 53.1372 96.4799 53.637 96.4799 54.2061C96.4799 55.0817 96.6805 55.7858 97.0855 56.3148C97.4905 56.8402 98.0851 57.1065 98.8731 57.1065Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M104.279 57.8545L104.287 48.1392H105.286V54.0785L108.54 50.5689H109.865L106.45 54.2135L110.31 57.8581H108.865L105.29 54.3485V57.8581H104.279V57.8545Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M150.441 33.1521C152.36 33.1448 153.856 31.649 153.863 29.7337C153.867 27.873 152.367 26.3846 150.463 26.3663C148.547 26.3444 147.081 27.7964 147.077 29.7118C147.07 31.6891 148.504 33.1557 150.441 33.1521ZM153.888 22.1234C153.888 21.6673 153.87 21.2916 153.892 20.9231C153.921 20.4853 154.027 20.3722 154.461 20.3686C156.07 20.3649 157.679 20.2774 159.281 20.5109C160.32 20.6604 161.006 21.2259 161.276 22.262C161.426 22.8384 161.521 23.4222 161.521 24.0132C161.506 28.8398 161.561 33.6665 161.415 38.4931C161.378 39.6606 161.152 40.7952 160.798 41.9006C160.178 43.8306 158.971 45.2935 157.208 46.3041C155.432 47.3219 153.494 47.8327 151.473 48.0005C147.763 48.3106 144.213 47.7306 140.882 46.0049C139.507 45.2935 139.748 45.3118 140.419 44.2647C141.174 43.09 141.94 41.9262 142.707 40.7587C143.144 40.0947 143.166 40.0874 143.885 40.496C145.001 41.1308 146.151 41.6854 147.435 41.8751C148.788 42.0757 150.127 42.021 151.415 41.5176C152.856 40.9521 153.713 39.5584 153.582 38.0371C153.564 37.8219 153.567 37.592 153.323 37.5045C153.111 37.4279 152.976 37.5957 152.823 37.7051C148.405 40.9047 142.517 39.1827 140.499 34.1043C139.419 31.39 139.168 28.6501 140.237 25.8774C140.912 24.1299 141.889 22.5867 143.374 21.3974C145.738 19.5003 150.036 18.9239 152.998 21.5871C153.217 21.7841 153.432 22.0066 153.888 22.1234Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M83.0283 29.8248C83.0247 31.7146 84.2578 32.9915 86.0892 32.9915C87.9535 32.9915 89.3325 31.6198 89.3179 29.7774C89.3033 28.008 87.9571 26.7092 86.1184 26.6983C84.2614 26.6837 83.0283 27.9314 83.0283 29.8248ZM89.8105 37.5956C89.504 37.581 89.4019 37.727 89.2851 37.8401C88.1177 38.9674 86.7058 39.5803 85.1115 39.759C83.8346 39.905 82.5613 39.8284 81.3209 39.4453C79.5479 38.9017 78.1542 37.8328 77.2057 36.2604C74.7066 32.1232 74.5242 27.9168 77.0415 23.7176C79.0116 20.4305 82.9298 19.0624 86.465 20.343C87.3187 20.6531 88.0629 21.142 88.8145 21.7914C88.9531 21.4083 88.9458 21.0653 88.9458 20.7297C88.9568 18.8837 88.9568 17.0413 88.9677 15.1953C88.9787 13.0611 89.8469 12.1709 91.9775 12.1417C93.466 12.1198 94.9582 12.1307 96.4467 12.1344C97.1763 12.1344 97.1799 12.1417 97.1799 12.9005C97.1836 18.3182 97.1836 23.7359 97.1872 29.1499C97.1872 32.178 97.1909 35.206 97.1909 38.2341C97.1909 38.3982 97.1945 38.5661 97.1872 38.7302C97.1654 39.2592 97.1617 39.2702 96.6108 39.2702C94.5058 39.2738 92.4007 39.2738 90.2957 39.2702C89.8177 39.2702 89.8141 39.2592 89.8068 38.7485C89.8068 38.38 89.8105 38.0079 89.8105 37.5956Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M23.444 15.8994C23.5096 15.9177 23.5352 15.9177 23.5534 15.9322C26.6873 18.3146 29.0696 21.2186 29.9744 25.1514C30.1021 25.7096 30.1422 26.2714 30.1422 26.8406C30.1458 30.7661 30.1422 34.6916 30.1422 38.6172C30.1422 38.7339 30.1385 38.8543 30.1422 38.971C30.1495 39.2045 30.0473 39.3249 29.8065 39.314C29.7117 39.3103 29.6168 39.314 29.522 39.314C27.0156 39.314 24.5093 39.314 22.0029 39.314C21.3937 39.314 21.39 39.3067 21.39 38.6938C21.3864 36.4245 21.39 34.1517 21.39 31.8825C21.39 31.3024 21.3827 31.2951 20.8136 31.2951C18.8034 31.2914 16.7932 31.2914 14.783 31.2951C14.2832 31.2951 14.2722 31.306 14.2722 31.8022C14.2686 34.024 14.2686 36.2494 14.2686 38.4712C14.2686 38.6354 14.2613 38.8032 14.2686 38.9674C14.2795 39.2009 14.181 39.3213 13.9402 39.314C13.8235 39.3103 13.7031 39.314 13.5864 39.314C11.1274 39.314 8.6685 39.314 6.20957 39.314C5.42885 39.314 5.50181 39.3322 5.50181 38.639C5.50546 34.8558 5.50911 31.0725 5.5164 27.2893C5.52005 25.4798 5.99068 23.787 6.80059 22.1817C8.02641 19.752 9.81041 17.7856 11.9301 16.1074C12.1891 15.8994 12.3423 15.8812 12.543 16.184C12.8968 16.7203 13.3456 17.1836 13.8709 17.5521C14.1628 17.7564 14.2285 17.9972 14.2285 18.3292C14.2139 20.0074 14.2175 21.6856 14.2248 23.3674C14.2248 23.9402 14.2358 23.9475 14.8122 23.9511C16.8005 23.9548 18.7851 23.9548 20.7734 23.9511C21.3572 23.9511 21.3645 23.9402 21.3645 23.3711C21.3681 21.7403 21.3754 20.1059 21.3572 18.4751C21.3535 18.1139 21.4301 17.8622 21.7548 17.6506C22.448 17.2018 22.9697 16.5561 23.444 15.8994Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M128.919 30.3318C129.167 30.0108 129.208 29.6569 129.291 29.3322C129.864 27.0666 130.426 24.7938 130.999 22.5282C131.068 22.2546 131.163 21.9846 131.276 21.7256C131.546 21.1272 132.009 20.7551 132.659 20.6165C132.962 20.5508 133.264 20.5143 133.575 20.5143C135.563 20.518 137.547 20.5143 139.536 20.5143C139.631 20.5143 139.725 20.5107 139.82 20.518C140.287 20.5508 140.324 20.58 140.156 21.0287C139.66 22.3567 139.153 23.681 138.638 25.0017C136.661 30.1129 134.676 35.2205 132.695 40.3317C132.25 41.4809 131.71 42.579 131.097 43.648C129.521 46.4024 127.099 47.7851 123.987 48.0223C122.185 48.1572 120.397 48.0368 118.628 47.6355C118.022 47.4969 118 47.5006 118.084 46.9205C118.317 45.3079 118.555 43.6918 118.821 42.0829C118.956 41.2657 119.306 40.9993 120.149 41.0358C120.908 41.0687 121.659 41.0942 122.411 40.9446C123.432 40.7403 124.261 39.9012 124.417 38.8943C124.476 38.5185 124.293 38.2011 124.158 37.8801C123.009 35.1329 121.853 32.3931 120.7 29.6459C119.766 27.4242 118.832 25.2024 117.905 22.9806C117.77 22.6559 117.635 22.3202 117.57 21.9773C117.431 21.2732 117.77 20.7916 118.471 20.6055C118.748 20.5326 119.029 20.5216 119.313 20.5216C121.324 20.518 123.334 20.5143 125.348 20.5143C126.066 20.5143 126.07 20.518 126.263 21.1929C127.048 23.9656 127.825 26.7419 128.617 29.511C128.682 29.7736 128.689 30.0691 128.919 30.3318Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M220.998 31.1673C220.998 33.5569 221.001 35.9465 220.998 38.3361C220.998 39.1168 220.925 39.1898 220.147 39.1934C218.112 39.2007 216.08 39.1934 214.044 39.1898C213.902 39.1898 213.759 39.1825 213.621 39.1679C213.34 39.1424 213.201 38.9891 213.194 38.7046C213.187 38.3981 213.165 38.0917 213.139 37.7852C213.125 37.5919 213.088 37.3948 212.884 37.3146C212.658 37.227 212.537 37.4058 212.417 37.5481C211.074 39.1679 209.261 39.7991 207.255 39.7735C204.288 39.7334 201.366 38.1318 200.866 33.9947C200.779 33.265 200.75 32.5354 200.75 31.7984C200.757 28.4165 200.75 25.0309 200.75 21.6489C200.75 21.4848 200.746 21.3169 200.75 21.1528C200.772 20.4268 200.841 20.3465 201.581 20.3502C202.931 20.3538 204.278 20.3647 205.627 20.3757C206.105 20.3793 206.565 20.4778 207.017 20.6274C207.959 20.9448 208.499 21.6052 208.666 22.5719C208.754 23.0608 208.779 23.557 208.787 24.0531C208.812 26.1363 208.842 28.2158 208.885 30.299C208.896 30.7951 208.896 31.2913 209.042 31.7765C209.301 32.6485 209.863 33.1118 210.72 33.1483C211.607 33.1847 212.143 32.8163 212.497 31.9224C212.771 31.2293 212.844 30.5033 212.847 29.7663C212.858 27.0447 212.866 24.3268 212.869 21.6052C212.873 20.0984 212.979 20.3611 214.099 20.3574C215.211 20.3538 216.324 20.3757 217.433 20.383C217.55 20.383 217.67 20.383 217.787 20.3903C219.502 20.4851 220.735 21.0397 220.921 23.2213C220.954 23.6226 220.998 24.0203 220.998 24.4216C220.994 26.6726 220.998 28.9199 220.998 31.1673Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M45.8022 29.3833C45.8095 27.6686 44.3502 26.191 42.6574 26.1947C40.9901 26.202 39.5819 27.6576 39.5929 29.3687C39.6038 31.1053 40.9719 32.5281 42.6537 32.5463C44.3684 32.5682 45.7949 31.1344 45.8022 29.3833ZM43.2484 19.201C45.0397 19.2338 47.236 19.8139 49.2097 21.0944C51.6102 22.6522 52.9455 24.9069 53.3651 27.7233C53.5985 29.2921 53.5073 30.8353 53.0695 32.3566C52.3472 34.8849 50.8769 36.8877 48.5493 38.1026C44.5071 40.2113 40.4247 40.2332 36.459 37.8728C33.876 36.3369 32.4897 33.9764 32.0373 31.0286C31.7673 29.2665 31.906 27.5409 32.4751 25.8554C33.2266 23.6336 34.6166 21.9299 36.6633 20.7843C38.5385 19.7373 40.5451 19.1864 43.2484 19.201Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M175.545 37.3804C175.137 37.5081 174.863 37.7708 174.575 38.0006C173.546 38.8251 172.419 39.438 171.113 39.7044C167.435 40.4523 164.115 38.1684 163.524 34.4691C163.375 33.5315 163.291 32.5902 163.287 31.6453C163.273 28.2634 163.269 24.8815 163.262 21.4995C163.262 21.4302 163.262 21.3572 163.262 21.2879C163.28 20.5838 163.353 20.4962 164.032 20.4962C165.615 20.4926 167.202 20.4816 168.785 20.5072C170.219 20.5291 171.069 21.3244 171.222 22.7472C171.361 24.0205 171.31 25.2974 171.335 26.5743C171.368 28.0627 171.292 29.5549 171.459 31.0397C171.489 31.2951 171.518 31.5578 171.587 31.8059C171.817 32.6559 172.415 33.1302 173.276 33.1557C174.148 33.1849 174.732 32.7727 175.035 31.908C175.345 31.0251 175.407 30.1058 175.414 29.1828C175.432 26.6509 175.436 24.1226 175.443 21.5907C175.443 21.401 175.44 21.2113 175.447 21.0216C175.469 20.54 175.549 20.4379 176.034 20.4233C176.625 20.405 177.216 20.4233 177.807 20.4342C178.825 20.4525 179.843 20.4671 180.857 20.4926C182.375 20.5327 183.199 21.2879 183.407 22.8056C183.488 23.393 183.524 23.9803 183.524 24.5714C183.524 29.0186 183.531 33.4658 183.535 37.9094C183.535 38.121 183.531 38.3363 183.531 38.5479C183.528 38.92 183.353 39.106 182.973 39.1279C180.73 39.2556 178.482 39.3176 176.239 39.1316C175.724 39.0878 175.669 39.0002 175.629 38.4603C175.6 38.1174 175.677 37.7635 175.545 37.3804Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M107.478 35.1403C107.927 35.1622 108.358 35.0601 108.763 34.8448C109.791 34.2903 110.547 32.5172 110.233 31.3972C110.185 31.2221 110.087 31.1856 109.923 31.2148C108.784 31.4191 107.643 31.5979 106.512 31.8241C105.833 31.959 105.461 32.4443 105.344 33.0973C105.22 33.7868 105.465 34.3523 106.063 34.7427C106.486 35.0236 106.957 35.1586 107.478 35.1403ZM109.923 37.9021C109.532 38.1574 109.222 38.3654 108.908 38.566C106.968 39.7992 104.892 40.153 102.666 39.5292C100.35 38.8798 98.77 36.9936 98.5401 34.4873C98.3285 32.2071 99.2953 30.2079 101.575 29.0258C103.086 28.2451 104.717 27.8766 106.402 27.7344C107.321 27.6577 108.237 27.5519 109.157 27.4899C109.507 27.4644 109.58 27.2966 109.576 26.9901C109.569 26.2495 109.175 25.7278 108.401 25.5016C107.431 25.2207 106.479 25.2864 105.563 25.7059C104.877 26.0197 104.202 26.3626 103.535 26.7165C103.265 26.8588 103.089 26.8661 102.878 26.6034C102.25 25.8336 101.568 25.1112 100.952 24.3342C100.211 23.4002 100.324 22.6596 101.214 21.8679C102.236 20.9632 103.476 20.5217 104.753 20.1569C107.303 19.4273 109.835 19.4929 112.352 20.3357C114.312 20.9924 115.665 22.2838 116.435 24.1955C116.913 25.3885 117.19 26.6326 117.245 27.9168C117.383 31.2732 117.31 34.6296 117.321 37.986C117.321 38.2231 117.318 38.4602 117.321 38.6937C117.329 39.033 117.205 39.2118 116.829 39.2227C114.724 39.2957 112.622 39.3468 110.517 39.2556C110.215 39.241 110.109 39.1133 110.076 38.8397C110.054 38.5624 109.992 38.2851 109.923 37.9021Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M24.4591 12.9297C24.4335 12.1417 24.4408 11.4631 24.2767 10.7954C23.5069 7.66158 20.6977 5.57478 17.4544 5.7426C14.3972 5.90312 11.7777 8.31827 11.3472 11.4047C11.2268 12.2766 11.2232 13.1668 11.5114 14.0059C11.6902 14.524 11.5041 14.7611 11.1283 15.053C9.078 16.6217 7.36332 18.4969 6.05359 20.7333C4.96276 22.5976 4.30242 24.6005 4.18203 26.7675C3.92665 26.8478 3.84274 26.6289 3.7187 26.5085C1.8289 24.6552 0.723475 22.3896 0.278387 19.8067C-0.61179 14.6042 0.635917 9.94905 3.97773 5.87393C6.33086 3.00275 9.43918 1.33549 13.0108 0.489096C15.1743 -0.0253096 17.3669 -0.152999 19.5595 0.197235C22.8721 0.726233 26.1118 3.01369 26.3343 7.67253C26.4073 9.16102 25.9257 11.288 24.4591 12.9297Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M62.9587 25.5343V38.2376C62.9587 38.4017 62.9477 38.5696 62.9623 38.7337C62.9842 39.0256 62.8893 39.1898 62.5683 39.1642C62.499 39.1569 62.426 39.1642 62.3567 39.1642C60.0619 39.1642 57.7672 39.1679 55.4724 39.1642C54.9069 39.1642 54.8996 39.1569 54.8777 38.5805C54.8632 38.1792 54.8668 37.7779 54.8705 37.3729C54.8741 30.3719 54.8814 23.3709 54.8814 16.3662C54.8814 15.56 54.9179 14.7573 55.0748 13.9657C55.3155 12.7508 55.9722 12.1853 57.2126 12.0905C58.9346 11.9555 60.6639 11.9847 62.3895 11.9409C62.9477 11.9263 62.955 11.9445 62.955 12.5501C62.9623 16.877 62.9587 21.2038 62.9587 25.5343Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M185.498 29.7918C185.498 27.1177 185.498 24.4435 185.498 21.7693C185.498 21.5796 185.494 21.3899 185.498 21.2002C185.516 20.383 185.582 20.3027 186.406 20.3246C187.989 20.3684 189.576 20.3319 191.16 20.4231C192.112 20.4778 192.696 20.9448 192.991 21.824C193.006 21.8678 193.02 21.9152 193.039 21.959C193.258 22.4807 193.371 22.5172 193.75 22.0685C194.775 20.8572 196.063 20.2224 197.654 20.2261C197.701 20.2261 197.749 20.2261 197.796 20.2297C199.12 20.2881 199.511 20.6639 199.419 21.97C199.325 23.3125 199.153 24.6514 198.996 25.9903C198.942 26.4719 198.807 26.5741 198.299 26.6106C197.829 26.647 197.355 26.6616 196.884 26.7054C194.629 26.9243 193.531 28.099 193.498 30.3646C193.476 31.9261 193.487 33.4875 193.484 35.049C193.48 36.0887 193.484 37.1321 193.48 38.1719C193.476 39.0767 193.476 39.0876 192.546 39.1679C191.342 39.2737 190.135 39.2554 188.927 39.2481C188.051 39.2408 187.176 39.2554 186.3 39.2226C185.567 39.1971 185.498 39.1132 185.498 38.3762C185.494 35.5123 185.498 32.6484 185.498 29.7882V29.7918Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M73.6552 29.8794C73.6552 32.6922 73.6552 35.505 73.6552 38.3178C73.6552 38.482 73.6333 38.6498 73.6479 38.814C73.6771 39.1679 73.502 39.2518 73.1809 39.2481C71.645 39.2372 70.1091 39.2445 68.5732 39.2445C67.6976 39.2445 66.8257 39.2518 65.9501 39.2408C65.4539 39.2372 65.4539 39.2263 65.4284 38.7191C65.4211 38.555 65.4247 38.3872 65.4247 38.223C65.4247 33.4474 65.4247 28.6755 65.4247 23.8999C65.4247 23.3818 65.4247 22.8638 65.5269 22.3457C65.7677 21.1528 66.5046 20.4231 67.7013 20.3903C69.5436 20.3392 71.3897 20.372 73.232 20.3611C73.5056 20.3574 73.6187 20.4742 73.6224 20.7332C73.626 20.9922 73.6443 21.2513 73.6443 21.5139C73.6479 24.3012 73.6443 27.0921 73.6443 29.8794C73.6443 29.8794 73.6516 29.8794 73.6552 29.8794Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M32.9228 12.4918C32.1749 12.1598 31.3869 12.0467 30.5952 12.189C30.0261 12.2911 29.6649 12.1853 29.4132 11.6308C29.1979 11.1565 28.855 10.7516 28.5011 10.3721C28.2567 10.1095 28.3114 9.938 28.5668 9.741C29.3001 9.17552 30.0881 8.70124 30.9162 8.29263C31.1242 8.19048 31.3321 8.08103 31.5437 7.97523C31.4051 7.77823 31.2519 7.86943 31.1205 7.90592C30.1793 8.16494 29.2855 8.52612 28.4792 9.08796C28.3625 9.16822 28.253 9.25942 28.129 9.33239C27.9794 9.41995 27.8626 9.66073 27.6474 9.51115C27.4796 9.39441 27.5817 9.212 27.5963 9.05147C27.6219 8.79245 27.6474 8.53342 27.6583 8.27439C27.7131 6.70929 27.392 5.22444 26.739 3.80162C26.6441 3.59367 26.4872 3.40761 26.469 3.17412C26.542 3.09751 26.6076 3.13399 26.6697 3.16317C30.245 4.92164 33.0614 7.43894 34.674 11.1565C35.5933 13.2725 36.0384 15.4797 35.856 17.7927C35.8122 18.3327 35.6772 18.8617 35.586 19.3979C35.5495 19.6241 35.4218 19.781 35.2358 19.9051C33.47 21.0835 32.2369 22.696 31.416 24.6369C31.4088 24.6551 31.3796 24.666 31.3577 24.6806C31.1862 24.677 31.2154 24.5274 31.1899 24.4289C30.5186 21.773 29.1286 19.5183 27.3045 17.5118C26.5712 16.7055 25.7795 15.9613 24.9331 15.2718C24.5646 14.969 24.561 14.9398 24.8674 14.6114C25.9801 13.4184 26.7937 12.0467 27.3336 10.394C29.1432 11.981 30.1027 13.9949 30.8688 16.1401C30.8798 14.9726 30.4857 13.9 30.0698 12.7836C31.0184 12.4553 31.9779 12.5684 32.9228 12.4918Z","fill":"#ACE632"}}),_c('path',{attrs:{"d":"M17.8565 17.6834C15.3683 17.7709 12.5227 15.7243 12.5118 12.2985C12.5008 9.33251 14.9524 6.96844 17.9258 6.98668C20.859 7.00492 23.234 9.39453 23.234 12.335C23.2377 15.3011 20.8371 17.687 17.8565 17.6834Z","fill":"#FFEA0F"}}),_c('path',{attrs:{"d":"M65.5121 14.8377C65.5523 12.4773 67.515 10.5583 69.8536 10.5875C72.1702 10.6203 74.1111 12.6378 74.0673 14.9691C74.0272 17.2675 72.0498 19.1171 69.6784 19.0624C67.3946 19.0113 65.4027 17.1179 65.5121 14.8377Z","fill":"#2D2D2D"}})])]],2)
}
var guru_logovue_type_template_id_03134204_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo.vue?vue&type=template&id=03134204&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-logo.vue?vue&type=script&lang=js

/* harmony default export */ var guru_logovue_type_script_lang_js = ({
  name: 'Logo',
  props: {
    lang: {
      type: String,
      default: 'de',
    },
  },
});

// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo.vue?vue&type=script&lang=js
 /* harmony default export */ var logos_guru_logovue_type_script_lang_js = (guru_logovue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/svg/logos/guru-logo.vue?vue&type=style&index=0&id=03134204&prod&lang=postcss&scoped=true
var guru_logovue_type_style_index_0_id_03134204_prod_lang_postcss_scoped_true = __webpack_require__("ae0f");

// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo.vue






/* normalize component */

var guru_logo_component = normalizeComponent(
  logos_guru_logovue_type_script_lang_js,
  guru_logovue_type_template_id_03134204_scoped_true_render,
  guru_logovue_type_template_id_03134204_scoped_true_staticRenderFns,
  false,
  null,
  "03134204",
  null
  
)

/* harmony default export */ var guru_logo = (guru_logo_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-logo-plain.vue?vue&type=template&id=8b90c156&scoped=true
var guru_logo_plainvue_type_template_id_8b90c156_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(['de', 'at'].includes(_vm.lang))?[_c('svg',{attrs:{"viewBox":"0 0 221 49","xmlns":"http://www.w3.org/2000/svg","fill":"none"}},[_c('path',{attrs:{"d":"M150.472 26.6052C148.519 26.5829 147.084 27.9988 147.069 29.9611C147.054 31.9456 148.453 33.4396 150.345 33.4694C152.309 33.4991 153.839 31.994 153.854 30.0168C153.869 28.1103 152.397 26.6275 150.472 26.6052ZM153.879 22.2756C153.879 21.8445 153.865 21.4654 153.883 21.09C153.909 20.6069 154.015 20.4805 154.478 20.4694C156.063 20.4397 157.652 20.3988 159.226 20.6106C160.365 20.763 161 21.365 161.285 22.4985C161.428 23.0597 161.515 23.6321 161.512 24.2118C161.501 29.0766 161.541 33.9376 161.406 38.8024C161.373 39.9656 161.161 41.0954 160.829 42.2066C160.215 44.2655 158.981 45.8078 157.144 46.867C155.384 47.8816 153.47 48.3907 151.473 48.5617C147.788 48.8776 144.257 48.3052 140.945 46.5771C139.455 45.8004 139.725 45.845 140.434 44.7226C141.19 43.5297 141.957 42.3404 142.723 41.1549C143.118 40.5454 143.169 40.5305 143.797 40.891C144.893 41.5228 146.014 42.0877 147.266 42.307C148.595 42.5374 149.91 42.4891 151.192 42.0543C152.755 41.5228 153.704 40.0623 153.573 38.4419C153.554 38.2264 153.562 37.9922 153.321 37.8919C153.109 37.8064 152.974 37.9774 152.824 38.0889C148.471 41.2887 142.65 39.6683 140.573 34.6363C138.798 30.3364 139.262 26.3116 142.194 22.6584C144.747 19.4771 149.852 18.8119 152.992 21.707C153.226 21.9411 153.456 22.1864 153.879 22.2756Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M110.739 33.4769C112.641 33.4918 114.091 32.0238 114.109 30.069C114.124 28.0918 112.736 26.6313 110.804 26.6053C108.822 26.5756 107.354 28.0101 107.339 29.9872C107.324 31.9235 108.822 33.462 110.739 33.4769ZM106.82 37.7248C106.82 38.2265 106.835 38.6353 106.817 39.0404C106.795 39.5272 106.726 39.6127 106.284 39.6164C104.275 39.6276 102.263 39.6276 100.255 39.6127C99.8092 39.609 99.7361 39.5123 99.6923 39.0515C99.6704 38.8137 99.6741 38.5721 99.6741 38.3305C99.6741 31.039 99.6777 23.7474 99.6741 16.4558C99.6741 15.8054 99.696 15.1551 99.7617 14.5084C99.926 12.9438 100.689 12.1894 102.23 12.063C103.811 11.9367 105.396 11.9738 106.981 11.985C107.617 11.9887 107.66 12.0296 107.664 12.6911C107.675 14.5196 107.671 16.348 107.675 18.1765C107.675 19.139 107.664 20.1016 107.679 21.0641C107.69 21.6848 107.795 21.7517 108.358 21.4915C108.811 21.2834 109.245 21.0418 109.687 20.8151C112.835 19.1874 116.267 19.7745 118.721 22.35C120.35 24.0596 121.197 26.1407 121.457 28.4746C121.756 31.1542 121.296 33.6962 119.959 36.0524C117.987 39.5309 114.058 41.0584 110.315 39.7985C109.38 39.4826 108.559 38.9772 107.814 38.3305C107.551 38.1038 107.295 37.8585 106.82 37.7248Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M12.1175 15.9243C12.6543 16.6825 13.213 17.3365 13.9251 17.8197C14.1734 17.9869 14.1332 18.2285 14.1332 18.4626C14.1332 19.8823 14.1332 21.3019 14.1332 22.7216C14.1332 24.3345 14.1369 25.9474 14.1405 27.5604C14.1405 28.0918 14.1734 28.6158 14.2756 29.1398C14.6956 31.3065 16.1197 32.139 18.1464 31.9383C19.6729 31.7896 20.7392 30.645 20.9583 29.0432C21.0496 28.3743 21.1043 27.7053 21.1043 27.0289C21.1007 24.2379 21.1226 21.4432 21.108 18.6522C21.1043 18.1988 21.2139 17.9014 21.601 17.6413C22.2327 17.2102 22.7184 16.6081 23.1383 15.9801C23.3976 16.0024 23.5364 16.1845 23.6934 16.3145C25.6142 17.8829 27.2392 19.7076 28.4041 21.93C29.2842 23.6098 29.8064 25.3826 29.8173 27.3114C29.8283 28.902 29.8502 30.4926 29.4448 32.0423C28.5794 35.3611 26.5782 37.7507 23.4487 38.9734C19.5925 40.4786 15.6523 40.5789 11.7377 39.0701C10.5801 38.6241 9.5211 37.9886 8.58261 37.1635C6.67277 35.48 5.70507 33.3171 5.53709 30.7862C5.45675 29.5895 5.42023 28.3854 5.44945 27.1813C5.49327 25.4123 5.96434 23.7659 6.74945 22.205C8.01295 19.689 9.85706 17.6859 12.1175 15.9243Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M220.998 31.444C220.998 33.8745 221.001 36.3088 220.998 38.7393C220.998 39.542 220.928 39.6164 220.158 39.6164C218.098 39.6201 216.042 39.6201 213.983 39.6126C213.252 39.6089 213.22 39.5681 213.19 38.8434C213.176 38.5312 213.19 38.2116 213.081 37.9143C212.99 37.6653 212.781 37.6169 212.573 37.7805C212.5 37.8399 212.442 37.918 212.38 37.9886C210.459 40.1106 207.457 40.7907 204.777 39.7241C202.352 38.7616 201.198 36.8588 200.869 34.3316C200.778 33.6144 200.745 32.8934 200.749 32.1687C200.753 28.679 200.749 25.1856 200.749 21.6959C200.749 21.5509 200.745 21.406 200.753 21.2611C200.775 20.5401 200.866 20.4397 201.596 20.4435C202.896 20.4472 204.2 20.4583 205.5 20.4806C205.996 20.4881 206.489 20.5624 206.964 20.7222C207.936 21.0418 208.502 21.7182 208.673 22.7365C208.754 23.2122 208.783 23.6916 208.79 24.1747C208.819 26.3414 208.848 28.508 208.892 30.6747C208.903 31.2024 208.914 31.7339 209.093 32.243C209.367 33.0235 209.933 33.4434 210.751 33.4732C211.569 33.4992 212.084 33.1758 212.427 32.4028C212.785 31.5927 212.851 30.7342 212.854 29.8608C212.858 27.1404 212.869 24.42 212.873 21.6996C212.876 20.4546 212.876 20.4472 214.067 20.462C215.25 20.4732 216.433 20.4918 217.616 20.5178C218.138 20.5289 218.657 20.5698 219.154 20.7408C219.95 21.0121 220.49 21.5509 220.727 22.3723C220.928 23.0709 220.998 23.7882 220.998 24.5129C220.994 26.8208 220.994 29.1324 220.998 31.444Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M175.549 37.7655C175.122 37.9141 174.848 38.178 174.556 38.4158C173.508 39.2706 172.361 39.9284 171.017 40.1551C167.19 40.8018 164.094 38.4976 163.513 34.7923C163.352 33.7703 163.276 32.7372 163.272 31.7003C163.265 28.4261 163.257 25.152 163.254 21.8778C163.254 21.6623 163.246 21.443 163.261 21.2275C163.294 20.7406 163.393 20.6031 163.849 20.5994C165.551 20.5883 167.256 20.5548 168.958 20.6217C170.291 20.6737 171.072 21.5099 171.215 22.8553C171.361 24.2452 171.306 25.6463 171.335 27.0399C171.364 28.4819 171.295 29.9276 171.456 31.3695C171.488 31.6817 171.525 31.9939 171.631 32.2875C171.897 33.0382 172.504 33.4581 173.325 33.4693C174.114 33.4804 174.695 33.1051 174.983 32.3581C175.341 31.4253 175.403 30.433 175.414 29.4482C175.436 26.8467 175.436 24.2489 175.447 21.6474C175.447 21.4542 175.458 21.2609 175.45 21.0714C175.436 20.6997 175.626 20.5474 175.969 20.5511C176.396 20.5548 176.82 20.5511 177.247 20.5548C178.383 20.5622 179.519 20.5697 180.654 20.5883C182.407 20.618 183.203 21.3538 183.426 23.1043C183.488 23.606 183.528 24.1077 183.528 24.6131C183.528 29.2103 183.535 33.8075 183.539 38.4047C183.539 38.5979 183.539 38.7912 183.535 38.9807C183.528 39.3226 183.364 39.5233 183.02 39.5419C180.727 39.6683 178.438 39.724 176.144 39.5456C175.786 39.5196 175.659 39.3152 175.637 38.9844C175.6 38.6091 175.666 38.2226 175.549 37.7655Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M89.7823 37.9699C89.3733 37.8621 89.1031 38.126 88.8219 38.3341C87.9346 38.9808 86.9997 39.5419 85.9553 39.8913C82.2306 41.1325 78.546 39.0477 77.6952 35.2086C77.5527 34.5768 77.4797 33.9264 77.4797 33.2761C77.4724 29.9536 77.4724 26.6312 77.4688 23.3087C77.4688 22.9445 77.5235 22.5877 77.6294 22.2421C77.8997 21.3613 78.4547 20.8001 79.3786 20.6663C79.6342 20.6292 79.8971 20.6032 80.1564 20.5994C81.6938 20.5846 83.2311 20.5771 84.7685 20.5771C85.4222 20.5771 85.4404 20.5994 85.4368 21.2758C85.4331 24.5017 85.4331 27.7275 85.5536 30.9533C85.5682 31.3881 85.5792 31.8192 85.7289 32.2318C86.0028 32.9788 86.5104 33.4173 87.3101 33.473C88.139 33.5288 88.7489 33.1943 89.0995 32.4473C89.4208 31.7635 89.534 31.0277 89.545 30.2732C89.5851 28.0583 89.6326 25.8433 89.6764 23.632C89.6801 23.4388 89.6837 23.2455 89.702 23.056C89.8481 21.5471 90.6916 20.6998 92.1778 20.5957C92.7439 20.5548 93.3135 20.5474 93.8795 20.5437C94.8984 20.54 95.9135 20.54 96.9324 20.5586C97.4436 20.5697 97.4911 20.6366 97.513 21.1532C97.5166 21.2721 97.513 21.3947 97.513 21.5137C97.513 27.2444 97.5166 32.9751 97.5166 38.702C97.5166 38.847 97.5093 38.9919 97.5166 39.1368C97.5386 39.4825 97.356 39.6125 97.0456 39.62C96.8812 39.6237 96.7133 39.6237 96.5489 39.6237C94.6793 39.6237 92.8132 39.6237 90.9436 39.6237C90.7537 39.6237 90.5638 39.6311 90.3776 39.6163C89.9065 39.5791 89.8627 39.5271 89.8334 39.0514C89.8079 38.6909 89.8773 38.3267 89.7823 37.9699Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M68.6019 32.4177C68.591 32.2505 68.58 32.0833 68.5727 31.916C68.5618 31.589 68.4047 31.4217 68.0797 31.4775C67.0098 31.6521 65.9325 31.7711 64.8881 32.0721C64.2235 32.2616 63.8547 32.7076 63.778 33.4026C63.7013 34.0938 63.9606 34.6178 64.5339 34.9858C65.5053 35.6138 66.8235 35.4875 67.6744 34.6736C68.3061 34.0604 68.5983 33.3022 68.6019 32.4177ZM75.6862 33.332C75.6862 35.1604 75.6899 36.9889 75.6826 38.8211C75.6789 39.5644 75.6643 39.5867 74.9157 39.5904C73.0461 39.6015 71.18 39.6015 69.3104 39.5978C68.5764 39.5941 68.5654 39.5755 68.4157 38.8731C68.2988 38.3119 68.2623 38.2822 67.7985 38.5832C66.7943 39.2299 65.7536 39.7948 64.5704 40.0215C62.9418 40.3337 61.3642 40.2073 59.8999 39.3562C57.2159 37.7954 56.3285 34.6736 57.3693 31.9272C57.833 30.7045 58.7167 29.8534 59.8378 29.2476C61.1707 28.5304 62.6022 28.1327 64.0921 27.958C65.1255 27.8391 66.1626 27.7685 67.1997 27.6719C67.9592 27.6013 68.1528 27.2854 67.8898 26.5681C67.7182 26.0998 67.3749 25.8285 66.9258 25.6836C66.064 25.4012 65.2058 25.4235 64.3513 25.7171C63.6064 25.9698 62.9162 26.334 62.2406 26.7354C61.6892 27.0624 61.5943 27.0401 61.1597 26.5495C60.685 26.0144 60.203 25.4829 59.7429 24.9329C58.5305 23.4872 58.64 22.5767 60.1811 21.4915C61.1634 20.7965 62.2845 20.4063 63.4311 20.1053C65.7755 19.4847 68.1126 19.5367 70.4314 20.2316C73.2104 21.0678 74.7258 23.0524 75.3357 25.8583C75.5584 26.8952 75.6789 27.9432 75.6716 29.0061C75.6643 30.4518 75.668 31.8937 75.668 33.3394H75.6862V33.332Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M24.1419 12.9623C24.1419 12.193 24.1273 11.5055 23.9739 10.8179C23.3604 8.09382 20.6655 5.3474 16.7362 5.83425C13.6359 6.22075 11.182 9.05637 11.1528 12.3082C11.1491 12.94 11.182 13.5681 11.3901 14.159C11.5435 14.5864 11.3901 14.8056 11.0688 15.0546C9.03478 16.6304 7.31848 18.5035 6.01482 20.7556C5.00694 22.4986 4.33868 24.3605 4.17435 26.3897C4.1634 26.5086 4.14514 26.6275 4.11958 26.7464C4.11227 26.791 4.07941 26.8319 4.05385 26.8765C3.853 26.9025 3.77997 26.7241 3.67042 26.6164C1.80074 24.7767 0.708881 22.5135 0.277979 19.9306C-0.686073 14.1181 0.858601 9.06008 4.89374 4.83825C7.24544 2.378 10.207 1.03638 13.4753 0.363707C15.4399 -0.041381 17.4301 -0.134291 19.402 0.218767C26.0737 1.42288 27.622 8.51006 24.3318 12.8397C24.3135 12.8731 24.2624 12.888 24.1419 12.9623Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M129.874 40.3782C127.11 40.3484 124.484 39.7724 122.089 38.3007C121.252 37.7878 121.249 37.747 121.935 37C122.6 36.279 123.272 35.5691 123.918 34.837C124.495 34.1829 125.174 33.9339 126.018 34.1458C126.956 34.3799 127.899 34.6103 128.841 34.8333C129.359 34.9597 129.874 34.982 130.342 34.6512C130.897 34.2573 130.908 33.6924 130.363 33.291C130.152 33.1349 129.903 33.0494 129.659 32.9602C128.611 32.5923 127.563 32.2207 126.515 31.849C126.292 31.771 126.069 31.6892 125.85 31.5963C122.344 30.1209 121.234 25.9102 123.568 22.8553C124.879 21.1421 126.664 20.1907 128.746 19.8674C132.062 19.3508 135.184 19.9974 138.101 21.6772C138.185 21.7256 138.262 21.7776 138.346 21.8259C138.635 21.9894 138.697 22.1901 138.467 22.4614C138.248 22.7141 138.05 22.9854 137.839 23.2418C137.141 24.0929 136.425 24.9254 135.783 25.8173C135.355 26.4082 135.071 26.4788 134.373 26.2558C133.606 26.0106 132.839 25.769 132.072 25.5349C131.583 25.3862 131.094 25.3825 130.608 25.5497C130.239 25.6761 129.896 25.8396 129.87 26.3153C129.849 26.6981 130.02 26.9322 130.542 27.1255C131.207 27.3708 131.886 27.5789 132.558 27.8019C133.278 28.0397 133.993 28.2813 134.713 28.5191C138.941 29.9165 139.303 35.231 136.907 37.7321C135.534 39.1629 133.895 40.0251 131.937 40.2481C131.247 40.3224 130.564 40.3819 129.874 40.3782Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M55.4184 25.8135C55.4184 30.1692 55.4221 34.5248 55.4148 38.8841C55.4148 39.5345 55.3637 39.5828 54.721 39.5865C52.4971 39.5939 50.2732 39.5939 48.0529 39.5865C47.3591 39.5828 47.2934 39.5159 47.2861 38.7801C47.2715 36.9739 47.2788 35.1714 47.2824 33.3653C47.2897 29.0802 47.308 24.799 47.308 20.5139C47.308 18.7338 47.2313 16.9536 47.3628 15.1735C47.4066 14.5937 47.5161 14.0288 47.6914 13.4788C47.958 12.6426 48.5313 12.152 49.3895 12.0517C51.1532 11.8473 52.9243 11.7767 54.6991 11.8547C55.3089 11.8807 55.3308 11.903 55.36 12.5274C55.3892 13.0811 55.3929 13.6349 55.3929 14.1886C55.3965 18.0648 55.3929 21.9373 55.3929 25.8135C55.4111 25.8135 55.4148 25.8135 55.4184 25.8135Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M31.9356 31.3214C31.9356 28.9652 31.932 26.6053 31.9356 24.2491C31.9356 23.5987 31.9941 22.9521 32.1949 22.3277C32.4944 21.4023 33.0896 20.8151 34.0609 20.6813C34.364 20.6405 34.6708 20.5921 34.9775 20.5884C36.2775 20.5736 37.5775 20.5698 38.8775 20.5736C39.5202 20.5736 39.5239 20.5921 39.5641 21.2722C39.575 21.4655 39.575 21.6588 39.6079 21.8483C39.67 22.1976 39.7941 22.2608 40.0899 22.101C40.2141 22.0341 40.3236 21.9375 40.4405 21.8557C41.0174 21.4395 41.5908 21.0121 42.175 20.607C43.1902 19.9009 44.3113 19.7671 45.4981 19.9901C45.845 20.0533 45.9874 20.2391 45.9582 20.5847C45.8961 21.328 45.8377 22.0713 45.772 22.8146C45.6916 23.7474 45.604 24.6839 45.5164 25.6167C45.5018 25.784 45.4908 25.9512 45.4652 26.1184C45.363 26.7539 45.3228 26.7874 44.7093 26.8283C44.2127 26.858 43.7197 26.884 43.2231 26.9323C41.1708 27.1256 40.0023 28.3966 39.984 30.4852C39.9658 32.8897 39.9694 35.2979 39.9658 37.7025C39.9658 38.0629 39.9694 38.4234 39.9621 38.7839C39.9511 39.5644 39.9329 39.5867 39.1551 39.5904C37.0042 39.5941 34.8534 39.5941 32.6988 39.5904C31.9429 39.5867 31.9137 39.5569 31.9137 38.7653C31.9101 36.2865 31.9137 33.8077 31.9137 31.3288H31.9356V31.3214Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M193.318 22.5804C193.683 22.3983 193.873 22.0787 194.117 21.826C195.268 20.6516 196.652 20.1908 198.255 20.4138C199.168 20.5401 199.449 20.8672 199.431 21.7926C199.405 23.0227 199.19 24.2342 199.084 25.4532C199.076 25.5238 199.054 25.5944 199.051 25.6651C198.992 26.9807 198.773 26.78 197.765 26.8692C197.156 26.9249 196.535 26.9063 195.936 27.081C194.599 27.4749 193.796 28.3371 193.584 29.7568C193.526 30.1396 193.497 30.5224 193.497 30.9052C193.493 33.4323 193.489 35.9632 193.486 38.4903C193.486 38.7059 193.482 38.9252 193.475 39.1407C193.467 39.3637 193.358 39.5012 193.135 39.5272C192.854 39.557 192.573 39.5978 192.288 39.6127C190.349 39.7205 188.41 39.6573 186.471 39.6573C186.354 39.6573 186.233 39.6499 186.116 39.635C185.602 39.5755 185.518 39.4975 185.51 38.9512C185.499 37.4572 185.503 35.9669 185.499 34.4729C185.496 30.1619 185.492 25.8509 185.496 21.5436C185.496 20.4286 185.521 20.4026 186.613 20.4249C188.077 20.4584 189.545 20.4807 191.01 20.5327C192.058 20.5699 192.7 21.0344 193.015 22.023C193.073 22.2125 193.124 22.3983 193.318 22.5804Z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M22.9487 12.3751C22.956 15.3259 20.5897 17.7639 17.6866 17.7936C14.7871 17.8233 12.3295 15.3296 12.3478 12.3751C12.3624 9.42798 14.7615 7.00117 17.6537 7.00489C20.5641 7.00489 22.945 9.42055 22.9487 12.3751Z","fill":"#FFEA00"}}),_c('path',{attrs:{"d":"M33.7717 10.1936C32.143 7.02348 29.5905 4.83452 26.4938 3.25134C26.3989 3.20302 26.3003 3.1064 26.1761 3.18072C26.125 3.25505 26.1615 3.31823 26.1907 3.38141C27.0854 5.18758 27.5126 7.07923 27.2424 9.10467C27.2315 9.19758 27.2242 9.29792 27.2388 9.39083C27.2643 9.58037 27.3848 9.6324 27.5419 9.54692C27.6843 9.46516 27.8157 9.35738 27.9472 9.25704C28.6812 8.71073 29.4882 8.32051 30.3537 8.05293C30.518 8.0009 30.6969 7.89312 30.9306 8.07894C29.8826 8.71073 28.7725 9.20501 27.8997 10.0895C28.3817 10.699 28.8711 11.2602 29.2034 11.9254C29.3714 12.2636 29.5941 12.3342 29.9483 12.2636C30.6787 12.115 31.409 12.2041 32.1321 12.3491C32.2745 12.3788 32.4498 12.39 32.4936 12.6055C31.7231 12.6018 30.9635 12.5684 30.2149 12.6873C29.711 12.769 29.6818 12.8136 29.8643 13.2856C30.1054 13.9137 30.2843 14.5603 30.4304 15.2181C30.4596 15.3594 30.4851 15.5043 30.4924 15.6455C30.4961 15.7645 30.5655 15.9094 30.3902 16.0469C30.0141 14.9729 29.6233 13.9434 29.0573 12.9995C28.4986 12.0704 27.8961 11.1747 26.9978 10.4351C26.6107 11.6504 26.1104 12.6798 25.4166 13.6089C25.1317 13.9917 24.8359 14.3708 24.5146 14.7239C24.2918 14.9691 24.3357 15.1327 24.573 15.3036C24.668 15.3742 24.7593 15.4523 24.8505 15.5266C26.6472 17.0801 28.2101 18.8379 29.3823 20.9377C29.8388 21.7516 30.1893 22.6175 30.6202 23.4537C30.6714 23.1452 30.7152 22.8368 30.7736 22.532C31.1315 20.6218 32.395 19.4363 34.2427 19.2765C35.2689 19.1873 35.2689 19.1873 35.404 18.1318C35.4149 18.0352 35.4222 17.9386 35.4296 17.8456C35.6012 15.1327 35.0023 12.5869 33.7717 10.1936Z","fill":"#ABE532"}})])]:[_c('svg',{attrs:{"viewBox":"0 0 221 49","xmlns":"http://www.w3.org/2000/svg","fill":"none"}},[_c('path',{attrs:{"d":"M150.441 33.1521C152.36 33.1448 153.856 31.649 153.863 29.7337C153.867 27.873 152.367 26.3846 150.463 26.3663C148.547 26.3444 147.081 27.7964 147.077 29.7118C147.07 31.6891 148.504 33.1557 150.441 33.1521ZM153.888 22.1234C153.888 21.6673 153.87 21.2916 153.892 20.9231C153.921 20.4853 154.027 20.3722 154.461 20.3686C156.07 20.3649 157.679 20.2774 159.281 20.5109C160.32 20.6604 161.006 21.2259 161.276 22.262C161.426 22.8384 161.521 23.4222 161.521 24.0132C161.506 28.8398 161.561 33.6665 161.415 38.4931C161.378 39.6606 161.152 40.7952 160.798 41.9006C160.178 43.8306 158.971 45.2935 157.208 46.3041C155.432 47.3219 153.494 47.8327 151.473 48.0005C147.763 48.3106 144.213 47.7306 140.882 46.0049C139.507 45.2935 139.748 45.3118 140.419 44.2647C141.174 43.09 141.94 41.9262 142.707 40.7587C143.144 40.0947 143.166 40.0874 143.885 40.496C145.001 41.1308 146.151 41.6854 147.435 41.8751C148.788 42.0757 150.127 42.021 151.415 41.5176C152.856 40.9521 153.713 39.5584 153.582 38.0371C153.564 37.8219 153.567 37.592 153.323 37.5045C153.111 37.4279 152.976 37.5957 152.823 37.7051C148.405 40.9047 142.517 39.1827 140.499 34.1043C139.419 31.39 139.168 28.6501 140.237 25.8774C140.912 24.1299 141.889 22.5867 143.374 21.3974C145.738 19.5003 150.036 18.9239 152.998 21.5871C153.217 21.7841 153.432 22.0066 153.888 22.1234Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M83.0283 29.8248C83.0247 31.7146 84.2578 32.9915 86.0892 32.9915C87.9535 32.9915 89.3325 31.6198 89.3179 29.7774C89.3033 28.008 87.9571 26.7092 86.1184 26.6983C84.2614 26.6837 83.0283 27.9314 83.0283 29.8248ZM89.8105 37.5956C89.504 37.581 89.4019 37.727 89.2851 37.8401C88.1177 38.9674 86.7058 39.5803 85.1115 39.759C83.8346 39.905 82.5613 39.8284 81.3209 39.4453C79.5479 38.9017 78.1542 37.8328 77.2057 36.2604C74.7066 32.1232 74.5242 27.9168 77.0415 23.7176C79.0116 20.4305 82.9298 19.0624 86.465 20.343C87.3187 20.6531 88.0629 21.142 88.8145 21.7914C88.9531 21.4083 88.9458 21.0653 88.9458 20.7297C88.9568 18.8837 88.9568 17.0413 88.9677 15.1953C88.9787 13.0611 89.8469 12.1709 91.9775 12.1417C93.466 12.1198 94.9582 12.1307 96.4467 12.1344C97.1763 12.1344 97.1799 12.1417 97.1799 12.9005C97.1836 18.3182 97.1836 23.7359 97.1872 29.1499C97.1872 32.178 97.1909 35.206 97.1909 38.2341C97.1909 38.3982 97.1945 38.5661 97.1872 38.7302C97.1654 39.2592 97.1617 39.2702 96.6108 39.2702C94.5058 39.2738 92.4007 39.2738 90.2957 39.2702C89.8177 39.2702 89.8141 39.2592 89.8068 38.7485C89.8068 38.38 89.8105 38.0079 89.8105 37.5956Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M23.444 15.8994C23.5096 15.9177 23.5352 15.9177 23.5534 15.9322C26.6873 18.3146 29.0696 21.2186 29.9744 25.1514C30.1021 25.7096 30.1422 26.2714 30.1422 26.8406C30.1458 30.7661 30.1422 34.6916 30.1422 38.6172C30.1422 38.7339 30.1385 38.8543 30.1422 38.971C30.1495 39.2045 30.0473 39.3249 29.8065 39.314C29.7117 39.3103 29.6168 39.314 29.522 39.314C27.0156 39.314 24.5093 39.314 22.0029 39.314C21.3937 39.314 21.39 39.3067 21.39 38.6938C21.3864 36.4245 21.39 34.1517 21.39 31.8825C21.39 31.3024 21.3827 31.2951 20.8136 31.2951C18.8034 31.2914 16.7932 31.2914 14.783 31.2951C14.2832 31.2951 14.2722 31.306 14.2722 31.8022C14.2686 34.024 14.2686 36.2494 14.2686 38.4712C14.2686 38.6354 14.2613 38.8032 14.2686 38.9674C14.2795 39.2009 14.181 39.3213 13.9402 39.314C13.8235 39.3103 13.7031 39.314 13.5864 39.314C11.1274 39.314 8.6685 39.314 6.20957 39.314C5.42885 39.314 5.50181 39.3322 5.50181 38.639C5.50546 34.8558 5.50911 31.0725 5.5164 27.2893C5.52005 25.4798 5.99068 23.787 6.80059 22.1817C8.02641 19.752 9.81041 17.7856 11.9301 16.1074C12.1891 15.8994 12.3423 15.8812 12.543 16.184C12.8968 16.7203 13.3456 17.1836 13.8709 17.5521C14.1628 17.7564 14.2285 17.9972 14.2285 18.3292C14.2139 20.0074 14.2175 21.6856 14.2248 23.3674C14.2248 23.9402 14.2358 23.9475 14.8122 23.9511C16.8005 23.9548 18.7851 23.9548 20.7734 23.9511C21.3572 23.9511 21.3645 23.9402 21.3645 23.3711C21.3681 21.7403 21.3754 20.1059 21.3572 18.4751C21.3535 18.1139 21.4301 17.8622 21.7548 17.6506C22.448 17.2018 22.9697 16.5561 23.444 15.8994Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M128.919 30.3318C129.167 30.0108 129.208 29.6569 129.291 29.3322C129.864 27.0666 130.426 24.7938 130.999 22.5282C131.068 22.2546 131.163 21.9846 131.276 21.7256C131.546 21.1272 132.009 20.7551 132.659 20.6165C132.962 20.5508 133.264 20.5143 133.575 20.5143C135.563 20.518 137.547 20.5143 139.536 20.5143C139.631 20.5143 139.725 20.5107 139.82 20.518C140.287 20.5508 140.324 20.58 140.156 21.0287C139.66 22.3567 139.153 23.681 138.638 25.0017C136.661 30.1129 134.676 35.2205 132.695 40.3317C132.25 41.4809 131.71 42.579 131.097 43.648C129.521 46.4024 127.099 47.7851 123.987 48.0223C122.185 48.1572 120.397 48.0368 118.628 47.6355C118.022 47.4969 118 47.5006 118.084 46.9205C118.317 45.3079 118.555 43.6918 118.821 42.0829C118.956 41.2657 119.306 40.9993 120.149 41.0358C120.908 41.0687 121.659 41.0942 122.411 40.9446C123.432 40.7403 124.261 39.9012 124.417 38.8943C124.476 38.5185 124.293 38.2011 124.158 37.8801C123.009 35.1329 121.853 32.3931 120.7 29.6459C119.766 27.4242 118.832 25.2024 117.905 22.9806C117.77 22.6559 117.635 22.3202 117.57 21.9773C117.431 21.2732 117.77 20.7916 118.471 20.6055C118.748 20.5326 119.029 20.5216 119.313 20.5216C121.324 20.518 123.334 20.5143 125.348 20.5143C126.066 20.5143 126.07 20.518 126.263 21.1929C127.048 23.9656 127.825 26.7419 128.617 29.511C128.682 29.7736 128.689 30.0691 128.919 30.3318Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M220.998 31.1673C220.998 33.5569 221.001 35.9465 220.998 38.3361C220.998 39.1168 220.925 39.1898 220.147 39.1934C218.112 39.2007 216.08 39.1934 214.044 39.1898C213.902 39.1898 213.759 39.1825 213.621 39.1679C213.34 39.1424 213.201 38.9891 213.194 38.7046C213.187 38.3981 213.165 38.0917 213.139 37.7852C213.125 37.5919 213.088 37.3948 212.884 37.3146C212.658 37.227 212.537 37.4058 212.417 37.5481C211.074 39.1679 209.261 39.7991 207.255 39.7735C204.288 39.7334 201.366 38.1318 200.866 33.9947C200.779 33.265 200.75 32.5354 200.75 31.7984C200.757 28.4165 200.75 25.0309 200.75 21.6489C200.75 21.4848 200.746 21.3169 200.75 21.1528C200.772 20.4268 200.841 20.3465 201.581 20.3502C202.931 20.3538 204.278 20.3647 205.627 20.3757C206.105 20.3793 206.565 20.4778 207.017 20.6274C207.959 20.9448 208.499 21.6052 208.666 22.5719C208.754 23.0608 208.779 23.557 208.787 24.0531C208.812 26.1363 208.842 28.2158 208.885 30.299C208.896 30.7951 208.896 31.2913 209.042 31.7765C209.301 32.6485 209.863 33.1118 210.72 33.1483C211.607 33.1847 212.143 32.8163 212.497 31.9224C212.771 31.2293 212.844 30.5033 212.847 29.7663C212.858 27.0447 212.866 24.3268 212.869 21.6052C212.873 20.0984 212.979 20.3611 214.099 20.3574C215.211 20.3538 216.324 20.3757 217.433 20.383C217.55 20.383 217.67 20.383 217.787 20.3903C219.502 20.4851 220.735 21.0397 220.921 23.2213C220.954 23.6226 220.998 24.0203 220.998 24.4216C220.994 26.6726 220.998 28.9199 220.998 31.1673Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M45.8022 29.3833C45.8095 27.6686 44.3502 26.191 42.6574 26.1947C40.9901 26.202 39.5819 27.6576 39.5929 29.3687C39.6038 31.1053 40.9719 32.5281 42.6537 32.5463C44.3684 32.5682 45.7949 31.1344 45.8022 29.3833ZM43.2484 19.201C45.0397 19.2338 47.236 19.8139 49.2097 21.0944C51.6102 22.6522 52.9455 24.9069 53.3651 27.7233C53.5985 29.2921 53.5073 30.8353 53.0695 32.3566C52.3472 34.8849 50.8769 36.8877 48.5493 38.1026C44.5071 40.2113 40.4247 40.2332 36.459 37.8728C33.876 36.3369 32.4897 33.9764 32.0373 31.0286C31.7673 29.2665 31.906 27.5409 32.4751 25.8554C33.2266 23.6336 34.6166 21.9299 36.6633 20.7843C38.5385 19.7373 40.5451 19.1864 43.2484 19.201Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M175.545 37.3804C175.137 37.5081 174.863 37.7708 174.575 38.0006C173.546 38.8251 172.419 39.438 171.113 39.7044C167.435 40.4523 164.115 38.1684 163.524 34.4691C163.375 33.5315 163.291 32.5902 163.287 31.6453C163.273 28.2634 163.269 24.8815 163.262 21.4995C163.262 21.4302 163.262 21.3572 163.262 21.2879C163.28 20.5838 163.353 20.4962 164.032 20.4962C165.615 20.4926 167.202 20.4816 168.785 20.5072C170.219 20.5291 171.069 21.3244 171.222 22.7472C171.361 24.0205 171.31 25.2974 171.335 26.5743C171.368 28.0627 171.292 29.5549 171.459 31.0397C171.489 31.2951 171.518 31.5578 171.587 31.8059C171.817 32.6559 172.415 33.1302 173.276 33.1557C174.148 33.1849 174.732 32.7727 175.035 31.908C175.345 31.0251 175.407 30.1058 175.414 29.1828C175.432 26.6509 175.436 24.1226 175.443 21.5907C175.443 21.401 175.44 21.2113 175.447 21.0216C175.469 20.54 175.549 20.4379 176.034 20.4233C176.625 20.405 177.216 20.4233 177.807 20.4342C178.825 20.4525 179.843 20.4671 180.857 20.4926C182.375 20.5327 183.199 21.2879 183.407 22.8056C183.488 23.393 183.524 23.9803 183.524 24.5714C183.524 29.0186 183.531 33.4658 183.535 37.9094C183.535 38.121 183.531 38.3363 183.531 38.5479C183.528 38.92 183.353 39.106 182.973 39.1279C180.73 39.2556 178.482 39.3176 176.239 39.1316C175.724 39.0878 175.669 39.0002 175.629 38.4603C175.6 38.1174 175.677 37.7635 175.545 37.3804Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M107.478 35.1403C107.927 35.1622 108.358 35.0601 108.763 34.8448C109.791 34.2903 110.547 32.5172 110.233 31.3972C110.185 31.2221 110.087 31.1856 109.923 31.2148C108.784 31.4191 107.643 31.5979 106.512 31.8241C105.833 31.959 105.461 32.4443 105.344 33.0973C105.22 33.7868 105.465 34.3523 106.063 34.7427C106.486 35.0236 106.957 35.1586 107.478 35.1403ZM109.923 37.9021C109.532 38.1574 109.222 38.3654 108.908 38.566C106.968 39.7992 104.892 40.153 102.666 39.5292C100.35 38.8798 98.77 36.9936 98.5401 34.4873C98.3285 32.2071 99.2953 30.2079 101.575 29.0258C103.086 28.2451 104.717 27.8766 106.402 27.7344C107.321 27.6577 108.237 27.5519 109.157 27.4899C109.507 27.4644 109.58 27.2966 109.576 26.9901C109.569 26.2495 109.175 25.7278 108.401 25.5016C107.431 25.2207 106.479 25.2864 105.563 25.7059C104.877 26.0197 104.202 26.3626 103.535 26.7165C103.265 26.8588 103.089 26.8661 102.878 26.6034C102.25 25.8336 101.568 25.1112 100.952 24.3342C100.211 23.4002 100.324 22.6596 101.214 21.8679C102.236 20.9632 103.476 20.5217 104.753 20.1569C107.303 19.4273 109.835 19.4929 112.352 20.3357C114.312 20.9924 115.665 22.2838 116.435 24.1955C116.913 25.3885 117.19 26.6326 117.245 27.9168C117.383 31.2732 117.31 34.6296 117.321 37.986C117.321 38.2231 117.318 38.4602 117.321 38.6937C117.329 39.033 117.205 39.2118 116.829 39.2227C114.724 39.2957 112.622 39.3468 110.517 39.2556C110.215 39.241 110.109 39.1133 110.076 38.8397C110.054 38.5624 109.992 38.2851 109.923 37.9021Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M24.4591 12.9297C24.4335 12.1417 24.4408 11.4631 24.2767 10.7954C23.5069 7.66158 20.6977 5.57478 17.4544 5.7426C14.3972 5.90312 11.7777 8.31827 11.3472 11.4047C11.2268 12.2766 11.2232 13.1668 11.5114 14.0059C11.6902 14.524 11.5041 14.7611 11.1283 15.053C9.078 16.6217 7.36332 18.4969 6.05359 20.7333C4.96276 22.5976 4.30242 24.6005 4.18203 26.7675C3.92665 26.8478 3.84274 26.6289 3.7187 26.5085C1.8289 24.6552 0.723475 22.3896 0.278387 19.8067C-0.61179 14.6042 0.635917 9.94905 3.97773 5.87393C6.33086 3.00275 9.43918 1.33549 13.0108 0.489096C15.1743 -0.0253096 17.3669 -0.152999 19.5595 0.197235C22.8721 0.726233 26.1118 3.01369 26.3343 7.67253C26.4073 9.16102 25.9257 11.288 24.4591 12.9297Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M62.9587 25.5343V38.2376C62.9587 38.4017 62.9477 38.5696 62.9623 38.7337C62.9842 39.0256 62.8893 39.1898 62.5683 39.1642C62.499 39.1569 62.426 39.1642 62.3567 39.1642C60.0619 39.1642 57.7672 39.1679 55.4724 39.1642C54.9069 39.1642 54.8996 39.1569 54.8777 38.5805C54.8632 38.1792 54.8668 37.7779 54.8705 37.3729C54.8741 30.3719 54.8814 23.3709 54.8814 16.3662C54.8814 15.56 54.9179 14.7573 55.0748 13.9657C55.3155 12.7508 55.9722 12.1853 57.2126 12.0905C58.9346 11.9555 60.6639 11.9847 62.3895 11.9409C62.9477 11.9263 62.955 11.9445 62.955 12.5501C62.9623 16.877 62.9587 21.2038 62.9587 25.5343Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M185.498 29.7918C185.498 27.1177 185.498 24.4435 185.498 21.7693C185.498 21.5796 185.494 21.3899 185.498 21.2002C185.516 20.383 185.582 20.3027 186.406 20.3246C187.989 20.3684 189.576 20.3319 191.16 20.4231C192.112 20.4778 192.696 20.9448 192.991 21.824C193.006 21.8678 193.02 21.9152 193.039 21.959C193.258 22.4807 193.371 22.5172 193.75 22.0685C194.775 20.8572 196.063 20.2224 197.654 20.2261C197.701 20.2261 197.749 20.2261 197.796 20.2297C199.12 20.2881 199.511 20.6639 199.419 21.97C199.325 23.3125 199.153 24.6514 198.996 25.9903C198.942 26.4719 198.807 26.5741 198.299 26.6106C197.829 26.647 197.355 26.6616 196.884 26.7054C194.629 26.9243 193.531 28.099 193.498 30.3646C193.476 31.9261 193.487 33.4875 193.484 35.049C193.48 36.0887 193.484 37.1321 193.48 38.1719C193.476 39.0767 193.476 39.0876 192.546 39.1679C191.342 39.2737 190.135 39.2554 188.927 39.2481C188.051 39.2408 187.176 39.2554 186.3 39.2226C185.567 39.1971 185.498 39.1132 185.498 38.3762C185.494 35.5123 185.498 32.6484 185.498 29.7882V29.7918Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M73.6552 29.8794C73.6552 32.6922 73.6552 35.505 73.6552 38.3178C73.6552 38.482 73.6333 38.6498 73.6479 38.814C73.6771 39.1679 73.502 39.2518 73.1809 39.2481C71.645 39.2372 70.1091 39.2445 68.5732 39.2445C67.6976 39.2445 66.8257 39.2518 65.9501 39.2408C65.4539 39.2372 65.4539 39.2263 65.4284 38.7191C65.4211 38.555 65.4247 38.3872 65.4247 38.223C65.4247 33.4474 65.4247 28.6755 65.4247 23.8999C65.4247 23.3818 65.4247 22.8638 65.5269 22.3457C65.7677 21.1528 66.5046 20.4231 67.7013 20.3903C69.5436 20.3392 71.3897 20.372 73.232 20.3611C73.5056 20.3574 73.6187 20.4742 73.6224 20.7332C73.626 20.9922 73.6443 21.2513 73.6443 21.5139C73.6479 24.3012 73.6443 27.0921 73.6443 29.8794C73.6443 29.8794 73.6516 29.8794 73.6552 29.8794Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M32.9228 12.4918C32.1749 12.1598 31.3869 12.0467 30.5952 12.189C30.0261 12.2911 29.6649 12.1853 29.4132 11.6308C29.1979 11.1565 28.855 10.7516 28.5011 10.3721C28.2567 10.1095 28.3114 9.938 28.5668 9.741C29.3001 9.17552 30.0881 8.70124 30.9162 8.29263C31.1242 8.19048 31.3321 8.08103 31.5437 7.97523C31.4051 7.77823 31.2519 7.86943 31.1205 7.90592C30.1793 8.16494 29.2855 8.52612 28.4792 9.08796C28.3625 9.16822 28.253 9.25942 28.129 9.33239C27.9794 9.41995 27.8626 9.66073 27.6474 9.51115C27.4796 9.39441 27.5817 9.212 27.5963 9.05147C27.6219 8.79245 27.6474 8.53342 27.6583 8.27439C27.7131 6.70929 27.392 5.22444 26.739 3.80162C26.6441 3.59367 26.4872 3.40761 26.469 3.17412C26.542 3.09751 26.6076 3.13399 26.6697 3.16317C30.245 4.92164 33.0614 7.43894 34.674 11.1565C35.5933 13.2725 36.0384 15.4797 35.856 17.7927C35.8122 18.3327 35.6772 18.8617 35.586 19.3979C35.5495 19.6241 35.4218 19.781 35.2358 19.9051C33.47 21.0835 32.2369 22.696 31.416 24.6369C31.4088 24.6551 31.3796 24.666 31.3577 24.6806C31.1862 24.677 31.2154 24.5274 31.1899 24.4289C30.5186 21.773 29.1286 19.5183 27.3045 17.5118C26.5712 16.7055 25.7795 15.9613 24.9331 15.2718C24.5646 14.969 24.561 14.9398 24.8674 14.6114C25.9801 13.4184 26.7937 12.0467 27.3336 10.394C29.1432 11.981 30.1027 13.9949 30.8688 16.1401C30.8798 14.9726 30.4857 13.9 30.0698 12.7836C31.0184 12.4553 31.9779 12.5684 32.9228 12.4918Z","fill":"#ACE632"}}),_c('path',{attrs:{"d":"M17.8565 17.6834C15.3683 17.7709 12.5227 15.7243 12.5118 12.2985C12.5008 9.33251 14.9524 6.96844 17.9258 6.98668C20.859 7.00492 23.234 9.39453 23.234 12.335C23.2377 15.3011 20.8371 17.687 17.8565 17.6834Z","fill":"#FFEA0F"}}),_c('path',{attrs:{"d":"M65.5121 14.8377C65.5523 12.4773 67.515 10.5583 69.8536 10.5875C72.1702 10.6203 74.1111 12.6378 74.0673 14.9691C74.0272 17.2675 72.0498 19.1171 69.6784 19.0624C67.3946 19.0113 65.4027 17.1179 65.5121 14.8377Z","fill":"#2D2D2D"}})])]],2)
}
var guru_logo_plainvue_type_template_id_8b90c156_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-plain.vue?vue&type=template&id=8b90c156&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-logo-plain.vue?vue&type=script&lang=js

/* harmony default export */ var guru_logo_plainvue_type_script_lang_js = ({
  name: 'Logo',
  props: {
    lang: {
      type: String,
      default: 'de',
    },
  },
});

// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-plain.vue?vue&type=script&lang=js
 /* harmony default export */ var logos_guru_logo_plainvue_type_script_lang_js = (guru_logo_plainvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/svg/logos/guru-logo-plain.vue?vue&type=style&index=0&id=8b90c156&prod&lang=postcss&scoped=true
var guru_logo_plainvue_type_style_index_0_id_8b90c156_prod_lang_postcss_scoped_true = __webpack_require__("9d13");

// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-plain.vue






/* normalize component */

var guru_logo_plain_component = normalizeComponent(
  logos_guru_logo_plainvue_type_script_lang_js,
  guru_logo_plainvue_type_template_id_8b90c156_scoped_true_render,
  guru_logo_plainvue_type_template_id_8b90c156_scoped_true_staticRenderFns,
  false,
  null,
  "8b90c156",
  null
  
)

/* harmony default export */ var guru_logo_plain = (guru_logo_plain_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-logo-mobile.vue?vue&type=template&id=6755bd4c
var guru_logo_mobilevue_type_template_id_6755bd4c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ug-logo-mobile"},[(['de', 'at'].includes(_vm.locale))?_c('div',[_c('svg',{attrs:{"width":"55px","height":"60px","viewBox":"0 0 55 60","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("Logo/turban/grey/HG")]),_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Logo/turban/colored/UG","transform":"translate(0.000000, -3.000000)"}},[_c('g',{attrs:{"id":"Logo/turban/grey/HG","transform":"translate(0.000000, 3.000000)"}},[_c('path',{attrs:{"d":"M21.4984518,26.6422546 C21.8768411,26.8942475 21.815159,27.2505877 21.8156399,27.6029699 C21.8173232,29.7237399 21.815159,31.8449897 21.8167221,33.9662395 C21.8184054,36.3749842 21.8217721,38.7843286 21.8279042,41.1930733 C21.8295875,41.9839543 21.8802078,42.7670392 22.0354351,43.5501241 C22.6764244,46.7864513 24.8474433,48.0268655 27.9337145,47.7292956 C30.2573156,47.5051287 31.8853393,45.79803 32.2163547,43.4075161 C32.3542678,42.4111788 32.4393964,41.4095641 32.4383142,40.398834 C32.4332642,36.2284181 32.4633238,32.0581222 32.4411999,27.8877063 C32.437713,27.2117273 32.6019583,26.7687908 33.1894416,26.3769485 C34.1531498,25.7343127 34.8892474,24.8357261 35.5313188,23.894441 C35.9285854,23.9277841 36.1355152,24.1992072 36.3787568,24.393869 C39.3058328,26.7338884 41.7817755,29.4622718 43.5555278,32.7829165 C44.896423,35.2921705 45.6915574,37.9412739 45.7082705,40.817183 C45.7228193,43.1939038 45.7588908,45.5671465 45.1418289,47.8853369 C43.8214944,52.8432755 40.7758637,56.4120749 36.008183,58.2368343 C30.1321477,60.4861794 24.1280588,60.6361038 18.1662937,58.3818411 C16.4025212,57.7144978 14.7895273,56.7682952 13.3584535,55.5335182 C10.4468883,53.0213856 8.97409193,49.7912953 8.71978837,46.0078042 C8.59967052,44.2184269 8.54075386,42.4218534 8.58740624,40.6224012 C8.65534076,37.9806141 9.36967523,35.5241335 10.565924,33.1908307 C12.4916572,29.4356453 15.2992165,26.4425554 18.7421139,23.8095238 C19.5588912,24.9417526 20.4090948,25.9162609 21.4984518,26.6422546 Z","id":"Fill-1","fill":"#323231"}}),_c('path',{attrs:{"d":"M37.1348804,19.2920245 C37.1360945,18.1482727 37.1135125,17.121884 36.8753083,16.1003953 C35.9297763,12.0476655 31.7881565,7.95848387 25.7419962,8.68465273 C20.9745138,9.25700669 17.194571,13.48112 17.1547489,18.3185806 C17.1468573,19.2571264 17.1996702,20.1929233 17.5216464,21.0732656 C17.755237,21.7115915 17.522132,22.0355947 17.0283623,22.4068061 C13.9001421,24.7538279 11.2563432,27.5406622 9.25236883,30.8893333 C7.69942834,33.4836301 6.67133828,36.2521787 6.41795803,39.2733806 C6.40326756,39.4510984 6.37133703,39.6284576 6.33491438,39.803307 C6.32083095,39.869757 6.27141755,39.9281994 6.23487349,39.9963226 C5.92698067,40.0344477 5.81394904,39.7672137 5.64604061,39.6074231 C2.77010799,36.8699481 1.0881099,33.4991669 0.42849567,29.6588141 C-1.0569415,21.0075327 1.32182192,13.4844664 7.53200555,7.19909004 C11.1518101,3.53585736 15.7041561,1.5415223 20.7340029,0.541068133 C23.7559904,-0.0596107177 26.8178,-0.202191273 29.8510784,0.327615601 C40.1142534,2.12116664 42.4962949,12.6654349 37.4376741,19.1101238 C37.397852,19.1609174 37.3196647,19.1830275 37.1348804,19.2920245","id":"Fill-3","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M35.2380952,18.5355447 C35.2474758,22.9654086 31.6359117,26.6194798 27.2024311,26.6662419 C22.7764214,26.7125219 19.0237542,22.9704704 19.047619,18.53446 C19.0717124,14.1113452 22.7317167,10.4711339 27.151822,10.4761905 C31.5930144,10.480655 35.2285576,14.104114 35.2380952,18.5355447","id":"Fill-5","fill":"#FFEA00"}}),_c('path',{attrs:{"d":"M39.9574233,4.76190476 L40.2192064,4.76190476 C40.4071218,4.86744948 40.5913622,4.98009469 40.7835651,5.07757613 C43.8741244,6.64449997 46.6641906,8.60110886 48.9235855,11.2234799 C51.7877643,14.5478375 53.5526257,18.367425 54.1714971,22.6880189 C55.0472515,32.0405805 50.6819544,37.6404678 48.0736787,40 L47.8117731,40 C47.770123,39.8029912 47.7066679,39.6074266 47.6903753,39.4082516 C47.5128724,37.2394701 46.8922861,35.2151056 45.9021164,33.2564508 C44.5023058,30.4868949 42.7670895,27.9687448 40.5525296,25.7819112 C39.4648497,24.7078102 38.2824771,23.726136 37.1428571,22.7024606 L37.1428571,22.3810126 C37.3263625,22.1712469 37.5077854,21.9596761 37.6938634,21.7523175 C39.128219,20.154344 40.264409,18.3811446 40.9863031,16.3631585 C41.0634783,16.1473755 41.1417559,15.9319536 41.2287311,15.691018 C42.5982841,16.7719788 43.5570937,18.1314236 44.4394632,19.5534491 C45.3169326,20.9676521 45.9024839,22.5131541 46.5142502,24.1280965 C46.7607208,23.7416609 46.6714181,23.4087798 46.5916704,23.1182611 C46.2863997,22.0049268 45.949034,20.8996558 45.6056657,19.7967917 C45.4499679,19.296387 45.4914955,19.1472765 46.0137141,19.1068398 C47.1198916,19.0211524 48.229989,18.9857702 49.3384939,18.9314935 C49.4606267,18.9254761 49.5832495,18.9306511 49.7055047,18.9306511 C49.7162848,18.8884091 49.7270648,18.8462875 49.7378448,18.8040456 C49.598807,18.7312354 49.4676092,18.6226819 49.3195064,18.5913916 C48.1299063,18.3396247 46.9351612,18.208446 45.7209385,18.4422811 C45.1864698,18.5452985 44.9371818,18.3777749 44.6417111,17.9253888 C44.2072027,17.2602284 43.7417016,16.6142033 43.2766906,15.9687799 C43.0773827,15.6921011 42.8465922,15.4373256 42.6254792,15.1670252 C43.9799647,13.8364637 45.7057485,13.1052326 47.2733844,12.105386 C47.0516589,12.0467768 46.8303009,11.9989988 46.6404255,12.0543587 C45.1461672,12.4897758 43.7515017,13.1265341 42.5018764,14.0569403 C42.2819884,14.2207332 42.0462979,14.5413388 41.7420072,14.3519119 C41.4595216,14.1757232 41.5896169,13.8215407 41.6245295,13.5425753 C41.7813298,12.2907211 41.7630773,11.0425976 41.5618094,9.79748288 C41.3032113,8.19938906 40.7682526,6.690232 40.045991,5.23992484 C39.9761659,5.09996076 39.9851084,4.92220757 39.9574233,4.76190476","id":"Fill-7","fill":"#ABE532"}})])])])])]):_c('div',[_c('svg',{attrs:{"width":"80","height":"80","viewBox":"0 0 45 50","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("Holidayguru_Turban_RGB")]),_c('defs',[_c('polygon',{attrs:{"id":"path-1","points":"0 0 44.9226073 0 44.9226073 49.139938 0 49.139938"}})]),_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Holidayguru_Turban_RGB","transform":"translate(0.000000, -0.000000)"}},[_c('mask',{attrs:{"id":"mask-2","fill":"white"}},[_c('use',{attrs:{"xlink:href":"#path-1"}})]),_c('g',{attrs:{"id":"Clip-2"}}),_c('path',{attrs:{"d":"M5.20361364,33.6172921 C5.12170326,33.5952958 5.07561557,33.5387336 5.02565234,33.49097 C3.87010843,32.386332 2.86424475,31.1654274 2.09080964,29.7590199 C1.31559386,28.34947 0.789775294,26.8503634 0.457943977,25.280973 C0.15931674,23.8682808 -0.00628471926,22.4385152 -0.00628471926,20.9942948 C-0.00628471926,17.2353205 0.927828854,13.7186208 2.78767635,10.4538322 C4.43929132,7.55418371 6.65589938,5.18108702 9.47499915,3.3823057 C11.0141183,2.40000959 12.675684,1.68208918 14.4066955,1.11720083 C15.7381058,0.682614929 17.0995778,0.377179284 18.4874455,0.191466871 C19.8207413,0.0131913338 21.1610549,-0.0363529253 22.5036729,0.0252369782 C23.4768562,0.0699629797 24.4477351,0.152606575 25.3965129,0.396347571 C27.7680385,1.0054382 29.7281267,2.2466633 31.2296424,4.19282045 C31.6745981,4.76944021 31.9757392,5.42273312 32.2367631,6.09529906 C32.7694948,7.46839778 33.0266431,8.89083126 32.9539502,10.3649039 C32.8812574,11.8335298 32.4770475,13.2116563 31.7838468,14.5067202 C31.4765258,15.0807213 31.1223838,15.624556 30.7248776,16.1399001 C30.6917782,16.1827407 30.6704103,16.2384649 30.5957273,16.2642321 C30.5957273,16.1925867 30.5909091,16.1260738 30.5964605,16.0605036 C30.93929,11.9708502 28.1729816,8.15751338 24.0179675,7.32049821 C20.3801829,6.58759931 16.89763,8.30593667 15.1688181,11.3893074 C14.3549516,12.8408599 14.0338042,14.4049083 14.1511183,16.0590371 C14.1986724,16.7298224 14.335888,17.3856292 14.5514527,18.0245721 C14.6443613,18.2997365 14.6716996,18.2373086 14.4329864,18.4136988 C11.7100423,20.4260546 9.41361873,22.8335075 7.66930468,25.7469823 C6.72042213,27.3319796 6.01329043,29.0186841 5.60111991,30.8237501 C5.40273338,31.6922934 5.27347838,32.5708923 5.23430385,33.461851 C5.23220895,33.5090908 5.24509255,33.5601015 5.20361364,33.6172921","id":"Fill-1","fill":"#00D6E1","mask":"url(#mask-2)"}}),_c('path',{attrs:{"d":"M41.6978312,15.7790545 C41.5026917,15.5985793 41.2646069,15.5155167 41.024951,15.4402052 C40.5512953,15.2914677 40.0632896,15.2151088 39.5683707,15.1914365 C38.861658,15.1573945 38.1567259,15.1811715 37.4580786,15.3027802 C37.3380411,15.3236244 37.2838881,15.2834024 37.2285828,15.180543 C36.8664803,14.5074534 36.4516912,13.8681963 35.9657803,13.2772265 C35.7999694,13.0755929 35.6235793,12.8823388 35.4478176,12.6890848 C35.3213907,12.5500885 35.2829494,12.565067 35.4560925,12.4172722 C35.8164143,12.1096369 36.1964282,11.8282926 36.5897447,11.5644406 C37.5896379,10.8936553 38.6553109,10.3445834 39.750836,9.85039777 C39.8627034,9.79991081 39.9797033,9.75780343 40.0718786,9.66845617 C39.7737751,9.68039707 39.4870888,9.73559754 39.2024974,9.8031579 C37.7634095,10.1454637 36.4361889,10.7315105 35.2497453,11.6224692 C35.1200713,11.7198818 34.993016,11.8217984 34.8718263,11.9297902 C34.7914871,12.0014356 34.733668,12.0155762 34.6390835,11.94016 C34.5225026,11.8472514 34.4797668,11.7648173 34.5054292,11.6036151 C34.6551095,10.6658355 34.6806672,9.7235519 34.5859779,8.77655476 C34.4119969,7.03810641 33.8955007,5.41005901 33.0440307,3.88644211 C33.0338705,3.86832127 33.0274811,3.84810553 33.0208821,3.82830878 C33.0194157,3.82370001 33.0247577,3.8168916 33.0321946,3.79751383 C33.1859598,3.84024968 33.3313455,3.90728631 33.4750553,3.97641783 C34.6228481,4.52915579 35.7117744,5.18223921 36.7552414,5.91157679 C37.7123988,6.58058141 38.6100611,7.32238362 39.4406869,8.14316335 C41.3999371,10.0793698 42.8596597,12.3380852 43.8055047,14.9267466 C44.2206081,16.0628079 44.5313857,17.2271504 44.7317624,18.4194597 C44.887832,19.3476028 44.9209314,20.2846492 44.9226256,21.2254664 C44.9250164,22.5084846 44.6890265,23.7519094 44.3496536,24.9795177 C43.79922,26.9700866 43.0097589,28.8598911 41.9197852,30.6185552 C41.4536712,31.3704129 40.9396888,32.0868668 40.302736,32.7073746 C40.104978,32.900105 39.895279,33.078171 39.6600224,33.2239757 C39.4904406,33.3288251 39.4666636,33.3164653 39.4538847,33.112213 C39.3768973,31.8730828 39.1305377,30.666633 38.756599,29.4847982 C38.3095485,28.070849 37.6810801,26.7396482 36.9094256,25.4751697 C36.0154293,24.0103146 34.9591834,22.671258 33.7733683,21.432442 C32.8880658,20.5073365 31.9448395,19.646649 30.9359382,18.8580259 C30.885975,18.8188514 30.836326,18.7790484 30.7865722,18.7394549 C30.745617,18.7068793 30.7422652,18.6697996 30.7773547,18.6317773 C30.825223,18.5799286 30.8750815,18.5298607 30.9238926,18.47885 C31.9355172,17.4206139 32.7962047,16.254805 33.446879,14.9393159 C33.7385931,14.3496031 33.9781443,13.7393603 34.1691987,13.1100539 C34.181349,13.0701461 34.1964323,13.0311811 34.2148674,12.978285 C34.3300866,13.0188212 34.4039316,13.1047119 34.4839566,13.1787664 C35.2825304,13.9174263 35.9484974,14.7650207 36.5312971,15.6802802 C37.4328351,17.0954863 38.0928316,18.6187889 38.5649162,20.2263064 C38.5788472,20.2735462 38.592045,20.3213098 38.6086995,20.3678165 C38.6261918,20.4169418 38.6521685,20.4592587 38.7161676,20.4417663 C38.771368,20.4266831 38.7671782,20.3797574 38.7637217,20.3388022 C38.7478005,20.1560227 38.7343931,19.9729289 38.711454,19.7909873 C38.5482617,18.5008464 38.1922344,17.264649 37.6681965,16.0756915 C37.6596074,16.0563138 37.6519611,16.036517 37.6423245,16.017663 C37.5974938,15.9312486 37.6262986,15.8856846 37.7196262,15.8721725 C37.9081667,15.8449389 38.0958692,15.8118396 38.2848287,15.7892147 C39.0070437,15.7026955 39.7298871,15.6312596 40.4592247,15.6500089 C40.8413335,15.659855 41.2199857,15.6915926 41.5944481,15.76858 C41.6282806,15.7754931 41.6633701,15.7757026 41.6978312,15.7790545","id":"Fill-3","fill":"#ACE632","mask":"url(#mask-2)"}}),_c('path',{attrs:{"d":"M29.0919072,15.4136001 C29.0676064,19.1314097 26.0913895,22.1221861 22.3674,22.116329 C18.5525968,22.1103499 15.644045,18.9934609 15.663845,15.3749493 C15.6845812,11.6547306 18.7235402,8.68972137 22.3848924,8.69181516 C25.9556403,8.69370167 29.0726341,11.5698873 29.0919072,15.4136001","id":"Fill-4","fill":"#FFEB00","mask":"url(#mask-2)"}}),_c('path',{attrs:{"d":"M29.2629553,19.7689909 C29.3444467,19.7923489 29.3789077,19.7927679 29.4009041,19.8096318 C33.3295649,22.7973706 36.319608,26.4385071 37.4553552,31.3727172 C37.6162431,32.0711551 37.6659969,32.7796485 37.6665206,33.4920174 C37.6701866,38.4149152 37.668406,43.3383367 37.668406,48.2613392 C37.668406,48.4098672 37.662226,48.5579763 37.6673585,48.7061901 C37.6781472,48.9996848 37.5509871,49.1510409 37.2467037,49.1375289 C37.1283421,49.1323964 37.0095616,49.1389953 36.8913048,49.1389953 C33.7474964,49.1389953 30.6036879,49.1408807 27.4599842,49.1375289 C26.6963951,49.1371099 26.6899009,49.129254 26.6893772,48.3582281 C26.6866538,45.5106377 26.6908436,42.6637806 26.6866538,39.816714 C26.6856064,39.0909377 26.6773316,39.0810917 25.962763,39.07973 C23.441662,39.0750165 20.9208752,39.0750165 18.4000884,39.0802537 C17.7752861,39.0815107 17.7608313,39.0937658 17.7594696,39.716159 C17.7538134,42.5039401 17.7566415,45.2917212 17.7566415,48.0796071 C17.7566415,48.2868969 17.748262,48.4951294 17.757689,48.7020003 C17.7712011,48.9965425 17.6471833,49.1460132 17.3447852,49.1375289 C17.1966762,49.1333391 17.0485671,49.1389953 16.8999344,49.1389953 C13.8157257,49.1389953 10.7312027,49.1379479 7.64709879,49.1399746 C6.66878298,49.1404617 6.75676856,49.1618296 6.75771126,48.2952765 C6.76336747,43.5498163 6.76755726,38.8049846 6.77541312,34.0599434 C6.77918393,31.7915914 7.36889678,29.6656923 8.38460647,27.6540697 C9.92341135,24.6058932 12.158245,22.142716 14.8175043,20.0359852 C15.1444126,19.7769515 15.3345243,19.7513938 15.5842358,20.1301507 C16.0278297,20.8029261 16.5887378,21.3842594 17.2484201,21.8454505 C17.6159694,22.1025988 17.6989272,22.4054158 17.6956801,22.8218809 C17.6793399,24.9277738 17.6843677,27.0334571 17.6901286,29.1388263 C17.6919093,29.8576894 17.7016506,29.8683734 18.4275316,29.8697351 C20.9190945,29.8748675 23.4101338,29.8748675 25.9016968,29.8697351 C26.6325008,29.8683734 26.6428705,29.8581084 26.6446512,29.1443778 C26.6503074,27.0982941 26.658687,25.0516868 26.6376333,23.0054984 C26.6330245,22.5513252 26.7294944,22.2354151 27.1356945,21.9707252 C28.0125127,21.4010186 28.6670625,20.5914465 29.2629553,19.7689909","id":"Fill-5","fill":"#2E2E2E","mask":"url(#mask-2)"}})])])])])])
}
var guru_logo_mobilevue_type_template_id_6755bd4c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-mobile.vue?vue&type=template&id=6755bd4c

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-logo-mobile.vue?vue&type=script&lang=js

/* harmony default export */ var guru_logo_mobilevue_type_script_lang_js = ({
  name: 'Logo',
  props: {
    locale: {
      type: String,
      default: 'de',
    },
  },
});

// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-mobile.vue?vue&type=script&lang=js
 /* harmony default export */ var logos_guru_logo_mobilevue_type_script_lang_js = (guru_logo_mobilevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-mobile.vue





/* normalize component */

var guru_logo_mobile_component = normalizeComponent(
  logos_guru_logo_mobilevue_type_script_lang_js,
  guru_logo_mobilevue_type_template_id_6755bd4c_render,
  guru_logo_mobilevue_type_template_id_6755bd4c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var guru_logo_mobile = (guru_logo_mobile_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-logo-u.vue?vue&type=template&id=521852b4
var guru_logo_uvue_type_template_id_521852b4_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ug-logo-u"},[_c('svg',{attrs:{"width":"36","height":"40","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('path',{attrs:{"d":"m0.024,0.178l18.18,0l0,23.639l-18.181,0l0.001,-23.639z","id":"a"}}),_c('path',{attrs:{"d":"m0.217,0.037l16.749,0l0,16.247l-16.75,0l0.001,-16.247z","id":"c"}})]),_c('g',[_c('title',[_vm._v("background")]),_c('rect',{attrs:{"fill":"none","id":"canvas_background","height":"402","width":"582","y":"-1","x":"-1"}})]),_c('g',[_c('title',[_vm._v("Layer 1")]),_c('g',{attrs:{"id":"svg_1","fill-rule":"evenodd","fill":"none"}},[_c('path',{attrs:{"id":"svg_5","fill":"#24404F","d":"m11.512,14.643c0.206,0.139 0.172,0.335 0.172,0.529l0,3.5l0.007,3.976c0,0.435 0.028,0.866 0.113,1.297c0.347,1.78 1.526,2.463 3.2,2.3c1.262,-0.124 2.146,-1.063 2.325,-2.378c0.075,-0.548 0.121,-1.1 0.12,-1.656c-0.002,-2.294 0.014,-4.588 0.002,-6.883c-0.002,-0.372 0.087,-0.615 0.406,-0.83c0.523,-0.354 0.923,-0.849 1.271,-1.367c0.216,0.019 0.328,0.168 0.46,0.275c1.59,1.287 2.933,2.789 3.896,4.615c0.727,1.38 1.159,2.838 1.168,4.42c0.008,1.308 0.027,2.614 -0.307,3.89c-0.717,2.727 -2.37,4.69 -4.958,5.694c-3.189,1.238 -6.448,1.32 -9.683,0.08a8.628,8.628 0 0 1 -2.61,-1.567c-1.58,-1.382 -2.38,-3.16 -2.517,-5.24a32.295,32.295 0 0 1 -0.072,-2.964c0.037,-1.453 0.424,-2.804 1.074,-4.088c1.045,-2.066 2.569,-3.713 4.437,-5.161"}}),_c('path',{attrs:{"id":"svg_11","fill":"#00D5E0","d":"m19.96,10.652c0.001,-0.632 -0.01,-1.199 -0.139,-1.763c-0.508,-2.237 -2.734,-4.495 -5.984,-4.094c-2.563,0.316 -4.595,2.648 -4.616,5.32c-0.004,0.517 0.024,1.034 0.197,1.52c0.126,0.352 0,0.531 -0.265,0.736c-1.681,1.296 -3.103,2.835 -4.18,4.684c-0.834,1.432 -1.387,2.96 -1.523,4.629a2.46,2.46 0 0 1 -0.045,0.292c-0.007,0.037 -0.034,0.07 -0.054,0.107c-0.165,0.02 -0.226,-0.127 -0.316,-0.215c-1.546,-1.511 -2.45,-3.372 -2.805,-5.493c-0.798,-4.776 0.48,-8.93 3.819,-12.4c1.945,-2.023 4.391,-3.124 7.096,-3.676c1.624,-0.332 3.27,-0.41 4.9,-0.118c5.517,0.99 6.797,6.812 4.078,10.37c-0.021,0.028 -0.063,0.04 -0.162,0.1"}}),_c('path',{attrs:{"id":"svg_14","fill":"#FFEA00","d":"m18.974,10.168c0.005,2.426 -1.95,4.426 -4.352,4.452c-2.397,0.025 -4.43,-2.024 -4.416,-4.452c0.013,-2.422 1.995,-4.415 4.389,-4.412c2.405,0.002 4.374,1.986 4.38,4.412"}}),_c('path',{attrs:{"id":"svg_15","fill":"#ABE532","d":"m27.925,8.377c-1.347,-2.605 -3.458,-4.402 -6.02,-5.703c-0.078,-0.04 -0.16,-0.12 -0.262,-0.058c-0.04,0.063 -0.011,0.114 0.014,0.165c0.739,1.483 1.093,3.038 0.868,4.703a0.873,0.873 0 0 0 -0.004,0.237c0.022,0.154 0.121,0.198 0.25,0.127c0.119,-0.066 0.225,-0.156 0.336,-0.237a6.567,6.567 0 0 1 1.99,-0.99c0.137,-0.042 0.285,-0.13 0.477,0.023c-0.867,0.518 -1.784,0.924 -2.508,1.652c0.399,0.501 0.803,0.962 1.08,1.51c0.14,0.278 0.323,0.336 0.616,0.277c0.603,-0.121 1.208,-0.05 1.805,0.071c0.12,0.025 0.263,0.033 0.3,0.21c-0.637,-0.002 -1.265,-0.032 -1.885,0.066c-0.417,0.067 -0.44,0.104 -0.29,0.492c0.201,0.518 0.348,1.049 0.468,1.59c0.025,0.115 0.046,0.233 0.05,0.35c0.005,0.099 0.061,0.216 -0.083,0.33c-0.31,-0.882 -0.633,-1.728 -1.102,-2.504c-0.461,-0.765 -0.959,-1.5 -1.704,-2.108c-0.32,0.997 -0.734,1.845 -1.307,2.607c-0.236,0.315 -0.48,0.626 -0.746,0.915c-0.185,0.2 -0.148,0.334 0.049,0.476c0.08,0.057 0.155,0.12 0.23,0.184c1.486,1.278 2.778,2.722 3.748,4.447c0.377,0.67 0.666,1.379 1.023,2.068c0.041,-0.253 0.078,-0.507 0.125,-0.758c0.296,-1.57 1.341,-2.543 2.869,-2.675c0.848,-0.072 0.848,-0.072 0.96,-0.941c0.01,-0.079 0.014,-0.158 0.02,-0.237c0.146,-2.23 -0.351,-4.323 -1.367,-6.29"}})])])])])
}
var guru_logo_uvue_type_template_id_521852b4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-u.vue?vue&type=template&id=521852b4

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-logo-u.vue?vue&type=script&lang=js

/* harmony default export */ var guru_logo_uvue_type_script_lang_js = ({
  name: 'guru-logo-u',
  props: {
    color: {
      type: String,
      default: 'default',
    },
  },
});

// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-u.vue?vue&type=script&lang=js
 /* harmony default export */ var logos_guru_logo_uvue_type_script_lang_js = (guru_logo_uvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-u.vue





/* normalize component */

var guru_logo_u_component = normalizeComponent(
  logos_guru_logo_uvue_type_script_lang_js,
  guru_logo_uvue_type_template_id_521852b4_render,
  guru_logo_uvue_type_template_id_521852b4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var guru_logo_u = (guru_logo_u_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-logo-part.vue?vue&type=template&id=76efa870
var guru_logo_partvue_type_template_id_76efa870_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ug-logo-part"},[_c('svg',{attrs:{"width":"183","height":"40","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('defs',[_c('path',{attrs:{"d":"m0.024,0.178l18.18,0l0,23.639l-18.181,0l0.001,-23.639z","id":"a"}}),_c('path',{attrs:{"d":"m0.217,0.037l16.749,0l0,16.247l-16.75,0l0.001,-16.247z","id":"c"}})]),_c('g',[_c('title',[_vm._v("background")]),_c('rect',{attrs:{"fill":"none","id":"canvas_background","height":"402","width":"582","y":"-1","x":"-1"}})]),_c('g',[_c('title',[_vm._v("Layer 1")]),_c('g',{attrs:{"id":"svg_1","fill-rule":"evenodd","fill":"none"}},[_c('g',{attrs:{"fill":"#00D5E0","id":"svg_2"}},[_c('path',{attrs:{"id":"svg_4","fill":"#00D5E0","d":"m127.246003,18.305001c0,-0.355 -0.012,-0.666 0.004,-0.975c0.02,-0.397 0.109,-0.502 0.493,-0.51c1.31,-0.024 2.623,-0.056 3.927,0.118c0.943,0.126 1.467,0.62 1.701,1.552c0.117,0.462 0.19,0.932 0.188,1.408c-0.009,3.995 0.024,7.992 -0.086,11.987c-0.026,0.955 -0.203,1.884 -0.476,2.796c-0.506,1.69 -1.53,2.96 -3.046,3.83c-1.457,0.833 -3.038,1.253 -4.69,1.393c-3.046,0.259 -5.967,-0.211 -8.708,-1.63c-1.233,-0.639 -1.009,-0.603 -0.424,-1.523a289.04,289.04 0 0 1 1.894,-2.93c0.327,-0.501 0.368,-0.513 0.887,-0.215c0.905,0.52 1.831,0.982 2.87,1.162c1.097,0.191 2.184,0.15 3.245,-0.207c1.292,-0.436 2.077,-1.635 1.968,-2.967c-0.014,-0.178 -0.009,-0.37 -0.208,-0.45c-0.176,-0.07 -0.287,0.07 -0.413,0.162c-3.598,2.629 -8.414,1.297 -10.131,-2.836c-1.468,-3.531 -1.083,-6.84 1.34,-9.841c2.112,-2.614 6.333,-3.16 8.93,-0.78c0.195,0.18 0.388,0.382 0.735,0.455m-2.817,3.559c-1.616,-0.018 -2.803,1.144 -2.815,2.756c-0.011,1.63 1.144,2.86 2.709,2.883c1.625,0.024 2.891,-1.213 2.903,-2.837c0.012,-1.568 -1.203,-2.785 -2.797,-2.802"}})]),_c('path',{attrs:{"id":"svg_5","fill":"#24404F","d":"m88.331,30.997c0,0.413 0.013,0.748 -0.003,1.082c-0.019,0.399 -0.074,0.471 -0.44,0.473c-1.662,0.01 -3.324,0.01 -4.986,-0.001c-0.37,-0.003 -0.43,-0.085 -0.467,-0.463c-0.019,-0.195 -0.014,-0.394 -0.014,-0.592c0,-5.991 0.002,-11.982 0,-17.973c0,-0.535 0.019,-1.068 0.075,-1.6c0.135,-1.284 0.766,-1.906 2.041,-2.007c1.308,-0.106 2.619,-0.074 3.929,-0.064c0.525,0.005 0.561,0.037 0.565,0.58c0.008,1.503 0.006,3.006 0.008,4.509c0,0.79 -0.01,1.581 0.003,2.372c0.009,0.51 0.097,0.564 0.563,0.352c0.374,-0.17 0.735,-0.369 1.1,-0.556c2.604,-1.336 5.442,-0.857 7.471,1.261c1.346,1.406 2.047,3.115 2.264,5.032c0.248,2.202 -0.135,4.289 -1.238,6.224c-1.629,2.86 -4.88,4.114 -7.976,3.077c-0.772,-0.26 -1.453,-0.674 -2.069,-1.205c-0.22,-0.19 -0.432,-0.392 -0.826,-0.501m3.242,-3.491c1.574,0.012 2.774,-1.195 2.787,-2.801c0.014,-1.626 -1.136,-2.824 -2.732,-2.846c-1.638,-0.023 -2.854,1.155 -2.867,2.78a2.812,2.812 0 0 0 2.812,2.867m-81.557,-14.421"}}),_c('g',{attrs:{"id":"svg_6"}},[_c('mask',{attrs:{"transform":"translate(165.78700256347656,16.766000747680664) ","id":"d"}},[_c('use',{attrs:{"id":"svg_7","xlink:href":"#c"}})]),_c('path',{attrs:{"id":"svg_8","fill":"#00D5E0","d":"m182.752003,25.836001c0,1.999 0.002,3.996 -0.001,5.995c-0.002,0.66 -0.057,0.72 -0.696,0.72c-1.702,0.004 -3.405,0.003 -5.107,-0.003c-0.603,-0.002 -0.63,-0.036 -0.656,-0.631c-0.01,-0.257 0,-0.52 -0.09,-0.763c-0.074,-0.205 -0.246,-0.244 -0.419,-0.11c-0.06,0.047 -0.108,0.113 -0.161,0.171c-1.587,1.745 -4.07,2.301 -6.286,1.428c-2.005,-0.791 -2.96,-2.356 -3.23,-4.43a13.611,13.611 0 0 1 -0.1,-1.776c0.003,-2.868 0,-5.737 -0.002,-8.606c0,-0.118 -0.002,-0.237 0.002,-0.355c0.019,-0.594 0.094,-0.674 0.697,-0.673c1.076,0.003 2.154,0.013 3.229,0.03c0.411,0.005 0.817,0.068 1.212,0.196c0.804,0.261 1.27,0.818 1.412,1.654c0.067,0.39 0.092,0.784 0.097,1.181c0.024,1.78 0.05,3.56 0.085,5.34c0.008,0.434 0.017,0.87 0.166,1.29c0.227,0.64 0.694,0.986 1.37,1.008c0.679,0.022 1.103,-0.244 1.387,-0.88c0.297,-0.664 0.35,-1.371 0.352,-2.088l0.017,-6.706c0.002,-1.024 0.002,-1.028 0.989,-1.018c0.978,0.01 1.956,0.025 2.934,0.046c0.43,0.01 0.86,0.044 1.273,0.185c0.658,0.223 1.104,0.665 1.3,1.34c0.168,0.572 0.224,1.162 0.223,1.758l0,5.698l0.003,0l0,-0.001z"}})]),_c('path',{attrs:{"id":"svg_9","fill":"#00D5E0","d":"m145.167,31.031c-0.353,0.123 -0.58,0.339 -0.82,0.533c-0.868,0.702 -1.816,1.242 -2.926,1.428c-3.166,0.532 -5.726,-1.36 -6.206,-4.405a16.466,16.466 0 0 1 -0.2,-2.539l-0.016,-8.07c0,-0.177 -0.008,-0.356 0.004,-0.533c0.027,-0.401 0.11,-0.514 0.487,-0.516c1.408,-0.009 2.818,-0.038 4.224,0.018c1.103,0.043 1.75,0.73 1.866,1.836c0.12,1.144 0.076,2.292 0.1,3.439c0.025,1.185 -0.032,2.373 0.1,3.556c0.028,0.257 0.056,0.511 0.144,0.754c0.222,0.618 0.721,0.962 1.4,0.971c0.65,0.01 1.133,-0.3 1.37,-0.911c0.297,-0.768 0.348,-1.58 0.355,-2.392c0.019,-2.136 0.019,-4.272 0.027,-6.408c0,-0.158 0.008,-0.316 0.002,-0.474c-0.011,-0.305 0.144,-0.43 0.43,-0.427c0.352,0.003 0.704,0 1.056,0.002c0.939,0.008 1.878,0.011 2.817,0.027c1.449,0.025 2.108,0.63 2.293,2.068c0.053,0.413 0.083,0.825 0.083,1.241c0.001,3.778 0.005,7.555 0.008,11.333c0,0.158 -0.001,0.316 -0.004,0.475c-0.006,0.281 -0.142,0.446 -0.426,0.462c-1.895,0.103 -3.79,0.15 -5.686,0.003c-0.298,-0.023 -0.403,-0.19 -0.42,-0.463c-0.02,-0.314 0.034,-0.633 -0.062,-1.008"}}),_c('path',{attrs:{"id":"svg_10","fill":"#24404F","d":"m74.24,31.197c-0.337,-0.088 -0.56,0.13 -0.794,0.298c-0.735,0.532 -1.507,0.994 -2.37,1.28c-3.08,1.018 -6.127,-0.695 -6.832,-3.848a7.347,7.347 0 0 1 -0.178,-1.588c-0.007,-2.73 -0.008,-5.46 -0.01,-8.189c0,-0.299 0.045,-0.591 0.133,-0.876c0.225,-0.723 0.684,-1.185 1.446,-1.295c0.212,-0.03 0.428,-0.052 0.642,-0.054c1.271,-0.01 2.543,-0.019 3.814,-0.018c0.54,0 0.555,0.017 0.554,0.572c-0.003,2.65 -0.002,5.301 0.095,7.95c0.014,0.357 0.02,0.713 0.145,1.052c0.227,0.613 0.648,0.973 1.308,1.019c0.686,0.046 1.19,-0.23 1.48,-0.842c0.265,-0.562 0.357,-1.166 0.37,-1.785c0.033,-1.82 0.07,-3.639 0.107,-5.458c0.003,-0.158 0.005,-0.317 0.02,-0.474c0.122,-1.24 0.82,-1.936 2.049,-2.022c0.468,-0.033 0.938,-0.041 1.407,-0.043c0.841,-0.004 1.683,-0.002 2.524,0.013c0.423,0.008 0.461,0.063 0.48,0.488c0.004,0.099 0.001,0.198 0.001,0.296c0,4.709 0.002,9.416 0.003,14.124c0,0.118 -0.008,0.237 0,0.356c0.018,0.283 -0.134,0.39 -0.389,0.397c-0.137,0.004 -0.274,0.004 -0.41,0.004l-4.637,0c-0.156,0 -0.313,0.006 -0.469,-0.007c-0.39,-0.032 -0.426,-0.074 -0.448,-0.464c-0.017,-0.294 0.038,-0.59 -0.04,-0.886m-11.657,-3.808c0,1.503 0.004,3.005 -0.002,4.509c-0.002,0.612 -0.016,0.628 -0.632,0.631c-1.545,0.008 -3.09,0.009 -4.635,0.006c-0.607,-0.002 -0.617,-0.02 -0.739,-0.595c-0.097,-0.46 -0.127,-0.484 -0.51,-0.239c-0.83,0.532 -1.69,0.995 -2.668,1.18c-1.347,0.257 -2.65,0.153 -3.863,-0.547c-2.219,-1.282 -2.954,-3.849 -2.093,-6.103c0.383,-1.004 1.114,-1.704 2.042,-2.202c1.102,-0.59 2.286,-0.917 3.518,-1.06c0.854,-0.1 1.713,-0.157 2.57,-0.236c0.626,-0.057 0.787,-0.317 0.571,-0.906c-0.141,-0.385 -0.426,-0.607 -0.796,-0.727c-0.712,-0.233 -1.422,-0.213 -2.13,0.029c-0.616,0.208 -1.186,0.506 -1.745,0.835c-0.455,0.269 -0.533,0.25 -0.895,-0.154c-0.394,-0.44 -0.792,-0.876 -1.172,-1.327c-1.002,-1.187 -0.912,-1.935 0.361,-2.829c0.813,-0.57 1.74,-0.89 2.69,-1.14a10.53,10.53 0 0 1 5.787,0.105c2.298,0.687 3.553,2.319 4.055,4.623c0.185,0.852 0.283,1.713 0.278,2.587c-0.006,1.187 -0.001,2.373 -0.001,3.56l0.01,0l-0.001,0zm-5.855,-0.753c-0.008,-0.137 -0.019,-0.275 -0.024,-0.412c-0.01,-0.269 -0.138,-0.406 -0.41,-0.362c-0.883,0.143 -1.775,0.241 -2.64,0.488c-0.547,0.155 -0.853,0.522 -0.919,1.093c-0.064,0.566 0.153,0.997 0.625,1.3c0.804,0.516 1.893,0.411 2.596,-0.254c0.528,-0.5 0.768,-1.126 0.772,-1.853z"}}),_c('path',{attrs:{"id":"svg_12","fill":"#24404F","d":"m107.397,33.179c-2.287,-0.026 -4.458,-0.5 -6.439,-1.707c-0.692,-0.422 -0.695,-0.456 -0.127,-1.069c0.548,-0.591 1.106,-1.175 1.64,-1.778c0.476,-0.536 1.038,-0.743 1.736,-0.569c0.777,0.194 1.556,0.38 2.335,0.567c0.43,0.102 0.853,0.122 1.24,-0.15c0.458,-0.324 0.466,-0.788 0.018,-1.12c-0.175,-0.128 -0.379,-0.199 -0.583,-0.27c-0.868,-0.3 -1.734,-0.606 -2.6,-0.912a10.597,10.597 0 0 1 -0.548,-0.207c-2.898,-1.212 -3.818,-4.673 -1.888,-7.181c1.083,-1.409 2.56,-2.19 4.28,-2.456c2.743,-0.423 5.325,0.107 7.737,1.488c0.069,0.039 0.134,0.083 0.202,0.121c0.237,0.135 0.29,0.298 0.099,0.52c-0.18,0.21 -0.346,0.43 -0.52,0.643c-0.576,0.698 -1.169,1.382 -1.702,2.116c-0.353,0.485 -0.59,0.543 -1.165,0.36c-0.633,-0.203 -1.268,-0.4 -1.903,-0.592a1.937,1.937 0 0 0 -1.212,0.012c-0.305,0.104 -0.59,0.238 -0.61,0.628c-0.017,0.313 0.124,0.507 0.554,0.665c0.55,0.2 1.112,0.372 1.669,0.556c0.593,0.196 1.187,0.393 1.781,0.588c3.496,1.15 3.797,5.515 1.813,7.568c-1.135,1.175 -2.492,1.883 -4.11,2.068c-0.564,0.065 -1.128,0.112 -1.697,0.11m-61.57,-11.965c0,3.579 0.002,7.158 -0.003,10.737c0,0.534 -0.043,0.575 -0.572,0.577c-1.839,0.007 -3.677,0.007 -5.515,0c-0.574,-0.003 -0.629,-0.058 -0.633,-0.662c-0.01,-1.483 -0.007,-2.966 -0.004,-4.449c0.006,-3.52 0.021,-7.04 0.02,-10.559c0,-1.463 -0.062,-2.926 0.047,-4.387c0.035,-0.476 0.128,-0.94 0.273,-1.392c0.22,-0.687 0.694,-1.09 1.405,-1.171a27.666,27.666 0 0 1 4.392,-0.163c0.504,0.023 0.521,0.041 0.548,0.554c0.023,0.454 0.028,0.91 0.028,1.364c0.002,3.183 0.001,6.367 0.001,9.55l0.013,0m-19.42,4.524c0,-1.937 -0.002,-3.875 0,-5.812c0.001,-0.535 0.05,-1.067 0.216,-1.579c0.246,-0.76 0.74,-1.241 1.544,-1.353c0.25,-0.035 0.504,-0.073 0.757,-0.076c1.075,-0.01 2.15,-0.014 3.225,-0.011c0.531,0 0.536,0.014 0.567,0.574c0.008,0.157 0.008,0.317 0.035,0.472c0.05,0.288 0.153,0.34 0.4,0.207c0.103,-0.055 0.194,-0.133 0.289,-0.202c0.478,-0.343 0.952,-0.693 1.436,-1.027c0.84,-0.58 1.766,-0.691 2.748,-0.508c0.287,0.054 0.405,0.204 0.382,0.488c-0.052,0.61 -0.1,1.221 -0.154,1.832c-0.067,0.767 -0.14,1.534 -0.21,2.301c-0.013,0.138 -0.02,0.277 -0.043,0.413c-0.084,0.522 -0.118,0.55 -0.625,0.582c-0.41,0.026 -0.82,0.046 -1.228,0.084c-1.697,0.159 -2.665,1.204 -2.68,2.919c-0.016,1.977 -0.011,3.953 -0.015,5.93c-0.001,0.297 0.002,0.593 -0.002,0.89c-0.008,0.641 -0.023,0.661 -0.667,0.662c-1.78,0.004 -3.559,0.004 -5.338,0c-0.626,-0.001 -0.65,-0.027 -0.65,-0.677c-0.004,-2.037 -0.002,-4.073 -0.002,-6.109l0.015,0z"}}),_c('path',{attrs:{"id":"svg_13","fill":"#00D5E0","d":"m159.861,18.554c0.302,-0.15 0.458,-0.413 0.661,-0.62c0.951,-0.965 2.096,-1.342 3.423,-1.158c0.756,0.105 0.988,0.372 0.973,1.133c-0.02,1.009 -0.199,2.005 -0.288,3.008c-0.006,0.06 -0.025,0.117 -0.028,0.176c-0.048,1.081 -0.229,0.915 -1.063,0.989c-0.507,0.044 -1.017,0.03 -1.512,0.175c-1.104,0.323 -1.771,1.033 -1.945,2.2a6.43,6.43 0 0 0 -0.072,0.944c-0.002,2.078 -0.006,4.155 -0.011,6.232c0,0.178 -0.004,0.356 -0.01,0.534c-0.006,0.183 -0.095,0.296 -0.281,0.316c-0.233,0.025 -0.466,0.058 -0.7,0.071c-1.604,0.088 -3.208,0.038 -4.812,0.037a2.6,2.6 0 0 1 -0.293,-0.018c-0.426,-0.05 -0.497,-0.112 -0.501,-0.56c-0.01,-1.227 -0.007,-2.454 -0.008,-3.68c-0.002,-3.542 -0.004,-7.083 -0.003,-10.624c0,-0.918 0.022,-0.939 0.924,-0.919c1.212,0.028 2.424,0.045 3.637,0.088c0.866,0.03 1.398,0.412 1.66,1.224c0.048,0.15 0.09,0.304 0.249,0.452"}})])])])])
}
var guru_logo_partvue_type_template_id_76efa870_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-part.vue?vue&type=template&id=76efa870

// CONCATENATED MODULE: ./src/components/svg/logos/guru-logo-part.vue

var guru_logo_part_script = {}


/* normalize component */

var guru_logo_part_component = normalizeComponent(
  guru_logo_part_script,
  guru_logo_partvue_type_template_id_76efa870_render,
  guru_logo_partvue_type_template_id_76efa870_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var guru_logo_part = (guru_logo_part_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/gyg-logo.vue?vue&type=template&id=7ddfd2cc
var gyg_logovue_type_template_id_7ddfd2cc_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"360","height":"285","viewBox":"0 0 360 285","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M92.9 118.5C87.3 118.5 83 122.8 83 128.4C83 134 87.4 138.3 92.9 138.3C98.5 138.3 102.8 134 102.8 128.4C102.8 122.8 98.5 118.5 92.9 118.5Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M149.7 69.6H114.5V52.7H145.9V35.8H114.5V19.2H149.1V2.2H95.6V86.6H149.7V69.6Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M110.5 120.6C116 120.6 120.4 116.3 120.4 110.7C120.4 105.1 116 100.8 110.5 100.8C104.9 100.8 100.6 105.1 100.6 110.7C100.6 116.3 105 120.6 110.5 120.6Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M36.7 88.3C49 88.3 59.7 82.1 66.1 72.5V86.6H82.7V39.7H38.1V55.9H56.8C55.1 64.6 47.4 71.3 38.2 71.3C27.9 71.3 19.6 63 19.6 50.8V38.3C19.6 26.4 28.5 17.6 41 17.6C50.7 17.6 59.4 22.9 62.3 30.7L79.9 24.6C75 9.8 59.3 0.599998 41.2 0.599998C18.3 0.599998 1.19999 16 1.19999 38.4V50.9C1.09999 72.4 17.1 88.3 36.7 88.3Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M199.3 37.2V25.9H180.6V41.7V52.9H199.3V37.2Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M221.9 2.2H157.8V19.2H221.9V2.2Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M32.3 184.6H51.3V152.6L83.1 100.2H61.7L41.7 134.8L21.9 100.2H0.5L32.3 152.8V184.6Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M199.3 75.3V59.6H180.6V70.8V86.6H199.3V75.3Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M343.5 184.6L320.5 152.3C331.7 148.8 339.6 139 339.6 127C339.6 111.7 327 100.2 311 100.2H300V117.3H310.4C315.9 117.3 320.2 121.7 320.2 127.5C320.2 133.3 315.9 137.7 310.4 137.7H300V153.9L320.6 184.7H343.5V184.6Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M249.6 198.1H221.7V282.6H249.6C275.7 282.6 294.2 264.7 294.2 240.4C294.2 216.1 275.7 198.1 249.6 198.1ZM251.1 265.6H240.7V215.1H251.1C265.2 215.1 274.8 226 274.8 240.4C274.8 254.8 265.2 265.6 251.1 265.6Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M324.5 248.7H355.8V231.9H324.5V215.2H359.1V198.2H305.5V282.6H359.6V265.6H324.5V248.7Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M294.3 156.1L284.5 142.2L294.2 128.1L284.4 114.2L294 100.2H274.5L264.8 114.4L274.6 128.3L264.9 142.3L274.7 156.2L265.1 170.3L275.5 184.7H295.2L284.6 170.1L294.3 156.1Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M251.1 151.8V100.2H232.3V152.1C232.3 161.8 225.4 169 215.9 169C206.4 169 199.5 161.8 199.5 152.1V100.2H180.7V151.8C180.7 171.7 195.6 186.4 216 186.4C236.2 186.3 251.1 171.7 251.1 151.8Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M147.6 250.1C147.6 259.8 140.7 267 131.2 267C121.7 267 114.8 259.8 114.8 250.1V198.2H96V249.8C96 269.7 110.9 284.4 131.3 284.4C151.7 284.4 166.6 269.7 166.6 249.8V198.2H147.8V250.1H147.6Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M38.1 251.9H56.8C55.1 260.6 47.4 267.3 38.2 267.3C27.9 267.3 19.6 259 19.6 246.8V234.3C19.6 222.4 28.5 213.6 41 213.6C50.7 213.6 59.4 218.9 62.3 226.7L79.9 220.6C75 205.8 59.3 196.5 41.2 196.5C18.3 196.5 1.20001 211.9 1.20001 234.3V246.8C1.20001 268.4 17.2 284.4 36.8 284.4C49.1 284.4 59.8 278.2 66.2 268.6V282.7H82.8V235.8H38.2V251.9H38.1Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M124.7 98.5V116.3C138.6 116.3 149.6 127.6 149.6 142.4C149.6 157.2 138.6 168.5 124.7 168.5C110.8 168.5 99.8 157.2 99.8 142.4H80.4C80.4 167 100.1 186.3 124.7 186.3C149.3 186.3 169 167 169 142.4C169 117.8 149.4 98.5 124.7 98.5Z","fill":"#FF5533"}}),_c('path',{attrs:{"d":"M202.3 237.9C205.1 235.4 209.8 231.1 209.8 223.4C209.8 215.6 205.1 211.4 202.3 208.9C202.2 208.8 202.1 208.7 202 208.6C200.6 207.1 200.4 205 200.3 204V198.1H181.3V206C181.3 206.1 181.3 206.2 181.3 206.3C181.3 214.1 186 218.3 188.8 220.8C190.8 222.6 190.8 222.7 190.8 223.4C190.8 224.1 190.8 224.2 188.8 226C186.1 228.4 181.7 232.4 181.3 239.7C181.3 239.8 181.3 240 181.3 240.1C181.3 240.2 181.3 240.2 181.3 240.3C181.3 240.4 181.3 240.4 181.3 240.5C181.3 240.6 181.3 240.8 181.3 240.9C181.6 248.1 186.1 252.1 188.8 254.6C190.8 256.4 190.8 256.5 190.8 257.2C190.8 257.9 190.8 258 188.8 259.8C186 262.3 181.3 266.6 181.3 274.3C181.3 274.4 181.3 274.5 181.3 274.6V282.5H200.3V276.6C200.3 275.6 200.6 273.5 202 272C202.1 271.9 202.2 271.8 202.3 271.7C205.1 269.2 209.8 264.9 209.8 257.2C209.8 249.4 205.1 245.2 202.3 242.7C200.5 241.1 200.3 240.8 200.3 240.3C200.3 239.8 200.5 239.6 202.3 237.9Z","fill":"#FF5533"}})])
}
var gyg_logovue_type_template_id_7ddfd2cc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/gyg-logo.vue?vue&type=template&id=7ddfd2cc

// CONCATENATED MODULE: ./src/components/svg/logos/gyg-logo.vue

var gyg_logo_script = {}


/* normalize component */

var gyg_logo_component = normalizeComponent(
  gyg_logo_script,
  gyg_logovue_type_template_id_7ddfd2cc_render,
  gyg_logovue_type_template_id_7ddfd2cc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var gyg_logo = (gyg_logo_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-scroll-top.vue?vue&type=template&id=2eff5cce
var guru_scroll_topvue_type_template_id_2eff5cce_render = function render(){var _vm=this,_c=_vm._self._c;return (['de', 'at'].includes(_vm.locale))?_c('svg',{attrs:{"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"filter":"url(#scroll-to-top)"}},[_c('rect',{attrs:{"x":"5","y":"5","width":"54","height":"54","rx":"27","fill":"#fff"}})]),_c('path',{attrs:{"d":"m32.323 10.359 6.441 6.441a.37.37 0 0 1 0 .523l-.609.61a.37.37 0 0 1-.523 0l-5.57-5.56-5.571 5.56a.37.37 0 0 1-.523 0l-.61-.61a.37.37 0 0 1 0-.523l6.442-6.44a.37.37 0 0 1 .523 0Z","fill":"#323231"}}),_c('path',{attrs:{"d":"M34.08 39.398v-3.702c0-.168.033-.28.19-.369.514-.335.927-.783 1.274-1.286.1-.145.112-.157.235-.056 1.844 1.431 3.353 3.131 4.27 5.312a8.47 8.47 0 0 1 .67 3.31c0 .85 0 1.7-.145 2.54-.502 2.974-2.168 4.987-4.952 6.106-.905.358-1.855.525-2.817.637-.905.112-1.822.146-2.728.067-1.934-.179-3.733-.738-5.276-1.946-1.476-1.152-2.325-2.672-2.538-4.53-.134-1.207-.19-2.426-.1-3.645.089-1.13.424-2.192.939-3.199.749-1.476 1.788-2.74 3.007-3.847.313-.29.648-.559.995-.816.1-.078.156-.067.223.045.347.514.772.961 1.297 1.308.112.078.123.179.123.302v7.023c0 .526.056 1.052.224 1.555.335 1.04 1.084 1.622 2.18 1.678.28.01.558.022.827-.034.995-.19 1.721-.906 1.934-1.912a8.212 8.212 0 0 0 .145-1.656c.011-.961 0-1.934 0-2.896h.023v.01Z","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M21.122 42.205a9.172 9.172 0 0 1-.973-1.018c-.995-1.196-1.587-2.572-1.889-4.093-.179-.895-.28-1.8-.257-2.718.078-4.395 2.437-8.533 6.182-10.647a13.66 13.66 0 0 1 4.55-1.565 14.13 14.13 0 0 1 2.918-.146c1.084.045 2.124.269 3.085.783.704.38 1.308.872 1.822 1.476.593.705.917 1.533 1.096 2.416.369 1.8-.045 3.422-1.118 4.887-.034.045-.056.112-.156.135V31.4c.078-2.281-1.431-4.272-3.555-4.898-2.84-.839-5.802 1.018-6.272 3.925a4.875 4.875 0 0 0 .157 2.338c.067.224.067.224-.123.369-1.7 1.275-3.13 2.807-4.17 4.664-.75 1.342-1.196 2.762-1.286 4.305.011.012 0 .034-.011.101Z","fill":"#00D6E1"}}),_c('path',{attrs:{"d":"M38.562 29.825c.123.011.18.112.257.179.85.838 1.454 1.834 1.912 2.919.157.38.29.771.414 1.163.022.056.022.123.09.179.055-.045.033-.112.033-.168a7.66 7.66 0 0 0-.459-2.002c-.044-.123-.1-.246-.145-.369-.067-.168-.056-.19.112-.212.704-.101 1.42-.18 2.135-.068.011 0 .033 0 .067-.01-.056-.101-.157-.113-.246-.146a3.196 3.196 0 0 0-1.084-.18c-.336 0-.682-.01-1.018.046-.111.022-.223.033-.29-.112-.29-.56-.671-1.052-1.118-1.532.827-.739 1.8-1.22 2.783-1.7-.234-.012-.447.044-.66.1-.849.235-1.642.604-2.324 1.175-.056.044-.09.123-.18.067-.089-.045-.111-.112-.1-.224a6.84 6.84 0 0 0 .078-1.074 7.38 7.38 0 0 0-.816-3.299c-.044-.078-.1-.145-.1-.257.111-.045.201.034.29.078.817.403 1.577.873 2.303 1.42 1.465 1.119 2.639 2.483 3.432 4.161.56 1.186.928 2.438 1.04 3.747.09 1.084 0 2.158-.302 3.21-.402 1.409-.972 2.75-1.822 3.947a5.07 5.07 0 0 1-.716.828c-.111.1-.223.201-.39.246a18.093 18.093 0 0 0-.113-.861c-.223-1.499-.804-2.863-1.632-4.127-.894-1.387-2.023-2.572-3.309-3.601a.4.4 0 0 0-.112-.079c-.089-.055-.089-.111-.01-.19a8.1 8.1 0 0 0 .692-.816c.537-.705.962-1.465 1.23-2.304.022-.022.034-.078.078-.134Z","fill":"#ACE632"}}),_c('path',{attrs:{"d":"M31.407 35.282c-2.19.012-4.024-1.834-3.99-4.06a4.037 4.037 0 0 1 4.08-4.003c2.202.011 4.002 1.845 3.98 4.082-.023 2.304-1.957 4.026-4.07 3.981Z","fill":"#FFEB00"}}),_c('defs',[_c('filter',{attrs:{"id":"scroll-to-top","x":"0","y":"0","width":"64","height":"64","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"2.5"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_2485_72125"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_2485_72125","result":"shape"}})],1)])]):_c('svg',{attrs:{"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"filter":"url(#scroll-to-top)"}},[_c('rect',{attrs:{"x":"5","y":"5","width":"54","height":"54","rx":"27","fill":"#fff"}})]),_c('path',{attrs:{"d":"m32.323 10.359 6.441 6.441a.37.37 0 0 1 0 .523l-.609.61a.37.37 0 0 1-.523 0l-5.57-5.56-5.571 5.56a.37.37 0 0 1-.523 0l-.61-.61a.37.37 0 0 1 0-.523l6.442-6.44a.37.37 0 0 1 .523 0Z","fill":"#323231"}}),_c('svg',{attrs:{"width":"27","height":"30","y":"22","x":"19","viewBox":"0 0 27 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.6912 11.7319C17.7424 11.7462 17.7622 11.7462 17.7764 11.7575C20.2157 13.6162 22.0699 15.8818 22.7742 18.9501C22.8735 19.3856 22.9048 19.8239 22.9048 20.268C22.9076 23.3306 22.9048 26.3932 22.9048 29.4558C22.9048 29.5469 22.9019 29.6408 22.9048 29.7319C22.9105 29.914 22.831 30.008 22.6435 29.9994C22.5697 29.9966 22.4959 29.9994 22.422 29.9994C20.4712 29.9994 18.5204 29.9994 16.5696 29.9994C16.0954 29.9994 16.0925 29.9937 16.0925 29.5156C16.0897 27.7452 16.0925 25.9719 16.0925 24.2015C16.0925 23.749 16.0869 23.7433 15.6439 23.7433C14.0793 23.7404 12.5146 23.7404 10.95 23.7433C10.561 23.7433 10.5525 23.7518 10.5525 24.1389C10.5496 25.8723 10.5496 27.6085 10.5496 29.3419C10.5496 29.47 10.5439 29.601 10.5496 29.729C10.5581 29.9112 10.4815 30.0051 10.294 29.9994C10.2032 29.9966 10.1095 29.9994 10.0186 29.9994C8.10471 29.9994 6.1908 29.9994 4.2769 29.9994C3.66923 29.9994 3.72602 30.0137 3.72602 29.4729C3.72886 26.5213 3.7317 23.5697 3.73738 20.6181C3.74022 19.2063 4.10653 17.8856 4.73692 16.6332C5.69103 14.7376 7.0796 13.2035 8.72942 11.8942C8.93103 11.7319 9.0503 11.7177 9.20648 11.9539C9.48192 12.3723 9.83119 12.7338 10.2401 13.0213C10.4673 13.1807 10.5184 13.3686 10.5184 13.6276C10.507 14.9369 10.5099 16.2462 10.5155 17.5583C10.5155 18.0052 10.5241 18.0109 10.9727 18.0137C12.5203 18.0165 14.0651 18.0165 15.6126 18.0137C16.067 18.0137 16.0727 18.0052 16.0727 17.5611C16.0755 16.2888 16.0812 15.0137 16.067 13.7414C16.0641 13.4596 16.1238 13.2632 16.3765 13.0982C16.916 12.7481 17.3221 12.2443 17.6912 11.7319Z","fill":"#323231"}}),_c('path',{attrs:{"d":"M3.10218 20.0679C2.73562 19.7347 2.42459 19.4126 2.13579 19.0571C1.14718 17.8686 0.55846 16.5023 0.258546 14.9916C0.0808192 14.103 -0.0191522 13.2032 0.00306367 12.2924C0.0808192 7.92696 2.42459 3.81703 6.14575 1.71763C7.55646 0.928966 9.06714 0.418001 10.6667 0.162518C11.622 0.00700738 12.5884 -0.0263164 13.5659 0.0181153C14.6433 0.062547 15.6764 0.284706 16.6316 0.795671C17.3314 1.17334 17.9313 1.66209 18.4422 2.26192C19.031 2.96172 19.3531 3.7837 19.5308 4.66123C19.8974 6.44961 19.4864 8.06026 18.42 9.5154C18.3867 9.55983 18.3645 9.62648 18.2645 9.64869C18.2645 9.53761 18.2645 9.43764 18.2645 9.33767C18.3423 7.07165 16.8427 5.09444 14.7322 4.4724C11.9108 3.6393 8.96717 5.48322 8.50063 8.37128C8.36734 9.15994 8.41177 9.92639 8.65614 10.6928C8.72279 10.915 8.72279 10.915 8.53396 11.0594C6.84555 12.3257 5.42374 13.8475 4.3907 15.6914C3.64647 17.0244 3.20215 18.4351 3.11329 19.968C3.12439 19.9791 3.11329 20.0013 3.10218 20.0679","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M20.4301 7.77207C20.5523 7.78318 20.6078 7.88315 20.6856 7.9498C21.5298 8.78289 22.1296 9.7715 22.585 10.849C22.7405 11.2266 22.8738 11.6154 22.996 12.0042C23.0182 12.0597 23.0182 12.1264 23.0849 12.1819C23.1404 12.1375 23.1182 12.0708 23.1182 12.0153C23.0627 11.3266 22.896 10.6712 22.6628 10.027C22.6183 9.90479 22.5628 9.7826 22.5184 9.66042C22.4517 9.4938 22.4628 9.47158 22.6295 9.44937C23.3293 9.3494 24.0402 9.27164 24.7511 9.38272C24.7622 9.38272 24.7844 9.38272 24.8177 9.37161C24.7622 9.27164 24.6622 9.26053 24.5733 9.22721C24.229 9.10502 23.8735 9.04948 23.4959 9.04948C23.1626 9.04948 22.8183 9.03837 22.4851 9.09391C22.374 9.11613 22.2629 9.12724 22.1962 8.98283C21.9074 8.42744 21.5298 7.93869 21.0855 7.46105C21.9074 6.72792 22.8738 6.25028 23.8513 5.77264C23.6181 5.76153 23.407 5.81707 23.196 5.87261C22.3518 6.10588 21.5631 6.47244 20.8855 7.03895C20.83 7.08338 20.7966 7.16113 20.7078 7.10559C20.6189 7.06116 20.5967 6.99451 20.6078 6.88343C20.6633 6.52798 20.6856 6.18363 20.6856 5.81707C20.6745 4.66185 20.3968 3.57327 19.8747 2.54023C19.8303 2.46248 19.7747 2.39583 19.7747 2.28475C19.8858 2.24032 19.9747 2.31807 20.0635 2.36251C20.8744 2.76239 21.6297 3.22893 22.3518 3.77321C23.8069 4.88401 24.9732 6.23917 25.7619 7.90536C26.3173 9.08281 26.6838 10.3269 26.7949 11.6265C26.8838 12.704 26.7949 13.7704 26.495 14.8145C26.0951 16.2141 25.5286 17.547 24.6844 18.7356C24.4734 19.0355 24.2401 19.3132 23.9735 19.5576C23.8624 19.6576 23.7514 19.7575 23.5847 19.802C23.5514 19.502 23.5181 19.2243 23.4737 18.9466C23.2515 17.4582 22.6739 16.103 21.8519 14.8478C20.9633 13.4704 19.8414 12.293 18.564 11.2711C18.5306 11.2377 18.4973 11.2155 18.4529 11.1933C18.364 11.1378 18.364 11.0822 18.4418 11.0045C18.6861 10.749 18.9194 10.4824 19.1305 10.1936C19.6636 9.4938 20.0857 8.73846 20.3523 7.90536C20.3745 7.88315 20.3857 7.82761 20.4301 7.77207","fill":"#ABE532"}}),_c('path',{attrs:{"d":"M13.3215 13.192C11.1443 13.2031 9.3226 11.3703 9.35592 9.1598C9.37813 6.93821 11.1776 5.17205 13.4103 5.18316C15.5986 5.19427 17.387 7.01597 17.3647 9.23755C17.3425 11.5258 15.4209 13.2364 13.3215 13.192","fill":"#FFEA00"}})]),_c('defs',[_c('filter',{attrs:{"id":"scroll-to-top","x":"0","y":"0","width":"64","height":"64","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"2.5"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_2485_72125"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_2485_72125","result":"shape"}})],1)])])
}
var guru_scroll_topvue_type_template_id_2eff5cce_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/guru-scroll-top.vue?vue&type=template&id=2eff5cce

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/guru-scroll-top.vue?vue&type=script&lang=js

/* harmony default export */ var guru_scroll_topvue_type_script_lang_js = ({
  props: {
    locale: {
      type: String,
      default: 'de',
    },
  },
});

// CONCATENATED MODULE: ./src/components/svg/logos/guru-scroll-top.vue?vue&type=script&lang=js
 /* harmony default export */ var logos_guru_scroll_topvue_type_script_lang_js = (guru_scroll_topvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/svg/logos/guru-scroll-top.vue





/* normalize component */

var guru_scroll_top_component = normalizeComponent(
  logos_guru_scroll_topvue_type_script_lang_js,
  guru_scroll_topvue_type_template_id_2eff5cce_render,
  guru_scroll_topvue_type_template_id_2eff5cce_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var guru_scroll_top = (guru_scroll_top_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/apple-logo.vue?vue&type=template&id=76e49406
var apple_logovue_type_template_id_76e49406_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"20","viewBox":"0 0 17 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"apple-in-brands"}},[_c('path',{attrs:{"id":"logo_apple","d":"M14.2183 10.5689C14.2094 8.9302 14.9506 7.69336 16.4508 6.78248C15.6114 5.58137 14.3433 4.92054 12.6689 4.79105C11.0838 4.66603 9.35133 5.71533 8.71729 5.71533C8.04752 5.71533 6.51153 4.8357 5.30595 4.8357C2.81443 4.87589 0.166626 6.82267 0.166626 10.7832C0.166626 11.9531 0.380951 13.1616 0.8096 14.4089C1.38113 16.0476 3.44401 20.0662 5.59618 19.9992C6.72139 19.9724 7.51618 19.1999 8.98073 19.1999C10.4006 19.1999 11.1374 19.9992 12.3921 19.9992C14.5621 19.9679 16.4285 16.3155 16.9733 14.6723C14.062 13.3015 14.2183 10.6537 14.2183 10.5689ZM11.691 3.2372C12.91 1.7905 12.7984 0.4733 12.7627 0C11.6866 0.0625114 10.4408 0.732276 9.73086 1.55832C8.94947 2.44241 8.48957 3.53636 8.5878 4.76872C9.75319 4.85803 10.8159 4.2597 11.691 3.2372Z","fill":"black"}})])])
}
var apple_logovue_type_template_id_76e49406_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/apple-logo.vue?vue&type=template&id=76e49406

// CONCATENATED MODULE: ./src/components/svg/logos/apple-logo.vue

var apple_logo_script = {}


/* normalize component */

var apple_logo_component = normalizeComponent(
  apple_logo_script,
  apple_logovue_type_template_id_76e49406_render,
  apple_logovue_type_template_id_76e49406_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var apple_logo = (apple_logo_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/facebook-logo.vue?vue&type=template&id=5a020d0a
var facebook_logovue_type_template_id_5a020d0a_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"version":"1.1","id":"svg9","width":"666.66669","height":"666.66718","viewBox":"0 0 666.66668 666.66717","xmlns":"http://www.w3.org/2000/svg","xmlns:svg":"http://www.w3.org/2000/svg"}},[_c('defs',{attrs:{"id":"defs13"}},[_c('clipPath',{attrs:{"clipPathUnits":"userSpaceOnUse","id":"clipPath25"}},[_c('path',{attrs:{"d":"M 0,700 H 700 V 0 H 0 Z","id":"path23"}})])]),_c('g',{attrs:{"id":"g17","transform":"matrix(1.3333333,0,0,-1.3333333,-133.33333,799.99999)"}},[_c('g',{attrs:{"id":"g19"}},[_c('g',{attrs:{"id":"g21","clip-path":"url(#clipPath25)"}},[_c('g',{attrs:{"id":"g27","transform":"translate(600,350)"}},[_c('path',{staticStyle:{"fill":"#0866ff","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},attrs:{"d":"m 0,0 c 0,138.071 -111.929,250 -250,250 -138.071,0 -250,-111.929 -250,-250 0,-117.245 80.715,-215.622 189.606,-242.638 v 166.242 h -51.552 V 0 h 51.552 v 32.919 c 0,85.092 38.508,124.532 122.048,124.532 15.838,0 43.167,-3.105 54.347,-6.211 V 81.986 c -5.901,0.621 -16.149,0.932 -28.882,0.932 -40.993,0 -56.832,-15.528 -56.832,-55.9 V 0 h 81.659 l -14.028,-76.396 h -67.631 V -248.169 C -95.927,-233.218 0,-127.818 0,0","id":"path29"}})]),_c('g',{attrs:{"id":"g31","transform":"translate(447.9175,273.6036)"}},[_c('path',{staticStyle:{"fill":"#ffffff","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"},attrs:{"d":"M 0,0 14.029,76.396 H -67.63 v 27.019 c 0,40.372 15.838,55.899 56.831,55.899 12.733,0 22.981,-0.31 28.882,-0.931 v 69.253 c -11.18,3.106 -38.509,6.212 -54.347,6.212 -83.539,0 -122.048,-39.441 -122.048,-124.533 V 76.396 h -51.552 V 0 h 51.552 v -166.242 c 19.343,-4.798 39.568,-7.362 60.394,-7.362 10.254,0 20.358,0.632 30.288,1.831 L -67.63,0 Z","id":"path33"}})])])])])])
}
var facebook_logovue_type_template_id_5a020d0a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/facebook-logo.vue?vue&type=template&id=5a020d0a

// CONCATENATED MODULE: ./src/components/svg/logos/facebook-logo.vue

var facebook_logo_script = {}


/* normalize component */

var facebook_logo_component = normalizeComponent(
  facebook_logo_script,
  facebook_logovue_type_template_id_5a020d0a_render,
  facebook_logovue_type_template_id_5a020d0a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var facebook_logo = (facebook_logo_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/logos/google-logo.vue?vue&type=template&id=106aea46
var google_logovue_type_template_id_106aea46_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24","width":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z","fill":"#FBBC05"}}),_c('path',{attrs:{"d":"M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z","fill":"#EA4335"}}),_c('path',{attrs:{"d":"M1 1h22v22H1z","fill":"none"}})])
}
var google_logovue_type_template_id_106aea46_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/logos/google-logo.vue?vue&type=template&id=106aea46

// CONCATENATED MODULE: ./src/components/svg/logos/google-logo.vue

var google_logo_script = {}


/* normalize component */

var google_logo_component = normalizeComponent(
  google_logo_script,
  google_logovue_type_template_id_106aea46_render,
  google_logovue_type_template_id_106aea46_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var google_logo = (google_logo_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/adults-svg.vue?vue&type=template&id=f051bd06
var adults_svgvue_type_template_id_f051bd06_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"19","height":"14","viewBox":"0 0 19 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.625 7.375a3.28 3.28 0 003.281-3.281A3.28 3.28 0 005.625.813a3.28 3.28 0 00-3.281 3.28 3.28 3.28 0 003.281 3.282zm8.437 0a2.813 2.813 0 10-.001-5.626 2.813 2.813 0 00.001 5.626zM5.625 5.969A1.877 1.877 0 013.75 4.094c0-1.034.84-1.875 1.875-1.875 1.034 0 1.875.84 1.875 1.875 0 1.034-.84 1.875-1.875 1.875zm8.437 0a1.407 1.407 0 11.001-2.813 1.407 1.407 0 010 2.813zm-4.218 7.968c.776 0 1.406-.63 1.406-1.406V11.22c0-.697-.211-1.345-.574-1.884-.607-.9-1.64-1.374-2.704-1.374-.349 0-.7.05-1.04.155a4.497 4.497 0 01-1.31.197c-.457 0-.893-.07-1.31-.197a3.608 3.608 0 00-1.04-.155c-1.063 0-2.097.475-2.704 1.374A3.399 3.399 0 000 11.219v1.312c0 .777.63 1.406 1.406 1.406h8.438zM17.578 13c.648 0 1.172-.524 1.172-1.172v-1.093a2.8 2.8 0 00-.478-1.57c-.506-.75-1.368-1.145-2.253-1.145-.814 0-1.019.293-1.957.293-.937 0-1.142-.293-1.957-.293-.39 0-.767.087-1.119.237.17.173.331.351.47.554.137.205.251.421.35.644.097-.02.197-.032.3-.032.503 0 .867.293 1.956.293 1.096 0 1.45-.293 1.957-.293.46 0 .865.196 1.087.524.156.232.238.501.238.782v.865h-5.157v.937c0 .161-.017.317-.046.469h5.437zm-7.731-.469h-8.44V11.22c0-.847.538-1.57 1.291-1.849.302-.111.633-.108.935 0a5.907 5.907 0 001.992.349c.674 0 1.342-.117 1.995-.349.302-.108.633-.111.935 0a1.972 1.972 0 011.292 1.849v1.312z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var adults_svgvue_type_template_id_f051bd06_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/adults-svg.vue?vue&type=template&id=f051bd06

// CONCATENATED MODULE: ./src/components/svg/attributes/adults-svg.vue

var adults_svg_script = {}


/* normalize component */

var adults_svg_component = normalizeComponent(
  adults_svg_script,
  adults_svgvue_type_template_id_f051bd06_render,
  adults_svgvue_type_template_id_f051bd06_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var adults_svg = (adults_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/baby-bottle-svg.vue?vue&type=template&id=5a91c1c8
var baby_bottle_svgvue_type_template_id_5a91c1c8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18.551 1.426c.538.473.814 1.326.654 2.023-.134.583-.64 1.161-1.218 1.448l-.146.065-.047.016.036.09c.123.316.19.553.213.812l.01.16v.169c-.01.34-.075.683-.192 1.011l-.041.101c.129.186.215.388.259.601l.025.162.008.165c0 .378-.13.738-.366 1.026l-.109.12-.843.843c-.22.219-.501.354-.805.388l-.091.004-.015.17a3.474 3.474 0 01-.702 1.714l-.151.183-.148.157-5.612 5.611a2.666 2.666 0 01-1.896.785c-.652 0-1.269-.23-1.755-.652l-.142-.133-3.942-3.942a2.666 2.666 0 01-.785-1.896c0-.652.23-1.268.652-1.755l.133-.142 3.01-2.99.005-.011.063-.082h.005l.096-.086-.048.038 2.48-2.481a3.482 3.482 0 012.265-1.02l.067-.003.001-.049a1.61 1.61 0 01.26-.767l.097-.134.113-.125.657-.657a1.61 1.61 0 011.145-.474c.277 0 .545.069.782.2l.146.091.101-.04c.164-.06.332-.105.501-.137l.255-.038.257-.017c.412-.01.707.056 1.139.222l.089.035.017-.045c.216-.54.698-1.04 1.223-1.268l.145-.056.145-.04c.697-.16 1.55.115 2 .63zM9.626 5.751c-.345 0-.676.094-.963.27l-.062.042.521.52a.831.831 0 01.075 1.09l-.075.084a.826.826 0 01-1.091.073l-.083-.073-.547-.546-1.009 1.008.547.547c.13.13.213.298.236.478l.008.11a.826.826 0 01-.83.83.826.826 0 01-.505-.171l-.083-.073-.547-.546-1.008 1.008.546.547c.13.13.213.298.237.478l.007.11a.826.826 0 01-.83.83.826.826 0 01-.505-.171l-.082-.073-.548-.547-.326.328a1.012 1.012 0 00-.291.588l-.009.135c0 .227.074.443.21.62l.09.102 3.942 3.942c.368.368.949.396 1.35.085l.095-.085 5.612-5.612c.68-.679.717-1.76.114-2.484l-.113-.124-2.779-2.78a1.831 1.831 0 00-1.304-.54zm2.125-2.186l-.601.6 3.658 3.667.08.066.007.01.94.94.6-.599-4.684-4.684zm5.23-1.154l-.065.005-.041.02c-.09.056-.226.201-.28.302l-.021.054c-.09.438-.37.834-.737 1.038a1.205 1.205 0 01-1.014.082l-.227-.088-.345-.138-.048-.017 2.127 2.127-.071-.19-.171-.429a1.208 1.208 0 01.082-1.014c.204-.367.6-.646 1.038-.737.093-.019.29-.193.354-.284l.02-.037.007-.056c.004-.126-.075-.329-.133-.375a.823.823 0 01-.13-.13c-.037-.046-.16-.098-.269-.122l-.076-.011z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var baby_bottle_svgvue_type_template_id_5a91c1c8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/baby-bottle-svg.vue?vue&type=template&id=5a91c1c8

// CONCATENATED MODULE: ./src/components/svg/attributes/baby-bottle-svg.vue

var baby_bottle_svg_script = {}


/* normalize component */

var baby_bottle_svg_component = normalizeComponent(
  baby_bottle_svg_script,
  baby_bottle_svgvue_type_template_id_5a91c1c8_render,
  baby_bottle_svgvue_type_template_id_5a91c1c8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var baby_bottle_svg = (baby_bottle_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/baby-svg.vue?vue&type=template&id=8ce83524
var baby_svgvue_type_template_id_8ce83524_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"15","height":"20","viewBox":"0 0 15 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.031 6.037l.163.101 1.304.895a4.06 4.06 0 002.329.726c.887 0 1.699-.276 2.273-.628l.15-.098 1.305-.895a2.109 2.109 0 012.928.545c.328.477.432 1.045.334 1.575a2.104 2.104 0 01-.723 1.238l-.153.116-1.304.891a8.296 8.296 0 01-.903.537l-.32.154v.705l1.908 1.98a2.097 2.097 0 01.461 2.445l-.088.165-1.371 2.008a2.122 2.122 0 01-1.752.936c-.376 0-.744-.101-1.068-.293-.305-.181-.993-.732-1.012-1.63-.01-.473.166-1.048.699-1.72l.14-.17-.52-.327c-.478.154-1.138.173-1.66.058l-.214-.058-.52.327c.643.745.85 1.377.84 1.89-.02.898-.707 1.449-1.013 1.63a2.093 2.093 0 01-1.068.293c-.644 0-1.254-.3-1.649-.795l-.102-.14-1.375-2.015a2.101 2.101 0 01-.273-1.37c.058-.404.235-.79.518-1.102l.127-.13L4.34 11.9v-.705a8.51 8.51 0 01-.935-.501l-.29-.19-1.303-.891a2.1 2.1 0 01-.876-1.353 2.102 2.102 0 011.686-2.454 2.093 2.093 0 011.41.232zm6.948 7.467L9.86 14.622l1.042.982-.987 1.346-.05.107a.768.768 0 00-.024.462c.048.188.169.358.735.568a.76.76 0 00.655-.373h0l1.314-1.918.048-.097a.764.764 0 00-.225-.872h0l-1.39-1.323zm-6.27-.085l-1.318 1.4-.086.08a.758.758 0 00-.098.903h0l1.665 2.176.088.018c.156.024.355.018.614-.023a.764.764 0 00.254-1.031h0l-.985-1.334 1.043-.983-1.178-1.206zM9.95 12.29l-4.142.347L6.94 13.77l.1.085c.217.157.528.234.837.234.356 0 .716-.101.934-.32h0L9.95 12.29zm2.817-5.184l-.111.005a.805.805 0 00-.345.138h0l-1.299.891-.243.158c-.9.551-1.898.802-2.874.802a5.621 5.621 0 01-3.158-.96h0l-1.3-.892-.115-.067a.702.702 0 00-.446-.064.795.795 0 00-.494.338.773.773 0 00-.134.573.74.74 0 00.328.474h0l1.3.891.285.186a7.29 7.29 0 001.523.698h0v.649h4.384v-.649l.315-.112a7.116 7.116 0 001.494-.772h0l1.3-.892.104-.083a.701.701 0 00.224-.39.773.773 0 00-.135-.574.796.796 0 00-.495-.337h0l-.108-.011zM7.877.9c.818 0 1.56.332 2.096.868s.868 1.278.868 2.097c0 .818-.332 1.56-.868 2.096a2.955 2.955 0 01-2.097.868c-.819 0-1.56-.332-2.096-.868a2.955 2.955 0 01-.868-2.096c0-.82.331-1.56.868-2.097A2.955 2.955 0 017.876.9zm0 1.346c-.448 0-.852.181-1.145.474a1.614 1.614 0 00-.475 1.145c0 .446.182.851.475 1.144a1.614 1.614 0 002.289 0 1.614 1.614 0 000-2.289 1.614 1.614 0 00-1.145-.474z","fill":"currentColor","fill-rule":"nonzero","stroke":"currentColor","stroke-width":".2"}})])
}
var baby_svgvue_type_template_id_8ce83524_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/baby-svg.vue?vue&type=template&id=8ce83524

// CONCATENATED MODULE: ./src/components/svg/attributes/baby-svg.vue

var baby_svg_script = {}


/* normalize component */

var baby_svg_component = normalizeComponent(
  baby_svg_script,
  baby_svgvue_type_template_id_8ce83524_render,
  baby_svgvue_type_template_id_8ce83524_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var baby_svg = (baby_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/beach-svg.vue?vue&type=template&id=f2518cc0
var beach_svgvue_type_template_id_f2518cc0_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"16","viewBox":"0 0 20 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.5 16a.5.5 0 00.5-.5V15a.5.5 0 00-.5-.5H9.563l2.614-7.097 7.146 2.6c.057.021.116.03.173.03a.495.495 0 00.501-.472c.095-3.896-2.274-7.59-6.138-8.996A9.308 9.308 0 0010.669 0a9.36 9.36 0 00-7.295 3.51c-.21.263-.083.658.232.773l7.162 2.606L7.964 14.5H.5a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5h17zM8.194 4.357l-2.633-.959a7.917 7.917 0 014.83-1.885c-.14.117-1.152.889-2.197 2.844zm5.95 2.165L9.605 4.87c.446-.789.955-1.477 1.505-1.999.792-.75 1.564-1.067 2.107-.868.548.2.932.935 1.057 2.02.087.753.034 1.608-.132 2.499zm4.254 1.548l-2.843-1.034c.23-1.096.377-2.409.129-3.697a7.814 7.814 0 012.714 4.731z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var beach_svgvue_type_template_id_f2518cc0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/beach-svg.vue?vue&type=template&id=f2518cc0

// CONCATENATED MODULE: ./src/components/svg/attributes/beach-svg.vue

var beach_svg_script = {}


/* normalize component */

var beach_svg_component = normalizeComponent(
  beach_svg_script,
  beach_svgvue_type_template_id_f2518cc0_render,
  beach_svgvue_type_template_id_f2518cc0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var beach_svg = (beach_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/biking-svg.vue?vue&type=template&id=6ab89c76
var biking_svgvue_type_template_id_6ab89c76_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"16","viewBox":"0 0 20 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12.344 2.962A1.482 1.482 0 1012.343 0a1.482 1.482 0 000 2.963zm-2.47 10.616a.74.74 0 00.74-.74V8.886a.827.827 0 00-.33-.617L8.739 7.24l2.2-1.886 1.437 1.149c.112.09.319.163.462.163h1.975a.74.74 0 000-1.482h-1.715l-2.265-1.812a.862.862 0 00-.463-.163.858.858 0 00-.482.179l-3.21 2.75c-.19.163-.345.499-.345.75 0 .292.197.66.44.822l2.361 1.573v3.554c0 .41.332.741.741.741zM3.95 15.8c2.18 0 3.95-1.77 3.95-3.95S6.13 7.9 3.95 7.9 0 9.67 0 11.85s1.77 3.95 3.95 3.95zm11.85 0c2.18 0 3.95-1.77 3.95-3.95S17.98 7.9 15.8 7.9s-3.95 1.77-3.95 3.95 1.77 3.95 3.95 3.95zM3.95 14.319a2.47 2.47 0 010-4.938 2.47 2.47 0 012.469 2.469 2.474 2.474 0 01-2.469 2.469zm11.85 0a2.47 2.47 0 010-4.938 2.47 2.47 0 012.469 2.469 2.474 2.474 0 01-2.469 2.469z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var biking_svgvue_type_template_id_6ab89c76_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/biking-svg.vue?vue&type=template&id=6ab89c76

// CONCATENATED MODULE: ./src/components/svg/attributes/biking-svg.vue

var biking_svg_script = {}


/* normalize component */

var biking_svg_component = normalizeComponent(
  biking_svg_script,
  biking_svgvue_type_template_id_6ab89c76_render,
  biking_svgvue_type_template_id_6ab89c76_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var biking_svg = (biking_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/calendar-image-svg.vue?vue&type=template&id=caaf87f8
var calendar_image_svgvue_type_template_id_caaf87f8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512"}},[_c('path',{attrs:{"d":"M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192L32 192l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32zM230 265.4c12.5-18.1 39.2-18.4 52.2-.6l96.3 132.4c15.4 21.2 .3 50.8-25.9 50.8L95.1 448c-26 0-41.2-29.4-26-50.6l51-71.3c11.5-16.1 34.7-18 48.7-4l13.1 13.1L230 265.4zM352.6 416L256.3 283.6l-59.2 85.5c-2.7 3.9-7 6.4-11.7 6.8s-9.4-1.3-12.8-4.6L146 344.7 95.1 416l257.5 0zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}})])
}
var calendar_image_svgvue_type_template_id_caaf87f8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/calendar-image-svg.vue?vue&type=template&id=caaf87f8

// CONCATENATED MODULE: ./src/components/svg/attributes/calendar-image-svg.vue

var calendar_image_svg_script = {}


/* normalize component */

var calendar_image_svg_component = normalizeComponent(
  calendar_image_svg_script,
  calendar_image_svgvue_type_template_id_caaf87f8_render,
  calendar_image_svgvue_type_template_id_caaf87f8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var calendar_image_svg = (calendar_image_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/check-svg.vue?vue&type=template&id=d14a4bf8
var check_svgvue_type_template_id_d14a4bf8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"14","viewBox":"0 0 17 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.728 13.278L16.853 2.152a.445.445 0 000-.63l-1.05-1.05a.445.445 0 00-.629 0l-9.761 9.762-3.587-3.587a.445.445 0 00-.63 0l-1.05 1.05a.445.445 0 000 .63l4.952 4.95a.445.445 0 00.63 0z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var check_svgvue_type_template_id_d14a4bf8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/check-svg.vue?vue&type=template&id=d14a4bf8

// CONCATENATED MODULE: ./src/components/svg/attributes/check-svg.vue

var check_svg_script = {}


/* normalize component */

var check_svg_component = normalizeComponent(
  check_svg_script,
  check_svgvue_type_template_id_d14a4bf8_render,
  check_svgvue_type_template_id_d14a4bf8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var check_svg = (check_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/child-svg.vue?vue&type=template&id=f99ef1f0
var child_svgvue_type_template_id_f99ef1f0_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"19","viewBox":"0 0 16 19","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.187 18.25c.648 0 1.24-.245 1.688-.646.448.401 1.04.646 1.687.646h.282a2.534 2.534 0 002.531-2.531V9.455l2.072-2.071a2.534 2.534 0 000-3.58 2.534 2.534 0 00-2.85-.51 3.797 3.797 0 00-7.445 0 2.534 2.534 0 00-2.85.51 2.534 2.534 0 000 3.58l2.073 2.07v6.265a2.534 2.534 0 002.531 2.531h.281zM7.875 6.156a2.11 2.11 0 110-4.218 2.11 2.11 0 010 4.218zM6.187 16.562h-.28a.844.844 0 01-.845-.843V8.756L2.497 6.19A.844.844 0 013.69 4.997l2.566 2.566h3.238l2.566-2.566a.844.844 0 011.193 1.193l-2.566 2.566v6.963a.844.844 0 01-.843.843h-.282a.844.844 0 01-.843-.843v-3.375H7.03v3.375a.844.844 0 01-.844.843z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var child_svgvue_type_template_id_f99ef1f0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/child-svg.vue?vue&type=template&id=f99ef1f0

// CONCATENATED MODULE: ./src/components/svg/attributes/child-svg.vue

var child_svg_script = {}


/* normalize component */

var child_svg_component = normalizeComponent(
  child_svg_script,
  child_svgvue_type_template_id_f99ef1f0_render,
  child_svgvue_type_template_id_f99ef1f0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var child_svg = (child_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/clock-svg.vue?vue&type=template&id=0f9a378a
var clock_svgvue_type_template_id_0f9a378a_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.719 17.437a8.717 8.717 0 008.718-8.718A8.717 8.717 0 008.72 0 8.717 8.717 0 000 8.719a8.717 8.717 0 008.719 8.718zm0-1.687a7.03 7.03 0 01-7.032-7.031A7.03 7.03 0 018.72 1.687 7.03 7.03 0 0115.75 8.72a7.03 7.03 0 01-7.031 7.031zm2.763-3.762l.661-.91a.422.422 0 00-.091-.59l-2.349-1.71V3.798a.423.423 0 00-.422-.422H8.156a.423.423 0 00-.422.422V9.57c0 .133.064.26.173.34l2.984 2.17c.19.137.454.095.591-.092z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var clock_svgvue_type_template_id_0f9a378a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/clock-svg.vue?vue&type=template&id=0f9a378a

// CONCATENATED MODULE: ./src/components/svg/attributes/clock-svg.vue

var clock_svg_script = {}


/* normalize component */

var clock_svg_component = normalizeComponent(
  clock_svg_script,
  clock_svgvue_type_template_id_0f9a378a_render,
  clock_svgvue_type_template_id_0f9a378a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var clock_svg = (clock_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/couple-svg.vue?vue&type=template&id=3abd1e5d
var couple_svgvue_type_template_id_3abd1e5d_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"18","viewBox":"0 0 20 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.625 11.375a3.28 3.28 0 003.281-3.281 3.28 3.28 0 00-3.281-3.281 3.28 3.28 0 00-3.281 3.28 3.28 3.28 0 003.281 3.282zm0-1.406A1.877 1.877 0 013.75 8.094c0-1.034.84-1.875 1.875-1.875 1.034 0 1.875.84 1.875 1.875 0 1.034-.84 1.875-1.875 1.875zm4.219 7.968c.776 0 1.406-.63 1.406-1.406V15.22c0-.697-.211-1.345-.574-1.884-.607-.9-1.64-1.374-2.704-1.374-.349 0-.7.05-1.04.155a4.497 4.497 0 01-1.31.197c-.457 0-.893-.07-1.31-.197a3.608 3.608 0 00-1.04-.155c-1.063 0-2.097.475-2.704 1.374A3.399 3.399 0 000 15.219v1.312c0 .777.63 1.406 1.406 1.406h8.438zM16.834 12c1.026 0 2.025.476 2.612 1.38.311.48.507 1.046.547 1.66l.007.232v1.316c0 .734-.539 1.337-1.228 1.406l-.13.006h-6.304c.023-.122.04-.246.048-.373l.006-.192v-.904h6.455V15.22c0-.847-.54-1.573-1.292-1.849a1.366 1.366 0 00-.935 0 5.949 5.949 0 01-1.995.349 5.907 5.907 0 01-1.992-.349 1.375 1.375 0 00-.782-.046l-.08.024-.109-.2a4.461 4.461 0 00-.119-.195 4.825 4.825 0 00-.543-.667A3.21 3.21 0 0112.297 12c.945 0 1.182.353 2.269.353 1.087 0 1.325-.353 2.269-.353zm-8.28 1.37a1.972 1.972 0 011.293 1.849v1.312h-8.44V15.22c0-.847.538-1.57 1.291-1.849.302-.111.633-.108.935 0a5.907 5.907 0 001.992.349c.674 0 1.342-.117 1.995-.349.302-.108.633-.111.935 0zm6.071-8.557a3.28 3.28 0 013.281 3.28 3.28 3.28 0 01-3.281 3.282 3.28 3.28 0 01-3.281-3.281 3.28 3.28 0 013.281-3.281zm0 1.406c-1.034 0-1.875.84-1.875 1.875 0 1.034.84 1.875 1.875 1.875 1.034 0 1.875-.841 1.875-1.875s-.84-1.875-1.875-1.875zm-4.5-5.67a1.968 1.968 0 012.782 2.782v.001L10.07 6.17 7.234 3.332A1.969 1.969 0 0110.016.55l.054.053.055-.054z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var couple_svgvue_type_template_id_3abd1e5d_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/couple-svg.vue?vue&type=template&id=3abd1e5d

// CONCATENATED MODULE: ./src/components/svg/attributes/couple-svg.vue

var couple_svg_script = {}


/* normalize component */

var couple_svg_component = normalizeComponent(
  couple_svg_script,
  couple_svgvue_type_template_id_3abd1e5d_render,
  couple_svgvue_type_template_id_3abd1e5d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var couple_svg = (couple_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/deck-chair-sun-svg.vue?vue&type=template&id=06aeb822
var deck_chair_sun_svgvue_type_template_id_06aeb822_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"22px","height":"23px","viewBox":"0 0 22 23","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("deck-chair-sun")]),_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Icon/deck-chairs/regular","transform":"translate(-1.000000, -1.000000)","fill":"currentColor","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"deck-chairs-sun","transform":"translate(1.093473, 1.209651)"}},[_c('path',{attrs:{"d":"M8.36628981,4.45329604 C8.97364088,3.47839285 9.84592267,2.69721372 10.8867968,2.19353119 C11.4931007,1.90032722 12.1465266,1.70765033 12.8125185,1.62387777 C12.1863186,2.09195696 11.6093351,2.69197793 11.0888981,3.41661059 C10.5831212,4.11820579 10.2249935,4.80199933 9.99357181,5.30987048 L8.32230921,4.69728363 C8.30031891,4.68890637 8.2835644,4.67319901 8.2835644,4.58628498 L8.36628981,4.45329604 Z M16.0471865,7.52670189 L11.4763462,5.85334498 C11.6774003,5.42715207 11.9747929,4.873206 12.375854,4.31821278 C13.3182954,3.01659661 14.4104801,2.25531345 15.6262294,2.05321215 C15.830425,2.32442582 16.1738925,2.86894747 16.3644751,3.679447 C16.630453,4.82294247 16.523643,6.11618139 16.0471865,7.52670189 L16.0471865,7.52670189 Z M18.0723882,5.32976647 C18.1027558,4.65853882 18.0503979,4.01349009 17.9153147,3.40299755 C19.2462512,4.76011305 19.8871113,6.66908029 19.6096147,8.5717646 L19.5876244,8.72464952 C19.5834358,8.74873414 19.5708699,8.76863012 19.5509739,8.781196 L19.485003,8.78747895 L17.5236779,8.06808207 C17.8472495,7.12040497 18.0305019,6.20100111 18.0723882,5.32976647 L18.0723882,5.32976647 Z M19.1881793,17.6806988 C19.0641508,18.1770107 18.3820216,17.9736238 18.3170979,17.9547749 C16.4102249,17.3966402 14.5054806,17.1327654 12.6226922,17.0552758 L12.8444173,15.859338 C14.8739374,15.6391799 17.1223173,16.2707185 17.9357573,16.603427 C18.7491972,16.9361355 19.3095253,17.1330064 19.1881793,17.6806988 Z M5.14942344,15.9338075 C5.55048458,16.7233639 6.4317456,16.4770991 6.7416555,16.3590263 C7.05156541,16.2409534 9.47521487,15.4714267 11.2153353,15.9338075 L11.0896816,17.0033702 C10.8048549,17.0127946 10.5143527,16.9834742 10.2389504,17.0033702 C8.05353369,17.1614909 6.79214402,17.461742 5.79420338,17.8198697 C5.37711856,17.9963506 5.08190648,17.7962183 5.02745432,17.6956913 L1.57853394,12.4960729 C1.54816639,12.4405736 1.23755399,12.217763 1.23755399,11.825186 C1.23755399,11.3443086 1.67756375,11.3084382 1.88536416,11.3918123 C2.09316457,11.4751863 2.60344779,12.2398391 2.6421926,12.3162815 L5.14942344,15.9338075 Z M16.2021658,0.467816422 C14.5507992,-0.137440336 12.7235102,-0.156289162 11.0574833,0.416505728 C9.39250368,0.989300617 7.96313435,2.12651314 7.03221176,3.62080621 L6.94948636,3.75379515 C6.68560279,4.17684659 6.62696199,4.68995353 6.78927133,5.16222134 C6.95053351,5.633442 7.31284984,6.00204127 7.78092903,6.17482218 L10.0396467,6.9978876 C10.0836273,7.02301937 10.1307494,7.04500966 10.1810129,7.06281133 C10.2166163,7.07433006 10.2511724,7.08166016 10.248031,7.07851869 L12.7863396,8.00839412 L11.5339398,14.4463155 C9.19563816,14.5625499 7.30551974,15.0924114 6.37145568,15.4044642 C6.26673998,15.443209 6.14736408,15.3908511 6.09710054,15.2924184 L3.40684944,10.9278679 C2.9597134,10.0472088 1.87800019,9.69117545 0.996293982,10.1320286 C0.557535191,10.3519315 0.232916515,10.7310024 0.0852673751,11.1990816 C-0.0634289218,11.6671608 -0.0163068559,12.1635132 0.216162003,12.5949419 L3.7640347,18.3417396 C4.17766173,19.1114 5.11905589,19.4799993 5.9567815,19.184701 C6.19134467,19.0998813 6.53271786,18.9857412 6.96414656,18.8684596 L5.65101165,21.0078014 C5.54106017,21.1868652 5.50650398,21.3973438 5.55572036,21.6025866 C5.60493674,21.8067822 5.72954843,21.9795631 5.91070659,22.0905617 C6.27407008,22.3104647 6.77042251,22.1879473 6.99137264,21.8308668 L9.07521511,18.4359837 C9.63649127,18.357447 10.2113805,18.3019476 10.7894111,18.2736744 L10.2857286,20.8674823 C10.2459367,21.0716779 10.2878229,21.2811094 10.4051045,21.4570317 C10.5234333,21.631907 10.70145,21.7502357 10.9098342,21.7900277 C11.3192726,21.8706588 11.7496541,21.5847849 11.8292381,21.1669692 L12.39575,18.2558727 C13.0376573,18.2757687 13.6910833,18.3249851 14.3434621,18.4056162 L16.4482477,21.8308668 C16.5917082,22.0664771 16.8430259,22.205749 17.117381,22.205749 C17.2618887,22.205749 17.4032549,22.165957 17.531008,22.0895146 C17.7090247,21.9795631 17.8336364,21.8067822 17.8828528,21.6015394 C17.9320692,21.3973438 17.8985602,21.1868652 17.7875615,21.0078014 L16.4074086,18.7585081 C16.9288928,18.8736954 17.4514241,19.0077315 17.9666254,19.1595692 C18.4765908,19.3103598 19.0221596,19.2276344 19.4672014,18.9354776 C19.9080545,18.644368 20.1991641,18.1762888 20.2630407,17.6464273 C20.3604263,16.8568709 19.9164317,16.0861634 19.184469,15.7730634 C17.2995863,14.963611 15.2670546,14.5154278 13.1392315,14.4368911 L14.2816798,8.55605724 L18.94467,10.2639703 C19.4064663,10.4336098 19.9321391,10.3854406 20.3551905,10.1320286 C20.7834777,9.8775694 21.0714459,9.44718787 21.1426526,8.95397691 L21.1656901,8.79899767 C21.4211964,7.05862271 21.065163,5.26588989 20.1635608,3.75274799 C19.2619586,2.24065326 17.8556267,1.07412034 16.2021658,0.467816422 Z","id":"deck-chair"}})])])])])
}
var deck_chair_sun_svgvue_type_template_id_06aeb822_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/deck-chair-sun-svg.vue?vue&type=template&id=06aeb822

// CONCATENATED MODULE: ./src/components/svg/attributes/deck-chair-sun-svg.vue

var deck_chair_sun_svg_script = {}


/* normalize component */

var deck_chair_sun_svg_component = normalizeComponent(
  deck_chair_sun_svg_script,
  deck_chair_sun_svgvue_type_template_id_06aeb822_render,
  deck_chair_sun_svgvue_type_template_id_06aeb822_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var deck_chair_sun_svg = (deck_chair_sun_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/diving-svg.vue?vue&type=template&id=5758171b
var diving_svgvue_type_template_id_5758171b_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"20","viewBox":"0 0 18 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.865.75c.402 0 .73.313.777.712l.006.101V5.73l.168-.118a4.649 4.649 0 012.065-.763l.282-.023.256-.007h7.162c2.574 0 4.669 2.088 4.669 4.657 0 1.42-.477 2.607-1.383 3.423-.749.675-1.756 1.063-2.92 1.139l-.325.014c-.24 0-.466.052-.828.198l-.299.127-.794.362c-.73.322-1.156.438-1.7.438-.578 0-1.045-.14-1.844-.5l-.652-.3-.299-.127c-.316-.127-.53-.184-.739-.196l-.447-.019a5.22 5.22 0 01-1.949-.503l-.24-.129-.183-.112.004.242c.028.917.207 1.603.538 2.086l.104.14.103.116c.596.623 1.427.815 3.1.83l.286-.001.019-.13c.098-.508.477-.908.96-1.012l.123-.02.127-.006h1.976c.642 0 1.166.511 1.229 1.16l.006.131v1.132c0 .665-.484 1.219-1.108 1.285l-.127.007H8.012c-.505 0-.942-.319-1.133-.777l-.042-.117-.007-.026-.223.001c-2.09 0-3.353-.299-4.32-1.31-.763-.797-1.154-1.929-1.2-3.44l-.005-.306.019-1.866A5.16 5.16 0 01.75 9.475c0-.527.089-1.043.247-1.47l.085-.207V1.563c0-.446.348-.813.783-.813zm7.792 16.411H8.342v.462h1.315v-.462zm-.668-5.887l-.125.142-.226.285-.258.34-.25.321-.227.272a5.54 5.54 0 01-.32.34l-.085.079.375.171.298.127c.317.128.53.184.74.196l.09.003c.263 0 .511-.064.94-.245l.36-.159.133-.062-.084-.082a6.71 6.71 0 01-.624-.74l-.552-.759-.185-.229zm3.592-4.83H5.419c-.832 0-1.615.321-2.205.905a2.973 2.973 0 00-.898 2.126c0 .958.285 1.691.843 2.194.537.484 1.326.747 2.238.76.5-.1.86-.34 1.327-.871l.266-.32c.047-.058.095-.12.144-.183l.313-.412c.571-.745.973-1.07 1.553-1.07.542 0 .919.285 1.417.94l.41.564c.685.938 1.093 1.288 1.701 1.347.974-.004 1.772-.267 2.313-.755.558-.503.843-1.235.843-2.194 0-.798-.318-1.552-.898-2.126a3.115 3.115 0 00-2.205-.905z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var diving_svgvue_type_template_id_5758171b_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/diving-svg.vue?vue&type=template&id=5758171b

// CONCATENATED MODULE: ./src/components/svg/attributes/diving-svg.vue

var diving_svg_script = {}


/* normalize component */

var diving_svg_component = normalizeComponent(
  diving_svg_script,
  diving_svgvue_type_template_id_5758171b_render,
  diving_svgvue_type_template_id_5758171b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var diving_svg = (diving_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/doctor-svg.vue?vue&type=template&id=eab59606
var doctor_svgvue_type_template_id_eab59606_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"21","viewBox":"0 0 18 21","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.75 11.75a5.626 5.626 0 005.625-5.625A5.626 5.626 0 008.75.5a5.626 5.626 0 00-5.625 5.625A5.626 5.626 0 008.75 11.75zm0-1.875A3.756 3.756 0 015 6.125a3.756 3.756 0 013.75-3.75 3.756 3.756 0 013.75 3.75 3.756 3.756 0 01-3.75 3.75zM16.555 20.5c.52 0 .937-.418.937-.938v-1.937a5.24 5.24 0 00-5.242-5.25c-.43 0-.852.102-1.258.242a6.774 6.774 0 01-4.484 0c-.406-.14-.828-.242-1.258-.242A5.251 5.251 0 000 17.625v1.937c0 .52.418.938.937.938.52 0 .938-.418.938-.938v-1.937c0-1.777 1.383-3.219 3.125-3.352v1.954a2.18 2.18 0 00-1.563 2.085 2.189 2.189 0 004.375 0 2.18 2.18 0 00-1.562-2.085V14.48a8.637 8.637 0 002.5.395c.852 0 1.687-.148 2.5-.395v1.418c-1.102.293-1.875 1.348-1.875 2.524v1.14c0 .165.066.325.184.442l.402.402c.121.121.32.121.441 0l.442-.441a.314.314 0 000-.442l-.223-.222v-.989c0-.757.68-1.359 1.461-1.234.613.102 1.04.68 1.04 1.3v.923l-.224.222a.314.314 0 000 .442l.442.441c.12.121.32.121.441 0l.403-.402a.627.627 0 00.183-.442v-1.25c0-1.16-.8-2.128-1.875-2.406v-1.629a3.368 3.368 0 013.125 3.352v1.933c0 .52.418.938.938.938zm-10.93-1.25a.935.935 0 01-.938-.938c0-.519.418-.937.938-.937s.937.418.937.937c0 .52-.417.938-.937.938z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var doctor_svgvue_type_template_id_eab59606_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/doctor-svg.vue?vue&type=template&id=eab59606

// CONCATENATED MODULE: ./src/components/svg/attributes/doctor-svg.vue

var doctor_svg_script = {}


/* normalize component */

var doctor_svg_component = normalizeComponent(
  doctor_svg_script,
  doctor_svgvue_type_template_id_eab59606_render,
  doctor_svgvue_type_template_id_eab59606_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var doctor_svg = (doctor_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/entertainment-svg.vue?vue&type=template&id=7b0708ae
var entertainment_svgvue_type_template_id_7b0708ae_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"19","viewBox":"0 0 18 19","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.281 18.25c.31 0 .563-.252.563-.563v-5.314l2.904-2.564c.967-.005 2.307-.565 2.991-1.25l1.008-1.007C17.44 6.86 18 5.505 18 4.527c0-.978-.561-2.333-1.253-3.024C16.056.81 14.701.25 13.723.25c-.978 0-2.333.561-3.025 1.253L9.69 2.51c-.684.684-1.244 2.024-1.25 2.991L.422 14.553c-.234.265-.423.765-.423 1.118 0 .385.22.92.493 1.192l.892.893c.273.272.807.493 1.193.493.352 0 .853-.19 1.118-.423l4.461-3.963v3.824c0 .311.252.563.563.563h.562zm6.356-11.994l-3.644-3.643c.407-.373 1.185-.676 1.737-.676.59 0 1.407.34 1.824.759.978.978 1 2.546.083 3.56zm-2.922 1.869a3.095 3.095 0 01-.26-.025L10.15 5.797a3.099 3.099 0 01-.014-.267c0-.546.297-1.318.663-1.724l3.644 3.644c-.405.372-1.18.674-1.73.675zM2.58 16.562l-.893-.892 7.494-8.457 1.856 1.856-8.457 7.493z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var entertainment_svgvue_type_template_id_7b0708ae_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/entertainment-svg.vue?vue&type=template&id=7b0708ae

// CONCATENATED MODULE: ./src/components/svg/attributes/entertainment-svg.vue

var entertainment_svg_script = {}


/* normalize component */

var entertainment_svg_component = normalizeComponent(
  entertainment_svg_script,
  entertainment_svgvue_type_template_id_7b0708ae_render,
  entertainment_svgvue_type_template_id_7b0708ae_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var entertainment_svg = (entertainment_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/family-svg.vue?vue&type=template&id=420d1037
var family_svgvue_type_template_id_420d1037_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"22","viewBox":"0 0 24 22","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.32 5.453c.309 0 .605.109.834.305.31.233.538.608.61 1.019l.896 5.049 1.087.488h2.26l.987-.479 2.076-4.676c.13-.295.354-.547.632-.711.197-.136.457-.216.715-.216h4.617c.088.003.138.008.19.015.613.106 1.08.525 1.238 1.076l1.333 4.671a1.502 1.502 0 01-1.03 1.854 1.002 1.002 0 01-.128.03l.56 2.015a.821.821 0 01-.787 1.037h-1.217v3.168c0 .932-.703 1.691-1.567 1.691a1.48 1.48 0 01-.892-.301c-.261.195-.57.301-.892.301-.864 0-1.567-.759-1.567-1.691V16.93h-1.217a.822.822 0 01-.651-.323.824.824 0 01-.137-.714l.55-1.982-1.696.824v5.496c0 .858-.632 1.558-1.41 1.558-.29 0-.565-.097-.8-.276a1.31 1.31 0 01-.8.276c-.776 0-1.408-.7-1.408-1.558v-5.462l-2.014-.904a1.212 1.212 0 01-.28-.179v6.412c0 .932-.707 1.691-1.576 1.691-.317 0-.624-.102-.883-.291-.26.189-.566.291-.884.291-.87 0-1.576-.759-1.576-1.691v-6.032h-.02C.66 14.066 0 13.355 0 12.482V7.038c0-.593.304-1.131.793-1.405.193-.116.423-.18.658-.18zm0 1.069H1.45a.225.225 0 00-.118.033.541.541 0 00-.264.483v5.444c0 .279.186.516.405.516.219 0 .405-.237.405-.516V7.583h.684v12.515c0 .337.232.622.507.622.276 0 .508-.285.508-.622v-6.45h.75v6.45c0 .337.234.622.509.622s.508-.285.508-.622V7.583H6l.865 4.882a.606.606 0 00.17.328c.056.071.074.088.093.096l2.645 1.188v6.154c0 .266.156.489.34.489.186 0 .342-.223.342-.489v-3.338h.918v3.338c0 .266.156.489.34.489.185 0 .342-.223.342-.489v-6.165l2.516-1.221a.629.629 0 00.182-.226l1.928-4.343h.66l-.008.583-1.947 7.004h1.955v4.235c0 .337.229.622.5.622.27 0 .499-.285.499-.622v-4.235h.786v4.235c0 .337.228.622.499.622.27 0 .5-.285.5-.622v-4.235h1.955l-1.955-7.07v-.517h.605l1.21 4.246a.432.432 0 00.532.3.43.43 0 00.294-.534l-1.332-4.672a.434.434 0 00-.348-.309l-4.67-.006a.22.22 0 00-.132.041.543.543 0 00-.24.25l-2.076 4.679a.515.515 0 00-.041.162l-.011.142-1.722.807-2.726-.021-1.79-.804-.007-.153c-.002-.026-.003-.052-.008-.078l-.951-5.363a.569.569 0 00-.223-.368c-.061-.054-.113-.073-.17-.073zm4.595 1.39c1.03 0 1.87.839 1.87 1.87 0 1.03-.84 1.87-1.87 1.87a1.872 1.872 0 01-1.87-1.87c0-1.031.839-1.87 1.87-1.87zm0 1.068a.803.803 0 000 1.604.803.803 0 000-1.604zm7.82-8.258A2.37 2.37 0 0121.1 3.09a2.37 2.37 0 01-2.367 2.367 2.37 2.37 0 01-2.367-2.367A2.37 2.37 0 0118.734.722zM3.952 0A2.37 2.37 0 016.32 2.367a2.37 2.37 0 01-2.367 2.367 2.37 2.37 0 01-2.367-2.367A2.37 2.37 0 013.953 0zm14.781 1.79a1.3 1.3 0 00-1.299 1.3 1.3 1.3 0 001.3 1.298 1.3 1.3 0 001.298-1.299 1.3 1.3 0 00-1.299-1.299zM3.953 1.068a1.3 1.3 0 00-1.3 1.3 1.3 1.3 0 001.3 1.298 1.3 1.3 0 001.299-1.299 1.3 1.3 0 00-1.3-1.299z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var family_svgvue_type_template_id_420d1037_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/family-svg.vue?vue&type=template&id=420d1037

// CONCATENATED MODULE: ./src/components/svg/attributes/family-svg.vue

var family_svg_script = {}


/* normalize component */

var family_svg_component = normalizeComponent(
  family_svg_script,
  family_svgvue_type_template_id_420d1037_render,
  family_svgvue_type_template_id_420d1037_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var family_svg = (family_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/fitness-svg.vue?vue&type=template&id=19440048
var fitness_svgvue_type_template_id_19440048_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"14","viewBox":"0 0 20 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.75 14c.966 0 1.75-.784 1.75-1.75V8h3v4.25c0 .966.784 1.75 1.75 1.75h1c.966 0 1.75-.784 1.75-1.75v-.275c.081.012.166.025.25.025h1c.966 0 1.75-.784 1.75-1.75V8h.75a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25H19V3.75C19 2.784 18.216 2 17.25 2h-1c-.084 0-.169.013-.25.025V1.75C16 .784 15.216 0 14.25 0h-1c-.966 0-1.75.784-1.75 1.75V6h-3V1.75C8.5.784 7.716 0 6.75 0h-1C4.784 0 4 .784 4 1.75v.275A1.655 1.655 0 003.75 2h-1C1.784 2 1 2.784 1 3.75V6H.25a.25.25 0 00-.25.25v1.5c0 .137.112.25.25.25H1v2.25c0 .966.784 1.75 1.75 1.75h1c.084 0 .169-.013.25-.025v.275c0 .966.784 1.75 1.75 1.75h1zm0-1.5h-1a.25.25 0 01-.25-.25V1.75a.25.25 0 01.25-.25h1a.25.25 0 01.25.25v10.5a.25.25 0 01-.25.25zm7.5 0h-1a.25.25 0 01-.25-.25V1.75a.25.25 0 01.25-.25h1a.25.25 0 01.25.25v10.5a.25.25 0 01-.25.25zm-10.5-2h-1a.25.25 0 01-.25-.25v-6.5a.25.25 0 01.25-.25h1a.25.25 0 01.25.25v6.5a.25.25 0 01-.25.25zm13.5 0h-1a.25.25 0 01-.25-.25v-6.5a.25.25 0 01.25-.25h1a.25.25 0 01.25.25v6.5a.25.25 0 01-.25.25z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var fitness_svgvue_type_template_id_19440048_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/fitness-svg.vue?vue&type=template&id=19440048

// CONCATENATED MODULE: ./src/components/svg/attributes/fitness-svg.vue

var fitness_svg_script = {}


/* normalize component */

var fitness_svg_component = normalizeComponent(
  fitness_svg_script,
  fitness_svgvue_type_template_id_19440048_render,
  fitness_svgvue_type_template_id_19440048_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var fitness_svg = (fitness_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/garage-car-svg.vue?vue&type=template&id=6bc310b7
var garage_car_svgvue_type_template_id_6bc310b7_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"19","height":"15","viewBox":"0 0 19 15","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.375 0c.221 0 .567.07.77.155l7.372 3.07c.68.281 1.233 1.107 1.233 1.844v9.462c0 .259-.21.469-.469.469h-.469a.469.469 0 01-.468-.469V5.074a.646.646 0 00-.367-.55l-7.37-3.072a.716.716 0 00-.23-.045c-.067 0-.17.02-.23.045L1.771 4.523a.64.64 0 00-.366.547v9.461c0 .259-.21.469-.469.469H.47A.469.469 0 010 14.53V5.07c0-.737.552-1.563 1.233-1.844L8.604.155C8.808.069 9.154 0 9.375 0zm1.096 6.477c1.034 0 2.077.781 2.327 1.744l.403 1.545c.646.19 1.172.87 1.174 1.518v.798c-.001.31-.25.643-.556.745v1.118a.544.544 0 01-.555.532h-1.111a.544.544 0 01-.556-.532v-1.064H7.153v1.064a.544.544 0 01-.556.532h-1.11a.544.544 0 01-.556-.532v-1.118c-.306-.102-.555-.435-.556-.745v-.798c.002-.63.51-1.304 1.134-1.504l.406-1.557c.249-.964 1.292-1.746 2.328-1.746zm-4.296 4.024c-.48 0-.8.39-.8.974s.32.973.8.973c.48 0 1.2.097 1.2-.487s-.72-1.46-1.2-1.46zm6.4 0c-.48 0-1.2.876-1.2 1.46s.72.487 1.2.487.8-.384.8-.97-.32-.977-.8-.977zm-2.144-3.024H8.32l-.101.011c-.266.056-.512.327-.577.652l-.267 1.337h4l-.268-1.337c-.072-.366-.375-.663-.676-.663z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var garage_car_svgvue_type_template_id_6bc310b7_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/garage-car-svg.vue?vue&type=template&id=6bc310b7

// CONCATENATED MODULE: ./src/components/svg/attributes/garage-car-svg.vue

var garage_car_svg_script = {}


/* normalize component */

var garage_car_svg_component = normalizeComponent(
  garage_car_svg_script,
  garage_car_svgvue_type_template_id_6bc310b7_render,
  garage_car_svgvue_type_template_id_6bc310b7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var garage_car_svg = (garage_car_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/golf-club-svg.vue?vue&type=template&id=6eda8f14
var golf_club_svgvue_type_template_id_6eda8f14_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"15","viewBox":"0 0 18 15","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.314 14.4c.692 0 1.322-.396 1.623-1.02L17.956.84a.45.45 0 00-.208-.599l-.406-.194a.45.45 0 00-.601.208l-3.648 7.6L2.132 5.8A1.8 1.8 0 000 7.569v5.032a1.8 1.8 0 001.8 1.8h8.514zm0-1.35H1.8c-.466 0-.462-.485-.453-.633l.003-.041h2.025a.226.226 0 00.225-.225v-.9a.226.226 0 00-.225-.225H1.35v-1.35h2.025A.226.226 0 003.6 9.45v-.9a.226.226 0 00-.225-.225H1.35v-.757c0-.27.242-.498.532-.442L11.909 9.01c.292.053.45.368.323.636l-1.513 3.15a.455.455 0 01-.405.256z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var golf_club_svgvue_type_template_id_6eda8f14_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/golf-club-svg.vue?vue&type=template&id=6eda8f14

// CONCATENATED MODULE: ./src/components/svg/attributes/golf-club-svg.vue

var golf_club_svg_script = {}


/* normalize component */

var golf_club_svg_component = normalizeComponent(
  golf_club_svg_script,
  golf_club_svgvue_type_template_id_6eda8f14_render,
  golf_club_svgvue_type_template_id_6eda8f14_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var golf_club_svg = (golf_club_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/hand-wash-svg.vue?vue&type=template&id=75729272
var hand_wash_svgvue_type_template_id_75729272_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.422.85l.115.004.109.01c.837.095 1.521.7 1.725 1.507l.01.049.056.01c.687.154 1.241.654 1.468 1.312l.046.155.012.055.07.013c.4.092.762.305 1.037.607l.112.135.101.145c.285.451.378.995.263 1.511l-.045.171-.539 1.706.054.093c.11.213.183.444.212.682l.014.18v.022h2.881c.87 0 1.634.54 1.92 1.321l.048.15.036.154c.035.18.045.365.03.548l-.01.075.048.027c.496.306.832.81.927 1.378l.022.172.006.16c0 .7-.364 1.346-.954 1.71l-.047.026.008.056c.06.7-.25 1.379-.809 1.793l-.133.09-.051.028.01.07c.032.41-.061.82-.266 1.173l-.095.148-.108.14c-.345.408-.835.66-1.361.706l-.177.008H8.769a4.796 4.796 0 01-2.714-.853l-.108-.077-.04.045a2.946 2.946 0 01-1.681.856l-.215.022-.198.007a2.958 2.958 0 01-1.857-5.264l.026-.021-.073-.09a5.12 5.12 0 01-1.02-2.462l-.026-.269-.012-.27V7.288c.014-1.101.93-1.992 2.05-1.992.119 0 .237.012.354.034l.192.046.87-2.747a2.062 2.062 0 011.605-1.407l.16-.02.161-.007a2.035 2.035 0 01.762.15l.07.031.052-.047c.269-.229.593-.382.938-.446L8.24.859 8.422.85zm2.808 7.823l-.089.007-.085.019-3.31 1.022a3.66 3.66 0 00-2.512 3.281l-.006.197v.403l.09.05a2.948 2.948 0 011.45 2.34l.007.197a2.928 2.928 0 01-.091.69l-.036.116.113.086a3.49 3.49 0 001.769.635l.24.009h6.397a.588.588 0 00.577-.706.599.599 0 00-.508-.463l-.097-.008h-2.925a.396.396 0 01-.08-.784l.08-.008h3.937a.588.588 0 00.577-.706.599.599 0 00-.508-.463l-.097-.007h-3.909a.396.396 0 01-.08-.784l.08-.009h4.921a.588.588 0 00.577-.706.599.599 0 00-.508-.463l-.097-.007h-4.893a.396.396 0 01-.08-.784l.08-.008h3.937a.588.588 0 00.577-.706.599.599 0 00-.508-.464l-.097-.007H9.145l2.26-.818a.588.588 0 00-.175-1.15zM3.813 14.65a1.537 1.537 0 100 3.075 1.537 1.537 0 000-3.075zM8.419 2.275a.603.603 0 00-.53.345l-.038.094L6.377 7.38a.396.396 0 01-.772-.16l.017-.079 1.187-3.755a.588.588 0 00-.5-.763l-.062-.003a.603.603 0 00-.531.345l-.038.093-2.103 6.655-.1-2.4a.588.588 0 00-.583-.592.617.617 0 00-.607.49l-.01.094v3.465c.015.89.354 1.74.95 2.393l.103.105.105-.017.19-.019.18-.007v-.027c0-2.12 1.312-4 3.304-4.761l.216-.077 2.262-.7.976-3.089a.588.588 0 00-.019-.407l-.049-.092A.589.589 0 0010 3.806a.603.603 0 00-.531.345l-.037.093-1.03 3.275a.396.396 0 01-.771-.16l.016-.079L8.98 3.041a.588.588 0 00-.5-.762l-.062-.004zm8.33 1.95a2.4 2.4 0 11-.165.006l.165-.006zm0 1.425a.975.975 0 100 1.95.975.975 0 000-1.95zm-5.167-.311a.608.608 0 00-.533.345l-.038.093-.506 1.6.137-.041a1.975 1.975 0 011.088-.02l.026.007.385-1.218a.588.588 0 00-.018-.407l-.05-.092a.589.589 0 00-.43-.264l-.061-.003zM15.062.85a1.837 1.837 0 110 3.675 1.837 1.837 0 010-3.675zm0 1.425a.412.412 0 100 .825.412.412 0 000-.825z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var hand_wash_svgvue_type_template_id_75729272_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/hand-wash-svg.vue?vue&type=template&id=75729272

// CONCATENATED MODULE: ./src/components/svg/attributes/hand-wash-svg.vue

var hand_wash_svg_script = {}


/* normalize component */

var hand_wash_svg_component = normalizeComponent(
  hand_wash_svg_script,
  hand_wash_svgvue_type_template_id_75729272_render,
  hand_wash_svgvue_type_template_id_75729272_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hand_wash_svg = (hand_wash_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/hiking-svg.vue?vue&type=template&id=4dc643df
var hiking_svgvue_type_template_id_4dc643df_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"19","viewBox":"0 0 14 19","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.423.75c.716 0 1.365.268 1.869.772s.772 1.153.772 1.869-.268 1.365-.772 1.869l-.117.108-.126.102-.042.029 1.268 1.625.881.001.077.002.077.005.127.017v-.57c0-.222.14-.411.336-.484l.087-.024.093-.009h.531c.253 0 .464.183.508.423l.008.093v11.156a.516.516 0 01-.423.508l-.093.008h-.531a.516.516 0 01-.507-.423l-.009-.093v-6.947l-.126.018-.155.007h-1.779c-.343 0-.672-.093-.955-.265l-.138-.093-.084-.068-.013.05 1.472.965a2.914 2.914 0 011.189 1.968l.02.197.007.2v2.64a1.845 1.845 0 01-1.844 1.844c-.966 0-1.76-.746-1.837-1.693l-.007-.15V14.18l-.865-.586-.814 3.257a1.84 1.84 0 01-1.477 1.372l-.154.02-.158.007a1.846 1.846 0 01-1.82-2.142l.03-.149 1.163-4.649-2.421-.693a1.188 1.188 0 01-.58-.336l-.09-.105-.078-.115a1.195 1.195 0 01-.161-.785l.026-.135.7-2.71c.397-1.513 1.95-2.456 3.523-2.175l.174.037.865.247-.057-.118a2.547 2.547 0 01-.176-.604l-.026-.211-.008-.216c0-.717.268-1.365.772-1.87A2.595 2.595 0 018.423.75zm-.54 5.281c-.46 0-.936.344-1.1.777l-.035.11-.894 3.577-.009.068c0 .052.035.132.073.184l.04.04 3.464 2.342a.781.781 0 01.32.53l.008.107v2.64a.281.281 0 00.555.065l.007-.065v-2.64c0-.385-.166-.75-.444-1l-.11-.088-2.395-1.568.074-.19.035-.065.977-3.905 1.706 2.191c.04.052.096.087.158.102l.064.007h1.78a.281.281 0 00.064-.555l-.065-.008h-1.52l-.197-.096L8.71 6.374a1.16 1.16 0 00-.826-.343zm-2.435 6.297l-1.002 4.01a.281.281 0 00.524.196l.022-.06.952-3.81-.496-.336zM3.093 6.574l-.052.122-.04.129-.614 2.372 2.035.581.81-3.238a2.77 2.77 0 01.134-.388l.073-.162-.653-.187-.136-.026c-.647-.093-1.285.242-1.557.797zm5.33-4.262c-.302 0-.552.103-.764.315-.21.21-.314.461-.314.764 0 .302.104.552.315.764.21.21.46.314.763.314s.553-.103.764-.315c.212-.21.315-.46.315-.763s-.104-.553-.315-.764a1.03 1.03 0 00-.764-.315z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var hiking_svgvue_type_template_id_4dc643df_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/hiking-svg.vue?vue&type=template&id=4dc643df

// CONCATENATED MODULE: ./src/components/svg/attributes/hiking-svg.vue

var hiking_svg_script = {}


/* normalize component */

var hiking_svg_component = normalizeComponent(
  hiking_svg_script,
  hiking_svgvue_type_template_id_4dc643df_render,
  hiking_svgvue_type_template_id_4dc643df_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hiking_svg = (hiking_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/hotel-svg.vue?vue&type=template&id=5555806f
var hotel_svgvue_type_template_id_5555806f_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"19","viewBox":"0 0 21 19"}},[_c('path',{attrs:{"d":"M19.687 18.53a.563.563 0 00.563-.563v-.562a.564.564 0 00-.563-.563h-.562V2.218h.562a.563.563 0 00.563-.563v-.562a.563.563 0 00-.563-.563H.562A.563.563 0 000 1.093v.562c0 .31.252.563.562.563h.562v14.624H.562a.563.563 0 00-.562.563v.562c0 .311.252.563.562.563h19.125zM9 16.842H2.812V2.218h14.625v14.624H11.25V14.03h2.25a3.375 3.375 0 10-6.75 0H9v2.812zm1.8-10.687c.225 0 .45-.225.45-.45v-1.35a.484.484 0 00-.45-.45H9.45a.484.484 0 00-.45.45v1.35c0 .225.225.45.45.45h1.35zm4.5 0c.225 0 .45-.225.45-.45v-1.35a.484.484 0 00-.45-.45h-1.35a.484.484 0 00-.45.45v1.35c0 .225.225.45.45.45h1.35zm-9 0c.225 0 .45-.225.45-.45v-1.35a.484.484 0 00-.45-.45H4.95a.484.484 0 00-.45.45v1.35c0 .225.225.45.45.45H6.3zm4.5 3.375c.225 0 .45-.225.45-.45V7.73a.484.484 0 00-.45-.45H9.45a.484.484 0 00-.45.45v1.35c0 .225.225.45.45.45h1.35zm4.5 0c.225 0 .45-.225.45-.45V7.73a.484.484 0 00-.45-.45h-1.35a.484.484 0 00-.45.45v1.35c0 .225.225.45.45.45h1.35zm-9 0c.225 0 .45-.225.45-.45V7.73a.484.484 0 00-.45-.45H4.95a.484.484 0 00-.45.45v1.35c0 .225.225.45.45.45H6.3z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var hotel_svgvue_type_template_id_5555806f_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/hotel-svg.vue?vue&type=template&id=5555806f

// CONCATENATED MODULE: ./src/components/svg/attributes/hotel-svg.vue

var hotel_svg_script = {}


/* normalize component */

var hotel_svg_component = normalizeComponent(
  hotel_svg_script,
  hotel_svgvue_type_template_id_5555806f_render,
  hotel_svgvue_type_template_id_5555806f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hotel_svg = (hotel_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/massage-svg.vue?vue&type=template&id=76e38189
var massage_svgvue_type_template_id_76e38189_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"21","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.381 0a2.315 2.315 0 11-.538 4.566c.51.391.852.973 1.036 1.61l.051.189.062.253.198.878.15.71 2.189 2.12a.631.631 0 01.08.812l-.074.088-.211.211c-.782.78-1.808.893-2.673.314l-.151-.11-.634-.448-.537 1.343v7.033a.631.631 0 01-.528.623l-.103.008a.631.631 0 01-.623-.529l-.008-.102v-7.154c0-.054.007-.107.02-.159l.025-.076.694-1.736-.39-.275a.631.631 0 01-.22-.275l-.028-.085-.614-2.417a.631.631 0 011.19-.408l.034.097.556 2.191 1.918 1.356c.31.242.604.287.893.134l.012-.008-1.833-1.777a.631.631 0 01-.153-.234l-.026-.09-.272-1.266-.136-.588-.07-.272C5.499 5.951 5.13 5.47 4.623 5.35c-.681-.16-.992-.08-1.181.29l-.042.091-2.185 5.311a.631.631 0 01-1.199-.382l.032-.098L2.233 5.25c.455-1.1 1.4-1.429 2.677-1.13l.038.012A2.315 2.315 0 016.382 0zm6.734 7.996a2.525 2.525 0 012.501 2.871l-.064-.01c.56.061 1.078.319 1.456.727l.349.386.352.401c.2.233.407.476.614.723l.716.87c.059.072.1.158.123.249.078.327.072.647-.005.938l.618-.001a.631.631 0 01.102 1.254l-.102.009H6.38a.631.631 0 01-.102-1.255l.102-.008.69.001a1.921 1.921 0 01-.003-.938.631.631 0 01.122-.25l.408-.498.309-.371.777-.91.368-.414.17-.186a2.318 2.318 0 011.275-.7l.116-.017a2.525 2.525 0 012.501-2.871zM15.1 12.08a2.52 2.52 0 01-1.985.965 2.52 2.52 0 01-1.986-.965l-.313.03c-.261.03-.498.147-.668.33l-.333.369-.34.387-.298.348-.9 1.082-.004.073c.006.242.149.41.391.444l.096.006h3.723v-.213l-.01-.055c-.07-.22-.512-.519-.929-.567l-.113-.007h-.841a.631.631 0 01-.103-1.254l.103-.008h.841c.6 0 1.232.247 1.684.643a2.658 2.658 0 011.532-.638l.151-.005h.842a.631.631 0 01.102 1.254l-.102.008h-.842c-.447 0-.965.335-1.042.574l-.01.058v.21h3.723c.3 0 .48-.178.487-.45l-.004-.072-.294-.359a67.829 67.829 0 00-.606-.724l-.456-.53-.354-.397-.16-.176a1.053 1.053 0 00-.536-.308l-.125-.022zm-1.985-2.823a1.263 1.263 0 100 2.526 1.263 1.263 0 000-2.526zM6.38 1.263a1.052 1.052 0 100 2.104 1.052 1.052 0 000-2.104z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var massage_svgvue_type_template_id_76e38189_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/massage-svg.vue?vue&type=template&id=76e38189

// CONCATENATED MODULE: ./src/components/svg/attributes/massage-svg.vue

var massage_svg_script = {}


/* normalize component */

var massage_svg_component = normalizeComponent(
  massage_svg_script,
  massage_svgvue_type_template_id_76e38189_render,
  massage_svgvue_type_template_id_76e38189_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var massage_svg = (massage_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/maxi-club-svg.vue?vue&type=template&id=6162eecc
var maxi_club_svgvue_type_template_id_6162eecc_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"23","height":"19","viewBox":"0 0 23 19","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M21.937 18.25c.311 0 .563-.252.563-.563v-.562a.562.562 0 00-.563-.563h-1.003L12.29 4.567l2.226-3.09a.563.563 0 00-.121-.786L13.942.36a.562.562 0 00-.786.121L11.25 3.124 9.344.48a.562.562 0 00-.786-.121l-.453.332a.562.562 0 00-.121.786l2.226 3.09-8.644 11.995H.562a.562.562 0 00-.562.563v.562c0 .311.252.563.562.563h21.375zM7.16 16.562H3.645L11.25 6.01l7.605 10.553h-3.514l-4.091-5.624-4.09 5.624z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var maxi_club_svgvue_type_template_id_6162eecc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/maxi-club-svg.vue?vue&type=template&id=6162eecc

// CONCATENATED MODULE: ./src/components/svg/attributes/maxi-club-svg.vue

var maxi_club_svg_script = {}


/* normalize component */

var maxi_club_svg_component = normalizeComponent(
  maxi_club_svg_script,
  maxi_club_svgvue_type_template_id_6162eecc_render,
  maxi_club_svgvue_type_template_id_6162eecc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var maxi_club_svg = (maxi_club_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/mini-club-svg.vue?vue&type=template&id=d9adde06
var mini_club_svgvue_type_template_id_d9adde06_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"19","height":"19","viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.5 0a9.5 9.5 0 110 19 9.5 9.5 0 010-19zM5.751 8.571l.08-.056c-1.257.876-2.128 1.783-2.62 2.714-.405.766-.654 1.51-.75 2.232a8.074 8.074 0 007.398 4.106c-.695-1.38-1.222-2.725-1.582-4.035a22.133 22.133 0 01-.694-3.563l-.043-.471-.15-.006a2.84 2.84 0 01-1.79-.811l.151-.11zm4.62-1.262A2.851 2.851 0 018.486 9.36l-.021-.323c.063 1.29.306 2.704.729 4.243.37 1.347.929 2.74 1.677 4.178a8.075 8.075 0 006.656-8.855c-.701-.635-1.635-1.018-2.817-1.15a26.915 26.915 0 00-4.337-.144zm-7.128-2.91l-.065.076A8.04 8.04 0 001.425 9.5c0 .883.142 1.733.404 2.529.14-.412.321-.827.542-1.244.535-1.013 1.427-1.97 2.671-2.875a2.846 2.846 0 01-.05-2.413c-.365-.406-.679-.672-.93-.797a4.67 4.67 0 00-.82-.3zM7.6 4.75a1.9 1.9 0 100 3.8 1.9 1.9 0 000-3.8zm4.023-3.043l.183-.075c-.635.24-1.108.586-1.431 1.039-.318.445-.656 1.026-1.011 1.74.59.466.99 1.158 1.071 1.945l-.343.017c1.51-.09 3.085-.045 4.722.137.932.103 1.748.35 2.443.739a8.092 8.092 0 00-5.634-5.542zM9.5 1.425a8.047 8.047 0 00-5.543 2.203c.197.07.373.143.53.222.326.163.673.44 1.05.835A2.84 2.84 0 017.6 3.8c.326 0 .639.055.93.155.37-.742.727-1.353 1.072-1.836a3.53 3.53 0 01.617-.663 8.56 8.56 0 00-.719-.031z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var mini_club_svgvue_type_template_id_d9adde06_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/mini-club-svg.vue?vue&type=template&id=d9adde06

// CONCATENATED MODULE: ./src/components/svg/attributes/mini-club-svg.vue

var mini_club_svg_script = {}


/* normalize component */

var mini_club_svg_component = normalizeComponent(
  mini_club_svg_script,
  mini_club_svgvue_type_template_id_d9adde06_render,
  mini_club_svgvue_type_template_id_d9adde06_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mini_club_svg = (mini_club_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/no-smoking-svg.vue?vue&type=template&id=5d1a3aa6
var no_smoking_svgvue_type_template_id_5d1a3aa6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9 18a9 9 0 009-9 9 9 0 00-9-9 9 9 0 00-9 9 9 9 0 009 9zm5.727-4.465l-2.285-2.285h1.62c.31 0 .563-.253.563-.563v-2.25a.564.564 0 00-.563-.562H9.067L4.465 3.273A7.288 7.288 0 019 1.687c4.032 0 7.312 3.28 7.312 7.313a7.288 7.288 0 01-1.585 4.535zM13.215 6.75a.287.287 0 00.281-.33 2.253 2.253 0 00-2.225-1.92 1.125 1.125 0 01-1.104-.91.272.272 0 00-.27-.215h-.57a.287.287 0 00-.281.33 2.253 2.253 0 002.225 1.92c.549 0 1.006.394 1.104.91.025.127.14.215.27.215h.57zM9 16.312c-4.032 0-7.313-3.28-7.313-7.312 0-1.712.598-3.287 1.586-4.535l10.262 10.262A7.288 7.288 0 019 16.312zM7.671 11.25L4.296 7.875h-.359a.564.564 0 00-.562.562v2.25c0 .31.253.563.562.563h3.734zm5.829-1.125h-2.183L10.192 9H13.5v1.125z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var no_smoking_svgvue_type_template_id_5d1a3aa6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/no-smoking-svg.vue?vue&type=template&id=5d1a3aa6

// CONCATENATED MODULE: ./src/components/svg/attributes/no-smoking-svg.vue

var no_smoking_svg_script = {}


/* normalize component */

var no_smoking_svg_component = normalizeComponent(
  no_smoking_svg_script,
  no_smoking_svgvue_type_template_id_5d1a3aa6_render,
  no_smoking_svgvue_type_template_id_5d1a3aa6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var no_smoking_svg = (no_smoking_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/parking-svg.vue?vue&type=template&id=9c3670ec
var parking_svgvue_type_template_id_9c3670ec_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"19","height":"20","viewBox":"0 0 19 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.203 19.078a9.203 9.203 0 009.203-9.203A9.203 9.203 0 009.203.672 9.203 9.203 0 000 9.875a9.203 9.203 0 009.203 9.203zm0-1.781c-4.092 0-7.422-3.33-7.422-7.422s3.33-7.422 7.422-7.422c4.093 0 7.422 3.33 7.422 7.422s-3.33 7.422-7.422 7.422zm-2.075-2.675a.594.594 0 00.594-.594V11.95h1.781c1.801 0 3.266-1.465 3.266-3.266 0-1.8-1.465-3.265-3.266-3.265H6.535a.594.594 0 00-.594.593v8.016c0 .328.266.594.594.594h.593zm2.375-4.453h-1.78v-2.97h1.78a1.486 1.486 0 010 2.969z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var parking_svgvue_type_template_id_9c3670ec_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/parking-svg.vue?vue&type=template&id=9c3670ec

// CONCATENATED MODULE: ./src/components/svg/attributes/parking-svg.vue

var parking_svg_script = {}


/* normalize component */

var parking_svg_component = normalizeComponent(
  parking_svg_script,
  parking_svgvue_type_template_id_9c3670ec_render,
  parking_svgvue_type_template_id_9c3670ec_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var parking_svg = (parking_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/pet-svg.vue?vue&type=template&id=4a5380b0
var pet_svgvue_type_template_id_4a5380b0_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"15","viewBox":"0 0 17 15","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.934 5.312c.925 0 1.867-.89 2.215-2.166.393-1.442-.12-2.83-1.148-3.1A1.671 1.671 0 0011.645 0h-.001c-.925 0-1.867.89-2.215 2.167-.393 1.441.12 2.83 1.148 3.1.118.03.237.045.357.045zm-4.869 0c.12 0 .24-.014.358-.045 1.027-.27 1.541-1.658 1.148-3.1C7.223.891 6.28 0 5.356 0c-.12 0-.24.015-.357.046-1.027.27-1.541 1.659-1.148 3.1.348 1.276 1.29 2.167 2.214 2.167zm4.852-1.33h-.002c-.03-.007-.082-.055-.133-.144-.136-.234-.235-.721-.072-1.322.213-.78.721-1.188.934-1.188l.019.003c.029.007.081.055.133.144.135.235.235.722.072 1.322-.212.778-.718 1.185-.95 1.185zm-4.852.002c-.212 0-.72-.408-.933-1.188-.164-.6-.064-1.086.072-1.32.051-.09.104-.138.133-.145a.072.072 0 01.02-.003c.212 0 .72.409.933 1.188.163.6.063 1.088-.072 1.322-.052.089-.104.137-.153.146zM2.125 8.5c.12 0 .241-.013.36-.042.967-.231 1.47-1.35 1.125-2.501C3.307 4.947 2.45 4.25 1.593 4.25c-.12 0-.24.014-.359.042C.267 4.524-.236 5.644.11 6.794.412 7.803 1.268 8.5 2.126 8.5zm12.75 0c.858 0 1.713-.697 2.016-1.706.345-1.15-.158-2.27-1.125-2.502a1.533 1.533 0 00-.36-.042c-.858 0-1.713.698-2.016 1.707-.345 1.15.158 2.27 1.125 2.501.12.029.24.042.36.042zM2.124 7.172c-.216 0-.595-.264-.744-.76-.096-.319-.046-.577.032-.713.056-.097.11-.11.13-.115a.22.22 0 01.05-.006c.216 0 .596.265.745.76.095.319.046.578-.032.713-.057.098-.11.11-.18.12zm12.707-.005h-.008c-.02-.005-.074-.018-.13-.115-.078-.136-.128-.395-.032-.713.15-.496.528-.76.745-.76l.05.005c.02.005.074.018.13.115.078.136.128.395.032.713-.147.49-.52.755-.787.755zm-2.34 7.708c1.493 0 2.383-.692 2.383-1.85 0-2.574-3.738-6.65-6.375-6.65s-6.375 4.076-6.375 6.65c0 1.158.89 1.85 2.382 1.85 1.622 0 2.692-.832 3.993-.832 1.312 0 2.386.832 3.993.832zm.001-1.593c-.588 0-1.105-.17-1.704-.368-.661-.218-1.41-.465-2.289-.465-.87 0-1.614.246-2.27.462-.603.199-1.123.37-1.723.37-.526 0-.75-.129-.776-.155a.317.317 0 01-.012-.102c0-1.795 3.083-5.055 4.78-5.055 1.699 0 4.782 3.26 4.782 5.055 0 .06-.008.094-.006.094-.032.035-.256.164-.782.164z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var pet_svgvue_type_template_id_4a5380b0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/pet-svg.vue?vue&type=template&id=4a5380b0

// CONCATENATED MODULE: ./src/components/svg/attributes/pet-svg.vue

var pet_svg_script = {}


/* normalize component */

var pet_svg_component = normalizeComponent(
  pet_svg_script,
  pet_svgvue_type_template_id_4a5380b0_render,
  pet_svgvue_type_template_id_4a5380b0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var pet_svg = (pet_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/place-svg.vue?vue&type=template&id=6665d84c
var place_svgvue_type_template_id_6665d84c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"15","height":"19","viewBox":"0 0 15 19","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.636 18.162c4.726-7.577 5.614-8.398 5.614-11.037a7.125 7.125 0 10-14.25 0c0 2.64.89 3.464 5.614 11.037a1.782 1.782 0 003.022 0zm-1.511-.943C2.396 9.637 1.781 9.159 1.781 7.125a5.344 5.344 0 1110.688 0c0 2.024-.563 2.428-5.344 10.094zm0-7.125a2.969 2.969 0 100-5.938 2.969 2.969 0 000 5.938z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var place_svgvue_type_template_id_6665d84c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/place-svg.vue?vue&type=template&id=6665d84c

// CONCATENATED MODULE: ./src/components/svg/attributes/place-svg.vue

var place_svg_script = {}


/* normalize component */

var place_svg_component = normalizeComponent(
  place_svg_script,
  place_svgvue_type_template_id_6665d84c_render,
  place_svgvue_type_template_id_6665d84c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var place_svg = (place_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/pool-svg.vue?vue&type=template&id=3ca0eb3a
var pool_svgvue_type_template_id_3ca0eb3a_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"10","viewBox":"0 0 20 10"}},[_c('path',{attrs:{"d":"M9 14.5c.15 0 .286-.012.407-.032l.805-1.129c.466-.652.982-1.26 1.523-1.847l4.08 2.858c.122-.05.217-.104.26-.144.374-.345.791-.568 1.225-.66l-4.484-3.14c.646-.597 1.322-1.164 2.05-1.673.29-.204.66-.278 1.034-.2l3.2.564c.416.071.813-.198.888-.605.074-.408-.201-.798-.618-.871l-3.174-.56c-.771-.162-1.58.002-2.219.45-2.902 2.034-4.61 4.398-5.018 4.968l-1.161 1.627c.042.035.086.062.127.1.11.102.477.294 1.075.294zM6 13c1.657 0 3-1.343 3-3S7.657 7 6 7s-3 1.343-3 3 1.343 3 3 3zm0-1.5c-.827 0-1.5-.673-1.5-1.5S5.173 8.5 6 8.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5zM3 17c1.207 0 2.272-.38 3-.995.727.614 1.793.995 3 .995s2.272-.38 3-.995c.727.614 1.793.995 3 .995s2.272-.38 3-.995c.727.614 1.793.995 3 .995h.5c.276 0 .5-.224.5-.5V16c0-.276-.224-.5-.5-.5H21c-.814 0-1.431-.263-1.753-.56-.278-.256-.614-.44-.993-.44h-.509c-.378 0-.715.184-.993.44-.32.297-.938.56-1.752.56-.814 0-1.431-.263-1.753-.56-.278-.256-.614-.44-.993-.44h-.509c-.378 0-.715.184-.993.44-.32.297-.938.56-1.752.56-.814 0-1.431-.263-1.753-.56-.278-.256-.614-.44-.993-.44h-.509c-.378 0-.715.184-.993.44-.32.297-.938.56-1.752.56h-.5c-.276 0-.5.224-.5.5v.5c0 .276.224.5.5.5H3z","transform":"translate(-42 -301) translate(40 294)","fill":"currentColor","fill-rule":"nonzero"}})])
}
var pool_svgvue_type_template_id_3ca0eb3a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/pool-svg.vue?vue&type=template&id=3ca0eb3a

// CONCATENATED MODULE: ./src/components/svg/attributes/pool-svg.vue

var pool_svg_script = {}


/* normalize component */

var pool_svg_component = normalizeComponent(
  pool_svg_script,
  pool_svgvue_type_template_id_3ca0eb3a_render,
  pool_svgvue_type_template_id_3ca0eb3a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var pool_svg = (pool_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/pool-kids-svg.vue?vue&type=template&id=6d0fc4f4
var pool_kids_svgvue_type_template_id_6d0fc4f4_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"19","height":"18","viewBox":"0 0 19 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.604 8.331c.26-.25.66-.271.944-.065l.104.092 1.705 1.715 2.434 2.431.805.8.412.413c1.066 1.044 1.87 1.645 2.52 1.715l.07.004.013-.007c.631-.372 1.47-.425 2.161-.16l.17.074.162.086c.362.214.697.32.994.32.338 0 .625-.097.947-.322a.737.737 0 011.02.172.72.72 0 01-.175 1.013c-.571.4-1.144.588-1.792.588-.57 0-1.156-.178-1.744-.524-.273-.161-.72-.161-.993 0-.588.346-1.175.524-1.744.524-.57 0-1.157-.178-1.745-.524-.272-.161-.72-.161-.993 0-.587.346-1.175.524-1.744.524-.57 0-1.157-.178-1.744-.524-.273-.161-.72-.161-.993 0-.588.346-1.175.524-1.745.524-.394 0-.713-.092-1.046-.264l-.299-.164-.075-.037a.723.723 0 01-.367-.96.735.735 0 01.967-.364l.142.069.176.096c.25.142.335.173.502.173.298 0 .633-.106.995-.32.684-.403 1.612-.432 2.33-.086l.163.086c.362.214.697.32.994.32.248 0 .522-.073.816-.222l.178-.098a2.39 2.39 0 01.894-.302l.193-.019.129-.003-.18-.171-.445-.442-.417-.422-1.597-1.584L3.592 9.36a.72.72 0 01-.06-.947l.072-.08zM3.086 4.85c1.055 0 2.018.362 2.793 1.05l.176.163 6.346 6.263c.555.547 1.016.87 1.581 1.032.745.214 1.597.094 2.613-.374a.736.736 0 01.972.348.722.722 0 01-.353.966c-.9.416-1.727.614-2.49.614-1.223 0-2.188-.47-3.15-1.361l-.207-.198-6.346-6.262a2.697 2.697 0 00-1.935-.79c-.266 0-.54.063-.805.17l-.092.039-.15.072-.102.059A.736.736 0 01.924 6.44a.722.722 0 01.203-1.009 3.64 3.64 0 011.96-.581zm3.448-1.518l.085.066 1.8 1.633 1.352-.057c.176-.007.35.015.514.063l.162.058.092.044.08-.01c.125-.024.245-.072.352-.14l.102-.073.091-.086 1.2-1.289a.737.737 0 011.033-.043.72.72 0 01.111.943l-.067.084-1.2 1.288c-.225.242-.5.436-.805.571l-.034.013.221 2.286 1.642-.176a2.247 2.247 0 011.444.336l.155.108.147.122c.294.267.508.602.623.977l.052.201.247 1.262a.726.726 0 01-.72.864.732.732 0 01-.691-.488l-.027-.1-.245-1.253a.74.74 0 00-.228-.393.768.768 0 00-.49-.198l-.109.004-2.4.258-.04.002-.083-.002-.12-.02-.107-.038-.07-.034-.088-.058-.074-.065-.086-.106-.066-.121-.024-.066-.018-.069-.012-.077-.292-3.036-.007-.037c0-.003.002-.004.006-.001l-.026-.019-.023-.02-.03-.013-.03-.003-1.656.069a.738.738 0 01-.434-.12l-.09-.07-2.024-1.835a.72.72 0 01-.043-1.027.738.738 0 01.948-.11zM9.688.8c.504 0 .978.194 1.334.546a1.852 1.852 0 010 2.64c-.356.352-.83.546-1.334.546-.503 0-.978-.194-1.334-.546a1.844 1.844 0 01-.554-1.32c0-.499.197-.968.554-1.32C8.71.993 9.184.8 9.688.8zm-.005 1.1a.783.783 0 00-.783.775c0 .207.082.403.23.549a.783.783 0 00.553.226.783.783 0 00.784-.775.767.767 0 00-.23-.549.783.783 0 00-.554-.226z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var pool_kids_svgvue_type_template_id_6d0fc4f4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/pool-kids-svg.vue?vue&type=template&id=6d0fc4f4

// CONCATENATED MODULE: ./src/components/svg/attributes/pool-kids-svg.vue

var pool_kids_svg_script = {}


/* normalize component */

var pool_kids_svg_component = normalizeComponent(
  pool_kids_svg_script,
  pool_kids_svgvue_type_template_id_6d0fc4f4_render,
  pool_kids_svgvue_type_template_id_6d0fc4f4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var pool_kids_svg = (pool_kids_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/restaurant-svg.vue?vue&type=template&id=d4bd99de
var restaurant_svgvue_type_template_id_d4bd99de_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"16","viewBox":"0 0 17 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.437 16c.979 0 1.757-.816 1.7-1.784l-.318-5.65C8.112 7.887 9 6.572 9 4.922c0-.953-.403-3.056-.488-3.49C8.36.627 7.628 0 6.582 0c-.357 0-.723.075-1.041.244A2.247 2.247 0 004.5 0c-.36 0-.728.078-1.04.244A2.227 2.227 0 002.418 0C1.379 0 .64.622.487 1.431.403 1.862 0 3.966 0 4.921 0 6.57.881 7.885 2.181 8.57l-.319 5.647A1.694 1.694 0 003.562 16h1.875zm9.813 0c.966 0 1.75-.756 1.75-1.688V1.687C17 .757 16.216 0 15.25 0 13.006 0 10 2.594 10 5.678c0 1.888 1.094 3.163 2.172 4.028l-.416 4.453c-.09.988.71 1.841 1.744 1.841h1.75zm-9.813-1.5H3.562c-.115 0-.209-.09-.203-.2l.382-6.766C2.416 7.281 1.5 6.291 1.5 4.922c0-.863.462-3.21.462-3.21.05-.287.885-.28.922.007v3.553c.028.331.882.337.922.006l.231-3.566c.05-.28.872-.28.922 0l.232 3.566c.04.331.893.325.921-.006V1.719c.038-.288.872-.294.922-.007 0 0 .463 2.347.463 3.21.003 1.362-.906 2.356-2.238 2.612l.382 6.766c.006.106-.085.2-.204.2zm9.813 0H13.5c-.144 0-.26-.094-.25-.2l.494-5.297C12.506 8.16 11.5 7.16 11.5 5.678c0-2.269 2.356-4.178 3.75-4.178.134 0 .25.087.25.187v12.625c0 .104-.116.188-.25.188z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var restaurant_svgvue_type_template_id_d4bd99de_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/restaurant-svg.vue?vue&type=template&id=d4bd99de

// CONCATENATED MODULE: ./src/components/svg/attributes/restaurant-svg.vue

var restaurant_svg_script = {}


/* normalize component */

var restaurant_svg_component = normalizeComponent(
  restaurant_svg_script,
  restaurant_svgvue_type_template_id_d4bd99de_render,
  restaurant_svgvue_type_template_id_d4bd99de_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var restaurant_svg = (restaurant_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/sauna-svg.vue?vue&type=template&id=b44fc73c
var sauna_svgvue_type_template_id_b44fc73c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.833 5.75l.172.01c.344.036.75.173 1.042.349l.136.091 3.399 2.549L16 8.75a1.25 1.25 0 011.225.998l.019.124.006.128v5a2.25 2.25 0 01-2.096 2.245L15 17.25H3a2.25 2.25 0 01-2.245-2.096L.75 15V8a2.25 2.25 0 012.096-2.245L3 5.75h1.833zm10.916 4.499h-13.5L2.25 15c0 .379.283.693.648.743L3 15.75h12a.752.752 0 00.743-.648L15.75 15l-.001-4.751zM4.75 10.75a.5.5 0 01.492.41l.008.09v3.5a.5.5 0 01-.41.492l-.09.008h-.5a.5.5 0 01-.492-.41l-.008-.09v-3.5a.5.5 0 01.41-.492l.09-.008h.5zm3 0a.5.5 0 01.492.41l.008.09v3.5a.5.5 0 01-.41.492l-.09.008h-.5a.5.5 0 01-.492-.41l-.008-.09v-3.5a.5.5 0 01.41-.492l.09-.008h.5zm3 0a.5.5 0 01.492.41l.008.09v3.5a.5.5 0 01-.41.492l-.09.008h-.5a.5.5 0 01-.492-.41l-.008-.09v-3.5a.5.5 0 01.41-.492l.09-.008h.5zm3 0a.5.5 0 01.492.41l.008.09v3.5a.5.5 0 01-.41.492l-.09.008h-.5a.5.5 0 01-.492-.41l-.008-.09v-3.5a.5.5 0 01.41-.492l.09-.008h.5zm-8.917-3.5H3a.752.752 0 00-.743.648L2.25 8l-.001.749h4.834l-1.8-1.35a.755.755 0 00-.353-.143l-.097-.006zm4.92-5.5a.5.5 0 01.498.477c.048.825.355 1.57.838 2.058l.136.126c.891.763 1.445 1.985 1.512 3.316a.502.502 0 01-.42.516l-.083.007h-.5a.5.5 0 01-.497-.477c-.052-.9-.413-1.704-.974-2.184-.891-.763-1.445-1.985-1.512-3.315a.502.502 0 01.42-.517l.083-.007h.5zm3 0a.5.5 0 01.498.477c.048.825.355 1.57.838 2.058l.136.126c.891.763 1.445 1.985 1.512 3.316a.502.502 0 01-.42.516l-.083.007h-.5a.5.5 0 01-.497-.477c-.052-.9-.413-1.704-.974-2.184-.891-.763-1.445-1.985-1.512-3.315a.502.502 0 01.42-.517l.083-.007h.5zM3.5.75a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1.5c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var sauna_svgvue_type_template_id_b44fc73c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/sauna-svg.vue?vue&type=template&id=b44fc73c

// CONCATENATED MODULE: ./src/components/svg/attributes/sauna-svg.vue

var sauna_svg_script = {}


/* normalize component */

var sauna_svg_component = normalizeComponent(
  sauna_svg_script,
  sauna_svgvue_type_template_id_b44fc73c_render,
  sauna_svgvue_type_template_id_b44fc73c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var sauna_svg = (sauna_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/star-svg.vue?vue&type=template&id=53aa6b28
var star_svgvue_type_template_id_53aa6b28_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"20","viewBox":"0 0 21 20"}},[_c('path',{attrs:{"d":"M7.344 21.856l5.105-2.684 5.106 2.684c.906.476 1.988-.29 1.812-1.317l-.976-5.683 4.128-4.024c.743-.722.333-1.984-.69-2.132l-5.708-.832-2.55-5.172c-.458-.922-1.782-.934-2.243 0l-2.55 5.172L3.07 8.7c-1.023.148-1.433 1.41-.691 2.132l4.129 4.024-.977 5.683c-.176 1.028.906 1.797 1.813 1.317zm9.96-2.25l-4.855-2.55-4.855 2.55.926-5.406-3.93-3.828 5.43-.79 2.43-4.921 2.429 4.921 5.43.79-3.93 3.828.926 5.406z","transform":"translate(-690 -440) translate(688 438)","fill":"currentColor","fill-rule":"nonzero"}})])
}
var star_svgvue_type_template_id_53aa6b28_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/star-svg.vue?vue&type=template&id=53aa6b28

// CONCATENATED MODULE: ./src/components/svg/attributes/star-svg.vue

var star_svg_script = {}


/* normalize component */

var star_svg_component = normalizeComponent(
  star_svg_script,
  star_svgvue_type_template_id_53aa6b28_render,
  star_svgvue_type_template_id_53aa6b28_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var star_svg = (star_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/theater-masks-svg.vue?vue&type=template&id=0a98d8bb
var theater_masks_svgvue_type_template_id_0a98d8bb_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"22","height":"18","viewBox":"0 0 22 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.877 15c.122 0 .23-.015.341-.027a9.442 9.442 0 01-1.049-1.64c-1.756-.348-4.245-1.821-4.511-3.325L1.604 4.05c-.046-.263.066-.527.273-.642a13.499 13.499 0 016.534-1.694c.28 0 .563.016.844.034a3.16 3.16 0 011.03-.36c.628-.1 1.264-.152 1.9-.178-.333-.463-.813-.804-1.388-.896A15.05 15.05 0 001.102 2.02C.3 2.464-.13 3.394.035 4.326l1.053 5.959C1.561 12.957 5.615 15 7.877 15zm12.285-2.604l1.053-5.976c.165-.935-.265-1.867-1.067-2.314a15.034 15.034 0 00-9.695-1.709c-.906.145-1.63.874-1.794 1.81l-1.054 5.975c-.51 2.897 3.164 6.533 5.257 6.902 2.093.369 6.789-1.79 7.3-4.688zm-7.024 3.118c-1.33-.234-4.303-3.131-3.964-5.056l1.054-5.975c.046-.264.243-.475.477-.512a13.42 13.42 0 018.667 1.528c.207.115.32.38.273.645l-1.053 5.975c-.34 1.924-4.124 3.63-5.454 3.395zM5.343 6.865A1.328 1.328 0 006.42 5.326a1.312 1.312 0 00-.135-.379c-.274.297-.686.524-1.173.61-.486.086-.952.013-1.31-.172a1.31 1.31 0 00.002.403 1.328 1.328 0 001.539 1.077zm8.213 1.304c.06-.117.11-.242.135-.38a1.328 1.328 0 10-2.616-.46c-.024.137-.02.271-.003.402.36-.185.825-.257 1.311-.172.486.086.9.313 1.173.61zm4.185.739c.061-.118.111-.242.136-.38a1.328 1.328 0 10-2.617-.461c-.024.137-.02.271-.003.403.36-.186.825-.258 1.311-.172.487.085.9.313 1.173.61zm-12.783 1.8c.379-.423.957-.788 1.657-1.028l.253-1.438c-1.19.348-1.99 1.371-1.91 2.467zm12.613.193c-.934.565-2.28.806-3.717.553-1.437-.253-2.62-.94-3.303-1.79-.149 1.785 1.108 3.431 2.956 3.758 1.85.326 3.593-.792 4.064-2.52z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var theater_masks_svgvue_type_template_id_0a98d8bb_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/theater-masks-svg.vue?vue&type=template&id=0a98d8bb

// CONCATENATED MODULE: ./src/components/svg/attributes/theater-masks-svg.vue

var theater_masks_svg_script = {}


/* normalize component */

var theater_masks_svg_component = normalizeComponent(
  theater_masks_svg_script,
  theater_masks_svgvue_type_template_id_0a98d8bb_render,
  theater_masks_svgvue_type_template_id_0a98d8bb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var theater_masks_svg = (theater_masks_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/train-subway.vue?vue&type=template&id=4316f36e
var train_subwayvue_type_template_id_4316f36e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512"}},[_c('path',{attrs:{"d":"M200 48l0 160L48 208 48 96c0-26.5 21.5-48 48-48l104 0zm48 0l104 0c26.5 0 48 21.5 48 48l0 112-152 0 0-160zM48 352l0-96 352 0 0 96c0 26.5-21.5 48-48 48L96 400c-26.5 0-48-21.5-48-48zM96 0C43 0 0 43 0 96L0 352c0 42.8 28 79 66.6 91.4L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 188.1 0 57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6C420 431 448 394.8 448 352l0-256c0-53-43-96-96-96L96 0zm32 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}})])
}
var train_subwayvue_type_template_id_4316f36e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/train-subway.vue?vue&type=template&id=4316f36e

// CONCATENATED MODULE: ./src/components/svg/attributes/train-subway.vue

var train_subway_script = {}


/* normalize component */

var train_subway_component = normalizeComponent(
  train_subway_script,
  train_subwayvue_type_template_id_4316f36e_render,
  train_subwayvue_type_template_id_4316f36e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var train_subway = (train_subway_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/twenty-four-reception-svg.vue?vue&type=template&id=a19527ec
var twenty_four_reception_svgvue_type_template_id_a19527ec_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"22","height":"18","viewBox":"0 0 22 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M13 .95A8.049 8.049 0 0121.05 9 8.049 8.049 0 0113 17.05a8.049 8.049 0 01-8.046-7.804l-.004-.305.003-.348.343.053c.23.036.464.054.704.054l.235-.006.315-.015v.315a6.451 6.451 0 104.64-6.187l-.289.091-.3.104-.086-.306a4.5 4.5 0 00-.244-.66l-.104-.212-.16-.307.327-.115A8.037 8.037 0 0113 .95zm.219 3c.285 0 .535.18.635.46l.03.11.01.105-.001 4.418 2.08 1.514c.204.147.302.39.266.639l-.023.107-.04.107-.055.091-.258.355a.675.675 0 01-.744.24l-.107-.039-.092-.055-2.54-1.845a.668.668 0 01-.238-.335l-.028-.111-.008-.098V4.625c0-.286.18-.535.46-.635l.11-.03.105-.01h.438z"}}),_c('path',{attrs:{"d":"M2.896 1.8c.571 0 1.039.15 1.395.451.363.309.546.727.546 1.24 0 .276-.05.539-.152.788-.099.244-.25.492-.45.745a8.45 8.45 0 01-.782.819l-.183.17-.661.626h2.426v1.186H.8V6.95l.06-.143 1.457-1.435.293-.298.237-.25.183-.201c.052-.06.095-.11.128-.153.13-.167.223-.322.28-.463.055-.135.082-.28.082-.437 0-.197-.056-.341-.167-.446-.113-.106-.276-.162-.5-.162-.191 0-.377.035-.556.104a2.41 2.41 0 00-.506.288l-.147.11-.152.117-.747-.894.355-.278a3.14 3.14 0 01.78-.434c.318-.117.658-.175 1.016-.175zm5.98.064l-.001 3.611h.762v1.14h-.762v1.21H7.59v-1.21H5.004v-.886l.037-.116L7.626 1.95l.163-.085h1.086zM7.827 3.066h-.031l-.048.104a4.89 4.89 0 01-.293.503L6.052 5.675h1.737V4.283l.001-.24c.004-.388.016-.714.038-.977z"}})])])
}
var twenty_four_reception_svgvue_type_template_id_a19527ec_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/twenty-four-reception-svg.vue?vue&type=template&id=a19527ec

// CONCATENATED MODULE: ./src/components/svg/attributes/twenty-four-reception-svg.vue

var twenty_four_reception_svg_script = {}


/* normalize component */

var twenty_four_reception_svg_component = normalizeComponent(
  twenty_four_reception_svg_script,
  twenty_four_reception_svgvue_type_template_id_a19527ec_render,
  twenty_four_reception_svgvue_type_template_id_a19527ec_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var twenty_four_reception_svg = (twenty_four_reception_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/washer-svg.vue?vue&type=template&id=134595a2
var washer_svgvue_type_template_id_134595a2_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"19","viewBox":"0 0 17 19"}},[_c('path',{attrs:{"d":"M18.59 21.25c.62 0 1.125-.504 1.125-1.125V5.5c0-1.242-1.008-2.25-2.25-2.25H6.215c-1.242 0-2.25 1.008-2.25 2.25v14.625c0 .621.504 1.125 1.125 1.125h13.5zm-.563-1.688H5.652V5.5c0-.31.252-.562.563-.562h11.25c.31 0 .562.252.562.562v14.062zM7.621 7.75c.466 0 .844-.378.844-.844 0-.465-.378-.843-.844-.843-.466 0-.844.378-.844.843 0 .466.378.844.844.844zm2.813 0c.465 0 .843-.378.843-.844 0-.465-.378-.843-.843-.843-.466 0-.844.378-.844.843 0 .466.378.844.844.844zm1.406 10.688c2.64 0 4.781-2.142 4.781-4.782 0-2.639-2.142-4.781-4.781-4.781-2.64 0-4.781 2.142-4.781 4.781 0 2.64 2.142 4.782 4.78 4.782zm0-1.594c-1.758-.002-3.186-1.43-3.188-3.188 0-.101.021-.197.03-.296.183.09.497.163.7.163h.001c.401 0 .953-.233 1.233-.52.277.287.825.52 1.224.52s.947-.233 1.224-.52c.248.256.712.468 1.094.512l.139.008c.204 0 .517-.074.7-.163.01.099.03.195.03.296-.002 1.758-1.43 3.186-3.187 3.188z","transform":"translate(-354 -681) translate(351 678)","fill":"currentColor","fill-rule":"nonzero"}})])
}
var washer_svgvue_type_template_id_134595a2_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/washer-svg.vue?vue&type=template&id=134595a2

// CONCATENATED MODULE: ./src/components/svg/attributes/washer-svg.vue

var washer_svg_script = {}


/* normalize component */

var washer_svg_component = normalizeComponent(
  washer_svg_script,
  washer_svgvue_type_template_id_134595a2_render,
  washer_svgvue_type_template_id_134595a2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var washer_svg = (washer_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/watersports-svg.vue?vue&type=template&id=4ca012f7
var watersports_svgvue_type_template_id_4ca012f7_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"22","height":"22","viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.419 18.674c.222.01.444.133.566.315l.09.106a3.479 3.479 0 00.345.332h-.001l.11.087c.124.088.232.158.343.223.35.2.589.296.978.387.442.107.888.137 1.368.103.768-.06 1.442-.3 2.06-.735l.117-.084a3.817 3.817 0 00.358-.32c.047-.046.094-.097.14-.15l.02-.027a.705.705 0 01.5-.227c.179.001.345.075.48.214l.002-.004c.078.098.164.19.255.276.089.085.181.169.279.247l.046.036.049.036c.062.044.125.087.188.127.346.221.6.341.937.443.45.138.852.194 1.308.178a3.67 3.67 0 002.17-.758v-.002l.054-.026-.01-.01c.047-.04.094-.08.14-.123a3.334 3.334 0 00.35-.362c.216-.282.573-.36.86-.191a.686.686 0 01.312.442.578.578 0 01-.087.463 3.018 3.018 0 01-.19.242c-1.027 1.187-2.696 1.797-4.353 1.59-1.055-.13-2.065-.578-2.8-1.238-1.185 1.022-2.852 1.473-4.495 1.2-.961-.157-1.866-.585-2.511-1.186a5.34 5.34 0 01-3.41 1.268 4.61 4.61 0 01-.586-.037C2.02 21.334.786 20.647.1 19.67a.588.588 0 01-.086-.464.685.685 0 01.31-.44c.297-.175.655-.09.873.204.065.078.117.135.17.19.08.082.48.413.532.45.153.103.307.193.458.267.176.087.236.114.443.18.444.14.846.2 1.291.18a3.903 3.903 0 002.152-.716l.286-.218c.078-.068.157-.139.232-.214.065-.065.132-.132.191-.206a.535.535 0 01.466-.209zm1.993-10.08l.101.016c.18.042.334.154.424.307a.657.657 0 01-.227.887l-1.66 1.087a3.97 3.97 0 00-.18.128c-.251.182-.536.39-.861.39h-.002l-1.031-.003c.06.068.107.15.141.242l.744 2.086 2.836-.002c.268 0 .488.147.585.387.02.024.037.05.055.078l1.958 3.276a.94.94 0 01-.064 1c-.163.22-.365.318-.56.399-.055.023-.11.047-.167.074-.218.098-.464.21-.731.214h-.01c-.432 0-.68-.291-.885-.605L8.49 16.422l-2.813.003c-.749 0-1.36-.257-1.766-.74-.247-.292-.427-.62-.586-1.06l-1.187-3.308c-.11-.307.116-.779.32-.968a.887.887 0 01.621-.25h.003l3.791.005 2.164-1.416a.6.6 0 01.476-.078zM8.262.967c.964-.149 2.031.026 3.269.529 1.302.53 2.561 1.285 3.85 2.308a20.367 20.367 0 016.444 8.874c.07.19.03.408-.109.586a.66.66 0 01-.181.162l-7.182 4.494a.618.618 0 01-.516.064.733.733 0 01-.44-.434L7.344 1.906a.548.548 0 01.014-.435.75.75 0 01.42-.381c.157-.056.318-.097.482-.122zm-4.71 10.436l1.074 2.994.048.103c.025.049.053.099.083.147.019.028.155.203.187.234a.786.786 0 00.575.238l3.291-.002c.208 0 .383.084.5.236.058.047.106.101.146.163l1.472 2.26.023-.01-1.632-2.73-2.916.002c-.285 0-.523-.178-.626-.466l-.91-2.552a.595.595 0 01.04-.475.713.713 0 01.097-.14l-1.453-.002zm5.306-9.188L14.34 16.39l6.06-3.791a19.019 19.019 0 00-2.751-4.69 20.17 20.17 0 00-1.758-1.926A18.468 18.468 0 0014.1 4.46a15.606 15.606 0 00-1.84-1.181 12.487 12.487 0 00-.885-.438l-.138-.06a8.941 8.941 0 00-.625-.236 7.57 7.57 0 00-.787-.222 5.937 5.937 0 00-.381-.07l-.076-.01-.16-.014a3.276 3.276 0 00-.35-.012zm-5.19 3.449c.865 0 1.612.588 1.818 1.43.117.487.04.99-.221 1.415a1.858 1.858 0 01-1.599.899 1.865 1.865 0 01-1.818-1.43 1.86 1.86 0 01.22-1.416c.26-.427.671-.727 1.157-.844.144-.036.294-.054.443-.054zm0 1.305a.556.556 0 00-.485.271.565.565 0 00-.067.43c.073.3.384.488.685.417a.564.564 0 00.417-.685.566.566 0 00-.55-.433z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var watersports_svgvue_type_template_id_4ca012f7_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/watersports-svg.vue?vue&type=template&id=4ca012f7

// CONCATENATED MODULE: ./src/components/svg/attributes/watersports-svg.vue

var watersports_svg_script = {}


/* normalize component */

var watersports_svg_component = normalizeComponent(
  watersports_svg_script,
  watersports_svgvue_type_template_id_4ca012f7_render,
  watersports_svgvue_type_template_id_4ca012f7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var watersports_svg = (watersports_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/wellness-svg.vue?vue&type=template&id=1d9611ee
var wellness_svgvue_type_template_id_1d9611ee_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"22","height":"17","viewBox":"0 0 22 17","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18.081 13.624c3.03-2.716 3.286-6.36 3.294-7.396a.282.282 0 00-.286-.29h-.002c-.793.003-3.135.134-5.483 1.337-.986-2.907-2.57-5.44-4.517-7.134A.608.608 0 0010.69 0a.608.608 0 00-.399.141C8.343 1.835 6.759 4.368 5.77 7.275 3.425 6.072 1.083 5.94.289 5.937H.286a.282.282 0 00-.286.29c.009 1.037.265 4.682 3.294 7.397 2.97 2.89 5.91 2.997 7.21 3.001h.271c1.246 0 4.261-.036 7.306-3.001zm-7.393-1.086c-.484-1.171-1.236-2.42-2.465-3.52a9.543 9.543 0 00-.914-.766c.745-2.368 1.924-4.48 3.38-6.025 1.455 1.545 2.633 3.657 3.378 6.025-.311.236-.62.479-.915.765-1.229 1.1-1.98 2.35-2.464 3.52zm.985 2.278l.661-1.598c.476-1.152 1.132-2.091 2.006-2.873l.028-.025.027-.027c1.596-1.556 3.57-2.176 5.007-2.42-.275 1.292-.937 3.014-2.51 4.424l-.054.05c-1.99 1.939-3.914 2.372-5.165 2.469zm-1.972 0c-1.253-.098-3.176-.533-5.164-2.469l-.026-.025-.027-.025c-1.574-1.41-2.235-3.132-2.51-4.424 1.439.245 3.411.866 5.006 2.42l.027.027.029.025c.873.782 1.53 1.722 2.005 2.874l.66 1.597z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var wellness_svgvue_type_template_id_1d9611ee_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/wellness-svg.vue?vue&type=template&id=1d9611ee

// CONCATENATED MODULE: ./src/components/svg/attributes/wellness-svg.vue

var wellness_svg_script = {}


/* normalize component */

var wellness_svg_component = normalizeComponent(
  wellness_svg_script,
  wellness_svgvue_type_template_id_1d9611ee_render,
  wellness_svgvue_type_template_id_1d9611ee_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var wellness_svg = (wellness_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/wheelchair-svg.vue?vue&type=template&id=57d5b66e
var wheelchair_svgvue_type_template_id_57d5b66e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"21","viewBox":"0 0 20 21","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.268 18.84l2.472-1.256a.469.469 0 00.211-.628l-.416-.84a.469.469 0 00-.63-.21l-1.595.82-2.391-5.358c-.122-.273-.439-.5-.743-.547l-.114-.008H8.008l-.25-1.875h5.523c.26 0 .469-.21.469-.47v-.937a.469.469 0 00-.469-.468H7.508l-.377-2.83a1.875 1.875 0 001.617-1.939A1.875 1.875 0 005 2.374v.022l.001.004v.02c.008.109.083.65 1.257 9.454.062.466.46.814.93.814h6.266l2.542 5.694a.938.938 0 001.272.458zM6.875 20.5a6.884 6.884 0 006.236-3.982l-.873-1.955h-.452a5.008 5.008 0 01-4.911 4.062c-2.757 0-5-2.243-5-5 0-1.71.863-3.221 2.175-4.123l-.269-2.015A6.882 6.882 0 000 13.625 6.883 6.883 0 006.875 20.5z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var wheelchair_svgvue_type_template_id_57d5b66e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/wheelchair-svg.vue?vue&type=template&id=57d5b66e

// CONCATENATED MODULE: ./src/components/svg/attributes/wheelchair-svg.vue

var wheelchair_svg_script = {}


/* normalize component */

var wheelchair_svg_component = normalizeComponent(
  wheelchair_svg_script,
  wheelchair_svgvue_type_template_id_57d5b66e_render,
  wheelchair_svgvue_type_template_id_57d5b66e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var wheelchair_svg = (wheelchair_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/wintersport-svg.vue?vue&type=template&id=7aa3f5b0
var wintersport_svgvue_type_template_id_7aa3f5b0_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14 .8a2.203 2.203 0 01.469 4.353l-.158.028-.121.013.2.6 1.368.69a1.702 1.702 0 01.873 1.995l-.05.145-.062.142c-.36.71-1.218 1.19-2.14.819l-.147-.066-2.88-1.575.561.561c.646.646.817 1.618.465 2.429l-.077.16-1.369 2.321-.06.089-.044.056-.09.097 3.799 2.036c.395.182.874.138 1.247-.102l.12-.087.1-.091a.695.695 0 01.99-.002.693.693 0 01-.002.99 2.723 2.723 0 01-2.857.636l-.223-.092-12.745-6.829a.703.703 0 01-.284-.948.703.703 0 01.855-.327l.094.042 6.016 3.227.01-.043c.019-.074.042-.147.071-.217l.047-.103.083-.148.789-1.343-1.98-1.98a2.685 2.685 0 01-.786-2.067l.018-.192.032-.191c.05-.247.144-.483.278-.722l-.73-.419-.01.007c-.331.2-.728.259-1.099.16l-.137-.045-.134-.06-.179-.091.092-.179.306-.552-.72-.63c-.24-.211-.106-.584.17-.634l.071-.006.072.008.932.189.369-.725.179.092c.427.22.703.63.76 1.088l.01.15 1.041.596.014-.007a2.92 2.92 0 01.19-.11l.085-.041 2.693-1.08c.35-.141.693-.201 1.04-.191l.21.014.198.028.01-.065a2.2 2.2 0 011.84-1.778l.165-.018L14 .8zM7.62 5.792l-.038.075c-.035.078-.06.155-.076.235-.078.383.019.775.258 1.074l.096.108 2.747 2.75-1.356 2.302c-.103.154-.061.314.084.412.125.084.263.08.362-.016l.046-.055 1.278-2.17a.804.804 0 00-.026-.924l-.074-.085-2.78-2.781.613-.274-1.134-.651zm3.552-1.752l-.133.031-.133.046-1.998.799 1.434.821 1.675-.747.636 1.91.026.07.07.15 1.234.707.884.44c.167.084.321.022.4-.135.068-.135.046-.27-.067-.36l-.064-.04-1.816-.906-.1-.116-.6-1.797c-.188-.568-.788-.99-1.448-.873zM14 2.2a.8.8 0 000 1.6.8.8 0 000-1.6z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var wintersport_svgvue_type_template_id_7aa3f5b0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/wintersport-svg.vue?vue&type=template&id=7aa3f5b0

// CONCATENATED MODULE: ./src/components/svg/attributes/wintersport-svg.vue

var wintersport_svg_script = {}


/* normalize component */

var wintersport_svg_component = normalizeComponent(
  wintersport_svg_script,
  wintersport_svgvue_type_template_id_7aa3f5b0_render,
  wintersport_svgvue_type_template_id_7aa3f5b0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var wintersport_svg = (wintersport_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/attributes/wlan-svg.vue?vue&type=template&id=20f6478a
var wlan_svgvue_type_template_id_20f6478a_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"14","viewBox":"0 0 20 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19.377 4.885l.52-.537a.368.368 0 00-.019-.53c-5.57-5.095-14.196-5.086-19.756 0a.368.368 0 00-.018.53l.518.537a.378.378 0 00.526.017c4.987-4.556 12.713-4.56 17.704 0 .15.137.384.129.525-.017zm-3.495 3.663l.515-.543a.376.376 0 00-.019-.536 9.473 9.473 0 00-12.757 0 .376.376 0 00-.018.536l.514.543a.37.37 0 00.52.019 7.992 7.992 0 0110.725 0c.15.136.38.128.52-.019zM10 14a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-1.5a1.001 1.001 0 111-1c0 .551-.449 1-1 1z","fill":"currentColor","fill-rule":"nonzero"}})])
}
var wlan_svgvue_type_template_id_20f6478a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/attributes/wlan-svg.vue?vue&type=template&id=20f6478a

// CONCATENATED MODULE: ./src/components/svg/attributes/wlan-svg.vue

var wlan_svg_script = {}


/* normalize component */

var wlan_svg_component = normalizeComponent(
  wlan_svg_script,
  wlan_svgvue_type_template_id_20f6478a_render,
  wlan_svgvue_type_template_id_20f6478a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var wlan_svg = (wlan_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/earth-svg.vue?vue&type=template&id=e1088ca6
var earth_svgvue_type_template_id_e1088ca6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"76","height":"77"}},[_c('path',{attrs:{"d":"M14.27 11.614c1.825 2.072 3.008 3.193 4.065 3.444 1.114.265 3.032-.065 4.302-.345a1.74 1.74 0 00-.401.389c-.371.486-.452 1.089-.543 1.787-.04.29-.111.83-.123.899-.261.318-.638.386-1.444.462-.807.077-1.81.175-2.578.985-1.058 1.119-.87 2.37-.77 3.043.02.123.049.244.061.272-.077.243-.237.726-.419 1.18-.087.155-.16.32-.216.493-.023.044-.044.095-.064.136-.343.154-1.14.316-1.42.375-.09.017-.17.035-.246.052l-.115-.044c-.566-.2-1.511-.541-2.615-.13-1.475.543-2.434 2.702-2.777 3.605l-.177.46.121.48s.311 1.254.574 2.233c.387 1.444 1.789 2.246 2.913 2.377.334.063 1.185.536 1.374.8.587.893 2.407 2.839 3.094 3.471 1.364 1.26 3.343.392 4.66-.182l.32-.139c.896-.375 1.447-1.202 1.892-1.867.103-.156.195-.309.289-.428.776-.25 2.216-.607 2.752-.686.499.223 1.287 1.25 1.638 1.71.585.764 1.009 1.317 1.736 1.468.977.203 2.116-.108 3.437-.465.735-.203 2.07-.562 2.585-.489.16.136.355.346.562.553.771.78 1.237 1.229 1.854 1.384.997.25 2.17-.05 3.293-.385l.125-.081c.016.006.423.19 1.127 1.603.195.397.306 1.373-.283 3.769-.218.894-.682 1.298-1.55 1.997-.425.34-.908.728-1.349 1.227-.845.955-1.35 2.588-1.526 3.695-.177 1.104.239 1.951.515 2.513.168.344.263.548.256.715-.016.31-.016.31-.571.789-.188.162-.394.343-.62.555-.589.56-.83 1.258-1.066 1.932-.163.472-.32.92-.6 1.363-.168.107-.547.274-.788.377-.963.424-2.754 1.215-2.283 2.974.006.023.636 2.276 1.437 3.057.32.31.735.496 1.218.71.07.03.14.06.206.09a6.79 6.79 0 01-.732.183c-.879-.654-2.72-2.445-2.941-3.27-.283-1.054-.49-1.735-.655-2.278a26.239 26.239 0 01-.258-.885c-.234-.872-.887-1.517-1.516-2.139-.265-.261-.542-.527-.74-.787-.21-.332-.593-1.694-.823-2.509-.412-1.463-.644-2.25-1-2.755-.643-.916-2.216-1.505-3.462-1.843-1.705-.717-3.53-1.849-3.768-2.3l-1.295-4.831c-.304-1.136-1.479-1.686-2.721-2.27a16.073 16.073 0 01-.926-.456c-.097-.24-.232-.684-.325-.997-.19-.633-.39-1.287-.658-1.79-.595-1.114-3.064-3.046-4.524-2.655-.326.087-.505.116-.6.12-.104-.097-.231-.229-.386-.384-.867-.87-2.307-2.288-4.215-3.219.14-1.36.357-2.704.655-4.026.286-1.272.65-2.494 1.076-3.674 1.87-4.302 4.564-8.197 7.952-11.417m39.668-4.98c-.724.39-1.497.772-2.192 1.09a2.107 2.107 0 01-.47.157c-.012-.018-.024-.035-.033-.052-.24-.343-.965-1.391-2.28-1.098l-.395.078c-.868.163-2.474.464-2.6 2.151-.054.723.172 1.323.353 1.804.004.017.01.032.017.048-.108.045-.21.09-.293.13-.175.08-.587.182-.903.221a4.618 4.618 0 01-.205-.89c-.017-.289.203-1.221.335-1.778.345-1.465.545-2.404.31-3.22-.112-.387-.332-.735-.665-1.258-.16-.251-.35-.556-.542-.89 3.46.644 6.658 1.866 9.563 3.506M29.814 4.02l.1-.02c.38-.087.756-.156 1.133-.228l-.004.031c-.46.042-1.015.146-1.418.66-.428.543-.493 1.175-.466 1.693-.092.023-.21.046-.351.073-.045.007-.08.012-.105.014a51.764 51.764 0 01-.345-1.943 36.1 36.1 0 011.456-.28M18.6 24.645c.387-.202 1.12-.19 1.537-.136 1.074.832 1.435.91 1.638.954.407.088.78.019 1.592-.147.26-.053.534-.117.738-.144.604.235.738.416.745.415.02.086-.018.279-.079.463-.183.061-.475.15-.933.272-.405.109-.82.212-1.162.297l-.486.132c-.524.026-2.473-.523-3.078-.854-.222-.327-.477-.931-.512-1.252m34.84-11.938c-1.915.513-9.408 3.512-8.263 7.783.296 1.107.57 2.09.902 2.932.643 1.619 2.44 2.372 3.755 2.92.323.135.765.322.796.32.164.204.522 1 .758 1.526.62 1.378 1.039 2.251 1.648 2.752 1.443 1.182 4.373.287 5.096-.621.202-.255.336-.554.506-.933.086-.19.233-.521.336-.687.424-.217 1.462-.614 1.727-.659.114-.009.185-.011.213-.02.036.057.092.162.157.34.259.687.326 1.023.342 1.166l-.118.118c-.132.134-.272.28-.413.45-1.324 1.591.595 4.656.617 4.683.534.67 1.398.873 2.493 1.13.28.064.692.162.975.249.179.653.404 1.758.46 2.384l-.225.116c-.739.4-1.753.948-2.225 2.012-.387.868-.75 2.6-.66 3.614.052.618.331 1.187.578 1.69.045.09.1.205.148.312a9.889 9.889 0 01-.323.346c-.395.408-.733.76-.838 1.314-.205 1.075.904 3.157.914 3.174.455.755 2.927 2.036 5.74 2.067C64.42 62.288 56.558 69.488 46.36 72.22c-7.26 1.945-14.626 1.331-21.199-1.28a31.731 31.731 0 01-6.048-3.76C9.404 59.554 3.527 46.51 3.661 34.13c.976.67 1.778 1.468 2.312 2.003.42.423.698.703 1.007.887.91.55 1.91.405 2.549.253.43.195 1.222.755 1.398 1.037.12.226.286.77.417 1.208.326 1.076.583 1.927 1.215 2.44.436.353 1.045.639 1.689.941.333.157.848.398 1.123.568l1.204 4.492c.565 2.11 4.147 3.793 5.66 4.418l.188.064c.71.188 1.533.505 1.846.706.14.348.372 1.172.532 1.739.494 1.755.83 2.868 1.322 3.527.322.43.713.814 1.056 1.155.249.247.627.62.683.704.084.312.175.618.288.986.156.517.354 1.166.623 2.172.597 2.226 4.167 5.248 5.035 5.518.502.155 1.301.053 2.06-.15.753-.202 1.465-.504 1.81-.753 1.396-1.005.677-2.93.371-3.748-.272-.821-.996-1.143-1.763-1.484-.106-.047-.212-.091-.304-.134a8.183 8.183 0 01-.338-.773l.338-.151c.789-.347 1.533-.675 1.977-1.33.544-.802.807-1.56 1.02-2.169.092-.271.223-.642.291-.725.186-.177.358-.327.514-.462.717-.62 1.532-1.324 1.614-2.951.051-.997-.31-1.737-.575-2.277-.169-.342-.246-.514-.23-.613.127-.803.5-1.801.798-2.138.272-.308.617-.584.98-.876.941-.756 2.113-1.697 2.591-3.638.69-2.817.703-4.588.037-5.927-1.281-2.582-2.78-3.663-4.451-3.215l-.342.098c-.764.225-1.297.346-1.589.358-.17-.153-.419-.405-.586-.572-.658-.667-1.055-1.053-1.551-1.241-1.302-.492-2.933-.05-4.491.375-.539.144-1.303.353-1.762.412-.074-.094-.153-.2-.24-.313-.785-1.028-1.974-2.58-3.581-2.893-1.002-.196-4.352.899-4.385.91-.719.263-1.139.893-1.546 1.503-.173.26-.463.693-.567.772l-.366.158c-.345.15-1.2.523-1.623.575-.728-.71-2.093-2.221-2.418-2.717-.768-1.171-2.58-2.047-3.54-2.162-.139-.015-.3-.117-.326-.086-.15-.564-.318-1.222-.43-1.663.3-.665.688-1.303.84-1.421.15-.05.369.05.611.137.409.145.97.345 1.6.176.078-.02.198-.043.341-.073.449-.092.863-.195 1.258-.31.282.599.6 1.071.778 1.282.89 1.066 4.827 2.115 6.04 1.79l.58-.146c.365-.091.812-.203 1.247-.32 1.603-.429 2.197-.67 2.565-1.25.01-.02 1.244-2.006.386-3.793-.659-1.366-2.145-1.904-2.611-2.07-.6-.277-1.225-.148-2.259.064-.155.031-.308.065-.44.091a15.71 15.71 0 01-.746-.558l-.268-.216-.332-.079a7.583 7.583 0 00-1.774-.156c-.01-.079-.02-.16-.032-.23-.023-.15-.057-.376-.085-.4.12-.056.517-.098.782-.124.944-.09 2.367-.229 3.43-1.533.55-.675.675-1.61.784-2.435.01-.075.018-.15.029-.221.51-.189 1.471-.46 2.853-.839l.28-.074c.9-.242 1.348-.756 1.565-1.147.485-.872.244-1.76.082-2.361-.145-.541-.514-1.008-1.038-1.314-1.11-.653-3.04-.629-5.38.033-1.35.397-3.529.758-4.006.651-.366-.165-1.184-.961-2.424-2.357 2.639-1.8 5.67-3.225 9.062-4.25.165 1.098.355 2.158.512 2.493.628 1.339 1.912 1.962 3.439 1.667.216-.042.472-.091.738-.162.79-.212 1.678-.617 2.006-1.602.09-.269.114-.525.11-.75.402-.048.846-.14 1.24-.425.538-.379.675-.72 1.06-3.12a34.783 34.783 0 016.173-.173c.456 1.222 1.118 2.265 1.588 2.987.103.159.194.296.263.409-.036.367-.23 1.138-.35 1.62-.293 1.17-.545 2.177-.426 3 .074.515.229 1.586.9 2.624.818 1.264 2.536 1.055 3.605.769.54-.145.916-.31.927-.315.058-.028.126-.053.199-.082.52-.206 2.107-.834 1.946-2.584-.045-.495-.19-.921-.324-1.272.023-.007.044-.01.065-.014.36.46 1.028 1.127 2.21 1.129.448.002 1.28-.206 1.848-.468.821-.373 2.582-1.206 4-2.096a35.287 35.287 0 013.68 2.902c-2.776.17-6.099.463-6.891.675M65.59 44.253c-.098-.2-.246-.503-.265-.564-.035-.398.208-1.611.401-2.045.11-.169.648-.457.936-.61.59-.318 1.197-.645 1.542-1.26.829-1.475-.526-5.46-.54-5.497-.452-1.117-1.693-1.403-3.007-1.705-.262-.06-.619-.145-.862-.214a6.219 6.219 0 01-.296-.864c1.156-1.19 1.258-2.294.425-4.511-.846-2.247-2.378-2.394-3.456-2.31-.81.064-2.626.815-3.176 1.156-.694.429-1.06 1.233-1.382 1.941l-.065.147c-.292.106-.734.21-1.012.22-.21-.352-.52-1.044-.72-1.487-.546-1.21-.908-1.977-1.417-2.458-.431-.412-1.025-.657-1.778-.967-.524-.217-1.921-.792-2.076-1.182-.272-.68-.516-1.566-.786-2.571-.218-.816 3.275-3.236 6.21-4.023.757-.193 6.583-.669 9.033-.725a35.82 35.82 0 017.252 13.897 35.725 35.725 0 01-.724 20.964c-1.994.455-3.92-.316-4.599-.689a11.027 11.027 0 01-.228-.591c.422-.437.896-.966 1.084-1.605.265-.904-.155-1.76-.493-2.446m7.23-19.052c-5.76-15.125-21.93-29.057-43.83-23.942C14.405 3.929 4.736 12.687 1.755 25.926.118 33.198.75 41.131 3.204 48.506a37.913 37.913 0 002.188 5.442c2.838 5.954 6.91 11.286 11.948 15.247 8.564 6.73 18.58 8.733 28.943 5.956 3.337-.894 6.71-2.284 10.082-4.171 19.3-10.798 22.174-30.772 16.456-45.78M37.184 13.305c-.035.131-.135.349-.861.52-.462-.025-1.484-.205-2.084-.365.03-.045.064-.091.098-.136l.047-.007a69.78 69.78 0 012.68-.413c.074.144.132.319.12.4m1.042-3.967c-.528-.24-1.173-.264-4.158.057-.254.027-.443.048-.51.052l-.308.047c-1.002.268-1.53 1.68-1.71 2.275-.409 1.354-.104 2.207.22 2.681.796 1.165 4.178 2.48 5.125 2.323a3.47 3.47 0 00.499-.108c1.613-.433 2.616-1.625 2.754-3.273.104-1.235-.652-3.48-1.912-4.053","fill":"currentColor","fill-rule":"evenodd"}})])
}
var earth_svgvue_type_template_id_e1088ca6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/earth-svg.vue?vue&type=template&id=e1088ca6

// CONCATENATED MODULE: ./src/components/svg/decorations/earth-svg.vue

var earth_svg_script = {}


/* normalize component */

var earth_svg_component = normalizeComponent(
  earth_svg_script,
  earth_svgvue_type_template_id_e1088ca6_render,
  earth_svgvue_type_template_id_e1088ca6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var earth_svg = (earth_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/envelope-svg.vue?vue&type=template&id=48c8926e
var envelope_svgvue_type_template_id_48c8926e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"298","height":"264","viewBox":"0 0 298 264","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M290.869 146.465C295.395 117.529 299.793 87.6876 295.739 58.4163C295.455 55.1279 292.836 52.0165 289.434 51.711C279.279 50.5092 269.504 48.7855 259.779 46.7764C192.423 20.4742 120.644 7.81773 48.8481 0.162856C46.2841 0.0051535 44.027 1.37354 42.8367 3.22444C42.0772 3.24507 41.3316 3.18701 40.5449 3.12576L40.5449 3.12576L40.5449 3.12576L40.5449 3.12576C39.8329 3.07032 39.0873 3.01227 38.2673 3.00753C37.3791 3.14531 36.7702 3.33234 36.1109 3.80488C34.5634 4.41521 33.1945 5.64582 32.7917 7.92998C29.169 28.4756 24.5167 48.8994 19.8617 69.3349C9.89693 113.081 -0.080092 156.881 0.00402955 202.044C0.00882311 205.283 2.32108 206.869 4.60577 206.977C5.29261 207.981 6.25875 209.035 7.93451 209.33C21.3982 212.271 34.8956 215.115 48.3974 217.96C91.0683 226.951 133.784 235.951 175.625 248.025C179.694 249.174 184.395 250.73 189.503 252.421L189.504 252.421C212.295 259.966 243.188 270.192 262.123 258.861C265.983 259.836 270.626 258.005 271.482 253.151C272.448 248.133 273.421 243.115 274.394 238.096L274.394 238.095L274.394 238.094L274.394 238.093C280.264 207.803 286.146 177.453 290.869 146.465ZM51.697 16.8199C61.424 20.2714 72.2029 21.0145 82.7033 21.7084C106.26 23.2576 130.453 26.0766 153.843 30.2008C175.408 33.8457 196.114 40.4304 216.849 47.0244C234.178 52.5353 251.528 58.0527 269.416 61.8656C270.927 62.5428 272.479 63.1908 274.041 63.8428L274.041 63.843C276.88 65.0284 279.752 66.2272 282.466 67.6393C283.531 68.1163 284.644 68.3127 285.529 68.1793C285.789 69.9615 285.82 71.4139 285.802 73.1469C260.2 123.905 199.5 139.247 145.965 149.775C145.835 148.884 145.099 148.175 144.035 147.698C143.575 147.617 143.13 147.451 142.73 147.302C142.403 147.18 142.107 147.069 141.856 147.025C141.742 146.86 141.558 146.683 141.374 146.506C141.19 146.328 141.006 146.151 140.891 145.986C119.927 128.11 103.553 106.992 88.3122 84.3365C85.5894 80.2391 82.9363 76.1539 80.2831 72.0687C77.63 67.9836 74.9769 63.8985 72.2542 59.8011C66.0908 49.1647 59.9275 38.5282 54.0426 27.9408C52.4894 25.3518 50.9177 24.4959 49.247 24.2014C49.1355 21.5772 49.5809 19.0513 51.697 16.8199ZM43.229 46.9125C40.7488 43.2109 38.494 39.8459 36.8425 36.2904C34.2575 49.278 31.41 62.2392 28.5604 75.2096C20.4023 112.343 12.2276 149.552 10.1496 187.673C22.9644 174.428 36.811 162.329 50.6403 150.246L50.6405 150.246L50.6409 150.245C55.6041 145.909 60.5652 141.574 65.4755 137.189C65.9913 136.686 66.4945 136.256 66.9976 135.825C67.5007 135.394 68.0039 134.964 68.5197 134.461C70.6037 132.488 72.7232 130.521 74.8551 128.542L74.8552 128.542L74.8554 128.542C78.6692 125.002 82.5226 121.426 86.2833 117.711C86.3823 117.639 86.4859 117.54 86.599 117.432L86.5991 117.432C86.8597 117.184 87.1706 116.888 87.5912 116.755C70.624 95.0681 56.5995 71.2294 43.229 46.9125ZM217.449 245.179C210.134 243.445 202.965 241.294 195.795 239.143L195.795 239.142C188.626 236.991 181.457 234.84 174.142 233.106C125.156 220.624 76.0949 210.199 26.1986 202.879C37.1969 192.693 47.9164 182.457 58.6358 172.221C62.6291 168.739 66.6352 165.301 70.6331 161.87C81.6043 152.455 92.5144 143.092 102.934 133.007C111.279 142.76 120.562 152.086 130.555 160.651C133.04 162.863 135.93 162.781 138.135 161.691C138.871 162.413 139.987 162.609 141.153 162.519C162.245 160.323 184.705 156.89 206.226 150.629L206.505 150.678C207.52 151.448 208.484 152.506 209.118 153.801C209.217 154.308 209.317 154.817 209.416 155.327L209.549 156.007C215.784 187.911 222.698 223.288 240.724 250.17C232.741 249.32 224.735 247.152 218.554 245.478C218.179 245.376 217.81 245.276 217.449 245.179ZM253.733 242.153C255.583 241.591 257.483 240.742 259.201 239.268C261.72 224.987 264.441 210.858 267.165 196.717C270.575 179.012 273.989 161.288 277.012 143.221L277.046 143.008C279.537 127.233 282.073 111.175 283.437 95.2035C266.937 115.981 243.193 129.855 217.379 138.923C221.854 145.415 223.291 153.447 224.735 161.517C225.54 166.016 226.348 170.527 227.684 174.79C232.354 189.651 238.214 203.871 244.076 218.097C247.364 226.075 250.653 234.056 253.733 242.153Z","fill":"#79E8F1","fill-opacity":"0.2"}})])
}
var envelope_svgvue_type_template_id_48c8926e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/envelope-svg.vue?vue&type=template&id=48c8926e

// CONCATENATED MODULE: ./src/components/svg/decorations/envelope-svg.vue

var envelope_svg_script = {}


/* normalize component */

var envelope_svg_component = normalizeComponent(
  envelope_svg_script,
  envelope_svgvue_type_template_id_48c8926e_render,
  envelope_svgvue_type_template_id_48c8926e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var envelope_svg = (envelope_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/plane-svg.vue?vue&type=template&id=64889e96
var plane_svgvue_type_template_id_64889e96_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"52"}},[_c('path',{attrs:{"d":"M66.584 11.478c-.488-1.195-1.177-2.57-2.33-2.94-1.8-.581-4.172.821-5.689 1.42-2.746 1.082-3.593 1.372-6.281 2.47-.612.251-2.44 1.02-2.44 1.02s-22.07 10.58-29.896 12.781c-.593.166-2.304.652-2.304.652l-6.51-3.103-.096-.036c-.062.028-.139.067-.193.094-1.736.872-4.35 2.177-6.296 2.987.231.12 1.56.88 1.772.994.461.248 1.268.445 1.744.656 1.84.815 2.392 1.375 4.016 2.577 2.127 1.576 4.232 3.444 6.413 3.897 2.612.542 4.682-.628 7.39-1.96.169-.083 1.162-.562 1.162-.562 3.97-1.943 3.483-1.774 7.632-3.298 1.503-.552 1.935-.815 2.6-1.086.426-.174 1.307-.46 1.787-.595.204-.057.832-.69 1.5-.207.464.337.981 1.443 1.018 2.065 0 0-.776 15.482.394 18.825.346.99 4.326-.45 4.54-1.479 1.123-5.41.175-12.657 1.124-19.819l.84-2.562.92-.686.204-.079c4.682-1.823 7.15-2.275 11.598-4.697 1.23-.669 3.777-3.002 4.666-4.133.807-1.026 1.088-2.28.715-3.196M33.61 17.675l9.106-3.668C38.542 11.195 32.37 5.975 28.894 2.634c-.064-.061.012-.253-.073-.322-.02.005-.236.09-.263.097-.685.163-3.252 1.297-2.937 1.935.408.831 2.714 4.958 4.288 7.034 1.234 1.628 2.713 4.242 3.701 6.297m36.063-7.53c.783 1.923-.103 4.303-1.586 6.188-1.24 1.578-2.229 3.228-3.719 4.04-4.525 2.463-8.349 3.95-13.017 5.768-.935 7.166-1.487 12.9-1.888 20.108 0 0-.35 1.87-.577 2.286-.178.326-1.128 1.088-1.128 1.088-1.095.567-1.937 1.02-3.079 1.497-.395.164-.792.324-1.19.477-.34.131-1.243.179-2.093-.18-.874-.368-2.202-1.532-2.275-2.774l-.79-16.928a88.908 88.908 0 00-9.952 4.183c-.17.082-.337.165-.502.247-2.874 1.415-6.436 2.403-10.055 1.652-2.825-.587-5.197-2.343-7.49-4.042-1.562-1.156-3.036-2.248-4.574-2.93a21.055 21.055 0 01-1.578-.793c-.708-.38-.53-.393-1.408-.702l-.856-.35C.409 28.438.083 27.589.076 26.972c-.004-.285-.432-1.526.784-1.995 2.829-1.094 6.214-2.773 8.582-3.963.36-.18.904-.454 1.596-.434.472.013.856.161 1.11.26l5.454 2.547.603-.254 12.61-5.039a30.754 30.754 0 00-3.052-5.007c-1.994-2.63-3.592-5.512-5.137-8.301 0 0-.381-1.697-.305-2.025.075-.328 1.103-.772 1.103-.772a12.167 12.167 0 014.17-1.872c.344-.083.723-.151 1.162-.098.938.113 2.412 1.064 2.787 1.423 3.434 3.3 9.724 7.492 14.448 10.554l3.236-1.285c2.7-1.081 5.49-2.199 8.243-3.284 1.688-.666 3.79-1.495 6.014-1.455 1.201.02 2.42.342 3.43.905 1.18.655 2.295 2.13 2.759 3.268","fill":"currentColor","fill-rule":"evenodd"}})])
}
var plane_svgvue_type_template_id_64889e96_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/plane-svg.vue?vue&type=template&id=64889e96

// CONCATENATED MODULE: ./src/components/svg/decorations/plane-svg.vue

var plane_svg_script = {}


/* normalize component */

var plane_svg_component = normalizeComponent(
  plane_svg_script,
  plane_svgvue_type_template_id_64889e96_render,
  plane_svgvue_type_template_id_64889e96_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var plane_svg = (plane_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/support-box-svg.vue?vue&type=template&id=36e96b6b
var support_box_svgvue_type_template_id_36e96b6b_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"96","height":"85"}},[_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"fill":"#FFEC1A","d":"M51.96 53.172c4.579.558 18.309 1.8 24.158-2.433.158-.114.534-.12.819-.013.81.302 1.903.776 3.06 1.283 3.549 1.547 10.53 2.633 12.126 2.633.532 0 2.91-.224 3.158-.51.644-.743-3.53-4.336-6.072-7.926-1.82-2.574-3.097-5.378-3.054-5.461 6.23-11.612 1.953-21.016.782-23.85C82.426 5.982 71.022.787 59.369.646 43.103.449 30.743 11.106 28.747 22.927c-1.197 7.083.35 13.601 3.86 18.782 0 0 2.683-.176 5.64.905 2.957 1.084 6.029 2.524 8.083 4.212 2.052 1.689 4.463 4.041 4.897 5.122l.733 1.223z"}}),_c('path',{attrs:{"fill":"#B1F2EC","d":"M17.537 79.389c-.472-.342-.895-.89-1.423-1.082-.195-.07-4.296 2.502-5.83 2.967-2.66.804-5.468 1.396-5.815 1.04-.346-.356 7.441-8.19 6.269-9.523-4.397-4.998-3.779-12.38-1.182-18.19 2.591-5.783 7.799-9.866 14.29-11.198 5.607-1.146 17.47.399 22.01 4.243 4.609 3.898 7.127 9.49 6.914 15.339-.256 6.988-3.951 13.159-9.889 16.503-5.954 3.355-19.968 3.813-25.345-.099m37.483-20.59c-1.637-9.63-11.785-18.315-25.137-18.155-9.569.114-18.927 4.348-22.631 13.24-.96 2.31-4.471 9.973.642 19.435.037.068-1.013 2.354-2.507 4.45-2.09 2.929-5.513 5.854-4.984 6.461.201.23 2.156.412 2.592.412 1.311 0 7.042-.883 9.95-2.143.952-.414 1.85-.8 2.515-1.048.236-.087.543-.083.673.011 5.79 4.162 20.99 1.832 21.077 1.815 11.96-2.203 19.877-12.318 17.81-24.478"}}),_c('path',{attrs:{"fill":"#B1F2EC","d":"M31.561 70.336l.373 2.195c.078.462-.27.8-1.18.959l-.556.097c-.913.16-1.35-.037-1.428-.501l-.373-2.193c-.078-.467.267-.801 1.18-.961l.556-.1c.913-.162 1.35.037 1.428.504m3.715-16.133c.76 4.488-4.84 7.702-4.677 11.643.008.445-.18.717-.964.854l-.488.086c-.684.121-1.03-.125-1.108-.592-.254-1.495.424-3.636 1.907-5.78 1.378-1.989 2.57-3.67 2.289-5.333-.394-2.327-1.99-3.209-4.696-2.731-2.056.36-3.363 1.754-3.853 1.84-.326.059-1.252-1.045-1.33-1.512-.191-1.13 2.907-2.463 5.289-2.882 4.338-.765 7.124 1.415 7.63 4.407"}}),_c('path',{attrs:{"fill":"#FFF","d":"M58.627 19.474c1.423-.599 2.232 2.32 2.364 3.163.263 1.696.516 4.49.716 6.193.414 3.586.351 7.13.828 10.708-1.058.09-2.11.215-3.168.276-.549.032-1.095.052-1.644.041-.876-.017-.826.173-.934-.716-.237-1.942.585-4.37.915-6.285.724-4.185.735-9.913.924-13.38m4.963-1.791c-2.233 1.056 1.802 1.557 2.405 1.787 3.398 1.296 4.911 7.49 4.012 7.747-.983.281-2.845-2.53-3.75-3.38-.876-.825-1.453-1.167-2.179-2.165-.553-.758-1.076-1.216-1.793-1.79-.944-.753-1.763-1.835-3.101-1.774-1.31.056-1.91 1.6-2.626 2.55-.703.936-1.555 1.598-2.403 2.333-.943.82-1.674 2.023-2.44 3-.567.727-1.628 2.333-2.54 2.319-.586-.01-.731-3.366.851-5.842.45-.7 1.785-1.864 2.475-2.335.642-.442 1.394-.07 1.932-.557.507-.456.642-.553.128-.952-.75-.581-1.512-.024-2.422-.06-.933-.04-2.037-.022-2.939.151-.939.178-4 1.15-4.124.212-.102-.784 4.677-4.709 7.208-3.655.876.366 1.66.785 2.543 1.112.664.245 1.566.863 1.922-.217.522-1.587-2.483-1.8-3.348-2.632-.62-.596-1.126-.835-1.846-1.277-.661-.408-2.465-2.335-2.034-2.942.62-.872 5.36.705 6.796 1.927.776.664 1.234 1.687 1.642 2.613.318.72.047 1.659 1.021 1.722 1.115.073.97-1.147 1.21-1.876.293-.889 1.18-2.665 1.906-3.23 1.524-1.193 5.864-2.832 6.221-2.023.304.687-1.218 1.754-1.613 2.326-.48.69-1.58 1.474-2.249 1.958-.683.492-2.235 1.5-2.136 2.404.174 1.616 3.058-.31 4.047-.68 2.82-1.058 7.34 1.266 7.412 2.647.019.377-1.954 1.188-3.446.475-.857-.408-1.824-.304-2.756-.085-1.332.313-2.956-.297-3.986.189m11.756-.181c-.245-4.506-5.776-4.699-9.747-4.063.596-.464 1.776-.772 2.264-1.362.614-.74.796-1.368 1.598-1.98 1.444-1.1 1.657-3.12-.765-3.408-3.368-.397-7.87 1.702-9.49 4.668-1.771-3.18-5.978-4.516-9.55-3.783-.646.134-2.081.826-2.187 1.624-.128.969.453 1.151.997 1.637.683.605.796 1.565 1.56 2.114.654.47 1.79.498 2.404 1.093-3.515-.12-7.062.537-8.702 3.79-.264.524-.627 2.085-.145 2.632.583.659 1.542.412 2.162.193.83-.293 1.338-.11 2.181-.048.89.065 1.692-.707 2.58-.676-1.502 1.465-3.237 3.523-3.462 5.598-.107.965-.319 6.212 1.656 5.49.65-.239 1.863-1.186 2.34-1.69.662-.695 1.405-1.118 1.973-1.936.488-.7 1.089-1.216 1.618-1.875.744-.924 1.392-2.194 2.255-2.988-.258 4.421-.82 8.732-1.53 13.098a38.133 38.133 0 00-.402 3.068c-.06.725-.726 2.418.059 2.637 1.377.381 4.551.34 5.87.228 1.4-.12 4.057.223 4.037-1.603-.02-1.942-.542-4.004-.798-5.934-.53-3.987-1.255-8.016-1.992-11.973.609.462.86 1.169 1.379 1.7.672.69 1.557 1.568 2.25 2.26.738.732 1.586 1.246 2.353 1.925.618.544 1.12 1.383 2.169 1.086 1.648-.464 1.333-4.41 1.025-5.61-.537-2.074-2.155-3.49-3.96-4.624.73-.226 1.178.113 1.91.254 1.1.212 1.524.23 2.649.086.692-.086 3.493-.657 3.441-1.628"}}),_c('path',{attrs:{"fill":"#FFF","d":"M64.504 39.166a5.105 5.105 0 012.142.758c1.73 1.067 3.67 2.127 2.794 3.01-5.687 5.734-19.624 1.328-18.287-.24 1.912-2.246 3.184-3.107 4.54-3.409l.352-1.524c-1.973.323-3.306 1.203-6.442 4.043 0 0-.93 1.553.753 2.817 4.417 3.317 12.757 4.633 19.945.121 1.545-.97.98-2.714.774-3.045-1.135-1.813-1.708-1.815-4.331-3.16-.91-.465-1.725-.74-2.528-.895l.288 1.524z"}})])])
}
var support_box_svgvue_type_template_id_36e96b6b_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/support-box-svg.vue?vue&type=template&id=36e96b6b

// CONCATENATED MODULE: ./src/components/svg/decorations/support-box-svg.vue

var support_box_svg_script = {}


/* normalize component */

var support_box_svg_component = normalizeComponent(
  support_box_svg_script,
  support_box_svgvue_type_template_id_36e96b6b_render,
  support_box_svgvue_type_template_id_36e96b6b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var support_box_svg = (support_box_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/decorations/trust-pilot-placeholder-svg.vue?vue&type=template&id=4fcc54ab
var trust_pilot_placeholder_svgvue_type_template_id_4fcc54ab_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"244","height":"135","viewBox":"0 0 244 135","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_1942_50802)"}},[_c('path',{attrs:{"d":"M46.1638 22.9871H59.3268V25.3717H54.1511V38.7768H51.3051V25.3717H46.1523V22.9871H46.1638ZM58.7645 27.344H61.1974V29.5503H61.2433C61.3236 29.2383 61.4728 28.9375 61.6908 28.6477C61.9089 28.358 62.1728 28.0794 62.4827 27.8454C62.7925 27.6003 63.1368 27.4109 63.5155 27.2549C63.8942 27.11 64.2844 27.032 64.6746 27.032C64.973 27.032 65.191 27.0431 65.3058 27.0543C65.4205 27.0654 65.5353 27.0877 65.6615 27.0989V29.528C65.4779 29.4946 65.2943 29.4723 65.0992 29.45C64.9041 29.4278 64.7205 29.4166 64.5369 29.4166C64.1008 29.4166 63.6877 29.5058 63.2975 29.6729C62.9073 29.84 62.5745 30.0963 62.2876 30.4195C62.0007 30.7538 61.7712 31.1549 61.599 31.6452C61.4269 32.1355 61.3465 32.6927 61.3465 33.3278V38.7656H58.753V27.344H58.7645ZM77.5851 38.7768H75.0374V37.1833H74.9915C74.6702 37.7628 74.1997 38.2196 73.5685 38.5651C72.9373 38.9105 72.2946 39.0888 71.6405 39.0888C70.0913 39.0888 68.9666 38.7211 68.278 37.9745C67.5895 37.2279 67.2452 36.1024 67.2452 34.5981V27.344H69.8388V34.353C69.8388 35.3559 70.0339 36.069 70.4355 36.4813C70.8257 36.8936 71.388 37.1053 72.0996 37.1053C72.6504 37.1053 73.098 37.0273 73.4652 36.8602C73.8324 36.693 74.1308 36.4813 74.3488 36.2027C74.5784 35.9353 74.739 35.601 74.8423 35.2221C74.9456 34.8433 74.9915 34.431 74.9915 33.9853V27.3551H77.5851V38.7768ZM82.0033 35.1107C82.0837 35.8462 82.3706 36.3587 82.864 36.6596C83.369 36.9493 83.9657 37.1053 84.6658 37.1053C84.9068 37.1053 85.1822 37.083 85.492 37.0496C85.8019 37.0162 86.1003 36.9382 86.3642 36.8379C86.6396 36.7376 86.8577 36.5816 87.0413 36.381C87.2134 36.1804 87.2938 35.9242 87.2823 35.601C87.2708 35.2779 87.1446 35.0104 86.915 34.8099C86.6855 34.5981 86.3986 34.4421 86.0429 34.3084C85.6871 34.1858 85.2855 34.0744 84.8264 33.9853C84.3674 33.8961 83.9083 33.7958 83.4378 33.6955C82.9558 33.5953 82.4853 33.4615 82.0378 33.3167C81.5902 33.1718 81.1885 32.9712 80.8328 32.715C80.477 32.4698 80.1901 32.1467 79.9836 31.7567C79.7655 31.3666 79.6622 30.8875 79.6622 30.3081C79.6622 29.684 79.8229 29.1715 80.1327 28.748C80.4426 28.3246 80.8443 27.9903 81.3148 27.734C81.7968 27.4777 82.3247 27.2994 82.9099 27.188C83.4952 27.0877 84.0575 27.032 84.5854 27.032C85.1937 27.032 85.7789 27.0989 86.3298 27.2214C86.8806 27.344 87.3856 27.5446 87.8331 27.8343C88.2807 28.1129 88.6479 28.4806 88.9463 28.9263C89.2447 29.372 89.4283 29.918 89.5086 30.5532H86.8003C86.6741 29.9515 86.3986 29.5392 85.9511 29.3386C85.5035 29.1269 84.9871 29.0266 84.4133 29.0266C84.2297 29.0266 84.0116 29.0377 83.7592 29.0712C83.5067 29.1046 83.2772 29.1603 83.0476 29.2383C82.8296 29.3163 82.646 29.4389 82.4853 29.5949C82.3361 29.7509 82.2558 29.9515 82.2558 30.2078C82.2558 30.5198 82.3706 30.7649 82.5886 30.9544C82.8066 31.1438 83.0935 31.2998 83.4493 31.4335C83.8051 31.5561 84.2067 31.6675 84.6658 31.7567C85.1248 31.8458 85.5953 31.9461 86.0773 32.0464C86.5478 32.1467 87.0069 32.2804 87.4659 32.4252C87.9249 32.5701 88.3266 32.7707 88.6824 33.027C89.0381 33.2833 89.325 33.5953 89.5431 33.9741C89.7611 34.353 89.8759 34.8321 89.8759 35.3893C89.8759 36.069 89.7152 36.6373 89.3939 37.1165C89.0725 37.5845 88.6594 37.9745 88.1545 38.2642C87.6495 38.5539 87.0757 38.7768 86.456 38.9105C85.8363 39.0442 85.2166 39.1111 84.6084 39.1111C83.8624 39.1111 83.1739 39.0331 82.5427 38.8659C81.9115 38.6988 81.3607 38.4536 80.9016 38.1305C80.4426 37.7962 80.0754 37.3839 79.8114 36.8936C79.5475 36.4033 79.4098 35.8127 79.3868 35.133H82.0033V35.1107ZM90.5644 27.344H92.5268V23.9119H95.1204V27.344H97.4615V29.2272H95.1204V35.3336C95.1204 35.601 95.1319 35.8239 95.1548 36.0244C95.1778 36.2139 95.2351 36.381 95.3155 36.5147C95.3958 36.6485 95.522 36.7487 95.6942 36.8156C95.8663 36.8825 96.0844 36.9159 96.3827 36.9159C96.5664 36.9159 96.75 36.9159 96.9336 36.9047C97.1172 36.8936 97.3008 36.8713 97.4844 36.8267V38.7768C97.1975 38.8102 96.9106 38.8325 96.6467 38.8659C96.3713 38.8994 96.0958 38.9105 95.8089 38.9105C95.1204 38.9105 94.5695 38.8436 94.1564 38.7211C93.7433 38.5985 93.4105 38.4091 93.1809 38.1639C92.9399 37.9188 92.7908 37.6179 92.6989 37.2502C92.6186 36.8825 92.5612 36.459 92.5498 35.991V29.2495H90.5874V27.344H90.5644ZM99.2976 27.344H101.753V28.8929H101.799C102.167 28.2243 102.672 27.7563 103.326 27.4666C103.98 27.1769 104.68 27.032 105.449 27.032C106.378 27.032 107.182 27.188 107.87 27.5111C108.559 27.8231 109.133 28.2577 109.592 28.8149C110.051 29.372 110.383 30.0183 110.613 30.7538C110.842 31.4892 110.957 32.2804 110.957 33.1161C110.957 33.885 110.854 34.6316 110.647 35.3447C110.441 36.069 110.131 36.7042 109.718 37.2613C109.305 37.8185 108.777 38.2531 108.134 38.5873C107.491 38.9216 106.746 39.0888 105.873 39.0888C105.495 39.0888 105.116 39.0554 104.737 38.9885C104.359 38.9216 103.991 38.8102 103.647 38.6654C103.303 38.5205 102.97 38.3311 102.683 38.0971C102.385 37.8631 102.144 37.5956 101.937 37.2948H101.891V43H99.2976V27.344V27.344ZM108.364 33.0715C108.364 32.559 108.295 32.0575 108.157 31.5672C108.019 31.0769 107.813 30.6535 107.537 30.2746C107.262 29.8958 106.918 29.5949 106.516 29.372C106.103 29.1492 105.632 29.0266 105.104 29.0266C104.014 29.0266 103.188 29.3943 102.637 30.1298C102.086 30.8652 101.811 31.8458 101.811 33.0715C101.811 33.651 101.88 34.1858 102.029 34.6761C102.178 35.1664 102.385 35.5899 102.683 35.9464C102.97 36.303 103.314 36.5816 103.716 36.7822C104.118 36.9939 104.588 37.0942 105.116 37.0942C105.713 37.0942 106.206 36.9716 106.619 36.7376C107.032 36.5036 107.365 36.1916 107.629 35.8239C107.893 35.445 108.088 35.0216 108.203 34.5424C108.306 34.0633 108.364 33.573 108.364 33.0715V33.0715ZM112.943 22.9871H115.536V25.3717H112.943V22.9871ZM112.943 27.344H115.536V38.7768H112.943V27.344ZM117.854 22.9871H120.448V38.7768H117.854V22.9871ZM128.401 39.0888C127.46 39.0888 126.622 38.9328 125.888 38.6319C125.153 38.3311 124.533 37.9076 124.017 37.3839C123.512 36.849 123.122 36.2139 122.858 35.4784C122.594 34.743 122.456 33.9295 122.456 33.0492C122.456 32.1801 122.594 31.3778 122.858 30.6423C123.122 29.9069 123.512 29.2717 124.017 28.7369C124.522 28.202 125.153 27.7897 125.888 27.4889C126.622 27.188 127.46 27.032 128.401 27.032C129.342 27.032 130.18 27.188 130.914 27.4889C131.648 27.7897 132.268 28.2132 132.785 28.7369C133.29 29.2717 133.68 29.9069 133.944 30.6423C134.208 31.3778 134.345 32.1801 134.345 33.0492C134.345 33.9295 134.208 34.743 133.944 35.4784C133.68 36.2139 133.29 36.849 132.785 37.3839C132.28 37.9188 131.648 38.3311 130.914 38.6319C130.18 38.9328 129.342 39.0888 128.401 39.0888V39.0888ZM128.401 37.0942C128.975 37.0942 129.479 36.9716 129.904 36.7376C130.329 36.5036 130.673 36.1916 130.948 35.8127C131.224 35.4339 131.419 34.9993 131.557 34.5201C131.683 34.041 131.752 33.5507 131.752 33.0492C131.752 32.559 131.683 32.0798 131.557 31.5895C131.43 31.0992 131.224 30.6758 130.948 30.2969C130.673 29.918 130.329 29.6172 129.904 29.3832C129.479 29.1492 128.975 29.0266 128.401 29.0266C127.827 29.0266 127.322 29.1492 126.897 29.3832C126.473 29.6172 126.128 29.9292 125.853 30.2969C125.578 30.6758 125.383 31.0992 125.245 31.5895C125.119 32.0798 125.05 32.559 125.05 33.0492C125.05 33.5507 125.119 34.041 125.245 34.5201C125.371 34.9993 125.578 35.4339 125.853 35.8127C126.128 36.1916 126.473 36.5036 126.897 36.7376C127.322 36.9827 127.827 37.0942 128.401 37.0942V37.0942ZM135.103 27.344H137.065V23.9119H139.659V27.344H142V29.2272H139.659V35.3336C139.659 35.601 139.67 35.8239 139.693 36.0244C139.716 36.2139 139.773 36.381 139.854 36.5147C139.934 36.6485 140.06 36.7487 140.232 36.8156C140.405 36.8825 140.623 36.9159 140.921 36.9159C141.105 36.9159 141.288 36.9159 141.472 36.9047C141.656 36.8936 141.839 36.8713 142.023 36.8267V38.7768C141.736 38.8102 141.449 38.8325 141.185 38.8659C140.91 38.8994 140.634 38.9105 140.347 38.9105C139.659 38.9105 139.108 38.8436 138.695 38.7211C138.282 38.5985 137.949 38.4091 137.719 38.1639C137.478 37.9188 137.329 37.6179 137.237 37.2502C137.157 36.8825 137.1 36.459 137.088 35.991V29.2495H135.126V27.344H135.103Z","fill":"#323231"}}),_c('path',{attrs:{"d":"M43.1344 22.9871H31.2452L27.5729 12L23.8891 22.9871L12 22.9759L21.6284 29.7732L17.9446 40.7491L27.5729 33.963L37.1898 40.7491L33.5175 29.7732L43.1344 22.9871Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M43.1344 22.9871H31.2452L27.5729 12L23.8891 22.9871L12 22.9759L21.6284 29.7732L17.9446 40.7491L27.5729 33.963L37.1898 40.7491L33.5175 29.7732L43.1344 22.9871Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M43.1344 22.9871H31.2452L27.5729 12L23.8891 22.9871L12 22.9759L21.6284 29.7732L17.9446 40.7491L27.5729 33.963L37.1898 40.7491L33.5175 29.7732L43.1344 22.9871Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M34.3436 32.2581L33.5173 29.7732L27.5728 33.963L34.3436 32.2581Z","fill":"#005128"}})]),_c('rect',{attrs:{"x":"12","y":"55","width":"40","height":"40","fill":"#68C812"}}),_c('path',{attrs:{"d":"M46 71.9935H35.3078L32.0052 62L28.6922 71.9935L18 71.9833L26.659 78.1659L23.3461 88.1492L32.0052 81.9768L40.6539 88.1492L37.3513 78.1659L46 71.9935Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M46 71.9935H35.3078L32.0052 62L28.6922 71.9935L18 71.9833L26.659 78.1659L23.3461 88.1492L32.0052 81.9768L40.6539 88.1492L37.3513 78.1659L46 71.9935Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M46 71.9935H35.3078L32.0052 62L28.6922 71.9935L18 71.9833L26.659 78.1659L23.3461 88.1492L32.0052 81.9768L40.6539 88.1492L37.3513 78.1659L46 71.9935Z","fill":"white"}}),_c('path',{attrs:{"d":"M38.0946 80.426L37.3515 78.1658L32.0054 81.9767L38.0946 80.426Z","fill":"#68C812"}}),_c('rect',{attrs:{"x":"57","y":"55","width":"40","height":"40","fill":"#68C812"}}),_c('path',{attrs:{"d":"M91 71.9935H80.3078L77.0052 62L73.6922 71.9935L63 71.9833L71.659 78.1659L68.3461 88.1492L77.0052 81.9768L85.6539 88.1492L82.3513 78.1659L91 71.9935Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M91 71.9935H80.3078L77.0052 62L73.6922 71.9935L63 71.9833L71.659 78.1659L68.3461 88.1492L77.0052 81.9768L85.6539 88.1492L82.3513 78.1659L91 71.9935Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M91 71.9935H80.3078L77.0052 62L73.6922 71.9935L63 71.9833L71.659 78.1659L68.3461 88.1492L77.0052 81.9768L85.6539 88.1492L82.3513 78.1659L91 71.9935Z","fill":"white"}}),_c('path',{attrs:{"d":"M83.0946 80.426L82.3515 78.1658L77.0054 81.9767L83.0946 80.426Z","fill":"#68C812"}}),_c('rect',{attrs:{"x":"102","y":"55","width":"40","height":"40","fill":"#68C812"}}),_c('path',{attrs:{"d":"M136 71.9935H125.308L122.005 62L118.692 71.9935L108 71.9833L116.659 78.1659L113.346 88.1492L122.005 81.9768L130.654 88.1492L127.351 78.1659L136 71.9935Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M136 71.9935H125.308L122.005 62L118.692 71.9935L108 71.9833L116.659 78.1659L113.346 88.1492L122.005 81.9768L130.654 88.1492L127.351 78.1659L136 71.9935Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M136 71.9935H125.308L122.005 62L118.692 71.9935L108 71.9833L116.659 78.1659L113.346 88.1492L122.005 81.9768L130.654 88.1492L127.351 78.1659L136 71.9935Z","fill":"white"}}),_c('path',{attrs:{"d":"M128.095 80.426L127.351 78.1658L122.005 81.9767L128.095 80.426Z","fill":"#68C812"}}),_c('rect',{attrs:{"x":"147","y":"55","width":"40","height":"40","fill":"#68C812"}}),_c('path',{attrs:{"d":"M181 71.9935H170.308L167.005 62L163.692 71.9935L153 71.9833L161.659 78.1659L158.346 88.1492L167.005 81.9768L175.654 88.1492L172.351 78.1659L181 71.9935Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M181 71.9935H170.308L167.005 62L163.692 71.9935L153 71.9833L161.659 78.1659L158.346 88.1492L167.005 81.9768L175.654 88.1492L172.351 78.1659L181 71.9935Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M181 71.9935H170.308L167.005 62L163.692 71.9935L153 71.9833L161.659 78.1659L158.346 88.1492L167.005 81.9768L175.654 88.1492L172.351 78.1659L181 71.9935Z","fill":"white"}}),_c('path',{attrs:{"d":"M173.095 80.426L172.351 78.1658L167.005 81.9767L173.095 80.426Z","fill":"#68C812"}}),_c('rect',{attrs:{"x":"192","y":"55","width":"40","height":"40","fill":"#D7D7E2"}}),_c('path',{attrs:{"d":"M226 71.9935H215.308L212.005 62L208.692 71.9935L198 71.9833L206.659 78.1659L203.346 88.1492L212.005 81.9768L220.654 88.1492L217.351 78.1659L226 71.9935Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M226 71.9935H215.308L212.005 62L208.692 71.9935L198 71.9833L206.659 78.1659L203.346 88.1492L212.005 81.9768L220.654 88.1492L217.351 78.1659L226 71.9935Z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M226 71.9935H215.308L212.005 62L208.692 71.9935L198 71.9833L206.659 78.1659L203.346 88.1492L212.005 81.9768L220.654 88.1492L217.351 78.1659L226 71.9935Z","fill":"white"}}),_c('path',{attrs:{"d":"M218.095 80.426L217.351 78.1658L212.005 81.9767L218.095 80.426Z","fill":"#D7D7E2"}}),_c('path',{attrs:{"d":"M15.8145 120H14.8184V112.318H12.1055V111.434H18.5273V112.318H15.8145V120ZM22.6055 113.461C22.8906 113.461 23.1465 113.484 23.373 113.531L23.2383 114.434C22.9727 114.375 22.7383 114.346 22.5352 114.346C22.0156 114.346 21.5703 114.557 21.1992 114.979C20.832 115.4 20.6484 115.926 20.6484 116.555V120H19.6758V113.578H20.4785L20.5898 114.768H20.6367C20.875 114.35 21.1621 114.027 21.498 113.801C21.834 113.574 22.2031 113.461 22.6055 113.461ZM25.4883 113.578V117.744C25.4883 118.268 25.6074 118.658 25.8457 118.916C26.084 119.174 26.457 119.303 26.9648 119.303C27.6367 119.303 28.127 119.119 28.4355 118.752C28.748 118.385 28.9043 117.785 28.9043 116.953V113.578H29.877V120H29.0742L28.9336 119.139H28.8809C28.6816 119.455 28.4043 119.697 28.0488 119.865C27.6973 120.033 27.2949 120.117 26.8418 120.117C26.0605 120.117 25.4746 119.932 25.084 119.561C24.6973 119.189 24.5039 118.596 24.5039 117.779V113.578H25.4883ZM36.0879 118.248C36.0879 118.846 35.8652 119.307 35.4199 119.631C34.9746 119.955 34.3496 120.117 33.5449 120.117C32.6934 120.117 32.0293 119.982 31.5527 119.713V118.811C31.8613 118.967 32.1914 119.09 32.543 119.18C32.8984 119.27 33.2402 119.314 33.5684 119.314C34.0762 119.314 34.4668 119.234 34.7402 119.074C35.0137 118.91 35.1504 118.662 35.1504 118.33C35.1504 118.08 35.041 117.867 34.8223 117.691C34.6074 117.512 34.1855 117.301 33.5566 117.059C32.959 116.836 32.5332 116.643 32.2793 116.479C32.0293 116.311 31.8418 116.121 31.7168 115.91C31.5957 115.699 31.5352 115.447 31.5352 115.154C31.5352 114.631 31.748 114.219 32.1738 113.918C32.5996 113.613 33.1836 113.461 33.9258 113.461C34.6172 113.461 35.293 113.602 35.9531 113.883L35.6074 114.674C34.9629 114.408 34.3789 114.275 33.8555 114.275C33.3945 114.275 33.0469 114.348 32.8125 114.492C32.5781 114.637 32.4609 114.836 32.4609 115.09C32.4609 115.262 32.5039 115.408 32.5898 115.529C32.6797 115.65 32.8223 115.766 33.0176 115.875C33.2129 115.984 33.5879 116.143 34.1426 116.35C34.9043 116.627 35.418 116.906 35.6836 117.188C35.9531 117.469 36.0879 117.822 36.0879 118.248ZM39.75 119.314C39.9219 119.314 40.0879 119.303 40.248 119.279C40.4082 119.252 40.5352 119.225 40.6289 119.197V119.941C40.5234 119.992 40.3672 120.033 40.1602 120.064C39.957 120.1 39.7734 120.117 39.6094 120.117C38.3672 120.117 37.7461 119.463 37.7461 118.154V114.334H36.8262V113.865L37.7461 113.461L38.1562 112.09H38.7188V113.578H40.582V114.334H38.7188V118.113C38.7188 118.5 38.8105 118.797 38.9941 119.004C39.1777 119.211 39.4297 119.314 39.75 119.314ZM46.8984 117.721C46.8984 118.475 46.625 119.062 46.0781 119.484C45.5312 119.906 44.7891 120.117 43.8516 120.117C42.8359 120.117 42.0547 119.986 41.5078 119.725V118.764C41.8594 118.912 42.2422 119.029 42.6562 119.115C43.0703 119.201 43.4805 119.244 43.8867 119.244C44.5508 119.244 45.0508 119.119 45.3867 118.869C45.7227 118.615 45.8906 118.264 45.8906 117.814C45.8906 117.518 45.8301 117.275 45.709 117.088C45.5918 116.896 45.3926 116.721 45.1113 116.561C44.834 116.4 44.4102 116.219 43.8398 116.016C43.043 115.73 42.4727 115.393 42.1289 115.002C41.7891 114.611 41.6191 114.102 41.6191 113.473C41.6191 112.812 41.8672 112.287 42.3633 111.896C42.8594 111.506 43.5156 111.311 44.332 111.311C45.1836 111.311 45.9668 111.467 46.6816 111.779L46.3711 112.646C45.6641 112.35 44.9766 112.201 44.3086 112.201C43.7812 112.201 43.3691 112.314 43.0723 112.541C42.7754 112.768 42.627 113.082 42.627 113.484C42.627 113.781 42.6816 114.025 42.791 114.217C42.9004 114.404 43.084 114.578 43.3418 114.738C43.6035 114.895 44.002 115.068 44.5371 115.26C45.4355 115.58 46.0527 115.924 46.3887 116.291C46.7285 116.658 46.8984 117.135 46.8984 117.721ZM51.0703 120.117C50.1406 120.117 49.4199 119.832 48.9082 119.262C48.4004 118.688 48.1465 117.877 48.1465 116.83C48.1465 115.756 48.4043 114.926 48.9199 114.34C49.4395 113.754 50.1777 113.461 51.1348 113.461C51.4434 113.461 51.752 113.494 52.0605 113.561C52.3691 113.627 52.6113 113.705 52.7871 113.795L52.4883 114.621C52.2734 114.535 52.0391 114.465 51.7852 114.41C51.5312 114.352 51.3066 114.322 51.1113 114.322C49.8066 114.322 49.1543 115.154 49.1543 116.818C49.1543 117.607 49.3125 118.213 49.6289 118.635C49.9492 119.057 50.4219 119.268 51.0469 119.268C51.582 119.268 52.1309 119.152 52.6934 118.922V119.783C52.2637 120.006 51.7227 120.117 51.0703 120.117ZM59.7656 116.783C59.7656 117.83 59.502 118.648 58.9746 119.238C58.4473 119.824 57.7188 120.117 56.7891 120.117C56.2148 120.117 55.7051 119.982 55.2598 119.713C54.8145 119.443 54.4707 119.057 54.2285 118.553C53.9863 118.049 53.8652 117.459 53.8652 116.783C53.8652 115.736 54.127 114.922 54.6504 114.34C55.1738 113.754 55.9004 113.461 56.8301 113.461C57.7285 113.461 58.4414 113.76 58.9688 114.357C59.5 114.955 59.7656 115.764 59.7656 116.783ZM54.873 116.783C54.873 117.604 55.0371 118.229 55.3652 118.658C55.6934 119.088 56.1758 119.303 56.8125 119.303C57.4492 119.303 57.9316 119.09 58.2598 118.664C58.5918 118.234 58.7578 117.607 58.7578 116.783C58.7578 115.967 58.5918 115.348 58.2598 114.926C57.9316 114.5 57.4453 114.287 56.8008 114.287C56.1641 114.287 55.6836 114.496 55.3594 114.914C55.0352 115.332 54.873 115.955 54.873 116.783ZM64.4062 113.461C64.6914 113.461 64.9473 113.484 65.1738 113.531L65.0391 114.434C64.7734 114.375 64.5391 114.346 64.3359 114.346C63.8164 114.346 63.3711 114.557 63 114.979C62.6328 115.4 62.4492 115.926 62.4492 116.555V120H61.4766V113.578H62.2793L62.3906 114.768H62.4375C62.6758 114.35 62.9629 114.027 63.2988 113.801C63.6348 113.574 64.0039 113.461 64.4062 113.461ZM69.0879 120.117C68.1387 120.117 67.3887 119.828 66.8379 119.25C66.291 118.672 66.0176 117.869 66.0176 116.842C66.0176 115.807 66.2715 114.984 66.7793 114.375C67.291 113.766 67.9766 113.461 68.8359 113.461C69.6406 113.461 70.2773 113.727 70.7461 114.258C71.2148 114.785 71.4492 115.482 71.4492 116.35V116.965H67.0254C67.0449 117.719 67.2344 118.291 67.5938 118.682C67.957 119.072 68.4668 119.268 69.123 119.268C69.8145 119.268 70.498 119.123 71.1738 118.834V119.701C70.8301 119.85 70.5039 119.955 70.1953 120.018C69.8906 120.084 69.5215 120.117 69.0879 120.117ZM68.8242 114.275C68.3086 114.275 67.8965 114.443 67.5879 114.779C67.2832 115.115 67.1035 115.58 67.0488 116.174H70.4062C70.4062 115.561 70.2695 115.092 69.9961 114.768C69.7227 114.439 69.332 114.275 68.8242 114.275ZM81.8613 118.225H80.8301V120H79.0605V118.225H75.4043V116.965L79.1602 111.434H80.8301V116.818H81.8613V118.225ZM79.0605 116.818V115.365C79.0605 115.123 79.0703 114.771 79.0898 114.311C79.1094 113.85 79.125 113.582 79.1367 113.508H79.0898C78.9453 113.828 78.7715 114.141 78.5684 114.445L76.998 116.818H79.0605ZM82.7402 119.162C82.7402 118.834 82.8281 118.586 83.0039 118.418C83.1797 118.25 83.4355 118.166 83.7715 118.166C84.0957 118.166 84.3457 118.252 84.5215 118.424C84.7012 118.596 84.791 118.842 84.791 119.162C84.791 119.471 84.7012 119.715 84.5215 119.895C84.3418 120.07 84.0918 120.158 83.7715 120.158C83.4434 120.158 83.1895 120.072 83.0098 119.9C82.8301 119.725 82.7402 119.479 82.7402 119.162ZM91.9453 120H85.957V118.74L88.1074 116.566C88.7441 115.914 89.1602 115.463 89.3555 115.213C89.5508 114.959 89.6914 114.725 89.7773 114.51C89.8633 114.295 89.9062 114.072 89.9062 113.842C89.9062 113.498 89.8105 113.242 89.6191 113.074C89.4316 112.906 89.1797 112.822 88.8633 112.822C88.5312 112.822 88.209 112.898 87.8965 113.051C87.584 113.203 87.2578 113.42 86.918 113.701L85.9336 112.535C86.3555 112.176 86.7051 111.922 86.9824 111.773C87.2598 111.625 87.5625 111.512 87.8906 111.434C88.2188 111.352 88.5859 111.311 88.9922 111.311C89.5273 111.311 90 111.408 90.4102 111.604C90.8203 111.799 91.1387 112.072 91.3652 112.424C91.5918 112.775 91.7051 113.178 91.7051 113.631C91.7051 114.025 91.6348 114.396 91.4941 114.744C91.3574 115.088 91.1426 115.441 90.8496 115.805C90.5605 116.168 90.0488 116.686 89.3145 117.357L88.2129 118.395V118.477H91.9453V120ZM98.3438 110.883H99.1699V122.906H98.3438V110.883ZM111.645 120H105.656V118.74L107.807 116.566C108.443 115.914 108.859 115.463 109.055 115.213C109.25 114.959 109.391 114.725 109.477 114.51C109.562 114.295 109.605 114.072 109.605 113.842C109.605 113.498 109.51 113.242 109.318 113.074C109.131 112.906 108.879 112.822 108.562 112.822C108.23 112.822 107.908 112.898 107.596 113.051C107.283 113.203 106.957 113.42 106.617 113.701L105.633 112.535C106.055 112.176 106.404 111.922 106.682 111.773C106.959 111.625 107.262 111.512 107.59 111.434C107.918 111.352 108.285 111.311 108.691 111.311C109.227 111.311 109.699 111.408 110.109 111.604C110.52 111.799 110.838 112.072 111.064 112.424C111.291 112.775 111.404 113.178 111.404 113.631C111.404 114.025 111.334 114.396 111.193 114.744C111.057 115.088 110.842 115.441 110.549 115.805C110.26 116.168 109.748 116.686 109.014 117.357L107.912 118.395V118.477H111.645V120ZM112.717 119.162C112.717 118.834 112.805 118.586 112.98 118.418C113.156 118.25 113.412 118.166 113.748 118.166C114.072 118.166 114.322 118.252 114.498 118.424C114.678 118.596 114.768 118.842 114.768 119.162C114.768 119.471 114.678 119.715 114.498 119.895C114.318 120.07 114.068 120.158 113.748 120.158C113.42 120.158 113.166 120.072 112.986 119.9C112.807 119.725 112.717 119.479 112.717 119.162ZM120.41 120H118.6V115.043L118.617 114.229L118.646 113.338C118.346 113.639 118.137 113.836 118.02 113.93L117.035 114.721L116.162 113.631L118.922 111.434H120.41V120ZM128.742 115.09C128.742 116.777 128.387 118.037 127.676 118.869C126.965 119.701 125.889 120.117 124.447 120.117C123.939 120.117 123.555 120.09 123.293 120.035V118.582C123.621 118.664 123.965 118.705 124.324 118.705C124.93 118.705 125.428 118.617 125.818 118.441C126.209 118.262 126.508 117.982 126.715 117.604C126.922 117.221 127.041 116.695 127.072 116.027H127.002C126.775 116.395 126.514 116.652 126.217 116.801C125.92 116.949 125.549 117.023 125.104 117.023C124.357 117.023 123.77 116.785 123.34 116.309C122.91 115.828 122.695 115.162 122.695 114.311C122.695 113.393 122.955 112.668 123.475 112.137C123.998 111.602 124.709 111.334 125.607 111.334C126.24 111.334 126.793 111.482 127.266 111.779C127.742 112.076 128.107 112.508 128.361 113.074C128.615 113.637 128.742 114.309 128.742 115.09ZM125.643 112.787C125.268 112.787 124.975 112.916 124.764 113.174C124.553 113.432 124.447 113.803 124.447 114.287C124.447 114.701 124.543 115.029 124.734 115.271C124.926 115.514 125.217 115.635 125.607 115.635C125.975 115.635 126.289 115.516 126.551 115.277C126.812 115.035 126.943 114.758 126.943 114.445C126.943 113.98 126.82 113.588 126.574 113.268C126.332 112.947 126.021 112.787 125.643 112.787ZM134.121 120H132.311V115.043L132.328 114.229L132.357 113.338C132.057 113.639 131.848 113.836 131.73 113.93L130.746 114.721L129.873 113.631L132.633 111.434H134.121V120ZM140.314 111.434H142.734C143.871 111.434 144.693 111.604 145.201 111.943C145.709 112.283 145.963 112.82 145.963 113.555C145.963 114.062 145.82 114.482 145.535 114.814C145.254 115.143 144.842 115.355 144.299 115.453V115.512C145.6 115.734 146.25 116.418 146.25 117.562C146.25 118.328 145.99 118.926 145.471 119.355C144.955 119.785 144.232 120 143.303 120H140.314V111.434ZM141.311 115.102H142.951C143.654 115.102 144.16 114.992 144.469 114.773C144.777 114.551 144.932 114.178 144.932 113.654C144.932 113.174 144.76 112.828 144.416 112.617C144.072 112.402 143.525 112.295 142.775 112.295H141.311V115.102ZM141.311 115.945V119.15H143.098C143.789 119.15 144.309 119.018 144.656 118.752C145.008 118.482 145.184 118.062 145.184 117.492C145.184 116.961 145.004 116.57 144.645 116.32C144.289 116.07 143.746 115.945 143.016 115.945H141.311ZM150.662 120.117C149.713 120.117 148.963 119.828 148.412 119.25C147.865 118.672 147.592 117.869 147.592 116.842C147.592 115.807 147.846 114.984 148.354 114.375C148.865 113.766 149.551 113.461 150.41 113.461C151.215 113.461 151.852 113.727 152.32 114.258C152.789 114.785 153.023 115.482 153.023 116.35V116.965H148.6C148.619 117.719 148.809 118.291 149.168 118.682C149.531 119.072 150.041 119.268 150.697 119.268C151.389 119.268 152.072 119.123 152.748 118.834V119.701C152.404 119.85 152.078 119.955 151.77 120.018C151.465 120.084 151.096 120.117 150.662 120.117ZM150.398 114.275C149.883 114.275 149.471 114.443 149.162 114.779C148.857 115.115 148.678 115.58 148.623 116.174H151.98C151.98 115.561 151.844 115.092 151.57 114.768C151.297 114.439 150.906 114.275 150.398 114.275ZM159.932 120L158.754 116.232C158.68 116.002 158.541 115.479 158.338 114.662H158.291C158.135 115.346 157.998 115.873 157.881 116.244L156.668 120H155.543L153.791 113.578H154.811C155.225 115.191 155.539 116.42 155.754 117.264C155.973 118.107 156.098 118.676 156.129 118.969H156.176C156.219 118.746 156.287 118.459 156.381 118.107C156.479 117.752 156.562 117.471 156.633 117.264L157.811 113.578H158.865L160.014 117.264C160.232 117.936 160.381 118.5 160.459 118.957H160.506C160.521 118.816 160.562 118.6 160.629 118.307C160.699 118.014 161.107 116.438 161.854 113.578H162.861L161.086 120H159.932ZM166.74 120.117C165.791 120.117 165.041 119.828 164.49 119.25C163.943 118.672 163.67 117.869 163.67 116.842C163.67 115.807 163.924 114.984 164.432 114.375C164.943 113.766 165.629 113.461 166.488 113.461C167.293 113.461 167.93 113.727 168.398 114.258C168.867 114.785 169.102 115.482 169.102 116.35V116.965H164.678C164.697 117.719 164.887 118.291 165.246 118.682C165.609 119.072 166.119 119.268 166.775 119.268C167.467 119.268 168.15 119.123 168.826 118.834V119.701C168.482 119.85 168.156 119.955 167.848 120.018C167.543 120.084 167.174 120.117 166.74 120.117ZM166.477 114.275C165.961 114.275 165.549 114.443 165.24 114.779C164.936 115.115 164.756 115.58 164.701 116.174H168.059C168.059 115.561 167.922 115.092 167.648 114.768C167.375 114.439 166.984 114.275 166.477 114.275ZM173.695 113.461C173.98 113.461 174.236 113.484 174.463 113.531L174.328 114.434C174.062 114.375 173.828 114.346 173.625 114.346C173.105 114.346 172.66 114.557 172.289 114.979C171.922 115.4 171.738 115.926 171.738 116.555V120H170.766V113.578H171.568L171.68 114.768H171.727C171.965 114.35 172.252 114.027 172.588 113.801C172.924 113.574 173.293 113.461 173.695 113.461ZM177.738 119.314C177.91 119.314 178.076 119.303 178.236 119.279C178.396 119.252 178.523 119.225 178.617 119.197V119.941C178.512 119.992 178.355 120.033 178.148 120.064C177.945 120.1 177.762 120.117 177.598 120.117C176.355 120.117 175.734 119.463 175.734 118.154V114.334H174.814V113.865L175.734 113.461L176.145 112.09H176.707V113.578H178.57V114.334H176.707V118.113C176.707 118.5 176.799 118.797 176.982 119.004C177.166 119.211 177.418 119.314 177.738 119.314ZM180.82 113.578V117.744C180.82 118.268 180.939 118.658 181.178 118.916C181.416 119.174 181.789 119.303 182.297 119.303C182.969 119.303 183.459 119.119 183.768 118.752C184.08 118.385 184.236 117.785 184.236 116.953V113.578H185.209V120H184.406L184.266 119.139H184.213C184.014 119.455 183.736 119.697 183.381 119.865C183.029 120.033 182.627 120.117 182.174 120.117C181.393 120.117 180.807 119.932 180.416 119.561C180.029 119.189 179.836 118.596 179.836 117.779V113.578H180.82ZM191.672 120V115.846C191.672 115.322 191.553 114.932 191.314 114.674C191.076 114.416 190.703 114.287 190.195 114.287C189.523 114.287 189.031 114.469 188.719 114.832C188.406 115.195 188.25 115.795 188.25 116.631V120H187.277V113.578H188.068L188.227 114.457H188.273C188.473 114.141 188.752 113.896 189.111 113.725C189.471 113.549 189.871 113.461 190.312 113.461C191.086 113.461 191.668 113.648 192.059 114.023C192.449 114.395 192.645 114.99 192.645 115.811V120H191.672ZM199.904 113.578V114.193L198.715 114.334C198.824 114.471 198.922 114.65 199.008 114.873C199.094 115.092 199.137 115.34 199.137 115.617C199.137 116.246 198.922 116.748 198.492 117.123C198.062 117.498 197.473 117.686 196.723 117.686C196.531 117.686 196.352 117.67 196.184 117.639C195.77 117.857 195.562 118.133 195.562 118.465C195.562 118.641 195.635 118.771 195.779 118.857C195.924 118.939 196.172 118.98 196.523 118.98H197.66C198.355 118.98 198.889 119.127 199.26 119.42C199.635 119.713 199.822 120.139 199.822 120.697C199.822 121.408 199.537 121.949 198.967 122.32C198.396 122.695 197.564 122.883 196.471 122.883C195.631 122.883 194.982 122.727 194.525 122.414C194.072 122.102 193.846 121.66 193.846 121.09C193.846 120.699 193.971 120.361 194.221 120.076C194.471 119.791 194.822 119.598 195.275 119.496C195.111 119.422 194.973 119.307 194.859 119.15C194.75 118.994 194.695 118.812 194.695 118.605C194.695 118.371 194.758 118.166 194.883 117.99C195.008 117.814 195.205 117.645 195.475 117.48C195.143 117.344 194.871 117.111 194.66 116.783C194.453 116.455 194.35 116.08 194.35 115.658C194.35 114.955 194.561 114.414 194.982 114.035C195.404 113.652 196.002 113.461 196.775 113.461C197.111 113.461 197.414 113.5 197.684 113.578H199.904ZM194.783 121.078C194.783 121.426 194.93 121.689 195.223 121.869C195.516 122.049 195.936 122.139 196.482 122.139C197.299 122.139 197.902 122.016 198.293 121.77C198.688 121.527 198.885 121.197 198.885 120.779C198.885 120.432 198.777 120.189 198.562 120.053C198.348 119.92 197.943 119.854 197.35 119.854H196.184C195.742 119.854 195.398 119.959 195.152 120.17C194.906 120.381 194.783 120.684 194.783 121.078ZM195.311 115.635C195.311 116.084 195.438 116.424 195.691 116.654C195.945 116.885 196.299 117 196.752 117C197.701 117 198.176 116.539 198.176 115.617C198.176 114.652 197.695 114.17 196.734 114.17C196.277 114.17 195.926 114.293 195.68 114.539C195.434 114.785 195.311 115.15 195.311 115.635ZM203.936 120.117C202.986 120.117 202.236 119.828 201.686 119.25C201.139 118.672 200.865 117.869 200.865 116.842C200.865 115.807 201.119 114.984 201.627 114.375C202.139 113.766 202.824 113.461 203.684 113.461C204.488 113.461 205.125 113.727 205.594 114.258C206.062 114.785 206.297 115.482 206.297 116.35V116.965H201.873C201.893 117.719 202.082 118.291 202.441 118.682C202.805 119.072 203.314 119.268 203.971 119.268C204.662 119.268 205.346 119.123 206.021 118.834V119.701C205.678 119.85 205.352 119.955 205.043 120.018C204.738 120.084 204.369 120.117 203.936 120.117ZM203.672 114.275C203.156 114.275 202.744 114.443 202.436 114.779C202.131 115.115 201.951 115.58 201.896 116.174H205.254C205.254 115.561 205.117 115.092 204.844 114.768C204.57 114.439 204.18 114.275 203.672 114.275ZM212.355 120V115.846C212.355 115.322 212.236 114.932 211.998 114.674C211.76 114.416 211.387 114.287 210.879 114.287C210.207 114.287 209.715 114.469 209.402 114.832C209.09 115.195 208.934 115.795 208.934 116.631V120H207.961V113.578H208.752L208.91 114.457H208.957C209.156 114.141 209.436 113.896 209.795 113.725C210.154 113.549 210.555 113.461 210.996 113.461C211.77 113.461 212.352 113.648 212.742 114.023C213.133 114.395 213.328 114.99 213.328 115.811V120H212.355Z","fill":"#323231"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1942_50802"}},[_c('rect',{attrs:{"width":"130","height":"31","fill":"white","transform":"translate(12 12)"}})])])])
}
var trust_pilot_placeholder_svgvue_type_template_id_4fcc54ab_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/decorations/trust-pilot-placeholder-svg.vue?vue&type=template&id=4fcc54ab

// CONCATENATED MODULE: ./src/components/svg/decorations/trust-pilot-placeholder-svg.vue

var trust_pilot_placeholder_svg_script = {}


/* normalize component */

var trust_pilot_placeholder_svg_component = normalizeComponent(
  trust_pilot_placeholder_svg_script,
  trust_pilot_placeholder_svgvue_type_template_id_4fcc54ab_render,
  trust_pilot_placeholder_svgvue_type_template_id_4fcc54ab_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var trust_pilot_placeholder_svg = (trust_pilot_placeholder_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/stores/app_de.vue?vue&type=template&id=1a855f90&scoped=true
var app_devue_type_template_id_1a855f90_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 180 55"},attrs:{"version":"1.1","id":"Ebene_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0","y":"0","viewBox":"0 0 180 55","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID2_1_","d":"M0 0h179.9v54.5H0z"}})]),_c('clipPath',{attrs:{"id":"SVGID2_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID2_1_"}})]),_c('path',{staticClass:"at0",attrs:{"d":"M179.9 47.2c0 4.1-3.3 7.4-7.4 7.4H7.4c-4.1 0-7.4-3.3-7.4-7.4V7.4C0 3.3 3.3 0 7.4 0h165.2c4.1 0 7.4 3.3 7.4 7.4v39.8z"}}),_c('path',{staticClass:"at1",attrs:{"d":"M41.7 27c0-4.6 3.8-6.8 3.9-6.9-2.2-3.1-5.5-3.6-6.7-3.6-2.8-.3-5.5 1.7-7 1.7s-3.7-1.6-6-1.6c-3.1 0-5.9 1.8-7.5 4.6-3.2 5.6-.8 13.8 2.3 18.3 1.5 2.2 3.4 4.7 5.7 4.6 2.3-.1 3.2-1.5 6-1.5s3.6 1.5 6 1.4c2.5 0 4.1-2.2 5.5-4.5 1.8-2.5 2.5-5 2.5-5.2.2 0-4.6-1.8-4.7-7.3M37.2 13.5c1.2-1.6 2.1-3.7 1.9-5.8-1.8.1-4.1 1.2-5.4 2.8-1.1 1.3-2.2 3.5-1.9 5.6 2 .1 4.1-1.1 5.4-2.6M68.4 35.7 67 31.4c-.1-.4-.4-1.5-.8-3.1-.2.7-.4 1.7-.8 3.1L64 35.7h4.4zm4.9 6.9h-2.8L69 37.7h-5.4L62 42.6h-2.7L64.6 26h3.3l5.4 16.6zM84.3 36.6c0-1.2-.3-2.1-.8-2.9-.6-.8-1.3-1.2-2.3-1.2-.7 0-1.2.2-1.8.6-.5.4-.9 1-1 1.7-.1.3-.1.6-.1.8v2c0 .9.3 1.6.8 2.2.5.6 1.2.9 2.1.9 1 0 1.8-.4 2.3-1.2.5-.7.8-1.7.8-2.9m2.6-.1c0 2-.5 3.6-1.6 4.8-1 1-2.2 1.6-3.7 1.6-1.6 0-2.7-.6-3.4-1.7v6.3h-2.6V34.6c0-1.3 0-2.6-.1-3.9h2.3l.1 1.9c.9-1.4 2.2-2.1 4-2.1 1.4 0 2.6.6 3.5 1.7 1.1 1 1.5 2.4 1.5 4.3M98 36.6c0-1.2-.3-2.1-.8-2.9-.6-.8-1.3-1.2-2.3-1.2-.7 0-1.2.2-1.8.6-.5.4-.9 1-1 1.7-.1.3-.1.6-.1.8v2c0 .9.3 1.6.8 2.2.5.6 1.2.9 2.1.9 1 0 1.8-.4 2.3-1.2.5-.7.8-1.7.8-2.9m2.7-.1c0 2-.5 3.6-1.6 4.8-1 1-2.2 1.6-3.7 1.6-1.6 0-2.7-.6-3.4-1.7v6.3h-2.6V34.6c0-1.3 0-2.6-.1-3.9h2.3l.1 1.9c.9-1.4 2.2-2.1 4-2.1 1.4 0 2.6.6 3.5 1.7 1 1 1.5 2.4 1.5 4.3M116 37.9c0 1.4-.5 2.6-1.5 3.4-1.1 1-2.6 1.4-4.5 1.4-1.8 0-3.2-.3-4.3-1l.6-2.2c1.2.7 2.4 1.1 3.8 1.1 1 0 1.8-.2 2.3-.7.6-.4.8-1.1.8-1.8s-.2-1.2-.7-1.7c-.5-.5-1.2-.9-2.3-1.3-2.9-1.1-4.3-2.7-4.3-4.7 0-1.4.5-2.5 1.5-3.3 1-.9 2.4-1.3 4-1.3 1.5 0 2.8.3 3.8.8l-.7 2.2c-.9-.5-2-.8-3.2-.8-.9 0-1.7.2-2.2.7-.4.4-.7.9-.7 1.5 0 .7.3 1.2.8 1.6.4.4 1.2.8 2.4 1.3 1.4.6 2.5 1.2 3.1 2 1 .7 1.3 1.7 1.3 2.8M124.8 32.6h-2.9v5.8c0 1.5.5 2.2 1.5 2.2.5 0 .9 0 1.2-.1l.1 2c-.5.2-1.2.3-2.1.3-1 0-1.9-.3-2.5-1-.6-.6-.9-1.7-.9-3.2v-6h-1.7v-2h1.7v-2.2l2.6-.8v3h2.9v2zM135.2 36.6c0-1.1-.2-2-.7-2.8-.6-1-1.3-1.4-2.4-1.4-1.1 0-1.9.5-2.4 1.4-.5.8-.7 1.7-.7 2.9 0 1.1.2 2 .7 2.8.6 1 1.4 1.4 2.4 1.4s1.8-.5 2.4-1.5c.4-.8.7-1.7.7-2.8m2.7-.1c0 1.8-.5 3.3-1.6 4.5-1.1 1.2-2.6 1.8-4.4 1.8-1.8 0-3.1-.6-4.2-1.7-1-1.2-1.6-2.6-1.6-4.4 0-1.8.5-3.4 1.6-4.5 1.1-1.2 2.5-1.8 4.3-1.8 1.7 0 3.2.6 4.2 1.7 1.2 1.2 1.7 2.6 1.7 4.4M146.5 33c-.3 0-.5-.1-.8-.1-.9 0-1.7.4-2.2 1.1-.4.6-.7 1.4-.7 2.4v6.3h-2.7v-8.2c0-1.4 0-2.6-.1-3.8h2.3l.1 2.3h.1c.3-.8.7-1.4 1.3-1.9.6-.4 1.2-.6 1.9-.6h.7V33zM155.9 35.4c0-.8-.2-1.5-.5-2-.5-.7-1.2-1.1-2.1-1.1-.9 0-1.6.4-2.1 1.1-.4.6-.7 1.3-.8 2.1l5.5-.1zm2.5.6c0 .5 0 .9-.1 1.2h-7.9c0 1.2.4 2.1 1.2 2.7.7.6 1.5.8 2.6.8 1.2 0 2.2-.2 3.2-.6l.4 1.8c-1.1.5-2.5.7-4 .7-1.8 0-3.3-.5-4.4-1.6-1.1-1.1-1.6-2.5-1.6-4.4 0-1.8.5-3.3 1.5-4.5 1-1.3 2.4-1.9 4.2-1.9 1.7 0 3 .6 3.9 1.9.6 1.2 1 2.5 1 3.9"}})]),_c('path',{staticClass:"at2",attrs:{"d":"M64.6 15.2h-2.2V17h2.5v.9h-3.6v-6h3.4v.9h-2.3v1.6h2.2z"}}),_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID2_3_","d":"M0 0h179.9v54.5H0z"}})]),_c('clipPath',{attrs:{"id":"SVGID2_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID2_3_"}})]),_c('path',{staticClass:"at3",attrs:{"d":"M66.2 15v-1.4h.9v.8c.2-.6.7-.9 1.2-.9h.3v1h-.3c-.5 0-.9.3-1 .8v2.5h-1.1V15zM69.7 11.6h1.1v2.6c.1-.2.3-.4.5-.5.2-.1.5-.2.8-.2.7 0 1.5.5 1.5 1.9V18h-1.1v-2.4c0-.6-.2-1.1-.8-1.1-.4 0-.7.3-.9.6V18h-1.1v-6.4zM77.7 12.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5c0 .2-.2.5-.5.5zm-.3 2.9c-.8 0-1.5.1-1.5.8 0 .4.3.6.6.6.4 0 .8-.3.9-.6v-.8zm-2-3.4c0-.3.2-.5.6-.5.3 0 .5.2.5.5s-.2.5-.5.5c-.4 0-.6-.3-.6-.5m3.1 4.5c0 .4 0 .8.1 1h-1l-.1-.5c-.3.3-.7.6-1.3.6-.9 0-1.4-.6-1.4-1.3 0-1.1 1-1.6 2.6-1.6V15c0-.3-.1-.8-.9-.8-.4 0-.9.1-1.2.3l-.2-.7c.3-.2.9-.4 1.6-.4 1.4 0 1.8.9 1.8 1.8v1.7z"}})]),_c('path',{staticClass:"at2",attrs:{"d":"M80 11.6h1.1v6.3H80z"}}),_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID2_5_","d":"M0 0h179.9v54.5H0z"}})]),_c('clipPath',{attrs:{"id":"SVGID2_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID2_5_"}})]),_c('path',{staticClass:"at4",attrs:{"d":"M83.9 12.5v1.1h1v.8h-1v1.9c0 .5.1.8.6.8h.4v.8c-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.4-.2-.2-.3-.6-.3-1.2v-2h-.6v-.8h.6v-.8l1-.3z"}})]),_c('path',{staticClass:"at2",attrs:{"d":"M86.2 11.6h1.1v6.3h-1.1z"}}),_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID2_7_","d":"M0 0h179.9v54.5H0z"}})]),_c('clipPath',{attrs:{"id":"SVGID2_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID2_7_"}})]),_c('path',{staticClass:"at5",attrs:{"d":"M88.8 13.6h1.1v4.3h-1.1v-4.3zm1.2-1.2c0 .3-.2.6-.6.6-.4 0-.6-.3-.6-.6s.2-.6.6-.6c.3 0 .6.2.6.6M94.6 17.8c-.2.1-.6.2-1.2.2-1.3 0-2.2-.9-2.2-2.2 0-1.3.9-2.3 2.4-2.3.4 0 .8.1 1.1.2l-.2.8c-.2-.1-.4-.2-.8-.2-.8 0-1.3.6-1.3 1.4 0 .9.6 1.4 1.3 1.4.4 0 .6-.1.9-.2v.9zM95.8 11.6h1.1v2.6c.1-.2.3-.4.5-.5.2-.1.5-.2.8-.2.7 0 1.5.5 1.5 1.9V18h-1.1v-2.4c0-.6-.2-1.1-.8-1.1-.4 0-.7.3-.9.6V18h-1.1v-6.4zM103.5 13.6h1.1v4.3h-1.1v-4.3zm1.1-1.2c0 .3-.2.6-.6.6-.4 0-.6-.3-.6-.6s.2-.6.6-.6c.4 0 .6.2.6.6M106.1 14.9v-1.3h.9v.6c.2-.3.6-.7 1.3-.7.6 0 1 .3 1.2.8.1-.2.3-.4.5-.5.2-.2.5-.3.9-.3.7 0 1.4.5 1.4 1.9v2.5h-1.1v-2.4c0-.7-.2-1.1-.8-1.1-.4 0-.6.3-.8.6v3h-1.1v-2.5c0-.6-.2-1-.7-1-.4 0-.7.3-.8.6v3h-1.1v-3.2z"}})])])
}
var app_devue_type_template_id_1a855f90_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/stores/app_de.vue?vue&type=template&id=1a855f90&scoped=true

// EXTERNAL MODULE: ./src/components/svg/stores/app_de.vue?vue&type=style&index=0&id=1a855f90&prod&scoped=true&lang=css
var app_devue_type_style_index_0_id_1a855f90_prod_scoped_true_lang_css = __webpack_require__("9525");

// CONCATENATED MODULE: ./src/components/svg/stores/app_de.vue

var app_de_script = {}



/* normalize component */

var app_de_component = normalizeComponent(
  app_de_script,
  app_devue_type_template_id_1a855f90_scoped_true_render,
  app_devue_type_template_id_1a855f90_scoped_true_staticRenderFns,
  false,
  null,
  "1a855f90",
  null
  
)

/* harmony default export */ var app_de = (app_de_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/stores/app_at.vue?vue&type=template&id=afbd35ec
var app_atvue_type_template_id_afbd35ec_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 180 55"},attrs:{"version":"1.1","id":"Ebene_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 180 55","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVG_ID_1_","x":"0","y":"0","width":"179.9","height":"54.5"}})]),_c('clipPath',{attrs:{"id":"SVG_ID_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVG_ID_1_"}})]),_c('path',{staticClass:"at0",attrs:{"d":"M179.9,47.2c0,4.1-3.3,7.4-7.4,7.4H7.4c-4.1,0-7.4-3.3-7.4-7.4V7.4C0,3.3,3.3,0,7.4,0h165.2\n\t\tc4.1,0,7.4,3.3,7.4,7.4V47.2z"}}),_c('path',{staticClass:"at1",attrs:{"d":"M41.7,27c0-4.6,3.8-6.8,3.9-6.9c-2.2-3.1-5.5-3.6-6.7-3.6c-2.8-0.3-5.5,1.7-7,1.7c-1.5,0-3.7-1.6-6-1.6\n\t\tc-3.1,0-5.9,1.8-7.5,4.6c-3.2,5.6-0.8,13.8,2.3,18.3c1.5,2.2,3.4,4.7,5.7,4.6c2.3-0.1,3.2-1.5,6-1.5c2.8,0,3.6,1.5,6,1.4\n\t\tc2.5,0,4.1-2.2,5.5-4.5c1.8-2.5,2.5-5,2.5-5.2C46.6,34.3,41.8,32.5,41.7,27"}}),_c('path',{staticClass:"at1",attrs:{"d":"M37.2,13.5c1.2-1.6,2.1-3.7,1.9-5.8c-1.8,0.1-4.1,1.2-5.4,2.8c-1.1,1.3-2.2,3.5-1.9,5.6\n\t\tC33.8,16.2,35.9,15,37.2,13.5"}}),_c('path',{staticClass:"at1",attrs:{"d":"M68.4,35.7L67,31.4c-0.1-0.4-0.4-1.5-0.8-3.1h0c-0.2,0.7-0.4,1.7-0.8,3.1L64,35.7H68.4z M73.3,42.6h-2.8\n\t\tl-1.5-4.9h-5.4L62,42.6h-2.7L64.6,26h3.3L73.3,42.6z"}}),_c('path',{staticClass:"at1",attrs:{"d":"M84.3,36.6c0-1.2-0.3-2.1-0.8-2.9c-0.6-0.8-1.3-1.2-2.3-1.2c-0.7,0-1.2,0.2-1.8,0.6c-0.5,0.4-0.9,1-1,1.7\n\t\tc-0.1,0.3-0.1,0.6-0.1,0.8v2c0,0.9,0.3,1.6,0.8,2.2c0.5,0.6,1.2,0.9,2.1,0.9c1,0,1.8-0.4,2.3-1.2C84,38.8,84.3,37.8,84.3,36.6\n\t\t M86.9,36.5c0,2-0.5,3.6-1.6,4.8c-1,1-2.2,1.6-3.7,1.6c-1.6,0-2.7-0.6-3.4-1.7h0v6.3h-2.6V34.6c0-1.3,0-2.6-0.1-3.9h2.3l0.1,1.9h0\n\t\tc0.9-1.4,2.2-2.1,4-2.1c1.4,0,2.6,0.6,3.5,1.7C86.5,33.2,86.9,34.6,86.9,36.5"}}),_c('path',{staticClass:"at1",attrs:{"d":"M98,36.6c0-1.2-0.3-2.1-0.8-2.9c-0.6-0.8-1.3-1.2-2.3-1.2c-0.7,0-1.2,0.2-1.8,0.6c-0.5,0.4-0.9,1-1,1.7\n\t\tc-0.1,0.3-0.1,0.6-0.1,0.8v2c0,0.9,0.3,1.6,0.8,2.2c0.5,0.6,1.2,0.9,2.1,0.9c1,0,1.8-0.4,2.3-1.2C97.7,38.8,98,37.8,98,36.6\n\t\t M100.7,36.5c0,2-0.5,3.6-1.6,4.8c-1,1-2.2,1.6-3.7,1.6c-1.6,0-2.7-0.6-3.4-1.7h0v6.3h-2.6V34.6c0-1.3,0-2.6-0.1-3.9h2.3l0.1,1.9h0\n\t\tc0.9-1.4,2.2-2.1,4-2.1c1.4,0,2.6,0.6,3.5,1.7C100.2,33.2,100.7,34.6,100.7,36.5"}}),_c('path',{staticClass:"at1",attrs:{"d":"M116,37.9c0,1.4-0.5,2.6-1.5,3.4c-1.1,1-2.6,1.4-4.5,1.4c-1.8,0-3.2-0.3-4.3-1l0.6-2.2\n\t\tc1.2,0.7,2.4,1.1,3.8,1.1c1,0,1.8-0.2,2.3-0.7c0.6-0.4,0.8-1.1,0.8-1.8c0-0.7-0.2-1.2-0.7-1.7c-0.5-0.5-1.2-0.9-2.3-1.3\n\t\tc-2.9-1.1-4.3-2.7-4.3-4.7c0-1.4,0.5-2.5,1.5-3.3c1-0.9,2.4-1.3,4-1.3c1.5,0,2.8,0.3,3.8,0.8l-0.7,2.2c-0.9-0.5-2-0.8-3.2-0.8\n\t\tc-0.9,0-1.7,0.2-2.2,0.7c-0.4,0.4-0.7,0.9-0.7,1.5c0,0.7,0.3,1.2,0.8,1.6c0.4,0.4,1.2,0.8,2.4,1.3c1.4,0.6,2.5,1.2,3.1,2\n\t\tC115.7,35.8,116,36.8,116,37.9"}}),_c('path',{staticClass:"at1",attrs:{"d":"M124.8,32.6h-2.9v5.8c0,1.5,0.5,2.2,1.5,2.2c0.5,0,0.9,0,1.2-0.1l0.1,2c-0.5,0.2-1.2,0.3-2.1,0.3\n\t\tc-1,0-1.9-0.3-2.5-1c-0.6-0.6-0.9-1.7-0.9-3.2v-6h-1.7v-2h1.7v-2.2l2.6-0.8v3h2.9V32.6z"}}),_c('path',{staticClass:"at1",attrs:{"d":"M135.2,36.6c0-1.1-0.2-2-0.7-2.8c-0.6-1-1.3-1.4-2.4-1.4c-1.1,0-1.9,0.5-2.4,1.4c-0.5,0.8-0.7,1.7-0.7,2.9\n\t\tc0,1.1,0.2,2,0.7,2.8c0.6,1,1.4,1.4,2.4,1.4c1,0,1.8-0.5,2.4-1.5C134.9,38.6,135.2,37.7,135.2,36.6 M137.9,36.5\n\t\tc0,1.8-0.5,3.3-1.6,4.5c-1.1,1.2-2.6,1.8-4.4,1.8c-1.8,0-3.1-0.6-4.2-1.7c-1-1.2-1.6-2.6-1.6-4.4c0-1.8,0.5-3.4,1.6-4.5\n\t\tc1.1-1.2,2.5-1.8,4.3-1.8c1.7,0,3.2,0.6,4.2,1.7C137.4,33.3,137.9,34.7,137.9,36.5"}}),_c('path',{staticClass:"at1",attrs:{"d":"M146.5,33c-0.3,0-0.5-0.1-0.8-0.1c-0.9,0-1.7,0.4-2.2,1.1c-0.4,0.6-0.7,1.4-0.7,2.4v6.3h-2.7l0-8.2\n\t\tc0-1.4,0-2.6-0.1-3.8h2.3l0.1,2.3h0.1c0.3-0.8,0.7-1.4,1.3-1.9c0.6-0.4,1.2-0.6,1.9-0.6c0.2,0,0.5,0,0.7,0V33z"}}),_c('path',{staticClass:"at1",attrs:{"d":"M155.9,35.4c0-0.8-0.2-1.5-0.5-2c-0.5-0.7-1.2-1.1-2.1-1.1c-0.9,0-1.6,0.4-2.1,1.1c-0.4,0.6-0.7,1.3-0.8,2.1\n\t\tL155.9,35.4L155.9,35.4z M158.4,36c0,0.5,0,0.9-0.1,1.2h-7.9c0,1.2,0.4,2.1,1.2,2.7c0.7,0.6,1.5,0.8,2.6,0.8c1.2,0,2.2-0.2,3.2-0.6\n\t\tl0.4,1.8c-1.1,0.5-2.5,0.7-4,0.7c-1.8,0-3.3-0.5-4.4-1.6c-1.1-1.1-1.6-2.5-1.6-4.4c0-1.8,0.5-3.3,1.5-4.5c1-1.3,2.4-1.9,4.2-1.9\n\t\tc1.7,0,3,0.6,3.9,1.9C158,33.3,158.4,34.6,158.4,36"}})]),_c('polygon',{staticClass:"at2",attrs:{"points":"64.6,15.2 62.4,15.2 62.4,17 64.9,17 64.9,17.9 61.3,17.9 61.3,11.9 64.7,11.9 64.7,12.8 62.4,12.8\n\t62.4,14.4 64.6,14.4 "}}),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVG_ID_3_","x":"0","y":"0","width":"179.9","height":"54.5"}})]),_c('clipPath',{attrs:{"id":"SVG_ID_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVG_ID_3_"}})]),_c('path',{staticClass:"at3",attrs:{"d":"M66.2,15c0-0.6,0-1,0-1.4h0.9l0,0.8h0c0.2-0.6,0.7-0.9,1.2-0.9c0.1,0,0.2,0,0.3,0v1c-0.1,0-0.2,0-0.3,0\n\t\tc-0.5,0-0.9,0.3-1,0.8c0,0.1,0,0.2,0,0.3v2.2h-1.1L66.2,15L66.2,15z"}}),_c('path',{staticClass:"at3",attrs:{"d":"M69.7,11.6h1.1v2.6h0c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.5-0.2,0.8-0.2c0.7,0,1.5,0.5,1.5,1.9v2.6h-1.1v-2.4\n\t\tc0-0.6-0.2-1.1-0.8-1.1c-0.4,0-0.7,0.3-0.9,0.6c0,0.1,0,0.2,0,0.3v2.6h-1.1L69.7,11.6L69.7,11.6z"}}),_c('path',{staticClass:"at3",attrs:{"d":"M77.7,12.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5C78.2,12.6,78,12.9,77.7,12.9\n\t\tL77.7,12.9z M77.4,15.8c-0.8,0-1.5,0.1-1.5,0.8c0,0.4,0.3,0.6,0.6,0.6c0.4,0,0.8-0.3,0.9-0.6c0-0.1,0-0.2,0-0.2V15.8z M75.4,12.4\n\t\tc0-0.3,0.2-0.5,0.6-0.5c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5C75.6,12.9,75.4,12.6,75.4,12.4 M78.5,16.9c0,0.4,0,0.8,0.1,1\n\t\th-1l-0.1-0.5h0c-0.3,0.3-0.7,0.6-1.3,0.6c-0.9,0-1.4-0.6-1.4-1.3c0-1.1,1-1.6,2.6-1.6V15c0-0.3-0.1-0.8-0.9-0.8\n\t\tc-0.4,0-0.9,0.1-1.2,0.3l-0.2-0.7c0.3-0.2,0.9-0.4,1.6-0.4c1.4,0,1.8,0.9,1.8,1.8L78.5,16.9L78.5,16.9z"}})]),_c('rect',{staticClass:"at2",attrs:{"x":"80","y":"11.6","width":"1.1","height":"6.3"}}),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVG_ID_5_","x":"0","y":"0","width":"179.9","height":"54.5"}})]),_c('clipPath',{attrs:{"id":"SVG_ID_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVG_ID_5_"}})]),_c('path',{staticClass:"at4",attrs:{"d":"M83.9,12.5v1.1h1v0.8h-1v1.9c0,0.5,0.1,0.8,0.6,0.8c0.2,0,0.3,0,0.4,0l0,0.8c-0.2,0.1-0.5,0.1-0.8,0.1\n\t\tc-0.4,0-0.7-0.1-0.9-0.4c-0.2-0.2-0.3-0.6-0.3-1.2v-2h-0.6v-0.8h0.6v-0.8L83.9,12.5z"}})]),_c('rect',{staticClass:"at2",attrs:{"x":"86.2","y":"11.6","width":"1.1","height":"6.3"}}),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVG_ID_7_","x":"0","y":"0","width":"179.9","height":"54.5"}})]),_c('clipPath',{attrs:{"id":"SVG_ID_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVG_ID_7_"}})]),_c('path',{staticClass:"at5",attrs:{"d":"M88.8,13.6h1.1v4.3h-1.1V13.6z M90,12.4c0,0.3-0.2,0.6-0.6,0.6c-0.4,0-0.6-0.3-0.6-0.6c0-0.3,0.2-0.6,0.6-0.6\n\t\tC89.7,11.8,90,12,90,12.4"}}),_c('path',{staticClass:"at5",attrs:{"d":"M94.6,17.8C94.4,17.9,94,18,93.4,18c-1.3,0-2.2-0.9-2.2-2.2c0-1.3,0.9-2.3,2.4-2.3c0.4,0,0.8,0.1,1.1,0.2\n\t\tl-0.2,0.8c-0.2-0.1-0.4-0.2-0.8-0.2c-0.8,0-1.3,0.6-1.3,1.4c0,0.9,0.6,1.4,1.3,1.4c0.4,0,0.6-0.1,0.9-0.2L94.6,17.8z"}}),_c('path',{staticClass:"at5",attrs:{"d":"M95.8,11.6h1.1v2.6h0c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.5-0.2,0.8-0.2c0.7,0,1.5,0.5,1.5,1.9v2.6h-1.1v-2.4\n\t\tc0-0.6-0.2-1.1-0.8-1.1c-0.4,0-0.7,0.3-0.9,0.6c0,0.1,0,0.2,0,0.3v2.6h-1.1L95.8,11.6L95.8,11.6z"}}),_c('path',{staticClass:"at5",attrs:{"d":"M103.5,13.6h1.1v4.3h-1.1V13.6z M104.6,12.4c0,0.3-0.2,0.6-0.6,0.6c-0.4,0-0.6-0.3-0.6-0.6\n\t\tc0-0.3,0.2-0.6,0.6-0.6C104.4,11.8,104.6,12,104.6,12.4"}}),_c('path',{staticClass:"at5",attrs:{"d":"M106.1,14.9c0-0.5,0-0.9,0-1.3h0.9l0,0.6h0c0.2-0.3,0.6-0.7,1.3-0.7c0.6,0,1,0.3,1.2,0.8h0\n\t\tc0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.2,0.5-0.3,0.9-0.3c0.7,0,1.4,0.5,1.4,1.9v2.5h-1.1v-2.4c0-0.7-0.2-1.1-0.8-1.1\n\t\tc-0.4,0-0.6,0.3-0.8,0.6c0,0.1,0,0.2,0,0.4v2.6h-1.1v-2.5c0-0.6-0.2-1-0.7-1c-0.4,0-0.7,0.3-0.8,0.6c0,0.1,0,0.2,0,0.4v2.6h-1.1\n\t\tV14.9z"}})])])
}
var app_atvue_type_template_id_afbd35ec_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/stores/app_at.vue?vue&type=template&id=afbd35ec

// EXTERNAL MODULE: ./src/components/svg/stores/app_at.vue?vue&type=style&index=0&id=afbd35ec&prod&lang=css
var app_atvue_type_style_index_0_id_afbd35ec_prod_lang_css = __webpack_require__("8763");

// CONCATENATED MODULE: ./src/components/svg/stores/app_at.vue

var app_at_script = {}



/* normalize component */

var app_at_component = normalizeComponent(
  app_at_script,
  app_atvue_type_template_id_afbd35ec_render,
  app_atvue_type_template_id_afbd35ec_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var app_at = (app_at_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/stores/app_ch.vue?vue&type=template&id=ec2a1f88
var app_chvue_type_template_id_ec2a1f88_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 180 55"},attrs:{"version":"1.1","id":"Ebene_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 180 55","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVG_ID_1_","x":"0","y":"0","width":"179.9","height":"54.5"}})]),_c('clipPath',{attrs:{"id":"SVG_ID_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVG_ID_1_"}})]),_c('path',{staticClass:"at0",attrs:{"d":"M179.9,47.2c0,4.1-3.3,7.4-7.4,7.4H7.4c-4.1,0-7.4-3.3-7.4-7.4V7.4C0,3.3,3.3,0,7.4,0h165.2\n\t\tc4.1,0,7.4,3.3,7.4,7.4V47.2z"}}),_c('path',{staticClass:"at1",attrs:{"d":"M41.7,27c0-4.6,3.8-6.8,3.9-6.9c-2.2-3.1-5.5-3.6-6.7-3.6c-2.8-0.3-5.5,1.7-7,1.7c-1.5,0-3.7-1.6-6-1.6\n\t\tc-3.1,0-5.9,1.8-7.5,4.6c-3.2,5.6-0.8,13.8,2.3,18.3c1.5,2.2,3.4,4.7,5.7,4.6c2.3-0.1,3.2-1.5,6-1.5c2.8,0,3.6,1.5,6,1.4\n\t\tc2.5,0,4.1-2.2,5.5-4.5c1.8-2.5,2.5-5,2.5-5.2C46.6,34.3,41.8,32.5,41.7,27"}}),_c('path',{staticClass:"at1",attrs:{"d":"M37.2,13.5c1.2-1.6,2.1-3.7,1.9-5.8c-1.8,0.1-4.1,1.2-5.4,2.8c-1.1,1.3-2.2,3.5-1.9,5.6\n\t\tC33.8,16.2,35.9,15,37.2,13.5"}}),_c('path',{staticClass:"at1",attrs:{"d":"M68.4,35.7L67,31.4c-0.1-0.4-0.4-1.5-0.8-3.1h0c-0.2,0.7-0.4,1.7-0.8,3.1L64,35.7H68.4z M73.3,42.6h-2.8\n\t\tl-1.5-4.9h-5.4L62,42.6h-2.7L64.6,26h3.3L73.3,42.6z"}}),_c('path',{staticClass:"at1",attrs:{"d":"M84.3,36.6c0-1.2-0.3-2.1-0.8-2.9c-0.6-0.8-1.3-1.2-2.3-1.2c-0.7,0-1.2,0.2-1.8,0.6c-0.5,0.4-0.9,1-1,1.7\n\t\tc-0.1,0.3-0.1,0.6-0.1,0.8v2c0,0.9,0.3,1.6,0.8,2.2c0.5,0.6,1.2,0.9,2.1,0.9c1,0,1.8-0.4,2.3-1.2C84,38.8,84.3,37.8,84.3,36.6\n\t\t M86.9,36.5c0,2-0.5,3.6-1.6,4.8c-1,1-2.2,1.6-3.7,1.6c-1.6,0-2.7-0.6-3.4-1.7h0v6.3h-2.6V34.6c0-1.3,0-2.6-0.1-3.9h2.3l0.1,1.9h0\n\t\tc0.9-1.4,2.2-2.1,4-2.1c1.4,0,2.6,0.6,3.5,1.7C86.5,33.2,86.9,34.6,86.9,36.5"}}),_c('path',{staticClass:"at1",attrs:{"d":"M98,36.6c0-1.2-0.3-2.1-0.8-2.9c-0.6-0.8-1.3-1.2-2.3-1.2c-0.7,0-1.2,0.2-1.8,0.6c-0.5,0.4-0.9,1-1,1.7\n\t\tc-0.1,0.3-0.1,0.6-0.1,0.8v2c0,0.9,0.3,1.6,0.8,2.2c0.5,0.6,1.2,0.9,2.1,0.9c1,0,1.8-0.4,2.3-1.2C97.7,38.8,98,37.8,98,36.6\n\t\t M100.7,36.5c0,2-0.5,3.6-1.6,4.8c-1,1-2.2,1.6-3.7,1.6c-1.6,0-2.7-0.6-3.4-1.7h0v6.3h-2.6V34.6c0-1.3,0-2.6-0.1-3.9h2.3l0.1,1.9h0\n\t\tc0.9-1.4,2.2-2.1,4-2.1c1.4,0,2.6,0.6,3.5,1.7C100.2,33.2,100.7,34.6,100.7,36.5"}}),_c('path',{staticClass:"at1",attrs:{"d":"M116,37.9c0,1.4-0.5,2.6-1.5,3.4c-1.1,1-2.6,1.4-4.5,1.4c-1.8,0-3.2-0.3-4.3-1l0.6-2.2\n\t\tc1.2,0.7,2.4,1.1,3.8,1.1c1,0,1.8-0.2,2.3-0.7c0.6-0.4,0.8-1.1,0.8-1.8c0-0.7-0.2-1.2-0.7-1.7c-0.5-0.5-1.2-0.9-2.3-1.3\n\t\tc-2.9-1.1-4.3-2.7-4.3-4.7c0-1.4,0.5-2.5,1.5-3.3c1-0.9,2.4-1.3,4-1.3c1.5,0,2.8,0.3,3.8,0.8l-0.7,2.2c-0.9-0.5-2-0.8-3.2-0.8\n\t\tc-0.9,0-1.7,0.2-2.2,0.7c-0.4,0.4-0.7,0.9-0.7,1.5c0,0.7,0.3,1.2,0.8,1.6c0.4,0.4,1.2,0.8,2.4,1.3c1.4,0.6,2.5,1.2,3.1,2\n\t\tC115.7,35.8,116,36.8,116,37.9"}}),_c('path',{staticClass:"at1",attrs:{"d":"M124.8,32.6h-2.9v5.8c0,1.5,0.5,2.2,1.5,2.2c0.5,0,0.9,0,1.2-0.1l0.1,2c-0.5,0.2-1.2,0.3-2.1,0.3\n\t\tc-1,0-1.9-0.3-2.5-1c-0.6-0.6-0.9-1.7-0.9-3.2v-6h-1.7v-2h1.7v-2.2l2.6-0.8v3h2.9V32.6z"}}),_c('path',{staticClass:"at1",attrs:{"d":"M135.2,36.6c0-1.1-0.2-2-0.7-2.8c-0.6-1-1.3-1.4-2.4-1.4c-1.1,0-1.9,0.5-2.4,1.4c-0.5,0.8-0.7,1.7-0.7,2.9\n\t\tc0,1.1,0.2,2,0.7,2.8c0.6,1,1.4,1.4,2.4,1.4c1,0,1.8-0.5,2.4-1.5C134.9,38.6,135.2,37.7,135.2,36.6 M137.9,36.5\n\t\tc0,1.8-0.5,3.3-1.6,4.5c-1.1,1.2-2.6,1.8-4.4,1.8c-1.8,0-3.1-0.6-4.2-1.7c-1-1.2-1.6-2.6-1.6-4.4c0-1.8,0.5-3.4,1.6-4.5\n\t\tc1.1-1.2,2.5-1.8,4.3-1.8c1.7,0,3.2,0.6,4.2,1.7C137.4,33.3,137.9,34.7,137.9,36.5"}}),_c('path',{staticClass:"at1",attrs:{"d":"M146.5,33c-0.3,0-0.5-0.1-0.8-0.1c-0.9,0-1.7,0.4-2.2,1.1c-0.4,0.6-0.7,1.4-0.7,2.4v6.3h-2.7l0-8.2\n\t\tc0-1.4,0-2.6-0.1-3.8h2.3l0.1,2.3h0.1c0.3-0.8,0.7-1.4,1.3-1.9c0.6-0.4,1.2-0.6,1.9-0.6c0.2,0,0.5,0,0.7,0V33z"}}),_c('path',{staticClass:"at1",attrs:{"d":"M155.9,35.4c0-0.8-0.2-1.5-0.5-2c-0.5-0.7-1.2-1.1-2.1-1.1c-0.9,0-1.6,0.4-2.1,1.1c-0.4,0.6-0.7,1.3-0.8,2.1\n\t\tL155.9,35.4L155.9,35.4z M158.4,36c0,0.5,0,0.9-0.1,1.2h-7.9c0,1.2,0.4,2.1,1.2,2.7c0.7,0.6,1.5,0.8,2.6,0.8c1.2,0,2.2-0.2,3.2-0.6\n\t\tl0.4,1.8c-1.1,0.5-2.5,0.7-4,0.7c-1.8,0-3.3-0.5-4.4-1.6c-1.1-1.1-1.6-2.5-1.6-4.4c0-1.8,0.5-3.3,1.5-4.5c1-1.3,2.4-1.9,4.2-1.9\n\t\tc1.7,0,3,0.6,3.9,1.9C158,33.3,158.4,34.6,158.4,36"}})]),_c('polygon',{staticClass:"at2",attrs:{"points":"64.6,15.2 62.4,15.2 62.4,17 64.9,17 64.9,17.9 61.3,17.9 61.3,11.9 64.7,11.9 64.7,12.8 62.4,12.8\n\t62.4,14.4 64.6,14.4 "}}),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVG_ID_3_","x":"0","y":"0","width":"179.9","height":"54.5"}})]),_c('clipPath',{attrs:{"id":"SVG_ID_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVG_ID_3_"}})]),_c('path',{staticClass:"at3",attrs:{"d":"M66.2,15c0-0.6,0-1,0-1.4h0.9l0,0.8h0c0.2-0.6,0.7-0.9,1.2-0.9c0.1,0,0.2,0,0.3,0v1c-0.1,0-0.2,0-0.3,0\n\t\tc-0.5,0-0.9,0.3-1,0.8c0,0.1,0,0.2,0,0.3v2.2h-1.1L66.2,15L66.2,15z"}}),_c('path',{staticClass:"at3",attrs:{"d":"M69.7,11.6h1.1v2.6h0c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.5-0.2,0.8-0.2c0.7,0,1.5,0.5,1.5,1.9v2.6h-1.1v-2.4\n\t\tc0-0.6-0.2-1.1-0.8-1.1c-0.4,0-0.7,0.3-0.9,0.6c0,0.1,0,0.2,0,0.3v2.6h-1.1L69.7,11.6L69.7,11.6z"}}),_c('path',{staticClass:"at3",attrs:{"d":"M77.7,12.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5C78.2,12.6,78,12.9,77.7,12.9\n\t\tL77.7,12.9z M77.4,15.8c-0.8,0-1.5,0.1-1.5,0.8c0,0.4,0.3,0.6,0.6,0.6c0.4,0,0.8-0.3,0.9-0.6c0-0.1,0-0.2,0-0.2V15.8z M75.4,12.4\n\t\tc0-0.3,0.2-0.5,0.6-0.5c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5C75.6,12.9,75.4,12.6,75.4,12.4 M78.5,16.9c0,0.4,0,0.8,0.1,1\n\t\th-1l-0.1-0.5h0c-0.3,0.3-0.7,0.6-1.3,0.6c-0.9,0-1.4-0.6-1.4-1.3c0-1.1,1-1.6,2.6-1.6V15c0-0.3-0.1-0.8-0.9-0.8\n\t\tc-0.4,0-0.9,0.1-1.2,0.3l-0.2-0.7c0.3-0.2,0.9-0.4,1.6-0.4c1.4,0,1.8,0.9,1.8,1.8L78.5,16.9L78.5,16.9z"}})]),_c('rect',{staticClass:"at2",attrs:{"x":"80","y":"11.6","width":"1.1","height":"6.3"}}),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVG_ID_5_","x":"0","y":"0","width":"179.9","height":"54.5"}})]),_c('clipPath',{attrs:{"id":"SVG_ID_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVG_ID_5_"}})]),_c('path',{staticClass:"at4",attrs:{"d":"M83.9,12.5v1.1h1v0.8h-1v1.9c0,0.5,0.1,0.8,0.6,0.8c0.2,0,0.3,0,0.4,0l0,0.8c-0.2,0.1-0.5,0.1-0.8,0.1\n\t\tc-0.4,0-0.7-0.1-0.9-0.4c-0.2-0.2-0.3-0.6-0.3-1.2v-2h-0.6v-0.8h0.6v-0.8L83.9,12.5z"}})]),_c('rect',{staticClass:"at2",attrs:{"x":"86.2","y":"11.6","width":"1.1","height":"6.3"}}),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVG_ID_7_","x":"0","y":"0","width":"179.9","height":"54.5"}})]),_c('clipPath',{attrs:{"id":"SVG_ID_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVG_ID_7_"}})]),_c('path',{staticClass:"at5",attrs:{"d":"M88.8,13.6h1.1v4.3h-1.1V13.6z M90,12.4c0,0.3-0.2,0.6-0.6,0.6c-0.4,0-0.6-0.3-0.6-0.6c0-0.3,0.2-0.6,0.6-0.6\n\t\tC89.7,11.8,90,12,90,12.4"}}),_c('path',{staticClass:"at5",attrs:{"d":"M94.6,17.8C94.4,17.9,94,18,93.4,18c-1.3,0-2.2-0.9-2.2-2.2c0-1.3,0.9-2.3,2.4-2.3c0.4,0,0.8,0.1,1.1,0.2\n\t\tl-0.2,0.8c-0.2-0.1-0.4-0.2-0.8-0.2c-0.8,0-1.3,0.6-1.3,1.4c0,0.9,0.6,1.4,1.3,1.4c0.4,0,0.6-0.1,0.9-0.2L94.6,17.8z"}}),_c('path',{staticClass:"at5",attrs:{"d":"M95.8,11.6h1.1v2.6h0c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.5-0.2,0.8-0.2c0.7,0,1.5,0.5,1.5,1.9v2.6h-1.1v-2.4\n\t\tc0-0.6-0.2-1.1-0.8-1.1c-0.4,0-0.7,0.3-0.9,0.6c0,0.1,0,0.2,0,0.3v2.6h-1.1L95.8,11.6L95.8,11.6z"}}),_c('path',{staticClass:"at5",attrs:{"d":"M103.5,13.6h1.1v4.3h-1.1V13.6z M104.6,12.4c0,0.3-0.2,0.6-0.6,0.6c-0.4,0-0.6-0.3-0.6-0.6\n\t\tc0-0.3,0.2-0.6,0.6-0.6C104.4,11.8,104.6,12,104.6,12.4"}}),_c('path',{staticClass:"at5",attrs:{"d":"M106.1,14.9c0-0.5,0-0.9,0-1.3h0.9l0,0.6h0c0.2-0.3,0.6-0.7,1.3-0.7c0.6,0,1,0.3,1.2,0.8h0\n\t\tc0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.2,0.5-0.3,0.9-0.3c0.7,0,1.4,0.5,1.4,1.9v2.5h-1.1v-2.4c0-0.7-0.2-1.1-0.8-1.1\n\t\tc-0.4,0-0.6,0.3-0.8,0.6c0,0.1,0,0.2,0,0.4v2.6h-1.1v-2.5c0-0.6-0.2-1-0.7-1c-0.4,0-0.7,0.3-0.8,0.6c0,0.1,0,0.2,0,0.4v2.6h-1.1\n\t\tV14.9z"}})])])
}
var app_chvue_type_template_id_ec2a1f88_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/stores/app_ch.vue?vue&type=template&id=ec2a1f88

// EXTERNAL MODULE: ./src/components/svg/stores/app_ch.vue?vue&type=style&index=0&id=ec2a1f88&prod&lang=css
var app_chvue_type_style_index_0_id_ec2a1f88_prod_lang_css = __webpack_require__("5cbb");

// CONCATENATED MODULE: ./src/components/svg/stores/app_ch.vue

var app_ch_script = {}



/* normalize component */

var app_ch_component = normalizeComponent(
  app_ch_script,
  app_chvue_type_template_id_ec2a1f88_render,
  app_chvue_type_template_id_ec2a1f88_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var app_ch = (app_ch_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/stores/app_nl.vue?vue&type=template&id=91fdd616
var app_nlvue_type_template_id_91fdd616_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"185px","height":"54px","viewBox":"0 0 185 54","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("apple_store")]),_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Footer/Desktop","transform":"translate(-995.000000, -110.000000)","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"Group-8","transform":"translate(261.000000, 33.000000)"}},[_c('g',{attrs:{"id":"Linkliste/Accordion/Accordion-Copy-4","transform":"translate(716.000000, 0.000000)"}},[_c('g',{attrs:{"id":"apple_store","transform":"translate(18.000000, 77.000000)"}},[_c('g',{attrs:{"id":"Group","fill":"#000000"}},[_c('path',{attrs:{"d":"M10.6912148,53.74 C10.2778535,53.74 9.8644923,53.74 9.45113107,53.74 C8.62440862,53.74 7.65989909,53.6 6.83317663,53.46 C6.00645418,53.32 5.3175188,53.04 4.49079635,52.76 C3.80186097,52.34 3.11292559,51.92 2.56177729,51.36 C2.01062898,50.8 1.45948068,50.1 1.18390653,49.4 C0.770545301,48.7 0.632758225,47.86 0.494971149,47.02 C0.357184074,46.18 0.219396998,45.34 0.219396998,44.36 C0.219396998,44.08 0.219396998,43.1 0.219396998,43.1 L0.219396998,10.76 C0.219396998,10.76 0.219396998,9.78 0.219396998,9.5 C0.219396998,8.66 0.357184074,7.68 0.494971149,6.84 C0.632758225,6.14 0.908332377,5.3 1.3216936,4.6 C1.73505483,3.9 2.14841606,3.2 2.69956436,2.64 C3.25071266,2.08 3.93964804,1.66 4.62858342,1.24 C5.3175188,0.82 6.14424125,0.68 6.97096371,0.54 C7.79768616,0.4 8.62440862,0.26 9.58891815,0.26 L10.8290018,0.26 L174.244474,0.26 L175.484557,0.26 C176.31128,0.26 177.138002,0.4 178.102512,0.54 C178.929234,0.68 179.61817,0.96 180.444892,1.24 C181.822763,1.94 183.062846,3.2 183.751782,4.6 C184.165143,5.3 184.30293,6.14 184.440717,6.84 C184.578504,7.68 184.716291,8.66 184.716291,9.5 C184.716291,9.92 184.716291,10.34 184.716291,10.76 C184.716291,11.32 184.716291,11.74 184.716291,12.3 L184.716291,41.56 C184.716291,42.12 184.716291,42.54 184.716291,43.1 C184.716291,43.52 184.716291,43.94 184.716291,44.36 C184.716291,45.2 184.578504,46.04 184.440717,47.02 C184.30293,47.86 184.027356,48.56 183.751782,49.4 C183.338421,50.1 182.925059,50.8 182.373911,51.36 C181.822763,51.92 181.133827,52.48 180.444892,52.76 C179.755957,53.18 178.929234,53.46 178.102512,53.46 C177.275789,53.6 176.449067,53.74 175.484557,53.74 C175.071196,53.74 174.657835,53.74 174.244474,53.74 L172.728816,53.74 L10.6912148,53.74 Z","id":"Path"}})]),_c('g',{attrs:{"id":"_Group_","transform":"translate(12.000000, 8.000000)","fill":"#FFFFFF"}},[_c('g',{attrs:{"id":"_Group_3"}},[_c('path',{attrs:{"d":"M25.9722222,19.7785714 C25.9722222,16.9928571 27.5,14.2071429 30,12.675 C28.4722222,10.4464286 25.9722222,9.19285714 23.3333333,9.05357143 C20.5555556,8.775 17.7777778,10.725 16.25,10.725 C14.7222222,10.725 12.6388889,9.05357143 10.2777778,9.05357143 C7.08333333,9.19285714 4.30555556,10.8642857 2.77777778,13.65 C-0.416666667,19.2214286 1.94444444,27.5785714 5.13888889,32.0357143 C6.66666667,34.2642857 8.47222222,36.7714286 10.8333333,36.7714286 C13.1944444,36.6321429 14.0277778,35.2392857 16.8055556,35.2392857 C19.5833333,35.2392857 20.2777778,36.7714286 22.7777778,36.7714286 C25.2777778,36.7714286 26.8055556,34.5428571 28.3333333,32.175 C29.4444444,30.6428571 30.2777778,28.8321429 30.8333333,27.0214286 C27.9166667,26.0464286 25.9722222,22.9821429 25.9722222,19.7785714 Z","id":"_Path_"}}),_c('path',{attrs:{"d":"M21.3888889,6.26785714 C22.7777778,4.59642857 23.3333333,2.64642857 23.1944444,0.417857143 C21.25,0.557142857 19.1666667,1.53214286 17.7777778,3.20357143 C16.3888889,4.73571429 15.8333333,6.68571429 15.9722222,8.91428571 C18.1944444,8.91428571 20,7.93928571 21.3888889,6.26785714 Z","id":"_Path_2"}})]),_c('g',{attrs:{"id":"Group","transform":"translate(44.444444, 15.321429)"}},[_c('path',{attrs:{"d":"M10.9722222,14.0678571 L4.44444444,14.0678571 L2.91666667,18.8035714 L0.138888889,18.8035714 L6.38888889,1.53214286 L9.16666667,1.53214286 L15.4166667,18.8035714 L12.6388889,18.8035714 L10.9722222,14.0678571 Z M5.13888889,11.9785714 L10.4166667,11.9785714 L7.77777778,4.31785714 L7.63888889,4.31785714 L5.13888889,11.9785714 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M28.8888889,12.5357143 C28.8888889,16.4357143 26.8055556,18.9428571 23.6111111,18.9428571 C21.9444444,19.0821429 20.4166667,18.1071429 19.7222222,16.7142857 L19.7222222,16.7142857 L19.7222222,22.9821429 L17.0833333,22.9821429 L17.0833333,6.26785714 L19.5833333,6.26785714 L19.5833333,8.35714286 L19.5833333,8.35714286 C20.4166667,6.96428571 21.9444444,6.12857143 23.6111111,6.12857143 C26.6666667,5.98928571 28.8888889,8.63571429 28.8888889,12.5357143 Z M26.1111111,12.5357143 C26.1111111,10.0285714 24.8611111,8.35714286 22.7777778,8.35714286 C20.8333333,8.35714286 19.4444444,10.0285714 19.4444444,12.5357143 C19.4444444,15.0428571 20.8333333,16.7142857 22.7777778,16.7142857 C24.8611111,16.7142857 26.1111111,15.0428571 26.1111111,12.5357143 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M42.6388889,12.5357143 C42.6388889,16.4357143 40.5555556,18.9428571 37.3611111,18.9428571 C35.6944444,19.0821429 34.1666667,18.1071429 33.4722222,16.7142857 L33.4722222,16.7142857 L33.4722222,22.9821429 L30.8333333,22.9821429 L30.8333333,6.26785714 L33.3333333,6.26785714 L33.3333333,8.35714286 L33.3333333,8.35714286 C34.1666667,6.96428571 35.6944444,6.12857143 37.3611111,6.12857143 C40.5555556,5.98928571 42.6388889,8.63571429 42.6388889,12.5357143 Z M40,12.5357143 C40,10.0285714 38.75,8.35714286 36.6666667,8.35714286 C34.7222222,8.35714286 33.3333333,10.0285714 33.3333333,12.5357143 C33.3333333,15.0428571 34.7222222,16.7142857 36.6666667,16.7142857 C38.75,16.7142857 40,15.0428571 40,12.5357143 L40,12.5357143 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M51.8055556,13.9285714 C51.9444444,15.6 53.6111111,16.7142857 55.9722222,16.7142857 C58.1944444,16.7142857 59.7222222,15.6 59.7222222,14.0678571 C59.7222222,12.675 58.75,11.9785714 56.5277778,11.4214286 L54.3055556,10.8642857 C51.1111111,10.0285714 49.7222222,8.63571429 49.7222222,6.26785714 C49.7222222,3.34285714 52.3611111,1.25357143 55.9722222,1.25357143 C59.5833333,1.25357143 62.0833333,3.34285714 62.2222222,6.26785714 L59.5833333,6.26785714 C59.4444444,4.59642857 58.0555556,3.48214286 55.9722222,3.48214286 C53.8888889,3.48214286 52.5,4.59642857 52.5,6.12857143 C52.5,7.38214286 53.4722222,8.07857143 55.6944444,8.63571429 L57.6388889,9.05357143 C61.1111111,9.88928571 62.6388889,11.2821429 62.6388889,13.7892857 C62.6388889,16.9928571 60,19.0821429 55.9722222,19.0821429 C52.0833333,19.0821429 49.5833333,17.1321429 49.4444444,13.9285714 L51.8055556,13.9285714 L51.8055556,13.9285714 Z","id":"Path"}}),_c('path',{attrs:{"d":"M67.9166667,3.20357143 L67.9166667,6.12857143 L70.2777778,6.12857143 L70.2777778,8.21785714 L67.9166667,8.21785714 L67.9166667,15.1821429 C67.9166667,16.2964286 68.3333333,16.7142857 69.4444444,16.7142857 C69.7222222,16.7142857 70,16.7142857 70.2777778,16.7142857 L70.2777778,18.8035714 C69.8611111,18.9428571 69.3055556,18.9428571 68.8888889,18.9428571 C66.3888889,18.9428571 65.4166667,17.9678571 65.4166667,15.6 L65.4166667,8.35714286 L63.6111111,8.35714286 L63.6111111,6.26785714 L65.4166667,6.26785714 L65.4166667,3.34285714 L67.9166667,3.34285714 L67.9166667,3.20357143 L67.9166667,3.20357143 Z","id":"Path"}}),_c('path',{attrs:{"d":"M71.8055556,12.5357143 C71.8055556,8.63571429 74.1666667,6.12857143 77.7777778,6.12857143 C81.3888889,6.12857143 83.75,8.63571429 83.75,12.5357143 C83.75,16.575 81.3888889,18.9428571 77.7777778,18.9428571 C74.0277778,18.9428571 71.8055556,16.4357143 71.8055556,12.5357143 Z M81.1111111,12.5357143 C81.1111111,9.75 79.8611111,8.21785714 77.7777778,8.21785714 C75.6944444,8.21785714 74.4444444,9.75 74.4444444,12.5357143 C74.4444444,15.3214286 75.6944444,16.8535714 77.7777778,16.8535714 C79.8611111,16.8535714 81.1111111,15.1821429 81.1111111,12.5357143 L81.1111111,12.5357143 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M85.8333333,6.12857143 L88.3333333,6.12857143 L88.3333333,8.35714286 L88.3333333,8.35714286 C88.6111111,6.96428571 90,5.98928571 91.3888889,6.12857143 C91.6666667,6.12857143 91.9444444,6.12857143 92.2222222,6.26785714 L92.2222222,8.63571429 C91.8055556,8.49642857 91.3888889,8.49642857 91.1111111,8.49642857 C89.7222222,8.49642857 88.4722222,9.61071429 88.4722222,11.0035714 C88.4722222,11.1428571 88.4722222,11.2821429 88.4722222,11.4214286 L88.4722222,18.9428571 L85.8333333,18.9428571 L85.8333333,6.12857143 Z","id":"Path"}}),_c('path',{attrs:{"d":"M104.166667,15.0428571 C103.888889,17.2714286 101.527778,18.9428571 98.75,18.9428571 C95.1388889,18.9428571 92.7777778,16.4357143 92.7777778,12.5357143 C92.7777778,8.63571429 95,5.98928571 98.6111111,5.98928571 C102.083333,5.98928571 104.305556,8.35714286 104.305556,12.2571429 L104.305556,13.0928571 L95.4166667,13.0928571 L95.4166667,13.2321429 C95.2777778,15.0428571 96.5277778,16.575 98.3333333,16.8535714 C98.4722222,16.8535714 98.6111111,16.8535714 98.75,16.8535714 C100,16.9928571 101.25,16.2964286 101.666667,15.0428571 L104.166667,15.0428571 Z M95.4166667,11.2821429 L101.666667,11.2821429 C101.805556,9.61071429 100.416667,8.21785714 98.75,8.07857143 C98.6111111,8.07857143 98.6111111,8.07857143 98.4722222,8.07857143 C96.8055556,8.07857143 95.4166667,9.47142857 95.4166667,11.2821429 L95.4166667,11.2821429 Z","id":"Shape"}})])]),_c('path',{attrs:{"d":"M60.948,17 C62.068,17 62.966,16.668 63.642,16.004 C64.318,15.34 64.656,14.272 64.656,12.8 C64.656,11.336 64.318,10.27 63.642,9.602 C62.966,8.934 62.068,8.6 60.948,8.6 L60.948,8.6 L58.524,8.6 C58.396,8.6 58.304,8.628 58.248,8.684 C58.192,8.74 58.164,8.832 58.164,8.96 L58.164,8.96 L58.164,16.64 C58.164,16.768 58.192,16.86 58.248,16.916 C58.304,16.972 58.396,17 58.524,17 L58.524,17 L60.948,17 Z M60.864,16.088 L59.22,16.088 L59.22,9.512 L60.864,9.512 C61.672,9.512 62.324,9.778 62.82,10.31 C63.316,10.842 63.564,11.672 63.564,12.8 C63.564,13.936 63.316,14.768 62.82,15.296 C62.324,15.824 61.672,16.088 60.864,16.088 L60.864,16.088 Z M68.784,17.072 C69.68,17.072 70.358,16.802 70.818,16.262 C71.278,15.722 71.508,14.932 71.508,13.892 C71.508,12.844 71.274,12.042 70.806,11.486 C70.338,10.93 69.664,10.652 68.784,10.652 C67.888,10.652 67.2,10.932 66.72,11.492 C66.24,12.052 66,12.852 66,13.892 C66,14.924 66.238,15.712 66.714,16.256 C67.19,16.8 67.88,17.072 68.784,17.072 Z M68.748,16.208 C68.164,16.208 67.736,16.018 67.464,15.638 C67.192,15.258 67.056,14.668 67.056,13.868 C67.056,13.06 67.192,12.466 67.464,12.086 C67.736,11.706 68.164,11.516 68.748,11.516 C69.332,11.516 69.764,11.708 70.044,12.092 C70.324,12.476 70.464,13.068 70.464,13.868 C70.464,14.668 70.324,15.258 70.044,15.638 C69.764,16.018 69.332,16.208 68.748,16.208 Z M75.012,17.024 C75.3,17.024 75.46,16.96 75.492,16.832 L75.492,16.832 L76.476,13.016 C76.532,12.8 76.592,12.492 76.656,12.092 C76.72,12.492 76.78,12.804 76.836,13.028 L76.836,13.028 L77.796,16.832 C77.828,16.96 77.984,17.024 78.264,17.024 L78.264,17.024 L78.624,17.024 C78.912,17.024 79.072,16.96 79.104,16.832 L79.104,16.832 L80.712,11.072 C80.736,11 80.748,10.944 80.748,10.904 C80.748,10.768 80.588,10.7 80.268,10.7 C79.972,10.7 79.808,10.764 79.776,10.892 L79.776,10.892 L78.768,14.744 C78.688,15.064 78.616,15.416 78.552,15.8 C78.52,15.928 78.5,16.024 78.492,16.088 C78.476,16.008 78.446,15.854 78.402,15.626 C78.358,15.398 78.288,15.096 78.192,14.72 L78.192,14.72 L77.184,10.904 C77.144,10.768 76.988,10.7 76.716,10.7 L76.716,10.7 L76.632,10.7 C76.352,10.7 76.196,10.768 76.164,10.904 L76.164,10.904 L75.168,14.72 C75.056,15.104 74.956,15.564 74.868,16.1 C74.836,15.94 74.808,15.816 74.784,15.728 C74.76,15.608 74.688,15.276 74.568,14.732 L74.568,14.732 L73.56,10.892 C73.528,10.764 73.368,10.7 73.08,10.7 C72.712,10.7 72.528,10.768 72.528,10.904 C72.528,10.944 72.548,11.024 72.588,11.144 L72.588,11.144 L74.172,16.832 C74.204,16.96 74.364,17.024 74.652,17.024 L74.652,17.024 L75.012,17.024 Z M82.692,17.024 C83.012,17.024 83.172,16.936 83.172,16.76 L83.172,16.76 L83.172,12.368 C83.372,12.112 83.606,11.908 83.874,11.756 C84.142,11.604 84.412,11.528 84.684,11.528 C85.076,11.528 85.378,11.63 85.59,11.834 C85.802,12.038 85.908,12.324 85.908,12.692 L85.908,12.692 L85.908,16.76 C85.908,16.936 86.068,17.024 86.388,17.024 L86.388,17.024 L86.436,17.024 C86.756,17.024 86.916,16.936 86.916,16.76 L86.916,16.76 L86.916,12.596 C86.916,11.988 86.742,11.512 86.394,11.168 C86.046,10.824 85.568,10.652 84.96,10.652 C84.624,10.652 84.292,10.732 83.964,10.892 C83.636,11.052 83.344,11.272 83.088,11.552 C83.08,11.512 83.062,11.428 83.034,11.3 C83.006,11.172 82.966,11.05 82.914,10.934 C82.862,10.818 82.78,10.76 82.668,10.76 C82.54,10.76 82.4,10.782 82.248,10.826 C82.096,10.87 82.02,10.94 82.02,11.036 C82.02,11.06 82.044,11.186 82.092,11.414 C82.14,11.642 82.164,12.02 82.164,12.548 L82.164,12.548 L82.164,16.76 C82.164,16.936 82.324,17.024 82.644,17.024 L82.644,17.024 L82.692,17.024 Z M90.348,17.072 C90.932,17.072 91.224,16.952 91.224,16.712 C91.224,16.632 91.2,16.518 91.152,16.37 C91.104,16.222 91.044,16.148 90.972,16.148 C90.932,16.148 90.874,16.158 90.798,16.178 C90.722,16.198 90.608,16.208 90.456,16.208 C90.256,16.208 90.098,16.144 89.982,16.016 C89.866,15.888 89.808,15.656 89.808,15.32 L89.808,15.32 L89.808,8.24 C89.808,8.064 89.648,7.976 89.328,7.976 L89.328,7.976 L89.28,7.976 C88.96,7.976 88.8,8.064 88.8,8.24 L88.8,8.24 L88.8,15.416 C88.8,16.032 88.958,16.462 89.274,16.706 C89.59,16.95 89.948,17.072 90.348,17.072 Z M94.824,17.072 C95.72,17.072 96.398,16.802 96.858,16.262 C97.318,15.722 97.548,14.932 97.548,13.892 C97.548,12.844 97.314,12.042 96.846,11.486 C96.378,10.93 95.704,10.652 94.824,10.652 C93.928,10.652 93.24,10.932 92.76,11.492 C92.28,12.052 92.04,12.852 92.04,13.892 C92.04,14.924 92.278,15.712 92.754,16.256 C93.23,16.8 93.92,17.072 94.824,17.072 Z M94.788,16.208 C94.204,16.208 93.776,16.018 93.504,15.638 C93.232,15.258 93.096,14.668 93.096,13.868 C93.096,13.06 93.232,12.466 93.504,12.086 C93.776,11.706 94.204,11.516 94.788,11.516 C95.372,11.516 95.804,11.708 96.084,12.092 C96.364,12.476 96.504,13.068 96.504,13.868 C96.504,14.668 96.364,15.258 96.084,15.638 C95.804,16.018 95.372,16.208 94.788,16.208 Z M100.848,17.072 C101.648,17.072 102.32,16.772 102.864,16.172 C102.872,16.212 102.89,16.3 102.918,16.436 C102.946,16.572 102.986,16.702 103.038,16.826 C103.09,16.95 103.172,17.012 103.284,17.012 C103.412,17.012 103.552,16.99 103.704,16.946 C103.856,16.902 103.932,16.832 103.932,16.736 C103.932,16.712 103.908,16.586 103.86,16.358 C103.812,16.13 103.788,15.752 103.788,15.224 L103.788,15.224 L103.788,12.536 C103.788,11.944 103.58,11.482 103.164,11.15 C102.748,10.818 102.168,10.652 101.424,10.652 C101.048,10.652 100.684,10.694 100.332,10.778 C99.98,10.862 99.698,10.964 99.486,11.084 C99.274,11.204 99.168,11.316 99.168,11.42 C99.168,11.5 99.218,11.62 99.318,11.78 C99.418,11.94 99.508,12.02 99.588,12.02 C99.604,12.02 99.7,11.978 99.876,11.894 C100.052,11.81 100.272,11.726 100.536,11.642 C100.8,11.558 101.108,11.516 101.46,11.516 C101.924,11.516 102.26,11.61 102.468,11.798 C102.676,11.986 102.78,12.228 102.78,12.524 L102.78,12.524 L102.78,13.088 C101.988,13.096 101.316,13.146 100.764,13.238 C100.212,13.33 99.746,13.534 99.366,13.85 C98.986,14.166 98.796,14.64 98.796,15.272 C98.796,15.864 98.984,16.312 99.36,16.616 C99.736,16.92 100.232,17.072 100.848,17.072 Z M100.896,16.196 C100.56,16.196 100.306,16.112 100.134,15.944 C99.962,15.776 99.876,15.532 99.876,15.212 C99.876,14.828 100.02,14.544 100.308,14.36 C100.596,14.176 100.93,14.064 101.31,14.024 C101.69,13.984 102.18,13.96 102.78,13.952 L102.78,13.952 L102.78,15.368 C102.484,15.632 102.194,15.836 101.91,15.98 C101.626,16.124 101.288,16.196 100.896,16.196 Z M107.7,17.072 C108.396,17.072 109.032,16.772 109.608,16.172 C109.616,16.212 109.634,16.3 109.662,16.436 C109.69,16.572 109.73,16.702 109.782,16.826 C109.834,16.95 109.916,17.012 110.028,17.012 C110.156,17.012 110.296,16.99 110.448,16.946 C110.6,16.902 110.676,16.832 110.676,16.736 C110.676,16.712 110.652,16.586 110.604,16.358 C110.556,16.13 110.532,15.752 110.532,15.224 L110.532,15.224 L110.532,8.24 C110.532,8.064 110.372,7.976 110.052,7.976 L110.052,7.976 L110.004,7.976 C109.684,7.976 109.524,8.064 109.524,8.24 L109.524,8.24 L109.524,11.264 C109.268,11.064 109.006,10.912 108.738,10.808 C108.47,10.704 108.16,10.652 107.808,10.652 C107.328,10.652 106.904,10.776 106.536,11.024 C106.168,11.272 105.882,11.638 105.678,12.122 C105.474,12.606 105.372,13.188 105.372,13.868 C105.372,14.484 105.466,15.036 105.654,15.524 C105.842,16.012 106.112,16.392 106.464,16.664 C106.816,16.936 107.228,17.072 107.7,17.072 Z M107.904,16.196 C107.432,16.196 107.068,15.986 106.812,15.566 C106.556,15.146 106.428,14.548 106.428,13.772 C106.428,13.052 106.564,12.502 106.836,12.122 C107.108,11.742 107.512,11.548 108.048,11.54 C108.6,11.54 109.092,11.72 109.524,12.08 L109.524,12.08 L109.524,15.368 C109.284,15.632 109.022,15.836 108.738,15.98 C108.454,16.124 108.176,16.196 107.904,16.196 Z M116.076,9.212 C116.396,9.212 116.556,9.124 116.556,8.948 L116.556,8.948 L116.556,8.24 C116.556,8.064 116.396,7.976 116.076,7.976 L116.076,7.976 L115.932,7.976 C115.612,7.976 115.452,8.064 115.452,8.24 L115.452,8.24 L115.452,8.948 C115.452,9.124 115.612,9.212 115.932,9.212 L115.932,9.212 L116.076,9.212 Z M116.028,17.024 C116.348,17.024 116.508,16.936 116.508,16.76 L116.508,16.76 L116.508,10.964 C116.508,10.788 116.348,10.7 116.028,10.7 L116.028,10.7 L115.98,10.7 C115.66,10.7 115.5,10.788 115.5,10.964 L115.5,10.964 L115.5,16.76 C115.5,16.936 115.66,17.024 115.98,17.024 L115.98,17.024 L116.028,17.024 Z M119.148,17.024 C119.468,17.024 119.628,16.936 119.628,16.76 L119.628,16.76 L119.628,12.368 C119.828,12.112 120.062,11.908 120.33,11.756 C120.598,11.604 120.868,11.528 121.14,11.528 C121.532,11.528 121.834,11.63 122.046,11.834 C122.258,12.038 122.364,12.324 122.364,12.692 L122.364,12.692 L122.364,16.76 C122.364,16.936 122.524,17.024 122.844,17.024 L122.844,17.024 L122.892,17.024 C123.212,17.024 123.372,16.936 123.372,16.76 L123.372,16.76 L123.372,12.596 C123.372,11.988 123.198,11.512 122.85,11.168 C122.502,10.824 122.024,10.652 121.416,10.652 C121.08,10.652 120.748,10.732 120.42,10.892 C120.092,11.052 119.8,11.272 119.544,11.552 C119.536,11.512 119.518,11.428 119.49,11.3 C119.462,11.172 119.422,11.05 119.37,10.934 C119.318,10.818 119.236,10.76 119.124,10.76 C118.996,10.76 118.856,10.782 118.704,10.826 C118.552,10.87 118.476,10.94 118.476,11.036 C118.476,11.06 118.5,11.186 118.548,11.414 C118.596,11.642 118.62,12.02 118.62,12.548 L118.62,12.548 L118.62,16.76 C118.62,16.936 118.78,17.024 119.1,17.024 L119.1,17.024 L119.148,17.024 Z M130.104,17.072 C130.8,17.072 131.436,16.772 132.012,16.172 C132.02,16.212 132.038,16.3 132.066,16.436 C132.094,16.572 132.134,16.702 132.186,16.826 C132.238,16.95 132.32,17.012 132.432,17.012 C132.56,17.012 132.7,16.99 132.852,16.946 C133.004,16.902 133.08,16.832 133.08,16.736 C133.08,16.712 133.056,16.586 133.008,16.358 C132.96,16.13 132.936,15.752 132.936,15.224 L132.936,15.224 L132.936,8.24 C132.936,8.064 132.776,7.976 132.456,7.976 L132.456,7.976 L132.408,7.976 C132.088,7.976 131.928,8.064 131.928,8.24 L131.928,8.24 L131.928,11.264 C131.672,11.064 131.41,10.912 131.142,10.808 C130.874,10.704 130.564,10.652 130.212,10.652 C129.732,10.652 129.308,10.776 128.94,11.024 C128.572,11.272 128.286,11.638 128.082,12.122 C127.878,12.606 127.776,13.188 127.776,13.868 C127.776,14.484 127.87,15.036 128.058,15.524 C128.246,16.012 128.516,16.392 128.868,16.664 C129.22,16.936 129.632,17.072 130.104,17.072 Z M130.308,16.196 C129.836,16.196 129.472,15.986 129.216,15.566 C128.96,15.146 128.832,14.548 128.832,13.772 C128.832,13.052 128.968,12.502 129.24,12.122 C129.512,11.742 129.916,11.548 130.452,11.54 C131.004,11.54 131.496,11.72 131.928,12.08 L131.928,12.08 L131.928,15.368 C131.688,15.632 131.426,15.836 131.142,15.98 C130.858,16.124 130.58,16.196 130.308,16.196 Z M137.532,17.072 C137.908,17.072 138.262,17.03 138.594,16.946 C138.926,16.862 139.192,16.758 139.392,16.634 C139.592,16.51 139.692,16.4 139.692,16.304 C139.692,16.224 139.642,16.104 139.542,15.944 C139.442,15.784 139.352,15.704 139.272,15.704 C139.248,15.704 139.156,15.746 138.996,15.83 C138.836,15.914 138.634,15.998 138.39,16.082 C138.146,16.166 137.856,16.208 137.52,16.208 C136.928,16.208 136.484,16.052 136.188,15.74 C135.892,15.428 135.72,14.94 135.672,14.276 L135.672,14.276 L139.464,14.276 C139.536,14.276 139.62,14.212 139.716,14.084 C139.812,13.956 139.86,13.856 139.86,13.784 C139.86,12.76 139.652,11.982 139.236,11.45 C138.82,10.918 138.204,10.652 137.388,10.652 C136.468,10.652 135.772,10.928 135.3,11.48 C134.828,12.032 134.592,12.84 134.592,13.904 C134.592,14.976 134.832,15.772 135.312,16.292 C135.792,16.812 136.532,17.072 137.532,17.072 Z M138.792,13.412 L135.672,13.412 C135.76,12.148 136.32,11.516 137.352,11.516 C138.312,11.516 138.792,12.148 138.792,13.412 L138.792,13.412 Z","id":"Downloadinde","fill":"#FFFFFF"}})])])])])])])
}
var app_nlvue_type_template_id_91fdd616_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/stores/app_nl.vue?vue&type=template&id=91fdd616

// CONCATENATED MODULE: ./src/components/svg/stores/app_nl.vue

var app_nl_script = {}


/* normalize component */

var app_nl_component = normalizeComponent(
  app_nl_script,
  app_nlvue_type_template_id_91fdd616_render,
  app_nlvue_type_template_id_91fdd616_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var app_nl = (app_nl_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/stores/app_es.vue?vue&type=template&id=6725dc26
var app_esvue_type_template_id_6725dc26_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"185px","height":"54px","viewBox":"0 0 185 54","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("apple_store_es")]),_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"apple_store_es","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"Group","fill":"#000000"}},[_c('path',{attrs:{"d":"M10.6912148,53.74 C10.2778535,53.74 9.8644923,53.74 9.45113107,53.74 C8.62440862,53.74 7.65989909,53.6 6.83317663,53.46 C6.00645418,53.32 5.3175188,53.04 4.49079635,52.76 C3.80186097,52.34 3.11292559,51.92 2.56177729,51.36 C2.01062898,50.8 1.45948068,50.1 1.18390653,49.4 C0.770545301,48.7 0.632758225,47.86 0.494971149,47.02 C0.357184074,46.18 0.219396998,45.34 0.219396998,44.36 C0.219396998,44.08 0.219396998,43.1 0.219396998,43.1 L0.219396998,10.76 C0.219396998,10.76 0.219396998,9.78 0.219396998,9.5 C0.219396998,8.66 0.357184074,7.68 0.494971149,6.84 C0.632758225,6.14 0.908332377,5.3 1.3216936,4.6 C1.73505483,3.9 2.14841606,3.2 2.69956436,2.64 C3.25071266,2.08 3.93964804,1.66 4.62858342,1.24 C5.3175188,0.82 6.14424125,0.68 6.97096371,0.54 C7.79768616,0.4 8.62440862,0.26 9.58891815,0.26 L10.8290018,0.26 L174.244474,0.26 L175.484557,0.26 C176.31128,0.26 177.138002,0.4 178.102512,0.54 C178.929234,0.68 179.61817,0.96 180.444892,1.24 C181.822763,1.94 183.062846,3.2 183.751782,4.6 C184.165143,5.3 184.30293,6.14 184.440717,6.84 C184.578504,7.68 184.716291,8.66 184.716291,9.5 C184.716291,9.92 184.716291,10.34 184.716291,10.76 C184.716291,11.32 184.716291,11.74 184.716291,12.3 L184.716291,41.56 C184.716291,42.12 184.716291,42.54 184.716291,43.1 C184.716291,43.52 184.716291,43.94 184.716291,44.36 C184.716291,45.2 184.578504,46.04 184.440717,47.02 C184.30293,47.86 184.027356,48.56 183.751782,49.4 C183.338421,50.1 182.925059,50.8 182.373911,51.36 C181.822763,51.92 181.133827,52.48 180.444892,52.76 C179.755957,53.18 178.929234,53.46 178.102512,53.46 C177.275789,53.6 176.449067,53.74 175.484557,53.74 C175.071196,53.74 174.657835,53.74 174.244474,53.74 L172.728816,53.74 L10.6912148,53.74 Z","id":"Path"}})]),_c('g',{attrs:{"id":"_Group_","transform":"translate(12.000000, 8.000000)","fill":"#FFFFFF"}},[_c('g',{attrs:{"id":"_Group_3"}},[_c('path',{attrs:{"d":"M25.9722222,19.7785714 C25.9722222,16.9928571 27.5,14.2071429 30,12.675 C28.4722222,10.4464286 25.9722222,9.19285714 23.3333333,9.05357143 C20.5555556,8.775 17.7777778,10.725 16.25,10.725 C14.7222222,10.725 12.6388889,9.05357143 10.2777778,9.05357143 C7.08333333,9.19285714 4.30555556,10.8642857 2.77777778,13.65 C-0.416666667,19.2214286 1.94444444,27.5785714 5.13888889,32.0357143 C6.66666667,34.2642857 8.47222222,36.7714286 10.8333333,36.7714286 C13.1944444,36.6321429 14.0277778,35.2392857 16.8055556,35.2392857 C19.5833333,35.2392857 20.2777778,36.7714286 22.7777778,36.7714286 C25.2777778,36.7714286 26.8055556,34.5428571 28.3333333,32.175 C29.4444444,30.6428571 30.2777778,28.8321429 30.8333333,27.0214286 C27.9166667,26.0464286 25.9722222,22.9821429 25.9722222,19.7785714 Z","id":"_Path_"}}),_c('path',{attrs:{"d":"M21.3888889,6.26785714 C22.7777778,4.59642857 23.3333333,2.64642857 23.1944444,0.417857143 C21.25,0.557142857 19.1666667,1.53214286 17.7777778,3.20357143 C16.3888889,4.73571429 15.8333333,6.68571429 15.9722222,8.91428571 C18.1944444,8.91428571 20,7.93928571 21.3888889,6.26785714 Z","id":"_Path_2"}})]),_c('g',{attrs:{"id":"Group","transform":"translate(44.444444, 16.321429)"}},[_c('path',{attrs:{"d":"M10.9722222,13.0678571 L4.44444444,13.0678571 L2.91666667,17.8035714 L0.138888889,17.8035714 L6.38888889,0.532142857 L9.16666667,0.532142857 L15.4166667,17.8035714 L12.6388889,17.8035714 L10.9722222,13.0678571 Z M5.13888889,10.9785714 L10.4166667,10.9785714 L7.77777778,3.31785714 L7.63888889,3.31785714 L5.13888889,10.9785714 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M28.8888889,11.5357143 C28.8888889,15.4357143 26.8055556,17.9428571 23.6111111,17.9428571 C21.9444444,18.0821429 20.4166667,17.1071429 19.7222222,15.7142857 L19.7222222,15.7142857 L19.7222222,21.9821429 L17.0833333,21.9821429 L17.0833333,5.26785714 L19.5833333,5.26785714 L19.5833333,7.35714286 L19.5833333,7.35714286 C20.4166667,5.96428571 21.9444444,5.12857143 23.6111111,5.12857143 C26.6666667,4.98928571 28.8888889,7.63571429 28.8888889,11.5357143 Z M26.1111111,11.5357143 C26.1111111,9.02857143 24.8611111,7.35714286 22.7777778,7.35714286 C20.8333333,7.35714286 19.4444444,9.02857143 19.4444444,11.5357143 C19.4444444,14.0428571 20.8333333,15.7142857 22.7777778,15.7142857 C24.8611111,15.7142857 26.1111111,14.0428571 26.1111111,11.5357143 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M42.6388889,11.5357143 C42.6388889,15.4357143 40.5555556,17.9428571 37.3611111,17.9428571 C35.6944444,18.0821429 34.1666667,17.1071429 33.4722222,15.7142857 L33.4722222,15.7142857 L33.4722222,21.9821429 L30.8333333,21.9821429 L30.8333333,5.26785714 L33.3333333,5.26785714 L33.3333333,7.35714286 L33.3333333,7.35714286 C34.1666667,5.96428571 35.6944444,5.12857143 37.3611111,5.12857143 C40.5555556,4.98928571 42.6388889,7.63571429 42.6388889,11.5357143 Z M40,11.5357143 C40,9.02857143 38.75,7.35714286 36.6666667,7.35714286 C34.7222222,7.35714286 33.3333333,9.02857143 33.3333333,11.5357143 C33.3333333,14.0428571 34.7222222,15.7142857 36.6666667,15.7142857 C38.75,15.7142857 40,14.0428571 40,11.5357143 L40,11.5357143 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M51.8055556,12.9285714 C51.9444444,14.6 53.6111111,15.7142857 55.9722222,15.7142857 C58.1944444,15.7142857 59.7222222,14.6 59.7222222,13.0678571 C59.7222222,11.675 58.75,10.9785714 56.5277778,10.4214286 L54.3055556,9.86428571 C51.1111111,9.02857143 49.7222222,7.63571429 49.7222222,5.26785714 C49.7222222,2.34285714 52.3611111,0.253571429 55.9722222,0.253571429 C59.5833333,0.253571429 62.0833333,2.34285714 62.2222222,5.26785714 L59.5833333,5.26785714 C59.4444444,3.59642857 58.0555556,2.48214286 55.9722222,2.48214286 C53.8888889,2.48214286 52.5,3.59642857 52.5,5.12857143 C52.5,6.38214286 53.4722222,7.07857143 55.6944444,7.63571429 L57.6388889,8.05357143 C61.1111111,8.88928571 62.6388889,10.2821429 62.6388889,12.7892857 C62.6388889,15.9928571 60,18.0821429 55.9722222,18.0821429 C52.0833333,18.0821429 49.5833333,16.1321429 49.4444444,12.9285714 L51.8055556,12.9285714 L51.8055556,12.9285714 Z","id":"Path"}}),_c('path',{attrs:{"d":"M67.9166667,2.20357143 L67.9166667,5.12857143 L70.2777778,5.12857143 L70.2777778,7.21785714 L67.9166667,7.21785714 L67.9166667,14.1821429 C67.9166667,15.2964286 68.3333333,15.7142857 69.4444444,15.7142857 C69.7222222,15.7142857 70,15.7142857 70.2777778,15.7142857 L70.2777778,17.8035714 C69.8611111,17.9428571 69.3055556,17.9428571 68.8888889,17.9428571 C66.3888889,17.9428571 65.4166667,16.9678571 65.4166667,14.6 L65.4166667,7.35714286 L63.6111111,7.35714286 L63.6111111,5.26785714 L65.4166667,5.26785714 L65.4166667,2.34285714 L67.9166667,2.34285714 L67.9166667,2.20357143 L67.9166667,2.20357143 Z","id":"Path"}}),_c('path',{attrs:{"d":"M71.8055556,11.5357143 C71.8055556,7.63571429 74.1666667,5.12857143 77.7777778,5.12857143 C81.3888889,5.12857143 83.75,7.63571429 83.75,11.5357143 C83.75,15.575 81.3888889,17.9428571 77.7777778,17.9428571 C74.0277778,17.9428571 71.8055556,15.4357143 71.8055556,11.5357143 Z M81.1111111,11.5357143 C81.1111111,8.75 79.8611111,7.21785714 77.7777778,7.21785714 C75.6944444,7.21785714 74.4444444,8.75 74.4444444,11.5357143 C74.4444444,14.3214286 75.6944444,15.8535714 77.7777778,15.8535714 C79.8611111,15.8535714 81.1111111,14.1821429 81.1111111,11.5357143 L81.1111111,11.5357143 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M85.8333333,5.12857143 L88.3333333,5.12857143 L88.3333333,7.35714286 L88.3333333,7.35714286 C88.6111111,5.96428571 90,4.98928571 91.3888889,5.12857143 C91.6666667,5.12857143 91.9444444,5.12857143 92.2222222,5.26785714 L92.2222222,7.63571429 C91.8055556,7.49642857 91.3888889,7.49642857 91.1111111,7.49642857 C89.7222222,7.49642857 88.4722222,8.61071429 88.4722222,10.0035714 C88.4722222,10.1428571 88.4722222,10.2821429 88.4722222,10.4214286 L88.4722222,17.9428571 L85.8333333,17.9428571 L85.8333333,5.12857143 Z","id":"Path"}}),_c('path',{attrs:{"d":"M104.166667,14.0428571 C103.888889,16.2714286 101.527778,17.9428571 98.75,17.9428571 C95.1388889,17.9428571 92.7777778,15.4357143 92.7777778,11.5357143 C92.7777778,7.63571429 95,4.98928571 98.6111111,4.98928571 C102.083333,4.98928571 104.305556,7.35714286 104.305556,11.2571429 L104.305556,12.0928571 L95.4166667,12.0928571 L95.4166667,12.2321429 C95.2777778,14.0428571 96.5277778,15.575 98.3333333,15.8535714 C98.4722222,15.8535714 98.6111111,15.8535714 98.75,15.8535714 C100,15.9928571 101.25,15.2964286 101.666667,14.0428571 L104.166667,14.0428571 Z M95.4166667,10.2821429 L101.666667,10.2821429 C101.805556,8.61071429 100.416667,7.21785714 98.75,7.07857143 C98.6111111,7.07857143 98.6111111,7.07857143 98.4722222,7.07857143 C96.8055556,7.07857143 95.4166667,8.47142857 95.4166667,10.2821429 L95.4166667,10.2821429 Z","id":"Shape"}})])]),_c('path',{attrs:{"d":"M61.548,17.072 C61.988,17.072 62.398,17.024 62.778,16.928 C63.158,16.832 63.462,16.716 63.69,16.58 C63.918,16.444 64.032,16.32 64.032,16.208 C64.032,16.128 63.98,16 63.876,15.824 C63.772,15.648 63.684,15.56 63.612,15.56 C63.572,15.56 63.496,15.596 63.384,15.668 C63.112,15.812 62.836,15.93 62.556,16.022 C62.276,16.114 61.94,16.16 61.548,16.16 C60.604,16.16 59.906,15.89 59.454,15.35 C59.002,14.81 58.776,13.964 58.776,12.812 C58.776,11.636 59.004,10.78 59.46,10.244 C59.916,9.708 60.628,9.44 61.596,9.44 C61.932,9.44 62.23,9.478 62.49,9.554 C62.75,9.63 62.97,9.718 63.15,9.818 C63.33,9.918 63.432,9.968 63.456,9.968 C63.528,9.968 63.614,9.88 63.714,9.704 C63.814,9.528 63.864,9.384 63.864,9.272 C63.864,9.168 63.754,9.056 63.534,8.936 C63.314,8.816 63.026,8.718 62.67,8.642 C62.314,8.566 61.948,8.528 61.572,8.528 C58.98,8.528 57.684,9.952 57.684,12.8 C57.684,14.264 57.998,15.342 58.626,16.034 C59.254,16.726 60.228,17.072 61.548,17.072 Z M67.872,17.072 C68.768,17.072 69.446,16.802 69.906,16.262 C70.366,15.722 70.596,14.932 70.596,13.892 C70.596,12.844 70.362,12.042 69.894,11.486 C69.426,10.93 68.752,10.652 67.872,10.652 C66.976,10.652 66.288,10.932 65.808,11.492 C65.328,12.052 65.088,12.852 65.088,13.892 C65.088,14.924 65.326,15.712 65.802,16.256 C66.278,16.8 66.968,17.072 67.872,17.072 Z M67.836,16.208 C67.252,16.208 66.824,16.018 66.552,15.638 C66.28,15.258 66.144,14.668 66.144,13.868 C66.144,13.06 66.28,12.466 66.552,12.086 C66.824,11.706 67.252,11.516 67.836,11.516 C68.42,11.516 68.852,11.708 69.132,12.092 C69.412,12.476 69.552,13.068 69.552,13.868 C69.552,14.668 69.412,15.258 69.132,15.638 C68.852,16.018 68.42,16.208 67.836,16.208 Z M72.816,17.024 C73.136,17.024 73.296,16.936 73.296,16.76 L73.296,16.76 L73.296,12.368 C73.496,12.112 73.73,11.908 73.998,11.756 C74.266,11.604 74.536,11.528 74.808,11.528 C75.2,11.528 75.502,11.63 75.714,11.834 C75.926,12.038 76.032,12.324 76.032,12.692 L76.032,12.692 L76.032,16.76 C76.032,16.936 76.192,17.024 76.512,17.024 L76.512,17.024 L76.56,17.024 C76.88,17.024 77.04,16.936 77.04,16.76 L77.04,16.76 L77.04,12.596 C77.04,11.988 76.866,11.512 76.518,11.168 C76.17,10.824 75.692,10.652 75.084,10.652 C74.748,10.652 74.416,10.732 74.088,10.892 C73.76,11.052 73.468,11.272 73.212,11.552 C73.204,11.512 73.186,11.428 73.158,11.3 C73.13,11.172 73.09,11.05 73.038,10.934 C72.986,10.818 72.904,10.76 72.792,10.76 C72.664,10.76 72.524,10.782 72.372,10.826 C72.22,10.87 72.144,10.94 72.144,11.036 C72.144,11.06 72.168,11.186 72.216,11.414 C72.264,11.642 72.288,12.02 72.288,12.548 L72.288,12.548 L72.288,16.76 C72.288,16.936 72.448,17.024 72.768,17.024 L72.768,17.024 L72.816,17.024 Z M80.268,17.108 C80.66,17.108 81.018,17.026 81.342,16.862 C81.666,16.698 81.922,16.474 82.11,16.19 C82.298,15.906 82.392,15.588 82.392,15.236 C82.392,14.868 82.334,14.57 82.218,14.342 C82.102,14.114 81.91,13.922 81.642,13.766 C81.374,13.61 80.984,13.452 80.472,13.292 C80.136,13.188 79.896,13.056 79.752,12.896 C79.608,12.736 79.536,12.52 79.536,12.248 C79.536,12.016 79.638,11.832 79.842,11.696 C80.046,11.56 80.3,11.492 80.604,11.492 C80.932,11.492 81.19,11.542 81.378,11.642 C81.566,11.742 81.672,11.796 81.696,11.804 C81.768,11.804 81.85,11.722 81.942,11.558 C82.034,11.394 82.08,11.26 82.08,11.156 C82.08,11.02 81.918,10.9 81.594,10.796 C81.27,10.692 80.904,10.64 80.496,10.64 C80.112,10.64 79.77,10.714 79.47,10.862 C79.17,11.01 78.934,11.216 78.762,11.48 C78.59,11.744 78.504,12.044 78.504,12.38 C78.504,12.844 78.624,13.214 78.864,13.49 C79.104,13.766 79.54,13.996 80.172,14.18 C80.62,14.308 80.932,14.452 81.108,14.612 C81.284,14.772 81.372,14.988 81.372,15.26 C81.372,15.908 80.98,16.232 80.196,16.232 C79.948,16.232 79.722,16.196 79.518,16.124 C79.314,16.052 79.144,15.972 79.008,15.884 C78.872,15.796 78.796,15.752 78.78,15.752 C78.7,15.752 78.61,15.832 78.51,15.992 C78.41,16.152 78.36,16.272 78.36,16.352 C78.36,16.448 78.446,16.556 78.618,16.676 C78.79,16.796 79.022,16.898 79.314,16.982 C79.606,17.066 79.924,17.108 80.268,17.108 Z M84.288,9.98 C84.568,9.98 84.772,9.908 84.9,9.764 L84.9,9.764 L85.356,9.248 C85.668,8.896 85.858,8.674 85.926,8.582 C85.994,8.49 86.028,8.42 86.028,8.372 C86.028,8.316 85.982,8.276 85.89,8.252 C85.798,8.228 85.652,8.216 85.452,8.216 C85.26,8.216 85.104,8.24 84.984,8.288 C84.864,8.336 84.772,8.416 84.708,8.528 C84.476,8.928 84.302,9.236 84.186,9.452 C84.07,9.668 84.012,9.804 84.012,9.86 C84.012,9.94 84.104,9.98 84.288,9.98 Z M84.516,17.024 C84.836,17.024 84.996,16.936 84.996,16.76 L84.996,16.76 L84.996,10.964 C84.996,10.788 84.836,10.7 84.516,10.7 L84.516,10.7 L84.468,10.7 C84.148,10.7 83.988,10.788 83.988,10.964 L83.988,10.964 L83.988,16.76 C83.988,16.936 84.148,17.024 84.468,17.024 L84.468,17.024 L84.516,17.024 Z M89.112,19.544 C90.008,19.544 90.688,19.388 91.152,19.076 C91.616,18.764 91.848,18.316 91.848,17.732 C91.848,17.236 91.69,16.89 91.374,16.694 C91.058,16.498 90.612,16.364 90.036,16.292 L90.036,16.292 L89.688,16.256 C89.32,16.216 89.032,16.172 88.824,16.124 C88.616,16.076 88.444,15.996 88.308,15.884 C88.172,15.772 88.104,15.612 88.104,15.404 C88.104,15.116 88.2,14.91 88.392,14.786 C88.584,14.662 88.868,14.592 89.244,14.576 C89.996,14.576 90.578,14.392 90.99,14.024 C91.402,13.656 91.608,13.184 91.608,12.608 C91.608,12.216 91.504,11.872 91.296,11.576 L91.296,11.576 L91.308,11.552 C91.54,11.576 91.82,11.588 92.148,11.588 C92.236,11.588 92.298,11.56 92.334,11.504 C92.37,11.448 92.388,11.356 92.388,11.228 L92.388,11.228 L92.388,11.084 C92.388,10.956 92.37,10.864 92.334,10.808 C92.298,10.752 92.236,10.724 92.148,10.724 L92.148,10.724 L89.964,10.724 C89.748,10.676 89.512,10.652 89.256,10.652 C88.512,10.652 87.932,10.836 87.516,11.204 C87.1,11.572 86.892,12.04 86.892,12.608 C86.892,12.976 86.98,13.308 87.156,13.604 C87.332,13.9 87.588,14.132 87.924,14.3 C87.476,14.612 87.252,15.028 87.252,15.548 C87.252,15.948 87.412,16.276 87.732,16.532 L87.732,16.532 L87.72,16.556 C87.392,16.692 87.128,16.888 86.928,17.144 C86.728,17.4 86.628,17.704 86.628,18.056 C86.628,18.568 86.85,18.944 87.294,19.184 C87.738,19.424 88.344,19.544 89.112,19.544 Z M89.244,13.772 C88.292,13.772 87.816,13.388 87.816,12.62 C87.816,11.844 88.292,11.456 89.244,11.456 C90.204,11.456 90.684,11.844 90.684,12.62 C90.684,13.028 90.554,13.322 90.294,13.502 C90.034,13.682 89.684,13.772 89.244,13.772 Z M89.244,18.728 C88.1,18.728 87.528,18.44 87.528,17.864 C87.528,17.44 87.792,17.116 88.32,16.892 C88.496,16.948 88.824,17 89.304,17.048 C89.832,17.104 90.228,17.18 90.492,17.276 C90.756,17.372 90.888,17.56 90.888,17.84 C90.888,18.144 90.754,18.368 90.486,18.512 C90.218,18.656 89.804,18.728 89.244,18.728 Z M95.484,17.072 C95.82,17.072 96.152,16.992 96.48,16.832 C96.808,16.672 97.1,16.452 97.356,16.172 C97.364,16.212 97.382,16.3 97.41,16.436 C97.438,16.572 97.478,16.702 97.53,16.826 C97.582,16.95 97.664,17.012 97.776,17.012 C97.904,17.012 98.044,16.99 98.196,16.946 C98.348,16.902 98.424,16.832 98.424,16.736 C98.424,16.712 98.4,16.586 98.352,16.358 C98.304,16.13 98.28,15.752 98.28,15.224 L98.28,15.224 L98.28,10.964 C98.28,10.788 98.12,10.7 97.8,10.7 L97.8,10.7 L97.752,10.7 C97.432,10.7 97.272,10.788 97.272,10.964 L97.272,10.964 L97.272,15.356 C97.072,15.612 96.838,15.816 96.57,15.968 C96.302,16.12 96.032,16.196 95.76,16.196 C95.368,16.196 95.066,16.094 94.854,15.89 C94.642,15.686 94.536,15.4 94.536,15.032 L94.536,15.032 L94.536,10.964 C94.536,10.788 94.376,10.7 94.056,10.7 L94.056,10.7 L94.008,10.7 C93.688,10.7 93.528,10.788 93.528,10.964 L93.528,10.964 L93.528,15.128 C93.528,15.736 93.702,16.212 94.05,16.556 C94.398,16.9 94.876,17.072 95.484,17.072 Z M102.912,17.072 C103.288,17.072 103.642,17.03 103.974,16.946 C104.306,16.862 104.572,16.758 104.772,16.634 C104.972,16.51 105.072,16.4 105.072,16.304 C105.072,16.224 105.022,16.104 104.922,15.944 C104.822,15.784 104.732,15.704 104.652,15.704 C104.628,15.704 104.536,15.746 104.376,15.83 C104.216,15.914 104.014,15.998 103.77,16.082 C103.526,16.166 103.236,16.208 102.9,16.208 C102.308,16.208 101.864,16.052 101.568,15.74 C101.272,15.428 101.1,14.94 101.052,14.276 L101.052,14.276 L104.844,14.276 C104.916,14.276 105,14.212 105.096,14.084 C105.192,13.956 105.24,13.856 105.24,13.784 C105.24,12.76 105.032,11.982 104.616,11.45 C104.2,10.918 103.584,10.652 102.768,10.652 C101.848,10.652 101.152,10.928 100.68,11.48 C100.208,12.032 99.972,12.84 99.972,13.904 C99.972,14.976 100.212,15.772 100.692,16.292 C101.172,16.812 101.912,17.072 102.912,17.072 Z M104.172,13.412 L101.052,13.412 C101.14,12.148 101.7,11.516 102.732,11.516 C103.692,11.516 104.172,12.148 104.172,13.412 L104.172,13.412 Z M108.312,17.072 C108.896,17.072 109.188,16.952 109.188,16.712 C109.188,16.632 109.164,16.518 109.116,16.37 C109.068,16.222 109.008,16.148 108.936,16.148 C108.896,16.148 108.838,16.158 108.762,16.178 C108.686,16.198 108.572,16.208 108.42,16.208 C108.22,16.208 108.062,16.144 107.946,16.016 C107.83,15.888 107.772,15.656 107.772,15.32 L107.772,15.32 L107.772,8.24 C107.772,8.064 107.612,7.976 107.292,7.976 L107.292,7.976 L107.244,7.976 C106.924,7.976 106.764,8.064 106.764,8.24 L106.764,8.24 L106.764,15.416 C106.764,16.032 106.922,16.462 107.238,16.706 C107.554,16.95 107.912,17.072 108.312,17.072 Z M111.984,17.072 C112.784,17.072 113.456,16.772 114,16.172 C114.008,16.212 114.026,16.3 114.054,16.436 C114.082,16.572 114.122,16.702 114.174,16.826 C114.226,16.95 114.308,17.012 114.42,17.012 C114.548,17.012 114.688,16.99 114.84,16.946 C114.992,16.902 115.068,16.832 115.068,16.736 C115.068,16.712 115.044,16.586 114.996,16.358 C114.948,16.13 114.924,15.752 114.924,15.224 L114.924,15.224 L114.924,12.536 C114.924,11.944 114.716,11.482 114.3,11.15 C113.884,10.818 113.304,10.652 112.56,10.652 C112.184,10.652 111.82,10.694 111.468,10.778 C111.116,10.862 110.834,10.964 110.622,11.084 C110.41,11.204 110.304,11.316 110.304,11.42 C110.304,11.5 110.354,11.62 110.454,11.78 C110.554,11.94 110.644,12.02 110.724,12.02 C110.74,12.02 110.836,11.978 111.012,11.894 C111.188,11.81 111.408,11.726 111.672,11.642 C111.936,11.558 112.244,11.516 112.596,11.516 C113.06,11.516 113.396,11.61 113.604,11.798 C113.812,11.986 113.916,12.228 113.916,12.524 L113.916,12.524 L113.916,13.088 C113.124,13.096 112.452,13.146 111.9,13.238 C111.348,13.33 110.882,13.534 110.502,13.85 C110.122,14.166 109.932,14.64 109.932,15.272 C109.932,15.864 110.12,16.312 110.496,16.616 C110.872,16.92 111.368,17.072 111.984,17.072 Z M112.032,16.196 C111.696,16.196 111.442,16.112 111.27,15.944 C111.098,15.776 111.012,15.532 111.012,15.212 C111.012,14.828 111.156,14.544 111.444,14.36 C111.732,14.176 112.066,14.064 112.446,14.024 C112.826,13.984 113.316,13.96 113.916,13.952 L113.916,13.952 L113.916,15.368 C113.62,15.632 113.33,15.836 113.046,15.98 C112.762,16.124 112.424,16.196 112.032,16.196 Z M122.364,17.072 C122.74,17.072 123.094,17.03 123.426,16.946 C123.758,16.862 124.024,16.758 124.224,16.634 C124.424,16.51 124.524,16.4 124.524,16.304 C124.524,16.224 124.474,16.104 124.374,15.944 C124.274,15.784 124.184,15.704 124.104,15.704 C124.08,15.704 123.988,15.746 123.828,15.83 C123.668,15.914 123.466,15.998 123.222,16.082 C122.978,16.166 122.688,16.208 122.352,16.208 C121.76,16.208 121.316,16.052 121.02,15.74 C120.724,15.428 120.552,14.94 120.504,14.276 L120.504,14.276 L124.296,14.276 C124.368,14.276 124.452,14.212 124.548,14.084 C124.644,13.956 124.692,13.856 124.692,13.784 C124.692,12.76 124.484,11.982 124.068,11.45 C123.652,10.918 123.036,10.652 122.22,10.652 C121.3,10.652 120.604,10.928 120.132,11.48 C119.66,12.032 119.424,12.84 119.424,13.904 C119.424,14.976 119.664,15.772 120.144,16.292 C120.624,16.812 121.364,17.072 122.364,17.072 Z M123.624,13.412 L120.504,13.412 C120.592,12.148 121.152,11.516 122.184,11.516 C123.144,11.516 123.624,12.148 123.624,13.412 L123.624,13.412 Z M126.792,17.024 C127.112,17.024 127.272,16.936 127.272,16.76 L127.272,16.76 L127.272,12.368 C127.472,12.112 127.706,11.908 127.974,11.756 C128.242,11.604 128.512,11.528 128.784,11.528 C129.176,11.528 129.478,11.63 129.69,11.834 C129.902,12.038 130.008,12.324 130.008,12.692 L130.008,12.692 L130.008,16.76 C130.008,16.936 130.168,17.024 130.488,17.024 L130.488,17.024 L130.536,17.024 C130.856,17.024 131.016,16.936 131.016,16.76 L131.016,16.76 L131.016,12.596 C131.016,11.988 130.842,11.512 130.494,11.168 C130.146,10.824 129.668,10.652 129.06,10.652 C128.724,10.652 128.392,10.732 128.064,10.892 C127.736,11.052 127.444,11.272 127.188,11.552 C127.18,11.512 127.162,11.428 127.134,11.3 C127.106,11.172 127.066,11.05 127.014,10.934 C126.962,10.818 126.88,10.76 126.768,10.76 C126.64,10.76 126.5,10.782 126.348,10.826 C126.196,10.87 126.12,10.94 126.12,11.036 C126.12,11.06 126.144,11.186 126.192,11.414 C126.24,11.642 126.264,12.02 126.264,12.548 L126.264,12.548 L126.264,16.76 C126.264,16.936 126.424,17.024 126.744,17.024 L126.744,17.024 L126.792,17.024 Z M137.328,17.072 C137.912,17.072 138.204,16.952 138.204,16.712 C138.204,16.632 138.18,16.518 138.132,16.37 C138.084,16.222 138.024,16.148 137.952,16.148 C137.912,16.148 137.854,16.158 137.778,16.178 C137.702,16.198 137.588,16.208 137.436,16.208 C137.236,16.208 137.078,16.144 136.962,16.016 C136.846,15.888 136.788,15.656 136.788,15.32 L136.788,15.32 L136.788,8.24 C136.788,8.064 136.628,7.976 136.308,7.976 L136.308,7.976 L136.26,7.976 C135.94,7.976 135.78,8.064 135.78,8.24 L135.78,8.24 L135.78,15.416 C135.78,16.032 135.938,16.462 136.254,16.706 C136.57,16.95 136.928,17.072 137.328,17.072 Z M141,17.072 C141.8,17.072 142.472,16.772 143.016,16.172 C143.024,16.212 143.042,16.3 143.07,16.436 C143.098,16.572 143.138,16.702 143.19,16.826 C143.242,16.95 143.324,17.012 143.436,17.012 C143.564,17.012 143.704,16.99 143.856,16.946 C144.008,16.902 144.084,16.832 144.084,16.736 C144.084,16.712 144.06,16.586 144.012,16.358 C143.964,16.13 143.94,15.752 143.94,15.224 L143.94,15.224 L143.94,12.536 C143.94,11.944 143.732,11.482 143.316,11.15 C142.9,10.818 142.32,10.652 141.576,10.652 C141.2,10.652 140.836,10.694 140.484,10.778 C140.132,10.862 139.85,10.964 139.638,11.084 C139.426,11.204 139.32,11.316 139.32,11.42 C139.32,11.5 139.37,11.62 139.47,11.78 C139.57,11.94 139.66,12.02 139.74,12.02 C139.756,12.02 139.852,11.978 140.028,11.894 C140.204,11.81 140.424,11.726 140.688,11.642 C140.952,11.558 141.26,11.516 141.612,11.516 C142.076,11.516 142.412,11.61 142.62,11.798 C142.828,11.986 142.932,12.228 142.932,12.524 L142.932,12.524 L142.932,13.088 C142.14,13.096 141.468,13.146 140.916,13.238 C140.364,13.33 139.898,13.534 139.518,13.85 C139.138,14.166 138.948,14.64 138.948,15.272 C138.948,15.864 139.136,16.312 139.512,16.616 C139.888,16.92 140.384,17.072 141,17.072 Z M141.048,16.196 C140.712,16.196 140.458,16.112 140.286,15.944 C140.114,15.776 140.028,15.532 140.028,15.212 C140.028,14.828 140.172,14.544 140.46,14.36 C140.748,14.176 141.082,14.064 141.462,14.024 C141.842,13.984 142.332,13.96 142.932,13.952 L142.932,13.952 L142.932,15.368 C142.636,15.632 142.346,15.836 142.062,15.98 C141.778,16.124 141.44,16.196 141.048,16.196 Z","id":"Consíguelaenla","fill":"#FFFFFF"}})])])])
}
var app_esvue_type_template_id_6725dc26_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/stores/app_es.vue?vue&type=template&id=6725dc26

// CONCATENATED MODULE: ./src/components/svg/stores/app_es.vue

var app_es_script = {}


/* normalize component */

var app_es_component = normalizeComponent(
  app_es_script,
  app_esvue_type_template_id_6725dc26_render,
  app_esvue_type_template_id_6725dc26_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var app_es = (app_es_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/stores/play_de.vue?vue&type=template&id=b1ba5614&scoped=true
var play_devue_type_template_id_b1ba5614_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 184.3 55"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 184.3 55","xml:space":"preserve"}},[_c('g',{attrs:{"id":"Ebene_1"}}),_c('g',{attrs:{"id":"artwork"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M177.1,54.5H6.8c-3.7,0-6.8-3.1-6.8-6.8V6.8C0,3.1,3.1,0,6.8,0h170.3c3.7,0,6.8,3.1,6.8,6.8v40.9\n\t\t\t\tC184,51.5,180.9,54.5,177.1,54.5z"}})]),_c('path',{staticClass:"st0",attrs:{"d":"M92.9,29.7c-3.2,0-5.8,2.4-5.8,5.8c0,3.3,2.6,5.8,5.8,5.8c3.2,0,5.8-2.5,5.8-5.8\n\t\t\tC98.7,32.1,96.1,29.7,92.9,29.7z M92.9,39c-1.8,0-3.3-1.4-3.3-3.5c0-2.1,1.5-3.5,3.3-3.5s3.3,1.4,3.3,3.5\n\t\t\tC96.1,37.5,94.6,39,92.9,39z M80.2,29.7c-3.2,0-5.8,2.4-5.8,5.8c0,3.3,2.6,5.8,5.8,5.8c3.2,0,5.8-2.5,5.8-5.8\n\t\t\tC86,32.1,83.4,29.7,80.2,29.7z M80.2,39c-1.8,0-3.3-1.4-3.3-3.5c0-2.1,1.5-3.5,3.3-3.5c1.8,0,3.3,1.4,3.3,3.5\n\t\t\tC83.4,37.5,81.9,39,80.2,39z M65.1,31.4v2.5H71c-0.2,1.4-0.6,2.4-1.3,3.1c-0.9,0.9-2.2,1.8-4.5,1.8c-3.6,0-6.5-2.9-6.5-6.5\n\t\t\ts2.8-6.5,6.5-6.5c2,0,3.4,0.8,4.4,1.8l1.7-1.7c-1.5-1.4-3.4-2.5-6.2-2.5c-5,0-9.1,4-9.1,9c0,5,4.2,9,9.1,9c2.7,0,4.7-0.9,6.3-2.5\n\t\t\tc1.6-1.6,2.1-3.9,2.1-5.8c0-0.6,0-1.1-0.1-1.5H65.1z M126.8,33.4c-0.5-1.3-2-3.7-5-3.7c-3,0-5.5,2.3-5.5,5.8\n\t\t\tc0,3.2,2.5,5.8,5.8,5.8c2.7,0,4.2-1.6,4.8-2.6l-2-1.3c-0.7,1-1.6,1.6-2.9,1.6c-1.3,0-2.2-0.6-2.8-1.8l7.7-3.2L126.8,33.4z\n\t\t\t M118.9,35.3c-0.1-2.2,1.7-3.4,3-3.4c1,0,1.9,0.5,2.2,1.2L118.9,35.3z M112.6,40.9h2.5v-17h-2.5V40.9z M108.4,31L108.4,31\n\t\t\tc-0.7-0.7-1.8-1.3-3.1-1.3c-2.9,0-5.6,2.5-5.6,5.8c0,3.2,2.7,5.8,5.6,5.8c1.4,0,2.5-0.6,3.1-1.3h0.1v0.8c0,2.2-1.2,3.4-3.1,3.4\n\t\t\tc-1.6,0-2.5-1.1-2.9-2.1l-2.2,0.9c0.6,1.5,2.3,3.4,5.1,3.4c3,0,5.5-1.8,5.5-6V30h-2.4V31z M105.5,39c-1.8,0-3.2-1.5-3.2-3.5\n\t\t\tc0-2,1.5-3.5,3.2-3.5c1.7,0,3.1,1.5,3.1,3.5C108.6,37.5,107.2,39,105.5,39z M138.7,23.9h-6.1v17h2.5v-6.5h3.5c2.8,0,5.6-2,5.6-5.3\n\t\t\tS141.5,23.9,138.7,23.9z M138.8,32.1h-3.6v-5.8h3.6c1.9,0,3,1.6,3,2.9C141.8,30.5,140.7,32.1,138.8,32.1z M154.5,29.6\n\t\t\tc-1.8,0-3.7,0.8-4.5,2.6l2.3,0.9c0.5-0.9,1.4-1.2,2.3-1.2c1.3,0,2.7,0.8,2.7,2.2v0.2c-0.5-0.3-1.4-0.7-2.7-0.7\n\t\t\tc-2.4,0-4.9,1.3-4.9,3.8c0,2.3,2,3.7,4.2,3.7c1.7,0,2.7-0.8,3.2-1.7h0.1v1.3h2.5v-6.5C159.7,31.3,157.4,29.6,154.5,29.6z\n\t\t\t M154.2,39c-0.8,0-2-0.4-2-1.4c0-1.3,1.4-1.8,2.7-1.8c1.1,0,1.6,0.2,2.3,0.6C157,37.9,155.7,39,154.2,39z M168.6,30l-2.9,7.4h-0.1\n\t\t\tl-3-7.4h-2.7l4.5,10.3l-2.6,5.7h2.7l7-16.1H168.6z M145.7,40.9h2.5v-17h-2.5V40.9z"}}),_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_1_","gradientUnits":"userSpaceOnUse","x1":"29.7229","y1":"44.6617","x2":"6.8569","y2":"21.7957","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#00a0ff"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#00a1ff"},attrs:{"offset":"6.574450e-03"}}),_c('stop',{staticStyle:{"stop-color":"#00beff"},attrs:{"offset":"0.2601"}}),_c('stop',{staticStyle:{"stop-color":"#00d2ff"},attrs:{"offset":"0.5122"}}),_c('stop',{staticStyle:{"stop-color":"#00dfff"},attrs:{"offset":"0.7604"}}),_c('stop',{staticStyle:{"stop-color":"#00e3ff"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st1",attrs:{"d":"M14.2,10.3c-0.4,0.4-0.6,1.1-0.6,1.9v30.1c0,0.8,0.2,1.5,0.6,1.9l0.1,0.1l16.9-16.9v-0.2v-0.2L14.3,10.2\n\t\t\t\tL14.2,10.3z"}}),_c('linearGradient',{attrs:{"id":"SVGID_2_","gradientUnits":"userSpaceOnUse","x1":"46.1201","y1":"29.2768","x2":"13.1519","y2":"29.2768","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#ffe000"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#ffbd00"},attrs:{"offset":"0.4087"}}),_c('stop',{staticStyle:{"stop-color":"#ffa500"},attrs:{"offset":"0.7754"}}),_c('stop',{staticStyle:{"stop-color":"#ff9c00"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st2",attrs:{"d":"M36.8,33.1l-5.6-5.6v-0.2v-0.2l5.6-5.6l0.1,0.1l6.7,3.8c1.9,1.1,1.9,2.9,0,3.9L37,33L36.8,33.1z"}}),_c('linearGradient',{attrs:{"id":"SVGID_3_","gradientUnits":"userSpaceOnUse","x1":"33.8475","y1":"26.1503","x2":"2.8394","y2":"-4.8578","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#ff3a44"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#c31162"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st3",attrs:{"d":"M37,33l-5.8-5.8l-17,17c0.6,0.7,1.7,0.7,2.8,0.1L37,33"}}),_c('linearGradient',{attrs:{"id":"SVGID_4_","gradientUnits":"userSpaceOnUse","x1":"9.9634","y1":"56.2887","x2":"23.8098","y2":"42.4422","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#32a071"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#2da771"},attrs:{"offset":"6.850000e-02"}}),_c('stop',{staticStyle:{"stop-color":"#15cf74"},attrs:{"offset":"0.4762"}}),_c('stop',{staticStyle:{"stop-color":"#06e775"},attrs:{"offset":"0.8009"}}),_c('stop',{staticStyle:{"stop-color":"#00f076"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st4",attrs:{"d":"M37,21.5L17.1,10.2c-1.2-0.7-2.2-0.6-2.8,0.1l17,17L37,21.5z"}}),_c('g',[_c('path',{staticClass:"st5",attrs:{"d":"M36.8,32.9L17.1,44.1c-1.1,0.6-2.1,0.6-2.7,0l0,0l-0.1,0.1l0,0l0.1,0.1l0,0c0.6,0.6,1.6,0.6,2.7,0L37,33\n\t\t\t\t\tL36.8,32.9z"}}),_c('path',{staticClass:"st6",attrs:{"d":"M14.2,44.1c-0.4-0.4-0.6-1.1-0.6-1.9v0.2c0,0.8,0.2,1.5,0.6,1.9l0.1-0.1L14.2,44.1z"}})]),_c('path',{staticClass:"st6",attrs:{"d":"M43.6,29.1l-6.8,3.9L37,33l6.7-3.8c1-0.5,1.4-1.3,1.4-2l0,0C45,27.9,44.5,28.6,43.6,29.1z"}}),_c('path',{staticClass:"st7",attrs:{"d":"M17.1,10.4l26.6,15.1c0.9,0.5,1.3,1.1,1.4,1.8l0,0c0-0.7-0.5-1.4-1.4-2L17.1,10.2c-1.9-1.1-3.5-0.2-3.5,2\n\t\t\t\tv0.2C13.6,10.2,15.2,9.3,17.1,10.4z"}})],1)]),_c('g',[_c('path',{staticClass:"st8",attrs:{"d":"M58.6,17.9c-0.6,0-1.1-0.2-1.5-0.5c-0.4-0.3-0.7-0.8-0.9-1.4l1-0.4c0.2,0.9,0.7,1.3,1.5,1.3\n\t\t\tc0.5,0,0.9-0.2,1.1-0.5c0.3-0.3,0.4-0.7,0.4-1.3V9.6h1.1v5.6c0,0.9-0.2,1.6-0.7,2.1C60,17.7,59.4,17.9,58.6,17.9z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M67.7,10.6H64v2.6h3.4v1H64v2.6h3.7v1H63V9.6h4.8V10.6z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M72.2,17.7h-1.1v-7.2h-2.3v-1h5.6v1h-2.3V17.7z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M75.3,17.7v-1.1l4.3-6.1h-4.2v-1h5.4v1.1l-4.3,6.1h4.4v1H75.3z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M85.2,17.7h-1.1v-7.2h-2.3v-1h5.6v1h-2.3V17.7z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M91.6,17.7V9.6h3c0.6,0,1.2,0.2,1.7,0.6c0.5,0.4,0.7,1,0.7,1.6c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.5-0.8,0.7\n\t\t\tv0c0.4,0.1,0.7,0.4,1,0.7c0.3,0.3,0.4,0.7,0.4,1.2c0,0.7-0.2,1.2-0.7,1.7c-0.5,0.4-1.1,0.7-1.7,0.7H91.6z M92.6,13.1h1.9\n\t\t\tc0.4,0,0.7-0.1,1-0.4c0.2-0.3,0.4-0.5,0.4-0.9s-0.1-0.6-0.3-0.9c-0.2-0.3-0.5-0.4-0.9-0.4h-2V13.1z M92.6,16.7h2.1\n\t\t\tc0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-1-0.4h-2.1V16.7z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M103.4,10.6h-3.7v2.6h3.4v1h-3.4v2.6h3.7v1h-4.8V9.6h4.8V10.6z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M105,17.7V9.6h1v8.2H105z"}})])])])
}
var play_devue_type_template_id_b1ba5614_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/stores/play_de.vue?vue&type=template&id=b1ba5614&scoped=true

// EXTERNAL MODULE: ./src/components/svg/stores/play_de.vue?vue&type=style&index=0&id=b1ba5614&prod&scoped=true&lang=css
var play_devue_type_style_index_0_id_b1ba5614_prod_scoped_true_lang_css = __webpack_require__("a099");

// CONCATENATED MODULE: ./src/components/svg/stores/play_de.vue

var play_de_script = {}



/* normalize component */

var play_de_component = normalizeComponent(
  play_de_script,
  play_devue_type_template_id_b1ba5614_scoped_true_render,
  play_devue_type_template_id_b1ba5614_scoped_true_staticRenderFns,
  false,
  null,
  "b1ba5614",
  null
  
)

/* harmony default export */ var play_de = (play_de_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/stores/play_at.vue?vue&type=template&id=119aaaf8
var play_atvue_type_template_id_119aaaf8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 184.3 55"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 184.3 55","xml:space":"preserve"}},[_c('g',{attrs:{"id":"Ebene_1"}}),_c('g',{attrs:{"id":"artwork"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M177.1,54.5H6.8c-3.7,0-6.8-3.1-6.8-6.8V6.8C0,3.1,3.1,0,6.8,0h170.3c3.7,0,6.8,3.1,6.8,6.8v40.9\n\t\t\t\tC184,51.5,180.9,54.5,177.1,54.5z"}})]),_c('path',{staticClass:"st0",attrs:{"d":"M92.9,29.7c-3.2,0-5.8,2.4-5.8,5.8c0,3.3,2.6,5.8,5.8,5.8c3.2,0,5.8-2.5,5.8-5.8\n\t\t\tC98.7,32.1,96.1,29.7,92.9,29.7z M92.9,39c-1.8,0-3.3-1.4-3.3-3.5c0-2.1,1.5-3.5,3.3-3.5s3.3,1.4,3.3,3.5\n\t\t\tC96.1,37.5,94.6,39,92.9,39z M80.2,29.7c-3.2,0-5.8,2.4-5.8,5.8c0,3.3,2.6,5.8,5.8,5.8c3.2,0,5.8-2.5,5.8-5.8\n\t\t\tC86,32.1,83.4,29.7,80.2,29.7z M80.2,39c-1.8,0-3.3-1.4-3.3-3.5c0-2.1,1.5-3.5,3.3-3.5c1.8,0,3.3,1.4,3.3,3.5\n\t\t\tC83.4,37.5,81.9,39,80.2,39z M65.1,31.4v2.5H71c-0.2,1.4-0.6,2.4-1.3,3.1c-0.9,0.9-2.2,1.8-4.5,1.8c-3.6,0-6.5-2.9-6.5-6.5\n\t\t\ts2.8-6.5,6.5-6.5c2,0,3.4,0.8,4.4,1.8l1.7-1.7c-1.5-1.4-3.4-2.5-6.2-2.5c-5,0-9.1,4-9.1,9c0,5,4.2,9,9.1,9c2.7,0,4.7-0.9,6.3-2.5\n\t\t\tc1.6-1.6,2.1-3.9,2.1-5.8c0-0.6,0-1.1-0.1-1.5H65.1z M126.8,33.4c-0.5-1.3-2-3.7-5-3.7c-3,0-5.5,2.3-5.5,5.8\n\t\t\tc0,3.2,2.5,5.8,5.8,5.8c2.7,0,4.2-1.6,4.8-2.6l-2-1.3c-0.7,1-1.6,1.6-2.9,1.6c-1.3,0-2.2-0.6-2.8-1.8l7.7-3.2L126.8,33.4z\n\t\t\t M118.9,35.3c-0.1-2.2,1.7-3.4,3-3.4c1,0,1.9,0.5,2.2,1.2L118.9,35.3z M112.6,40.9h2.5v-17h-2.5V40.9z M108.4,31L108.4,31\n\t\t\tc-0.7-0.7-1.8-1.3-3.1-1.3c-2.9,0-5.6,2.5-5.6,5.8c0,3.2,2.7,5.8,5.6,5.8c1.4,0,2.5-0.6,3.1-1.3h0.1v0.8c0,2.2-1.2,3.4-3.1,3.4\n\t\t\tc-1.6,0-2.5-1.1-2.9-2.1l-2.2,0.9c0.6,1.5,2.3,3.4,5.1,3.4c3,0,5.5-1.8,5.5-6V30h-2.4V31z M105.5,39c-1.8,0-3.2-1.5-3.2-3.5\n\t\t\tc0-2,1.5-3.5,3.2-3.5c1.7,0,3.1,1.5,3.1,3.5C108.6,37.5,107.2,39,105.5,39z M138.7,23.9h-6.1v17h2.5v-6.5h3.5c2.8,0,5.6-2,5.6-5.3\n\t\t\tS141.5,23.9,138.7,23.9z M138.8,32.1h-3.6v-5.8h3.6c1.9,0,3,1.6,3,2.9C141.8,30.5,140.7,32.1,138.8,32.1z M154.5,29.6\n\t\t\tc-1.8,0-3.7,0.8-4.5,2.6l2.3,0.9c0.5-0.9,1.4-1.2,2.3-1.2c1.3,0,2.7,0.8,2.7,2.2v0.2c-0.5-0.3-1.4-0.7-2.7-0.7\n\t\t\tc-2.4,0-4.9,1.3-4.9,3.8c0,2.3,2,3.7,4.2,3.7c1.7,0,2.7-0.8,3.2-1.7h0.1v1.3h2.5v-6.5C159.7,31.3,157.4,29.6,154.5,29.6z\n\t\t\t M154.2,39c-0.8,0-2-0.4-2-1.4c0-1.3,1.4-1.8,2.7-1.8c1.1,0,1.6,0.2,2.3,0.6C157,37.9,155.7,39,154.2,39z M168.6,30l-2.9,7.4h-0.1\n\t\t\tl-3-7.4h-2.7l4.5,10.3l-2.6,5.7h2.7l7-16.1H168.6z M145.7,40.9h2.5v-17h-2.5V40.9z"}}),_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_1_","gradientUnits":"userSpaceOnUse","x1":"29.7229","y1":"44.6617","x2":"6.8569","y2":"21.7957","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#00a0ff"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#00a1ff"},attrs:{"offset":"6.574450e-03"}}),_c('stop',{staticStyle:{"stop-color":"#00beff"},attrs:{"offset":"0.2601"}}),_c('stop',{staticStyle:{"stop-color":"#00d2ff"},attrs:{"offset":"0.5122"}}),_c('stop',{staticStyle:{"stop-color":"#00dfff"},attrs:{"offset":"0.7604"}}),_c('stop',{staticStyle:{"stop-color":"#00e3ff"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st1",attrs:{"d":"M14.2,10.3c-0.4,0.4-0.6,1.1-0.6,1.9v30.1c0,0.8,0.2,1.5,0.6,1.9l0.1,0.1l16.9-16.9v-0.2v-0.2L14.3,10.2\n\t\t\t\tL14.2,10.3z"}}),_c('linearGradient',{attrs:{"id":"SVGID_2_","gradientUnits":"userSpaceOnUse","x1":"46.1201","y1":"29.2768","x2":"13.1519","y2":"29.2768","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#ffe000"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#ffbd00"},attrs:{"offset":"0.4087"}}),_c('stop',{staticStyle:{"stop-color":"#ffa500"},attrs:{"offset":"0.7754"}}),_c('stop',{staticStyle:{"stop-color":"#ff9c00"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st2",attrs:{"d":"M36.8,33.1l-5.6-5.6v-0.2v-0.2l5.6-5.6l0.1,0.1l6.7,3.8c1.9,1.1,1.9,2.9,0,3.9L37,33L36.8,33.1z"}}),_c('linearGradient',{attrs:{"id":"SVGID_3_","gradientUnits":"userSpaceOnUse","x1":"33.8475","y1":"26.1503","x2":"2.8394","y2":"-4.8578","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#ff3a44"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#c31162"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st3",attrs:{"d":"M37,33l-5.8-5.8l-17,17c0.6,0.7,1.7,0.7,2.8,0.1L37,33"}}),_c('linearGradient',{attrs:{"id":"SVGID_4_","gradientUnits":"userSpaceOnUse","x1":"9.9634","y1":"56.2887","x2":"23.8098","y2":"42.4422","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#32a071"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#2da771"},attrs:{"offset":"6.850000e-02"}}),_c('stop',{staticStyle:{"stop-color":"#15cf74"},attrs:{"offset":"0.4762"}}),_c('stop',{staticStyle:{"stop-color":"#06e775"},attrs:{"offset":"0.8009"}}),_c('stop',{staticStyle:{"stop-color":"#00f076"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st4",attrs:{"d":"M37,21.5L17.1,10.2c-1.2-0.7-2.2-0.6-2.8,0.1l17,17L37,21.5z"}}),_c('g',[_c('path',{staticClass:"st5",attrs:{"d":"M36.8,32.9L17.1,44.1c-1.1,0.6-2.1,0.6-2.7,0l0,0l-0.1,0.1l0,0l0.1,0.1l0,0c0.6,0.6,1.6,0.6,2.7,0L37,33\n\t\t\t\t\tL36.8,32.9z"}}),_c('path',{staticClass:"st6",attrs:{"d":"M14.2,44.1c-0.4-0.4-0.6-1.1-0.6-1.9v0.2c0,0.8,0.2,1.5,0.6,1.9l0.1-0.1L14.2,44.1z"}})]),_c('path',{staticClass:"st6",attrs:{"d":"M43.6,29.1l-6.8,3.9L37,33l6.7-3.8c1-0.5,1.4-1.3,1.4-2l0,0C45,27.9,44.5,28.6,43.6,29.1z"}}),_c('path',{staticClass:"st7",attrs:{"d":"M17.1,10.4l26.6,15.1c0.9,0.5,1.3,1.1,1.4,1.8l0,0c0-0.7-0.5-1.4-1.4-2L17.1,10.2c-1.9-1.1-3.5-0.2-3.5,2\n\t\t\t\tv0.2C13.6,10.2,15.2,9.3,17.1,10.4z"}})],1)]),_c('g',[_c('path',{staticClass:"st8",attrs:{"d":"M58.6,17.9c-0.6,0-1.1-0.2-1.5-0.5c-0.4-0.3-0.7-0.8-0.9-1.4l1-0.4c0.2,0.9,0.7,1.3,1.5,1.3\n\t\t\tc0.5,0,0.9-0.2,1.1-0.5c0.3-0.3,0.4-0.7,0.4-1.3V9.6h1.1v5.6c0,0.9-0.2,1.6-0.7,2.1C60,17.7,59.4,17.9,58.6,17.9z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M67.7,10.6H64v2.6h3.4v1H64v2.6h3.7v1H63V9.6h4.8V10.6z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M72.2,17.7h-1.1v-7.2h-2.3v-1h5.6v1h-2.3V17.7z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M75.3,17.7v-1.1l4.3-6.1h-4.2v-1h5.4v1.1l-4.3,6.1h4.4v1H75.3z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M85.2,17.7h-1.1v-7.2h-2.3v-1h5.6v1h-2.3V17.7z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M91.6,17.7V9.6h3c0.6,0,1.2,0.2,1.7,0.6c0.5,0.4,0.7,1,0.7,1.6c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.5-0.8,0.7\n\t\t\tv0c0.4,0.1,0.7,0.4,1,0.7c0.3,0.3,0.4,0.7,0.4,1.2c0,0.7-0.2,1.2-0.7,1.7c-0.5,0.4-1.1,0.7-1.7,0.7H91.6z M92.6,13.1h1.9\n\t\t\tc0.4,0,0.7-0.1,1-0.4c0.2-0.3,0.4-0.5,0.4-0.9s-0.1-0.6-0.3-0.9c-0.2-0.3-0.5-0.4-0.9-0.4h-2V13.1z M92.6,16.7h2.1\n\t\t\tc0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-1-0.4h-2.1V16.7z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M103.4,10.6h-3.7v2.6h3.4v1h-3.4v2.6h3.7v1h-4.8V9.6h4.8V10.6z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M105,17.7V9.6h1v8.2H105z"}})])])])
}
var play_atvue_type_template_id_119aaaf8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/stores/play_at.vue?vue&type=template&id=119aaaf8

// EXTERNAL MODULE: ./src/components/svg/stores/play_at.vue?vue&type=style&index=0&id=119aaaf8&prod&lang=css
var play_atvue_type_style_index_0_id_119aaaf8_prod_lang_css = __webpack_require__("3c74");

// CONCATENATED MODULE: ./src/components/svg/stores/play_at.vue

var play_at_script = {}



/* normalize component */

var play_at_component = normalizeComponent(
  play_at_script,
  play_atvue_type_template_id_119aaaf8_render,
  play_atvue_type_template_id_119aaaf8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var play_at = (play_at_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/stores/play_ch.vue?vue&type=template&id=47d061b6
var play_chvue_type_template_id_47d061b6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 184.3 55"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 184.3 55","xml:space":"preserve"}},[_c('g',{attrs:{"id":"Ebene_1"}}),_c('g',{attrs:{"id":"artwork"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M177.1,54.5H6.8c-3.7,0-6.8-3.1-6.8-6.8V6.8C0,3.1,3.1,0,6.8,0h170.3c3.7,0,6.8,3.1,6.8,6.8v40.9\n\t\t\t\tC184,51.5,180.9,54.5,177.1,54.5z"}})]),_c('path',{staticClass:"st0",attrs:{"d":"M92.9,29.7c-3.2,0-5.8,2.4-5.8,5.8c0,3.3,2.6,5.8,5.8,5.8c3.2,0,5.8-2.5,5.8-5.8\n\t\t\tC98.7,32.1,96.1,29.7,92.9,29.7z M92.9,39c-1.8,0-3.3-1.4-3.3-3.5c0-2.1,1.5-3.5,3.3-3.5s3.3,1.4,3.3,3.5\n\t\t\tC96.1,37.5,94.6,39,92.9,39z M80.2,29.7c-3.2,0-5.8,2.4-5.8,5.8c0,3.3,2.6,5.8,5.8,5.8c3.2,0,5.8-2.5,5.8-5.8\n\t\t\tC86,32.1,83.4,29.7,80.2,29.7z M80.2,39c-1.8,0-3.3-1.4-3.3-3.5c0-2.1,1.5-3.5,3.3-3.5c1.8,0,3.3,1.4,3.3,3.5\n\t\t\tC83.4,37.5,81.9,39,80.2,39z M65.1,31.4v2.5H71c-0.2,1.4-0.6,2.4-1.3,3.1c-0.9,0.9-2.2,1.8-4.5,1.8c-3.6,0-6.5-2.9-6.5-6.5\n\t\t\ts2.8-6.5,6.5-6.5c2,0,3.4,0.8,4.4,1.8l1.7-1.7c-1.5-1.4-3.4-2.5-6.2-2.5c-5,0-9.1,4-9.1,9c0,5,4.2,9,9.1,9c2.7,0,4.7-0.9,6.3-2.5\n\t\t\tc1.6-1.6,2.1-3.9,2.1-5.8c0-0.6,0-1.1-0.1-1.5H65.1z M126.8,33.4c-0.5-1.3-2-3.7-5-3.7c-3,0-5.5,2.3-5.5,5.8\n\t\t\tc0,3.2,2.5,5.8,5.8,5.8c2.7,0,4.2-1.6,4.8-2.6l-2-1.3c-0.7,1-1.6,1.6-2.9,1.6c-1.3,0-2.2-0.6-2.8-1.8l7.7-3.2L126.8,33.4z\n\t\t\t M118.9,35.3c-0.1-2.2,1.7-3.4,3-3.4c1,0,1.9,0.5,2.2,1.2L118.9,35.3z M112.6,40.9h2.5v-17h-2.5V40.9z M108.4,31L108.4,31\n\t\t\tc-0.7-0.7-1.8-1.3-3.1-1.3c-2.9,0-5.6,2.5-5.6,5.8c0,3.2,2.7,5.8,5.6,5.8c1.4,0,2.5-0.6,3.1-1.3h0.1v0.8c0,2.2-1.2,3.4-3.1,3.4\n\t\t\tc-1.6,0-2.5-1.1-2.9-2.1l-2.2,0.9c0.6,1.5,2.3,3.4,5.1,3.4c3,0,5.5-1.8,5.5-6V30h-2.4V31z M105.5,39c-1.8,0-3.2-1.5-3.2-3.5\n\t\t\tc0-2,1.5-3.5,3.2-3.5c1.7,0,3.1,1.5,3.1,3.5C108.6,37.5,107.2,39,105.5,39z M138.7,23.9h-6.1v17h2.5v-6.5h3.5c2.8,0,5.6-2,5.6-5.3\n\t\t\tS141.5,23.9,138.7,23.9z M138.8,32.1h-3.6v-5.8h3.6c1.9,0,3,1.6,3,2.9C141.8,30.5,140.7,32.1,138.8,32.1z M154.5,29.6\n\t\t\tc-1.8,0-3.7,0.8-4.5,2.6l2.3,0.9c0.5-0.9,1.4-1.2,2.3-1.2c1.3,0,2.7,0.8,2.7,2.2v0.2c-0.5-0.3-1.4-0.7-2.7-0.7\n\t\t\tc-2.4,0-4.9,1.3-4.9,3.8c0,2.3,2,3.7,4.2,3.7c1.7,0,2.7-0.8,3.2-1.7h0.1v1.3h2.5v-6.5C159.7,31.3,157.4,29.6,154.5,29.6z\n\t\t\t M154.2,39c-0.8,0-2-0.4-2-1.4c0-1.3,1.4-1.8,2.7-1.8c1.1,0,1.6,0.2,2.3,0.6C157,37.9,155.7,39,154.2,39z M168.6,30l-2.9,7.4h-0.1\n\t\t\tl-3-7.4h-2.7l4.5,10.3l-2.6,5.7h2.7l7-16.1H168.6z M145.7,40.9h2.5v-17h-2.5V40.9z"}}),_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_1_","gradientUnits":"userSpaceOnUse","x1":"29.7229","y1":"44.6617","x2":"6.8569","y2":"21.7957","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#00a0ff"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#00a1ff"},attrs:{"offset":"6.574450e-03"}}),_c('stop',{staticStyle:{"stop-color":"#00beff"},attrs:{"offset":"0.2601"}}),_c('stop',{staticStyle:{"stop-color":"#00d2ff"},attrs:{"offset":"0.5122"}}),_c('stop',{staticStyle:{"stop-color":"#00dfff"},attrs:{"offset":"0.7604"}}),_c('stop',{staticStyle:{"stop-color":"#00e3ff"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st1",attrs:{"d":"M14.2,10.3c-0.4,0.4-0.6,1.1-0.6,1.9v30.1c0,0.8,0.2,1.5,0.6,1.9l0.1,0.1l16.9-16.9v-0.2v-0.2L14.3,10.2\n\t\t\t\tL14.2,10.3z"}}),_c('linearGradient',{attrs:{"id":"SVGID_2_","gradientUnits":"userSpaceOnUse","x1":"46.1201","y1":"29.2768","x2":"13.1519","y2":"29.2768","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#ffe000"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#ffbd00"},attrs:{"offset":"0.4087"}}),_c('stop',{staticStyle:{"stop-color":"#ffa500"},attrs:{"offset":"0.7754"}}),_c('stop',{staticStyle:{"stop-color":"#ff9c00"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st2",attrs:{"d":"M36.8,33.1l-5.6-5.6v-0.2v-0.2l5.6-5.6l0.1,0.1l6.7,3.8c1.9,1.1,1.9,2.9,0,3.9L37,33L36.8,33.1z"}}),_c('linearGradient',{attrs:{"id":"SVGID_3_","gradientUnits":"userSpaceOnUse","x1":"33.8475","y1":"26.1503","x2":"2.8394","y2":"-4.8578","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#ff3a44"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#c31162"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st3",attrs:{"d":"M37,33l-5.8-5.8l-17,17c0.6,0.7,1.7,0.7,2.8,0.1L37,33"}}),_c('linearGradient',{attrs:{"id":"SVGID_4_","gradientUnits":"userSpaceOnUse","x1":"9.9634","y1":"56.2887","x2":"23.8098","y2":"42.4422","gradientTransform":"matrix(1 0 0 -1 0 56.56)"}},[_c('stop',{staticStyle:{"stop-color":"#32a071"},attrs:{"offset":"0"}}),_c('stop',{staticStyle:{"stop-color":"#2da771"},attrs:{"offset":"6.850000e-02"}}),_c('stop',{staticStyle:{"stop-color":"#15cf74"},attrs:{"offset":"0.4762"}}),_c('stop',{staticStyle:{"stop-color":"#06e775"},attrs:{"offset":"0.8009"}}),_c('stop',{staticStyle:{"stop-color":"#00f076"},attrs:{"offset":"1"}})],1),_c('path',{staticClass:"st4",attrs:{"d":"M37,21.5L17.1,10.2c-1.2-0.7-2.2-0.6-2.8,0.1l17,17L37,21.5z"}}),_c('g',[_c('path',{staticClass:"st5",attrs:{"d":"M36.8,32.9L17.1,44.1c-1.1,0.6-2.1,0.6-2.7,0l0,0l-0.1,0.1l0,0l0.1,0.1l0,0c0.6,0.6,1.6,0.6,2.7,0L37,33\n\t\t\t\t\tL36.8,32.9z"}}),_c('path',{staticClass:"st6",attrs:{"d":"M14.2,44.1c-0.4-0.4-0.6-1.1-0.6-1.9v0.2c0,0.8,0.2,1.5,0.6,1.9l0.1-0.1L14.2,44.1z"}})]),_c('path',{staticClass:"st6",attrs:{"d":"M43.6,29.1l-6.8,3.9L37,33l6.7-3.8c1-0.5,1.4-1.3,1.4-2l0,0C45,27.9,44.5,28.6,43.6,29.1z"}}),_c('path',{staticClass:"st7",attrs:{"d":"M17.1,10.4l26.6,15.1c0.9,0.5,1.3,1.1,1.4,1.8l0,0c0-0.7-0.5-1.4-1.4-2L17.1,10.2c-1.9-1.1-3.5-0.2-3.5,2\n\t\t\t\tv0.2C13.6,10.2,15.2,9.3,17.1,10.4z"}})],1)]),_c('g',[_c('path',{staticClass:"st8",attrs:{"d":"M58.6,17.9c-0.6,0-1.1-0.2-1.5-0.5c-0.4-0.3-0.7-0.8-0.9-1.4l1-0.4c0.2,0.9,0.7,1.3,1.5,1.3\n\t\t\tc0.5,0,0.9-0.2,1.1-0.5c0.3-0.3,0.4-0.7,0.4-1.3V9.6h1.1v5.6c0,0.9-0.2,1.6-0.7,2.1C60,17.7,59.4,17.9,58.6,17.9z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M67.7,10.6H64v2.6h3.4v1H64v2.6h3.7v1H63V9.6h4.8V10.6z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M72.2,17.7h-1.1v-7.2h-2.3v-1h5.6v1h-2.3V17.7z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M75.3,17.7v-1.1l4.3-6.1h-4.2v-1h5.4v1.1l-4.3,6.1h4.4v1H75.3z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M85.2,17.7h-1.1v-7.2h-2.3v-1h5.6v1h-2.3V17.7z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M91.6,17.7V9.6h3c0.6,0,1.2,0.2,1.7,0.6c0.5,0.4,0.7,1,0.7,1.6c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.5-0.8,0.7\n\t\t\tv0c0.4,0.1,0.7,0.4,1,0.7c0.3,0.3,0.4,0.7,0.4,1.2c0,0.7-0.2,1.2-0.7,1.7c-0.5,0.4-1.1,0.7-1.7,0.7H91.6z M92.6,13.1h1.9\n\t\t\tc0.4,0,0.7-0.1,1-0.4c0.2-0.3,0.4-0.5,0.4-0.9s-0.1-0.6-0.3-0.9c-0.2-0.3-0.5-0.4-0.9-0.4h-2V13.1z M92.6,16.7h2.1\n\t\t\tc0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-1-0.4h-2.1V16.7z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M103.4,10.6h-3.7v2.6h3.4v1h-3.4v2.6h3.7v1h-4.8V9.6h4.8V10.6z"}}),_c('path',{staticClass:"st8",attrs:{"d":"M105,17.7V9.6h1v8.2H105z"}})])])])
}
var play_chvue_type_template_id_47d061b6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/stores/play_ch.vue?vue&type=template&id=47d061b6

// EXTERNAL MODULE: ./src/components/svg/stores/play_ch.vue?vue&type=style&index=0&id=47d061b6&prod&lang=css
var play_chvue_type_style_index_0_id_47d061b6_prod_lang_css = __webpack_require__("7894");

// CONCATENATED MODULE: ./src/components/svg/stores/play_ch.vue

var play_ch_script = {}



/* normalize component */

var play_ch_component = normalizeComponent(
  play_ch_script,
  play_chvue_type_template_id_47d061b6_render,
  play_chvue_type_template_id_47d061b6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var play_ch = (play_ch_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/stores/play_nl.vue?vue&type=template&id=1e5c1bb0
var play_nlvue_type_template_id_1e5c1bb0_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"187px","height":"56px","viewBox":"0 0 187 56","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("google_play")]),_c('defs',[_c('linearGradient',{attrs:{"x1":"60.7777687%","y1":"4.82%","x2":"26.7064163%","y2":"71.94%","id":"linearGradient-1"}},[_c('stop',{attrs:{"stop-color":"#00A0FF","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#00A1FF","offset":"1%"}}),_c('stop',{attrs:{"stop-color":"#00BEFF","offset":"26%"}}),_c('stop',{attrs:{"stop-color":"#00D2FF","offset":"51%"}}),_c('stop',{attrs:{"stop-color":"#00DFFF","offset":"76%"}}),_c('stop',{attrs:{"stop-color":"#00E3FF","offset":"100%"}})],1),_c('linearGradient',{attrs:{"x1":"107.684729%","y1":"50%","x2":"-130.640394%","y2":"50%","id":"linearGradient-2"}},[_c('stop',{attrs:{"stop-color":"#FFE000","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#FFBD00","offset":"41%"}}),_c('stop',{attrs:{"stop-color":"#FFA500","offset":"78%"}}),_c('stop',{attrs:{"stop-color":"#FF9C00","offset":"100%"}})],1),_c('linearGradient',{attrs:{"x1":"86.3173653%","y1":"30.2347278%","x2":"-49.9700599%","y2":"138.344982%","id":"linearGradient-3"}},[_c('stop',{attrs:{"stop-color":"#FF3A44","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#C31162","offset":"100%"}})],1),_c('linearGradient',{attrs:{"x1":"-18.6227545%","y1":"-13.6142933%","x2":"42.2155689%","y2":"34.7178226%","id":"linearGradient-4"}},[_c('stop',{attrs:{"stop-color":"#32A071","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#2DA771","offset":"7%"}}),_c('stop',{attrs:{"stop-color":"#15CF74","offset":"48%"}}),_c('stop',{attrs:{"stop-color":"#06E775","offset":"80%"}}),_c('stop',{attrs:{"stop-color":"#00F076","offset":"100%"}})],1)],1),_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Footer/Desktop","transform":"translate(-1216.000000, -109.000000)","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"Group-8","transform":"translate(261.000000, 33.000000)"}},[_c('g',{attrs:{"id":"Linkliste/Accordion/Accordion-Copy-4","transform":"translate(716.000000, 0.000000)"}},[_c('g',{attrs:{"id":"google_play","transform":"translate(239.000000, 76.000000)"}},[_c('path',{attrs:{"d":"M6.875,0 L180.125,0 C183.975,0 187,3.08 187,7 L187,49 C187,52.92 183.975,56 180.125,56 L6.875,56 C3.025,56 0,52.92 0,49 L0,7 C0,3.08 3.025,0 6.875,0 Z","id":"Path","fill":"#000000"}}),_c('path',{attrs:{"d":"M95.2099602,30.7791014 C92.0638301,30.7791014 89.4648531,33.4610446 89.4648531,36.8487624 C89.4648531,40.0953252 92.0638301,42.7772685 95.3467484,42.7772685 C98.4928785,42.7772685 101.091856,40.0953252 101.091856,36.8487624 C101.091856,33.6021995 98.6296668,30.9202563 95.4835367,30.7791014 C95.3467484,30.6379465 95.3467484,30.6379465 95.2099602,30.7791014 Z M95.2099602,40.377635 C93.2949245,40.51879 91.5166771,38.966086 91.3798888,36.9899173 C91.2431005,35.0137486 92.7477714,33.1787348 94.6628071,33.0375799 C96.5778428,32.896425 98.3560902,34.449129 98.4928785,36.4252977 C98.4928785,36.5664526 98.4928785,36.5664526 98.4928785,36.7076075 C98.6296668,38.6837762 97.2617841,40.2364801 95.2099602,40.377635 C95.3467484,40.377635 95.3467484,40.377635 95.2099602,40.377635 Z M82.4886517,30.7791014 C79.3425216,30.7791014 76.7435446,33.4610446 76.7435446,36.8487624 C76.7435446,40.0953252 79.3425216,42.7772685 82.6254399,42.7772685 C85.77157,42.7772685 88.370547,40.0953252 88.370547,36.8487624 C88.370547,33.6021995 85.9083583,30.9202563 82.7622282,30.7791014 C82.6254399,30.6379465 82.6254399,30.6379465 82.4886517,30.7791014 L82.4886517,30.7791014 Z M82.4886517,40.377635 C80.573616,40.51879 78.7953686,38.966086 78.6585803,36.9899173 C78.521792,35.0137486 80.0264629,33.1787348 81.9414986,33.0375799 C83.8565343,32.896425 85.6347817,34.449129 85.77157,36.4252977 C85.77157,36.5664526 85.77157,36.5664526 85.77157,36.7076075 C85.9083583,38.6837762 84.4036874,40.2364801 82.4886517,40.377635 C82.6254399,40.377635 82.4886517,40.377635 82.4886517,40.377635 L82.4886517,40.377635 Z M67.3051544,32.6141152 L67.3051544,35.1549035 L73.1870497,35.1549035 C73.0502615,36.2841428 72.6398967,37.413382 71.8191671,38.4014664 C70.5880727,39.6718605 68.9466136,40.377635 67.3051544,40.2364801 C63.6118713,40.2364801 60.7393178,37.2722271 60.7393178,33.4610446 C60.7393178,29.6498622 63.6118713,26.6856091 67.3051544,26.6856091 C68.9466136,26.6856091 70.5880727,27.2502287 71.8191671,28.5206229 L73.5974145,26.6856091 C71.9559554,24.9917502 69.7673432,24.0036659 67.4419427,24.0036659 C62.5175652,23.862511 58.277129,27.8148484 58.0035525,32.896425 C57.8667642,37.9780016 61.6968356,42.3538037 66.6212131,42.6361136 C66.8947896,42.6361136 67.0315779,42.6361136 67.3051544,42.6361136 C69.6305549,42.7772685 71.9559554,41.7891841 73.5974145,40.0953252 C74.9652972,38.4014664 75.7860268,36.2841428 75.7860268,34.1668192 C75.7860268,33.6021995 75.7860268,33.0375799 75.6492385,32.6141152 L67.3051544,32.6141152 Z M129.407026,34.5902839 C128.723085,32.3318054 126.671261,30.9202563 124.482649,30.7791014 C121.473307,30.7791014 119.011118,33.3198897 119.011118,36.4252977 C119.011118,36.5664526 119.011118,36.7076075 119.011118,36.8487624 C119.011118,40.0953252 121.473307,42.7772685 124.619437,42.7772685 C124.756225,42.7772685 124.756225,42.7772685 124.893013,42.7772685 C126.808049,42.7772685 128.723085,41.7891841 129.680603,40.0953252 L127.765567,38.6837762 C127.218414,39.6718605 126.124108,40.377635 124.893013,40.377635 C123.661919,40.377635 122.567613,39.6718605 122.02046,38.5426213 L129.817391,35.2960584 L129.407026,34.5902839 Z M121.336519,36.5664526 C121.19973,34.7314388 122.567613,33.1787348 124.34586,33.0375799 L124.34586,33.0375799 C125.303378,33.0375799 126.124108,33.4610446 126.534473,34.3079741 L121.336519,36.5664526 Z M115.044258,42.3538037 L117.643235,42.3538037 L117.643235,24.7094404 L115.044258,24.7094404 L115.044258,42.3538037 Z M110.94061,32.0494956 L110.94061,32.0494956 C110.119881,31.2025661 108.888787,30.6379465 107.79448,30.6379465 C104.64835,30.7791014 102.049373,33.6021995 102.32295,36.9899173 C102.459738,40.0953252 104.921927,42.4949586 107.79448,42.6361136 C109.025575,42.6361136 110.119881,42.0714939 110.803822,41.2245645 L110.94061,41.2245645 L110.94061,42.0714939 C110.94061,44.3299724 109.709516,45.6003666 107.79448,45.6003666 C106.426598,45.6003666 105.332292,44.7534372 104.921927,43.483043 L102.733315,44.4711273 C103.554044,46.5884509 105.605868,48 107.931269,48 C110.94061,48 113.402799,46.1649862 113.402799,41.7891841 L113.402799,31.0614112 L111.077399,31.0614112 L110.94061,32.0494956 L110.94061,32.0494956 Z M107.931269,40.377635 C106.016233,40.2364801 104.511562,38.4014664 104.64835,36.4252977 C104.785139,34.5902839 106.153021,33.3198897 107.931269,33.0375799 C109.709516,33.1787348 111.077399,34.7314388 111.077399,36.5664526 C111.077399,36.5664526 111.077399,36.5664526 111.077399,36.7076075 C111.214187,38.5426213 109.846304,40.2364801 108.068057,40.377635 C108.068057,40.377635 108.068057,40.377635 107.931269,40.377635 L107.931269,40.377635 Z M141.307605,24.7094404 L135.152133,24.7094404 L135.152133,42.3538037 L137.75111,42.3538037 L137.75111,35.7195231 L141.307605,35.7195231 C144.180159,36.0018329 146.779136,33.6021995 147.052712,30.6379465 C147.326289,27.6736935 145.000888,24.9917502 142.128335,24.7094404 C141.854758,24.7094404 141.581182,24.7094404 141.307605,24.7094404 L141.307605,24.7094404 Z M141.307605,33.1787348 L137.75111,33.1787348 L137.75111,27.1090738 L141.444393,27.1090738 C143.085852,27.1090738 144.316947,28.5206229 144.316947,30.0733269 C144.316947,31.6260308 142.949064,33.1787348 141.307605,33.1787348 L141.307605,33.1787348 Z M157.038255,30.6379465 C155.12322,30.4967916 153.344972,31.6260308 152.524243,33.3198897 L154.849643,34.3079741 C155.260008,33.4610446 156.217526,32.896425 157.175044,33.0375799 C158.542926,32.896425 159.774021,33.8845093 159.910809,35.2960584 L159.910809,35.2960584 L159.910809,35.4372133 C159.090079,35.0137486 158.132561,34.7314388 157.311832,34.7314388 C154.849643,34.7314388 152.387454,36.1429879 152.387454,38.6837762 C152.524243,40.9422547 154.30249,42.6361136 156.491102,42.6361136 L156.627891,42.6361136 C157.995773,42.7772685 159.226868,42.0714939 159.910809,40.9422547 L160.047597,40.9422547 L160.047597,42.3538037 L162.509786,42.3538037 L162.509786,35.5783682 C162.372998,32.4729603 160.047597,30.6379465 157.038255,30.6379465 L157.038255,30.6379465 Z M156.764679,40.2364801 C155.943949,40.2364801 154.712855,39.8130154 154.712855,38.6837762 C154.712855,37.2722271 156.217526,36.8487624 157.44862,36.8487624 C158.26935,36.8487624 159.090079,36.9899173 159.774021,37.413382 C159.637232,39.1072409 158.406138,40.377635 156.764679,40.2364801 L156.764679,40.2364801 Z M171.264235,31.0614112 L168.391681,38.6837762 L168.254893,38.6837762 L165.245551,31.0614112 L162.509786,31.0614112 L167.023799,41.7891841 L164.424822,47.7176902 L167.023799,47.7176902 L174,31.0614112 L171.264235,31.0614112 L171.264235,31.0614112 Z M148.283806,42.3538037 L150.882783,42.3538037 L150.882783,24.7094404 L148.283806,24.7094404 L148.283806,42.3538037 Z","id":"Shape","fill":"#FFFFFF"}}),_c('path',{attrs:{"d":"M14.5886861,11 C14.174131,11.56 13.897761,12.26 14.035946,12.96 L14.035946,43.9 C14.035946,44.6 14.174131,45.3 14.7268712,45.86 L14.8650562,46 L32,28.64 L32,28.22 L14.5886861,11 L14.5886861,11 Z","id":"Path","fill":"url(#linearGradient-1)"}}),_c('path',{attrs:{"d":"M36.6551724,34 L31,28.2117647 L31,27.7882353 L36.6551724,22 L36.7931034,22 L43.5517241,25.9529412 C45.4827586,27.0823529 45.4827586,28.9176471 43.5517241,30.0470588 L36.7931034,34 L36.6551724,34 Z","id":"Path","fill":"url(#linearGradient-2)"}}),_c('path',{attrs:{"d":"M37,33.8656743 L31.2155689,28 L14,45.4573639 C14.8263473,46.1556585 16.0658683,46.1556585 16.8922156,45.5970228 L37,33.8656743","id":"Path","fill":"url(#linearGradient-3)"}}),_c('path',{attrs:{"d":"M37,22.1281553 L16.8922156,10.5242718 C16.0658683,9.82524272 14.8263473,9.82524272 14,10.5242718 L31.2155689,28 L37,22.1281553 Z","id":"Path","fill":"url(#linearGradient-4)"}}),_c('path',{attrs:{"d":"M36.8622754,34 L16.8922156,45.3103448 C16.0658683,45.862069 14.9640719,45.862069 14.1377246,45.3103448 L14,45.4482759 L14.1377246,45.5862069 C14.9640719,46.137931 16.0658683,46.137931 16.8922156,45.5862069 L37,34.137931 L36.8622754,34 Z","id":"Path","fill":"#000000","opacity":"0.2"}}),_c('path',{attrs:{"d":"M13.6926407,45.712 C13.2770563,45.136 13,44.416 13,43.696 L13,43.984 C13,44.704 13.1385281,45.424 13.6926407,46 L13.6926407,45.712 L13.6926407,45.712 Z M43.6147186,29.872 L36.6883117,33.904 L36.8268398,34.048 L43.6147186,30.016 C44.4458874,29.584 44.8614719,28.864 45,28 C44.8614719,28.864 44.3073593,29.44 43.6147186,29.872 Z","id":"Shape","fill":"#000000","opacity":"0.12"}}),_c('path',{attrs:{"d":"M16.4782609,10.5891975 L43.6086957,26.1746739 C44.3043478,26.595903 44.8608696,27.1575418 45,28 C44.8608696,27.1575418 44.4434783,26.3150836 43.6086957,26.0342642 L16.4782609,10.5891975 C14.5304348,9.32551018 13,10.1679684 13,12.4145235 L13,12.5549332 C13,10.4487878 14.5304348,9.46591988 16.4782609,10.5891975 Z","id":"Path","fill":"#FFFFFF","opacity":"0.25"}}),_c('path',{attrs:{"d":"M62.38,17.072 C63.588,17.072 64.508,16.706 65.14,15.974 C65.772,15.242 66.088,14.176 66.088,12.776 C66.088,11.376 65.772,10.318 65.14,9.602 C64.508,8.886 63.588,8.528 62.38,8.528 C61.172,8.528 60.254,8.886 59.626,9.602 C58.998,10.318 58.684,11.376 58.684,12.776 C58.684,14.176 59,15.242 59.632,15.974 C60.264,16.706 61.18,17.072 62.38,17.072 Z M62.38,16.16 C61.532,16.16 60.886,15.872 60.442,15.296 C59.998,14.72 59.776,13.88 59.776,12.776 C59.776,11.68 59.998,10.85 60.442,10.286 C60.886,9.722 61.532,9.44 62.38,9.44 C63.228,9.44 63.876,9.722 64.324,10.286 C64.772,10.85 64.996,11.68 64.996,12.776 C64.996,13.88 64.772,14.72 64.324,15.296 C63.876,15.872 63.228,16.16 62.38,16.16 Z M68.416,17.024 C68.736,17.024 68.896,16.936 68.896,16.76 L68.896,16.76 L68.896,10.268 L69.22,10.88 L73.18,16.856 C73.252,16.968 73.392,17.024 73.6,17.024 L73.6,17.024 L73.84,17.024 C74.16,17.024 74.32,16.936 74.32,16.76 L74.32,16.76 L74.32,8.84 C74.32,8.664 74.16,8.576 73.84,8.576 L73.84,8.576 L73.756,8.576 C73.436,8.576 73.276,8.664 73.276,8.84 L73.276,8.84 L73.276,15.26 L72.916,14.588 L69.088,8.804 C69.024,8.716 68.956,8.656 68.884,8.624 C68.812,8.592 68.712,8.576 68.584,8.576 L68.584,8.576 L68.332,8.576 C68.012,8.576 67.852,8.664 67.852,8.84 L67.852,8.84 L67.852,16.76 C67.852,16.936 68.012,17.024 68.332,17.024 L68.332,17.024 L68.416,17.024 Z M78.76,17.024 C79.08,17.024 79.24,16.936 79.24,16.76 L79.24,16.76 L79.24,9.512 L81.508,9.512 C81.596,9.512 81.658,9.484 81.694,9.428 C81.73,9.372 81.748,9.28 81.748,9.152 L81.748,9.152 L81.748,8.96 C81.748,8.832 81.73,8.74 81.694,8.684 C81.658,8.628 81.596,8.6 81.508,8.6 L81.508,8.6 L75.88,8.6 C75.8,8.6 75.74,8.628 75.7,8.684 C75.66,8.74 75.64,8.832 75.64,8.96 L75.64,8.96 L75.64,9.152 C75.64,9.28 75.66,9.372 75.7,9.428 C75.74,9.484 75.8,9.512 75.88,9.512 L75.88,9.512 L78.184,9.512 L78.184,16.76 C78.184,16.936 78.344,17.024 78.664,17.024 L78.664,17.024 L78.76,17.024 Z M85.936,17 C87.056,17 87.954,16.668 88.63,16.004 C89.306,15.34 89.644,14.272 89.644,12.8 C89.644,11.336 89.306,10.27 88.63,9.602 C87.954,8.934 87.056,8.6 85.936,8.6 L85.936,8.6 L83.512,8.6 C83.384,8.6 83.292,8.628 83.236,8.684 C83.18,8.74 83.152,8.832 83.152,8.96 L83.152,8.96 L83.152,16.64 C83.152,16.768 83.18,16.86 83.236,16.916 C83.292,16.972 83.384,17 83.512,17 L83.512,17 L85.936,17 Z M85.852,16.088 L84.208,16.088 L84.208,9.512 L85.852,9.512 C86.66,9.512 87.312,9.778 87.808,10.31 C88.304,10.842 88.552,11.672 88.552,12.8 C88.552,13.936 88.304,14.768 87.808,15.296 C87.312,15.824 86.66,16.088 85.852,16.088 L85.852,16.088 Z M96.052,17 C96.14,17 96.202,16.972 96.238,16.916 C96.274,16.86 96.292,16.768 96.292,16.64 L96.292,16.64 L96.292,16.448 C96.292,16.32 96.274,16.228 96.238,16.172 C96.202,16.116 96.14,16.088 96.052,16.088 L96.052,16.088 L92.548,16.088 L92.548,13.16 L95.68,13.16 C95.768,13.16 95.83,13.132 95.866,13.076 C95.902,13.02 95.92,12.928 95.92,12.8 L95.92,12.8 L95.92,12.608 C95.92,12.48 95.902,12.388 95.866,12.332 C95.83,12.276 95.768,12.248 95.68,12.248 L95.68,12.248 L92.548,12.248 L92.548,9.512 L96.04,9.512 C96.128,9.512 96.19,9.484 96.226,9.428 C96.262,9.372 96.28,9.28 96.28,9.152 L96.28,9.152 L96.28,8.96 C96.28,8.832 96.262,8.74 96.226,8.684 C96.19,8.628 96.128,8.6 96.04,8.6 L96.04,8.6 L91.852,8.6 C91.724,8.6 91.632,8.628 91.576,8.684 C91.52,8.74 91.492,8.832 91.492,8.96 L91.492,8.96 L91.492,16.64 C91.492,16.768 91.52,16.86 91.576,16.916 C91.632,16.972 91.724,17 91.852,17 L91.852,17 L96.052,17 Z M98.62,17.024 C98.94,17.024 99.1,16.936 99.1,16.76 L99.1,16.76 L99.1,13.004 L99.148,13.004 L102.58,16.868 C102.644,16.94 102.726,16.984 102.826,17 C102.926,17.016 103.064,17.024 103.24,17.024 L103.24,17.024 L103.384,17.024 C103.576,17.024 103.712,17.012 103.792,16.988 C103.872,16.964 103.912,16.92 103.912,16.856 C103.912,16.808 103.876,16.744 103.804,16.664 L103.804,16.664 L100.168,12.716 L103.168,8.972 C103.248,8.884 103.288,8.804 103.288,8.732 C103.288,8.684 103.252,8.646 103.18,8.618 C103.108,8.59 103.004,8.576 102.868,8.576 L102.868,8.576 L102.748,8.576 C102.404,8.576 102.188,8.632 102.1,8.744 L102.1,8.744 L99.148,12.512 L99.1,12.512 L99.1,8.84 C99.1,8.664 98.94,8.576 98.62,8.576 L98.62,8.576 L98.524,8.576 C98.204,8.576 98.044,8.664 98.044,8.84 L98.044,8.84 L98.044,16.76 C98.044,16.936 98.204,17.024 98.524,17.024 L98.524,17.024 L98.62,17.024 Z M108.412,17.024 C108.732,17.024 108.892,16.936 108.892,16.76 L108.892,16.76 L108.892,13.148 L113.236,13.148 L113.236,16.76 C113.236,16.936 113.396,17.024 113.716,17.024 L113.716,17.024 L113.812,17.024 C114.132,17.024 114.292,16.936 114.292,16.76 L114.292,16.76 L114.292,8.84 C114.292,8.664 114.132,8.576 113.812,8.576 L113.812,8.576 L113.716,8.576 C113.396,8.576 113.236,8.664 113.236,8.84 L113.236,8.84 L113.236,12.236 L108.892,12.236 L108.892,8.84 C108.892,8.664 108.732,8.576 108.412,8.576 L108.412,8.576 L108.316,8.576 C107.996,8.576 107.836,8.664 107.836,8.84 L107.836,8.84 L107.836,16.76 C107.836,16.936 107.996,17.024 108.316,17.024 L108.316,17.024 L108.412,17.024 Z M121.192,17 C121.28,17 121.342,16.972 121.378,16.916 C121.414,16.86 121.432,16.768 121.432,16.64 L121.432,16.64 L121.432,16.448 C121.432,16.32 121.414,16.228 121.378,16.172 C121.342,16.116 121.28,16.088 121.192,16.088 L121.192,16.088 L117.688,16.088 L117.688,13.16 L120.82,13.16 C120.908,13.16 120.97,13.132 121.006,13.076 C121.042,13.02 121.06,12.928 121.06,12.8 L121.06,12.8 L121.06,12.608 C121.06,12.48 121.042,12.388 121.006,12.332 C120.97,12.276 120.908,12.248 120.82,12.248 L120.82,12.248 L117.688,12.248 L117.688,9.512 L121.18,9.512 C121.268,9.512 121.33,9.484 121.366,9.428 C121.402,9.372 121.42,9.28 121.42,9.152 L121.42,9.152 L121.42,8.96 C121.42,8.832 121.402,8.74 121.366,8.684 C121.33,8.628 121.268,8.6 121.18,8.6 L121.18,8.6 L116.992,8.6 C116.864,8.6 116.772,8.628 116.716,8.684 C116.66,8.74 116.632,8.832 116.632,8.96 L116.632,8.96 L116.632,16.64 C116.632,16.768 116.66,16.86 116.716,16.916 C116.772,16.972 116.864,17 116.992,17 L116.992,17 L121.192,17 Z M125.38,17.024 C125.7,17.024 125.86,16.936 125.86,16.76 L125.86,16.76 L125.86,9.512 L128.128,9.512 C128.216,9.512 128.278,9.484 128.314,9.428 C128.35,9.372 128.368,9.28 128.368,9.152 L128.368,9.152 L128.368,8.96 C128.368,8.832 128.35,8.74 128.314,8.684 C128.278,8.628 128.216,8.6 128.128,8.6 L128.128,8.6 L122.5,8.6 C122.42,8.6 122.36,8.628 122.32,8.684 C122.28,8.74 122.26,8.832 122.26,8.96 L122.26,8.96 L122.26,9.152 C122.26,9.28 122.28,9.372 122.32,9.428 C122.36,9.484 122.42,9.512 122.5,9.512 L122.5,9.512 L124.804,9.512 L124.804,16.76 C124.804,16.936 124.964,17.024 125.284,17.024 L125.284,17.024 L125.38,17.024 Z M135.868,17.072 C137.076,17.072 137.996,16.706 138.628,15.974 C139.26,15.242 139.576,14.176 139.576,12.776 C139.576,11.376 139.26,10.318 138.628,9.602 C137.996,8.886 137.076,8.528 135.868,8.528 C134.66,8.528 133.742,8.886 133.114,9.602 C132.486,10.318 132.172,11.376 132.172,12.776 C132.172,14.176 132.488,15.242 133.12,15.974 C133.752,16.706 134.668,17.072 135.868,17.072 Z M135.868,16.16 C135.02,16.16 134.374,15.872 133.93,15.296 C133.486,14.72 133.264,13.88 133.264,12.776 C133.264,11.68 133.486,10.85 133.93,10.286 C134.374,9.722 135.02,9.44 135.868,9.44 C136.716,9.44 137.364,9.722 137.812,10.286 C138.26,10.85 138.484,11.68 138.484,12.776 C138.484,13.88 138.26,14.72 137.812,15.296 C137.364,15.872 136.716,16.16 135.868,16.16 Z M141.856,17.024 C142.176,17.024 142.336,16.936 142.336,16.76 L142.336,16.76 L142.336,13.424 L144.196,13.424 C144.508,13.424 144.856,13.362 145.24,13.238 C145.624,13.114 145.972,12.868 146.284,12.5 C146.596,12.132 146.752,11.616 146.752,10.952 C146.752,10.056 146.482,9.44 145.942,9.104 C145.402,8.768 144.78,8.6 144.076,8.6 L144.076,8.6 L141.64,8.6 C141.512,8.6 141.42,8.628 141.364,8.684 C141.308,8.74 141.28,8.832 141.28,8.96 L141.28,8.96 L141.28,16.76 C141.28,16.936 141.44,17.024 141.76,17.024 L141.76,17.024 L141.856,17.024 Z M144.208,12.512 L142.336,12.512 L142.336,9.512 L144.04,9.512 C144.48,9.512 144.86,9.618 145.18,9.83 C145.5,10.042 145.66,10.416 145.66,10.952 C145.66,11.528 145.504,11.932 145.192,12.164 C144.88,12.396 144.552,12.512 144.208,12.512 L144.208,12.512 Z","id":"ONTDEKHETOP","fill":"#FFFFFF"}})])])])])])])
}
var play_nlvue_type_template_id_1e5c1bb0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/stores/play_nl.vue?vue&type=template&id=1e5c1bb0

// CONCATENATED MODULE: ./src/components/svg/stores/play_nl.vue

var play_nl_script = {}


/* normalize component */

var play_nl_component = normalizeComponent(
  play_nl_script,
  play_nlvue_type_template_id_1e5c1bb0_render,
  play_nlvue_type_template_id_1e5c1bb0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var play_nl = (play_nl_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/stores/play_es.vue?vue&type=template&id=47624dc2
var play_esvue_type_template_id_47624dc2_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"187px","height":"56px","viewBox":"0 0 187 56","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("google_play_es")]),_c('defs',[_c('linearGradient',{attrs:{"x1":"60.7777687%","y1":"4.82%","x2":"26.7064163%","y2":"71.94%","id":"linearGradient-1"}},[_c('stop',{attrs:{"stop-color":"#00A0FF","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#00A1FF","offset":"1%"}}),_c('stop',{attrs:{"stop-color":"#00BEFF","offset":"26%"}}),_c('stop',{attrs:{"stop-color":"#00D2FF","offset":"51%"}}),_c('stop',{attrs:{"stop-color":"#00DFFF","offset":"76%"}}),_c('stop',{attrs:{"stop-color":"#00E3FF","offset":"100%"}})],1),_c('linearGradient',{attrs:{"x1":"107.684729%","y1":"50%","x2":"-130.640394%","y2":"50%","id":"linearGradient-2"}},[_c('stop',{attrs:{"stop-color":"#FFE000","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#FFBD00","offset":"41%"}}),_c('stop',{attrs:{"stop-color":"#FFA500","offset":"78%"}}),_c('stop',{attrs:{"stop-color":"#FF9C00","offset":"100%"}})],1),_c('linearGradient',{attrs:{"x1":"86.3173653%","y1":"30.2347278%","x2":"-49.9700599%","y2":"138.344982%","id":"linearGradient-3"}},[_c('stop',{attrs:{"stop-color":"#FF3A44","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#C31162","offset":"100%"}})],1),_c('linearGradient',{attrs:{"x1":"-18.6227545%","y1":"-13.6142933%","x2":"42.2155689%","y2":"34.7178226%","id":"linearGradient-4"}},[_c('stop',{attrs:{"stop-color":"#32A071","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#2DA771","offset":"7%"}}),_c('stop',{attrs:{"stop-color":"#15CF74","offset":"48%"}}),_c('stop',{attrs:{"stop-color":"#06E775","offset":"80%"}}),_c('stop',{attrs:{"stop-color":"#00F076","offset":"100%"}})],1)],1),_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"google_play_es","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M6.875,0 L180.125,0 C183.975,0 187,3.08 187,7 L187,49 C187,52.92 183.975,56 180.125,56 L6.875,56 C3.025,56 0,52.92 0,49 L0,7 C0,3.08 3.025,0 6.875,0 Z","id":"Path","fill":"#000000"}}),_c('path',{attrs:{"d":"M95.2099602,30.7791014 C92.0638301,30.7791014 89.4648531,33.4610446 89.4648531,36.8487624 C89.4648531,40.0953252 92.0638301,42.7772685 95.3467484,42.7772685 C98.4928785,42.7772685 101.091856,40.0953252 101.091856,36.8487624 C101.091856,33.6021995 98.6296668,30.9202563 95.4835367,30.7791014 C95.3467484,30.6379465 95.3467484,30.6379465 95.2099602,30.7791014 Z M95.2099602,40.377635 C93.2949245,40.51879 91.5166771,38.966086 91.3798888,36.9899173 C91.2431005,35.0137486 92.7477714,33.1787348 94.6628071,33.0375799 C96.5778428,32.896425 98.3560902,34.449129 98.4928785,36.4252977 C98.4928785,36.5664526 98.4928785,36.5664526 98.4928785,36.7076075 C98.6296668,38.6837762 97.2617841,40.2364801 95.2099602,40.377635 C95.3467484,40.377635 95.3467484,40.377635 95.2099602,40.377635 Z M82.4886517,30.7791014 C79.3425216,30.7791014 76.7435446,33.4610446 76.7435446,36.8487624 C76.7435446,40.0953252 79.3425216,42.7772685 82.6254399,42.7772685 C85.77157,42.7772685 88.370547,40.0953252 88.370547,36.8487624 C88.370547,33.6021995 85.9083583,30.9202563 82.7622282,30.7791014 C82.6254399,30.6379465 82.6254399,30.6379465 82.4886517,30.7791014 L82.4886517,30.7791014 Z M82.4886517,40.377635 C80.573616,40.51879 78.7953686,38.966086 78.6585803,36.9899173 C78.521792,35.0137486 80.0264629,33.1787348 81.9414986,33.0375799 C83.8565343,32.896425 85.6347817,34.449129 85.77157,36.4252977 C85.77157,36.5664526 85.77157,36.5664526 85.77157,36.7076075 C85.9083583,38.6837762 84.4036874,40.2364801 82.4886517,40.377635 C82.6254399,40.377635 82.4886517,40.377635 82.4886517,40.377635 L82.4886517,40.377635 Z M67.3051544,32.6141152 L67.3051544,35.1549035 L73.1870497,35.1549035 C73.0502615,36.2841428 72.6398967,37.413382 71.8191671,38.4014664 C70.5880727,39.6718605 68.9466136,40.377635 67.3051544,40.2364801 C63.6118713,40.2364801 60.7393178,37.2722271 60.7393178,33.4610446 C60.7393178,29.6498622 63.6118713,26.6856091 67.3051544,26.6856091 C68.9466136,26.6856091 70.5880727,27.2502287 71.8191671,28.5206229 L73.5974145,26.6856091 C71.9559554,24.9917502 69.7673432,24.0036659 67.4419427,24.0036659 C62.5175652,23.862511 58.277129,27.8148484 58.0035525,32.896425 C57.8667642,37.9780016 61.6968356,42.3538037 66.6212131,42.6361136 C66.8947896,42.6361136 67.0315779,42.6361136 67.3051544,42.6361136 C69.6305549,42.7772685 71.9559554,41.7891841 73.5974145,40.0953252 C74.9652972,38.4014664 75.7860268,36.2841428 75.7860268,34.1668192 C75.7860268,33.6021995 75.7860268,33.0375799 75.6492385,32.6141152 L67.3051544,32.6141152 Z M129.407026,34.5902839 C128.723085,32.3318054 126.671261,30.9202563 124.482649,30.7791014 C121.473307,30.7791014 119.011118,33.3198897 119.011118,36.4252977 C119.011118,36.5664526 119.011118,36.7076075 119.011118,36.8487624 C119.011118,40.0953252 121.473307,42.7772685 124.619437,42.7772685 C124.756225,42.7772685 124.756225,42.7772685 124.893013,42.7772685 C126.808049,42.7772685 128.723085,41.7891841 129.680603,40.0953252 L127.765567,38.6837762 C127.218414,39.6718605 126.124108,40.377635 124.893013,40.377635 C123.661919,40.377635 122.567613,39.6718605 122.02046,38.5426213 L129.817391,35.2960584 L129.407026,34.5902839 Z M121.336519,36.5664526 C121.19973,34.7314388 122.567613,33.1787348 124.34586,33.0375799 L124.34586,33.0375799 C125.303378,33.0375799 126.124108,33.4610446 126.534473,34.3079741 L121.336519,36.5664526 Z M115.044258,42.3538037 L117.643235,42.3538037 L117.643235,24.7094404 L115.044258,24.7094404 L115.044258,42.3538037 Z M110.94061,32.0494956 L110.94061,32.0494956 C110.119881,31.2025661 108.888787,30.6379465 107.79448,30.6379465 C104.64835,30.7791014 102.049373,33.6021995 102.32295,36.9899173 C102.459738,40.0953252 104.921927,42.4949586 107.79448,42.6361136 C109.025575,42.6361136 110.119881,42.0714939 110.803822,41.2245645 L110.94061,41.2245645 L110.94061,42.0714939 C110.94061,44.3299724 109.709516,45.6003666 107.79448,45.6003666 C106.426598,45.6003666 105.332292,44.7534372 104.921927,43.483043 L102.733315,44.4711273 C103.554044,46.5884509 105.605868,48 107.931269,48 C110.94061,48 113.402799,46.1649862 113.402799,41.7891841 L113.402799,31.0614112 L111.077399,31.0614112 L110.94061,32.0494956 L110.94061,32.0494956 Z M107.931269,40.377635 C106.016233,40.2364801 104.511562,38.4014664 104.64835,36.4252977 C104.785139,34.5902839 106.153021,33.3198897 107.931269,33.0375799 C109.709516,33.1787348 111.077399,34.7314388 111.077399,36.5664526 C111.077399,36.5664526 111.077399,36.5664526 111.077399,36.7076075 C111.214187,38.5426213 109.846304,40.2364801 108.068057,40.377635 C108.068057,40.377635 108.068057,40.377635 107.931269,40.377635 L107.931269,40.377635 Z M141.307605,24.7094404 L135.152133,24.7094404 L135.152133,42.3538037 L137.75111,42.3538037 L137.75111,35.7195231 L141.307605,35.7195231 C144.180159,36.0018329 146.779136,33.6021995 147.052712,30.6379465 C147.326289,27.6736935 145.000888,24.9917502 142.128335,24.7094404 C141.854758,24.7094404 141.581182,24.7094404 141.307605,24.7094404 L141.307605,24.7094404 Z M141.307605,33.1787348 L137.75111,33.1787348 L137.75111,27.1090738 L141.444393,27.1090738 C143.085852,27.1090738 144.316947,28.5206229 144.316947,30.0733269 C144.316947,31.6260308 142.949064,33.1787348 141.307605,33.1787348 L141.307605,33.1787348 Z M157.038255,30.6379465 C155.12322,30.4967916 153.344972,31.6260308 152.524243,33.3198897 L154.849643,34.3079741 C155.260008,33.4610446 156.217526,32.896425 157.175044,33.0375799 C158.542926,32.896425 159.774021,33.8845093 159.910809,35.2960584 L159.910809,35.2960584 L159.910809,35.4372133 C159.090079,35.0137486 158.132561,34.7314388 157.311832,34.7314388 C154.849643,34.7314388 152.387454,36.1429879 152.387454,38.6837762 C152.524243,40.9422547 154.30249,42.6361136 156.491102,42.6361136 L156.627891,42.6361136 C157.995773,42.7772685 159.226868,42.0714939 159.910809,40.9422547 L160.047597,40.9422547 L160.047597,42.3538037 L162.509786,42.3538037 L162.509786,35.5783682 C162.372998,32.4729603 160.047597,30.6379465 157.038255,30.6379465 L157.038255,30.6379465 Z M156.764679,40.2364801 C155.943949,40.2364801 154.712855,39.8130154 154.712855,38.6837762 C154.712855,37.2722271 156.217526,36.8487624 157.44862,36.8487624 C158.26935,36.8487624 159.090079,36.9899173 159.774021,37.413382 C159.637232,39.1072409 158.406138,40.377635 156.764679,40.2364801 L156.764679,40.2364801 Z M171.264235,31.0614112 L168.391681,38.6837762 L168.254893,38.6837762 L165.245551,31.0614112 L162.509786,31.0614112 L167.023799,41.7891841 L164.424822,47.7176902 L167.023799,47.7176902 L174,31.0614112 L171.264235,31.0614112 L171.264235,31.0614112 Z M148.283806,42.3538037 L150.882783,42.3538037 L150.882783,24.7094404 L148.283806,24.7094404 L148.283806,42.3538037 Z","id":"Shape","fill":"#FFFFFF"}}),_c('path',{attrs:{"d":"M14.5886861,11 C14.174131,11.56 13.897761,12.26 14.035946,12.96 L14.035946,43.9 C14.035946,44.6 14.174131,45.3 14.7268712,45.86 L14.8650562,46 L32,28.64 L32,28.22 L14.5886861,11 L14.5886861,11 Z","id":"Path","fill":"url(#linearGradient-1)"}}),_c('path',{attrs:{"d":"M36.6551724,34 L31,28.2117647 L31,27.7882353 L36.6551724,22 L36.7931034,22 L43.5517241,25.9529412 C45.4827586,27.0823529 45.4827586,28.9176471 43.5517241,30.0470588 L36.7931034,34 L36.6551724,34 Z","id":"Path","fill":"url(#linearGradient-2)"}}),_c('path',{attrs:{"d":"M37,33.8656743 L31.2155689,28 L14,45.4573639 C14.8263473,46.1556585 16.0658683,46.1556585 16.8922156,45.5970228 L37,33.8656743","id":"Path","fill":"url(#linearGradient-3)"}}),_c('path',{attrs:{"d":"M37,22.1281553 L16.8922156,10.5242718 C16.0658683,9.82524272 14.8263473,9.82524272 14,10.5242718 L31.2155689,28 L37,22.1281553 Z","id":"Path","fill":"url(#linearGradient-4)"}}),_c('path',{attrs:{"d":"M36.8622754,34 L16.8922156,45.3103448 C16.0658683,45.862069 14.9640719,45.862069 14.1377246,45.3103448 L14,45.4482759 L14.1377246,45.5862069 C14.9640719,46.137931 16.0658683,46.137931 16.8922156,45.5862069 L37,34.137931 L36.8622754,34 Z","id":"Path","fill":"#000000","opacity":"0.2"}}),_c('path',{attrs:{"d":"M13.6926407,45.712 C13.2770563,45.136 13,44.416 13,43.696 L13,43.984 C13,44.704 13.1385281,45.424 13.6926407,46 L13.6926407,45.712 L13.6926407,45.712 Z M43.6147186,29.872 L36.6883117,33.904 L36.8268398,34.048 L43.6147186,30.016 C44.4458874,29.584 44.8614719,28.864 45,28 C44.8614719,28.864 44.3073593,29.44 43.6147186,29.872 Z","id":"Shape","fill":"#000000","opacity":"0.12"}}),_c('path',{attrs:{"d":"M16.4782609,10.5891975 L43.6086957,26.1746739 C44.3043478,26.595903 44.8608696,27.1575418 45,28 C44.8608696,27.1575418 44.4434783,26.3150836 43.6086957,26.0342642 L16.4782609,10.5891975 C14.5304348,9.32551018 13,10.1679684 13,12.4145235 L13,12.5549332 C13,10.4487878 14.5304348,9.46591988 16.4782609,10.5891975 Z","id":"Path","fill":"#FFFFFF","opacity":"0.25"}}),_c('path',{attrs:{"d":"M61.948,17 C63.068,17 63.966,16.668 64.642,16.004 C65.318,15.34 65.656,14.272 65.656,12.8 C65.656,11.336 65.318,10.27 64.642,9.602 C63.966,8.934 63.068,8.6 61.948,8.6 L61.948,8.6 L59.524,8.6 C59.396,8.6 59.304,8.628 59.248,8.684 C59.192,8.74 59.164,8.832 59.164,8.96 L59.164,8.96 L59.164,16.64 C59.164,16.768 59.192,16.86 59.248,16.916 C59.304,16.972 59.396,17 59.524,17 L59.524,17 L61.948,17 Z M61.864,16.088 L60.22,16.088 L60.22,9.512 L61.864,9.512 C62.672,9.512 63.324,9.778 63.82,10.31 C64.316,10.842 64.564,11.672 64.564,12.8 C64.564,13.936 64.316,14.768 63.82,15.296 C63.324,15.824 62.672,16.088 61.864,16.088 L61.864,16.088 Z M68.008,9.212 C68.328,9.212 68.488,9.124 68.488,8.948 L68.488,8.948 L68.488,8.24 C68.488,8.064 68.328,7.976 68.008,7.976 L68.008,7.976 L67.864,7.976 C67.544,7.976 67.384,8.064 67.384,8.24 L67.384,8.24 L67.384,8.948 C67.384,9.124 67.544,9.212 67.864,9.212 L67.864,9.212 L68.008,9.212 Z M67.96,17.024 C68.28,17.024 68.44,16.936 68.44,16.76 L68.44,16.76 L68.44,10.964 C68.44,10.788 68.28,10.7 67.96,10.7 L67.96,10.7 L67.912,10.7 C67.592,10.7 67.432,10.788 67.432,10.964 L67.432,10.964 L67.432,16.76 C67.432,16.936 67.592,17.024 67.912,17.024 L67.912,17.024 L67.96,17.024 Z M71.848,17.108 C72.24,17.108 72.598,17.026 72.922,16.862 C73.246,16.698 73.502,16.474 73.69,16.19 C73.878,15.906 73.972,15.588 73.972,15.236 C73.972,14.868 73.914,14.57 73.798,14.342 C73.682,14.114 73.49,13.922 73.222,13.766 C72.954,13.61 72.564,13.452 72.052,13.292 C71.716,13.188 71.476,13.056 71.332,12.896 C71.188,12.736 71.116,12.52 71.116,12.248 C71.116,12.016 71.218,11.832 71.422,11.696 C71.626,11.56 71.88,11.492 72.184,11.492 C72.512,11.492 72.77,11.542 72.958,11.642 C73.146,11.742 73.252,11.796 73.276,11.804 C73.348,11.804 73.43,11.722 73.522,11.558 C73.614,11.394 73.66,11.26 73.66,11.156 C73.66,11.02 73.498,10.9 73.174,10.796 C72.85,10.692 72.484,10.64 72.076,10.64 C71.692,10.64 71.35,10.714 71.05,10.862 C70.75,11.01 70.514,11.216 70.342,11.48 C70.17,11.744 70.084,12.044 70.084,12.38 C70.084,12.844 70.204,13.214 70.444,13.49 C70.684,13.766 71.12,13.996 71.752,14.18 C72.2,14.308 72.512,14.452 72.688,14.612 C72.864,14.772 72.952,14.988 72.952,15.26 C72.952,15.908 72.56,16.232 71.776,16.232 C71.528,16.232 71.302,16.196 71.098,16.124 C70.894,16.052 70.724,15.972 70.588,15.884 C70.452,15.796 70.376,15.752 70.36,15.752 C70.28,15.752 70.19,15.832 70.09,15.992 C69.99,16.152 69.94,16.272 69.94,16.352 C69.94,16.448 70.026,16.556 70.198,16.676 C70.37,16.796 70.602,16.898 70.894,16.982 C71.186,17.066 71.504,17.108 71.848,17.108 Z M76.036,19.496 C76.356,19.496 76.516,19.408 76.516,19.232 L76.516,19.232 L76.516,16.46 C76.772,16.66 77.034,16.812 77.302,16.916 C77.57,17.02 77.88,17.072 78.232,17.072 C78.712,17.072 79.136,16.948 79.504,16.7 C79.872,16.452 80.158,16.088 80.362,15.608 C80.566,15.128 80.668,14.548 80.668,13.868 C80.668,13.244 80.576,12.69 80.392,12.206 C80.208,11.722 79.942,11.342 79.594,11.066 C79.246,10.79 78.828,10.652 78.34,10.652 C77.644,10.652 77.008,10.952 76.432,11.552 C76.424,11.512 76.406,11.428 76.378,11.3 C76.35,11.172 76.31,11.05 76.258,10.934 C76.206,10.818 76.124,10.76 76.012,10.76 C75.884,10.76 75.744,10.782 75.592,10.826 C75.44,10.87 75.364,10.94 75.364,11.036 C75.364,11.06 75.388,11.186 75.436,11.414 C75.484,11.642 75.508,12.02 75.508,12.548 L75.508,12.548 L75.508,19.232 C75.508,19.408 75.668,19.496 75.988,19.496 L75.988,19.496 L76.036,19.496 Z M78.004,16.184 C77.444,16.184 76.948,16.004 76.516,15.644 L76.516,15.644 L76.516,12.356 C76.756,12.092 77.018,11.888 77.302,11.744 C77.586,11.6 77.864,11.528 78.136,11.528 C78.608,11.528 78.972,11.738 79.228,12.158 C79.484,12.578 79.612,13.176 79.612,13.952 C79.612,14.672 79.476,15.222 79.204,15.602 C78.932,15.982 78.532,16.176 78.004,16.184 Z M84.796,17.072 C85.692,17.072 86.37,16.802 86.83,16.262 C87.29,15.722 87.52,14.932 87.52,13.892 C87.52,12.844 87.286,12.042 86.818,11.486 C86.35,10.93 85.676,10.652 84.796,10.652 C83.9,10.652 83.212,10.932 82.732,11.492 C82.252,12.052 82.012,12.852 82.012,13.892 C82.012,14.924 82.25,15.712 82.726,16.256 C83.202,16.8 83.892,17.072 84.796,17.072 Z M84.76,16.208 C84.176,16.208 83.748,16.018 83.476,15.638 C83.204,15.258 83.068,14.668 83.068,13.868 C83.068,13.06 83.204,12.466 83.476,12.086 C83.748,11.706 84.176,11.516 84.76,11.516 C85.344,11.516 85.776,11.708 86.056,12.092 C86.336,12.476 86.476,13.068 86.476,13.868 C86.476,14.668 86.336,15.258 86.056,15.638 C85.776,16.018 85.344,16.208 84.76,16.208 Z M89.74,17.024 C90.06,17.024 90.22,16.936 90.22,16.76 L90.22,16.76 L90.22,12.368 C90.42,12.112 90.654,11.908 90.922,11.756 C91.19,11.604 91.46,11.528 91.732,11.528 C92.124,11.528 92.426,11.63 92.638,11.834 C92.85,12.038 92.956,12.324 92.956,12.692 L92.956,12.692 L92.956,16.76 C92.956,16.936 93.116,17.024 93.436,17.024 L93.436,17.024 L93.484,17.024 C93.804,17.024 93.964,16.936 93.964,16.76 L93.964,16.76 L93.964,12.596 C93.964,11.988 93.79,11.512 93.442,11.168 C93.094,10.824 92.616,10.652 92.008,10.652 C91.672,10.652 91.34,10.732 91.012,10.892 C90.684,11.052 90.392,11.272 90.136,11.552 C90.128,11.512 90.11,11.428 90.082,11.3 C90.054,11.172 90.014,11.05 89.962,10.934 C89.91,10.818 89.828,10.76 89.716,10.76 C89.588,10.76 89.448,10.782 89.296,10.826 C89.144,10.87 89.068,10.94 89.068,11.036 C89.068,11.06 89.092,11.186 89.14,11.414 C89.188,11.642 89.212,12.02 89.212,12.548 L89.212,12.548 L89.212,16.76 C89.212,16.936 89.372,17.024 89.692,17.024 L89.692,17.024 L89.74,17.024 Z M96.532,9.212 C96.852,9.212 97.012,9.124 97.012,8.948 L97.012,8.948 L97.012,8.24 C97.012,8.064 96.852,7.976 96.532,7.976 L96.532,7.976 L96.388,7.976 C96.068,7.976 95.908,8.064 95.908,8.24 L95.908,8.24 L95.908,8.948 C95.908,9.124 96.068,9.212 96.388,9.212 L96.388,9.212 L96.532,9.212 Z M96.484,17.024 C96.804,17.024 96.964,16.936 96.964,16.76 L96.964,16.76 L96.964,10.964 C96.964,10.788 96.804,10.7 96.484,10.7 L96.484,10.7 L96.436,10.7 C96.116,10.7 95.956,10.788 95.956,10.964 L95.956,10.964 L95.956,16.76 C95.956,16.936 96.116,17.024 96.436,17.024 L96.436,17.024 L96.484,17.024 Z M101.896,17.072 C102.368,17.072 102.78,16.936 103.132,16.664 C103.484,16.392 103.754,16.012 103.942,15.524 C104.13,15.036 104.224,14.48 104.224,13.856 C104.224,13.176 104.122,12.596 103.918,12.116 C103.714,11.636 103.428,11.272 103.06,11.024 C102.692,10.776 102.268,10.652 101.788,10.652 C101.436,10.652 101.126,10.704 100.858,10.808 C100.59,10.912 100.328,11.064 100.072,11.264 L100.072,11.264 L100.072,8.24 C100.072,8.064 99.912,7.976 99.592,7.976 L99.592,7.976 L99.544,7.976 C99.224,7.976 99.064,8.064 99.064,8.24 L99.064,8.24 L99.064,16.76 C99.064,16.936 99.184,17.024 99.424,17.024 L99.424,17.024 L99.472,17.024 C99.648,17.024 99.756,16.976 99.796,16.88 C99.884,16.648 99.948,16.412 99.988,16.172 C100.564,16.772 101.2,17.072 101.896,17.072 Z M101.692,16.196 C101.42,16.196 101.142,16.124 100.858,15.98 C100.574,15.836 100.312,15.632 100.072,15.368 L100.072,15.368 L100.072,12.08 C100.28,11.904 100.514,11.77 100.774,11.678 C101.034,11.586 101.296,11.54 101.56,11.54 C102.088,11.548 102.488,11.742 102.76,12.122 C103.032,12.502 103.168,13.052 103.168,13.772 C103.168,14.548 103.04,15.146 102.784,15.566 C102.528,15.986 102.164,16.196 101.692,16.196 Z M107.404,17.072 C107.988,17.072 108.28,16.952 108.28,16.712 C108.28,16.632 108.256,16.518 108.208,16.37 C108.16,16.222 108.1,16.148 108.028,16.148 C107.988,16.148 107.93,16.158 107.854,16.178 C107.778,16.198 107.664,16.208 107.512,16.208 C107.312,16.208 107.154,16.144 107.038,16.016 C106.922,15.888 106.864,15.656 106.864,15.32 L106.864,15.32 L106.864,8.24 C106.864,8.064 106.704,7.976 106.384,7.976 L106.384,7.976 L106.336,7.976 C106.016,7.976 105.856,8.064 105.856,8.24 L105.856,8.24 L105.856,15.416 C105.856,16.032 106.014,16.462 106.33,16.706 C106.646,16.95 107.004,17.072 107.404,17.072 Z M112.036,17.072 C112.412,17.072 112.766,17.03 113.098,16.946 C113.43,16.862 113.696,16.758 113.896,16.634 C114.096,16.51 114.196,16.4 114.196,16.304 C114.196,16.224 114.146,16.104 114.046,15.944 C113.946,15.784 113.856,15.704 113.776,15.704 C113.752,15.704 113.66,15.746 113.5,15.83 C113.34,15.914 113.138,15.998 112.894,16.082 C112.65,16.166 112.36,16.208 112.024,16.208 C111.432,16.208 110.988,16.052 110.692,15.74 C110.396,15.428 110.224,14.94 110.176,14.276 L110.176,14.276 L113.968,14.276 C114.04,14.276 114.124,14.212 114.22,14.084 C114.316,13.956 114.364,13.856 114.364,13.784 C114.364,12.76 114.156,11.982 113.74,11.45 C113.324,10.918 112.708,10.652 111.892,10.652 C110.972,10.652 110.276,10.928 109.804,11.48 C109.332,12.032 109.096,12.84 109.096,13.904 C109.096,14.976 109.336,15.772 109.816,16.292 C110.296,16.812 111.036,17.072 112.036,17.072 Z M113.296,13.412 L110.176,13.412 C110.264,12.148 110.824,11.516 111.856,11.516 C112.816,11.516 113.296,12.148 113.296,13.412 L113.296,13.412 Z M121.384,17.072 C121.76,17.072 122.114,17.03 122.446,16.946 C122.778,16.862 123.044,16.758 123.244,16.634 C123.444,16.51 123.544,16.4 123.544,16.304 C123.544,16.224 123.494,16.104 123.394,15.944 C123.294,15.784 123.204,15.704 123.124,15.704 C123.1,15.704 123.008,15.746 122.848,15.83 C122.688,15.914 122.486,15.998 122.242,16.082 C121.998,16.166 121.708,16.208 121.372,16.208 C120.78,16.208 120.336,16.052 120.04,15.74 C119.744,15.428 119.572,14.94 119.524,14.276 L119.524,14.276 L123.316,14.276 C123.388,14.276 123.472,14.212 123.568,14.084 C123.664,13.956 123.712,13.856 123.712,13.784 C123.712,12.76 123.504,11.982 123.088,11.45 C122.672,10.918 122.056,10.652 121.24,10.652 C120.32,10.652 119.624,10.928 119.152,11.48 C118.68,12.032 118.444,12.84 118.444,13.904 C118.444,14.976 118.684,15.772 119.164,16.292 C119.644,16.812 120.384,17.072 121.384,17.072 Z M122.644,13.412 L119.524,13.412 C119.612,12.148 120.172,11.516 121.204,11.516 C122.164,11.516 122.644,12.148 122.644,13.412 L122.644,13.412 Z M125.812,17.024 C126.132,17.024 126.292,16.936 126.292,16.76 L126.292,16.76 L126.292,12.368 C126.492,12.112 126.726,11.908 126.994,11.756 C127.262,11.604 127.532,11.528 127.804,11.528 C128.196,11.528 128.498,11.63 128.71,11.834 C128.922,12.038 129.028,12.324 129.028,12.692 L129.028,12.692 L129.028,16.76 C129.028,16.936 129.188,17.024 129.508,17.024 L129.508,17.024 L129.556,17.024 C129.876,17.024 130.036,16.936 130.036,16.76 L130.036,16.76 L130.036,12.596 C130.036,11.988 129.862,11.512 129.514,11.168 C129.166,10.824 128.688,10.652 128.08,10.652 C127.744,10.652 127.412,10.732 127.084,10.892 C126.756,11.052 126.464,11.272 126.208,11.552 C126.2,11.512 126.182,11.428 126.154,11.3 C126.126,11.172 126.086,11.05 126.034,10.934 C125.982,10.818 125.9,10.76 125.788,10.76 C125.66,10.76 125.52,10.782 125.368,10.826 C125.216,10.87 125.14,10.94 125.14,11.036 C125.14,11.06 125.164,11.186 125.212,11.414 C125.26,11.642 125.284,12.02 125.284,12.548 L125.284,12.548 L125.284,16.76 C125.284,16.936 125.444,17.024 125.764,17.024 L125.764,17.024 L125.812,17.024 Z","id":"Disponibleen","fill":"#FFFFFF"}})])])])
}
var play_esvue_type_template_id_47624dc2_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/stores/play_es.vue?vue&type=template&id=47624dc2

// CONCATENATED MODULE: ./src/components/svg/stores/play_es.vue

var play_es_script = {}


/* normalize component */

var play_es_component = normalizeComponent(
  play_es_script,
  play_esvue_type_template_id_47624dc2_render,
  play_esvue_type_template_id_47624dc2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var play_es = (play_es_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/arrow-svg.vue?vue&type=template&id=a32f9acc
var arrow_svgvue_type_template_id_a32f9acc_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.0021 18.3377L21.9564 12.3834C22.1681 12.1717 22.1681 11.8285 21.9564 11.6167L16.002 5.66242C15.7903 5.45074 15.447 5.45074 15.2353 5.66242L14.3487 6.54907C14.1339 6.76379 14.1375 7.11308 14.3565 7.32344L18.0031 10.8255H2.42689C2.12751 10.8255 1.88477 11.0682 1.88477 11.3676V12.6326C1.88477 12.9319 2.12751 13.1747 2.42689 13.1747H18.0031L14.3566 16.6767C14.1375 16.8871 14.1339 17.2364 14.3487 17.4511L15.2353 18.3377C15.4471 18.5494 15.7903 18.5494 16.0021 18.3377Z"}})])
}
var arrow_svgvue_type_template_id_a32f9acc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/arrow-svg.vue?vue&type=template&id=a32f9acc

// CONCATENATED MODULE: ./src/components/svg/ui/arrow-svg.vue

var arrow_svg_script = {}


/* normalize component */

var arrow_svg_component = normalizeComponent(
  arrow_svg_script,
  arrow_svgvue_type_template_id_a32f9acc_render,
  arrow_svgvue_type_template_id_a32f9acc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var arrow_svg = (arrow_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/arrow-right-long-svg.vue?vue&type=template&id=1799e052
var arrow_right_long_svgvue_type_template_id_1799e052_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"91","height":"13","viewBox":"0 0 91 13"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"fill":"#00D5E0"}},[_c('g',[_c('g',[_c('g',[_c('g',[_c('path',{attrs:{"d":"M84.117 40.834l5.955-5.954c.211-.212.211-.555 0-.767l-5.955-5.954c-.211-.212-.555-.212-.766 0l-.887.886c-.215.215-.211.564.008.775l3.646 3.502H.542c-.3 0-.542.243-.542.542v1.265c0 .3.243.542.542.542h85.576l-3.646 3.502c-.22.21-.223.56-.008.774l.887.887c.211.212.555.212.766 0z","transform":"translate(-125 -742) translate(-1 422) translate(12 231) translate(2 61) translate(112)"}})])])])])])])])
}
var arrow_right_long_svgvue_type_template_id_1799e052_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/arrow-right-long-svg.vue?vue&type=template&id=1799e052

// CONCATENATED MODULE: ./src/components/svg/ui/arrow-right-long-svg.vue

var arrow_right_long_svg_script = {}


/* normalize component */

var arrow_right_long_svg_component = normalizeComponent(
  arrow_right_long_svg_script,
  arrow_right_long_svgvue_type_template_id_1799e052_render,
  arrow_right_long_svgvue_type_template_id_1799e052_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var arrow_right_long_svg = (arrow_right_long_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/badge-svg.vue?vue&type=template&id=cd743222
var badge_svgvue_type_template_id_cd743222_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12"}},[_c('path',{attrs:{"d":"M6.086 2.015L7.25 2.5l.485 1.163c.027.054.08.087.14.087.06 0 .113-.033.14-.087L8.5 2.5l1.164-.485a.156.156 0 00.086-.14.156.156 0 00-.086-.14L8.5 1.25 8.015.087a.157.157 0 00-.28 0L7.25 1.25l-1.164.485a.158.158 0 000 .28zm2.452 4.25l-2.456-.359-1.1-2.231a.538.538 0 00-.965 0l-1.1 2.231-2.455.359a.537.537 0 00-.298.918l1.779 1.735-.422 2.45a.538.538 0 00.78.568L4.5 10.78l2.198 1.157a.54.54 0 00.567-.04.542.542 0 00.214-.527l-.42-2.451 1.78-1.735a.54.54 0 00-.3-.918zm3.393-1.127L11 4.75l-.389-.93a.124.124 0 00-.112-.07.126.126 0 00-.112.07L10 4.75l-.93.388c-.043.021-.07.065-.07.112s.027.09.07.112l.93.388.388.93a.125.125 0 00.224 0L11 5.75l.93-.388c.043-.021.07-.065.07-.112s-.027-.09-.07-.112z","fill":"#323231","fill-rule":"nonzero"}})])
}
var badge_svgvue_type_template_id_cd743222_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/badge-svg.vue?vue&type=template&id=cd743222

// CONCATENATED MODULE: ./src/components/svg/ui/badge-svg.vue

var badge_svg_script = {}


/* normalize component */

var badge_svg_component = normalizeComponent(
  badge_svg_script,
  badge_svgvue_type_template_id_cd743222_render,
  badge_svgvue_type_template_id_cd743222_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var badge_svg = (badge_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/home-hero-de-svg.vue?vue&type=template&id=1710cbd4
var home_hero_de_svgvue_type_template_id_1710cbd4_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"718","height":"82","viewBox":"0 0 718 82","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M26.8148 50.2562C25.3588 50.8109 23.9721 51.3309 22.6548 51.8162C21.3374 52.2322 20.0201 52.7175 18.7028 53.2722C18.3561 53.4109 17.8361 53.6535 17.1428 54.0002C16.5881 54.2775 16.0334 54.4509 15.4788 54.5202C14.9241 54.5202 14.4734 54.1389 14.1268 53.3762C13.6414 52.5442 13.5374 51.8162 13.8148 51.1922C14.1614 50.5682 14.6121 50.0482 15.1668 49.6322C15.9294 49.0775 16.6921 48.5575 17.4548 48.0722C18.2868 47.5869 19.1188 47.1362 19.9508 46.7202C21.1988 46.1655 22.4468 45.6802 23.6948 45.2642C24.9428 44.8482 26.1561 44.4322 27.3348 44.0162C28.2361 39.4402 29.1028 34.9682 29.9348 30.6002C30.7668 26.2322 31.5988 21.7949 32.4308 17.2882C32.2921 17.2882 32.0841 17.2535 31.8068 17.1842C31.5988 17.1149 31.3908 17.1495 31.1828 17.2882C28.0628 18.3975 25.0121 19.5415 22.0308 20.7202C19.0494 21.8295 15.9988 22.9735 12.8788 24.1522C12.3241 24.4295 11.7694 24.7415 11.2148 25.0882C10.7294 25.3655 10.5561 25.9895 10.6948 26.9602C10.7641 27.0989 10.7294 27.2722 10.5908 27.4802C10.5214 27.6189 10.4521 27.7575 10.3828 27.8962C10.0361 28.4509 9.44677 28.8669 8.61477 29.1442C7.78277 29.4215 6.88144 29.5949 5.91077 29.6642C5.00944 29.7335 4.10811 29.6642 3.20677 29.4562C2.37477 29.2482 1.78544 28.9015 1.43877 28.4162C0.884108 27.7229 0.641441 26.9255 0.710774 26.0242C0.710774 25.0535 1.09211 24.1869 1.85477 23.4242C3.58811 21.8295 5.39077 20.4775 7.26277 19.3682C10.5908 17.4962 13.9881 15.8669 17.4548 14.4802C20.9214 13.0242 24.4228 11.7069 27.9588 10.5282C35.5161 8.03219 43.0388 6.09086 50.5268 4.70419C58.0841 3.31753 65.7454 2.34686 73.5108 1.79219C74.6894 1.65353 75.8681 1.65353 77.0468 1.79219C78.2254 1.93086 79.4041 2.10419 80.5828 2.31219C81.4841 2.38153 82.4548 2.83219 83.4948 3.66419C84.6734 4.49619 85.1588 5.77886 84.9508 7.51219C84.8814 8.13619 84.5694 8.79486 84.0148 9.48819C83.5294 10.1815 82.9401 10.8055 82.2468 11.3602C81.6228 11.9149 80.9294 12.3655 80.1668 12.7122C79.4734 13.0589 78.8494 13.1629 78.2948 13.0242C77.3934 12.8855 76.7694 12.4349 76.4228 11.6722C76.0761 10.9095 75.7641 10.0082 75.4868 8.96819C74.3081 9.03753 73.1294 9.10686 71.9508 9.17619C70.7721 9.24553 69.5934 9.34953 68.4148 9.48819C64.0468 9.83486 59.7828 10.4242 55.6228 11.2562C51.5321 12.0882 47.3374 13.0242 43.0388 14.0642C42.3454 14.2029 41.7214 14.4455 41.1668 14.7922C40.6814 15.1389 40.3348 15.7629 40.1268 16.6642C39.4334 20.4775 38.7401 24.2909 38.0468 28.1042C37.3534 31.8482 36.6601 35.5922 35.9668 39.3362C35.8974 39.6829 35.8628 39.9949 35.8628 40.2722C35.8628 40.5495 35.8628 40.9655 35.8628 41.5202C37.6654 41.1042 39.3988 40.7229 41.0628 40.3762C42.7961 39.9602 44.4948 39.5789 46.1588 39.2322C46.7134 39.0935 47.2334 38.9895 47.7188 38.9202C48.2734 38.8509 48.8281 38.8855 49.3828 39.0242C49.7294 39.0935 50.0761 39.3015 50.4228 39.6482C50.7694 39.9949 50.9774 40.3415 51.0468 40.6882C51.1854 41.1042 51.1508 41.5895 50.9428 42.1442C50.7348 42.6989 50.5268 43.0455 50.3188 43.1842C49.8334 43.6002 49.2788 43.9122 48.6548 44.1202C48.1001 44.3282 47.5454 44.5362 46.9908 44.7442C44.9801 45.2989 42.9694 45.8535 40.9588 46.4082C39.0174 46.8935 37.0068 47.4135 34.9268 47.9682C34.7881 48.7309 34.6494 49.4589 34.5108 50.1522C34.3721 50.8455 34.2681 51.5735 34.1988 52.3362C34.0601 55.2482 33.9214 58.1602 33.7828 61.0722C33.7134 63.9842 33.6441 66.8962 33.5748 69.8082C33.5748 70.7095 33.6441 71.5762 33.7828 72.4082C33.9908 73.2402 34.1641 74.0722 34.3028 74.9042C34.8574 77.1229 34.4414 78.7522 33.0548 79.7922C32.2921 80.3469 31.4601 80.5549 30.5588 80.4162C29.7268 80.3469 28.9988 79.8269 28.3748 78.8562C27.7508 78.0242 27.3348 77.0189 27.1268 75.8402C26.9881 74.5922 26.8494 73.3095 26.7108 71.9922C26.5721 70.6749 26.5028 69.3575 26.5028 68.0402C26.5028 65.1975 26.5374 62.3549 26.6068 59.5122C26.6761 56.6002 26.7454 53.5149 26.8148 50.2562Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M61.6588 59.5122C62.0055 59.7895 62.5948 59.5469 63.4268 58.7842C64.3282 57.9522 65.2988 56.9122 66.3388 55.6642C67.3788 54.4162 68.4535 53.1335 69.5628 51.8162C70.7415 50.4295 71.7468 49.3549 72.5788 48.5922C72.9948 48.2455 73.4108 48.0722 73.8268 48.0722C74.3122 48.0722 74.7282 48.2109 75.0748 48.4882C75.4215 48.6962 75.6295 49.0082 75.6988 49.4242C75.8375 49.8402 75.7682 50.3255 75.4908 50.8802C75.1442 51.5042 74.7282 52.1282 74.2428 52.7522C72.8562 54.2082 71.5042 55.6989 70.1868 57.2242C68.9388 58.7495 67.6215 60.2402 66.2348 61.6962C65.4722 62.4589 64.5362 63.1175 63.4268 63.6722C61.4162 64.7122 59.5788 64.8509 57.9148 64.0882C56.3202 63.3255 55.3495 61.8349 55.0028 59.6162C54.6562 57.3975 54.7255 55.0055 55.2108 52.4402C55.6962 49.8749 56.3895 47.5869 57.2908 45.5762C57.6375 44.6749 58.1575 44.0509 58.8508 43.7042C59.5442 43.3575 60.2722 43.3229 61.0348 43.6002C62.6295 44.1549 63.3228 45.3335 63.1148 47.1362C63.0455 48.2455 62.8722 49.5629 62.5948 51.0882C62.3868 52.6135 62.2135 53.9309 62.0748 55.0402C61.9362 55.5949 61.8668 56.2535 61.8668 57.0162C61.8668 57.7095 61.7975 58.5415 61.6588 59.5122ZM61.9708 35.6962C62.3175 35.6962 62.6642 35.8695 63.0108 36.2162C63.4268 36.4935 63.7735 36.8402 64.0508 37.2562C64.3975 37.6029 64.6402 37.9842 64.7788 38.4002C64.9868 38.8162 65.0562 39.1629 64.9868 39.4402C64.8482 39.7869 64.5708 40.1335 64.1548 40.4802C63.7388 40.8269 63.3575 41.0349 63.0108 41.1042C62.5948 41.1042 62.1788 41.0002 61.7628 40.7922C61.3468 40.5842 60.9655 40.3069 60.6188 39.9602C60.3415 39.5442 60.0988 39.1282 59.8908 38.7122C59.6828 38.2962 59.5788 37.9149 59.5788 37.5682C59.7175 37.0135 59.9948 36.5629 60.4108 36.2162C60.8268 35.8002 61.3468 35.6269 61.9708 35.6962Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M88.0163 44.1202C89.403 43.0802 90.8243 42.7682 92.2803 43.1842C93.7363 43.6002 94.6377 44.7095 94.9843 46.5122C95.123 47.4829 95.1923 48.6962 95.1923 50.1522C95.1923 51.6082 95.1923 53.0642 95.1923 54.5202C95.2617 55.9069 95.3657 57.1202 95.5043 58.1602C95.7123 59.2002 96.059 59.7549 96.5443 59.8242C96.891 59.8242 97.3763 59.5122 98.0003 58.8882C98.8323 58.0562 99.699 57.0509 100.6 55.8722C101.571 54.6935 102.472 53.5495 103.304 52.4402C104.136 51.2615 104.864 50.2562 105.488 49.4242C106.112 48.5229 106.528 47.9682 106.736 47.7602C107.014 47.4829 107.326 47.3789 107.672 47.4482C108.019 47.5175 108.296 47.6909 108.504 47.9682C108.782 48.2455 108.99 48.5922 109.128 49.0082C109.267 49.4242 109.302 49.7709 109.232 50.0482C109.094 50.8802 108.574 51.9895 107.672 53.3762C106.771 54.7629 105.731 56.1842 104.552 57.6402C103.374 59.0269 102.126 60.3095 100.808 61.4882C99.5603 62.5975 98.4857 63.3255 97.5843 63.6722C96.267 64.1575 94.9843 64.1575 93.7363 63.6722C92.5577 63.1869 91.691 62.0775 91.1363 60.3442C90.7897 59.2349 90.547 58.0562 90.4083 56.8082C90.339 55.4909 90.235 54.2429 90.0963 53.0642C90.027 52.4402 89.9923 51.8162 89.9923 51.1922C89.9923 50.4989 89.9577 49.7015 89.8883 48.8002C88.7097 49.8402 87.739 50.9495 86.9763 52.1282C86.2137 53.2375 85.4857 54.3815 84.7923 55.5602C84.099 56.7389 83.4057 57.9175 82.7123 59.0962C82.019 60.2749 81.187 61.3842 80.2163 62.4242C79.0377 63.3949 77.7203 63.8802 76.2643 63.8802C74.8083 63.8109 73.6643 63.1175 72.8323 61.8002C72.2777 60.9682 71.9657 59.9975 71.8963 58.8882C71.827 57.7789 71.7577 56.7042 71.6883 55.6642C71.6883 53.0989 71.8617 50.5335 72.2083 47.9682C72.4857 45.3335 73.0403 42.7682 73.8723 40.2722C74.0803 39.6482 74.2883 39.1282 74.4963 38.7122C75.3977 36.5629 76.6457 35.8349 78.2403 36.5282C78.9337 36.6669 79.4883 37.1175 79.9043 37.8802C80.3897 38.5735 80.459 39.4749 80.1123 40.5842C79.627 42.1789 79.1763 43.8082 78.7603 45.4722C78.4137 47.1362 78.171 48.6962 78.0323 50.1522C77.8937 51.6082 77.8243 52.8909 77.8243 54.0002C77.8937 55.0402 78.1017 55.8029 78.4483 56.2882C78.8643 56.6349 79.419 56.2882 80.1123 55.2482C80.875 54.2082 81.6723 52.9602 82.5043 51.5042C83.4057 50.0482 84.307 48.5922 85.2083 47.1362C86.179 45.6802 87.115 44.6749 88.0163 44.1202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M119.445 40.0642C119.653 39.5095 119.895 38.8855 120.173 38.1922C120.45 37.4295 120.727 36.6669 121.005 35.9042C122.045 32.9922 123.05 30.0455 124.021 27.0642C125.061 24.0829 126.066 21.1362 127.037 18.2242C127.175 18.0162 127.314 17.7735 127.453 17.4962C127.591 17.2189 127.73 16.9415 127.869 16.6642C128.631 15.2775 129.775 14.7575 131.301 15.1042C132.687 15.4509 133.45 16.3175 133.589 17.7042C133.727 18.3975 133.762 19.0909 133.693 19.7842C133.693 20.4775 133.623 21.2055 133.485 21.9682C132.722 26.6829 131.994 31.3629 131.301 36.0082C130.607 40.5842 129.879 45.2642 129.117 50.0482C128.77 51.8509 128.493 53.6882 128.285 55.5602C128.077 57.3629 127.834 59.2002 127.557 61.0722C127.487 61.4189 127.418 61.7309 127.349 62.0082C127.349 62.2855 127.279 62.5975 127.141 62.9442C126.586 64.8855 125.407 65.7869 123.605 65.6482C122.773 65.5789 122.079 65.3015 121.525 64.8162C120.97 64.3309 120.658 63.6029 120.589 62.6322C120.45 61.5922 120.381 60.5175 120.381 59.4082C120.45 58.2989 120.519 57.1895 120.589 56.0802C120.658 55.3175 120.693 54.5549 120.693 53.7922C120.762 53.0295 120.727 52.2322 120.589 51.4002C120.103 51.8855 119.722 52.3709 119.445 52.8562C118.474 54.1042 117.538 55.3869 116.637 56.7042C115.735 57.9522 114.799 59.1655 113.829 60.3442C113.413 60.8989 112.893 61.3842 112.269 61.8002C111.645 62.2162 111.021 62.5975 110.397 62.9442C108.871 63.7069 107.45 63.7762 106.133 63.1522C104.885 62.4589 104.018 61.2802 103.533 59.6162C103.394 59.0615 103.325 58.5415 103.325 58.0562C103.463 54.6589 104.226 51.6082 105.613 48.9042C106.999 46.1309 109.218 43.8429 112.269 42.0402C113.239 41.4855 114.314 41.1042 115.493 40.8962C116.741 40.6882 118.058 40.4109 119.445 40.0642ZM109.045 57.9522C110.015 57.2589 110.951 56.3922 111.853 55.3522C112.754 54.3122 113.551 53.2375 114.245 52.1282C115.007 50.9495 115.631 49.7709 116.117 48.5922C116.602 47.4135 116.879 46.3389 116.949 45.3682C115.839 45.5069 114.765 45.9575 113.725 46.7202C112.685 47.4829 111.783 48.4535 111.021 49.6322C110.327 50.8109 109.773 52.1282 109.357 53.5842C109.01 55.0402 108.906 56.4962 109.045 57.9522Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M137.516 53.6882C137.308 55.0749 137.378 56.0802 137.724 56.7042C138.14 57.3282 138.695 57.7095 139.388 57.8482C140.151 57.9869 140.983 57.9869 141.884 57.8482C142.855 57.6402 143.791 57.3629 144.692 57.0162C147.466 56.1149 149.788 54.9709 151.66 53.5842C153.532 52.1975 155.508 50.6029 157.588 48.8002C158.49 47.9682 159.252 47.5175 159.876 47.4482C160.5 47.3789 160.951 47.5175 161.228 47.8642C161.575 48.2109 161.714 48.7655 161.644 49.5282C161.575 50.2215 161.263 50.9149 160.708 51.6082C159.738 52.8562 158.386 54.1735 156.652 55.5602C154.988 56.9469 153.151 58.2295 151.14 59.4082C149.199 60.5869 147.188 61.5575 145.108 62.3202C143.098 63.0135 141.26 63.3255 139.596 63.2562C136.338 62.9095 133.98 61.6615 132.524 59.5122C130.999 57.3629 130.687 54.7282 131.588 51.6082C132.282 49.2509 133.426 47.1709 135.02 45.3682C135.714 44.5362 136.684 43.6349 137.932 42.6642C139.18 41.6242 140.463 40.7922 141.78 40.1682C143.167 39.4749 144.519 39.1282 145.836 39.1282C147.223 39.0589 148.402 39.5442 149.372 40.5842C150.551 41.7629 150.863 43.2189 150.308 44.9522C149.754 46.6855 148.748 48.3149 147.292 49.8402C145.906 51.2962 144.276 52.4402 142.404 53.2722C140.602 54.1042 138.972 54.2429 137.516 53.6882ZM145.732 44.0162C142.682 45.3335 140.706 47.1709 139.804 49.5282C141.052 49.1815 142.162 48.6269 143.132 47.8642C144.172 47.1015 145.039 45.8189 145.732 44.0162Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M198.765 40.0642C198.973 39.5095 199.216 38.8855 199.493 38.1922C199.77 37.4295 200.048 36.6669 200.325 35.9042C201.365 32.9922 202.37 30.0455 203.341 27.0642C204.381 24.0829 205.386 21.1362 206.357 18.2242C206.496 18.0162 206.634 17.7735 206.773 17.4962C206.912 17.2189 207.05 16.9415 207.189 16.6642C207.952 15.2775 209.096 14.7575 210.621 15.1042C212.008 15.4509 212.77 16.3175 212.909 17.7042C213.048 18.3975 213.082 19.0909 213.013 19.7842C213.013 20.4775 212.944 21.2055 212.805 21.9682C212.042 26.6829 211.314 31.3629 210.621 36.0082C209.928 40.5842 209.2 45.2642 208.437 50.0482C208.09 51.8509 207.813 53.6882 207.605 55.5602C207.397 57.3629 207.154 59.2002 206.877 61.0722C206.808 61.4189 206.738 61.7309 206.669 62.0082C206.669 62.2855 206.6 62.5975 206.461 62.9442C205.906 64.8855 204.728 65.7869 202.925 65.6482C202.093 65.5789 201.4 65.3015 200.845 64.8162C200.29 64.3309 199.978 63.6029 199.909 62.6322C199.77 61.5922 199.701 60.5175 199.701 59.4082C199.77 58.2989 199.84 57.1895 199.909 56.0802C199.978 55.3175 200.013 54.5549 200.013 53.7922C200.082 53.0295 200.048 52.2322 199.909 51.4002C199.424 51.8855 199.042 52.3709 198.765 52.8562C197.794 54.1042 196.858 55.3869 195.957 56.7042C195.056 57.9522 194.12 59.1655 193.149 60.3442C192.733 60.8989 192.213 61.3842 191.589 61.8002C190.965 62.2162 190.341 62.5975 189.717 62.9442C188.192 63.7069 186.77 63.7762 185.453 63.1522C184.205 62.4589 183.338 61.2802 182.853 59.6162C182.714 59.0615 182.645 58.5415 182.645 58.0562C182.784 54.6589 183.546 51.6082 184.933 48.9042C186.32 46.1309 188.538 43.8429 191.589 42.0402C192.56 41.4855 193.634 41.1042 194.813 40.8962C196.061 40.6882 197.378 40.4109 198.765 40.0642ZM188.365 57.9522C189.336 57.2589 190.272 56.3922 191.173 55.3522C192.074 54.3122 192.872 53.2375 193.565 52.1282C194.328 50.9495 194.952 49.7709 195.437 48.5922C195.922 47.4135 196.2 46.3389 196.269 45.3682C195.16 45.5069 194.085 45.9575 193.045 46.7202C192.005 47.4829 191.104 48.4535 190.341 49.6322C189.648 50.8109 189.093 52.1282 188.677 53.5842C188.33 55.0402 188.226 56.4962 188.365 57.9522Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M216.837 53.6882C216.629 55.0749 216.698 56.0802 217.045 56.7042C217.461 57.3282 218.015 57.7095 218.709 57.8482C219.471 57.9869 220.303 57.9869 221.205 57.8482C222.175 57.6402 223.111 57.3629 224.013 57.0162C226.786 56.1149 229.109 54.9709 230.981 53.5842C232.853 52.1975 234.829 50.6029 236.909 48.8002C237.81 47.9682 238.573 47.5175 239.197 47.4482C239.821 47.3789 240.271 47.5175 240.549 47.8642C240.895 48.2109 241.034 48.7655 240.965 49.5282C240.895 50.2215 240.583 50.9149 240.029 51.6082C239.058 52.8562 237.706 54.1735 235.973 55.5602C234.309 56.9469 232.471 58.2295 230.461 59.4082C228.519 60.5869 226.509 61.5575 224.429 62.3202C222.418 63.0135 220.581 63.3255 218.917 63.2562C215.658 62.9095 213.301 61.6615 211.845 59.5122C210.319 57.3629 210.007 54.7282 210.909 51.6082C211.602 49.2509 212.746 47.1709 214.341 45.3682C215.034 44.5362 216.005 43.6349 217.253 42.6642C218.501 41.6242 219.783 40.7922 221.101 40.1682C222.487 39.4749 223.839 39.1282 225.157 39.1282C226.543 39.0589 227.722 39.5442 228.693 40.5842C229.871 41.7629 230.183 43.2189 229.629 44.9522C229.074 46.6855 228.069 48.3149 226.613 49.8402C225.226 51.2962 223.597 52.4402 221.725 53.2722C219.922 54.1042 218.293 54.2429 216.837 53.6882ZM225.053 44.0162C222.002 45.3335 220.026 47.1709 219.125 49.5282C220.373 49.1815 221.482 48.6269 222.453 47.8642C223.493 47.1015 224.359 45.8189 225.053 44.0162Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M242.034 59.5122C242.381 59.7895 242.97 59.5469 243.802 58.7842C244.703 57.9522 245.674 56.9122 246.714 55.6642C247.754 54.4162 248.829 53.1335 249.938 51.8162C251.117 50.4295 252.122 49.3549 252.954 48.5922C253.37 48.2455 253.786 48.0722 254.202 48.0722C254.687 48.0722 255.103 48.2109 255.45 48.4882C255.797 48.6962 256.005 49.0082 256.074 49.4242C256.213 49.8402 256.143 50.3255 255.866 50.8802C255.519 51.5042 255.103 52.1282 254.618 52.7522C253.231 54.2082 251.879 55.6989 250.562 57.2242C249.314 58.7495 247.997 60.2402 246.61 61.6962C245.847 62.4589 244.911 63.1175 243.802 63.6722C241.791 64.7122 239.954 64.8509 238.29 64.0882C236.695 63.3255 235.725 61.8349 235.378 59.6162C235.031 57.3975 235.1 55.0055 235.586 52.4402C236.071 49.8749 236.764 47.5869 237.666 45.5762C238.012 44.6749 238.533 44.0509 239.226 43.7042C239.919 43.3575 240.647 43.3229 241.41 43.6002C243.005 44.1549 243.698 45.3335 243.49 47.1362C243.421 48.2455 243.247 49.5629 242.97 51.0882C242.762 52.6135 242.589 53.9309 242.45 55.0402C242.311 55.5949 242.242 56.2535 242.242 57.0162C242.242 57.7095 242.173 58.5415 242.034 59.5122ZM242.346 35.6962C242.693 35.6962 243.039 35.8695 243.386 36.2162C243.802 36.4935 244.149 36.8402 244.426 37.2562C244.773 37.6029 245.015 37.9842 245.154 38.4002C245.362 38.8162 245.431 39.1629 245.362 39.4402C245.223 39.7869 244.946 40.1335 244.53 40.4802C244.114 40.8269 243.732 41.0349 243.386 41.1042C242.97 41.1042 242.554 41.0002 242.138 40.7922C241.722 40.5842 241.34 40.3069 240.994 39.9602C240.717 39.5442 240.474 39.1282 240.266 38.7122C240.058 38.2962 239.954 37.9149 239.954 37.5682C240.093 37.0135 240.37 36.5629 240.786 36.2162C241.202 35.8002 241.722 35.6269 242.346 35.6962Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M268.391 44.1202C269.778 43.0802 271.199 42.7682 272.655 43.1842C274.111 43.6002 275.013 44.7095 275.359 46.5122C275.498 47.4829 275.567 48.6962 275.567 50.1522C275.567 51.6082 275.567 53.0642 275.567 54.5202C275.637 55.9069 275.741 57.1202 275.879 58.1602C276.087 59.2002 276.434 59.7549 276.919 59.8242C277.266 59.8242 277.751 59.5122 278.375 58.8882C279.207 58.0562 280.074 57.0509 280.975 55.8722C281.946 54.6935 282.847 53.5495 283.679 52.4402C284.511 51.2615 285.239 50.2562 285.863 49.4242C286.487 48.5229 286.903 47.9682 287.111 47.7602C287.389 47.4829 287.701 47.3789 288.047 47.4482C288.394 47.5175 288.671 47.6909 288.879 47.9682C289.157 48.2455 289.365 48.5922 289.503 49.0082C289.642 49.4242 289.677 49.7709 289.607 50.0482C289.469 50.8802 288.949 51.9895 288.047 53.3762C287.146 54.7629 286.106 56.1842 284.927 57.6402C283.749 59.0269 282.501 60.3095 281.183 61.4882C279.935 62.5975 278.861 63.3255 277.959 63.6722C276.642 64.1575 275.359 64.1575 274.111 63.6722C272.933 63.1869 272.066 62.0775 271.511 60.3442C271.165 59.2349 270.922 58.0562 270.783 56.8082C270.714 55.4909 270.61 54.2429 270.471 53.0642C270.402 52.4402 270.367 51.8162 270.367 51.1922C270.367 50.4989 270.333 49.7015 270.263 48.8002C269.085 49.8402 268.114 50.9495 267.351 52.1282C266.589 53.2375 265.861 54.3815 265.167 55.5602C264.474 56.7389 263.781 57.9175 263.087 59.0962C262.394 60.2749 261.562 61.3842 260.591 62.4242C259.413 63.3949 258.095 63.8802 256.639 63.8802C255.183 63.8109 254.039 63.1175 253.207 61.8002C252.653 60.9682 252.341 59.9975 252.271 58.8882C252.202 57.7789 252.133 56.7042 252.063 55.6642C252.063 53.0989 252.237 50.5335 252.583 47.9682C252.861 45.3335 253.415 42.7682 254.247 40.2722C254.455 39.6482 254.663 39.1282 254.871 38.7122C255.773 36.5629 257.021 35.8349 258.615 36.5282C259.309 36.6669 259.863 37.1175 260.279 37.8802C260.765 38.5735 260.834 39.4749 260.487 40.5842C260.002 42.1789 259.551 43.8082 259.135 45.4722C258.789 47.1362 258.546 48.6962 258.407 50.1522C258.269 51.6082 258.199 52.8909 258.199 54.0002C258.269 55.0402 258.477 55.8029 258.823 56.2882C259.239 56.6349 259.794 56.2882 260.487 55.2482C261.25 54.2082 262.047 52.9602 262.879 51.5042C263.781 50.0482 264.682 48.5922 265.583 47.1362C266.554 45.6802 267.49 44.6749 268.391 44.1202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M290.876 53.6882C290.668 55.0749 290.737 56.0802 291.084 56.7042C291.5 57.3282 292.054 57.7095 292.748 57.8482C293.51 57.9869 294.342 57.9869 295.244 57.8482C296.214 57.6402 297.15 57.3629 298.052 57.0162C300.825 56.1149 303.148 54.9709 305.02 53.5842C306.892 52.1975 308.868 50.6029 310.948 48.8002C311.849 47.9682 312.612 47.5175 313.236 47.4482C313.86 47.3789 314.31 47.5175 314.588 47.8642C314.934 48.2109 315.073 48.7655 315.004 49.5282C314.934 50.2215 314.622 50.9149 314.068 51.6082C313.097 52.8562 311.745 54.1735 310.012 55.5602C308.348 56.9469 306.51 58.2295 304.5 59.4082C302.558 60.5869 300.548 61.5575 298.468 62.3202C296.457 63.0135 294.62 63.3255 292.956 63.2562C289.697 62.9095 287.34 61.6615 285.884 59.5122C284.358 57.3629 284.046 54.7282 284.948 51.6082C285.641 49.2509 286.785 47.1709 288.38 45.3682C289.073 44.5362 290.044 43.6349 291.292 42.6642C292.54 41.6242 293.822 40.7922 295.14 40.1682C296.526 39.4749 297.878 39.1282 299.196 39.1282C300.582 39.0589 301.761 39.5442 302.732 40.5842C303.91 41.7629 304.222 43.2189 303.668 44.9522C303.113 46.6855 302.108 48.3149 300.652 49.8402C299.265 51.2962 297.636 52.4402 295.764 53.2722C293.961 54.1042 292.332 54.2429 290.876 53.6882ZM299.092 44.0162C296.041 45.3335 294.065 47.1709 293.164 49.5282C294.412 49.1815 295.521 48.6269 296.492 47.8642C297.532 47.1015 298.398 45.8189 299.092 44.0162Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M326.993 44.1202C328.38 43.0802 329.801 42.7682 331.257 43.1842C332.713 43.6002 333.614 44.7095 333.961 46.5122C334.1 47.4829 334.169 48.6962 334.169 50.1522C334.169 51.6082 334.169 53.0642 334.169 54.5202C334.238 55.9069 334.342 57.1202 334.481 58.1602C334.689 59.2002 335.036 59.7549 335.521 59.8242C335.868 59.8242 336.353 59.5122 336.977 58.8882C337.809 58.0562 338.676 57.0509 339.577 55.8722C340.548 54.6935 341.449 53.5495 342.281 52.4402C343.113 51.2615 343.841 50.2562 344.465 49.4242C345.089 48.5229 345.505 47.9682 345.713 47.7602C345.99 47.4829 346.302 47.3789 346.649 47.4482C346.996 47.5175 347.273 47.6909 347.481 47.9682C347.758 48.2455 347.966 48.5922 348.105 49.0082C348.244 49.4242 348.278 49.7709 348.209 50.0482C348.07 50.8802 347.55 51.9895 346.649 53.3762C345.748 54.7629 344.708 56.1842 343.529 57.6402C342.35 59.0269 341.102 60.3095 339.785 61.4882C338.537 62.5975 337.462 63.3255 336.561 63.6722C335.244 64.1575 333.961 64.1575 332.713 63.6722C331.534 63.1869 330.668 62.0775 330.113 60.3442C329.766 59.2349 329.524 58.0562 329.385 56.8082C329.316 55.4909 329.212 54.2429 329.073 53.0642C329.004 52.4402 328.969 51.8162 328.969 51.1922C328.969 50.4989 328.934 49.7015 328.865 48.8002C327.686 49.8402 326.716 50.9495 325.953 52.1282C325.19 53.2375 324.462 54.3815 323.769 55.5602C323.076 56.7389 322.382 57.9175 321.689 59.0962C320.996 60.2749 320.164 61.3842 319.193 62.4242C318.014 63.3949 316.697 63.8802 315.241 63.8802C313.785 63.8109 312.641 63.1175 311.809 61.8002C311.254 60.9682 310.942 59.9975 310.873 58.8882C310.804 57.7789 310.734 56.7042 310.665 55.6642C310.665 53.0989 310.838 50.5335 311.185 47.9682C311.462 45.3335 312.017 42.7682 312.849 40.2722C313.057 39.6482 313.265 39.1282 313.473 38.7122C314.374 36.5629 315.622 35.8349 317.217 36.5282C317.91 36.6669 318.465 37.1175 318.881 37.8802C319.366 38.5735 319.436 39.4749 319.089 40.5842C318.604 42.1789 318.153 43.8082 317.737 45.4722C317.39 47.1362 317.148 48.6962 317.009 50.1522C316.87 51.6082 316.801 52.8909 316.801 54.0002C316.87 55.0402 317.078 55.8029 317.425 56.2882C317.841 56.6349 318.396 56.2882 319.089 55.2482C319.852 54.2082 320.649 52.9602 321.481 51.5042C322.382 50.0482 323.284 48.5922 324.185 47.1362C325.156 45.6802 326.092 44.6749 326.993 44.1202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M394.785 17.6002C392.913 18.2242 391.041 18.8135 389.169 19.3682C387.366 19.9229 385.563 20.5122 383.761 21.1362C382.721 21.4829 381.681 21.8295 380.641 22.1762C379.67 22.5229 378.699 22.8695 377.729 23.2162C376.897 23.4935 375.995 23.6322 375.025 23.6322C374.401 23.5629 373.846 23.3549 373.361 23.0082C372.945 22.6615 372.737 22.1415 372.737 21.4482C372.737 21.0322 372.875 20.6162 373.153 20.2002C373.43 19.7149 373.742 19.2989 374.089 18.9522C374.435 18.6055 374.817 18.3282 375.233 18.1202C375.649 17.9122 376.099 17.7389 376.585 17.6002C381.022 16.2135 385.425 14.7922 389.793 13.3362C394.161 11.8109 398.563 10.4589 403.001 9.2802C408.894 7.68553 414.787 6.22953 420.681 4.91219C426.574 3.59486 432.467 2.27752 438.361 0.960192C438.707 0.89086 439.019 0.821527 439.297 0.752195C439.574 0.682862 439.886 0.682862 440.233 0.752195C440.857 0.821527 441.377 1.06419 441.793 1.48019C442.278 1.82686 442.521 2.38153 442.521 3.14419C442.451 3.62953 442.278 4.18419 442.001 4.80819C441.793 5.36286 441.515 5.70953 441.169 5.84819C440.406 6.33353 439.643 6.68019 438.881 6.8882C438.187 7.09619 437.459 7.30419 436.697 7.51219C433.438 8.27486 430.214 9.00286 427.025 9.69619C423.835 10.3895 420.646 11.1175 417.457 11.8802C414.891 12.4349 412.361 13.0589 409.865 13.7522C407.438 14.3762 404.907 14.9655 402.273 15.5202C402.619 17.1149 402.585 18.5362 402.169 19.7842C401.822 21.0322 401.475 22.3149 401.129 23.6322C398.91 30.7735 396.865 37.9149 394.993 45.0562C393.121 52.1282 391.699 59.4082 390.729 66.8962C390.59 68.0749 390.486 69.2535 390.417 70.4322C390.417 71.6109 390.833 72.7895 391.665 73.9682C392.289 74.8695 392.323 76.0482 391.769 77.5042C391.283 78.8909 390.521 79.9309 389.481 80.6242C388.51 81.3175 387.435 81.5255 386.257 81.2482C385.147 81.0402 384.315 80.3469 383.761 79.1682C383.067 77.7122 382.651 76.1522 382.513 74.4882C382.235 71.7149 382.235 68.9762 382.513 66.2722C382.859 63.5682 383.275 60.8642 383.761 58.1602C384.662 52.6829 385.737 47.2749 386.985 41.9362C388.233 36.5282 389.862 31.2242 391.873 26.0242C392.427 24.7069 392.947 23.4242 393.433 22.1762C393.987 20.9282 394.507 19.6455 394.993 18.3282C394.854 18.0509 394.785 17.8082 394.785 17.6002Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M411.818 45.3682C412.511 44.6749 413.066 44.1202 413.482 43.7042C413.898 43.2882 414.314 42.9069 414.73 42.5602C415.562 41.8669 416.359 41.1735 417.122 40.4802C417.954 39.7869 418.821 39.1975 419.722 38.7122C422.079 37.5335 424.09 37.7762 425.754 39.4402C427.071 40.9655 427.314 42.9762 426.482 45.4722C426.135 46.6509 425.303 47.2055 423.986 47.1362C423.015 46.9975 422.599 46.3735 422.738 45.2642C422.877 44.5709 422.911 44.0162 422.842 43.6002C422.634 42.2135 421.802 41.9362 420.346 42.7682C419.93 43.0455 419.479 43.3922 418.994 43.8082C418.509 44.1549 418.093 44.5362 417.746 44.9522C415.597 47.1709 413.759 49.6322 412.234 52.3362C410.709 54.9709 409.946 57.7442 409.946 60.6562C409.946 61.6962 409.634 62.6322 409.01 63.4642C408.455 64.2962 407.693 64.8162 406.722 65.0242C405.821 65.2322 405.023 65.0935 404.33 64.6082C403.706 64.1229 403.325 63.3602 403.186 62.3202C403.047 61.4189 403.013 59.9629 403.082 57.9522C403.082 55.8722 403.221 53.6882 403.498 51.4002C403.706 49.0429 404.087 46.7202 404.642 44.4322C405.197 42.0749 405.89 40.0989 406.722 38.5042C407.138 37.7415 407.693 37.1869 408.386 36.8402C409.079 36.4935 409.773 36.3549 410.466 36.4242C412.061 36.6322 412.754 37.6375 412.546 39.4402C412.477 40.3415 412.373 41.2775 412.234 42.2482C412.095 43.1495 411.957 44.1895 411.818 45.3682Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M440.425 53.8962C439.732 54.7975 439.073 55.6295 438.449 56.3922C437.825 57.0855 437.201 57.7789 436.577 58.4722C435.953 59.0269 435.295 59.6162 434.601 60.2402C433.977 60.8642 433.319 61.3495 432.625 61.6962C431.377 62.4589 430.233 62.6322 429.193 62.2162C428.084 61.7309 427.321 60.7949 426.905 59.4082C426.559 58.4375 426.455 57.5015 426.593 56.6002C427.148 53.4802 428.119 50.6375 429.505 48.0722C430.892 45.5069 432.903 43.3229 435.537 41.5202C437.271 40.3415 439.004 39.6829 440.737 39.5442C442.471 39.4055 444.239 39.8909 446.041 41.0002C447.081 41.6242 447.775 42.2482 448.121 42.8722C448.468 43.4269 448.537 44.3282 448.329 45.5762C448.191 46.6855 447.983 47.7949 447.705 48.9042C447.497 49.9442 447.324 51.0535 447.185 52.2322C447.047 53.2722 446.908 54.3469 446.769 55.4562C446.631 56.4962 446.631 57.3282 446.769 57.9522C446.977 58.5762 447.324 58.8882 447.809 58.8882C448.364 58.8882 449.231 58.2989 450.409 57.1202C451.38 56.0109 452.108 55.1442 452.593 54.5202C453.148 53.8962 453.633 53.3415 454.049 52.8562C454.535 52.3015 455.02 51.7122 455.505 51.0882C456.06 50.4642 456.823 49.6322 457.793 48.5922C458.071 48.3149 458.348 48.0375 458.625 47.7602C458.972 47.4829 459.319 47.2749 459.665 47.1362C460.012 46.9975 460.393 47.0322 460.809 47.2402C461.295 47.3789 461.641 47.5869 461.849 47.8642C462.057 48.0029 462.127 48.2802 462.057 48.6962C462.057 49.0429 462.023 49.3895 461.953 49.7362C461.884 50.0135 461.641 50.3602 461.225 50.7762C460.393 51.8162 459.735 52.6482 459.249 53.2722C458.764 53.8269 458.313 54.3469 457.897 54.8322C457.481 55.3175 456.996 55.8722 456.441 56.4962C455.956 57.0509 455.263 57.8482 454.361 58.8882C453.737 59.6509 453.079 60.3442 452.385 60.9682C451.761 61.5922 451.068 62.1815 450.305 62.7362C448.503 63.9149 446.943 64.4695 445.625 64.4002C444.377 64.3309 443.337 63.8109 442.505 62.8402C441.743 61.8695 441.188 60.5869 440.841 58.9922C440.495 57.3975 440.356 55.6989 440.425 53.8962ZM431.585 57.0162C432.279 56.5309 433.18 55.6989 434.289 54.5202C435.399 53.3415 436.473 52.1282 437.513 50.8802C438.623 49.5629 439.593 48.3149 440.425 47.1362C441.327 45.8882 441.881 44.9522 442.089 44.3282C440.911 44.1895 439.732 44.4322 438.553 45.0562C437.375 45.6109 436.3 46.4775 435.329 47.6562C434.428 48.7655 433.631 50.1522 432.937 51.8162C432.244 53.4109 431.793 55.1442 431.585 57.0162Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M473.751 51.9202C473.057 52.8215 472.468 53.5842 471.983 54.2082C471.567 54.8322 471.116 55.3869 470.631 55.8722C469.66 57.0509 468.585 58.1602 467.407 59.2002C466.297 60.1709 465.015 60.9335 463.559 61.4882C461.756 62.3202 460.161 62.3202 458.775 61.4882C457.596 60.7949 456.868 59.6509 456.591 58.0562C456.313 56.4615 456.313 54.8322 456.591 53.1682C456.868 51.4349 457.319 49.8055 457.943 48.2802C458.567 46.6855 459.156 45.5762 459.711 44.9522C460.335 44.1895 461.063 43.8082 461.895 43.8082C462.796 43.7389 463.593 43.9122 464.287 44.3282C464.98 44.6749 465.431 45.1949 465.639 45.8882C465.916 46.5815 465.743 47.3095 465.119 48.0722C464.772 48.4882 464.46 49.0775 464.183 49.8402C463.905 50.5335 463.628 51.3309 463.351 52.2322C463.073 53.0642 462.831 53.8962 462.623 54.7282C462.484 55.5602 462.415 56.2535 462.415 56.8082C462.692 57.2242 463.281 57.0509 464.183 56.2882C465.153 55.5255 466.193 54.5202 467.303 53.2722C468.481 52.0242 469.625 50.7069 470.735 49.3202C471.844 47.8642 472.745 46.7202 473.439 45.8882C473.716 45.5415 473.959 45.1949 474.167 44.8482C474.444 44.4322 474.756 44.0509 475.103 43.7042C475.519 43.2882 476.073 43.0455 476.767 42.9762C477.46 42.8375 478.119 42.8375 478.743 42.9762C479.436 43.0455 480.025 43.2535 480.511 43.6002C480.996 43.9469 481.273 44.3975 481.343 44.9522C481.343 45.2989 481.273 45.9575 481.135 46.9282C480.996 47.8989 480.823 48.9735 480.615 50.1522C480.476 51.3309 480.337 52.5095 480.199 53.6882C480.129 54.7975 480.129 55.7335 480.199 56.4962C480.337 57.2589 480.615 57.7095 481.031 57.8482C481.447 57.9869 482.071 57.6402 482.903 56.8082C484.081 55.6295 485.191 54.4162 486.231 53.1682C487.34 51.9202 488.449 50.6375 489.559 49.3202C490.321 48.4189 491.049 47.8642 491.743 47.6562C492.505 47.4482 493.06 47.5175 493.407 47.8642C493.823 48.1415 493.996 48.6269 493.927 49.3202C493.857 50.0135 493.441 50.7762 492.679 51.6082C491.569 52.9949 490.425 54.4162 489.247 55.8722C488.137 57.3282 486.993 58.6455 485.815 59.8242C484.705 60.9335 483.561 61.8349 482.383 62.5282C481.273 63.2215 480.164 63.5335 479.055 63.4642C475.311 63.1175 473.543 59.2695 473.751 51.9202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M516.019 53.2722C517.059 51.4002 518.238 49.6669 519.555 48.0722C520.873 46.4775 522.329 45.0909 523.923 43.9122C525.726 42.5949 527.286 42.2829 528.603 42.9762C529.99 43.6002 530.787 45.0562 530.995 47.3442C531.203 49.2162 531.342 51.0535 531.411 52.8562C531.481 54.5895 531.723 56.3575 532.139 58.1602C534.427 56.9815 536.473 55.4215 538.275 53.4802C540.147 51.4695 541.777 49.7709 543.163 48.3842C543.649 47.8989 544.099 47.6909 544.515 47.7602C545.001 47.7602 545.382 47.9335 545.659 48.2802C545.937 48.5575 546.075 48.9735 546.075 49.5282C546.145 50.0135 546.006 50.5335 545.659 51.0882C544.897 51.9202 544.065 52.8562 543.163 53.8962C542.262 54.9362 541.326 55.9415 540.355 56.9122C539.385 57.8829 538.379 58.7842 537.339 59.6162C536.299 60.4482 535.259 61.1069 534.219 61.5922C532.417 62.3549 530.961 62.4242 529.851 61.8002C528.811 61.1069 528.014 59.7895 527.459 57.8482C527.182 57.0855 527.009 56.2882 526.939 55.4562C526.939 54.6242 526.905 53.7922 526.835 52.9602C526.766 52.1282 526.731 51.2615 526.731 50.3602C526.801 49.4589 526.835 48.4535 526.835 47.3442C525.726 47.7602 524.755 48.3495 523.923 49.1122C523.091 49.8749 522.363 50.7069 521.739 51.6082C521.115 52.5095 520.526 53.4455 519.971 54.4162C519.417 55.3869 518.827 56.2882 518.203 57.1202C517.787 57.8135 517.302 58.4375 516.747 58.9922C516.193 59.4775 515.43 59.6509 514.459 59.5122C513.489 59.3735 512.83 58.9922 512.483 58.3682C512.206 57.6749 511.929 56.9469 511.651 56.1842C511.443 55.2135 511.201 54.3122 510.923 53.4802C510.715 52.5789 510.542 51.6775 510.403 50.7762C509.433 52.0242 508.601 53.2029 507.907 54.3122C507.283 55.3522 506.659 56.3922 506.035 57.4322C505.55 58.1949 505.099 58.9229 504.683 59.6162C504.267 60.3095 503.886 61.0375 503.539 61.8002C502.985 63.1869 502.187 64.1922 501.147 64.8162C500.107 65.3709 498.929 65.5789 497.611 65.4402C496.225 65.3709 495.15 64.8855 494.387 63.9842C493.694 63.0829 493.139 62.0429 492.723 60.8642C492.238 59.3389 491.926 57.5362 491.787 55.4562C491.718 53.3762 491.787 51.2962 491.995 49.2162C492.273 47.0669 492.689 45.0562 493.243 43.1842C493.798 41.2429 494.491 39.6829 495.323 38.5042C495.809 37.9495 496.363 37.6375 496.987 37.5682C497.611 37.4989 498.201 37.5682 498.755 37.7762C500.003 38.2615 500.593 39.1282 500.523 40.3762C500.385 42.0402 500.142 43.7389 499.795 45.4722C499.518 47.1362 499.275 48.8349 499.067 50.5682C498.929 52.2322 498.894 53.8615 498.963 55.4562C499.033 57.0509 499.345 58.5415 499.899 59.9282C501.355 57.5015 502.846 55.1095 504.371 52.7522C505.897 50.3255 507.595 48.1762 509.467 46.3042C510.646 45.1949 511.721 44.8135 512.691 45.1602C513.662 45.5069 514.321 46.4429 514.667 47.9682C514.806 48.7309 514.979 49.6322 515.187 50.6722C515.395 51.6429 515.673 52.5095 516.019 53.2722Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M558.962 51.9202C558.268 52.8215 557.679 53.5842 557.194 54.2082C556.778 54.8322 556.327 55.3869 555.842 55.8722C554.871 57.0509 553.796 58.1602 552.618 59.2002C551.508 60.1709 550.226 60.9335 548.77 61.4882C546.967 62.3202 545.372 62.3202 543.986 61.4882C542.807 60.7949 542.079 59.6509 541.802 58.0562C541.524 56.4615 541.524 54.8322 541.802 53.1682C542.079 51.4349 542.53 49.8055 543.154 48.2802C543.778 46.6855 544.367 45.5762 544.922 44.9522C545.546 44.1895 546.274 43.8082 547.106 43.8082C548.007 43.7389 548.804 43.9122 549.498 44.3282C550.191 44.6749 550.642 45.1949 550.85 45.8882C551.127 46.5815 550.954 47.3095 550.33 48.0722C549.983 48.4882 549.671 49.0775 549.394 49.8402C549.116 50.5335 548.839 51.3309 548.562 52.2322C548.284 53.0642 548.042 53.8962 547.834 54.7282C547.695 55.5602 547.626 56.2535 547.626 56.8082C547.903 57.2242 548.492 57.0509 549.394 56.2882C550.364 55.5255 551.404 54.5202 552.514 53.2722C553.692 52.0242 554.836 50.7069 555.946 49.3202C557.055 47.8642 557.956 46.7202 558.65 45.8882C558.927 45.5415 559.17 45.1949 559.378 44.8482C559.655 44.4322 559.967 44.0509 560.314 43.7042C560.73 43.2882 561.284 43.0455 561.978 42.9762C562.671 42.8375 563.33 42.8375 563.954 42.9762C564.647 43.0455 565.236 43.2535 565.722 43.6002C566.207 43.9469 566.484 44.3975 566.554 44.9522C566.554 45.2989 566.484 45.9575 566.346 46.9282C566.207 47.8989 566.034 48.9735 565.826 50.1522C565.687 51.3309 565.548 52.5095 565.41 53.6882C565.34 54.7975 565.34 55.7335 565.41 56.4962C565.548 57.2589 565.826 57.7095 566.242 57.8482C566.658 57.9869 567.282 57.6402 568.114 56.8082C569.292 55.6295 570.402 54.4162 571.442 53.1682C572.551 51.9202 573.66 50.6375 574.77 49.3202C575.532 48.4189 576.26 47.8642 576.954 47.6562C577.716 47.4482 578.271 47.5175 578.618 47.8642C579.034 48.1415 579.207 48.6269 579.138 49.3202C579.068 50.0135 578.652 50.7762 577.89 51.6082C576.78 52.9949 575.636 54.4162 574.458 55.8722C573.348 57.3282 572.204 58.6455 571.026 59.8242C569.916 60.9335 568.772 61.8349 567.594 62.5282C566.484 63.2215 565.375 63.5335 564.266 63.4642C560.522 63.1175 558.754 59.2695 558.962 51.9202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M583.966 45.3682C584.66 44.6749 585.214 44.1202 585.63 43.7042C586.046 43.2882 586.462 42.9069 586.878 42.5602C587.71 41.8669 588.508 41.1735 589.27 40.4802C590.102 39.7869 590.969 39.1975 591.87 38.7122C594.228 37.5335 596.238 37.7762 597.902 39.4402C599.22 40.9655 599.462 42.9762 598.63 45.4722C598.284 46.6509 597.452 47.2055 596.134 47.1362C595.164 46.9975 594.748 46.3735 594.886 45.2642C595.025 44.5709 595.06 44.0162 594.99 43.6002C594.782 42.2135 593.95 41.9362 592.494 42.7682C592.078 43.0455 591.628 43.3922 591.142 43.8082C590.657 44.1549 590.241 44.5362 589.894 44.9522C587.745 47.1709 585.908 49.6322 584.382 52.3362C582.857 54.9709 582.094 57.7442 582.094 60.6562C582.094 61.6962 581.782 62.6322 581.158 63.4642C580.604 64.2962 579.841 64.8162 578.87 65.0242C577.969 65.2322 577.172 65.0935 576.478 64.6082C575.854 64.1229 575.473 63.3602 575.334 62.3202C575.196 61.4189 575.161 59.9629 575.23 57.9522C575.23 55.8722 575.369 53.6882 575.646 51.4002C575.854 49.0429 576.236 46.7202 576.79 44.4322C577.345 42.0749 578.038 40.0989 578.87 38.5042C579.286 37.7415 579.841 37.1869 580.534 36.8402C581.228 36.4935 581.921 36.3549 582.614 36.4242C584.209 36.6322 584.902 37.6375 584.694 39.4402C584.625 40.3415 584.521 41.2775 584.382 42.2482C584.244 43.1495 584.105 44.1895 583.966 45.3682Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M616.006 47.8642C616.699 47.1015 617.392 46.9975 618.086 47.5522C618.779 48.0375 618.848 48.9389 618.294 50.2562C618.086 50.8109 617.566 51.6775 616.734 52.8562C615.971 54.0349 615.104 55.3175 614.134 56.7042C613.232 58.0215 612.366 59.2695 611.534 60.4482C610.702 61.6269 610.078 62.4589 609.662 62.9442C609.038 63.6375 608.344 64.1922 607.582 64.6082C606.888 65.0242 606.056 65.1282 605.086 64.9202C603.56 64.6429 602.486 63.7415 601.862 62.2162C601.307 60.6909 600.995 58.9922 600.926 57.1202C600.787 55.2482 600.822 53.4109 601.03 51.6082C601.238 49.8055 601.376 48.4189 601.446 47.4482C601.654 45.1602 601.966 42.4562 602.382 39.3362C602.798 36.1469 603.318 32.9922 603.942 29.8722C604.566 26.6829 605.224 23.6669 605.918 20.8242C606.611 17.9815 607.339 15.7282 608.102 14.0642C608.448 13.1629 608.934 12.5735 609.558 12.2962C610.251 11.9495 610.979 11.8455 611.742 11.9842C613.267 12.4002 613.926 13.5442 613.718 15.4162C612.608 21.3789 611.568 27.2375 610.598 32.9922C609.696 38.6775 609.003 44.3629 608.518 50.0482C608.448 51.0882 608.414 52.0935 608.414 53.0642C608.414 54.0349 608.483 54.7975 608.622 55.3522C608.83 55.9069 609.107 56.1495 609.454 56.0802C609.87 56.0109 610.424 55.4562 611.118 54.4162C611.742 53.4455 612.4 52.5442 613.094 51.7122C613.787 50.8109 614.238 50.1869 614.446 49.8402C614.654 49.4935 614.862 49.1815 615.07 48.9042C615.347 48.5575 615.659 48.2109 616.006 47.8642Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M626.589 53.8962C625.896 54.7975 625.237 55.6295 624.613 56.3922C623.989 57.0855 623.365 57.7789 622.741 58.4722C622.117 59.0269 621.459 59.6162 620.765 60.2402C620.141 60.8642 619.483 61.3495 618.789 61.6962C617.541 62.4589 616.397 62.6322 615.357 62.2162C614.248 61.7309 613.485 60.7949 613.069 59.4082C612.723 58.4375 612.619 57.5015 612.757 56.6002C613.312 53.4802 614.283 50.6375 615.669 48.0722C617.056 45.5069 619.067 43.3229 621.701 41.5202C623.435 40.3415 625.168 39.6829 626.901 39.5442C628.635 39.4055 630.403 39.8909 632.205 41.0002C633.245 41.6242 633.939 42.2482 634.285 42.8722C634.632 43.4269 634.701 44.3282 634.493 45.5762C634.355 46.6855 634.147 47.7949 633.869 48.9042C633.661 49.9442 633.488 51.0535 633.349 52.2322C633.211 53.2722 633.072 54.3469 632.933 55.4562C632.795 56.4962 632.795 57.3282 632.933 57.9522C633.141 58.5762 633.488 58.8882 633.973 58.8882C634.528 58.8882 635.395 58.2989 636.573 57.1202C637.544 56.0109 638.272 55.1442 638.757 54.5202C639.312 53.8962 639.797 53.3415 640.213 52.8562C640.699 52.3015 641.184 51.7122 641.669 51.0882C642.224 50.4642 642.987 49.6322 643.957 48.5922C644.235 48.3149 644.512 48.0375 644.789 47.7602C645.136 47.4829 645.483 47.2749 645.829 47.1362C646.176 46.9975 646.557 47.0322 646.973 47.2402C647.459 47.3789 647.805 47.5869 648.013 47.8642C648.221 48.0029 648.291 48.2802 648.221 48.6962C648.221 49.0429 648.187 49.3895 648.117 49.7362C648.048 50.0135 647.805 50.3602 647.389 50.7762C646.557 51.8162 645.899 52.6482 645.413 53.2722C644.928 53.8269 644.477 54.3469 644.061 54.8322C643.645 55.3175 643.16 55.8722 642.605 56.4962C642.12 57.0509 641.427 57.8482 640.525 58.8882C639.901 59.6509 639.243 60.3442 638.549 60.9682C637.925 61.5922 637.232 62.1815 636.469 62.7362C634.667 63.9149 633.107 64.4695 631.789 64.4002C630.541 64.3309 629.501 63.8109 628.669 62.8402C627.907 61.8695 627.352 60.5869 627.005 58.9922C626.659 57.3975 626.52 55.6989 626.589 53.8962ZM617.749 57.0162C618.443 56.5309 619.344 55.6989 620.453 54.5202C621.563 53.3415 622.637 52.1282 623.677 50.8802C624.787 49.5629 625.757 48.3149 626.589 47.1362C627.491 45.8882 628.045 44.9522 628.253 44.3282C627.075 44.1895 625.896 44.4322 624.717 45.0562C623.539 45.6109 622.464 46.4775 621.493 47.6562C620.592 48.7655 619.795 50.1522 619.101 51.8162C618.408 53.4109 617.957 55.1442 617.749 57.0162Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M659.915 51.9202C659.221 52.8215 658.632 53.5842 658.147 54.2082C657.731 54.8322 657.28 55.3869 656.795 55.8722C655.824 57.0509 654.749 58.1602 653.571 59.2002C652.461 60.1709 651.179 60.9335 649.723 61.4882C647.92 62.3202 646.325 62.3202 644.939 61.4882C643.76 60.7949 643.032 59.6509 642.755 58.0562C642.477 56.4615 642.477 54.8322 642.755 53.1682C643.032 51.4349 643.483 49.8055 644.107 48.2802C644.731 46.6855 645.32 45.5762 645.875 44.9522C646.499 44.1895 647.227 43.8082 648.059 43.8082C648.96 43.7389 649.757 43.9122 650.451 44.3282C651.144 44.6749 651.595 45.1949 651.803 45.8882C652.08 46.5815 651.907 47.3095 651.283 48.0722C650.936 48.4882 650.624 49.0775 650.347 49.8402C650.069 50.5335 649.792 51.3309 649.515 52.2322C649.237 53.0642 648.995 53.8962 648.787 54.7282C648.648 55.5602 648.579 56.2535 648.579 56.8082C648.856 57.2242 649.445 57.0509 650.347 56.2882C651.317 55.5255 652.357 54.5202 653.467 53.2722C654.645 52.0242 655.789 50.7069 656.899 49.3202C658.008 47.8642 658.909 46.7202 659.603 45.8882C659.88 45.5415 660.123 45.1949 660.331 44.8482C660.608 44.4322 660.92 44.0509 661.267 43.7042C661.683 43.2882 662.237 43.0455 662.931 42.9762C663.624 42.8375 664.283 42.8375 664.907 42.9762C665.6 43.0455 666.189 43.2535 666.675 43.6002C667.16 43.9469 667.437 44.3975 667.507 44.9522C667.507 45.2989 667.437 45.9575 667.299 46.9282C667.16 47.8989 666.987 48.9735 666.779 50.1522C666.64 51.3309 666.501 52.5095 666.363 53.6882C666.293 54.7975 666.293 55.7335 666.363 56.4962C666.501 57.2589 666.779 57.7095 667.195 57.8482C667.611 57.9869 668.235 57.6402 669.067 56.8082C670.245 55.6295 671.355 54.4162 672.395 53.1682C673.504 51.9202 674.613 50.6375 675.723 49.3202C676.485 48.4189 677.213 47.8642 677.907 47.6562C678.669 47.4482 679.224 47.5175 679.571 47.8642C679.987 48.1415 680.16 48.6269 680.091 49.3202C680.021 50.0135 679.605 50.7762 678.843 51.6082C677.733 52.9949 676.589 54.4162 675.411 55.8722C674.301 57.3282 673.157 58.6455 671.979 59.8242C670.869 60.9335 669.725 61.8349 668.547 62.5282C667.437 63.2215 666.328 63.5335 665.219 63.4642C661.475 63.1175 659.707 59.2695 659.915 51.9202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M685.231 52.4402C686.341 51.1922 687.415 50.0135 688.455 48.9042C689.565 47.7255 690.709 46.6855 691.887 45.7842C693.066 44.8829 694.314 44.1202 695.631 43.4962C696.949 42.8722 698.405 42.4909 699.999 42.3522C701.178 42.2135 702.218 42.2482 703.119 42.4562C704.367 42.6642 705.303 43.0455 705.927 43.6002C706.621 44.0855 707.106 44.7095 707.383 45.4722C707.73 46.1655 707.903 46.9629 707.903 47.8642C707.903 48.7655 707.834 49.6669 707.695 50.5682C708.735 50.2215 709.567 49.9442 710.191 49.7362C710.815 49.4589 711.37 49.2509 711.855 49.1122C712.341 48.9042 712.826 48.7655 713.311 48.6962C713.797 48.5575 714.386 48.4189 715.079 48.2802C715.911 48.2109 716.501 48.3495 716.847 48.6962C717.263 49.0429 717.471 49.4589 717.471 49.9442C717.541 50.4295 717.402 50.9149 717.055 51.4002C716.778 51.8855 716.293 52.1975 715.599 52.3362C712.965 52.8909 709.949 53.7575 706.551 54.9362C703.223 56.1149 699.826 57.7442 696.359 59.8242C695.527 60.3095 694.695 60.7602 693.863 61.1762C693.031 61.5229 692.165 61.8695 691.263 62.2162C689.045 63.1175 687.658 62.9789 687.103 61.8002C686.341 60.5522 687.138 59.3042 689.495 58.0562C690.674 57.3629 691.922 56.7389 693.239 56.1842C694.557 55.5602 695.805 54.9015 696.983 54.2082C698.162 53.5149 699.202 52.7175 700.103 51.8162C701.005 50.9149 701.629 50.0482 701.975 49.2162C702.391 48.3842 702.495 47.6909 702.287 47.1362C702.149 46.5815 701.594 46.3042 700.623 46.3042C698.682 46.3042 696.81 46.8935 695.007 48.0722C693.274 49.2509 691.714 50.7069 690.327 52.4402C688.941 54.1735 687.797 56.0455 686.895 58.0562C685.994 60.0669 685.405 61.8695 685.127 63.4642C684.989 64.0882 684.711 64.6429 684.295 65.1282C683.879 65.5442 683.359 65.8562 682.735 66.0642C682.181 66.2722 681.591 66.3415 680.967 66.2722C680.343 66.1335 679.789 65.8215 679.303 65.3362C678.749 64.7815 678.229 64.1922 677.743 63.5682C677.327 62.8749 677.085 62.1815 677.015 61.4882C676.807 59.9629 676.669 58.4722 676.599 57.0162C676.461 55.4909 676.461 53.9655 676.599 52.4402C676.946 47.1709 677.501 41.9362 678.263 36.7362C679.026 31.5362 680.101 26.3362 681.487 21.1362C681.765 20.0962 682.042 19.1255 682.319 18.2242C682.666 17.2535 683.013 16.2829 683.359 15.3122C683.498 14.7575 683.671 14.2722 683.879 13.8562C684.157 13.3709 684.434 12.9202 684.711 12.5042C685.959 10.8402 687.311 10.3202 688.767 10.9442C690.085 11.5682 690.605 12.8162 690.327 14.6882C689.773 18.2935 689.149 21.8989 688.455 25.5042C687.831 29.0402 687.242 32.6802 686.687 36.4242C686.341 38.7122 686.063 41.0349 685.855 43.3922C685.647 45.6802 685.405 47.9682 685.127 50.2562C685.058 50.5335 685.023 50.8455 685.023 51.1922C685.093 51.4695 685.162 51.8855 685.231 52.4402Z"}})])
}
var home_hero_de_svgvue_type_template_id_1710cbd4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-de-svg.vue?vue&type=template&id=1710cbd4

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/home-hero-de-svg.vue?vue&type=script&lang=js

/* harmony default export */ var home_hero_de_svgvue_type_script_lang_js = ({
  props: {
    color: {
      type: String,
      default: '#323231',
    },
  },

  data: () => ({
    svgColor: '',
  }),

  mounted() {
    this.svgColor = this.color ? this.color : '#323231'
  },

  watch: {
    color() {
      this.svgColor = this.color
    },
  },
});

// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-de-svg.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_home_hero_de_svgvue_type_script_lang_js = (home_hero_de_svgvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/svg/ui/home-hero-de-svg.vue?vue&type=style&index=0&id=1710cbd4&prod&lang=css
var home_hero_de_svgvue_type_style_index_0_id_1710cbd4_prod_lang_css = __webpack_require__("35ca");

// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-de-svg.vue






/* normalize component */

var home_hero_de_svg_component = normalizeComponent(
  ui_home_hero_de_svgvue_type_script_lang_js,
  home_hero_de_svgvue_type_template_id_1710cbd4_render,
  home_hero_de_svgvue_type_template_id_1710cbd4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var home_hero_de_svg = (home_hero_de_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/home-hero-at-svg.vue?vue&type=template&id=e66d1830
var home_hero_at_svgvue_type_template_id_e66d1830_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"718","height":"82","viewBox":"0 0 718 82","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M26.8148 50.2562C25.3588 50.8109 23.9721 51.3309 22.6548 51.8162C21.3374 52.2322 20.0201 52.7175 18.7028 53.2722C18.3561 53.4109 17.8361 53.6535 17.1428 54.0002C16.5881 54.2775 16.0334 54.4509 15.4788 54.5202C14.9241 54.5202 14.4734 54.1389 14.1268 53.3762C13.6414 52.5442 13.5374 51.8162 13.8148 51.1922C14.1614 50.5682 14.6121 50.0482 15.1668 49.6322C15.9294 49.0775 16.6921 48.5575 17.4548 48.0722C18.2868 47.5869 19.1188 47.1362 19.9508 46.7202C21.1988 46.1655 22.4468 45.6802 23.6948 45.2642C24.9428 44.8482 26.1561 44.4322 27.3348 44.0162C28.2361 39.4402 29.1028 34.9682 29.9348 30.6002C30.7668 26.2322 31.5988 21.7949 32.4308 17.2882C32.2921 17.2882 32.0841 17.2535 31.8068 17.1842C31.5988 17.1149 31.3908 17.1495 31.1828 17.2882C28.0628 18.3975 25.0121 19.5415 22.0308 20.7202C19.0494 21.8295 15.9988 22.9735 12.8788 24.1522C12.3241 24.4295 11.7694 24.7415 11.2148 25.0882C10.7294 25.3655 10.5561 25.9895 10.6948 26.9602C10.7641 27.0989 10.7294 27.2722 10.5908 27.4802C10.5214 27.6189 10.4521 27.7575 10.3828 27.8962C10.0361 28.4509 9.44677 28.8669 8.61477 29.1442C7.78277 29.4215 6.88144 29.5949 5.91077 29.6642C5.00944 29.7335 4.10811 29.6642 3.20677 29.4562C2.37477 29.2482 1.78544 28.9015 1.43877 28.4162C0.884108 27.7229 0.641441 26.9255 0.710774 26.0242C0.710774 25.0535 1.09211 24.1869 1.85477 23.4242C3.58811 21.8295 5.39077 20.4775 7.26277 19.3682C10.5908 17.4962 13.9881 15.8669 17.4548 14.4802C20.9214 13.0242 24.4228 11.7069 27.9588 10.5282C35.5161 8.03219 43.0388 6.09086 50.5268 4.70419C58.0841 3.31753 65.7454 2.34686 73.5108 1.79219C74.6894 1.65353 75.8681 1.65353 77.0468 1.79219C78.2254 1.93086 79.4041 2.10419 80.5828 2.31219C81.4841 2.38153 82.4548 2.83219 83.4948 3.66419C84.6734 4.49619 85.1588 5.77886 84.9508 7.51219C84.8814 8.13619 84.5694 8.79486 84.0148 9.48819C83.5294 10.1815 82.9401 10.8055 82.2468 11.3602C81.6228 11.9149 80.9294 12.3655 80.1668 12.7122C79.4734 13.0589 78.8494 13.1629 78.2948 13.0242C77.3934 12.8855 76.7694 12.4349 76.4228 11.6722C76.0761 10.9095 75.7641 10.0082 75.4868 8.96819C74.3081 9.03753 73.1294 9.10686 71.9508 9.17619C70.7721 9.24553 69.5934 9.34953 68.4148 9.48819C64.0468 9.83486 59.7828 10.4242 55.6228 11.2562C51.5321 12.0882 47.3374 13.0242 43.0388 14.0642C42.3454 14.2029 41.7214 14.4455 41.1668 14.7922C40.6814 15.1389 40.3348 15.7629 40.1268 16.6642C39.4334 20.4775 38.7401 24.2909 38.0468 28.1042C37.3534 31.8482 36.6601 35.5922 35.9668 39.3362C35.8974 39.6829 35.8628 39.9949 35.8628 40.2722C35.8628 40.5495 35.8628 40.9655 35.8628 41.5202C37.6654 41.1042 39.3988 40.7229 41.0628 40.3762C42.7961 39.9602 44.4948 39.5789 46.1588 39.2322C46.7134 39.0935 47.2334 38.9895 47.7188 38.9202C48.2734 38.8509 48.8281 38.8855 49.3828 39.0242C49.7294 39.0935 50.0761 39.3015 50.4228 39.6482C50.7694 39.9949 50.9774 40.3415 51.0468 40.6882C51.1854 41.1042 51.1508 41.5895 50.9428 42.1442C50.7348 42.6989 50.5268 43.0455 50.3188 43.1842C49.8334 43.6002 49.2788 43.9122 48.6548 44.1202C48.1001 44.3282 47.5454 44.5362 46.9908 44.7442C44.9801 45.2989 42.9694 45.8535 40.9588 46.4082C39.0174 46.8935 37.0068 47.4135 34.9268 47.9682C34.7881 48.7309 34.6494 49.4589 34.5108 50.1522C34.3721 50.8455 34.2681 51.5735 34.1988 52.3362C34.0601 55.2482 33.9214 58.1602 33.7828 61.0722C33.7134 63.9842 33.6441 66.8962 33.5748 69.8082C33.5748 70.7095 33.6441 71.5762 33.7828 72.4082C33.9908 73.2402 34.1641 74.0722 34.3028 74.9042C34.8574 77.1229 34.4414 78.7522 33.0548 79.7922C32.2921 80.3469 31.4601 80.5549 30.5588 80.4162C29.7268 80.3469 28.9988 79.8269 28.3748 78.8562C27.7508 78.0242 27.3348 77.0189 27.1268 75.8402C26.9881 74.5922 26.8494 73.3095 26.7108 71.9922C26.5721 70.6749 26.5028 69.3575 26.5028 68.0402C26.5028 65.1975 26.5374 62.3549 26.6068 59.5122C26.6761 56.6002 26.7454 53.5149 26.8148 50.2562Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M61.6588 59.5122C62.0055 59.7895 62.5948 59.5469 63.4268 58.7842C64.3282 57.9522 65.2988 56.9122 66.3388 55.6642C67.3788 54.4162 68.4535 53.1335 69.5628 51.8162C70.7415 50.4295 71.7468 49.3549 72.5788 48.5922C72.9948 48.2455 73.4108 48.0722 73.8268 48.0722C74.3122 48.0722 74.7282 48.2109 75.0748 48.4882C75.4215 48.6962 75.6295 49.0082 75.6988 49.4242C75.8375 49.8402 75.7682 50.3255 75.4908 50.8802C75.1442 51.5042 74.7282 52.1282 74.2428 52.7522C72.8562 54.2082 71.5042 55.6989 70.1868 57.2242C68.9388 58.7495 67.6215 60.2402 66.2348 61.6962C65.4722 62.4589 64.5362 63.1175 63.4268 63.6722C61.4162 64.7122 59.5788 64.8509 57.9148 64.0882C56.3202 63.3255 55.3495 61.8349 55.0028 59.6162C54.6562 57.3975 54.7255 55.0055 55.2108 52.4402C55.6962 49.8749 56.3895 47.5869 57.2908 45.5762C57.6375 44.6749 58.1575 44.0509 58.8508 43.7042C59.5442 43.3575 60.2722 43.3229 61.0348 43.6002C62.6295 44.1549 63.3228 45.3335 63.1148 47.1362C63.0455 48.2455 62.8722 49.5629 62.5948 51.0882C62.3868 52.6135 62.2135 53.9309 62.0748 55.0402C61.9362 55.5949 61.8668 56.2535 61.8668 57.0162C61.8668 57.7095 61.7975 58.5415 61.6588 59.5122ZM61.9708 35.6962C62.3175 35.6962 62.6642 35.8695 63.0108 36.2162C63.4268 36.4935 63.7735 36.8402 64.0508 37.2562C64.3975 37.6029 64.6402 37.9842 64.7788 38.4002C64.9868 38.8162 65.0562 39.1629 64.9868 39.4402C64.8482 39.7869 64.5708 40.1335 64.1548 40.4802C63.7388 40.8269 63.3575 41.0349 63.0108 41.1042C62.5948 41.1042 62.1788 41.0002 61.7628 40.7922C61.3468 40.5842 60.9655 40.3069 60.6188 39.9602C60.3415 39.5442 60.0988 39.1282 59.8908 38.7122C59.6828 38.2962 59.5788 37.9149 59.5788 37.5682C59.7175 37.0135 59.9948 36.5629 60.4108 36.2162C60.8268 35.8002 61.3468 35.6269 61.9708 35.6962Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M88.0163 44.1202C89.403 43.0802 90.8243 42.7682 92.2803 43.1842C93.7363 43.6002 94.6377 44.7095 94.9843 46.5122C95.123 47.4829 95.1923 48.6962 95.1923 50.1522C95.1923 51.6082 95.1923 53.0642 95.1923 54.5202C95.2617 55.9069 95.3657 57.1202 95.5043 58.1602C95.7123 59.2002 96.059 59.7549 96.5443 59.8242C96.891 59.8242 97.3763 59.5122 98.0003 58.8882C98.8323 58.0562 99.699 57.0509 100.6 55.8722C101.571 54.6935 102.472 53.5495 103.304 52.4402C104.136 51.2615 104.864 50.2562 105.488 49.4242C106.112 48.5229 106.528 47.9682 106.736 47.7602C107.014 47.4829 107.326 47.3789 107.672 47.4482C108.019 47.5175 108.296 47.6909 108.504 47.9682C108.782 48.2455 108.99 48.5922 109.128 49.0082C109.267 49.4242 109.302 49.7709 109.232 50.0482C109.094 50.8802 108.574 51.9895 107.672 53.3762C106.771 54.7629 105.731 56.1842 104.552 57.6402C103.374 59.0269 102.126 60.3095 100.808 61.4882C99.5603 62.5975 98.4857 63.3255 97.5843 63.6722C96.267 64.1575 94.9843 64.1575 93.7363 63.6722C92.5577 63.1869 91.691 62.0775 91.1363 60.3442C90.7897 59.2349 90.547 58.0562 90.4083 56.8082C90.339 55.4909 90.235 54.2429 90.0963 53.0642C90.027 52.4402 89.9923 51.8162 89.9923 51.1922C89.9923 50.4989 89.9577 49.7015 89.8883 48.8002C88.7097 49.8402 87.739 50.9495 86.9763 52.1282C86.2137 53.2375 85.4857 54.3815 84.7923 55.5602C84.099 56.7389 83.4057 57.9175 82.7123 59.0962C82.019 60.2749 81.187 61.3842 80.2163 62.4242C79.0377 63.3949 77.7203 63.8802 76.2643 63.8802C74.8083 63.8109 73.6643 63.1175 72.8323 61.8002C72.2777 60.9682 71.9657 59.9975 71.8963 58.8882C71.827 57.7789 71.7577 56.7042 71.6883 55.6642C71.6883 53.0989 71.8617 50.5335 72.2083 47.9682C72.4857 45.3335 73.0403 42.7682 73.8723 40.2722C74.0803 39.6482 74.2883 39.1282 74.4963 38.7122C75.3977 36.5629 76.6457 35.8349 78.2403 36.5282C78.9337 36.6669 79.4883 37.1175 79.9043 37.8802C80.3897 38.5735 80.459 39.4749 80.1123 40.5842C79.627 42.1789 79.1763 43.8082 78.7603 45.4722C78.4137 47.1362 78.171 48.6962 78.0323 50.1522C77.8937 51.6082 77.8243 52.8909 77.8243 54.0002C77.8937 55.0402 78.1017 55.8029 78.4483 56.2882C78.8643 56.6349 79.419 56.2882 80.1123 55.2482C80.875 54.2082 81.6723 52.9602 82.5043 51.5042C83.4057 50.0482 84.307 48.5922 85.2083 47.1362C86.179 45.6802 87.115 44.6749 88.0163 44.1202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M119.445 40.0642C119.653 39.5095 119.895 38.8855 120.173 38.1922C120.45 37.4295 120.727 36.6669 121.005 35.9042C122.045 32.9922 123.05 30.0455 124.021 27.0642C125.061 24.0829 126.066 21.1362 127.037 18.2242C127.175 18.0162 127.314 17.7735 127.453 17.4962C127.591 17.2189 127.73 16.9415 127.869 16.6642C128.631 15.2775 129.775 14.7575 131.301 15.1042C132.687 15.4509 133.45 16.3175 133.589 17.7042C133.727 18.3975 133.762 19.0909 133.693 19.7842C133.693 20.4775 133.623 21.2055 133.485 21.9682C132.722 26.6829 131.994 31.3629 131.301 36.0082C130.607 40.5842 129.879 45.2642 129.117 50.0482C128.77 51.8509 128.493 53.6882 128.285 55.5602C128.077 57.3629 127.834 59.2002 127.557 61.0722C127.487 61.4189 127.418 61.7309 127.349 62.0082C127.349 62.2855 127.279 62.5975 127.141 62.9442C126.586 64.8855 125.407 65.7869 123.605 65.6482C122.773 65.5789 122.079 65.3015 121.525 64.8162C120.97 64.3309 120.658 63.6029 120.589 62.6322C120.45 61.5922 120.381 60.5175 120.381 59.4082C120.45 58.2989 120.519 57.1895 120.589 56.0802C120.658 55.3175 120.693 54.5549 120.693 53.7922C120.762 53.0295 120.727 52.2322 120.589 51.4002C120.103 51.8855 119.722 52.3709 119.445 52.8562C118.474 54.1042 117.538 55.3869 116.637 56.7042C115.735 57.9522 114.799 59.1655 113.829 60.3442C113.413 60.8989 112.893 61.3842 112.269 61.8002C111.645 62.2162 111.021 62.5975 110.397 62.9442C108.871 63.7069 107.45 63.7762 106.133 63.1522C104.885 62.4589 104.018 61.2802 103.533 59.6162C103.394 59.0615 103.325 58.5415 103.325 58.0562C103.463 54.6589 104.226 51.6082 105.613 48.9042C106.999 46.1309 109.218 43.8429 112.269 42.0402C113.239 41.4855 114.314 41.1042 115.493 40.8962C116.741 40.6882 118.058 40.4109 119.445 40.0642ZM109.045 57.9522C110.015 57.2589 110.951 56.3922 111.853 55.3522C112.754 54.3122 113.551 53.2375 114.245 52.1282C115.007 50.9495 115.631 49.7709 116.117 48.5922C116.602 47.4135 116.879 46.3389 116.949 45.3682C115.839 45.5069 114.765 45.9575 113.725 46.7202C112.685 47.4829 111.783 48.4535 111.021 49.6322C110.327 50.8109 109.773 52.1282 109.357 53.5842C109.01 55.0402 108.906 56.4962 109.045 57.9522Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M137.516 53.6882C137.308 55.0749 137.378 56.0802 137.724 56.7042C138.14 57.3282 138.695 57.7095 139.388 57.8482C140.151 57.9869 140.983 57.9869 141.884 57.8482C142.855 57.6402 143.791 57.3629 144.692 57.0162C147.466 56.1149 149.788 54.9709 151.66 53.5842C153.532 52.1975 155.508 50.6029 157.588 48.8002C158.49 47.9682 159.252 47.5175 159.876 47.4482C160.5 47.3789 160.951 47.5175 161.228 47.8642C161.575 48.2109 161.714 48.7655 161.644 49.5282C161.575 50.2215 161.263 50.9149 160.708 51.6082C159.738 52.8562 158.386 54.1735 156.652 55.5602C154.988 56.9469 153.151 58.2295 151.14 59.4082C149.199 60.5869 147.188 61.5575 145.108 62.3202C143.098 63.0135 141.26 63.3255 139.596 63.2562C136.338 62.9095 133.98 61.6615 132.524 59.5122C130.999 57.3629 130.687 54.7282 131.588 51.6082C132.282 49.2509 133.426 47.1709 135.02 45.3682C135.714 44.5362 136.684 43.6349 137.932 42.6642C139.18 41.6242 140.463 40.7922 141.78 40.1682C143.167 39.4749 144.519 39.1282 145.836 39.1282C147.223 39.0589 148.402 39.5442 149.372 40.5842C150.551 41.7629 150.863 43.2189 150.308 44.9522C149.754 46.6855 148.748 48.3149 147.292 49.8402C145.906 51.2962 144.276 52.4402 142.404 53.2722C140.602 54.1042 138.972 54.2429 137.516 53.6882ZM145.732 44.0162C142.682 45.3335 140.706 47.1709 139.804 49.5282C141.052 49.1815 142.162 48.6269 143.132 47.8642C144.172 47.1015 145.039 45.8189 145.732 44.0162Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M198.765 40.0642C198.973 39.5095 199.216 38.8855 199.493 38.1922C199.77 37.4295 200.048 36.6669 200.325 35.9042C201.365 32.9922 202.37 30.0455 203.341 27.0642C204.381 24.0829 205.386 21.1362 206.357 18.2242C206.496 18.0162 206.634 17.7735 206.773 17.4962C206.912 17.2189 207.05 16.9415 207.189 16.6642C207.952 15.2775 209.096 14.7575 210.621 15.1042C212.008 15.4509 212.77 16.3175 212.909 17.7042C213.048 18.3975 213.082 19.0909 213.013 19.7842C213.013 20.4775 212.944 21.2055 212.805 21.9682C212.042 26.6829 211.314 31.3629 210.621 36.0082C209.928 40.5842 209.2 45.2642 208.437 50.0482C208.09 51.8509 207.813 53.6882 207.605 55.5602C207.397 57.3629 207.154 59.2002 206.877 61.0722C206.808 61.4189 206.738 61.7309 206.669 62.0082C206.669 62.2855 206.6 62.5975 206.461 62.9442C205.906 64.8855 204.728 65.7869 202.925 65.6482C202.093 65.5789 201.4 65.3015 200.845 64.8162C200.29 64.3309 199.978 63.6029 199.909 62.6322C199.77 61.5922 199.701 60.5175 199.701 59.4082C199.77 58.2989 199.84 57.1895 199.909 56.0802C199.978 55.3175 200.013 54.5549 200.013 53.7922C200.082 53.0295 200.048 52.2322 199.909 51.4002C199.424 51.8855 199.042 52.3709 198.765 52.8562C197.794 54.1042 196.858 55.3869 195.957 56.7042C195.056 57.9522 194.12 59.1655 193.149 60.3442C192.733 60.8989 192.213 61.3842 191.589 61.8002C190.965 62.2162 190.341 62.5975 189.717 62.9442C188.192 63.7069 186.77 63.7762 185.453 63.1522C184.205 62.4589 183.338 61.2802 182.853 59.6162C182.714 59.0615 182.645 58.5415 182.645 58.0562C182.784 54.6589 183.546 51.6082 184.933 48.9042C186.32 46.1309 188.538 43.8429 191.589 42.0402C192.56 41.4855 193.634 41.1042 194.813 40.8962C196.061 40.6882 197.378 40.4109 198.765 40.0642ZM188.365 57.9522C189.336 57.2589 190.272 56.3922 191.173 55.3522C192.074 54.3122 192.872 53.2375 193.565 52.1282C194.328 50.9495 194.952 49.7709 195.437 48.5922C195.922 47.4135 196.2 46.3389 196.269 45.3682C195.16 45.5069 194.085 45.9575 193.045 46.7202C192.005 47.4829 191.104 48.4535 190.341 49.6322C189.648 50.8109 189.093 52.1282 188.677 53.5842C188.33 55.0402 188.226 56.4962 188.365 57.9522Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M216.837 53.6882C216.629 55.0749 216.698 56.0802 217.045 56.7042C217.461 57.3282 218.015 57.7095 218.709 57.8482C219.471 57.9869 220.303 57.9869 221.205 57.8482C222.175 57.6402 223.111 57.3629 224.013 57.0162C226.786 56.1149 229.109 54.9709 230.981 53.5842C232.853 52.1975 234.829 50.6029 236.909 48.8002C237.81 47.9682 238.573 47.5175 239.197 47.4482C239.821 47.3789 240.271 47.5175 240.549 47.8642C240.895 48.2109 241.034 48.7655 240.965 49.5282C240.895 50.2215 240.583 50.9149 240.029 51.6082C239.058 52.8562 237.706 54.1735 235.973 55.5602C234.309 56.9469 232.471 58.2295 230.461 59.4082C228.519 60.5869 226.509 61.5575 224.429 62.3202C222.418 63.0135 220.581 63.3255 218.917 63.2562C215.658 62.9095 213.301 61.6615 211.845 59.5122C210.319 57.3629 210.007 54.7282 210.909 51.6082C211.602 49.2509 212.746 47.1709 214.341 45.3682C215.034 44.5362 216.005 43.6349 217.253 42.6642C218.501 41.6242 219.783 40.7922 221.101 40.1682C222.487 39.4749 223.839 39.1282 225.157 39.1282C226.543 39.0589 227.722 39.5442 228.693 40.5842C229.871 41.7629 230.183 43.2189 229.629 44.9522C229.074 46.6855 228.069 48.3149 226.613 49.8402C225.226 51.2962 223.597 52.4402 221.725 53.2722C219.922 54.1042 218.293 54.2429 216.837 53.6882ZM225.053 44.0162C222.002 45.3335 220.026 47.1709 219.125 49.5282C220.373 49.1815 221.482 48.6269 222.453 47.8642C223.493 47.1015 224.359 45.8189 225.053 44.0162Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M242.034 59.5122C242.381 59.7895 242.97 59.5469 243.802 58.7842C244.703 57.9522 245.674 56.9122 246.714 55.6642C247.754 54.4162 248.829 53.1335 249.938 51.8162C251.117 50.4295 252.122 49.3549 252.954 48.5922C253.37 48.2455 253.786 48.0722 254.202 48.0722C254.687 48.0722 255.103 48.2109 255.45 48.4882C255.797 48.6962 256.005 49.0082 256.074 49.4242C256.213 49.8402 256.143 50.3255 255.866 50.8802C255.519 51.5042 255.103 52.1282 254.618 52.7522C253.231 54.2082 251.879 55.6989 250.562 57.2242C249.314 58.7495 247.997 60.2402 246.61 61.6962C245.847 62.4589 244.911 63.1175 243.802 63.6722C241.791 64.7122 239.954 64.8509 238.29 64.0882C236.695 63.3255 235.725 61.8349 235.378 59.6162C235.031 57.3975 235.1 55.0055 235.586 52.4402C236.071 49.8749 236.764 47.5869 237.666 45.5762C238.012 44.6749 238.533 44.0509 239.226 43.7042C239.919 43.3575 240.647 43.3229 241.41 43.6002C243.005 44.1549 243.698 45.3335 243.49 47.1362C243.421 48.2455 243.247 49.5629 242.97 51.0882C242.762 52.6135 242.589 53.9309 242.45 55.0402C242.311 55.5949 242.242 56.2535 242.242 57.0162C242.242 57.7095 242.173 58.5415 242.034 59.5122ZM242.346 35.6962C242.693 35.6962 243.039 35.8695 243.386 36.2162C243.802 36.4935 244.149 36.8402 244.426 37.2562C244.773 37.6029 245.015 37.9842 245.154 38.4002C245.362 38.8162 245.431 39.1629 245.362 39.4402C245.223 39.7869 244.946 40.1335 244.53 40.4802C244.114 40.8269 243.732 41.0349 243.386 41.1042C242.97 41.1042 242.554 41.0002 242.138 40.7922C241.722 40.5842 241.34 40.3069 240.994 39.9602C240.717 39.5442 240.474 39.1282 240.266 38.7122C240.058 38.2962 239.954 37.9149 239.954 37.5682C240.093 37.0135 240.37 36.5629 240.786 36.2162C241.202 35.8002 241.722 35.6269 242.346 35.6962Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M268.391 44.1202C269.778 43.0802 271.199 42.7682 272.655 43.1842C274.111 43.6002 275.013 44.7095 275.359 46.5122C275.498 47.4829 275.567 48.6962 275.567 50.1522C275.567 51.6082 275.567 53.0642 275.567 54.5202C275.637 55.9069 275.741 57.1202 275.879 58.1602C276.087 59.2002 276.434 59.7549 276.919 59.8242C277.266 59.8242 277.751 59.5122 278.375 58.8882C279.207 58.0562 280.074 57.0509 280.975 55.8722C281.946 54.6935 282.847 53.5495 283.679 52.4402C284.511 51.2615 285.239 50.2562 285.863 49.4242C286.487 48.5229 286.903 47.9682 287.111 47.7602C287.389 47.4829 287.701 47.3789 288.047 47.4482C288.394 47.5175 288.671 47.6909 288.879 47.9682C289.157 48.2455 289.365 48.5922 289.503 49.0082C289.642 49.4242 289.677 49.7709 289.607 50.0482C289.469 50.8802 288.949 51.9895 288.047 53.3762C287.146 54.7629 286.106 56.1842 284.927 57.6402C283.749 59.0269 282.501 60.3095 281.183 61.4882C279.935 62.5975 278.861 63.3255 277.959 63.6722C276.642 64.1575 275.359 64.1575 274.111 63.6722C272.933 63.1869 272.066 62.0775 271.511 60.3442C271.165 59.2349 270.922 58.0562 270.783 56.8082C270.714 55.4909 270.61 54.2429 270.471 53.0642C270.402 52.4402 270.367 51.8162 270.367 51.1922C270.367 50.4989 270.333 49.7015 270.263 48.8002C269.085 49.8402 268.114 50.9495 267.351 52.1282C266.589 53.2375 265.861 54.3815 265.167 55.5602C264.474 56.7389 263.781 57.9175 263.087 59.0962C262.394 60.2749 261.562 61.3842 260.591 62.4242C259.413 63.3949 258.095 63.8802 256.639 63.8802C255.183 63.8109 254.039 63.1175 253.207 61.8002C252.653 60.9682 252.341 59.9975 252.271 58.8882C252.202 57.7789 252.133 56.7042 252.063 55.6642C252.063 53.0989 252.237 50.5335 252.583 47.9682C252.861 45.3335 253.415 42.7682 254.247 40.2722C254.455 39.6482 254.663 39.1282 254.871 38.7122C255.773 36.5629 257.021 35.8349 258.615 36.5282C259.309 36.6669 259.863 37.1175 260.279 37.8802C260.765 38.5735 260.834 39.4749 260.487 40.5842C260.002 42.1789 259.551 43.8082 259.135 45.4722C258.789 47.1362 258.546 48.6962 258.407 50.1522C258.269 51.6082 258.199 52.8909 258.199 54.0002C258.269 55.0402 258.477 55.8029 258.823 56.2882C259.239 56.6349 259.794 56.2882 260.487 55.2482C261.25 54.2082 262.047 52.9602 262.879 51.5042C263.781 50.0482 264.682 48.5922 265.583 47.1362C266.554 45.6802 267.49 44.6749 268.391 44.1202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M290.876 53.6882C290.668 55.0749 290.737 56.0802 291.084 56.7042C291.5 57.3282 292.054 57.7095 292.748 57.8482C293.51 57.9869 294.342 57.9869 295.244 57.8482C296.214 57.6402 297.15 57.3629 298.052 57.0162C300.825 56.1149 303.148 54.9709 305.02 53.5842C306.892 52.1975 308.868 50.6029 310.948 48.8002C311.849 47.9682 312.612 47.5175 313.236 47.4482C313.86 47.3789 314.31 47.5175 314.588 47.8642C314.934 48.2109 315.073 48.7655 315.004 49.5282C314.934 50.2215 314.622 50.9149 314.068 51.6082C313.097 52.8562 311.745 54.1735 310.012 55.5602C308.348 56.9469 306.51 58.2295 304.5 59.4082C302.558 60.5869 300.548 61.5575 298.468 62.3202C296.457 63.0135 294.62 63.3255 292.956 63.2562C289.697 62.9095 287.34 61.6615 285.884 59.5122C284.358 57.3629 284.046 54.7282 284.948 51.6082C285.641 49.2509 286.785 47.1709 288.38 45.3682C289.073 44.5362 290.044 43.6349 291.292 42.6642C292.54 41.6242 293.822 40.7922 295.14 40.1682C296.526 39.4749 297.878 39.1282 299.196 39.1282C300.582 39.0589 301.761 39.5442 302.732 40.5842C303.91 41.7629 304.222 43.2189 303.668 44.9522C303.113 46.6855 302.108 48.3149 300.652 49.8402C299.265 51.2962 297.636 52.4402 295.764 53.2722C293.961 54.1042 292.332 54.2429 290.876 53.6882ZM299.092 44.0162C296.041 45.3335 294.065 47.1709 293.164 49.5282C294.412 49.1815 295.521 48.6269 296.492 47.8642C297.532 47.1015 298.398 45.8189 299.092 44.0162Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M326.993 44.1202C328.38 43.0802 329.801 42.7682 331.257 43.1842C332.713 43.6002 333.614 44.7095 333.961 46.5122C334.1 47.4829 334.169 48.6962 334.169 50.1522C334.169 51.6082 334.169 53.0642 334.169 54.5202C334.238 55.9069 334.342 57.1202 334.481 58.1602C334.689 59.2002 335.036 59.7549 335.521 59.8242C335.868 59.8242 336.353 59.5122 336.977 58.8882C337.809 58.0562 338.676 57.0509 339.577 55.8722C340.548 54.6935 341.449 53.5495 342.281 52.4402C343.113 51.2615 343.841 50.2562 344.465 49.4242C345.089 48.5229 345.505 47.9682 345.713 47.7602C345.99 47.4829 346.302 47.3789 346.649 47.4482C346.996 47.5175 347.273 47.6909 347.481 47.9682C347.758 48.2455 347.966 48.5922 348.105 49.0082C348.244 49.4242 348.278 49.7709 348.209 50.0482C348.07 50.8802 347.55 51.9895 346.649 53.3762C345.748 54.7629 344.708 56.1842 343.529 57.6402C342.35 59.0269 341.102 60.3095 339.785 61.4882C338.537 62.5975 337.462 63.3255 336.561 63.6722C335.244 64.1575 333.961 64.1575 332.713 63.6722C331.534 63.1869 330.668 62.0775 330.113 60.3442C329.766 59.2349 329.524 58.0562 329.385 56.8082C329.316 55.4909 329.212 54.2429 329.073 53.0642C329.004 52.4402 328.969 51.8162 328.969 51.1922C328.969 50.4989 328.934 49.7015 328.865 48.8002C327.686 49.8402 326.716 50.9495 325.953 52.1282C325.19 53.2375 324.462 54.3815 323.769 55.5602C323.076 56.7389 322.382 57.9175 321.689 59.0962C320.996 60.2749 320.164 61.3842 319.193 62.4242C318.014 63.3949 316.697 63.8802 315.241 63.8802C313.785 63.8109 312.641 63.1175 311.809 61.8002C311.254 60.9682 310.942 59.9975 310.873 58.8882C310.804 57.7789 310.734 56.7042 310.665 55.6642C310.665 53.0989 310.838 50.5335 311.185 47.9682C311.462 45.3335 312.017 42.7682 312.849 40.2722C313.057 39.6482 313.265 39.1282 313.473 38.7122C314.374 36.5629 315.622 35.8349 317.217 36.5282C317.91 36.6669 318.465 37.1175 318.881 37.8802C319.366 38.5735 319.436 39.4749 319.089 40.5842C318.604 42.1789 318.153 43.8082 317.737 45.4722C317.39 47.1362 317.148 48.6962 317.009 50.1522C316.87 51.6082 316.801 52.8909 316.801 54.0002C316.87 55.0402 317.078 55.8029 317.425 56.2882C317.841 56.6349 318.396 56.2882 319.089 55.2482C319.852 54.2082 320.649 52.9602 321.481 51.5042C322.382 50.0482 323.284 48.5922 324.185 47.1362C325.156 45.6802 326.092 44.6749 326.993 44.1202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M394.785 17.6002C392.913 18.2242 391.041 18.8135 389.169 19.3682C387.366 19.9229 385.563 20.5122 383.761 21.1362C382.721 21.4829 381.681 21.8295 380.641 22.1762C379.67 22.5229 378.699 22.8695 377.729 23.2162C376.897 23.4935 375.995 23.6322 375.025 23.6322C374.401 23.5629 373.846 23.3549 373.361 23.0082C372.945 22.6615 372.737 22.1415 372.737 21.4482C372.737 21.0322 372.875 20.6162 373.153 20.2002C373.43 19.7149 373.742 19.2989 374.089 18.9522C374.435 18.6055 374.817 18.3282 375.233 18.1202C375.649 17.9122 376.099 17.7389 376.585 17.6002C381.022 16.2135 385.425 14.7922 389.793 13.3362C394.161 11.8109 398.563 10.4589 403.001 9.2802C408.894 7.68553 414.787 6.22953 420.681 4.91219C426.574 3.59486 432.467 2.27752 438.361 0.960192C438.707 0.89086 439.019 0.821527 439.297 0.752195C439.574 0.682862 439.886 0.682862 440.233 0.752195C440.857 0.821527 441.377 1.06419 441.793 1.48019C442.278 1.82686 442.521 2.38153 442.521 3.14419C442.451 3.62953 442.278 4.18419 442.001 4.80819C441.793 5.36286 441.515 5.70953 441.169 5.84819C440.406 6.33353 439.643 6.68019 438.881 6.8882C438.187 7.09619 437.459 7.30419 436.697 7.51219C433.438 8.27486 430.214 9.00286 427.025 9.69619C423.835 10.3895 420.646 11.1175 417.457 11.8802C414.891 12.4349 412.361 13.0589 409.865 13.7522C407.438 14.3762 404.907 14.9655 402.273 15.5202C402.619 17.1149 402.585 18.5362 402.169 19.7842C401.822 21.0322 401.475 22.3149 401.129 23.6322C398.91 30.7735 396.865 37.9149 394.993 45.0562C393.121 52.1282 391.699 59.4082 390.729 66.8962C390.59 68.0749 390.486 69.2535 390.417 70.4322C390.417 71.6109 390.833 72.7895 391.665 73.9682C392.289 74.8695 392.323 76.0482 391.769 77.5042C391.283 78.8909 390.521 79.9309 389.481 80.6242C388.51 81.3175 387.435 81.5255 386.257 81.2482C385.147 81.0402 384.315 80.3469 383.761 79.1682C383.067 77.7122 382.651 76.1522 382.513 74.4882C382.235 71.7149 382.235 68.9762 382.513 66.2722C382.859 63.5682 383.275 60.8642 383.761 58.1602C384.662 52.6829 385.737 47.2749 386.985 41.9362C388.233 36.5282 389.862 31.2242 391.873 26.0242C392.427 24.7069 392.947 23.4242 393.433 22.1762C393.987 20.9282 394.507 19.6455 394.993 18.3282C394.854 18.0509 394.785 17.8082 394.785 17.6002Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M411.818 45.3682C412.511 44.6749 413.066 44.1202 413.482 43.7042C413.898 43.2882 414.314 42.9069 414.73 42.5602C415.562 41.8669 416.359 41.1735 417.122 40.4802C417.954 39.7869 418.821 39.1975 419.722 38.7122C422.079 37.5335 424.09 37.7762 425.754 39.4402C427.071 40.9655 427.314 42.9762 426.482 45.4722C426.135 46.6509 425.303 47.2055 423.986 47.1362C423.015 46.9975 422.599 46.3735 422.738 45.2642C422.877 44.5709 422.911 44.0162 422.842 43.6002C422.634 42.2135 421.802 41.9362 420.346 42.7682C419.93 43.0455 419.479 43.3922 418.994 43.8082C418.509 44.1549 418.093 44.5362 417.746 44.9522C415.597 47.1709 413.759 49.6322 412.234 52.3362C410.709 54.9709 409.946 57.7442 409.946 60.6562C409.946 61.6962 409.634 62.6322 409.01 63.4642C408.455 64.2962 407.693 64.8162 406.722 65.0242C405.821 65.2322 405.023 65.0935 404.33 64.6082C403.706 64.1229 403.325 63.3602 403.186 62.3202C403.047 61.4189 403.013 59.9629 403.082 57.9522C403.082 55.8722 403.221 53.6882 403.498 51.4002C403.706 49.0429 404.087 46.7202 404.642 44.4322C405.197 42.0749 405.89 40.0989 406.722 38.5042C407.138 37.7415 407.693 37.1869 408.386 36.8402C409.079 36.4935 409.773 36.3549 410.466 36.4242C412.061 36.6322 412.754 37.6375 412.546 39.4402C412.477 40.3415 412.373 41.2775 412.234 42.2482C412.095 43.1495 411.957 44.1895 411.818 45.3682Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M440.425 53.8962C439.732 54.7975 439.073 55.6295 438.449 56.3922C437.825 57.0855 437.201 57.7789 436.577 58.4722C435.953 59.0269 435.295 59.6162 434.601 60.2402C433.977 60.8642 433.319 61.3495 432.625 61.6962C431.377 62.4589 430.233 62.6322 429.193 62.2162C428.084 61.7309 427.321 60.7949 426.905 59.4082C426.559 58.4375 426.455 57.5015 426.593 56.6002C427.148 53.4802 428.119 50.6375 429.505 48.0722C430.892 45.5069 432.903 43.3229 435.537 41.5202C437.271 40.3415 439.004 39.6829 440.737 39.5442C442.471 39.4055 444.239 39.8909 446.041 41.0002C447.081 41.6242 447.775 42.2482 448.121 42.8722C448.468 43.4269 448.537 44.3282 448.329 45.5762C448.191 46.6855 447.983 47.7949 447.705 48.9042C447.497 49.9442 447.324 51.0535 447.185 52.2322C447.047 53.2722 446.908 54.3469 446.769 55.4562C446.631 56.4962 446.631 57.3282 446.769 57.9522C446.977 58.5762 447.324 58.8882 447.809 58.8882C448.364 58.8882 449.231 58.2989 450.409 57.1202C451.38 56.0109 452.108 55.1442 452.593 54.5202C453.148 53.8962 453.633 53.3415 454.049 52.8562C454.535 52.3015 455.02 51.7122 455.505 51.0882C456.06 50.4642 456.823 49.6322 457.793 48.5922C458.071 48.3149 458.348 48.0375 458.625 47.7602C458.972 47.4829 459.319 47.2749 459.665 47.1362C460.012 46.9975 460.393 47.0322 460.809 47.2402C461.295 47.3789 461.641 47.5869 461.849 47.8642C462.057 48.0029 462.127 48.2802 462.057 48.6962C462.057 49.0429 462.023 49.3895 461.953 49.7362C461.884 50.0135 461.641 50.3602 461.225 50.7762C460.393 51.8162 459.735 52.6482 459.249 53.2722C458.764 53.8269 458.313 54.3469 457.897 54.8322C457.481 55.3175 456.996 55.8722 456.441 56.4962C455.956 57.0509 455.263 57.8482 454.361 58.8882C453.737 59.6509 453.079 60.3442 452.385 60.9682C451.761 61.5922 451.068 62.1815 450.305 62.7362C448.503 63.9149 446.943 64.4695 445.625 64.4002C444.377 64.3309 443.337 63.8109 442.505 62.8402C441.743 61.8695 441.188 60.5869 440.841 58.9922C440.495 57.3975 440.356 55.6989 440.425 53.8962ZM431.585 57.0162C432.279 56.5309 433.18 55.6989 434.289 54.5202C435.399 53.3415 436.473 52.1282 437.513 50.8802C438.623 49.5629 439.593 48.3149 440.425 47.1362C441.327 45.8882 441.881 44.9522 442.089 44.3282C440.911 44.1895 439.732 44.4322 438.553 45.0562C437.375 45.6109 436.3 46.4775 435.329 47.6562C434.428 48.7655 433.631 50.1522 432.937 51.8162C432.244 53.4109 431.793 55.1442 431.585 57.0162Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M473.751 51.9202C473.057 52.8215 472.468 53.5842 471.983 54.2082C471.567 54.8322 471.116 55.3869 470.631 55.8722C469.66 57.0509 468.585 58.1602 467.407 59.2002C466.297 60.1709 465.015 60.9335 463.559 61.4882C461.756 62.3202 460.161 62.3202 458.775 61.4882C457.596 60.7949 456.868 59.6509 456.591 58.0562C456.313 56.4615 456.313 54.8322 456.591 53.1682C456.868 51.4349 457.319 49.8055 457.943 48.2802C458.567 46.6855 459.156 45.5762 459.711 44.9522C460.335 44.1895 461.063 43.8082 461.895 43.8082C462.796 43.7389 463.593 43.9122 464.287 44.3282C464.98 44.6749 465.431 45.1949 465.639 45.8882C465.916 46.5815 465.743 47.3095 465.119 48.0722C464.772 48.4882 464.46 49.0775 464.183 49.8402C463.905 50.5335 463.628 51.3309 463.351 52.2322C463.073 53.0642 462.831 53.8962 462.623 54.7282C462.484 55.5602 462.415 56.2535 462.415 56.8082C462.692 57.2242 463.281 57.0509 464.183 56.2882C465.153 55.5255 466.193 54.5202 467.303 53.2722C468.481 52.0242 469.625 50.7069 470.735 49.3202C471.844 47.8642 472.745 46.7202 473.439 45.8882C473.716 45.5415 473.959 45.1949 474.167 44.8482C474.444 44.4322 474.756 44.0509 475.103 43.7042C475.519 43.2882 476.073 43.0455 476.767 42.9762C477.46 42.8375 478.119 42.8375 478.743 42.9762C479.436 43.0455 480.025 43.2535 480.511 43.6002C480.996 43.9469 481.273 44.3975 481.343 44.9522C481.343 45.2989 481.273 45.9575 481.135 46.9282C480.996 47.8989 480.823 48.9735 480.615 50.1522C480.476 51.3309 480.337 52.5095 480.199 53.6882C480.129 54.7975 480.129 55.7335 480.199 56.4962C480.337 57.2589 480.615 57.7095 481.031 57.8482C481.447 57.9869 482.071 57.6402 482.903 56.8082C484.081 55.6295 485.191 54.4162 486.231 53.1682C487.34 51.9202 488.449 50.6375 489.559 49.3202C490.321 48.4189 491.049 47.8642 491.743 47.6562C492.505 47.4482 493.06 47.5175 493.407 47.8642C493.823 48.1415 493.996 48.6269 493.927 49.3202C493.857 50.0135 493.441 50.7762 492.679 51.6082C491.569 52.9949 490.425 54.4162 489.247 55.8722C488.137 57.3282 486.993 58.6455 485.815 59.8242C484.705 60.9335 483.561 61.8349 482.383 62.5282C481.273 63.2215 480.164 63.5335 479.055 63.4642C475.311 63.1175 473.543 59.2695 473.751 51.9202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M516.019 53.2722C517.059 51.4002 518.238 49.6669 519.555 48.0722C520.873 46.4775 522.329 45.0909 523.923 43.9122C525.726 42.5949 527.286 42.2829 528.603 42.9762C529.99 43.6002 530.787 45.0562 530.995 47.3442C531.203 49.2162 531.342 51.0535 531.411 52.8562C531.481 54.5895 531.723 56.3575 532.139 58.1602C534.427 56.9815 536.473 55.4215 538.275 53.4802C540.147 51.4695 541.777 49.7709 543.163 48.3842C543.649 47.8989 544.099 47.6909 544.515 47.7602C545.001 47.7602 545.382 47.9335 545.659 48.2802C545.937 48.5575 546.075 48.9735 546.075 49.5282C546.145 50.0135 546.006 50.5335 545.659 51.0882C544.897 51.9202 544.065 52.8562 543.163 53.8962C542.262 54.9362 541.326 55.9415 540.355 56.9122C539.385 57.8829 538.379 58.7842 537.339 59.6162C536.299 60.4482 535.259 61.1069 534.219 61.5922C532.417 62.3549 530.961 62.4242 529.851 61.8002C528.811 61.1069 528.014 59.7895 527.459 57.8482C527.182 57.0855 527.009 56.2882 526.939 55.4562C526.939 54.6242 526.905 53.7922 526.835 52.9602C526.766 52.1282 526.731 51.2615 526.731 50.3602C526.801 49.4589 526.835 48.4535 526.835 47.3442C525.726 47.7602 524.755 48.3495 523.923 49.1122C523.091 49.8749 522.363 50.7069 521.739 51.6082C521.115 52.5095 520.526 53.4455 519.971 54.4162C519.417 55.3869 518.827 56.2882 518.203 57.1202C517.787 57.8135 517.302 58.4375 516.747 58.9922C516.193 59.4775 515.43 59.6509 514.459 59.5122C513.489 59.3735 512.83 58.9922 512.483 58.3682C512.206 57.6749 511.929 56.9469 511.651 56.1842C511.443 55.2135 511.201 54.3122 510.923 53.4802C510.715 52.5789 510.542 51.6775 510.403 50.7762C509.433 52.0242 508.601 53.2029 507.907 54.3122C507.283 55.3522 506.659 56.3922 506.035 57.4322C505.55 58.1949 505.099 58.9229 504.683 59.6162C504.267 60.3095 503.886 61.0375 503.539 61.8002C502.985 63.1869 502.187 64.1922 501.147 64.8162C500.107 65.3709 498.929 65.5789 497.611 65.4402C496.225 65.3709 495.15 64.8855 494.387 63.9842C493.694 63.0829 493.139 62.0429 492.723 60.8642C492.238 59.3389 491.926 57.5362 491.787 55.4562C491.718 53.3762 491.787 51.2962 491.995 49.2162C492.273 47.0669 492.689 45.0562 493.243 43.1842C493.798 41.2429 494.491 39.6829 495.323 38.5042C495.809 37.9495 496.363 37.6375 496.987 37.5682C497.611 37.4989 498.201 37.5682 498.755 37.7762C500.003 38.2615 500.593 39.1282 500.523 40.3762C500.385 42.0402 500.142 43.7389 499.795 45.4722C499.518 47.1362 499.275 48.8349 499.067 50.5682C498.929 52.2322 498.894 53.8615 498.963 55.4562C499.033 57.0509 499.345 58.5415 499.899 59.9282C501.355 57.5015 502.846 55.1095 504.371 52.7522C505.897 50.3255 507.595 48.1762 509.467 46.3042C510.646 45.1949 511.721 44.8135 512.691 45.1602C513.662 45.5069 514.321 46.4429 514.667 47.9682C514.806 48.7309 514.979 49.6322 515.187 50.6722C515.395 51.6429 515.673 52.5095 516.019 53.2722Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M558.962 51.9202C558.268 52.8215 557.679 53.5842 557.194 54.2082C556.778 54.8322 556.327 55.3869 555.842 55.8722C554.871 57.0509 553.796 58.1602 552.618 59.2002C551.508 60.1709 550.226 60.9335 548.77 61.4882C546.967 62.3202 545.372 62.3202 543.986 61.4882C542.807 60.7949 542.079 59.6509 541.802 58.0562C541.524 56.4615 541.524 54.8322 541.802 53.1682C542.079 51.4349 542.53 49.8055 543.154 48.2802C543.778 46.6855 544.367 45.5762 544.922 44.9522C545.546 44.1895 546.274 43.8082 547.106 43.8082C548.007 43.7389 548.804 43.9122 549.498 44.3282C550.191 44.6749 550.642 45.1949 550.85 45.8882C551.127 46.5815 550.954 47.3095 550.33 48.0722C549.983 48.4882 549.671 49.0775 549.394 49.8402C549.116 50.5335 548.839 51.3309 548.562 52.2322C548.284 53.0642 548.042 53.8962 547.834 54.7282C547.695 55.5602 547.626 56.2535 547.626 56.8082C547.903 57.2242 548.492 57.0509 549.394 56.2882C550.364 55.5255 551.404 54.5202 552.514 53.2722C553.692 52.0242 554.836 50.7069 555.946 49.3202C557.055 47.8642 557.956 46.7202 558.65 45.8882C558.927 45.5415 559.17 45.1949 559.378 44.8482C559.655 44.4322 559.967 44.0509 560.314 43.7042C560.73 43.2882 561.284 43.0455 561.978 42.9762C562.671 42.8375 563.33 42.8375 563.954 42.9762C564.647 43.0455 565.236 43.2535 565.722 43.6002C566.207 43.9469 566.484 44.3975 566.554 44.9522C566.554 45.2989 566.484 45.9575 566.346 46.9282C566.207 47.8989 566.034 48.9735 565.826 50.1522C565.687 51.3309 565.548 52.5095 565.41 53.6882C565.34 54.7975 565.34 55.7335 565.41 56.4962C565.548 57.2589 565.826 57.7095 566.242 57.8482C566.658 57.9869 567.282 57.6402 568.114 56.8082C569.292 55.6295 570.402 54.4162 571.442 53.1682C572.551 51.9202 573.66 50.6375 574.77 49.3202C575.532 48.4189 576.26 47.8642 576.954 47.6562C577.716 47.4482 578.271 47.5175 578.618 47.8642C579.034 48.1415 579.207 48.6269 579.138 49.3202C579.068 50.0135 578.652 50.7762 577.89 51.6082C576.78 52.9949 575.636 54.4162 574.458 55.8722C573.348 57.3282 572.204 58.6455 571.026 59.8242C569.916 60.9335 568.772 61.8349 567.594 62.5282C566.484 63.2215 565.375 63.5335 564.266 63.4642C560.522 63.1175 558.754 59.2695 558.962 51.9202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M583.966 45.3682C584.66 44.6749 585.214 44.1202 585.63 43.7042C586.046 43.2882 586.462 42.9069 586.878 42.5602C587.71 41.8669 588.508 41.1735 589.27 40.4802C590.102 39.7869 590.969 39.1975 591.87 38.7122C594.228 37.5335 596.238 37.7762 597.902 39.4402C599.22 40.9655 599.462 42.9762 598.63 45.4722C598.284 46.6509 597.452 47.2055 596.134 47.1362C595.164 46.9975 594.748 46.3735 594.886 45.2642C595.025 44.5709 595.06 44.0162 594.99 43.6002C594.782 42.2135 593.95 41.9362 592.494 42.7682C592.078 43.0455 591.628 43.3922 591.142 43.8082C590.657 44.1549 590.241 44.5362 589.894 44.9522C587.745 47.1709 585.908 49.6322 584.382 52.3362C582.857 54.9709 582.094 57.7442 582.094 60.6562C582.094 61.6962 581.782 62.6322 581.158 63.4642C580.604 64.2962 579.841 64.8162 578.87 65.0242C577.969 65.2322 577.172 65.0935 576.478 64.6082C575.854 64.1229 575.473 63.3602 575.334 62.3202C575.196 61.4189 575.161 59.9629 575.23 57.9522C575.23 55.8722 575.369 53.6882 575.646 51.4002C575.854 49.0429 576.236 46.7202 576.79 44.4322C577.345 42.0749 578.038 40.0989 578.87 38.5042C579.286 37.7415 579.841 37.1869 580.534 36.8402C581.228 36.4935 581.921 36.3549 582.614 36.4242C584.209 36.6322 584.902 37.6375 584.694 39.4402C584.625 40.3415 584.521 41.2775 584.382 42.2482C584.244 43.1495 584.105 44.1895 583.966 45.3682Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M616.006 47.8642C616.699 47.1015 617.392 46.9975 618.086 47.5522C618.779 48.0375 618.848 48.9389 618.294 50.2562C618.086 50.8109 617.566 51.6775 616.734 52.8562C615.971 54.0349 615.104 55.3175 614.134 56.7042C613.232 58.0215 612.366 59.2695 611.534 60.4482C610.702 61.6269 610.078 62.4589 609.662 62.9442C609.038 63.6375 608.344 64.1922 607.582 64.6082C606.888 65.0242 606.056 65.1282 605.086 64.9202C603.56 64.6429 602.486 63.7415 601.862 62.2162C601.307 60.6909 600.995 58.9922 600.926 57.1202C600.787 55.2482 600.822 53.4109 601.03 51.6082C601.238 49.8055 601.376 48.4189 601.446 47.4482C601.654 45.1602 601.966 42.4562 602.382 39.3362C602.798 36.1469 603.318 32.9922 603.942 29.8722C604.566 26.6829 605.224 23.6669 605.918 20.8242C606.611 17.9815 607.339 15.7282 608.102 14.0642C608.448 13.1629 608.934 12.5735 609.558 12.2962C610.251 11.9495 610.979 11.8455 611.742 11.9842C613.267 12.4002 613.926 13.5442 613.718 15.4162C612.608 21.3789 611.568 27.2375 610.598 32.9922C609.696 38.6775 609.003 44.3629 608.518 50.0482C608.448 51.0882 608.414 52.0935 608.414 53.0642C608.414 54.0349 608.483 54.7975 608.622 55.3522C608.83 55.9069 609.107 56.1495 609.454 56.0802C609.87 56.0109 610.424 55.4562 611.118 54.4162C611.742 53.4455 612.4 52.5442 613.094 51.7122C613.787 50.8109 614.238 50.1869 614.446 49.8402C614.654 49.4935 614.862 49.1815 615.07 48.9042C615.347 48.5575 615.659 48.2109 616.006 47.8642Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M626.589 53.8962C625.896 54.7975 625.237 55.6295 624.613 56.3922C623.989 57.0855 623.365 57.7789 622.741 58.4722C622.117 59.0269 621.459 59.6162 620.765 60.2402C620.141 60.8642 619.483 61.3495 618.789 61.6962C617.541 62.4589 616.397 62.6322 615.357 62.2162C614.248 61.7309 613.485 60.7949 613.069 59.4082C612.723 58.4375 612.619 57.5015 612.757 56.6002C613.312 53.4802 614.283 50.6375 615.669 48.0722C617.056 45.5069 619.067 43.3229 621.701 41.5202C623.435 40.3415 625.168 39.6829 626.901 39.5442C628.635 39.4055 630.403 39.8909 632.205 41.0002C633.245 41.6242 633.939 42.2482 634.285 42.8722C634.632 43.4269 634.701 44.3282 634.493 45.5762C634.355 46.6855 634.147 47.7949 633.869 48.9042C633.661 49.9442 633.488 51.0535 633.349 52.2322C633.211 53.2722 633.072 54.3469 632.933 55.4562C632.795 56.4962 632.795 57.3282 632.933 57.9522C633.141 58.5762 633.488 58.8882 633.973 58.8882C634.528 58.8882 635.395 58.2989 636.573 57.1202C637.544 56.0109 638.272 55.1442 638.757 54.5202C639.312 53.8962 639.797 53.3415 640.213 52.8562C640.699 52.3015 641.184 51.7122 641.669 51.0882C642.224 50.4642 642.987 49.6322 643.957 48.5922C644.235 48.3149 644.512 48.0375 644.789 47.7602C645.136 47.4829 645.483 47.2749 645.829 47.1362C646.176 46.9975 646.557 47.0322 646.973 47.2402C647.459 47.3789 647.805 47.5869 648.013 47.8642C648.221 48.0029 648.291 48.2802 648.221 48.6962C648.221 49.0429 648.187 49.3895 648.117 49.7362C648.048 50.0135 647.805 50.3602 647.389 50.7762C646.557 51.8162 645.899 52.6482 645.413 53.2722C644.928 53.8269 644.477 54.3469 644.061 54.8322C643.645 55.3175 643.16 55.8722 642.605 56.4962C642.12 57.0509 641.427 57.8482 640.525 58.8882C639.901 59.6509 639.243 60.3442 638.549 60.9682C637.925 61.5922 637.232 62.1815 636.469 62.7362C634.667 63.9149 633.107 64.4695 631.789 64.4002C630.541 64.3309 629.501 63.8109 628.669 62.8402C627.907 61.8695 627.352 60.5869 627.005 58.9922C626.659 57.3975 626.52 55.6989 626.589 53.8962ZM617.749 57.0162C618.443 56.5309 619.344 55.6989 620.453 54.5202C621.563 53.3415 622.637 52.1282 623.677 50.8802C624.787 49.5629 625.757 48.3149 626.589 47.1362C627.491 45.8882 628.045 44.9522 628.253 44.3282C627.075 44.1895 625.896 44.4322 624.717 45.0562C623.539 45.6109 622.464 46.4775 621.493 47.6562C620.592 48.7655 619.795 50.1522 619.101 51.8162C618.408 53.4109 617.957 55.1442 617.749 57.0162Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M659.915 51.9202C659.221 52.8215 658.632 53.5842 658.147 54.2082C657.731 54.8322 657.28 55.3869 656.795 55.8722C655.824 57.0509 654.749 58.1602 653.571 59.2002C652.461 60.1709 651.179 60.9335 649.723 61.4882C647.92 62.3202 646.325 62.3202 644.939 61.4882C643.76 60.7949 643.032 59.6509 642.755 58.0562C642.477 56.4615 642.477 54.8322 642.755 53.1682C643.032 51.4349 643.483 49.8055 644.107 48.2802C644.731 46.6855 645.32 45.5762 645.875 44.9522C646.499 44.1895 647.227 43.8082 648.059 43.8082C648.96 43.7389 649.757 43.9122 650.451 44.3282C651.144 44.6749 651.595 45.1949 651.803 45.8882C652.08 46.5815 651.907 47.3095 651.283 48.0722C650.936 48.4882 650.624 49.0775 650.347 49.8402C650.069 50.5335 649.792 51.3309 649.515 52.2322C649.237 53.0642 648.995 53.8962 648.787 54.7282C648.648 55.5602 648.579 56.2535 648.579 56.8082C648.856 57.2242 649.445 57.0509 650.347 56.2882C651.317 55.5255 652.357 54.5202 653.467 53.2722C654.645 52.0242 655.789 50.7069 656.899 49.3202C658.008 47.8642 658.909 46.7202 659.603 45.8882C659.88 45.5415 660.123 45.1949 660.331 44.8482C660.608 44.4322 660.92 44.0509 661.267 43.7042C661.683 43.2882 662.237 43.0455 662.931 42.9762C663.624 42.8375 664.283 42.8375 664.907 42.9762C665.6 43.0455 666.189 43.2535 666.675 43.6002C667.16 43.9469 667.437 44.3975 667.507 44.9522C667.507 45.2989 667.437 45.9575 667.299 46.9282C667.16 47.8989 666.987 48.9735 666.779 50.1522C666.64 51.3309 666.501 52.5095 666.363 53.6882C666.293 54.7975 666.293 55.7335 666.363 56.4962C666.501 57.2589 666.779 57.7095 667.195 57.8482C667.611 57.9869 668.235 57.6402 669.067 56.8082C670.245 55.6295 671.355 54.4162 672.395 53.1682C673.504 51.9202 674.613 50.6375 675.723 49.3202C676.485 48.4189 677.213 47.8642 677.907 47.6562C678.669 47.4482 679.224 47.5175 679.571 47.8642C679.987 48.1415 680.16 48.6269 680.091 49.3202C680.021 50.0135 679.605 50.7762 678.843 51.6082C677.733 52.9949 676.589 54.4162 675.411 55.8722C674.301 57.3282 673.157 58.6455 671.979 59.8242C670.869 60.9335 669.725 61.8349 668.547 62.5282C667.437 63.2215 666.328 63.5335 665.219 63.4642C661.475 63.1175 659.707 59.2695 659.915 51.9202Z"}}),_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M685.231 52.4402C686.341 51.1922 687.415 50.0135 688.455 48.9042C689.565 47.7255 690.709 46.6855 691.887 45.7842C693.066 44.8829 694.314 44.1202 695.631 43.4962C696.949 42.8722 698.405 42.4909 699.999 42.3522C701.178 42.2135 702.218 42.2482 703.119 42.4562C704.367 42.6642 705.303 43.0455 705.927 43.6002C706.621 44.0855 707.106 44.7095 707.383 45.4722C707.73 46.1655 707.903 46.9629 707.903 47.8642C707.903 48.7655 707.834 49.6669 707.695 50.5682C708.735 50.2215 709.567 49.9442 710.191 49.7362C710.815 49.4589 711.37 49.2509 711.855 49.1122C712.341 48.9042 712.826 48.7655 713.311 48.6962C713.797 48.5575 714.386 48.4189 715.079 48.2802C715.911 48.2109 716.501 48.3495 716.847 48.6962C717.263 49.0429 717.471 49.4589 717.471 49.9442C717.541 50.4295 717.402 50.9149 717.055 51.4002C716.778 51.8855 716.293 52.1975 715.599 52.3362C712.965 52.8909 709.949 53.7575 706.551 54.9362C703.223 56.1149 699.826 57.7442 696.359 59.8242C695.527 60.3095 694.695 60.7602 693.863 61.1762C693.031 61.5229 692.165 61.8695 691.263 62.2162C689.045 63.1175 687.658 62.9789 687.103 61.8002C686.341 60.5522 687.138 59.3042 689.495 58.0562C690.674 57.3629 691.922 56.7389 693.239 56.1842C694.557 55.5602 695.805 54.9015 696.983 54.2082C698.162 53.5149 699.202 52.7175 700.103 51.8162C701.005 50.9149 701.629 50.0482 701.975 49.2162C702.391 48.3842 702.495 47.6909 702.287 47.1362C702.149 46.5815 701.594 46.3042 700.623 46.3042C698.682 46.3042 696.81 46.8935 695.007 48.0722C693.274 49.2509 691.714 50.7069 690.327 52.4402C688.941 54.1735 687.797 56.0455 686.895 58.0562C685.994 60.0669 685.405 61.8695 685.127 63.4642C684.989 64.0882 684.711 64.6429 684.295 65.1282C683.879 65.5442 683.359 65.8562 682.735 66.0642C682.181 66.2722 681.591 66.3415 680.967 66.2722C680.343 66.1335 679.789 65.8215 679.303 65.3362C678.749 64.7815 678.229 64.1922 677.743 63.5682C677.327 62.8749 677.085 62.1815 677.015 61.4882C676.807 59.9629 676.669 58.4722 676.599 57.0162C676.461 55.4909 676.461 53.9655 676.599 52.4402C676.946 47.1709 677.501 41.9362 678.263 36.7362C679.026 31.5362 680.101 26.3362 681.487 21.1362C681.765 20.0962 682.042 19.1255 682.319 18.2242C682.666 17.2535 683.013 16.2829 683.359 15.3122C683.498 14.7575 683.671 14.2722 683.879 13.8562C684.157 13.3709 684.434 12.9202 684.711 12.5042C685.959 10.8402 687.311 10.3202 688.767 10.9442C690.085 11.5682 690.605 12.8162 690.327 14.6882C689.773 18.2935 689.149 21.8989 688.455 25.5042C687.831 29.0402 687.242 32.6802 686.687 36.4242C686.341 38.7122 686.063 41.0349 685.855 43.3922C685.647 45.6802 685.405 47.9682 685.127 50.2562C685.058 50.5335 685.023 50.8455 685.023 51.1922C685.093 51.4695 685.162 51.8855 685.231 52.4402Z"}})])
}
var home_hero_at_svgvue_type_template_id_e66d1830_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-at-svg.vue?vue&type=template&id=e66d1830

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/home-hero-at-svg.vue?vue&type=script&lang=js

/* harmony default export */ var home_hero_at_svgvue_type_script_lang_js = ({
  props: {
    color: {
      type: String,
      default: '#323231',
    },
  },

  data: () => ({
    svgColor: '',
  }),

  mounted() {
    this.svgColor = this.color ? this.color : '#323231'
  },

  watch: {
    color() {
      this.svgColor = this.color
    },
  },
});

// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-at-svg.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_home_hero_at_svgvue_type_script_lang_js = (home_hero_at_svgvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/svg/ui/home-hero-at-svg.vue?vue&type=style&index=0&id=e66d1830&prod&lang=css
var home_hero_at_svgvue_type_style_index_0_id_e66d1830_prod_lang_css = __webpack_require__("a8c8");

// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-at-svg.vue






/* normalize component */

var home_hero_at_svg_component = normalizeComponent(
  ui_home_hero_at_svgvue_type_script_lang_js,
  home_hero_at_svgvue_type_template_id_e66d1830_render,
  home_hero_at_svgvue_type_template_id_e66d1830_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var home_hero_at_svg = (home_hero_at_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/home-hero-nl-svg.vue?vue&type=template&id=5d65cdc6
var home_hero_nl_svgvue_type_template_id_5d65cdc6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"768","height":"98","viewBox":"0 0 768 98","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{class:`${
      _vm.svgColor === '#ffffff' || _vm.svgColor === '#FFFFFF' ? 'white' : 'black'
    }`,attrs:{"d":"M14.2 61.3c.333-.733.6-1.367.8-1.9l.8-1.6c3.6-8.933 7.867-17.3 12.8-25.1 5-7.867 10.6-15.367 16.8-22.5a46 46 0 0 1 4.1-4 214.84 214.84 0 0 1 4.4-3.7l.8-.8a2.66 2.66 0 0 1 .9-.6c.933-.4 1.767-.5 2.5-.3.733.2 1.3.667 1.7 1.4.533.8.667 1.533.4 2.2A5.329 5.329 0 0 1 59 6.2l-.4.4-.4.4C51.6 12.6 45.867 18.833 41 25.7c-4.8 6.867-9.3 14.067-13.5 21.6a61.573 61.573 0 0 0-4.6 10.3 143.194 143.194 0 0 0-3 10.8 19.35 19.35 0 0 1-.5 2.1 12.3 12.3 0 0 1-.6 1.9c-.333 1.133-.867 2.033-1.6 2.7-.667.667-1.6 1.067-2.8 1.2-1.133.133-2.133-.067-3-.6-.867-.533-1.567-1.267-2.1-2.2a33.66 33.66 0 0 1-1.1-2.2 30.535 30.535 0 0 0-.9-2.2 95.736 95.736 0 0 1-4-14.5 124.628 124.628 0 0 1-1.9-15 96.73 96.73 0 0 1 0-13.9c.333-4.6.9-9.2 1.7-13.8a21.664 21.664 0 0 1 1.5-5.4c.4-1 .967-1.7 1.7-2.1.8-.4 1.6-.5 2.4-.3 1.733.4 2.5 1.767 2.3 4.1a159.42 159.42 0 0 1-.6 8.1c-.267 2.6-.433 5.3-.5 8.1a128.07 128.07 0 0 0 .3 16.8A120.205 120.205 0 0 0 13 57.7c.133.467.3.967.5 1.5s.433 1.233.7 2.1Zm30.756-5c.333.267.9.033 1.7-.7.866-.8 1.8-1.8 2.8-3 1-1.2 2.033-2.433 3.1-3.7 1.133-1.333 2.1-2.367 2.9-3.1.4-.333.8-.5 1.2-.5.466 0 .866.133 1.2.4.333.2.533.5.6.9.133.4.066.867-.2 1.4-.334.6-.734 1.2-1.2 1.8a119.154 119.154 0 0 0-3.9 4.3 76.223 76.223 0 0 1-3.8 4.3c-.734.733-1.634 1.367-2.7 1.9-1.934 1-3.7 1.133-5.3.4-1.534-.733-2.467-2.167-2.8-4.3-.334-2.133-.267-4.433.2-6.9.466-2.467 1.133-4.667 2-6.6.333-.867.833-1.467 1.5-1.8.666-.333 1.366-.367 2.1-.1 1.533.533 2.2 1.667 2 3.4-.067 1.067-.234 2.333-.5 3.8-.2 1.467-.367 2.733-.5 3.8-.134.533-.2 1.167-.2 1.9 0 .667-.067 1.467-.2 2.4Zm.3-22.9c.333 0 .666.167 1 .5.4.267.733.6 1 1 .333.333.566.7.7 1.1.2.4.266.733.2 1-.134.333-.4.667-.8 1-.4.333-.767.533-1.1.6-.4 0-.8-.1-1.2-.3a4.22 4.22 0 0 1-1.1-.8c-.267-.4-.5-.8-.7-1.2-.2-.4-.3-.767-.3-1.1a2.4 2.4 0 0 1 .8-1.3c.4-.4.9-.567 1.5-.5Zm25.043 8.1c1.334-1 2.7-1.3 4.1-.9 1.4.4 2.267 1.467 2.6 3.2.134.933.2 2.1.2 3.5v4.2c.067 1.333.167 2.5.3 3.5.2 1 .534 1.533 1 1.6.334 0 .8-.3 1.4-.9.8-.8 1.634-1.767 2.5-2.9a92.51 92.51 0 0 0 2.6-3.3c.8-1.133 1.5-2.1 2.1-2.9.6-.867 1-1.4 1.2-1.6.267-.267.567-.367.9-.3.334.067.6.233.8.5.267.267.467.6.6 1 .134.4.167.733.1 1-.133.8-.633 1.867-1.5 3.2a48.888 48.888 0 0 1-3 4.1 37.83 37.83 0 0 1-3.6 3.7c-1.2 1.067-2.233 1.767-3.1 2.1-1.266.467-2.5.467-3.7 0-1.133-.467-1.966-1.533-2.5-3.2a18.073 18.073 0 0 1-.7-3.4 55.998 55.998 0 0 0-.3-3.6c-.066-.6-.1-1.2-.1-1.8 0-.667-.033-1.433-.1-2.3-1.133 1-2.066 2.067-2.8 3.2a55.485 55.485 0 0 0-2.1 3.3l-2 3.4a18.23 18.23 0 0 1-2.4 3.2c-1.133.933-2.4 1.4-3.8 1.4-1.4-.067-2.5-.733-3.3-2-.533-.8-.833-1.733-.9-2.8-.066-1.067-.133-2.1-.2-3.1 0-2.467.167-4.933.5-7.4.267-2.533.8-5 1.6-7.4.2-.6.4-1.1.6-1.5.867-2.067 2.067-2.767 3.6-2.1.667.133 1.2.567 1.6 1.3.467.667.534 1.533.2 2.6-.466 1.533-.9 3.1-1.3 4.7a41.424 41.424 0 0 0-.9 8.2c.067 1 .267 1.733.6 2.2.4.333.934 0 1.6-1 .734-1 1.5-2.2 2.3-3.6l2.6-4.2c.934-1.4 1.834-2.367 2.7-2.9Zm30.22-3.9c.2-.533.433-1.133.7-1.8l.8-2.2c1-2.8 1.966-5.633 2.9-8.5 1-2.867 1.966-5.7 2.9-8.5.133-.2.266-.433.4-.7l.4-.8c.733-1.333 1.833-1.833 3.3-1.5 1.333.333 2.066 1.167 2.2 2.5.133.667.166 1.333.1 2 0 .667-.067 1.367-.2 2.1-.734 4.533-1.434 9.033-2.1 13.5-.667 4.4-1.367 8.9-2.1 13.5a67.25 67.25 0 0 0-.8 5.3c-.2 1.733-.434 3.5-.7 5.3-.067.333-.134.633-.2.9 0 .267-.067.567-.2.9-.534 1.867-1.667 2.733-3.4 2.6-.8-.067-1.467-.333-2-.8-.534-.467-.834-1.167-.9-2.1-.134-1-.2-2.033-.2-3.1l.2-3.2c.066-.733.1-1.467.1-2.2a9.05 9.05 0 0 0-.1-2.3 6.697 6.697 0 0 0-1.1 1.4 74.864 74.864 0 0 0-2.7 3.7 69.698 69.698 0 0 1-2.7 3.5c-.4.533-.9 1-1.5 1.4-.6.4-1.2.767-1.8 1.1-1.467.733-2.834.8-4.1.2-1.2-.667-2.034-1.8-2.5-3.4a6.202 6.202 0 0 1-.2-1.5c.133-3.267.866-6.2 2.2-8.8 1.333-2.667 3.466-4.867 6.4-6.6a9.534 9.534 0 0 1 3.1-1.1c1.2-.2 2.466-.467 3.8-.8Zm-10 17.2c.933-.667 1.833-1.5 2.7-2.5a24.9 24.9 0 0 0 2.3-3.1 20.97 20.97 0 0 0 1.8-3.4c.466-1.133.733-2.167.8-3.1-1.067.133-2.1.567-3.1 1.3-1 .733-1.867 1.667-2.6 2.8-.667 1.133-1.2 2.4-1.6 3.8a12.78 12.78 0 0 0-.3 4.2Zm40.741 30c.133-.533.333-1 .6-1.4.2-.4.4-.833.6-1.3 1.733-4.8 3.167-9.633 4.3-14.5 1.067-4.933 1.9-10 2.5-15.2.133-1.2.233-2.4.3-3.6.067-1.267.167-2.467.3-3.6.067-.467.133-.9.2-1.3s.167-.767.3-1.1c.467-1.267 1.4-1.867 2.8-1.8 1.267.067 2.067.833 2.4 2.3 0 .533.033.933.1 1.2.533 14.733-1.967 28.967-7.5 42.7-.4 1-.867 1.967-1.4 2.9-.6 1-1.2 1.967-1.8 2.9-.6 1-1.433 1.933-2.5 2.8-1.4 1-2.8 1.267-4.2.8-1.467-.4-2.467-1.433-3-3.1-.533-1.4-.733-2.9-.6-4.5a79.1 79.1 0 0 1 1.3-9 51.976 51.976 0 0 1 2.6-8.7c.2-.533.433-1.033.7-1.5.2-.467.467-.933.8-1.4 1.067-1.6 2.233-1.967 3.5-1.1.733.467 1.1 1 1.1 1.6-.067.533-.233 1.133-.5 1.8-.6 2-1.133 4-1.6 6a373.861 373.861 0 0 1-1.6 6 1.729 1.729 0 0 0-.1 1c.067.333.1.667.1 1 .133 0 .233.033.3.1Zm14.2-49.2c0 .6-.267 1.167-.8 1.7-.467.467-1.067.7-1.8.7a2.716 2.716 0 0 1-1.7-.8c-.467-.467-.667-1.067-.6-1.8 0-.8.233-1.467.7-2 .533-.533 1.167-.767 1.9-.7.6 0 1.133.3 1.6.9.467.533.7 1.2.7 2Zm8.666 15.1c-.2 1.333-.134 2.3.2 2.9.4.6.933.967 1.6 1.1.733.133 1.533.133 2.4 0 .933-.2 1.833-.467 2.7-.8 2.666-.867 4.9-1.967 6.7-3.3 1.8-1.333 3.7-2.867 5.7-4.6.866-.8 1.6-1.233 2.2-1.3.6-.067 1.033.067 1.3.4.333.333.466.867.4 1.6-.067.667-.367 1.333-.9 2-.934 1.2-2.234 2.467-3.9 3.8a39.327 39.327 0 0 1-5.3 3.7 33.152 33.152 0 0 1-5.8 2.8c-1.934.667-3.7.967-5.3.9-3.134-.333-5.4-1.533-6.8-3.6-1.467-2.067-1.767-4.6-.9-7.6a15.55 15.55 0 0 1 3.3-6c.666-.8 1.6-1.667 2.8-2.6 1.2-1 2.433-1.8 3.7-2.4 1.333-.667 2.633-1 3.9-1 1.333-.067 2.466.4 3.4 1.4 1.133 1.133 1.433 2.533.9 4.2-.534 1.667-1.5 3.233-2.9 4.7a14.63 14.63 0 0 1-4.7 3.3c-1.734.8-3.3.933-4.7.4Zm7.9-9.3c-2.934 1.267-4.834 3.033-5.7 5.3a9.038 9.038 0 0 0 3.2-1.6c1-.733 1.833-1.967 2.5-3.7Zm46.793 9.4c1-1.867 1.866-3.5 2.6-4.9.733-1.4 1.466-2.7 2.2-3.9a40.526 40.526 0 0 1 2.4-3.5c.933-1.133 2.1-2.4 3.5-3.8.6-.6 1.2-.9 1.8-.9.666 0 1.2.2 1.6.6.4.4.633.9.7 1.5.066.6-.167 1.2-.7 1.8a68.988 68.988 0 0 0-3.3 3.9 43.622 43.622 0 0 0-2.4 3.7 110.39 110.39 0 0 0-2 4c-.6 1.333-1.3 2.867-2.1 4.6a25.5 25.5 0 0 0-1.3 2.3c-.4.8-.867 1.533-1.4 2.2-.934 1.333-2.1 2-3.5 2-1.334-.067-2.467-.8-3.4-2.2-1.667-2.333-2.734-4.833-3.2-7.5-.4-2.667-.534-5.4-.4-8.2.066-.6.3-1.1.7-1.5.466-.467 1-.7 1.6-.7.666 0 1.166.233 1.5.7.4.4.666.9.8 1.5.4 3.2.9 6.3 1.5 9.3.533 2.467 1.466 2.133 2.8-1Zm31.498-4.3c1.267.2 2.4.2 3.4 0 1.067-.2 2.134-.467 3.2-.8l1-.4c.334-.133.634-.167.9-.1.867.2 1.467.733 1.8 1.6.134.2.134.533 0 1-.066.467-.233.8-.5 1-.933.8-1.866 1.333-2.8 1.6-1 .267-2 .5-3 .7-1 .2-2.033.333-3.1.4-.733 0-1.366.167-1.9.5-.466.267-.933.8-1.4 1.6-1 1.733-2.233 3.133-3.7 4.2a11.82 11.82 0 0 1-4.7 2c-1.6.4-3.066.4-4.4 0a7.58 7.58 0 0 1-3.3-2.1c-.866-1-1.466-2.233-1.8-3.7-.333-1.533-.333-3.167 0-4.9.534-2.4 1.334-4.5 2.4-6.3 1.067-1.8 2.667-3.2 4.8-4.2.4-.2.767-.467 1.1-.8l1-1c1.134-1.333 2.4-2.067 3.8-2.2s2.734.467 4 1.8c1.8 1.867 2.8 4.333 3 7.4V45c.067.467.134.967.2 1.5Zm-12-1.3c-.733.933-1.266 1.9-1.6 2.9a20.068 20.068 0 0 0-.6 3c-.2 2.133.6 3.1 2.4 2.9 1.134-.133 2.1-.433 2.9-.9.867-.533 1.6-1.367 2.2-2.5a19.927 19.927 0 0 1-3.1-1.8c-.933-.667-1.666-1.867-2.2-3.6Zm5-4.9c-.266 1.533-.3 2.533-.1 3 .267.467.967.867 2.1 1.2a25.03 25.03 0 0 0-.2-1.6 3.511 3.511 0 0 0-.3-1 1.978 1.978 0 0 0-.6-.7c-.2-.267-.5-.567-.9-.9Zm28.649 4.8c.666-.733 1.333-.833 2-.3.666.467.733 1.333.2 2.6-.2.533-.7 1.367-1.5 2.5a125.342 125.342 0 0 1-2.5 3.7c-.867 1.267-1.7 2.467-2.5 3.6s-1.4 1.933-1.8 2.4c-.6.667-1.267 1.2-2 1.6-.667.4-1.467.5-2.4.3-1.467-.267-2.5-1.133-3.1-2.6-.534-1.467-.834-3.1-.9-4.9-.134-1.8-.1-3.567.1-5.3.2-1.733.333-3.067.4-4 .2-2.2.5-4.8.9-7.8.4-3.067.9-6.1 1.5-9.1.6-3.067 1.233-5.967 1.9-8.7.666-2.733 1.366-4.9 2.1-6.5.333-.867.8-1.433 1.4-1.7a3.27 3.27 0 0 1 2.1-.3c1.466.4 2.1 1.5 1.9 3.3a1012.53 1012.53 0 0 0-3 16.9 228.654 228.654 0 0 0-2 16.4c-.067 1-.1 1.967-.1 2.9 0 .933.066 1.667.2 2.2.2.533.466.767.8.7.4-.067.933-.6 1.6-1.6.6-.933 1.233-1.8 1.9-2.6.666-.867 1.1-1.467 1.3-1.8.2-.333.4-.633.6-.9.266-.333.566-.667.9-1Zm13.076 9.4a48.294 48.294 0 0 1-4.7 3.2c-1.6 1-3.133 1.667-4.6 2-1.4.267-2.666.1-3.8-.5-1.066-.6-1.8-1.9-2.2-3.9-.266-1.733-.166-3.6.3-5.6.4-2 1.034-3.933 1.9-5.8a24.322 24.322 0 0 1 3.4-5.1c1.334-1.6 2.8-2.8 4.4-3.6 1.6-.8 3.334-1.2 5.2-1.2 1.4.067 2.6.6 3.6 1.6 1 .933 1.467 2.067 1.4 3.4-.133 1.067-.566 1.9-1.3 2.5-.466.333-.933.4-1.4.2-.466-.2-.866-.567-1.2-1.1a3.338 3.338 0 0 1-.4-.5c-.133-.267-.266-.467-.4-.6-1.266.2-2.6 1.033-4 2.5-1.333 1.4-2.5 3-3.5 4.8-1 1.733-1.666 3.467-2 5.2-.333 1.667-.1 2.867.7 3.6.867-.2 1.767-.567 2.7-1.1.934-.6 1.8-1.267 2.6-2 .8-.733 1.534-1.533 2.2-2.4.667-.867 1.234-1.7 1.7-2.5.267-.4.567-.767.9-1.1.334-.4.734-.7 1.2-.9 1.267-.667 2.4-.633 3.4.1 1.067.667 1.634 1.733 1.7 3.2 0 1.333-.033 2.7-.1 4.1a79.107 79.107 0 0 1-.3 4 83.408 83.408 0 0 1-2.8 14.3c-1.333 4.6-2.866 9.2-4.6 13.8-.266.6-.566 1.2-.9 1.8a5.308 5.308 0 0 1-1.2 1.8c-.933.933-2 1.6-3.2 2-1.533.467-2.8.1-3.8-1.1-.533-.667-.766-1.3-.7-1.9.134-.6.334-1.267.6-2 .867-2.133 1.734-4.533 2.6-7.2.934-2.6 1.8-5.267 2.6-8 .8-2.8 1.534-5.567 2.2-8.3.734-2.733 1.334-5.3 1.8-7.7Zm16.193-3.8c-.2 1.333-.133 2.3.2 2.9.4.6.933.967 1.6 1.1.733.133 1.533.133 2.4 0 .933-.2 1.833-.467 2.7-.8 2.667-.867 4.9-1.967 6.7-3.3 1.8-1.333 3.7-2.867 5.7-4.6.867-.8 1.6-1.233 2.2-1.3.6-.067 1.033.067 1.3.4.333.333.467.867.4 1.6-.067.667-.367 1.333-.9 2-.933 1.2-2.233 2.467-3.9 3.8a39.327 39.327 0 0 1-5.3 3.7 33.152 33.152 0 0 1-5.8 2.8c-1.933.667-3.7.967-5.3.9-3.133-.333-5.4-1.533-6.8-3.6-1.467-2.067-1.767-4.6-.9-7.6a15.576 15.576 0 0 1 3.3-6c.667-.8 1.6-1.667 2.8-2.6 1.2-1 2.433-1.8 3.7-2.4 1.333-.667 2.633-1 3.9-1 1.333-.067 2.467.4 3.4 1.4 1.133 1.133 1.433 2.533.9 4.2-.533 1.667-1.5 3.233-2.9 4.7-1.333 1.4-2.9 2.5-4.7 3.3-1.733.8-3.3.933-4.7.4Zm7.9-9.3c-2.933 1.267-4.833 3.033-5.7 5.3a9.03 9.03 0 0 0 3.2-1.6c1-.733 1.833-1.967 2.5-3.7Zm26.828.1c1.334-1 2.7-1.3 4.1-.9 1.4.4 2.267 1.467 2.6 3.2.134.933.2 2.1.2 3.5v4.2c.067 1.333.167 2.5.3 3.5.2 1 .534 1.533 1 1.6.334 0 .8-.3 1.4-.9.8-.8 1.634-1.767 2.5-2.9a91.83 91.83 0 0 0 2.6-3.3c.8-1.133 1.5-2.1 2.1-2.9.6-.867 1-1.4 1.2-1.6.267-.267.567-.367.9-.3.334.067.6.233.8.5.267.267.467.6.6 1 .134.4.167.733.1 1-.133.8-.633 1.867-1.5 3.2a48.62 48.62 0 0 1-3 4.1 37.761 37.761 0 0 1-3.6 3.7c-1.2 1.067-2.233 1.767-3.1 2.1-1.266.467-2.5.467-3.7 0-1.133-.467-1.966-1.533-2.5-3.2a18.145 18.145 0 0 1-.7-3.4 55.149 55.149 0 0 0-.3-3.6c-.066-.6-.1-1.2-.1-1.8 0-.667-.033-1.433-.1-2.3-1.133 1-2.066 2.067-2.8 3.2a55.792 55.792 0 0 0-2.1 3.3l-2 3.4a18.17 18.17 0 0 1-2.4 3.2c-1.133.933-2.4 1.4-3.8 1.4-1.4-.067-2.5-.733-3.3-2-.533-.8-.833-1.733-.9-2.8-.066-1.067-.133-2.1-.2-3.1 0-2.467.167-4.933.5-7.4.267-2.533.8-5 1.6-7.4.2-.6.4-1.1.6-1.5.867-2.067 2.067-2.767 3.6-2.1.667.133 1.2.567 1.6 1.3.467.667.534 1.533.2 2.6-.466 1.533-.9 3.1-1.3 4.7-.333 1.6-.566 3.1-.7 4.5-.133 1.4-.2 2.633-.2 3.7.067 1 .267 1.733.6 2.2.4.333.934 0 1.6-1 .734-1 1.5-2.2 2.3-3.6l2.6-4.2c.934-1.4 1.834-2.367 2.7-2.9Zm30.22-3.9c.2-.533.433-1.133.7-1.8l.8-2.2c1-2.8 1.966-5.633 2.9-8.5 1-2.867 1.966-5.7 2.9-8.5.133-.2.266-.433.4-.7l.4-.8c.733-1.333 1.833-1.833 3.3-1.5 1.333.333 2.066 1.167 2.2 2.5.133.667.166 1.333.1 2 0 .667-.067 1.367-.2 2.1-.734 4.533-1.434 9.033-2.1 13.5-.667 4.4-1.367 8.9-2.1 13.5a67.25 67.25 0 0 0-.8 5.3c-.2 1.733-.434 3.5-.7 5.3-.067.333-.134.633-.2.9 0 .267-.067.567-.2.9-.534 1.867-1.667 2.733-3.4 2.6-.8-.067-1.467-.333-2-.8-.534-.467-.834-1.167-.9-2.1-.134-1-.2-2.033-.2-3.1l.2-3.2c.066-.733.1-1.467.1-2.2a9.05 9.05 0 0 0-.1-2.3 6.697 6.697 0 0 0-1.1 1.4 74.22 74.22 0 0 0-2.7 3.7 70.054 70.054 0 0 1-2.7 3.5c-.4.533-.9 1-1.5 1.4-.6.4-1.2.767-1.8 1.1-1.467.733-2.834.8-4.1.2-1.2-.667-2.034-1.8-2.5-3.4a6.168 6.168 0 0 1-.2-1.5c.133-3.267.866-6.2 2.2-8.8 1.333-2.667 3.466-4.867 6.4-6.6a9.527 9.527 0 0 1 3.1-1.1c1.2-.2 2.466-.467 3.8-.8Zm-10 17.2c.933-.667 1.833-1.5 2.7-2.5a24.9 24.9 0 0 0 2.3-3.1 21.017 21.017 0 0 0 1.8-3.4c.466-1.133.733-2.167.8-3.1-1.067.133-2.1.567-3.1 1.3-1 .733-1.867 1.667-2.6 2.8-.667 1.133-1.2 2.4-1.6 3.8-.334 1.4-.434 2.8-.3 4.2Zm27.376-4.1c-.2 1.333-.133 2.3.2 2.9.4.6.934.967 1.6 1.1.734.133 1.534.133 2.4 0 .934-.2 1.834-.467 2.7-.8 2.667-.867 4.9-1.967 6.7-3.3 1.8-1.333 3.7-2.867 5.7-4.6.867-.8 1.6-1.233 2.2-1.3.6-.067 1.034.067 1.3.4.334.333.467.867.4 1.6-.066.667-.366 1.333-.9 2-.933 1.2-2.233 2.467-3.9 3.8a39.263 39.263 0 0 1-5.3 3.7 33.118 33.118 0 0 1-5.8 2.8c-1.933.667-3.7.967-5.3.9-3.133-.333-5.4-1.533-6.8-3.6-1.466-2.067-1.766-4.6-.9-7.6a15.576 15.576 0 0 1 3.3-6c.667-.8 1.6-1.667 2.8-2.6 1.2-1 2.434-1.8 3.7-2.4 1.334-.667 2.634-1 3.9-1 1.334-.067 2.467.4 3.4 1.4 1.134 1.133 1.434 2.533.9 4.2-.533 1.667-1.5 3.233-2.9 4.7-1.333 1.4-2.9 2.5-4.7 3.3-1.733.8-3.3.933-4.7.4Zm7.9-9.3c-2.933 1.267-4.833 3.033-5.7 5.3a9.03 9.03 0 0 0 3.2-1.6c1-.733 1.834-1.967 2.5-3.7Zm50.993-3.8c.2-.533.434-1.133.7-1.8l.8-2.2c1-2.8 1.967-5.633 2.9-8.5 1-2.867 1.967-5.7 2.9-8.5.134-.2.267-.433.4-.7l.4-.8c.734-1.333 1.834-1.833 3.3-1.5 1.334.333 2.067 1.167 2.2 2.5.134.667.167 1.333.1 2 0 .667-.066 1.367-.2 2.1a1131.7 1131.7 0 0 0-2.1 13.5c-.666 4.4-1.366 8.9-2.1 13.5a67.72 67.72 0 0 0-.8 5.3c-.2 1.733-.433 3.5-.7 5.3-.066.333-.133.633-.2.9 0 .267-.066.567-.2.9-.533 1.867-1.666 2.733-3.4 2.6-.8-.067-1.466-.333-2-.8-.533-.467-.833-1.167-.9-2.1-.133-1-.2-2.033-.2-3.1l.2-3.2c.067-.733.1-1.467.1-2.2.067-.733.034-1.5-.1-2.3a6.764 6.764 0 0 0-1.1 1.4 75.513 75.513 0 0 0-2.7 3.7 68.882 68.882 0 0 1-2.7 3.5c-.4.533-.9 1-1.5 1.4-.6.4-1.2.767-1.8 1.1-1.466.733-2.833.8-4.1.2-1.2-.667-2.033-1.8-2.5-3.4a6.217 6.217 0 0 1-.2-1.5c.134-3.267.867-6.2 2.2-8.8 1.334-2.667 3.467-4.867 6.4-6.6a9.543 9.543 0 0 1 3.1-1.1c1.2-.2 2.467-.467 3.8-.8Zm-10 17.2c.934-.667 1.834-1.5 2.7-2.5.867-1 1.634-2.033 2.3-3.1a20.86 20.86 0 0 0 1.8-3.4c.467-1.133.734-2.167.8-3.1-1.066.133-2.1.567-3.1 1.3-1 .733-1.866 1.667-2.6 2.8-.666 1.133-1.2 2.4-1.6 3.8-.333 1.4-.433 2.8-.3 4.2Zm30.777-12.1 1.6-1.6c.4-.4.8-.767 1.2-1.1.8-.667 1.567-1.333 2.3-2 .8-.667 1.633-1.233 2.5-1.7 2.267-1.133 4.2-.9 5.8.7 1.267 1.467 1.5 3.4.7 5.8-.333 1.133-1.133 1.667-2.4 1.6-.933-.133-1.333-.733-1.2-1.8.133-.667.167-1.2.1-1.6-.2-1.333-1-1.6-2.4-.8-.4.267-.833.6-1.3 1-.467.333-.867.7-1.2 1.1a34.573 34.573 0 0 0-5.3 7.1c-1.467 2.533-2.2 5.2-2.2 8 0 1-.3 1.9-.9 2.7-.533.8-1.267 1.3-2.2 1.5-.867.2-1.633.067-2.3-.4-.6-.467-.967-1.2-1.1-2.2-.133-.867-.167-2.267-.1-4.2 0-2 .133-4.1.4-6.3.2-2.267.567-4.5 1.1-6.7.533-2.267 1.2-4.167 2-5.7.4-.733.933-1.267 1.6-1.6.667-.333 1.333-.467 2-.4 1.533.2 2.2 1.167 2 2.9a42.231 42.231 0 0 1-.3 2.7 86.292 86.292 0 0 0-.4 3Zm36.307 3.8c1.267.2 2.4.2 3.4 0a28.13 28.13 0 0 0 3.2-.8l1-.4c.333-.133.633-.167.9-.1.867.2 1.467.733 1.8 1.6.133.2.133.533 0 1-.067.467-.233.8-.5 1-.933.8-1.867 1.333-2.8 1.6-1 .267-2 .5-3 .7-1 .2-2.033.333-3.1.4-.733 0-1.367.167-1.9.5-.467.267-.933.8-1.4 1.6-1 1.733-2.233 3.133-3.7 4.2a11.83 11.83 0 0 1-4.7 2c-1.6.4-3.067.4-4.4 0a7.568 7.568 0 0 1-3.3-2.1c-.867-1-1.467-2.233-1.8-3.7-.333-1.533-.333-3.167 0-4.9.533-2.4 1.333-4.5 2.4-6.3 1.067-1.8 2.667-3.2 4.8-4.2.4-.2.767-.467 1.1-.8l1-1c1.133-1.333 2.4-2.067 3.8-2.2s2.733.467 4 1.8c1.8 1.867 2.8 4.333 3 7.4V45c.067.467.133.967.2 1.5Zm-12-1.3c-.733.933-1.267 1.9-1.6 2.9a19.819 19.819 0 0 0-.6 3c-.2 2.133.6 3.1 2.4 2.9 1.133-.133 2.1-.433 2.9-.9.867-.533 1.6-1.367 2.2-2.5a19.88 19.88 0 0 1-3.1-1.8c-.933-.667-1.667-1.867-2.2-3.6Zm5-4.9c-.267 1.533-.3 2.533-.1 3 .267.467.967.867 2.1 1.2-.067-.667-.133-1.2-.2-1.6a3.576 3.576 0 0 0-.3-1 1.978 1.978 0 0 0-.6-.7c-.2-.267-.5-.567-.9-.9Zm34.148 6.2c1.267.2 2.4.2 3.4 0 1.067-.2 2.134-.467 3.2-.8l1-.4c.334-.133.634-.167.9-.1.867.2 1.467.733 1.8 1.6.134.2.134.533 0 1-.066.467-.233.8-.5 1-.933.8-1.866 1.333-2.8 1.6-1 .267-2 .5-3 .7-1 .2-2.033.333-3.1.4-.733 0-1.366.167-1.9.5-.466.267-.933.8-1.4 1.6-1 1.733-2.233 3.133-3.7 4.2a11.82 11.82 0 0 1-4.7 2c-1.6.4-3.066.4-4.4 0a7.58 7.58 0 0 1-3.3-2.1c-.866-1-1.466-2.233-1.8-3.7-.333-1.533-.333-3.167 0-4.9.534-2.4 1.334-4.5 2.4-6.3 1.067-1.8 2.667-3.2 4.8-4.2.4-.2.767-.467 1.1-.8l1-1c1.134-1.333 2.4-2.067 3.8-2.2s2.734.467 4 1.8c1.8 1.867 2.8 4.333 3 7.4V45c.067.467.134.967.2 1.5Zm-12-1.3c-.733.933-1.266 1.9-1.6 2.9a20.068 20.068 0 0 0-.6 3c-.2 2.133.6 3.1 2.4 2.9 1.134-.133 2.1-.433 2.9-.9.867-.533 1.6-1.367 2.2-2.5a19.927 19.927 0 0 1-3.1-1.8c-.933-.667-1.666-1.867-2.2-3.6Zm5-4.9c-.266 1.533-.3 2.533-.1 3 .267.467.967.867 2.1 1.2a25.03 25.03 0 0 0-.2-1.6 3.511 3.511 0 0 0-.3-1 1.978 1.978 0 0 0-.6-.7c-.2-.267-.5-.567-.9-.9Zm39.149 10c1-1.8 2.133-3.467 3.4-5a23.72 23.72 0 0 1 4.2-4c1.733-1.267 3.233-1.567 4.5-.9 1.333.6 2.1 2 2.3 4.2.2 1.8.333 3.567.4 5.3a27.5 27.5 0 0 0 .7 5.1 21.36 21.36 0 0 0 5.9-4.5c1.8-1.933 3.366-3.567 4.7-4.9.466-.467.9-.667 1.3-.6.466 0 .833.167 1.1.5.266.267.4.667.4 1.2.066.467-.067.967-.4 1.5-.734.8-1.534 1.7-2.4 2.7-.867 1-1.767 1.967-2.7 2.9-.934.933-1.9 1.8-2.9 2.6s-2 1.433-3 1.9c-1.734.733-3.134.8-4.2.2-1-.667-1.767-1.933-2.3-3.8a8.808 8.808 0 0 1-.5-2.3c0-.8-.034-1.6-.1-2.4-.067-.8-.1-1.633-.1-2.5.066-.867.1-1.833.1-2.9-1.067.4-2 .967-2.8 1.7-.8.733-1.5 1.533-2.1 2.4-.6.867-1.167 1.767-1.7 2.7-.534.933-1.1 1.8-1.7 2.6a9.31 9.31 0 0 1-1.4 1.8c-.534.467-1.267.633-2.2.5-.934-.133-1.567-.5-1.9-1.1a68.282 68.282 0 0 1-.8-2.1c-.2-.933-.434-1.8-.7-2.6-.2-.867-.367-1.733-.5-2.6a40.57 40.57 0 0 0-2.4 3.4l-1.8 3c-.467.733-.9 1.433-1.3 2.1s-.767 1.367-1.1 2.1c-.534 1.333-1.3 2.3-2.3 2.9-1 .533-2.134.733-3.4.6-1.334-.067-2.367-.533-3.1-1.4-.667-.867-1.2-1.867-1.6-3-.467-1.467-.767-3.2-.9-5.2-.067-2 0-4 .2-6 .266-2.067.666-4 1.2-5.8.533-1.867 1.2-3.367 2-4.5.466-.533 1-.833 1.6-.9.6-.067 1.166 0 1.7.2 1.2.467 1.766 1.3 1.7 2.5a43.566 43.566 0 0 1-.7 4.9c-.267 1.6-.5 3.233-.7 4.9a36.952 36.952 0 0 0-.1 4.7c.066 1.533.366 2.967.9 4.3 1.4-2.333 2.833-4.633 4.3-6.9 1.466-2.333 3.1-4.4 4.9-6.2 1.133-1.067 2.166-1.433 3.1-1.1.933.333 1.566 1.233 1.9 2.7.133.733.3 1.6.5 2.6.2.933.466 1.767.8 2.5Zm34.79.5c1-1.867 1.867-3.5 2.6-4.9.734-1.4 1.467-2.7 2.2-3.9a40.982 40.982 0 0 1 2.4-3.5c.934-1.133 2.1-2.4 3.5-3.8.6-.6 1.2-.9 1.8-.9.667 0 1.2.2 1.6.6.4.4.634.9.7 1.5.067.6-.166 1.2-.7 1.8a69.837 69.837 0 0 0-3.3 3.9 44.12 44.12 0 0 0-2.4 3.7 113.5 113.5 0 0 0-2 4c-.6 1.333-1.3 2.867-2.1 4.6-.466.733-.9 1.5-1.3 2.3-.4.8-.866 1.533-1.4 2.2-.933 1.333-2.1 2-3.5 2-1.333-.067-2.466-.8-3.4-2.2-1.666-2.333-2.733-4.833-3.2-7.5-.4-2.667-.533-5.4-.4-8.2.067-.6.3-1.1.7-1.5.467-.467 1-.7 1.6-.7.667 0 1.167.233 1.5.7.4.4.667.9.8 1.5.4 3.2.9 6.3 1.5 9.3.534 2.467 1.467 2.133 2.8-1Zm22.699.1a101.8 101.8 0 0 1-1.9 2.4l-1.8 2c-.6.533-1.233 1.1-1.9 1.7-.6.6-1.233 1.067-1.9 1.4-1.2.733-2.3.9-3.3.5-1.067-.467-1.8-1.367-2.2-2.7-.333-.933-.433-1.833-.3-2.7.533-3 1.467-5.733 2.8-8.2 1.333-2.467 3.267-4.567 5.8-6.3 1.667-1.133 3.333-1.767 5-1.9 1.667-.133 3.367.333 5.1 1.4 1 .6 1.667 1.2 2 1.8.333.533.4 1.4.2 2.6a26.851 26.851 0 0 1-.6 3.2c-.2 1-.367 2.067-.5 3.2-.133 1-.267 2.033-.4 3.1-.133 1-.133 1.8 0 2.4.2.6.533.9 1 .9.533 0 1.367-.567 2.5-1.7.933-1.067 1.633-1.9 2.1-2.5.533-.6 1-1.133 1.4-1.6.467-.533.933-1.1 1.4-1.7.533-.6 1.267-1.4 2.2-2.4l.8-.8a3.977 3.977 0 0 1 1-.6c.333-.133.7-.1 1.1.1.467.133.8.333 1 .6.2.133.267.4.2.8 0 .333-.033.667-.1 1-.067.267-.3.6-.7 1-.8 1-1.433 1.8-1.9 2.4-.467.533-.9 1.033-1.3 1.5-.4.467-.867 1-1.4 1.6-.467.533-1.133 1.3-2 2.3-.6.733-1.233 1.4-1.9 2-.6.6-1.267 1.167-2 1.7-1.733 1.133-3.233 1.667-4.5 1.6-1.2-.067-2.2-.567-3-1.5-.733-.933-1.267-2.167-1.6-3.7-.333-1.533-.467-3.167-.4-4.9Zm-8.5 3c.667-.467 1.533-1.267 2.6-2.4 1.067-1.133 2.1-2.3 3.1-3.5 1.067-1.267 2-2.467 2.8-3.6.867-1.2 1.4-2.1 1.6-2.7-1.133-.133-2.267.1-3.4.7-1.133.533-2.167 1.367-3.1 2.5-.867 1.067-1.633 2.4-2.3 4-.667 1.533-1.1 3.2-1.3 5Zm33.244-4.9.8-1c.266-.4.533-.833.8-1.3 1.133-1.467 2.233-2.9 3.3-4.3l3.4-4.4c.333-.533.733-1 1.2-1.4a27.04 27.04 0 0 1 1.6-1.3c.533-.4 1.066-.6 1.6-.6.6-.067 1.166.167 1.7.7.533.667.633 1.233.3 1.7-.267.4-.6.867-1 1.4l-4 4.6a107.786 107.786 0 0 0-3.6 4.6c.333 1 .6 1.933.8 2.8l.8 2.4c.666 1.867 1.6 2.733 2.8 2.6 1.266-.2 2.533-.833 3.8-1.9a25.834 25.834 0 0 0 3.7-3.9c1.2-1.467 2.1-2.6 2.7-3.4.333-.4.733-.6 1.2-.6.466-.067.866 0 1.2.2.333.2.566.5.7.9.133.4.066.833-.2 1.3-.6 1.067-1.4 2.233-2.4 3.5-.934 1.2-2 2.367-3.2 3.5a20.864 20.864 0 0 1-3.6 2.9c-1.267.8-2.534 1.3-3.8 1.5-1.2.2-2.4.033-3.6-.5-1.134-.6-2.134-1.767-3-3.5l-.4-1c-.134-.333-.367-.733-.7-1.2-.267.533-.534.967-.8 1.3-.267.333-.5.7-.7 1.1a16.36 16.36 0 0 0-.9 1.9 56.73 56.73 0 0 1-.8 1.9c-.467.8-1.034 1.433-1.7 1.9-.667.467-1.5.667-2.5.6-.934-.067-1.7-.367-2.3-.9-.534-.6-.967-1.367-1.3-2.3a10.661 10.661 0 0 1-.5-3.8c.066-3.067.3-6.333.7-9.8.333-3.533.833-7.033 1.5-10.5.666-3.533 1.466-7 2.4-10.4 1-3.4 2.1-6.567 3.3-9.5a5.86 5.86 0 0 1 .6-1.5c.266-.467.566-.9.9-1.3.533-.733 1.166-1.2 1.9-1.4.733-.2 1.466-.133 2.2.2 1.4.533 1.9 1.8 1.5 3.8-.334 1.533-.7 3.267-1.1 5.2-.4 1.867-.834 3.833-1.3 5.9-.467 2-.934 3.967-1.4 5.9-.4 1.933-.767 3.633-1.1 5.1a109.75 109.75 0 0 0-.9 4.6 103.99 103.99 0 0 1-.9 4.4 6.543 6.543 0 0 0-.2 1.6c0 .467-.034.967-.1 1.5.133.067.233.1.3.1.066 0 .166.033.3.1Zm30.529 1.9c-.666.867-1.3 1.667-1.9 2.4l-1.8 2c-.6.533-1.233 1.1-1.9 1.7-.6.6-1.233 1.067-1.9 1.4-1.2.733-2.3.9-3.3.5-1.066-.467-1.8-1.367-2.2-2.7-.333-.933-.433-1.833-.3-2.7.534-3 1.467-5.733 2.8-8.2 1.334-2.467 3.267-4.567 5.8-6.3 1.667-1.133 3.334-1.767 5-1.9 1.667-.133 3.367.333 5.1 1.4 1 .6 1.667 1.2 2 1.8.334.533.4 1.4.2 2.6a26.851 26.851 0 0 1-.6 3.2c-.2 1-.366 2.067-.5 3.2a429.4 429.4 0 0 0-.4 3.1c-.133 1-.133 1.8 0 2.4.2.6.534.9 1 .9.534 0 1.367-.567 2.5-1.7.934-1.067 1.634-1.9 2.1-2.5.534-.6 1-1.133 1.4-1.6.467-.533.934-1.1 1.4-1.7.534-.6 1.267-1.4 2.2-2.4l.8-.8a3.994 3.994 0 0 1 1-.6c.334-.133.7-.1 1.1.1.467.133.8.333 1 .6.2.133.267.4.2.8 0 .333-.033.667-.1 1-.066.267-.3.6-.7 1-.8 1-1.433 1.8-1.9 2.4-.466.533-.9 1.033-1.3 1.5-.4.467-.866 1-1.4 1.6-.466.533-1.133 1.3-2 2.3-.6.733-1.233 1.4-1.9 2-.6.6-1.266 1.167-2 1.7-1.733 1.133-3.233 1.667-4.5 1.6-1.2-.067-2.2-.567-3-1.5-.733-.933-1.266-2.167-1.6-3.7-.333-1.533-.466-3.167-.4-4.9Zm-8.5 3c.667-.467 1.534-1.267 2.6-2.4 1.067-1.133 2.1-2.3 3.1-3.5 1.067-1.267 2-2.467 2.8-3.6.867-1.2 1.4-2.1 1.6-2.7-1.133-.133-2.266.1-3.4.7-1.133.533-2.166 1.367-3.1 2.5-.866 1.067-1.633 2.4-2.3 4-.666 1.533-1.1 3.2-1.3 5Zm40.544-12.4c1.333-1 2.7-1.3 4.1-.9 1.4.4 2.267 1.467 2.6 3.2.133.933.2 2.1.2 3.5v4.2c.067 1.333.167 2.5.3 3.5.2 1 .533 1.533 1 1.6.333 0 .8-.3 1.4-.9.8-.8 1.633-1.767 2.5-2.9a92.97 92.97 0 0 0 2.6-3.3c.8-1.133 1.5-2.1 2.1-2.9.6-.867 1-1.4 1.2-1.6.267-.267.567-.367.9-.3.333.067.6.233.8.5.267.267.467.6.6 1 .133.4.167.733.1 1-.133.8-.633 1.867-1.5 3.2a49.068 49.068 0 0 1-3 4.1 37.761 37.761 0 0 1-3.6 3.7c-1.2 1.067-2.233 1.767-3.1 2.1-1.267.467-2.5.467-3.7 0-1.133-.467-1.967-1.533-2.5-3.2a18.065 18.065 0 0 1-.7-3.4 56.578 56.578 0 0 0-.3-3.6c-.067-.6-.1-1.2-.1-1.8 0-.667-.033-1.433-.1-2.3-1.133 1-2.067 2.067-2.8 3.2a55.792 55.792 0 0 0-2.1 3.3l-2 3.4a18.27 18.27 0 0 1-2.4 3.2c-1.133.933-2.4 1.4-3.8 1.4-1.4-.067-2.5-.733-3.3-2-.533-.8-.833-1.733-.9-2.8-.067-1.067-.133-2.1-.2-3.1 0-2.467.167-4.933.5-7.4.267-2.533.8-5 1.6-7.4.2-.6.4-1.1.6-1.5.867-2.067 2.067-2.767 3.6-2.1.667.133 1.2.567 1.6 1.3.467.667.533 1.533.2 2.6-.467 1.533-.9 3.1-1.3 4.7a41.4 41.4 0 0 0-.9 8.2c.067 1 .267 1.733.6 2.2.4.333.933 0 1.6-1 .733-1 1.5-2.2 2.3-3.6l2.6-4.2c.933-1.4 1.833-2.367 2.7-2.9Zm28.02-18c1.733-.333 3.5-.7 5.3-1.1 1.866-.467 3.633-.867 5.3-1.2.466-.133.933-.233 1.4-.3a14.884 14.884 0 0 1 1.5-.3c1.266-.133 2 .367 2.2 1.5.266 1-.167 1.8-1.3 2.4-.734.2-1.434.4-2.1.6-.667.2-1.334.367-2 .5-1.334.333-2.867.7-4.6 1.1-1.667.333-3.2.633-4.6.9-1.4.267-2.2 1.1-2.4 2.5a159.174 159.174 0 0 0-2 15.9c-.334 5.267-.3 10.533.1 15.8l.4 2.4c.2.733.566 1.467 1.1 2.2.866 1.067 1.133 2.133.8 3.2-.267 1-1.134 1.533-2.6 1.6-2.667.2-4.534-.967-5.6-3.5-.934-2.267-1.5-4.6-1.7-7-.467-4-.534-7.933-.2-11.8.333-3.933.7-7.9 1.1-11.9.133-.933.266-1.9.4-2.9.133-1.067.266-2.167.4-3.3-.534.133-1 .233-1.4.3-.334 0-.7.067-1.1.2-.734.267-1.5.533-2.3.8-.8.267-1.6.567-2.4.9-2.467 1-3.9.9-4.3-.3-.6-1.067.433-2.133 3.1-3.2a33.21 33.21 0 0 1 3.2-1.4c1.066-.4 2.166-.767 3.3-1.1 1.133-.333 2-.8 2.6-1.4.6-.6 1.033-1.533 1.3-2.8.2-.667.466-1.5.8-2.5.333-1 .733-1.9 1.2-2.7.533-.867 1.166-1.533 1.9-2 .733-.467 1.566-.533 2.5-.2.8.333 1.233.9 1.3 1.7.066.8.033 1.767-.1 2.9l-.2 1.6a36.043 36.043 0 0 1-.3 1.9Zm8.062 32.8c.333.267.9.033 1.7-.7.867-.8 1.8-1.8 2.8-3 1-1.2 2.033-2.433 3.1-3.7 1.133-1.333 2.1-2.367 2.9-3.1.4-.333.8-.5 1.2-.5.467 0 .867.133 1.2.4.333.2.533.5.6.9.133.4.067.867-.2 1.4-.333.6-.733 1.2-1.2 1.8a119.907 119.907 0 0 0-3.9 4.3 76.342 76.342 0 0 1-3.8 4.3c-.733.733-1.633 1.367-2.7 1.9-1.933 1-3.7 1.133-5.3.4-1.533-.733-2.467-2.167-2.8-4.3-.333-2.133-.267-4.433.2-6.9.467-2.467 1.133-4.667 2-6.6.333-.867.833-1.467 1.5-1.8.667-.333 1.367-.367 2.1-.1 1.533.533 2.2 1.667 2 3.4-.067 1.067-.233 2.333-.5 3.8-.2 1.467-.367 2.733-.5 3.8-.133.533-.2 1.167-.2 1.9 0 .667-.067 1.467-.2 2.4Zm.3-22.9c.333 0 .667.167 1 .5.4.267.733.6 1 1 .333.333.567.7.7 1.1.2.4.267.733.2 1-.133.333-.4.667-.8 1-.4.333-.767.533-1.1.6-.4 0-.8-.1-1.2-.3-.4-.2-.767-.467-1.1-.8-.267-.4-.5-.8-.7-1.2-.2-.4-.3-.767-.3-1.1a2.4 2.4 0 0 1 .8-1.3c.4-.4.9-.567 1.5-.5Zm14.144 17.3c-.2 1.333-.133 2.3.2 2.9.4.6.933.967 1.6 1.1.733.133 1.533.133 2.4 0 .933-.2 1.833-.467 2.7-.8 2.667-.867 4.9-1.967 6.7-3.3 1.8-1.333 3.7-2.867 5.7-4.6.867-.8 1.6-1.233 2.2-1.3.6-.067 1.033.067 1.3.4.333.333.467.867.4 1.6-.067.667-.367 1.333-.9 2-.933 1.2-2.233 2.467-3.9 3.8a39.327 39.327 0 0 1-5.3 3.7 33.152 33.152 0 0 1-5.8 2.8c-1.933.667-3.7.967-5.3.9-3.133-.333-5.4-1.533-6.8-3.6-1.467-2.067-1.767-4.6-.9-7.6a15.576 15.576 0 0 1 3.3-6c.667-.8 1.6-1.667 2.8-2.6 1.2-1 2.433-1.8 3.7-2.4 1.333-.667 2.633-1 3.9-1 1.333-.067 2.467.4 3.4 1.4 1.133 1.133 1.433 2.533.9 4.2-.533 1.667-1.5 3.233-2.9 4.7-1.333 1.4-2.9 2.5-4.7 3.3-1.733.8-3.3.933-4.7.4Zm7.9-9.3c-2.933 1.267-4.833 3.033-5.7 5.3a9.03 9.03 0 0 0 3.2-1.6c1-.733 1.833-1.967 2.5-3.7Z","fill":"#323231"}})])
}
var home_hero_nl_svgvue_type_template_id_5d65cdc6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-nl-svg.vue?vue&type=template&id=5d65cdc6

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/home-hero-nl-svg.vue?vue&type=script&lang=js

/* harmony default export */ var home_hero_nl_svgvue_type_script_lang_js = ({
  props: {
    color: {
      type: String,
      default: '#323231',
    },
  },

  data: () => ({
    svgColor: '',
  }),

  mounted() {
    this.svgColor = this.color ? this.color : '#323231'
  },

  watch: {
    color() {
      this.svgColor = this.color
    },
  },
});

// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-nl-svg.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_home_hero_nl_svgvue_type_script_lang_js = (home_hero_nl_svgvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/svg/ui/home-hero-nl-svg.vue?vue&type=style&index=0&id=5d65cdc6&prod&lang=css
var home_hero_nl_svgvue_type_style_index_0_id_5d65cdc6_prod_lang_css = __webpack_require__("5d4c");

// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-nl-svg.vue






/* normalize component */

var home_hero_nl_svg_component = normalizeComponent(
  ui_home_hero_nl_svgvue_type_script_lang_js,
  home_hero_nl_svgvue_type_template_id_5d65cdc6_render,
  home_hero_nl_svgvue_type_template_id_5d65cdc6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var home_hero_nl_svg = (home_hero_nl_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/home-hero-es-svg.vue?vue&type=template&id=27af79df
var home_hero_es_svgvue_type_template_id_27af79df_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"821px","height":"294px","viewBox":"0 0 821 294","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("schriftzuege_pfade_ES")]),_c('g',{attrs:{"id":"schriftzuege_pfade_ES","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(0.529948, -0.048413)","fill":"currentColor","fill-rule":"nonzero","id":"spanisch"}},[_c('g',{attrs:{"id":"Group"}},[_c('path',{attrs:{"d":"M198.103671,145.072697 C199.79327,141.065314 199.576655,138.260146 197.464656,136.678854 C195.352657,135.097563 193.240657,135.465809 191.128658,137.783592 C190.067243,138.845007 189.16829,139.841437 188.431798,140.794545 C187.695306,141.747652 187.002137,142.754913 186.373953,143.805497 C185.745768,144.866912 184.35943,146.708142 182.258262,149.350849 C180.146263,151.993555 178.142571,154.787893 176.236357,157.744692 C174.124358,160.907275 172.488912,162.607705 171.33002,162.813489 C170.171129,163.030105 169.315498,162.293613 168.795621,160.593183 C168.264914,158.903583 168.004976,156.5858 168.004976,153.629001 C168.004976,150.672202 168.113283,147.607096 168.319068,144.444512 C169.792052,127.12612 171.958205,109.753573 174.817527,92.3268727 C177.666018,74.9001723 180.785278,57.1160566 184.164477,38.9528642 C184.803492,33.2450512 182.788969,29.7683757 178.142571,28.5011763 C175.813957,28.0787764 173.647804,28.3387148 171.644113,29.2918221 C169.62959,30.2449294 168.102453,32.0969902 167.051868,34.8371736 C164.723254,39.9059715 162.502947,46.7726763 160.401779,55.4264573 C158.28978,64.0910691 156.286088,73.2214038 154.379874,82.828292 C152.48449,92.4351803 150.892367,102.052899 149.625168,111.659788 C148.357968,121.266676 147.404861,129.552211 146.776677,136.527223 C146.570892,139.484022 146.148492,143.70802 145.509477,149.199218 C145.325354,150.791341 145.195385,152.405125 145.087078,154.018908 C143.202524,151.170417 140.808925,150.141495 137.884619,150.975464 C136.823204,151.34371 135.707635,151.798602 134.559574,152.34014 C133.400682,152.892509 132.295944,153.434047 131.234529,153.986416 C121.649303,158.751953 112.204876,163.452505 102.890418,168.120564 C93.5759606,172.788624 84.120703,177.315883 74.546307,181.702343 C69.0442785,184.085111 63.4556039,186.088803 57.7802832,187.735079 C52.1049625,189.381355 46.3321649,191.125108 40.483552,192.944677 C39.5954293,193.312923 38.5773374,193.399569 37.4184456,193.215446 C36.2595537,193.031323 34.7107544,192.944677 32.7612167,192.944677 C33.8226317,190.930155 34.7540774,189.099755 35.555554,187.453479 C36.3570306,185.807203 37.1909995,184.258404 38.0791222,182.78542 C41.0900748,178.767206 44.025212,174.694838 46.8628724,170.579148 C49.7005327,166.463457 52.8089622,162.575213 56.17733,158.914414 C63.8021884,150.130664 72.011908,142.27836 80.7956582,135.314178 C89.5794084,128.360827 98.9371891,122.057322 108.869,116.382001 C114.371029,113.089449 116.320566,109.342004 114.728444,105.128837 C113.136322,100.742377 109.313062,99.3668698 103.280326,101.013146 C100.800081,101.565515 98.3523278,102.247853 95.9587288,103.070991 C93.5651298,103.894129 91.0307309,104.576468 88.3771935,105.128837 C79.6800894,106.775113 71.0371392,108.421389 62.4266813,110.067665 C53.8162233,111.713942 45.0757962,113.273572 36.2053999,114.735725 C33.5410318,115.103971 30.7900175,115.331417 27.9523572,115.418063 C25.1146968,115.51554 22.3636826,114.454125 19.6993145,112.266311 C20.230022,107.327482 21.6921752,103.027668 24.096605,99.3668698 C26.490204,95.7169021 29.0137721,92.1427497 31.6781403,88.6660742 C41.263367,76.6006023 51.5525935,65.66153 62.5458197,55.8813495 C73.5498766,46.1011689 85.6045177,37.7289878 98.7422353,30.7756369 C108.85817,25.4685621 119.147396,21.2662254 129.609915,18.157796 C132.620867,17.2480117 135.025297,16.6956427 136.790712,16.5115197 C138.556126,16.3273967 139.942464,16.6089966 140.917233,17.3346579 C141.892002,18.0711499 142.682648,19.3925031 143.310832,21.3095485 C143.928186,23.2265939 144.513047,25.8368081 145.043754,29.1293606 C145.40117,30.2232679 145.9752,31.414652 146.776677,32.6926822 C147.578153,33.9707124 148.325476,34.6097276 149.040307,34.6097276 C150.101722,34.6097276 151.303936,34.1981585 152.636121,33.3750204 C153.968305,32.5518823 154.89975,31.6854211 155.430458,30.7648061 C156.491873,27.6563766 157.120057,24.4504703 157.293349,21.1579178 C157.466642,17.8653653 157.109226,14.8002589 156.231934,11.9625986 C155.343812,9.1249382 153.751689,6.70967767 151.444736,4.69515544 C149.137784,2.6806332 145.856062,1.31595685 141.599571,0.579464847 C134.852005,-0.514442389 128.028623,-0.059550271 121.107764,1.9441412 C97.8649434,8.34512314 77.1023674,18.5910266 58.8308674,32.6710207 C40.5593673,46.7618456 24.139928,64.1343922 9.59421101,84.7994912 C7.6338426,87.3663825 5.99839713,90.2473659 4.66621307,93.4424415 C3.33402901,96.6483478 2.14264489,99.8001003 1.07039919,102.90853 C-0.879138461,110.955788 -0.16430799,117.681693 3.20405983,123.075414 C6.57242766,128.479965 12.0744561,131.545072 19.7101453,132.270733 C22.7210978,132.638979 25.8295273,132.725625 29.0246029,132.541502 C32.2196785,132.357379 35.3172772,132.08661 38.3390606,131.718364 C42.4222588,131.350118 46.4621341,130.711103 50.4478555,129.801319 C54.4444077,128.891534 58.4734521,128.252519 62.5566504,127.884273 L63.6180654,128.989011 C62.7299427,129.898795 61.7984969,130.862734 60.8237281,131.869995 C59.8489593,132.877256 58.9175135,133.92784 58.0293908,135.021747 C52.7114853,141.238606 47.4693952,147.466296 42.324782,153.683155 C37.1801687,159.900014 32.0355555,166.21435 26.8909423,172.615331 C25.4721121,174.445731 24.2265741,176.460253 23.1651592,178.648067 C22.1037443,180.846713 21.1289754,182.947881 20.2408527,184.962403 C17.7606076,191.547508 17.8039307,196.995383 20.3708219,201.284366 C22.9377131,205.584179 27.3350036,207.826148 33.5518625,208.010271 C36.0321077,208.010271 38.3823836,207.826148 40.6026904,207.457902 C42.8229971,207.089656 45.1732731,206.548117 47.6535182,205.811625 C63.2606501,201.425166 78.5320284,195.977291 93.4351606,189.489663 C108.338293,183.002035 123.068133,175.637115 137.61385,167.405734 C138.501973,166.853365 139.476741,166.268503 140.538156,165.618657 C141.599571,164.979642 142.57434,164.199827 143.462463,163.290043 C144.014832,162.802659 144.469724,162.271951 144.881293,161.708751 C144.902955,163.116751 144.946278,164.535581 145.032924,165.954411 C145.347016,171.651393 146.408431,176.83933 148.206338,181.474897 C149.993414,186.121295 153.220982,188.872309 157.86738,189.706278 C160.824179,190.345293 163.412731,190.02037 165.633038,188.753171 C167.853345,187.485971 169.91119,185.796372 171.806574,183.684373 C173.073774,182.211389 174.979988,179.67699 177.503556,176.081176 C180.037955,172.496193 182.734816,168.640441 185.583307,164.52475 C188.431798,160.40906 191.074504,156.553307 193.500596,152.957494 C195.937518,149.405003 197.464656,146.773127 198.103671,145.072697 Z","id":"Path"}}),_c('path',{attrs:{"d":"M409.996752,205.497533 C411.458905,208.064424 413.386781,209.613224 415.758718,210.165593 C418.130656,210.717962 420.329301,210.252239 422.343823,208.790086 C425.993791,206.234025 427.011883,201.652612 425.365607,195.067507 C424.629115,192.511446 423.9901,189.901232 423.448561,187.247695 C422.896192,184.594157 422.4413,181.897297 422.073054,179.157113 C419.874409,160.679829 418.683025,142.343344 418.509733,124.147659 C418.32561,105.951975 418.596379,87.5180132 419.332871,68.8566056 C419.701117,61.1775934 420.015209,53.4877505 420.296809,45.8087383 C420.567578,38.1297261 420.708378,30.4398832 420.708378,22.760871 C420.340132,13.4355826 417.643271,7.34869279 412.617797,4.51103244 C407.581491,1.67337208 401.776201,2.90807926 395.191096,8.21515397 C392.082667,10.5979222 389.115037,13.2514596 386.277377,16.175766 C383.439716,19.1000725 380.742856,22.1218559 378.186796,25.2302853 C366.478739,38.9528642 356.005389,53.5419043 346.766747,68.9974055 C337.528105,84.4529068 329.069278,100.7857 321.390265,117.974124 C320.653773,119.6204 319.928112,121.223353 319.19162,122.772152 C318.455128,124.331782 317.729467,125.923905 316.992975,127.570181 L315.07593,127.570181 C314.707684,125.555659 314.480238,123.45449 314.393591,121.255845 C314.296115,119.0572 314.166145,116.771909 313.982022,114.399971 C313.613776,105.074683 313.299684,95.6952405 313.018084,86.2724752 C312.747315,76.8497099 312.422392,67.4810985 312.054146,58.1449793 C311.6859,54.8524268 311.274331,51.6140282 310.819439,48.4081218 C310.364547,45.2130462 309.671378,42.0504629 308.761594,38.9420334 C306.931195,33.0934205 303.866088,29.7033912 299.566275,28.7936069 C295.266461,27.8838227 291.29157,29.5300989 287.630772,33.7324356 C285.063881,36.4726191 282.778589,40.0467714 280.774898,44.4332312 C273.269178,57.603441 266.456627,71.001097 260.337245,84.626199 C254.207032,98.251301 248.488388,112.298803 243.192144,126.747043 C239.1631,137.718608 235.556455,148.65768 232.350549,159.531768 C229.144642,170.416686 226.447782,181.615697 224.259968,193.139631 C222.797814,199.724736 224.075845,203.840426 228.104889,205.486702 C230.119411,206.407317 231.895657,206.309841 233.455287,205.215933 C235.004086,204.122026 236.33627,202.562396 237.430177,200.547874 C238.155839,199.269843 238.610731,197.937659 238.794854,196.572983 C238.978977,195.197476 239.1631,193.789476 239.347223,192.316492 C239.715469,190.670216 239.845438,188.980617 239.758792,187.236864 C239.661315,185.503941 239.802115,183.900988 240.170361,182.438835 C245.293313,162.867643 251.423525,143.892143 258.550169,125.501505 C265.687643,107.121697 273.919024,89.3267509 283.244312,72.1383273 C283.969973,71.04442 284.706465,69.939682 285.442957,68.8457748 C286.168619,67.7518676 286.991757,66.5604835 287.912372,65.2824532 C288.638033,67.2969755 289.006279,69.1706978 289.006279,70.9036201 C289.006279,72.6473732 288.908802,74.2394956 288.73551,75.7016489 C288.367264,87.2255825 288.053172,98.6628701 287.771572,110.002681 C287.500803,121.342491 288.183141,132.595656 289.829417,143.751344 C290.555078,147.596265 291.378216,151.430356 292.298831,155.275277 C293.208616,159.120199 294.4,162.68352 295.862153,165.976073 C297.508429,169.268625 299.468798,171.835516 301.76492,173.655085 C304.050211,175.485484 306.476302,176.536068 309.032363,176.806837 C311.588423,177.077607 314.155315,176.536068 316.711375,175.160561 C319.267436,173.785054 321.552727,171.640563 323.567249,168.716256 C326.675679,163.96155 329.145093,158.936076 330.975492,153.629001 C333.174137,148.321926 335.318629,143.058175 337.419797,137.848577 C339.520966,132.638979 341.578811,127.375227 343.593333,122.068153 C349.994315,106.146928 357.175112,91.2004732 365.124893,77.2071252 C373.085505,63.2137772 382.269994,49.9027673 392.70002,37.2849264 C393.793928,36.0068962 394.985312,34.728866 396.263342,33.440005 C397.541372,32.1619747 399.003525,30.6998215 400.649802,29.0535453 C400.833925,30.5156985 400.963894,31.6637596 401.061371,32.4868977 C401.148017,33.3100358 401.19134,33.992374 401.19134,34.544743 C399.729187,52.8379046 398.678602,71.0335893 398.039587,89.1426279 C397.389741,107.251666 397.530541,125.458182 398.451156,143.740513 C398.819402,151.419525 399.458417,158.925245 400.368202,166.236011 C401.277986,173.557608 402.382724,181.052497 403.660754,188.731509 C404.029,191.85077 404.797984,194.764245 405.989369,197.51526 C407.202414,200.277105 408.534598,202.930642 409.996752,205.497533 Z","id":"Path"}}),_c('path',{attrs:{"d":"M726.471696,44.2707697 C726.580004,42.1587706 726.417543,40.0467714 725.995143,37.9347723 C725.572743,33.7107741 723.244128,31.0788983 719.02013,30.0174833 C714.373732,28.9668991 710.886226,30.5481908 708.568442,34.772189 C708.146042,35.6169887 707.723643,36.4617883 707.301243,37.306588 C706.878843,38.1513876 706.456443,38.8878796 706.034043,39.5268947 C703.077245,48.397291 700.066292,57.375995 697.001186,66.4521758 C693.936079,75.5283566 690.82765,84.5070606 687.654236,93.3774569 C686.809436,95.7060713 685.964636,97.9697011 685.119837,100.190008 C684.275037,102.410315 683.538545,104.359852 682.89953,106.049452 C678.675532,107.110867 674.711472,107.944835 671.018181,108.583851 C667.32489,109.222866 663.989015,110.381757 661.032216,112.071357 C651.73942,117.562554 644.981023,124.483413 640.757024,132.823102 C640.215486,133.895348 639.70644,134.989255 639.219056,136.104824 C637.605272,138.335961 635.796534,140.827037 633.782012,143.599713 C631.247613,147.087219 628.550753,150.628879 625.702262,154.213862 C622.85377,157.809676 620.15691,160.863952 617.622511,163.398351 C615.727127,165.304565 614.243312,166.246842 613.181897,166.246842 C611.698083,166.041057 610.701652,164.351458 610.170945,161.178044 C609.640237,158.015461 609.326145,154.268016 609.217838,149.93571 C609.10953,145.614235 609.055376,141.227775 609.055376,136.787162 C609.055376,132.346548 608.838761,128.653258 608.416361,125.696459 C607.354946,120.205261 604.614763,116.826062 600.18498,115.558863 C595.744366,114.291664 591.422891,115.244771 587.198893,118.407354 C584.447879,120.096953 581.653541,123.16206 578.80505,127.591843 C575.956559,132.032456 573.205545,136.462239 570.573669,140.902852 C567.930963,145.343466 565.504871,149.134234 563.284564,152.307648 C561.064258,155.470231 559.320505,156.531646 558.053305,155.470231 C556.99189,153.997247 556.41786,151.625309 556.309552,148.343588 C556.201244,145.072697 556.363706,141.216945 556.786106,136.787162 C557.208505,132.346548 557.999151,127.602673 559.158043,122.533875 C560.316935,117.465078 561.638288,112.504587 563.122103,107.641574 C564.172687,104.262375 564.021056,101.468038 562.645549,99.2477313 C561.270042,97.0274246 559.526289,95.7169021 557.425121,95.2836715 C552.562107,93.1716723 548.760509,95.3919791 546.020326,101.933761 C545.38131,103.20096 544.753126,104.782252 544.124942,106.688467 C541.590543,114.291664 539.84679,122.057322 538.893682,129.974611 C538.850359,130.364518 538.817867,130.743595 538.774544,131.133503 C537.713129,131.956641 536.651714,132.974733 535.568638,134.252763 C532.189439,138.270977 528.864394,142.170052 525.593503,145.97165 C522.311782,149.773249 518.88926,153.47737 515.293446,157.062353 C512.759047,159.596752 510.852833,160.658167 509.596464,160.235767 C508.329264,159.813368 507.538619,158.448691 507.224526,156.120077 C506.910434,153.802293 506.910434,150.888817 507.224526,147.412142 C507.538619,143.924636 507.961018,140.393806 508.491726,136.797993 C509.011603,133.213009 509.488156,129.942119 509.921387,126.974489 C510.343787,124.01769 510.549571,122.013999 510.549571,120.952584 C510.343787,119.262985 509.488156,117.887477 508.015172,116.836893 C506.531357,115.786309 504.787604,115.09314 502.783913,114.779048 C500.769391,114.464956 498.711545,114.464956 496.610377,114.779048 C494.498378,115.09314 492.808779,115.883786 491.541579,117.150985 C490.480164,118.2124 489.581211,119.317138 488.844719,120.47603 C488.108227,121.634922 487.30675,122.750491 486.472781,123.801075 C484.360782,126.335474 481.609768,129.768826 478.230569,134.101132 C474.851371,138.433438 471.418018,142.494975 467.930512,146.296573 C464.443006,150.098172 461.280422,153.163278 458.421101,155.481062 C455.572609,157.809676 453.720549,158.329553 452.875749,157.062353 C452.875749,155.372754 453.135687,153.260755 453.666395,150.726356 C454.186272,148.191957 454.879441,145.614235 455.72424,142.960698 C456.56904,140.317991 457.413839,137.8919 458.258639,135.671593 C459.103439,133.451286 460.056546,131.707533 461.10713,130.440334 C463.002514,128.12255 463.587375,125.902243 462.850883,123.790244 C462.114391,121.678245 460.68473,120.0428 458.572731,118.883908 C456.460732,117.725016 454.077964,117.194308 451.446088,117.302616 C448.803382,117.410924 446.539752,118.623969 444.633537,120.952584 C442.943938,122.847968 441.146031,126.173012 439.250647,130.927718 C437.355263,135.682424 435.979756,140.642914 435.134956,145.82002 C434.290157,150.997125 434.290157,156.011769 435.134956,160.874783 C435.979756,165.737796 438.200063,169.225302 441.785046,171.32647 C446.009044,173.860869 450.861227,173.860869 456.352425,171.32647 C460.793038,169.636871 464.746267,167.264934 468.233773,164.199827 C471.72128,161.134721 474.938017,157.809676 477.894816,154.224693 C479.3678,152.751709 480.79746,151.051279 482.172968,149.155895 C483.548475,147.260511 485.292228,144.931897 487.404227,142.180883 C486.765212,164.568073 492.158933,176.297791 503.563728,177.348376 C506.942926,177.564991 510.376279,176.611884 513.863785,174.499885 C517.351291,172.387885 520.838798,169.593548 524.315473,166.106042 C527.802979,162.618536 531.290486,158.665307 534.767161,154.224693 C535.687776,153.05497 536.586729,151.91774 537.496514,150.758848 C537.485683,151.701125 537.453191,152.643401 537.453191,153.585678 C537.669806,156.759092 537.87559,160.029983 538.092206,163.409181 C538.29799,166.78838 539.251098,169.745179 540.940697,172.279578 C543.475096,176.297791 546.962602,178.355637 551.392385,178.463944 C555.832998,178.572252 559.840381,177.142591 563.436195,174.185792 C566.392994,171.012378 568.927393,167.64401 571.039392,164.048197 C573.151391,160.463213 575.26339,156.8674 577.375389,153.282416 C579.487388,149.697433 581.696864,146.155773 584.025479,142.668267 C586.343263,139.180761 589.300061,135.855716 592.895875,132.682302 C593.10166,135.433316 593.209967,137.805254 593.209967,139.808945 C593.209967,141.823467 593.318275,143.773005 593.52406,145.668389 C593.946459,149.264203 594.314705,153.011647 594.628798,156.910723 C594.94289,160.820629 595.625228,164.470596 596.686643,167.838964 C598.376242,173.124377 601.062272,176.503576 604.766393,177.97656 C608.459684,179.460375 612.315436,179.460375 616.33365,177.97656 C619.073834,176.925976 622.398878,174.651515 626.308784,171.164009 C628.94066,168.813733 631.496721,166.257673 633.976966,163.52832 C634.085273,164.210658 634.204412,164.903827 634.377704,165.618657 C635.861519,170.687455 638.547548,174.229115 642.457455,176.232807 C646.367361,178.247329 650.634682,178.084868 655.291911,175.756253 C657.187295,174.705669 659.093509,173.535946 660.988893,172.268747 C662.895108,171.001548 664.476399,169.528564 665.743599,167.828133 C668.700397,164.24315 671.548889,160.495706 674.299903,156.5858 C677.040086,152.675894 679.899408,148.820141 682.856207,145.018543 C683.701007,143.545559 684.859898,142.061744 686.343713,140.577929 C686.766113,143.112328 686.928574,145.53842 686.820267,147.867034 C686.711959,150.195649 686.549498,152.513432 686.343713,154.831216 C686.127098,158.210414 685.975467,161.589613 685.867159,164.968812 C685.758852,168.34801 685.921313,171.618901 686.343713,174.792315 C686.549498,177.749114 687.502605,179.969421 689.192204,181.442405 C690.881804,182.926219 692.993803,183.771019 695.528202,183.976804 C701.019399,184.399203 704.604382,181.65902 706.293982,175.745422 C706.716382,174.694838 706.97632,173.741731 707.084628,172.896931 C707.192935,172.052132 707.344566,171.109855 707.561181,170.04844 C708.405981,164.351458 709.142473,158.697799 709.781488,153.098293 C710.420503,147.509619 711.254472,141.964267 712.315887,136.462239 C714.633671,121.88403 716.853977,107.58742 718.965976,93.5290876 C721.077976,79.4924165 723.287452,65.2824532 725.616066,50.9208592 C726.10345,48.6030756 726.374219,46.3827688 726.471696,44.2707697 Z M672.783596,132.021625 C671.299781,135.617439 669.458551,139.148269 667.238244,142.635775 C665.017937,146.123281 662.537692,149.448326 659.797509,152.610909 C657.046495,155.784323 654.198003,158.42703 651.241205,160.528198 C650.818805,156.087585 651.187051,151.657802 652.345943,147.217188 C653.504835,142.776575 655.194434,138.769192 657.414741,135.173378 C659.635047,131.588395 662.321077,128.631596 665.494491,126.302982 C668.667905,123.985198 671.938796,122.609691 675.317995,122.187291 C675.101379,125.165751 674.25658,128.436642 672.783596,132.021625 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M818.186612,137.848577 C817.125197,135.108393 815.229813,133.407963 812.48963,132.779779 C811.64483,132.573994 810.691723,132.671471 809.641139,133.093871 C808.579724,133.516271 807.529139,133.938671 806.478555,134.361071 C803.099357,135.422485 799.774312,136.256454 796.49259,136.895469 C793.221699,137.523654 789.571732,137.523654 785.564349,136.895469 C785.347733,135.20587 785.196103,133.624579 785.087795,132.140764 C784.979487,130.66778 784.925333,129.40058 784.925333,128.339165 C784.297149,118.623969 781.123735,110.814988 775.426753,104.89056 C771.408539,100.666562 767.195372,98.7711777 762.754758,99.1935775 C758.314145,99.6159773 754.306762,101.944592 750.710948,106.16859 C749.649533,107.230005 748.598949,108.280589 747.548364,109.331173 C746.48695,110.392588 745.328058,111.226557 744.060858,111.865572 C737.302461,115.038986 732.233663,119.468769 728.854465,125.176582 C725.475266,130.873564 722.940867,137.534485 721.251268,145.137681 C720.200684,150.628879 720.200684,155.751831 721.251268,160.506537 C722.312683,165.261242 724.26222,169.214471 727.110711,172.387885 C729.959203,175.550469 733.446709,177.770775 737.562399,179.037975 C741.67809,180.305174 746.270334,180.305174 751.339132,179.037975 C756.83033,177.987391 761.844974,175.821238 766.383064,172.539516 C770.921155,169.268625 774.776907,164.882165 777.950321,159.390968 C779.423305,156.856569 780.961274,155.112816 782.542565,154.159708 C784.123857,153.206601 786.073395,152.730047 788.402009,152.730047 C791.781208,152.524263 795.052098,152.091032 798.225513,151.462848 C801.398927,150.823833 804.56151,150.087341 807.734924,149.242541 C810.691723,148.397742 813.648522,146.708142 816.60532,144.173743 C817.45012,143.545559 818.034981,142.484144 818.349073,141.01116 C818.663166,139.549007 818.609012,138.487592 818.186612,137.848577 Z M757.523499,157.647215 C754.880792,159.228506 751.772363,160.235767 748.176549,160.658167 C742.479567,161.297182 739.945168,158.232076 740.573352,151.473679 C740.995752,148.09448 741.67809,144.877743 742.631197,141.812637 C743.584305,138.758361 745.21975,135.747408 747.537534,132.79061 C749.227133,138.281807 751.544917,142.083406 754.501715,144.195405 C757.458514,146.307404 760.729405,148.213619 764.325219,149.903218 C762.429835,153.488201 760.166205,156.065923 757.523499,157.647215 Z M763.220481,126.768704 C762.483989,125.29572 762.538143,122.122306 763.382942,117.270124 C764.650142,118.331539 765.646572,119.230492 766.393895,119.956153 C767.130387,120.703476 767.704418,121.494122 768.137648,122.328091 C768.560048,123.172891 768.87414,124.223475 769.090755,125.501505 C769.29654,126.768704 769.513155,128.458304 769.71894,130.570303 C766.123126,129.508888 763.967804,128.241688 763.220481,126.768704 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M209.963358,247.9433 C209.746743,247.217639 208.793636,246.860224 207.093205,246.860224 L204.862068,246.860224 C203.204961,246.860224 202.241023,247.22847 201.991915,247.9433 L187.153768,289.674236 C187.110445,289.890852 187.067122,290.064144 187.023798,290.215775 C186.980475,290.367405 186.958814,290.529867 186.958814,290.692328 C186.958814,291.461313 187.987737,291.840389 190.02392,291.840389 L190.987858,291.840389 C191.670197,291.840389 192.244227,291.753743 192.70995,291.580451 C193.175673,291.407159 193.500596,291.13639 193.673888,290.746482 L196.998933,281.031286 L214.696402,281.031286 L218.086432,290.746482 C218.259724,291.13639 218.595478,291.407159 219.104524,291.580451 C219.613569,291.753743 220.230923,291.840389 220.956584,291.840389 L222.104645,291.840389 C224.021691,291.840389 224.974798,291.450482 224.974798,290.692328 C224.974798,290.389067 224.909813,290.074975 224.779844,289.72839 L209.963358,247.9433 Z M199.045947,275.171843 L204.927053,258.308342 C205.143668,257.71265 205.31696,257.084465 205.468591,256.423789 C205.620221,255.763112 205.761021,255.113266 205.88016,254.474251 L206.010129,254.474251 C206.140098,255.113266 206.270067,255.763112 206.400037,256.423789 C206.530006,257.084465 206.670806,257.71265 206.844098,258.308342 L212.660219,275.171843 L199.045947,275.171843 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M281.143144,246.990193 L251.055279,246.990193 C250.113003,246.990193 249.64728,247.759177 249.64728,249.286315 L249.64728,250.564345 C249.64728,252.102314 250.113003,252.860467 251.055279,252.860467 L262.741675,252.860467 L262.741675,290.237436 C262.741675,291.298851 263.716443,291.829559 265.676812,291.829559 L266.629919,291.829559 C268.590288,291.829559 269.565056,291.298851 269.565056,290.237436 L269.565056,252.860467 L281.132313,252.860467 C282.063759,252.860467 282.540493,252.091483 282.540493,250.564345 L282.540493,249.286315 C282.551143,247.759177 282.07459,246.990193 281.143144,246.990193 Z","id":"Path"}}),_c('path',{attrs:{"d":"M325.040233,246.860224 L324.087126,246.860224 C322.126757,246.860224 321.151989,247.390931 321.151989,248.463177 L321.151989,277.153872 C321.151989,278.940949 320.686266,280.52224 319.743989,281.886917 C318.801713,283.251593 317.512852,284.323839 315.877406,285.114485 C314.241961,285.90513 312.357408,286.295038 310.223747,286.295038 C308.133409,286.295038 306.259687,285.90513 304.60258,285.146977 C302.945473,284.377993 301.645781,283.305747 300.703505,281.919409 C299.761228,280.533071 299.295505,278.951779 299.295505,277.153872 L299.295505,248.463177 C299.295505,247.401762 298.320737,246.860224 296.360368,246.860224 L295.39643,246.860224 C293.436062,246.860224 292.461293,247.390931 292.461293,248.463177 L292.461293,277.218857 C292.461293,281.908578 293.999262,285.569377 297.064368,288.212083 C300.129474,290.85479 304.515934,292.176143 310.223747,292.176143 C315.888237,292.176143 320.263866,290.85479 323.350634,288.212083 C326.437402,285.569377 327.986201,281.908578 327.986201,277.218857 L327.986201,248.463177 C327.97537,247.390931 327.000602,246.860224 325.040233,246.860224 Z","id":"Path"}}),_c('path',{attrs:{"d":"M379.540641,247.9433 C379.324026,247.217639 378.370919,246.860224 376.670489,246.860224 L374.439351,246.860224 C372.782244,246.860224 371.818306,247.22847 371.569198,247.9433 L356.731051,289.674236 C356.687728,289.890852 356.644405,290.064144 356.601082,290.215775 C356.557758,290.367405 356.536097,290.529867 356.536097,290.692328 C356.536097,291.461313 357.56502,291.840389 359.601203,291.840389 L360.565141,291.840389 C361.24748,291.840389 361.82151,291.753743 362.287233,291.580451 C362.752956,291.407159 363.077879,291.13639 363.251171,290.746482 L366.576216,281.031286 L384.273685,281.031286 L387.663715,290.746482 C387.837007,291.13639 388.172761,291.407159 388.681807,291.580451 C389.190853,291.753743 389.808206,291.840389 390.533867,291.840389 L391.681928,291.840389 C393.598974,291.840389 394.552081,291.450482 394.552081,290.692328 C394.552081,290.389067 394.487096,290.074975 394.357127,289.72839 L379.540641,247.9433 Z M368.6124,275.171843 L374.493505,258.308342 C374.71012,257.71265 374.883412,257.084465 375.035043,256.423789 C375.186674,255.763112 375.327474,255.113266 375.446612,254.474251 L375.576581,254.474251 C375.70655,255.113266 375.83652,255.763112 375.966489,256.423789 C376.096458,257.084465 376.237258,257.71265 376.41055,258.308342 L382.226671,275.171843 L368.6124,275.171843 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M428.094959,285.840146 L411.610535,285.840146 L411.610535,248.463177 C411.610535,247.401762 410.635767,246.860224 408.675398,246.860224 L407.722291,246.860224 C405.761923,246.860224 404.787154,247.390931 404.787154,248.463177 L404.787154,289.609252 C404.787154,291.017251 405.491153,291.721251 406.899153,291.721251 L428.10579,291.721251 C429.080559,291.721251 429.578774,290.952267 429.578774,289.425129 L429.578774,288.147099 C429.567943,286.60913 429.069728,285.840146 428.094959,285.840146 Z","id":"Path"}}),_c('path',{attrs:{"d":"M468.634512,284.107223 C468.233773,283.554854 467.811374,283.273255 467.388974,283.273255 C467.129035,283.273255 466.544174,283.522362 465.63439,284.009747 C464.724606,284.497131 463.51156,284.995346 462.027745,285.515223 C460.5331,286.024269 458.724362,286.284207 456.601532,286.284207 C451.955134,286.284207 448.521782,284.897869 446.279813,282.125193 C444.048676,279.363348 442.922276,275.096027 442.922276,269.344891 C442.922276,263.507109 444.048676,259.239788 446.312306,256.532096 C448.565105,253.824405 452.063442,252.47056 456.796486,252.47056 C458.8435,252.47056 460.54393,252.687175 461.908607,253.109575 C463.273283,253.531975 464.323867,253.965205 465.07119,254.387605 C465.818513,254.810005 466.316728,255.02662 466.576666,255.02662 C466.91242,255.02662 467.302328,254.755851 467.724727,254.192651 C468.147127,253.640282 468.526204,253.012098 468.840296,252.308098 C469.165219,251.604099 469.31685,251.06256 469.31685,250.672653 C469.31685,250.076961 468.786142,249.481269 467.713897,248.885577 C466.944912,248.419854 465.980974,248.008285 464.811252,247.672531 C463.641529,247.336777 462.363499,247.055177 460.977161,246.838562 C459.590823,246.632778 458.171993,246.52447 456.731501,246.52447 C442.846461,246.52447 435.903941,254.106005 435.903941,269.269076 C435.903941,277.099719 437.582709,282.872516 440.951077,286.587469 C444.319445,290.29159 449.529043,292.143651 456.601532,292.143651 C458.096178,292.143651 459.5475,292.024512 460.977161,291.797066 C462.406822,291.55879 463.728175,291.266359 464.941221,290.898113 C466.154267,290.540698 467.161528,290.118298 467.973835,289.652575 C468.656173,289.316821 469.17605,288.926914 469.544296,288.504514 C469.901711,288.082114 470.085834,287.670545 470.085834,287.291468 C470.085834,286.999038 469.945034,286.522484 469.674265,285.883469 C469.381834,285.266115 469.03525,284.670423 468.634512,284.107223 Z","id":"Path"}}),_c('path',{attrs:{"d":"M499.393883,247.9433 C499.177268,247.217639 498.224161,246.860224 496.523731,246.860224 L494.292593,246.860224 C492.635486,246.860224 491.671548,247.22847 491.422441,247.9433 L476.595124,289.674236 C476.551801,289.890852 476.508478,290.064144 476.465155,290.215775 C476.421832,290.367405 476.40017,290.529867 476.40017,290.692328 C476.40017,291.461313 477.418262,291.840389 479.465276,291.840389 L480.418384,291.840389 C481.100722,291.840389 481.674752,291.753743 482.140475,291.580451 C482.606198,291.407159 482.931121,291.13639 483.093583,290.746482 L486.418627,281.031286 L504.116097,281.031286 L507.506126,290.746482 C507.668588,291.13639 508.015172,291.407159 508.524218,291.580451 C509.044095,291.753743 509.650618,291.840389 510.376279,291.840389 L511.52434,291.840389 C513.441385,291.840389 514.394493,291.450482 514.394493,290.692328 C514.394493,290.389067 514.329508,290.074975 514.199539,289.72839 L499.393883,247.9433 Z M488.476473,275.171843 L494.357578,258.308342 C494.574193,257.71265 494.747485,257.084465 494.899116,256.423789 C495.050747,255.763112 495.180716,255.113266 495.310685,254.474251 L495.440654,254.474251 C495.570624,255.113266 495.700593,255.763112 495.819731,256.423789 C495.9497,257.084465 496.0905,257.71265 496.263792,258.308342 L502.079913,275.171843 L488.476473,275.171843 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M556.450352,246.860224 L555.616383,246.860224 C553.656015,246.860224 552.681246,247.390931 552.681246,248.463177 L552.681246,275.550919 C552.681246,276.493196 552.692077,277.26218 552.713738,277.879534 C552.7354,278.496887 552.767892,279.168395 552.811215,279.894056 L552.551277,279.959041 C552.248015,279.276702 551.933923,278.637687 551.587339,278.041995 C551.251585,277.446303 550.840016,276.82895 550.374293,276.189934 L531.972824,248.203238 C531.626239,247.694192 531.21467,247.347608 530.727286,247.152654 C530.239901,246.9577 529.611717,246.860224 528.842733,246.860224 L527.120641,246.860224 C525.160273,246.860224 524.185504,247.390931 524.185504,248.463177 L524.185504,290.248267 C524.185504,291.309682 525.160273,291.840389 527.120641,291.840389 L527.95461,291.840389 C529.914978,291.840389 530.889747,291.309682 530.889747,290.248267 L530.889747,262.705632 C530.889747,261.774187 530.889747,260.994372 530.889747,260.377018 C530.889747,259.759664 530.846424,259.088157 530.759778,258.362496 L531.019716,258.297511 C531.35547,258.979849 531.702055,259.629695 532.037808,260.247049 C532.373562,260.864402 532.76347,261.492587 533.185869,262.131602 L552.0314,290.692328 C552.323831,291.114728 552.702907,291.41799 553.146969,291.591282 C553.59103,291.764574 554.15423,291.85122 554.836568,291.85122 L556.42869,291.85122 C558.389059,291.85122 559.363828,291.320513 559.363828,290.259098 L559.363828,248.474008 C559.39632,247.390931 558.41072,246.860224 556.450352,246.860224 Z","id":"Path"}}),_c('path',{attrs:{"d":"M604.788055,284.107223 C604.387317,283.554854 603.964917,283.273255 603.542517,283.273255 C603.282579,283.273255 602.697717,283.522362 601.787933,284.009747 C600.878149,284.497131 599.665103,284.995346 598.181288,285.515223 C596.686643,286.024269 594.877905,286.284207 592.755075,286.284207 C588.108677,286.284207 584.675325,284.897869 582.433356,282.125193 C580.202219,279.363348 579.075819,275.096027 579.075819,269.344891 C579.075819,263.507109 580.202219,259.239788 582.465849,256.532096 C584.718648,253.824405 588.216985,252.47056 592.939198,252.47056 C594.986213,252.47056 596.686643,252.687175 598.051319,253.109575 C599.415996,253.531975 600.46658,253.965205 601.213902,254.387605 C601.961225,254.810005 602.45944,255.02662 602.719379,255.02662 C603.055132,255.02662 603.44504,254.755851 603.86744,254.192651 C604.28984,253.640282 604.668916,253.012098 604.983009,252.308098 C605.307932,251.604099 605.459562,251.06256 605.459562,250.672653 C605.459562,250.076961 604.928855,249.481269 603.86744,248.885577 C603.098456,248.419854 602.134517,248.008285 600.964795,247.672531 C599.795072,247.336777 598.517042,247.055177 597.130704,246.838562 C595.744366,246.632778 594.325536,246.52447 592.885044,246.52447 C579.000004,246.52447 572.057484,254.106005 572.057484,269.269076 C572.057484,277.099719 573.736252,282.872516 577.10462,286.587469 C580.472988,290.29159 585.682586,292.143651 592.755075,292.143651 C594.249721,292.143651 595.701043,292.024512 597.130704,291.797066 C598.560365,291.55879 599.881718,291.266359 601.094764,290.898113 C602.30781,290.540698 603.315071,290.118298 604.127378,289.652575 C604.809716,289.316821 605.329593,288.926914 605.697839,288.504514 C606.055254,288.082114 606.239377,287.670545 606.239377,287.291468 C606.239377,286.999038 606.098577,286.522484 605.827808,285.883469 C605.535378,285.266115 605.188793,284.670423 604.788055,284.107223 Z","id":"Path"}}),_c('path',{attrs:{"d":"M642.327485,285.840146 L624.695,285.840146 L624.695,271.781813 L640.41044,271.781813 C641.385209,271.781813 641.883424,271.012829 641.883424,269.485691 L641.883424,268.207661 C641.883424,266.669692 641.39604,265.911539 640.41044,265.911539 L624.695,265.911539 L624.695,252.882129 L642.262501,252.882129 C643.23727,252.882129 643.735485,252.113144 643.735485,250.586007 L643.735485,249.307976 C643.735485,247.770008 643.2481,247.011854 642.262501,247.011854 L619.961956,247.011854 C618.553957,247.011854 617.849957,247.715854 617.849957,249.123853 L617.849957,289.630913 C617.849957,291.038913 618.553957,291.742913 619.961956,291.742913 L642.327485,291.742913 C643.302254,291.742913 643.800469,290.973928 643.800469,289.44679 L643.800469,288.16876 C643.789639,286.60913 643.302254,285.840146 642.327485,285.840146 Z","id":"Path"}})])])])])
}
var home_hero_es_svgvue_type_template_id_27af79df_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-es-svg.vue?vue&type=template&id=27af79df

// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-es-svg.vue

var home_hero_es_svg_script = {}


/* normalize component */

var home_hero_es_svg_component = normalizeComponent(
  home_hero_es_svg_script,
  home_hero_es_svgvue_type_template_id_27af79df_render,
  home_hero_es_svgvue_type_template_id_27af79df_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var home_hero_es_svg = (home_hero_es_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/home-hero-ch-svg.vue?vue&type=template&id=3d35fc11
var home_hero_ch_svgvue_type_template_id_3d35fc11_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"636","height":"80","viewBox":"0 0 636 80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M25.4338 47.8202C24.0543 48.3457 22.7406 48.8383 21.4925 49.2982C20.2445 49.6923 18.9964 50.1521 17.7484 50.6776C17.4199 50.809 16.9273 51.0389 16.2704 51.3673C15.7449 51.6301 15.2194 51.7943 14.6939 51.86C14.1684 51.86 13.7414 51.4987 13.413 50.7761C12.9532 49.9879 12.8546 49.2982 13.1174 48.707C13.4458 48.1158 13.8728 47.6231 14.3983 47.229C15.1209 46.7035 15.8434 46.2108 16.566 45.751C17.3542 45.2912 18.1425 44.8643 18.9307 44.4701C20.1131 43.9446 21.2955 43.4848 22.4779 43.0907C23.6602 42.6966 24.8098 42.3024 25.9264 41.9083C26.7804 37.573 27.6015 33.3361 28.3897 29.1978C29.178 25.0595 29.9662 20.8555 30.7545 16.5858C30.6231 16.5858 30.426 16.553 30.1633 16.4873C29.9662 16.4216 29.7692 16.4545 29.5721 16.5858C26.6162 17.6368 23.7259 18.7207 20.9014 19.8374C18.0768 20.8884 15.1865 21.9722 12.2306 23.0889C11.7051 23.3516 11.1796 23.6472 10.6541 23.9757C10.1943 24.2384 10.0301 24.8296 10.1615 25.7492C10.2272 25.8806 10.1943 26.0448 10.0629 26.2419C9.99724 26.3733 9.93156 26.5046 9.86587 26.636C9.53743 27.1615 8.97909 27.5556 8.19084 27.8184C7.40259 28.0811 6.54866 28.2453 5.62903 28.311C4.7751 28.3767 3.92116 28.311 3.06722 28.114C2.27897 27.9169 1.72063 27.5885 1.39219 27.1287C0.866695 26.4718 0.636789 25.7164 0.702476 24.8624C0.702476 23.9428 1.06376 23.1217 1.78632 22.3992C3.4285 20.8884 5.13638 19.6074 6.90994 18.5565C10.0629 16.7829 13.2816 15.2392 16.566 13.9255C19.8504 12.5461 23.1676 11.298 26.5176 10.1813C33.6776 7.81656 40.8046 5.97731 47.8989 4.66356C55.0588 3.34982 62.3173 2.43019 69.6743 1.90469C70.7909 1.77332 71.9076 1.77332 73.0243 1.90469C74.141 2.03607 75.2577 2.20028 76.3744 2.39735C77.2283 2.46303 78.1479 2.89 79.1332 3.67825C80.2499 4.4665 80.7097 5.68172 80.5127 7.3239C80.447 7.91509 80.1514 8.53912 79.6259 9.19599C79.1661 9.85287 78.6077 10.4441 77.9509 10.9696C77.3597 11.4951 76.7028 11.922 75.9802 12.2505C75.3234 12.5789 74.7322 12.6774 74.2067 12.5461C73.3528 12.4147 72.7616 11.9877 72.4331 11.2652C72.1047 10.5426 71.8091 9.68865 71.5463 8.70334C70.4297 8.76903 69.313 8.83471 68.1963 8.9004C67.0796 8.96609 65.9629 9.06462 64.8462 9.19599C60.7079 9.52443 56.6681 10.0828 52.7269 10.871C48.8513 11.6593 44.8773 12.5461 40.8046 13.5314C40.1478 13.6627 39.5566 13.8926 39.0311 14.2211C38.5713 14.5495 38.2428 15.1407 38.0458 15.9946C37.3889 19.6074 36.732 23.2203 36.0751 26.8331C35.4183 30.3802 34.7614 33.9273 34.1045 37.4744C34.0388 37.8029 34.006 38.0985 34.006 38.3612C34.006 38.624 34.006 39.0181 34.006 39.5436C35.7139 39.1495 37.356 38.7882 38.9325 38.4597C40.5747 38.0656 42.1841 37.7043 43.7606 37.3759C44.2861 37.2445 44.7787 37.146 45.2385 37.0803C45.764 37.0146 46.2895 37.0475 46.815 37.1788C47.1435 37.2445 47.4719 37.4416 47.8003 37.77C48.1288 38.0985 48.3258 38.4269 48.3915 38.7553C48.5229 39.1495 48.4901 39.6093 48.293 40.1348C48.0959 40.6603 47.8989 40.9887 47.7018 41.1201C47.242 41.5142 46.7165 41.8098 46.1253 42.0069C45.5998 42.2039 45.0743 42.401 44.5488 42.598C42.6439 43.1235 40.7389 43.649 38.834 44.1745C36.9948 44.6343 35.0898 45.127 33.1192 45.6525C32.9878 46.3751 32.8565 47.0648 32.7251 47.7217C32.5937 48.3785 32.4952 49.0683 32.4295 49.7908C32.2981 52.5497 32.1667 55.3086 32.0354 58.0674C31.9697 60.8263 31.904 63.5852 31.8383 66.344C31.8383 67.198 31.904 68.0191 32.0354 68.8073C32.2324 69.5956 32.3966 70.3838 32.528 71.1721C33.0535 73.2741 32.6594 74.8177 31.3457 75.803C30.6231 76.3285 29.8348 76.5256 28.9809 76.3942C28.1927 76.3285 27.5029 75.8359 26.9118 74.9162C26.3206 74.128 25.9264 73.1755 25.7294 72.0588C25.598 70.8765 25.4666 69.6613 25.3353 68.4132C25.2039 67.1651 25.1382 65.9171 25.1382 64.669C25.1382 61.9758 25.171 59.2826 25.2367 56.5895C25.3024 53.8306 25.3681 50.9075 25.4338 47.8202Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M58.4456 56.5895C58.774 56.8522 59.3323 56.6223 60.1206 55.8997C60.9745 55.1115 61.8941 54.1262 62.8795 52.9438C63.8648 51.7614 64.8829 50.5462 65.9339 49.2982C67.0506 47.9844 68.0031 46.9663 68.7913 46.2437C69.1854 45.9153 69.5796 45.751 69.9737 45.751C70.4335 45.751 70.8276 45.8824 71.1561 46.1452C71.4845 46.3422 71.6816 46.6378 71.7473 47.0319C71.8786 47.4261 71.8129 47.8859 71.5502 48.4114C71.2217 49.0026 70.8276 49.5937 70.3678 50.1849C69.0541 51.5644 67.7732 52.9766 66.5251 54.4218C65.3427 55.8669 64.0947 57.2792 62.7809 58.6586C62.0584 59.3812 61.1716 60.0052 60.1206 60.5307C58.2156 61.516 56.4749 61.6474 54.8984 60.9248C53.3876 60.2023 52.468 58.79 52.1396 56.688C51.8111 54.586 51.8768 52.3198 52.3366 49.8893C52.7964 47.4589 53.4533 45.2912 54.3072 43.3863C54.6357 42.5324 55.1283 41.9412 55.7852 41.6127C56.4421 41.2843 57.1318 41.2515 57.8544 41.5142C59.3652 42.0397 60.022 43.1564 59.825 44.8643C59.7593 45.9153 59.5951 47.1633 59.3323 48.6084C59.1353 50.0536 58.9711 51.3016 58.8397 52.3526C58.7083 52.8781 58.6426 53.5022 58.6426 54.2247C58.6426 54.8816 58.5769 55.6698 58.4456 56.5895ZM58.7411 34.0258C59.0696 34.0258 59.398 34.1901 59.7265 34.5185C60.1206 34.7812 60.449 35.1097 60.7118 35.5038C61.0402 35.8322 61.2701 36.1935 61.4015 36.5876C61.5985 36.9818 61.6642 37.3102 61.5985 37.573C61.4672 37.9014 61.2044 38.2298 60.8103 38.5583C60.4162 38.8867 60.0549 39.0838 59.7265 39.1495C59.3323 39.1495 58.9382 39.0509 58.5441 38.8539C58.15 38.6568 57.7887 38.394 57.4602 38.0656C57.1975 37.6715 56.9676 37.2774 56.7705 36.8832C56.5735 36.4891 56.4749 36.1278 56.4749 35.7994C56.6063 35.2739 56.8691 34.8469 57.2632 34.5185C57.6573 34.1244 58.15 33.9601 58.7411 34.0258Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M83.417 42.0069C84.7308 41.0215 86.0774 40.726 87.4568 41.1201C88.8362 41.5142 89.6902 42.5652 90.0186 44.2731C90.15 45.1927 90.2157 46.3422 90.2157 47.7217C90.2157 49.1011 90.2157 50.4805 90.2157 51.86C90.2814 53.1737 90.3799 54.3232 90.5113 55.3086C90.7083 56.2939 91.0368 56.8194 91.4966 56.8851C91.825 56.8851 92.2848 56.5895 92.876 55.9983C93.6643 55.21 94.4854 54.2576 95.3393 53.1409C96.2589 52.0242 97.1129 50.9403 97.9011 49.8893C98.6893 48.7727 99.3791 47.8202 99.9703 47.0319C100.561 46.178 100.956 45.6525 101.153 45.4554C101.415 45.1927 101.711 45.0942 102.039 45.1598C102.368 45.2255 102.631 45.3898 102.828 45.6525C103.09 45.9153 103.287 46.2437 103.419 46.6378C103.55 47.0319 103.583 47.3604 103.517 47.6231C103.386 48.4114 102.893 49.4624 102.039 50.7761C101.185 52.0899 100.2 53.4365 99.0835 54.8159C97.9668 56.1296 96.7844 57.3449 95.5364 58.4615C94.354 59.5125 93.3358 60.2023 92.4819 60.5307C91.2338 60.9905 90.0186 60.9905 88.8362 60.5307C87.7196 60.0709 86.8985 59.0199 86.373 57.3777C86.0445 56.3267 85.8146 55.21 85.6832 54.0276C85.6176 52.7796 85.519 51.5972 85.3876 50.4805C85.322 49.8893 85.2891 49.2982 85.2891 48.707C85.2891 48.0501 85.2563 47.2947 85.1906 46.4408C84.0739 47.4261 83.1543 48.4771 82.4317 49.5938C81.7092 50.6447 81.0194 51.7286 80.3626 52.8453C79.7057 53.962 79.0488 55.0786 78.3919 56.1953C77.7351 57.312 76.9468 58.363 76.0272 59.3483C74.9105 60.268 73.6624 60.7278 72.283 60.7278C70.9036 60.6621 69.8197 60.0052 69.0315 58.7571C68.506 57.9689 68.2104 57.0493 68.1447 55.9983C68.079 54.9473 68.0133 53.9291 67.9476 52.9438C67.9476 50.5134 68.1119 48.0829 68.4403 45.6525C68.703 43.1564 69.2286 40.7259 70.0168 38.3612C70.2139 37.77 70.4109 37.2774 70.608 36.8832C71.4619 34.8469 72.6443 34.1572 74.1551 34.8141C74.812 34.9455 75.3375 35.3724 75.7316 36.095C76.1914 36.7519 76.2571 37.6058 75.9287 38.6568C75.4689 40.1676 75.0419 41.7113 74.6478 43.2878C74.3193 44.8643 74.0894 46.3422 73.958 47.7217C73.8267 49.1011 73.761 50.3163 73.761 51.3673C73.8267 52.3526 74.0237 53.0752 74.3522 53.535C74.7463 53.8634 75.2718 53.535 75.9287 52.5497C76.6512 51.5644 77.4066 50.382 78.1949 49.0026C79.0488 47.6231 79.9028 46.2437 80.7567 44.8643C81.6763 43.4848 82.5631 42.5324 83.417 42.0069Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M113.193 38.1641C113.39 37.6386 113.62 37.0475 113.882 36.3906C114.145 35.668 114.408 34.9455 114.671 34.2229C115.656 31.464 116.608 28.6723 117.528 25.8478C118.513 23.0232 119.466 20.2315 120.385 17.4726C120.517 17.2755 120.648 17.0456 120.78 16.7829C120.911 16.5201 121.042 16.2574 121.174 15.9946C121.896 14.6809 122.98 14.1882 124.425 14.5167C125.739 14.8451 126.462 15.6662 126.593 16.98C126.724 17.6368 126.757 18.2937 126.691 18.9506C126.691 19.6074 126.626 20.2972 126.494 21.0197C125.772 25.4865 125.082 29.9204 124.425 34.3214C123.768 38.6568 123.079 43.0907 122.356 47.6231C122.028 49.331 121.765 51.0717 121.568 52.8453C121.371 54.5531 121.141 56.2939 120.878 58.0674C120.812 58.3959 120.747 58.6915 120.681 58.9542C120.681 59.217 120.615 59.5125 120.484 59.841C119.958 61.6802 118.842 62.5342 117.134 62.4028C116.346 62.3371 115.689 62.0744 115.163 61.6145C114.638 61.1547 114.342 60.465 114.277 59.5454C114.145 58.5601 114.079 57.5419 114.079 56.4909C114.145 55.4399 114.211 54.3889 114.277 53.3379C114.342 52.6154 114.375 51.8928 114.375 51.1702C114.441 50.4477 114.408 49.6923 114.277 48.904C113.817 49.3638 113.455 49.8237 113.193 50.2835C112.273 51.4658 111.386 52.6811 110.532 53.9291C109.678 55.1115 108.792 56.261 107.872 57.3777C107.478 57.9032 106.985 58.363 106.394 58.7571C105.803 59.1513 105.212 59.5125 104.62 59.841C103.175 60.5635 101.829 60.6292 100.581 60.038C99.3983 59.3812 98.5772 58.2645 98.1174 56.688C97.986 56.1625 97.9203 55.6698 97.9203 55.21C98.0517 51.9913 98.7743 49.1011 100.088 46.5393C101.402 43.9118 103.504 41.7441 106.394 40.0362C107.314 39.5107 108.332 39.1495 109.448 38.9524C110.631 38.7553 111.879 38.4926 113.193 38.1641ZM103.34 55.1115C104.259 54.4546 105.146 53.6335 106 52.6482C106.854 51.6629 107.609 50.6447 108.266 49.5938C108.989 48.4771 109.58 47.3604 110.04 46.2437C110.499 45.127 110.762 44.1089 110.828 43.1892C109.777 43.3206 108.759 43.7476 107.773 44.4701C106.788 45.1927 105.934 46.1123 105.212 47.229C104.555 48.3457 104.029 49.5938 103.635 50.9732C103.307 52.3526 103.208 53.7321 103.34 55.1115Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M130.314 51.0717C130.117 52.3855 130.183 53.3379 130.511 53.9291C130.905 54.5203 131.431 54.8816 132.088 55.013C132.81 55.1443 133.598 55.1443 134.452 55.013C135.372 54.8159 136.259 54.5532 137.113 54.2247C139.74 53.3708 141.941 52.2869 143.714 50.9732C145.488 49.6594 147.36 48.1486 149.33 46.4408C150.184 45.6525 150.907 45.2255 151.498 45.1598C152.089 45.0942 152.516 45.2255 152.779 45.554C153.108 45.8824 153.239 46.4079 153.173 47.1305C153.108 47.7873 152.812 48.4442 152.286 49.1011C151.367 50.2835 150.086 51.5315 148.444 52.8453C146.867 54.159 145.126 55.3742 143.222 56.4909C141.382 57.6076 139.477 58.5272 137.507 59.2498C135.602 59.9067 133.861 60.2023 132.285 60.1366C129.197 59.8081 126.964 58.6258 125.584 56.5895C124.139 54.5531 123.844 52.057 124.698 49.1011C125.355 46.8677 126.438 44.8971 127.949 43.1892C128.606 42.401 129.526 41.547 130.708 40.6274C131.89 39.6421 133.106 38.8539 134.354 38.2627C135.668 37.6058 136.948 37.2774 138.196 37.2774C139.51 37.2117 140.627 37.6715 141.547 38.6568C142.663 39.7735 142.959 41.1529 142.433 42.7951C141.908 44.4373 140.955 45.9809 139.576 47.4261C138.262 48.8055 136.719 49.8893 134.945 50.6776C133.237 51.4658 131.693 51.5972 130.314 51.0717ZM138.098 41.9083C135.208 43.1564 133.336 44.8971 132.482 47.1305C133.664 46.802 134.715 46.2765 135.635 45.554C136.62 44.8314 137.441 43.6162 138.098 41.9083Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M188.342 38.1641C188.539 37.6386 188.769 37.0475 189.032 36.3906C189.294 35.668 189.557 34.9455 189.82 34.2229C190.805 31.464 191.758 28.6723 192.677 25.8478C193.663 23.0232 194.615 20.2315 195.535 17.4726C195.666 17.2755 195.797 17.0456 195.929 16.7829C196.06 16.5201 196.192 16.2574 196.323 15.9946C197.045 14.6809 198.129 14.1882 199.574 14.5167C200.888 14.8451 201.611 15.6662 201.742 16.98C201.873 17.6368 201.906 18.2937 201.841 18.9506C201.841 19.6074 201.775 20.2972 201.644 21.0197C200.921 25.4865 200.231 29.9204 199.574 34.3214C198.918 38.6568 198.228 43.0907 197.505 47.6231C197.177 49.331 196.914 51.0717 196.717 52.8453C196.52 54.5531 196.29 56.2939 196.027 58.0674C195.962 58.3959 195.896 58.6915 195.83 58.9542C195.83 59.217 195.765 59.5125 195.633 59.841C195.108 61.6802 193.991 62.5342 192.283 62.4028C191.495 62.3371 190.838 62.0744 190.312 61.6145C189.787 61.1547 189.491 60.465 189.426 59.5454C189.294 58.5601 189.229 57.5419 189.229 56.4909C189.294 55.4399 189.36 54.3889 189.426 53.3379C189.491 52.6154 189.524 51.8928 189.524 51.1702C189.59 50.4477 189.557 49.6923 189.426 48.904C188.966 49.3638 188.605 49.8237 188.342 50.2835C187.422 51.4658 186.535 52.6811 185.682 53.9291C184.828 55.1115 183.941 56.261 183.021 57.3777C182.627 57.9032 182.134 58.363 181.543 58.7571C180.952 59.1513 180.361 59.5125 179.77 59.841C178.325 60.5635 176.978 60.6292 175.73 60.038C174.548 59.3812 173.726 58.2645 173.267 56.688C173.135 56.1625 173.07 55.6698 173.07 55.21C173.201 51.9913 173.923 49.1011 175.237 46.5393C176.551 43.9118 178.653 41.7441 181.543 40.0362C182.463 39.5107 183.481 39.1495 184.598 38.9524C185.78 38.7553 187.028 38.4926 188.342 38.1641ZM178.489 55.1115C179.408 54.4546 180.295 53.6335 181.149 52.6482C182.003 51.6629 182.758 50.6447 183.415 49.5938C184.138 48.4771 184.729 47.3604 185.189 46.2437C185.649 45.127 185.911 44.1089 185.977 43.1892C184.926 43.3206 183.908 43.7476 182.923 44.4701C181.937 45.1927 181.083 46.1123 180.361 47.229C179.704 48.3457 179.178 49.5938 178.784 50.9732C178.456 52.3526 178.357 53.7321 178.489 55.1115Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M205.463 51.0717C205.266 52.3855 205.332 53.3379 205.66 53.9291C206.054 54.5203 206.58 54.8816 207.237 55.013C207.959 55.1443 208.748 55.1443 209.602 55.013C210.521 54.8159 211.408 54.5532 212.262 54.2247C214.889 53.3708 217.09 52.2869 218.863 50.9732C220.637 49.6594 222.509 48.1486 224.48 46.4408C225.334 45.6525 226.056 45.2255 226.647 45.1598C227.239 45.0942 227.666 45.2255 227.928 45.554C228.257 45.8824 228.388 46.4079 228.322 47.1305C228.257 47.7873 227.961 48.4442 227.436 49.1011C226.516 50.2835 225.235 51.5315 223.593 52.8453C222.016 54.159 220.276 55.3742 218.371 56.4909C216.532 57.6076 214.627 58.5272 212.656 59.2498C210.751 59.9067 209.01 60.2023 207.434 60.1366C204.347 59.8081 202.113 58.6258 200.734 56.5895C199.289 54.5531 198.993 52.057 199.847 49.1011C200.504 46.8677 201.588 44.8971 203.098 43.1892C203.755 42.401 204.675 41.547 205.857 40.6274C207.04 39.6421 208.255 38.8539 209.503 38.2627C210.817 37.6058 212.098 37.2774 213.346 37.2774C214.659 37.2117 215.776 37.6715 216.696 38.6568C217.812 39.7735 218.108 41.1529 217.583 42.7951C217.057 44.4373 216.105 45.9809 214.725 47.4261C213.411 48.8055 211.868 49.8893 210.094 50.6776C208.386 51.4658 206.843 51.5972 205.463 51.0717ZM213.247 41.9083C210.357 43.1564 208.485 44.8971 207.631 47.1305C208.813 46.802 209.864 46.2765 210.784 45.554C211.769 44.8314 212.59 43.6162 213.247 41.9083Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M229.335 56.5895C229.664 56.8522 230.222 56.6223 231.01 55.8997C231.864 55.1115 232.784 54.1262 233.769 52.9438C234.755 51.7614 235.773 50.5462 236.824 49.2982C237.94 47.9844 238.893 46.9663 239.681 46.2437C240.075 45.9153 240.469 45.751 240.864 45.751C241.323 45.751 241.718 45.8824 242.046 46.1452C242.374 46.3422 242.571 46.6378 242.637 47.0319C242.769 47.4261 242.703 47.8859 242.44 48.4114C242.112 49.0026 241.718 49.5937 241.258 50.1849C239.944 51.5644 238.663 52.9766 237.415 54.4218C236.233 55.8669 234.985 57.2792 233.671 58.6586C232.948 59.3812 232.061 60.0052 231.01 60.5307C229.106 61.516 227.365 61.6474 225.788 60.9248C224.278 60.2023 223.358 58.79 223.029 56.688C222.701 54.586 222.767 52.3198 223.227 49.8893C223.686 47.4589 224.343 45.2912 225.197 43.3863C225.526 42.5324 226.018 41.9412 226.675 41.6127C227.332 41.2843 228.022 41.2515 228.744 41.5142C230.255 42.0397 230.912 43.1564 230.715 44.8643C230.649 45.9153 230.485 47.1633 230.222 48.6084C230.025 50.0536 229.861 51.3016 229.73 52.3526C229.598 52.8781 229.533 53.5022 229.533 54.2247C229.533 54.8816 229.467 55.6698 229.335 56.5895ZM229.631 34.0258C229.959 34.0258 230.288 34.1901 230.616 34.5185C231.01 34.7812 231.339 35.1097 231.602 35.5038C231.93 35.8322 232.16 36.1935 232.291 36.5876C232.488 36.9818 232.554 37.3102 232.488 37.573C232.357 37.9014 232.094 38.2298 231.7 38.5583C231.306 38.8867 230.945 39.0838 230.616 39.1495C230.222 39.1495 229.828 39.0509 229.434 38.8539C229.04 38.6568 228.679 38.394 228.35 38.0656C228.087 37.6715 227.857 37.2774 227.66 36.8832C227.463 36.4891 227.365 36.1278 227.365 35.7994C227.496 35.2739 227.759 34.8469 228.153 34.5185C228.547 34.1244 229.04 33.9601 229.631 34.0258Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M254.307 42.0069C255.621 41.0215 256.967 40.726 258.347 41.1201C259.726 41.5142 260.58 42.5652 260.909 44.2731C261.04 45.1927 261.106 46.3422 261.106 47.7217C261.106 49.1011 261.106 50.4805 261.106 51.86C261.171 53.1737 261.27 54.3232 261.401 55.3086C261.598 56.2939 261.927 56.8194 262.386 56.8851C262.715 56.8851 263.175 56.5895 263.766 55.9983C264.554 55.21 265.375 54.2576 266.229 53.1409C267.149 52.0242 268.003 50.9403 268.791 49.8893C269.579 48.7727 270.269 47.8202 270.86 47.0319C271.451 46.178 271.845 45.6525 272.043 45.4554C272.305 45.1927 272.601 45.0942 272.929 45.1598C273.258 45.2255 273.52 45.3898 273.718 45.6525C273.98 45.9153 274.177 46.2437 274.309 46.6378C274.44 47.0319 274.473 47.3604 274.407 47.6231C274.276 48.4114 273.783 49.4624 272.929 50.7761C272.075 52.0899 271.09 53.4365 269.973 54.8159C268.857 56.1296 267.674 57.3449 266.426 58.4615C265.244 59.5125 264.226 60.2023 263.372 60.5307C262.124 60.9905 260.909 60.9905 259.726 60.5307C258.609 60.0709 257.788 59.0199 257.263 57.3777C256.934 56.3267 256.705 55.21 256.573 54.0276C256.507 52.7796 256.409 51.5972 256.278 50.4805C256.212 49.8893 256.179 49.2982 256.179 48.707C256.179 48.0501 256.146 47.2947 256.08 46.4408C254.964 47.4261 254.044 48.4771 253.322 49.5938C252.599 50.6447 251.909 51.7286 251.252 52.8453C250.596 53.962 249.939 55.0786 249.282 56.1953C248.625 57.312 247.837 58.363 246.917 59.3483C245.8 60.268 244.552 60.7278 243.173 60.7278C241.793 60.6621 240.71 60.0052 239.921 58.7571C239.396 57.9689 239.1 57.0493 239.035 55.9983C238.969 54.9473 238.903 53.9291 238.838 52.9438C238.838 50.5134 239.002 48.0829 239.33 45.6525C239.593 43.1564 240.118 40.7259 240.907 38.3612C241.104 37.77 241.301 37.2774 241.498 36.8832C242.352 34.8469 243.534 34.1572 245.045 34.8141C245.702 34.9455 246.227 35.3724 246.621 36.095C247.081 36.7519 247.147 37.6058 246.819 38.6568C246.359 40.1676 245.932 41.7113 245.538 43.2878C245.209 44.8643 244.979 46.3422 244.848 47.7217C244.717 49.1011 244.651 50.3163 244.651 51.3673C244.717 52.3526 244.914 53.0752 245.242 53.535C245.636 53.8634 246.162 53.535 246.819 52.5497C247.541 51.5644 248.297 50.382 249.085 49.0026C249.939 47.6231 250.793 46.2437 251.647 44.8643C252.566 43.4848 253.453 42.5324 254.307 42.0069Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M275.609 51.0717C275.412 52.3855 275.478 53.3379 275.806 53.9291C276.2 54.5203 276.726 54.8816 277.382 55.013C278.105 55.1443 278.893 55.1443 279.747 55.013C280.667 54.8159 281.554 54.5532 282.408 54.2247C285.035 53.3708 287.236 52.2869 289.009 50.9732C290.783 49.6594 292.655 48.1486 294.625 46.4408C295.479 45.6525 296.202 45.2255 296.793 45.1598C297.384 45.0942 297.811 45.2255 298.074 45.554C298.402 45.8824 298.534 46.4079 298.468 47.1305C298.402 47.7873 298.107 48.4442 297.581 49.1011C296.662 50.2835 295.381 51.5315 293.739 52.8453C292.162 54.159 290.421 55.3742 288.516 56.4909C286.677 57.6076 284.772 58.5272 282.802 59.2498C280.897 59.9067 279.156 60.2023 277.579 60.1366C274.492 59.8081 272.259 58.6258 270.879 56.5895C269.434 54.5531 269.139 52.057 269.993 49.1011C270.649 46.8677 271.733 44.8971 273.244 43.1892C273.901 42.401 274.821 41.547 276.003 40.6274C277.185 39.6421 278.401 38.8539 279.649 38.2627C280.962 37.6058 282.243 37.2774 283.491 37.2774C284.805 37.2117 285.922 37.6715 286.841 38.6568C287.958 39.7735 288.254 41.1529 287.728 42.7951C287.203 44.4373 286.25 45.9809 284.871 47.4261C283.557 48.8055 282.013 49.8893 280.24 50.6776C278.532 51.4658 276.988 51.5972 275.609 51.0717ZM283.393 41.9083C280.503 43.1564 278.63 44.8971 277.777 47.1305C278.959 46.802 280.01 46.2765 280.93 45.554C281.915 44.8314 282.736 43.6162 283.393 41.9083Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M342.012 16.8814C340.238 17.4726 338.465 18.031 336.691 18.5565C334.983 19.0819 333.275 19.6403 331.568 20.2315C330.582 20.5599 329.597 20.8884 328.612 21.2168C327.692 21.5452 326.772 21.8737 325.853 22.2021C325.065 22.4648 324.211 22.5962 323.291 22.5962C322.7 22.5305 322.174 22.3335 321.715 22.005C321.32 21.6766 321.123 21.1839 321.123 20.5271C321.123 20.1329 321.255 19.7388 321.517 19.3447C321.78 18.8849 322.076 18.4908 322.404 18.1623C322.733 17.8339 323.094 17.5711 323.488 17.3741C323.882 17.177 324.309 17.0128 324.769 16.8814C328.973 15.5677 333.144 14.2211 337.282 12.8416C341.421 11.3965 345.592 10.1156 349.796 8.99893C355.379 7.48812 360.963 6.10869 366.546 4.86062C372.13 3.61256 377.713 2.3645 383.296 1.11644C383.625 1.05076 383.921 0.985069 384.183 0.919382C384.446 0.853696 384.742 0.853696 385.07 0.919382C385.661 0.985069 386.154 1.21497 386.548 1.6091C387.008 1.93753 387.238 2.46303 387.238 3.1856C387.172 3.64541 387.008 4.17091 386.745 4.76209C386.548 5.28759 386.285 5.61603 385.957 5.7474C385.234 6.20722 384.512 6.53566 383.789 6.73272C383.132 6.92978 382.443 7.12684 381.72 7.3239C378.633 8.04646 375.578 8.73618 372.557 9.39305C369.535 10.0499 366.513 10.7396 363.492 11.4622C361.061 11.9877 358.664 12.5789 356.299 13.2358C354 13.827 351.602 14.3853 349.106 14.9108C349.435 16.4216 349.402 17.7682 349.008 18.9506C348.679 20.1329 348.351 21.3482 348.022 22.5962C345.92 29.362 343.983 36.1278 342.209 42.8936C340.435 49.5937 339.089 56.4909 338.169 63.5852C338.038 64.7019 337.939 65.8185 337.874 66.9352C337.874 68.0519 338.268 69.1686 339.056 70.2853C339.647 71.1392 339.68 72.2559 339.155 73.6353C338.695 74.9491 337.972 75.9344 336.987 76.5913C336.067 77.2481 335.049 77.4452 333.932 77.1825C332.881 76.9854 332.093 76.3285 331.568 75.2118C330.911 73.8324 330.517 72.3544 330.385 70.7779C330.123 68.1504 330.123 65.5558 330.385 62.994C330.714 60.4322 331.108 57.8704 331.568 55.3086C332.422 50.1192 333.44 44.9956 334.622 39.9377C335.804 34.8141 337.348 29.789 339.253 24.8624C339.779 23.6144 340.271 22.3992 340.731 21.2168C341.257 20.0344 341.749 18.8192 342.209 17.5711C342.078 17.3084 342.012 17.0785 342.012 16.8814Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M358.149 43.1892C358.806 42.5324 359.332 42.0069 359.726 41.6127C360.12 41.2186 360.514 40.8573 360.908 40.5289C361.697 39.872 362.452 39.2151 363.175 38.5583C363.963 37.9014 364.784 37.343 365.638 36.8832C367.871 35.7665 369.776 35.9965 371.353 37.573C372.601 39.0181 372.831 40.923 372.042 43.2878C371.714 44.4044 370.926 44.9299 369.678 44.8643C368.758 44.7329 368.364 44.1417 368.495 43.0907C368.627 42.4338 368.659 41.9083 368.594 41.5142C368.397 40.2005 367.608 39.9377 366.229 40.7259C365.835 40.9887 365.408 41.3171 364.948 41.7113C364.488 42.0397 364.094 42.401 363.766 42.7951C361.729 44.8971 359.989 47.229 358.544 49.7908C357.098 52.2869 356.376 54.9144 356.376 57.6733C356.376 58.6586 356.08 59.5454 355.489 60.3336C354.964 61.1219 354.241 61.6145 353.321 61.8116C352.468 62.0087 351.712 61.8773 351.055 61.4175C350.464 60.9577 350.103 60.2351 349.971 59.2498C349.84 58.3959 349.807 57.0164 349.873 55.1115C349.873 53.1409 350.004 51.0717 350.267 48.904C350.464 46.6707 350.825 44.4701 351.351 42.3024C351.876 40.0691 352.533 38.197 353.321 36.6862C353.716 35.9636 354.241 35.4381 354.898 35.1097C355.555 34.7812 356.212 34.6499 356.869 34.7155C358.379 34.9126 359.036 35.8651 358.839 37.573C358.773 38.4269 358.675 39.3137 358.544 40.2333C358.412 41.0872 358.281 42.0725 358.149 43.1892Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M385.252 51.2688C384.596 52.1227 383.972 52.911 383.38 53.6335C382.789 54.2904 382.198 54.9473 381.607 55.6041C381.016 56.1296 380.392 56.688 379.735 57.2792C379.144 57.8704 378.519 58.3302 377.863 58.6586C376.68 59.3812 375.596 59.5454 374.611 59.1513C373.56 58.6915 372.838 57.8047 372.443 56.4909C372.115 55.5713 372.016 54.6845 372.148 53.8306C372.673 50.8747 373.593 48.1815 374.907 45.751C376.22 43.3206 378.125 41.2515 380.621 39.5436C382.264 38.4269 383.906 37.8029 385.548 37.6715C387.19 37.5401 388.865 37.9999 390.573 39.0509C391.558 39.6421 392.215 40.2333 392.544 40.8245C392.872 41.35 392.938 42.2039 392.741 43.3863C392.609 44.4373 392.412 45.4883 392.15 46.5393C391.953 47.5246 391.788 48.5756 391.657 49.6923C391.526 50.6776 391.394 51.6957 391.263 52.7467C391.131 53.7321 391.131 54.5203 391.263 55.1115C391.46 55.7027 391.788 55.9983 392.248 55.9983C392.774 55.9983 393.595 55.4399 394.711 54.3232C395.631 53.2722 396.321 52.4512 396.781 51.86C397.306 51.2688 397.766 50.7433 398.16 50.2835C398.62 49.758 399.08 49.1996 399.539 48.6084C400.065 48.0173 400.788 47.229 401.707 46.2437C401.97 45.9809 402.233 45.7182 402.495 45.4554C402.824 45.1927 403.152 44.9956 403.481 44.8643C403.809 44.7329 404.17 44.7657 404.565 44.9628C405.024 45.0942 405.353 45.2912 405.55 45.554C405.747 45.6853 405.813 45.9481 405.747 46.3422C405.747 46.6707 405.714 46.9991 405.648 47.3275C405.583 47.5903 405.353 47.9187 404.959 48.3128C404.17 49.2982 403.546 50.0864 403.087 50.6776C402.627 51.2031 402.2 51.6957 401.806 52.1556C401.412 52.6154 400.952 53.1409 400.426 53.7321C399.966 54.2576 399.31 55.013 398.456 55.9983C397.864 56.7208 397.24 57.3777 396.584 57.9689C395.992 58.5601 395.335 59.1184 394.613 59.6439C392.905 60.7606 391.427 61.2861 390.179 61.2204C388.997 61.1547 388.011 60.6621 387.223 59.7425C386.5 58.8228 385.975 57.6076 385.647 56.0968C385.318 54.586 385.187 52.9766 385.252 51.2688ZM376.877 54.2247C377.534 53.7649 378.388 52.9767 379.439 51.86C380.49 50.7433 381.508 49.5937 382.494 48.4114C383.545 47.1633 384.464 45.9809 385.252 44.8643C386.106 43.6819 386.632 42.7951 386.829 42.2039C385.712 42.0725 384.596 42.3024 383.479 42.8936C382.362 43.4191 381.344 44.2402 380.424 45.3569C379.57 46.4079 378.815 47.7217 378.158 49.2982C377.501 50.809 377.074 52.4512 376.877 54.2247Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M416.826 49.3967C416.169 50.2506 415.61 50.9732 415.15 51.5644C414.756 52.1556 414.329 52.6811 413.87 53.1409C412.95 54.2576 411.932 55.3086 410.815 56.2939C409.764 57.2135 408.549 57.936 407.169 58.4615C405.462 59.2498 403.951 59.2498 402.637 58.4615C401.52 57.8047 400.831 56.7208 400.568 55.21C400.305 53.6992 400.305 52.1556 400.568 50.5791C400.831 48.9369 401.258 47.3932 401.849 45.9481C402.44 44.4373 402.998 43.3863 403.524 42.7951C404.115 42.0725 404.805 41.7113 405.593 41.7113C406.447 41.6456 407.202 41.8098 407.859 42.2039C408.516 42.5324 408.943 43.025 409.14 43.6819C409.403 44.3388 409.239 45.0285 408.647 45.751C408.319 46.1452 408.023 46.7035 407.761 47.4261C407.498 48.0829 407.235 48.8383 406.972 49.6923C406.71 50.4805 406.48 51.2688 406.283 52.057C406.151 52.8453 406.086 53.5021 406.086 54.0276C406.348 54.4218 406.907 54.2576 407.761 53.535C408.68 52.8124 409.666 51.86 410.717 50.6776C411.833 49.4952 412.917 48.2472 413.968 46.9334C415.019 45.554 415.873 44.4701 416.53 43.6819C416.793 43.3534 417.023 43.025 417.22 42.6966C417.482 42.3024 417.778 41.9412 418.106 41.6127C418.501 41.2186 419.026 40.9887 419.683 40.923C420.34 40.7916 420.964 40.7916 421.555 40.923C422.212 40.9887 422.77 41.1858 423.23 41.5142C423.69 41.8426 423.953 42.2696 424.018 42.7951C424.018 43.1235 423.953 43.7476 423.821 44.6672C423.69 45.5868 423.526 46.605 423.329 47.7217C423.197 48.8383 423.066 49.955 422.934 51.0717C422.869 52.1227 422.869 53.0095 422.934 53.7321C423.066 54.4546 423.329 54.8816 423.723 55.013C424.117 55.1443 424.708 54.8159 425.496 54.0276C426.613 52.911 427.664 51.7614 428.649 50.5791C429.7 49.3967 430.751 48.1815 431.802 46.9334C432.525 46.0795 433.215 45.554 433.871 45.3569C434.594 45.1598 435.119 45.2255 435.448 45.554C435.842 45.8167 436.006 46.2765 435.941 46.9334C435.875 47.5903 435.481 48.3128 434.758 49.1011C433.707 50.4148 432.623 51.7614 431.507 53.1409C430.456 54.5203 429.372 55.7684 428.255 56.8851C427.204 57.9361 426.12 58.79 425.004 59.4469C423.953 60.1037 422.902 60.3993 421.851 60.3336C418.303 60.0052 416.628 56.3596 416.826 49.3967Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M456.871 50.6776C457.857 48.904 458.973 47.2618 460.222 45.751C461.47 44.2402 462.849 42.9265 464.36 41.8098C466.068 40.5617 467.546 40.2661 468.794 40.923C470.107 41.5142 470.863 42.8936 471.06 45.0613C471.257 46.8349 471.388 48.5756 471.454 50.2835C471.52 51.9257 471.75 53.6007 472.144 55.3086C474.311 54.1919 476.249 52.7139 477.957 50.8747C479.731 48.9697 481.274 47.3604 482.588 46.0466C483.048 45.5868 483.475 45.3898 483.869 45.4554C484.329 45.4554 484.69 45.6197 484.953 45.9481C485.216 46.2108 485.347 46.605 485.347 47.1305C485.413 47.5903 485.281 48.0829 484.953 48.6084C484.23 49.3967 483.442 50.2835 482.588 51.2688C481.734 52.2541 480.847 53.2066 479.928 54.1262C479.008 55.0458 478.056 55.8997 477.07 56.688C476.085 57.4762 475.1 58.1003 474.114 58.5601C472.407 59.2826 471.027 59.3483 469.976 58.7571C468.991 58.1003 468.235 56.8522 467.71 55.013C467.447 54.2904 467.283 53.535 467.217 52.7467C467.217 51.9585 467.184 51.1702 467.119 50.382C467.053 49.5937 467.02 48.7727 467.02 47.9187C467.086 47.0648 467.119 46.1123 467.119 45.0613C466.068 45.4554 465.148 46.0138 464.36 46.7363C463.572 47.4589 462.882 48.2472 462.291 49.1011C461.699 49.955 461.141 50.8418 460.616 51.7614C460.09 52.6811 459.532 53.535 458.941 54.3232C458.546 54.9801 458.087 55.5713 457.561 56.0968C457.036 56.5566 456.313 56.7208 455.393 56.5895C454.474 56.4581 453.85 56.0968 453.521 55.5056C453.259 54.8487 452.996 54.159 452.733 53.4365C452.536 52.5168 452.306 51.6629 452.043 50.8747C451.846 50.0207 451.682 49.1668 451.551 48.3128C450.631 49.4952 449.843 50.6119 449.186 51.6629C448.595 52.6482 448.004 53.6335 447.412 54.6188C446.953 55.3414 446.526 56.0311 446.132 56.688C445.737 57.3449 445.376 58.0346 445.048 58.7571C444.522 60.0709 443.767 61.0234 442.782 61.6145C441.796 62.14 440.68 62.3371 439.431 62.2057C438.118 62.14 437.1 61.6802 436.377 60.8263C435.72 59.9724 435.195 58.987 434.801 57.8704C434.341 56.4252 434.045 54.7174 433.914 52.7467C433.848 50.7761 433.914 48.8055 434.111 46.8349C434.374 44.7986 434.768 42.8936 435.293 41.1201C435.819 39.2808 436.476 37.8029 437.264 36.6862C437.724 36.1607 438.249 35.8651 438.84 35.7994C439.431 35.7337 439.99 35.7994 440.515 35.9965C441.698 36.4563 442.256 37.2774 442.19 38.4597C442.059 40.0362 441.829 41.6456 441.501 43.2878C441.238 44.8643 441.008 46.4736 440.811 48.1158C440.68 49.6923 440.647 51.2359 440.712 52.7467C440.778 54.2576 441.074 55.6698 441.599 56.9836C442.979 54.6845 444.391 52.4183 445.836 50.1849C447.281 47.8859 448.89 45.8496 450.664 44.076C451.781 43.025 452.799 42.6637 453.718 42.9922C454.638 43.3206 455.262 44.2074 455.591 45.6525C455.722 46.3751 455.886 47.229 456.083 48.2143C456.28 49.1339 456.543 49.955 456.871 50.6776Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M488.885 46.0466C490.396 45.8496 491.578 45.7182 492.432 45.6525C493.286 45.5211 494.041 45.4226 494.698 45.3569C495.421 45.2255 496.176 45.0942 496.964 44.9628C497.753 44.8314 498.869 44.6672 500.314 44.4701C501.103 44.3388 501.727 44.4373 502.187 44.7657C502.712 45.0942 503.041 45.4883 503.172 45.9481C503.303 46.4079 503.205 46.8677 502.876 47.3275C502.614 47.7873 502.121 48.1158 501.398 48.3128C500.085 48.5756 499.099 48.7727 498.442 48.904C497.851 48.9697 497.326 49.0682 496.866 49.1996C496.406 49.2653 495.913 49.3638 495.388 49.4952C494.928 49.5609 494.14 49.7251 493.023 49.9879C494.731 53.6664 495.486 57.2792 495.289 60.8263C495.158 63.3224 494.83 65.7857 494.304 68.2161C493.779 70.5809 492.99 72.9128 491.939 75.2118C491.414 76.2628 490.757 77.1825 489.969 77.9707C489.18 78.8246 488.064 79.1859 486.619 79.0546C485.173 78.9232 484.123 78.332 483.466 77.281C482.809 76.2957 482.25 75.179 481.791 73.9309C481.068 71.3691 480.641 68.8073 480.51 66.2455C480.313 63.6837 480.313 61.1219 480.51 58.5601C480.838 53.8306 481.495 49.2653 482.48 44.8643C483.466 40.4632 484.944 36.1278 486.914 31.8582C487.243 31.267 487.538 30.6758 487.801 30.0846C488.129 29.4934 488.491 28.9351 488.885 28.4096C489.936 27.0301 491.118 26.7345 492.432 27.5228C493.155 28.0483 493.516 28.6066 493.516 29.1978C493.516 29.789 493.45 30.413 493.319 31.0699C492.333 34.0258 491.479 36.6862 490.757 39.0509C490.034 41.35 489.41 43.6819 488.885 46.0466ZM487.111 72.3544C488.228 70.7779 489.082 68.9387 489.673 66.8367C490.33 64.669 490.658 62.567 490.658 60.5307C490.724 58.4287 490.527 56.5238 490.067 54.8159C489.607 53.108 488.852 51.9257 487.801 51.2688C487.21 54.6845 486.816 58.1331 486.619 61.6145C486.487 65.0303 486.651 68.6103 487.111 72.3544Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M504.905 51.0717C504.708 52.3855 504.774 53.3379 505.102 53.9291C505.497 54.5203 506.022 54.8816 506.679 55.013C507.402 55.1443 508.19 55.1443 509.044 55.013C509.963 54.8159 510.85 54.5532 511.704 54.2247C514.332 53.3708 516.532 52.2869 518.306 50.9732C520.079 49.6594 521.951 48.1486 523.922 46.4408C524.776 45.6525 525.498 45.2255 526.09 45.1598C526.681 45.0942 527.108 45.2255 527.37 45.554C527.699 45.8824 527.83 46.4079 527.765 47.1305C527.699 47.7873 527.403 48.4442 526.878 49.1011C525.958 50.2835 524.677 51.5315 523.035 52.8453C521.459 54.159 519.718 55.3742 517.813 56.4909C515.974 57.6076 514.069 58.5272 512.098 59.2498C510.193 59.9067 508.453 60.2023 506.876 60.1366C503.789 59.8081 501.555 58.6258 500.176 56.5895C498.731 54.5531 498.435 52.057 499.289 49.1011C499.946 46.8677 501.03 44.8971 502.541 43.1892C503.198 42.401 504.117 41.547 505.299 40.6274C506.482 39.6421 507.697 38.8539 508.945 38.2627C510.259 37.6058 511.54 37.2774 512.788 37.2774C514.102 37.2117 515.218 37.6715 516.138 38.6568C517.255 39.7735 517.55 41.1529 517.025 42.7951C516.499 44.4373 515.547 45.9809 514.167 47.4261C512.854 48.8055 511.31 49.8893 509.536 50.6776C507.828 51.4658 506.285 51.5972 504.905 51.0717ZM512.689 41.9083C509.799 43.1564 507.927 44.8971 507.073 47.1305C508.255 46.802 509.306 46.2765 510.226 45.554C511.211 44.8314 512.032 43.6162 512.689 41.9083Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M531.734 43.1892C532.39 42.5324 532.916 42.0069 533.31 41.6127C533.704 41.2186 534.098 40.8573 534.492 40.5289C535.281 39.872 536.036 39.2151 536.759 38.5583C537.547 37.9014 538.368 37.343 539.222 36.8832C541.455 35.7665 543.36 35.9965 544.937 37.573C546.185 39.0181 546.415 40.923 545.626 43.2878C545.298 44.4044 544.51 44.9299 543.262 44.8643C542.342 44.7329 541.948 44.1417 542.079 43.0907C542.211 42.4338 542.244 41.9083 542.178 41.5142C541.981 40.2005 541.193 39.9377 539.813 40.7259C539.419 40.9887 538.992 41.3171 538.532 41.7113C538.072 42.0397 537.678 42.401 537.35 42.7951C535.314 44.8971 533.573 47.229 532.128 49.7908C530.683 52.2869 529.96 54.9144 529.96 57.6733C529.96 58.6586 529.664 59.5454 529.073 60.3336C528.548 61.1219 527.825 61.6145 526.906 61.8116C526.052 62.0087 525.296 61.8773 524.639 61.4175C524.048 60.9577 523.687 60.2351 523.555 59.2498C523.424 58.3959 523.391 57.0164 523.457 55.1115C523.457 53.1409 523.588 51.0717 523.851 48.904C524.048 46.6707 524.409 44.4701 524.935 42.3024C525.46 40.0691 526.117 38.197 526.906 36.6862C527.3 35.9636 527.825 35.4381 528.482 35.1097C529.139 34.7812 529.796 34.6499 530.453 34.7155C531.963 34.9126 532.62 35.8651 532.423 37.573C532.358 38.4269 532.259 39.3137 532.128 40.2333C531.996 41.0872 531.865 42.0725 531.734 43.1892Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M553.122 56.5895C553.45 56.8522 554.009 56.6223 554.797 55.8997C555.651 55.1115 556.57 54.1262 557.556 52.9438C558.541 51.7614 559.559 50.5462 560.61 49.2982C561.727 47.9844 562.679 46.9663 563.468 46.2437C563.862 45.9153 564.256 45.751 564.65 45.751C565.11 45.751 565.504 45.8824 565.832 46.1452C566.161 46.3422 566.358 46.6378 566.423 47.0319C566.555 47.4261 566.489 47.8859 566.226 48.4114C565.898 49.0026 565.504 49.5937 565.044 50.1849C563.73 51.5644 562.449 52.9766 561.201 54.4218C560.019 55.8669 558.771 57.2792 557.457 58.6586C556.735 59.3812 555.848 60.0052 554.797 60.5307C552.892 61.516 551.151 61.6474 549.575 60.9248C548.064 60.2023 547.144 58.79 546.816 56.688C546.487 54.586 546.553 52.3198 547.013 49.8893C547.473 47.4589 548.13 45.2912 548.983 43.3863C549.312 42.5324 549.805 41.9412 550.461 41.6127C551.118 41.2843 551.808 41.2515 552.531 41.5142C554.041 42.0397 554.698 43.1564 554.501 44.8643C554.435 45.9153 554.271 47.1633 554.009 48.6084C553.811 50.0536 553.647 51.3016 553.516 52.3526C553.384 52.8781 553.319 53.5022 553.319 54.2247C553.319 54.8816 553.253 55.6698 553.122 56.5895ZM553.417 34.0258C553.746 34.0258 554.074 34.1901 554.403 34.5185C554.797 34.7812 555.125 35.1097 555.388 35.5038C555.716 35.8322 555.946 36.1935 556.078 36.5876C556.275 36.9818 556.34 37.3102 556.275 37.573C556.143 37.9014 555.881 38.2298 555.487 38.5583C555.092 38.8867 554.731 39.0838 554.403 39.1495C554.009 39.1495 553.614 39.0509 553.22 38.8539C552.826 38.6568 552.465 38.394 552.136 38.0656C551.874 37.6715 551.644 37.2774 551.447 36.8832C551.25 36.4891 551.151 36.1278 551.151 35.7994C551.282 35.2739 551.545 34.8469 551.939 34.5185C552.334 34.1244 552.826 33.9601 553.417 34.0258Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M567.353 51.0717C567.156 52.3855 567.222 53.3379 567.55 53.9291C567.944 54.5203 568.47 54.8816 569.127 55.013C569.849 55.1443 570.638 55.1443 571.492 55.013C572.411 54.8159 573.298 54.5532 574.152 54.2247C576.779 53.3708 578.98 52.2869 580.754 50.9732C582.527 49.6594 584.399 48.1486 586.37 46.4408C587.224 45.6525 587.946 45.2255 588.537 45.1598C589.129 45.0942 589.556 45.2255 589.818 45.554C590.147 45.8824 590.278 46.4079 590.213 47.1305C590.147 47.7873 589.851 48.4442 589.326 49.1011C588.406 50.2835 587.125 51.5315 585.483 52.8453C583.907 54.159 582.166 55.3742 580.261 56.4909C578.422 57.6076 576.517 58.5272 574.546 59.2498C572.641 59.9067 570.9 60.2023 569.324 60.1366C566.237 59.8081 564.003 58.6258 562.624 56.5895C561.179 54.5531 560.883 52.057 561.737 49.1011C562.394 46.8677 563.478 44.8971 564.989 43.1892C565.645 42.401 566.565 41.547 567.747 40.6274C568.93 39.6421 570.145 38.8539 571.393 38.2627C572.707 37.6058 573.988 37.2774 575.236 37.2774C576.55 37.2117 577.666 37.6715 578.586 38.6568C579.703 39.7735 579.998 41.1529 579.473 42.7951C578.947 44.4373 577.995 45.9809 576.615 47.4261C575.301 48.8055 573.758 49.8893 571.984 50.6776C570.276 51.4658 568.733 51.5972 567.353 51.0717ZM575.137 41.9083C572.247 43.1564 570.375 44.8971 569.521 47.1305C570.703 46.802 571.754 46.2765 572.674 45.554C573.659 44.8314 574.48 43.6162 575.137 41.9083Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M601.571 42.0069C602.885 41.0215 604.232 40.726 605.611 41.1201C606.991 41.5142 607.844 42.5652 608.173 44.2731C608.304 45.1927 608.37 46.3422 608.37 47.7217C608.37 49.1011 608.37 50.4805 608.37 51.86C608.436 53.1737 608.534 54.3232 608.666 55.3086C608.863 56.2939 609.191 56.8194 609.651 56.8851C609.979 56.8851 610.439 56.5895 611.03 55.9983C611.819 55.21 612.64 54.2576 613.494 53.1409C614.413 52.0242 615.267 50.9403 616.055 49.8893C616.844 48.7727 617.533 47.8202 618.125 47.0319C618.716 46.178 619.11 45.6525 619.307 45.4554C619.57 45.1927 619.865 45.0942 620.194 45.1598C620.522 45.2255 620.785 45.3898 620.982 45.6525C621.245 45.9153 621.442 46.2437 621.573 46.6378C621.704 47.0319 621.737 47.3604 621.672 47.6231C621.54 48.4114 621.048 49.4624 620.194 50.7761C619.34 52.0899 618.354 53.4365 617.238 54.8159C616.121 56.1296 614.939 57.3449 613.691 58.4615C612.508 59.5125 611.49 60.2023 610.636 60.5307C609.388 60.9905 608.173 60.9905 606.991 60.5307C605.874 60.0709 605.053 59.0199 604.527 57.3777C604.199 56.3267 603.969 55.21 603.838 54.0276C603.772 52.7796 603.673 51.5972 603.542 50.4805C603.476 49.8893 603.443 49.2982 603.443 48.707C603.443 48.0501 603.411 47.2947 603.345 46.4408C602.228 47.4261 601.309 48.4771 600.586 49.5938C599.863 50.6447 599.174 51.7286 598.517 52.8453C597.86 53.962 597.203 55.0786 596.546 56.1953C595.889 57.312 595.101 58.363 594.182 59.3483C593.065 60.268 591.817 60.7278 590.437 60.7278C589.058 60.6621 587.974 60.0052 587.186 58.7571C586.66 57.9689 586.365 57.0493 586.299 55.9983C586.233 54.9473 586.168 53.9291 586.102 52.9438C586.102 50.5134 586.266 48.0829 586.595 45.6525C586.857 43.1564 587.383 40.7259 588.171 38.3612C588.368 37.77 588.565 37.2774 588.762 36.8832C589.616 34.8469 590.799 34.1572 592.309 34.8141C592.966 34.9455 593.492 35.3724 593.886 36.095C594.346 36.7519 594.411 37.6058 594.083 38.6568C593.623 40.1676 593.196 41.7113 592.802 43.2878C592.474 44.8643 592.244 46.3422 592.112 47.7217C591.981 49.1011 591.915 50.3163 591.915 51.3673C591.981 52.3526 592.178 53.0752 592.506 53.535C592.901 53.8634 593.426 53.535 594.083 52.5497C594.806 51.5644 595.561 50.382 596.349 49.0026C597.203 47.6231 598.057 46.2437 598.911 44.8643C599.831 43.4848 600.717 42.5324 601.571 42.0069Z","fill":_vm.svgColor}}),_c('path',{attrs:{"d":"M632.234 31.267C631.708 33.6974 631.248 36.1278 630.854 38.5583C630.526 40.923 630.165 43.3206 629.771 45.751C629.508 46.8677 629.179 47.7217 628.785 48.3128C628.391 48.8383 627.734 49.1668 626.815 49.2982C625.961 49.2982 625.238 49.0682 624.647 48.6084C624.121 48.0829 623.793 47.3275 623.662 46.3422C623.53 45.6197 623.432 44.8314 623.366 43.9775C623.366 43.1235 623.432 42.2696 623.563 41.4157C624.548 36.095 625.534 30.84 626.519 25.6507C627.504 20.3957 628.522 15.1079 629.573 9.78718C629.705 9.13031 629.836 8.50628 629.968 7.91509C630.165 7.3239 630.329 6.73271 630.46 6.14153C630.657 5.41897 630.986 4.86063 631.445 4.4665C631.971 4.00669 632.595 3.80963 633.318 3.87531C634.631 4.00669 635.387 4.79494 635.584 6.24006C635.781 10.4441 635.42 14.648 634.5 18.852C633.646 22.9903 632.891 27.1287 632.234 31.267ZM628.194 57.1806C628.128 57.3777 628.063 57.6405 627.997 57.9689C627.997 58.2973 627.931 58.6586 627.8 59.0527C627.8 59.3812 627.603 59.6768 627.209 59.9395C626.88 60.2023 626.453 60.3336 625.928 60.3336C624.877 60.3336 624.056 60.1037 623.464 59.6439C623.136 59.4469 622.873 59.1513 622.676 58.7571C622.545 58.2973 622.446 57.8047 622.381 57.2792C622.315 56.688 622.315 56.1625 622.381 55.7027C622.512 55.1772 622.709 54.7831 622.972 54.5203C623.826 53.8634 624.745 53.535 625.731 53.535C626.453 53.6007 627.044 53.7649 627.504 54.0276C627.964 54.2247 628.227 54.5531 628.293 55.013C628.424 55.3414 628.457 55.6698 628.391 55.9983C628.325 56.3267 628.26 56.7208 628.194 57.1806Z","fill":_vm.svgColor}})])
}
var home_hero_ch_svgvue_type_template_id_3d35fc11_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-ch-svg.vue?vue&type=template&id=3d35fc11

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/home-hero-ch-svg.vue?vue&type=script&lang=js

/* harmony default export */ var home_hero_ch_svgvue_type_script_lang_js = ({
  props: {
    color: {
      type: String,
      default: '#323231',
    },
  },

  data: () => ({
    svgColor: '',
  }),

  mounted() {
    this.svgColor = this.color ? this.color : '#323231'
  },

  watch: {
    color() {
      this.svgColor = this.color
    },
  },
});

// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-ch-svg.vue?vue&type=script&lang=js
 /* harmony default export */ var ui_home_hero_ch_svgvue_type_script_lang_js = (home_hero_ch_svgvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-ch-svg.vue





/* normalize component */

var home_hero_ch_svg_component = normalizeComponent(
  ui_home_hero_ch_svgvue_type_script_lang_js,
  home_hero_ch_svgvue_type_template_id_3d35fc11_render,
  home_hero_ch_svgvue_type_template_id_3d35fc11_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var home_hero_ch_svg = (home_hero_ch_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/home-hero-eng-svg.vue?vue&type=template&id=0818c86e
var home_hero_eng_svgvue_type_template_id_0818c86e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"821px","height":"303px","viewBox":"0 0 821 303","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("schriftzuege_pfade_ENG")]),_c('g',{attrs:{"id":"schriftzuege_pfade_ENG","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(0.658243, 0.724104)","fill":"currentColor","fill-rule":"nonzero","id":"Ebene_3"}},[_c('g',{attrs:{"id":"Group","transform":"translate(0.000000, 0.000000)"}},[_c('path',{attrs:{"d":"M95.6390002,33.4274173 C101.963183,31.7379244 108.435768,30.1740018 115.022507,28.7470652 C123.218831,26.7836004 131.426571,24.9114596 139.622895,23.1306427 C147.819219,21.3498258 156.106867,19.4776849 164.497254,17.5142201 C166.460719,16.9776919 168.378522,16.4411638 170.250662,15.9046356 C172.122803,15.3681074 174.040606,14.477699 176.004071,13.2334102 C176.894479,12.87953 177.647902,11.9434595 178.275754,10.425199 C178.903606,8.91835389 179.303148,7.52566375 179.474381,6.28137501 C179.474381,4.31791022 178.892191,2.84531163 177.739226,1.86357923 C176.574845,0.881846833 175.193571,0.299656691 173.595402,0.128424296 C172.704993,-0.0428080987 171.894493,-0.0428080987 171.186733,0.128424296 C170.467557,0.311072184 169.668472,0.493720072 168.778064,0.664952466 C153.618289,4.05535388 138.46993,7.4457553 123.310155,10.8247412 C108.150381,14.2151426 93.0020213,17.9594243 77.8422467,22.0575863 C66.4267537,25.0941075 55.1140001,28.5187553 43.881155,32.354361 C32.6483099,36.1899666 21.3241409,39.8885864 9.90864791,43.4502202 C8.66435918,43.8155159 7.49997889,44.2493047 6.42692255,44.7858329 C5.35386621,45.322361 4.37213381,46.0301216 3.48172536,46.92053 C2.59131691,47.8109385 1.78081691,48.8383329 1.07305634,49.9912977 C0.353880283,51.1556779 6.48895649e-14,52.2629808 6.48895649e-14,53.3360371 C6.48895649e-14,55.116854 0.570774649,56.4524667 1.73515493,57.3428751 C2.88811973,58.2332836 4.26939438,58.7698118 5.87897889,58.9524596 C8.37897185,58.9524596 10.6963169,58.5985794 12.8310141,57.8794033 C15.3310071,56.9889949 17.8652465,56.0985864 20.4565634,55.2081779 C23.0364648,54.3177695 25.6734437,53.427361 28.3446691,52.5369526 C32.9793592,50.9273681 37.6597114,49.420523 42.3857255,47.9935864 C47.1117395,46.5666498 51.8834156,45.0483892 56.6893382,43.4502202 C56.6893382,43.9867483 56.871986,44.6146005 57.2258663,45.322361 C55.9815776,48.7127624 54.6916269,52.0118399 53.3445987,55.2195934 C52.008986,58.427347 50.6277114,61.7264244 49.2007748,65.1168259 C44.0295564,78.4843681 39.8400705,92.0916358 36.632317,105.904382 C33.4245635,119.717129 30.6620142,133.678277 28.3446691,147.75358 C27.1003803,154.705615 26.072986,161.65765 25.2739015,168.609685 C24.474817,175.56172 24.429155,182.60508 25.1369156,189.739763 C25.4907958,194.020573 26.5638522,198.027411 28.3446691,201.771692 C29.7716057,204.796798 31.9519649,206.623277 34.8971621,207.251129 C37.8423592,207.878981 40.5592466,207.296791 43.0592395,205.515974 C45.7304649,203.735157 47.7395917,201.01827 49.0752043,197.365312 C50.410817,193.712354 50.2738311,190.721495 48.6756621,188.40415 C46.5409649,185.379044 45.5135705,182.342523 45.6048945,179.317418 C45.6962184,176.292312 45.9131128,173.255791 46.2669931,170.21927 C48.766986,150.961333 52.4199438,132.205678 57.2372818,113.929474 C62.0546199,95.6532696 67.3057466,77.3314034 73.0134931,58.9752906 C73.9039016,55.5848892 74.839972,52.2858117 75.8217044,49.0780582 C76.8034368,45.8703047 76.8490988,42.2173469 75.9586903,38.1077695 C82.7509086,36.6808328 89.3034016,35.1169103 95.6390002,33.4274173 Z","id":"Path"}}),_c('path',{attrs:{"d":"M253.994719,157.913368 C258.994705,153.826622 262.921634,149.95677 265.786923,146.280981 C267.419339,144.249023 268.332578,142.148573 268.549472,140.00246 C268.754951,137.856347 268.389656,136.281009 267.476416,135.253615 C266.551761,134.237636 265.181902,133.826678 263.344008,134.032157 C261.506113,134.237636 259.257261,135.561833 256.608867,138.016164 C250.490163,143.324368 244.668261,148.016136 239.154578,152.102882 C233.640895,156.189629 226.803015,159.557199 218.640937,162.205594 C215.981127,163.232988 213.287071,163.997826 210.524522,164.500108 C207.773388,165.013805 205.319057,165.059467 203.172944,164.648509 C201.026831,164.237551 199.394416,163.118833 198.275698,161.280939 C197.145564,159.443044 196.894423,156.486432 197.51086,152.399685 C201.803085,154.032101 206.643254,153.621143 212.054198,151.178227 C217.465141,148.735312 222.259648,145.310664 226.449134,140.927115 C230.627205,136.543565 233.538155,131.79472 235.181986,126.691995 C236.814402,121.58927 235.889747,117.30846 232.430853,113.826734 C229.565564,110.767382 226.152332,109.283368 222.168324,109.386108 C218.184317,109.488847 214.211726,110.516241 210.227719,112.44546 C206.243712,114.386094 202.419522,116.840425 198.743733,119.797037 C195.067944,122.765065 192.202655,125.459122 190.170698,127.913453 C185.467515,133.221657 182.11136,139.351777 180.067986,146.280981 C179.702691,147.52527 179.428719,148.746727 179.188993,149.945354 C179.074838,150.093756 178.960684,150.264988 178.846529,150.413389 C175.98124,154.191918 172.921888,158.016108 169.668472,161.897375 C167.41962,165.367685 165.684465,167.251242 164.463007,167.55946 C163.24155,167.867678 162.316895,167.251242 161.711874,165.721566 C161.095437,164.191889 160.638817,162.045777 160.330599,159.294643 C160.022381,156.543509 159.759824,153.735298 159.565761,150.881425 C159.154803,147.205636 158.846585,143.586925 158.652521,140.013875 C158.447043,136.440826 157.933345,132.924854 157.122845,129.454544 C155.695909,123.33584 152.887698,119.557312 148.709627,118.130375 C144.520141,116.703439 140.079514,118.027636 135.387747,122.114382 C130.684564,126.201129 126.403754,130.584678 122.533902,135.276446 C118.652634,139.979629 114.668627,144.876875 110.593296,149.979601 C110.593296,143.655418 110.798775,135.641742 111.209733,125.938572 C111.62069,116.246819 112.385528,106.246847 113.504247,95.9272414 C114.622965,85.6190513 115.958578,75.5620019 117.488254,65.767509 C119.01793,55.973016 120.798747,47.8109385 122.84212,41.269861 C123.858099,37.7995511 123.766775,35.0484173 122.533902,33.0050441 C121.312444,30.9730863 119.565874,29.7402131 117.328437,29.3292554 C115.079585,28.9182976 112.682331,29.2835934 110.136676,30.4023117 C107.579606,31.5324455 105.69605,33.6214807 104.474592,36.6808328 C101.814782,42.6054737 99.4175284,51.2812484 97.2828312,62.7081568 C95.1367185,74.1464808 93.4015636,86.4409668 92.0773664,99.6030302 C90.7531692,112.765094 89.8855918,125.99565 89.474634,139.260453 C89.0636763,152.536671 89.3718946,163.86084 90.3878735,173.244375 C90.7988312,178.347101 93.1504228,182.125629 97.4312326,184.568544 C101.107021,186.817397 104.417514,187.171277 107.385543,185.641601 C110.342155,184.111925 112.237127,181.200974 113.047627,176.908749 C113.253106,175.687291 113.401507,174.363094 113.504247,172.924742 C113.606986,171.497805 113.960866,170.276347 114.577303,169.248953 C116.415197,166.794622 118.298754,163.940749 120.239388,160.675918 C122.180021,157.411087 124.269057,154.146256 126.517909,150.881425 C128.766761,147.616594 131.164014,144.659981 133.709669,142.000171 C136.255324,139.351777 138.960796,137.205664 141.826085,135.573249 C142.442521,141.703368 143.047543,147.776411 143.663979,153.792375 C144.280416,159.819756 145.695937,166.098277 147.956205,172.627939 C150.604599,178.746643 154.177648,182.27403 158.675352,183.18727 C163.161641,184.111925 167.750669,182.114213 172.453853,177.216967 C175.718684,174.157615 178.629634,170.835706 181.186705,167.262657 C181.209536,167.228411 181.232367,167.194164 181.255198,167.159918 C181.688986,167.981833 182.168437,168.780918 182.704965,169.557171 C187.088515,175.89277 194.074796,179.557143 203.675226,180.584537 C208.572472,180.790016 214.029078,179.819699 220.056458,177.673587 C226.072423,175.527474 231.997064,172.730678 237.818965,169.260368 C243.583789,165.767228 248.994733,162.000115 253.994719,157.913368 Z M221.688874,123.91803 C219.645501,129.226234 217.145508,133.004763 214.188895,135.242199 C211.232282,137.491051 207.910374,139.123467 204.234585,140.139446 C206.894395,133.210242 212.704881,127.799298 221.688874,123.91803 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M539.484783,52.4456286 C539.576107,48.8269174 539.621769,45.2538681 539.621769,41.7264807 C539.793001,38.906854 539.359213,36.3497835 538.308987,34.0552694 C537.258762,31.7607554 535.683424,30.0027694 533.594389,28.7584807 C532.190283,28.0621356 530.660607,27.6625934 529.00536,27.5712694 C527.338698,27.4799455 525.820438,27.8794877 524.416332,28.7584807 C523.537339,29.4662413 522.715424,30.8361004 521.927755,32.8566427 C521.140086,34.8886004 520.831867,36.6123399 521.014515,38.0164455 C522.235973,42.959354 522.498529,47.7196145 521.802184,52.3086427 C521.105839,56.8976709 520.31817,61.4866991 519.439177,66.0757273 C516.996262,78.781171 514.108142,91.2240583 510.797649,103.392974 C507.475741,115.561889 503.628719,127.570988 499.268001,139.386023 C496.825086,146.098333 493.891304,152.228453 490.489487,157.787798 C487.08767,163.347143 482.841107,168.073157 477.784043,171.943009 C471.494107,176.532037 465.55805,178.290023 459.964459,177.239798 C454.370867,176.178157 449.393712,171.863101 445.032994,164.271798 C442.590079,160.03665 440.398304,155.40196 438.480501,150.379143 C436.562698,145.356326 434.98736,140.276432 433.765902,135.162291 C432.361797,130.04815 431.448557,124.797023 431.014769,119.420326 C430.58098,114.043629 430.181438,108.609854 429.838973,103.141833 C429.485093,97.491164 429.359522,91.8062485 429.450846,86.0642555 C429.54217,80.333678 429.496508,74.6487625 429.31386,68.986678 C429.142628,65.6419385 428.697424,62.502678 428.001078,59.5917273 C427.304733,56.6807765 425.466839,54.5232484 422.498811,53.1077272 C419.873247,52.0460864 417.555902,52.3657202 415.558191,54.0323822 C413.549064,55.7104596 411.665508,57.6054315 409.930353,59.7287132 C408.526247,61.4981146 407.133557,63.3930864 405.740867,65.4136287 C404.336762,67.4455864 402.944071,69.4318822 401.551381,71.372516 C392.818529,84.0779597 384.131339,96.8747273 375.478395,109.751403 C366.825452,122.639495 358.138261,135.516171 349.405409,148.392847 C345.387156,154.214749 341.32324,159.865418 337.225078,165.333439 C333.115501,170.80146 328.880353,176.360805 324.519635,182.011474 C323.298177,183.780875 321.848409,185.367629 320.193163,186.771735 C318.537916,188.187256 316.745684,189.865333 314.827881,191.794552 C313.948888,187.034291 313.652085,182.753481 313.914642,178.952122 C314.177198,175.162178 314.656649,171.406481 315.352994,167.707861 C319.017367,146.532122 323.731966,125.938572 329.49679,105.904382 C335.261613,85.8816076 342.076663,66.2469597 349.941937,47.011854 C350.284402,46.132861 350.683944,45.2538681 351.117733,44.3634596 C351.551522,43.4844667 352.030973,42.5940582 352.556085,41.7150652 C353.423663,41.1899526 354.131423,41.0187202 354.656536,41.1899526 C356.403106,42.080361 358.058353,42.4228258 359.633691,42.2515934 C361.209029,42.080361 362.339163,40.7561638 363.035508,38.2790019 C363.560621,36.8748962 363.640529,35.2767272 363.298064,33.5187413 C362.944184,31.7607554 362.681628,29.90003 362.510395,27.9593962 C362.339163,27.4342835 362.156515,26.9434173 361.985283,26.4982131 C361.81405,26.0644244 361.551494,25.5735582 361.197614,25.0484455 C359.097163,19.3977765 356.391691,16.144361 353.081198,15.2539525 C349.75929,14.3749595 346.266149,15.9617131 342.601775,20.0142131 C338.937402,24.249361 335.957959,28.8383892 333.697691,33.7812976 C323.743381,54.0780441 315.227423,74.9341498 308.149818,96.3724456 C301.072212,117.810741 295.786839,140.35634 292.293698,163.997826 C291.414705,170.002375 290.980916,175.995509 290.980916,182.000059 C290.980916,188.004608 291.677261,193.906418 293.081367,199.728319 C294.131592,204.317347 295.70693,207.981721 297.795965,210.710023 C299.896416,213.449742 302.156684,215.37896 304.611015,216.531925 C307.05393,217.673474 309.679494,218.027354 312.476289,217.593566 C315.273085,217.148361 317.887233,216.132383 320.341564,214.545629 C325.227395,211.897235 329.679437,208.015967 333.709106,202.901826 C337.202247,198.312798 340.74105,193.632446 344.325515,188.872185 C347.898564,184.111925 351.266135,179.169016 354.416811,174.054875 C363.492128,159.762678 372.45329,145.607467 381.277466,131.577826 C390.101642,117.548185 398.960064,103.484298 407.875564,89.363333 C408.743142,87.9478118 409.667797,86.5779527 410.626698,85.265171 C411.5856,83.9409738 412.498839,82.5711146 413.377832,81.167009 C413.731712,81.5208893 414.165501,81.7377836 414.690614,81.8291076 C415.215726,81.9204315 415.649515,82.1373259 416.003395,82.4912062 C416.003395,88.1418752 415.912071,93.7811287 415.740839,99.4317978 C415.569607,105.082467 415.649515,110.72172 416.003395,116.372389 C416.69974,127.84496 418.400649,138.872326 421.117536,149.454488 C423.823008,160.03665 428.320712,169.751235 434.610649,178.575411 C440.900586,187.570819 448.012438,193.175826 455.969036,195.379016 C463.914219,197.593622 472.087712,196.223763 480.466684,191.280854 C484.131057,189.340221 487.715522,186.828812 491.208663,183.735213 C494.701804,180.65303 497.841065,177.251213 500.63786,173.541178 C503.959769,168.95215 506.973459,164.100566 509.678931,158.986425 C512.384403,153.872284 514.793072,148.495587 516.882107,142.844918 C527.007649,117.43403 534.256487,90.7902696 538.628621,62.9136357 C539.085241,59.5460653 539.393459,56.0643399 539.484783,52.4456286 Z","id":"Path"}}),_c('path',{attrs:{"d":"M665.511826,109.865558 C662.829185,111.315326 660.306361,113.061896 657.943354,115.116685 C655.580347,117.171474 653.160262,119.237678 650.6831,121.292467 C649.450227,122.331277 648.217354,123.449995 646.973065,124.694284 C645.740192,125.927157 644.084945,127.582403 642.030156,129.637192 C642.441114,126.144051 642.852072,122.993375 643.26303,120.21941 C643.673987,117.43403 643.982206,114.717143 644.187685,112.034502 C644.804121,106.680636 642.749332,103.701192 638.011903,103.084756 C635.957114,102.879277 633.89091,103.290234 631.836121,104.317629 C629.781332,105.345023 628.126086,107.00027 626.893213,109.260537 C624.427466,113.997967 622.361262,119.808453 620.717431,126.703411 C619.861269,130.27646 619.142093,133.849509 618.537072,137.422558 C618.240269,137.491051 617.954882,137.536713 617.635248,137.662284 C616.607854,138.073242 615.580459,138.484199 614.553065,138.895157 C611.253987,139.922551 608.011987,140.744467 604.827065,141.360904 C601.630727,141.97734 598.080508,141.97734 594.17641,141.360904 C593.970931,139.717073 593.811114,138.175981 593.708375,136.726213 C593.605635,135.287861 593.548558,134.054988 593.548558,133.016178 C592.932121,123.552734 589.838523,115.927185 584.290593,110.162361 C580.375079,106.041368 576.265501,104.192058 571.93903,104.603016 C567.612558,105.013974 563.697044,107.285657 560.203903,111.395234 C559.176508,112.422629 558.149114,113.450023 557.12172,114.477418 C556.08291,115.516227 554.964191,116.326727 553.719903,116.943164 C547.133163,120.036763 542.190255,124.351819 538.902593,129.911164 C535.603515,135.470509 533.137769,141.954509 531.493938,149.363164 C530.466543,154.71703 530.466543,159.705601 531.493938,164.340291 C532.521332,168.974981 534.42772,172.833418 537.201684,175.915601 C539.987065,178.997784 543.377466,181.166728 547.39572,182.399601 C551.413973,183.632474 555.888846,183.632474 560.831755,182.399601 C566.185621,181.372206 571.071452,179.26034 575.500663,176.064002 C579.929875,172.87908 583.685572,168.59827 586.767755,163.244404 C588.206107,160.778657 589.701537,159.077749 591.242628,158.153094 C592.78372,157.228439 594.690107,156.760404 596.96179,156.760404 C600.249452,156.554925 603.44579,156.143967 606.527973,155.52753 C609.621572,154.911094 612.703755,154.191918 615.797354,153.370002 C616.082741,153.290094 616.368128,153.164523 616.653516,153.061784 C616.265389,157.856291 616.025663,162.433904 615.945755,166.806037 C615.843016,172.87908 616.002832,177.251213 616.41379,179.933854 C616.824748,183.016037 618.011959,185.287721 619.964008,186.726073 C621.916058,188.164425 624.233403,188.575382 626.916044,187.958946 C629.792748,187.342509 632.110093,185.801418 633.868079,183.324256 C635.614649,180.858509 636.493642,178.073129 636.493642,174.990946 C636.493642,166.349418 638.75391,158.06177 643.285861,150.139418 C647.806396,142.217065 653.274417,134.956812 659.655678,128.370072 C660.683072,127.137199 661.915945,125.949988 663.365713,124.819854 C664.804065,123.68972 666.151093,122.707988 667.383966,121.886072 C671.710438,119.420326 674.176185,120.242241 674.792621,124.351819 C674.9981,125.584692 674.895361,127.239939 674.484403,129.294727 C674.073445,132.593805 675.306318,134.443115 678.194438,134.854072 C682.098537,135.059551 684.575699,133.41572 685.603093,129.911164 C688.06884,122.502509 687.349664,116.532206 683.445565,112.000256 C678.479826,107.091594 672.509523,106.372418 665.511826,109.865558 Z M566.859135,161.589157 C564.279234,163.130249 561.254128,164.111981 557.749572,164.522939 C552.190227,165.139375 549.72448,162.159932 550.340917,155.561777 C550.751875,152.274115 551.425389,149.134854 552.350044,146.143995 C553.274698,143.164551 554.872867,140.23077 557.133135,137.34265 C558.776966,142.696516 561.037234,146.406551 563.925353,148.46134 C566.802058,150.516129 569.998396,152.376854 573.502952,154.020685 C571.642227,157.536657 569.427621,160.048066 566.859135,161.589157 Z M572.407065,131.486502 C571.687889,130.04815 571.733551,126.965967 572.566882,122.228537 C573.799755,123.255932 574.781487,124.134925 575.500663,124.854101 C576.219839,125.573277 576.779199,126.34953 577.201572,127.171446 C577.61253,127.993361 577.920748,129.020756 578.126227,130.265044 C578.331706,131.497918 578.537184,133.153164 578.742663,135.207953 C575.238107,134.169143 573.126241,132.93627 572.407065,131.486502 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M818.045643,47.4913047 C817.634685,43.3703117 815.363002,40.8018258 811.253424,39.7744314 C806.721474,38.7470371 803.331072,40.2881286 801.059389,44.4091216 C800.648431,45.2310371 800.237474,46.0643681 799.826516,46.8748681 C799.415558,47.6967836 799.0046,48.4159596 798.593643,49.0323962 C795.705523,57.6739244 792.771741,66.4296076 789.792298,75.2766146 C786.801438,84.1236217 783.776333,92.8793048 780.682734,101.520833 C779.860819,103.792516 779.027488,105.995706 778.216988,108.16465 C777.395072,110.322178 776.675896,112.228565 776.05946,113.883812 C771.938467,114.911206 768.08003,115.733122 764.48415,116.349558 C760.876854,116.965995 757.634854,118.107544 754.75815,119.751375 C746.299269,124.751361 740.020748,130.972805 735.876924,138.392875 C735.386058,138.929403 734.929438,139.465932 734.529896,139.979629 C733.81072,140.904284 733.137206,141.886016 732.520769,142.913411 C731.904333,143.940805 730.557305,145.744453 728.502516,148.312939 C726.447727,150.89284 724.484262,153.621143 722.634952,156.497847 C720.580164,159.58003 718.981995,161.235277 717.851861,161.440756 C716.721727,161.646235 715.888396,160.927058 715.386114,159.283227 C714.872417,157.639396 714.621276,155.379129 714.621276,152.491009 C714.621276,149.614305 714.724016,146.623446 714.929495,143.529847 C716.367847,126.657749 718.479713,109.717157 721.265093,92.7309034 C724.039058,75.7446498 727.075579,58.404516 730.374657,40.6990864 C730.991093,35.1397413 729.039044,31.7493399 724.507093,30.5050511 C722.23541,30.0940934 720.134959,30.3452342 718.171495,31.2813047 C716.20803,32.2059596 714.724016,34.0096075 713.696621,36.6808328 C711.424938,41.6237413 709.26741,48.3132202 707.212621,56.7492695 C705.157833,65.1967343 703.194368,74.0894033 701.345058,83.4615231 C699.495748,92.8336428 697.954657,102.194347 696.710368,111.566467 C695.477495,120.938587 694.55284,129.00934 693.924988,135.801558 C693.719509,138.689678 693.308551,142.799256 692.692114,148.153122 C692.075678,153.506988 691.915861,158.963594 692.224079,164.522939 C692.532297,170.082284 693.571107,175.127932 695.317678,179.648467 C697.064248,184.180418 700.203509,186.851643 704.735459,187.673559 C707.612164,188.289995 710.134988,187.981777 712.303931,186.748904 C714.461459,185.51603 716.470586,183.872199 718.319896,181.805995 C719.552769,180.367643 721.413495,177.901897 723.879241,174.39734 C725.283347,172.411044 726.755945,170.310594 728.26279,168.153066 C728.331283,169.351692 728.4911,170.595981 728.82215,171.931594 C730.260502,176.874502 732.886065,180.321981 736.69884,182.27403 C740.500199,184.237495 744.678269,184.077678 749.21022,181.805995 C751.05953,180.778601 752.920255,179.648467 754.769565,178.404178 C756.618875,177.171305 758.171382,175.732953 759.404255,174.077706 C762.28096,170.584566 765.06634,166.931608 767.737565,163.118833 C770.408791,159.306058 773.194171,155.550361 776.070875,151.851742 C776.892791,150.413389 778.022924,148.975037 779.472692,147.52527 C779.88365,149.991016 780.043467,152.365439 779.940727,154.625706 C779.837988,156.885974 779.678171,159.157657 779.472692,161.417925 C779.267213,164.717002 779.107396,168.004664 779.004657,171.303742 C778.901917,174.602819 779.050319,177.787742 779.472692,180.869925 C779.678171,183.758044 780.602826,185.915573 782.258072,187.353925 C783.901903,188.803692 785.968107,189.625608 788.433854,189.819671 C793.78772,190.230629 797.280861,187.559404 798.936108,181.79458 C799.347065,180.767185 799.598206,179.84253 799.700946,179.009199 C799.803685,178.187284 799.952086,177.262629 800.168981,176.223819 C800.990896,170.664474 801.710072,165.162206 802.326509,159.705601 C802.942946,154.260411 803.764861,148.849467 804.792255,143.495601 C807.052523,129.294727 809.221467,115.344995 811.276255,101.657819 C813.331044,87.9706428 815.488572,74.1236498 817.760255,60.1282554 C818.171213,57.8679878 818.422354,55.6990441 818.525093,53.6442554 C818.616417,51.6122977 818.456601,49.5575089 818.045643,47.4913047 Z M766.173643,139.203375 C764.735291,142.707932 762.931643,146.143995 760.774114,149.545812 C758.616586,152.936213 756.185086,156.189629 753.513861,159.271812 C750.83122,162.365411 748.057255,164.933897 745.180551,166.988685 C744.769593,162.662213 745.123474,158.347157 746.265023,154.020685 C747.395157,149.694213 749.050403,145.790115 751.207931,142.285558 C753.36546,138.792418 755.991023,135.904298 759.084621,133.64403 C762.17822,131.383763 765.363143,130.04815 768.66222,129.625777 C768.43391,132.525312 767.611995,135.710234 766.173643,139.203375 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M165.376247,256.337749 L164.383099,256.337749 C162.476712,256.337749 161.51781,256.862862 161.51781,257.901671 L161.51781,298.63215 C161.51781,299.67096 162.476712,300.184657 164.383099,300.184657 L165.376247,300.184657 C167.282634,300.184657 168.241536,299.659545 168.241536,298.63215 L168.241536,257.901671 C168.241536,256.851446 167.282634,256.337749 165.376247,256.337749 Z","id":"Path"}}),_c('path',{attrs:{"d":"M202.990296,278.997502 C201.825916,278.038601 200.558796,277.239516 199.188937,276.600249 C197.819078,275.960981 196.47205,275.367376 195.136437,274.819432 C193.720916,274.282904 192.41955,273.746376 191.209507,273.198432 C190.010881,272.661904 189.029148,271.976974 188.287141,271.143643 C187.545134,270.310312 187.168423,269.191594 187.168423,267.776073 C187.168423,266.531784 187.45381,265.458728 188.036,264.568319 C188.618191,263.677911 189.462937,262.992981 190.558824,262.513531 C191.654712,262.03408 193.00174,261.794354 194.577078,261.794354 C195.992599,261.794354 197.168395,261.942756 198.127296,262.228143 C199.086198,262.524946 199.896698,262.833164 200.558796,263.164214 C201.015416,263.369693 201.392127,263.55234 201.677515,263.689326 C201.962902,263.837728 202.191212,263.906221 202.362444,263.906221 C202.659247,263.906221 202.990296,263.65508 203.355592,263.164214 C203.732303,262.661932 204.063353,262.102573 204.34874,261.486136 C204.634127,260.858284 204.782529,260.367418 204.782529,259.990707 C204.782529,259.37427 204.34874,258.79208 203.469747,258.244136 C202.807648,257.787516 201.962902,257.39939 200.946923,257.056925 C199.930944,256.725876 198.846472,256.463319 197.704923,256.280671 C196.563374,256.098023 195.456071,256.0067 194.371599,256.0067 C191.711789,256.0067 189.314536,256.48615 187.179838,257.433636 C185.045141,258.392538 183.355648,259.750981 182.134191,261.508967 C180.912733,263.278369 180.296296,265.378819 180.296296,267.83315 C180.296296,269.819446 180.593099,271.497524 181.163874,272.844552 C181.746064,274.19158 182.510902,275.310298 183.469803,276.212122 C184.417289,277.102531 185.501761,277.867369 186.711803,278.483805 C187.91043,279.111657 189.154719,279.671017 190.444669,280.161883 C192.020007,280.823981 193.538268,281.474664 194.988036,282.125347 C196.437803,282.764615 197.625015,283.552284 198.538254,284.488355 C199.451493,285.424425 199.908113,286.680129 199.908113,288.255467 C199.908113,289.625326 199.565648,290.801122 198.880719,291.771439 C198.195789,292.753171 197.293965,293.483763 196.175247,293.986045 C195.056529,294.488326 193.789409,294.728052 192.373888,294.728052 C190.296268,294.728052 188.515451,294.431249 187.020022,293.826228 C185.524592,293.221207 184.360212,292.718925 183.538296,292.296552 C183.241493,292.091073 182.978937,291.91984 182.727796,291.79427 C182.476655,291.6687 182.271176,291.611622 182.099944,291.611622 C181.848803,291.611622 181.506338,291.862763 181.07255,292.353629 C180.638761,292.855911 180.26205,293.41527 179.953831,294.031707 C179.645613,294.659559 179.485796,295.173256 179.485796,295.595629 C179.485796,296.177819 179.919585,296.78284 180.798578,297.399277 C181.837388,298.141284 183.40131,298.837629 185.501761,299.488312 C187.602212,300.138995 190.056543,300.458629 192.887585,300.458629 C194.873881,300.458629 196.711775,300.184657 198.401268,299.648129 C200.079346,299.111601 201.551944,298.312517 202.819064,297.250876 C204.086184,296.189235 205.0565,294.887869 205.752846,293.323946 C206.437775,291.760024 206.78024,289.956376 206.78024,287.878756 C206.78024,285.76689 206.437775,283.986073 205.752846,282.559136 C205.079331,281.155031 204.154677,279.956404 202.990296,278.997502 Z","id":"Path"}}),_c('path',{attrs:{"d":"M253.994719,257.387974 C253.78924,256.680214 252.85317,256.326333 251.186508,256.326333 L249.006148,256.326333 C247.385148,256.326333 246.449078,256.680214 246.197937,257.387974 L231.745923,298.04996 C231.700261,298.255439 231.666015,298.438087 231.620353,298.575073 C231.574691,298.723474 231.55186,298.871876 231.55186,299.043108 C231.55186,299.785115 232.545008,300.161826 234.542719,300.161826 L235.50162,300.161826 C236.163719,300.161826 236.723078,300.081918 237.179698,299.910686 C237.636317,299.739453 237.944536,299.476897 238.115768,299.100186 L241.357768,289.636742 L258.606578,289.636742 L261.905656,299.100186 C262.076888,299.476897 262.407937,299.739453 262.898803,299.910686 C263.401085,300.070502 263.994691,300.161826 264.702451,300.161826 L265.82117,300.161826 C267.69331,300.161826 268.629381,299.785115 268.629381,299.043108 C268.629381,298.746305 268.560888,298.438087 268.446733,298.107038 L253.994719,257.387974 Z M243.344064,283.928995 L249.074641,267.490685 C249.28012,266.908495 249.462768,266.292059 249.599754,265.652791 C249.748156,265.013524 249.873726,264.374256 249.999296,263.757819 L250.124867,263.757819 C250.250437,264.385671 250.376008,265.013524 250.501578,265.652791 C250.627148,266.292059 250.77555,266.908495 250.935367,267.490685 L256.597451,283.928995 L243.344064,283.928995 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M302.202346,256.463319 L272.875944,256.463319 C271.962705,256.463319 271.506085,257.205326 271.506085,258.700756 L271.506085,259.945045 C271.506085,261.440474 271.962705,262.182481 272.875944,262.182481 L284.268606,262.182481 L284.268606,298.609319 C284.268606,299.648129 285.227508,300.161826 287.133895,300.161826 L288.069965,300.161826 C289.976353,300.161826 290.935254,299.636714 290.935254,298.609319 L290.935254,262.193897 L302.202346,262.193897 C303.115585,262.193897 303.572205,261.45189 303.572205,259.95646 L303.572205,258.712171 C303.572205,257.205326 303.115585,256.463319 302.202346,256.463319 Z","id":"Path"}}),_c('path',{attrs:{"d":"M358.309494,256.337749 L357.373423,256.337749 C356.665663,256.337749 356.037811,256.406242 355.478452,256.554643 C354.919092,256.703045 354.508135,256.94277 354.256994,257.273819 L344.599487,272.091129 L335.136043,257.330897 C334.884902,256.954185 334.508191,256.703045 334.017325,256.554643 C333.515043,256.406242 332.898606,256.337749 332.145184,256.337749 L330.900895,256.337749 C329.782177,256.337749 328.971677,256.440488 328.469395,256.645967 C327.967113,256.851446 327.727388,257.125418 327.727388,257.456467 C327.727388,257.75327 327.910036,258.164228 328.286747,258.700756 L341.117761,278.129925 L341.117761,298.620735 C341.117761,299.659545 342.076663,300.173242 343.98305,300.173242 L344.919121,300.173242 C346.825508,300.173242 347.784409,299.648129 347.784409,298.620735 L347.784409,278.312573 L360.672501,258.68934 C360.798071,258.4382 360.912226,258.20989 361.014966,258.004411 C361.117705,257.798932 361.174783,257.604869 361.174783,257.445052 C361.174783,256.748707 360.215881,256.371995 358.309494,256.337749 Z","id":"Path"}}),_c('path',{attrs:{"d":"M386.460099,256.018115 C380.192994,256.018115 375.398487,257.890256 372.076578,261.623122 C368.75467,265.355988 367.099423,270.881087 367.099423,278.187002 C367.099423,285.413009 368.75467,290.938108 372.076578,294.750883 C375.398487,298.563657 380.192994,300.48146 386.460099,300.48146 C392.772867,300.48146 397.590205,298.575073 400.912114,294.750883 C404.234022,290.926693 405.889269,285.413009 405.889269,278.187002 C405.889269,270.881087 404.234022,265.355988 400.912114,261.623122 C397.590205,257.890256 392.772867,256.018115 386.460099,256.018115 Z M395.832219,290.52715 C393.697522,293.346777 390.569677,294.762298 386.460099,294.762298 C382.396184,294.762298 379.29117,293.346777 377.145057,290.52715 C375.01036,287.707524 373.937304,283.597946 373.937304,278.198418 C373.937304,272.79889 374.998945,268.723559 377.145057,265.961009 C379.279754,263.19846 382.384769,261.817185 386.460099,261.817185 C390.569677,261.817185 393.697522,263.19846 395.832219,265.961009 C397.966916,268.723559 399.039973,272.79889 399.039973,278.198418 C399.039973,283.586531 397.966916,287.707524 395.832219,290.52715 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M449.610607,256.337749 L448.674536,256.337749 C446.768149,256.337749 445.809248,256.862862 445.809248,257.901671 L445.809248,285.858214 C445.809248,287.604784 445.352628,289.13446 444.439388,290.470073 C443.526149,291.805686 442.270445,292.844495 440.672276,293.609333 C439.074107,294.374171 437.236212,294.762298 435.158593,294.762298 C433.126635,294.762298 431.300156,294.385587 429.679156,293.64358 C428.058156,292.901573 426.791036,291.851348 425.877797,290.504319 C424.964557,289.157291 424.507938,287.604784 424.507938,285.869629 L424.507938,257.913087 C424.507938,256.874277 423.549036,256.349164 421.642649,256.349164 L420.706578,256.349164 C418.800191,256.349164 417.84129,256.874277 417.84129,257.913087 L417.84129,285.938122 C417.84129,290.504319 419.336719,294.077369 422.327578,296.645855 C425.318438,299.225756 429.587832,300.504291 435.158593,300.504291 C440.683691,300.504291 444.94167,299.21434 447.95536,296.645855 C450.96905,294.065953 452.475895,290.504319 452.475895,285.938122 L452.475895,257.913087 C452.475895,256.851446 451.516994,256.337749 449.610607,256.337749 Z","id":"Path"}}),_c('path',{attrs:{"d":"M492.829663,285.481502 C492.121903,283.609362 491.36848,282.034024 490.55798,280.744073 C489.74748,279.454122 488.742917,278.632207 487.532874,278.255495 L487.532874,278.004355 C489.736065,277.171024 491.49405,275.881073 492.795417,274.145918 C494.108198,272.399347 494.758881,270.241819 494.758881,267.673333 C494.758881,263.814897 493.480346,260.983854 490.923276,259.168791 C488.366205,257.365143 484.599093,256.463319 479.621938,256.463319 L468.663064,256.463319 C467.293205,256.463319 466.608276,257.148249 466.608276,258.518108 L466.608276,298.620735 C466.608276,299.659545 467.555762,300.173242 469.473564,300.173242 L470.409635,300.173242 C472.316022,300.173242 473.274924,299.648129 473.274924,298.620735 L473.274924,281.497495 L477.94386,281.497495 C480.272621,281.497495 482.042022,281.874207 483.274896,282.616214 C484.496353,283.358221 485.523748,284.796573 486.357079,286.908439 L491.151586,299.111601 C491.322818,299.44265 491.653867,299.705207 492.144734,299.887855 C492.647015,300.070502 493.240621,300.173242 493.948381,300.173242 L495.135593,300.173242 C497.133304,300.173242 498.126452,299.819362 498.126452,299.111601 C498.126452,298.906122 498.046543,298.575073 497.875311,298.118453 L492.829663,285.481502 Z M484.393614,274.77377 C483.331973,275.401622 482.144762,275.70984 480.809149,275.70984 L473.274924,275.70984 L473.274924,262.193897 L480.37536,262.193897 C482.658459,262.193897 484.484938,262.730425 485.854797,263.814897 C487.224656,264.899369 487.909586,266.531784 487.909586,268.734974 C487.909586,269.979263 487.589952,271.143643 486.939269,272.2167 C486.300001,273.301171 485.455255,274.145918 484.393614,274.77377 Z","id":"Shape"}}),_c('path',{attrs:{"d":"M549.062382,256.463319 L529.199424,256.463319 C527.829565,256.463319 527.144635,257.148249 527.144635,258.518108 L527.144635,298.620735 C527.144635,299.659545 528.103536,300.173242 530.009924,300.173242 L530.945994,300.173242 C532.852382,300.173242 533.811283,299.648129 533.811283,298.620735 L533.811283,282.056855 L548.137727,282.056855 C549.085213,282.056855 549.564663,281.314847 549.564663,279.819418 L549.564663,278.575129 C549.564663,277.0797 549.085213,276.337693 548.137727,276.337693 L533.811283,276.337693 L533.811283,262.193897 L549.073797,262.193897 C550.032698,262.193897 550.500734,261.45189 550.500734,259.95646 L550.500734,258.712171 C550.489318,257.205326 550.021283,256.463319 549.062382,256.463319 Z","id":"Path"}}),_c('path',{attrs:{"d":"M586.117072,294.328509 L568.925339,294.328509 L568.925339,280.629918 L584.244931,280.629918 C585.203832,280.629918 585.683283,279.887911 585.683283,278.392481 L585.683283,277.148193 C585.683283,275.652763 585.203832,274.910756 584.244931,274.910756 L568.925339,274.910756 L568.925339,262.193897 L586.048579,262.193897 C587.00748,262.193897 587.475515,261.45189 587.475515,259.95646 L587.475515,258.712171 C587.475515,257.216742 586.996065,256.474735 586.048579,256.474735 L564.31348,256.474735 C562.943621,256.474735 562.258691,257.159664 562.258691,258.529523 L562.258691,298.015714 C562.258691,299.385573 562.943621,300.070502 564.31348,300.070502 L586.117072,300.070502 C587.064558,300.070502 587.544208,299.328495 587.544208,297.833066 L587.544208,296.588777 C587.555424,295.070517 587.075973,294.328509 586.117072,294.328509 Z","id":"Path"}}),_c('path',{attrs:{"d":"M623.856692,294.328509 L606.664959,294.328509 L606.664959,280.629918 L621.984551,280.629918 C622.943452,280.629918 623.422903,279.887911 623.422903,278.392481 L623.422903,277.148193 C623.422903,275.652763 622.943452,274.910756 621.984551,274.910756 L606.664959,274.910756 L606.664959,262.193897 L623.788199,262.193897 C624.7471,262.193897 625.215135,261.45189 625.215135,259.95646 L625.215135,258.712171 C625.215135,257.216742 624.735685,256.474735 623.788199,256.474735 L602.0531,256.474735 C600.683241,256.474735 599.998311,257.159664 599.998311,258.529523 L599.998311,298.015714 C599.998311,299.385573 600.683241,300.070502 602.0531,300.070502 L623.856692,300.070502 C624.804178,300.070502 625.283827,299.328495 625.283827,297.833066 L625.283827,296.588777 C625.295044,295.070517 624.815593,294.328509 623.856692,294.328509 Z","id":"Path"}}),_c('path',{attrs:{"d":"M663.776671,256.463319 L634.438854,256.463319 C633.525614,256.463319 633.068994,257.205326 633.068994,258.700756 L633.068994,259.945045 C633.068994,261.440474 633.525614,262.182481 634.438854,262.182481 L645.831516,262.182481 L645.831516,298.609319 C645.831516,299.648129 646.790417,300.161826 648.696804,300.161826 L649.632875,300.161826 C651.539262,300.161826 652.498164,299.636714 652.498164,298.609319 L652.498164,262.193897 L663.765255,262.193897 C664.678495,262.193897 665.135323,261.45189 665.135323,259.95646 L665.135323,258.712171 C665.14653,257.205326 664.68991,256.463319 663.776671,256.463319 Z","id":"Path"}})])])])])
}
var home_hero_eng_svgvue_type_template_id_0818c86e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-eng-svg.vue?vue&type=template&id=0818c86e

// CONCATENATED MODULE: ./src/components/svg/ui/home-hero-eng-svg.vue

var home_hero_eng_svg_script = {}


/* normalize component */

var home_hero_eng_svg_component = normalizeComponent(
  home_hero_eng_svg_script,
  home_hero_eng_svgvue_type_template_id_0818c86e_render,
  home_hero_eng_svgvue_type_template_id_0818c86e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var home_hero_eng_svg = (home_hero_eng_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/no-result-svg.vue?vue&type=template&id=0a02a3e4
var no_result_svgvue_type_template_id_0a02a3e4_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"153","height":"156","viewBox":"0 0 153 156","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m35.813 134.892-3.532 3.547c-2.613-.945-5.512-2.111-8.418-3.185l2.673-2.661-4.224 2.098c-3.87-1.378-7.663-2.496-10.71-2.61 3.727-3.37 8.685-5.436 13.847-6.583l6.982 3.026-4.925-3.434c4.765-.834 9.587-.938 13.678-.605 9.146.743 16.379 11.325 16.379 11.325s-12.15 5.727-19.527 4.348c-1.302-.244-2.84-.704-4.526-1.285l2.303-3.981z","fill":"#ABE532"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"8qe68tieba","maskUnits":"userSpaceOnUse","x":"0","y":"97","width":"68","height":"47"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 97.287h67.33v46.018H0V97.287z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#8qe68tieba)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M67.215 134.991c.66-3.583-1.758-8.906-1.758-8.906s-3.86 4.344-3.761 8.329c.035 1.397.334 2.49.708 3.321a169.505 169.505 0 0 0-3.314-3.879c.44-.304 2.384-1.814 2.775-5.013.441-3.612-2.295-8.817-2.295-8.817s-3.589 4.524-3.247 8.502c.115 1.35.461 2.404.867 3.207a161.211 161.211 0 0 0-3.494-3.716c.436-.335 2.06-1.76 2.283-4.6.259-3.285-2.418-7.915-2.418-7.915s-3.07 4.205-2.607 7.798c.155 1.199.5 2.131.89 2.843-.9-.896-1.83-1.799-2.788-2.701.442-.366 1.897-1.765 2.026-4.439.153-3.156-2.546-7.534-2.546-7.534s-2.819 4.102-2.27 7.535c.186 1.171.555 2.071.96 2.749-.907-.822-1.81-1.616-2.709-2.385.38-.354 1.733-1.803 1.663-4.45-.08-3.077-3.018-7.184-3.018-7.184s-2.438 4.149-1.657 7.458c.26 1.105.671 1.946 1.103 2.578a102.732 102.732 0 0 0-3.264-2.558c.327-.372 1.45-1.854 1.112-4.354-.394-2.914-3.597-6.573-3.597-6.573s-1.878 4.133-.798 7.21c.321.914.733 1.62 1.154 2.163a82.494 82.494 0 0 0-3.095-2.092c.318-.469 1.175-2.017.582-4.387-.718-2.869-4.31-6.237-4.31-6.237s-1.403 4.284.016 7.256a8.072 8.072 0 0 0 1.162 1.806 63.117 63.117 0 0 0-2.9-1.598c.205-.415.898-2.113-.133-4.491-1.191-2.75-5.302-5.616-5.302-5.616s-.663 4.43 1.237 7.19c.44.639.898 1.142 1.342 1.541a47.175 47.175 0 0 0-3.402-1.366c.138-.55.345-2.062-.837-3.922-1.492-2.35-5.632-4.457-5.632-4.457s.076 4.091 2.208 6.365c.396.423.79.765 1.17 1.044a35.302 35.302 0 0 0-3.343-.733c.03-.612-.083-1.825-1.174-3.187-1.565-1.956-5.442-3.48-5.442-3.48s.502 3.616 2.623 5.452c.426.369.84.652 1.229.875-.94-.073-1.868-.1-2.783-.08-.006-.465-.153-1.447-1.138-2.501-1.362-1.459-4.512-2.455-4.512-2.455s.638 2.822 2.43 4.158c.607.453 1.17.72 1.65.879-.268.022-.536.048-.802.078-.248-.277-1.119-1.103-2.87-1.346-2.114-.293-5.189.828-5.189.828s2.62 1.756 4.955 1.7c1.368-.033 2.221-.4 2.697-.699.507-.068 1.02-.121 1.536-.158a4.902 4.902 0 0 0-1.773 1.03c-1.48 1.325-2.227 4.18-2.227 4.18s3.102-.807 4.392-2.499c1.031-1.352.948-2.401.873-2.768a28.194 28.194 0 0 1 4.022.207c.384.119.71.172.955.196-.698.029-2.042.24-3.436 1.31-2.016 1.547-3.268 5.088-3.268 5.088s4.01-.758 5.825-2.783c1.79-1.998 1.385-3.558 1.374-3.601 1.828.309 3.702.788 5.618 1.433-.836-.006-2.237.164-3.777 1.111-2.467 1.517-4.346 5.34-4.346 5.34s4.597-.425 6.903-2.498c1.837-1.651 2.03-3.134 2.033-3.669 1.671.6 3.373 1.326 5.104 2.179-.93-.086-2.348-.024-4.003.697-2.955 1.288-5.692 5.152-5.692 5.152s5.068.194 7.95-1.717c2.161-1.435 2.713-2.917 2.854-3.567a65.552 65.552 0 0 1 4.403 2.517c-.903-.217-2.347-.364-4.158.144-3.145.883-6.509 4.335-6.509 4.335s4.991.857 8.169-.65c2.491-1.182 3.249-2.645 3.46-3.222 1.352.87 2.72 1.814 4.097 2.821-.885-.262-2.221-.466-3.928-.148-3.234.601-6.974 3.737-6.974 3.737s4.879 1.288 8.214.069c2.537-.927 3.477-2.26 3.783-2.846 1.326 1 2.664 2.061 4.01 3.184-.899-.344-2.256-.658-4.042-.482-3.456.341-7.73 3.282-7.73 3.282s4.963 1.78 8.596.803c2.793-.75 3.924-2.079 4.298-2.654.944.808 1.891 1.642 2.843 2.509.204.185.407.372.608.558-.894-.413-2.277-.831-4.154-.756-3.571.142-8.18 2.898-8.18 2.898s4.955 2.118 8.756 1.335c2.975-.613 4.23-1.943 4.635-2.491a142.132 142.132 0 0 1 3.601 3.519c-.919-.457-2.357-.936-4.337-.904-3.73.06-8.624 2.819-8.624 2.819s5.101 2.329 9.091 1.607c3.097-.56 4.452-1.897 4.903-2.468a163.695 163.695 0 0 1 4.345 4.664c-.989-.545-2.57-1.146-4.797-1.185-4.12-.071-9.116 3.039-9.116 3.039s4.982 2.507 9.421 1.859c3.45-.504 5.008-1.931 5.532-2.542a166.795 166.795 0 0 1 4.02 4.746c-.958-.584-2.495-1.242-4.683-1.383-4.114-.267-9.819 2.325-9.819 2.325s5.351 3.012 9.827 2.576c3.474-.339 5.118-1.686 5.68-2.272a99.128 99.128 0 0 1 2.403 3.114l.406-.227c-.026-.035-.91-1.245-2.484-3.215.452-.278 2.494-1.691 3.08-4.872","fill":"#39B54A"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m76.478 118.247 7.039-.41c1.478-3.656 2.996-7.824 4.615-11.913l-5.302.332 6.176-2.505c2.212-5.397 4.624-10.466 7.378-13.802-7.036.782-13.874 4.093-19.943 8.486l-3.426 10.242 1.06-8.446c-5.368 4.265-10.027 9.277-13.539 13.925-7.851 10.39-3.62 28.001-3.62 28.001s17.449-7.492 22.967-16.605c.974-1.61 1.944-3.67 2.928-6.003l-6.333-1.302z","fill":"#009245"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"yv4ojcvvdb","maskUnits":"userSpaceOnUse","x":"102","y":"79","width":"51","height":"70"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M102.358 79.248h50.641v69.134h-50.641V79.248z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#yv4ojcvvdb)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M143.955 104.161c-.713.462-1.27.94-1.708 1.401a44.767 44.767 0 0 0 1.432-3.489c.632.126 2.365.301 4.444-.945 2.625-1.573 4.876-5.83 4.876-5.83s-4.666.177-7.18 2.398a8.849 8.849 0 0 0-1.149 1.213 32.38 32.38 0 0 0 .712-3.413c.7.016 2.08-.129 3.594-1.27 2.173-1.637 3.767-5.612 3.767-5.612s-4.107.597-6.123 2.797a7.79 7.79 0 0 0-.953 1.266 25.33 25.33 0 0 0-.012-2.825c.53-.018 1.645-.191 2.811-1.217 1.614-1.42 2.633-4.643 2.633-4.643s-3.196.716-4.653 2.569c-.495.628-.779 1.206-.943 1.698a24.362 24.362 0 0 0-.118-.813c.306-.259 1.217-1.163 1.428-2.948.256-2.154-1.137-5.25-1.137-5.25s-1.906 2.704-1.756 5.074c.089 1.388.54 2.246.899 2.722.096.514.176 1.033.237 1.556-.211-.524-.582-1.156-1.241-1.775-1.568-1.472-4.854-2.16-4.854-2.16s1.037 3.13 3.016 4.4c1.581 1.014 2.775.904 3.192.82a25.656 25.656 0 0 1-.087 4.089c-.121.393-.17.725-.188.974-.059-.707-.351-2.067-1.624-3.456-1.84-2.01-5.927-3.197-5.927-3.197s1.014 4.056 3.393 5.85c2.347 1.77 4.112 1.32 4.16 1.307a33.806 33.806 0 0 1-1.426 5.742c-.024-.849-.271-2.268-1.408-3.81-1.823-2.468-6.256-4.284-6.256-4.284s.656 4.659 3.107 6.951c1.953 1.826 3.653 1.986 4.264 1.976a46.483 46.483 0 0 1-2.296 5.236c.062-.945-.061-2.385-.945-4.048-1.581-2.97-6.091-5.657-6.091-5.657s-.033 5.153 2.255 8.033c1.717 2.162 3.429 2.686 4.177 2.813a64.213 64.213 0 0 1-2.707 4.532c.213-.922.326-2.393-.321-4.217-1.124-3.174-5.189-6.507-5.189-6.507s-.792 5.091 1.046 8.282c1.441 2.502 3.14 3.236 3.806 3.436a84.367 84.367 0 0 1-3.067 4.231c.267-.906.449-2.268.023-3.995-.807-3.27-4.525-6.992-4.525-6.992s-1.288 4.987.227 8.345c1.153 2.554 2.709 3.477 3.389 3.773a106.772 106.772 0 0 1-3.484 4.151c.359-.921.667-2.307.399-4.117-.517-3.503-4.033-7.772-4.033-7.772s-1.846 5.084-.596 8.751c.96 2.818 2.519 3.935 3.189 4.301-.887.978-1.803 1.961-2.757 2.949l-.614.631c.438-.918.864-2.333.708-4.238-.296-3.624-3.612-8.239-3.612-8.239s-2.232 5.084-1.197 8.926c.81 3.008 2.374 4.251 3.015 4.649a155.577 155.577 0 0 1-3.881 3.743c.487-.944.98-2.417.869-4.427-.207-3.787-3.538-8.693-3.538-8.693s-2.468 5.239-1.495 9.274c.755 3.133 2.331 4.476 2.998 4.92a171.69 171.69 0 0 1-5.16 4.528c.586-1.018 1.213-2.64 1.174-4.902-.072-4.187-3.543-9.74-3.543-9.74s-2.94 5.676-2.035 10.169c.704 3.492 2.39 5.04 3.107 5.557a182.044 182.044 0 0 1-5.266 4.2c.631-.989 1.324-2.565 1.404-4.791.151-4.185-3.02-9.917-3.02-9.917s-3.238 5.508-2.573 10.044c.517 3.521 2.115 5.158 2.805 5.715-2.124 1.594-3.426 2.489-3.465 2.516l.274.407c.04-.028 1.387-.954 3.577-2.601.334.452 2.023 2.492 5.674 3.01 4.114.584 10.098-2.003 10.098-2.003s-5.101-3.816-9.645-3.618c-1.593.07-2.829.4-3.763.8a183.429 183.429 0 0 0 4.303-3.46c.363.44 2.158 2.377 5.823 2.696 4.139.361 9.977-2.545 9.977-2.545s-5.296-3.535-9.823-3.091c-1.537.15-2.726.527-3.628.959a175.637 175.637 0 0 0 4.111-3.64c.398.435 2.085 2.049 5.334 2.207 3.759.183 8.943-2.649 8.943-2.649s-4.914-3.016-8.996-2.458c-1.363.186-2.414.559-3.211.974.988-.937 1.984-1.904 2.978-2.899.434.44 2.085 1.885 5.141 1.951 3.607.078 8.503-2.77 8.503-2.77s-4.786-2.763-8.684-2.123c-1.329.218-2.342.615-3.1 1.042.903-.94 1.776-1.877 2.619-2.809.419.378 2.123 1.716 5.14 1.581 3.51-.156 8.087-3.24 8.087-3.24s-4.826-2.376-8.573-1.502c-1.251.291-2.195.729-2.901 1.183.98-1.133 1.911-2.259 2.798-3.377.437.323 2.17 1.427 5.01 1.023 3.31-.471 7.367-3.814 7.367-3.814s-4.787-1.807-8.258-.634c-1.031.348-1.821.784-2.425 1.224.8-1.073 1.56-2.138 2.272-3.194.547.311 2.346 1.144 5.027.484 3.248-.799 6.957-4.53 6.957-4.53s-4.941-1.32-8.28.193a9.235 9.235 0 0 0-2.017 1.224 61.889 61.889 0 0 0 1.716-2.985c.481.199 2.444.861 5.12-.244 3.094-1.277 6.211-5.522 6.211-5.522s-5.081-.565-8.159 1.431","fill":"#39B54A"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m118.325 121.386 7.782-1.542c1.077-4.238 2.119-9.043 3.285-13.778l-5.859 1.187 6.495-3.704c1.623-6.26 3.52-12.193 6.069-16.278-7.722 1.95-14.827 6.64-20.907 12.398l-2.22 11.761-.139-9.424c-5.316 5.509-9.728 11.727-12.918 17.368-7.13 12.609.338 31.261.338 31.261s18.281-10.922 23.01-21.769c.835-1.916 1.595-4.326 2.327-7.036l-7.263-.444z","fill":"#ABE532"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m61.245 110.088 3.834-9.054c-3.403-3.824-7.385-7.973-11.213-12.207l-2.861 6.833.837-9.1c-5.005-5.682-9.502-11.438-11.745-16.69-3.395 9.251-3.686 19.615-2.231 29.598l9.972 9.813-9.306-5.876c1.735 9.032 4.785 17.578 8.11 24.489 7.431 15.448 30.788 19.618 30.788 19.618s1.871-25.932-5.486-37.764c-1.3-2.089-3.134-4.416-5.28-6.907l-5.42 7.247z","fill":"#ABE57A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M77.462 113.342a7.162 7.162 0 0 1-.556.873c-.094.13.035.142-1.276.684-1.158.495-3.096.684-3.214.708-2.41.401-3.758 1.144-6.274.472-.638-.165-1.348-.425-2.175-.803-1.713-.778-3.084-1.899-4.218-3.196-.91-.991-1.678-2.089-2.375-3.209.39 1.262.756 2.536 1.122 3.822l.213.743c.19.673.378 1.333.567 1.994-.307.024-.673.106-.969.354-.366.318-.271.566-.733 1.215-.39.566-.626.625-.945 1.062-.153-.354-.319-.708-.472-1.062a932.874 932.874 0 0 1-2.553-5.804c-.011-.012-.011-.012 0-.012-.85-1.923-1.69-3.858-2.564-5.863-.46-1.05-1.051-2.466-1.335-4.117a7.796 7.796 0 0 1-.142-1.074 9.914 9.914 0 0 1 .201-2.973c.19-.873.756-3.42 2.458-3.975a1.94 1.94 0 0 1 .732-.106c1.23.035 2.695 1.062 5.082 2.76a33.706 33.706 0 0 1 2.918 2.312c0 .06.012.107.012.165.39 3.67.319 3.906.59 4.719.769 2.265 2.388 3.622 3.073 4.2.272.236 4.171 3.421 9.087 2.513 1.252-.236 2.73-.508 3.686-1.77a4.054 4.054 0 0 0 .745-1.781c.638 2.784.543 5.025-.686 7.149","fill":"#2A3F44"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M77.58 105.893v.012a4.026 4.026 0 0 1-.734 1.764c-.944 1.25-2.402 1.519-3.637 1.753-4.85.9-8.697-2.255-8.965-2.489-.676-.573-2.273-1.916-3.03-4.16-.269-.806-.199-1.04-.584-4.674 0-.059-.011-.105-.011-.164-.163-1.496-.327-2.98-.455-4.066-.361-3.085-.478-3.822-.408-5.119.035-.607.105-1.156.187-1.635-.653.467-1.306.958-1.97 1.472a104.281 104.281 0 0 0-5.141 4.23l-.105.094a1.902 1.902 0 0 0-.723.105c-1.679.549-2.238 3.073-2.425 3.938a9.854 9.854 0 0 0-.198 2.944c-.163.468-.291.912-.408 1.344a1.864 1.864 0 0 1-.326.117c-1.154.409-2.308.327-3.1-.269a2.233 2.233 0 0 1-.48-.479c.572-5.293 2.333-9.02 3.533-11.101.91-1.59 3.929-4.616 9.955-10.669.432-.42 1.26-1.239 2.577-1.893.314-.152.617-.292.92-.385.175.093.362.221.537.385.524.444 1.026 1.11 1.41 2.384.607 1.963.793 4.908.851 6.742l-.093.34a23.736 23.736 0 0 1-.291 2.991c-.07.397-.14.76-.234 1.122v.011a20.576 20.576 0 0 1-.42 1.59c-.99 3.143-2.237 4.907-1.468 7.21.233.689.548 1.121 1.166 1.975.676.923 2.81 3.856 4.954 3.435a1.81 1.81 0 0 0 .595-.211c.547 0 1.119-.011 1.702-.046 2.471-.14 4.71-.55 6.668-1.075.174.712.29 1.601.151 2.477","fill":"#FFEA00"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M109.761 103.404a98.123 98.123 0 0 1-.514 8.555c-1.04.342-2.761.707-4.625.141a6.51 6.51 0 0 1-1.387-.613 104.168 104.168 0 0 0-2.342-17.381 30.642 30.642 0 0 0-.358-1.509c-.92-2.157-3.25-8.225-4.625-18.36-.084-.648-.191-1.556-.323-2.664-.765.2-1.625.354-2.557.413-.168 0-.323.012-.49.012-.12 1.249-.275 2.84-.466 4.643-.646 6.104-1.028 8.025-1.339 11.784-.383 4.679-.096 5.516-.299 9.581-.18 3.488-.669 8.508-2.115 14.672-.813.318-2.283.719-3.932.283a5.314 5.314 0 0 1-1.326-.531 358.954 358.954 0 0 1-.993-11.772c-.561-8.214-.693-14.036-.8-18.95-.108-5.209-.06-7.365.107-9.722.156-2.25.466-5.574 1.195-9.534.24-1.331.49-2.533.718-3.559 1.183.33 2.413.578 3.656.814 4.398.8 6.598 1.201 8.57 1.084 4.684-.283 4.397-1.733 10.026-2.97.156 1.167.359 2.687.586 4.466.538 4.384.848 7.79 1.112 10.901a1059.93 1059.93 0 0 1 1.409 17.853c.263 1.203.514 2.546.706 4.02.239 1.767.466 4.218.406 8.343","fill":"#00D5E0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M97.277 13.778c-.187.32-.455.77-.746 1.319-1.294 2.352-1.55 3.198-2.285 3.615l-.012.012c-.046.021-.093.055-.151.076-.77.363-1.574.154-2.366-.033-.735-.175-2.192-.516-2.728-1.648-.525-1.11.151-2.33.618-3.154a6.278 6.278 0 0 1 1.34-1.66c.012.012.024.023.035.045.222.23.525.505.921.758.373.23 1.165.714 2.261.714.84.011 1.504-.274 1.959-.538.233.12.676.362 1.154.494","fill":"#F95623"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M99.948 11.434c.074.984-.505 2.215-1.627 2.584-.012.012-.037.012-.061.025-.308.086-.678.05-1.023-.05-.505-.147-.973-.418-1.22-.553-.48.295-1.182.615-2.07.603-1.158 0-1.996-.542-2.39-.8a5.37 5.37 0 0 1-.974-.85c.025-.048.037-.085.062-.134.296-.739.567-1.354.801-1.822.678-1.427 1.183-2.473 2.156-3.58.456-.53.9-.949 1.27-1.244.196.16.381.283.542.394a5.594 5.594 0 0 0 2.34.861c-.098.148-.209.308-.32.493-.492.812-1.343 2.202-.9 2.793.075.099.321.345 1.097.27.456-.479 1.085-.651 1.553-.454.678.283.752 1.218.764 1.464","fill":"#FCD0A3"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mn3yy9mlkc","maskUnits":"userSpaceOnUse","x":"93","y":"0","width":"14","height":"16"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M93.434 0h13.524v15.853H93.434V0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#mn3yy9mlkc)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M104.563 14.058c-.432.467-1.572 1.66-2.786 1.789a2.152 2.152 0 0 1-.612-.035c-.48-.105-.841-.398-1.153-.632a4.731 4.731 0 0 1-1.31-1.613c1.094-.35 1.658-1.52 1.586-2.455-.012-.234-.084-1.122-.745-1.391-.456-.187-1.068-.023-1.513.432-.756.07-.996-.163-1.068-.257-.433-.561.396-1.882.876-2.654.108-.175.216-.327.313-.467a5.542 5.542 0 0 1-2.282-.819c-.156-.105-.337-.222-.529-.374-1.009-.783-2.21-2.174-1.837-3.647.204-.842.973-1.847 2.053-1.929 1.045-.082 2.162.678 2.594 1.93 1.057-.153 3.315-.27 5.465 1.11.516.327 2.521 1.648 3.158 4.196.889 3.566-1.693 6.278-2.21 6.816","fill":"#F95623"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M101.739 16.011c-.076.3-.152.6-.228.913-.101.445-.176.877-.265 1.298l-.076.504c-1.3.588-3.17 1.19-5.418 1.165-.909-.012-1.389.012-2.045-.12.176-.24.303-.48.391-.72l.013-.012c.795-.457 1.073-1.382 2.475-3.953.316-.6.606-1.092.808-1.441.354.096.733.132 1.048.048.026-.012.05-.012.063-.024a4.884 4.884 0 0 0 1.377 1.658c.329.24.707.54 1.213.649.214.047.429.047.644.035","fill":"#FCD0A3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M112.246 36.116c-.147.409-.428.994-1.053 1.625a6.6 6.6 0 0 0-.478-.854c-.342-.538-1.248-1.975-2.374-2.466a33.057 33.057 0 0 0-2.621-11.07 32.42 32.42 0 0 0-1.75-3.46c.257.176.514.387.783.632 1.641 1.52 2.302 3.25 2.596 3.998 2.987 7.527 5.901 8.848 4.897 11.595","fill":"#008E8A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M108.432 34.476a1.47 1.47 0 0 0-.491-.14.779.779 0 0 0-.331-.025l-.423.118-.674.188a85.79 85.79 0 0 0-.674-4.542c-.354-1.965-.822-4.096-1.428-5.814-.719-2.083-1.61-3.825-1.61-3.825a32.486 32.486 0 0 0-1.062-1.883c.091.024.194.048.297.071.285.082 1.222.353 2.318 1.224a33.471 33.471 0 0 1 1.634 3.483c1.701 4.26 2.273 8.18 2.444 11.145","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M112.895 41.583v.012a10.952 10.952 0 0 1-1.836 3.448c-.049.07-.11.139-.17.208a8.23 8.23 0 0 1-.426.486v.012c-1.021 1.1-3.538 3.436-6.978 3.587a7.94 7.94 0 0 1-1.046-.023c-.036 0-.085-.012-.121-.012a6.739 6.739 0 0 1-1.228-.231 8.91 8.91 0 0 1-3.04-1.458V47.6c.098-1.933-.145-4.316-1.556-6.538-.425-.682-1.726-2.742-3.233-2.603l1.896-.486c.34.243.742.578 1.143 1.018.39.405.972 1.123 1.763 2.789.742 1.55.62 1.724 1.07 2.603.316.614 1.045 2.072 2.358 3.009.426.3.924.555 1.496.706 2.212.59 4.242-.74 4.802-1.111 2.346-1.528 2.99-3.992 3.294-5.16.207-.753.414-1.574.304-2.604a6.043 6.043 0 0 0-.109-.672c-.365-1.515-1.338-2.696-2.225-3.482a5.933 5.933 0 0 0-.547-.452c.182.012.352.07.523.14 1.118.485 2.018 1.908 2.358 2.44.182.278.34.556.474.845.596 1.192.9 2.395 1.034 3.541","fill":"#5D7E82"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M110.218 45.327c0 .377-.012.766-.037 1.167-.17 2.888-1.082 5.317-2.08 7.192a.633.633 0 0 1-.085.153 6.894 6.894 0 0 1-1.399.649c-1.751.884-3.856 1.733-6.216 2.44a12.452 12.452 0 0 0 1.922-2.935c.462-.99.815-2.146.912-3.42a8.624 8.624 0 0 0 0-1.591c3.443-.154 5.961-2.535 6.983-3.655","fill":"#2A3F44"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M112.068 45.773c-.43 2.348-.947 5.106-3.472 7.011-.051.035-.101.082-.164.129 0 0 0-.012.013-.024.921-1.776 1.805-4.16 1.994-7.011.038-.526.05-1.04.025-1.531a10.941 10.941 0 0 0 1.907-3.483c.227 2.022-.101 3.833-.303 4.909","fill":"#2A3F44"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m106.647 34.67-4.462 1.286c.477-.28.866-.667 1.243-1.03 1.476-1.438 2.209-3.239 2.564-4.771a86.93 86.93 0 0 1 .655 4.514","fill":"#008E8A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M110.788 41.292c-.291 1.222-.91 3.798-3.164 5.395-.537.387-2.487 1.778-4.612 1.162a4.304 4.304 0 0 1-1.437-.738c-1.261-.98-1.961-2.505-2.265-3.145-.432-.92-.315-1.101-1.027-2.722-.76-1.742-1.32-2.492-1.694-2.915-.385-.46-.77-.81-1.097-1.065l5.044-1.427 1.623-.46 4.694-1.33.689-.194.432-.121a.796.796 0 0 1 .339.024c.163.133.35.29.525.472.853.822 1.787 2.056 2.137 3.64.047.23.082.46.105.703.106 1.076-.093 1.935-.292 2.721M102.118 50.494a12.735 12.735 0 0 1-.66 2.885c-.59 1.71-1.458 3.067-2.234 4.074-1.053.303-2.14.57-3.287.776a31.544 31.544 0 0 1-4.016.484c1.262-.351 2.176-1.151 2.57-1.49 2.314-1.989 2.789-4.85 3.183-7.274.115-.704.277-1.686.324-2.837.67.545 1.655 1.176 2.893 1.527.37.121.752.194 1.169.242.034 0 .081.013.116.013.023.509 0 1.042-.058 1.6","fill":"#2A3F44"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M103.489 50.542a10.526 10.526 0 0 1-.876 3.482 12.726 12.726 0 0 1-1.844 2.99c-.409.12-.83.252-1.261.36.782-.996 1.658-2.341 2.253-4.034.316-.865.549-1.826.665-2.858.059-.553.082-1.081.059-1.585.339.036.677.036 1.004.023a9.53 9.53 0 0 1 0 1.622M110.651 44.88c.023.503.012 1.03-.023 1.568a19.837 19.837 0 0 1-1.831 7.18c-.012.013-.012.025-.012.025a9.657 9.657 0 0 1-.683.514c-.035.024-.081.06-.116.084a.634.634 0 0 0 .081-.156c.95-1.903 1.819-4.368 1.982-7.3.023-.407.034-.801.034-1.184v-.013c.197-.227.336-.406.406-.502a2.48 2.48 0 0 0 .162-.216","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M86.884 32.52a43.38 43.38 0 0 1-3.694 1.557z","fill":"#FFB357"}}),_c('path',{attrs:{"d":"M86.884 32.52a43.38 43.38 0 0 1-3.694 1.557","stroke":"#070707","stroke-width":".343"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M71.662 36.963c.146.208.316.428.51.659-.692.485-1.42.681-2.003.496a1.55 1.55 0 0 1-.62-.392 2.217 2.217 0 0 1-.425-.705c-.34-.786-.388-1.744-.4-2.16-.061-1.352.4-1.317 1.894-5.487.146-.405.267-.774.425-1.075.194-.427.425-.716.79-.797.485-.115.995.197 1.347.497-.4.832-.801 1.687-1.19 2.53-.947 2.021-1.25 2.345-1.372 2.968-.134.717-.073 1.768.874 3.212.049.081.11.162.17.254","fill":"#008E8A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M95.492 50.657c-1.844.168-3.593-.527-4.562-1.85-.662-.896-.792-1.87-.792-2.52l.035-.068 5.32 4.438z","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M95.939 51.166c-.554 2.747-2.252 4.777-4.331 5.203-.295.06-1.931.4-2.916-.499-1.845-1.677.05-6.393.726-8.083.234-.608.48-1.13.714-1.568 0 .705.135 1.763.824 2.735 1.009 1.434 2.83 2.188 4.75 2.006l.233.206zM97.04 46.635c-.157.09-.458.079-2.457-1.463-2.817-2.176-3.13-2.833-3.106-3.445.012-.454.204-.783.349-1.043a3.68 3.68 0 0 1 .975-1.1c.433-.328.915-.544 1.385-.498 1.324.124 1.962 2.357 2.613 4.624.337 1.19.746 2.652.24 2.925","fill":"#5D7E82"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M96.514 46.83c-.15.094-.438.082-2.357-1.503-2.704-2.238-3.004-2.914-2.981-3.543.011-.466.196-.805.335-1.072.208-.397.543-.817.936-1.13.416-.339.878-.56 1.329-.514 1.27.128 1.884 2.424 2.508 4.755.323 1.224.716 2.728.23 3.007m-5.259 9.196c-.277.058-1.814.385-2.738-.478-1.733-1.608.046-6.13.682-7.75a13.504 13.504 0 0 1 .704-1.574l5.2 4.616.22.198c-.52 2.634-2.114 4.58-4.068 4.988m4.97-15.21c-.404-.688-1.64-2.762-3.074-2.622-.23.011-.427.093-.647.233h-.011c-.451.315-.925.92-1.56 1.993a20.983 20.983 0 0 0-.914 1.701c-.693 1.422-1.166 2.786-1.78 4.523-.623 1.76-1.34 3.706-1.813 6.142-.07.396-.15.804-.208 1.236-.023.116-.035.232-.047.349-.08.641-.103 1.352.232 2.075.878 1.888 3.34 2.226 3.466 2.237.624.07 1.214.012 1.734-.116h.035c1.26-.338 2.172-1.107 2.565-1.434 2.311-1.911 2.785-4.662 3.178-6.993.115-.676.277-1.62.323-2.727V47.4c.093-1.946-.138-4.347-1.479-6.585","fill":"#39565B"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M106.201 30.124c-.385 1.54-1.18 3.35-2.781 4.797-.41.364-.831.752-1.349 1.034l-1.674.447c-2.432-.035-4.816-2.727-5.78-5.15-.782-1.951-.3-2.904-1.433-5.15-.325-.658-.686-1.2-1.023-1.681-.012 0-.012-.012-.012-.012s-.012-.012-.012-.024c-.168-.529-.325-.846-.325-.846a9.341 9.341 0 0 0-1.228-1.917c.12-.023.24-.058.373-.094.289-.082.542-.153.77-.235a59.852 59.852 0 0 0 4.769 2.528c3.348 1.6 4.022 1.564 4.443 1.329 1.541-.847.723-4.856.337-6.432.109-.059.205-.106.289-.165h.012c.097.024.193.035.301.06.337.528.723 1.151 1.12 1.88 0 0 .939 1.74 1.698 3.822.638 1.716 1.132 3.845 1.505 5.809","fill":"#00A8A8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M100.863 24.687c-.409.224-1.064.258-4.313-1.267a58.493 58.493 0 0 1-4.629-2.41c.76-.248 1.228-.505 1.637-.954.082-.09.164-.18.222-.28.608.123 1.052.1 1.893.112 2.081.022 3.81-.539 5.015-1.088.175-.09.35-.168.502-.247.374 1.503 1.169 5.326-.327 6.134","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m100.4 36.49-5.355 1.405-1.934.5c-.247.012-.458.095-.694.238.286-6.097.236-10.575-.037-12.397-.111-.738-.31-1.393-.459-1.882.347.489.72 1.037 1.054 1.703 1.165 2.275.67 3.24 1.475 5.216.992 2.454 3.446 5.18 5.95 5.217","fill":"#008E8A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M93.085 38.494h-.011c-.442.316-.907.924-1.531 2a21.228 21.228 0 0 0-.896 1.71c.442-7.572.43-13.224.136-15.308-.204-1.521-.749-2.727-.749-2.727a9.289 9.289 0 0 0-1.236-2c.635-.106 1.35-.223 2.348-.492.363.468.794 1.1 1.157 1.907 0 0 .147.316.306.843 0 .012.011.023.011.023s0 .012.011.012c.137.48.318 1.124.42 1.85.25 1.79.295 6.19.034 12.182","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M90.67 41.742c-.706 1.43-1.188 2.801-1.812 4.548-.636 1.77-1.365 3.727-1.848 6.176a40.262 40.262 0 0 1-4.39-8.814c-.4-1.148-.719-2.25-.99-3.305.413-1.148.848-2.426 1.343-3.832.2-.586.482-1.418.788-2.45a39.26 39.26 0 0 1-9.817 2.356c-.211.024-.423.047-.635.059a4.064 4.064 0 0 1-.8.762 9.805 9.805 0 0 1-.495-.668c-.06-.094-.118-.176-.165-.258-.918-1.466-.977-2.532-.848-3.259.118-.633.413-.96 1.33-3.012.377-.855.766-1.723 1.154-2.566.13.117.236.222.306.304a19.353 19.353 0 0 0 2.437-.668c2.578-.879 3.378-1.734 6.933-3.493 1.871-.914 2.801-1.383 3.731-1.605.671-.176 1.236-.246 1.86-.34.4.48.883 1.148 1.283 2.004 0 0 .565 1.207.777 2.73.306 2.087.318 7.748-.141 15.331","fill":"#00A8A8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M73.627 12.77c-.024.352-.396.811-2.115 1.329-.108.694-.192 1.283-.264 1.753-.938 6.425-.962 8.249-.758 10.05.097.752.217 1.412.325 1.917-.156.306-.276.683-.42 1.095-1.479 4.247-1.935 4.212-1.875 5.589.012.424.06 1.4.396 2.2.097.26.24.518.42.718-.816.306-1.742.459-2.643.153-2.211-.764-2.74-3.789-3.112-5.883-.517-2.977-.025-5.307.6-8.237.565-2.636 1.37-4.895 2.404-7.849.288-.824.565-1.565.805-2.189.048 0 .096-.011.144-.011-.024-.07-.048-.141-.06-.224v-.012a5.568 5.568 0 0 1 .216-3.247c.012-.036.025-.083.049-.118.156-.377.372-.718.624-1.024a3.79 3.79 0 0 1 .878-.753 3.929 3.929 0 0 1 2.331-.623h.024c.986.046 1.55.082 1.875.482.18.224.18.435.12.647-.096.283-.3.565-.433.894a1.18 1.18 0 0 0-.06.189c-.204.776-.432 1.53-.408 2.059.012.306.096.494.216.612.289.294.733.223.721.482","fill":"#FCD0A3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M68.719 8.737c-.25.332-.466.704-.621 1.114-.024.039-.036.09-.048.128a6.61 6.61 0 0 0-.215 3.536v.012c-.024.077-.06.167-.083.257-.992.102-2.281.23-3.034.307a1.962 1.962 0 0 1-.931-.666c-.753-1-.43-2.716.418-3.677.43-.473.92-.704 1.301-.82h.012l3.2-.191z","fill":"#39565B"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m76.749 13.049-3.777.15c-.132-.137-.224-.355-.237-.709-.026-.613.224-1.485.447-2.384.014-.069.04-.15.066-.218l3.409-.26c-.474.355-.777.982-.777 1.677 0 .75.356 1.403.869 1.744","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M77.346 12.458c-.531 0-.961-.46-.961-1.047 0-.573.43-1.034.96-1.034s.96.461.96 1.034c0 .586-.43 1.047-.96 1.047m.474-2.71h-.029a1.555 1.555 0 0 0-.76-.11l-.53.041-.244.014c-.516.363-.846 1.005-.846 1.718 0 .768.388 1.438.947 1.787l.874-.028c.975-.041 1.749-.824 1.749-1.773a1.77 1.77 0 0 0-1.161-1.648","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M77.643 10.961c0 .503-.3.899-.67.899-.369 0-.669-.396-.669-.899 0-.491.3-.886.67-.886.37 0 .669.395.669.886M81.213 9.48l-3.316.149h-.023a1.037 1.037 0 0 0-.606-.11l-.422.042c-.103-.545-.275-1.921.445-2.875a2.6 2.6 0 0 1 .297-.314l2.276-.204 1.269-.109c-.412.354-.675.981-.675 1.676 0 .75.309 1.403.755 1.744M82.551 8.29c0 .488-.3.893-.67.893-.369 0-.669-.405-.669-.893s.3-.892.67-.892c.37 0 .67.404.67.892","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M82.254 8.888c-.53 0-.96-.475-.96-1.048 0-.573.43-1.048.96-1.048s.96.475.96 1.048c0 .573-.43 1.048-.96 1.048m-.315-2.823-.774.056c-.516.364-.846 1.006-.846 1.72 0 .768.387 1.439.946 1.788l.875-.028c.975-.042 1.75-.825 1.75-1.775 0-1.034-.89-1.845-1.95-1.761","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M78.535 5.658c-.341 0-.936.052-1.493.43-1.378.928-1.264 2.807-1.264 2.886l-2.011.209c.063-.235.063-.47-.127-.718-.341-.444-.936-.483-1.973-.536h-.025c-.885-.051-1.733.21-2.454.692a2.52 2.52 0 0 1 .05-.953c.266-1.057 1.114-1.553 1.329-1.684.847-.496 1.695-.365 1.947-.326h6.02z","fill":"#39565B"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m79.875 6.507-2.303.174c-.127.093-.22.185-.3.267-.73.812-.556 1.985-.452 2.45l-.196.01-2.997.221c.128-.325.325-.603.417-.882l1.84-.186c0-.07-.105-1.741 1.156-2.565.51-.337 1.053-.383 1.365-.383h.127c.128 0 .544 0 .915.29.231.174.358.406.428.604M87.013 53.09c-.068.402-.148.815-.205 1.253-.023.118-.034.236-.046.354a50.318 50.318 0 0 1-5.082-10.605c-.171-.484-.331-.97-.468-1.454.183-.555.388-1.147.593-1.773.262 1.064.57 2.175.957 3.334a41.297 41.297 0 0 0 4.251 8.89","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M108.246 56.307c-.491 1.01-1.801 1.25-2.537 1.407-.281.06-.55.12-.807.18-5.508 1.262-5.227 2.741-9.81 3.03-1.93.12-4.081-.289-8.385-1.106-1.215-.24-2.42-.493-3.577-.83-2.023-.601-3.894-1.467-5.38-2.873-.584-.553-1.157-1.239-1.367-2.213-.363-1.671.62-3.174 1.075-3.908 1.111-1.791 2.035-4.1 3.321-7.79.14.492.304.985.48 1.478a50.96 50.96 0 0 0 5.215 10.785c-.082.662-.106 1.395.233 2.14.889 1.948 3.38 2.297 3.508 2.31a4.92 4.92 0 0 0 1.754-.121h.036a32.455 32.455 0 0 0 4.057-.481 33.839 33.839 0 0 0 3.32-.77c.433-.108.854-.24 1.263-.36 2.269-.722 4.292-1.588 5.976-2.49.514-.18.97-.42 1.344-.66.035-.025.082-.061.117-.085.07.168.129.337.176.505.199.601.269 1.275-.012 1.852","fill":"#00A8A8"}}),_c('path',{attrs:{"d":"m82.338 119.4-.021 1.338","stroke":"#070707","stroke-width":".343"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m87.906 112.914-.125 1.72-.546 7.481-.216.289c-.341.323-.898.75-1.672.935-.66.161-1.172.069-2.525-.289-3.447-.889-2.31-.808-4.903-1.582-.341-.103-1.035-.311-1.559-.935-.147-.184-.636-.761-.466-1.12.239-.519 1.65-.195 3.913-.034a32.14 32.14 0 0 0 2.423.081l.057-5.322.012-1.432c.068.047.147.081.227.127a4.96 4.96 0 0 0 1.263.52c1.57.427 2.968.034 3.742-.277.148-.058.273-.116.375-.162","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M91.03 72.075c.423.024.87.036 1.352.011l2.922-.433a12.66 12.66 0 0 0 2.419-.892","stroke":"#6D1212","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m107.622 121.443.011.844c-.343.582-.902.915-1.851 1.034-.286.048-.902.582-3.485-1.533-1.988-1.641-.845-.951-2.947-2.818-.377-.333-.994-.88-1.143-1.736-.023-.118-.103-.63.08-.951v-.011a.63.63 0 0 1 .114-.131c.354-.297 1.006.012 1.611.25.675.261 1.6.57 2.8.76 0-1.723-.046-3.507-.126-5.337.377.238.823.452 1.325.618 1.783.57 3.428.202 4.422-.143-.206 2.045-.48 4.256-.845 6.634l.034 2.52z","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M76.596 82.508c-.332 1.046-1.133 1.839-1.985 2.326h-.01a4.331 4.331 0 0 1-1.133.498c-1.164.325-2.37.112-3.47-.396-1.622-.762-3.056-2.174-3.856-3.505a5.97 5.97 0 0 1-.24-.437c-.57-1.087-.851-2.255-.934-3.342l-.01-.01a11.764 11.764 0 0 1-.042-1.585c.01-.376.041-.742.072-1.077.094-.884.26-1.585.343-1.95.323-1.433.51-2.896.905-4.297.29-1.037.643-2.043.26-3.17a2.914 2.914 0 0 0-.281-.57 4.115 4.115 0 0 1-2.1-.182c-.623-.234-1.142-.61-1.465-1.118-.478-.741.097-1.933.596-2.248 1.967-1.24 7.439-1.355 9.36.217 2.48 2.03 2.38 5.75 2.286 7.365-.177 2.428-.894 2.286-.977 4.246a7.246 7.246 0 0 0 .488 2.947c.946 2.53 2.91 4.073 2.193 6.288","fill":"#876751"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M66.514 68.027c-.394 1.412-.573 2.895-.895 4.33a16.885 16.885 0 0 0-.334 1.974c-.835-.43-1.85-1.172-2.398-2.368-.966-2.082-.036-4.39.644-6.077.287-.73.609-1.34.895-1.818.609.24 1.324.311 2.064.191.108.168.203.36.275.574.381 1.137.035 2.154-.251 3.194","fill":"#FCD0A3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M66.933 85.554c-.483.103-.944.217-1.396.34l-.126.485c-.063-1.886-.252-4.926-.892-6.945-.4-1.309-.935-2-1.48-2.453a2.67 2.67 0 0 0-.568-.391 8.825 8.825 0 0 1 1.775-.474c.2.196.42.433.63.71.178.228.346.465.493.774l.01.01c.084 1.103.368 2.288.945 3.39.095.546.19 1.144.295 1.845.094.69.199 1.617.314 2.71","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M47.757 105.675c-.257.252-1.002.934-1.632.755-1.234-.371-1.054-3.928-1.04-4.347.025-.563.09-1.042.153-1.425.129.132.258.228.36.3.874.61 2.146.694 3.419.275.141 1.066.192 3.113-1.26 4.442","fill":"#FCD0A3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M79.874 86.826a5.174 5.174 0 0 0-.912-.986 4.151 4.151 0 0 0-.866-.552c.023-1.262 0-3.316-.196-5.31a6.408 6.408 0 0 0-.704-2.523 6.88 6.88 0 0 1 1.627 1.922 7.635 7.635 0 0 1 .935 3.46l.116 3.989zM77.19 84.594l-.242-.032-2.236-.298c.79-.512 1.533-1.343 1.841-2.441.665-2.324-1.157-3.945-2.034-6.6.453.16.964.395 1.504.757.222.331.405.715.579 1.184.288.778.356 1.439.404 1.908.193 2.079.203 4.211.184 5.522","fill":"#FFEA00"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M80.249 88.315a.368.368 0 0 1-.198.176c-.148.078-.366.1-.653.078-.406-.023-.94-.11-1.593-.177-2.602-.254-3.928.121-5.036.21-.485.022-.93.01-1.415-.155-.218-.066-.446-.176-.703-.298-.91-.497-.96-.861-2.453-1.689a14.66 14.66 0 0 0-2.603-1.137c.426-.132.861-.254 1.316-.364.198-.045.396-.1.604-.133h.01c.356.243.791.541 1.276.861 1.346.905 1.741 1.148 2.365 1.336.455.143.801.166 1.514.232 1.078.11 1.246-.011 3.017 0 1.415.01 2.118.01 2.395.044.713.077.99.155 1.078 0 .11-.199-.207-.806-1.998-2.506 0-.066.01-.121 0-.199l.05.011c.197.067.445.155.722.298.277.133.573.332.86.585.337.298.663.674.92 1.06v.011l.01.012c.456.673.723 1.357.515 1.744","fill":"#2A3F44"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M79.867 103.031c-.546.186-1.139.361-1.743.524a33.968 33.968 0 0 1-6.783 1.072 28.54 28.54 0 0 1-1.731.047c.237-.116.522-.303.806-.594l.368-.432a26.027 26.027 0 0 0 1.34-5.525c.059-.502.118-1.026.142-1.574a22.076 22.076 0 0 0-.296-5.362 21.235 21.235 0 0 0-.605-2.577c.498.152.948.164 1.446.14.119.432.297.991.534 1.632.64 1.714 1.055 2.122 1.85 3.86 1.102 2.4 1.09 3.263 1.672 3.356.972.152 2.063-2.11 2.181-2.366 1.103-2.285.973-4.675.57-6.505.296.011.521 0 .675-.07.226.77.415 1.586.57 2.46.865 4.85-.036 9.069-.996 11.914","fill":"#2A3F44"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M78.614 95.096c-.112.264-1.14 2.587-2.057 2.431-.548-.096-.537-.981-1.577-3.448-.749-1.785-1.14-2.204-1.744-3.964a22.533 22.533 0 0 1-.503-1.676c1.073-.084 2.359-.431 4.874-.192.638.06 1.152.144 1.543.168.38 1.88.504 4.334-.536 6.681","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M70.057 84.495c-.805.08-1.651.192-2.548.374-.082.01-.163.03-.245.05h-.01c-.214.03-.418.08-.622.121a95.169 95.169 0 0 0-.306-2.655 79.651 79.651 0 0 0-.285-1.807c.071.151.153.293.234.434.785 1.323 2.192 2.726 3.782 3.483","fill":"#FFEA00"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M76.743 84.23c.017.132 0 .226 0 .34l-.439-.397.439.056zM78.962 87.208c-.089.11-.364.055-1.073 0-.275-.023-.974-.023-2.381-.031-1.762-.008-1.93.078-3.002 0-.709-.048-1.053-.063-1.506-.165-.62-.134-1.013-.307-2.352-.95-.482-.228-.915-.44-1.27-.613a30.174 30.174 0 0 1 2.696-.33c1.045.393 2.186.558 3.288.306a4.622 4.622 0 0 0 1.073-.385h.01l2.283.22.246.165c1.781 1.21 2.096 1.642 1.988 1.783","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M71.791 95.75c-1.426-.186-4.44-.835-6.53-3.307a8.577 8.577 0 0 1-1.45-2.506v-.012c.1-.36.174-.719.25-1.113.224-1.277.287-2.333.312-2.971l.1-.336.125-.465a17.38 17.38 0 0 1 2.815 1.022c1.626.742 1.676 1.079 2.665 1.52.275.116.525.209.763.267.25.789.475 1.647.638 2.563.362 1.892.425 3.69.312 5.338","fill":"#39565B"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M71.842 96.817c-.023.56-.083 1.097-.143 1.61-1.192-.143-4.361-.704-6.518-3.447a8.428 8.428 0 0 1-1.37-2.517c.154-.5.297-1.037.428-1.622a9.014 9.014 0 0 0 1.382 2.576c1.99 2.54 4.863 3.209 6.221 3.4","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M71.842 97.946a25.036 25.036 0 0 1-1.372 5.465l-.377.427a3.023 3.023 0 0 1-.825.588 1.97 1.97 0 0 1-.62.208c-2.233.415-4.456-2.48-5.16-3.39-.643-.842-.97-1.269-1.214-1.95-.801-2.27.498-4.012 1.53-7.114a8.024 8.024 0 0 0 1.396 2.433c2.198 2.652 5.428 3.194 6.642 3.333","fill":"#39565B"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M65.149 77.009a3.457 3.457 0 0 0-.589-.644 6.614 6.614 0 0 0-.75-.594c.47-.05.897-.08 1.295-.101-.03.423-.015.876.044 1.339","fill":"#FFEA00"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M77.637 84.594c-.251-.13-.471-.213-.649-.272l-.052-.012c.02-1.244.01-3.268-.167-5.246-.042-.45-.105-1.077-.377-1.823a5.82 5.82 0 0 0-.534-1.125c.2.118.398.272.607.438.094.083.21.178.345.296 0 .012 0 .024.01.024a6.795 6.795 0 0 1 .638 2.487c.179 1.965.2 3.99.179 5.233","fill":"#2D2D2D"}}),_c('path',{attrs:{"d":"M53.101 101.104a31.086 31.086 0 0 0 2.214 4.607c.569.973 1.151 1.982 1.797 2.968 0 0 .012 0 0 .011","stroke":"#171D1E","stroke-width":".31","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60.225 118.631c-.046.111-.278.245-.278.245a13.988 13.988 0 0 0-2.393 1.775c-.813.758-1.278 1.383-2.323 1.885-.162.078-1.382.648-1.637.346-.07-.078-.058-.201.011-.357.082-.19.245-.435.453-.725.535-.748 1.347-1.774 1.719-2.857.058-.167.163-.491.395-.87.047-.067.093-.134.128-.19.313-.413.546-.469.929-1.004.453-.614.36-.848.72-1.149.29-.235.65-.313.952-.335.117-.011.22-.011.325-.011l.755 2.243.047.145s.279.636.197.859","fill":"#00D5E0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M136.847 150.708c-6.435 1.863-35.802 4.423-47.963 4.729-12.02.306-25.612-.035-25.682-1.176-.059-1.023-13.276-2.929-16.281-2.941-7.148-.035-19.715 2.186-17.7-.459 5.8-7.615 16.515-20.324 17.77-21.818 1.339-1.612 2.923-3.07 4.625-4.634a33.468 33.468 0 0 1 1.949-1.659c-.07.165-.082.294-.012.377.258.317 1.49-.283 1.655-.365 1.056-.529 1.526-1.188 2.348-1.988a14.2 14.2 0 0 1 2.418-1.87s.235-.141.281-.258c.082-.236-.2-.906-.2-.906l-.046-.153c.81-.282 1.655-.565 2.512-.823a68.652 68.652 0 0 1 3.216-.882c2.5.67 3.838-.071 6.233-.471.117-.024 2.042-.212 3.192-.706 1.303-.541 1.174-.553 1.268-.682.212-.294.4-.577.552-.871 1.408.259 3.204.542 5.294.812l-.06 5.423c-.692 0-1.548-.012-2.5-.083-2.335-.164-3.79-.494-4.037.035-.176.365.328.953.481 1.141.54.635 1.256.847 1.608.953 2.677.788 1.503.706 5.06 1.611 1.396.365 1.924.459 2.605.295.798-.189 1.373-.624 1.726-.953l.223-.294.563-7.622c1.678.094 2.723.094 4.66.435 1.244.212 3.087.529 5.212 1.2v.012c-.188.317-.106.823-.082.941.152.846.786 1.388 1.173 1.717 2.16 1.846.986 1.164 3.029 2.788 2.652 2.093 3.286 1.564 3.58 1.517.974-.118 1.549-.447 1.901-1.023l-.011-.836.88.612c1.479 1.07 2.512 1.988 3.392 3.164.61.823 1.315 1.929 2.641 2.258 1.831.471 2.934-1.023 4.695-1.082 1.491-.035 2.806.988 3.909 2.27.798.918 1.479 1.964 2.054 2.835 1.878 2.834 3.181 5.01 4.296 6.845 0 0-.012.012 0 .024 1.784 2.976.532 3.972 2.738 6.524 1.503 1.729 5.814 5.753 4.835 6.037","fill":"#BAA479"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55.778 116.74a73.752 73.752 0 0 0-1.994 3.182c-.185.319-.37.65-.556.969-.707.343-1.437.675-2.19 1.005-.51.213-1.009.426-1.507.627a682.94 682.94 0 0 1 1.704-5.357 492.8 492.8 0 0 1 2.04-6.245 903.412 903.412 0 0 0 2.503 5.819M59.793 111.827c-.4.438-.786.876-1.172 1.326l-.24-.727a160.813 160.813 0 0 0-1.265-3.736c.786 1.096 1.651 2.168 2.677 3.137","fill":"#2D2D2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53.992 122.05c-.21.31-.374.572-.455.775a33.255 33.255 0 0 0-1.938 1.681c-1.692 1.586-3.267 3.064-4.598 4.698-.361.024-1.096.036-1.295-.167-.164-.155-.28-.763-.105-.894 1.412-.942 2.836-4.197 3.268-5.27.198-.072.408-.155.618-.251.502-.202 1.004-.417 1.517-.632a64.34 64.34 0 0 0 2.206-1.013 6.78 6.78 0 0 0 .513-.239l.269 1.312z","fill":"#00D5E0"}}),_c('path',{attrs:{"d":"M96.384 37.87c.209.225.512.57.838 1.018.538.74.878 1.406 1.42 2.591.872 1.912.69 1.716.999 2.283.648 1.186 1.4 2.562 2.935 3.115 1.366.492 2.664.084 3.224-.092a5.954 5.954 0 0 0 2.806-1.913c1.013-1.208 1.246-2.443 1.419-3.362.154-.815.356-1.958-.032-3.362-.428-1.547-1.341-2.575-1.871-3.085","stroke":"#171D1E","stroke-width":".31","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M102.185 38.633c.231.377.456.792.665 1.246.944 2.055 1.135 4.026 1.119 5.448M105.755 37.295c.231.377.456.791.665 1.245.944 2.055 1.135 4.026 1.119 5.448","stroke":"#171D1E","stroke-width":".31","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M85.037 60.944a14.179 14.179 0 0 0-.255 2.523c-.02 1.716.264 3.037.446 3.725M86.695 62.645a29.61 29.61 0 0 0 5.228-.362l-.192 3.92-1.912 2.773-3.187-1.507-.51-2.352","stroke":"#6D1212","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M97.724 62.271a8.78 8.78 0 0 0 2.37-.197 9.134 9.134 0 0 0 3.431-1.576","stroke":"#6D1212","stroke-width":".31","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"m97.724 61.92 1.113 3.732 2.969 1.54 1.855-2.607.31-4.087M99.061 71.654a72.75 72.75 0 0 0 .56 5.463 74.098 74.098 0 0 0 3.457 14.17","stroke":"#6D1212","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M66.933 85.487c.465.17.862.335 1.183.477.685.302 1.28.564 1.981.996.532.326.667.469 1.088.603.379.121.723.15 1.15.154.951.01 1.547-.111 2.142-.182.734-.087 1.443-.058 2.86 0 1.787.074 2.33.227 2.494-.014.13-.19.038-.647-1.406-1.908M72.199 88.61c.157.8.287 1.637.378 2.51.483 4.575-.218 8.601-1.182 11.769M80.097 88.61c.209.847.435 1.967.567 3.294.055.56.246 2.687-.103 5.49a26.927 26.927 0 0 1-1.134 5.049M65.595 90.395c.042.66.213 1.172.389 1.545 1.196 2.538 4.616 2.887 4.966 2.917M62.918 97.535a8.44 8.44 0 0 0 .628 1.965c.42.912 1.1 2.387 2.693 3.231 1.42.754 2.864.632 3.544.524l.674-1.965.493-2.402","stroke":"#171D1E","stroke-width":".31","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M65.595 97.088c.4.317.96.7 1.698 1.045a9.736 9.736 0 0 0 2.318.74M61.58 104.674a8.844 8.844 0 0 0 1.848 2.982c2.843 2.999 6.917 2.866 9.18 2.792 2.965-.097 3.904-.969 4.27-1.396a3.67 3.67 0 0 0 .765-1.522M66.041 111.814c.574.154 1.47.35 2.613.42 1.16.071 2.12-.015 2.742-.099M75.412 111.368c.228-.04.58-.142.967-.429.396-.294.663-.662.818-.91","stroke":"#171D1E","stroke-width":".31","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M83.89 34.171a6.693 6.693 0 0 0 1.843-1.057c1.264-1.02 1.89-2.273 2.172-2.959M77.196 35.51c.8-.2 1.685-.503 2.594-.97 3.673-1.89 5.291-5.18 5.884-6.616","stroke":"#876751","stroke-width":".31"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61.133 150.362a17.082 17.082 0 0 1-.032-.173l-.414.446.446-.273z","fill":"#BAA479"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M76.742 149.692c-.159-4.106-.83-8.887-2.206-13.524l-2.77 5.299 2.13-7.296c-1.73-4.996-4.331-9.68-8.06-12.987.247 3.042-.396 6.944-1.285 10.954l2.546 3.951-2.913-2.344c-.706 3.016-1.501 6.035-2.115 8.744l3.879 3.092-4.158-1.819a52.571 52.571 0 0 0-.408 2.131c.472.648.93 1.284 1.361 1.897l-1.61 2.926.016.146 2.17-2.239c.78 1.144 1.44 2.201 1.894 3.125.49.999.83 2.178 1.058 3.43 2.335.212 5.725.331 9.487.365.665-1.86 1.06-3.838.984-5.851","fill":"#ABE532"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M66.169 151.641c-.52-1.05-1.275-2.253-2.166-3.555l-2.484 2.548-.256.262.237-.429 1.843-3.328a150.628 150.628 0 0 0-1.559-2.158c-1.014-1.386-2.087-2.829-3.13-4.283l-1.555 2.838.711-4.029c-2.084-2.98-3.934-5.951-4.77-8.506-1.886 3.884-2.393 8.529-2.087 13.148l4.207 5.259-4.044-3.429c.236 2.128.63 4.227 1.126 6.222 3.458.442 7.69 1.142 9.904 1.767.929.262 1.503.511 1.515.723.023.364 1.428.646 3.72.852-.262-1.424-.65-2.765-1.212-3.902M100.847 155.544l.446-.447-.232.011c-.069.154-.14.299-.214.436","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M125.84 141.783c1.269.033 2.672-1.126 2.672-1.126s-1.683-.731-2.828-.535c-.956.164-1.419.714-1.547.893-.146-.02-.293-.037-.44-.051.26-.105.565-.282.893-.583.958-.881 1.272-2.738 1.272-2.738s-1.7.66-2.424 1.621c-.525.698-.592 1.347-.589 1.651a12.668 12.668 0 0 0-1.515.055 4.25 4.25 0 0 0 .661-.579c1.132-1.211 1.363-3.589 1.363-3.589s-2.089 1.008-2.918 2.296c-.577.898-.625 1.696-.601 2.099-.597.124-1.202.29-1.814.493.204-.185.417-.413.63-.695 1.132-1.498 1.126-4.188 1.126-4.188s-2.225 1.392-3.009 2.939c-.622 1.228-.49 2.223-.409 2.583-.607.265-1.22.567-1.84.906.239-.264.485-.595.718-1.02 1.001-1.818.589-4.73.589-4.73s-2.2 1.892-2.816 3.702c-.533 1.567-.136 2.682-.02 2.953-.515.327-1.035.679-1.558 1.056.214-.31.427-.7.611-1.19.736-1.956-.075-4.77-.075-4.77s-1.913 2.22-2.271 4.107c-.295 1.559.189 2.576.367 2.884a44.63 44.63 0 0 0-1.66 1.382c.223-.358.44-.822.605-1.426.552-2.025-.516-4.739-.516-4.739s-1.699 2.411-1.879 4.328c-.156 1.644.472 2.617.653 2.86-.579.538-1.161 1.1-1.747 1.691.229-.417.444-.97.573-1.7.387-2.177-.986-4.901-.986-4.901s-1.549 2.705-1.558 4.729c-.007 1.74.745 2.69.956 2.923a66.805 66.805 0 0 0-1.449 1.577c.213-.447.406-1.039.494-1.814.259-2.258-1.32-4.95-1.32-4.95s-1.416 2.883-1.297 4.957c.101 1.76.909 2.678 1.153 2.916-.425.496-.84.991-1.243 1.484l.366-.02c.339-.412.685-.824 1.038-1.237.149.238.506.7 1.203 1.102 1.918-.123 3.905-.269 5.97-.444-.518-.35-2.666-1.735-4.362-1.812-1.019-.046-1.765.23-2.246.503l.322-.367a71.51 71.51 0 0 1 1.516-1.654c.209.376.837 1.248 2.366 1.738 1.985.636 4.661-.542 4.661-.542s-2.356-1.927-4.238-2.145c-.972-.113-1.706.096-2.191.324a59.048 59.048 0 0 1 2.143-2.101c.172.384.698 1.259 2.088 1.865 1.826.796 4.463-.059 4.463-.059s-2.068-2.055-3.833-2.446c-.931-.206-1.655-.069-2.133.105a45.89 45.89 0 0 1 2.195-1.863c.12.377.546 1.339 1.917 2.114 1.743.985 4.446.413 4.446.413s-1.868-2.264-3.587-2.839c-.99-.331-1.773-.232-2.261-.088a34.252 34.252 0 0 1 2.364-1.662c.084.427.401 1.401 1.592 2.34 1.587 1.252 4.339 1.116 4.339 1.116s-1.532-2.536-3.152-3.378c-.903-.469-1.671-.509-2.175-.452a24.013 24.013 0 0 1 2.74-1.439c.008.352.13 1.325 1.147 2.408 1.277 1.358 3.78 1.63 3.78 1.63s-1.065-2.51-2.423-3.503c-.846-.619-1.607-.729-2.061-.724a16.944 16.944 0 0 1 3.032-.951c-.007.034-.204 1.058.788 2.364 1.009 1.329 3.197 1.82 3.197 1.82s-.721-2.326-1.834-3.339c-.77-.702-1.503-.838-1.882-.856.131-.016.304-.052.508-.127a12.679 12.679 0 0 1 2.191-.143c-.036.245-.066.932.507 1.815.72 1.11 2.415 1.636 2.415 1.636s-.438-1.876-1.258-2.745a2.637 2.637 0 0 0-.961-.668c.277.023.553.055.826.098.262.195.729.433 1.47.452","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M99.37 148.85s-1.358 2.998-1.185 5.12c.052.631.189 1.151.356 1.574.645-.032 1.3-.066 1.962-.103.149-.417.272-.928.327-1.555.204-2.322-1.46-5.036-1.46-5.036M95.045 155.544c.877-.036 1.77-.075 2.678-.119-.45-2.064-1.625-3.897-1.625-3.897s-.791 2.001-1.053 4.016","fill":"#fff"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"6fdvx3na9d","maskUnits":"userSpaceOnUse","x":"92","y":"155","width":"2","height":"1"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M92.994 155.631h.223v.136h-.223v-.136z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#6fdvx3na9d)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m93.08 155.767.051-.002-.035-.048-.017.05","fill":"#fff"}})])])
}
var no_result_svgvue_type_template_id_0a02a3e4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/no-result-svg.vue?vue&type=template&id=0a02a3e4

// CONCATENATED MODULE: ./src/components/svg/ui/no-result-svg.vue

var no_result_svg_script = {}


/* normalize component */

var no_result_svg_component = normalizeComponent(
  no_result_svg_script,
  no_result_svgvue_type_template_id_0a02a3e4_render,
  no_result_svgvue_type_template_id_0a02a3e4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var no_result_svg = (no_result_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/trustpilot-star-svg.vue?vue&type=template&id=34cee7ed
var trustpilot_star_svgvue_type_template_id_34cee7ed_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"539","height":"513","viewBox":"0 0 539 513","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M269.2 0.299988L355.7 164.3L538.4 195.9L409.1 328.8L435.5 512.3L269.2 430.5L102.8 512.3L129.2 328.8L0 195.9L182.6 164.3L269.2 0.299988Z","fill":"#00B67A"}})])
}
var trustpilot_star_svgvue_type_template_id_34cee7ed_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/trustpilot-star-svg.vue?vue&type=template&id=34cee7ed

// CONCATENATED MODULE: ./src/components/svg/ui/trustpilot-star-svg.vue

var trustpilot_star_svg_script = {}


/* normalize component */

var trustpilot_star_svg_component = normalizeComponent(
  trustpilot_star_svg_script,
  trustpilot_star_svgvue_type_template_id_34cee7ed_render,
  trustpilot_star_svgvue_type_template_id_34cee7ed_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var trustpilot_star_svg = (trustpilot_star_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/instagram-footer-svg.vue?vue&type=template&id=2724b112
var instagram_footer_svgvue_type_template_id_2724b112_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20.228 16.124a4.095 4.095 0 0 0-4.1 4.103 4.095 4.095 0 0 0 4.1 4.102 4.095 4.095 0 0 0 4.102-4.102 4.095 4.095 0 0 0-4.102-4.103Zm0 6.77a2.671 2.671 0 0 1-2.666-2.667 2.67 2.67 0 0 1 2.666-2.667 2.67 2.67 0 0 1 2.667 2.667c0 1.47-1.2 2.666-2.667 2.666Zm5.226-6.937a.954.954 0 0 1-.957.956.957.957 0 1 1 .957-.957Zm2.716.97c-.06-1.281-.353-2.416-1.292-3.352-.935-.935-2.07-1.228-3.352-1.292-1.32-.075-5.279-.075-6.6 0-1.277.06-2.412.353-3.351 1.289-.939.935-1.228 2.07-1.292 3.352-.075 1.321-.075 5.28 0 6.602.06 1.281.353 2.416 1.292 3.352.939.935 2.07 1.228 3.352 1.292 1.32.075 5.279.075 6.6 0 1.28-.06 2.416-.353 3.351-1.292.935-.936 1.228-2.07 1.292-3.352.075-1.322.075-5.277 0-6.598Zm-1.706 8.016a2.7 2.7 0 0 1-1.52 1.52c-1.053.418-3.552.322-4.716.322-1.163 0-3.666.093-4.715-.321a2.7 2.7 0 0 1-1.52-1.521c-.418-1.053-.322-3.553-.322-4.716 0-1.164-.092-3.667.322-4.717a2.7 2.7 0 0 1 1.52-1.52c1.053-.418 3.552-.322 4.715-.322 1.164 0 3.666-.093 4.716.321a2.7 2.7 0 0 1 1.52 1.521c.418 1.054.321 3.553.321 4.717 0 1.163.097 3.666-.32 4.716Z","fill":"#000"}})])
}
var instagram_footer_svgvue_type_template_id_2724b112_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/instagram-footer-svg.vue?vue&type=template&id=2724b112

// CONCATENATED MODULE: ./src/components/svg/ui/instagram-footer-svg.vue

var instagram_footer_svg_script = {}


/* normalize component */

var instagram_footer_svg_component = normalizeComponent(
  instagram_footer_svg_script,
  instagram_footer_svgvue_type_template_id_2724b112_render,
  instagram_footer_svgvue_type_template_id_2724b112_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var instagram_footer_svg = (instagram_footer_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/facebook-footer-svg.vue?vue&type=template&id=52d87708
var facebook_footer_svgvue_type_template_id_52d87708_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m25.357 22.25.534-3.62h-3.334v-2.348c0-.99.465-1.956 1.959-1.956h1.515v-3.082S24.656 11 23.341 11c-2.746 0-4.54 1.734-4.54 4.872v2.759h-3.053v3.619H18.8V31h3.756v-8.75h2.801Z","fill":"#000"}})])
}
var facebook_footer_svgvue_type_template_id_52d87708_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/facebook-footer-svg.vue?vue&type=template&id=52d87708

// CONCATENATED MODULE: ./src/components/svg/ui/facebook-footer-svg.vue

var facebook_footer_svg_script = {}


/* normalize component */

var facebook_footer_svg_component = normalizeComponent(
  facebook_footer_svg_script,
  facebook_footer_svgvue_type_template_id_52d87708_render,
  facebook_footer_svgvue_type_template_id_52d87708_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var facebook_footer_svg = (facebook_footer_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/youtube-footer-svg.vue?vue&type=template&id=1e0f4e89
var youtube_footer_svgvue_type_template_id_1e0f4e89_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.888 15.767c-.184-.74-.726-1.321-1.414-1.519-1.248-.359-6.251-.359-6.251-.359s-5.004 0-6.251.36c-.689.197-1.231.779-1.415 1.518-.334 1.34-.334 4.134-.334 4.134s0 2.795.334 4.135a2.047 2.047 0 0 0 1.415 1.494c1.247.36 6.25.36 6.25.36s5.004 0 6.252-.36a2.049 2.049 0 0 0 1.414-1.494c.335-1.34.335-4.135.335-4.135s0-2.795-.335-4.134Zm-9.302 6.672v-5.075l4.182 2.537-4.182 2.538Z","fill":"#000"}})])
}
var youtube_footer_svgvue_type_template_id_1e0f4e89_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/youtube-footer-svg.vue?vue&type=template&id=1e0f4e89

// CONCATENATED MODULE: ./src/components/svg/ui/youtube-footer-svg.vue

var youtube_footer_svg_script = {}


/* normalize component */

var youtube_footer_svg_component = normalizeComponent(
  youtube_footer_svg_script,
  youtube_footer_svgvue_type_template_id_1e0f4e89_render,
  youtube_footer_svgvue_type_template_id_1e0f4e89_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var youtube_footer_svg = (youtube_footer_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/tiktok-footer-svg.vue?vue&type=template&id=ac00e292
var tiktok_footer_svgvue_type_template_id_ac00e292_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M28.218 18.209a7.397 7.397 0 0 1-4.385-1.431v6.516a6.013 6.013 0 0 1-1.035 3.376 5.824 5.824 0 0 1-2.736 2.172 5.692 5.692 0 0 1-3.46.194 5.788 5.788 0 0 1-2.953-1.853 6.031 6.031 0 0 1-.727-6.712 5.862 5.862 0 0 1 2.485-2.468 5.702 5.702 0 0 1 3.418-.582v3.277a2.613 2.613 0 0 0-1.644.015 2.67 2.67 0 0 0-1.323.997 2.76 2.76 0 0 0-.497 1.6 2.76 2.76 0 0 0 .516 1.593c.332.462.8.806 1.334.98.535.176 1.11.174 1.644-.004a2.669 2.669 0 0 0 1.328-.989c.33-.464.508-1.023.508-1.596V10.556h3.142c-.002.27.02.541.067.808.109.595.336 1.162.667 1.665.331.503.76.931 1.258 1.26.71.479 1.542.734 2.393.734v3.186Z","fill":"#000"}})])
}
var tiktok_footer_svgvue_type_template_id_ac00e292_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/tiktok-footer-svg.vue?vue&type=template&id=ac00e292

// CONCATENATED MODULE: ./src/components/svg/ui/tiktok-footer-svg.vue

var tiktok_footer_svg_script = {}


/* normalize component */

var tiktok_footer_svg_component = normalizeComponent(
  tiktok_footer_svg_script,
  tiktok_footer_svgvue_type_template_id_ac00e292_render,
  tiktok_footer_svgvue_type_template_id_ac00e292_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tiktok_footer_svg = (tiktok_footer_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/linkedin-footer-svg.vue?vue&type=template&id=5c69eee3
var linkedin_footer_svgvue_type_template_id_5c69eee3_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.105 27.646h-3.082v-9.927h3.082v9.927Zm-1.543-11.28c-.985 0-1.785-.817-1.785-1.803a1.785 1.785 0 0 1 3.57 0c0 .986-.8 1.802-1.785 1.802Zm13.08 11.28h-3.076v-4.832c0-1.152-.023-2.629-1.602-2.629-1.603 0-1.848 1.251-1.848 2.546v4.915h-3.08v-9.927h2.957v1.354h.043c.411-.78 1.417-1.603 2.916-1.603 3.12 0 3.693 2.055 3.693 4.723v5.453h-.003Z","fill":"#000"}})])
}
var linkedin_footer_svgvue_type_template_id_5c69eee3_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/linkedin-footer-svg.vue?vue&type=template&id=5c69eee3

// CONCATENATED MODULE: ./src/components/svg/ui/linkedin-footer-svg.vue

var linkedin_footer_svg_script = {}


/* normalize component */

var linkedin_footer_svg_component = normalizeComponent(
  linkedin_footer_svg_script,
  linkedin_footer_svgvue_type_template_id_5c69eee3_render,
  linkedin_footer_svgvue_type_template_id_5c69eee3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var linkedin_footer_svg = (linkedin_footer_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/pinterest-footer-svg.vue?vue&type=template&id=2afe8ffc
var pinterest_footer_svgvue_type_template_id_2afe8ffc_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 10c-5.523 0-10 4.477-10 10 0 4.237 2.636 7.855 6.356 9.312-.088-.791-.167-2.005.035-2.868.182-.78 1.172-4.97 1.172-4.97s-.299-.6-.299-1.486c0-1.39.806-2.428 1.81-2.428.852 0 1.264.64 1.264 1.408 0 .858-.546 2.14-.828 3.33-.236.995.5 1.807 1.48 1.807 1.778 0 3.144-1.874 3.144-4.58 0-2.393-1.72-4.067-4.177-4.067-2.845 0-4.514 2.134-4.514 4.339 0 .859.33 1.781.744 2.281a.3.3 0 0 1 .069.288l-.278 1.133c-.044.184-.145.223-.335.134-1.249-.581-2.03-2.407-2.03-3.874 0-3.154 2.292-6.052 6.608-6.052 3.469 0 6.165 2.473 6.165 5.776 0 3.447-2.173 6.22-5.19 6.22-1.013 0-1.965-.526-2.291-1.148l-.623 2.378c-.226.869-.835 1.958-1.244 2.621.937.29 1.931.446 2.962.446 5.523 0 10-4.477 10-10s-4.477-10-10-10Z","fill":"#000"}})])
}
var pinterest_footer_svgvue_type_template_id_2afe8ffc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/pinterest-footer-svg.vue?vue&type=template&id=2afe8ffc

// CONCATENATED MODULE: ./src/components/svg/ui/pinterest-footer-svg.vue

var pinterest_footer_svg_script = {}


/* normalize component */

var pinterest_footer_svg_component = normalizeComponent(
  pinterest_footer_svg_script,
  pinterest_footer_svgvue_type_template_id_2afe8ffc_render,
  pinterest_footer_svgvue_type_template_id_2afe8ffc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var pinterest_footer_svg = (pinterest_footer_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/telegram-footer-svg.vue?vue&type=template&id=1a8f8260
var telegram_footer_svgvue_type_template_id_1a8f8260_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.1631 21.492L8.4205 19.8863C8.4205 19.8863 7.8537 19.6473 8.03621 19.1055C8.07378 18.9938 8.14957 18.8987 8.37629 18.7353C9.42712 17.9742 27.8264 11.1024 27.8264 11.1024C27.8264 11.1024 28.3459 10.9205 28.6523 11.0415C28.7281 11.0659 28.7963 11.1108 28.85 11.1715C28.9036 11.2323 28.9407 11.3068 28.9576 11.3873C28.9907 11.5296 29.0045 11.676 28.9987 11.8223C28.9972 11.9489 28.9825 12.0661 28.9713 12.2501C28.8593 14.1288 25.5058 28.1507 25.5058 28.1507C25.5058 28.1507 25.3051 28.9712 24.5863 28.9993C24.4096 29.0052 24.2336 28.9741 24.0688 28.9079C23.9039 28.8416 23.7536 28.7415 23.6268 28.6136C22.2161 27.3527 17.3404 23.9479 16.263 23.1991C16.2387 23.1819 16.2182 23.1595 16.203 23.1333C16.1877 23.1072 16.178 23.078 16.1746 23.0476C16.1595 22.9687 16.2421 22.871 16.2421 22.871C16.2421 22.871 24.732 15.0294 24.9579 14.2062C24.9754 14.1425 24.9094 14.111 24.8206 14.1389C24.2567 14.3545 14.4816 20.7689 13.4028 21.4768C13.3251 21.5012 13.243 21.5064 13.1631 21.492Z","fill":"black"}})])
}
var telegram_footer_svgvue_type_template_id_1a8f8260_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/telegram-footer-svg.vue?vue&type=template&id=1a8f8260

// CONCATENATED MODULE: ./src/components/svg/ui/telegram-footer-svg.vue

var telegram_footer_svg_script = {}


/* normalize component */

var telegram_footer_svg_component = normalizeComponent(
  telegram_footer_svg_script,
  telegram_footer_svgvue_type_template_id_1a8f8260_render,
  telegram_footer_svgvue_type_template_id_1a8f8260_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var telegram_footer_svg = (telegram_footer_svg_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"34dc801c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg/ui/whatsapp-footer-svg.vue?vue&type=template&id=bce216f6
var whatsapp_footer_svgvue_type_template_id_bce216f6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"padding":"7px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 448 512"}},[_c('path',{attrs:{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})])
}
var whatsapp_footer_svgvue_type_template_id_bce216f6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/svg/ui/whatsapp-footer-svg.vue?vue&type=template&id=bce216f6

// CONCATENATED MODULE: ./src/components/svg/ui/whatsapp-footer-svg.vue

var whatsapp_footer_svg_script = {}


/* normalize component */

var whatsapp_footer_svg_component = normalizeComponent(
  whatsapp_footer_svg_script,
  whatsapp_footer_svgvue_type_template_id_bce216f6_render,
  whatsapp_footer_svgvue_type_template_id_bce216f6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var whatsapp_footer_svg = (whatsapp_footer_svg_component.exports);
// CONCATENATED MODULE: ./src/lang/deals.js
const deals = {
  en: {
    deal: {
      days: 'Days',
      day: 'Day',
      stars: 'Stars',
      star: 'Star',
    },
  },
  de: {
    deal: {
      days: 'Tage',
      day: 'Tag',
      stars: 'Sterne',
      star: 'Stern',
    },
  },
}

// CONCATENATED MODULE: ./src/lang/search.js
const search = {
  en: {
    search: {
      types: {
        packageDeal: 'Package Deal',
        hotel: 'Hotel',
      },
      where: {
        placeholder: 'Where are you going?',
        noResult: 'No Results could be found',
        noOptions: 'Please enter a search term',
        categories: {
          destinations: 'Destinations',
          cities: 'Cities',
          accommodations: 'Hotels',
          pois: 'Point of interests',
          regions: 'Countries',
        },
      },
      who: {
        child: 'child',
        children: 'children',
        adult: 'adult',
        adults: 'adults',
      },
      durations: {
        '1-4': '1 - 4 Days',
        '5-8': '5 - 8 Days',
        '9-12': '9 - 12 Days',
        '10': '10 Days',
        '1 WE': '1 Weekend',
        '1 W': '1 Week',
        '2 W': '2 Weeks',
        custom: 'Enter yourself',
      },
      airport: {
        placeholder: 'Where to start from?'
      },
      day: 'day',
      days: 'days',
      close: 'close',
    },
  },
  de: {
    search: {
      types: {
        packageDeal: 'Pauschal',
        hotel: 'Hotel',
      },
      where: {
        placeholder: "Wohin soll's gehen",
        noResult: 'Keine Ergebnisse...',
        noOptions: 'Bitte einen Suchbegriff eingeben',
        categories: {
          destinations: 'Reiseziele',
          cities: 'Städte',
          accommodations: 'Hotels',
          pois: 'Sehenswürdigkeiten',
          regions: 'Länder',
        },
      },
      who: {
        istraveleing: 'Wer reist mit?',
        child: 'Kind',
        children: 'Kinder',
        childage: 'Alter des Kindes',
        ageinfo: 'Alter der Kinder bei Rückreise',
        years: 'Jahre',
        adult: 'Erwachsener',
        adults: 'Erwachsene',
      },
      durations: {
        placeholder: 'Wie lange?',
        '1-4': '1 - 4 Tage',
        '5-8': '5 - 8 Tage',
        '9-12': '9 - 12 Tage',
        '10': '10 Tage',
        '1 WE': '1 Wochenende',
        '1 W': '1 Woche',
        '2 W': '2 Wochen',
        custom: 'Reisedauer:',
      },
      airport: {
        placeholder: 'Wo wird gestartet?'
      },
      day: 'Tag',
      days: 'Tage',
      close: 'Schließen',
    },
  },
  ch: {
    search: {
      types: {
        packageDeal: 'Pauschal',
        hotel: 'Hotel',
      },
      where: {
        placeholder: "Wohin soll's gehen",
        noResult: 'Keine Ergebnisse...',
        noOptions: 'Bitte einen Suchbegriff eingeben',
        categories: {
          destinations: 'Reiseziele',
          cities: 'Städte',
          accommodations: 'Hotels',
          pois: 'Sehenswürdigkeiten',
          regions: 'Länder',
        },
      },
      who: {
        istraveleing: 'Wer reist mit?',
        child: 'Kind',
        children: 'Kinder',
        childage: 'Alter des Kindes',
        ageinfo: 'Alter der Kinder bei Rückreise',
        years: 'Jahre',
        adult: 'Erwachsener',
        adults: 'Erwachsene',
      },
      durations: {
        placeholder: 'Wie lange?',
        '1-4': '1 - 4 Tage',
        '5-8': '5 - 8 Tage',
        '9-12': '9 - 12 Tage',
        '10': '10 Tage',
        '1 WE': '1 Wochenende',
        '1 W': '1 Woche',
        '2 W': '2 Wochen',
        custom: 'Reisedauer:',
      },
      airport: {
        placeholder: 'Wo wird gestartet?'
      },
      day: 'Tag',
      days: 'Tage',
      close: 'Schließen',
    },
  },
}

// EXTERNAL MODULE: ./src/lang/de.json
var lang_de = __webpack_require__("bac1");

// CONCATENATED MODULE: ./src/lang/sections.de.js
/* harmony default export */ var sections_de = ({
  homepage: {
    topDealsTag: '688d0b25-c128-42b1-837e-2dbda9f8b7e2',
    topDeals: 'Top Deals des Tages',
    currentDealsTitle: 'Aktuelle Deals',
    currentDealsSubline:
      'Hier findet ihr alle verfügbaren Deals auf einen Blick',
    buttonText: 'Zu den Deals',

    tagSection_1_tagImage: '/assets/images/home-mood/destination_spain',
    tagSection_1_tagId: '61b41f42-ad02-43b6-8b9c-84f76df54e63',
    tagSection_1_title: 'Pauschalreisen',
    tagSection_1_subline: 'Hier findet ihr das passende Rundum-Sorglos Paket',

    tagSection_2_tagImage: '/assets/images/home-mood/tag_short-trip',
    tagSection_2_tagId: '7f548400-c363-4381-b434-049ce82f0fa6',
    tagSection_2_title: 'Kurzurlaub',
    tagSection_2_subline: 'Entdeckt aktuelle Angebote für eine kleine Auszeit',

    tagSection_3_tagImage: '/assets/images/home-mood/tag_flexcancel',
    tagSection_3_tagId: '92f90b86-822a-427a-930d-f5f920ada826',
    tagSection_3_title: 'Wellness',
    tagSection_3_subline:
      'Die besten Angebote für eine erholsame Wellnessauszeit',

    promotionSection_link: 'https://urlaubsguru.de/adventskalender-2020',
    promotionSection_title: 'Der große Adventskalender',
    promotionSection_subline:
      'Mitmachen und täglich eine von 24 Reisen gewinnen!',

    partnerSection_link:
      'https://buchen.urlaubsguru.de/region?dur=7&ibe=hotel&ddate=2018-08-15&rdate=2018-09-29&adult=2&_ga=2.178471271.252352868.1598601230-2100991080.1590410166/suchen-und-buchen/;desktop;',
    partnerSection_title: 'Hotelsuche',
    partnerSection_subline: 'Unterkünfte, wie ihr sie braucht',
    noMoreDealsInfo: 'keine weiteren Angebote vorhanden',
  },
  supportPersonImageSrc: '/assets/images/callcenter/lena.jpg',

  magazine: {
    section: {
      link: 'https://www.urlaubsguru.de/reisemagazin/',
      image: '/assets/images/magazine/de.jpg',
    },
  },

  deutschlandLiebe: {
    section: {
      link: 'https://www.urlaubsguru.de/deutschlandliebe/',
      image: '/assets/images/banners/urlaub_in_deutschland.jpg',
    },
  },

  raffle: {
    link: 'https://www.urlaubsguru.de/kreta-ostergewinnspiel/',
  },

  HomeHeroSVG: 'images/header/svgs/schriftzuege_pfade_DE.svg',

  partnerList: {
    headline: 'Weitere Reisearten',
    subline: 'Urlaub, wie ihr ihn braucht',
    data: [
      {
        label: 'Hotels',
        sub: 'Die perfekte Unterkunft',
        url: 'https://hotels.urlaubsguru.de/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_hotels.png',
      },
      {
        label: 'Flüge',
        sub: 'Günstige Flüge weltweit',
        url: 'https://www.urlaubsguru.de/flugsuche/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_fluege.png',
      },
      {
        label: 'Kurzreisen',
        sub: 'Kurz mal weg mit Wellness, Events & mehr',
        url: 'https://kurzreisen.urlaubsguru.de/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_kurzreisen.png',
      },

      {
        label: 'Blind Booking',
        sub: 'Überraschungstrip mit eigener Anreise',
        url:
          'https://blookery.urlaubsguru.de/eigene-anreise.html?utm_source=urlaubsguru&utm_campaign=urlaubsguru-suchen-und-buchen&utm_medium=banner&utm_content=kachel-section',
        image: '/assets/images/teasercards/Kachel_WL_368x180_blind_booking.png',
      },
      {
        label: 'Hotelgutscheine',
        sub: 'Top Auswahl der besten Hotelgutscheine',
        url: 'https://hotelgutscheine.urlaubsguru.de/ ',
        image:
          '/assets/images/teasercards/Kachel_WL_368x180_hotelgutscheine.png',
      },
      {
        label: 'Last Minute',
        sub: 'Last Minute Angebote zum kleinen Preis',
        url: 'https://www.urlaubsguru.de/last-minute-angebote/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_fruehbucher.png',
      },
      {
        label: 'Städtereisen',
        sub: 'Citytrips mit Flug & Hotel',
        url: 'https://staedtereisen.urlaubsguru.de/de-de/galerie',
        image: '/assets/images/teasercards/Kachel_WL_368x180_staedtereisen.png',
      },
      {
        label: 'Ferienwohnungen',
        sub: 'Günstige Ferienwohnungen im Vergleich ',
        url: 'https://ferienhaus.urlaubsguru.de/',
        image:
          '/assets/images/teasercards/Kachel_WL_368x180_ferienwohnungen.png',
      },
      {
        label: 'Skireisen',
        sub: 'Skiurlaub - preiswert wie nie zuvor',
        url: 'https://skireisen.urlaubsguru.de/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_skireisen.png',
      },
      {
        label: 'Rundreisen',
        sub: 'Rundreisen weltweit zum Bestpreis',
        url: 'https://rundreisen.urlaubsguru.de/de/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_rundreise.png',
      },
      {
        label: 'Mietwagen',
        sub: 'Preiswerte Mietwagen im Vergleich',
        url: 'https://www.urlaubsguru.de/mietwagen/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_mietwagen.png',
      },
      {
        label: 'Gutscheine',
        sub: 'Exklusive Urlaubsguru-Gutscheine',
        url: 'https://urlaubsguru-gutschein.de/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_gutschein.png',
      },
      {
        label: 'Kreuzfahrten',
        sub: 'Günstige Kreuzfahrten im Vergleich',
        url: 'https://kreuzfahrten.urlaubsguru.de/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_kreuzfahrten.png',
      },
      {
        label: 'Bahnreisen',
        sub: 'Die perfekte Städtereise mit der Bahn',
        url: 'https://bahnreisen.urlaubsguru.de/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_bahnreisen.png',
      },
      {
        label: 'Pauschalreisen',
        sub: 'Reisen mit allem was dazu gehört',
        url: 'https://buchen.urlaubsguru.de',
        image:
          '/assets/images/teasercards/Kachel_WL_368x180_pauschalreisen.png',
      },
      {
        label: 'Reiseanfrage',
        sub: 'Stellt jetzt eure individuelle Reiseanfrage',
        url: 'https://www.urlaubsguru.de/individuelle-reiseanfrage/',
        image: '/assets/images/teasercards/Kachel_WL_368x180_reiseanfragen.png',
      },
    ],
  },

  linkList: [
    {
      label: 'Beliebte Urlaubsziele',
      links: [
        {
          label: 'Günstige Urlaubsziele',
          url: 'https://www.urlaubsguru.de/urlaubsziele/',
        },

        {
          label: 'Kroatien Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/kroatien/',
        },

        {
          label: 'Mallorca Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/mallorca-urlaub/',
        },
        {
          label: 'Griechenland Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/griechenland-urlaub/',
        },
        {
          label: 'Bulgarien Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/bulgarien-urlaub/',
        },
        {
          label: 'Italien Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/italien-urlaub/',
        },
        {
          label: 'Teneriffa Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/teneriffa-urlaub/',
        },
        {
          label: 'Kreta Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/kreta-urlaub/',
        },
      ],
    },
    {
      label: 'Urlaubsziele weltweit',
      links: [
        {
          label: 'Ägypten Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/aegypten-urlaub/',
        },
        {
          label: 'Thailand Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/thailand/',
        },
        {
          label: 'Türkei Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/tuerkei-urlaub/',
        },
        {
          label: 'Zypern Urlaub ',
          url: 'https://www.urlaubsguru.de/urlaubsziele/zypern-urlaub/',
        },
        {
          label: 'DomRep Urlaub',
          url:
            'https://www.urlaubsguru.de/urlaubsziele/dominikanische-republik/',
        },
        {
          label: 'Malta Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/malta-urlaub/',
        },
        {
          label: 'Algarve Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/algarve/',
        },
        {
          label: 'Österreich Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/oesterreich/',
        },
      ],
    },
    {
      label: 'Deutschlandliebe',
      links: [
        {
          label: 'Urlaub in Deutschland',
          url: 'https://www.urlaubsguru.de/deutschlandliebe/',
        },
        {
          label: 'Ostsee Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/ostsee/',
        },
        {
          label: 'Nordsee Urlaub',
          url: 'https://www.urlaubsguru.de/urlaubsziele/nordsee/',
        },
        {
          label: 'Allgäu Urlaub',
          url: 'https://www.urlaubsguru.de/deutschlandliebe/allgaeu/',
        },
        {
          label: 'Bayern Urlaub',
          url: 'https://www.urlaubsguru.de/deutschlandliebe/bayern/',
        },
        {
          label: 'Mecklenburgische Seenplatte Urlaub',
          url:
            'https://www.urlaubsguru.de/deutschlandliebe/mecklenburg-vorpommern/',
        },
        {
          label: 'Harz Urlaub',
          url: 'https://www.urlaubsguru.de/deutschlandliebe/harz/',
        },
        {
          label: 'Schwarzwald Urlaub',
          url: 'https://www.urlaubsguru.de/deutschlandliebe/schwarzwald/',
        },
      ],
    },
    {
      label: 'Reisearten',
      links: [
        {
          label: 'Kurzurlaub',
          url: 'https://www.urlaubsguru.de/kurzreisen/',
        },
        {
          label: 'Pauschalreisen',
          url: 'https://www.urlaubsguru.de/pauschalreisen/',
        },
        {
          label: 'Rundreisen',
          url: 'https://www.urlaubsguru.de/rundreisen/',
        },
        {
          label: 'All Inclusive',
          url: 'https://www.urlaubsguru.de/all-inclusive/',
        },
        {
          label: 'Familienurlaub',
          url: 'https://www.urlaubsguru.de/familienurlaub/',
        },
        {
          label: 'Singlereisen',
          url: 'https://www.urlaubsguru.de/singlereisen/',
        },
        {
          label: 'Frühbucher',
          url: 'https://www.urlaubsguru.de/fruehbucher/',
        },
        {
          label: 'Wanderurlaub',
          url: 'https://www.urlaubsguru.de/wanderurlaub/',
        },
      ],
    },
    {
      label: 'Last Minute Angebote',
      links: [
        {
          label: 'Last Minute',
          url: 'https://www.urlaubsguru.de/last-minute/',
        },
        {
          label: 'Last Minute Kreta',
          url: 'https://www.urlaubsguru.de/last-minute/kreta/',
        },
        {
          label: 'Last Minute Dubai',
          url: 'https://www.urlaubsguru.de/last-minute/dubai/',
        },
        {
          label: 'Last Minute Griechenland',
          url: 'https://www.urlaubsguru.de/last-minute/griechenland/',
        },
        {
          label: 'Last Minute Kanaren',
          url: 'https://www.urlaubsguru.de/last-minute/kanaren/',
        },
        {
          label: 'Last Minute Türkei',
          url: 'https://www.urlaubsguru.de/last-minute/tuerkei/',
        },
        {
          label: 'Last Minute New York',
          url: 'https://www.urlaubsguru.de/last-minute/new-york/',
        },
        {
          label: 'Last Minute Mallorca',
          url: 'https://www.urlaubsguru.de/last-minute/mallorca/',
        },
      ],
    },
    {
      label: 'Wellness',
      links: [
        {
          label: 'Wellnessurlaub',
          url: 'https://www.urlaubsguru.de/wellness/',
        },
        {
          label: 'Wellness Deutschland',
          url: 'https://www.urlaubsguru.de/wellness/deutschland/',
        },
        {
          label: 'Wellness Bayern',
          url: 'https://www.urlaubsguru.de/wellness/bayern/',
        },
        {
          label: 'Wellness Ostsee',
          url: 'https://www.urlaubsguru.de/wellness/ostsee/',
        },
        {
          label: 'Wellness Holland',
          url: 'https://www.urlaubsguru.de/wellness/niederlande/',
        },
        {
          label: 'Wellness in Österreich',
          url: 'https://www.urlaubsguru.de/wellness/oesterreich/',
        },
        {
          label: 'Wellness Italien',
          url: 'https://www.urlaubsguru.de/wellness/italien/',
        },
        {
          label: 'Wellnesshotel',
          url: 'https://www.urlaubsguru.de/tag/wellnesshotel/',
        },
      ],
    },
    {
      label: 'Städtereisen Angebote',
      links: [
        {
          label: 'Städtereisen',
          url: 'https://www.urlaubsguru.de/staedtereisen/',
        },
        {
          label: 'Städtereise Paris',
          url: 'https://www.urlaubsguru.de/tag/paris/',
        },
        {
          label: 'Städtereise Wien',
          url: 'https://www.urlaubsguru.de/urlaubsziele/wien/',
        },
        {
          label: 'Städtereise Prag',
          url: 'https://www.urlaubsguru.de/tag/prag/',
        },
        {
          label: 'Städtereise Barcelona',
          url: 'https://www.urlaubsguru.de/urlaubsziele/barcelona/',
        },
        {
          label: 'Städtereise Amsterdam',
          url: 'https://www.urlaubsguru.de/tag/amsterdam/',
        },
        {
          label: 'Städtereise Rom',
          url: 'https://www.urlaubsguru.de/urlaubsziele/rom/',
        },
        {
          label: 'Städtereise Berlin',
          url: 'https://www.urlaubsguru.de/deutschlandliebe/berlin/',
        },
      ],
    },
    {
      label: 'Informationen',
      links: [
        {
          label: 'Reisemagazin',
          url: 'https://www.urlaubsguru.de/reisemagazin/',
        },
        {
          label: 'Tipps & Tricks',
          url: 'https://www.urlaubsguru.de/magazin-tag/tipps-tricks/',
        },
        {
          label: 'Corona FAQ',
          url: 'https://www.urlaubsguru.de/corona/',
        },
        {
          label: 'Reisekalender',
          url: 'https://www.urlaubsguru.de/reisekalender/',
        },
        {
          label: 'Sehenswürdigkeiten',
          url: 'https://www.urlaubsguru.de/urlaubsziele/sehenswuerdigkeiten/',
        },
        {
          label: 'Silvesterreisen 2020/21',
          url: 'https://www.urlaubsguru.de/reisekalender/silvester/',
        },
        {
          label: 'Freizeitaktivitäten',
          url: 'https://www.urlaubsguru.de/freizeitaktivitaeten/',
        },
        {
          label: 'Lexikon',
          url: 'https://www.urlaubsguru.de/lexikon/',
        },
      ],
    },
  ],

  footer: {
    corporate: {
      label: 'Unternehmen',
      data: [
        {
          label: 'Über Urlaubsguru',
          url: 'https://www.urlaubsguru.de/ueber-uns/',
        },
        {
          label: 'Jobs',
          url: 'https://www.urlaubsguru.de/jobs/',
        },
        {
          label: 'Werbung',
          url: 'https://www.urlaubsguru.de/werbung/',
        },
        {
          label: 'Presse',
          url: 'https://www.urlaubsguru.de/presse/',
        },
      ],
    },
    informations: {
      label: 'Informationen',
      data: [
        {
          label: 'Corona Reiseinformationen',
          url: 'https://www.urlaubsguru.de/corona/',
        },
        {
          label: 'Buchen beim Urlaubsguru',
          url: 'https://www.urlaubsguru.de/suchen-buchen-bei-urlaubsguru/',
        },
        {
          label: 'Dein Feedback an Uns',
          url: 'https://www.urlaubsguru.de/urlaubsguru-feedback/',
        },
        {
          label: 'Nachhaltig Reisen',
          url: 'https://www.urlaubsguru.de/nachhaltiger-tourismus/',
        },
      ],
    },
    buttons: [
      {
        label: 'Datenschutz',
        url: 'https://www.urlaubsguru.de/datenschutzerklaerung/',
      },
      {
        label: 'Sitemap',
        url: 'https://www.urlaubsguru.de/sitemap/',
      },
      {
        label: 'Schlagworte',
        url: 'https://www.urlaubsguru.de/tag/',
      },
      {
        label: 'Impressum / Rechtliche Hinweise',
        url: 'https://www.urlaubsguru.de/impressum/',
      },
    ],
    social: {
      label: 'Folgt uns auf',
      data: [
        {
          label: 'Facebook',
          icon: 'facebook',
          url: 'https://www.facebook.com/derurlaubsguru/',
        },
        {
          label: 'Instagram',
          icon: 'instagram',
          url: 'https://www.instagram.com/urlaubsguru/',
        },
        {
          label: 'TikTok',
          icon: 'tiktok',
          url: 'https://www.tiktok.com/@urlaubsguru.de',
        },
        {
          label: 'YouTube',
          icon: 'youtube',
          url: 'https://www.youtube.com/channel/UCKDLTlnI9j6lyP6CyTp293g',
        },
      ],
    },
    newsletter: {
      label: 'Meldet euch für den Newsletter an',
      button: 'Zum Newsletter',
      url: 'https://www.urlaubsguru.de/urlaubsguru-newsletter/',
    },
    app: {
      label: 'Ladet euch die App herunter',
      apple:
        'https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087',
      android: 'https://play.google.com/store/apps/details',
    },
  },

  skiSearchControls: {
    durationOptions: [
      {
        name: 'exakt wie angegeben',
        value: 'exact',
      },
      {
        name: 'beliebig',
        value: 'any',
      },
      {
        name: '7 Nächte',
        value: '7,7',
      },
      {
        name: '1-2 Nächte',
        value: '1,2',
      },
      {
        name: '2-5 Nächte',
        value: '2,5',
      },
      {
        name: '5-9 Nächte',
        value: '5,9',
      },
      {
        name: '9-11 Nächte',
        value: '9,11',
      },
      {
        name: '1 Nacht',
        value: '1,1',
      },
      {
        name: '2 Nächte',
        value: '2,2',
      },
      {
        name: '3 Nächte',
        value: '3,3',
      },
      {
        name: '4 Nächte',
        value: '4,4',
      },
      {
        name: '5 Nächte',
        value: '5,5',
      },
      {
        name: '6 Nächte',
        value: '6,6',
      },
      {
        name: '7 Nächte',
        value: '7,7',
      },
      {
        name: '8 Nächte',
        value: '8,8',
      },
      {
        name: '9 Nächte',
        value: '9,9',
      },
      {
        name: '10 Nächte',
        value: '10,10',
      },
      {
        name: '11 Nächte',
        value: '11,11',
      },
    ],
  },

  ibeSearchControls: {
    dayNames: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    monthNames: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember',
    ],
    durationOptions: [
      {
        name: 'exakt wie angegeben',
        value: 'exact',
      },
      {
        name: 'beliebig',
        value: '',
      },
      {
        name: '1 - 4 Tage',
        value: '1,4',
      },
      {
        name: '5 - 10 Tage',
        value: '5,10',
      },
      {
        name: '10  Tage',
        value: '10',
      },
      {
        name: '1 Wochenende',
        value: '2',
      },
      {
        name: '1 Woche',
        value: '7',
      },
      {
        name: '2 Wochen',
        value: '14',
      },
    ],
    childAgeOptions: [
      { label: '< 2 Jahre', value: 1 },
      { label: '2 Jahre', value: 2 },
      { label: '3 Jahre', value: 3 },
      { label: '4 Jahre', value: 4 },
      { label: '5 Jahre', value: 5 },
      { label: '6 Jahre', value: 6 },
      { label: '7 Jahre', value: 7 },
      { label: '8 Jahre', value: 8 },
      { label: '9 Jahre', value: 9 },
      { label: '10 Jahre', value: 10 },
      { label: '11 Jahre', value: 11 },
      { label: '12 Jahre', value: 12 },
      { label: '13 Jahre', value: 13 },
      { label: '14 Jahre', value: 14 },
      { label: '15 Jahre', value: 15 },
      { label: '16 Jahre', value: 16 },
      { label: '17 Jahre', value: 17 },
    ],
  },
  ameropaSearchControls: {
    durationOptions: [
      {
        name: 'exakt wie angegeben',
        value: 'exact',
      },
      {
        name: '1 Nacht',
        value: '1',
      },
      {
        name: '2 Nächte',
        value: '2',
      },
      {
        name: '3 Nächte',
        value: '3',
      },
      {
        name: '4 Nächte',
        value: '4',
      },
      {
        name: '5 Nächte',
        value: '5',
      },
      {
        name: '6 Nächte',
        value: '6',
      },
      {
        name: '7 Nächte',
        value: '7',
      },
      {
        name: '14 Nächte',
        value: '14',
      },
      {
        name: '2-4 Nächte',
        value: '2-4',
      },
      {
        name: '5-8 Nächte',
        value: '5-8',
      },
      {
        name: '9-14 Nächte',
        value: '9-14',
      },
    ],
  },
  jsonLD: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Urlaubsguru',
    url: 'https://www.urlaubsguru.de/',
    logo:
      'https://www.urlaubsguru.de/wp-content/uploads/2016/04/logo_dummy_x2-400x87.png',
    sameAs: [
      'https://www.facebook.com/derurlaubsguru/',
      'https://twitter.com/urlaubsguru_de?lang=de',
      'https://www.pinterest.de/urlaubsguru/',
      'https://www.instagram.com/urlaubsguru/?hl=de',
      'https://www.youtube.com/channel/UCKDLTlnI9j6lyP6CyTp293g',
    ],
  },
  searchCustomLinks: [
    {
      label: 'Kurzreisen',
      url: 'https://kurzreisen.urlaubsguru.de/getaways',
      icon: 'deck-chair-sun',
    },
  ],
  privacyManagerModalId: '395825',
  headerFooterData: {
    supportPhone: '+4923018939742',
    supportPhoneLabel: '+49 2301 / 89 39 742',
    supportTitle: 'Benötigst Du Hilfe?',
    supportSubline: 'täglich 10 - 20 Uhr',
    footerJson:
      '{"title": "Urlaubsguru", "corporate": {"title": "Unternehmen", "data": [{"label":"Über Urlaubsguru","url":"https://www.urlaubsguru.de/ueber-uns/","target":"_self"},{"label":"Jobs","url":"https://www.urlaubsguru.de/jobs/","target":"_self"},{"label":"Werbung","url":"https://www.urlaubsguru.de/werbung/","target":"_self"},{"label":"Presse","url":"https://www.urlaubsguru.de/presse/","target":"_self"}]}, "informations": { "title": "Informationen", "data": [{"label":"Corona Reiseinformationen","url":"https://www.urlaubsguru.de/corona/","target":"_self"},{"label":"Buchen beim Urlaubsguru","url":"https://www.urlaubsguru.de/suchen-buchen-bei-urlaubsguru/","target":"_self"},{"label":"Urlaubsguru Feedback","url":"https://www.urlaubsguru.de/urlaubsguru-feedback/","target":"_self"},{"label":"Nachhaltig Reisen","url":"https://www.urlaubsguru.de/nachhaltiger-tourismus/","target":"_self"},{"label":"Messenger","url":"https://www.urlaubsguru.de/messenger/","target":"_self"}]}, "app": {"title": "Ladet euch die App herunter", "appstore": "https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087", "playstore": "https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru"}, "newsletter": {"title": "Meldet euch für den Newsletter an", "button": "Zum Newsletter", "url": "https://www.urlaubsguru.de/newsletter/" }, "social": {"title": "Folge uns", "data": [{ "label":"Facebook", "icon": "facebook", "url": "https://www.facebook.com/derurlaubsguru/"},{ "label":"Instagram", "icon": "instagram", "url": "https://www.instagram.com/urlaubsguru/"},{ "label":"YouTube", "icon": "youtube", "url": "https://www.youtube.com/channel/UCKDLTlnI9j6lyP6CyTp293g"},{ "label":"TikTok", "icon": "tiktok", "url": "https://www.tiktok.com/@urlaubsguru.de"}]}, "footer": {"data":[{"label":"Datenschutzerklärung","url":"https://www.urlaubsguru.de/datenschutzerklaerung/","target":"_self"},{"label":"Sitemap","url":"https://www.urlaubsguru.de/sitemap/","target":"_self"},{"label":"Schlagworte","url":"https://www.urlaubsguru.de/tag/","target":"_self"},{"label":"Impressum","url":"https://www.urlaubsguru.de/impressum/","target":"_self"}]}}',
  },
  destination_category_destination: 'Regionen',
  destination_category_region: 'Regionen',
  destination_category_accommodation: 'Hotels',
  destination_category_city: 'Städte',
  destination_category_poi: 'Sehenswürdigkeiten',
  destination_category_point_of_interest: 'Sehenswürdigkeiten',
  destination_category_multi_city_vicinity: 'Gebiete',
  destination_category_province_state: 'Regionen',
  destination_category_neighborhood: 'Umgebungen',
  destination_category_airport: 'Flughäfen',
  destination_category_train_station: 'Bahnstationen',
  destination_category_metro_station: 'Metrostationen',
  destination_category_continent: 'Kontinente',
  destination_category_country: 'Länder',
  destination_category_high_level_region: 'Gebiete',

  newsletter: {
    title: 'Dein Urlaubsguru-Newsletter',
    info:
      'Du suchst nach <strong>hilfreichen Reiseempfehlungen und Top Deals?</strong> Dann melde dich für den exklusiven Urlaubsguru Newsletter an. <br /> <br />Das erwartet dich:',
    listItem1: 'handverlesene Angebote von den Urlaubsguru-Reiseexperten',
    listItem2: 'Deals mit unschlagbarem Preisleistungsverhältnis',
    listItem3: 'Inspiration und hilfreiche Tipps für deine nächste Reise',
    button: 'Newsletter anmelden',
  },
  shortTripSearch: {
    title: 'Kurzreisen',
    destinationLabel: 'Reiseziel',
    destinationPlaceholder: 'Wo soll die Reise hingehen?',
    noResult: 'Trage deinen Abreiseort ein',
  },
});

// CONCATENATED MODULE: ./src/lang/index.js





const messages = {
  en: {
    message: {
      hello: 'hello world',
    },
    from: 'from',
    newsletterBox: {
      title: 'Never miss anything!',
    },
    ...deals.en,
    ...search.en,
  },
  de: {
    ...deals.de,
    ...search.de,

    ...lang_de,
    ...sections_de,
  },
}

/* harmony default export */ var lang = (messages);

// CONCATENATED MODULE: ./src/index.js
/**
 * Inputs
 */






















/**
 * UI Components
 */




































/**
 * Dropdown
 */


/**
 * Icon with Headline
 */

/**
 * Partials
 */
































/**
 * Search
 */






















/**
 * Content Components
 */



/**
 * Cards
 */







/**
 * Deal Components
 */









/**
 * Deal Detail
 */









/**
 * Deal box
 */



/**
 * Hotels
 */



/**
 * Forms
 */









/**
 * Modals
 */


/**
 * SVGs
 */
// Logos












/**
 * Travel Attribute SVGs
 */












































/**
 * Decorations
 */

















/**
 * Store Buttons
 */











/**
 * UI
 */























/**
 * I18N Messages
 */




// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ }),

/***/ "fbb9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fcc4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fdea":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fef1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ff81":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_voucher_vue_vue_type_style_index_0_id_bc370548_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("747b");
/* harmony import */ var _node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_voucher_vue_vue_type_style_index_0_id_bc370548_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_hg_deal_voucher_vue_vue_type_style_index_0_id_bc370548_prod_lang_postcss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ })

/******/ });
});
//# sourceMappingURL=holidayguru-components.umd.js.map